webpackJsonp([4,3],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var PaymentMethod = SoaModel.extend();
module.exports = PaymentMethod;

var _ = __webpack_require__(0);
var paymentMethodTypes = {
    'WIRE_TRANSFER': 'WireTransfer',
    'CHECK': 'Check',
    'CREDIT_TO_USER_ACCOUNT': 'CreditToUserAccount',
    'DISCOUNT': 'Discount',
    'DIRECT_PAYMENT': 'DirectPayment',
    'CASH': 'Cash',
    'ACH': 'ACH',
    'NOT_AVAILABLE': 'NotAvailable',
    'PAYPAL_ACCOUNT': 'PayPalAccount',
    'CREDIT_CARD'   : 'CreditCard',
    'APPLE_PAY'     : 'ApplePay'
};

var isPaymentMethodType = function (type) {
    return this.get('paymentMethodType') === type;
};

// Service enums for card types
_.extend(PaymentMethod, {
    CARD_TYPE_VISA      : 'Visa',
    CARD_TYPE_MASTER    : 'MasterCard',
    CARD_TYPE_DISCOVER  : 'Discover',
    CARD_TYPE_AMEX      : 'American Express'
});

/**
 * @class PaymentMethod
 * @extends SoaModel
 * @property {string} idAttribute - "id"
 * @property {array} relations
 *      @property relations.type {Backbone.One}
 *      @property relations.key {string}- "item"
 *      @property relations.relatedModel {Backbone.Model}
 *      @property relations.collectionType {Backbone.Models}
 */
_.extend(PaymentMethod.prototype, {
    defaults : {
        apiType : 'defaultPaymentMethod'//This maps to a java interface
        // so, do a concrete version, and define apiType
        //`defaultPaymentMethod` is the placeholder for now, until we do actual concrete implementations
    }
});

_.each(paymentMethodTypes, function (description, type) {
    PaymentMethod['TYPE_' + type] = type;
    PaymentMethod.prototype['is' + description] = _.partial(isPaymentMethodType, type);
});


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/30/14
 * Time: 2:39 PM
 */


var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var Clump = __webpack_require__(22);
var Party = __webpack_require__(8);
var Note = __webpack_require__(33);
var baseTransitionMixin = __webpack_require__(307);



module.exports = {
    transition: function (status, passedOptions) {
        this.set('status', status);
        return baseTransitionMixin.transition.call(this, passedOptions);
    },
    updateAndTransition: function (status, passedOptions) {
        this.set('status', status);
        return baseTransitionMixin.updateAndTransition.call(this, passedOptions);
    },
    update: function (status, passedOptions) {
        return baseTransitionMixin.update.call(this, passedOptions);
    },
    /**
     * Transitions the document and anchors a note
     * @param {string} status to transition to
     * @param {object} passedOptions
     * @param passedOptions.noteContent
     * @param passedOptions.noteRole The note role
     * @param passedOptions.noteType The note type
     * @returns {$.Deferred.promise}
     */
    transitionWithNote: function (status, passedOptions) {
        var clump = new Clump();
        var saves = this._clumpTransitionWithNote(clump, status, passedOptions);
        clump.run({dynaOptions: {
            open: '___',
            close: '___',
            params: {
                anchorId: {
                    clumpElement: "transition",
                    expression: "$.result.id"
                }
            }
        }});
        return $.when.apply($, saves);
    },
    /**
     * @private
     * @param {Clump} clump
     * @param {string} status
     * @param {object} passedOptions Options representing new note attributes
     * @returns {$.deferred.promise[]}
     */
    _clumpTransitionWithNote: function (clump, status, passedOptions) {
        var saves = [];
        var note;
        var saveNote = false;
        var options = _.extend({
            clump: clump,
            clumpName: 'transition',
            clumpProfile: 'transition',
            transitionFunction: 'transition'
        }, passedOptions);

        // Save Note
        if (options.noteContent) {
            note = this.newNote({
                content: options.noteContent,
                role: options.noteRole,
                type: options.noteType
            });
            if (this.isNew()) {
                note.setAnchorId(this.anchorType, '___anchorId___');
            }
            if (options.saveNoteFirst) {
                saves.push(note.save(null, { clump: clump }));
            } else {
                saveNote = true;
            }
        }

        // Transition self
        saves.push(this[options.transitionFunction](status, options));

        // the note MUST be saved after the transition for the dynaparam anchor id
        // to work
        if (saveNote && !options.saveNoteFirst) {
            saves.push(note.save(null, { clump: clump }));
        }
        return saves;
    },
    /**
     * Transition this model while taking action on an offer at the same time
     * @param status {String} status to transition this model to
     * @param passedOptions options for this function described below
     * @param passedOptions.offer {Object} offer to accept or counter
     * @param passedOptions.counterOffer {Object} offer to counter with, null if accepting
     * @param passedOptions.noteContent {Object} note to anchor to the counter offer
     * @param passedOptions.noteRole {Object} note to anchor to the counter offer
     * @param passedOptions.noteType {Object} note to anchor to the counter offer
     */
    transitionWithOfferNote: function (status, passedOptions) {
        var saves = [];
        var options = passedOptions || {};
        var dynaOptions;
        var clump = new Clump();

        if (!!options.noteContent) {
            dynaOptions = {
                open: '___',
                close: '___',
                params: {
                    anchorId: {
                        clumpElement: "transition",
                        expression: "$.result.id"
                    },
                    counterOfferId: {
                        clumpElement: "counterOffer",
                        expression: "$.result.counterOfferId"
                    }
                }
            };
        }

        if (options.counterOffer) {
            saves = options.offer.clumpCounterOfferNote(clump, options);
            // Note has been saved, remove it so it is not saved when this is transitioned
            options.noteContent = undefined;
        } else {
            if (!passedOptions.offer.isAccepted()) {
                saves = [options.offer.accept({clump: clump})];
            }
        }
        saves.push(this._clumpTransitionWithNote(clump, status, options));
        clump.run({dynaOptions: dynaOptions});
        return $.when.apply($, _.flatten(saves));
    },
    dealerTransitionWithOfferNote: function (status, offer, counterOffer, passedOptions) {
        var options = _.extend({
            offer: offer,
            counterOffer: counterOffer,
            noteRole: Party.ROLE_SELLER,
            noteType: Note.TYPE_BUYER_SELLER
        }, passedOptions);
        return this.transitionWithOfferNote(status, options);
    }
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: ronald
 * Date: 1/7/13
 * Time: 7:10 PM
 */


var SoaModel = __webpack_require__(2);
var Transaction = module.exports = SoaModel.extend({}, {
    STATUS_NEW: 'NEW',
    STATUS_NEGOTIATING: 'NEGOTIATING',
    STATUS_NOT_AVAILABLE: 'NOT_AVAILABLE',
    STATUS_PENDING: 'PENDING',
    STATUS_CANCELED: 'CANCELED',
    STATUS_REFUNDED: 'REFUNDED',
    STATUS_CLOSED: 'CLOSED',
    TYPE_NEGOTIABLE: 'NEGOTIABLE',
    TYPE_NON_NEGOTIABLE: 'NON_NEGOTIABLE',
    TYPE_PRE_AUTH_NEGOTIATION: 'PRE_AUTH_NEGOTIATION',
    CANCELLATION_REASON_FRAUD: 'FRAUD',
    CANCELLATION_REASON_CANCELED_BEFORE_APPROVED: 'CANCELED_BEFORE_APPROVED',
    CANCELLATION_REASON_BUYER_NOT_RESPONDING_SHIPPING: 'BUYER_NOT_RESPONDING_SHIPPING',
    CANCELLATION_REASON_BUYER_NOT_RESPONDING_OFFER: 'BUYER_NOT_RESPONDING_OFFER',
    CANCELLATION_REASON_BUYER_NO_LONGER_INTERESTED_PRE_CHECKOUT: 'BUYER_NO_LONGER_INTERESTED_PRE_CHECKOUT',
    CANCELLATION_REASON_BUYER_PASSED_ON_OFFER_PRE_CHECKOUT: 'BUYER_PASSED_ON_OFFER_PRE_CHECKOUT',
    CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_DEALER_INACTION: 'OFFER_EXPIRED_PRE_CHECKOUT_DEALER_INACTION',
    CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_BUYER_INACTION: 'OFFER_EXPIRED_PRE_CHECKOUT_BUYER_INACTION',
    ERROR_EXISTING_TRANSACTION: 'EXISTING_TRANSACTION',
    ERROR_DUPLICATE_ORDER: 'DUPLICATE_ORDER'
});

var endpoints = __webpack_require__(6);
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var bunsen = __webpack_require__(21);
var Offers = __webpack_require__(160);
var Offer = __webpack_require__(26);
var CurrencyConversionRateEvent = __webpack_require__(326);
var Item = __webpack_require__(34);
var Shipment = __webpack_require__(83);
var TransactionShipmentQuotes = __webpack_require__(78);
var Seller = __webpack_require__(101);
var PaymentAuthorizations = __webpack_require__(161);
var PaymentAuthorization = __webpack_require__(25);
var Invoices = __webpack_require__(159);
var Disbursements = __webpack_require__(156);
var Notes = __webpack_require__(24);
var Note = __webpack_require__(33);
var User = __webpack_require__(28);
var Anchor = __webpack_require__(12);
var ReturnPolicy = __webpack_require__(314);
var Promotions = __webpack_require__(162);
var Price = __webpack_require__(66);
var FinancialAmount = __webpack_require__(10);
var Actions = __webpack_require__(155);
var Refunds = __webpack_require__(163);
var InvoiceSummary = __webpack_require__(230);
var simplyDeferred = __webpack_require__(29);

// Mixins
var actionMixin = __webpack_require__(192);
var documentAccessMixin = __webpack_require__(195);
var statusMixin = __webpack_require__(232);
var currencyMixin = __webpack_require__(194);
var shippingMixin = __webpack_require__(196);
var checkoutMixin = __webpack_require__(193);
var transitionMixin = __webpack_require__(19);

var root = typeof window === 'undefined' ? global : window;

function warn(prop) {

    Object.defineProperty(Transaction, 'STATUS_' + prop, {
        get: function () {
            console.warn('Attempting to access pre-N2.0 transaction status!', prop);
            return prop;
        }
    });
}

warn('SECURING_PAYMENT');
warn('AWAITING_MANUAL_REVIEW');
warn('PENDING_INVENTORY_CHECK');
warn('INVENTORY_CONFIRMED');

root.bunsen = root.bunsen || {};

// root.bunsen for console debugging
root.bunsen.Transaction = Transaction;

_.extend(Transaction.prototype, {
    idAttribute: "id",
    defaults: {
        buyer: {},
        offers: [],
        shipmentQuotes: [],
        notes: [],
        invoices: [],
        shipment: {},
        disbursements: []
    },
    initialize: function () {
        this.urlRoot = endpoints.transaction();
        this.url = Backbone.Model.prototype.url;
    },
    relations: function () {
        return [
            {
                type: Backbone.Many,
                key: 'offers',
                collectionType: Offers
            },
            {
                type: Backbone.One,
                key: 'currencyConversionRateEvent',
                relatedModel: CurrencyConversionRateEvent
            },
            {
                type: Backbone.One,
                key: 'displayMetadata',
                relatedModel: SoaModel.extend({
                    relations: [{
                        type: Backbone.One,
                        key: 'sla',
                        relatedModel: SoaModel
                    }]
                })
            },
            {
                type: Backbone.One,
                key: 'item',
                relatedModel: Item,
                saveJSONFields: ['id', 'apiType']
            },
            {
                type: Backbone.One,
                key: 'shipment',
                relatedModel: Shipment
            },
            {
                type: Backbone.Many,
                key: 'shipmentQuotes',
                collectionType: TransactionShipmentQuotes
            },
            {
                type: Backbone.One,
                key: 'buyer',
                relatedModel: User,
                saveJSONFields: ['id']
            },
            {
                type: Backbone.One,
                key: 'seller',
                relatedModel: Seller,
                saveJSONFields: ['id']
            },
            {
                type: Backbone.Many,
                key: 'paymentAuthorizations',
                collectionType: PaymentAuthorizations
            },
            {
                type: Backbone.Many,
                key: 'invoices',
                collectionType: Invoices
            },
            {
                type: Backbone.Many,
                key: 'disbursements',
                collectionType: Disbursements
            },
            {
                type: Backbone.Many,
                key: 'notes',
                collectionType: Notes,
                omitFromSave: true
            },
            {
                type: Backbone.One,
                key: 'supportRep',
                relatedModel: User
            },
            {
                type: Backbone.One,
                key: 'salesRep',
                relatedModel: User
            },
            {
                type: Backbone.One,
                key: 'shippingRep',
                relatedModel: User
            },
            {
                key: 'returnPolicy',
                relatedModel: ReturnPolicy,
                type: Backbone.One
            },
            {
                key: 'promotions',
                collectionType: Promotions,
                type: Backbone.Many
            },
            {
                key: 'actions',
                collectionType: Actions,
                type: Backbone.Many
            },
            {
                key: 'refunds',
                collectionType: Refunds,
                type: Backbone.Many
            },
            {
                key: 'summary',
                relatedModel: SoaModel.extend({
                    relations: [
                        {
                            key: 'availablePrices',
                            relatedModel: Price,
                            type: Backbone.Many
                        },
                        {
                            key: 'acceptedOffer',
                            relatedModel: Offer,
                            type: Backbone.One
                        },
                        {
                            key : 'balanceDueAmount',
                            relatedModel : FinancialAmount,
                            type : Backbone.One
                        },
                        {
                            key : 'settlingAmount',
                            relatedModel : FinancialAmount,
                            type : Backbone.One
                        },
                        {
                            key : 'itemPrice',
                            relatedModel : Price,
                            type : Backbone.One
                        },
                        {
                            key : 'checkoutPaymentAuthorization',
                            relatedModel : PaymentAuthorization,
                            type : Backbone.One
                        },
                        {
                            key : 'balanceDuePaymentAuthorization',
                            relatedModel : PaymentAuthorization,
                            type : Backbone.One
                        },
                        {
                            key: 'checkoutOffer',
                            relatedModel: Offer,
                            type: Backbone.One
                        },
                        {
                            key : 'totalCapturedAmount',
                            relatedModel : FinancialAmount,
                            type : Backbone.One
                        },
                        {
                            key: 'invoiceSummary',
                            relatedModel: InvoiceSummary,
                            type: Backbone.One
                        }
                    ]
                }),
                type: Backbone.One
            }
        ];
    },
    parse: function (response) {
        var transaction;
        if (response.result) {
            transaction = response.result;
        } else {
            transaction = response;
        }
        return SoaModel.prototype.parse.call(this, transaction);
    },
    getCancellationReason: function () {
        return this.get('cancellationReason');
    },
    canMultipleQuantityBePurchased: function () {
        var item = this.get('item');
        return item && item.canMultipleQuantityBePurchased();
    },
    savePrivateOffers: function () {
        if (this.isNew()) {
            // for new transactions, the entire transaction is saved
            // compute adjustments must be called before saving a transaction
            return this.computeAdjustments().then(this.save.bind(this));
        } else {
            // if adding offer to an existing transaction, save the offer
            return simplyDeferred.when.apply(simplyDeferred,
                _(this.get('offers').filter(bunsen.callon('isNew'))).invoke('save'));
        }
    },
    /**
     * @param {object} [newNoteOptions]
     * @param {object[]} [additionalAnchors]
     * @returns {Note}
     */
    newNote: function (newNoteOptions, additionalAnchors) {
        return this.get('notes').newNote(this._getOptionsForNewNote(newNoteOptions, additionalAnchors));
    },
    /**
     * Returns a new note with type BUYER_SELLER,
     * and defaults the createdBy to have the role
     * "SELLER" and the id to be the transaction
     * seller id
     * @param {object} [newNoteOptions]
     * @param {object[]} [additionalAnchors]
     * @returns {Note}
     */
    newBuyerSellerNote: function (newNoteOptions, additionalAnchors) {
        newNoteOptions = _.extend({ creatorId: this.get('seller.id') }, newNoteOptions || {});
        return this.get('notes').newBuyerSellerNote(this._getOptionsForNewNote(newNoteOptions, additionalAnchors));
    },
    /**
     * @param {object} [noteOptions]
     * @param {object} [syncOptions]
     * @returns {$.Deferred.promise}
     */
    addNewNote : function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        return this.addAndSaveNote(note, syncOptions);
    },
    /**
     * @param {Note} note
     * @param {object} [syncOptions]
     * @returns {$.Deferred.promise}
     */
    addAndSaveNote: function (note, syncOptions) {
        console.assert(note instanceof Note, 'Note must be instance of note');
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },

    _getOptionsForNewNote: function (newNoteOptions, additionalAnchors) {
        var anchors;
        newNoteOptions = newNoteOptions || {};
        anchors = newNoteOptions.anchors || this._getDefaultNoteAnchors() || [];
        anchors = additionalAnchors ? anchors.concat(additionalAnchors) : anchors;
        return _.extend({ anchors: anchors }, newNoteOptions);
    },
    _getDefaultNoteAnchors: function () {
        return [{
            sourceId : this.get('id'),
            sourceType : Anchor.TYPE_TRANSACTION
        }, {
            sourceId: this.get('seller.id'),
            sourceType : Anchor.TYPE_SELLER
        }];
    },
    /**
     * used for OMT reloading after changes to sub models.
     */
    refetch: function () {
        var self = this;
        var actions = this.get('actions');

        // remove all actions before fetching to make sure stale actions are removed
        if (actions) {
            actions.reset();
        }

        this.trigger('refetching');
        return this.fetch({
            refetching: true
        }).always(function () {
            self.trigger('refetched');
        });
    }
}, actionMixin, documentAccessMixin, statusMixin, currencyMixin, shippingMixin, checkoutMixin, transitionMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Rob/Shad
 * Date: 8/16/13
 */



var SoaModel = __webpack_require__(2);
var PaymentAuthorization = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

module.exports = root.bunsen.PaymentAuthorization = PaymentAuthorization;

var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var transitionMixin = __webpack_require__(19);
var endpoints = __webpack_require__(6);
var Anchor = __webpack_require__(12);
var PaymentMethod = __webpack_require__(57);
var FinancialAmount = __webpack_require__(10);
var financialAmountMixin = __webpack_require__(47);
var PaymentProviderResponse = __webpack_require__(174);
var Review = __webpack_require__(82);

__webpack_require__(79);

_.extend(PaymentAuthorization, {
    STATUS_NEW: 'NEW',
    STATUS_AWAITING_FRAUD_SCORE: 'AWAITING_FRAUD_SCORE',
    STATUS_AWAITING_PROVIDER_RESPONSE: 'AWAITING_PROVIDER_RESPONSE',
    STATUS_PENDING_ADMIN_APPROVAL: 'PENDING_ADMIN_APPROVAL',
    STATUS_FRAUDULENT: 'FRAUDULENT',
    STATUS_AUTHORIZED: 'AUTHORIZED',
    STATUS_CAPTURED: 'CAPTURED',
    STATUS_DENIED_DATA_VALIDATION: 'DENIED_DATA_VALIDATION',
    STATUS_DENIED_PROCESSOR_ERROR: 'DENIED_PROCESSOR_ERROR',
    TIMEOUT_TRANSITION: 60000,
    PROGRESS_TRANSITION_ATTEMPTING: 'paymentAuthTransitionAttempting',
    PROGRESS_FETCHING: 'paymentAuthFetching',
    getActiveStatuses: function () {
        return [
            PaymentAuthorization.STATUS_PENDING_ADMIN_APPROVAL,
            PaymentAuthorization.STATUS_FRAUDULENT,
            PaymentAuthorization.STATUS_AUTHORIZED,
            PaymentAuthorization.STATUS_CAPTURED
        ];
    },
    getTransitioningStatuses: function () {
        return [
            PaymentAuthorization.STATUS_AWAITING_PROVIDER_RESPONSE
        ];
    },
    getDeniedStatuses: function () {
        return [
            PaymentAuthorization.STATUS_DENIED_DATA_VALIDATION,
            PaymentAuthorization.STATUS_FRAUDULENT,
            PaymentAuthorization.STATUS_DENIED_PROCESSOR_ERROR
        ];
    },
    newOfferPaymentAuthorization: function () {
        return new PaymentAuthorization({
            anchor: {
                sourceType: Anchor.TYPE_OFFER
            }
        });
    },
    newShipmentQuotePaymentAuthorization: function (shipmentQuote) {
        return new PaymentAuthorization({
            anchor: {
                sourceType: Anchor.TYPE_SHIPMENT_QUOTE,
                sourceId: shipmentQuote.id
            }
        });
    }
});

_.extend(PaymentAuthorization.prototype, {
    idAttribute: "id",
    initialize: function () {
        // set in here to work around backbone bug where url get set from parent
        this.url = function () {
            return endpoints.paymentAuthorization(this.get(this.idAttribute));
        };
    },
    relations : function () {
        return [
            {
                type: Backbone.One,
                key: 'paymentMethod',
                relatedModel: PaymentMethod,
                saveJSONFields : [
                    'apiType',
                    'id',
                    'token',
                    'nonce',
                    'cardHolderName',
                    'cardExpiryMonth',
                    'cardExpiryYear',
                    'maskedCardNumber',
                    'billingAddress',
                    'accountHolderName',
                    'confirmationNumber',
                    'transactionNumber',
                    'referenceNumber',
                    'paymentAuthorizationId'
                ]
            },
            {
                type : Backbone.One,
                key : 'transaction',
                relatedModel: SoaModel,
                saveJSONFields : ['id']
            },
            {
                type: Backbone.One,
                key: 'anchor',
                relatedModel: Anchor
            },
            {
                type: Backbone.Many,
                key: 'anchors',
                relatedModel: Anchor
            },
            {
                type: Backbone.One,
                key: 'amount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.One,
                key: 'authorizationAmount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.One,
                key: 'capturedAmount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.Many,
                key: 'paymentProviderResponses',
                relatedModel: PaymentProviderResponse
            },
            {
                type: Backbone.Many,
                key: 'reviews',
                relatedModel: Review
            }
        ];
    },
    /**
     * Return true if the transaction is "active", means it has already been processed
     * and linked to an offer/shipmentQuote
     * @return {Boolean}
     */
    isActive: function () {
        return _.contains(PaymentAuthorization.getActiveStatuses(), this.get('status'));
    },
    isReadyForProcessing: function () {
        return this.get('status') === PaymentAuthorization.STATUS_NEW;
    },
    isAuthorized: function () {
        return this.get('status') === PaymentAuthorization.STATUS_AUTHORIZED;
    },
    isCaptured: function () {
        return this.get('status') === PaymentAuthorization.STATUS_CAPTURED;
    },
    /**
     * Return true if the transaction is "current", meaning it is actively being
     * used for checkout or balance due. Status NEW or no ID
     * and linked to an offer/shipmentQuote
     * @return {Boolean}
     */

    isCurrentCheckout: function () {
        return this.get('status') === PaymentAuthorization.STATUS_NEW || this.isNew();
    },
    /**
     * Return true if the transaction is "current", for balance due
     * and linked to a shipmentQuote
     * @return {Boolean}
     */

    isCurrentBalanceDue: function () {
        return this.isNew();
    },
    /**
     * Returns true if the payment auth has been staged by ecom and is ready
     * to be posted to braintree
     * @returns {Boolean}
     */
    isStagedPaymentAuth: function () {
        return this.has('paymentProviderStagingArgument');
    },
    isDenied: function () {
        return _.contains(PaymentAuthorization.getDeniedStatuses(), this.get('status'));
    },
    isCheckoutPaymentAuthorization: function () {
        return this.get('anchor.sourceType') === Anchor.TYPE_OFFER;
    },
    isOfferPaymentAuthorization: function () {
        return this.isCheckoutPaymentAuthorization();
    },
    isBalanceDuePaymentAuthorization: function () {
        return this.get('anchor.sourceType') === Anchor.TYPE_SHIPMENT_QUOTE;
    },
    isShippingPaymentAuthorization: function () {
        return this.isBalanceDuePaymentAuthorization();
    },
    isWireTransfer: function () {
        return this.get('paymentMethod').isWireTransfer();
    },
    getBraintreeIdReserve: function () {
        return this.get('paymentProviderTransactionId');
    },
    getAmount: function (currency) {
        return this._getFinancialAmount('amount', currency);
    },
    getCapturedAmount: function (currency) {
        return this._getFinancialAmount('capturedAmount', currency);
    },
    getAuthorizationAmount: function (currency) {
        return this._getFinancialAmount('authorizationAmount', currency);
    },
    getCardType: function () {
        var paymentMethod = this.get('paymentMethod');
        var maskedCardNumber = paymentMethod && paymentMethod.get('maskedCardNumber');
        return maskedCardNumber && $.payment.cardType(maskedCardNumber);
    },
    autoCapture: function () {
        this.set('autoCapture', 'Y');
        return this.updateAndTransition(PaymentAuthorization.STATUS_CAPTURED);
    },
    hasAutoCaptureFailed: function () {
        var responses = this.get('paymentProviderResponses');
        if (!responses) {
            return false;
        }
        return responses.some(function (model) {
            return model.isVaultTransaction() && !model.isSuccess();
        });
    },
    hasPaymentDeclined: function() {
        return !!this.getPaymentReview();
    },
    getPaymentReview: function () {
        var reviews = this.get('reviews');
        if (!reviews) {
            return false;
        }

        return reviews.find(function(review) {
            return review.isPending() && review.isPaymentDeclined();
        });
    },
    getFraudReview: function () {
        var reviews = this.get('reviews');
        if (!reviews) {
            return false;
        }

        return reviews.find(function(review) {
            return review.isPending() && review.isFraud();
        });

    }
}, transitionMixin, financialAmountMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: ronald
 * Date: 1/7/13
 * Time: 7:10 PM
 */


var qs = __webpack_require__(42);
var SoaModel = __webpack_require__(2);
var Offer = SoaModel.extend({}, {
    DisplayOfferStatus: {
        expired: 'expired',
        canceledNoLongerInterested: 'canceledNoLongerInterested',
        canceledPassed: 'canceledPassed',
        canceledOther: 'canceledOther',
        dealerCountered: 'dealerCountered',
        buyerCountered: 'buyerCountered',
        newBuyerOfferWithoutReserve: 'newBuyerOfferWithoutReserve',
        newBuyerOfferWithReserve: 'newBuyerOfferWithReserve',
        newDealerOffer: 'newDealerOffer',
        dealerAccepted: 'dealerAccepted',
        newOrder: 'newOrder',
        newOrderManualReview: 'newOrderManualReview',
        requestedOffer: 'requestedOffer'
    },
    STATUS_AMENDED: 'AMENDED',
    STATUS_SUBMITTED: 'SUBMITTED',
    STATUS_ACCEPTED: 'ACCEPTED',
    STATUS_COUNTERED: 'COUNTERED',
    STATUS_EXPIRED: 'EXPIRED',
    STATUS_NEW: 'NEW',
    STATUS_CANCELED: 'CANCELED',
    STATUS_REQUESTED: 'REQUESTED'
});
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

// Attaching to bunsen until bOMT and checkout are commonJS
module.exports = root.bunsen.Offer = Offer;

var SoaCollection = __webpack_require__(9);
var endpoints = __webpack_require__(6);
var AdjustmentList = __webpack_require__(56);
var Transaction = __webpack_require__(20);
var Notes = __webpack_require__(24);
var Note = __webpack_require__(33);
var Party = __webpack_require__(8);
var Anchor = __webpack_require__(12);
var PaymentAuthorization = __webpack_require__(25);
var Backbone = __webpack_require__(3);
var transitionMixin = __webpack_require__(19);
var financialAmountMixin = __webpack_require__(47);
var Clump = __webpack_require__(22);
var Period = __webpack_require__(114);
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var FinancialAmount = __webpack_require__(10);
var Action = __webpack_require__(51);
var uri = __webpack_require__(134);

_.extend(Offer.prototype, {
    offerDisplayStatus: function offerDisplayStatus(options) {
        options = _.defaults({}, options, {
            transaction: this.get('transaction')
        });
        var _options = options,
            transaction = _options.transaction;


        if (transaction.isCanceled()) {
            switch (transaction.get('cancellationReason')) {
                case Transaction.CANCELLATION_REASON_BUYER_NO_LONGER_INTERESTED_PRE_CHECKOUT:
                    return Offer.DisplayOfferStatus.canceledNoLongerInterested;
                case Transaction.CANCELLATION_REASON_BUYER_PASSED_ON_OFFER_PRE_CHECKOUT:
                    return Offer.DisplayOfferStatus.canceledPassed;
                case Transaction.CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_DEALER_INACTION:
                case Transaction.CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_BUYER_INACTION:
                    return Offer.DisplayOfferStatus.expired;
                default:
                    return Offer.DisplayOfferStatus.canceledOther;
            }
        }
        if (transaction.isAwaitingManualReview()) {
            return Offer.DisplayOfferStatus.newOrderManualReview;
        }
        if (transaction.isFullPriceOrder()) {
            return Offer.DisplayOfferStatus.newOrder;
        }
        if (transaction.isBuyerOfferWithReserve()) {
            return Offer.DisplayOfferStatus.newBuyerOfferWithReserve;
        }
        switch (this.get('status')) {
            case Offer.STATUS_SUBMITTED:
                // countered offers
                if (transaction.isMostRecentlyDealerCountered()) {
                    return Offer.DisplayOfferStatus.dealerCountered;
                } else if (transaction.isMostRecentlyBuyerCountered()) {
                    return Offer.DisplayOfferStatus.buyerCountered;
                    // new offers
                } else if (this.isBuyerInitiatedOffer()) {
                    return Offer.DisplayOfferStatus.newBuyerOfferWithoutReserve;
                } else {
                    return Offer.DisplayOfferStatus.newDealerOffer;
                }
            case Offer.STATUS_ACCEPTED:
                if (transaction.hasAction(Action.CODE_BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER)) {
                    return Offer.DisplayOfferStatus.dealerAccepted;
                } else {
                    return Offer.DisplayOfferStatus.newOrder;
                }
            case Offer.STATUS_REQUESTED:
                return Offer.DisplayOfferStatus.requestedOffer;
        }
    },
    isUserComesFromAmpPage: function isUserComesFromAmpPage() {
        var params = qs.parse(document.location.search.substr(1));
        return _.has(params, 'userComesFromAmp') && params.userComesFromAmp === 'true';
    },
    redirectToCheckout: function redirectToCheckout() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _options2 = options,
            item = _options2.item;


        if (!item) {
            throw new Error('options.item required for redirectToCheckout');
        }

        options = Object.assign({
            offerAmount: this.get('amountPerItem.amount'),
            offerCurrency: this.get('amountPerItem.currency'),
            quantity: this.get('quantity'),
            chkIncludeOffer: true
        }, options);

        if (this.isUserComesFromAmpPage()) {
            options.userComesFromAmp = true;
        }

        // we are not passing the item itself
        delete options.item;

        var params = qs.stringify(options);
        var url = '/checkout' + item.getPDPURL(false) + '?' + params;

        uri.redirect({ url: url });
    },

    /**
     * @deprecated since .COM version 56.
     * We don't ever want to POST to checkout any more. We should always use a GET with query params.
     * Use offer.redirectToCheckout instead.
     */
    postToCheckout: function postToCheckout(options) {
        console.warn("Calling deprecated function! Use redirectToCheckout instead.");
        this.redirectToCheckout(options);
    },
    idAttribute: "id",
    /**
     * @memberof bunsen.Offer
     * @returns {string}
     */
    url: function url() {
        return endpoints.offer(this.get(this.idAttribute));
    },
    defaults: {
        amountPerItem: {},
        subTotalAmount: {},
        quantity: 1,
        notes: [],
        transaction: {}
    },
    relations: function relations() {
        return [{
            type: Backbone.One,
            key: 'item',
            relatedModel: SoaModel,
            collectionType: SoaCollection
        }, {
            type: Backbone.One,
            key: 'transaction',
            relatedModel: Transaction,
            saveJSONFields: ['id']
        }, {
            type: Backbone.One,
            key: 'adjustments',
            relatedModel: AdjustmentList,
            collectionType: SoaCollection
        }, {
            type: Backbone.Many,
            key: 'notes',
            collectionType: Notes
        }, {
            type: Backbone.One,
            key: 'paymentAuthorization',
            relatedModel: PaymentAuthorization,
            collectionType: SoaCollection
        }, {
            type: Backbone.One,
            key: 'initiatingParty',
            relatedModel: Party
        }, {
            type: Backbone.One,
            key: 'counterParty',
            relatedModel: Party
        }, {
            type: Backbone.One,
            key: 'amountPerItem',
            relatedModel: FinancialAmount
        }, {
            type: Backbone.One,
            key: 'subTotalAmount',
            relatedModel: FinancialAmount
        }, {
            type: Backbone.One,
            key: 'totalAmount',
            relatedModel: FinancialAmount
        }, {
            type: Backbone.One,
            key: 'expirationPeriod',
            relatedModel: Period
        }];
    },
    getQuantity: function getQuantity() {
        return Number(this.get('quantity'));
    },
    getSellerId: function getSellerId() {
        if (this.isDealerInitiatedOffer()) {
            return this.get('initiatingParty').id;
        } else {
            return this.get('counterParty').id;
        }
    },
    getInitiatingPartyRole: function getInitiatingPartyRole() {
        return this.get('initiatingParty').getRole();
    },
    getCounterPartyRole: function getCounterPartyRole() {
        return this.get('counterParty').getRole();
    },
    isBuyerInitiatedOffer: function isBuyerInitiatedOffer() {
        return this.get('initiatingParty').isBuyer();
    },
    isDealerInitiatedOffer: function isDealerInitiatedOffer() {
        return this.get('initiatingParty').isSeller();
    },
    isAccepted: function isAccepted() {
        return Offer.STATUS_ACCEPTED === this.get('status');
    },
    isSubmitted: function isSubmitted() {
        return this.get('status') === Offer.STATUS_SUBMITTED;
    },
    isExpired: function isExpired() {
        return this.get('status') === Offer.STATUS_EXPIRED;
    },
    isNewStatus: function isNewStatus() {
        return this.get('status') === Offer.STATUS_NEW;
    },
    isCanceled: function isCanceled() {
        return this.get('status') === Offer.STATUS_CANCELED;
    },
    isRequested: function isRequested() {
        return this.get('status') === Offer.STATUS_REQUESTED;
    },
    getTaxAmount: function getTaxAmount(currency) {
        var adjustments = this.get('adjustments');
        if (adjustments) {
            return adjustments.getMerchTaxTotal(currency);
        }
        return 0;
    },
    hasTax: function hasTax() {
        return this.getTaxAmount(FinancialAmount.CURRENCY_USD) > 0;
    },
    /**
     * Creates a new empty counter offer from this offer,
     * (same item, roles reversed, amounts emptied)
     */
    newCounterOffer: function newCounterOffer() {
        var offer = new Offer({
            transaction: {
                id: this.get('transaction.id')
            },
            quantity: this.get('quantity'),
            counterParty: {
                id: this.get('initiatingParty.id'),
                role: this.getInitiatingPartyRole()
            },
            initiatingParty: {
                id: this.get('counterParty.id'),
                role: this.getCounterPartyRole()
            },
            amountPerItem: this.get('amountPerItem').toJSON(),
            subTotalAmount: {
                amount: this.get('amountPerItem.amount') * this.get('quantity'),
                currency: this.get('amountPerItem.currency')
            }
        });
        return offer;
    },
    newAmendedOffer: function newAmendedOffer() {
        var offer = this.clone();
        _.each(['id', 'status', 'createdDate', 'expirationDate', 'expiredDate', 'modifiedDate'], offer.unset.bind(offer));
        return offer;
    },
    accept: function accept(passedOptions) {
        return this.transition(Offer.STATUS_ACCEPTED, passedOptions);
    },
    counter: function counter(counterOffer, passedOptions) {
        var options = passedOptions || {};
        _.extend(options, {
            queries: counterOffer._getCounterOfferQueryParams()
        });
        return this.transition(Offer.STATUS_COUNTERED, options);
    },
    _getCounterOfferQueryParams: function _getCounterOfferQueryParams() {
        return {
            counterOfferAmount: this.get('amountPerItem.amount'),
            counterOfferCurrency: this.get('amountPerItem.currency')
        };
    },
    _actOnOffer: function _actOnOffer(role, counterOffer, passedOptions) {
        var options = void 0;
        var dynaOptions = void 0;
        var clump = new Clump();
        var saves = void 0;

        if (!!passedOptions && passedOptions.noteContent) {
            dynaOptions = {
                "open": "___",
                "close": "___",
                "params": {
                    counterOfferId: {
                        clumpElement: "counterOffer",
                        expression: "$.result.counterOfferId"
                    }
                }
            };
        }

        // If no counter offer, accept this offer
        if (!counterOffer) {
            return this.accept();
        }

        options = _.extend({}, passedOptions || {}, {
            counterOffer: counterOffer,
            noteRole: role
        });
        saves = this.clumpCounterOfferNote(clump, options);
        clump.run({ dynaOptions: dynaOptions });
        return $.when.apply($, saves);
    },
    /**
     * Accepts or counters an offer, will add note to counter
     * @param [counterOffer] - will accept the offer if this is null
     * @param [passedOptions]
     * @returns {*}
     */
    dealerActOnOffer: function dealerActOnOffer(counterOffer, passedOptions) {
        return this._actOnOffer(Party.ROLE_SELLER, counterOffer, passedOptions);
    },
    buyerActOnOffer: function buyerActOnOffer(counterOffer, passedOptions) {
        return this._actOnOffer(Party.ROLE_BUYER, counterOffer, passedOptions);
    },
    /**
     * Pass in a clump instance and it will counter the offer and create the note on it.
     * Add more stuff with the same clump and run it later.
     * @param clump
     * @param passedOptions
     * @returns {Array}
     */
    clumpCounterOfferNote: function clumpCounterOfferNote(clump, passedOptions) {
        var note = void 0;
        var saves = [];
        var options = passedOptions || {};
        saves.push(this.counter(options.counterOffer, {
            clump: clump,
            clumpName: 'counterOffer'
        }));

        if (options.noteContent) {
            note = options.counterOffer.newBuyerSellerNote({
                content: options.noteContent,
                role: options.noteRole
            });
            note.setAnchorId('OFFER', "___counterOfferId___");
            saves.push(note.save(null, { clump: clump }));
        }
        return saves;
    },
    newBuyerSellerNote: function newBuyerSellerNote(passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            type: Note.TYPE_BUYER_SELLER
        });
        return this.newNote(options);
    },
    newNote: function newNote(passedOptions) {
        var options = _.defaults(passedOptions, {
            anchors: [{
                sourceId: this.get('transaction').id,
                sourceType: Anchor.TYPE_TRANSACTION
            }, {
                sourceId: this.getSellerId(),
                sourceType: Anchor.TYPE_SELLER
            }, {
                sourceId: this.id,
                sourceType: Anchor.TYPE_OFFER
            }]
        });
        return this.get('notes').newNote(options);
    },
    addNewNote: function addNewNote(noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },
    getAmountPerItem: function getAmountPerItem(currency) {
        return this._getFinancialAmount('amountPerItem', currency);
    },
    getAcceptedDate: function getAcceptedDate() {
        var unixDate = this.get('acceptedDate');
        var acceptedDate = new Date(unixDate);
        return acceptedDate.getMonth() + 1 + '-' + acceptedDate.getFullYear();
    }
}, transitionMixin, financialAmountMixin);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 7/20/15.
 */



module.exports = {
    NAV: {
        'ACTIVE_GROUP_CHANGED': 'globalNav:activeGroupChanged',
        'ITEMS_ADDED': 'globalNav:itemsAdded',
        'ITEMS_REMOVED': 'globalNav:itemsRemoved',
        'TOGGLE_MENU': 'globalNav:toggleMenu',
        'TOGGLE_SEARCH': 'globalNav:toggleSearch',
        'NAVIGATED': 'globalNav:navigated',
        'RECEIVED_LIST_DATA': 'globalNav:receivedListData'
    },
    SEARCH: {
        'SEARCH_TERM_CHANGED': 'SEARCH_TERM_CHANGED',
        'SEARCH_RESULT_RETURNED': 'SEARCH_RESULT_RETURNED'
    },
    CART: {
        'cart:updated': 'cart:updated'
    },
    HAMBURGER: {
        'UPDATE_LOGIN': 'hamburgerMenu:updateLogin',
        'UPDATE_USER_INITIALS': 'hamburgerMenu:updateUserInitials',
        'UPDATE_USER_STATES': 'hamburgerMenu:updateUserStates'
    }
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Shad
 * Date: 8/13/13
 */


var ShipmentQuote = __webpack_require__(73);

var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};
var TransactionShipmentQuote = module.exports = bunsen.TransactionShipmentQuote = ShipmentQuote.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var endpoints = __webpack_require__(6);
var SoaModel = __webpack_require__(2);
var AdjustmentList = __webpack_require__(56);
var Notes = __webpack_require__(24);
var Note = __webpack_require__(33);
var Party = __webpack_require__(8);
var Anchor = __webpack_require__(12);
var transitionMixin = __webpack_require__(19);
var assert = __webpack_require__(31);

_.extend(TransactionShipmentQuote, {
    STATUS_NEW: 'NEW',
    STATUS_SUBMITTED: 'SUBMITTED',
    STATUS_DEALER_REJECTED: 'DEALER_REJECTED',
    STATUS_DEALER_ACCEPTED: 'DEALER_ACCEPTED',
    STATUS_BUYER_ACCEPTED: 'BUYER_ACCEPTED',
    STATUS_PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
    STATUS_ACCEPTED: 'ACCEPTED',
    STATUS_CANCELED: 'CANCELED'
});

_.extend(TransactionShipmentQuote.prototype, {
    idAttribute: "id",
    anchorType: Anchor.TYPE_SHIPMENT_QUOTE,

    defaults: _.extend({}, ShipmentQuote.prototype.defaults, {
        notes: [],
        complimentaryShipping: 'N'
    }),

    initialize: function () {

        TransactionShipmentQuote.__super__.initialize.apply(this, arguments);
        this.url = function () {
            return endpoints.ecomShipmentQuote(this.id);
        };
    },
    relations: function () {
        // Get the parent's relations and add ecom specific relations.
        var relations = _.result(ShipmentQuote.prototype, 'relations').slice(0);
        relations.push(SoaModel.createRelations([
            {
                type : Backbone.One,
                key : 'adjustments',
                relatedModel : AdjustmentList
            },
            {
                type: Backbone.Many,
                key: 'notes',
                collectionType: Notes,
                omitFromSave: true
            },
            {
                type: Backbone.One,
                key: 'anchor',
                relatedModel: SoaModel
            }
        ]));
        return _.flatten(relations);
    },
    getTransactionId: function () {
        if (this.get('anchor.sourceType') === 'TRANSACTION') {
            return this.get('anchor.sourceId');
        }
    },

    wasAcceptedByDealer: function () {
        var statuses = ['DEALER_ACCEPTED', 'PAYMENT_REQUIRED', 'BUYER_ACCEPTED'];
        return _.contains(statuses, this.get('status'));
    },
    wasAcceptedByBuyer: function () {
        return this.get('status') === TransactionShipmentQuote.STATUS_BUYER_ACCEPTED;
    },
    wasAcceptedForAccounting: function () {
        return this.isAccountingQuote() && this.get('status') === TransactionShipmentQuote.STATUS_ACCEPTED;
    },
    isQuoteRequest: function () {
        return this.get('status') === TransactionShipmentQuote.STATUS_NEW;
    },
    isQuoteSubmitted: function () {
        return this.get('status') === TransactionShipmentQuote.STATUS_SUBMITTED;
    },
    isActive: function () {
        var statuses = [TransactionShipmentQuote.STATUS_CANCELED, TransactionShipmentQuote.STATUS_DEALER_REJECTED];
        return !_.contains(statuses, this.get('status'));
    },
    isActiveAccountingQuote: function () {
        return this.isAccountingQuote() && this.get('status') !== TransactionShipmentQuote.STATUS_DEALER_REJECTED && this.get('status') !== TransactionShipmentQuote.STATUS_CANCELED;
    },
    isRejectedAccountingQuote: function () {
        return this.isAccountingQuote() && this.get('status') === TransactionShipmentQuote.STATUS_DEALER_REJECTED;
    },
    getSellerId: function () {
        // TODO: This is probably not reliable if used outside of a transaction.
        return this.collection.parents[0].get('seller').id;
    },
    isComplimentary: function () {
        return this.get('complimentaryShipping') === 'Y';
    },
    isFreeToBuyer: function () {
        return !this.hasCostGreaterThanZero() || this.isComplimentary();

    },
    getTaxAmount: function (currency) {
        var adjustments = this.get('adjustments');
        if (adjustments) {
            return adjustments.getShippingTaxTotal(currency);
        }
        return 0;
    },
    newNote: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            anchors: [
                {
                    sourceId : this.getTransactionId(),
                    sourceType : Anchor.TYPE_TRANSACTION
                },
                {
                    sourceId: this.id,
                    sourceType: Anchor.TYPE_SHIPMENT_QUOTE
                },
                {
                    sourceId: this.getSellerId(),
                    sourceType: Anchor.TYPE_SELLER
                }
            ]
        });
        return this.get('notes').newNote(options);
    },
    addNewNote : function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },
    newBuyerSellerNote: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            type: Note.TYPE_BUYER_SELLER
        });
        return this.newNote(options);
    },
    getLastNote: function () {
        var notes = this.get('notes');
        return notes ? notes.last() : null;
    },
    setComplimentaryIfFree: function () {
        if (!this.hasCostGreaterThanZero()) {
            this.set('complimentaryShipping', 'Y');
        }
    },
    /**
     * Accept/Counter offer while creating shipment quote with note
     * @param {Offer} offer
     * @param {Offer} counterOffer
     * @param {object} [passedOptions]
     */
    dealerSubmitWithOffer: function (offer, counterOffer, passedOptions) {
        this.setComplimentaryIfFree();
        return this.dealerTransitionWithOfferNote(null, offer, counterOffer, passedOptions);
    },
    /**
     * Accept/Counter offer while accepting shipment quote with note
     * @param {Offer} offer
     * @param {Offer} counterOffer
     * @param {object} [passedOptions]
     * @returns {$.Deferred.promise}
     */
    dealerAcceptWithOffer: function (offer, counterOffer, passedOptions) {
        var options = _.extend({
            transitionFunction: 'updateAndTransition'
        }, passedOptions);
        this.setComplimentaryIfFree();
        return this.dealerTransitionWithOfferNote(
            TransactionShipmentQuote.STATUS_DEALER_ACCEPTED,
            offer,
            counterOffer,
            options
        );
    },
    updateAccountingQuote: function (clump) {
        assert(this.isAccountingQuote(), 'quote must be an accounting quote');
        return this.save(null, { clump: clump });
    },
    /**
     * @param {Clump} [clump]
     * @returns {$.Deferred.promise}
     */
    acceptAccountingQuote: function (clump) {
        assert(this.isAccountingQuote(), 'quote must be an accounting quote');
        return this.updateAndTransition(TransactionShipmentQuote.STATUS_ACCEPTED, { clump: clump });
    },

    /**
     * @param {Clump} [clump]
     * @returns {$.Deferred.promise}
     */
    rejectAccountingQuoteForDealer: function (clump) {
        assert(this.isAccountingQuote(), 'quote must be an accounting quote');
        return this.transition(TransactionShipmentQuote.STATUS_DEALER_REJECTED, { clump: clump });
    },

    /**
     * Save this quote model instance as a 'submitted' 1stdibs quote
     * to the logistics service, which will then be displayed to the
     * dealer for approval.
     * @param {object} [passedOptions]
     * @returns {$.Deferred.promise}
     */
    provide1stdibsQuote: function (passedOptions) {
        var options = _.extend({
            noteRole: Party.ROLE_INTERNAL,
            noteType: Note.TYPE_SELLER_ADMIN,
            transitionFunction: 'updateAndTransition'
        }, passedOptions);
        this.setComplimentaryIfFree();
        return this.transitionWithNote(TransactionShipmentQuote.STATUS_SUBMITTED, options);
    },
    saveModifiedQuote: function (passedOptions) {
        var options = _.extend({
            noteRole: Party.ROLE_INTERNAL,
            noteType: Note.TYPE_SELLER_ADMIN,
            transitionFunction: 'update'
        }, passedOptions);
        this.setComplimentaryIfFree();
        return this.transitionWithNote(null, options);
    },

    /**
     * Saves the shipmentQuote with notes on them, have to use temporary SoaModel
     * as currently notes are omitted from the save on this model
     * @returns {*|$.Deferred.promise}
     */
    saveWithNotes: function () {
        var soaModel = new SoaModel(this.toJSON());
        soaModel.url = endpoints.ecomShipmentQuote(this.id);
        return soaModel.save();
    }

}, transitionMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(206);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  return ('WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  return JSON.stringify(v);
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}
  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Module dependencies.
 */

try {
  var query = __webpack_require__(86);
} catch (err) {
  var query = __webpack_require__(86);
}

var Element = __webpack_require__(89).Element;
var proto = Element && Element.prototype || {};
var vendor = proto.matches
  || proto.matchesSelector
  || proto.webkitMatchesSelector
  || proto.mozMatchesSelector
  || proto.msMatchesSelector
  || proto.oMatchesSelector;

module.exports = match;

/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function match(el, selector) {
  if (!el || el.nodeType !== 1) return false;
  if (vendor) return vendor.call(el, selector);
  var nodes = query.all(selector, el.parentNode);
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i] == el) return true;
  }
  return false;
}


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Builds a new instance of the constructor from the given key, with additional arguments passed to the contructor.
// @param {string} key - the key that was associated with the constructor in a prior call to register
var registryStack = [];
var newsy = module.exports = function (key) {
    if (!getRegistry()[key]) {
        throw new Error(key + " is not a registered constructor");
    }
    if (getRegistry()[key].unsatisfiedDependencies) {
        throw new Error(key + " has unmet dependencies: " + Object.keys(getRegistry()[key].unsatisfiedDependencies).join(", "));
    }
    return getRegistry()[key].build(Array.prototype.splice.call(arguments, 1));
};
var getRegistry = newsy.getRegistry = function () {
    return global.__newsyRegistry__;
};
var setRegistry = newsy.setRegistry = function (registry) {
    global.__newsyRegistry__ = registry;
};
setRegistry(global.__newsyRegistry__ || {});
// saves the current registry onto the private registryStack, and exposes a new registry. Only useful for testing
newsy.newRegistry = function () {
    registryStack.push(getRegistry());
    setRegistry({});
};

// pops the top of registryStack onto the current registry, replacing what was already there.
newsy.restoreRegistry = function () {
    setRegistry(registryStack.pop());
};

// Registers a new constructor to be associated with a key.
// @param {String} key - key with with the constructor will be associated
// @param {Constructor} constructor - constructor that will be assocaited with the key
newsy.register = function (constructor, key) {
    var dependencyIndex;
    var dependencyKey;
    var registration;
    var i;
    if (constructor instanceof Array) {
        for (i = 0; i < constructor.length; ++i) {
            newsy.register(constructor[i]);
        }
        return;
    }
    if (!constructor.newsy && !key) {
        throw new Error("constructor does not have a 'newsy' property and no key was provided to newsy.register");
    }
    if (!key && "string" === typeof constructor.newsy) {
        key = constructor.newsy;
    } else if (!key && constructor.newsy.name) {
        key = constructor.newsy.name;
    }
    if (!key) {
        throw new Error("constructor does not have a newsy name. Specify it as static.newsy or static.newsy.name, or as the second argument to newsy.register");
    }
    registration = getRegistry()[key] = {
        build: function (args) {
            function F() {
                return constructor.apply(this, args);
            }
            F.prototype = constructor.prototype;
            return new F();
        },
        originalConstructor: constructor,
        unsatisfiedDependencies: undefined
    };
    // build a truth map of the current unmet dependencies
    if (constructor.newsy && constructor.newsy.builds) {
        for (dependencyIndex = 0; dependencyIndex < constructor.newsy.builds.length; ++dependencyIndex) {
            dependencyKey = constructor.newsy.builds[dependencyIndex];
            if (!getRegistry()[dependencyKey]) {
                if (!registration.unsatisfiedDependencies) {
                    registration.unsatisfiedDependencies = {};
                }
                // declare dependencyKey to be a dependency of key
                registration.unsatisfiedDependencies[dependencyKey] = true;
            }
        }
    }
    if (!registration.unsatisfiedDependencies) {
        newsy._dependencySatisfied(key);
    }
    return constructor;
};

newsy.getConstructor = function (options) {
    var Constructor;
    if ("string" === typeof options) {
        options = {key: options};
    }
    if (!options.key) {
        throw new Error('constructor key required for getConstructor');
    }
    Constructor = getRegistry()[options.key];
    Constructor = (Constructor && Constructor.originalConstructor) || options.defaultConstructor;
    if (!Constructor) {
        throw new Error("No constructor for key " + options.key);
    }
    return Constructor;
};

// declares a dependency as fully satisfied, and proparages the change through the entire dependency graph
newsy._dependencySatisfied = function (key) {
    var anyAreTrue;
    var registryKey;
    var dependencyKey;
    var newUnsatisfiedDependencies;
    var oldUnsatisfiedDependencies;
    // iterate through all the registered constructors
    for (registryKey in getRegistry()) {
        if (getRegistry().hasOwnProperty(registryKey)) {
            if (!getRegistry()[registryKey].unsatisfiedDependencies) {
                // registryKey has no unsatisfied dependencies to begin with
                continue;
            }
            if (!getRegistry()[registryKey].unsatisfiedDependencies[key]) {
                // key was not a dependency of registryKey to begin with
                continue;
            }
            // remove key as a dependency of registryKey
            getRegistry()[registryKey].unsatisfiedDependencies[key] = false;
            newUnsatisfiedDependencies = {};
            oldUnsatisfiedDependencies = getRegistry()[registryKey].unsatisfiedDependencies;
            anyAreTrue = false;
            for (dependencyKey in oldUnsatisfiedDependencies) {
                if (oldUnsatisfiedDependencies.hasOwnProperty(dependencyKey)) {
                    if (oldUnsatisfiedDependencies[dependencyKey]) {
                        newUnsatisfiedDependencies[dependencyKey] = true;
                        anyAreTrue = true;
                    }
                }
            }
            // if none of the dependencies are true, adjust the entire depenency graph to reflect this
            if (anyAreTrue) {
                // registryKey still has unsatisfied dependencies
                getRegistry()[registryKey].unsatisfiedDependencies = newUnsatisfiedDependencies;
                continue;
            }
            getRegistry()[registryKey].unsatisfiedDependencies = undefined;
            // all of registryKey's dependencies have been satisfied, so everything that depends on it can now remove registryKey as a dependency
            newsy._dependencySatisfied(registryKey);
        }
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(52);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(112)
var ieee754 = __webpack_require__(116)
var isArray = __webpack_require__(113)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);

// ---------------------------------------------------
// Module Definition

/**
 * @class FieldRule
 *
 * Base pseudoclass for validated field rules. Contains
 * an 'outputSchema' method that outputs an object used
 * by the {@link Validator} class. You extend this
 * class and define a 'validate' method (returning a
 * boolean) to tell the Validator class if the
 * field violates this Rule or not.
 * @param {object} [options]
 * @param {boolean} [options.noMatch] Overrides property of the same name
 * @param {string} [options.message] Overrides property of the same name
 * @param {string} [options.messageBody="is invalid"] Overrides property of the same name
 *
 * @property {string} message
 *      A message for to display if {@link Validator}
 *      determines a field's value to be false for this
 *      rule
 * @property {boolean} noMatch
 *      If the inverse of this rule's result should be
 *      used to determine if a validation error occurred or
 *      not. For example: if the rule's validate method
 *      returns 'true', which would normally pass validation,
 *      it would be considered an error if noMatch is true.
 * @property {string} messageBody
 *      If defined and the parent {@link FieldValidation}
 *      has a fieldDisplayName defined, than they will be combined
 *      to create a 'message'. This is a assuming a message is
 *      not defined. If a custom message option is provided, then
 *      messageBody will be ignored
 * @property {string} defaultMessage
 *      If no 'message' exists and one cannot be constructed
 *      from the 'messageBody', then the 'defaultMessage'
 *      wold be used for this field.
 *
 */
var FieldRule = module.exports = function () {
    this.initialize.apply(this, arguments);
};

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(FieldRule.prototype, {

    messageBody: "is invalid",

    initialize: function (options) {
        options = options || {};
        this.validate = options.validate || this.validate;
        this.noMatch = _.isBoolean(options.noMatch) ? options.noMatch : this.noMatch;
        this.setMessage(!_.isUndefined(options.message) ? options.message : this.message);
        this.setMessageBody(!_.isUndefined(options.messageBody) ? options.messageBody : this.messageBody);
    },

    /**
     * Set the error message for this rule
     * should the validation not pass
     * @param message
     * @returns {FieldRule}
     */
    setMessage: function (message) {
        this.message = message;
        return this;
    },

    /**
     * @param messageBody
     * @returns {FieldRule}
     */
    setMessageBody: function (messageBody) {
        this.messageBody = messageBody;
        this.defaultMessage = 'This field ' + messageBody;
        return this;
    },

    /**
     * @param {FieldValidation} parentValidation
     * @returns {FieldRule}
     */
    setParentValidation: function (parentValidation) {
        this._parentValidation = parentValidation;
        return this;
    },

    /**
     * @returns {FieldValidation}
     */
    getParentValidation: function () {
        return this._parentValidation;
    },

    ///**
    // * Default message function
    // * @returns {string}
    // */
    //message: function () {
    //    var messageBody = _.result(this, 'messageBody');
    //    var parentValidation = this.getParentValidation();
    //    if (parentValidation && parentValidation.fieldDisplayName && messageBody) {
    //        return FieldRule.createMessageWithBody(parentValidation.fieldDisplayName, messageBody);
    //    }
    //    return _.result(this, 'defaultMessage') || 'This field is invalid';
    //},

    /**
     * Override in extension. Gets invoked by {@link Validator}
     * @param {Backbone.Model} model
     * @param {*} value
     * @param {string} fieldName
     * @returns {boolean}
     */
    validate: function (model, value, fieldName, required) {}, //eslint-disable-line

    /**
     * Output the {@link Validator} config json
     * for this rule
     * @returns {object}
     */
    outputSchema: function () {
        var self = this;
        return {
            noMatch: self.noMatch,
            message: self.message,
            validator: function (value, fieldName, required) {
                if (required !== !!required) { // if required isn't a bool (undefined, null, whatever) then default to true
                    required = true;
                }
                return self.validate(this, value, fieldName, required); // "this" is the model in this context
            }
        };
    }
}, Backbone.Events);

// ---------------------------------------------------
// Define Module Static Properties

_.extend(FieldRule, {
    /**
     * @function
     * @param {object} instanceProperties
     * @param {object} staticProperties
     * @returns {function} New constructor function
     */
    extend: Backbone.Model.extend, // Give this pseudoclass the ability to be extended,

    /**
     * @param {string} fieldDisplayName
     * @param {string} messageBody
     * @returns {string}
     */
    createMessageWithBody: function (fieldDisplayName, messageBody) {
        return '"' + fieldDisplayName + '" field ' + messageBody;
    }

});


/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// globalDataLogger is for dumping forensic data to rollbar when something bad happens

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var clone = __webpack_require__(124);
var log = __webpack_require__(292);
var logger = module.exports = {
    reset: function reset() {
        logger._eventLog = [];
    },
    event: function event(obj) {
        logger._eventLog = logger._eventLog || [];
        if ('object' === (typeof obj === 'undefined' ? 'undefined' : _typeof(obj))) {
            obj = clone(obj);
        }
        logger._eventLog.push(obj);
    },
    stringify: function stringify() {
        return window.JSON.stringify(logger._eventLog);
    },
    flush: function flush() {
        if (0 === logger._eventLog.length) {
            return;
        }
        log.remote.error(window.JSON.stringify(logger._eventLog));
        logger.reset();
    }
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


module.exports = __webpack_require__(143);


/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var _ = __webpack_require__(0);
var SoaModel = __webpack_require__(2);
var Action = SoaModel.extend();

_.extend(Action.prototype, {
    isCode : function (code) {
        return this.get('code') === code;
    }
});


//constants
_.extend(Action, {
    CODE_ADMIN_APPROVES_AUTH_REVIEW: "ADMIN_APPROVES_AUTH_REVIEW",
    CODE_ADMIN_PROVIDES_FIRSTDIBS_QUOTE: "ADMIN_PROVIDES_FIRSTDIBS_QUOTE",
    CODE_ADMIN_PROVIDE_ACCOUNTING_QUOTE: "ADMIN_PROVIDE_ACCOUNTING_QUOTE",
    CODE_ADMIN_MARK_SHIPPED: "ADMIN_MARK_SHIPPED",
    CODE_ADMIN_MARK_DELIVERED: "ADMIN_MARK_DELIVERED",
    CODE_ADMIN_CORRECT_SHIPPING: "ADMIN_CORRECT_SHIPPING",
    CODE_ADMIN_WIRE_TRANSFER_DETAILS: "ADMIN_WIRE_TRANSFER_DETAILS",
    CODE_ADMIN_WIRE_TRANSFER_CAPTURE: "ADMIN_WIRE_TRANSFER_CAPTURE",
    CODE_ADMIN_CHECK_DETAILS: "ADMIN_CHECK_DETAILS",
    CODE_ADMIN_CHECK_CAPTURE: "ADMIN_CHECK_CAPTURE",
    CODE_ADMIN_MANUAL_CAPTURE: "ADMIN_MANUAL_CAPTURE",
    CODE_ADMIN_REFUND_CAPTURE: "ADMIN_REFUND_CAPTURE",
    CODE_ADMIN_MODIFY_SHIPMENT_QUOTE: "ADMIN_MODIFY_SHIPMENT_QUOTE",
    CODE_ADMIN_MODIFY_ORDER: "ADMIN_MODIFY_ORDER",
    CODE_ADMIN_ADD_BUYER_PMT_AUTH: "ADMIN_ADD_BUYER_PMT_AUTH",
    CODE_ADMIN_ADD_DEALER_PMT_AUTH: "ADMIN_ADD_DEALER_PMT_AUTH",
    CODE_ADMIN_BUYER_REAUTH_PMT: "BUYER_REAUTH_PMT",

    CODE_DEALER_COUNTER_OFFER_PRE_CHECKOUT: "DEALER_COUNTER_OFFER_PRE_CHECKOUT",
    CODE_DEALER_ACCEPT_OFFER_PRE_CHECKOUT: "DEALER_ACCEPT_OFFER_PRE_CHECKOUT",
    CODE_DEALER_AMEND_OFFER_PRE_CHECKOUT: "DEALER_AMEND_OFFER_PRE_CHECKOUT",

    CODE_DEALER_MARK_ITEM_NOT_AVAILABLE: "DEALER_MARK_ITEM_NOT_AVAILABLE",
    CODE_DEALER_REQUEST_FIRSTDIBS_QUOTE: "DEALER_REQUEST_FIRSTDIBS_QUOTE",
    CODE_DEALER_PROVIDE_QUOTE: "DEALER_PROVIDE_QUOTE",
    CODE_DEALER_REVIEW_FIRSTDIBS_QUOTE: "DEALER_REVIEW_FIRSTDIBS_QUOTE",
    CODE_DEALER_ACCEPT_OFFER: "DEALER_ACCEPT_OFFER",
    CODE_DEALER_COUNTER_OFFER: "DEALER_COUNTER_OFFER",
    CODE_DEALER_MARK_SHIPPED: "DEALER_MARK_SHIPPED",
    CODE_DEALER_MARK_READY_FOR_PICKUP: "DEALER_MARK_READY_FOR_PICKUP",

    // will be removed when N2.0 is released
    CODE_BUYER_CHECKOUT_OFFER: "BUYER_CHECKOUT_OFFER",

    CODE_BUYER_ACCEPT_OFFER: "BUYER_ACCEPT_OFFER",
    CODE_BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER: "BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER",
    CODE_BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER: "BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER",
    CODE_BUYER_PASS_OFFER_PRE_CHECKOUT: "BUYER_PASS_OFFER_PRE_CHECKOUT",
    CODE_BUYER_COUNTER_OFFER_PRE_CHECKOUT: "BUYER_COUNTER_OFFER_PRE_CHECKOUT",
    CODE_BUYER_NOT_INTERESTED_OFFER_PRE_CHECKOUT: "BUYER_NOT_INTERESTED_OFFER_PRE_CHECKOUT",
    CODE_BUYER_COUNTER_OFFER: "BUYER_COUNTER_OFFER",
    CODE_BUYER_BALANCE_DUE: "BUYER_BALANCE_DUE",
    CODE_BUYER_MARK_SHIPPED: "BUYER_MARK_SHIPPED",
    CODE_BUYER_SUBMIT_INVOICE: "BUYER_SUBMIT_INVOICE"
});

module.exports = Action;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(111)))

/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PortfolioItemModel = __webpack_require__(291);
var endpoints = __webpack_require__(6);

module.exports = PortfolioItemModel.extend({

    url: function () {
        return endpoints.cartPortfolioAddItem(this.get('item.id'));
    },

    defaults: {
        loggedOut: false,
        createdDate: '',
        item: {}
    }

});



/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org 

var _ = __webpack_require__(152);

// Helpers
// -------

// Helper function to correctly set up the prototype chain, for subclasses.
// Similar to `goog.inherits`, but uses a hash of prototype properties and
// class properties to be extended.
var extend = module.exports.extend = function(protoProps, staticProps) {

  var parent = this;
  var child;

  // The constructor function for the new subclass is either defined by you
  // (the "constructor" property in your `extend` definition), or defaulted
  // by us to simply call the parent's constructor.
  if (protoProps && _.has(protoProps, 'constructor')) {
    child = protoProps.constructor;
  } else {
    child = function(){ return parent.apply(this, arguments); };
  }

  // Add static properties to the constructor function, if supplied.
  _.extend(child, parent, staticProps);

  // Set the prototype chain to inherit from `parent`, without calling
  // `parent`'s constructor function.
  var Surrogate = function(){ this.constructor = child; };
  Surrogate.prototype = parent.prototype;
  child.prototype = new Surrogate();

  // Add prototype properties (instance properties) to the subclass,
  // if supplied.
  if (protoProps) _.extend(child.prototype, protoProps);

  // Set a convenience property in case the parent's prototype is needed
  // later.
  child.__super__ = parent.prototype;

  return child;

};

var urlError = module.exports.urlError = function() {
  throw new Error('A "url" property or function must be specified');
};

// Wrap an optional error callback with a fallback error event.
var wrapError = module.exports.wrapError = function (model, options) {
  var error = options.error;
  options.error = function(resp) {
    if (error) error(model, resp, options);
    model.trigger('error', model, resp, options);
  };
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/4/13
 */

var SoaModel = __webpack_require__(2);
var AdjustmentList = SoaModel.extend();

module.exports = AdjustmentList;

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var Adjustment = __webpack_require__(130);
var getAdjustmentsTotalByfn;
var getAdjustmentsByFn;


getAdjustmentsTotalByfn = function (fn, currency) {
    return _.reduce(getAdjustmentsByFn.call(this, fn), function (memo, adjustment) {
        return memo + (parseFloat(adjustment.getTotalAmount(currency)) || 0);
    }, 0, this);
};

getAdjustmentsByFn = function (fn) {
    if (!this.get('documents')) {
        return [];
    }
    return this.get('documents').filter(function (adjustment) {
        return adjustment[fn]();
    });
};
/**
 * @class AdjustmentList
 * @extends SoaModel
 * @property {array} relations
 *      @property relations.type {Backbone.One}
 *      @property relations.key {string}- "item"
 *      @property relations.relatedModel {Backbone.Model}
 *      @property relations.collectionType {Backbone.Models}
 */
_.extend(AdjustmentList.prototype, {
    relations: [{
        type: Backbone.Many,
        key: 'documents',
        relatedModel: Adjustment
    }],
    getMerchTaxTotal: _.partial(getAdjustmentsTotalByfn, 'isMerchTaxAdjustment'),
    getShippingTaxTotal: _.partial(getAdjustmentsTotalByfn, 'isShippingTaxAdjustment'),
    getCommissionTotal: _.partial(getAdjustmentsTotalByfn, 'isCommissionAdjustment'),
    getProcessingFeeTotal: _.partial(getAdjustmentsTotalByfn, 'isProcessingFeeAdjustment'),
    getListingCreditTotal: _.partial(getAdjustmentsTotalByfn, 'isListingCreditAdjustment'),
    getComplimentaryShippingTotal: _.partial(getAdjustmentsTotalByfn, 'isComplimentaryShipping'),
    getDealerChargeTotal: _.partial(getAdjustmentsTotalByfn, 'isDealerCharge'),
    getPromotionTotal: _.partial(getAdjustmentsTotalByfn, 'isPromotionAdjustment'),
    hasPromotion: function () {
        return !!getAdjustmentsByFn.call(this, 'isPromotionAdjustment').length;
    },
    getListingCreditAdjustment: function () {
        return getAdjustmentsByFn.call(this, 'isListingCreditAdjustment')[0];
    }
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 8/19/13
 */

var SoaModel = __webpack_require__(2);

var paymentMethodFactory = SoaModel.extend({
    constructor: function (data, options) {
        // declared down here for circular dependency reasons
        var WireTransfer = __webpack_require__(190);
        var Check = __webpack_require__(183);
        var CreditToUserAccount = __webpack_require__(185);
        var Discount = __webpack_require__(187);
        var DirectPayment = __webpack_require__(186);
        var Cash = __webpack_require__(182);
        var ACH = __webpack_require__(180);
        var NotAvailable = __webpack_require__(188);
        var CreditCard = __webpack_require__(184);
        var PayPalAccount = __webpack_require__(189);
        var ApplePay = __webpack_require__(181);

        switch (data.paymentMethodType) {
            case 'WIRE_TRANSFER':
                return new WireTransfer(data, options);
            case 'CHECK':
                return new Check(data, options);
            case 'CREDIT_TO_USER_ACCOUNT':
                return new CreditToUserAccount(data, options);
            case 'DISCOUNT':
                return new Discount(data, options);
            case 'DIRECT_PAYMENT':
                return new DirectPayment(data, options);
            case 'CASH':
                return new Cash(data, options);
            case 'ACH':
                return new ACH(data, options);
            case 'NOT_AVAILABLE':
                return new NotAvailable(data, options);
            case 'PAYPAL_ACCOUNT':
                return new PayPalAccount(data, options);
            case 'CREDIT_CARD':
                return new CreditCard(data, options);
            case 'APPLE_PAY':
                return new ApplePay(data, options);
            default:
                return new CreditCard(data, options);
        }
    }
});

module.exports = paymentMethodFactory;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var arrayEach = __webpack_require__(319),
    baseEach = __webpack_require__(304),
    bindCallback = __webpack_require__(122),
    isArray = __webpack_require__(64);

/**
 * Creates a function for `_.forEach` or `_.forEachRight`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over an array.
 * @param {Function} eachFunc The function to iterate over a collection.
 * @returns {Function} Returns the new each function.
 */
function createForEach(arrayFunc, eachFunc) {
  return function(collection, iteratee, thisArg) {
    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
      ? arrayFunc(collection, iteratee)
      : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
  };
}

/**
 * Iterates over elements of `collection` invoking `iteratee` for each element.
 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
 * (value, index|key, collection). Iteratee functions may exit iteration early
 * by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length" property
 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
 * may be used for object iteration.
 *
 * @static
 * @memberOf _
 * @alias each
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Array|Object|string} Returns `collection`.
 * @example
 *
 * _([1, 2]).forEach(function(n) {
 *   console.log(n);
 * }).value();
 * // => logs each value from left to right and returns the array
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
 *   console.log(n, key);
 * });
 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
 */
var forEach = createForEach(arrayEach, baseEach);

module.exports = forEach;


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constats = __webpack_require__(275);
var currencies = constats.currencies;
var currencySymbols = constats.symbols;
var abbreviations = constats.abbreviations;

/**
 * A more forgiving parseFloat
 * This is useful when consuming user-input
 * @param {number|string} number Either a formatted string (3,000) or integer (3000)
 * @returns {Number}
 */
exports.parseFloat = function dibsParsFloat(number) {
    return parseFloat(String(number).replace(/[^\d\.e-]/ig, '')) || 0;
};

/**
 * Round to the given precision
 * @param {number|string} number @see Number.parseFloat#number
 * @param {number} digits
 * @returns {number}
 */
exports.round = function round(number, digits) {
    var powed = Math.pow(10, digits);
    return Math.round(exports.parseFloat(number) * powed) / powed;
};

/**
 * Similar to PHP's number_format
 * @param number
 * @param {number} significantDigits The decimal place to round and fix a number to, Defaults to 0
 * @param {String} thousandsSeparator Defaults to ,
 * @param {String} decimalMark Defaults to .
 */
exports.format = function format(number, significantDigits, thousandsSeparator, decimalMark) {
    var suffix = '';
    var isNegative = number < 0;
    var bits;
    var i;

    if (isNegative) {
        number = number * -1;
    }

    significantDigits = significantDigits > -1 ? significantDigits : 0;
    thousandsSeparator = thousandsSeparator === undefined ? ',' : thousandsSeparator;
    decimalMark = decimalMark === undefined ? '.' : decimalMark;
    number = exports.round(number, significantDigits).toFixed(significantDigits);
    if (thousandsSeparator && number.match(/^\d{4}/)) {
        if (significantDigits) {
            suffix = number.substr(number.indexOf('.'));
            number = number.split('.')[0];
        }
        bits = number.split('');
        i = bits.length - 3;
        while (i > 0) {
            bits.splice(i, 0, thousandsSeparator);
            i -= 3;
        }
        number = bits.concat(suffix).join('');
    }
    if (decimalMark !== '.' && significantDigits) {
        number = number.replace(/\.(\d+)$/, decimalMark + '$1');
    }

    if (isNegative) {
        number = '-' + number;
    }

    return number;
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.abbreviation] Wheter to include an abbreviation or not
 * @param {boolean} [options.includeCurrencySymbol] Wheter to include a currency symbol or not
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {object}
 */
exports.localizedCashFormatObj = function (number, options) {
    options = Object.assign({
        includeCurrencySymbol: true
    }, options);
    var decimalsToShow = options.showDecimal === false ?  0 : 2;
    var thousandsSeparator = options.thousandsSeparator || ',';
    var decimalMark = options.decimalMark || '.';
    var currencySymbol = options.currencySymbol || '$';
    var abbreviation = options.abbreviation || '';
    var sign = '';

    number = exports.format(number, decimalsToShow, thousandsSeparator, decimalMark);
    currencySymbol = options.includeCurrencySymbol ? currencySymbol : '';

    // if it's negative we need to put the negative sign in front
    if (number.indexOf('-') !== -1) {
        sign = '-';
        number = number.replace('-', '');
    }

    return {
        sign: sign,
        currencySymbol: currencySymbol,
        number: number,
        abbreviation: abbreviation
    };
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.abbreviation] Wheter to include an abbreviation or not
 * @param {boolean} [options.includeCurrencySymbol] Wheter to include a currency symbol or not
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {string}
 */
exports.localizedCashFormat = function (number, options) {
    var localizedObject = exports.localizedCashFormatObj(number, options);
    var localizedNumber = localizedObject.number;
    var currencySymbol = localizedObject.currencySymbol;
    var abbreviation = localizedObject.abbreviation;
    var sign = localizedObject.sign;

    // if it's negative we need to put the negative sign in front
    if (sign) {
        sign = sign + ' ';
    }

    if (abbreviation.length) {
        abbreviation = ' ' + abbreviation;
    }

    if (options.formatNegativeAmount && sign) {
        return '(' + currencySymbol + localizedNumber + abbreviation + ')';
    }

    return sign + currencySymbol + localizedNumber + abbreviation;
};

/**
 * Converts a string containing numbers to an integer
 * @param  {string} amount
 * @return {number}
 */
exports.currencyToInteger = function (amount) {
    // Match all numbers and - sign
    var regexp = /-?[0-9]*/g;
    if (typeof amount === 'number') {
        return amount;
    } else if (typeof amount === 'string') {
        return parseInt(amount.match(regexp).join(''), 10);
    } else {
        return NaN;
    }
};

/**
 * Used internaly for intelligentFormat
 * @param  {number} The number to format
 * @param  {string}
 * @param  {object} passedOptions
 * @return {object}
 */
exports.getFormatOptions = function (amount, currency, passedOptions) {
    var options;
    var num = exports.parseFloat(amount);
    var currencyUppercase = (currency + '').toUpperCase();
    options = {
        // Only if there are decimals do we show them
        showDecimal : Math.ceil(num) !== Math.floor(num),
        thousandsSeparator : ',',
        decimalMark : '.',
        currencySymbol : currencySymbols.USD,
        abbreviation: abbreviations[currencyUppercase],
        formatNegativeAmount: false
    };

    switch (currencyUppercase) {
        case currencies.CURRENCY_GBP:
        case currencySymbols.GBP:
            options.currencySymbol = currencySymbols.GBP;
            break;
        case currencies.CURRENCY_CHF:
        case currencySymbols.CHF:
            options.includeCurrencySymbol = false;
            break;
        case currencies.CURRENCY_EUR:
        case currencySymbols.EUR:
            options.thousandsSeparator = '.';
            options.decimalMark = ',';
            options.currencySymbol = currencySymbols.EUR;
            break;
    }

    return Object.assign(options, passedOptions);
};


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: hella
 * Date: 3/30/14
 * Time: 2:50 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var browserCheck = __webpack_require__(478);

module.exports = {
    timer: {
        count: 0,
        interval: 1000,
        fn: null
    },
    ie: {
        lessThan10: browserCheck.ie8() || browserCheck.ie9(),
        isIE9: browserCheck.ie9(),
        isIE8: browserCheck.ie8()
    },
    noop: function () { },
    disallowAction: function (e) {
        if (e) {
            e.preventDefault();
        }
        return false;
    },
    ieRedirect: function (url) {
        if (url) {
            global.location.href = url;
        }
    },
    goBack: function () {
        // this needs to be fixed to look at the document.referrer
        if (global.history && global.history.length > 1) {
            global.history.back();
        } else {
            this.ieRedirect(global.location.pathname);
        }
        return false;
    }
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SoaModel = __webpack_require__(2);
var ConversationMember = module.exports = SoaModel.extend();
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var bunsen = __webpack_require__(21);
var User = __webpack_require__(28);
var Party = __webpack_require__(8);
var newsy = __webpack_require__(41);
var endpoints = __webpack_require__(6);
var userType = {
    external: 'EXTERNAL',
    seller: 'SELLER',
    buyer: 'BUYER'
};
var globalDataLogger = __webpack_require__(48);
var copyText = __webpack_require__(39)();
_.extend(ConversationMember, {
    userType: userType,
    newsy: 'ConversationMember',
    getMe : function (options) {
        var meInTheConversation;
        options = _.extend({
            userId: undefined,
            masquerade: false,
            masqueradeUserId: undefined,
            conversation: undefined
        }, options);
        meInTheConversation = newsy('ConversationMember', {
            conversation: {id: options.conversation.id}
        });
        // TODO: move this tricky masquerade logic into the entry file
        if (options.masquerade && options.masqueradeUserId) {
            globalDataLogger.event({'gotMeFromMasquerade': options.masqueradeUserId});
            meInTheConversation.set('user.id', options.masqueradeUserId);
        } else {
            globalDataLogger.event({'gotMeFromGotCurrentUser': options.userId});
            if (!options.userId) {
                throw new Error('expected options.userId in ConversationMember.getMe');
            }
            meInTheConversation.set('user.id', options.userId);
        }
        if (options.userType) {
            meInTheConversation.set('userType', options.userType);
        }
        return meInTheConversation;
    }
});
_.extend(ConversationMember.prototype, {
    url: _.compose(endpoints.conversationMembers, bunsen.getOn('id')),
    parse : function () {
        var data = ConversationMember.__super__.parse.apply(this, arguments);
        if (undefined === data.members) {
            return data; // we probably didn't get the data from endpoints.conversationMembers
        }
        if (data.members.length !== 1) {
            return data; // we don't know what to do with multiple members
        }
        return data.members[0].member;
    },
    defaults : {
        user: {},
        // conversation: {}, // messes with contact dealer
        userType: Party.ROLE_BUYER
    },
    relations : [{
        key : 'user',
        relatedModel: User,
        type : Backbone.One,
        saveJSONFields : ['id']
    }],
    getDisplayName: function () {
        var displayName = this.get('displayName');
        if ('string' === typeof displayName) {
            displayName = displayName.trim();
        }
        if (!displayName) {
            switch (this.get('userType')) {
                case userType.seller:
                    displayName = copyText.get('1stdibs dealer');
                    break;
                case userType.buyer:
                    displayName = copyText.get('1stdibs customer');
                    break;
                case userType.external:
                default:
                    displayName = copyText.get('3rd party');
                    break;
            }
        }
        return displayName;
    },
    isExternal: function () {
        return ConversationMember.userType.external === this.get('userType');
    },
    isDiscloseEmail: function () {
        return this.get('discloseEmail') === 'Y';
    },
    setDiscloseEmail: function (discloseEmail) {
        this.set('discloseEmail', discloseEmail ? 'Y' : 'N');
    },
    isOriginal: function () {
        return this.get('isOriginal') === 'Y';
    }
});


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var newsy = __webpack_require__(41);
module.exports = SoaModel.extend({
    defaults: {
        recipientType: 'TO',
        readMessage: 'N'
    },
    relations: [
        {
            key: 'recipientDetails',
            relatedModel : newsy.getConstructor.bind(newsy, 'ConversationMember'),
            type: Backbone.One
        }
    ]
}, {
    newsy: {
        builds: ['ConversationMember'],
        name: 'MessageRecipient'
    }
});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/***
 * options.conversation {Conversation Model} (required) - conversation to which this message will be posted
 * options.attachmentPingInterval {number} - how often to ping for processing attachments (in milliseconds)
 */
var SoaModel = __webpack_require__(2);
var extendCompose = __webpack_require__(43);
module.exports = extendCompose.call(SoaModel);
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Anchor = __webpack_require__(12);
var Action = __webpack_require__(51);
var MessageRecipient = __webpack_require__(71);
var AttachmentList = __webpack_require__(228);
var Offer = __webpack_require__(26);
var ConversationMember = __webpack_require__(68);
var copyText = __webpack_require__(39)();
var defaultAttachmentPingInterval = 2000;
var Message = module.exports;
var globalDataLogger = __webpack_require__(48);
var Deferred = __webpack_require__(29).Deferred;

copyText = copyText.extend({
    noRecipients : "Your message has no recipients",
    emptyMessage : "Your message is empty"
});
module.exports.extendSelf({
    initialize : function (attributes, options) {
        this._conversation = options.conversation;
        this.options = _.extend({
            attachmentPollTimeout: 60000,
            attachmentPingInterval: defaultAttachmentPingInterval
        }, options);
        this._conversationMemberConstructor = this.options.conversationMemberConstructor || ConversationMember;
        if (this.options.action) {
            this.setAction(this.options.action);
        }
        this.on('change:viewState', this.startPollingIfAppropriate);
        this.startPollingIfAppropriate();
        return this.options;
    },
    startPollingIfAppropriate: function () {
        var viewState = this.get('viewState');
        if (viewState && 'expanded' !== viewState) {
            return;
        }
        this.off('change:viewState', this.startPollingIfAppropriate);
        this.gotAllAttachments = this.pollForAttachments();
        _.delay(function () {
            clearTimeout(this._pollforAttachmentsTimeout);
        }.bind(this), this.options.attachmentPollTimeout);
    },
    parse : function () {
        var data = Message.__super__.parse.apply(this, arguments);
        if ("string" === typeof data.isLatestMessageSender) {
            data.isLatestMessageSender = data.isLatestMessageSender === 'Y';
        }
        return data;
    },
    pollForAttachments: function () {
        var fetchOptions = {
            data: { fields: 'attachment'}
        };

        if (!this.get('attachmentCount')) {
            return Deferred().resolve();
        }
        if (!this.areAttachmentsProcessing()) {
            return Deferred().resolve();
        }
        return this.fetch(fetchOptions).then(function () {
            var pollComplete = Deferred();
            clearTimeout(this._pollforAttachmentsTimeout);
            this._pollforAttachmentsTimeout = _.delay(function () {
                this.pollForAttachments()
                    .fail(pollComplete.reject.bind(pollComplete))
                    .done(pollComplete.resolve.bind(pollComplete));
            }.bind(this), this.options.attachmentPingInterval);
            return pollComplete;
        }.bind(this));
    },
    areAttachmentsProcessing: function () {
        return !!this.get('attachments').where({processed: 'N'}).length;
    },
    idAttribute : 'id',
    url : function () {
        var conversation;
        if (this.id) {
            return endpoints.messageGET({message: this.id});
        }
        conversation = this.get('from.conversation');
        if (conversation && conversation.id) {
            return endpoints.messagePOST({conversation: conversation.id});
        }
        return endpoints.messageNewConversation();
        // TODO: throw error instead of returning messageNewConversation once contact dealer uses new ContactDealerMessage model
        //throw new Error("from.conversation.id must be set in order to create a message");
    },
    defaults : {
        attachments : [],
        recipients : []
    },
    relations: function () {
        return [
            {
                key : 'from',
                relatedModel : this._conversationMemberConstructor,
                type : Backbone.One
            },
            {
                key : 'recipients',
                relatedModel : MessageRecipient,
                type : Backbone.Many
            },
            {
                key: 'attachments',
                collectionType : AttachmentList,
                type: Backbone.Many
            },
            {
                key : 'emailDataMap',
                relatedModel : SoaModel,
                type : Backbone.One
            },
            {
                key : 'anchors',
                relatedModel : Anchor,
                type : Backbone.Many
            },
            {
                key: 'offer',
                relatedModel: Offer,
                type: Backbone.One,
                saveJSONFields: ['id', 'transaction']
            }, {
                type: Backbone.One,
                key: 'action',
                relatedModel: Action
            }
        ];
    },
    _conversationMemberConstructor: ConversationMember,
    validateMessageBody: function () {
        var trimmedBody = this.get('textBody') ? this.get('textBody').trim() : '';
        if (this.get('offer')) {
            return;
        }
        if (!trimmedBody) {
            return copyText.get('emptyMessage');
        }
    },
    validate: function () {
        if (this.get('recipients') && this.get('recipients').length === 0) {
            return copyText.get('noRecipients');
        }
        return this.validateMessageBody();
    },
    // prepare the message for a POST by infering any conspicuously missing required properties from the current running context
    preparedForPost : function (options) {
        options = _.extend({
            userId: undefined,
            masquerade: false
        }, options);
        var from = this.get('from');
        var meInTheconversation;
        if (!from) {
            meInTheconversation = this._conversationMemberConstructor.getMe(_.extend({
                userId: options.userId,
                conversation: this._conversation
            }, _.pick(options, 'masquerade')));
            this.set('from', meInTheconversation);
            from = meInTheconversation;
        }
        if (this.get('message')) {
            globalDataLogger.event({
                "detected message-in-a-message in Message.prototype.preparedForPost" : this.toJSON()
            });
        }
        var myUserId = from.get('user.id');
        var originalMembersThatArentMe = _.compact(this._conversation.get('members').map(function (member) {
            var memberUserId = member.get("user.id");
            if (memberUserId === myUserId) {
                return;
            }
            if (!memberUserId) {
                return;
            }
            if ('Y' !== member.get('isOriginal')) {
                return;
            }
            var recipientDetails = member.pick(
                'id',
                'userType' // only because this is set incorrectly in the MessageRecipient default
            );
            recipientDetails.user = {id: memberUserId};
            return new MessageRecipient({recipientDetails: recipientDetails});
        }));
        if (0 === originalMembersThatArentMe.length) {
            console.warn("message has no recipients");
        }
        this.get('recipients').add(originalMembersThatArentMe);
        this.set('subject', options.subject || _.chain(this._conversation.get('messages').pluck('subject')).compact().last().value());
        return Deferred().resolve(); // TODO: consider running the code from this method in initialize since it no longer runs asynchronously
    },
    flag: function (options) {
        options.messageId = this.get('id');
        return (new SoaModel()).save(options, { url: endpoints.flagMessage });
    },
    setAction: function (mcAction) {
        this.set('action', new Action({ name: mcAction }));
    },
    getConversation: function () {
        return this._conversation;
    },
    suppressEmails: function () {
        this.set('sendNotification', 'N');
    }
});

Object.assign(Message, {
    ReviewStatus: {
        open: 'OPEN',
        monitoring: 'MONITORING',
        inProgress: 'IN_PROGRESS',
        closed: 'CLOSED'
    },
    MC_ACTIONS: {
        contactDealer: 'CONTACT_DEALER',
        netPrice: 'NET_PRICE_REQUEST',
        mcReply: 'MC_REPLY',
        privateOffer: 'PRIVATE_OFFER',
        netPriceOffer: 'NET_PRICE_OFFER'
    }
});


/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var checkProps = __webpack_require__(166);
var FieldRule = __webpack_require__(46);
var assert = __webpack_require__(31);

// ---------------------------------------------------
// Module Definition

/**
 * @class FieldValidation
 *
 * @param {object} options
 * @param {string} options.field Overrides property of the same name
 * @param {string} [options.fieldDisplayName] Overrides property of the same name
 * @param {boolean|function} [options.required=undefined] Overrides property of the same name
 * @param {function} [options.required] Overrides property of the same name
 * @param {object|FieldRule} [options.rule] Overrides property of the same name
 * @param {string} [options.ruleName] Overrides property of the same name
 * @param {object} [options.additionalRules]
 *      If you have multiple rules, use this option to pass in
 *      to the field schema.
 *
 * @property {string} field The path of the field relative to the validated root model
 * @property {string} fieldDisplayName
 *      A version of the field name that can be displayed to the user. This will be
 *      combined with a generic 'messageBody' property of a rule to create an
 *      error message to show the user. If a 'message' property is defined, that will
 *      override the automatic generation of a message with the fieldDisplayName and
 *      the messageBody
 * @property {boolean|function} required
 *      A boolean or function returning a boolean. Defaults to 'undefined'.
 * @property {boolean} autoRun
 *      Automatically run the validation when the {@link Validator} 'validate' method is called.
 * @property {object|FieldRule} rule
 *      A correctly formatted rule schema object or a FieldRule instance. Defaults to undefined.
 *      This field can be used if there is only one rule needed for a field. Otherwise you can
 *      specify all rules with 'additionalRules' option or the 'setRule' methods.
 * @property {string} ruleName
 *      A name to describe the rule. Defaults to the value of the 'field' property.
 * @property {string} ruleName
 *      A name to describe the rule. Defaults to the value of the 'field' property.
 */
var FieldValidation = module.exports = function () {
    this._rules = {};
    this.initialize.apply(this, arguments);
};

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(FieldValidation.prototype, {

    autoRun: true,

    requiredMessageBody: 'is required',

    /**
     * @protected
     * Override in extension. Passed options that
     * were passed to the constructor.
     */
    initialize: function (options) {
        options = options || {};
        var self = this;

        // The path of the field from the root model
        self.field = options.field || self.field;

        // The display value of the field
        self.fieldDisplayName = options.fieldDisplayName || self.fieldDisplayName;

        // A boolean or function returning a boolean that says if the field is required to have a value or not
        self.required = !_.isUndefined(options.required) ? options.required : self.required;

        // A callback function that overrides 'required'. Instead of a callback function with the context
        // being the root model, the callback context is the FieldValidation instance and the arguments
        // are model, fieldValue, field
        self.required = !_.isUndefined(options.required) ? options.required : self.required;

        // Automatically run the validation when Rule.validate is called. True by default
        self.autoRun = !_.isUndefined(options.autoRun) ? options.autoRun : self.autoRun;

        // If you have only one rule, you can set it with this property
        self.rule = options.rule || self.rule;

        // The name of the default rule, which will default to the field name
        self.ruleName = options.ruleName || self.ruleName || self.field;

        // If the user passed rules as an option
        if (options.additionalRules) {
            self.setRulesWithMap(options.additionalRules);
        }

        // Sets the main rule using the 'rule' and 'ruleName' properties
        self.setupDefaultRule();

        // set the message for required errors if provided
        self.requiredMessage = options.requiredMessage || self.requiredMessage;
        self.setupDefaultRequiredMessage();
    },

    /**
     * @param {string} name
     * @param {object|FieldRule} rule
     * @returns {FieldValidation}
     */
    setRuleByName: function (name, rule) {
        this._rules[name] = rule;
        assert(rule instanceof FieldRule || typeof rule === 'object', 'rule must be an instance Rule or be an object');
        if (rule instanceof FieldRule && !rule.getParentValidation()) {
            rule.setParentValidation(this);
        }
        return this;
    },

    /**
     * Get a rule for a particular name
     * @param {string} name
     * @returns {object|FieldRule}
     */
    getRuleByName: function (name) {
        return this._rules[name];
    },

    /**
     * @param {object} map
     * @returns {FieldValidation}
     */
    setRulesWithMap: function (map) {
        var name;
        for (name in map) {
            if (map.hasOwnProperty(name)) {
                this.setRuleByName(name, map[name]);
            }
        }
        return this;
    },

    /**
     * @param {boolean} required
     * @returns {FieldValidation}
     */
    setRequired: function (required) {
        this.required = required;
        return this;
    },

    /**
     * @param {boolean} autoRun
     * @returns {FieldValidation}
     */
    setAutoRun: function (autoRun) {
        this.autoRun = autoRun;
        return this;
    },

    /**
     * @protected
     * @returns {FieldValidation}
     */
    setupDefaultRule: function () {
        if (this.rule) {
            this.setRuleByName(this.ruleName, this.rule);
        }
        return this;
    },

    /**
     * @param {string} name
     * @param {string} message
     * @returns {FieldValidation}
     */
    setMessageForRule: function (name, message) {
        var rule = this.getRuleByName(name);
        console.assert(rule, 'Rule for name "' + name + '" doesn\'t exist, so a message cannot be set');
        rule.setMessage(message);
        return this;
    },

    /**
     * @returns {string}
     */
    getMessageForRequired: function () {
        return this.requiredMessage;
    },

    /**
     * @param {string} message
     * @returns {FieldValidation}
     */
    setRequiredMessage: function (message) {
        this.requiredMessage = message;
        return this;
    },

    /**
     * @protected
     * @returns {FieldValidation}
     */
    setupDefaultRequiredMessage: function () {
        if (this.requiredMessage) {
            this.setRequiredMessage(_.result(this, 'requiredMessage'));
        } else if (this.fieldDisplayName) {
            this.setRequiredMessage(this.createMessageWithBody(this.requiredMessageBody));
        }
        return this;
    },

    /**
     * @param {string} name Rule name
     * @returns {string}
     */
    getMessageForRule: function (name) {
        var rule = this.getRuleByName(name);
        return rule ? _.result(rule, 'message') : null;
    },

    /**
     * Invoked by {@link Validator} in order
     * to determine if this field has a real
     * value or not (aka not empty string, null
     * or undefined)
     * @param {Backbone.Model} model
     * @param {*} val
     * @returns {boolean}
     */
    hasRealValue: function (model, val) {
        return (parseInt(val, 10) === 0 || !!val);
    },

    /**
     * Invoked by the {@link Validator} class
     * to get the value of the field for a model
     * @param {Backbone.Model} model
     * @param {string} fieldName
     * @returns {*}
     */
    getModelValueForField: function (model, fieldName) {
        return model.get(fieldName);
    },

    /**
     * Return a messageBody for a rule if it is defined
     * @param {string} name
     * @returns {string}
     */
    getMessageBodyForRule: function (name) {
        var rule = this.getRuleByName(name);
        return rule ?  _.result(rule, 'messageBody') : null;
    },

    /**
     * Get a default message for a rule if
     * the rule is defined.
     * @param {string} name
     * @returns {string}
     */
    getDefaultMessageForRule: function (name) {
        var rule = this.getRuleByName(name);
        return rule ?  _.result(rule, 'defaultMessage') : null;
    },

    /**
     * Given the fieldDisplay name and a standard
     * validation error message body, returns a
     * display message for the user.
     * @param {string} messageBody
     * @returns {string}
     */
    createMessageWithBody: function (messageBody) {
        return FieldValidation.createMessage(this.fieldDisplayName, messageBody);
    },

    /**
     * Creates a formatted schema object for
     * the @{link Validator} instance.
     * @returns {object}
     */
    outputSchema: function () {

        var schema = {
            field: this.field,
            required: _.isFunction(this.required) ? _.bind(this.required, this) : this.required,
            autoRun: this.autoRun,
            messages: {},
            rules: this._rules ? {} : null
        };

        if (this.required) {
            schema.messages.required = this.getMessageForRequired();
        }

        _.each(this._rules, function (rule, name) {

            var message;
            var messageBody;

            schema.rules[name] = (_.isFunction(rule.outputSchema)) ? rule.outputSchema() : rule;

            message = this.getMessageForRule(name);
            messageBody = this.getMessageBodyForRule(name);

            if (!message && this.fieldDisplayName && messageBody) {
                message = this.createMessageWithBody(messageBody);
            }

            // If there is no message, use a default message for the rule if it is invalid
            schema.messages[name] = message || this.getDefaultMessageForRule(name);

        }, this);

        checkProps({
            field: 'string',
            required: ['boolean', 'function'],
            autoRun: 'boolean',
            messages: 'object',
            rules: 'object'
        }, schema);

        return schema;
    }

}, Backbone.Events);

// ---------------------------------------------------
// Define Module Static Properties

_.extend(FieldValidation, {

    /**
     * @function
     * @param {object} instanceProperties
     * @param {object} staticProperties
     * @returns {function} New constructor function
     */
    extend: Backbone.Model.extend,

    /**
     * @param {string} fieldDisplayName
     * @param {string} messageBody
     * @returns {string}
     */
    createMessage: function (fieldDisplayName, messageBody) {
        return "\"" + fieldDisplayName + "\" field " + messageBody;
    }

});

/***/ }),
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: hella
 * Date: 5/17/14
 * Time: 3:38 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

var root = "undefined" === typeof global ? window : global;
var $ = __webpack_require__(5);
var LocalStorage;
var SessionStorage;
var initializedSessionStorage;

function Storage() {
    this.data = {};
}

Storage.prototype = {
    _storage: {},
    _supported: false,

    init: function (storage) {
        this._storage = storage || root.localStorage;
        this._supported = this.isSupported();
        return this;
    },

    isSupported: function () {
        try {
            // FINDING-1393 - trying this first fixes private mode browsing in safari
            // https://github.com/marcuswestin/store.js/issues/42
            this._storage.setItem("dibsy", "");
            this._storage.removeItem("dibsy");
            return true;
        } catch (e) {
            return false;
        }
    },

    /**
     * Sets whether or not local/session storage is supported
     * @param {boolean} supported
     */
    setSupported: function (supported) {
        this._supported = supported;
    },

    getItems: function () {
        if (!this._supported) {
            return "localStorage is not supported";
        }
        return this._storage;
    },

    showAllItems: function () {
        var values = this._storage;
        var key;
        var p;
        var val;
        if (!this._supported) {
            if ($.cookie) {
                values = $.cookie(); // retrieves all cookies, but as an object not array
                for (p in values) {
                    if (values.hasOwnProperty(p)) {
                        key = p;
                        val = this.getItem(key);
                    }
                }
                return this;
            }
        }
        var len = this._storage.length;
        var i = 0;
        for (i; i < len; i++) {
            key = this._storage.key(i);
            val = this.getItem(key);
        }
        return this;
    },
    /**
     * Set storage value by the key
     *
     * @param key - {string}
     * @param value - {mixed}
     * @returns {Storage}
     */
    setItem: function (key, value) {
        switch (typeof value) {
            case 'object':
                value = JSON.stringify(value);
                break;
            default:
                value += '';
        }

        if (!this._supported) {
            this.data[key] = value;
            if ($.cookie) {
                $.cookie(key, value, {path: '/'});
            }
        } else {
            try {
                this._storage.setItem(key, value);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    },
    /**
     * Get storage value by the key
     *
     * @param key - {string}
     * @returns {mixed}
     */
    getItem: function (key) {
        var value;

        if (!key) {
            return false;
        }
        if (!this._supported) {
            if ($.cookie) {
                value = $.cookie(key);
                if (value === null && this.data[key]) {
                    value = this.data[key];
                }
            } else {
                value = this.data[key];
            }
        } else {
            value = this._storage[key];
        }

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },
    /**
     * Delete storage by the key
     *
     * @param key - {string}
     * @returns {Storage}
     */
    deleteItem: function (key) {
        if (!this._supported) {
            delete this.data[key];
            if ($.cookie) {
                $.removeCookie(key, {path: '/'});
            }
        } else {
            try {
                this._storage.removeItem(key);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    }
};

LocalStorage = new Storage();
SessionStorage = new Storage();

initializedSessionStorage = SessionStorage.init(root.sessionStorage);

module.exports = {
    localStorage: LocalStorage.init(),
    sessionStorage: initializedSessionStorage
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var result = __webpack_require__(259);
var assign = __webpack_require__(254);
var map = __webpack_require__(257);
var forEach = __webpack_require__(255);
var isArray = __webpack_require__(256);
var isFunction = __webpack_require__(99);
var mapValues = __webpack_require__(258);
var composeClassNames = __webpack_require__(100);
var matches = __webpack_require__(38);
var View = __webpack_require__(90).View;
var TemplateView = module.exports = __webpack_require__(211).withMiddleware({
    afterPrototype: function (parentPrototype, childPrototypeBefore, childPrototypeAfter) {
        if (!childPrototypeAfter.template) {
            return childPrototypeAfter;
        }
        var newLocalClassNames;
        if (childPrototypeAfter.template.local__) {
            newLocalClassNames = composeClassNames(
                childPrototypeAfter.template.local,
                childPrototypeAfter.template.local__
            );
        } else if (childPrototypeAfter.template.__local) {
            newLocalClassNames = composeClassNames(
                childPrototypeAfter.template.__local,
                childPrototypeAfter.template.local
            );
        } else {
            return undefined;
        }
        assign(childPrototypeAfter,
            {
                template: assign({},
                    childPrototypeAfter.template,
                    {
                        local: newLocalClassNames
                    }
                )
            }
        );
    }
}).call(View, {});
var normalizeToView = __webpack_require__(245); // must come after TemplateView is defined in order to resolve circular dependency

var prototype = {
    templateVars: function () {
        return this.model ? this.model.toJSON() : {};
    },
    getSubElement : function (subViewKey) {
        var subSelector = "[data-append=" + subViewKey + "]";
        var subs = this.$(subSelector);
        if (matches(this.el, subSelector)) {
            subs = subs.concat([this.el]);
        }
        return subs[0];
    },
    getSubView : function (subViewKey) {
        return this._subs[subViewKey];
    },
    initialize: function (options) {
        var scope;
        var useInnerElement;
        var local;
        var renderedTemplate;
        options = options || {};
        scope = options.scope || this.scope || {};
        this.templateVars = options.templateVars || this.templateVars;
        this.template = options.template || this.template;
        if (!isFunction(this.template) && this.template instanceof Object) {
            useInnerElement = this.template.useInnerElement;
            local = this.template.local;
            this.template = this.template.src;
        }
        if (undefined === useInnerElement) {
            useInnerElement = useInnerElement || options.useInnerElement;
        }
        if (this.templateVars instanceof Function) {
            this.templateVars = this.templateVars.apply(this);
        }
        if (scope instanceof Function) {
            scope = scope.apply(this);
        }
        if (!this.template) {
            throw new Error("no template provided to template view");
        }
        if (local) {
            this.templateVars = assign({local: local}, this.templateVars);
        }
        renderedTemplate = this.template(this.templateVars);
        if (undefined === renderedTemplate) {
            renderedTemplate = "";
        }
        var innerElBuilder = document.createElement('div');
        innerElBuilder.innerHTML = renderedTemplate.trim();
        var innerEls = Array.prototype.slice.call(innerElBuilder.childNodes);
        if (useInnerElement) {
            if (innerEls.length !== 1) {
                throw new Error("useInnerElement requires template with a single root element. There are " + innerEls.length);
            }
            this.setElement(innerEls[0]);
        } else {
            innerEls.forEach(this.el.appendChild.bind(this.el));
        }
        this._subs = mapValues(scope, function (subViews, appendKey) {
            var el = this.getSubElement(appendKey);
            var wasArray = true;
            if (!el) {
                return undefined; // couldn't identify a subview parent
            }
            if (!isArray(subViews)) {
                subViews = [subViews];
                wasArray = false;
            }
            if (!subViews) {
                return undefined;
            }
            subViews = map(subViews, function (subView, i) {
                var innerEl = el;
                if (wasArray) {
                    innerEl = document.createElement(el.tagName);
                    innerEl.setAttribute('data-template-view-child', i);
                    el.appendChild(innerEl);
                }
                subView = normalizeToView({
                    defaultContext: this,
                    defaultParentElement: innerEl,
                    defaultTemplateVars: this.templateVars,
                    content: subView,
                    Constructor: this.defaultConstructor
                });
                if (false === subView) {
                    // TODO: test this
                    innerEl.parentNode.removeChild(innerEl);
                }
                if (!subView) {
                    return undefined;
                }
                if (innerEl !== subView.el) {
                    innerEl.appendChild(subView.el);
                }
                return subView;
            }.bind(this));
            if (!wasArray) {
                subViews = subViews[0];
            }
            if (this.subViewAppended) {
                this.subViewAppended(subViews);
            }
            if (!subViews) {
                return undefined;
            }
            return subViews;
        }.bind(this));
        return options;
    },
    render: function () {
        // overriding render so the subviews dont get blown away after initialize runs
        forEach(this._subs, function (subarray) {
            if (!isArray(subarray)) {
                subarray = [subarray];
            }
            forEach(subarray, function (sub) {
                result(sub, 'render');
            });
        });
        return this;
    }
};
TemplateView.extendSelf(assign(prototype, {
    defaultConstructor: TemplateView
}));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _ = __webpack_require__(0);
var TransactionShipmentQuote = __webpack_require__(36);
var ShipmentQuotes = __webpack_require__(312);
var Party = __webpack_require__(8);
var Anchor = __webpack_require__(12);
var ShipmentQuote = __webpack_require__(73);
var assert = __webpack_require__(31);
var TransactionShipmentQuotes;

var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

/**
 * @class TransactionShipmentQuotes
 * @extends SoaCollection
 * @property {Offer} model {@link Offer}
 * @property {endpoints.offers} url -
 */
TransactionShipmentQuotes = root.bunsen.TransactionShipmentQuotes = ShipmentQuotes.extend({
    model: TransactionShipmentQuote,
    _newTransactionShipmentQuote: function (quoteAttrs, options) {
        var sq;
        options = _.defaults(options || {}, {
            add: true
        });
        quoteAttrs.billToRole = quoteAttrs.billToRole || quoteAttrs.authorRole;
        sq = new TransactionShipmentQuote(_.extend({
            type: ShipmentQuote.TYPE_TRANSACTION,
            pricingType: ShipmentQuote.PRICING_TYPE_COMMERCIAL,
            anchor: {
                sourceType: Anchor.TYPE_TRANSACTION,
                sourceId: this.getTransactionId()
            },
            handlingTime: {}
        }, quoteAttrs));

        if (options.add) {
            this.add(sq);
        }
        return sq;
    },
    /**
     * Returns new TransactionShipmentQuote with Dealer author/billTo
     * @param {object} [options]
     * @param {boolean} [options.add=true] Adds to collection instance
     * @returns {TransactionShipmentQuote}
     */
    newDealerTransactionShipmentQuote: function (options) {
        var quoteAttrs;
        var sq;
        assert(this.parents && this.parents[0], 'TransactionShipmentQuotes must be relation of Transaction');
        quoteAttrs = {
            author: { role: Party.ROLE_SELLER },
            billTo: { role: Party.ROLE_SELLER }
        };
        sq = this._newTransactionShipmentQuote(quoteAttrs, options);
        sq.set('serviceMethod', {});
        return sq;
    },
    /**
     * Returns new TransactionShipmentQuote with Internal author/billTo
     * @param {object} [options]
     * @param {boolean} [options.add=true] Adds to collection instance
     * @returns {TransactionShipmentQuote}
     */
    new1stdibsTransactionShipmentQuote: function (options, passedQuoteAttrs) {
        var quoteAttrs;
        assert(this.parents && this.parents[0], 'TransactionShipmentQuotes must be relation of Transaction');
        quoteAttrs = _.defaults({
            author: { role: Party.ROLE_INTERNAL },
            billTo: { role: Party.ROLE_INTERNAL }
        }, passedQuoteAttrs);
        return this._newTransactionShipmentQuote(quoteAttrs, options);
    },
    getTransactionId: function () {
        // This collection should only be a relation to a Transaction
        return this.parents[0].get('id');
    },
    _findByFunction: function (fn) {
        return this.find(function (quote) {
            return quote[fn]();
        });
    },
    _findActiveQuoteByFunction: function (fn) {
        return this.find(function (quote) {
            return quote[fn]() && quote.isActive();
        });
    },
    getPreQuote: function () {
        return this._findActiveQuoteByFunction('isPreQuote');
    },
    getDealerQuote: function () {
        return this._findActiveQuoteByFunction('isDealerBilledQuote');
    },
    get1stdibsQuote: function () {
        return this._findActiveQuoteByFunction('is1stdibsQuote');
    },
    getActiveAccountingQuote: function () {
        return this._findByFunction('isActiveAccountingQuote');
    },
    getRejectedAccountingQuote: function () {
        return this._findByFunction('isRejectedAccountingQuote');
    },
    getActiveAccountingQuoteSubTotal: function (currency) {
        var quote = this.getActiveAccountingQuote();
        if (quote) {
            return quote.getSubTotal(currency);
        }
        return null;
    },
    getActiveAccountingQuoteTotal: function (currency) {
        var quote = this.getActiveAccountingQuote();
        if (quote) {
            return quote.getTotalAmount(currency);
        }
        return null;
    },
    hasPreQuote: function () {
        return !!this.getPreQuote();
    },
    hasPreQuoteIncludingCanceled: function () {
        return !!this._findByFunction('isPreQuote');
    }
});

module.exports = TransactionShipmentQuotes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
    var $, cardFromNumber, cardFromType, cards, defaultFormat, formatBackCardNumber, formatBackExpiry, formatCardNumber, formatExpiry, formatForwardExpiry, formatForwardSlashAndSpace, hasTextSelected, luhnCheck, reFormatCVC, reFormatCardNumber, reFormatExpiry, reFormatNumeric, restrictCVC, restrictCardNumber, restrictExpiry, restrictNumeric, safeVal, setCardType,
        __slice = [].slice,
        __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

    $ = __webpack_require__(5);;

    $.payment = {};

    $.payment.fn = {};

    $.fn.payment = function() {
        var args, method;
        method = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
        return $.payment.fn[method].apply(this, args);
    };

    defaultFormat = /(\d{1,4})/g;

    $.payment.cards = cards = [
        {
            type: 'visaelectron',
            pattern: /^4(026|17500|405|508|844|91[37])/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'maestro',
            pattern: /^(5(018|0[23]|[68])|6(39|7))/,
            format: defaultFormat,
            length: [12, 13, 14, 15, 16, 17, 18, 19],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'forbrugsforeningen',
            pattern: /^600/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'dankort',
            pattern: /^5019/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'visa',
            pattern: /^4/,
            format: defaultFormat,
            length: [13, 16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'mastercard',
            pattern: /^(5[0-5]|2[2-7])/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'amex',
            pattern: /^3[47]/,
            format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
            length: [15],
            cvcLength: [3, 4],
            luhn: true
        }, {
            type: 'dinersclub',
            pattern: /^3[0689]/,
            format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
            length: [14],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'discover',
            pattern: /^6([045]|22)/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'unionpay',
            pattern: /^(62|88)/,
            format: defaultFormat,
            length: [16, 17, 18, 19],
            cvcLength: [3],
            luhn: false
        }, {
            type: 'jcb',
            pattern: /^35/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }
    ];

    cardFromNumber = function(num) {
        var card, _i, _len;
        num = (num + '').replace(/\D/g, '');
        for (_i = 0, _len = cards.length; _i < _len; _i++) {
            card = cards[_i];
            if (card.pattern.test(num)) {
                return card;
            }
        }
    };

    cardFromType = function(type) {
        var card, _i, _len;
        for (_i = 0, _len = cards.length; _i < _len; _i++) {
            card = cards[_i];
            if (card.type === type) {
                return card;
            }
        }
    };

    luhnCheck = function(num) {
        var digit, digits, odd, sum, _i, _len;
        odd = true;
        sum = 0;
        digits = (num + '').split('').reverse();
        for (_i = 0, _len = digits.length; _i < _len; _i++) {
            digit = digits[_i];
            digit = parseInt(digit, 10);
            if ((odd = !odd)) {
                digit *= 2;
            }
            if (digit > 9) {
                digit -= 9;
            }
            sum += digit;
        }
        return sum % 10 === 0;
    };

    hasTextSelected = function($target) {
        var _ref;
        if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== $target.prop('selectionEnd')) {
            return true;
        }
        if ((typeof document !== "undefined" && document !== null ? (_ref = document.selection) != null ? _ref.createRange : void 0 : void 0) != null) {
            if (document.selection.createRange().text) {
                return true;
            }
        }
        return false;
    };

    safeVal = function(value, $target) {
        var cursor, error;
        try {
            cursor = $target.prop('selectionStart');
        } catch (_error) {
            error = _error;
            cursor = null;
        }
        $target.val(value);
        if (cursor !== null && $target.is(":focus")) {
            $target.prop('selectionStart', cursor);
            return $target.prop('selectionEnd', cursor);
        }
    };

    reFormatNumeric = function(e) {
        return setTimeout(function() {
            var $target, value;
            $target = $(e.currentTarget);
            value = $target.val();
            value = value.replace(/\D/g, '');
            return safeVal(value, $target);
        });
    };

    reFormatCardNumber = function(e) {
        return setTimeout(function() {
            var $target, value;
            $target = $(e.currentTarget);
            value = $target.val();
            value = $.payment.formatCardNumber(value);
            return safeVal(value, $target);
        });
    };

    formatCardNumber = function(e) {
        var $target, card, digit, length, re, upperLength, value;
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        $target = $(e.currentTarget);
        value = $target.val();
        card = cardFromNumber(value + digit);
        length = (value.replace(/\D/g, '') + digit).length;
        upperLength = 16;
        if (card) {
            upperLength = card.length[card.length.length - 1];
        }
        if (length >= upperLength) {
            return;
        }
        if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
            return;
        }
        if (card && card.type === 'amex') {
            re = /^(\d{4}|\d{4}\s\d{6})$/;
        } else {
            re = /(?:^|\s)(\d{4})$/;
        }
        if (re.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val(value + ' ' + digit);
            });
        } else if (re.test(value + digit)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val(value + digit + ' ');
            });
        }
    };

    formatBackCardNumber = function(e) {
        var $target, value;
        $target = $(e.currentTarget);
        value = $target.val();
        if (e.which !== 8) {
            return;
        }
        if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
            return;
        }
        if (/\d\s$/.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val(value.replace(/\d\s$/, ''));
            });
        } else if (/\s\d?$/.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val(value.replace(/\d$/, ''));
            });
        }
    };

    reFormatExpiry = function(e) {
        return setTimeout(function() {
            var $target, value;
            $target = $(e.currentTarget);
            value = $target.val();
            value = $.payment.formatExpiry(value);
            return safeVal(value, $target);
        });
    };

    formatExpiry = function(e) {
        var $target, digit, val;
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        $target = $(e.currentTarget);
        val = $target.val() + digit;
        if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val("0" + val + " / ");
            });
        } else if (/^\d\d$/.test(val)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val("" + val + " / ");
            });
        }
    };

    formatForwardExpiry = function(e) {
        var $target, digit, val;
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        $target = $(e.currentTarget);
        val = $target.val();
        if (/^\d\d$/.test(val)) {
            return $target.val("" + val + " / ");
        }
    };

    formatForwardSlashAndSpace = function(e) {
        var $target, val, which;
        which = String.fromCharCode(e.which);
        if (!(which === '/' || which === ' ')) {
            return;
        }
        $target = $(e.currentTarget);
        val = $target.val();
        if (/^\d$/.test(val) && val !== '0') {
            return $target.val("0" + val + " / ");
        }
    };

    formatBackExpiry = function(e) {
        var $target, value;
        $target = $(e.currentTarget);
        value = $target.val();
        if (e.which !== 8) {
            return;
        }
        if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
            return;
        }
        if (/\d\s\/\s$/.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val(value.replace(/\d\s\/\s$/, ''));
            });
        }
    };

    reFormatCVC = function(e) {
        return setTimeout(function() {
            var $target, value;
            $target = $(e.currentTarget);
            value = $target.val();
            value = value.replace(/\D/g, '').slice(0, 4);
            return safeVal(value, $target);
        });
    };

    restrictNumeric = function(e) {
        var input;
        if (e.metaKey || e.ctrlKey) {
            return true;
        }
        if (e.which === 32) {
            return false;
        }
        if (e.which === 0) {
            return true;
        }
        if (e.which < 33) {
            return true;
        }
        input = String.fromCharCode(e.which);
        return !!/[\d\s]/.test(input);
    };

    restrictCardNumber = function(e) {
        var $target, card, digit, value;
        $target = $(e.currentTarget);
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        if (hasTextSelected($target)) {
            return;
        }
        value = ($target.val() + digit).replace(/\D/g, '');
        card = cardFromNumber(value);
        if (card) {
            return value.length <= card.length[card.length.length - 1];
        } else {
            return value.length <= 16;
        }
    };

    restrictExpiry = function(e) {
        var $target, digit, value;
        $target = $(e.currentTarget);
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        if (hasTextSelected($target)) {
            return;
        }
        value = $target.val() + digit;
        value = value.replace(/\D/g, '');
        if (value.length > 6) {
            return false;
        }
    };

    restrictCVC = function(e) {
        var $target, digit, val;
        $target = $(e.currentTarget);
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        if (hasTextSelected($target)) {
            return;
        }
        val = $target.val() + digit;
        return val.length <= 4;
    };

    setCardType = function(e) {
        var $target, allTypes, card, cardType, val;
        $target = $(e.currentTarget);
        val = $target.val();
        cardType = $.payment.cardType(val) || 'unknown';
        if (!$target.hasClass(cardType)) {
            allTypes = (function() {
                var _i, _len, _results;
                _results = [];
                for (_i = 0, _len = cards.length; _i < _len; _i++) {
                    card = cards[_i];
                    _results.push(card.type);
                }
                return _results;
            })();
            $target.removeClass('unknown');
            $target.removeClass(allTypes.join(' '));
            $target.addClass(cardType);
            $target.toggleClass('identified', cardType !== 'unknown');
            return $target.trigger('payment.cardType', cardType);
        }
    };

    $.payment.fn.formatCardCVC = function() {
        this.on('keypress', restrictNumeric);
        this.on('keypress', restrictCVC);
        this.on('paste', reFormatCVC);
        this.on('change', reFormatCVC);
        this.on('input', reFormatCVC);
        return this;
    };

    $.payment.fn.formatCardExpiry = function() {
        this.on('keypress', restrictNumeric);
        this.on('keypress', restrictExpiry);
        this.on('keypress', formatExpiry);
        this.on('keypress', formatForwardSlashAndSpace);
        this.on('keypress', formatForwardExpiry);
        this.on('keydown', formatBackExpiry);
        this.on('change', reFormatExpiry);
        this.on('input', reFormatExpiry);
        return this;
    };

    $.payment.fn.formatCardNumber = function() {
        this.on('keypress', restrictNumeric);
        this.on('keypress', restrictCardNumber);
        this.on('keypress', formatCardNumber);
        this.on('keydown', formatBackCardNumber);
        this.on('keyup', setCardType);
        this.on('paste', reFormatCardNumber);
        this.on('change', reFormatCardNumber);
        this.on('input', reFormatCardNumber);
        this.on('input', setCardType);
        return this;
    };

    $.payment.fn.restrictNumeric = function() {
        this.on('keypress', restrictNumeric);
        this.on('paste', reFormatNumeric);
        this.on('change', reFormatNumeric);
        this.on('input', reFormatNumeric);
        return this;
    };

    $.payment.fn.cardExpiryVal = function() {
        return $.payment.cardExpiryVal($(this).val());
    };

    $.payment.cardExpiryVal = function(value) {
        var month, prefix, year, _ref;
        _ref = value.split(/[\s\/]+/, 2), month = _ref[0], year = _ref[1];
        if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
            prefix = (new Date).getFullYear();
            prefix = prefix.toString().slice(0, 2);
            year = prefix + year;
        }
        month = parseInt(month, 10);
        year = parseInt(year, 10);
        return {
            month: month,
            year: year
        };
    };

    $.payment.validateCardNumber = function(num) {
        var card, _ref;
        num = (num + '').replace(/\s+|-/g, '');
        if (!/^\d+$/.test(num)) {
            return false;
        }
        card = cardFromNumber(num);
        if (!card) {
            return false;
        }
        return (_ref = num.length, __indexOf.call(card.length, _ref) >= 0) && (card.luhn === false || luhnCheck(num));
    };

    $.payment.validateCardExpiry = function(month, year) {
        var currentTime, expiry, _ref;
        if (typeof month === 'object' && 'month' in month) {
            _ref = month, month = _ref.month, year = _ref.year;
        }
        if (!(month && year)) {
            return false;
        }
        month = $.trim(month);
        year = $.trim(year);
        if (!/^\d+$/.test(month)) {
            return false;
        }
        if (!/^\d+$/.test(year)) {
            return false;
        }
        if (!((1 <= month && month <= 12))) {
            return false;
        }
        if (year.length === 2) {
            if (year < 70) {
                year = "20" + year;
            } else {
                year = "19" + year;
            }
        }
        if (year.length !== 4) {
            return false;
        }
        expiry = new Date(year, month);
        currentTime = new Date;
        expiry.setMonth(expiry.getMonth() - 1);
        expiry.setMonth(expiry.getMonth() + 1, 1);
        return expiry > currentTime;
    };

    $.payment.validateCardCVC = function(cvc, type) {
        var card, _ref;
        cvc = $.trim(cvc);
        if (!/^\d+$/.test(cvc)) {
            return false;
        }
        card = cardFromType(type);
        if (card != null) {
            return _ref = cvc.length, __indexOf.call(card.cvcLength, _ref) >= 0;
        } else {
            return cvc.length >= 3 && cvc.length <= 4;
        }
    };

    $.payment.cardType = function(num) {
        var _ref;
        if (!num) {
            return null;
        }
        return ((_ref = cardFromNumber(num)) != null ? _ref.type : void 0) || null;
    };

    $.payment.formatCardNumber = function(num) {
        var card, groups, upperLength, _ref;
        num = num.replace(/\D/g, '');
        card = cardFromNumber(num);
        if (!card) {
            return num;
        }
        upperLength = card.length[card.length.length - 1];
        num = num.slice(0, upperLength);
        if (card.format.global) {
            return (_ref = num.match(card.format)) != null ? _ref.join(' ') : void 0;
        } else {
            groups = card.format.exec(num);
            if (groups == null) {
                return;
            }
            groups.shift();
            groups = $.grep(groups, function(n) {
                return n;
            });
            return groups.join(' ');
        }
    };

    $.payment.formatExpiry = function(expiry) {
        var mon, parts, sep, year;
        parts = expiry.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/);
        if (!parts) {
            return '';
        }
        mon = parts[1] || '';
        sep = parts[2] || '';
        year = parts[3] || '';
        if (year.length > 0) {
            sep = ' / ';
        } else if (sep === ' /') {
            mon = mon.substring(0, 1);
            sep = '';
        } else if (mon.length === 2 || sep.length > 0) {
            sep = ' / ';
        } else if (mon.length === 1 && (mon !== '0' && mon !== '1')) {
            mon = "0" + mon;
            sep = ' / ';
        }
        return mon + sep + year;
    };

}).call(this);


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by augustocorvalan on 7/17/15.
 */


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var AnchorMember = module.exports = SoaModel.extend();
var Anchor = __webpack_require__(12);
var SoaCollection = __webpack_require__(9);

_.extend(AnchorMember, {
    createAnchorMembers: function (sourceType, ids, note) {
        return new SoaCollection(_.map(ids, function (id) {
            if (_.isString(id)) {
                id = id.trim();
            }

            return new AnchorMember({
                'anchor': new Anchor({
                    apiType: 'anchor',
                    sourceId: id,
                    sourceType: sourceType
                }),
                note: note
            });
        }));
    }
});

_.extend(AnchorMember.prototype, {
    defaults: {
        'apiType': 'anchorListMember'
    },
    relations: SoaModel.createRelations([
        {
            key: 'anchor',
            type: Backbone.One,
            relatedModel: Anchor
        }
    ])
});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Rob
 * Date: 8/19/13
 */


var SoaModel = __webpack_require__(2);
var Invoice = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;


var SoaCollection = __webpack_require__(9);
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var AdjustmentList = __webpack_require__(56);
var InvoiceItems = __webpack_require__(158);
var Party = __webpack_require__(8);
var FinancialAmount = __webpack_require__(10);
var financialAmountMixin = __webpack_require__(47);
var isType;
var getAdjustmentsTotalByFn;
var getItemsTotalByFn;

root.bunsen = root.bunsen || {};
module.exports = root.bunsen.Invoice = Invoice;

getAdjustmentsTotalByFn = function (fn, currency) {
    var adjustments = this.get('adjustments');
    if (!adjustments) {
        return null;
    }
    return adjustments[fn](currency);
};

getItemsTotalByFn = function (fn, currency) {
    var items = this.get('invoiceItems');
    if (!items) {
        return null;
    }
    return items[fn](currency);
};

isType = function (type) {
    return this.get('type') === type;
};

_.extend(Invoice, {
    STATUS_CANCELED: 'CANCELED',
    STATUS_SUBMITTED: 'SUBMITTED',
    STATUS_SETTLED: 'SETTLED',
    TYPE_BUYER: 'BUYER',
    TYPE_DEALER: 'DEALER',
    TYPE_LSP: 'LSP'
});

/**
 * @class Invoice
 * @extends SoaModel
 * @property idAttribute {string} - "id"
 */
_.extend(Invoice.prototype, {
    idAttribute: "id",
    defaults: {
        adjustments: {
            adjustments: []
        }
    },
    url : function () {
        return endpoints.invoice(this.get(this.idAttribute));
    },
    relations: [
        {
            type: Backbone.One,
            key: 'adjustments',
            relatedModel: AdjustmentList,
            collectionType: SoaCollection,
            omitFromSave: true
        },
        {
            type: Backbone.Many,
            key: 'invoiceItems',
            collectionType: InvoiceItems
        },
        {
            type: Backbone.One,
            key: 'seller',
            relatedModel: Party
        },
        {
            type: Backbone.One,
            key: 'subTotalAmount',
            relatedModel: FinancialAmount
        },
        {
            type: Backbone.One,
            key: 'totalAmount',
            relatedModel: FinancialAmount
        }
    ],
    calculateCommission: _.partial(getAdjustmentsTotalByFn, 'getCommissionTotal'),
    calculateProcessingFee: _.partial(getAdjustmentsTotalByFn, 'getProcessingFeeTotal'),
    calculateListingCredit: _.partial(getAdjustmentsTotalByFn, 'getListingCreditTotal'),
    calculateComplimentaryShipping: _.partial(getAdjustmentsTotalByFn, 'getComplimentaryShippingTotal'),
    calculatePromotion: _.partial(getAdjustmentsTotalByFn, 'getPromotionTotal'),
    calculateDealerCharge: _.partial(getAdjustmentsTotalByFn, 'getDealerChargeTotal'),

    calculateItemPriceModification: _.partial(getItemsTotalByFn, 'getItemPriceModification'),
    calculateProductCustomization: _.partial(getItemsTotalByFn, 'getProductCustomization'),
    calculateCustomerCharge: _.partial(getItemsTotalByFn, 'getCustomerCharge'),

    getListingCreditAdjustment: function () {
        var adjustmentList = this.get('adjustments');
        if (adjustmentList) {
            return adjustmentList.getListingCreditAdjustment();
        }
    },
    isDealerInvoice: _.partial(isType, Invoice.TYPE_DEALER),
    isBuyerInvoice: _.partial(isType, Invoice.TYPE_BUYER),
    isShipperInvoice: _.partial(isType, Invoice.TYPE_LSP)
}, financialAmountMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var Review = module.exports = SoaModel.extend();
var Notes = __webpack_require__(24);

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var transitionMixin = __webpack_require__(19);

_.extend(Review, {
    STATUS_PENDING: 'PENDING',
    STATUS_APPROVED: 'APPROVED',
    STATUS_REJECTED: 'REJECTED',
    STATUS_CANCELED: 'CANCELED',
    TYPE_FRAUD: 'FRAUD',
    TYPE_PAYMENT_DECLINED: 'PAYMENT_DECLINED',
    TYPE_SHIPPING_REQUEST: 'SPECIAL_SHIPMENT_INSTRUCTIONS'
});

_.extend(Review.prototype, {
    defaults: {
        apiType: 'review'
    },
    url: function () {
        return endpoints.review(this.id);
    },
    getShippingRequestNote: function () {
        var notes = this.get('notes');
        if (notes) {
            return notes.find(function (note) {
                return note.get('type') === 'SPECIAL_SHIPMENT_INSTRUCTIONS';
            });
        }
    },
    isPending: function() {
        return this.get('status') === Review.STATUS_PENDING;
    },
    isFraud: function() {
        return this.get('type') === Review.TYPE_FRAUD;
    },
    isPaymentDeclined: function() {
        return this.get('type') === Review.TYPE_PAYMENT_DECLINED;
    },
    transitionToPending: function () {
        return this.transition(Review.STATUS_PENDING);
    },
    approve: function() {
        return this.transition(Review.STATUS_APPROVED);
    },
    reject: function() {
        return this.transition(Review.STATUS_REJECTED);
    },
    relations: function () {
        return SoaModel.createRelations([
            {
                type : Backbone.Many,
                key : 'notes',
                collectionType: Notes
            }
        ]);
    }
}, transitionMixin);


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Shad
 * Date: 8/13/13
 */

var SoaModel = __webpack_require__(2);
var Shipment = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
var Clump = __webpack_require__(22);
var $ = __webpack_require__(5);
root.bunsen = root.bunsen || {};

/**
 * Represents a logistics service 'Shipment'.
 *
 * @class Shipment
 * @extends SoaModel
 */
module.exports = root.bunsen.Shipment = Shipment;

var Notes = __webpack_require__(24);
var Note = __webpack_require__(33);
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var TransactionShipmentQuote = __webpack_require__(36);
var Address = __webpack_require__(32);
var ShipmentContent = __webpack_require__(178);
var ShipmentTracking = __webpack_require__(179);
var ServiceMethod = __webpack_require__(310);
var Anchor = __webpack_require__(12);
var Period = __webpack_require__(114);
var transitionMixin = __webpack_require__(19);
var periodMixin = __webpack_require__(327);
var Party = __webpack_require__(8);
var Reviews = __webpack_require__(164);

//Private Members
var carrierPatterns;

carrierPatterns = {
    UPS: /^(1Z[0-9A-Z]{16}|[0-9A-Z]{12}|T[0-9A-Z]{10}|[0-9A-Z]{9}|MI\d{6}[0-9A-Z]{1,22})$/,
    USPS: /^(94\d{20}|\d3\d{18})$/,
    FEDEX: /^\d{12,22}$/
};

//Static Properties/Methods
_.extend(Shipment, {
    TYPE_LOCAL_PICKUP : 'LOCAL_PICKUP',
    TYPE_EXTERNALLY_ARRANGED : 'EXTERNALLY_ARRANGED',
    TYPE_FIRSTDIBS_FACILITATED : 'FIRSTDIBS_FACILITATED',
    STATUS_NEW: 'NEW',
    STATUS_PENDING: 'PENDING',
    STATUS_READY_FOR_PICKUP: 'READY_FOR_PICKUP',
    STATUS_SHIPPED: 'SHIPPED',
    STATUS_DELIVERED: 'DELIVERED',
    STATUS_REGISTRATION_FAILED: 'REGISTRATION_FAILED',
    getTypes: function () {
        return [
            Shipment.TYPE_LOCAL_PICKUP,
            Shipment.TYPE_EXTERNALLY_ARRANGED,
            Shipment.TYPE_FIRSTDIBS_FACILITATED
        ];
    },
    getCarrierPatternFor: function (carrierName) {
        return carrierPatterns[carrierName];
    }
});

_.extend(Shipment.prototype, {
    idAttribute: "id",
    url : function () {
        return endpoints.shipment(this.get(this.idAttribute));
    },
    defaults: {
        notes: [],
        reviews: [],
        shippingAddress: {},
        shipmentTracking: {}
    },
    anchorType: Anchor.TYPE_SHIPMENT,
    relations: function () {
        return SoaModel.createRelations([
            {
                type: Backbone.One,
                key: 'acceptedQuote',
                relatedModel: TransactionShipmentQuote
//                saveJSONFields : ['id']
            },
            {
                type: Backbone.One,
                key: 'shippingAddress',
                relatedModel: Address
            },
            {
                type : Backbone.Many,
                key : 'notes',
                collectionType: Notes,
                omitFromSave: true
            },
            {
                type : Backbone.One,
                key : 'shipmentContent',
                relatedModel : ShipmentContent
            },
            {
                type : Backbone.One,
                key : 'shipmentTracking',
                relatedModel : ShipmentTracking
            },
            {
                type : Backbone.One,
                key : 'transaction',
                relatedModel : SoaModel,
                saveJSONFields: ['id']
            },
            {
                type : Backbone.One,
                key : 'serviceMethod',
                relatedModel : ServiceMethod
            },
            {
                type : Backbone.One,
                key : 'handlingTime',
                relatedModel : Period
            },
            {
                type : Backbone.Many,
                key : 'reviews',
                collectionType: Reviews
            }
        ]);
    },

    getShippingRequestReview: function () {
        return this.get('reviews').getShippingRequest();
    },

    getShippingRequestReviewNote: function () {
        var review =  this.getShippingRequestReview();
        if (review) {
            return review.getShippingRequestNote();
        }
    },

    getShippingRequestReviewNoteContent: function () {
        var note =  this.getShippingRequestReviewNote();
        if (note) {
            return note.get('content');
        }
    },

    /**
     * @returns {number}
     */
    getHandlingTimeDays : function () {
        return this.getPeriodInDays('handlingTime');
    },
    /**
     * @returns {string}
     */
    getDisplayHandlingTimeDays: function () {
        return this.getPeriodDisplayVal('handlingTime');
    },
    /**
     * @returns {string}
     */
    getAddresseeDisplayName: function () {
        var address = this.get('shippingAddress');
        return address ? (address.get('firstName') + ' ' + address.get('lastName')) : null;
    },
    /**
     * @returns {string}
     */
    getLastNote: function () {
        var notes = this.get('notes');
        return notes ? notes.last() : null;
    },
    /**
     * @returns {boolean}
     */
    is1stdibsFacilitated: function () {
        return this.get('shipmentType') === Shipment.TYPE_FIRSTDIBS_FACILITATED;
    },
    /**
     * @returns {Boolean}
     */
    isBuyerArrangedShipping: function () {
        var buyerArrangedShipmentTypes = [Shipment.TYPE_LOCAL_PICKUP, Shipment.TYPE_EXTERNALLY_ARRANGED];
        return _.contains(buyerArrangedShipmentTypes, this.get('shipmentType'));
    },
    /**
     * @returns {Boolean}
     */
    hasNotShipped: function () {
        var preShippedStatuses = [Shipment.STATUS_NEW, Shipment.STATUS_PENDING, Shipment.STATUS_READY_FOR_PICKUP];
        return _.contains(preShippedStatuses, this.get('status'));
    },
    /**
     * @returns {boolean}
     */
    isLocalPickup: function () {
        return this.get('shipmentType') === Shipment.TYPE_LOCAL_PICKUP;
    },
    /**
     * @returns {boolean}
     */
    isExternallyArranged: function () {
        return this.get('shipmentType') === Shipment.TYPE_EXTERNALLY_ARRANGED;
    },
    /**
     * @returns {boolean}
     */
    isStatusNew: function () {
        return this.get('status') === Shipment.STATUS_NEW;
    },
    /**
     * @returns {boolean}
     */
    isPending: function () {
        return this.get('status') === Shipment.STATUS_PENDING;
    },
    /**
     * @returns {boolean}
     */
    hasFailedAddressRegistration: function () {
        return this.get('status') === Shipment.STATUS_REGISTRATION_FAILED;
    },
    /**
     * @returns {boolean}
     */
    isReadyForPickup: function () {
        return this.get('status') === Shipment.STATUS_READY_FOR_PICKUP;
    },
    /**
     * @returns {boolean}
     */
    isShipped: function () {
        return this.get('shipmentTracking.status') === Shipment.STATUS_SHIPPED;
    },
    /**
     * @returns {boolean}
     */
    isDelivered: function () {
        return this.get('shipmentTracking.status') === Shipment.STATUS_DELIVERED;
    },
    /**
     * @returns {boolean}
     */
    hasBeenShipped: function () {
        return this.isShipped() || this.isDelivered();
    },
    /**
     * @returns {number}
     */
    getSellerId: function () {
        // TODO: This is probably not reliable if used outside of a transaction.
        return this.parents[0].get('seller').id;
    },
    getTransactionId: function () {
        // TODO: This is probably not reliable if used outside of a transaction.
        return this.parents[0].get('id');
    },

    /**
     * @returns {string}
     */
    getTrackingLabelURL: function () {
        return this.get('shipmentTracking.labelUrl');
    },

    /**
     * @returns {string}
     */
    getTrackingNumber: function () {
        return this.get('shipmentTracking.trackingNumber');
    },

    /**
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.role=INTERNAL]
     * @param {string} [passedOptions.type=ADMIN]
     * @param {string} [passedOptions.level=INFO]
     * @param {string|number} [passedOptions.creatorId] Defaults to current user id
     * @param {string} [passedOptions.content] Defaults to empty string
     * @param {object[]} [passedOptions.anchors] Defaults to empty array
     * @returns {Note}
     */
    newNote: function (passedOptions) {
        var options = _.defaults(passedOptions, {
            anchors: [
                {
                    sourceId : this.getTransactionId(),
                    sourceType : Anchor.TYPE_TRANSACTION
                },
                {
                    sourceId: this.getSellerId(),
                    sourceType : Anchor.TYPE_SELLER
                },
                {
                    sourceId: this.id,
                    sourceType: Anchor.TYPE_SHIPMENT
                }
            ]
        });
        return this.get('notes').newNote(options);
    },
    /**
     * @param {object} noteOptions {@see Shipment#newNote}
     * @param {object} syncOptions Options for SoaModel.save
     * @returns {Deferred.promise}
     */
    addNewNote : function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },
    /**
     * Accept/Counter offer while saving shipment quote in one service call
     */
    dealerCompleteNegotiation: function (offer, counterOffer, passedOptions) {
        var options = _.extend({transitionFunction: 'updateAndTransition'}, passedOptions);
        return this.dealerTransitionWithOfferNote(
            Shipment.STATUS_PENDING, offer, counterOffer, options);
    },
    /**
     * Marks a shipment as SHIPPED. Optionally takes a note to create and anchor
     * @private
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @param {string} [passedOptions.noteRole] The note role
     * @param {string} [passedOptions.noteType] The note type
     * @returns {$.Deferred.promise}
     */
    _markShipped: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true
        });
        return this.transitionWithNote(Shipment.STATUS_SHIPPED, options);
    },
    _updateShipmentAndAccountingQuote: function (accountingQuote, passedOptions) {
        var clump = new Clump();
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true,
            transitionFunction: 'update'
        });

        var quoteSave = accountingQuote.updateAccountingQuote(clump);
        var shipmentSave = this._clumpTransitionWithNote(clump, null, options);
        clump.run({ applyDynaParams: true });
        return $.when(quoteSave, shipmentSave);
    },
    /**
     * @param {TransactionShipmentQuote} accountingQuote
     * @param {object} passedOptions
     * @private
     * @returns {$.Deferred.promise}
     */
    _transitionShipmentAndAcceptAccountingQuote: function (accountingQuote, shipmentStatus, passedOptions) {
        var clump = new Clump();
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true,
            transitionFunction: 'updateAndTransition'
        });
        var quoteSave = accountingQuote.acceptAccountingQuote(clump);
        var shipmentSave = this._clumpTransitionWithNote(clump, shipmentStatus, options);
        clump.run({
            dynaOptions: {
                open: '___',
                close: '___',
                params: {
                    anchorId: {
                        clumpElement: "transition",
                        expression: "$.result.id"
                    }
                }
            }
        });
        return $.when(quoteSave, shipmentSave);
    },


    /**
     * asserts that the passed quote is actually an accounting quote and returns
     * passed options augmented with default values
     * @param accountingShipmentQuote
     * @param passedOptions
     * @returns {*}
     * @private
     */
    _getOptionsWithNoteDefaults: function (passedOptions) {
        return _.defaults(passedOptions || {}, {
            noteType: Note.TYPE_BUYER_SELLER,
            noteRole: Party.ROLE_INTERNAL,
            transitionFunction: 'updateAndTransition'
        });
    },

    _assertIsAccountingQuote: function(accountingShipmentQuote) {
        console.assert(accountingShipmentQuote instanceof TransactionShipmentQuote, 'accountingShipmentQuote must be instance of TransactionShipmentQuote');
        console.assert(accountingShipmentQuote.isAccountingQuote(), 'accountingShipmentQuote must an accounting quote');
    },
    /**
     * Use when a dealer marks a shipment as SHIPPED. Optionally create and anchor a note
     * @param passedOptions.noteContent The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    markDealerShipped: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            noteType: Note.TYPE_BUYER_SELLER,
            noteRole: Party.ROLE_SELLER,
            transitionFunction: 'updateAndTransition'
        });
        return this._markShipped(options);
    },
    markBuyerShipped: function () {
        return this.transition(Shipment.STATUS_SHIPPED);
    },
    /**
     * Use when a 1stdibs Admin marks a shipment as SHIPPED.
     * Marks the accountingShipmentQuote as 'ACCEPTED' as well.
     * Optionally create and anchor a note.
     * @param {TransactionShipmentQuote} accountingShipmentQuote The accounting shipment quote
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    mark1stdibsShipped: function (accountingShipmentQuote, passedOptions) {
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(passedOptions);
        return this._transitionShipmentAndAcceptAccountingQuote(accountingShipmentQuote, Shipment.STATUS_SHIPPED, options);
    },

    /**
     * Use when a dealer marks a shipment as SHIPPED and that
     * shipment was subsidized by 1stdibs.
     * Marks the accountingShipmentQuote as 'ACCEPTED' as well.
     * Optionally create and anchor a note.
     * @param {TransactionShipmentQuote} accountingShipmentQuote The accounting shipment quote
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    markDealerShipped1stdibsSubsidized: function (accountingShipmentQuote, passedOptions) {
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(_.extend({ noteRole: Party.ROLE_SELLER }, passedOptions));
        return this._transitionShipmentAndAcceptAccountingQuote(accountingShipmentQuote, Shipment.STATUS_SHIPPED, options);
    },
    overrideUpsLabel: function (accountingShipmentQuote, passedOptions) {
        passedOptions = passedOptions || { transitionFunction: 'update' };
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(passedOptions);
        return this._updateShipmentAndAccountingQuote(accountingShipmentQuote, options);
    },
    /**
     * Use when a 1stdibs Admin corrects shipping info after an address fails registration with easy post.
     * Marks the accountingShipmentQuote as 'ACCEPTED' and updates it as well.
     * Optionally create and anchor a note.
     * @param {TransactionShipmentQuote} accountingShipmentQuote The accounting shipment quote
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    enterShippingInfo: function (accountingShipmentQuote, passedOptions) {
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(passedOptions);
        return this._transitionShipmentAndAcceptAccountingQuote(accountingShipmentQuote, Shipment.STATUS_PENDING, options);
    },
    /**
     * Marks a shipment as READY_FOR_PICKUP. Optionally takes a note to create and anchor
     * @param passedOptions.noteContent The content to insert into the note
     * @param passedOptions.noteRole The note role
     * @param passedOptions.noteType The note type
     * @returns {$.Deferred.promise}
     */
    _markReadyForPickup: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true
        });
        return this.transitionWithNote(Shipment.STATUS_READY_FOR_PICKUP, options);
    },
    /**
     * Use when a dealer marks a shipment as READY_FOR_PICKUP. Optionally create and anchor a note
     * @param passedOptions.noteContent The content to insert into the note
     *
     * @returns {$.Deferred.promise}
     */
    markDealerReadyForPickup: function (passedOptions) {
        var options;
        var noteType;

        if (this.isBuyerArrangedShipping()) {
            noteType = Note.TYPE_BUYER_SELLER;
        } else {
            noteType = Note.TYPE_SELLER_ADMIN;
        }

        options = _.defaults(passedOptions || {}, {
            noteType: noteType,
            noteRole: Party.ROLE_SELLER
        });
        return this._markReadyForPickup(options);
    },
    /**
     * Use when a 1stdibs Admin marks a shipment as DELIVERED. Optionally create and anchor a note
     * @param passedOptions.noteContent The content to insert into the note
     *
     * @returns {$.Deferred.promise}
     */
    mark1stdibsDelivered: function (passedOptions) {
        return this.transitionWithNote(Shipment.STATUS_DELIVERED, passedOptions);
    }
}, transitionMixin, periodMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Lior Elrom
 * Date: 7/1/15
 * Time: 2:45 PM
 */



var _ = __webpack_require__(0);
var PaymentMethod = __webpack_require__(11);

var isCardType = function (cardType) {
    return this.getCardType() === cardType;
};

module.exports = {
    isVisa: _.partial(isCardType, PaymentMethod.CARD_TYPE_VISA),
    isMaster: _.partial(isCardType, PaymentMethod.CARD_TYPE_MASTER),
    isDiscover: _.partial(isCardType, PaymentMethod.CARD_TYPE_DISCOVER),
    isAmex: _.partial(isCardType, PaymentMethod.CARD_TYPE_AMEX),

    getDisplayMaskedCard: function () {
        var lastNumbers = this.getLastNumbers();
        var maskedCardStr;
        if (lastNumbers) {
            // Amex: xxxx-xxxxxx-xxxxx
            // Visa/Discover/Master: xxxx-xxxx-xxxx-xxxx
            maskedCardStr = this.isAmex() ? 'xxxx-xxxxxx-x' : 'xxxx-xxxx-xxxx-';
            return maskedCardStr + lastNumbers;
        }
        return;
    },
    isExpired : function () {
        var cardYear = parseInt(this.get('cardExpiryYear'), 10);
        var now = new Date();
        var thisYear = parseInt(now.getFullYear(), 10);
        if (cardYear < thisYear) {
            return true;
        } else if (cardYear > thisYear) {
            return false;
        }
        return (now.getMonth() + 1 > parseInt(this.get('cardExpiryMonth'), 10));
    }
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var FieldRule = __webpack_require__(46);

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Module Definition and Instance Properties

/**
 * @class RegexRule
 * @extends FieldRule
 */
var RegexRule = module.exports = FieldRule.extend({
    noMatch: false,
    initialize: function (options) {
        options = options || {};
        RegexRule.__super__.initialize.call(this, options);
        this.regex = options.regex || this.regex;
    },
    outputSchema: function () {
        return {
            validator: this.regex,
            noMatch: this.noMatch
        };
    }
});


/***/ }),
/* 86 */
/***/ (function(module, exports) {

function one(selector, el) {
  return el.querySelector(selector);
}

exports = module.exports = function(selector, el){
  el = el || document;
  return one(selector, el);
};

exports.all = function(selector, el){
  el = el || document;
  return el.querySelectorAll(selector);
};

exports.engine = function(obj){
  if (!obj.one) throw new Error('.one callback required');
  if (!obj.all) throw new Error('.all callback required');
  one = obj.one;
  exports.all = obj.all;
  return exports;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var debug = __webpack_require__(37)('Dispatchr:Action');

function Action(name, payload) {
    this.name = name;
    this.payload = payload;
    this._handlers = null;
    this._isExecuting = false;
    this._isCompleted = null;
}

/**
 * Gets a name from a store
 * @method getStoreName
 * @param {String|Object} store The store name or class from which to extract
 *      the name
 * @returns {String}
 */
Action.prototype.getStoreName = function getStoreName(store) {
    if ('string' === typeof store) {
        return store;
    }
    return store.storeName;
};

/**
 * Executes all handlers for the action
 * @method execute
 * @param {Function[]} handlers A mapping of store names to handler function
 * @throws {Error} if action has already been executed
 */
Action.prototype.execute = function execute(handlers) {
    if (this._isExecuting) {
        throw new Error('Action is already dispatched');
    }
    var self = this;
    this._handlers = handlers;
    this._isExecuting = true;
    this._isCompleted = {};
    Object.keys(handlers).forEach(function handlersEach(storeName) {
        self._callHandler(storeName);
    });
};

/**
 * Calls an individual store's handler function
 * @method _callHandler
 * @param {String} storeName
 * @private
 * @throws {Error} if handler does not exist for storeName
 */
Action.prototype._callHandler = function callHandler(storeName) {
    var self = this,
        handlerFn = self._handlers[storeName];
    if (!handlerFn) {
        throw new Error(storeName + ' does not have a handler for action ' + self.name);
    }
    if (self._isCompleted[storeName]) {
        return;
    }
    self._isCompleted[storeName] = false;
    debug('executing handler for ' + storeName);
    handlerFn(self.payload, self.name);
    self._isCompleted[storeName] = true;
};

/**
 * Waits until all stores have finished handling an action and then calls
 * the callback
 * @method waitFor
 * @param {String|String[]|Constructor|Constructor[]} stores An array of stores as strings or constructors to wait for
 * @param {Function} callback Called after all stores have completed handling their actions
 * @throws {Error} if the action is not being executed
 */
Action.prototype.waitFor = function waitFor(stores, callback) {
    var self = this;
    if (!self._isExecuting) {
        throw new Error('waitFor called even though there is no action being executed!');
    }
    if (!Array.isArray(stores)) {
        stores = [stores];
    }

    debug('waiting on ' + stores.join(', '));
    stores.forEach(function storesEach(storeName) {
        storeName = self.getStoreName(storeName);
        if (self._handlers[storeName]) {
            self._callHandler(storeName);
        }
    });

    callback();
};

module.exports = Action;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var debug = __webpack_require__(37)('Fluxible');
var isPromise = __webpack_require__(58);
var FluxibleContext = __webpack_require__(218);
var dispatchr = __webpack_require__(207);
var __DEV__ = 'production' !== 'production';

/*
 * The default component action handler
 * @method defaultComponentActionHandler
 */
function defaultComponentActionHandler(context, payload, done) {
    if (payload.err) {
        debug('Action returned error', payload.actionName, payload.err);
        throw payload.err;
    }
    done();
}

/**
 * Provides a structured way of registering an application's configuration and
 * resources.
 * @class Fluxible
 * @param {Object} [options]
 * @param {Object} [options.component] Stores your top level React component for access using `getComponent()`
 * @param {Function} [options.componentActionErrorHandler] App level component action handler
 * @constructor
 *
 * @example
 *      var app = new Fluxible({
 *          component: require('./components/App.jsx')
 *      });
 */
function Fluxible(options) {
    debug('Fluxible instance instantiated', options);
    options = options || {};

    // Options
    this._component = options.component;
    this._componentActionErrorHandler =
        options.componentActionErrorHandler || defaultComponentActionHandler;
    this._plugins = [];

    // Initialize dependencies
    this._dispatcher = dispatchr.createDispatcher(options);
}

/**
 * Creates an isolated context for a request/session
 * @method createContext
 * @param {Object} [options]
 * @returns {FluxibleContext}
 */
Fluxible.prototype.createContext = function createContext(options) {
    var self = this;
    options = options || {};
    var context = new FluxibleContext(self);

    // Plug context with app plugins that implement plugContext method
    this._plugins.forEach(function eachPlugin(plugin) {
        if (plugin.plugContext) {
            var contextPlugin = plugin.plugContext(options, context, self) || {};
            contextPlugin.name = contextPlugin.name || plugin.name;
            context.plug(contextPlugin);
        }
    });

    return context;
};

/**
 * Creates a new dispatcher instance using the application's dispatchr class. Used by
 * FluxibleContext to create new dispatcher instance
 * @method createDispatcherInstance
 * @param {Object} contextOptions The context options to be provided to each store instance
 * @returns {Dispatcher}
 */
Fluxible.prototype.createDispatcherInstance = function createDispatcherInstance(contextOptions) {
    return this._dispatcher.createContext(contextOptions);
};

/**
 * Provides plugin mechanism for adding application level settings that are persisted
 * between server/client and also modification of the FluxibleContext
 * @method plug
 * @param {Object} plugin
 * @param {String} plugin.name Name of the plugin
 * @param {Function} plugin.plugContext Method called after context is created to allow
 *  dynamically plugging the context
 * @param {Object} [plugin.dehydrate] Method called to serialize the plugin settings to be persisted
 *  to the client
 * @param {Object} [plugin.rehydrate] Method called to rehydrate the plugin settings from the server
 */
Fluxible.prototype.plug = function (plugin) {
    if (__DEV__) {
        if (!plugin.name) {
            throw new Error('Application plugin must have a name');
        }
    }
    this._plugins.push(plugin);
};

/**
 * Provides access to a plugin instance by name
 * @method getPlugin
 * @param {String} pluginName The plugin name
 * @returns {Object}
 */
Fluxible.prototype.getPlugin = function (pluginName) {
    var plugin = null;
    this._plugins.forEach(function (p) {
        if (pluginName === p.name) {
            plugin = p;
        }
    });
    return plugin;
};

/**
 * Getter for the top level react component for the application
 * @method getComponent
 * @returns {ReactComponent}
 */
Fluxible.prototype.getComponent = function getComponent() {
    return this._component;
};

/**
 * Registers a store to the dispatcher so it can listen for actions
 * @method registerStore
 */
Fluxible.prototype.registerStore = function registerStore() {
    debug(arguments[0].storeName + ' store registered');
    this._dispatcher.registerStore.apply(this._dispatcher, arguments);
};

/**
 * Creates a serializable state of the application and a given context for sending to the client
 * @method dehydrate
 * @param {FluxibleContext} context
 * @returns {Object} Dehydrated state object
 */
Fluxible.prototype.dehydrate = function dehydrate(context) {
    debug('dehydrate', context);
    var self = this;
    var state = {
        context: context.dehydrate(),
        plugins: {}
    };

    this._plugins.forEach(function (plugin) {
        if ('function' === typeof plugin.dehydrate) {
            // Use a namespace for storing plugin state and provide access to the application
            state.plugins[plugin.name] = plugin.dehydrate(self);
        }
    });

    return state;
};

/**
 * Rehydrates the application and creates a new context with the state from the server
 * @method rehydrate
 * @param {Object} obj Raw object of dehydrated state
 * @param {Object} obj.plugins Dehydrated app plugin state
 * @param {Object} obj.context Dehydrated context state
 * @param {Function} callback
 * @async Rehydration may require more asset loading or async IO calls
 */
Fluxible.prototype.rehydrate = function rehydrate(obj, callback) {
    debug('rehydrate', obj);
    var self = this;
    if (__DEV__) {
        if (typeof obj !== 'object') {
            throw new Error('`rehydrate` called with a non-object. Ensure ' +
                'that the parameter passed to rehydrate is a state object ' +
                'produced by a dehydrate call.');
        }
    }
    obj.plugins = obj.plugins || {};
    var pluginTasks = self._plugins.filter(function (plugin) {
        return 'function' === typeof plugin.rehydrate
            && obj.plugins[plugin.name];
    }).map(function (plugin) {
        return new Promise(function (resolve, reject) {
            var result = plugin.rehydrate(obj.plugins[plugin.name], function (err) {
                if (err) {
                    reject(err);
                } else {
                    resolve();
                }
            });
            if (isPromise(result)) {
                result.then(resolve, reject);
            } else if (plugin.rehydrate.length < 2) {
                resolve();
            }
        });
    });

    var context = self.createContext();
    var rehydratePromise = Promise.all(pluginTasks).then(function rehydratePluginTasks() {
        return context.rehydrate(obj.context || {});
    });

    if (callback) {
        rehydratePromise
            .then(function (contextValue) {
                // Ensures that errors in callback are not swallowed by promise
                setImmediate(callback, null, contextValue);
            }, function (err) {
                // Ensures that errors in callback are not swallowed by promise
                setImmediate(callback, err);
            });
    }

    return rehydratePromise;
};

module.exports = Fluxible;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44).setImmediate))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function($){try{$('export default global')}catch(e){try{$('export default self')}catch(e){try{module.exports=global}catch(e){try{self.global=self}catch(e){window.global=window}}}}}(eval))
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = global;

  // assume CommonJS
  var create = __webpack_require__(237);
  var isEmpty = __webpack_require__(250);
  var uniqueId = __webpack_require__(242);
  var size = __webpack_require__(241);
  var once = __webpack_require__(322);
  var assign = __webpack_require__(248);
  var pick = __webpack_require__(251);
  var result = __webpack_require__(252);
  var isFunction = __webpack_require__(99);
  var forEach = __webpack_require__(249);
  var has = __webpack_require__(238);
  var matches = __webpack_require__(38);
  var Backbone = module.exports = {};

  // Initial Setup
  // -------------

  // Create a local reference to a common array method we'll want to use later.
  var slice = Array.prototype.slice;

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // a custom event channel. You may bind a callback to an event with `on` or
  // remove with `off`; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     assign(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`).
  var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = Object.keys(name); i < names.length ; i++) {
        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space-separated event names by delegating them individually.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        events = iteratee(events, names[i], callback, opts);
      }
    } else {
      // Finally, standard events.
      events = iteratee(events, name, callback, opts);
    }
    return events;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    return internalOn(this, name, callback, context);
  };

  // Guard the `listening` argument from the public API.
  var internalOn = function(obj, name, callback, context, listening) {
    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
      context: context,
      ctx: obj,
      listening: listening
    });

    if (listening) {
      var listeners = obj._listeners || (obj._listeners = {});
      listeners[listening.id] = listening;
    }

    return obj;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to
  // for easier unbinding later.
  Events.listenTo = function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      var thisId = this._listenId || (this._listenId = uniqueId('l'));
      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
    }

    // Bind callbacks on obj, and keep track of them on listening.
    internalOn(obj, name, callback, this, listening);
    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
    }
    return events;
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off = function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
      context: context,
      listeners: this._listeners
    });
    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening = function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : Object.keys(listeningTo);

    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
    }
    if (isEmpty(listeningTo)) this._listeningTo = void 0;

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    if (!events) return;

    var i = 0, listening;
    var context = options.context, listeners = options.listeners;

    // Delete all events listeners and "drop" events.
    if (!name && !callback && !context) {
      var ids = listeners ? Object.keys(listeners) : [];
      for (; i < ids.length; i++) {
        listening = listeners[ids[i]];
        delete listeners[listening.id];
        delete listening.listeningTo[listening.objId];
      }
      return;
    }

    var names = name ? [name] : Object.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Replace events if there are any remaining.  Otherwise, clean up.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          listening = handler.listening;
          if (listening && --listening.count === 0) {
            delete listeners[listening.id];
            delete listening.listeningTo[listening.objId];
          }
        }
      }

      // Update tail event if the list has any events.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }
    if (size(events)) return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, its listener will be removed. If multiple events
  // are passed in using the space-separated syntax, the handler will fire
  // once for each event, not once for a combination of all events.
  Events.once = function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, this.off.bind(this));
    return this.on(events, void 0, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce = function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, this.stopListening.bind(this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var callbackOnce = map[name] = once(function() {
        offer(name, callbackOnce);
        callback.apply(this, arguments);
      });
      callbackOnce._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger = function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, callback, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  assign(Backbone, Events);

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = uniqueId('view');
    this.__delegatorConfigs = [];
    assign(this, pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be set as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  assign(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      if (!this.el) {
        return [];
      }
      return slice.call(this.el.querySelectorAll(selector));
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.undelegateEvents();
      if (!this.el.parentNode) {
        return;
      }
      this.el.parentNode.removeChild(this.el);
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` reference for this view using the
    // given `el`. `el` can be an element. Subclasses can
    // override this to utilize an alternative DOM manipulation API and are only
    // required to set the `this.el` property.
    _setElement: function(el) {
      var querySelector;
      if ('string' === typeof el) {
        querySelector = el;
        el = document.querySelector(querySelector);
      }
      this.el = el;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], method.bind(this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      var delegator;
      if (!listener) {
        listener = selector;
        selector = null;
      }
      delegator = function(e) {
        if (!selector || matches(e.target, selector)) {
          return listener.apply(this, arguments);
        }
      };
      this.__delegatorConfigs.push({
        eventName: eventName,
        selector: selector,
        delegator: delegator,
        listener: listener
      });
      this.el.addEventListener(eventName, delegator);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.__delegatorConfigs.forEach(function(delegatorConfig) {
        this.el.removeEventListener(delegatorConfig.eventName, delegatorConfig.delegator);
      }.bind(this));
      this.__delegatorConfigs = [];
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      var delegatorConfigs;
      if ('string' !== typeof selector && !listener) {
        listener = selector;
        selector = null;
      }
      delegatorConfigs = this.__delegatorConfigs.filter(function(delegatorConfig) {
        if (selector && selector !== delegatorConfig.selector) {
          return false;
        }
        if (listener && listener !== delegatorConfig.listener) {
          return false;
        }
        return eventName === delegatorConfig.eventName;
      });
      delegatorConfigs.forEach(function(delegatorConfig) {
        this.el.removeEventListener(delegatorConfig.eventName, delegatorConfig.delegator);
      }.bind(this));
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // Create an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = assign({}, result(this, 'attributes'));
        if (this.id) attrs.id = result(this, 'id');
        if (this.className) attrs['class'] = result(this, 'className');
        this.setElement(this._createElement(result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      if (!this.el) {
        return;
      }
      forEach(attributes, function(value, name) {
        this.el.setAttribute(name, value);
      }.bind(this));
    }

  });

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    assign(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function and add the prototype properties.
    child.prototype = create(parent.prototype, protoProps);
    child.prototype.constructor = child;

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  View.extend = extend;

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var appSetup = __webpack_require__(226);
var ContextProvider = __webpack_require__(290);
var pick = __webpack_require__(65);
var isEmpty = __webpack_require__(264);

/**
 * Creates a Fluxible app, registers the specified stores with it,
 * and creates the context from the app, allowing the nav bar to continue initialization using that context.
 * If dehydrated state is passed in, rehydrates App and returns a promise.
 *
 * @param {Array} [stores=[]] - An array of stores that should be registered with the app.
 * @param {Object} [opt={}]
 * @param {boolean} [opt.connectToNavBar=true] - If true, register Nav Bar stores with the app
 * @param {Object} [opt.state={}] - Dehydrated state of server-side App
 * @returns {Object|Promise} - Returns Fluxible Context, or Promise that resolves to Fluxible Context
 */
function createEntryPointContext() {
    var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var options = { connectToNavBar: true, state: {}, connectToContact: false };
    var App = void 0;
    var rehydrate = void 0;
    var promise = void 0;
    var context = void 0;

    Object.assign(options, opt);

    App = appSetup(stores, pick(options, 'connectToNavBar', 'connectToContact', 'contactOptions'));
    context = App.createContext();
    rehydrate = options.state && !isEmpty(options.state);

    if (rehydrate) {
        promise = new Promise(function (resolve /*, reject*/) {

            App.rehydrate(options.state, function (error, rehydratedContext) {
                if (error) {
                    console.log('Encontered an error while rehydrating App, ' + 'but failing silently and allowing context to be set: ' + error + '\n' + error.stack);

                    // If rehydration fails fallback to context without rehydrating to prevent showing user blank page
                    rehydratedContext = context;
                }
                resolve(ContextProvider.setContext(rehydratedContext));
            });
        });
    }

    return rehydrate ? promise : ContextProvider.setContext(context);
}

module.exports = createEntryPointContext;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    createReducerStore: __webpack_require__(215)
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(62);

/*
 * @param  {number} amount - The number to format.
 * @param  {string} currency - Accepts any currency from currencies file
 * @param  {object} passedOptions - Additional options for localizedCashFormat
 * @return {string} - Formatted price string
 */
module.exports = function intelligentFormat(amount, currency, passedOptions) {
    var options = util.getFormatOptions(amount, currency, passedOptions);
    return util.localizedCashFormat(amount, options);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var FinancialAmount = __webpack_require__(10);
var Price = __webpack_require__(66);
var User = __webpack_require__(15);
var numAddCommas = __webpack_require__(125);
var tokenReplace = __webpack_require__(75);
var currencyUtil = __webpack_require__(62);
var intelligentFormat = __webpack_require__(93);
var mapValues = __webpack_require__(107);
var enabler = __webpack_require__(63);

var ContactUIStore = function (_BaseStore) {
    _inherits(ContactUIStore, _BaseStore);

    function ContactUIStore(dispatcher) {
        _classCallCheck(this, ContactUIStore);

        var _this = _possibleConstructorReturn(this, (ContactUIStore.__proto__ || Object.getPrototypeOf(ContactUIStore)).call(this, dispatcher));

        _this.state = {
            modalId: '',
            isOpened: false
        };
        _this.reset();
        return _this;
    }

    _createClass(ContactUIStore, [{
        key: 'openModal',
        value: function openModal(_ref) {
            var modalId = _ref.modalId;

            Object.assign(this.state, {
                modalId: modalId,
                isOpened: true
            });
            this.emitChange();
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            Object.assign(this.state, {
                modalId: '',
                isOpened: false,
                isServerError: false
            });
            this.emitChange();
        }
    }, {
        key: 'startLoading',
        value: function startLoading(_ref2) {
            var sendToOmtOnSuccess = _ref2.sendToOmtOnSuccess,
                itemPk = _ref2.itemPk;

            this.reset();
            Object.assign(this.state, {
                sendToOmtOnSuccess: sendToOmtOnSuccess,
                isItem: !!itemPk
            });
        }
    }, {
        key: 'startSending',
        value: function startSending() {
            this.state.isSending = true;
            this.emitChange();
        }
    }, {
        key: 'doneSending',
        value: function doneSending() {
            this.state.formSubmitted = true;
        }
    }, {
        key: 'serverError',
        value: function serverError() {
            Object.assign(this.state, {
                isServerError: true,
                isOpened: true,
                isSending: false
            });
            this.emitChange();
        }
    }, {
        key: 'showOptIn',
        value: function showOptIn() {
            this.state.isShowOptIn = true;
            this.emitChange();
        }
    }, {
        key: 'doneLoading',
        value: function doneLoading(payload) {
            var _this2 = this;

            // initialize message before updating ui
            this.dispatcher.waitFor('ContactMessageStore', function () {
                var item = payload.item,
                    seller = payload.seller,
                    user = payload.user,
                    copyText = payload.copyText;

                if (user && _this2.state.user) {
                    // we have the up-to-date profile already
                    user.set('profile', _this2.state.user.get('profile'));
                }
                Object.assign(_this2.state, {
                    copyText: copyText,
                    seller: seller,
                    user: user,
                    isLoading: false,
                    isUserInitiallyLoggedIn: !!user,
                    isUserNameSet: user && user.get('profile') && user.get('profile').getDisplayName({ defaultToEmail: false }),
                    sellerCompany: seller.get('sellerProfile.company')
                });
                if (item) {
                    var isShowOffer = item.canMakeBuyerOffer();
                    _this2.state.isShowOffer = isShowOffer;
                    if (isShowOffer) {
                        var currency = _this2.dispatcher.getStore('UserStore').getCurrency();
                        var currencySymbol = FinancialAmount.getCurrencySymbol(currency);
                        var delimiter = currency === FinancialAmount.CURRENCY_EUR ? '.' : ',';

                        // Values are numbers, prices are string representations of corresponding numbers
                        var values = [Price.TYPE_RETAIL, Price.TYPE_NET, Price.TYPE_SALE].map(function (type) {
                            // getPriceIn defaults to main price if given type's price is not defined
                            return item.getPriceByType(type) ? item.getPriceIn(type, currency) : undefined;
                        });

                        var _values = _slicedToArray(values, 3),
                            retailValue = _values[0],
                            netValue = _values[1],
                            saleValue = _values[2];

                        var _values$map = values.map(function (value) {
                            return value ? numAddCommas(value, false, delimiter) : undefined;
                        }),
                            _values$map2 = _slicedToArray(_values$map, 3),
                            retailPrice = _values$map2[0],
                            netPrice = _values$map2[1],
                            salePrice = _values$map2[2];

                        var displayPrice = void 0;
                        var priceValue = void 0;
                        var priceType = void 0;
                        var showNetPrice = netValue && item.isFurniture() && User.canRequestNetPrice() && enabler.isEnabled('enable_net_price');
                        if (saleValue) {
                            displayPrice = salePrice;
                            priceValue = saleValue;
                            priceType = Price.TYPE_SALE;
                        } else if (showNetPrice) {
                            displayPrice = netPrice;
                            priceValue = netValue;
                            priceType = Price.TYPE_NET;
                        } else {
                            displayPrice = retailPrice;
                            priceValue = retailValue;
                            priceType = Price.TYPE_RETAIL;
                        }

                        Object.assign(_this2.state, {
                            isPricePerPiece: item.canMultipleQuantityBePurchased(),
                            pieces: item.getNumberOfPieces(),
                            currency: currency,
                            currencySymbol: currencySymbol,
                            displayPrice: displayPrice,
                            priceValue: priceValue,
                            priceType: priceType
                        }, {
                            formattedRetailPrice: intelligentFormat(retailValue, currency),
                            formattedNetPrice: showNetPrice ? intelligentFormat(netValue, currency) : undefined,
                            formattedSalePrice: saleValue ? intelligentFormat(saleValue, currency) : undefined
                        });
                    }
                }
                _this2._setBaseModalHeader();
                _this2.emitChange();
            });
        }
    }, {
        key: 'doneLoadingUserToUser',
        value: function doneLoadingUserToUser(payload) {
            var user = payload.user,
                copyText = payload.copyText,
                header = payload.header;


            Object.assign(this.state, {
                copyText: copyText,
                user: user,
                modalHeader: header,
                isLoading: false,
                isUserInitiallyLoggedIn: !!user,
                isUserNameSet: user && user.get('profile') && user.get('profile').getDisplayName({ defaultToEmail: false })
            });

            this.emitChange();
        }
    }, {
        key: 'toggleOffer',
        value: function toggleOffer() {
            this._toggleField('isOfferEnabled');
            this.clearErrors();
        }
    }, {
        key: 'toggleMessage',
        value: function toggleMessage() {
            this._toggleField('isMessageEnabled');
            this.clearErrors();
        }
    }, {
        key: 'showLowBall',
        value: function showLowBall() {
            Object.assign(this.state, {
                isShowLowBallWarning: true,
                modalHeader: this.state.copyText.get('offerLowballTitle')
            });
            this.emitChange();
        }
    }, {
        key: 'hideLowBall',
        value: function hideLowBall() {
            this.state.isShowLowBallWarning = false;
            this._setBaseModalHeader();
            this.emitChange();
        }
    }, {
        key: 'hideMakeOffer',
        value: function hideMakeOffer() {
            this.state.isShowOffer = false;
            this.emitChange();
        }
    }, {
        key: 'initLowballOptions',
        value: function initLowballOptions(_ref3) {
            var offerAmount = _ref3.offerAmount;
            var _state = this.state,
                priceValue = _state.priceValue,
                currency = _state.currency,
                isPricePerPiece = _state.isPricePerPiece,
                copyText = _state.copyText;

            var fivePercent = 0.05;
            var tenPercent = 0.1;
            var priceFivePercentOff = currencyUtil.round(priceValue * (1 - fivePercent), 0);
            var priceTenPercentOff = currencyUtil.round(priceValue * (1 - tenPercent), 0);
            var perItem = isPricePerPiece ? copyText.get(' per item') : '';

            // Value is what gets set on the offer model and label is visually displayed
            this.state.lowballOptions = [{
                value: '' + priceFivePercentOff,
                label: intelligentFormat(priceFivePercentOff, currency) + perItem,
                percentOff: fivePercent * 100,
                labelSubtext: tokenReplace(copyText.get('lowballOptionAmountOff'), {
                    amountOff: intelligentFormat(priceValue - priceFivePercentOff, currency),
                    percentOff: fivePercent * 100
                })
            }, {
                value: '' + priceTenPercentOff,
                label: intelligentFormat(priceTenPercentOff, currency) + perItem,
                percentOff: tenPercent * 100,
                labelSubtext: tokenReplace(copyText.get('lowballOptionAmountOff'), {
                    amountOff: intelligentFormat(priceValue - priceTenPercentOff, currency),
                    percentOff: tenPercent * 100
                })
            }];

            if (offerAmount) {
                var offerValue = currencyUtil.parseFloat(offerAmount);
                var amountOffValue = priceValue - offerValue;
                var percentOff = amountOffValue / priceValue * 100;
                this.state.lowballOptions.push({
                    value: offerAmount,
                    label: intelligentFormat(offerValue, currency) + perItem + ' ' + copyText.get('originalOffer'),
                    percentOff: percentOff,
                    labelSubtext: tokenReplace(copyText.get('lowballOptionAmountOff'), {
                        amountOff: intelligentFormat(amountOffValue, currency),
                        percentOff: currencyUtil.format(percentOff, 0)
                    }),
                    isOriginalOffer: true
                });
            }

            this.state.lowballOptions.push({
                isOther: true,
                value: 'other',
                label: copyText.get('lowballOtherOptionLabel')
            });

            // No Lowball option is selected at first so disable submit.
            this.state.submitDisabled = true;
        }
    }, {
        key: 'setLowballOption',
        value: function setLowballOption(payload) {
            var selectedLowballOption = payload.selectedLowballOption;

            var prevLowballOption = this.state.selectedLowballOption;
            selectedLowballOption.checked = true;
            if (prevLowballOption) {
                prevLowballOption.checked = false;
                if (prevLowballOption.isOther) {
                    // if no longer "other" option, reset offer label subtext for it
                    this.setLowballOfferDiscount({ value: '' });
                }
            }
            this.state.selectedLowballOption = selectedLowballOption;
            // Lowball option definitely selected now, enable submit button
            // if it's not the "other" option which is an input
            this.state.submitDisabled = Boolean(selectedLowballOption.isOther);
            this.clearErrors();
        }
    }, {
        key: 'setLowballOfferDiscount',
        value: function setLowballOfferDiscount(payload) {
            var _state2 = this.state,
                selectedLowballOption = _state2.selectedLowballOption,
                currency = _state2.currency,
                priceValue = _state2.priceValue,
                copyText = _state2.copyText;

            if (!selectedLowballOption || selectedLowballOption && !selectedLowballOption.isOther) {
                return;
            }
            if (payload.value === '') {
                selectedLowballOption.labelSubtext = undefined;
                this.state.submitDisabled = true;
                return;
            }
            var offerValue = currencyUtil.parseFloat(payload.value);
            var amountOffValue = priceValue - offerValue;
            if (amountOffValue <= 0) {
                selectedLowballOption.percentOff = undefined;
                selectedLowballOption.labelSubtext = undefined;
            } else {
                var percentOff = amountOffValue / priceValue * 100;
                selectedLowballOption.percentOff = percentOff;
                selectedLowballOption.labelSubtext = tokenReplace(copyText.get('lowballOptionAmountOff'), {
                    amountOff: intelligentFormat(amountOffValue, currency),
                    percentOff: currencyUtil.format(percentOff, 0)
                });
            }
            this.state.submitDisabled = false;
            // Reset errors after each change
            this.clearErrors();
        }
    }, {
        key: 'startAuth',
        value: function startAuth() {
            this.state.isOpened = false;
            this.emitChange();
        }
    }, {
        key: 'doneAuth',
        value: function doneAuth(_ref4) {
            var user = _ref4.user;

            Object.assign(this.state, {
                isOpened: true,
                user: user
            });
            this.emitChange();
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.state.errors = {};
            this.emitChange();
        }
    }, {
        key: 'validateForm',
        value: function validateForm(payload) {
            this.clearErrors();
            this.state.errors = mapValues(payload.errors, function (err) {
                return err.message;
            });
            this.emitChange();
        }
    }, {
        key: 'setChatEvents',
        value: function setChatEvents(_ref5) {
            var chatSuccessEvent = _ref5.chatSuccessEvent,
                chatAbandonEvent = _ref5.chatAbandonEvent;

            Object.assign(this.state, { chatSuccessEvent: chatSuccessEvent, chatAbandonEvent: chatAbandonEvent });
        }
    }, {
        key: 'setOptimizely',
        value: function setOptimizely(payload) {
            Object.assign(this.state, payload);
            this.emitChange();
        }
    }, {
        key: 'updateModalHeader',
        value: function updateModalHeader(headerCopy) {
            Object.assign(this.state, { modalheader: headerCopy });
            this.emitChange();
        }
    }, {
        key: 'reset',
        value: function reset() {
            Object.assign(this.state, {
                isLoading: true,
                isSending: false,
                isSendComplete: false,
                isServerError: false,
                isShowLowBallWarning: false,
                lowballOptions: [],
                selectedLowballOption: undefined,
                offerSent: false,
                isMessageEnabled: false,
                isOfferEnabled: false,
                submitDisabled: false,
                modalHeader: '',
                sellerCompany: '',
                errors: {},
                formSubmitted: false,
                chatSuccessEvent: null,
                chatAbandonEvent: null
            });
            this.emitChange();
        }
    }, {
        key: '_toggleField',
        value: function _toggleField(field) {
            this.state[field] = !this.state[field];
            this.emitChange();
        }
    }, {
        key: '_setBaseModalHeader',
        value: function _setBaseModalHeader() {
            this.state.modalHeader = tokenReplace(this.state.copyText.get('header'), {
                dealer: this.state.sellerCompany
            });
        }
    }]);

    return ContactUIStore;
}(BaseStore);

ContactUIStore.storeName = 'ContactUIStore';
ContactUIStore.handlers = {
    'contact:modal:open': 'openModal',
    'contact:modal:close': 'closeModal',
    'contact:loading:start': 'startLoading',
    'contact:loading:done': 'doneLoading',
    'contact:sending:start': 'startSending',
    'contact:sending:done': 'doneSending',
    'contact:userToUser:loading:done': 'doneLoadingUserToUser',
    'contact:serverError': 'serverError',
    'contact:showOptIn': 'showOptIn',
    'contact:offer:toggle': 'toggleOffer',
    'contact:message:toggle': 'toggleMessage',
    'contact:form:lowBall:show': 'showLowBall',
    'contact:form:lowBall:hide': 'hideLowBall',
    'contact:form:makeOffer:hide': 'hideMakeOffer',
    'contact:form:lowball:options:init': 'initLowballOptions',
    'contact:form:lowball:options:set': 'setLowballOption',
    'contact:form:lowball:options:offer': 'setLowballOfferDiscount',
    'contact:auth:start': 'startAuth',
    'contact:auth:done': 'doneAuth',
    'contact:form:validated': 'validateForm',
    'contact:chat:setEvents': 'setChatEvents',
    'contact:reset': 'reset',
    'contact:optimizely:setOptimizely': 'setOptimizely'
};

module.exports = ContactUIStore;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var arrayMap = __webpack_require__(320),
    baseDifference = __webpack_require__(121),
    baseFlatten = __webpack_require__(311),
    bindCallback = __webpack_require__(122),
    pickByArray = __webpack_require__(329),
    pickByCallback = __webpack_require__(330),
    keysIn = __webpack_require__(306),
    restParam = __webpack_require__(274);

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable properties of `object` that are not omitted.
 * Property names may be specified as individual arguments or as arrays of
 * property names. If `predicate` is provided it is invoked for each property
 * of `object` omitting the properties `predicate` returns truthy for. The
 * predicate is bound to `thisArg` and invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {Function|...(string|string[])} [predicate] The function invoked per
 *  iteration or property names to omit, specified as individual property
 *  names or arrays of property names.
 * @param {*} [thisArg] The `this` binding of `predicate`.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'user': 'fred', 'age': 40 };
 *
 * _.omit(object, 'age');
 * // => { 'user': 'fred' }
 *
 * _.omit(object, _.isNumber);
 * // => { 'user': 'fred' }
 */
var omit = restParam(function(object, props) {
  if (object == null) {
    return {};
  }
  if (typeof props[0] != 'function') {
    var props = arrayMap(baseFlatten(props), String);
    return pickByArray(object, baseDifference(keysIn(object), props));
  }
  var predicate = bindCallback(props[0], props[1], 3);
  return pickByCallback(object, function(value, key, object) {
    return !predicate(value, key, object);
  });
});

module.exports = omit;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var ContactDealerMessage = __webpack_require__(233);
var User = __webpack_require__(15);
var Price = __webpack_require__(66);
var contactHelpers = __webpack_require__(102);
var enabler = __webpack_require__(63);

var ContactMessageStore = function (_BaseStore) {
    _inherits(ContactMessageStore, _BaseStore);

    function ContactMessageStore(dispatcher) {
        _classCallCheck(this, ContactMessageStore);

        var _this = _possibleConstructorReturn(this, (ContactMessageStore.__proto__ || Object.getPrototypeOf(ContactMessageStore)).call(this, dispatcher));

        _this.reset();
        return _this;
    }

    _createClass(ContactMessageStore, [{
        key: 'reset',
        value: function reset() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.message = new ContactDealerMessage(null, options);
        }
    }, {
        key: 'doneLoading',
        value: function doneLoading(payload) {
            var user = payload.user,
                item = payload.item,
                seller = payload.seller,
                copyText = payload.copyText,
                isNetPrice = payload.isNetPrice;

            var canRequestNetPrice = false;
            this.reset({ isNetPrice: isNetPrice });
            if (user) {
                this.message.setFromUser(user);
                canRequestNetPrice = User.canRequestNetPrice();
            }
            if (item) {
                var uploadedNetPrice = item.getPriceByType(Price.TYPE_NET);
                var showingUploadedNetPrice = uploadedNetPrice && item.isFurniture() && canRequestNetPrice && enabler.isEnabled('enable_net_price');
                this.message.setItem(item);
                if (!showingUploadedNetPrice) {
                    if (copyText.get('hardcodedTextBody', { passthrough: false })) {
                        this.message.set('textBody', copyText.get('hardcodedTextBody'));
                    } else if (item.isPriceHidden()) {
                        this.message.set('textBody', copyText.get('pretextPur'));
                    }
                }
                this.message.set('subject', contactHelpers.constructItemSubject({
                    prefix: copyText.get('subjectItem'),
                    item: item
                }));
            } else if (seller) {
                this.message.setSeller(seller);
                this.message.set('subject', copyText.get('subjectDealer'));
            }
            this.emitChange();
        }
    }, {
        key: 'editField',
        value: function editField(payload) {
            this.message.set(payload.field, payload.value);
            this.emitChange();
        }
    }, {
        key: 'editOptIn',
        value: function editOptIn(payload) {
            var from = this.message.get('from');
            if (from) {
                from.setDiscloseEmail(payload.isOptIn);
            }
            this.emitChange();
        }
    }, {
        key: 'userAuth',
        value: function userAuth(payload) {
            this.message.set('from.user', payload.user);
            this.emitChange();
        }
    }, {
        key: 'prepareToSend',
        value: function prepareToSend() {
            var isUserToUser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!isUserToUser) {
                if (this.message.get('from.user.id')) {
                    return;
                }
                var userId = User.getUserId(true);
                if (userId) {
                    this.message.set('from.user.id', userId);
                }
            }
        }
    }]);

    return ContactMessageStore;
}(BaseStore);

ContactMessageStore.storeName = 'ContactMessageStore';
ContactMessageStore.handlers = {
    'contact:loading:start': 'reset',
    'contact:message:fieldEdited': 'editField',
    'contact:loading:done': 'doneLoading',
    'contact:optIn:edited': 'editOptIn',
    'contact:auth:done': 'userAuth',
    'contact:sending:start': 'prepareToSend'
};

module.exports = ContactMessageStore;

/***/ }),
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var processNextTick = __webpack_require__(297);
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(265);
util.inherits = __webpack_require__(50);
/*</replacement>*/

var Readable = __webpack_require__(350);
var Writable = __webpack_require__(300);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Item = __webpack_require__(34);
var Seller = __webpack_require__(101);
var User = __webpack_require__(28);
var AnchorLists = __webpack_require__(117);
var Conversation = __webpack_require__(131);
var Deferred = __webpack_require__(29).Deferred;

module.exports = {
    loadItem: function loadItem(itemPk) {
        var item = new Item({ id: itemPk });
        return item.fetch({ data: { fields: 'full,sellerInfo,key' } }).then(function () {
            return {
                item: item,
                seller: item.get('seller')
            };
        });
    },
    loadSeller: function loadSeller(sellerPk, preloadedSeller) {
        if (preloadedSeller) {
            return Deferred().resolve({ seller: preloadedSeller });
        }
        var seller = new Seller({ id: sellerPk });
        return seller.fetch({ data: { fields: Seller.FIELD_PREFERENCE } }).then(function () {
            return { seller: seller };
        });
    },


    /**
     * returns {Object} Deferred resolving to user model if user is authenticated
     */
    loadUser: function loadUser() {
        // note: User.gotCurrentUser will return a user model with id='me' if none was found
        return User.gotCurrentUser().then(function (user) {
            return (/\d/.test(user.id) ? user : null
            );
        });
    },


    // save inserted name to user's profile if they don't already have one set
    saveName: function saveName(options) {
        var userProfile = options.userProfile,
            fullName = options.fullName;

        if (!userProfile.get('firstName') && !userProfile.get('lastName')) {
            return userProfile.setDisplayName(fullName).save();
        }
        return Deferred().resolve();
    },


    /**
     * returns {Object} Deferred resolving to true if the user is able to opt in to
     * sharing their email address
     */
    checkEmailOptIn: function checkEmailOptIn(options) {
        var dealerId = options.dealerId,
            itemId = options.itemId;

        var anchorLists = new AnchorLists();
        var conversation = new Conversation();
        return anchorLists.fetchSellerOnList(dealerId, AnchorLists.listNames.OPOP, 'SELLER_POLICY').then(function () {
            // do not show opt in if dealer is on new policy
            if (anchorLists.length > 0) {
                return false;
            }
            if (!User.getUserId()) {
                // buyer is logged out -- will not check conversation history
                return true;
            }
            // general inquiry
            if (!itemId) {
                return true;
            }
            return conversation.fetchConversationForBuyerAndItem({
                buyerId: User.getUserId(),
                itemId: itemId
            }).then(
            // conversation exists between this buyer/item - user cannot opt in
            function () {
                return false;
            },
            // if conversation is not found - user can opt in
            function (response) {
                return Deferred().resolve(response.status === 404);
            });
        }, function () {
            return Deferred().resolve(false);
        });
    },
    constructItemSubject: function constructItemSubject(options) {
        var prefix = options.prefix,
            item = options.item;

        return [prefix, item.get('title'), item.get('dibsReference')].join(' - ');
    }
};

/***/ }),
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var PrivateTransaction = __webpack_require__(231);
var TransactionValidator = __webpack_require__(127);
var Party = __webpack_require__(8);

var ContactTransactionStore = function (_BaseStore) {
    _inherits(ContactTransactionStore, _BaseStore);

    function ContactTransactionStore() {
        _classCallCheck(this, ContactTransactionStore);

        return _possibleConstructorReturn(this, (ContactTransactionStore.__proto__ || Object.getPrototypeOf(ContactTransactionStore)).apply(this, arguments));
    }

    _createClass(ContactTransactionStore, [{
        key: 'doneLoading',
        value: function doneLoading(payload) {
            var user = payload.user,
                item = payload.item;

            if (!item) {
                return;
            }
            this.transaction = new PrivateTransaction({
                buyer: user,
                seller: item.get('seller'),
                item: item
            });
            this.offer = this.transaction.get('offers[0]');
            if (user) {
                this.offer.set('amountPerItem.currency', user.get('profile.currency'));
            } else {
                this.offer.set('initiatingParty', new Party({ role: Party.ROLE_BUYER }));
                this.offer.set('amountPerItem.currency', this.dispatcher.getStore('UserStore').getCurrency());
            }
            this.emitChange();
        }
    }, {
        key: 'editOffer',
        value: function editOffer(payload) {
            this.offer.set(payload.field, payload.value);
            this.emitChange();
        }
    }, {
        key: 'userAuth',
        value: function userAuth(_ref) {
            var user = _ref.user,
                _ref$isTransaction = _ref.isTransaction,
                isTransaction = _ref$isTransaction === undefined ? true : _ref$isTransaction;

            if (!this.transaction) {
                return;
            }
            if (isTransaction) {
                this.transaction.set('buyer', user);
                this.emitChange();
            }
        }
    }, {
        key: 'prepareToSave',
        value: function prepareToSave() {
            if (!this.transaction) {
                return;
            }
            this.offer.set('amountPerItem.amount', new TransactionValidator().parseOffer(this.transaction) + '');
            this.transaction.prepareToSaveBuyer();
        }
    }]);

    return ContactTransactionStore;
}(BaseStore);

ContactTransactionStore.storeName = 'ContactTransactionStore';
ContactTransactionStore.handlers = {
    'contact:loading:done': 'doneLoading',
    'contact:offer:fieldEdited': 'editOffer',
    'contact:auth:done': 'userAuth',
    'contact:form:offer:valid': 'prepareToSave',
    'pdp:contact:loading:done': 'doneLoading'
};

module.exports = ContactTransactionStore;

/***/ }),
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 7/27/15.
 */



var _CartStore$handlers;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var ProxiedCartCollection = __webpack_require__(144);
var CartPortfolioModel = __webpack_require__(289);
var enabler = __webpack_require__(63);
var User = __webpack_require__(15);
var chatUtils = __webpack_require__(268);
var currencyActionConstants = __webpack_require__(287);

var MAX_CART_COUNT = 9;

var CartStore = function (_BaseStore) {
    _inherits(CartStore, _BaseStore);

    function CartStore(dispatcher) {
        _classCallCheck(this, CartStore);

        var _this = _possibleConstructorReturn(this, (CartStore.__proto__ || Object.getPrototypeOf(CartStore)).call(this, dispatcher));

        _this._errorMessage = null;
        /*  This should maybe be moved to an action for server-side rendering since it makes use of User */
        _this._cartItems = ProxiedCartCollection.getCartCollection();
        _this._recentItems = [];
        _this._portfolioModel = new CartPortfolioModel();
        _this._currency = 'USD';
        _this._isDisplayingNotification = false;

        /*
         Listen to any events on the backbone model. This could potentially cause
         a memory leak if these events never get unregistered, so might need to revisit this
          TODO:  make this an action that registers this event handler
         this will cause a memory leak if this store is used for server-side rendering
         */
        _this._cartItems.on('reset', function () {
            return _this._onCartUpdated();
        });
        _this._cartItems.on('sync', function () {
            return _this._onCartUpdated();
        });

        return _this;
    }

    _createClass(CartStore, [{
        key: 'isNotificationVisible',
        value: function isNotificationVisible() {
            return this._isDisplayingNotification;
        }

        /**
         * Returns the URL for the cart. This is a constant value for now.
         * @returns {string}
         */

    }, {
        key: 'getCartUrl',
        value: function getCartUrl() {
            return '/my/cart/';
        }
        /**
         * Returns the URL for checkout of an item.
         * @param {Item} item
         * @returns {string}
         */

    }, {
        key: 'getCheckoutUrl',
        value: function getCheckoutUrl(item) {
            return '/checkout' + item.getPDPURL(false);
        }
    }, {
        key: 'getCurrency',
        value: function getCurrency() {
            return this._currency;
        }

        /**
         * Returns the ProxiedCartCollection model for the cart.
         * @returns {*}
         */

    }, {
        key: 'getItemsCollection',
        value: function getItemsCollection() {
            return this._cartItems;
        }
    }, {
        key: 'getItemAtIndex',
        value: function getItemAtIndex(index) {
            return this.getItemsCollection().at(index);
        }
    }, {
        key: 'getItemById',
        value: function getItemById(id) {
            return this.getItemsCollection().findWhere({ 'item.id': id });
        }

        /**
         * Returns either a list of item models in the cart, or the recently added items,
         * depending on whether the cart is in notification state or not.
         * @returns {*}
         */

    }, {
        key: 'getItemsInMenu',
        value: function getItemsInMenu() {
            if (this._isDisplayingNotification) {
                return this._recentItems;
            } else {
                /*  Return the models sorted by create date, since in the hover menu
                 we want to show them that way but any new item that gets added goes to the end of
                 the list, screwing up the order if we already had items loaded from the fetch
                 */
                return this._cartItems.models.map(function (m) {
                    return m;
                }) // so we don't sort the original collection
                .sort(function (a, b) {
                    var date1 = a.get('createdDate');
                    var date2 = b.get('createdDate');
                    if (date1 > date2) {
                        return -1;
                    } else if (date1 < date2) {
                        return 1;
                    } else {
                        return 0;
                    }
                }).map(function (m) {
                    return m.get('item');
                });
            }
        }

        /**
         * Returns a PortfolioModel representing the items in the cart. This gets passed to
         * an ItemsView from CartWrapperView.
         * @returns {PortfolioModel|exports|module.exports|*}
         */

    }, {
        key: 'getPortfolioModel',
        value: function getPortfolioModel() {
            return this._portfolioModel;
        }

        /**
         * Returns the number of items in the cart.
         * @returns {*}
         */

    }, {
        key: 'getItemCount',
        value: function getItemCount() {
            return this._cartItems.length;
        }

        /**
         * Returns the number of items in the cart, or "<Max_Cart_Count>" if it's greater than that value
         * @returns {*}
         */

    }, {
        key: 'getItemCountFormatted',
        value: function getItemCountFormatted() {
            var length = this.getItemCount() || 0;
            return length > MAX_CART_COUNT ? MAX_CART_COUNT : length;
        }
    }, {
        key: 'getItemBeingUpdated',
        value: function getItemBeingUpdated() {
            return this._updatingItem;
        }

        /**
         * Returns a boolean if the user is a trade user
         * @returns {boolean}
         */

    }, {
        key: 'isTradeUser',
        value: function isTradeUser() {
            return User.loggedIn() && User.canRequestNetPrice() && enabler.isEnabled('enable_net_price');
        }

        /**
         * Returns true if the item is in the cart.
         * @param item {Backbone.Model} The item to check.
         * @returns {boolean}
         */

    }, {
        key: 'isItemInCart',
        value: function isItemInCart(item) {
            return this._cartItems.findWhere({ 'item.id': item.get('id') }) ? true : false;
        }

        /**
         * Handler for errors when performing cart actions
         * @param payload
         * @param payload.message {String} The error message
         */

    }, {
        key: 'onCartError',
        value: function onCartError(payload) {
            var message = payload.message;

            this._errorMessage = message;
            this._cartItems.trigger('cart:error', this._errorMessage);
            this.emitChange();
        }
    }, {
        key: 'onCartPortfolioLoaded',
        value: function onCartPortfolioLoaded(payload) {
            var itemCount = payload.itemCount;

            this._errorMessage = null;
            this._portfolioModel.set('itemCount', itemCount);
            this._cartItems.trigger('cart:loaded');
            this.emitChange();
        }
    }, {
        key: 'onItemAdded',
        value: function onItemAdded(payload) {
            var item = payload.item;

            this._cartItems.add(item);
            this._updateItemCount();

            this._cartItems.trigger('cart:itemAdded', { item: item });
            this.emitChange();
        }
    }, {
        key: 'onItemRemoved',
        value: function onItemRemoved(payload) {
            var item = payload.item;

            this._cartItems.remove(item);
            this._updateItemCount();

            this._cartItems.trigger('cart:itemRemoved', { item: item });
            this.emitChange();
        }
    }, {
        key: 'onItemRemovedAtIndex',
        value: function onItemRemovedAtIndex(payload) {
            var index = payload.index;

            var item = this._cartItems.at(index);
            this.onItemRemoved({ item: item });
        }
    }, {
        key: 'onCurrencyChanged',
        value: function onCurrencyChanged(payload) {
            var currency = payload.currency;

            this._currency = currency.toLowerCase();
            this.emitChange();
        }
    }, {
        key: 'onItemUpdating',
        value: function onItemUpdating(payload) {
            var item = payload.item;

            this._updatingItem = item;
            this.emitChange();
        }
    }, {
        key: 'onItemUpdated',
        value: function onItemUpdated() {
            this._updatingItem = null;
            this.emitChange();
        }
    }, {
        key: 'onItemUpdateFailed',
        value: function onItemUpdateFailed(payload) {
            this.onCartError({ message: payload.err });
        }
    }, {
        key: 'onShowNotification',
        value: function onShowNotification(payload) {
            var items = payload.items;

            this._isDisplayingNotification = true;
            this._recentItems = items;
            this.emitChange();
        }
    }, {
        key: 'onHideNotification',
        value: function onHideNotification() {
            this._isDisplayingNotification = false;
            this._recentItems = [];
            this.emitChange();
        }

        /**
         * Currently, the only function of this method is to trigger a change notification when the
         * backbone model is updated, so no payload is required.
         */

    }, {
        key: '_onCartUpdated',
        value: function _onCartUpdated() {
            this._updateItemCount();
            var itemCount = this.getItemCount();
            chatUtils.customAttribute.itemsInCart(itemCount);

            this.emitChange();
        }
    }, {
        key: '_updateItemCount',
        value: function _updateItemCount() {
            var itemCount = this.getItemCount();
            this._portfolioModel.set('itemCount', itemCount);
        }
    }]);

    return CartStore;
}(BaseStore);

CartStore.storeName = 'CartStore';

CartStore.handlers = (_CartStore$handlers = {
    'cart:itemAdded': 'onItemAdded',
    'cart:itemRemoved': 'onItemRemoved',
    'cart:itemRemoved:error': 'onCartError',
    'cart:portfolio:loaded': 'onCartPortfolioLoaded',
    'cart:portfolio:error': 'onCartError',
    'cart:notification:show': 'onShowNotification',
    'cart:notification:hide': 'onHideNotification'
}, _defineProperty(_CartStore$handlers, currencyActionConstants.CURRENCY_CHANGED, 'onCurrencyChanged'), _defineProperty(_CartStore$handlers, 'item:update:start', 'onItemUpdating'), _defineProperty(_CartStore$handlers, 'item:update:done', 'onItemUpdated'), _defineProperty(_CartStore$handlers, 'item:update:failed', 'onItemUpdateFailed'), _CartStore$handlers);

module.exports = CartStore;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseCallback = __webpack_require__(303),
    baseFor = __webpack_require__(128),
    keys = __webpack_require__(294);

/**
 * The base implementation of `_.forOwn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return baseFor(object, iteratee, keys);
}

/**
 * Creates a function for `_.mapKeys` or `_.mapValues`.
 *
 * @private
 * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
 * @returns {Function} Returns the new map function.
 */
function createObjectMapper(isMapKeys) {
  return function(object, iteratee, thisArg) {
    var result = {};
    iteratee = baseCallback(iteratee, thisArg, 3);

    baseForOwn(object, function(value, key, object) {
      var mapped = iteratee(value, key, object);
      key = isMapKeys ? mapped : key;
      value = isMapKeys ? value : mapped;
      result[key] = value;
    });
    return result;
  };
}

/**
 * Creates an object with the same keys as `object` and values generated by
 * running each own enumerable property of `object` through `iteratee`. The
 * iteratee function is bound to `thisArg` and invoked with three arguments:
 * (value, key, object).
 *
 * If a property name is provided for `iteratee` the created `_.property`
 * style callback returns the property value of the given element.
 *
 * If a value is also provided for `thisArg` the created `_.matchesProperty`
 * style callback returns `true` for elements that have a matching property
 * value, else `false`.
 *
 * If an object is provided for `iteratee` the created `_.matches` style
 * callback returns `true` for elements that have the properties of the given
 * object, else `false`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
 *  per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Object} Returns the new mapped object.
 * @example
 *
 * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
 *   return n * 3;
 * });
 * // => { 'a': 3, 'b': 6 }
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * // using the `_.property` callback shorthand
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
var mapValues = createObjectMapper();

module.exports = mapValues;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var assign = __webpack_require__(60);
var forEach = __webpack_require__(59);
var isArray = __webpack_require__(64);
var omit = __webpack_require__(95);
var reduce = __webpack_require__(332);
var globaleval = eval; // eval called indirectly evaluates globally in es5+
var result = __webpack_require__(70);
var coreB3ndings = __webpack_require__(151);
var boundaryKey = '__b3nd-boundary';
var root = typeof global !== 'undefined' ? global : window;
var matches = __webpack_require__(38);
var iterateB3ndings = function (view, model, cb) {
    var boundElementSelector = "[data-model-bind]";
    var modelObj = result(model, 'toJSON');
    var stateObj = result(view.state, 'toJSON');
    var boundElements;
    var b3ndResult;
    var scopeObj;
    scopeObj = {
        testing: 'thomashallock',
        b3ndResult: undefined,
        view: view,
        state: stateObj,
        model: modelObj,
        computed: view.computeds && reduce(result(view, 'computeds'), function (memo, computed, key) {
            if (!(computed instanceof Function)) {
                computed = view[key];
            }
            memo[key] = computed.call(view, modelObj);
            return memo;
        }, {})
    };
    view.el[boundaryKey] = true; // prevents bound parent views from messing with us
    boundElements = Array.prototype.slice.call(view.el.querySelectorAll(boundElementSelector));
    if (matches(view.el, boundElementSelector)) {
        boundElements = [view.el].concat(boundElements);
    }
    boundElements.filter(function (el) {
        // filter out any elements that are on the other side of a b3nding boundary
        while (el && el !== view.el) {
            if (el[boundaryKey]) {
                return false;
            }
            el = el.parentNode;
        }
        return true;
    }).forEach(function (el) {
        var priorGlobalValues = {};
        var restoreGlobals = function () {
          forEach(priorGlobalValues, function (globalVarValue, globalVarName) {
              global[globalVarName] = priorGlobalValues[globalVarName];
          });
        };
        forEach(scopeObj, function (globalVarValue, globalVarName) {
            priorGlobalValues[globalVarName] = global[globalVarName];
            global[globalVarName] = globalVarValue;
        });
        try {
            b3ndResult = globaleval("({" + el.getAttribute('data-model-bind') + "});");
        } catch (e) {
            restoreGlobals();
            throw new EvalError("syntax error in b3nding: " + el.getAttribute('data-model-bind') + " : " + e.fileName + ":" + e.lineNumber + ": " + e.message);
        }
        restoreGlobals();
        forEach(b3ndResult, function (b3ndingValue, b3ndingName) {
            if (!this.b3ndings[b3ndingName]) {
                console.warn('undefined b3nding: ' + b3ndingName);
                return;
            }
            cb.call(view, this.b3ndings[b3ndingName], el, b3ndingValue);
        }, this);
    }.bind(this));
};

var initB3ndings = function (options) {
    iterateB3ndings.call(this, this.view, this.model, function (b3nding, el, value) {
        if (b3nding.init) {
            b3nding.init.call(el, value, this.model, this.view, options);
        }
    }.bind(this));
};
var updateB3ndings = function (view, model, options) {
    iterateB3ndings.call(this, view, model, function (b3nding, el, value) {
        if (b3nding.update) {
            b3nding.update.call(el, value, model, view, options);
        }
    });
};
var B3nd;
var B3ndContext;
B3ndContext = function () {};
B3ndContext.prototype = {
    on: function () {
        if (this.model) {
            this.model.on('change', this.forceUpdate, this);
        }
        if (this.options.nested) {
            this.model.on('nested-change', this.forceUpdate, this);
        }
        if (this.view.state) {
            this.view.state.on('change', this.forceUpdate, this);
        }
    },
    off: function () {
        if (this.model) {
            this.model.off('change', this.forceUpdate, this);
        }
        if (this.options.nested) {
            this.model.off('nested-change', this.forceUpdate, this);
        }
        if (this.view.state) {
            this.view.state.off('change', this.forceUpdate, this);
        }
    },
    forceUpdate: function () {
        B3nd._updateB3ndings.call(this, this.view, this.model);
    }
};

/**
 * signature:
 *   b3nd(view[, model][, options]); // context is not a Backbone.View
 *   view.b3nd([model][, options]); // context is a Backbone.View
 * @param model (required) - The model to which the view will be bound.
 * @param view (required) -  The view with the elements that will be bound to the model.
 */
B3nd = module.exports = function () {
    var options = {};
    var args = Array.prototype.slice.apply(arguments);
    var b3nd = new B3ndContext();
    if (result(this, 'el')) { // if it's a backbone view
        b3nd.view = this;
    } else {
        b3nd.view = args.shift();
    }
    b3nd.model = args.pop();
    if (b3nd.model) {
        if (!b3nd.model.toJSON) { // if it's not a backbone model
            options = b3nd.model || {};
            b3nd.model = args.pop();
        }
    }
    if (!b3nd.model) {
        b3nd.model = b3nd.view.model;
    }
    options = assign({
        using : [], // additional b3ndings
        nested : false
    }, options);
    if (!isArray(options.using)) {
        options.using = [options.using];
    }
    // finished parsing args
    options.using = options.using.concat(coreB3ndings);
    b3nd.b3ndings = options.using.reduce(function (b3ndings, b3nding) {
        b3ndings[b3nding.name] = b3nding;
        return b3ndings;
    }, {});
    b3nd.options = omit(options, 'using');
    initB3ndings.call(b3nd, b3nd.options);
    b3nd.on();
    b3nd.forceUpdate();
    return b3nd;
};
module.exports._updateB3ndings = updateB3ndings; // exported for test spec

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var Qs = __webpack_require__(42);
var result = __webpack_require__(70);
var pick = __webpack_require__(65);
var tracking = __webpack_require__(27);

var yesNo = function yesNo(predicate) {
    return predicate ? 'y' : 'n';
};
var SV = __webpack_require__(17);

var ContactGaStore = function (_BaseStore) {
    _inherits(ContactGaStore, _BaseStore);

    function ContactGaStore(dispatcher) {
        _classCallCheck(this, ContactGaStore);

        var _this = _possibleConstructorReturn(this, (ContactGaStore.__proto__ || Object.getPrototypeOf(ContactGaStore)).call(this, dispatcher));

        _this._reset();
        return _this;
    }

    _createClass(ContactGaStore, [{
        key: 'initialLoad',
        value: function initialLoad(_ref) {
            var linkLocation = _ref.linkLocation;

            this.data.linkLocation = linkLocation;
        }
    }, {
        key: 'constructVpvParams',
        value: function constructVpvParams(_ref2) {
            var item = _ref2.item,
                seller = _ref2.seller;

            this.data.vpvParams = {
                dd: seller.get('id'),
                dn: seller.get('sellerProfile.company')
            };
            this.data.purchaseStatus = '';
            if (item) {
                this.data.item = item;
                this.data.isItem = true;
                var hasPreQuoteShipping = false;
                if (item.get('shipmentQuotes')) {
                    hasPreQuoteShipping = item.get('shipmentQuotes').getNonLocalShipmentQuotes().length;
                }
                Object.assign(this.data.vpvParams, {
                    id: item.get('id'),
                    status: this._getStatus(item),
                    pur: yesNo(item.canMakePurchase()),
                    neg: yesNo(item.isNegotiablePrice()),
                    ship: yesNo(hasPreQuoteShipping),
                    ret: yesNo(result(item.get('returnPolicy'), 'acceptsReturns'))
                });
                this.data.purchaseStatus = Qs.stringify(pick(this.data.vpvParams, 'neg', 'ship', 'ret'), {
                    delimiter: '|'
                });
            }
            this.data.vpvParamsQuery = decodeURIComponent(Qs.stringify(this.data.vpvParams).toLowerCase());
        }
    }, {
        key: '_getStatus',
        value: function _getStatus(item) {
            var seller = item.get('seller');
            var status = 'Available-Price';
            if (seller.isStatusSuspended() || item.isItemDeleted()) {
                status = 'Suspended';
            } else if (item.isOnHold()) {
                status = 'Hold';
            } else if (item.isSold()) {
                status = 'Sold';
            } else if (item.hidingPrice()) {
                status = 'Available-No Price';
            }
            return 'PDP-' + status;
        }
    }, {
        key: '_reset',
        value: function _reset() {
            this.data = {};
        }
    }, {
        key: 'resetPage',
        value: function resetPage() {
            return tracking.addGTMMessage({
                pageType: SV.get('tracking.initialDataLayerInfo.pageType'),
                pageSubType: SV.get('tracking.initialDataLayerInfo.pageSubType')
            });
        }
    }]);

    return ContactGaStore;
}(BaseStore);

ContactGaStore.storeName = 'ContactGaStore';
ContactGaStore.handlers = {
    'contact:loading:start': 'initialLoad',
    'contact:loading:done': 'constructVpvParams',
    'contact:modal:close': 'resetPage'
};

module.exports = ContactGaStore;

/***/ }),
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 113 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Common valiation regular expressions such as email, string, etc.
 */
var specialChars = /^[^!@#$%^&*()+=><?]*$/;
var _rules = {
    email : /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, // http://www.w3.org/TR/html5/forms.html%23valid-e-mail-address
    password : /^.{5,128}$/,
    special_characters : specialChars,
    name: specialChars,
    digits: /\d/,
    numeric : /^[0-9]*$/,
    floating : /^[0-9\.]*$/,
    greater_than_one : /^[1-9][0-9]*$/,
    url : /^((http(?:s)?\:\/\/|)[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*\.[a-zA-Z]{2,6}(?:\/?|(?:\/[\w\-]+)*)(?:\/?|\/\w+\.[a-zA-Z]{2,4}(?:\?[\w]+\=[\w\-]+)?)?(?:\&[\w]+\=[\w\-]+)*)$/,
    price : /^(?=.*[1-9])\d*(?:(\.|\,)\d{1,2})?$/,
    itemPrice : /^[1-9]\d{0,2}(?:,?\d{3})*(?:\.\d{1,2})?$/,
    // Note* Month/Year pattern accepts either 2 or 4 digits for the year, and
    month_year : /^[0-9]{1}[1-2]{1}\s?\/\s?[0-9]{2}([0-9]{2})?$/,
    measurement : /^-?(?=.*[1-9])(\d*)(\.\d+)?$/,
    // currency string optionally delimited by commas without decimal amount
    currencyString: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*?$/,
    // currency string optionally delimited by periods without decimal amount
    currencyStringEur: /^[+-]?[0-9]{1,3}(?:\.?[0-9]{3})*?$/,
    notAllCaps : function (val) {
        val = val.replace(/[^A-Za-z]+/g, '');
        var re = /[a-z]/;
        if (val === '') {
            return true;
        }
        return re.test(val);
    }
};

module.exports = _rules;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var fieldRegex  = /\[\d+\]/g;
var ErrorList = __webpack_require__(200);
var FieldValidation = __webpack_require__(74);
var DEFAULT_MESSAGE = 'Please correct this value : ';
var DEFAULTREQUIREDMESSAGE = 'This field is required';
var getDeferredMethods = __webpack_require__(295);
var assert = __webpack_require__(31);

var when = getDeferredMethods().when;

/**
 * @class Validator
 *
 * Validator Class constructor follows backbone JS style inheritance. An instance of validator class *requires that you
 * specify a modelConstructor, and a validationRules set. You may also add an initialize method, and of course, any
 * other public and private methods you choose to add.
 *
 *
 * Default methods / properties :
 *      - initialize - function
 *      - fieldValidations - object | function **
 *      - modelConstructor - constructor function
 *      - validate - function ***
 *
 * @property {string} EVENT_WILL_VALIDATE_FIELD validator:willValidateField
 * @property {string} EVENT_FIELD_PASSED_VALIDATION validator:fieldPassedValidation
 * @property {string} EVENT_FIELD_FAILED_VALIDATION validator:fieldFailedValidation
 * @property {string} EVENT_FIELD_FIXED_VALIDATION validator:fieldFixedValidation
 *
 * @example
 * // ** fieldValidations may be an object with the validation rules in the expected format, OR a function that returns such
 * // a rules set. Validator rules follow this format :
 *      {
 *          // each value must be {@link FieldValidation} or
 *          // extension instance
 *          key : new FieldValidation({
 *              field: 'foo', // model attribute key
 *              required: true, // make this field required
 *              fieldDisplayName: 'Foo', // combined with rule messageBody values to make a message ('"Foo" field must be bar')
 *              additionalRules: {  // Specify an object of additional rules not defined by the FieldValidation class
 *                  bar: new FieldRule({
 *                      messageBody: 'must be bar',
 *                      validate: function (model, value, fieldName) {
  *                         return value === 'bar';
  *                     }
 *                  })
 *              }
 *          })
 *      }
 *
 * @example
 * // *** By default the validate function invokes the validation logic. If you want to over-ride the validation function
 * // to do some setup then you should invoke the parent's validation method like so :
 * var EntityValidator = Validator.extend({
 *      validate : function (options) {
 *          // do something...
 *          return EntityValidator.__super__.validate.apply(this, arguments);
 *      }
 * });
 *
 *
 */
var Validator = function () {
    var self = this;
    /**
     * @memberOf Validator#
     * @private
     */
    this._childValidators = {};

    this.initialize.apply(this, arguments);
    when(this.getReadyPromise()).done(function () {
        /**
         * @memberOf Validator#
         * @type {boolean}
         * @private
         */
        self._isReady = true;
    });
};

Validator.EVENT_WILL_VALIDATE_FIELD = 'validator:willValidateField';
Validator.EVENT_FIELD_PASSED_VALIDATION = 'validator:fieldPassedValidation';
Validator.EVENT_FIELD_FAILED_VALIDATION = 'validator:fieldFailedValidation';
Validator.EVENT_FIELD_FIXED_VALIDATION = 'validator:fieldFixedValidation';

Validator.events = [
    Validator.EVENT_WILL_VALIDATE_FIELD, Validator.EVENT_FIELD_PASSED_VALIDATION,
    Validator.EVENT_FIELD_FAILED_VALIDATION, Validator.EVENT_FIELD_FIXED_VALIDATION
];

/**
 * Return true if the field contains a generic
 * collection index.
 * @public
 * @param {string} modelFieldName
 * @returns {boolean}
 */
Validator.isGenericFieldName = function (modelFieldName) {
    return modelFieldName.indexOf('[*]') > -1;
};

/**
 * Replace specific collection indicies with the
 * 'generic' index symbol '[*]'
 * @public
 * @param {string} modelFieldName
 * @returns {string}
 */
Validator.getGenericFieldName = function (modelFieldName) {
    return modelFieldName.replace(fieldRegex, '[*]');
};

/**
 * Return true if a field name has a specific collection
 * index (e.g. foo.bar[1].bam)
 * @public
 * @param {string} modelFieldName
 * @returns {boolean}
 */
Validator.hasCollectionIndex = function (modelFieldName) {
    return fieldRegex.test(modelFieldName);
};

Validator.prototype.initialize = function () {
    this.on(Validator.EVENT_WILL_VALIDATE_FIELD, this.onWillValidateField, this);
    this.on(Validator.EVENT_FIELD_PASSED_VALIDATION, this.onFieldPassed, this);
    this.on(Validator.EVENT_FIELD_FAILED_VALIDATION, this.onFieldFailed, this);
    this.on(Validator.EVENT_FIELD_FIXED_VALIDATION, this.onFieldFixed, this);
};

Validator.prototype.validationRules = null;

Validator.prototype.modelConstructor = null;

Validator.prototype.deferToChildValidators = true;

/**
 * Override this in an extension and
 * return a deferred promise if you want
 * to delay validation.
 * @public
 * @returns {null}
 */
Validator.prototype.getReadyPromise = function () {
    return null;
};

/**
 * @param {function} callback
 * @param {object} [context]
 * @public
 * @returns {Validator}
 */
Validator.prototype.onReady = function (callback, context) {
    when(this.getReadyPromise()).done(function () {
        callback.call(context);
    });
    return this;
};

/**
 * @param {function} callback
 * @param {object} [context]
 * @public
 * @returns {Validator}
 */
Validator.prototype.onReadyFailure = function (callback, context) {
    when(this.getReadyPromise()).fail(function () {
        callback.apply(context, arguments);
    });
    return this;
};

/**
 * @public
 * @returns {boolean}
 */
Validator.prototype.isReady = function () {
    //var readyProm = this.getReadyPromise();
    //return !readyProm || readyProm.state() === 'resolved';
    return !!this._isReady;
};

/**
 * @param {FieldValidation} fieldValidation
 * @returns {Object}
 */
Validator.prototype.getSchemaForField = function (fieldValidation) {
    return fieldValidation.outputSchema();
};

/**
 * Method to generate the full schema for a Validator. If your validator returns different schema
 * based on the values of a model, override this method so that documentation can be generated
 * @returns {Object}
 */
Validator.prototype.getFullSchema = function () {
    return { default: _.result(this, 'fieldValidations') };
};

/**
 * Add a "child" validator. The child validator can be used in
 * CollectionFieldValidation field validations or as a way to
 * delegate validation for a particular related model to another
 * validator. For example, if you have a "shipmentQuotes" child
 * validator to a parent validator, validating shipmentQuotes[0].foo
 * on the parent validator will simply defer to the child by
 * validating "foo" field with the first model in the shipment quotes
 * collection.
 * @public
 * @param {string} key
 *      A matching field name for a relation on the model
 * @param {Validator} childValidator
 */
Validator.prototype.setChildValidatorForKey = function (key, childValidator) {
    assert(childValidator instanceof Validator, 'childValidator must be an instance of Validator');
    this._childValidators[key] = childValidator;
    childValidator.parentValidator = this;
};

/**
 * @public
 * @param {string} key
 * @returns {FieldValidation}
 */
Validator.prototype.getChildValidator = function (key) {
    return this._childValidators[key];
};

/**
 * @public
 * @param {string} deferToChildValidators
 * @returns {Validator}
 */
Validator.prototype.setDeferToChildValidators = function (deferToChildValidators) {
    this.deferToChildValidators = deferToChildValidators;
    return this;
};

/**
 * @protected
 * @param {string} key
 */
Validator.prototype.removeChildValidator = function (key) {
    var childValidator = this._childValidators[key];
    if (!childValidator) {
        return;
    }
    childValidator.parentValidator = null;
    delete this._childValidators[key];
};

/**
 * @protected
 * Receives following params
 * - {string} fieldName
 * - {FieldValidation} fieldValidation
 */
Validator.prototype.onWillValidateField = function (fieldName) {
    this._lastValidatedFields.push(fieldName);
};

/**
 * Receives following params
 * - {string} fieldName
 * - {FieldValidation} fieldValidation
 * @protected
 */
Validator.prototype.onFieldPassed = function (fieldName, fieldValidation) {
    var errorIndex;
    this._lastPassedFields.push(fieldName);
    errorIndex = _.indexOf(this._fieldsWithErrors || [], fieldName);
    if (errorIndex > -1) {
        this._fieldsWithErrors.splice(errorIndex, 1);
        this.triggerFixedValidation(fieldName, fieldValidation);
    }
};

/**
 * Receives following params
 * - {string} fieldName
 * - {FieldValidation} fieldValidation
 * - {object[{ field: string, message: string }]} errors
 * @protected
 */
Validator.prototype.onFieldFailed = function (fieldName) {
    this._lastFailedFields.push(fieldName);
    if (_.indexOf(this._fieldsWithErrors, fieldName) < 0) {
        this._fieldsWithErrors.push(fieldName);
    }
};

/**
 * Receives following params
 * - {string} fieldName
 * - {FieldValidation} fieldValidation
 * @protected
 */
Validator.prototype.onFieldFixed = function (fieldName) {
    this._lastFixedFields.push(fieldName);
};

/**
 * Returns a list of the model fields that were
 * validated on the last 'validate' method call
 * @returns {string[]}
 * @public
 */
Validator.prototype.getLastValidatedFields = function () {
    return this._lastValidatedFields;
};

/**
 * Returns a list of the model fields that passed
 * validation on the last 'validate' method call
 * @returns {string[]}
 * @public
 */
Validator.prototype.getLastPassedFields = function () {
    return this._lastPassedFields;
};

/**
 * Returns a list of the model fields that failed
 * validation on the last 'validate' method call
 * @returns {string[]}
 * @public
 */
Validator.prototype.getLastFailedFields = function () {
    return this._lastFailedFields;
};

/**
 * Returns a list of the model fields that were fixed
 * on the last 'validate' method call
 * @returns {string[]}
 * @public
 */
Validator.prototype.getLastFixedFields = function () {
    return this._lastFixedFields;
};

/**
 * @param {string} modelFieldName
 * @returns {boolean}
 */
Validator.prototype.hasCollectionIndex = function (modelFieldName) {
    return Validator.hasCollectionIndex(modelFieldName);
};

/**
 * Return true if the field
 * @public
 * @param modelFieldName
 * @returns {boolean}
 */
Validator.prototype.isGenericFieldName = function (modelFieldName) {
    return Validator.isGenericFieldName(modelFieldName);
};

/**
 * @public
 * @param {string} modelFieldName
 * @returns {string}
 */
Validator.prototype.getGenericFieldName = function (modelFieldName) {
    return Validator.getGenericFieldName(modelFieldName);
};

/**
 * @param {string} genericModelFieldName
 * @returns {boolean}
 * @private
 */
Validator.prototype._genericFieldHasError = function (genericModelFieldName) {
    var i = 0;
    for (i; i < this._fieldsWithErrors.length; i++) {
        if (this.getGenericFieldName(this._fieldsWithErrors[i]) === genericModelFieldName) {
            return true;
        }
    }
    return false;
};

/**
 * If a field has an error, based on result of
 * last "validate" call, return true. Otherwise,
 * return false.
 * @public
 * @param {string} modelFieldName
 * @returns {boolean}
 */
Validator.prototype.fieldHasError = function (modelFieldName) {
    var i = 0;
    if (this.isGenericFieldName(modelFieldName)) {
        return this._genericFieldHasError(modelFieldName);
    }
    for (i; i < this._fieldsWithErrors.length; i++) {
        if (this._fieldsWithErrors[i] === modelFieldName) {
            return true;
        }
    }
    return false;
};

/**
 * Resets the arrays used to track the model fields
 * that were validated and passed or failed validation
 * the last time 'validate' was called.
 * @private
 */
Validator.prototype._resetValidationTrackers = function () {
    if (!this._fieldsWithErrors) {
        this._fieldsWithErrors = [];
    }
    this._lastValidatedFields = [];
    this._lastPassedFields = [];
    this._lastFailedFields = [];
    this._lastFixedFields = [];
    this._childValidatorsFieldBuffers = {};
};

/**
 * @param {string} modelFieldName
 * @param {FieldValidation} fieldValidation
 */
Validator.prototype.triggerWillValidateField = function (modelFieldName, fieldValidation) {
    this.trigger(Validator.EVENT_WILL_VALIDATE_FIELD, modelFieldName, fieldValidation);
};

/**
 * @param {string} modelFieldName
 * @param {FieldValidation} fieldValidation
 */
Validator.prototype.triggerFieldPassed = function (modelFieldName, fieldValidation) {
    this.trigger(Validator.EVENT_FIELD_PASSED_VALIDATION, modelFieldName, fieldValidation);
};

/**
 * @param {string} modelFieldName
 * @param {FieldValidation} fieldValidation
 */
Validator.prototype.triggerFixedValidation = function (modelFieldName, fieldValidation) {
    this.trigger(Validator.EVENT_FIELD_FIXED_VALIDATION, modelFieldName, fieldValidation);
};

/**
 * @param {string} modelFieldName
 * @param {FieldValidation} fieldValidation
 * @param {object[]} errors
 */
Validator.prototype.triggerFieldFailed = function (modelFieldName, fieldValidation, errors) {
    this.trigger(Validator.EVENT_FIELD_FAILED_VALIDATION, modelFieldName, fieldValidation, errors);
};

/**
 * @public
 * @param {string} fieldName The field being validated
 * @returns {string} The matching child validator if there is one
 */
Validator.prototype.fieldMatchesChildValidator = function (fieldName) {
    var children = this._childValidators;
    var childValidatorKey;
    for (childValidatorKey in children) {
        if (children.hasOwnProperty(childValidatorKey)) {
            if (fieldName.indexOf(childValidatorKey) === 0 &&
                    _.indexOf([".", "["], fieldName.charAt(childValidatorKey.length)) > -1) {
                return childValidatorKey;
            }
        }
    }
    return null;
};

/**
 * @param {string} modelFieldName
 * @param {string} childValidatorKey
 * @private
 */
Validator.prototype._shouldValidateFieldWithChildValidator = function (modelFieldName, childValidatorKey) {
    // converts 'foo.bar[1]' into 'foo\.bar\[1\]'
    var regexKeySeg = childValidatorKey.replace(/\[\.\]/g, function (val) {
        return '\\' + val;
    });
    // breaks foo.bar into ['foo.bar', undefined, 'bar'] and foo[0].bar into ['foo[0].bar', '[0]', 'bar']
    var fieldDataRegex = new RegExp('^' + regexKeySeg + '(?:(?:(\\[\\d+\\])\\.)|\\.)(.+)');
    var matches = modelFieldName.match(fieldDataRegex);
    var childValidatorBuffer;
    var modelPath;
    if (matches && matches.length) {
        modelPath = childValidatorKey + (matches[1] || '');
        // We need to know the path to the model, the full field path (including parent model),
        // and the field relative to the model
        if (!this._childValidatorsFieldBuffers[modelPath]) {
            this._childValidatorsFieldBuffers[modelPath] = {
                childValidatorKey: childValidatorKey,
                fields: [],
                fullFieldPaths: []
            };
        }
        childValidatorBuffer = this._childValidatorsFieldBuffers[modelPath];
        childValidatorBuffer.fields.push(matches[2]);
        childValidatorBuffer.fullFieldPaths.push(modelFieldName);
    }
};

/**
 * @param {ErrorList} errorsList
 * @private
 */
Validator.prototype._validateChildValidatorFields = function (errorsList) {
    _.each(this._childValidatorsFieldBuffers, function (buffer, pathToModel) {
        var validator = this.getChildValidator(buffer.childValidatorKey);
        var childValidatorOut;
        var childModel = pathToModel ? this.model.get(pathToModel) : this.model;
        var i = 0;
        var err;
        this._matchChildValidatorEvents(pathToModel);
        childValidatorOut = validator.validate(childModel, { fields: buffer.fields });
        this._matchChildValidatorEvents(pathToModel, true);
        for (i; i < childValidatorOut.errors.length; i++) {
            err = childValidatorOut.errors[i];
            errorsList.add(buffer.fullFieldPaths[_.indexOf(buffer.fields, err.field)], err.message, err.rule);
        }
    }, this);
    return errorsList;
};

/**
 * Set up / removes events on the validator instance that
 * mirror the same events on child validators.
 * @param {string} pathToModel
 * @param {boolean} [removeEvents=false]
 * @private
 */
Validator.prototype._matchChildValidatorEvents = function (pathToModel, removeEvents) {
    var self = this;
    var fieldPrefix = pathToModel ? pathToModel + '.' : '';
    var events = Validator.events;
    var getCallback = function (event) {
        return function () {
            arguments[0] = fieldPrefix + arguments[0];
            self.trigger.apply(self, [event].concat(_.toArray(arguments)));
        };
    };
    _.each(self._childValidators, function (childValidator) {
        var i = 0;
        for (i; i < events.length; i++) {
            childValidator.off(events[i], null, self);
            if (!removeEvents) {
                childValidator.on(events[i], getCallback(events[i]), self);
            }
        }
    });
};


/**
 * @param {boolean} requireNone
 * @protected
 */
Validator.prototype.setRequireNone = function (requireNone) {
    this._requireNone = requireNone;
    this._setChildrenRequireNone(requireNone);
};

/**
 * @param {boolean} requireNone
 * @private
 */
Validator.prototype._setChildrenRequireNone = function (requireNone) {
    _.each(this._childValidators, function (validator) {
        validator.setRequireNone(requireNone);
    });
};

/**
 * Extend the Validator class like you would a Backbone.Model
 * @function
 * @memberOf Validator
 * @param {object} [instanceProperties]
 * @param {object} [staticProperties]
 * @returns {function(new:Validator)} A new Validator constructor
 */
Validator.extend = Backbone.Model.extend;

// Give Validator instances the ability to listen to and fire events
_.extend(Validator.prototype, Backbone.Events);

Validator.prototype.validate = null;

/*eslint-disable*/
// Disabling eslint errors (var must be at top of file) as this is deprecated and shouldn't need to be maintained for much longer, (hopefully)

/**
 * Helper function does individual validations.
 * @param {object} rule
 * @param {boolean} [rule.noMatch=false]
 * @param {function|RegExp} [rule.validator]
 * @param {string} fieldName exp. creators[0].name
 *      - validator <RegExp | Function>
 * @param value
 * @returns {boolean}
 * @private
 */
var _validateSingle = function (rule, value, fieldName, required) {
    var self = this;
    var test = true;
    var func = rule.validator;

    // Throws an error if validator is improperly configured. Each rules property of a validaiton config must
    // have a validator property
    if (!func || !(func instanceof RegExp || func instanceof Function)) {
        throw new Error("Invalid validator configuration. Each validation config's rules property must have " +
            "a validator method which is an instance of RegExp or Function");
    }

    if (func instanceof RegExp) {
        test = func.test(value);
    } else if (typeof func === 'function') {
        test = func.call(self, value, fieldName, required);
    }

    // for nomatch rules, invert the answer :
    if (rule.noMatch) {
        test = !test;
    }

    // If the error is not either bool or instance of ErrorList then error out.
    if (!_.isBoolean(test) && !(test instanceof ErrorList)) {
        throw new Error("Validator for '" + fieldName + "' returned an invalid result.");
    }

    return test;
};

var _getNestedValue = function (model, string) {
    var obj = model.toJSON();
    string = string.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    string = string.replace(/^\./, ''); // strip a leading dot
    var arr = string.split('.');
    var n;
    while (arr.length) {
        n = arr.shift();
        if (obj.hasOwnProperty(n)) {
            obj = obj[n];
        } else {
            return;
        }
    }
    return obj;
};

/**
 * Helper function to do validations based on a validation schema.
 * @param {object} fieldValidations - validation schema object (rules)
 * @param {object} options - fields not to evaluate for required rule if passed
 * @returns {{ errors: { field:string, message: string }[] }}
 */
var _validate = function (fieldValidations, options) {
    options = options || {};

    this._resetValidationTrackers();

    var model = this.model;
    var out = {};
    var errorList = new ErrorList();
    var fieldsToValidate = [];
    var topLevelFields = [];
    var schema = {};
    var requireNone = _.isBoolean(options.requireNone) ? options.requireNone : this._requireNone;
    var specificFieldsToValidate = options.partial !== true && options.fields ? options.fields.slice(0) : null; // null out fields option if partial is true
    assert(specificFieldsToValidate === null || specificFieldsToValidate instanceof Array, 'options.fields must be an array');

    // Make a deep clone of the schema -- this way if we alter the schema rules during the course of this method, the
    // core set will not be affected :
    // schema = clone(schema);

    // Get the list of fields that to validate.
    // By default, the fields to validate is all auto-run fields :
    //fieldsToValidate = _.pluck(_.values(_.where(schema, {autoRun : true})), 'field');

    _.each(fieldValidations, function (fieldValidation, fieldValidationKey) {
        console.assert(fieldValidation instanceof FieldValidation, 'fieldValidation must be an instance of FieldValidation');
        var fieldSchema = schema[fieldValidationKey] = this.getSchemaForField(fieldValidation, fieldValidationKey);
        assert(typeof fieldSchema.field === 'string', 'The fieldValidation for key ' + fieldValidationKey + ' must define a "field"');
        if (!specificFieldsToValidate && fieldSchema.autoRun) {
            fieldsToValidate.push(fieldSchema.field);
        }
    }, this);
    if (specificFieldsToValidate) {
        fieldsToValidate = specificFieldsToValidate;
    }

    // Otherwise, if the client is asking to validate the partial object, over-write fields to validate with any
    // field where the top level attribute was passed in (1st segment in field name) :
    if (options.partial === true) {
        topLevelFields = _.keys(options.payload);
        var newFieldsToValidate = [];
        _.each(fieldsToValidate, function (fieldName) {
            var furstSegment = _.first(fieldName.split('.'));
            if (_.indexOf(topLevelFields, furstSegment) !== -1) {
                newFieldsToValidate.push(fieldName);
            }
        });
        fieldsToValidate = newFieldsToValidate;
    }

    // Next, apply the require none option. Toggle all required fields in the schema to not required. This will be
    // over-ridden below by individual field overrides.
    if (requireNone) {
        this._setChildrenRequireNone(true);
        _.each(schema, function (config) {
            config.required = false;
        });
    }

    // Loop over every field that you are going to validate. For each look up the associated validator from the
    // validation schema :
    _.each(fieldsToValidate, function (fieldName) {
        var fieldValidation;
        var fieldValidationKey;
        var fieldValidationSchema;
        var genericFieldName = fieldName;
        var fieldErrors = [];
        var childValidatorKey;
        var val;
        var required;
        var hasRealValue;
        var message;
        var override;

        // Throws an error if no field name is configured on validation config.
        if (!fieldName) {
            throw new Error('Invalid configuration. Each validation config item must have a field property.');
        }

        if (this.deferToChildValidators) {
            // If there is a child validator matching this field and
            // deferToChildValidators is true
            childValidatorKey = this.fieldMatchesChildValidator(fieldName);
            if (childValidatorKey) {
                this._shouldValidateFieldWithChildValidator(fieldName, childValidatorKey);
                return;
            }
        }

        // If the field regex detects a number (ie. "abc[1].def") -- then replace the number with a * to achieve a
        // generic field name.
        if (fieldRegex.test(fieldName)) {
            genericFieldName = fieldName.replace(fieldRegex, '[*]');
        }

        // Find validation onfigs -- the first config that matches the given field name :
        // Note *** If many validation configs are configured to match a given field, then only the first one will
        // run, you may not define many configs to match against a certain field name.
        for (fieldValidationKey in schema) {
            if (schema.hasOwnProperty(fieldValidationKey) && (genericFieldName === schema[fieldValidationKey].field)) {
                fieldValidation = fieldValidations[fieldValidationKey];
                fieldValidationSchema = schema[fieldValidationKey];
                break;
            }
        }
        if (!fieldValidationSchema) {
            return;
        }

        // If there are any over-rides for this validation config, then apply them now. Note* This reverses the blanket
        // rule of "requireNone" for specified fields.
        if (options.overrides) {
            override = _.find(options.overrides, function (o) {
                var field = o.field || o.fieldName;
                return (fieldValidationSchema.field === field);
            });
            if (override) {
                // TODO ::: ONLY EXTEND ON OVER-RIDES THAT WOULD NOT BREAK, ie. DO NOT APPLY OVER RIDES THAT ARE rules
                // TODO ::: BECAUSE IF PASSED IN AS STRING -- FUNCTIONS WOULD BLOW UP! (use pick / omit?)
                fieldValidationSchema = _.extend({}, fieldValidationSchema, override);
            }
        }

        // We know the specific model field and are about to validate it
        // so trigger an event so any listeners can handle it appropriately
        this.triggerWillValidateField(fieldName, fieldValidation);

        // Now get the value you are to evaluate :
        try {
            val = (fieldValidation.getModelValueForField) ?
                    fieldValidation.getModelValueForField(model, fieldName) : model.get(fieldName);
        } catch (e) {
            val = _getNestedValue(model, fieldName);
        }

        // If the value is an array, then check the length :
        if (_.isArray(val)) {
            val = val.length ? val : false;
        }

        if (_.isBoolean(fieldValidationSchema.required)) {
            required = fieldValidationSchema.required;
        } else if (_.isFunction(fieldValidationSchema.required)) {
            required = fieldValidationSchema.required(model, val, fieldName);
        } else {
            required = false;
        }

        // If the current field is required, then validate it has a value :
        hasRealValue = fieldValidation.hasRealValue ?
                fieldValidation.hasRealValue(model, val, fieldName) : (parseInt(val, 10) === 0 || !!val);

        if (required && !hasRealValue) {
            message = (fieldValidationSchema.messages && fieldValidationSchema.messages.required) ?
                    fieldValidationSchema.messages.required : DEFAULTREQUIREDMESSAGE;
            errorList.add(fieldValidationSchema.field, message, "required");

            this.triggerFieldFailed(fieldName, fieldValidation, [errorList.last()]);
            // Return from this case and do not run other validations, since the item is required and is NOT defined.
            return;
        }

        // Next, if the value is set to something AND there are rules defined...
        // apply each of the rules to the current field, getting the output of each :
        if (fieldValidationSchema.rules && hasRealValue) {
            _.each(fieldValidationSchema.rules, function (validator, key) {

                // Get the result for the current validator. Results can be boolean true | false OR they can be
                // objects describing an error.
                var result = _validateSingle.call(model, validator, val, fieldName, required);
                var currMessage = (fieldValidationSchema.messages && fieldValidationSchema.messages[key]) ? fieldValidationSchema.messages[key] : DEFAULT_MESSAGE + fieldName;

                // If the result is a boolean add the default error based on the field being validated. Otherwise
                // the result should be an array of errors from the ErrorList Class
                if (_.isBoolean(result) && !result) {
                    errorList.add(fieldName, currMessage, validator.validator);
                    fieldErrors.push(errorList.last());
                // If the result is an ErrorList -- then merge it with the overall error list.
                } else if (result instanceof ErrorList && result.getErrors().length) {
                    errorList.merge(result);
                    fieldErrors = fieldErrors.concat(errorList.getErrors());
                }

            }, this);

            if (fieldErrors.length) {
                this.triggerFieldFailed(fieldName, fieldValidation, fieldErrors);
            } else {
                this.triggerFieldPassed(fieldName, fieldValidation);
            }

        }
    }, this);

    this._validateChildValidatorFields(errorList);

    if (requireNone) {
        this._setChildrenRequireNone(false); // restore requireNone's default value (false);
    }

    out.errors = errorList.getErrors();

    return out;
};

/**
 * Do validation on a plain JS object, configured by options.
 *
 * @param {object|array} payload JSON object to be validated.
 * @param {object} [options] - Options to configure validation. May contain any of the following :
 * @param {boolean} [options.partial=false] Defaults to false. IF passed as true then only validate the fields passed in (present on the payload)
 * @param {string[]} [options.fields] Array of strings, if passed and not empty then ONLY the fields specified will be validated.
 * @param {boolean} [options.requireNone=false] Defaults to false. Don't evaluate any of the fields to be required. ***Note : you may set this to true, then toggle selected fields to be required by using the overrides array.
 * @param {object[]} [options.overrides] Over-ride the values for validations in the validation schema for this entity. This is an array of objects that mimics the structure of the vdalidation schemas.
 * @returns {{ errors: object[] }}
 */
Validator.prototype.validate = function (payload, options) {

    options = options || {};
    _.extend(options, {
        payload : payload
    });

    var self = this;
    var requiredArr = ['modelConstructor', 'fieldValidations'];
    var changeError = function () {
        throw new Error('Validator: model should not change during validation');
    };
    var validationRules;
    var output;

    assert(this.isReady(), 'Validator instance is not ready to validate yet.');

    // Check the required properties are set on the validation instance :
    _.each(requiredArr, function (required) {
        if (!self[required]) {
            throw new Error('Missing required property : ' + required);
        }
    });

    assert(payload instanceof this.modelConstructor || payload instanceof Backbone.Model === false,
        'Validator.validate payload must be instance of modelConstructor or toJSON output');
    this.model = (payload instanceof this.modelConstructor) ? payload : new this.modelConstructor(payload);

    this.model.on('nested-change', changeError).on('change', changeError);

    // If validation rules is a function, then execute that function to get the rules set :
    validationRules = this.fieldValidations;
    if (typeof this.fieldValidations === 'function') {
        validationRules = this.fieldValidations(this.model, options);
    }

    // run validations in the context of this validator instance, and return the results
    output = _validate.call(this, validationRules, options);

    // remove the event handler
    this.model.off('nested-change', changeError).off('change', changeError);

    return output;
};
/*eslint-enable*/
module.exports = Validator;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var FieldValidation = __webpack_require__(74);
var RegexRule = __webpack_require__(85);
var _ = __webpack_require__(0);

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Module Definition and Instance Properties

/**
 * @class RegexFieldValidation
 * @extends FieldValidation
 */
var RegexFieldValidation = module.exports = FieldValidation.extend({
    autoRun: true,
    initialize: function (options) {
        options = options || {};
        this.regex = options.regex || this.regex;
        this.message = options.message || this.message;
        this.noMatch = _.isBoolean(options.noMatch) ? options.noMatch : this.noMatch;
        this.rule = this.createRule();
        RegexFieldValidation.__super__.initialize.call(this, options);
    },
    createRule: function () {
        return new RegexRule(_.pick(this, 'regex', 'noMatch', 'message'));
    }
});


/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseIndexOf = __webpack_require__(328),
    cacheIndexOf = __webpack_require__(235),
    createCache = __webpack_require__(236);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.difference` which accepts a single array
 * of values to exclude.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values) {
  var length = array ? array.length : 0,
      result = [];

  if (!length) {
    return result;
  }
  var index = -1,
      indexOf = baseIndexOf,
      isCommon = true,
      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
      valuesLength = values.length;

  if (cache) {
    indexOf = cacheIndexOf;
    isCommon = false;
    values = cache;
  }
  outer:
  while (++index < length) {
    var value = array[index];

    if (isCommon && value === value) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === value) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (indexOf(values, value, 0) < 0) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

// shim for Node's 'util' package
// DO NOT REMOVE THIS! It is required for compatibility with EnderJS (http://enderjs.com/).
var util = {
  isArray: function (ar) {
    return Array.isArray(ar) || (typeof ar === 'object' && objectToString(ar) === '[object Array]');
  },
  isDate: function (d) {
    return typeof d === 'object' && objectToString(d) === '[object Date]';
  },
  isRegExp: function (re) {
    return typeof re === 'object' && objectToString(re) === '[object RegExp]';
  },
  getRegExpFlags: function (re) {
    var flags = '';
    re.global && (flags += 'g');
    re.ignoreCase && (flags += 'i');
    re.multiline && (flags += 'm');
    return flags;
  }
};


if (true)
  module.exports = clone;

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/

function clone(parent, circular, depth, prototype) {
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth == 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (util.isArray(parent)) {
      child = [];
    } else if (util.isRegExp(parent)) {
      child = new RegExp(parent.source, util.getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (util.isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      child = new Buffer(parent.length);
      parent.copy(child);
      return child;
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }
      
      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Convert a number into a string and add commas every
 * 3 digits. If there are decimals, the number will be
 * treated as a currency unless 'notCurrency' param is
 * false.
 * @param {String|Number} number String representation of a number or a normal number
 * @param {Boolean} notCurrency If the number should not be treated like a currency for decimals
 * @param {String} delim Indicates what symbol should separate every 3 digits; Either a ',' or a '.'
 * @return {String}
 */

var DELIM_COMMA = ',';
var DELIM_PERIOD = '.';

function numAddCommas(number, notCurrency, delim) {

    var i = void 0;
    var len = void 0;
    var dec = '';
    var newNum = '';
    var decIndx = void 0;
    var decimalDelim = void 0;

    delim = delim || DELIM_COMMA;
    decimalDelim = delim === DELIM_COMMA ? DELIM_PERIOD : DELIM_COMMA;

    if (!number && number !== 0) {
        return '';
    }

    number = '' + number;

    if (number.indexOf(delim) !== -1) {
        number = number.replace(new RegExp(delim, 'g'), '');
    }

    decIndx = number.indexOf(decimalDelim);
    if (decIndx !== -1) {
        len = number.length;
        if (notCurrency) {
            dec = number.substring(decIndx, len);
        } else {
            var numSubstring = delim === DELIM_PERIOD ? delim + number.substring(decIndx + 1) : number.substring(decIndx);
            dec = ('' + Math.round(Number(numSubstring) * 100) / 100).substring(1);
            dec = delim === DELIM_PERIOD ? dec.replace(DELIM_PERIOD, DELIM_COMMA) : dec;
            if (dec.length > 3) {
                dec = dec.substring(0, 3);
            } else if (dec.length === 2) {
                dec = dec + '0';
            }
        }
        number = number.substring(0, decIndx);
    }

    len = number.length;
    i = len - 1;

    while (i >= 0) {
        newNum = number.charAt(i) + newNum;

        if ((len - i) % 3 === 0 && len - 1 !== i && i > 0) {
            newNum = delim + newNum;
        }

        i = i - 1;
    }

    return newNum + dec;
}

module.exports = numAddCommas;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);

var UserToUserMessageStore = function (_BaseStore) {
    _inherits(UserToUserMessageStore, _BaseStore);

    function UserToUserMessageStore(dispatcher) {
        _classCallCheck(this, UserToUserMessageStore);

        var _this = _possibleConstructorReturn(this, (UserToUserMessageStore.__proto__ || Object.getPrototypeOf(UserToUserMessageStore)).call(this, dispatcher));

        _this._init();
        return _this;
    }

    _createClass(UserToUserMessageStore, [{
        key: '_init',
        value: function _init() {
            this.message = {
                fromName: '',
                fromEmail: '',
                fromUserId: '',
                toName: '',
                toEmail: '',
                toUserId: '',
                bcc: '',
                subject: '',
                body: '',
                templateFolder: '',
                template: ''
            };
        }
    }, {
        key: 'doneLoading',
        value: function doneLoading(payload) {
            var user = payload.user,
                copyText = payload.copyText,
                contactName = payload.contactName,
                contactEmail = payload.contactEmail;


            if (user) {
                this.message.fromUserId = user.pick('id');
                this.message.fromName = [user.get('profile.firstName') || '', user.get('profile.lastName') || ''].join(' ').trim();
                this.message.fromEmail = user.get('profile.email');
            }

            this.message.toName = contactName;
            this.message.toEmail = contactEmail;

            this.message.subject = copyText.get('subject');
            this.message.templateFolder = copyText.get('templateFolder');
            this.message.template = copyText.get('template');

            this.emitChange();
        }
    }, {
        key: 'editField',
        value: function editField(payload) {
            this.message[payload.field] = payload.value;
            this.emitChange();
        }
    }]);

    return UserToUserMessageStore;
}(BaseStore);

UserToUserMessageStore.storeName = 'UserToUserMessageStore';

UserToUserMessageStore.handlers = {
    'contact:userToUser:message:fieldEdited': 'editField',
    'contact:userToUser:loading:done': 'doneLoading'
};

module.exports = UserToUserMessageStore;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Validator = __webpack_require__(118);
var Transaction = __webpack_require__(20);
var LocalizedCurrencyValidation = __webpack_require__(234);
var FieldRule = __webpack_require__(46);
var FinancialAmount = __webpack_require__(10);
var numberConversions = __webpack_require__(317);
var assert = __webpack_require__(31);

var TransactionValidator = module.exports = Validator.extend({

    modelConstructor: Transaction,

    initialize: function initialize() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this._copy = options.copyText;
        this._compareItemPrice = typeof options.compareItemPrice === 'boolean' ? options.compareItemPrice : true;
        TransactionValidator.__super__.initialize.apply(this, arguments);
    },
    fieldValidations: function fieldValidations() {
        var _this = this;

        var currency = this._getCurrency(this.model);
        var isEur = currency === FinancialAmount.CURRENCY_EUR;
        var additionalRules = {
            positive: new FieldRule({
                message: this._copy.get('errorPositiveNumber'),
                validate: function validate() {
                    return _this.parseOffer(_this.model) > 0;
                }
            })
        };
        if (this._compareItemPrice) {
            additionalRules.lowerThanItemPrice = new FieldRule({
                message: this._copy.get('errorUnderListPrice'),
                validate: function validate() {
                    return Math.floor(_this.parseOffer(_this.model) * 100) < Math.floor(_this._getItemPrice(_this.model) * 100);
                }
            });
        }
        return {
            offerAmount: new LocalizedCurrencyValidation({
                currency: currency,
                additionalRules: additionalRules,
                message: isEur ? this._copy.get('errorPriceFormatEur') : this._copy.get('errorPriceFormat'),
                required: true,
                field: 'amountPerItem.amount',
                getModelValueForField: function getModelValueForField(model, field) {
                    return _this._getOffer(model).get(field);
                }
            })
        };
    },
    validateLowball: function validateLowball(model, options) {
        model = model instanceof this.modelConstructor ? model : new this.modelConstructor(model);
        return this.parseOffer(model) < this._getItemPrice(model, options) * 0.6;
    },
    validateEqualItemPrice: function validateEqualItemPrice(model) {
        model = model instanceof this.modelConstructor ? model : new this.modelConstructor(model);
        return this.parseOffer(model) === this._getItemPrice(model);
    },
    validateHigherItemPrice: function validateHigherItemPrice(model) {
        model = model instanceof this.modelConstructor ? model : new this.modelConstructor(model);
        return this.parseOffer(model) > this._getItemPrice(model);
    },
    parseOffer: function parseOffer(model) {
        var offer = this._getOffer(model);
        var delimiter = this._getCurrency(model) === FinancialAmount.CURRENCY_EUR ? '.' : ',';
        var amount = offer.get('amountPerItem.amount') || '0';
        return numberConversions.removeThousandsDelim(amount.trim(), delimiter);
    },
    _getCurrency: function _getCurrency(model) {
        var offer = this._getOffer(model);
        return offer.get('amountPerItem.currency') || FinancialAmount.CURRENCY_USD;
    },
    _getItemPrice: function _getItemPrice(model, options) {
        options = options || {};
        var item = model.get('item');
        var pricing = item ? item.get('pricing') : undefined;
        if (pricing) {
            return pricing.getMostRelevantPrice(this._getCurrency(model), options.isTrade);
        }
        return 0;
    },


    // only validate most recent offer
    _getOffer: function _getOffer(model) {
        return model.getMostRecentOffer();
    }
});

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var extendCompose = __webpack_require__(43);
var Conversation = module.exports = extendCompose.call(SoaModel, {});
var Anchors = __webpack_require__(324);
var AnchorLists = __webpack_require__(117);
var Messages = __webpack_require__(165);
var Item = __webpack_require__(34);
var Transaction = __webpack_require__(20);
var BuyerProfile = __webpack_require__(229);
var Party = __webpack_require__(8);
var User = __webpack_require__(28);
var endpoints = __webpack_require__(6);
var Clump = __webpack_require__(22);
var bunsen = __webpack_require__(21);
var newsy = __webpack_require__(41);
var globalDataLogger = __webpack_require__(48);
var Deferred = __webpack_require__(29).Deferred;
var Qs = __webpack_require__(42);
var assign = __webpack_require__(60);
var copyText = __webpack_require__(39)();
/**
 * @attribute unreadMessagesCount - total number of unread messages in this conversation
 * @attribute numberOfAttachments
 */
Conversation.extendSelf({
    url: function (options) {
        options = options || {};
        if (this._asUser) {
            options.params = assign({}, options.params, {userId: this._asUser});
        }
        if (undefined === this.id || 'undefined' === this.id) {
            globalDataLogger.event({'conversation id is undefined': this.toJSON()});
            globalDataLogger.flush();
        }
        return endpoints.conversation(this.id, options);
    },
    sync: function (method, context, options) {
        var fields;
        if (method !== 'read') {
            return Conversation.__super__.sync.apply(this, arguments);
        }
        // make sure that conversation is always requested with at least baseFields
        options = _.extend({}, options);
        if (!options.data) {
            options.data = {};
        }
        fields = _.result(options.data, 'fields');
        if ("string" === typeof fields) {
            fields = fields.split(',');
        }
        if (!_.isArray(fields)) {
            fields = [];
        }
        options.data = _.extend({}, options.data, {fields: _.uniq(fields.concat(Conversation.baseFields)).join(',')});
        return Conversation.__super__.sync.call(this, method, context, options);
    },
    initialize : function (attributes, options) {
        options = assign({
            asUser: undefined
        }, options);
        this.on('sync', function (model, data) {
            globalDataLogger.event({'conversation model sync': data});
        });
        this._asUser = options.asUser;
    },
    _getLatestMessageSenderId: function () {
        return parseInt(this.get('latestMessageSenderId'), 10); // TODO: get services to be consistent between types in their ids, then remove the parseInt (and this method);
    },
    getLatestMessageRecipientDisplayName: function () {
        var latestMessageRecipient = _.last(this.get('members').filter(function (recipient) {
            if ('N' === recipient.get('isActive')) {
                return false;
            }
            if (recipient.isExternal()) {
                return false;
            }
            return recipient.id !== this._getLatestMessageSenderId();
        }, this));
        if (latestMessageRecipient) {
            return latestMessageRecipient.getDisplayName();
        }
        return copyText.get('unknownRecipient');
    },
    getOtherMemberDisplayName: function () {
        var displayName = '';
        if (this.getOtherMember) {
            displayName = _.result(this.getOtherMember(), 'getDisplayName');
        }
        return displayName;
    },
    parse : function () {
        var data = Conversation.__super__.parse.apply(this, arguments);
        if ("string" === typeof data.isLatestMessageSender) {
            data.isLatestMessageSender = data.isLatestMessageSender === 'Y';
        }
        return data;
    },
    idAttribute : "id",
    defaults : {
        members : [],
        anchors : []
    },
    relations: [
        {
            key: 'reviewedBy',
            relatedModel: User,
            type: Backbone.One
        },
        {
            key: 'messagePointers',
            relatedModel: SoaModel,
            type: Backbone.One
        },
        {
            key : 'anchors',
            collectionType: Anchors,
            type : Backbone.Many
        },
        {
            key : 'members',
            relatedModel: newsy.getConstructor.bind(newsy, 'ConversationMember'),
            type : Backbone.Many
        },
        {
            key : 'messages',
            omitFromSave: true,
            collectionType: Messages,
            type : Backbone.Many
        },
        {
            key: 'item',
            omitFromSave: true,
            relatedModel: Item,
            type: Backbone.One
        },
        {
            key: 'transaction',
            relatedModel: Transaction,
            type: Backbone.One
        },
        {
            key: 'buyerProfile',
            relatedModel: BuyerProfile,
            type: Backbone.One
        }
    ],
    fetchMessages : function () {
        var messages = this.get('messages') || new Messages();
        var dummyConversation = newsy('ConversationModel', _.pick(this, 'id'));
        this.set('messages', messages);
        globalDataLogger.event({'created dummy conversation': dummyConversation.toJSON()});
        return dummyConversation.fetch({data: {fields: ['message', 'attachment'].join(',')}}).then(function (data) {
            var newMessages;
            globalDataLogger.event({'fetched dummy conversation': data});
            newMessages = dummyConversation.get('messages');
            if (!newMessages) {
                return Deferred().reject();
            }
            messages.reset(newMessages.models);
        });
    },
    markReadUnread : function (isRead) {
        if (undefined === isRead) {
            isRead = true;
        }
        _.result(this._lastMarkReadUnreadRequest, 'abort');
        this._lastMarkReadUnreadRequest = Clump.ajax({
            type : "PUT",
            url : endpoints.markReadUnread + '?' + Qs.stringify(_.extend({
                isRead : isRead === true || isRead === 'Y' ? 'Y' : 'N',
                conversationIds : this.id
            }, bunsen.getToken()))
        });
        return this._lastMarkReadUnreadRequest;
    },
    getMemberForUser: function (options) {
        options = _.extend({
            userId: undefined
        }, options);
        if (!options.userId) {
            throw new Error('getMemberForUser expects options.userId');
        }
        return _.first(this.get('members').filter(function (member) {
            return member.get('user').id === options.userId;
        }));
    },
    getMostRecentMessage: function () {
        return _.result(this.get('messages'), 'last');
    },
    getOriginalBuyer: function () {
        return this.getOriginalMemberByType(Party.ROLE_BUYER);
    },
    getOriginalSeller: function () {
        return this.getOriginalMemberByType(Party.ROLE_SELLER);
    },
    getOriginalMemberByType: function (type) {
        return this.get('members').findWhere({
            userType: type,
            isOriginal: 'Y'
        });
    },
    isUnavailable: function () {
        return this.get('status') !== 'ACTIVE';
    },
    isContentRedacted: function () {
        return this.get('messageContentRedacted') === 'Y';
    },
    getUrlForBuyerAndItemEndpoint: function (options) {
        return endpoints.conversationsForBuyerAndItemUrl({
            buyerId: options.buyerId,
            itemId: options.itemId
        });
    },
    fetchConversationForBuyerAndItem: function (options) {
        return this.fetch({url: this.getUrlForBuyerAndItemEndpoint(options)});
    },
    getLatestDealerOffer: function () {
        var offers = this.get('transaction.offers');
        if (offers) {
            return _.last(offers.filter(function (offer) {
                return offer.get('initiatingParty.role') === Party.ROLE_SELLER;
            }));
        }
    },
    getReviewReasons: function () {
        if (!this.get('reviewReason')) {
            return [];
        }
        return this.get('reviewReason').split(',').map(function (reason) {
            return reason.trim();
        });
    },
    isSellerOnNewPolicy: function () {
        var seller = this.getOriginalSeller();
        var sellerId = seller.get('user').id;
        var anchorLists = new AnchorLists();

        return anchorLists.fetchListForSellerPolicy(sellerId).then(function (data) {
            if (data.result.length) {
                return !!_.findWhere(data.result, {name: AnchorLists.listNames.OPOP});
            }
        });
    }
});
Conversation.reviewStatuses = [
    'OPEN',
    'MONITORING',
    'IN_PROGRESS',
    'CLOSED'
];
Conversation.baseFields = [
    'conv_trans_full', // transaction in conversation will return the most relevant transaction
    'OFFER' // offers in messages
];
Conversation.newsy = {
    builds: ['ConversationMember'],
    name: 'ConversationModel'
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 133 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Rob Richard
 * Date: 3/17/15
 * Time: 10:56 AM
 */



var SoaModel = __webpack_require__(2);
var Token = module.exports = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;

root.bunsen = root.bunsen || {};
module.exports = root.bunsen.Token = Token;

var _ = __webpack_require__(0);
var ends = __webpack_require__(6);

_.extend(Token.prototype, {
    fetchClientToken: function () {
        return this.fetch({
            url: ends.paymentProviderClientToken()
        });
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var get = __webpack_require__(14);

function getDisplayName(_ref) {
    var firstName = _ref.firstName,
        lastName = _ref.lastName,
        email = _ref.email;

    if (firstName && lastName) {
        return firstName + ' ' + lastName;
    } else if (lastName) {
        return lastName;
    } else if (firstName) {
        return firstName;
    } else if (email) {
        return email.split('@')[0];
    }
    return '';
}

var ContactDealerStore = {
    storeName: 'ContactDealerStore',
    initialState: {
        errors: [],
        hasTrackingFired: false,
        isMessageSending: false,
        isMessageSent: false,
        messageBody: {
            action: { name: 'CONTACT_DEALER' },
            from: {},
            item: {},
            recipients: [],
            textBody: ''
        },
        optimizelyVariant: ''
    },
    reducers: {
        BOOTSTRAP_ITEM_STORE: function BOOTSTRAP_ITEM_STORE(state, payload) {
            var _payload$rawResult = payload.rawResult,
                item = _payload$rawResult === undefined ? {} : _payload$rawResult;

            var apiType = item.vertical + 'Item'; // Need to format V2 apiType for MC endpoint
            return _extends({}, state, {
                messageBody: _extends({}, state.messageBody, {
                    item: { apiType: apiType, id: item.id },
                    recipients: [{
                        recipientDetails: {
                            displayName: get(item, 'seller.sellerProfile.company', ''),
                            user: { id: get(item, 'seller.id') },
                            userType: 'SELLER'
                        },
                        recipientType: 'TO'
                    }],
                    subject: '1stdibs Item Inquiry - ' + get(item, 'title')
                })
            });
        },
        ENTER_MESSAGE: function ENTER_MESSAGE(state, payload) {
            var value = payload.value;

            return _extends({}, state, { messageBody: _extends({}, state.messageBody, { textBody: value }) });
        },
        ENTER_NAME: function ENTER_NAME(state, payload) {
            var value = payload.value;

            return _extends({}, state, { messageBody: _extends({}, state.messageBody, { from: { displayName: value } }) });
        },
        SET_USER_VALUES: function SET_USER_VALUES(state, payload) {
            var displayName = payload.displayName,
                user = payload.user;

            return _extends({}, state, {
                messageBody: _extends({}, state.messageBody, {
                    from: {
                        displayName: displayName || getDisplayName(user.profile || {}),
                        user: { id: user.userId || user.id },
                        userEmail: get(user, 'profile.email'),
                        userType: 'BUYER'
                    }
                })
            });
        },
        SET_OPTIMIZELY_VARIANT: function SET_OPTIMIZELY_VARIANT(state, payload) {
            var optimizely = payload.optimizely;

            return _extends({}, state, { optimizelyVariant: optimizely });
        },
        MESSAGE_SEND_END: function MESSAGE_SEND_END(state) {
            return _extends({}, state, { isMessageSent: true, isMessageSending: false });
        },
        MESSAGE_SEND_BEGIN: function MESSAGE_SEND_BEGIN(state) {
            return _extends({}, state, { isMessageSending: true });
        },
        PDP_CONTACT_FORM_ERRORS: function PDP_CONTACT_FORM_ERRORS(state, payload) {
            var errors = payload.errors;

            return _extends({}, state, { errors: errors });
        },
        TRACKING_FIRED: function TRACKING_FIRED(state) {
            return _extends({}, state, { hasTrackingFired: true });
        }
    },
    getters: {
        getErrors: function getErrors(state) {
            return state.errors;
        },
        getMessage: function getMessage(state) {
            return state.messageBody.textBody;
        },
        getMessageSending: function getMessageSending(state) {
            return state.isMessageSending;
        },
        getMessageSent: function getMessageSent(state) {
            return state.isMessageSent;
        },
        getName: function getName(state) {
            return state.messageBody.from.displayName;
        },
        getVariant: function getVariant(state) {
            return state.optimizelyVariant;
        },
        getTrackingFired: function getTrackingFired(state) {
            return state.hasTrackingFired;
        }
    }
};

module.exports = ContactDealerStore;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

/* eslint-env browser */
module.exports = window.FormData;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var moment = __webpack_require__(30);
var zipObject = __webpack_require__(243);
var map = __webpack_require__(331);
var uuid = __webpack_require__(262);
var buildMomentLocale = function (localeConfig, passedMoment) {
    var localeName = "-module-locale-" + uuid.v4();
    var theMoment = passedMoment || moment;
    moment.locale(localeName, localeConfig);
    return (function () {
        return theMoment.apply(theMoment, arguments).locale(localeName);
    });
};
module.exports = function (localeConfigs) {
    return zipObject(map(localeConfigs, function (localeConfig, localeName) {
        return [localeName, buildMomentLocale(localeConfig)]
    }));
}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Created by john on 7/16/15.
 */



var _NavBarUIStateStore$h;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var User = __webpack_require__(15);
var BaseStore = __webpack_require__(13);
var NavActions = __webpack_require__(35).NAV;
var get = __webpack_require__(14);
var root = typeof document === 'undefined' ? global : document;

/**
 * Stores the state of the nav bar UI. For example, whether the search bar is expanded, menu shown,
 * user logged in, etc.
 */

var NavBarUIStateStore = function (_BaseStore) {
    _inherits(NavBarUIStateStore, _BaseStore);

    function NavBarUIStateStore(dispatcher) {
        _classCallCheck(this, NavBarUIStateStore);

        var _this = _possibleConstructorReturn(this, (NavBarUIStateStore.__proto__ || Object.getPrototypeOf(NavBarUIStateStore)).call(this, dispatcher));

        _this.state = {
            showNavMenu: false,
            showSearchBar: false,
            showTrade: _this._canShowTrade()
        };

        // set up listener on User Model
        User.getCurrentUser().on('login:change', _this.updateUserStates, _this);
        User.getCurrentUser().on('change:profile', _this.updateUserStates, _this);
        return _this;
    }

    _createClass(NavBarUIStateStore, [{
        key: '_canShowTrade',
        value: function _canShowTrade() {
            var bodyEl = root.querySelector('body');
            return get(bodyEl, 'className', '').indexOf('is-trade') >= 0;
        }
    }, {
        key: 'getState',
        value: function getState() {
            return this.state;
        }
    }, {
        key: 'updateUserStates',
        value: function updateUserStates() {
            var _this2 = this;

            var loggedIn = User.loggedIn();

            if (loggedIn) {
                User.load().always(function () {
                    _this2.state.showTrade = _this2._canShowTrade();
                    _this2.emitChange();
                });
            }
        }

        /**
         * Handler for when the navigation menu state changes.
         * @param payload
         * @param payload.visible {boolean}
         */

    }, {
        key: 'onToggleNavMenu',
        value: function onToggleNavMenu(payload) {
            this.state.showNavMenu = !!payload.visible;
            this.emitChange();
        }

        /**
         * Handles showing and hiding the search bar.
         * @param payload
         * @param payload.visible {boolean}
         */

    }, {
        key: 'onToggleSearchBar',
        value: function onToggleSearchBar(payload) {
            this.state.showSearchBar = !!payload.visible;
            this.emitChange();
        }
    }]);

    return NavBarUIStateStore;
}(BaseStore);

NavBarUIStateStore.storeName = 'NavBarUIStateStore';

NavBarUIStateStore.handlers = (_NavBarUIStateStore$h = {}, _defineProperty(_NavBarUIStateStore$h, NavActions.TOGGLE_MENU, 'onToggleNavMenu'), _defineProperty(_NavBarUIStateStore$h, NavActions.TOGGLE_SEARCH, 'onToggleSearchBar'), _NavBarUIStateStore$h);

module.exports = NavBarUIStateStore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by caroline on 7/21/15.
 */



var _handlers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var $ = __webpack_require__(5);
var User = __webpack_require__(15);
var createStore = __webpack_require__(49);
var ActionConstants = __webpack_require__(35);
var NavActions = ActionConstants.NAV;

var DEFAULT_USER_INITIALS = null;
var DEFAULT_MESSAGE_COUNT = 0;
var DEFAULT_REDIRECT_URL = null;

/**
 * Stores the list of components that are displayed in the nav bar.
 */
module.exports = createStore({

    storeName: 'NavBarHamburgerStateStore',

    handlers: (_handlers = {}, _defineProperty(_handlers, ActionConstants.HAMBURGER.UPDATE_USER_STATES, '_onUpdateUserStates'), _defineProperty(_handlers, NavActions.ACTIVE_GROUP_CHANGED, 'onActiveGroupChange'), _defineProperty(_handlers, NavActions.RECEIVED_LIST_DATA, 'setLists'), _handlers),

    initialize: function initialize() {
        this.state = this._getDefaultState();
        this.lists = [];

        // set up listener on User Model
        User.getCurrentUser().on('login:change', this.updateUserStates, this);
        User.getCurrentUser().on('change:profile', this.updateUserStates, this);
    },
    getRedirectURL: function getRedirectURL() {
        return this.redirectURL || DEFAULT_REDIRECT_URL;
    },
    getState: function getState() {
        return this.state;
    },
    getLists: function getLists() {
        return this.lists;
    },
    setLists: function setLists(payload) {
        this.lists = this._getFormattedListsData(payload);
        this.emitChange();
    },
    onActiveGroupChange: function onActiveGroupChange(payload) {
        this.redirectURL = payload.redirectURL;
        this.emitChange();
    },


    /**
     * checks the user model, updates state.user and emits change
     * @param {promise} [payload.promise]
     */
    updateUserStates: function updateUserStates() {
        var _this = this;

        var loggedIn = User.loggedIn();

        if (loggedIn) {
            User.load().always(function () {
                _this.state = {
                    loggedIn: loggedIn,
                    userInitials: User.getInitials() || DEFAULT_USER_INITIALS,
                    messageCount: User.getCurrentUser().get('conversationSummary.totalUnreadMessageCount')
                };
                _this.emitChange();
            });
        } else {
            this.state = this._getDefaultState();
            this.emitChange();
        }
    },
    _onUpdateUserStates: function _onUpdateUserStates() {
        var _this2 = this;

        this.updateUserStates();

        //todo: revisit this and try to see if there is a better way to do this
        $.subscribe('reloadUserNav', function (obj, data) {
            _this2.state.messageCount = data.totalUnreadMessageCount;
            _this2.emitChange();
        });
    },
    _getDefaultState: function _getDefaultState() {
        return {
            loggedIn: false,
            userInitials: DEFAULT_USER_INITIALS,
            messageCount: DEFAULT_MESSAGE_COUNT
        };
    },
    _getFormattedListsData: function _getFormattedListsData(_ref) {
        var modules = _ref.modules;

        // Group the global nav items based on their is_vertical flags.
        return [{
            'label': 'Explore',
            'items': modules.filter(function (item) {
                return item.isVertical === true;
            }).map(function (item) {
                return {
                    'url': item.url,
                    'name': item.name
                };
            })
        }, {
            'label': 'Discover',
            'items': modules.filter(function (item) {
                return item.isVertical !== true;
            }).map(function (item) {
                return {
                    'url': item.url,
                    'name': item.name
                };
            })
        }];
    }
});

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 7/16/15.
 */



var _NavBarItemStore$hand;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var NavActions = __webpack_require__(35).NAV;

/**
 * Stores the list of components that are displayed in the nav bar.
 */

var NavBarItemStore = function (_BaseStore) {
    _inherits(NavBarItemStore, _BaseStore);

    function NavBarItemStore(dispatcher) {
        _classCallCheck(this, NavBarItemStore);

        var _this = _possibleConstructorReturn(this, (NavBarItemStore.__proto__ || Object.getPrototypeOf(NavBarItemStore)).call(this, dispatcher));

        _this.currentGroup = 'default';
        _this.componentGroups = {
            'default': []
        };
        _this.components = [];
        return _this;
    }

    _createClass(NavBarItemStore, [{
        key: 'getState',
        value: function getState() {
            return {
                components: this.getItems()
            };
        }
    }, {
        key: 'getItems',
        value: function getItems(group) {
            var groupKey = group || this.currentGroup || 'default';
            return this.componentGroups[groupKey];
        }

        /**
         * Changes the list of components that is currently rendered.
         * @param payload
         * @param payload.group
         */

    }, {
        key: 'onActiveGroupChanged',
        value: function onActiveGroupChanged(payload) {
            this.currentGroup = payload.group;
            this.emitChange();
        }

        /**
         * Adds a component to the list.
         * @param payload
         * @param payload.group      {string}    A key representing the list to add these components to.
         * @param payload.components {Array}     An array of react components representing items to be shown in the nav bar.
         * @param payload.index      {number}    The location in which the components should be inserted into the nav bar.
         */

    }, {
        key: 'onComponentsAdded',
        value: function onComponentsAdded(payload) {
            var components = payload.components,
                index = payload.index;

            var groupKey = payload.group || 'default';
            var componentGroup;
            if (components && components.length) {
                componentGroup = this.componentGroups[groupKey];
                if (!componentGroup) {
                    componentGroup = this.componentGroups[groupKey] = [];
                }
                Array.prototype.splice.apply(componentGroup, [index, 0].concat(components));
                this.emitChange();
            }
        }

        /**
         * Removes a component from the list.
         * @param payload
         * @param payload.key   {Component} A react component to remove from the nav bar.
         * @param payload.group {string}    The group to remove the component from. 'default' if not provided.
         */

    }, {
        key: 'onComponentsRemoved',
        value: function onComponentsRemoved(payload) {
            var component = payload.component,
                group = payload.group;

            var componentGroup = this.componentGroups[group || 'default'];
            if (componentGroup && component) {
                // TODO: actually remove the component
                this.emitChange();
            }
        }

        /**
         *
         * @param payload
         */

    }, {
        key: 'onNavigate',
        value: function onNavigate(payload) {
            console.log(payload);
            this.emitChange();
        }
    }]);

    return NavBarItemStore;
}(BaseStore);

NavBarItemStore.storeName = 'NavBarItemStore';

NavBarItemStore.handlers = (_NavBarItemStore$hand = {}, _defineProperty(_NavBarItemStore$hand, NavActions.NAVIGATED, 'onNavigate'), _defineProperty(_NavBarItemStore$hand, NavActions.ITEMS_ADDED, 'onComponentsAdded'), _defineProperty(_NavBarItemStore$hand, NavActions.ITEMS_REMOVED, 'onComponentsRemoved'), _defineProperty(_NavBarItemStore$hand, NavActions.ACTIVE_GROUP_CHANGED, 'onActiveGroupChanged'), _NavBarItemStore$hand);

module.exports = NavBarItemStore;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _handlers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ = __webpack_require__(23);
var createStore = __webpack_require__(49);
var ActionConstants = __webpack_require__(35);

var SearchStore = createStore({
    storeName: 'SearchStore',
    handlers: (_handlers = {}, _defineProperty(_handlers, ActionConstants.SEARCH.SEARCH_TERM_CHANGED, 'onSearchTermChanged'), _defineProperty(_handlers, ActionConstants.SEARCH.SEARCH_RESULT_RETURNED, 'onSearchResultReturned'), _handlers),
    initialize: function initialize() {
        this.term = '';

        // Default to the search term, if it exists
        if (window.location.search) {
            // .substring(1) to remove the leading '?'
            _.forEach(window.location.search.substring(1).split('&'), function (pair) {
                var split = pair.split('=');
                if (split[0] === 'q') {
                    this.term = split[1].replace(/\+/g, ' ');
                }
            }, this);
        }
        this.results = [];
    },
    getTerm: function getTerm() {
        return this.term;
    },
    getResults: function getResults() {
        return this.results;
    },
    getState: function getState() {
        return {
            term: this.term,
            results: this.results
        };
    },
    onSearchTermChanged: function onSearchTermChanged(payload) {
        // If the term is empty, clear the results as well
        if (this.term === '') {
            this.results = [];
        }

        this.term = payload.term;
        this.emit('change');
    },
    onSearchResultReturned: function onSearchResultReturned(payload) {
        this.results = payload.results;
        this.emit('change');
    }
});

module.exports = SearchStore;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var inherits = __webpack_require__(50);
var BaseStore = __webpack_require__(323);
var IGNORE_ON_PROTOTYPE = ['statics', 'storeName', 'handlers', 'mixins'];

function createChainedFunction(one, two) {
    return function chainedFunction() {
        one.apply(this, arguments);
        two.apply(this, arguments);
    };
}

function mixInto(dest, src) {
    Object.keys(src).forEach(function (prop) {
        if (-1 !== IGNORE_ON_PROTOTYPE.indexOf(prop)) {
            return;
        }
        if ('initialize' === prop) {
            if (!dest[prop]) {
                dest[prop] = src[prop];
            } else {
                dest[prop] = createChainedFunction(dest[prop], src[prop]);
            }
        } else {
            if (dest.hasOwnProperty(prop)) {
                throw new Error('Mixin property collision for property "' + prop + '"');
            }
            dest[prop] = src[prop];
        }
    });
}

/**
 * Helper for creating a store class
 * @method createStore
 * @param {Object} spec
 * @param {String} spec.storeName The name of the store
 * @param {Object} spec.handlers Hash of action name to method name of action handlers
 * @param {Function} spec.initialize Function called during construction for setting the default state
 * @param {Function} spec.dehydrate Function that returns serializable data to send to the client
 * @param {Function} spec.rehydrate Function that takes in serializable data to rehydrate the store
 */
module.exports = function createStore(spec) {
    spec.statics = spec.statics || {};
    if (!spec.storeName && !spec.statics.storeName) {
        throw new Error('createStore called without a storeName');
    }
    var Store = function (dispatcher) {
        BaseStore.call(this, dispatcher);
    };

    inherits(Store, BaseStore);

    Object.keys(spec.statics).forEach(function (prop) {
        Store[prop] = spec.statics[prop];
    });

    Store.storeName = spec.storeName || Store.storeName;
    Store.handlers = spec.handlers || Store.handlers;
    Store.mixins = spec.mixins || Store.mixins;

    if (Store.mixins) {
        Store.mixins.forEach(function(mixin) {
            mixInto(Store.prototype, mixin);
        });
    }
    mixInto(Store.prototype, spec);

    return Store;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This module was originally in bunsen and created by PeteJodo
 * Modified and relocated by Liliana on 12/22/15
 */



var $ = __webpack_require__(5);
var Proxier = __webpack_require__(147);
var LocalCartCollection = __webpack_require__(145);
var ServiceCartCollection = __webpack_require__(146);
var CartPortfolioItem = __webpack_require__(54);
var User = __webpack_require__(15);
var Clump = __webpack_require__(22);

var proxiedCart = void 0;
var localCart = void 0;
var serviceCart = void 0;

function saveLocalCartItems() {
    var saveComplete = $.Deferred();
    var clump = new Clump({ auto: true });
    $.when.apply($, localCart.models.reverse().map(function (cartItem) {
        return cartItem.save(null, { clump: clump });
    })).then(saveComplete.resolve, function (resp) {
        // saving duplicate returns 409
        if (resp.status === 409) {
            saveComplete.resolve();
        } else {
            localCart.trigger('cart:error', 'error merging cart data');
            saveComplete.reject();
        }
    });
    return saveComplete;
}

function setToServiceCart() {
    return User.load().done(function (userData) {
        var portfolioItems = userData.cart.items || [];
        var models = [];
        var saveComplete = void 0;
        portfolioItems.forEach(function (portfolioItem) {
            return models.push(new CartPortfolioItem(portfolioItem));
        });
        if (localCart.length > 0) {
            models.push.apply(models, localCart.models);
            saveComplete = saveLocalCartItems();
        } else {
            saveComplete = $.Deferred().resolve();
        }
        saveComplete.done(function () {
            if (localCart.length > 0) {
                localCart.reset();
            }
            proxiedCart.__proxySwitch(serviceCart);
            serviceCart.reset(models);
            serviceCart.checkStaleData();
            proxiedCart.trigger('cart:ready');
        });
    });
}

function initCartCollection() {
    localCart = new LocalCartCollection();
    serviceCart = new ServiceCartCollection();
    proxiedCart = new Proxier(localCart, { preserveEvents: true });
    setToServiceCart();
    if (!User.loggedIn()) {
        $.subscribe('login:change', function (e, data) {
            if (data.loggedIn) {
                setToServiceCart();
            }
        });
    }
}

module.exports.getCartCollection = function () {
    if (!proxiedCart) {
        initCartCollection();
    }
    return proxiedCart;
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var PortfolioItemCollection = __webpack_require__(123);
var CartPortfolioItem = __webpack_require__(54);
var Items = __webpack_require__(129);
var Storage = __webpack_require__(76);
var cartStorage = Storage.localStorage;

var LOCAL_STORAGE_ID = 'cart';

var LocalCartCollection = module.exports = PortfolioItemCollection.extend({
    model: CartPortfolioItem,

    comparator: function comparator(modelOne, modelTwo) {
        var localCart = cartStorage.getItem(LOCAL_STORAGE_ID);
        var localCartIdsArr = _.map(localCart, function (item) {
            return item.id;
        });
        return _.indexOf(localCartIdsArr, modelTwo.get('item.id')) - _.indexOf(localCartIdsArr, modelOne.get('item.id'));
    },
    fetch: function fetch(options) {
        var _this = this;

        var cartItems = cartStorage.getItem(LOCAL_STORAGE_ID);
        var numItems = options ? options.numberOfItems : false;
        var items;
        var itemIdsArr;
        var appendItemIdsArr = [];

        if (!cartItems || !cartItems.length || this.length === cartItems.length) {
            return $.Deferred().resolve();
        }
        itemIdsArr = cartItems.map(function (item) {
            return item.id;
        });
        items = new Items();
        if (numItems) {
            appendItemIdsArr = itemIdsArr.slice(0, -numItems);
            itemIdsArr = itemIdsArr.slice(-numItems);
        }
        items.setParam('pk', itemIdsArr.join(' '), { filterQuery: true });
        return items.fetchWithParameters().done(function (data) {
            _this.reset(data.result.items.map(function (item) {
                return new CartPortfolioItem({ item: item });
            }).concat(appendItemIdsArr.map(function (itemId) {
                return new CartPortfolioItem({ item: { id: itemId } });
            })));
        });
    },
    add: function add(model, options) {
        var _this2 = this;

        var cartPortfolioItem = new CartPortfolioItem();
        var localCart;
        var itemExists;
        var duplicate;

        if (_.isUndefined(model)) {
            return;
        }

        if (_.isArray(model)) {
            model.forEach(function (singleModel) {
                return _this2.add(singleModel, options);
            });
            return;
        }

        if (model instanceof CartPortfolioItem) {
            cartPortfolioItem = model;
        } else {
            cartPortfolioItem = new CartPortfolioItem();
            cartPortfolioItem.set({ item: model });
        }

        localCart = cartStorage.getItem(LOCAL_STORAGE_ID);
        if (localCart) {
            // check local storage for dupe
            itemExists = localCart.some(function (item) {
                return item.id === cartPortfolioItem.get('item.id');
            });
            if (!itemExists) {
                localCart.push({ id: cartPortfolioItem.get('item.id') });
                cartStorage.setItem(LOCAL_STORAGE_ID, JSON.stringify(localCart));
            }
        } else {
            localCart = [{ id: cartPortfolioItem.get('item.id') }];
            cartStorage.setItem(LOCAL_STORAGE_ID, JSON.stringify(localCart));
        }

        // check collection for dupe
        duplicate = this.find(function (existingModel) {
            return existingModel.get('item.id') === cartPortfolioItem.get('item.id');
        });
        if (duplicate) {
            // may not be necessary, but in case the newer model is inflated
            duplicate.set('item', cartPortfolioItem.get('item'));
            return;
        }

        return LocalCartCollection.__super__.add.call(this, cartPortfolioItem, options);
    },
    remove: function remove(model, options) {
        var _this3 = this;

        var localCart = cartStorage.getItem(LOCAL_STORAGE_ID);
        var updatedCart;

        if (_.isArray(model)) {
            model.forEach(function (singleModel) {
                return _this3.remove(singleModel, options);
            });
            return;
        }
        updatedCart = localCart ? localCart.filter(function (item) {
            return item.id !== model.get('item.id');
        }) : undefined;
        if (updatedCart) {
            cartStorage.setItem(LOCAL_STORAGE_ID, JSON.stringify(updatedCart));
        }
        return LocalCartCollection.__super__.remove.call(this, model, options);
    },
    reset: function reset(models, options) {
        if (_.isUndefined(models)) {
            cartStorage.deleteItem(LOCAL_STORAGE_ID);
        }
        return LocalCartCollection.__super__.reset.call(this, models, options);
    }
});

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var PortfolioItemCollection = __webpack_require__(123);
var CartPortfolioItem = __webpack_require__(54);
var Items = __webpack_require__(129);
var Storage = __webpack_require__(76);
var User = __webpack_require__(28);
var bunsen = __webpack_require__(21);
var endpoints = __webpack_require__(6);
var countStorage = Storage.sessionStorage;

var ServiceCartCollection = module.exports = PortfolioItemCollection.extend({
    model: CartPortfolioItem,
    url: function url() {
        return bunsen.extendURL(endpoints.cartPortfolio(User.getUserId()), { type: 'CART', loadItems: 'Y' });
    },
    comparator: function comparator(modelOne, modelTwo) {
        return modelTwo.get('id') - modelOne.get('id');
    },
    fetch: function fetch(options) {
        var _this = this;

        var numItems = options ? options.numberOfItems : false;
        var fetchPromise = void 0;
        if (numItems && numItems < this.length) {
            fetchPromise = this._fetchSome(numItems);
        } else {
            fetchPromise = ServiceCartCollection.__super__.fetch.call(this, Object.assign({ silent: true }, options));
        }
        // Make this a feature for other collections to make use of?
        return fetchPromise.then(function () {
            return _this.checkStaleData.call(_this, options) || fetchPromise;
        });
    },
    _fetchSome: function _fetchSome(numItems) {
        var _this2 = this;

        var itemIdsArr = void 0;
        var appendItemIdsArr = void 0;
        var items = void 0;

        if (!this.length) {
            return $.Deferred().resolve();
        }
        itemIdsArr = this.map(function (item) {
            return item.get('item.id');
        });
        items = new Items();
        itemIdsArr = itemIdsArr.slice(-numItems);
        appendItemIdsArr = itemIdsArr.slice(0, -numItems);
        items.setParam('pk', itemIdsArr.join(' '), { filterQuery: true });
        return items.fetchWithParameters().done(function (data) {
            _this2.reset(data.result.items.map(function (item) {
                return new CartPortfolioItem({ item: item });
            }).concat(appendItemIdsArr.map(function (itemId) {
                return new CartPortfolioItem({ item: { id: itemId } });
            })));
        });
    },
    checkStaleData: function checkStaleData(options) {
        // Necessary to handle stale data caused by bfcache in firefox/safari
        var storedCount = countStorage.getItem('cartCount');
        options = options || {};
        if (!(typeof storedCount === 'number') || options.numberOfItems < this.length) {
            return false;
        }
        if (storedCount !== this.length) {
            countStorage.deleteItem('cartCount');
            return this.fetch(options);
        }
        return false;
    },
    add: function add(model, options) {
        var _this3 = this;

        var cartPortfolioItem = void 0;
        var ret = void 0;

        if (Array.isArray(model)) {
            model.forEach(function (singleModel) {
                return _this3.add(singleModel, options);
            });
            return true;
        }
        if (model instanceof CartPortfolioItem) {
            cartPortfolioItem = model;
        } else {
            cartPortfolioItem = new CartPortfolioItem();
            cartPortfolioItem.set({ item: model });
            cartPortfolioItem.save({ 'item.id': model.get('id') });
        }
        ret = ServiceCartCollection.__super__.add.call(this, cartPortfolioItem, options);
        countStorage.setItem('cartCount', this.length);
        return ret;
    },
    remove: function remove(model, options) {
        var _this4 = this;

        var ret = void 0;
        if (Array.isArray(model)) {
            model.forEach(function (singleModel) {
                return _this4.remove(singleModel, options);
            });
            return false;
        }
        ret = ServiceCartCollection.__super__.remove.call(this, model, options);
        countStorage.setItem('cartCount', this.length);
        return ret;
    }
});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var _ = __webpack_require__(0);

/**
 * @class Proxier is a class that takes a target object as a parameter and returns another object
 *        that proxies/delegates any references to it to the target object. This is useful for
 *        instances like the cart that has an implementation for when a user is logged off and
 *        another for when they are logged in (see ProxiedCartCollection).
 *
 *  Sample Usage:
 *      var someModel = new Backbone.Model({ text: 'this belongs to someModel' });
 *      var anotherModel = new Backbone.Model({ text: 'this is anotherModel'});
 *      var proxiedObj = new Proxier(someModel);
 *      proxiedObj.get('text'); // "this belongs to someModel"
 *      proxiedObj.__proxySwitch(anotherModel);
 *      proxiedObj.get('text'); // "this is anotherModel"
 */

var PROXIER_PROPERTIES = ['__proxySwitch', '__preserveEvents', '__forcePrototype'];
var FORCE_PROXY_PROPS = ['_events', '_listenerId', '_listenId']; // These are not necessarily defined at proxy time

// only in underscore 1.8
var allKeys = function allKeys(obj) {
    var keys = [];
    if (!_.isObject(obj)) {
        return [];
    }
    for (var key in obj) {
        // eslint-disable-line
        keys.push(key);
    }
    return keys;
};

function bindProxy(obj, target, forcePrototype) {
    var proxy;
    var proxiedKeys = _.union(allKeys(target), FORCE_PROXY_PROPS);
    if (obj) {
        proxy = obj;
        _.each(allKeys(proxy), function (key) {
            if (!_.contains(PROXIER_PROPERTIES, key)) {
                delete proxy[key];
            }
        });
        // Computationally expensive, has to be forced
        if (Object.setPrototypeOf && forcePrototype) {
            Object.setPrototypeOf(proxy, Object.getPrototypeOf(target));
        }
    } else {
        proxy = Object.create(Object.getPrototypeOf(target)); // JS optimizer friendly
    }
    _.each(proxiedKeys, function (key) {
        Object.defineProperty(proxy, key, {
            configurable: true,
            get: function get() {
                return _.isFunction(target[key]) ? $.proxy(target[key], target) : target[key];
            },
            set: function set(val) {
                return target[key] = val;
            }
        });
    });
    return proxy;
}

/**
 * @param {object} target - the target object to proxy
 * @param {object} options - options object for Proxier
 * @param {boolean} options.preserveEvents - (optional) events on all objects are shared and handlers will
 *      only execute on the proxied object
 * @param {boolean} options.forcePrototype - (optional) force the prototype of the proxy to any new target
 *      so `instanceof` of the proxy will always match the object being proxied.
 *      NOTE: only do when necessary because it is computationally expensive to do.
 */
var Proxier = function Proxier(target, options) {
    options = options || {};
    this.__preserveEvents = options.preserveEvents;
    this.__forcePrototype = options.forcePrototype;
    this.__proxySwitch(target);
};

_.extend(Proxier.prototype, {
    __proxySwitch: function __proxySwitch(target) {
        var prevEvents;
        var listenId;
        var listenKey;
        if (this.__preserveEvents) {
            prevEvents = this._events || undefined;
            if (this._listenerId) {
                listenKey = '_listenerId';
                listenId = this._listenerId;
            } else if (this._listenId) {
                listenKey = '_listenId';
                listenId = this._listenId;
            }
        }
        bindProxy(this, target, this.__forcePrototype);
        this._events = prevEvents;
        if (listenKey && listenId) {
            this[listenKey] = listenId;
        }
        return this;
    }
});

module.exports = Proxier;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.

var _ = __webpack_require__(153);
var Events = __webpack_require__(221).Events;

var urlError = __webpack_require__(55).urlError;
var wrapError = __webpack_require__(55).wrapError;

var array = [];
var push = array.push;
var slice = array.slice;
var splice = array.splice;

var Model = module.exports.Model = function(attributes, options) {
  var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    sync : function(){

      throw new Error("Sync component not used");

    },
    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true}, options);

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !options.wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

Model.extend = __webpack_require__(55).extend;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

const assign = __webpack_require__(154);
const CustomEvent = __webpack_require__(205);
module.exports = function (node, name, detail, options) {
    options = assign({
        bubbles: true,
        detail: detail
    }, options);
    return node.dispatchEvent(new CustomEvent(name, options));
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var assign = __webpack_require__(210);
var contentKey = '__ellipsis-original-content';
var canscroll = function (el, tolerance) {
    var scrollRoom = 0,
        ost = 0, // old scroll top
        nst, // new scroll top
        origScrolltop;
    // Determine if $el can be scrolled by modifying scrollTop and checking if the change has stuck
    // Note: browsers have different tolerances.
    origScrolltop = el.scrollTop;
    el.scrollTop = 0;
    el.scrollTop = 1;
    nst = el.scrollTop; // new scroll top
    while (ost !== nst) {
        ost = el.scrollTop;
        el.scrollTop = ost + 1;
        nst = el.scrollTop;
        ++scrollRoom;
        if (scrollRoom > tolerance) { // break early if we can
            break;
        }
    }
    el.scrollTop = origScrolltop; // put it back so nobody suspects nothin'
    return scrollRoom > tolerance;
};
module.exports = function (el, config) {
    config = config || {};
    var _canscroll;
    var low = 0;
    var high;
    var test;
    var try_this;
    var truncated;
    var ellipsis;
    var after_ellipsis;
    var breakables;
    var content;
    config = assign({
        async: true,
        skip_slow_browsers: false,
        tolerance: 1, // maximum amount the element can scroll before triggering the truncation
        content: false, // if not supplied here, content will be scraped from the element itself using $.fn.html()
        ellipsis: " &hellip; " // will be concatenated to the end of the content if it is truncated
    }, config);
    _canscroll = canscroll.bind(null, el, config.tolerance);
    content = config.content;
    if (false === content) {
        content = el[contentKey];
        if (undefined === content) {
            content = el.innerHTML;
            el[content] = content;
        } else {
            el.innerHTML = content;
        }
    }
    if (!content) {
        return;
    }
    breakables = content.split(/\s/);
    if (!_canscroll()) {
        return;
    }
    el.innerHTML = "";
    breakables.push(" ");
    breakables.push(" ");
    low = 0;
    high = breakables.length;
    while (high > low + 1) { // binary search to find the scrolling point
        test = Math.floor((low + high) / 2);
        el.innerHTML = breakables.slice(0, test).join(" ") + " ";
        if (_canscroll()) {
            high = test;
        } else {
            low = test;
        }
    }
    var last = breakables.slice(0, high - 1).join(' ') + " ";
    after_ellipsis = document.createElement('span');
    after_ellipsis.style.display = 'none';
    after_ellipsis.classList.add('ellipsised-content');
    ellipsis = document.createElement('span');
    ellipsis.classList.add('ellipsis');
    ellipsis.innerHTML = config.ellipsis;
    truncated = document.createElement('span');
    truncated.classList.add('truncated-content');
    truncated.innerHTML = last;
    el.innerHTML = '';
    el.appendChild(truncated);
    el.appendChild(ellipsis);
    el.appendChild(after_ellipsis);
    try_this = last;
    // if the ellipsis has made the element scroll again, back off character by character until it doesnt
    while (try_this) {
        if (try_this.substr(-1).match(/\s/) && !_canscroll()) { // if we are at a space and cannot scroll
            break;
        }
        try_this = try_this.substr(0, try_this.length - 1);
        truncated.innerHTML = try_this;
    }
    if (try_this.length !== last.length) {
        after_ellipsis.innerHTML = last.substr(try_this.length - last.length);
    }
    after_ellipsis.innerHTML += breakables.slice(high - 1).join(" ");
    el.innerHTML = el.innerHTML.trim();
}


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var forEach = __webpack_require__(59);
var debounce = __webpack_require__(105);
var classList = __webpack_require__(203);
var matches = __webpack_require__(38);

module.exports = [
    {
        name: 'click',
        init : function (bindingData, model, view) {
            this.addEventListener('click', function () {
                bindingData.apply(view, arguments);
            });
        }
    }, {
        // binds to object attributes. Attributes should be specified as a map from key (attribute name) to value (attribute value) in the binding expression. Attributes are set using Element.prototype.setAttribute
        name: 'prop',
        update : function () {
            forEach(arguments[0], function (attrValue, attrName) {
                if (!attrValue) {
                    this.removeAttribute(attrName);
                } else {
                    this.setAttribute(attrName, true);
                }
            }.bind(this));
        }
    }, {
        name: 'attr',
        update : function () {
            forEach(arguments[0], function (attrValue, attrName) {
                this.setAttribute(attrName, attrValue);
            }.bind(this));
        }
    }, {
        name: 'style',
        update : function () {
            forEach(arguments[0], function (attrValue, attrName) {
                this.setAttribute(attrName, attrValue);
            }.bind(this));
        }
    }, {
        name: 'css',
        update : function (bindingData) {
            var nodeClassList = classList(this);
            forEach(bindingData, function (v, k) {
                nodeClassList[v ? 'add' : 'remove'].apply(nodeClassList, k.split(' '));
            });
        }
    }, {
        // if the binding expression is false, the element is hidden, otherwise the element is shown.
        name: 'visible',
        update : function (bindingData) {
            if (bindingData) {
                this.style.display = '';
            } else {
                this.style.display = 'none';
            }
        }
    }, {
        name: 'hidden',
        update : function (bindingData) {
            this.style.visibility = bindingData ? 'visible' : 'hidden';
        }
    },
    {
        name: 'textarea',
        init : function (bindingData, model) {
            this.addEventListener('keyup', debounce(function () {
                model.set(bindingData, this.value);
            }.bind(this), 200));
        }
    }, {
        // binds the text of an element (using textContent property of element instance) to the binding expression
        name: 'text',
        update : function (bindingData) {
            this.textContent = bindingData;
        }
    }, {
        // binds the html of an element (using innerHTML property of element instance) to the binding expression
        name: 'html',
        update : function (bindingData) {
            this.innerHTML = bindingData;
        }
    }, {
        // binds the value of an input field to the value of the binding expression
        name: 'val',
        update: function (bindingData) {
            if (this.matches(':radio,:checkbox') && !matches(this, ':checked')) { // TODO: handle this case when the need arises
                console.warn("val binding for checkable elements is not yet supported");
                return;
            }
            this.value = bindingData;
        }
    }, {
        name: 'contenteditable',
        init : function (bindingData, model) {
            var contenteditable = this.getAttribute('contenteditable');
            var property = contenteditable.match(/^plaintext/) ? 'textContent' : 'innerHTML';
            var handler = function () {
                model.set(bindingData, this[property]());
            }.bind(this);
            ['change', 'keyup', 'keydown'].forEach(function (eventName) {
                this.addEventListener(eventName, handler);
            }.bind(this));
        }
    }, {
        name: 'contenteditablePlaintext',
        init : function (bindingData, model) {
            var handler = function () {
                model.set(bindingData, this.textContent);
            }.bind(this);
            ['change', 'keyup', 'keydown'].forEach(function (eventName) {
                this.addEventListener(eventName, handler);
            }.bind(this));
        }
    }, {
        name: 'modelval',
        init : function (bindingData, model) {
            this.addEventListener('change', function () {
                model.set(bindingData, this.value);
            }.bind(this));
        }
    }
];


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 154 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var Actions = SoaCollection.extend();

var Action = __webpack_require__(51);

_.extend(Actions.prototype, {
    model : Action,
    hasCode : function (code) {
        return this.any(function (action) {
            return action.isCode(code);
        });
    },
    getActionStartDate : function (code) {
        var action = this.findWhere({code: code});
        return action && action.get('startDate');
    }
});

module.exports = Actions;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/21/14
 * Time: 5:57 PM
 */



var SoaCollection = __webpack_require__(9);
var Disbursement = __webpack_require__(171);

module.exports = SoaCollection.extend({
    model: Disbursement,
    getDealerDisbursement: function () {
        return this.find(function (disbursement) {
            return disbursement.isDealerDisbursement();
        });
    },
    getShipperDisbursement: function () {
        return this.find(function (disbursement) {
            return disbursement.isShipperDisbursement();
        });
    }
});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var EcomCharges = SoaCollection.extend();

var EcomCharge = __webpack_require__(172);

_.extend(EcomCharges.prototype, {
    model : EcomCharge
});

module.exports = EcomCharges;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Lior Elrom
 * Date: 12/1/15
 * Time: 9:31 AM
 */



var SoaCollection = __webpack_require__(9);
var InvoiceItems = SoaCollection.extend();

var _ = __webpack_require__(0);
var InvoiceItem = __webpack_require__(173);

var getInvoiceItemAmountByType = function (type, currency) {
    var invoiceItems = this.filter(function (item) {
        return item.get('code') === type;
    });

    if (invoiceItems) {
        return _.reduce(invoiceItems, function (memo, item) {
            return memo + (parseFloat(item.getTotalAmount(currency)) || 0);
        }, 0);
    }
    return 0;
};

_.extend(InvoiceItems, {
    TYPE_OFFER_COST: 'OFFER_COST',
    TYPE_OFFER_SALES_TAX: 'OFFER_SALES_TAX',
    TYPE_OFFER_PROMOTION: 'OFFER_PROMOTION',
    TYPE_SHIPMENT_COST: 'SHIPMENT_COST',
    TYPE_SHIPMENT_SALES_TAX: 'SHIPMENT_SALES_TAX',
    TYPE_SHIPMENT_TOTAL_COST: 'SHIPMENT_TOTAL_COST',
    TYPE_DEALER_SHIPMENT_SALES_TAX: 'DEALER_SHIPMENT_SALES_TAX',
    TYPE_FIRSTDIBS_SHIPMENT_SALES_TAX: 'FIRSTDIBS_SHIPMENT_SALES_TAX',
    TYPE_ITEM_PRICE: 'ITEM_PRICE',
    TYPE_PRODUCT_CUSTOMIZATION: 'PRODUCT_CUSTOMIZATION',
    TYPE_ADJUSTMENT_SALES_TAX: 'ADJUSTMENT_SALES_TAX',
    TYPE_CUSTOMER_CHARGE: 'CUSTOMER_CHARGE',
    TYPE_DEALER_SHIPMENT_REFUND: 'DEALER_SHIPMENT_REFUND',
    TYPE_FIRSTDIBS_SHIPMENT_REFUND: 'FIRSTDIBS_SHIPMENT_REFUND',
    TYPE_ITEM_REFUND: 'ITEM_REFUND',
    TYPE_DEALER_REFUND: 'DEALER_REFUND'
});

_.extend(InvoiceItems.prototype, {
    model: InvoiceItem,
    getOfferCost             : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_OFFER_COST),
    getAdjustmentSalesTax    : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_ADJUSTMENT_SALES_TAX),
    getOfferSalesTax         : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_OFFER_SALES_TAX),
    getOfferPromotion        : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_OFFER_PROMOTION),
    getShipmentCost          : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_SHIPMENT_COST),
    getShipmentSalesTax      : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_SHIPMENT_SALES_TAX),
    getShipmentTotalCost     : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_SHIPMENT_TOTAL_COST),
    getItemPriceModification : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_ITEM_PRICE),
    getProductCustomization  : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_PRODUCT_CUSTOMIZATION),
    getCustomerCharge        : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_CUSTOMER_CHARGE),
    getDealerShipmentRefund  : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_DEALER_SHIPMENT_REFUND),
    getFirstDibsShipmentRefund  : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_FIRSTDIBS_SHIPMENT_REFUND),
    getItemRefund            : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_ITEM_REFUND),
    getDealerRefund          : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_DEALER_REFUND)
});

module.exports = InvoiceItems;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/21/14
 * Time: 5:57 PM
 */



var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var Invoice = __webpack_require__(81);
var getInvoiceByFn = function (fn) {
    return this.find(function (invoice) {
        return invoice[fn]() && invoice.get("status") !== Invoice.STATUS_CANCELED;
    });
};

module.exports = SoaCollection.extend({
    model: Invoice,
    getDealerInvoice: _.partial(getInvoiceByFn, 'isDealerInvoice'),
    getBuyerInvoice: _.partial(getInvoiceByFn, 'isBuyerInvoice'),
    getShipperInvoice: _.partial(getInvoiceByFn, 'isShipperInvoice')
});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var Offer = __webpack_require__(26);
var endpoints = __webpack_require__(6);
var moment = __webpack_require__(30);
var root = typeof window === 'undefined' ? global : window;

root.bunsen = root.bunsen || {};

/**
 * @mixes bunsen.SoaCollection
 * @class
 * @property {bunsen.Offer} model - {@link bunsen.Offer}
 * @property {bunsen.endpoints.offers} url -
 */
module.exports = root.bunsen.Offers = SoaCollection.extend({
    url: endpoints,
    model: Offer,
    comparator: function (offer) {
        return parseInt(moment(offer.get("createdDate")).format("X"), 10) || -1;
    },
    // Use getters in case this changes
    getMostRecent: function () {
        return this.last();
    },
    getMostRecentBuyerOffer: function () {
        return _.find(this.toArray().reverse(), function (o) {
            return o.isBuyerInitiatedOffer();
        });
    },
    getMostRecentDealerOffer: function () {
        return _.find(this.toArray().reverse(), function (o) {
            return o.isDealerInitiatedOffer();
        });
    },
    getFirst: function () {
        return this.first();
    }

});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/4/14
 * Time: 11:04 AM
 */



var SoaCollection = __webpack_require__(9);
var PaymentAuthorization = __webpack_require__(25);

module.exports = SoaCollection.extend({
    model: PaymentAuthorization,
    getOfferPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isOfferPaymentAuthorization();
        }, this);
    },
    getShippingPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isShippingPaymentAuthorization();
        }, this);
    },
    getActiveOfferPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isActive() && paymentAuth.isOfferPaymentAuthorization();
        }, this);
    },
    getActiveShippingPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isActive() && paymentAuth.isShippingPaymentAuthorization();
        }, this);
    },
    getDeniedCheckoutPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isDenied() && paymentAuth.isCheckoutPaymentAuthorization();
        }, this);
    },
    getCurrentCheckoutPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isCurrentCheckout() && paymentAuth.isCheckoutPaymentAuthorization();
        }, this);
    },
    getCurrentBalanceDuePaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isCurrentBalanceDue();
        }, this);
    },
    getBalanceDuePaymentAuthorizationForProcessing: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isReadyForProcessing() && paymentAuth.isBalanceDuePaymentAuthorization();
        }, this);
    },
    getCheckoutPaymentAuthorizationForProcessing: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isReadyForProcessing() && paymentAuth.isCheckoutPaymentAuthorization();
        }, this);
    },
    getStagedPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isStagedPaymentAuth();
        }, this);
    }
});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 12/3/14
 * Time: 6:30 PM
 */



var SoaCollection = __webpack_require__(9);
var Promotions = module.exports = SoaCollection.extend();

var _ = __webpack_require__(0);
var Promotion = __webpack_require__(175);
var findByFn = function (fn) {
    return this.find(function (promo) {
        return promo[fn]();
    });
};

_.extend(Promotions.prototype, {
    model: Promotion,
    getActivePromo: _.partial(findByFn, 'isActive'),
    getInvalidPromo: _.partial(findByFn, 'isInvalid')
});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var Refunds = SoaCollection.extend();

var Refund = __webpack_require__(176);

_.extend(Refunds.prototype, {
    model : Refund
});

module.exports = Refunds;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by dev on 10/13/15.
 */


var SoaCollection = __webpack_require__(9);
var Review = __webpack_require__(82);
var Reviews = module.exports = SoaCollection.extend();

module.exports = SoaCollection.extend({
    model: Review,
    getShippingRequest: function () {
        return this.findWhere({'type': Review.TYPE_SHIPPING_REQUEST});
    },
    removeShippingRequestReview: function () {
        this.remove(this.getShippingRequest());
    }
});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SoaCollection = __webpack_require__(9);
var Message = __webpack_require__(72);
var moment = __webpack_require__(30);
module.exports = SoaCollection.extend({
    model: Message,
    comparator: function (modelOne, modelTwo) {
        // if a model isn't from server, it should come last
        if (!modelOne.id) {
            return 1;
        }
        if (!modelTwo.id) {
            return -1;
        }
        return moment(modelOne.get('createdDate')).format('X') - moment(modelTwo.get('createdDate')).format('X');
    },
    initialize : function (models, options) {
        this.conversationId = options.conversationId;
    }
});


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);

// ---------------------------------------------------
// Module Definition

// This makes the function do nothing on prod/testing environments
// So that we don't generate errors.
var checkProps = module.exports = function () {};

// The block below re-defining the checkProps module gets
// removed on prod/testing environments
/* develblock:start */
/**
 * @module checkProps
 * @type {function}
 * @param {object} propsConfig
 *      An object with keys being the allowed
 *      keys of the 'values' parameter, and the
 *      values being type or constructor function
 * @param {object} values
 *      An object with keys and values being of the
 *      name/type combination specified in the
 *      propsConfig parameter
 * @param {object} errorMessageCallbacks
 *      If you want to replace any of the callbacks
 *      for specific kinds of errors.
 *
 * @property {PropsChecker} PropsChecker
 */
checkProps = module.exports = function (propsConfig, values, errorMessageCallbacks) {
    return new checkProps.PropsChecker(propsConfig, errorMessageCallbacks).checkValues(values);
};
/* develblock:end */

// ---------------------------------------------------
// Define Module Static Properties

/**
 * @class PropsChecker
 * @memberOf module:checkProps
 * @param {object} propsConfig
 * @param {object} options
 * @constructor
 */
var PropsChecker = function (propsConfig, options) {
    options = options || {};
    this.propsConfig = propsConfig || this.propsConfig;
    this.handleTypeErrors = options.handleTypeErrors || this.handleTypeErrors;
    this.supportedError = options.supportedError || this.supportedError;
    this.parentProp = options.parentProp || this.parentProp;
    this._options = options;
};

checkProps.PropsChecker = PropsChecker;

_.extend(PropsChecker.prototype, {

    /**
     * @param {object} errorMessageCallbacks
     * @returns {PropsChecker}
     */
    setErrorMessageCallbacks: function (errorMessageCallbacks) {
        errorMessageCallbacks = errorMessageCallbacks || {};
        return this;
    },

    /**
     * @param {object} values
     * @returns {PropsChecker}
     */
    checkValues: function (values) {
        var propName;

        if (values === null || values === undefined) {
            return this;
        }

        if (typeof values !== 'object') {
            return this.valuesIsObjectError();
        }

        for (propName in values) {
            if (values.hasOwnProperty(propName)) {
                this.checkValueForProp(propName, values);
            }
        }

        return this;
    },

    /**
     * If you want to evaluate a specific property
     * and test it for type errors
     * @param {string} propName
     * @param {object} values
     * @returns {PropsChecker}
     */
    checkValueForProp: function (propName, values) {
        var propsConfig = this.propsConfig;
        var isArray;
        var typeErrors;
        var types;
        var value;

        if (!propsConfig.hasOwnProperty(propName)) {

            this.handleSupportedError(propName);

        } else {

            value = values[propName];
            types = propsConfig[propName];
            isArray = _.isArray(types);

            if (!isArray && typeof types === 'object') {
                new checkProps.PropsChecker(types, this._getOptionsClone(propName)).checkValues(value);
                return this;
            }

            types = isArray ? types : [types];

            if (_.first(types) === '*' || value === null || value === undefined) {
                return this;
            }

            typeErrors = this.findErrorsForEachType(types, value);
            if (typeErrors && typeErrors.length) {
                this.handleTypeErrors(propName, typeErrors);
            }

        }
        return this;
    },

    findErrorsForEachType: function (types, value) {
        var errors = [];
        var i = 0;
        var hasValidType;
        for (i; i < types.length; i++) {
            errors.push(this.findErrorsForType(types[i], value));
        }
        hasValidType = _.any(errors, function (error) {
            return error === null;
        });
        if (!hasValidType) {
            return errors;
        }
        return null;
    },

    findErrorsForType: function (type, value) {
        if (typeof type === 'string') {
            if (type === 'array' && !this.checkIsArray(value)) {
                return {
                    key: 'array',
                    typeVal: 'array'
                };
            } else if (!this.checkTypeof(type, value))  {
                return {
                    key: 'type',
                    typeVal: type
                };
            }
        } else if (typeof type === 'function' && !this.checkIsInstanceOf(type, value)) {
            return {
                key: 'instanceof',
                typeVal: type
            };
        }
        return null;
    },

    checkTypeof: function (type, value) {
        return typeof value === type;
    },

    checkIsArray: function (value) {
        return _.isArray(value);
    },

    checkIsInstanceOf: function (type, value) {
        return value instanceof type;
    },

    handleTypeErrors: function (propName, typeErrors) {
        console.error('Property ' + this._getFormatedPropName(propName) + ' is not of the correct ' +
            'type: must be one of the following: ', _.pluck(typeErrors, 'typeVal'));
        return this;
    },

    handleSupportedError: function (propName) {
        console.error(this.supportedError(propName));
        return this;
    },

    /**
     * @param {string} propName
     * @returns {string}
     */
    supportedError: function (propName) {
        return "Property name '" + this._getFormatedPropName(propName) + "' not supported";
    },

    setIsSubPropForName: function (propName) {
        this.subPropName = propName;
        return this;
    },

    valuesIsObjectError: function () {
        if (this.subPropName) {
            console.error('Property ' + this.subPropName + ' must have an object for it\'s value');
        } else {
            console.error('Values must be an object');
        }
        return this;
    },

    _getFormatedPropName: function (propName) {
        if (this.parentProp) {
            propName = this.parentProp + '.' + propName;
        }
        return propName;
    },

    _getOptionsClone : function (parentProperty) {
        return _.extend({}, this._options, { parentProp: parentProperty });
    }

});


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var _ = __webpack_require__(0);

var deferredHelpers = module.exports = {
    /**
     * Returns a promise that resolves after a delay
     * @param timeout in ms
     * @returns Promise
     */
    wait: function (timeout) {
        return $.Deferred(function (dfd) {
            setTimeout(dfd.resolve, timeout);
        }).promise();
    },
    /**
     * Wraps a promise in a deferred so we can cancel it
     * @private
     */
    wrapDeferred: function (jqXHR) {
        var dfd = new $.Deferred();
        jqXHR.then(dfd.resolve, dfd.reject);
        return dfd;
    },
    /**
     * Cancels an unresolved deferred after timeout has elapsed
     * @param dfd
     * @param timeout
     */
    cancelAfter: function (dfd, timeout) {
        var id = setTimeout(function () {
            if (dfd.state() === 'pending') {
                dfd.reject({status: 'timeout'});
            }
        }, timeout);

        dfd.done(function () {
            clearTimeout(id);
        });
    },
    /**
     * Run the provided function over and over until it works!
     * @param fn a function that returns a promise
     * @param maxTries number of times to retry
     * @param {Function} [condition] only retry if condition is true
     */


    retry: function (fn, maxTries, condition) {
        return fn().then(null, function (result) {
            if (maxTries > 1) {
                if (_.isFunction(condition) && !condition(result)) {
                    return result;
                }
                return deferredHelpers.retry(fn, maxTries - 1, condition);
            }
            return result;
        });
    },
    /**
     * Retry the jqXhr returning function over and over until it's not a 500
     * @param fn
     * @param maxTries
     * @returns {*}
     */
    retry500: function (fn, maxTries) {
        return deferredHelpers.retry(fn, maxTries, function (jq) {
            return jq.status >= 500;
        });
    }
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/5/15
 * Time: 7:20 PM
 */



var braintree;
if (typeof window !== 'undefined') {
    braintree = window.braintree;
}

module.exports = {
    checkout: function (clientToken, options) {
        return braintree.setup(clientToken, 'paypal', options);
    },
    /**
     * Takes a paypalData object from braintree and transforms it into an object
     * representing a backend PayPalAccount model
     * @param paypalData
     * @returns {{nonce: *, firstName: *, lastName: *, email: *, billingAddress: {city: *, country: (exports.displayLabels.countryCode|*|exports.displayTransforms.countryCode), line1: (*|mockUS.line1|mockNonUS.line1|UserProfile.displayLabels.line1|exports.displayLabels.line1|line1), line2: (*|mockUS.line2|mockNonUS.line2|UserProfile.displayLabels.line2|exports.displayLabels.line2|line2), zipCode: (.billingAddress.postalCode|*), state: *}}}
     */
    getPayPalModelData: function (paypalData) {
        var details;
        var billingAddress;
        paypalData = paypalData || {};
        details = paypalData.details || {};
        billingAddress = details.billingAddress || {};
        return {
            nonce: paypalData.nonce,
            firstName: details.firstName,
            lastName: details.lastName,
            email: details.email,
            billingAddress: {
                city: billingAddress.locality,
                country: billingAddress.countryCodeAlpha2,
                line1: billingAddress.streetAddress,
                line2: billingAddress.extendedAddress,
                zipCode: billingAddress.postalCode,
                state: billingAddress.region
            }
        };
    }
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/***
 * abstracts a file object into an attachment that can be uploaded to the boss service
 * options.uploadType : "image", "csv", or "message_center"
 * options.allowedFileType {array} - MIME types to support
 */

var SoaModel = __webpack_require__(2);
var Deferred = __webpack_require__(29).Deferred;
var bunsen = __webpack_require__(21);
var endpoints = __webpack_require__(6);
var filesize = __webpack_require__(197);
var Qs = __webpack_require__(42);
var assign = __webpack_require__(60);
var last = __webpack_require__(133);
var flow = __webpack_require__(198);
var FormData = __webpack_require__(137);

var Attachment = module.exports = SoaModel.extend({
    url : function (method) {
        if (this.uploadType === 'itemImage') {
            return endpoints.itemImageUpload();
        } else {
            return endpoints.cmsUpload(this.uploadType, method === 'create' ? this.get('dir') : undefined);
        }
    },
    sync : function (method, model, passedOptions) {
        // custom sync function so we can perform a multipart upload per the spec here: https://sites.google.com/a/1stdibs.com/wiki/home/engineering/services-documentation/boss-service/generic-file-uploader?pli=1
        var lastSave = Deferred();
        //always include user token in param
        var params = bunsen.getToken();
        var isDelete = method === 'delete';
        var defaultOptions;
        var options;
        var sank;

        if (passedOptions.itemId) {
            params.itemId = passedOptions.itemId;
        }

        if (isDelete) {
            params.keys = this.get('key');
            defaultOptions = {
                type: 'DELETE'
            };
        } else {
            defaultOptions = {
                xhr : function () { // make our own xhr so we can notify lastSave of its progress events
                    var xhr = new XMLHttpRequest();
                    xhr.upload.addEventListener("progress", function (e) {
                        this.set('upload-sent', e.loaded);
                        this.set('upload-total', e.total);
                        this.set('bitrate', e.bitrate);
                        lastSave.notify(e);
                    }.bind(this));
                    return xhr;
                }.bind(this),
                clump: false, // prevents autoclump from handing this
                type: 'POST',
                contentType: false, // forces multipart
                processData: false,
                data : new FormData(),
                cache : false
            };

            this.set('uploadStatus', 'pending');
        }

        defaultOptions.url = this.url(method) + "?" + Qs.stringify(params);
        options = assign(defaultOptions, passedOptions);

        sank = this.loaded.then(function (file) {
            var _sank;
            if (!isDelete && file) {
                defaultOptions.data.append('files', file, file.name);
            }
            _sank = Attachment.__super__.sync.call(this, method, model, options)
                .done(lastSave.resolve.bind(lastSave))
                .fail(lastSave.reject.bind(lastSave));
            lastSave.abort = _sank.abort.bind(_sank);
            return _sank;
        }.bind(this));

        //set lastSave promise if it has not been attached to the model
        if (!this.lastSave) {
            lastSave.always(flow(lastSave.state.bind(lastSave), this.set.bind(this, 'uploadStatus')));
            this.lastSave = lastSave;
        }
        return lastSave;
    },
    parseFile : function () {
        var file = this.get('file');
        var parsedFile = Deferred();
        var arrayBufferReader;
        var dataUrlReader;
        // TODO: fileBlob should be unset here, but is currently causing parseFile() to be called repeatedly due to 'change:fileBlob'
        //this.set('fileBlob', undefined);
        if (undefined === file) {
            return; // file not set yet
        }
        this.set('fileName', file.name);
        this.set('fileSize', file.size);
        this.set('displaySize', filesize(file.size));
        // update data-uri attribute
        if (!window.FileReader) {
            return;
        }
        arrayBufferReader = new window.FileReader();
        arrayBufferReader.onloadend = function () {
            var type = file.type;
            // workaround for chrome bug where mime type was not read correctly for xls files
            if (!type && last(file.name.split('.')) === 'xls') {
                type = 'application/vnd.ms-excel';
            }
            this.set('fileBlob', new Blob([arrayBufferReader.result], { type : type }));
            this.get('fileBlob').name = file.name;
            this.set('attachmentType', type);
            parsedFile.resolve(this.get('fileBlob'));
        }.bind(this);
        try {
            arrayBufferReader.readAsArrayBuffer(file);
        } catch (e) {
            parsedFile.reject();
            if (!(e instanceof TypeError)) {
                throw e;
            }
        }
        // need separate reader to avoid 'busy' error
        dataUrlReader = new window.FileReader();
        dataUrlReader.onloadend = function () {
            this.set('dataURI', dataUrlReader.result);
        }.bind(this);
        try {
            dataUrlReader.readAsDataURL(file);
        } catch (e) { /* do nothing if error occurs when reading data url */ }
        return parsedFile.promise();
    },
    parseAttachment: function () {
        this.set({
            'displayName': this.toDisplayName(this.get('sharedPath')),
            'displaySize': filesize(this.get('fileSize')),
            'thumbnailPath': this.getThumbnailPath(),
            'originalPath': this.isImageType() ? this.getOriginalPath() : this.getFullPath()
        });
    },
    toDisplayName: function (fileName) {
        return fileName && last(fileName.split('\\'));
    },
    getThumbnailPath: function () {
        return this.getFullPath('thumbnail');
    },
    getOriginalPath: function () {
        return this.getFullPath('original');
    },
    getFullPath: function (variantValue) {
        var sharedPath = this.get('sharedPath');

        if (variantValue) {
            sharedPath = this.replaceVariant(sharedPath, variantValue);
        }

        return [this.get('webPath'), this.get('webPathSuffix'), sharedPath].join('');
    },
    replaceVariant: function (path, value) {
        return path && path.replace('{variant}', value);
    },
    isImageType: function () {
        var type = this.get('attachmentType');
        return type && type.toLowerCase().indexOf('image') > -1;
    },
    initialize : function (attributes, options) {
        options = assign({
            allowedFileTypes: undefined,
            uploadType : 'image'
        }, options);
        this.uploadType = options.uploadType;

        //user uploaded file
        if (this.get('file')) {
            this.loaded = this.parseFile();
            //attachment coming from mc service
        } else if (this.get('sharedPath') && this.get('webPath')) {
            this.parseAttachment();
            this.loaded = Deferred().resolve().promise();
        }

        this.on('request', function (attachment, XHR) {
            this._xhr = XHR;
        });
    },
    // file failed to upload for some reason, abort request
    abort : function () {
        if (this._xhr.readyState !== 0 && this._xhr.readyState !== 4) {
            this._xhr.abort();
        }
    },
    defaults: {
        attachmentType: ''
    }
});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by augustocorvalan on 7/17/15.
 */


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var AnchorList = __webpack_require__(325);
var AnchorMember = __webpack_require__(80);

var PromoAnchorList = module.exports = AnchorList.extend();

_.extend(PromoAnchorList, {
    createAnchorList: function (sourceType, ids, note) {
        return new PromoAnchorList({ members: AnchorMember.createAnchorMembers(sourceType, ids, note) });
    }
});

_.extend(PromoAnchorList.prototype, {
    relations: SoaModel.createRelations([
        {
            key:          'members',
            type:         Backbone.Many,
            relatedModel: AnchorMember
        }
    ]),
    getIds: function () {
        var members = this.get('members') || [];
        return members.map(function (member) {
            return member.get('anchor.sourceId');
        });
    }
});


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Rob
 * Date: 8/20/13
 */


var SoaModel = __webpack_require__(2);
var Disbursement = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

// Attaching to bunsen until bOMT and checkout are commonJS
module.exports = root.bunsen.Disbursement = Disbursement;

var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var PaymentMethod = __webpack_require__(57);
var endpoints = __webpack_require__(6);
var Party = __webpack_require__(8);
var FinancialAmount = __webpack_require__(10);
var transitionMixin = __webpack_require__(19);

_.extend(Disbursement, {
    STATUS_NEW: 'NEW',
    STATUS_PAID: 'PAID'
});

_.extend(Disbursement.prototype, {
    idAttribute: "id",
    defaults: {
        paymentMethod: {}
    },
    url : function () {
        return endpoints.disbursement(this.get(this.idAttribute));
    },
    relations: [
        {
            key: 'paymentMethod',
            relatedModel: PaymentMethod,
            type: Backbone.One,
            saveJSONFields: ['paymentMethodType', 'apiType']
        },
        {
            key: 'payTo',
            relatedModel: Party,
            type: Backbone.One
        },
        {
            key: 'totalAmount',
            relatedModel: FinancialAmount,
            type: Backbone.One
        }
    ],
    isDealerDisbursement: function () {
        return this.get('payTo').isSeller();
    },
    isShipperDisbursement: function () {
        return this.get('payTo').isShipper();
    },
    isPaid: function () {
        return this.get('status') === Disbursement.STATUS_PAID;
    },
    isNewStatus: function () {
        return this.get('status') === Disbursement.STATUS_NEW;
    }
}, transitionMixin);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var EcomCharge = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Backbone = __webpack_require__(3);

var Party = __webpack_require__(8);
var FinancialAmount = __webpack_require__(10);

_.extend(EcomCharge, {

});

_.extend(EcomCharge.prototype, {
    relations : SoaModel.createRelations([
        {
            key : 'chargeParty',
            relatedModel : Party,
            type : Backbone.One
        },
        {
            key : 'amount',
            relatedModel : FinancialAmount,
            type : Backbone.One
        }

    ])
});



/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Lior Elrom
 * Date: 12/1/15
 * Time: 10:32 AM
 */



var SoaModel = __webpack_require__(2);
var InvoiceItem = SoaModel.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var financialAmountMixin = __webpack_require__(47);
var FinancialAmount = __webpack_require__(10);

_.extend(InvoiceItem.prototype, {
    relations: [
        {
            type: Backbone.One,
            key: 'subTotalAmount',
            relatedModel: FinancialAmount
        },
        {
            type: Backbone.One,
            key: 'totalAmount',
            relatedModel: FinancialAmount
        }
    ]
}, financialAmountMixin);

module.exports = InvoiceItem;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by lior on 12/4/14.
 */



var _ = __webpack_require__(0);
var SoaModel = __webpack_require__(2);
var PaymentProviderResponse = module.exports = SoaModel.extend();

var propEquals = function (propName, value) {
    return this.get(propName) === value;
};

_.extend(PaymentProviderResponse, {
    STATUS_SUCCESS: 'SUCCESS',
    STATUS_DATA_ERROR: 'DATA_ERROR',
    STATUS_PROCESSOR_ERROR: 'PROCESSOR_ERROR',
    ACTION_RESERVE: 'RESERVE',
    ACTION_CAPTURE: 'CAPTURE',
    ACTION_VAULT: 'VAULT_TRANSACTION'
});

_.extend(PaymentProviderResponse.prototype, {
    getErrorStatus: function () {
        return this.get('status');
    },
    isDataError: _.partial(propEquals, 'status', PaymentProviderResponse.STATUS_DATA_ERROR),
    isProcessorError: _.partial(propEquals, 'status', PaymentProviderResponse.STATUS_PROCESSOR_ERROR),
    isSuccess: _.partial(propEquals, 'status', PaymentProviderResponse.STATUS_SUCCESS),
    isReserveTransaction: _.partial(propEquals, 'requestAction', PaymentProviderResponse.ACTION_RESERVE),
    isCaptureTransaction: _.partial(propEquals, 'requestAction', PaymentProviderResponse.ACTION_CAPTURE),
    isVaultTransaction: _.partial(propEquals, 'requestAction', PaymentProviderResponse.ACTION_VAULT)
});



/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 12/3/14
 * Time: 6:33 PM
 */



var SoaModel = __webpack_require__(2);
var Promotion = module.exports = SoaModel.extend();

var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Backbone = __webpack_require__(3);
var Adjustment = __webpack_require__(130);
var Rule = __webpack_require__(177);
var Anchor = __webpack_require__(12);
var ruleTypes = ['ItemList', 'DealerList', 'BuyerList', 'PurchaseHistory', 'VerticalList', 'PriceRange', 'UsesPerBuyer', 'UsesPerCode'];
var ruleTypeMap = {
    'ItemList': [Rule.TYPE_ITEM_WHITE, Rule.TYPE_ITEM_BLACK],
    'DealerList': [Rule.TYPE_DEALER_WHITE, Rule.TYPE_DEALER_BLACK],
    'BuyerList': [Rule.TYPE_BUYER_WHITE, Rule.TYPE_BUYER_BLACK],
    'PurchaseHistory': [Rule.TYPE_PURCHASE_HISTORY],
    'VerticalList': [Rule.TYPE_VERTICAL_WHITE],
    'PriceRange': [Rule.TYPE_PRICE_RANGE],
    'UsesPerBuyer': [Rule.TYPE_USES_PER_BUYER],
    'UsesPerCode': [Rule.TYPE_USES_PER_CODE],
    'VerifiedTradeBuyer': [Rule.TYPE_VERIFIED_TRADE]
};
var buyerErrors = ["USES_PER_BUYER_EXCEEDED_ERROR", "BUYER_BLACKLIST_ERROR", "BUYER_WHITELIST_ERROR", "PURCHASE_HISTORY_ERROR"];

// ---------------------------------------------------
// Factory Methods
var getAdjustmentRateByApiType = function (apiType) {
    var adjustmentRateList = this.get('adjustmentRateList');
    if (adjustmentRateList) {
        return adjustmentRateList.findWhere({apiType: apiType});
    }
};

var hasAdjustmentRateApiType = function () {
    return !!getAdjustmentRateByApiType.apply(this, arguments);
};

var setAdjustment = function (apiType, rate, eligibleAmount) {
    // you can only have one adjustment for now
    this.set('adjustmentRateList', [{
        apiType: apiType,
        reference: Adjustment.REFERENCE_FIRSTDIBS_PROMOTION_OFFER_DISCOUNT,
        rate: rate,
        eligibleAmount: eligibleAmount,
        calculationTarget: {
            documentType : 'OFFER'
        }
    }]);
};

/**
 * @param {array} apiTypes
 */
var getRule = function (apiTypes) {
    var self = this;
    var rule;

    _.find(apiTypes, function (apiType) {
        rule = self.get('ruleList').findWhere({ apiType: apiType });
        return rule;
    });

    return rule;
};

/**
 * @param {array} apiTypes
 */
var removeRule = function (apiTypes) {
    var ruleList = this.get('ruleList');

    _.each(apiTypes, function (apiType) {
        return ruleList.remove(ruleList.where({ apiType: apiType }));
    });

    return this;
};

var addRule = function (apiType, name, sourceType, ids, note) {
    return this._addSingletonRule(apiType, Rule.createRule(apiType, name, sourceType, ids, note));
};

var addBlackWhiteRule = function (apiType, name, sourceType, conflictingRuleName, ids, note) {
    var conflictingRule = getRule.call(this, [conflictingRuleName]);

    if (conflictingRule) {
        removeRule.call(this, [conflictingRuleName]);
    }

    addRule.call(this, apiType, name, sourceType, ids, note);
};

var getRuleTypeFunctions = function (functionPrefix, baseFunction) {
    var ret = {};

    _.each(ruleTypes, function (ruleType) {
        ret[functionPrefix + ruleType + 'Rule'] = _.partial(baseFunction, ruleTypeMap[ruleType]);
    });

    return ret;
};
var getRuleGetters = _.partial(getRuleTypeFunctions, 'get', getRule);
var getRuleRemovers = _.partial(getRuleTypeFunctions, 'remove', removeRule);

// ---------------------------------------------------
// Instance Properties
_.extend(Promotion.prototype, {
    url: function () {
        return endpoints.promotion(this.id);
    },
    defaults: {
        'ruleList': [],
        'source': {
            'role': 'INTERNAL'
        }
    },
    relations: SoaModel.createRelations([
        'validationResult',
        {
            key: 'adjustmentRateList',
            type: Backbone.Many,
            relatedModel: Adjustment
        },
        {
            key: 'ruleList',
            type: Backbone.Many,
            relatedModel: Rule
        }
    ]),
    activate: function () {
        return this.set('status', 'ENABLED').save();
    },
    isDraft: function () {
        return this.get('status') === 'DRAFT';
    },
    isInvalid: function () {
        var validationSuccess = this.get('validationResult.success');
        return _.isBoolean(validationSuccess) ? !validationSuccess : false;
    },
    isActive: function () {
        return !this.isNew() && !this.isInvalid();
    },
    getDiscountRate: function () {
        var adjustmentRate = this.get('adjustmentRateList[0]');
        return adjustmentRate && adjustmentRate.get('rate');
    },
    getEligibleAmount: function (currency) {
        var adjustmentRate = this.get('adjustmentRateList[0]');
        return adjustmentRate && adjustmentRate.getEligibleAmount(currency);
    },
    getEligibleAmountCurrency: function () {
        var eligibleAmount = this.get('adjustmentRateList[0].eligibleAmount');
        return eligibleAmount && eligibleAmount.get('currency');
    },
    hasEligibleAmount: function () {
        var eligibleAmount = this.get('adjustmentRateList[0].eligibleAmount');
        var amount = eligibleAmount && eligibleAmount.get('amount');
        return $.isNumeric(amount) && Number(amount) !== 0;
    },
    hasBuyerError: function () {
        return _.contains(buyerErrors, this.get('validationResult.code'));
    },
    getDiscountCurrency: function () {
        return this.getFlatDiscountCurrency() || this.getEligibleAmountCurrency();
    },
    isPercentDiscount: _.partial(hasAdjustmentRateApiType, Adjustment.APITYPE_PERCENT),
    isFlatDiscount: _.partial(hasAdjustmentRateApiType, Adjustment.APITYPE_FLAT),
    getFlatDiscountCurrency: function () {
        return this.isFlatDiscount() && this.get('adjustmentRateList[0].rate.currency');
    },
    setFlatAdjustment: function (amount, currency) {
        setAdjustment.call(this, Adjustment.APITYPE_FLAT, {amount: amount, currency: currency});
    },
    setPercentAdjustment: function (rate, eligibleAmount, eligibleAmountCurrency) {
        var eligibleAmountObj;

        if (eligibleAmount) {
            eligibleAmountObj = {amount: eligibleAmount, currency: eligibleAmountCurrency};
        }

        setAdjustment.call(this, Adjustment.APITYPE_PERCENT, rate, eligibleAmountObj);
    },
    _addSingletonRule: function (apiType, rule) {
        //only one rule of each kind can exist at a time
        removeRule.call(this, [apiType]);

        if (rule) {
            return this.get('ruleList').add(rule);
        }
    },
    addPriceRangeRule: function (currency, minAmount, maxAmount) {
        this._addSingletonRule(Rule.TYPE_PRICE_RANGE, Rule.createPriceRangeRule(currency, minAmount, maxAmount));
    },
    addHistoryTimePeriodRule: function (days) {
        return this._addSingletonRule(Rule.TYPE_PURCHASE_HISTORY, Rule.createHistoryTimePeriodRule(days));
    },
    addPurchaseHistoryRule: function (startDate, endDate) {
        return this._addSingletonRule(Rule.TYPE_PURCHASE_HISTORY, Rule.createPurchaseHistoryRule(startDate, endDate));
    },
    addVerifiedTradeRule: function () {
        return this._addSingletonRule(Rule.TYPE_VERIFIED_TRADE, Rule.createVerifiedTradeRule());
    },
    removeVerifiedTradeRule : function () {
        return removeRule.call(this, [Rule.TYPE_VERIFIED_TRADE]);
    },
    addUsesPerBuyerRule: function (numberOfUses) {
        return this._addSingletonRule(Rule.TYPE_USES_PER_BUYER, Rule.createUsesPerBuyerRule(numberOfUses));
    },
    addUsesPerCodeRule: function (numberOfUses) {
        return this._addSingletonRule(Rule.TYPE_USES_PER_CODE, Rule.createUsesPerCodeRule(numberOfUses));
    },
    addIdsToCustomerList: function (ids, note) {
        var rule = this.getBuyerListRule();
        return rule.addIdsToCustomerList(ids, note);
    },

    addItemWhitelistRule:        _.partial(addBlackWhiteRule, Rule.TYPE_ITEM_WHITE, 'Item Whitelist', Anchor.TYPE_ITEM, 'itemBlacklistRule'),
    addItemBlacklistRule:        _.partial(addBlackWhiteRule, Rule.TYPE_ITEM_BLACK, 'Item Blacklist', Anchor.TYPE_ITEM, 'itemWhitelistRule'),
    addDealerWhitelistRule:      _.partial(addBlackWhiteRule, Rule.TYPE_DEALER_WHITE, 'Dealer Whitelist', Anchor.TYPE_SELLER, 'dealerBlacklistRule'),
    addDealerBlacklistRule:      _.partial(addBlackWhiteRule, Rule.TYPE_DEALER_BLACK, 'Dealer Blacklist', Anchor.TYPE_SELLER, 'dealerWhitelistRule'),
    addBuyerWhitelistRule:       _.partial(addBlackWhiteRule, Rule.TYPE_BUYER_WHITE, 'Buyer Whitelist', Anchor.TYPE_USER, 'buyerBlacklistRule'),
    addBuyerBlacklistRule:       _.partial(addBlackWhiteRule, Rule.TYPE_BUYER_BLACK, 'Buyer Blacklist', Anchor.TYPE_USER, 'buyerWhitelistRule'),
    addVerticalWhitelistRule:    _.partial(addBlackWhiteRule, Rule.TYPE_VERTICAL_WHITE, 'Vertical Whitelist', Anchor.TYPE_VERTICAL, 'verticalWhitelistRule')
}, getRuleGetters(), getRuleRemovers());


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var Refund = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Backbone = __webpack_require__(3);

var EcomCharges = __webpack_require__(157);
var Notes = __webpack_require__(24);

_.extend(Refund, {
    REASON_DEALER_CANCEL_BEFORE_SHIP : "DEALER_CANCEL_BEFORE_SHIP",
    REASON_CUSTOMER_CANCEL_BEFORE_SHIP_IN_POLICY : "CUSTOMER_CANCEL_BEFORE_SHIP_IN_POLICY",
    REASON_CUSTOMER_CANCEL_BEFORE_SHIP_OUTSIDE_POLICY : "CUSTOMER_CANCEL_BEFORE_SHIP_OUTSIDE_POLICY",
    REASON_ITEM_NOT_RECEIVED : "ITEM_NOT_RECEIVED",
    REASON_ITEM_ARRIVED_DAMAGED : "ITEM_ARRIVED_DAMAGED",
    REASON_ITEM_NOT_AS_DESCRIBED : "ITEM_NOT_AS_DESCRIBED",
    REASON_ITEM_NO_LONGER_DESIRED_IN_POLICY : "ITEM_NO_LONGER_DESIRED_IN_POLICY",
    REASON_ITEM_NO_LONGER_DESIRED_OUTSIDE_POLICY : "ITEM_NO_LONGER_DESIRED_OUTSIDE_POLICY",
    REASON_ITEM_AND_SHIPPING_COST_REDUCTION : "ITEM_AND_SHIPPING_COST_REDUCTION",
    REASON_ITEM_COST_REDUCTION : "ITEM_COST_REDUCTION",
    REASON_SHIPPING_COST_REDUCTION : "SHIPPING_COST_REDUCTION",
    REASON_OTHER : "OTHER",

    STATE_NEW : "NEW"
});

_.extend(Refund.prototype, {
    url: function () {
        return endpoints.refund(this.id);
    },
    relations : SoaModel.createRelations([
        {
            key : 'charges',
            collectionType : EcomCharges,
            type : Backbone.Many
        },
        {
            key : 'notes',
            collectionType : Notes,
            type : Backbone.Many
        }
    ])
});



/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by augustocorvalan on 1/28/15.
 */


// ---------------------------------------------------
// Dependencies
var SoaModel = __webpack_require__(2);
var Anchor = __webpack_require__(12);
var AnchorMember = __webpack_require__(80);
var Rule = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var PromotionAnchorList = __webpack_require__(170);
var FinancialAmount = __webpack_require__(10);
var endpoints = __webpack_require__(6);
//Local Vars
var types;
var _matchApiType;

// ---------------------------------------------------
// Factory Methods
_matchApiType = function (arr) {
    return _.contains(arr, this.get('apiType'));
};

// ---------------------------------------------------
// Static Properties and Methods
types = {
    TYPE_BUYER_WHITE:       'buyerWhitelistRule',
    TYPE_BUYER_BLACK:       'buyerBlacklistRule',
    TYPE_DEALER_WHITE:      'dealerWhitelistRule',
    TYPE_DEALER_BLACK:      'dealerBlacklistRule',
    TYPE_ITEM_WHITE:        'itemWhitelistRule',
    TYPE_ITEM_BLACK:        'itemBlacklistRule',
    TYPE_VERTICAL_WHITE:    'verticalWhitelistRule',
    TYPE_PRICE_RANGE:       'priceRangeRule',
    TYPE_PURCHASE_HISTORY:  'purchaseHistoryRule',
    TYPE_VERIFIED_TRADE:    'verifiedTradeBuyerRule',
    TYPE_USES_PER_BUYER:    'usesPerBuyerRule',
    TYPE_USES_PER_CODE:     'usesPerCodeRule'
};

_.extend(Rule, types, {
    TYPE_WHITELIST:         [types.TYPE_DEALER_WHITE, types.TYPE_BUYER_WHITE, types.TYPE_ITEM_WHITE, types.TYPE_VERTICAL_WHITE],
    TYPE_BLACKLIST:         [types.TYPE_DEALER_BLACK, types.TYPE_BUYER_BLACK, types.TYPE_ITEM_BLACK],
    /**
     * @param {string} apiType
     * @param {string} name
     * @param {string} sourceType
     * @param {array} ids
     * @returns {object}
     */
    createRule: function (apiType, name, sourceType, ids, note) {
        return new Rule ({
            apiType: apiType,
            name: name,
            anchorList: PromotionAnchorList.createAnchorList(sourceType, ids, note)
        });
    },
    /**
     * @param {number} numberOfUses
     * @returns {Rule}
     */
    createUsesPerBuyerRule: function (numberOfUses) {
        return new Rule({
            apiType: Rule.TYPE_USES_PER_BUYER,
            usesPerBuyer: numberOfUses
        });
    },

    createUsesPerCodeRule: function (numberOfUses) {
        return new Rule({
            apiType: Rule.TYPE_USES_PER_CODE,
            usesPerCode: numberOfUses
        });
    },
    /**
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @returns {Rule}
     */
    createPurchaseHistoryRule: function (startDate, endDate) {
        var rule = new Rule({
            apiType: Rule.TYPE_PURCHASE_HISTORY
        });

        if (startDate) {
            rule.set('historyStartDate', startDate);
        }

        if (endDate) {
            rule.set('historyEndDate', endDate);
        }

        return rule;
    },
    /**
     * @returns {Rule}
     */
    createVerifiedTradeRule: function () {
        return new Rule({ apiType : Rule.TYPE_VERIFIED_TRADE })
    },
    /**
     * @param {number} days
     * @returns {Rule}
     */
    createHistoryTimePeriodRule: function (days) {
        return new Rule({
            apiType: Rule.TYPE_PURCHASE_HISTORY,
            historyTimePeriod: {
                numberOfUnits: days,
                timeUnit: 'DAY',
                calendarType: 'BASIC'
            }
        });
    },
    /**
     * @param {string} currency
     * @param {number} [minAmount]
     * @param {number} [maxAmount]
     * @returns {Rule}
     */
    createPriceRangeRule: function (currency, minAmount, maxAmount) {
        var rule = new Rule({
            apiType: Rule.TYPE_PRICE_RANGE
        });

        if (minAmount) {
            rule.set('minAmount', { currency: currency, amount: minAmount });
        }

        if (maxAmount) {
            rule.set('maxAmount', { currency: currency, amount: maxAmount });
        }

        return rule;
    }
});

// ---------------------------------------------------
// Instance Methods and Properties
_.extend(Rule.prototype, {
    relations: SoaModel.createRelations([
        {
            type: Backbone.One,
            key: 'anchorList',
            relatedModel: PromotionAnchorList
        },
        {
            type: Backbone.One,
            key: 'minAmount',
            relatedModel: FinancialAmount
        },
        {
            type: Backbone.One,
            key: 'maxAmount',
            relatedModel: FinancialAmount
        }
    ]),
    getIds: function () {
        var anchorList = this.get('anchorList');
        return anchorList && anchorList.getIds();
    },
    getIdTotalCount: function () {
        var anchorList = this.get('anchorList');
        return anchorList && anchorList.get('totalSize');
    },
    getPriceRangeCurrency: function () {
        var min = this.get('minAmount');
        var max = this.get('maxAmount');

        return min && min.getCurrency() || max && max.getCurrency();
    },
    isPriceRangeCurrency: function (currency) {
        return this.getPriceRangeCurrency() === currency;
    },
    addIdsToCustomerList: function (ids, note) {
        var self = this;
        var members = AnchorMember.createAnchorMembers(Anchor.TYPE_USER, ids, note);

        return members.sync("create", members, {
            url: endpoints.promotionRuleAnchor(self.get('id'))
        });
    },
    isWhitelist:            _.partial(_matchApiType, Rule.TYPE_WHITELIST),
    isBlacklist:            _.partial(_matchApiType, Rule.TYPE_BLACKLIST),
    isItemListRule:         _.partial(_matchApiType, [Rule.TYPE_ITEM_WHITE, Rule.TYPE_ITEM_BLACK]),
    isDealerListRule:       _.partial(_matchApiType, [Rule.TYPE_DEALER_BLACK, Rule.TYPE_DEALER_WHITE]),
    isBuyerListRule:        _.partial(_matchApiType, [Rule.TYPE_BUYER_WHITE, Rule.TYPE_BUYER_BLACK]),
    isPriceRangeRule:       _.partial(_matchApiType, [Rule.TYPE_PRICE_RANGE]),
    isVerticalRule:         _.partial(_matchApiType, [Rule.TYPE_VERTICAL_WHITE]),
    isPurchaseHistoryRule:  _.partial(_matchApiType, [Rule.TYPE_PURCHASE_HISTORY]),
    isUsesPerBuyerRule:     _.partial(_matchApiType, [Rule.TYPE_USES_PER_BUYER]),
    isUsesPerCodeRule:      _.partial(_matchApiType, [Rule.TYPE_USES_PER_CODE])
});


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/20/13
 */

var SoaModel = __webpack_require__(2);
var ShipmentContent = SoaModel.extend();

module.exports = ShipmentContent;

var Backbone = __webpack_require__(3);
var Item = __webpack_require__(34);
var _ = __webpack_require__(0);

/**
 * @class ShipmentContent
 * @extends SoaModel
 * @property {array} relations
 *      @property relations.type {Backbone.One}
 *      @property relations.key {string}- "item"
 *      @property relations.relatedModel {Backbone.Model}
 *      @property relations.collectionType {Backbone.Models}
 */
_.extend(ShipmentContent.prototype, {
    relations : SoaModel.createRelations([
        {
            type: Backbone.One,
            key: 'item',
            relatedModel: Item,
            saveJSONFields : ['id', 'apiType', 'vertical']
        }
    ])
});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Joe Forzano
 * Date: January 7th, 2015
 */



// ---------------------------------------------------
// Load Super Class

var SoaModel = __webpack_require__(2);
var Carrier = __webpack_require__(315);
var Backbone = __webpack_require__(3);


// ---------------------------------------------------
// Module Definition

var ShipmentTracking = module.exports = SoaModel.extend();


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);


// ---------------------------------------------------
// Local Vars


// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ShipmentTracking.prototype, {
    defaults: {
        trackingNumber : '',
        carrier: {}
    },

    relations: function () {
        return SoaModel.createRelations([
            {
                type: Backbone.One,
                key: 'carrier',
                relatedModel: Carrier
            }
        ]);
    }
});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 10/8/13
 * Time: 5:54 PM
 */


var PaymentMethod = __webpack_require__(11);
var ACH = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

/**
 * @mixes bunsen.PaymentMethod
 * @class
 */
_.extend(ACH.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'ACH';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'ACH'
        };
    }
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Lior Elrom
 * Date: 6/30/15
 * Time: 3:55 PM
 */



var _ = __webpack_require__(0);
var PaymentMethod = __webpack_require__(11);
var creditCardMixin = __webpack_require__(84);
var ApplePay = PaymentMethod.extend();

module.exports = ApplePay;

_.extend(ApplePay.prototype, {
    defaults : {
        apiType: 'applePay',
        paymentMethodType: PaymentMethod.TYPE_APPLE_PAY
    },
    getDisplayVal: function () {
        return 'Apple Pay';
    },
    getLastNumbers: function () {
        return this.get('cardLastNumbers');
    },
    getCardType: function () {
        return this.get('cardType');
    }
}, creditCardMixin);


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */


var PaymentMethod = __webpack_require__(11);
var Cash = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

/**
 * @mixes bunsen.PaymentMethod
 * @class
 */
_.extend(Cash.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Cash';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'CASH'
        };
    }
});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */


var PaymentMethod = __webpack_require__(11);
var Check = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

module.exports = Check;

/**
 * @mixes bunsen.PaymentMethod
 * @class
 */
_.extend(Check.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Check';
    },
    defaults : function () {
        return {
            apiType : 'check',
            paymentMethodType : 'CHECK'
        };
    }
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PaymentMethodModel = __webpack_require__(11);
var CreditCard = module.exports = PaymentMethodModel.extend();
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var Address = __webpack_require__(32);
var creditCardMixin = __webpack_require__(84);
var ends = __webpack_require__(6);
var Token = __webpack_require__(135);
var braintree;
var cardTypeMap;

__webpack_require__(79);

// braintree can only be used in a browser
if (typeof window !== 'undefined') {
    braintree = window.braintree;
}


// jquery-payment card types mapped to service types
cardTypeMap = {
    visa:  PaymentMethodModel.CARD_TYPE_VISA,
    mastercard:  PaymentMethodModel.CARD_TYPE_MASTER,
    discover:  PaymentMethodModel.CARD_TYPE_DISCOVER,
    amex:  PaymentMethodModel.CARD_TYPE_AMEX
};

_.extend(CreditCard.prototype, {
    idAttribute: "token",
    defaults : {
        apiType : 'creditCard',
        paymentMethodType : PaymentMethodModel.TYPE_CREDIT_CARD,
        billingAddress: {}
    },
    url: function () {
        return ends.savedCard(this.getUserId(), this.get('hashedCardNumber'));
    },
    relations: [
        {
            type: Backbone.One,
            key: 'billingAddress',
            relatedModel: Address
        }
    ],
    getDisplayVal: function () {
        return 'Credit Card';
    },
    getLastNumbers: function () {
        var maskedCardNumber = this.get('maskedCardNumber');
        return maskedCardNumber.substr(-4);
    },
    getCardType: function () {
        var maskedCardNumber = this.get('maskedCardNumber');
        var jqueryPaymentCardType = maskedCardNumber && $.payment.cardType(maskedCardNumber);
        return cardTypeMap[jqueryPaymentCardType];
    },
    updateMaskedCardNumber : function () {
        var ccN = this.get('creditCardNumber') || '';
        this.set('maskedCardNumber', ccN.replace(/[^0-9]/g, '').replace(/^(\d{6})\d+(\d{4})$/, '$1******$2'));
    },
    makeNewCard: function () {
        return new CreditCard(this.omit('id', 'token', 'cardType'));
    },
    removeSpacesFromCreditCard: function () {
        var number = this.get('creditCardNumber');
        this.set('creditCardNumber', number.replace(/ /g, ''));
    },
    deleteFromWallet: function (userId, options) {
        var url = ends.savedCard(userId, this.get('hashedCardNumber'));
        options = _.extend({url: url}, options);
        return this.destroy(options);
    },
    saveToVault: function (userId, options) {
        var vaultRequest;
        options = _.extend({
            url: ends.vault(userId)
        }, options);

        options.queries = _.extend({
            paymentMethodNonce: this.get('nonce')
        }, options.queries);

        vaultRequest = new SoaModel();
        return vaultRequest.save({}, options);
    },
    saveToSellerVault : function (sellerId, options) {
      var vaultRequest;
      options = _.extend({
          url: ends.sellerVault(sellerId)
      }, options);

      options.queries = _.extend({
          paymentMethodNonce: this.get('nonce')
      }, options.queries);

      vaultRequest = new SoaModel();
      return vaultRequest.save({}, options);
    },
    setNonce: function (options) {
    // this method only works in the browser due to braintree-web limitations
        var clientToken = new Token();
        options = options || { validate : true };
        return clientToken.fetchClientToken().then(function () {
            var def = $.Deferred();
            var client = new braintree.api.Client({clientToken: clientToken.get('value')});
            var tokenizeObject = {
                number: this.get('creditCardNumber'),
                cardholderName: this.get('cardHolderName'),
                expirationMonth: this.get('cardExpiryMonth'),
                expirationYear: this.get('cardExpiryYear'),
                // Address if AVS is on
                billingAddress: {
                    firstName: this.get('billingAddress.firstName') || null,
                    lastName: this.get('billingAddress.lastName') || null,
                    company: this.get('billingAddress.company') || null,
                    streetAddress: this.get('billingAddress.line1'),
                    extendedAddress: this.get('billingAddress.line2') || null,
                    locality: this.get('billingAddress.city'),
                    region: this.get('billingAddress.state'),
                    postalCode: this.get('billingAddress.zipCode'),
                    countryCodeAlpha2: this.get('billingAddress.country')
                }
            };

            if (options.validate) {
                tokenizeObject.cvv = this.get('securityCode')
            }

            client.tokenizeCard(tokenizeObject, function (err, nonce) {
                if (err) {
                    def.reject(err);
                    return;
                }
                this.set('nonce', nonce);
                def.resolve(nonce);
            }.bind(this));

            return def.promise();
        }.bind(this));

    }
}, creditCardMixin);


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */

var PaymentMethod = __webpack_require__(11);
var CreditToUserAccount = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

_.extend(CreditToUserAccount.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Credit to dealer account';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'CREDIT_TO_USER_ACCOUNT'
        };
    }
});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */


var PaymentMethod = __webpack_require__(11);
var DirectPayment = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

_.extend(DirectPayment.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Direct Payment';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'DIRECT_PAYMENT'
        };
    }
});


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */


var PaymentMethod = __webpack_require__(11);
var Discount = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

_.extend(Discount.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Discount';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'DISCOUNT'
        };
    }
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */


var PaymentMethod = __webpack_require__(11);
var NotAvailable = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

_.extend(NotAvailable.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Not Available';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'NOT_AVAILABLE'
        };
    }
});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/11/15
 * Time: 4:41 PM
 */



var PaymentMethod = __webpack_require__(11);
var PayPalAccount = module.exports = PaymentMethod.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var WalletPaymentMethod = __webpack_require__(191);
var Address = __webpack_require__(32);
var paypal = __webpack_require__(168);
var ends = __webpack_require__(6);

_.extend(PayPalAccount.prototype, {
    defaults: {
        apiType : 'payPalAccount',
        paymentMethodType : 'PAYPAL_ACCOUNT',
        billingAddress: {}
    },
    relations: [
        {
            type: Backbone.One,
            key: 'billingAddress',
            relatedModel: Address
        }
    ],
    getDisplayVal: function () {
        return 'PayPal';
    },
    setFromBraintree: function (paypalData) {
        this.set(paypal.getPayPalModelData(paypalData));
    },
    saveToVault: function (userId, options) {
        var vaultRequest;
        options = _.extend({
            url: ends.vault(userId)
        }, options);

        options.queries = _.extend({
            paymentMethodNonce: this.get('nonce')
        }, options.queries);

        vaultRequest = new WalletPaymentMethod();
        return vaultRequest.save({}, options)
            .then(function () {
                var paymentMethod = vaultRequest.get('paymentMethod');
                this.clear();
                if (paymentMethod) {
                    this.set(paymentMethod.toJSON());
                }
            }.bind(this));
    }
});

_.extend(PayPalAccount, {
    createFromBraintree: function (paypalData) {
        return new PayPalAccount(paypal.getPayPalModelData(paypalData));
    }
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */

var PaymentMethod = __webpack_require__(11);
var WireTransfer = PaymentMethod.extend();

module.exports = WireTransfer;

var ends = __webpack_require__(6);
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

_.extend(WireTransfer.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    url: function () {
        return ends.paymentMethod();
    },
    getDisplayVal: function () {
        return 'Wire Transfer';
    },
    getNumber: function () {
        return this.getNumberType() ? this.get(this.getNumberType()) : null;
    },
    getNumberType: function () {
        if (this.get('confirmationNumber')) {
            return 'confirmationNumber';
        }
        if (this.get('transactionNumber')) {
            return 'transactionNumber';
        }
        if (this.get('referenceNumber')) {
            return 'referenceNumber';
        }
        return null;
    },
    getName: function () {
        return this.get('accountHolderName');
    },
    defaults : function () {
        return {
            apiType : 'wireTransfer',
            paymentMethodType : 'WIRE_TRANSFER'
        };
    }
});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var WalletPaymentMethod = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var PaymentMethod = __webpack_require__(57);

_.extend(WalletPaymentMethod.prototype, {
    relations : SoaModel.createRelations([{
        key : 'paymentMethod',
        relatedModel : PaymentMethod,
        type : Backbone.One
    }])
});



/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = {
    hasAction : function (code) {
        var actions = this.get('actions');
        return !!actions && actions.hasCode(code);
    }
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/3/14
 * Time: 6:56 PM
 */



var _ = __webpack_require__(0);
var Party = __webpack_require__(8);
var Offer = __webpack_require__(26);
var PaymentAuthorization = __webpack_require__(25);
var FinancialAmount = __webpack_require__(10);

var getFromWallet = function (fn) {
    var shippingAddress = this.get('shipment.shippingAddress');
    var wallet = this.get('buyer.wallet');
    if (!wallet) {
        throw new Error('Must have buyer.wallet for getPermissibleCards to work');
    }
    return wallet[fn](shippingAddress);
};

module.exports = {
    /**
     * Saves the transaction, note, and sends the entire page to braintree
     */
    submitForCheckout: function () {
        this.addCheckoutNote();

        return this.save(null, {
            queries: {
                autoAuthorize: true,
                deepUpdate: true,
                workflowAction: 'update'
            }
        });
    },
    /**
     * Saves the payment auth and sends the entire page to braintree
     */
    submitForBalanceDue: function () {
        var paymentAuth = this.getCurrentBalanceDuePaymentAuthorization();
        return paymentAuth.save(null, {
            queries: { autoAuthorize: true }
        });
    },
    addCheckoutNote: function () {
        var offer;
        var note;

        if (!this.checkoutNote) {
            return;
        }

        offer = this.getFirstOffer();
        note = offer.newBuyerSellerNote({
            role: Party.ROLE_BUYER,
            creatorId: this.get('buyer.id')
        });

        note.set('anchors', []);
        note.set('content', this.checkoutNote);
        offer.set('notes', [note]);
    },
    isCheckoutComplete: function () {
        // checkout is complete when the transaction is saved and we have an offer payment auth
        return !this.isNew() &&
            (this.getCurrentCheckoutPaymentAuthorization() || this.getOfferPaymentAuthorization());
    },
    isBalanceDueProcessed: function () {
        // balance due is processed when we have a shipment quote payment auth
        return !!this.getShippingPaymentAuthorization();
    },

    needsToTransitionCheckoutPaymentAuth: function () {
        return !!this.getCheckoutPaymentAuthorizationForProcessing();
    },
    needsToTransitionBalanceDuePaymentAuth: function () {
        return !!this.getBalanceDuePaymentAuthorizationForProcessing();
    },
    getPermissibleCards: _.partial(getFromWallet, 'getPermissibleCards'),
    getValidPermissibleCards: _.partial(getFromWallet, 'getValidPermissibleCards'),
    // TODO combine with methods on offer model
    newBuyerOffer: function (amountPerItem, quantity) {
        var offers = this.get('offers');
        var offer = new Offer({
            quantity: quantity,
            amountPerItem: amountPerItem,
            subTotalAmount: {
                amount: Number(amountPerItem.get('amount') * quantity),
                currency: amountPerItem.get('currency')
            },
            forCompleteLot: !this.get('item').isSoldIndividually(),
            counterParty: {
                id: this.get('item.seller.id'),
                role: Party.ROLE_SELLER
            },
            initiatingParty: {
                id: this.get('buyer.id'),
                role: Party.ROLE_BUYER
            }
        });
        offers.reset([offer]);
        return offer;
    },
    lockConversionRates: function () {
        this.set('currencyConversionRateEvent', this.get('item.pricing.totalAmount.conversionRateEvent'));
    },
    _setFirstValidPermissibleCard: function (paymentAuth) {
        var cards = this.getValidPermissibleCards();
        if (cards && !cards.isEmpty()) {
            paymentAuth.set('paymentMethod', cards.first());
        }
        return paymentAuth;
    },
    /**
     * Creates a payment auth for checkout
     * @param [setCard] - defaults to true
     */
    createCheckoutPaymentAuthorization: function () {
        var currency = FinancialAmount.CURRENCY_USD;
        var paymentAuth = PaymentAuthorization.newOfferPaymentAuthorization();
        var amount = this.get('item').getAmountIn(currency);
        paymentAuth.set('amount', {amount: amount, currency: currency});
        this._setFirstValidPermissibleCard(paymentAuth);
        this.set('paymentAuthorizations', [paymentAuth]);
    },
    createBalanceDuePaymentAuthorization: function () {
        var quote = this.getPaymentRequiredQuote();
        var paymentAuth;

        if (!quote) {
            return;
        }

        paymentAuth = PaymentAuthorization.newShipmentQuotePaymentAuthorization(quote);
        paymentAuth.set('transaction', {id: this.id});
        this._setFirstValidPermissibleCard(paymentAuth);
        this.get('paymentAuthorizations').add(paymentAuth);
        return paymentAuth;
    },
    /**
     *
     * @param [id] optional address id to use
     */
    setInitialShippingAddress: function (id) {
        var addressBook = this.get('buyer.addressBook');
        var savedAddress = addressBook && addressBook.getAddressById(id);
        var firstShippingAddresses = this.getFirstShippingAddress();
        var address = savedAddress || firstShippingAddresses;
        if (address) {
            this.get('shipment').set('shippingAddress', address);
        }
    },
    addPromo: function (promoCode) {
        this.set('promotions', [{
            code: promoCode
        }]);
        this.trigger('promoChanged');
    },
    removePromo: function () {
        this.set('promotions', []);
        this.trigger('promoChanged');
    },
    /**
     * Invoke this function when a checkout has failed. Will clear the id
     * and payment auth so it can be submitted again
     */
    clearForCheckoutRetry: function () {
        this.unset('id');
        if (!this.isReadyForBalanceDue()) {
            this.selectFirstAvailableOption();
        }
        // remove status from sub documents
        this.unset('shipment.status');
        _.each(['invoices', 'offers'], function (collection) {
            this.get(collection).each(function (model) {
                model.unset('status');
            });
        }, this);
    },
    clearForDeniedPaymentAuth: function () {
        var paymentAuthorizations = this.get('paymentAuthorizations');
        var paymentAuth = paymentAuthorizations && paymentAuthorizations.last();
        var paymentMethod = paymentAuth && paymentAuth.get('paymentMethod');
        var newPaymentAuth;
        if (paymentAuth) {
            newPaymentAuth = new PaymentAuthorization(paymentAuth.pick('amount', 'anchor', 'transaction'));
            if (paymentMethod) {
                this.previousPaymentMethod = paymentMethod.makeNewCard();
                newPaymentAuth.set('paymentMethod', this.previousPaymentMethod);
            }
        }
        this.set('paymentAuthorizations', [newPaymentAuth]);
    }
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/6/14
 * Time: 12:20 PM
 */



var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var FinancialAmount = __webpack_require__(10);
var Transaction = __webpack_require__(20);
var TransactionShipmentQuote = __webpack_require__(36);
var deferredHelpers = __webpack_require__(167);
var getFromInvoice;
var getPriceAmount;
var getFromDealerInvoice;
var getFromBuyerInvoice;
var hasAmount;

__webpack_require__(313);

getPriceAmount = function (type, currency) {
    var price = this.getPriceType(type);
    return price && Number(price.get('amount').getAmountIn(currency));
};

getFromInvoice = function (invoiceAccessor, fn, currency) {
    var invoice = this[invoiceAccessor]();
    if (invoice) {
        return invoice[fn](currency);
    }
};

hasAmount = function (fn) {
    var amount = this[fn](FinancialAmount.CURRENCY_USD);
    return $.isNumeric(amount) && Number(amount) !== 0;
};

getFromDealerInvoice = _.partial(getFromInvoice, 'getDealerInvoice');
getFromBuyerInvoice = _.partial(getFromInvoice, 'getBuyerInvoice');

module.exports = {
    getShippingSubtotal : function (currency) {
        var quote = this.getCurrentShippingQuote();
        if (!quote) {
            return 0;
        }
        return quote.getSubTotal(currency) || 0;
    },
    getShippingTotal: function (currency) {
        var quote = this.getCurrentShippingQuote();
        if (!quote) {
            return null;
        }
        return quote.getTotalAmount(currency) || 0;
    },
    getShippingTaxAmount : function (currency) {
        var buyerInvoice = this.getBuyerInvoice();
        var invoiceItems = buyerInvoice && buyerInvoice.get('invoiceItems');
        if (invoiceItems) {
            return invoiceItems.getShipmentSalesTax(currency);
        }
        return 0;
    },
    getAvailablePrices: function () {
        return this.get('summary.availablePrices');
    },
    getCheckoutPriceAmount: function (currency) {
        var itemPriceAmount = this.get('summary.itemPrice.amount');
        return itemPriceAmount && itemPriceAmount.getAmountIn(currency);
    },
    getCheckoutPriceType: function () {
        return this.get('summary.itemPrice.type');
    },
    getPriceType: function (type) {
        var availablePrices = this.getAvailablePrices();
        return availablePrices && availablePrices.find(function (price) {
            return price.get('type') === type;
        });
    },
    isOnSale: function () {
        return !!this.getPriceType('WEEKLY_SALE');
    },
    hasNetPrice: function () {
        return !!this.getPriceType('NET');
    },
    getRetailAmount: _.partial(getPriceAmount, 'RETAIL'),
    getSaleAmount: _.partial(getPriceAmount, 'WEEKLY_SALE'),
    getNetPriceAmount: _.partial(getPriceAmount, 'NET'),
    getOfferSubtotal : function (currency) {
        var offer = this.getMostRecentOffer();
        if (!offer) {
            return 0;
        }
        return offer.getSubTotal(currency);
    },
    getOfferTotal: function (currency, offer) {
        offer = offer || this.getMostRecentOffer();
        if (!offer) {
            return 0;
        }
        return offer.getTotalAmount(currency);
    },
    getOfferTaxAmount: function (currency) {
        var buyerInvoice = this.getBuyerInvoice();
        var invoiceItems = buyerInvoice && buyerInvoice.get('invoiceItems');
        if (invoiceItems) {
            return invoiceItems.getOfferSalesTax(currency);
        }
        return 0;
    },
    getAdjustmentTaxAmount: function (currency) {
        var buyerInvoice = this.getBuyerInvoice();
        var invoiceItems = buyerInvoice && buyerInvoice.get('invoiceItems');
        if (invoiceItems) {
            return invoiceItems.getAdjustmentSalesTax(currency);
        }
        return 0;
    },
    hasSalesTax: _.partial(hasAmount, 'getOfferTaxAmount'),
    hasShippingSalesTax: _.partial(hasAmount, 'getShippingTaxAmount'),
    getSalesTax : function (currency) {
        return this.getShippingTaxAmount(currency) +
            this.getOfferTaxAmount(currency) +
            this.getAdjustmentTaxAmount(currency);
    },
    getSalesTaxState: function () {
        if (this.isLocalPickup()) {
            return this.get('item.seller.shippingAddress.state');
        } else {
            return this.get('shipment.shippingAddress.state');
        }
    },
    getBuyerTotalFromOffers : function (currency, passedOffer) {
        var offer = passedOffer || this.getMostRecentOffer();
        var offerTotal = this.getOfferTotal(currency, offer) || 0;
        var quote = this.getCurrentShippingQuote();

        // Only include the shipping total when it is not free shipping for the buyer.
        if (quote && quote.get('complimentaryShipping') !== 'Y') {
            return offerTotal + this.getShippingTotal(currency);
        }
        return offerTotal;
    },
    getBuyerTotal: _.partial(getFromBuyerInvoice, 'getTotalAmount'),
    getItemCurrency: function () {
        return this.get('item.pricing.totalAmount.currency');
    },

    getAmountPerItem: function (currency) {
        var item = this.get('item');
        if (item) {
            return item.getAmountPerItem(currency);
        }
    },
    getCommission: _.partial(getFromDealerInvoice, 'calculateCommission'),
    getProcessingFee: _.partial(getFromDealerInvoice, 'calculateProcessingFee'),
    getListingCredit: _.partial(getFromDealerInvoice, 'calculateListingCredit'),
    getComplimentaryShippingAdjustment: _.partial(getFromDealerInvoice, 'calculateComplimentaryShipping'),
    getDealerTotal: _.partial(getFromDealerInvoice, 'getTotalAmount'),
    getDealerSubTotal: _.partial(getFromDealerInvoice, 'getSubTotal'),
    getPromotionAmount: _.partial(getFromBuyerInvoice, 'calculatePromotion'),
    getItemPriceModification: _.partial(getFromBuyerInvoice, 'calculateItemPriceModification'),
    getProductCustomization: _.partial(getFromBuyerInvoice, 'calculateProductCustomization'),
    getCustomerCharge: _.partial(getFromBuyerInvoice, 'calculateCustomerCharge'),
    getDealerCharge: _.partial(getFromDealerInvoice, 'calculateDealerCharge'),
    hasListingCredit: _.partial(hasAmount, 'getListingCredit'),
    hasComplimentaryShippingAdjustment: _.partial(hasAmount, 'getComplimentaryShippingAdjustment'),
    hasPromotion: function () {
        var adjustments = this.getBuyerInvoice() && this.getBuyerInvoice().get('adjustments');
        return adjustments && adjustments.hasPromotion();
    },
    hasItemPriceModification: _.partial(hasAmount, 'getItemPriceModification'),
    hasProductCustomization: _.partial(hasAmount, 'getProductCustomization'),
    hasCustomerCharge: _.partial(hasAmount, 'getCustomerCharge'),
    hasDealerCharge: _.partial(hasAmount, 'getDealerCharge'),
    hasBuyerOrderMod: function () {
        return this.hasItemPriceModification() || this.hasProductCustomization() || this.hasCustomerCharge();
    },
    hasDealerOrderMod: function () {
        return this.hasDealerCharge();
    },
    getBuyerBalanceDueAmount: function (currency) {
        var balanceDueAmount = this.get('summary.balanceDueAmount');
        return balanceDueAmount && balanceDueAmount.getAmountIn(currency) || 0;
    },
    getFinalCaptureAmount: function (currency) {

        var rawAmountToCapture = this.getBuyerTotal(currency);
        var paymentAuthOnShipping = this.getShippingPaymentAuthorization();
        if (paymentAuthOnShipping) {
            rawAmountToCapture -= paymentAuthOnShipping.get('amount').getAmountIn(currency);
        }
        return rawAmountToCapture;
    },
    getMostRecentOfferAmountPerItem: function (currency) {
        var offer = this.getMostRecentOffer();
        if (offer) {
            return offer.getAmountPerItem(currency);
        }
    },
    getAcceptedQuoteSubTotal: function (currency) {
        var sq = this.getAcceptedQuote();
        if (sq) {
            return sq.getSubTotal(currency);
        }
    },
    getOfferPaymentAuthorizationAmount: function (currency) {
        var pa = this.get('paymentAuthorizations').getOfferPaymentAuthorization();
        if (pa) {
            return pa.getAmount(currency);
        }
    },
    getOfferPaymentAuthorizationCapturedAmount: function (currency) {
        var pa = this.get('paymentAuthorizations').getOfferPaymentAuthorization();
        if (pa) {
            return pa.getCapturedAmount(currency);
        }
    },
    getOfferPaymentAuthorizationAuthorizationAmount: function (currency) {
        var pa = this.get('paymentAuthorizations').getOfferPaymentAuthorization();
        if (pa) {
            return pa.getAuthorizationAmount(currency);
        }
    },
    getShippingPaymentAuthorizationAmount: function (currency) {
        var pa = this.get('paymentAuthorizations').getShippingPaymentAuthorization();
        if (pa) {
            return pa.getAmount(currency);
        }
    },
    getBuyerCurrency: function () {
        return this.get('buyer.profile.currency') || FinancialAmount.CURRENCY_USD;
    },
    getBuyerOriginalPayment: function (currency) {
        var offer = this.getMostRecentOffer();
        var offerAmount = offer && offer.getTotalAmount(currency);
        var promotionAmount = this.getPromotionAmount(currency) || 0;
        return offerAmount + promotionAmount;
    },

    hasCurrencyConversionFor: function (currency) {
        var rates = this.get('currencyConversionRateEvent.conversionRates');
        var itemCurrency = this.getItemCurrency();

        return rates &&
            !!rates.findWhere({
                sourceCurrency: FinancialAmount.CURRENCY_USD,
                targetCurrency: currency
            }) &&
            !!rates.findWhere({
                sourceCurrency: itemCurrency,
                targetCurrency: currency
            });
    },

    hasBuyerCurrencyConversion: function () {
        return this.hasCurrencyConversionFor(this.getBuyerCurrency());
    },

    getBuyerLocalizedCurrency: function () {
        var itemHasSameCurrencyAsBuyer = this.getItemCurrency() === this.getBuyerCurrency();
        return itemHasSameCurrencyAsBuyer || this.hasBuyerCurrencyConversion() ? this.getBuyerCurrency() : FinancialAmount.CURRENCY_USD;
    },

    /**
     * @deprecated
     * @returns {*}
     */
    calculateTotals: function () {
        return this.computeAdjustments.apply(this, arguments);
    },
    computeCheckoutAdjustments: function () {
        // we need to preserve paymentAuth payment method since
        // ecom does not get the credit card info
        var paymentAuths = this.get('paymentAuthorizations').toJSON();
        var buyer = this.get('buyer').toJSON();
        var jqXhr;

        // cancel any outstanding calls
        if (this._checkoutAdjustmentsDeferred) {
            this._checkoutAdjustmentsDeferred.reject();
        }

        // compute adjustments starts
        this.trigger('computingAdjustments');

        jqXhr = this.save(null, {url: endpoints.computeAdjustments(), type: 'post'});

        this._checkoutAdjustmentsDeferred = deferredHelpers.wrapDeferred(jqXhr);
        this._checkoutAdjustmentsDeferred.then(_.bind(function () {
            _.each(paymentAuths, function (paymentAuth, i) {
                this.get('paymentAuthorizations[' + i + ']').set('paymentMethod', paymentAuth.paymentMethod, {computeAdjustments: true});
            }, this);
            // need to preserve the buyer or backbone will overwrite it if there's no id
            this.set('buyer', buyer);
            // compute adjustments ends
            this.trigger('computedAdjustments');
        }, this));

        return this._checkoutAdjustmentsDeferred.promise();
    },
    isAdjusted: function () {
        var offer = this.getFirstOffer();
        return offer && offer.has('adjustments.signature');
    },
    removeAdjustments: function () {
        this.get('offers').each(function (offer) {
            offer.unset('adjustments');
        });
        this.get('shipmentQuotes').each(function (shipmentQuote) {
            shipmentQuote.unset('adjustments');
        });
        this.trigger('removedAdjustments');
    },
    setEachModel: function (type, transaction) {
        var collection = this.get(type);
        if (collection) {
            collection.each(function (model, i) {
                if (i < transaction.get(type).length) {
                    model.set(transaction.get(type).at(i).toJSON());
                }
            });
            transaction.get(type).each(function (model) {
                if (!collection.findWhere({ id: model.id })) {
                    collection.push(model);
                }
            });
        }
    },
    setInvoiceModel: function (transaction) {
        var collection = this.get('invoices');
        var model;
        var invoices;
        if (collection) {
            invoices = transaction.get('invoices');
            invoices.each(function (invoice) {
                if (invoice.isBuyerInvoice()) {
                    model = collection.getBuyerInvoice();
                } else {
                    model = collection.getDealerInvoice();
                }

                if (model) {
                    model.set(invoice.toJSON());
                } else {
                    collection.push(invoice);
                }
            });
        }
    },
    _defaultZero: function (model, field) {
        var financialAmount = model.get(field);
        var currency;
        if (financialAmount && !financialAmount.get('amount')) {
            currency = financialAmount.get('currency');
            financialAmount.set({
                amount: 0,
                currency: currency
            });
        }
    },

    /**
     * @memberOf Transaction#
     * @param [shipmentQuote] - update totals/adjustments on this shipmentQuote
     * @return {$.Deferred.promise}
     */
    computeAdjustments: function (shipmentQuote) {
        var transaction = new Transaction(this.toJSON());
        var self = this;
        var newShipmentQuote;
        var transactionShipmentQuote;

        if (shipmentQuote && shipmentQuote.toJSON()) {
            transactionShipmentQuote = new TransactionShipmentQuote(shipmentQuote.toJSON());
        }

        newShipmentQuote = transactionShipmentQuote || transaction.get('shipment.acceptedQuote');
        if (newShipmentQuote) {
            transaction.get('shipment').set('acceptedQuote', newShipmentQuote);
            this._defaultZero(newShipmentQuote, 'subTotalAmount');
            this._defaultZero(newShipmentQuote, 'totalAmount');
        }
        this._defaultZero(transaction.get('offers').last(), 'subTotalAmount');
        this._defaultZero(transaction.get('offers').last(), 'amountPerItem');
        return transaction.save(null, {url: endpoints.computeAdjustments(), type: 'post'}).then(function () {
            var rateEvent;
            /*
             * IMPORTANT
             * form view holds on to sub-model references. we need to actually set each submodel or else
             * they will be replaced with a new model and the views will not have references to them
             */
            _.each(['offers', 'paymentAuthorizations'], function (type) {
                self.setEachModel(type, transaction);
            });
            /*
             * Had to break out 'invoices' from above call to "setEachModel" since invoice is
             * implementation dependent
             */
            self.setInvoiceModel(transaction);
            rateEvent = transaction.get('currencyConversionRateEvent');
            if (rateEvent) {
                self.set('currencyConversionRateEvent', rateEvent.toJSON());
            }
            if (shipmentQuote) {
                self.setAttributeOnShipmentQuote(shipmentQuote, transaction, 'shipment.acceptedQuote.totalAmount');
                self.setAttributeOnShipmentQuote(shipmentQuote, transaction, 'shipment.acceptedQuote.adjustments');
            }
        });
    },

    setAttributeOnShipmentQuote: function (on, from, what) {
        if (!on) {
            return;
        }
        if (what && from.get(what)) {
            on.set(_.last(what.split('.')), from.get(what));
        }
        return this; // eslint-disable-line
    }
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/6/14
 * Time: 11:26 AM
 */



var _ = __webpack_require__(0);
var TransactionShipmentQuote = __webpack_require__(36);
var getFromCollection;

getFromCollection = function (collectionProperty, fn) {
    var args = Array.prototype.slice.call(arguments, 2);
    var collection = this.get(collectionProperty);
    if (collection) {
        return collection[fn].apply(collection, args);
    }
};

/**
 * Transaction mixin for accessing sub-documents
 * @type {{}}
 */
module.exports = {
    /******************************
        Payment Authorizations
    ******************************/
    /**
     * Get the active payment auth that is anchored to an offer. This includes fraudulent payment auths
     */
    getOfferPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getActiveOfferPaymentAuthorization'),
    /**
     * Get the active payment auth that is anchored to a shipment quote. This includes fraudulent payment auths
     */
    getShippingPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getActiveShippingPaymentAuthorization'),
    /**
     * Get the current payment auth that is anchored to an offer and has not yet been processed
     */
    getCurrentCheckoutPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getCurrentCheckoutPaymentAuthorization'),
    /**
     * Get the active payment auth that is anchored to a shipment quote and has not yet been processed
     */
    getCurrentBalanceDuePaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getCurrentBalanceDuePaymentAuthorization'),
    /**
     * Get a denied payment auth that is anchored to an offer
     */
    getDeniedCheckoutPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getDeniedCheckoutPaymentAuthorization'),
    /**
     * Get a statged payment auth ready to send to braintree
     */
    getStagedPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getStagedPaymentAuthorization'),
    getCheckoutPaymentAuthorizationForProcessing: _.partial(getFromCollection, 'paymentAuthorizations', 'getCheckoutPaymentAuthorizationForProcessing'),
    getBalanceDuePaymentAuthorizationForProcessing: _.partial(getFromCollection, 'paymentAuthorizations', 'getBalanceDuePaymentAuthorizationForProcessing'),

    /******************************
        Offers
     ******************************/
    getMostRecentOffer: _.partial(getFromCollection, 'offers', 'getMostRecent'),
    getFirstOffer: _.partial(getFromCollection, 'offers', 'getFirst'),
    getMostRecentBuyerOffer: _.partial(getFromCollection, 'offers', 'getMostRecentBuyerOffer'),
    getMostRecentDealerOffer: _.partial(getFromCollection, 'offers', 'getMostRecentDealerOffer'),

    /******************************
        Shipment Quotes
     ******************************/
    getPaymentRequiredQuote: function () {
        var quotes = this.get('shipmentQuotes');
        return quotes && quotes.findWhere({status: 'PAYMENT_REQUIRED'});
    },
    getCurrentShippingQuote : function () {
        var acceptedQuote = this.getAcceptedQuote();
        var dibsQuote = this.get1stdibsShipmentQuote();
        var dealerQuote = this.getDealerShipmentQuote();
        var activeQuote;

        if (acceptedQuote) {
            activeQuote = acceptedQuote;
        } else if (dealerQuote) {
            activeQuote = dealerQuote;
        } else if (dibsQuote
            && dibsQuote.get('status') !== TransactionShipmentQuote.STATUS_NEW
            && dibsQuote.get('status') !== TransactionShipmentQuote.STATUS_SUBMITTED
        ) {
            activeQuote = dibsQuote;
        }
        return activeQuote;
    },
    getCurrentOrSubmittedShipmentQuote: function () {
        var currentShippingQuote = this.getCurrentShippingQuote();
        var dibsQuote = this.get1stdibsShipmentQuote();

        if (currentShippingQuote) {
            return currentShippingQuote;
        } else if (dibsQuote && dibsQuote.isQuoteSubmitted()) {
            return dibsQuote;
        }

        return null;
    },
    getDealerAcceptedQuote : function () {
        return this.get('shipmentQuotes').find(function (quote) {
            return _.contains(['PAYMENT_REQUIRED', 'BUYER_ACCEPTED'], quote.get('status'));
        });
    },
    getAcceptedQuote : function () {
        var acceptedQuote = this.get('shipment.acceptedQuote');
        if (!acceptedQuote || acceptedQuote.isLocalPickup()) {
            return undefined;
        }
        return acceptedQuote;
    },
    /**
     * Gets the current active accounting shipment quote.
     * This is the shipment quote on a transaction that is
     * not 'DEALER_REJECTED'. At this point in time, there
     * should not be more than on of these on an order.
     * @function
     * @returns {TransactionShipmentQuote}
     */
    getActiveAccountingShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'getActiveAccountingQuote'),
    /**
     * @function
     * @returns {TransactionShipmentQuote}
     */
    getRejectedAccountingShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'getRejectedAccountingQuote'),
    /**
     * @function
     * @param {string} currency
     * @returns {number}
     */
    getActiveAccountingShipmentQuoteSubTotal: function (currency) { // _.partial(getFromCollection, 'shipmentQuotes', 'getActiveAccountingQuoteSubTotal'),
        var quote = this.getActiveAccountingShipmentQuote();
        if (quote) {
            return quote.getSubTotal(currency);
        }
        return null;
    },
    /**
     * @function
     * @param {string} currency
     * @returns {number}
     */
    getActiveAccountingShipmentQuoteTotal: function (currency) { // _.partial(getFromCollection, 'shipmentQuotes', 'getActiveAccountingQuoteTotal'),
        var quote = this.getActiveAccountingShipmentQuote();
        if (quote) {
            return quote.getTotalAmount(currency);
        }
        return null;
    },
    get1stdibsShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'get1stdibsQuote'),
    getDealerShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'getDealerQuote'),
    getBuyerShipmentQuote: function () {
        var quote = this.getCurrentShippingQuote();

        if (quote && quote.get("status") !== "SUBMITTED") {
            return quote;
        }
    },

    /******************************
        Invoices
     ******************************/
    getDealerInvoice: _.partial(getFromCollection, 'invoices', 'getDealerInvoice'),
    getShipperInvoice: _.partial(getFromCollection, 'invoices', 'getShipperInvoice'),
    getBuyerInvoice: _.partial(getFromCollection, 'invoices', 'getBuyerInvoice'),
    getBuyerInvoiceItems: function () {
        var buyerInvoice = this.getBuyerInvoice();
        return buyerInvoice && buyerInvoice.get('invoiceItems');
    },

    /******************************
        Disbursements
     ******************************/
    getShipperDisbursement: _.partial(getFromCollection, 'disbursements', 'getShipperDisbursement'),
    getDealerDisbursement: _.partial(getFromCollection, 'disbursements', 'getDealerDisbursement'),

    /******************************
        Promotions
     ******************************/
    getActivePromo: _.partial(getFromCollection, 'promotions', 'getActivePromo'),
    getInvalidPromo: _.partial(getFromCollection, 'promotions', 'getInvalidPromo'),

    /******************************
        Notes
     ******************************/
    getReadyForPickupNote: function () {
        var shipment = this.get('shipment');
        if (shipment && !this.isDealerAuthoredShipping()) {
            return shipment.get('notes').getByCreatorRole('SELLER');
        }
    },
    getShippedNote: function () {
        var shipment = this.get('shipment');
        if (shipment && this.isDealerShipping()) {
            return shipment.get('notes').getByCreatorRole('SELLER');
        } else if (shipment && this.is1stdibsShipping()) {
            return shipment.get('notes').getByCreatorRole('INTERNAL');
        }
    },
    getBuyerSellerNotes: _.partial(getFromCollection, 'notes', 'getBuyerSellerNotes'),
    getUnanchoredBuyerSellerNotes: _.partial(getFromCollection, 'notes', 'getUnanchoredBuyerSellerNotes'),

    /******************************
        Item
     ******************************/
    getVertical: function () {
        return this.get('item.vertical');
    },

    /******************************
     Adjustments
     ******************************/
    getListingCreditAdjustment: function () {
        var invoice = this.getDealerInvoice();
        if (invoice) {
            return invoice.getListingCreditAdjustment();
        }
    },

    /******************************
        DisplayMetadata
     ******************************/
    getSlaStartDate: function () {
        return this.get('displayMetadata.sla.startDate');
    },

    /******************************
     Addresses
     ******************************/
    getShippingAddresses: function () {
        var addressBook = this.get('buyer.addressBook');
        var shippingAddresses = addressBook.getShippingAddresses() || [];
        return shippingAddresses;
    },
    getFirstShippingAddress: function () {
        var addresses = this.getShippingAddresses();
        return addresses && addresses[0];
    },

    /******************************
     Reviews
     ******************************/
    getFraudReview: function () {
        var paymentAuth = this.getOfferPaymentAuthorization();
        return paymentAuth && paymentAuth.getFraudReview();
    },

    getPaymentReview: function () {
        var paymentAuth = this.getOfferPaymentAuthorization();
        return paymentAuth && paymentAuth.getPaymentReview();
    },

    /******************************
     Actions
     ******************************/
    getActionStartDate: _.partial(getFromCollection, 'actions', 'getActionStartDate')

};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/21/14
 * Time: 5:05 PM
 */



var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var Party = __webpack_require__(8);
var Anchor = __webpack_require__(12);
var ShipmentQuote = __webpack_require__(73);
var Shipment = __webpack_require__(83);
var TransactionShipmentQuotes = __webpack_require__(78);
var Address = __webpack_require__(32);

/**
 * @mixin transactionShippingMixin
 */
module.exports = {
    getNumberOfPieces: function () {
        var item = this.get('item');
        var offer = this.getMostRecentOffer();

        if (!item || !offer) {
            // things are bad
            return 1;
        }

        if (item.soldIndividually()) {
            return offer.get('quantity');
        } else {
            return item.getNumberOfPieces();
        }
    },
    isEligibleFor1stdibsShipping: function () {
        return true;
    },
    /**
     * Returns true if shipping was known at checkout
     * @returns {Boolean}
     */
    isShippingKnownAtCheckout: function () {
        var isBuyerArrangedShipping = this.isBuyerShipping();
        var hasPreQuote = this.get('shipmentQuotes').hasPreQuoteIncludingCanceled();
        return hasPreQuote || isBuyerArrangedShipping;
    },
    /**
     * Returns true if buyer arranged shipping
     * @returns {Boolean}
     */
    isBuyerShipping: function () {
        return this.get('shipment').isBuyerArrangedShipping();
    },
    /**
     * Returns true if buyer arranged shipping
     * @deprecated Use isBuyerShipping instead
     * @returns {Boolean}
     */
    isBuyerArrangedShipping: function () {
        return this.isBuyerShipping();
    },

    /**
     * Returns true if dealer is shipping
     * @returns {Boolean}
     */
    isDealerShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && (acceptedQuote.isDealerBilledQuote() || this.is1stdibsSubsidizedDealerShipping());
    },

    /**
     * Returns true if dealer authored
     * the accepted quote
     * @returns {Boolean}
     */
    isDealerAuthoredShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.isDealerAuthoredQuote();
    },

    isDealerBilledShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.isDealerBilledQuote();
    },

    is1stdibsBilledShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsBilledQuote();
    },

    /**
     * Return true if 1stdibs authored the quote
     * @returns {boolean}
     */
    is1stdibsAuthoredShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return !!acceptedQuote && acceptedQuote.is1stdibsAuthoredQuote();
    },

    getShippingCostForTypeIn: function (costType, currency) {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote ? acceptedQuote.getSubTotalAmountForCostTypeIn(costType, currency) : null;
    },

    getCurrentShippingCostForTypeIn: function (costType, currency) {
        var quote = this.getCurrentShippingQuote();
        return quote ? quote.getSubTotalAmountForCostTypeIn(costType, currency) : null;
    },

    getShippingRequestReviewNoteContent: function () {
        var shipment = this.get('shipment');
        if (shipment) {
            return shipment.getShippingRequestReviewNoteContent();
        }
    },

    /**
     * Return true if the dealer needs to provide a shipment quote
     * @returns {boolean}
     */
    dealerQuoteNeeded: function () {
        var quotes = this.get('shipmentQuotes');
        return this.isShippingKnownAtCheckout() && !!quotes && !!quotes.noLocalPickupQuotes().length;
    },

    /**
     * Returns true if the item is shipped under the 1stdibs parcel
     * program (parcel shipping with a 1stdibs authored quote)
     * @returns {Boolean}
     */
    is1stdibsParcelShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsParcelQuote();
    },

    /**
     * Returns true if the item's shipping quote is authored by 1stdibs
     * and has white glove service method type
     * @returns {Boolean}
     */
    is1stdibsWhiteGloveShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsWhiteGloveQuote();
    },

    /**
     * Returns true if 1stdibs subsidizes the shipment
     * quote for the dealer. Right now this is true
     * only for 1sdibs parcel quotes and not for anything
     * else.
     * @returns {Boolean}
     */
    is1stdibsSubsidizedDealerShipping: function () {
        var accepted = this.getAcceptedQuote();
        return !!this.getAcceptedQuote() && accepted.is1stdibsSubsidizedDealerQuote();
    },

    /**
     * @returns {boolean}
     */
    isReadyToShip: function () {
        var shipment = this.get('shipment');
        return !!this.getAcceptedQuote() && this.isPending() && !shipment.hasBeenShipped();
    },

    /**
     * Returns true of an admin user has entered shipping info
     * for a transaction that has failed easy post address
     * registration. Currenlty, we know this is true when we
     * have a 1stdibs subsidized dealer shipping transaction
     * with an accepted, 1stdibs billed quote but no easypost-
     * supplied shipping label
     * @returns {boolean}
     */
    hasEnteredShippingInfo: function () {
        var activeQuote = this.getActiveAccountingShipmentQuote();
        return activeQuote &&
            this.is1stdibsSubsidizedDealerShipping() &&
            activeQuote.is1stdibsBilledQuote() &&
            activeQuote.wasAcceptedForAccounting() &&
            !this.getShipmentLabelURL();
    },

    /**
     * Returns true if 1stdibs (INTERNAL) is shipping
     * @returns {Boolean}
     */
    is1stdibsShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsBilledQuote() && !acceptedQuote.is1stdibsSubsidizedDealerQuote();
    },

    isPreQuote: function () {
        return this.get('shipmentQuotes').hasPreQuote();
    },
    isDealerPreQuote: function () {
        return this.isPreQuote() && this.isDealerBilledShipping();
    },
    is1stdibsPreQuote: function () {
        return this.isPreQuote() && this.is1stdibsShipping();
    },
    isLocalPickup: function () {
        return this.get('shipment').isLocalPickup();
    },
    isExternallyArranged: function () {
        return this.get('shipment').isExternallyArranged();
    },
    hasDealerRejectedQuote: function () {
        return !!this.getRejectedAccountingShipmentQuote();
    },
    /**
     * Get seller display val from the accepted shipment quote service method
     * @param [quote] Use this shipment quote instead of the accepted quote
     * @returns {*|string}
     */
    getSellerMethodDisplayVal: function (quote) {
        var serviceMethod;
        if (!quote) {
            quote = this.getAcceptedQuote();
        }
        serviceMethod = quote && quote.get('serviceMethod');
        if (serviceMethod) {
            return serviceMethod.getSellerMethodDisplayVal(this.getVertical());
        }
        return null;
    },
    /**
     * @deprecated Use isBuyerArrangedShipping, isDealerAuthoredShipping, and is1stdibsShipping instead;
     * @returns {String}
     */
    getShipper: function () {
        if (this.isBuyerShipping()) {
            return Party.ROLE_BUYER;
        } else if (this.isDealerShipping()) {
            return Party.ROLE_SELLER;
        } else if (this.is1stdibsShipping()) {
            return Party.ROLE_INTERNAL;
        }
        return null;
    },
    getBuyerShipmentMethodName: function () {
        var quote = this.getBuyerShipmentQuote();
        var method;

        if (quote.isLocalPickup()) {
            method = "Customer will pick up from dealer";
        } else if (quote) {
            method = quote.getBuyerServiceMethodDisplayValue();
        } else if (this.isBuyerShipping()) {
            method = "Customer Will Handle Shipping";
        } else {
            method = "TBD";
        }
        return method;
    },
    getShipmentAddresseeDisplayName: function () {
        return this.get('shipment').getAddresseeDisplayName();
    },
    getShipmentCountry: function () {
        return this.get('shipment.shippingAddress.country');
    },
    getShipmentType : function () {
        return this.get('shipment.shipmentType') || null;
    },
    getShipmentTypeDisplayVal: function () {
        if (this.isLocalPickup()) {
            return 'Customer Pickup';
        } else if (this.isBuyerShipping()) {
            return 'Customer Will Handle Shipping';
        } else if (this.isDealerPreQuote()) {
            return 'Dealer Flat Rate';
        } else if (this.is1stdibsSubsidizedDealerShipping() && this.is1stdibsParcelShipping()) {
            return '1stdibs Parcel Shipping';
        } else if (this.is1stdibsShipping()) {
            return '1stdibs Shipping';
        } else if (this.isDealerShipping()) {
            return 'Dealer Shipping';
        } else {
            return 'Customer Needs Item Shipped';
        }
    },

    /**
     * Get the shipment label
     * @returns {string}
     */
    getShipmentLabelURL: function () {
        var shipment = this.get('shipment');
        return shipment ? shipment.getTrackingLabelURL() : null;
    },

    /**
     * @returns {string}
     */
    getShipmentTrackingNumber: function () {
        var shipment = this.get('shipment');
        return shipment ? shipment.getTrackingNumber() : null;
    },

    /**
     * Get a new Note anchored to the shipment (and
     * other standard transactions)
     * @param {object} noteOptions
     * @returns {Note}
     */
    newNoteForShipment: function (noteOptions) {
        return this.newNote(noteOptions, [this._getShipmentAnchorAttrs()]);
    },
    /**
     * Get a new note of type BUYER_SELLER anchored
     * to the shipment;
     * @param noteOptions
     * @returns {Note}
     */
    newBuyerSellerNoteForShipment: function (noteOptions) {
        return this.newBuyerSellerNote(noteOptions, [this._getShipmentAnchorAttrs()]);
    },
    /**
     * @param {ShipmentQuote} shipmentQuote
     * @param {object} [noteOptions]
     * @returns {Note}
     */
    newBuyerSellerNoteForShipmentQuote: function (shipmentQuote, noteOptions) {
        console.assert(shipmentQuote instanceof ShipmentQuote, 'shipmentQuote must be a ShipmentQuote');
        return this.newBuyerSellerNote(noteOptions, [this._getShipmentQuoteAnchorAttrs(shipmentQuote)]);
    },
    /**
     * @param {ShipmentQuote} shipmentQuote
     * @param {object} [noteOptions]
     * @returns {Note}
     */
    newNoteForShipmentQuote: function (shipmentQuote, noteOptions) {
        console.assert(shipmentQuote instanceof ShipmentQuote, 'shipmentQuote must be a ShipmentQuote');
        return this.newNote(noteOptions, [this._getShipmentQuoteAnchorAttrs(shipmentQuote)]);
    },
    _getShipmentQuoteAnchorAttrs: function (shipmentQuote) {
        return {
            sourceId: shipmentQuote.id,
            sourceType: Anchor.TYPE_SHIPMENT_QUOTE
        };
    },
    _getShipmentAnchorAttrs: function () {
        return {
            sourceType: Anchor.TYPE_SHIPMENT,
            sourceId: this.get('shipment').id
        };
    },
    /**
     * sets the shipping address with a unified event
     * @param address
     */
    setShippingAddress: function (address) {
        this.get('shipment').set('shippingAddress', address);
        this.trigger('shippingAddressChanged');
    },
    /**
     * Used before checkout to make a transaction use a shipment quote
     */
    setShipmentQuote: function (shipmentQuote) {
        if (shipmentQuote.isLocalPickup()) {
            this.get('shipment').set('shipmentType', Shipment.TYPE_LOCAL_PICKUP);
        } else {
            this.get('shipment').set('shipmentType', Shipment.TYPE_FIRSTDIBS_FACILITATED);
        }
        this.get('shipmentQuotes').reset([shipmentQuote]);
        this.get('shipment').set('acceptedQuote', shipmentQuote);
        this.trigger('shippingChanged');
    },
    /**
     * Used before checkout to make a transaction externally arranged
     */
    setExternallyArranged: function () {
        this.get('shipmentQuotes').reset(); // remove all shipment quotes
        this.get('shipment').unset('acceptedQuote');
        this.get('shipment').set('shipmentType', Shipment.TYPE_EXTERNALLY_ARRANGED);
        this.trigger('shippingChanged');
    },
    /**
     * Used before checkout to make a transaction "quote needed"
     */
    setQuoteNeeded: function () {
        this.get('shipmentQuotes').reset(); // remove all shipment quotes
        this.get('shipment').unset('acceptedQuote');
        this.get('shipment').set('shipmentType', Shipment.TYPE_FIRSTDIBS_FACILITATED);
        this.trigger('shippingChanged');
    },
    fetchAvailableOptions: function (address) {
        var availableOptions = new TransactionShipmentQuotes();
        var currencyConversionRateEventId = this.get('currencyConversionRateEvent.id');
        var item = this.get('item');

        address = address || this.get('shipment.shippingAddress');

        if (!(address && address.get('country'))) {
            address = new Address({country: 'US'});
        }

        // Cancel any outstanding requests
        if (this._availableOptionsDeferred) {
            this._availableOptionsDeferred.reject();
        }

        this._availableOptionsDeferred = new $.Deferred();
        availableOptions.fetchAvailableOptions(item, address, currencyConversionRateEventId).done(_.bind(function () {
            this.availableOptions = availableOptions;
            this.selectFirstAvailableOption();
            this._availableOptionsDeferred.resolve(availableOptions);
        }, this)).fail(_.bind(function () {
            this._availableOptionsDeferred.reject();
        }, this));
        return this._availableOptionsDeferred.promise();
    },
    /**
     * Returns a promise that resolves with the available options.
     * Only fetches if they have not already been fetched
     */
    getAvailableOptionsPromise: function () {
        if (this._availableOptionsDeferred && this._availableOptionsDeferred.promise()) {
            return this._availableOptionsDeferred.promise();
        } else {
            return this.fetchAvailableOptions();
        }
    },
    selectFirstAvailableOption: function () {
        var quote = this.availableOptions.getNonLocalShipmentQuotes()[0];
        if (quote) {
            this.setShipmentQuote(quote);
        } else {
            this.setQuoteNeeded();
        }
    },
    showOverrideUpsLabel: function () {
        var shipment = this.get('shipment');
        var hasBeenShipped = shipment.hasBeenShipped();
        var hasFailedAddressRegistration = shipment.hasFailedAddressRegistration();
        return !!(this.isConfirmed() && this.is1stdibsParcelShipping() && hasBeenShipped === false && hasFailedAddressRegistration === false);
    },
    /**
     * Returns true or false depending on whether UPS label override was successful.
     * Checks that there are two accounting quotes: one canceled and one accepted.
     */
    wasOverrideUpsLabelSuccessful: function () {
        var shipmentQuotes = this.get('shipmentQuotes');
        var canceledQuote = shipmentQuotes.find(function (quote) {
            return quote.get('pricingType') === "ACCOUNTING" && quote.get('status') === "CANCELED";
        });
        var acceptedQuote = shipmentQuotes.find(function (quote) {
            return quote.get('pricingType') === "ACCOUNTING" && quote.get('status') === "ACCEPTED";
        });
        return !!(canceledQuote && acceptedQuote);
    }
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/**
 * filesize
 *
 * @copyright 2016 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 3.1.6
 */
(function (global) {
	var b = /^(b|B)$/;
	var si = {
		bits: ["b", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"],
		bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
	};

	/**
  * filesize
  *
  * @method filesize
  * @param  {Mixed}   arg        String, Int or Float to transform
  * @param  {Object}  descriptor [Optional] Flags
  * @return {String}             Readable file size String
  */
	function filesize(arg) {
		var descriptor = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		var result = [],
		    skip = false,
		    val = 0,
		    e = undefined,
		    base = undefined,
		    bits = undefined,
		    ceil = undefined,
		    neg = undefined,
		    num = undefined,
		    output = undefined,
		    round = undefined,
		    unix = undefined,
		    spacer = undefined,
		    suffixes = undefined;

		if (isNaN(arg)) {
			throw new Error("Invalid arguments");
		}

		bits = descriptor.bits === true;
		unix = descriptor.unix === true;
		base = descriptor.base !== undefined ? descriptor.base : 2;
		round = descriptor.round !== undefined ? descriptor.round : unix ? 1 : 2;
		spacer = descriptor.spacer !== undefined ? descriptor.spacer : unix ? "" : " ";
		suffixes = descriptor.suffixes !== undefined ? descriptor.suffixes : {};
		output = descriptor.output !== undefined ? descriptor.output : "string";
		e = descriptor.exponent !== undefined ? descriptor.exponent : -1;
		num = Number(arg);
		neg = num < 0;
		ceil = base > 2 ? 1000 : 1024;

		// Flipping a negative number to determine the size
		if (neg) {
			num = -num;
		}

		// Zero is now a special case because bytes divide by 1
		if (num === 0) {
			result[0] = 0;
			result[1] = unix ? "" : !bits ? "B" : "b";
		} else {
			// Determining the exponent
			if (e === -1 || isNaN(e)) {
				e = Math.floor(Math.log(num) / Math.log(ceil));
			}

			// Exceeding supported length, time to reduce & multiply
			if (e > 8) {
				e = 8;
			}

			val = base === 2 ? num / Math.pow(2, e * 10) : num / Math.pow(1000, e);

			if (bits) {
				val = val * 8;

				if (val > ceil) {
					val = val / ceil;
					e++;
				}
			}

			result[0] = Number(val.toFixed(e > 0 ? round : 0));
			result[1] = base === 10 && e === 1 ? bits ? "kb" : "kB" : si[bits ? "bits" : "bytes"][e];

			if (!skip && unix) {
				result[1] = result[1].charAt(0);

				if (b.test(result[1])) {
					result[0] = Math.floor(result[0]);
					result[1] = "";
				}
			}
		}

		// Decorating a 'diff'
		if (neg) {
			result[0] = -result[0];
		}

		// Applying custom suffix
		result[1] = suffixes[result[1]] || result[1];

		// Returning Array, Object, or String (default)
		if (output === "array") {
			return result;
		}

		if (output === "exponent") {
			return e;
		}

		if (output === "object") {
			return { value: result[0], suffix: result[1] };
		}

		return result.join(spacer);
	}

	// CommonJS, AMD, script tag
	if (true) {
		module.exports = filesize;
	} else if (typeof define === "function" && define.amd) {
		define(function () {
			return filesize;
		});
	} else {
		global.filesize = filesize;
	}
})(typeof window !== "undefined" ? window : global);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * lodash 3.2.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return function() {
    var length = arguments.length,
        index = fromRight ? length : -1,
        leftIndex = 0,
        funcs = Array(length);

    while ((fromRight ? index-- : ++index < length)) {
      var func = funcs[leftIndex++] = arguments[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
    }
    return function() {
      var index = 0,
          result = length ? funcs[index].apply(this, arguments) : arguments[0];

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  };
}

/**
 * Creates a function that returns the result of invoking the provided
 * functions with the `this` binding of the created function, where each
 * successive invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {...Function} [funcs] Functions to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow(_.add, square);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 43);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

module.exports = __webpack_require__(77);

/***/ },
/* 1 */
/***/ function(module, exports) {

module.exports = __webpack_require__(108);

/***/ },
/* 2 */
/***/ function(module, exports) {

module.exports = __webpack_require__(0);

/***/ },
/* 3 */
/***/ function(module, exports) {

module.exports = __webpack_require__(100);

/***/ },
/* 4 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"badgeTrade":"src-views-MessageSummary-style---badgeTrade---3_OuL","mcMessageSummary":"src-views-MessageSummary-style---mcMessageSummary---kNbyt","mcMessage":"src-views-MessageSummary-style---mcMessage---1oiTz","mcMessageBodyWrapper":"src-views-MessageSummary-style---mcMessageBodyWrapper---2WSIw","mcMessageHeader":"src-views-MessageSummary-style---mcMessageHeader---2uvej","attachmentErrorList":"src-views-MessageSummary-style---attachmentErrorList---1xm88","mcDisplayName":"src-views-MessageSummary-style---mcDisplayName---vfQDh","mcMessageBody":"src-views-MessageSummary-style---mcMessageBody---1GvUw","mcComposeControls":"src-views-MessageSummary-style---mcComposeControls---1hK4F","mcHasAttachment":"src-views-MessageSummary-style---mcHasAttachment---2exkf","mcMessageAttachIcon":"src-views-MessageSummary-style---mcMessageAttachIcon---1w0sl","showFlaggedMessage":"src-views-MessageSummary-style---showFlaggedMessage---2uqiX","mcAttachmentList":"src-views-MessageSummary-style---mcAttachmentList---2pPdO","numCollapsedIndicator":"src-views-MessageSummary-style---numCollapsedIndicator---2iis9","mcSentByCurrentUser":"src-views-MessageSummary-style---mcSentByCurrentUser---1l1CG","numCollapsedIndicatorTextWrapper":"src-views-MessageSummary-style---numCollapsedIndicatorTextWrapper---16Cj2","mcMessageBodyPlaceholder":"src-views-MessageSummary-style---mcMessageBodyPlaceholder---18NZ0","mcAttachmentFilename":"src-views-MessageSummary-style---mcAttachmentFilename---2gCw8","mcAttachmentImage":"src-views-MessageSummary-style---mcAttachmentImage---3ijZC","mcAttachmentLoading":"src-views-MessageSummary-style---mcAttachmentLoading---3IxqZ","mcAttachmentFileSize":"src-views-MessageSummary-style---mcAttachmentFileSize---3z4_i","mcAttachmentIcon":"src-views-MessageSummary-style---mcAttachmentIcon---2LpFf","attachmentListDisplay":"src-views-MessageSummary-style---attachmentListDisplay---2JMWZ","mcAttachmentListUgc":"src-views-MessageSummary-style---mcAttachmentListUgc---3hn19","mcAttachmentRow":"src-views-MessageSummary-style---mcAttachmentRow---JzKZX","mcAttachmentItem":"src-views-MessageSummary-style---mcAttachmentItem---2FPfP","mcAttachmentFileName":"src-views-MessageSummary-style---mcAttachmentFileName---1Xh6n","mcComposeAttachButton":"src-views-MessageSummary-style---mcComposeAttachButton---1V3qu","mcComposeAttachIcon":"src-views-MessageSummary-style---mcComposeAttachIcon---3Nr4u","mcComposeSend":"src-views-MessageSummary-style---mcComposeSend---3_D07","mcComposeSendContainer":"src-views-MessageSummary-style---mcComposeSendContainer---Rzndb","privateOfferIndicator":"src-views-MessageSummary-style---privateOfferIndicator---3Csxe","mcAttachmentListDisplay":"src-views-MessageSummary-style---mcAttachmentListDisplay---2YGRw","mcDisplayDate":"src-views-MessageSummary-style---mcDisplayDate---CZzq4","semiCollapsedOnly":"src-views-MessageSummary-style---semiCollapsedOnly---3Ydnp","privateOfferIcon":"src-views-MessageSummary-style---privateOfferIcon---2Ifnc","privateOfferPrice":"src-views-MessageSummary-style---privateOfferPrice---3vEKL","messageFlaggedIcon":"src-views-MessageSummary-style---messageFlaggedIcon---qJfoV"};

/***/ },
/* 5 */
/***/ function(module, exports) {

module.exports = __webpack_require__(39);

/***/ },
/* 6 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"badgeTrade":"src-views-Conversation-style---badgeTrade---1XAW5","mcAllConversationsBlock":"src-views-Conversation-style---mcAllConversationsBlock---11C93","mcConversationAlertContainer":"src-views-Conversation-style---mcConversationAlertContainer---1k0K-","alert":"src-views-Conversation-style---alert---1MLIK","mcBodyContainer":"src-views-Conversation-style---mcBodyContainer---1IPwx","mcUnavailableContainer":"src-views-Conversation-style---mcUnavailableContainer---2KAJu","mcUnvailableMessageSub":"src-views-Conversation-style---mcUnvailableMessageSub---wQTc0","cantShowConversationMessage":"src-views-Conversation-style---cantShowConversationMessage---1MmZx","mcConversationWrapper":"src-views-Conversation-style---mcConversationWrapper---1yBOA","mcConversationFooter":"src-views-Conversation-style---mcConversationFooter---19m1Y","mcConversationFilterAlert":"src-views-Conversation-style---mcConversationFilterAlert---tGRPM","mcConversationToolbar":"src-views-Conversation-style---mcConversationToolbar---1w7eM","mcConversationToolbarItemDisabled":"src-views-Conversation-style---mcConversationToolbarItemDisabled---npgNA","mcConversationReported":"src-views-Conversation-style---mcConversationReported---3fKZG","fa":"src-views-Conversation-style---fa----E6a4","mcBuyerConversation":"src-views-Conversation-style---mcBuyerConversation---UdSl0","alertAction":"src-views-Conversation-style---alertAction---21J4Z","conversationHeadsUp":"src-views-Conversation-style---conversationHeadsUp---286Ej","expandCollapseAll":"src-views-Conversation-style---expandCollapseAll---dqWF1","underneathConversation":"src-views-Conversation-style---underneathConversation---3udfU","alertContainer":"src-views-Conversation-style---alertContainer---OAGYl","exclamationIcon":"src-views-Conversation-style---exclamationIcon---M0DQV","circleIcon":"src-views-Conversation-style---circleIcon---K3Yzq"};

/***/ },
/* 7 */
/***/ function(module, exports) {

module.exports = __webpack_require__(148);

/***/ },
/* 8 */
/***/ function(module, exports) {

module.exports = __webpack_require__(149);

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var momentLocaleBuilder = __webpack_require__(42);
var moment = __webpack_require__(41);
var locales = {};
locales.en = {};
locales.inlineDatesAdverb = Object.assign({}, locales.inlineDates, {
    calendar: {
        sameDay: '[at] h:mmA',
        lastDay: '[on] MMMM D',
        nextDay: '[on] MMMM D',
        lastWeek: '[on] MMMM D',
        nextWeek: '[on] MMMM D',
        sameElse: function sameElse(now) {
            return '[on] MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    },
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    }
});
locales.inlineDates = {
    calendar: {
        sameDay: 'h:mmA',
        lastDay: 'MMMM D',
        nextDay: 'MMMM D',
        lastWeek: 'MMMM D',
        nextWeek: 'MMMM D',
        sameElse: function sameElse(now) {
            return 'MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    },
    relativeTime: Object.assign({}, locales.inlineDatesAdverb.relativeTime, {
        future: "%s",
        past: "%s"
    })
};
locales.inbox = {
    calendar: {
        sameDay: 'h:mmA',
        lastDay: 'dddd',
        nextDay: 'dddd',
        lastWeek: 'MMMM D',
        nextWeek: 'MMMM D',
        sameElse: function sameElse(now) {
            return 'MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    }
};
locales.inboxMobile = Object.assign({}, locales.inbox, {
    calendar: Object.assign({}, locales.inbox.calendar, {
        lastDay: 'ddd',
        nextDay: 'ddd',
        lastWeek: 'MMM D',
        nextWeek: 'MMM D',
        sameElse: function sameElse(now) {
            return 'MMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    })
});
module.exports = momentLocaleBuilder(locales);

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var composeClassNames = __webpack_require__(3);
var css = composeClassNames(__webpack_require__(26), __webpack_require__(4));
var AttachmentView = module.exports = {};
var TemplateView = __webpack_require__(0);
var template = __webpack_require__(32);
var defaultIconClass = 'fa-file-o';
var bind = __webpack_require__(1);
var fileTypeToIconClassMap = {
    'application/pdf': 'fa-file-pdf-o',
    "application/msword": 'fa-file-word-o',
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": 'fa-file-word-o',
    "application/vnd.ms-excel": 'fa-file-excel-o',
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": 'fa-file-excel-o',
    //TODO: remove these duplicate mappings once services return MIME types for attachments
    'PDF': 'fa-file-pdf-o',
    'DOC': 'fa-file-word-o',
    'SPREADSHEET': 'fa-file-excel-o'
};

AttachmentView.Thumbnail = TemplateView.extend({
    initialize__: function initialize__(options) {
        bind(this);
        this.el.classList.add(css.attachmentImageWrapper);
        return options;
    },

    template: {
        local: css,
        src: template.thumbnail
    }
});
AttachmentView.Document = TemplateView.extend({
    template: {
        local: css,
        src: template.normal
    },
    initialize__: function initialize__(options) {
        bind(this);
        return options;
    },
    fileTypeToIconClass: function fileTypeToIconClass(fileType) {
        return fileTypeToIconClassMap[fileType] || defaultIconClass;
    },
    templateVars__: function templateVars__(obj) {
        return Object.assign({
            iconClass: this.fileTypeToIconClass(this.model.get('attachmentType'))
        }, obj);
    }
});
AttachmentView.Loading = TemplateView.extend({
    template: {
        local: css,
        src: template.loading
    }
});
AttachmentView.buildAttachmentByModel = function (attachmentModel) {
    var Constructor = AttachmentView.Loading;
    var attachmentType = attachmentModel.get('attachmentType');
    if ('IMAGE' === attachmentType) {
        Constructor = AttachmentView.Thumbnail;
    } else if (attachmentType) {
        Constructor = AttachmentView.Document;
    }
    return new Constructor({ model: attachmentModel });
};

/***/ },
/* 11 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"src-views-InboxWrapper-style---verticallyCentered---2E4xh","horizontallyRight":"src-views-InboxWrapper-style---horizontallyRight---3ID5-","horizontallyCentered":"src-views-InboxWrapper-style---horizontallyCentered---nMmCz","verticallyHorizontallyCentered":"src-views-InboxWrapper-style---verticallyHorizontallyCentered---11cGH","inbox":"src-views-InboxWrapper-style---inbox---U_kT8","mcUnreadMessage":"src-views-InboxWrapper-style---mcUnreadMessage---1SEGx","mcHeader":"src-views-InboxWrapper-style---mcHeader---1k5zB","mcFilterLabel":"src-views-InboxWrapper-style---mcFilterLabel---3e2zN","alertContainer":"src-views-InboxWrapper-style---alertContainer---3S1pv node_modules-scss-alignment-transforms-index---horizontallyCentered---OykGB","close":"src-views-InboxWrapper-style---close---3z2W0","alertAction":"src-views-InboxWrapper-style---alertAction---2g0RC","heading":"src-views-InboxWrapper-style---heading---1KHIE","inboxPanel":"src-views-InboxWrapper-style---inboxPanel---3osEQ","mcInboxEmptyContainer":"src-views-InboxWrapper-style---mcInboxEmptyContainer---W6jaB","mcInboxEmptyMessage":"src-views-InboxWrapper-style---mcInboxEmptyMessage---19k3K","mcInboxEmptyDivider":"src-views-InboxWrapper-style---mcInboxEmptyDivider---3Iyfe","mcInboxEmptyLinkContainer":"src-views-InboxWrapper-style---mcInboxEmptyLinkContainer---22wCz","mcInboxEmptyLink":"src-views-InboxWrapper-style---mcInboxEmptyLink---15xOp","mcItemsContainer":"src-views-InboxWrapper-style---mcItemsContainer---1SqYs"};

/***/ },
/* 12 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcBrowseHeader":"src-views-MessageCenter-style---mcBrowseHeader---2TEMQ","totalUnreadConversationCount":"src-views-MessageCenter-style---totalUnreadConversationCount---1fqcH"};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "template": function(obj) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="' +
((__t = ( obj.local.mcConversationWrapper )) == null ? '' : __t) +
' wrapper' +
((__t = ( obj.isUnavailable ? ' is-unavailable' : '' )) == null ? '' : __t) +
'">\n        <div class="' +
((__t = ( obj.messageLocation )) == null ? '' : __t) +
'"></div>\n        <div data-append=\'conversationHeader\'></div>\n        <div class="' +
((__t = ( obj.local.mcBodyContainer )) == null ? '' : __t) +
'">\n            <div class="row">\n                <div class="col-xs-12 col-md-8 col-md-push-2" data-append=\'notificationMsg\'></div>\n                <div class="' +
((__t = ( obj.local.mcMessagesColumn )) == null ? '' : __t) +
' col-xs-12 col-md-8 col-md-push-4">\n                    ';
 if (obj.isUnavailable) { ;
__p += '\n                        <div class="' +
((__t = ( obj.local.mcUnavailableContainer )) == null ? '' : __t) +
'">\n                            <div class="' +
((__t = ( obj.local.mcUnvailableMessage )) == null ? '' : __t) +
'">' +
((__t = ( obj.copy('unavailableMessage') )) == null ? '' : __t) +
'</div>\n                            <div class="' +
((__t = ( obj.local.mcUnvailableMessageSub )) == null ? '' : __t) +
'">' +
((__t = ( obj.copy('unavailableMessageSub') )) == null ? '' : __t) +
'</div>\n                        </div>\n                    ';
 } ;
__p += '\n                    <div data-append=\'headsUps\' class=\'gtm-message-detail-header\'></div>\n                    <div class=\'' +
((__t = ( obj.local.expandCollapseAll )) == null ? '' : __t) +
'\' data-model-bind=\'text: model.expandCollapseText, click: view.toggleExpandCollapse\'></div>\n                    <div data-append=\'messages\'></div>\n                    <div class=\'' +
((__t = ( obj.local.mcConversationFooter )) == null ? '' : __t) +
'\'>\n                        <span class="' +
__e( obj.local.alertContainer ) +
'" data-append=\'alertIcon\'></span>\n                        <span class="' +
((__t = ( obj.local.mcConversationFilterAlert )) == null ? '' : __t) +
'">\n                            <span class=\'' +
((__t = ( obj.local.underneathConversation )) == null ? '' : __t) +
'\' data-append=\'underneath\'></span>\n                        </span>\n                        <span class=\'' +
((__t = ( obj.local.mcConversationToolbar )) == null ? '' : __t) +
'\'>\n                            ';
 if (obj.messages) { ;
__p += '\n                            <span data-modal=\'flagConversation\' class=\'gtm-modal-trigger\' data-modal-name=\'report conversation\' data-modal-trigger=\'hyperlink\' data-model-bind=\'css: {"' +
((__t = ( obj.local.mcConversationReported )) == null ? '' : __t) +
'": computed.userHasReportedConversation}, attr: {"data-modal": computed.userHasReportedConversation ? "alreadyReportedConversation" : "flagConversation"}\'>\n                                <span data-model-bind=\'text: (computed.userHasReportedConversation ? "reported" : "report") + " conversation"\'></span>\n                            </span>\n                            ';
 } ;
__p += '\n                        </span>\n                    </div>\n                </div>\n                <div class="col-xs-12 col-md-4 col-md-pull-8" data-append="sidePiece"></div>\n            </div>\n        </div>\n    </div>\n    <div data-append="bottomSection"></div>\n';
return __p
}
};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _bubbleEvent = __webpack_require__(8);

var _bubbleEvent2 = _interopRequireDefault(_bubbleEvent);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = (0, _composeClassNames2.default)(__webpack_require__(27), __webpack_require__(4));
var bind = __webpack_require__(1);
var MessageAttachmentView = __webpack_require__(10);
var template = __webpack_require__(33).attachmentIndicator;
module.exports = MessageAttachmentView.Document.extend({
    events: {
        'click [data-name=try-again]': function clickDataNameTryAgain() {
            this.model.save();
        },
        'click [data-name=remove-attachment]': function clickDataNameRemoveAttachment() {
            this.removeAttachment();
        }
    },
    template__: {
        src: template,
        local__: css
    },
    updateProgress: function updateProgress() {
        var uploadProgress = '';
        var uploadTotal = this.model.get('upload-total');
        if (!uploadTotal) {
            return;
        }
        uploadProgress += Math.floor(this.model.get('upload-sent') * 100 / uploadTotal);
        uploadProgress += '%';
        this.el.querySelector('[name=upload-progress]').textContent = uploadProgress;
    },
    removeAttachment: function removeAttachment() {
        return (0, _bubbleEvent2.default)(this.el, 'remove-attachment', this.model);
    },
    initialize__: function initialize__(options) {
        this.model.on('change:upload-sent', this.updateProgress, this); // TODO: handle this with bindings
        bind(this);
        return options;
    }
}, {
    newsy: 'AttachmentIndicator'
});

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

var _style = __webpack_require__(4);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(28);

var _style4 = _interopRequireDefault(_style3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: (0, _composeClassNames2.default)(_style2.default, _style4.default)
    }
});

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _template = __webpack_require__(13);

var _style = __webpack_require__(6);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        src: _template.template,
        local: _style2.default,
        messageLocation: '.' + _style2.default.mcConversationAlertContainer
    }
});

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(12);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(6);

var _style4 = _interopRequireDefault(_style3);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

var _template = __webpack_require__(13);

var _backboneModel = __webpack_require__(7);

var _b3nd = __webpack_require__(1);

var _b3nd2 = _interopRequireDefault(_b3nd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    initialize__: function initialize__(options) {
        this.model = new _backboneModel.Model();
        // b3nd this view here because its template declares b3ndings.
        // Otherwise, the parent view will try to evaluate the b3ndings and get very confused.
        (0, _b3nd2.default)(this);
        return options;
    },

    template: {
        src: _template.template,
        local: (0, _composeClassNames2.default)(_style2.default, _style4.default)
    }
});

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _template = __webpack_require__(34);

var TemplateView = __webpack_require__(0);
var css = __webpack_require__(29);
var copyText = __webpack_require__(5)();
var bind = __webpack_require__(1);
var OfferDiscountAmounts = __webpack_require__(25);

var PRIVATE_OFFER_NOTIFICATION_TYPE = 'newDealerOffer';
var SHOW_DISCOUNT_NOTIFICATION_TYPE = 'newDealerOfferDiscount';
var MARK_SHIPPED_NOTIFICATION_TYPE = 'markShippedNotification';
var PRICE_TYPE_RETAIL = 'RETAIL';
var PRICE_TYPE_SALE = 'WEEKLY_SALE';
var PRICE_TYPE_NET = 'NET';
var ITEM_PUR = 'Price Upon Request';
var ITEM_SOLD = 'Sold';

var ConversationHeadsUpView = module.exports = TemplateView.extend({
    template: {
        local: css,
        src: _template.template
    },
    initialize: function initialize(options) {
        var _this = this;

        if (!this.model) {
            throw new Error("ConversationHeadsUpView must be constructed with a model");
        }
        this.context = options.context;
        this.props = Object.assign({}, options.props);
        if (!this.context) {
            throw new Error('ConversationHeadsUpView view requires options.context');
        }
        this._copyText = (options.copyText || copyText).extend({
            netPriceLabel: 'Net Price',
            salePriceLabel: 'Sale Price',
            listPriceLabel: 'List Price',
            netLabel: 'net',
            listLabel: 'list'
        });
        this._messageCenter = options.messageCenter;
        this._item = this.model.get('item');
        this._itemStatus = this._item && this._item.getItemHidePriceStatus();
        this._buyerIsTrade = Boolean(this.model.get('members').find(function (member) {
            var roles = member.get('user').get('roles');
            if (!roles) {
                return undefined;
            }
            return Boolean(roles.find(function (role) {
                return role.get('name') === 'B_TRADE_BUYER';
            }));
        }));

        ConversationHeadsUpView.__super__.initialize.apply(this, arguments);
        this._bindApi = bind(this);
        this._bindApi.off(); // MCPERSON-2486: opt in to model change binding via .on()
        this.model.on('change:transaction', function () {
            return _this._bindApi.forceUpdate();
        });
        return options;
    },
    templateVars__: function templateVars__(obj) {
        return Object.assign({
            isSoldIndividually: this.props.isSoldIndividually,
            thumbnail: this.props.thumbnail,
            pdpUrl: this.props.pdpUrl,
            prices: this._getPricesArray()
        }, obj);
    },
    _getOfferDisplayVars: function _getOfferDisplayVars() {
        var notificationDetails = { notificationMsg: '', offerExpDateTxt: '' };
        var transaction = this.model.get('transaction');
        var offerDetails = transaction ? transaction.getOfferDetails() : {};
        var offer = offerDetails.offer;
        var offerAmounts = offerDetails.offerAmounts;

        if (!offer || !offerAmounts) {
            return notificationDetails;
        }

        var transactionSummary = transaction.get('summary');
        /* istanbul ignore next */
        var transactionItemPriceType = transactionSummary ? transactionSummary.get('itemPrice.type') : undefined;
        var copyKeyPrefix = transaction.isBuyerInitiatedTx() ? 'buyer' : 'dealer';
        var offerExpiredOrCanceledOtherOverride = this._copyText.get(copyKeyPrefix + 'OfferExpiredOrCanceledOtherOverride');
        var offerPassedOverride = this._copyText.get(copyKeyPrefix + 'OfferPassedOverride');
        var showPrice = !this._itemStatus;

        var notificationType = offer.offerDisplayStatus({ transaction: transaction });
        var displayOffer = this._getFormattedPrice({ financialAmount: offerAmounts, className: 'item-offer-price' });
        var displayDiscount = void 0;
        var pcsNotification = void 0;
        var priceType = void 0;
        var discountOffMultiplier = void 0;
        var displayDiscountPercent = void 0;

        if (!notificationType) {
            return notificationDetails;
        }

        if (showPrice && notificationType === PRIVATE_OFFER_NOTIFICATION_TYPE) {
            displayDiscount = this._getFormattedPrice({
                financialAmount: new OfferDiscountAmounts(transactionSummary.get('offerDiscountAmount')),
                className: 'item-offer-price'
            });
            discountOffMultiplier = parseFloat(transactionSummary.get('offerDiscountPercentage'));
            displayDiscountPercent = Math.floor(discountOffMultiplier * 100) + '%';
        }

        if (displayDiscount) {
            /* istanbul ignore next */
            priceType = this._copyText.get(transactionItemPriceType === PRICE_TYPE_NET ? 'netLabel' : 'listLabel');
            if (discountOffMultiplier > 0) {
                notificationType = SHOW_DISCOUNT_NOTIFICATION_TYPE;
            }
            if (offerAmounts.getAmountIn('USD') > 5000 && !this._buyerIsTrade) {
                pcsNotification = this._copyText.get('pcsNotification');
            }
        }

        if (this._canMarkOrderShipped) {
            notificationType = MARK_SHIPPED_NOTIFICATION_TYPE;
        }

        /* istanbul ignore next */
        if (this.props.isSoldIndividually) {
            var perItem = this._copyText.get('per item');
            displayOffer = displayOffer + ' ' + perItem;
            displayDiscount = displayDiscount ? displayDiscount + ' ' + perItem : undefined;
            displayDiscountPercent = displayDiscountPercent ? displayDiscountPercent + ' ' + perItem : undefined;
        }

        notificationDetails.pcsNotification = pcsNotification;
        notificationDetails.offerExpDateTxt = offerDetails.offerExpDateTxt;
        notificationDetails.notificationMsg = this._copyText.get(notificationType, { obj: {
                txId: transaction.get('id'),
                displayOffer: displayOffer,
                displayDiscount: displayDiscount,
                displayDiscountPercent: displayDiscountPercent,
                offerExpiredOrCanceledOtherOverride: offerExpiredOrCanceledOtherOverride,
                offerPassedOverride: offerPassedOverride,
                priceType: priceType,
                detailsLinkClassName: css.headsUpViewDOMT
            } });

        return notificationDetails;
    },
    _getPricesArray: function _getPricesArray() {
        var prices = [];
        var showPrice = !this._itemStatus;
        if (!this._item) {
            return prices;
        }

        var salePrice = this._item.getPriceByType(PRICE_TYPE_SALE);
        var retailPrice = this._item.getPriceByType(PRICE_TYPE_RETAIL);
        var netPrice = this._item.getPriceByType(PRICE_TYPE_NET);

        var initialPrice = void 0;
        if (salePrice) {
            initialPrice = {
                label: this._copyText.get('salePriceLabel'),
                value: this._getFormattedPrice({ financialAmount: salePrice.get('amount') }),
                type: PRICE_TYPE_SALE
            };
        } else if (showPrice) {
            initialPrice = {
                label: this._copyText.get('listPriceLabel'),
                value: this._getFormattedPrice({ financialAmount: retailPrice.get('amount') }),
                type: PRICE_TYPE_RETAIL
            };
        } else {
            initialPrice = { label: this._itemStatus };
        }

        var isTrade = this._buyerIsTrade && this._item.isFurniture();
        var transaction = this.model.get('transaction');
        var offerDetails = transaction ? transaction.getOfferDetails() : {};
        var offer = offerDetails.offer;
        var offerAmounts = offerDetails.offerAmounts;

        if (initialPrice.label === ITEM_SOLD) {
            prices.push(initialPrice);
            return prices;
        }

        if (isTrade && netPrice && this._isNetPriceEnabled() && initialPrice.type !== PRICE_TYPE_SALE) {
            // Don't show "Price Upon Request" if net price was uploaded
            if (initialPrice.label !== ITEM_PUR) {
                prices.push(initialPrice);
            }

            prices.push({
                label: this._copyText.get('netPriceLabel'),
                value: this._getFormattedPrice({ financialAmount: netPrice.get('amount') }),
                type: PRICE_TYPE_NET,
                callout: 'listedNetPriceCallout'
            });
        } else {
            prices.push(initialPrice);
        }

        if (offer && offerAmounts && transaction.buyerCanAcceptPrivateOffer()) {
            prices.push({
                label: this._copyText.get(isTrade ? 'offerPriceTradeLabel' : 'offerPriceLabel'),
                value: this._getFormattedPrice({ financialAmount: offerAmounts })
            });
        }

        return prices;
    },
    _isNetPriceEnabled: function _isNetPriceEnabled() {
        return true;
    },

    computeds: {
        offerDisplay: function offerDisplay() {
            return this._getOfferDisplayVars();
        }
    }
});
module.exports.priceTypes = {
    PRICE_TYPE_RETAIL: PRICE_TYPE_RETAIL,
    PRICE_TYPE_SALE: PRICE_TYPE_SALE,
    PRICE_TYPE_NET: PRICE_TYPE_NET
};
module.exports.constants = {
    PRIVATE_OFFER_NOTIFICATION_TYPE: PRIVATE_OFFER_NOTIFICATION_TYPE,
    SHOW_DISCOUNT_NOTIFICATION_TYPE: SHOW_DISCOUNT_NOTIFICATION_TYPE,
    MARK_SHIPPED_NOTIFICATION_TYPE: MARK_SHIPPED_NOTIFICATION_TYPE,
    PRICE_TYPE_RETAIL: PRICE_TYPE_RETAIL,
    PRICE_TYPE_SALE: PRICE_TYPE_SALE,
    PRICE_TYPE_NET: PRICE_TYPE_NET,
    ITEM_PUR: ITEM_PUR,
    ITEM_SOLD: ITEM_SOLD
};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(30);
var momentLocales = __webpack_require__(9);
var template = __webpack_require__(35);
var TemplateView = __webpack_require__(0);
var bind = __webpack_require__(1);
var copyText = __webpack_require__(5)();
var ellipsis = __webpack_require__(38);
var bubble = __webpack_require__(8);

var ConversationSummary = module.exports = TemplateView.extend({
    events: {
        "click": function click() {
            bubble(this.el, "showConversation", this.model.id);
        }
    },
    template: {
        local: css,
        src: template.conversationSummary
    },
    initialize: function initialize(options) {
        var _this = this;

        this.on('parentResized', function () {
            return ellipsis(_this._conversationBodySummary);
        });
        this._copyText = options.copyText || copyText;
        this._imagesHosts = options.imagesHosts;
        this._transaction = this.model.get('transaction');
        if (this._transaction) {
            this._offer = this._transaction.getMostRecentOffer();
        }
        ConversationSummary.__super__.initialize.call(this, options);
        this._conversationBodySummary = this.$('.' + css.mcConversationBodySummary);
        this.trigger('parentResized');
        bind(this);
        return options;
    },
    indicators: function indicators() {
        return [{
            template: template.indicators
        }];
    },
    scope: function scope() {
        return {
            indicatorsMobile: this.indicators(),
            indicatorsDesktop: this.indicators()
        };
    },

    templateVars__: function templateVars__(obj) {
        var seller = this.model.getOriginalSeller();
        var item = this.model.get('item');
        var templateData = Object.assign(this._getStatusMessage(), {
            displayDate: momentLocales.inbox(obj.latestMessageReceivedAt).calendar(),
            displayDateMobile: momentLocales.inboxMobile(obj.latestMessageReceivedAt).calendar(),
            countUpClockDays: 0
        });

        if (item) {
            templateData.thumbnail = item.getImageUrl({ position: 1, size: 'small' });
            templateData.itemDealerReference = item.get('dealerReference');
        } else if (seller) {
            var preferences = seller.get('user.sellerPreferences');
            if (preferences && preferences.scrollLogo) {
                templateData.thumbnail = preferences.scrollLogo;
            }
        }
        return Object.assign({}, obj, templateData, {
            otherMemberDisplayName: this.model.getOtherMemberDisplayName(),
            copy: this._copyText.get.bind(this._copyText)
        });
    },

    _getStatusMessage: function _getStatusMessage() {
        if (!this._transaction) {
            return {};
        }
        if (this._transaction.isCanceled()) {
            return {};
        }
        // Order is important here since a confirmed transaction has also completed checkout
        if (this._transaction.isConfirmed()) {
            return {
                statusMessage: copyText.get('order complete'),
                statusComplete: true
            };
        }
        if (this._transaction.isCheckoutComplete()) {
            return { statusMessage: copyText.get('order pending') };
        }
        if (!this._offer) {
            return {};
        }
        if (!this._offer.isExpired()) {
            return {
                statusMessage: copyText.get('offer pending')
            };
        }
        return {};
    }
}, {
    newsy: 'ConversationSummary'
});

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(31);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: _style2.default
    }
});

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _bubbleEvent = __webpack_require__(8);

var _bubbleEvent2 = _interopRequireDefault(_bubbleEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var forEach = __webpack_require__(39);
var invert = __webpack_require__(40);
var TemplateView = __webpack_require__(0);
var b3nd = __webpack_require__(1);
var copyText = __webpack_require__(5)();
var templates = __webpack_require__(36);
var allValue = 'all';
var unreadValue = 'showUnreadOnly';

var trackingValueMap = {
    'all': 'all',
    'showUnreadOnly': 'unread'
};

var InboxFilterView = module.exports = TemplateView.extend({
    events: {
        'change #conversationFilter': function changeConversationFilter(event) {
            var val = event.target.value;
            var prefix = trackingValueMap[val] || '';
            var label = prefix + ' clicked - dropdown';
            this.filter(val);
            // todo: remove once we're using native click event bubbling to track events
            (0, _bubbleEvent2.default)(this.el, 'changeConversationFilter', label);
        },
        'click .mc-filter-button-value': function clickMcFilterButtonValue(event) {
            var target = event.target;
            event.preventDefault();
            this.filter(target.getAttribute('data-value'));
        },
        'filter': function filter(event) {
            this.model.set(event.detail);
        }
    },

    tagName: 'span',

    initialize: function initialize(options) {
        this._isBuyer = options.isBuyer;
        // TODO: set template in admin / dotcom subclasses
        this.template = templates['conversationFilter' + (this._isBuyer ? 'Select' : 'Dropdown')];
        this.filters = {};
        this.filters[allValue] = copyText.get('filterAll');
        this.filters[unreadValue] = copyText.get('filterUnread');
        if (!this._isBuyer) {
            this.filters.showNeverRespondedOnly = copyText.get('filterNeedsResponse');
        }
        InboxFilterView.__super__.initialize.apply(this, arguments);
        b3nd(this);
    },
    computeds: {
        selectedfilterLabel: function selectedfilterLabel() {
            return this.mapSelectedFilter().label;
        },
        selectedfilterValue: function selectedfilterValue() {
            return this.mapSelectedFilter().value;
        }
    },
    filter: function filter(selectedFilter) {
        var params = {
            params: {},
            pageStart: 0
        };
        forEach(this.filters, function (label, value) {
            if (value !== allValue) {
                params.params[value] = 'N';
            }
        });
        if (selectedFilter !== allValue) {
            params.params[selectedFilter] = 'Y';
        }
        (0, _bubbleEvent2.default)(this.el, 'filter', params);
    },

    mapSelectedFilter: function mapSelectedFilter() {
        var pagerParams = this.model.get('params');
        var selectedFilterObj = {};
        selectedFilterObj.value = invert(pagerParams).Y || allValue;
        selectedFilterObj.label = this.filters[selectedFilterObj.value];
        return selectedFilterObj;
    },

    templateVars__: function templateVars__(obj) {
        return Object.assign({}, obj, {
            filters: this.filters,
            selectedFilter: this.mapSelectedFilter()
        });
    }
});

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(11);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: _style2.default
    }
});

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(12);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(11);

var _style4 = _interopRequireDefault(_style3);

var _style5 = __webpack_require__(6);

var _style6 = _interopRequireDefault(_style5);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

var _template = __webpack_require__(37);

var _backboneModel = __webpack_require__(7);

var _b3nd = __webpack_require__(1);

var _b3nd2 = _interopRequireDefault(_b3nd);

var _copyText = __webpack_require__(5);

var _copyText2 = _interopRequireDefault(_copyText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyText = (0, _copyText2.default)();

var MessageCenterView = _templateView2.default.extend({
    initialize: function initialize() {
        this.state = new _backboneModel.Model();
        MessageCenterView.__super__.initialize.apply(this, arguments);
        (0, _b3nd2.default)(this);
    },

    template: {
        src: _template.messageCenter,
        local: (0, _composeClassNames2.default)(_style2.default, (0, _composeClassNames2.default)(_style4.default, _style6.default))
    },
    templateVars: function templateVars(obj) {
        return Object.assign({}, obj, {
            copy: copyText.get.bind(copyText)
        });
    }
});
exports.default = MessageCenterView;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(4);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: _style2.default
    }
});

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Model = __webpack_require__(7).Model;

module.exports = Model.extend({
    initialize: function initialize(attrs) {
        this.set('convertedAmounts', new Model(attrs.convertedAmounts));
    },

    getCurrency: function getCurrency() {
        return this.get('currency');
    },
    localizedAmount: function localizedAmount() {
        // admin function stubbed to prevent errors
        return false;
    }
});

/***/ },
/* 26 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"attachmentImageWrapper":"src-views-Attachment-style---attachmentImageWrapper---2BKtR"};

/***/ },
/* 27 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcAttachmentRemove":"src-views-AttachmentIndicator-style---mcAttachmentRemove---krgow","mcAttachmentThumbnail":"src-views-AttachmentIndicator-style---mcAttachmentThumbnail---3MMjx","attachmentErrorList":"src-views-AttachmentIndicator-style---attachmentErrorList---2aUPe","mcAttachmentUploadProgress":"src-views-AttachmentIndicator-style---mcAttachmentUploadProgress---2kblJ"};

/***/ },
/* 28 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcMessageSummary":"src-views-ComposeMessage-style---mcMessageSummary---2F1it","mcComposing":"src-views-ComposeMessage-style---mcComposing---1UBth","mcComposeControls":"src-views-ComposeMessage-style---mcComposeControls---3-N2n","mcMessage":"src-views-ComposeMessage-style---mcMessage---2FrEm","attachmentErrorList":"src-views-ComposeMessage-style---attachmentErrorList---2AvXz","mcMessageHeader":"src-views-ComposeMessage-style---mcMessageHeader---1b81d","mcMessageBodyWrapper":"src-views-ComposeMessage-style---mcMessageBodyWrapper---13Mm3","mcMessageBody":"src-views-ComposeMessage-style---mcMessageBody---zND6J"};

/***/ },
/* 29 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcHeadsUp":"src-views-ConversationHeadsUp-style---mcHeadsUp---Jw6Cn","headsUpTopline":"src-views-ConversationHeadsUp-style---headsUpTopline---11iNC","headsUpExpDate":"src-views-ConversationHeadsUp-style---headsUpExpDate---2Glo1","headsUpNotif":"src-views-ConversationHeadsUp-style---headsUpNotif---1JoIX","itemOfferPrice":"src-views-ConversationHeadsUp-style---itemOfferPrice---i6klC","headsUpPCS":"src-views-ConversationHeadsUp-style---headsUpPCS---28AEW","headsUpPcs":"src-views-ConversationHeadsUp-style---headsUpPCS---28AEW","headsUpContent":"src-views-ConversationHeadsUp-style---headsUpContent---2lfEI","headsUpThumbnail":"src-views-ConversationHeadsUp-style---headsUpThumbnail---1WnGf","headsUpInfo":"src-views-ConversationHeadsUp-style---headsUpInfo---TqZZq","headsUpTitle":"src-views-ConversationHeadsUp-style---headsUpTitle---2X_Zs","headsUpPrice":"src-views-ConversationHeadsUp-style---headsUpPrice---1h-1F","itemAskingPrice":"src-views-ConversationHeadsUp-style---itemAskingPrice---1uCBV","priceLabel":"src-views-ConversationHeadsUp-style---priceLabel---hW_B7","headsUpCta":"src-views-ConversationHeadsUp-style---headsUpCta---3qt5d","headsUpHasExp":"src-views-ConversationHeadsUp-style---headsUpHasExp---2Pmyd","headsUpViewDOMT":"src-views-ConversationHeadsUp-style---headsUpViewDOMT---1aRyG","headsUpViewDomt":"src-views-ConversationHeadsUp-style---headsUpViewDOMT---1aRyG","shippingCopy":"src-views-ConversationHeadsUp-style---shippingCopy---SUGbu"};

/***/ },
/* 30 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"src-views-ConversationSummary-style---verticallyCentered---3qBbz","horizontallyRight":"src-views-ConversationSummary-style---horizontallyRight---3KH2y","horizontallyCentered":"src-views-ConversationSummary-style---horizontallyCentered---Rjckx","verticallyHorizontallyCentered":"src-views-ConversationSummary-style---verticallyHorizontallyCentered---30Gww","statusMessage":"src-views-ConversationSummary-style---statusMessage---7LmVL","mcToFromLine":"src-views-ConversationSummary-style---mcToFromLine---31Vqd","mcConversationSummary":"src-views-ConversationSummary-style---mcConversationSummary---2QrRq","bgColorReadMessage":"src-views-ConversationSummary-style---bgColorReadMessage---2tfkp","mcConversationSummaryOverlay":"src-views-ConversationSummary-style---mcConversationSummaryOverlay---3-7Hf","mcInboxCol":"src-views-ConversationSummary-style---mcInboxCol---3WHpv","mcInboxRightColContents":"src-views-ConversationSummary-style---mcInboxRightColContents---2KEV9","otherPersonsName":"src-views-ConversationSummary-style---otherPersonsName---3svrN","messagePreviewRow":"src-views-ConversationSummary-style---messagePreviewRow---20SZF","thumbnail":"src-views-ConversationSummary-style---thumbnail---2w5NI","mcSummaryIndicator":"src-views-ConversationSummary-style---mcSummaryIndicator---fH1R-","messageIndicators":"src-views-ConversationSummary-style---messageIndicators---1I3ZB","offerLabel":"src-views-ConversationSummary-style---offerLabel---37QFa","statusColumn":"src-views-ConversationSummary-style---statusColumn---1YLnR","statusWrapper":"src-views-ConversationSummary-style---statusWrapper---251JY","statusPending":"src-views-ConversationSummary-style---statusPending---n9jGw","statusComplete":"src-views-ConversationSummary-style---statusComplete---2C2B2","replyIndicator":"src-views-ConversationSummary-style---replyIndicator---13UDa","unreadIndicator":"src-views-ConversationSummary-style---unreadIndicator---3uAyu"};

/***/ },
/* 31 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flagConversation":"src-views-FlagConversation-style---flagConversation---21V_K","mcRcReason":"src-views-FlagConversation-style---mcRcReason---1akp4","mcRcExplanation":"src-views-FlagConversation-style---mcRcExplanation---R-wWc"};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "thumbnail": function(obj) {
var __t, __p = '', __e = _.escape;
__p += '\n    <div>\n        <span data-model-bind="visible: model.processed === \'N\'">\n           <span class="' +
((__t = ( obj.local.mcAttachmentImage )) == null ? '' : __t) +
' ' +
((__t = ( obj.local.mcAttachmentLoading )) == null ? '' : __t) +
' text-center">\n               <i class="fa fa-spinner fa-pulse fa-2x"></i>\n            </span>\n        </span>\n        <span data-model-bind="visible: model.processed === \'Y\'">\n           <a href="' +
__e( obj.originalPath ) +
'" target="_blank">\n               <img class="' +
((__t = ( obj.local.mcAttachmentImage )) == null ? '' : __t) +
'" data-model-bind="\n                   attr:{ src: model.processed === \'Y\' ? model.thumbnailPath : \'\'}\n               ">\n           </a>\n        </span>\n    </div>\n';
return __p
},
    "normal": function(obj) {
var __t, __p = '', __e = _.escape;
__p += '\n    <div class="' +
((__t = ( obj.local.mcAttachmentRow )) == null ? '' : __t) +
'">\n        <a class=\'' +
((__t = ( obj.local.mcAttachmentFilename )) == null ? '' : __t) +
'\' href="' +
__e( obj.originalPath ) +
'" target="_blank">\n            <strong>' +
__e( obj.displayName ) +
'</strong>\n        </a>\n        <span class="' +
((__t = ( obj.local.mcAttachmentFileSize )) == null ? '' : __t) +
'">' +
__e( obj.displaySize ) +
'</span>\n        <span><i class="' +
((__t = ( obj.local.mcAttachmentIcon )) == null ? '' : __t) +
' fa fa-lg ' +
__e( obj.iconClass ) +
'"></i></span>\n    </div>\n';
return __p
},
    "loading": function(obj) {
var __t, __p = '', __e = _.escape;
__p += '\n    <div class="' +
((__t = ( obj.local.mcAttachmentRow )) == null ? '' : __t) +
'">\n        <span class="' +
((__t = ( obj.local.mcAttachmentFilename )) == null ? '' : __t) +
'">\n            ' +
__e( obj.displayName ) +
'\n        </span>\n        <span><i class="' +
((__t = ( obj.local.mcAttachmentIcon )) == null ? '' : __t) +
' fa fa-spinner fa-pulse"></i></span>\n    </div>\n';
return __p
}
};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "attachmentIndicator": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class=\'' +
((__t = ( obj.local.mcAttachmentItem )) == null ? '' : __t) +
' row cf neue\'>\n        <div class=\'col-xs-7\'>\n            <strong class=\'' +
((__t = ( obj.local.mcAttachmentFileName )) == null ? '' : __t) +
'\' data-model-bind="text : model.fileName"></strong>\n            <span class=\'' +
((__t = ( obj.local.mcAttachmentFileSize )) == null ? '' : __t) +
' text-muted\' data-model-bind="text : model.displaySize"></span>\n        </div>\n        <div class=\'col-xs-5\'>\n            <div class="pull-right">\n                <span data-model-bind="visible : model.uploadStatus === \'pending\' || undefined === model.dir">\n                    <progress class=\'' +
((__t = ( obj.local.mcAttachmentUploadProgress )) == null ? '' : __t) +
'\'\n                              name=\'upload-progress\'\n                              data-model-bind="attr : {max : model[\'upload-total\'], value : model[\'upload-sent\']}">\n                        sent <span name=\'upload-sent\'></span> bytes\n                    </progress> <!-- TODO: use this polyfill if people complain about this: http://lea.verou.me/2011/07/a-polyfill-for-html5-progress-element-the-obsessive-perfectionist-way/ -->\n                </span>\n                <span data-model-bind="visible : model.uploadStatus === \'rejected\'">\n                    <i class="fa fa-exclamation-triangle"></i> upload failed <span data-name=\'try-again\' class=\'' +
((__t = ( obj.local.tryAgain )) == null ? '' : __t) +
'\'>try again</span>\n                </span>\n                <span data-model-bind="visible : model.uploadStatus === \'resolved\'">\n                    ';
 if (obj.showThumbnail) { ;
__p += '\n                        <img class="' +
((__t = ( obj.local.mcAttachmentThumbnail )) == null ? '' : __t) +
'" data-model-bind="attr : {src : model.dataURI}">\n                    ';
 } else { ;
__p += '\n                        <i class="' +
((__t = ( obj.local.mcAttachmentIcon )) == null ? '' : __t) +
' fa ' +
((__t = ( obj.iconClass )) == null ? '' : __t) +
'"></i>\n                    ';
 } ;
__p += '\n                </span>\n                <i data-name=\'remove-attachment\' class="fa fa-times ' +
((__t = ( obj.local.mcAttachmentRemove )) == null ? '' : __t) +
' text-muted"></i>\n            </div>\n        </div>\n    </div>\n';
return __p
}
};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "template": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="' +
((__t = ( obj.local.mcHeadsUp )) == null ? '' : __t) +
'">\n        <div class="' +
((__t = ( obj.local.headsUpTopline )) == null ? '' : __t) +
'" data-model-bind="css: {\'' +
((__t = ( obj.local.headsUpHasExp )) == null ? '' : __t) +
'\': computed.offerDisplay.offerExpDateTxt}">\n            <span class="' +
((__t = ( obj.local.headsUpExpDate )) == null ? '' : __t) +
'" data-model-bind="visible: computed.offerDisplay.offerExpDateTxt">\n                Expires <span data-model-bind="text: computed.offerDisplay.offerExpDateTxt"></span>\n            </span>\n        </div>\n        <div class="' +
((__t = ( obj.local.headsUpNotif )) == null ? '' : __t) +
'" data-model-bind="\n                html: computed.offerDisplay.notificationMsg,\n                visible: computed.offerDisplay.notificationMsg\n            "></div>\n        <div class="' +
((__t = ( obj.local.headsUpPCS )) == null ? '' : __t) +
'" data-model-bind="\n            html: computed.offerDisplay.pcsNotification,\n            visible: computed.offerDisplay.pcsNotification\n        "></div>\n        <div class="' +
((__t = ( obj.local.headsUpContent )) == null ? '' : __t) +
'">\n            <div class="' +
((__t = ( obj.local.headsUpThumbnail )) == null ? '' : __t) +
'">\n                <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" target="_blank">\n                    <img src="' +
((__t = ( obj.thumbnail )) == null ? '' : __t) +
'" />\n                </a>\n            </div>\n\n            <div class="' +
((__t = ( obj.local.headsUpInfo )) == null ? '' : __t) +
'">\n                <div class="' +
((__t = ( obj.local.headsUpTitle )) == null ? '' : __t) +
'">\n                    <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" target="_blank">' +
((__t = ( obj.item.title )) == null ? '' : __t) +
'</a>\n                </div>\n                <div>\n                    ';
 obj.prices.map(function (price) { ;
__p += '\n                        <div class="' +
((__t = ( obj.local.headsUpPrice )) == null ? '' : __t) +
'">\n                            <span class="' +
((__t = ( obj.local.priceLabel )) == null ? '' : __t) +
'">\n                                ' +
((__t = ( price.label )) == null ? '' : __t) +
'\n                            </span>\n                            ';
 if (price.callout) { ;
__p += '\n                                <span class="' +
((__t = ( obj.local.headsUpCallout )) == null ? '' : __t) +
'" data-append="' +
((__t = ( price.callout )) == null ? '' : __t) +
'"></span>\n                            ';
 } ;
__p += '\n                            ';
 if (price.value) { ;
__p += '\n                                ' +
((__t = ( price.value )) == null ? '' : __t) +
'\n                                ';
 if (obj.isSoldIndividually) { ;
__p += '\n                                    <span class="' +
((__t = ( obj.local.headsUpPerItem )) == null ? '' : __t) +
'">\n                                        / item\n                                    </span>\n                                ';
 } ;
__p += '\n                            ';
 } ;
__p += '\n                        </div>\n                    ';
 }) ;
__p += '\n                </div>\n                <div class="' +
((__t = ( obj.local.shippingCopy )) == null ? '' : __t) +
'" data-append="shippingCopy"></div>\n            </div>\n\n            <div class="' +
((__t = ( obj.local.headsUpCta )) == null ? '' : __t) +
'" data-append="headsUpCta"></div>\n        </div>\n    </div>\n';
return __p
}
};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "conversationSummary": function(obj) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class=\'list-group-item ' +
((__t = ( obj.local.mcConversationSummary )) == null ? '' : __t) +
'\' data-model-bind=\'css : {"' +
((__t = ( obj.local.bgColorReadMessage )) == null ? '' : __t) +
'" : !model.unreadMessagesCount}\'>\n        <div class=\'row\'>\n            <div class=\'col-xs-2 ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
' text-center\'><!-- thumbnail -->\n                ';
 if (!obj.isBuyer && !obj.item) { ;
__p += '\n                    <strong class="' +
((__t = ( obj.local.mcInboxStorefront )) == null ? '' : __t) +
' vertically-horizontally-centered" data-tn="mc-message-category">General Inquiry</strong>\n                ';
 } else if (obj.thumbnail) { ;
__p += '\n                    <img data-name=\'item-thumbnail\' class=\'vertically-horizontally-centered ' +
((__t = ( obj.local.thumbnail )) == null ? '' : __t) +
'\' src="' +
((__t = ( obj.thumbnail )) == null ? '' : __t) +
'"/>\n                ';
 } ;
__p += '\n                ';
 if (!obj.isBuyer && obj.item && obj.itemDealerReference) { ;
__p += '\n                    <div class="' +
((__t = ( obj.local.mcItemRefNum )) == null ? '' : __t) +
' horizontally-centered">\n                        REF # ' +
((__t = ( obj.itemDealerReference )) == null ? '' : __t) +
'\n                    </div>\n                ';
 } ;
__p += '\n            </div>\n            <div class="col-xs-2 ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
' hidden-xs">\n                <div class="' +
((__t = ( obj.local.otherPersonsName )) == null ? '' : __t) +
'"><!-- other persons name -->\n                    <div class="' +
((__t = ( obj.local.mcDealerToFromLine )) == null ? '' : __t) +
'" data-tn="mc-message-dealer">\n                        ' +
__e( obj.otherMemberDisplayName ) +
'\n                    </div>\n                    ';
 if (obj.isTrade) { ;
__p += '\n                        <span class="label ' +
((__t = ( obj.local.badgeTrade )) == null ? '' : __t) +
'">TRADE</span>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n            <div class="col-sm-4 col-xs-10 ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
'"><!-- message preview -->\n                <div class="' +
((__t = ( obj.local.mcToFromLine )) == null ? '' : __t) +
' visible-xs">\n                    ' +
__e( obj.otherMemberDisplayName ) +
'\n                    ';
 if (obj.isTrade) { ;
__p += '\n                        <span class="label ' +
((__t = ( obj.local.badgeTrade )) == null ? '' : __t) +
'">TRADE</span>\n                    ';
 } ;
__p += '\n                </div>\n                <div class=\'' +
((__t = ( obj.local.messageIndicators )) == null ? '' : __t) +
' visible-xs\' data-append=\'indicatorsMobile\'></div>\n                <div class="' +
((__t = ( obj.local.messagePreviewRow )) == null ? '' : __t) +
' ' +
((__t = ( obj.local.mcConversationBodySummary )) == null ? '' : __t) +
'\n                    ' +
((__t = ( obj.unreadMessagesCount ? obj.local.unreadIndicator : '')) == null ? '' : __t) +
'\n                    ' +
((__t = ( obj.isLatestMessageSender ? obj.local.replyIndicator : '' )) == null ? '' : __t) +
'\n                    " data-tn="mc-conversation-body">' +
__e( obj.latestMessage ) +
'\n                </div>\n                <div class="visible-xs ' +
((__t = ( obj.statusComplete ? obj.local.statusComplete : obj.local.statusPending )) == null ? '' : __t) +
'">\n                    ';
 if (obj.statusMessage) { ;
__p += '\n                        <div data-name=\'status-message\' class=\'' +
((__t = ( obj.local.statusMessage )) == null ? '' : __t) +
'\'>\n                            ' +
((__t = ( obj.statusMessage )) == null ? '' : __t) +
'\n                        </div>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n            <div class=\'col-xs-2 hidden-xs ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
' ' +
((__t = ( obj.local.statusColumn )) == null ? '' : __t) +
' ' +
((__t = ( obj.statusComplete ? obj.local.statusComplete : obj.local.statusPending )) == null ? '' : __t) +
'\'><!-- offer -->\n                    ';
 if (obj.statusMessage) { ;
__p += '\n                        <div class="' +
((__t = ( obj.local.statusWrapper )) == null ? '' : __t) +
'">\n                            <div class=\'hidden-xs ' +
((__t = ( obj.local.statusMessage )) == null ? '' : __t) +
'\'>' +
((__t = ( obj.statusMessage )) == null ? '' : __t) +
'</div>\n                        </div>\n                    ';
 } ;
__p += '\n            </div>\n            <div class=\'col-xs-2 hidden-xs ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
'\'><!-- spacer for free-floating date column -->\n            </div>\n            <div class=\'' +
((__t = ( obj.local.mcInboxRightColContents )) == null ? '' : __t) +
'\' data-tn="mc-message-date">\n                <span class="hidden-xs">' +
__e( obj.displayDate ) +
'</span>\n                <span class="visible-xs">' +
__e( obj.displayDateMobile ) +
'</span>\n                <div class=\'hidden-xs\' data-append=\'indicatorsDesktop\'></div>\n            </div>\n        </div>\n        <div class=\'' +
((__t = ( obj.local.mcConversationSummaryOverlay )) == null ? '' : __t) +
'\'></div>\n    </div>\n';
return __p
},
    "indicators": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    ';
 if (obj.numberOfAttachments) { ;
__p += '\n        <span><i class="fa fa-paperclip"></i><span>\n    ';
 } ;
__p += '\n';
return __p
}
};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "conversationFilterSelect": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <select id="conversationFilter">\n        ';
 _.each(obj.filters, function (label, value) { ;
__p += '\n            <option value="' +
((__t = ( value )) == null ? '' : __t) +
'" ' +
((__t = ( obj.selectedFilter.value === value ? 'selected' : '' )) == null ? '' : __t) +
' > ' +
((__t = ( label )) == null ? '' : __t) +
'</option>\n        ';
 }); ;
__p += '\n    </select>\n';
return __p
},
    "conversationFilterDropdown": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div id="filterDropdownContainer" class="bs dropdown mc-filter-button-container">\n        <button type="button" class="btn btn-default btn-sm dropdown-toggle mc-filter-button" data-toggle="dropdown">\n            <span class="pull-left mc-filter-button-selected" data-model-bind="text: computed.selectedfilterLabel"></span>\n            <span class="pull-right caret"></span>\n        </button>\n        <ul class="dropdown-menu gtm-message-inbox-view-selector">\n            ';
 _.each(obj.filters, function (label, value) { ;
__p += '\n                <li data-model-bind="visible: computed.selectedfilterValue !== \'' +
((__t = ( value )) == null ? '' : __t) +
'\'">\n                    <a\n                        href="#filter-inbox"\n                        class="mc-filter-button-value"\n                        data-value="' +
((__t = ( value )) == null ? '' : __t) +
'"\n                    >' +
((__t = ( label )) == null ? '' : __t) +
'</a>\n                </li>\n            ';
 }); ;
__p += '\n        </ul>\n    </div>\n';
return __p
}
};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "messageCenter": function(obj) {
var __t, __p = '';
__p += '\n    <div data-model-bind=\'visible: state.activeViewKey === "inbox"\'>\n        <div class=\'row\'>\n            <div class=\'col-xs-3\'>\n                <div class=\'' +
((__t = ( obj.local.refreshClock )) == null ? '' : __t) +
'\' data-append=\'refreshClock\'></div>\n            </div>\n            <div class=\'col-xs-9\'>\n                <div data-append=\'search\'></div>\n                <div data-append=\'searchParamsIndicator\'></div>\n            </div>\n        </div>\n        <h1 class=\'' +
((__t = ( obj.local.mcHeader )) == null ? '' : __t) +
'\' data-tn="mc-inbox-header" data-append=\'inboxHeader\'></h1>\n        <div data-append=\'inbox\'></div>\n    </div>\n    <div class=\'' +
((__t = ( obj.local.mcConversationWrapper )) == null ? '' : __t) +
' row\'>\n        <div class=\'col-xs-12\' data-model-bind=\'visible: state.activeViewKey !== "inbox" && state.pendingViewKey !== "inbox"\'>\n            <div class=\'' +
((__t = ( obj.local.mcAllConversationsBlock )) == null ? '' : __t) +
'\'>\n                <span\n                    data-mc-route-action=\'showIndex\'\n                    class=\'' +
((__t = ( obj.local.mcAllConversationsLink )) == null ? '' : __t) +
'\'\n                ><i class="fa fa-angle-left"></i>&nbsp;&nbsp;' +
((__t = ( obj.copy('all conversations') )) == null ? '' : __t) +
'</span>\n                <span\n                    data-mc-route-action=\'showIndexUnread\'\n                    data-model-bind=\'visible: state.totalUnreadConversationCount > 0\'\n                    class="' +
((__t = ( obj.local.totalUnreadConversationCount )) == null ? '' : __t) +
'"\n                >( <span data-model-bind=\'text: state.totalUnreadConversationCount\'></span> ' +
((__t = ( obj.copy('new') )) == null ? '' : __t) +
' )</span>\n            </div>\n        </div>\n        <div data-append=\'error\' data-model-bind=\'visible: state.activeViewKey==="error"\'></div>\n        <div data-append=\'conversation\' data-model-bind=\'visible: state.activeViewKey==="conversation"\'></div>\n    </div>\n    <div data-append=\'loading\' data-model-bind=\'visible: state.activeViewKey==="loading"\'></div>\n';
return __p
}
};

/***/ },
/* 38 */
/***/ function(module, exports) {

module.exports = __webpack_require__(150);

/***/ },
/* 39 */
/***/ function(module, exports) {

module.exports = __webpack_require__(59);

/***/ },
/* 40 */
/***/ function(module, exports) {

module.exports = __webpack_require__(239);

/***/ },
/* 41 */
/***/ function(module, exports) {

module.exports = __webpack_require__(30);

/***/ },
/* 42 */
/***/ function(module, exports) {

module.exports = __webpack_require__(138);

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _view = __webpack_require__(10);

Object.defineProperty(exports, 'Attachment', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view).default;
  }
});

var _view2 = __webpack_require__(14);

Object.defineProperty(exports, 'AttachmentIndicator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view2).default;
  }
});

var _ComposeMessage = __webpack_require__(15);

Object.defineProperty(exports, 'ComposeMessage', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ComposeMessage).default;
  }
});

var _Conversation = __webpack_require__(16);

Object.defineProperty(exports, 'Conversation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Conversation).default;
  }
});

var _ConversationError = __webpack_require__(17);

Object.defineProperty(exports, 'ConversationError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ConversationError).default;
  }
});

var _view3 = __webpack_require__(18);

Object.defineProperty(exports, 'ConversationHeadsUp', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view3).default;
  }
});

var _view4 = __webpack_require__(19);

Object.defineProperty(exports, 'ConversationSummary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view4).default;
  }
});

var _FlagConversation = __webpack_require__(20);

Object.defineProperty(exports, 'FlagConversation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FlagConversation).default;
  }
});

var _view5 = __webpack_require__(21);

Object.defineProperty(exports, 'InboxFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view5).default;
  }
});

var _InboxWrapper = __webpack_require__(22);

Object.defineProperty(exports, 'InboxWrapper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InboxWrapper).default;
  }
});

var _MessageCenter = __webpack_require__(23);

Object.defineProperty(exports, 'MessageCenter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessageCenter).default;
  }
});

var _MessageSummary = __webpack_require__(24);

Object.defineProperty(exports, 'MessageSummary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessageSummary).default;
  }
});

var _momentLocales = __webpack_require__(9);

Object.defineProperty(exports, 'momentLocales', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_momentLocales).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }
/******/ ]);
//# sourceMappingURL=bundle.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

/**
 * Constructs an array of errors in the correct format to be consumed by the Validator class. Proper usage :
 *      var errors = new ErrorList();
 *      errors.add('creators[0].role');
 *      errors.add('creators[1].attribution', 'The attribution is super wrong');
 *      return errors.getErrors();
 *
 * Chaining also enabled :
 *      return errors.add('creators[0].role').getErrors();
 *
 * @returns {ErrorList}
 * @constructor
 */
var ErrorList = function () {
    this._errors = [];
    return this;
};

/**
 * Get array of all error objects
 * @returns {object[]}
 */
ErrorList.prototype.getErrors = function () {
    return this._errors;
};

/**
 * Add 1 error to the error list
 * @param {String} fieldName
 * @param {String} message
 * @param {function|regex} rule
 * @param {string} viewKey
 * @returns {ErrorList}
 */
ErrorList.prototype.add = function (fieldName, message, rule) {
    if (!fieldName || typeof fieldName !== 'string') {
        throw new Error("Field name is required to use error constructor's add method. '" + fieldName + "' provided");
    }

    var obj = { field : fieldName };
    if (message) {
        obj.message = message;
    }
    if (rule) {
        obj.rule = rule.toString();
        if (typeof obj.rule === 'function') {
            obj.rule = obj.rule.replace(/  /g, '').replace(/\n/g, '');
        }
    }

    this._errors.push(obj);
    return this;
};

/**
 * Merge another error list into this error list as in :
 *  var errors = new ErrorList().add('shipmentQuotes');
 *  var mergedErrors = errors.merge(otherErrorList).getErrors();
 *
 * @param {ErrorList} errorList
 * @returns {ErrorList}
 */
ErrorList.prototype.merge = function (errorList) {
    var self = this;
    if (!(errorList instanceof ErrorList)) {
        throw new Error("Only ErrorList instances may be merged by ErrorList.merge. ");
    }

    var array = errorList.getErrors();
    _.each(array, function (error) {
        var args = [error.field];
        if (error.message) {
            args.push(error.message);
        }
        self.add.apply(self, args);
    });

    return this;
};

/**
 * Get a count of the number of errors;
 * @returns {number}
 */
ErrorList.prototype.count = function () {
    return this._errors.length;
};

/**
 * Get the last error
 * @returns {object}
 */
ErrorList.prototype.last = function () {
    return _.last(this._errors);
};

/**
 * WARNING -- THIS HAS NOT BEEN TESTED!!!!!!!!!
 * WARNING -- THIS HAS NOT BEEN TESTED!!!!!!!!!
 * WARNING -- THIS HAS NOT BEEN TESTED!!!!!!!!!
 * @param {*} newValue
 * @param {String} propName
 * @param {Object} searchObj
 * @returns {ErrorList}
 */
/* eslint-disable */
ErrorList.prototype.modifyWhere = function (newValue, propName, searchObj) {
    throw new Error('THIS METHOD HAS NOT BEEN TESTED. ');
    if (_.isUndefined(newValue) || _.isUndefined(propName)) {
        throw new Error("You must specify a new value and a property name to use ErrorList.modifyWhere");
    }
    var errorSet = this._errors;

    // If searchObj was passed then require that it has one of the 3 properties assigned to each error object.
    // If it does then use that search object as a predicate to search this._errors
    if (!_.isUndefined(searchObj)) {
        var requiredProps = ['field', 'message', 'rule'];
        var hasQualifiedProp = false;
        _.each(requiredProps, function (prop) {
            if (searchObj.hasOwnProperty(prop)) {
                hasQualifiedProp = true;
            }
        });

        if (!hasQualifiedProp) {
            var msg = "Search object used in ErrorList.modifyWhere must contain one of the following : [ " +
                requiredProps.join(' | ') + " ]";
            throw new Error(msg);
        }

        errorSet = _.where(this._errors, searchObj);
    }

    _.each(errorSet, function (error) {
        error[propName] = newValue;
    });

    return this;
};
/* eslint-enable */

module.exports = ErrorList;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var objectAssign = __webpack_require__(202);
var hasOwnProp = Object.prototype.hasOwnProperty;

var Base = module.exports = function () {};
Base.extend = extend;

/**
 * Extend this Class to create a new one inherithing this one.
 * Also add a helper __super__ object poiting to the parent prototypes methods
 * @param  {Object} protoProps  Prototype properties (available on the instances)
 * @param  {Object} staticProps Static properties (available on the contructor)
 * @return {Object}             New sub class
 */
function extend(protoProps, staticProps) {
  var parent = this;
  var child;

  // The constructor function for the new subclass is either defined by you
  // (the "constructor" property in your `extend` definition), or defaulted
  // by us to simply call the parent's constructor.
  if (protoProps && hasOwnProp.call(protoProps, 'constructor')) {
    child = protoProps.constructor;
  } else {
    child = function () { return parent.apply(this, arguments); };
  }

  // Add static properties to the constructor function, if supplied.
  objectAssign(child, parent, staticProps);

  // Set the prototype chain to inherit from `parent`
  child.prototype = Object.create(parent.prototype, {
    constructor: {
      value: child,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  // Add prototype properties (instance properties) to the subclass,
  // if supplied.
  if (protoProps) objectAssign(child.prototype, protoProps);

  // Set a convenience property in case the parent's prototype is needed
  // later.
  child.__super__ = parent.prototype;

  return child;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = Object.keys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ClassList

var indexOf = __webpack_require__(204),
    trim = __webpack_require__(260),
    arr = Array.prototype

/**
 * ClassList(elem) is kind of like Element#classList.
 *
 * @param {Element} elem
 * @return {ClassList}
 */
function ClassList (elem) {
  if (!(this instanceof ClassList))
    return new ClassList(elem)

  var classes = trim(elem.className).split(/\s+/),
      i

  this._elem = elem

  this.length = 0

  for (i = 0; i < classes.length; i += 1) {
    if (classes[i])
      arr.push.call(this, classes[i])
  }
}

/**
 * add(class1 [, class2 [, ...]]) adds the given class(es) to the
 * element.
 *
 * @param {String} ...
 * @return {Context}
 */
ClassList.prototype.add = function () {
  var name,
      i

  for (i = 0; i < arguments.length; i += 1) {
    name = '' + arguments[i]

    if (indexOf(this, name) >= 0)
      continue

    arr.push.call(this, name)
  }

  this._elem.className = this.toString()

  return this
}

/**
 * remove(class1 [, class2 [, ...]]) removes the given class(es) from
 * the element.
 *
 * @param {String} ...
 * @return {Context}
 */
ClassList.prototype.remove = function () {
  var index,
      name,
      i

  for (i = 0; i < arguments.length; i += 1) {
    name = '' + arguments[i]
    index = indexOf(this, name)

    if (index < 0) continue

    arr.splice.call(this, index, 1)
  }

  this._elem.className = this.toString()

  return this
}

/**
 * contains(name) determines if the element has a given class.
 *
 * @param {String} name
 * @return {Boolean}
 */
ClassList.prototype.contains = function (name) {
  name += ''
  return indexOf(this, name) >= 0
}

/**
 * toggle(name [, force]) toggles a class. If force is a boolean,
 * this method is basically just an alias for add/remove.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {Context}
 */
ClassList.prototype.toggle = function (name, force) {
  name += ''

  if (force === true) return this.add(name)
  if (force === false) return this.remove(name)

  return this[this.contains(name) ? 'remove' : 'add'](name)
}

/**
 * toString() returns the className of the element.
 *
 * @return {String}
 */
ClassList.prototype.toString = function () {
  return arr.join.call(this, ' ')
}


/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var globalObject = __webpack_require__(89);
var NativeCustomEvent = globalObject.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

var CustomEvent;
if (useNative()) {
  CustomEvent = NativeCustomEvent;
} else if (!globalObject.document) {
  CustomEvent = undefined;
} else if ('function' === typeof globalObject.document.createEvent) {
  // IE >= 9
  CustomEvent = function (type, params) {
    var e = globalObject.document.createEvent('CustomEvent');
    if (params) {
      e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
    } else {
      e.initCustomEvent(type, false, false, void 0);
    }
    return e;
  }
} else {
  // IE <= 8
  CustomEvent = function (type, params) {
    var e = globalObject.document.createEventObject();
    e.type = type;
    if (params) {
      e.bubbles = Boolean(params.bubbles);
      e.cancelable = Boolean(params.cancelable);
      e.detail = params.detail;
    } else {
      e.bubbles = false;
      e.cancelable = false;
      e.detail = void 0;
    }
    return e;
  }
}
module.exports = CustomEvent;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(244);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = Array.prototype.slice.call(arguments);

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    if ('function' === typeof exports.formatArgs) {
      args = exports.formatArgs.apply(self, args);
    }
    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
module.exports = __webpack_require__(208);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var Action = __webpack_require__(87);
var DEFAULT = 'default';
var DispatcherContext = __webpack_require__(209);

/**
 * @class Dispatcher
 * @param {Object} options Dispatcher options
 * @param {Array} options.stores Array of stores to register
 * @constructor
 */
function Dispatcher (options) {
    options = options || {};
    options.stores = options.stores || [];
    this.stores = {};
    this.handlers = {};
    this.handlers[DEFAULT] = [];
    this.hasWarnedAboutNameProperty = false;
    options.stores.forEach(function (store) {
        this.registerStore(store);
    }, this);

}

Dispatcher.prototype.createContext = function createContext(context) {
    return new DispatcherContext(this, context);
};

/**
 * Registers a store so that it can handle actions.
 * @method registerStore
 * @static
 * @param {Object} store A store class to be registered. The store should have a static
 *      `name` property so that it can be loaded later.
 * @throws {Error} if store is invalid
 * @throws {Error} if store is already registered
 */
Dispatcher.prototype.registerStore = function registerStore(store) {
    if ('function' !== typeof store) {
        throw new Error('registerStore requires a constructor as first parameter');
    }
    var storeName = this.getStoreName(store);
    if (!storeName) {
        throw new Error('Store is required to have a `storeName` property.');
    }
    if (this.stores[storeName]) {
        if (this.stores[storeName] === store) {
            // Store is already registered, nothing to do
            return;
        }
        throw new Error('Store with name `' + storeName + '` has already been registered.');
    }
    this.stores[storeName] = store;
    if (store.handlers) {
        Object.keys(store.handlers).forEach(function storeHandlersEach(action) {
            var handler = store.handlers[action];
            this._registerHandler(action, storeName, handler);
        }, this);
    }
};

/**
 * Method to discover if a storeName has been registered
 * @method isRegistered
 * @static
 * @param {Object|String} store The store to check
 * @returns {boolean}
 */
Dispatcher.prototype.isRegistered = function isRegistered(store) {
    var storeName = this.getStoreName(store),
        storeInstance = this.stores[storeName];

    if (!storeInstance) {
        return false;
    }

    if ('function' === typeof store) {
        if (store !== storeInstance) {
            return false;
        }
    }
    return true;
};

/**
 * Gets a name from a store
 * @method getStoreName
 * @static
 * @param {String|Object} store The store name or class from which to extract
 *      the name
 * @returns {String}
 */
Dispatcher.prototype.getStoreName = function getStoreName(store) {
    if ('string' === typeof store) {
        return store;
    }
    if (store.storeName) {
        return store.storeName;
    }

    if (false) {
        if (store.name && !this.hasWarnedAboutNameProperty) {
            console.warn('A store has been registered that relies on the ' +
                'constructor\'s name property. This name may change when you ' +
                'minify your stores during build time and could break string ' +
                'references to your store. It is advised that you add a ' +
                'static `storeName` property to your store to ensure the ' +
                'store name does not change during your build.');
            this.hasWarnedAboutNameProperty = true;
        }
    }
    return store.name;
};

/**
 * Adds a handler function to be called for the given action
 * @method registerHandler
 * @private
 * @static
 * @param {String} action Name of the action
 * @param {String} name Name of the store that handles the action
 * @param {String|Function} handler The function or name of the method that handles the action
 * @returns {number}
 */
Dispatcher.prototype._registerHandler = function registerHandler(action, name, handler) {
    this.handlers[action] = this.handlers[action] || [];
    this.handlers[action].push({
        name: this.getStoreName(name),
        handler: handler
    });
    return this.handlers.length - 1;
};

module.exports = {
    createDispatcher: function (options) {
        return new Dispatcher(options);
    }
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var Action = __webpack_require__(87);
var DEFAULT = 'default';
var debug = __webpack_require__(37)('Dispatchr:DispatcherContext');

/**
 * @class Dispatcher
 * @param {Object} context The context to be used for store instances
 * @constructor
 */
function DispatcherContext (dispatcher, context) {
    this.dispatcher = dispatcher;
    this.storeInstances = {};
    this.currentAction = null;
    this.dispatcherInterface = {
        getContext: function getContext() { return context; },
        getStore: this.getStore.bind(this),
        waitFor: this.waitFor.bind(this)
    };
}

/**
 * Returns a single store instance and creates one if it doesn't already exist
 * @method getStore
 * @param {String} name The name of the instance
 * @returns {Object} The store instance
 * @throws {Error} if store is not registered
 */
DispatcherContext.prototype.getStore = function getStore(name) {
    var storeName = this.dispatcher.getStoreName(name);
    if (!this.storeInstances[storeName]) {
        var Store = this.dispatcher.stores[storeName];
        if (!Store) {
            throw new Error('Store ' + storeName + ' was not registered.');
        }
        this.storeInstances[storeName] = new (this.dispatcher.stores[storeName])(this.dispatcherInterface);
    }
    return this.storeInstances[storeName];
};

/**
 * Dispatches a new action or queues it up if one is already in progress
 * @method dispatch
 * @param {String} actionName Name of the action to be dispatched
 * @param {Object} payload Parameters to describe the action
 * @throws {Error} if store has handler registered that does not exist
 */
DispatcherContext.prototype.dispatch = function dispatch(actionName, payload) {
    if (!actionName) {
        throw new Error('actionName parameter `' + actionName + '` is invalid.');
    }
    if (this.currentAction) {
        throw new Error('Cannot call dispatch while another dispatch is executing. Attempted to execute \'' + actionName + '\' but \'' + this.currentAction.name + '\' is already executing.');
    }
    var actionHandlers = this.dispatcher.handlers[actionName] || [],
        defaultHandlers = this.dispatcher.handlers[DEFAULT] || [];
    if (!actionHandlers.length && !defaultHandlers.length) {
        debug(actionName + ' does not have any registered handlers');
        return;
    }
    debug('dispatching ' + actionName, payload);
    this.currentAction = new Action(actionName, payload);
    var self = this,
        allHandlers = actionHandlers.concat(defaultHandlers),
        handlerFns = {};

    try {
        allHandlers.forEach(function actionHandlersEach(store) {
            if (handlerFns[store.name]) {
                // Don't call the default if the store has an explicit action handler
                return;
            }
            var storeInstance = self.getStore(store.name);
            if ('function' === typeof store.handler) {
                handlerFns[store.name] = store.handler.bind(storeInstance);
            } else {
                if (!storeInstance[store.handler]) {
                    throw new Error(store.name + ' does not have a method called ' + store.handler);
                }
                handlerFns[store.name] = storeInstance[store.handler].bind(storeInstance);
            }
        });
        this.currentAction.execute(handlerFns);
    } catch (e) {
        throw e;
    } finally {
        debug('finished ' + actionName);
        this.currentAction = null;
    }
};

/**
 * Returns a raw data object representation of the current state of the
 * dispatcher and all store instances. If the store implements a shouldDehdyrate
 * function, then it will be called and only dehydrate if the method returns `true`
 * @method dehydrate
 * @returns {Object} dehydrated dispatcher data
 */
DispatcherContext.prototype.dehydrate = function dehydrate() {
    var self = this,
        stores = {};
    Object.keys(self.storeInstances).forEach(function storeInstancesEach(storeName) {
        var store = self.storeInstances[storeName];
        if (!store.dehydrate || (store.shouldDehydrate && !store.shouldDehydrate())) {
            return;
        }
        stores[storeName] = store.dehydrate();
    });
    return {
        stores: stores
    };
};

/**
 * Takes a raw data object and rehydrates the dispatcher and store instances
 * @method rehydrate
 * @param {Object} dispatcherState raw state typically retrieved from `dehydrate`
 *      method
 */
DispatcherContext.prototype.rehydrate = function rehydrate(dispatcherState) {
    var self = this;
    if (dispatcherState.stores) {
        Object.keys(dispatcherState.stores).forEach(function storeStateEach(storeName) {
            var state = dispatcherState.stores[storeName],
                store = self.getStore(storeName);
            if (store.rehydrate) {
                store.rehydrate(state);
            }
        });
    }
};

/**
 * Waits until all stores have finished handling an action and then calls
 * the callback
 * @method waitFor
 * @param {String|String[]} stores An array of stores as strings to wait for
 * @param {Function} callback Called after all stores have completed handling their actions
 * @throws {Error} if there is no action dispatching
 */
DispatcherContext.prototype.waitFor = function waitFor(stores, callback) {
    if (!this.currentAction) {
        throw new Error('waitFor called even though there is no action dispatching');
    }
    this.currentAction.waitFor(stores, callback);
};

module.exports = DispatcherContext;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(214);
var assign = __webpack_require__(212);
var forEach = __webpack_require__(213);
var Base = __webpack_require__(201);
var extend = Base.extend;
var ExtendCompose;
var composeWith;
composeWith = function (parent, sub, newproperties, staticProperties) {
    assign(sub, staticProperties);
    assign(sub.prototype, newproperties);
    forEach(sub.prototype, function (method, name) {
        var composed;
        if (undefined === method) {
            return; // already handled
        }
        if ("__" === name.substr(-2)) {
            sub.prototype[name] = undefined;
            name = name.slice(0, -2);
            if (isArray(method)) {
                composed = sub.prototype[name].concat(method);
            } else if ("object" === typeof method) {
                composed = assign({}, sub.prototype[name], method);
            } else {
                composed = function () {
                    var preMethod;
                    var postMethod;
                    var preValue;
                    if (parent.prototype[name]) {
                        preMethod = parent.prototype[name];
                    }
                    postMethod = method;
                    if (preMethod) {
                        preValue = preMethod.apply(this, arguments);
                    }
                    return postMethod.call(this, preValue);
                };
            }
        } else if ("__" === name.substr(0, 2)) {
            sub.prototype[name] = undefined;
            name = name.slice(2);
            if (isArray(method)) {
                composed = method.concat(sub.prototype[name]);
            } else if ("object" === typeof method) {
                composed = assign({}, method, sub.prototype[name]);
            } else {
                composed = function () {
                    var preMethod = method;
                    var methodReturnVal = preMethod.apply(this, arguments);
                    var postMethod;
                    if (parent.prototype[name]) {
                        postMethod = parent.prototype[name];
                    } else {
                        return methodReturnVal;
                    }
                    return postMethod.call(this, methodReturnVal);
                };
            }
        } else {
            return;
        }
        sub.prototype[name] = composed;
    });
};
ExtendCompose = function () {};
ExtendCompose.prototype.middleware = {
    afterPrototype: function () {} // noop
};
ExtendCompose.prototype.exportBuilder = function () {
    var self = this;
    var ecExport = assign(function (protos, statics) {
        var parent = this;
        var sub;
        if (protos instanceof Array) {
            protos = assign.apply(null, [{}].concat(protos));
        }
        sub = extend.call(parent, protos, statics);
        sub.extend = ecExport;
        sub.extendSelf = function () {
            composeWith.apply(this, [
                parent,
                sub
            ].concat(Array.prototype.slice.apply(arguments))); // mutates sub
            self.middleware.afterPrototype(
                parent.prototype,
                protos,
                sub.prototype
            );
            return sub;
        };
        sub.extendSelf(sub.prototype);
        return sub;
    }, {
        withMiddleware: this.withMiddleware.bind(this)
    });
    return ecExport;
};
ExtendCompose.prototype.withMiddleware = function (middleware) {
    var parentEc = this;
    var NewExtendCompose = assign(function () {}, {
        prototype: this
    });
    var newEc = new NewExtendCompose();
    if (middleware.afterPrototype) {
        newEc.middleware = assign({}, assign({}, parentEc.middleware, {
            afterPrototype: function (parentPrototype, childPrototypeBefore, childPrototypeAfter) {
                parentEc.middleware.afterPrototype( // may mutate childPrototypeAfter
                    parentPrototype,
                    childPrototypeBefore,
                    childPrototypeAfter
                );
                middleware.afterPrototype( // may mutate childPrototypeAfter again
                    parentPrototype,
                    childPrototypeBefore,
                    childPrototypeAfter
                );
            }
        }));
    }
    return newEc.exportBuilder();
};
module.exports = new ExtendCompose().exportBuilder();


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _([1, 2]).forEach(function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, typeof iteratee == 'function' ? iteratee : identity);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forEach;


/***/ }),
/* 214 */
/***/ (function(module, exports) {

/**
 * lodash 4.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var createStore = __webpack_require__(216).createStore;
var __DEV__ = 'production' !== 'production';

function stateIdentity(state) { return state; }

module.exports = function createReducerStore(spec) {
    spec = spec || {};
    var ReducerStore = createStore({
        storeName: spec.storeName,
        handlers: {},
        initialize: function () {
            this.state = spec.initialState;
        },
        getState: function () {
            return this.state;
        },
        dehydrate: function () {
            return (spec.dehydrate || stateIdentity)(this.state);
        },
        rehydrate: function (state) {
            this.state = (spec.rehydrate || stateIdentity)(state);
        }
    });

    function replaceReducers(reducers) {
        spec.reducers = reducers || {};
        // Allow a single reducer function
        if (spec.reducer) {
            spec.reducers = {
                'default': spec.reducer
            };
        }
        // Create a handler proxy for each reducer so that the store can
        // still be lazy instantiated by dispatchr.
        Object.keys(spec.reducers).forEach(function eachReducer(eventName) {
            var reducer = spec.reducers[eventName];
            if (!ReducerStore.handlers[eventName]) {
                ReducerStore.handlers[eventName] = function (payload, dispatchedEventName) {
                    if (__DEV__) {
                        if (!spec.reducers[eventName]) {
                            // Calling a reducer that has been removed should be
                            // non-fatal, but warning may help with bugs.
                            console.warn(eventName + ' reducer on ' + spec.storeName +
                                ' has been removed.');
                            return;
                        }
                    }
                    var startingState = this.state;
                    this.state = spec.reducers[eventName](this.state, payload, dispatchedEventName);
                    if (this.state !== startingState) {
                        this.emitChange();
                    }
                };
            }
        });
    }
    ReducerStore.replaceReducer = replaceReducers;
    ReducerStore.replaceReducers = replaceReducers;

    ReducerStore.replaceGetters = function replaceGetters(getters) {
        spec.getters = getters || {};
        Object.keys(spec.getters).forEach(function (methodName) {
            if (!ReducerStore.prototype[methodName]) {
                ReducerStore.prototype[methodName] = function () {
                    if (__DEV__) {
                        if (!spec.getters[methodName]) {
                            // Calling a method that has been removed would be
                            // fatal, so let's throw a more useful error than
                            // "undefined is not a function"
                            throw new Error(methodName + ' on ' + storeName +
                                ' has been removed but was still called.');
                        }
                    }
                    var state = this.state;
                    var args = [state].concat(Array.prototype.slice.call(arguments));
                    return spec.getters[methodName].apply(null, args);
                };
            }
        });
    };

    ReducerStore.replaceSpec = function replaceSpec(spec) {
        spec = spec || {};
        ReducerStore.replaceReducers(spec.reducers);
        ReducerStore.replaceGetters(spec.getters);
    };

    ReducerStore.replaceSpec(spec);

    return ReducerStore;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


module.exports = {
    BaseStore: __webpack_require__(13),
    createStore: __webpack_require__(49)
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var Fluxible = __webpack_require__(88);
Fluxible.Fluxible = __webpack_require__(88);

module.exports = Fluxible;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var debug = __webpack_require__(37)('Fluxible:Context');
var isPromise = __webpack_require__(58);
var generateUUID = __webpack_require__(220);
var callAction = __webpack_require__(219);

var __DEV__ = 'production' !== 'production';
__webpack_require__(52);

/**
 * A request or browser-session context
 * @class FluxibleContext
 * @param {Fluxible} app The Fluxible instance used to create the context
 * @constructor
 */
function FluxContext(app) {
    this._app = app;

    // To be created on demand
    this._dispatcher = null;

    // Plugins
    this._plugins = [];

    // Set up contexts
    this._actionContext = null;
    this._componentContext = null;
    this._storeContext = null;
}

var warnedOnce = false;

/**
 * Getter for the app's component. Pass through to the Fluxible instance.
 * @method getComponent
 * @returns {ReactComponent}
 */
FluxContext.prototype.getComponent = function getComponent() {
    return this._app.getComponent();
};

/**
 * Getter for store from dispatcher
 * @method getStore
 * @returns {Object}
 */
FluxContext.prototype.getStore = function getStore(store) {
    if (!this._dispatcher) {
        this._initializeDispatcher();
    }
    return this._dispatcher.getStore(store);
};

/**
 * Provides plugin mechanism for adding application level settings that are persisted
 * between server/client and also modification of the FluxibleContext
 * @method plug
 * @param {Object} plugin
 * @param {String} plugin.name Name of the plugin
 * @param {Function} [plugin.plugActionContext] Method called after action context is created to allow
 *  dynamically modifying the action context
 * @param {Function} [plugin.plugComponentContext] Method called after component context is created to
 *  allow dynamically modifying the component context
 * @param {Function} [plugin.plugStoreContext] Method called after store context is created to allow
 *  dynamically modifying the store context
 * @param {Object} [plugin.dehydrate] Method called to serialize the plugin settings to be persisted
 *  to the client
 * @param {Object} [plugin.rehydrate] Method called to rehydrate the plugin settings from the server
 */
FluxContext.prototype.plug = function (plugin) {
    if (!plugin.name) {
        throw new Error('Context plugin must have a name');
    }
    this._plugins.push(plugin);
};

/**
 * Executes an action passing an action interface to as the first parameter
 * If a promise is returned by the action, it will wait for its resolution or rejection
 * If the action has less than three parameters, the returned promise
 * will be resolved with the return value
 * If the action throws an error, the promise will be rejected with the thrown value
 * @param {Object} context The current FluxibleContext
 * @param {Object} actionContext The current action context
 * @param {Function} action An action creator function that receives actionContext, payload,
 *  and done as parameters
 * @param {Object} payload The action payload
 * @param {Function} [done] Method to be called once action execution has completed
 * @return {Promise} executeActionPromise Resolved with action result or rejected with action error
 */
function executeActionProxy(context, actionContext, action, payload, done) {
    if (__DEV__) {
        if (!action) {
            throw new Error('executeAction called with an invalid action. Action ' +
                'must be a function.');
        }
    }
    var displayName = action.displayName || action.name;
    payload = (undefined !== payload) ? payload : {};
    if (__DEV__) {
        if (context._dispatcher && context._dispatcher.currentAction) {
            var currentActionDisplayName = context._dispatcher.currentAction.displayName ||
                context._dispatcher.currentAction.name;

            console.warn('Warning: executeAction for `' + displayName + '` was called, but `' +
                currentActionDisplayName + '` is currently being dispatched. This could mean ' +
                'there are cascading updates, which should be avoided. `' + displayName +
                '` will only start after `' + currentActionDisplayName + '` is complete.');
        }
    }

    if (debug.enabled) {
        debug('Executing action ' + actionContext.stack.join('.') + ' with payload', payload);
    }
    return callAction(actionContext, action, payload, done);
}

/**
 * Proxy function for executing an action.
 * @param {Function} action An action creator function that receives actionContext, payload,
 *  and done as parameters
 * @param {Object} payload The action payload
 * @param {Function} [done] Method to be called once action execution has completed
 * @return {Promise} executeActionPromise Resolved with action result or rejected with action error
 */
FluxContext.prototype.executeAction = function executeAction(action, payload, done) {
    var subActionContext = this._createSubActionContext(this.getActionContext(), action);
    return executeActionProxy(this, subActionContext, action, payload, done);
};

/**
 * Sets up the dispatcher with access to the store context
 * @method _initializeDispatcher
 * @private
 */
FluxContext.prototype._initializeDispatcher = function initializeDispatcher() {
    this._dispatcher = this._app.createDispatcherInstance(this.getStoreContext());
};

/**
 * Creates a subActionContext with new stack and rootID based on the action
 * that will be executed.
 * @private
 * @method _createSubActionContext
 * @param {Object} parentActionContext The action context that the stack should
 *      extend from
 * @param {Function} action The action to be executed to get the name from
 * @returns {Object}
 */
FluxContext.prototype._createSubActionContext = function createSubActionContext(parentActionContext, action) {
    var displayName = action.displayName || action.name;
    /*
     * We store the action's stack array on the `stack` property
     * of the actionContext interface.
     * You can access this in your actions with `context.stack`.
     * Use the `displayName` property on your actions for better
     * action tracing when your code gets minified in prod.
     * One action can execute multiple actions, so we need to create a shallow
     * clone with a new stack & new id every time a newActionContext is created.
     */
    var newActionContext = Object.assign({}, this.getActionContext(), {
        stack: (parentActionContext.stack || []).concat([displayName]),
        rootId: (parentActionContext.rootId) || generateUUID()
    });
    newActionContext.executeAction = newActionContext.executeAction.bind(newActionContext);
    return newActionContext;
};

/**
 * Returns the context for action controllers
 * @method getActionContext
 * @return {Object} Action context information
 */
FluxContext.prototype.getActionContext = function getActionContext() {
    var self = this;

    if (!self._actionContext) {
        if (!self._dispatcher) {
            self._initializeDispatcher();
        }

        var actionContext = {
            dispatch: self._dispatcher.dispatch.bind(self._dispatcher),
            executeAction: function executeAction (action, payload, callback) {
                // `this` will be the current action context
                var subActionContext = self._createSubActionContext(this, action);
                return executeActionProxy(self, subActionContext, action, payload, callback);
            },
            getStore: self._dispatcher.getStore.bind(self._dispatcher)
        };

        self._plugins.forEach(function pluginsEach(plugin) {
            var actionContextPlugin = plugin.plugActionContext;
            if (actionContextPlugin) {
                actionContextPlugin(actionContext, self, self._app);
            }
        });

        self._actionContext = actionContext;
    }

    return self._actionContext;
};

/**
 * Returns the context for action controllers
 * @method getComponentContext
 * @return {Object} Component context information
 */
FluxContext.prototype.getComponentContext = function getComponentContext() {
    if (this._componentContext) {
        return this._componentContext;
    }
    var self = this;
    if (!self._dispatcher) {
        self._initializeDispatcher();
    }

    var componentContext = {
        getStore: this._dispatcher.getStore.bind(this._dispatcher),
        // Prevents components from directly handling the callback for an action
        executeAction: function componentExecuteAction(action, payload, done) {
            if (done) {
                if (__DEV__) {
                    console.warn('When calling executeAction from a component,' +
                        'a callback isn\'t allowed. See our docs for more info:' +
                        'http://fluxible.io/api/components.html#component-context');
                }
            }
            self.executeAction(action, payload)
            ['catch'](function actionHandlerWrapper(err) {
                return self.executeAction(self._app._componentActionErrorHandler, {
                    actionName: action.displayName || action.name,
                    err: err
                });
            })
            ['catch'](function unhandledError(err) {
                setImmediate(function () {
                    throw err;
                });
            });
        }
    };

    self._plugins.forEach(function pluginsEach(plugin) {
        var componentPlugin = plugin.plugComponentContext;
        if (componentPlugin) {
            componentPlugin(componentContext, self, self._app);
        }
    });

    self._componentContext = componentContext;
    return self._componentContext;
};

/**
 * Returns the context for stores
 * @method getStoreContext
 * @return {Object} Store context information
 */
FluxContext.prototype.getStoreContext = function getStoreContext() {
    if (this._storeContext) {
        return this._storeContext;
    }
    var self = this;
    var storeContext = {};

    self._plugins.forEach(function pluginsEach(plugin) {
        var storeContextPlugin = plugin.plugStoreContext;
        if (storeContextPlugin) {
            storeContextPlugin(storeContext, self, self._app);
        }
    });

    self._storeContext = storeContext;
    return self._storeContext;
};

/**
 * Returns a serializable context state
 * @method dehydrate
 * @return {Object} See rehydrate method for properties
 */
FluxContext.prototype.dehydrate = function dehydrate() {
    var self = this;
    var state = {
        dispatcher: (this._dispatcher && this._dispatcher.dehydrate()) || {},
        plugins: {}
    };

    self._plugins.forEach(function pluginsEach(plugin) {
        if ('function' === typeof plugin.dehydrate) {
            // Use a namespace for storing plugin state and provide access to the application
            state.plugins[plugin.name] = plugin.dehydrate(self);
        }
    });

    return state;
};

/**
 * Rehydrates the context state
 * @method rehydrate
 * @param {Object} obj Configuration
 * @param {Object} obj.plugins Dehydrated context plugin state
 * @param {Object} obj.dispatcher Dehydrated dispatcher state
 */
FluxContext.prototype.rehydrate = function rehydrate(obj) {
    var self = this;
    if (__DEV__) {
        if (typeof obj !== 'object') {
            throw new Error('`rehydrate` called with a non-object. Ensure ' +
                'that the parameter passed to rehydrate is a state object ' +
                'produced by a dehydrate call.');
        }
    }
    obj.plugins = obj.plugins || {};
    var pluginTasks = self._plugins.filter(function (plugin) {
        return 'function' === typeof plugin.rehydrate
            && obj.plugins[plugin.name];
    }).map(function (plugin) {
        return new Promise(function (resolve, reject) {
            var result = plugin.rehydrate(obj.plugins[plugin.name], function (err) {
                if (err) {
                    reject(err);
                } else {
                    resolve();
                }
            });
            if (isPromise(result)) {
                result.then(resolve, reject);
            } else if (plugin.rehydrate.length < 2) {
                resolve();
            }
        });
    });

    return Promise.all(pluginTasks).then(function rehydratePluginTasks() {
        self._dispatcher = self._app.createDispatcherInstance(self.getStoreContext());
        self._dispatcher.rehydrate(obj.dispatcher || {});
        return self;
    });
};

module.exports = FluxContext;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44).setImmediate))

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global Promise */

var isPromise = __webpack_require__(58);
__webpack_require__(52);

/**
 * Call an action supporting Promise expectations on invocation.
 *
 * If done callback supplied, that indicates non-Promise invocation expectation,
 * otherwise, Promise invocation.
 */
function callAction (actionContext, action, payload, done) {
    var executeActionPromise = new Promise(function (resolve, reject) {
        setImmediate(function () {
            try {
                var syncResult = action(actionContext, payload, function (err, result) {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(result);
                    }
                });
                if (isPromise(syncResult)) {
                    syncResult.then(resolve, reject);
                } else if (action.length < 3) {
                    resolve(syncResult);
                }
            } catch (e) {
                reject(e);
            }
        });
    });

    if (done) {
        executeActionPromise
            .then(function(result) {
                // Ensures that errors in callback are not swallowed by promise
                setImmediate(done, null, result);
            }, function (err) {
                // Ensures that errors in callback are not swallowed by promise
                setImmediate(done, err);
            });
    }

    return executeActionPromise;
}

module.exports = callAction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44).setImmediate))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


/*
 * Generate a GUID for keeping track of a
 * transaction of actions and dispatches.
 * Reference: https://github.com/facebook/react/blob/a48ffb04dcfe4d6f832207618a8b39e3034bd413/src/renderers/dom/server/ServerReactRootIndex.js
 */
var GLOBAL_UUID_MAX = Math.pow(2, 53);

module.exports = function generateUUID () {
    return Math.ceil(Math.random() * GLOBAL_UUID_MAX);
}


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

// Backbone.Events
// ---------------

// A module that can be mixed in to *any object* in order to provide it with
// custom events. You may bind with `on` or remove with `off` callback
// functions to an event; `trigger`-ing an event fires all callbacks in
// succession.
//
//     var object = {};
//     _.extend(object, Backbone.Events);
//     object.on('expand', function(){ alert('expanded'); });
//     object.trigger('expand');
//

var array = [];
var push = array.push;
var slice = array.slice;
var splice = array.splice;

var _ = __webpack_require__(222);

var Events = module.exports.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }
      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeningTo = this._listeningTo;
      if (!listeningTo) return this;
      var remove = !name && !callback;
      if (!callback && typeof name === 'object') callback = this;
      if (obj) (listeningTo = {})[obj._listenId] = obj;
      for (var id in listeningTo) {
        obj = listeningTo[id];
        obj.off(name, callback, this);
        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeningTo = this._listeningTo || (this._listeningTo = {});
      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
      listeningTo[id] = obj;
      if (!callback && typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

//Events.extend = require('backbone-helpers').extend;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ContactUIStore = __webpack_require__(94);
var ContactMessageStore = __webpack_require__(96);
var UserToUserMessageStore = __webpack_require__(126);
var ContactGaStore = __webpack_require__(110);
var ContactTransactionStore = __webpack_require__(104);

/**
 * Registers the contact stores with the specified component.
 * @param App {Fluxible} A top level component that will be connected to the stores.
 * @param options {Object}
 * @param options.isStorefront {boolean} true if function is being called on dealer storefront
 */
module.exports = function (App) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    App.registerStore(ContactUIStore);
    App.registerStore(ContactMessageStore);
    App.registerStore(ContactGaStore);
    if (options.isUserToUser) {
        App.registerStore(UserToUserMessageStore);
    }
    if (!options.isStorefront) {
        App.registerStore(ContactTransactionStore);
    }
    return App;
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 7/17/15.
 */



var NavBarItemStore = __webpack_require__(141);
var NavBarUIStateStore = __webpack_require__(139);
var SearchStore = __webpack_require__(142);
var NavBarHamburgerStateStore = __webpack_require__(140);
var CartStore = __webpack_require__(106);
var CartCopyStore = __webpack_require__(227);

/**
 * Registers the nav bar stores with the specified component.
 * @param App {Fluxible} A top level component that will be connected to the stores.
 */
module.exports = function (App) {
  App.registerStore(NavBarItemStore);
  App.registerStore(NavBarUIStateStore);
  App.registerStore(SearchStore);
  App.registerStore(NavBarHamburgerStateStore);
  App.registerStore(CartStore);
  App.registerStore(CartCopyStore);

  return App;
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 8/24/15.
 */



var Fluxible = __webpack_require__(217);

/**
 * Creates a new Fluxible object and registers the specified stores with it.
 * @param stores
 * @returns {Fluxible|exports|module.exports} The created Fluxible object
 * @constructor
 */
function AppFactory() {
  var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var app = new Fluxible();

  stores.forEach(function (store) {
    app.registerStore(store);
  });

  return app;
}

module.exports = AppFactory;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var connectToNavBar = __webpack_require__(224);
var connectToContact = __webpack_require__(223);

var _require = __webpack_require__(92),
    createReducerStore = _require.createReducerStore;

var appFactory = __webpack_require__(225);

var RegionalInfoStore = __webpack_require__(316);
var UserStore = createReducerStore(__webpack_require__(109));
var PortfolioStore = __webpack_require__(293);
var ContactDealerStore = createReducerStore(__webpack_require__(136));

var StickyAlertTopStore = __webpack_require__(318);
var CalloutStore = __webpack_require__(301);

/**
 * Setups Fluxible App for use on the server and client.
 *
 * Registers the stores needed to communicate with the global nav bar and
 * registers RegionalInfoStore needed to communicate with global user auth modal,
 *
 * @param {Array} [stores=[]] - Array of stores to register onto App
 * @param {Object} [options={}]
 * @param {boolean} [options.connectToNavBar=true] - If true, register Nav Bar stores with the app
 * @returns {Object} - Fluxible App
 */
function appSetup() {
    var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var App = appFactory(stores);

    if (options.connectToNavBar) {
        App = connectToNavBar(App);
    }
    if (options.connectToContact) {
        App = connectToContact(App, options.contactOptions);
    }

    App.registerStore(RegionalInfoStore);
    App.registerStore(UserStore);
    App.registerStore(PortfolioStore);
    App.registerStore(ContactDealerStore);

    App.registerStore(StickyAlertTopStore);

    App.registerStore(CalloutStore);

    return App;
}

module.exports = appSetup;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var SV = __webpack_require__(17);

var CartCopyStore = function (_BaseStore) {
    _inherits(CartCopyStore, _BaseStore);

    function CartCopyStore(dispatcher) {
        _classCallCheck(this, CartCopyStore);

        var _this = _possibleConstructorReturn(this, (CartCopyStore.__proto__ || Object.getPrototypeOf(CartCopyStore)).call(this, dispatcher));

        _this._cartCopy = SV.get('cartData.cartCopy') || {};
        _this._cartText = SV.get('settings.globalCartCopy.cartBottomText');
        return _this;
    }

    _createClass(CartCopyStore, [{
        key: 'getCartText',
        value: function getCartText() {
            return this._cartText;
        }
    }, {
        key: 'getSoldItemText',
        value: function getSoldItemText() {
            return this._cartCopy.soldItem || '';
        }
    }]);

    return CartCopyStore;
}(BaseStore);

CartCopyStore.storeName = 'CartCopyStore';

module.exports = CartCopyStore;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var Attachment = __webpack_require__(169);
var Clump = __webpack_require__(22);
var endpoints = __webpack_require__(6);
var bunsen = __webpack_require__(21);
var _ = __webpack_require__(0);
var result = __webpack_require__(70);
var $ = __webpack_require__(5);

module.exports = Backbone.Collection.extend({
    model: Attachment,
    initialize: function initialize(models, options) {
        var _this = this;

        var firstAttachmentAdded;
        var _attachmentAdded2;
        options = $.extend({
            uploadType: 'message_center',
            directory: undefined,
            maxCombinedAttachmentSize: undefined,
            uploadOnAdd: true,
            saveOptions: undefined
        }, options);
        this._maxCombinedAttachmentSize = options.maxCombinedAttachmentSize;
        this._saveOptions = options.saveOptions;
        this.on({
            add: function add(attachment) {
                _this._uploadingAttachment = true;
                _this.gotDirectory.done($.proxy(attachment, 'set', 'dir'));
                if (options.uploadOnAdd) {
                    _this.gotDirectory.done(bunsen.gandalf($.proxy(attachment, 'save', null, _this._saveOptions)));
                }
            },
            remove: function remove(attachment) {
                attachment.destroy({
                    success: function success() {
                        return result(attachment.lastSave, 'abort');
                    }
                });
            }
        });
        if (options.directory) {
            this.gotDirectory = $.Deferred().resolve(options.directory);
            return;
        }
        // make request for the upload directory after the first model has been added
        firstAttachmentAdded = $.Deferred();
        _attachmentAdded2 = function _attachmentAdded(addedAttachment) {
            if (!addedAttachment.isNew()) {
                return;
            }
            this.off('add', _attachmentAdded2);
            firstAttachmentAdded.resolve();
        };
        this.on('add', _attachmentAdded2, this);
        this.gotDirectory = firstAttachmentAdded.then($.proxy(this, '_fetchDirectory', options.uploadType));
    },
    comparator: function comparator(modelA, modelB) {
        if (!this._uploadingAttachment) {
            return modelA.get('attachmentType').localeCompare(modelB.get('attachmentType'));
        }
    },
    hasRoomFor: function hasRoomFor(bytes) {
        if (undefined === this._maxCombinedAttachmentSize) {
            return true;
        }
        return bytes < this._maxCombinedAttachmentSize - this.getTotalSize();
    },
    getTotalSize: function getTotalSize() {
        return _.reduce(this.pluck('fileSize'), function (memo, num) {
            return memo + num;
        }, 0);
    },
    sync: function sync() {
        var _this2 = this;

        var unsavedAttachments = _.filter(this.models, function (attachment) {
            return !attachment.lastSave || attachment.lastSave.state() === "rejected";
        });
        if (0 === this.length) {
            return $.Deferred().resolve();
        }
        return this.gotDirectory.then(function (directory) {
            _.invoke(unsavedAttachments, 'set', 'dir', directory);
            _.invoke(unsavedAttachments, 'save', null, _this2._saveOptions);
            return $.when.apply($, _.pluck(_this2.models, 'lastSave'));
        });
    },
    _fetchDirectory: function _fetchDirectory(uploadType) {
        var endpointUpload = uploadType === 'itemImage' ? endpoints.itemImageUpload : endpoints.cmsUpload;

        return Clump.ajax({
            type: 'POST',
            url: endpointUpload(uploadType) + "?" + $.param($.extend({
                cleanup: 'N',
                execute: 'N'
            }, bunsen.getToken()))
        }).then(function (data) {
            return data.result.fileUpload.dir;
        });
    }
});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var Address = __webpack_require__(32);
var moment = __webpack_require__(30);

module.exports = Backbone.AssociatedModel.extend({

    relations: [{
        key: 'sellerDetails',
        relatedModel: Backbone.AssociatedModel.extend(),
        type: Backbone.One
    }, {
        key: 'address',
        relatedModel: Address,
        type: Backbone.One
    }],

    getRegDateFormatted: function getRegDateFormatted() {
        var regDateMomentObj = moment(this.get('buyerRegistrationDate'));
        return regDateMomentObj.format((regDateMomentObj.year() === moment().year() ? 'MMMM, ' : '') + 'YYYY');
    },
    isFollowingSeller: function isFollowingSeller() {
        return this.get('sellerDetails.followingSeller') === 'Y';
    },
    isVerifiedPaymentInformation: function isVerifiedPaymentInformation() {
        return this.get('verifiedPaymentInformation') === 'Y';
    },
    isActiveBuyer: function isActiveBuyer() {
        return this.get('activeBuyer') === 'Y';
    },
    isTrade: function isTrade() {
        return this.get('tradeBuyer') === 'Y';
    }
});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var SoaModel = __webpack_require__(2);
var InvoiceSummary = module.exports = SoaModel.extend();

var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var Invoice = __webpack_require__(81);

module.exports = root.bunsen.InvoiceSummary = InvoiceSummary;

_.extend(InvoiceSummary.prototype, {
    relations: SoaModel.createRelations([{
        type: Backbone.One,
        key: 'dealerCurrentInvoice',
        relatedModel: Invoice
    }, {
        type: Backbone.Many,
        key: 'dealerDeltasInvoices',
        relatedModel: Invoice
    }, {
        type: Backbone.One,
        key: 'dealerOriginalInvoice',
        relatedModel: Invoice
    }])
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Transaction = __webpack_require__(20);
var Party = __webpack_require__(8);
var FinancialAmount = __webpack_require__(10);
var extendCompose = __webpack_require__(43);
var PrivateTransaction = extendCompose.call(Transaction, {});

/**
 * this is an extension of the transaction model intended to facilitate
 * the creation of buyer or seller initiated negotiation 2.0 transactions
 */
PrivateTransaction.extendSelf({

    defaults__: {
        offers: [{
            quantity: '1',
            forCompleteLot: true,
            amountPerItem: {}
        }]
    },

    initialize__: function initialize__() {
        this._offer = this.get('offers[0]');
    },
    prepareToSaveBuyer: function prepareToSaveBuyer() {
        var seller = this.get('seller');
        if (seller) {
            this._offer.set('counterParty', new Party({
                role: Party.ROLE_SELLER,
                id: seller.id
            }));
        }
        var buyer = this.get('buyer');
        if (buyer) {
            this._offer.set('initiatingParty', new Party({
                role: Party.ROLE_BUYER,
                id: buyer.id
            }));
            // use buyer preference currency for buyer initiated transactions
            this._offer.set('amountPerItem.currency', buyer.get('profile.currency') || FinancialAmount.CURRENCY_USD);
        }
        var item = this.get('item');
        if (item) {
            this.set('currencyConversionRateEvent', item.get('pricing.totalAmount.conversionRateEvent'));
        }
    },
    prepareToSaveSeller: function prepareToSaveSeller() {
        var seller = this.get('seller');
        if (seller) {
            this._offer.set('initiatingParty', new Party({
                role: Party.ROLE_SELLER,
                id: seller.id
            }));
        }
        var buyer = this.get('buyer');
        if (buyer) {
            this._offer.set('counterParty', new Party({
                role: Party.ROLE_BUYER,
                id: buyer.id
            }));
        }
        var item = this.get('item');
        if (item) {
            var amount = item.get('pricing.totalAmount');
            this.set('currencyConversionRateEvent', amount.get('conversionRateEvent'));
            this._offer.set('amountPerItem.currency', amount.get('currency'));
        }
    }
});

module.exports = PrivateTransaction;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/6/14
 * Time: 12:07 PM
 */



var _ = __webpack_require__(0);
var Transaction = __webpack_require__(20);
var PaymentAuthorization = __webpack_require__(25);

var _require = __webpack_require__(199),
    momentLocales = _require.momentLocales;

var Offer = __webpack_require__(26);

module.exports = {
    isAccepted: function isAccepted() {
        return this.getMostRecentOffer().isAccepted();
    },
    isAwaitingManualReview: function isAwaitingManualReview() {
        var summary = this.get('summary');
        var checkoutPaymentAuthorization = summary && summary.get('checkoutPaymentAuthorization');
        return checkoutPaymentAuthorization && checkoutPaymentAuthorization.get('status') === PaymentAuthorization.STATUS_PENDING_ADMIN_APPROVAL;
    },
    isPrivateOffer: function isPrivateOffer() {
        var offer = this.getFirstOffer();
        return offer && offer.isDealerInitiatedOffer();
    },
    isPreCheckout: function isPreCheckout() {
        return this.get('summary.checkoutPaymentAuthorization') ? false : true;
    },
    hasSingleOffer: function hasSingleOffer() {
        var offers = this.get('offers');
        return offers && offers.length === 1;
    },
    hasMultipleOffers: function hasMultipleOffers() {
        var offers = this.get('offers');
        return offers && offers.length > 1;
    },
    hasTradeBuyer: function hasTradeBuyer() {
        return this.get('tradeBuyer') === 'Y';
    },
    buyerCanAcceptPrivateOffer: function buyerCanAcceptPrivateOffer() {
        if (!this.isPrivateOffer()) {
            return false;
        }
        if (this.get('status') !== Transaction.STATUS_NEGOTIATING) {
            return false;
        }
        if (_.result(this.getMostRecentOffer(), 'isExpired')) {
            return false;
        }
        if (this.get('summary.checkoutPaymentAuthorization')) {
            return false;
        }
        return true;
    },
    // orders marked as sold from the omt do not get status=CANCELED
    isPrivateOfferCanceled: function isPrivateOfferCanceled() {
        if (this.isCanceled()) {
            return true;
        }
        if (this.isPending() || this.get('status') === Transaction.STATUS_CLOSED) {
            return false;
        }
        return _.result(this.get('item'), 'isItemSold');
    },
    isReadyForBalanceDue: function isReadyForBalanceDue() {
        var paymentRequiredQuote = this.getPaymentRequiredQuote();
        return !!(this.isInProgress() && (paymentRequiredQuote || this.hasBuyerOrderMod()));
    },
    isNegotiable: function isNegotiable() {
        return this.get('transactionType') === Transaction.TYPE_NEGOTIABLE;
    },
    isPreAuthNegotiation: function isPreAuthNegotiation() {
        return this.get('transactionType') === Transaction.TYPE_PRE_AUTH_NEGOTIATION;
    },
    isBuyerInitiatedPreAuth: function isBuyerInitiatedPreAuth() {
        var firstOffer = this.getFirstOffer();
        return this.isPreAuthNegotiation() && firstOffer && firstOffer.isBuyerInitiatedOffer();
    },
    isInProgress: function isInProgress() {
        var inProgressStatuses = [Transaction.STATUS_NEGOTIATING];
        return _.contains(inProgressStatuses, this.get('status'));
    },
    isPending: function isPending() {
        var inPendingStatuses = [Transaction.STATUS_PENDING];
        return _.contains(inPendingStatuses, this.get('status'));
    },
    isConfirmed: function isConfirmed() {
        var confirmedStatuses = [Transaction.STATUS_PENDING, Transaction.STATUS_CLOSED];
        return _.contains(confirmedStatuses, this.get('status'));
    },
    isClosed: function isClosed() {
        return this.get('status') === Transaction.STATUS_CLOSED;
    },
    isCanceled: function isCanceled() {
        var canceledStates = [Transaction.STATUS_NOT_AVAILABLE, Transaction.STATUS_CANCELED];
        return _.contains(canceledStates, this.get('status'));
    },
    isPreConfirmation: function isPreConfirmation() {
        return !this.isPreCheckout() && this.isInProgress();
    },
    isNotApproved: function isNotApproved() {
        var cancellationReasons = [Transaction.CANCELLATION_REASON_FRAUD, Transaction.CANCELLATION_REASON_CANCELED_BEFORE_APPROVED];

        if (this.isAwaitingManualReview()) {
            return true;
        }

        if (_.contains(cancellationReasons, this.get('cancellationReason'))) {
            return true;
        }

        return false;
    },
    isReadyToMarkDealerPaid: function isReadyToMarkDealerPaid() {
        var paymentAuth = this.getOfferPaymentAuthorization();
        var hasPaymentAuthorization = paymentAuth && paymentAuth.isCaptured();
        var isPending = this.isPending();
        var canceled = this.isCanceled();
        var dealerDisbursement = this.getDealerDisbursement();

        return hasPaymentAuthorization && !canceled && isPending && dealerDisbursement && dealerDisbursement.isNewStatus();
    },
    canComputeAdjustments: function canComputeAdjustments() {
        return !!this.getMostRecentOffer().get('quantity');
    },
    isPendingPaymentDeclined: function isPendingPaymentDeclined() {
        var paymentAuth = this.getOfferPaymentAuthorization();
        if (paymentAuth) {
            return paymentAuth.hasPaymentDeclined();
        } else {
            return false;
        }
    },
    getOfferDetails: function getOfferDetails() {
        var mostRecentOffer = void 0;
        var offerAmounts = void 0;
        var offerExpDateTxt = void 0;

        if (!this) {
            return {};
        }
        mostRecentOffer = this.getMostRecentOffer();
        if (!mostRecentOffer) {
            return {};
        }

        if (mostRecentOffer.get('expirationDate') && this._needExpDate()) {
            offerExpDateTxt = momentLocales.inlineDatesAdverb(mostRecentOffer.get('expirationDate')).fromNow();
        }
        offerAmounts = mostRecentOffer.get('totalAmount');
        return {
            offer: mostRecentOffer,
            offerAmounts: offerAmounts, offerExpDateTxt: offerExpDateTxt
        };
    },
    _needExpDate: function _needExpDate() {
        var mostRecentOffer = this.getMostRecentOffer();
        if (!this.isPreAuthNegotiation() || this.isCanceled()) {
            return false;
        }
        if (mostRecentOffer.isSubmitted()) {
            return true;
        }
        if (mostRecentOffer.offerDisplayStatus({ transaction: this }) === Offer.DisplayOfferStatus.dealerAccepted) {
            return true;
        }
        return false;
    },
    _getCounteredOffers: function _getCounteredOffers() {
        return this.get('offers').where({ status: Offer.STATUS_COUNTERED });
    },
    isMostRecentlyDealerCountered: function isMostRecentlyDealerCountered() {
        return _.chain(this._getCounteredOffers()).last().result('isBuyerInitiatedOffer').value();
    },
    isMostRecentlyBuyerCountered: function isMostRecentlyBuyerCountered() {
        return _.chain(this._getCounteredOffers()).last().result('isDealerInitiatedOffer').value();
    },
    isBuyerOfferWithReserve: function isBuyerOfferWithReserve() {
        // currently, this method is the same as isNegotiable and only checks if the transaction type is negotiable
        // created this method in case the isNegotiable method gets updated above to include other transaction types
        return this.get('transactionType') === Transaction.TYPE_NEGOTIABLE;
    },
    isFullPriceOrder: function isFullPriceOrder() {
        // in the 5.48 BE ecom release, all reserve-less offers will have a new type
        // the only tx of type non-negotiable will be full-priced orders
        return this.get('transactionType') === Transaction.TYPE_NON_NEGOTIABLE;
    },
    isBuyerInitiatedTx: function isBuyerInitiatedTx() {
        return _.result(this.getFirstOffer(), 'isBuyerInitiatedOffer');
    }
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Message = __webpack_require__(72);
var Backbone = __webpack_require__(3);
var endpoints = __webpack_require__(6);
var extendCompose = __webpack_require__(43);
var Item = __webpack_require__(34);
var MessageRecipient = __webpack_require__(71);
var ConversationMember = __webpack_require__(68);
var Party = __webpack_require__(8);
var ContactDealerMessage = module.exports = extendCompose.call(Message, {});

ContactDealerMessage.extendSelf({
    url: endpoints.messageNewConversation,

    defaults__: {
        from: {
            displayName: '',
            discloseEmail: 'N'
        }
    },

    relations__: function relations__(relations) {
        return relations.concat([{
            type: Backbone.One,
            key: 'item',
            relatedModel: Item,
            saveJSONFields: ['id', 'apiType']
        }]);
    },
    initialize: function initialize(data, options) {
        options = _.extend({
            item: undefined,
            seller: undefined,
            isNetPrice: false
        }, options);
        this._isNetPrice = options.isNetPrice;
        if (options.item) {
            this.setItem(options.item);
        } else if (options.seller) {
            this.setSeller(options.seller);
        }
        if (options.fromUser) {
            this.setFromUser(options.fromUser);
        }
        this.setAction(Message.MC_ACTIONS[this._isNetPrice ? 'netPrice' : 'contactDealer']);
    },
    setItem: function setItem(item) {
        this.set({
            context: this._isNetPrice ? ContactDealerMessage.context.itemNetPrice : ContactDealerMessage.context.item,
            item: item
        });
        this.setToSeller(item.get('seller'));
    },
    setSeller: function setSeller(seller) {
        this.set('context', ContactDealerMessage.context.seller);
        this.setToSeller(seller);
    },
    setFromUser: function setFromUser(user) {
        this.set('from', new ConversationMember({
            user: user.pick('id'),
            displayName: [user.get('profile.firstName') || '', user.get('profile.lastName') || ''].join(' ').trim(),
            userEmail: user.get('profile.email'),
            userType: Party.ROLE_BUYER
        }));
    },
    setToSeller: function setToSeller(seller) {
        this.set('recipients', [new MessageRecipient({
            recipientDetails: new ConversationMember({
                user: seller.pick('id'),
                displayName: seller.get('sellerProfile.company'),
                userEmail: seller.get('sellerProfile.email'),
                userType: Party.ROLE_SELLER
            })
        })]);
    },
    getFirstRecipientName: function getFirstRecipientName() {
        return this.get('recipients[0].recipientDetails.displayName');
    }
});

Object.assign(ContactDealerMessage, {
    context: {
        item: 'CONTACT_SELLER_PDP',
        itemNetPrice: 'CONTACT_SELLER_NET_PRICE',
        seller: 'CONTACT_SELLER_STOREFRONT'
    }
});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RegexRule = __webpack_require__(85);
var RegexFieldValidation = __webpack_require__(119);
var FinancialAmount = __webpack_require__(10);
var regexRules = __webpack_require__(115);
var pick = __webpack_require__(65);

/**
 * @class LocalizedCurrencyValidation
 * @extends RegexFieldValidation
 */
var LocalizedCurrencyValidation = module.exports = RegexFieldValidation.extend({
    initialize: function initialize(options) {
        options = options || {};
        var isEur = options.currency === FinancialAmount.CURRENCY_EUR;
        this.regex = isEur ? regexRules.currencyStringEur : regexRules.currencyString;
        this.rule = new RegexRule(pick(this, 'regex', 'noMatch', 'message'));
        if (typeof options.getModelValueForField === 'function') {
            this.getModelValueForField = options.getModelValueForField;
        }
        LocalizedCurrencyValidation.__super__.initialize.call(this, options);
    }
});

/***/ }),
/* 235 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is in `cache` mimicking the return signature of
 * `_.indexOf` by returning `0` if the value is found, else `-1`.
 *
 * @private
 * @param {Object} cache The cache to search.
 * @param {*} value The value to search for.
 * @returns {number} Returns `0` if `value` is found, else `-1`.
 */
function cacheIndexOf(cache, value) {
  var data = cache.data,
      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

  return result ? 0 : -1;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = cacheIndexOf;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(321);

/** Native method references. */
var Set = getNative(global, 'Set');

/* Native method references for those with the same name as other `lodash` methods. */
var nativeCreate = getNative(Object, 'create');

/**
 *
 * Creates a cache object to store unique values.
 *
 * @private
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var length = values ? values.length : 0;

  this.data = { 'hash': nativeCreate(null), 'set': new Set };
  while (length--) {
    this.push(values[length]);
  }
}

/**
 * Adds `value` to the cache.
 *
 * @private
 * @name push
 * @memberOf SetCache
 * @param {*} value The value to cache.
 */
function cachePush(value) {
  var data = this.data;
  if (typeof value == 'string' || isObject(value)) {
    data.set.add(value);
  } else {
    data.hash[value] = true;
  }
}

/**
 * Creates a `Set` cache object to optimize linear searches of large arrays.
 *
 * @private
 * @param {Array} [values] The values to cache.
 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
 */
function createCache(values) {
  return (nativeCreate && Set) ? new SetCache(values) : null;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

// Add functions to the `Set` cache.
SetCache.prototype.push = cachePush;

module.exports = createCache;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 237 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = baseCreate(prototype);
  return properties ? baseAssign(result, properties) : result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = create;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 4.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseFor = __webpack_require__(128),
    keys = __webpack_require__(240);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite property
 * assignments of previous values.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  result[value] = key;
}, constant(identity));

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var getter = _.constant(object);
 *
 * getter() === object;
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument given to it.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = invert;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    result++;
  }
  return result;
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

module.exports = size;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var root = __webpack_require__(278);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = Symbol ? symbolProto.toString : undefined;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (value == null) {
    return '';
  }
  if (isSymbol(value)) {
    return Symbol ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Generates a unique ID. If `prefix` is provided the ID is appended to it.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {string} [prefix] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArray = __webpack_require__(64);

/**
 * Creates an object composed from arrays of property names and values. Provide
 * either a single two dimensional array, e.g. `[[key1, value1], [key2, value2]]`
 * or two arrays, one of property names and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @alias object
 * @category Array
 * @param {Array} props The property names.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['fred', 'barney'], [30, 40]);
 * // => { 'fred': 30, 'barney': 40 }
 */
function zipObject(props, values) {
  var index = -1,
      length = props ? props.length : 0,
      result = {};

  if (length && !values && !isArray(props[0])) {
    values = [];
  }
  while (++index < length) {
    var key = props[index];
    if (values) {
      result[key] = values[index];
    } else if (key) {
      result[key[0]] = key[1];
    }
  }
  return result;
}

module.exports = zipObject;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options){
  options = options || {};
  if ('string' == typeof val) return parse(val);
  return options.long
    ? long(val)
    : short(val);
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = '' + str;
  if (str.length > 10000) return;
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) return;
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function short(ms) {
  if (ms >= d) return Math.round(ms / d) + 'd';
  if (ms >= h) return Math.round(ms / h) + 'h';
  if (ms >= m) return Math.round(ms / m) + 'm';
  if (ms >= s) return Math.round(ms / s) + 's';
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function long(ms) {
  return plural(ms, d, 'day')
    || plural(ms, h, 'hour')
    || plural(ms, m, 'minute')
    || plural(ms, s, 'second')
    || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) return;
  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var TemplateView; // required after export is defined to avoid circular dependency
var result = __webpack_require__(247);
var assign = __webpack_require__(246);
var View = __webpack_require__(90).View;
var normalizeToView = module.exports = function (options) {
    if (!global.HTMLElement) {
        throw new Error('normalize-to-view expects global.HTMLElement');
    }
    // TODO: test this
    var view;
    var constructorOptions;
    var defaultParentElement;
    var newContent;
    var useDefaultParentElement;
    if (undefined === options.content && !options.Constructor) {
        throw new Error("normalizeToView requires options.Constructor if options.content is missing");
    }
    options = assign({
        defaultParentElement: undefined,
        defaultContext: undefined,
        defaultTemplateVars: undefined,
        content: undefined,
        Constructor: TemplateView
    }, options);
    if (false === options.content) {
        return false;
    }
    if (options.content && options.content.jquery) {
        options.content = options.content.get(0);
        view = new View({el: options.content});
    }
    // content can't be jQuery below this line
    if (options.content instanceof global.HTMLElement) {
        view = new View({el: options.content});
    }
    if (options.content && options.content.hasOwnProperty('el')) { // assume it's a backbone-style view if it has an `el` property
        view = options.content;
    }
    if (options.content instanceof Function) {
        defaultParentElement = undefined;
        if (options.defaultParentElement) {
            defaultParentElement = options.defaultParentElement;
        }
        newContent = options.content.call(options.defaultContext, defaultParentElement);
        if (!newContent) {
            return newContent;
        }
        view = normalizeToView(assign({}, options, {content: newContent}));
    }
    if (!view && options.Constructor) {
        constructorOptions = options.content;
        useDefaultParentElement = true;
        if (options.Constructor && result(options.Constructor.prototype.template, 'useInnerElement')) {
            useDefaultParentElement = false;
        }
        if (result(constructorOptions, 'useInnerElement')) {
            useDefaultParentElement = false;
        }
        if (useDefaultParentElement) {
            constructorOptions = assign({el: options.defaultParentElement}, constructorOptions);
        }
        if (
            options.Constructor.prototype.templateVars === TemplateView.prototype.templateVars &&
            !constructorOptions.templateVars && !constructorOptions.model
        ) {
            constructorOptions = assign({templateVars: options.defaultTemplateVars}, constructorOptions);
        }
        view = new options.Constructor(constructorOptions);
    }
    return view;
};
TemplateView = __webpack_require__(77);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 246 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    object = undefined;
    length = 1;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

module.exports = result;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 248 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _([1, 2]).forEach(function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, typeof iteratee == 'function' ? iteratee : identity);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forEach;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(69)(module)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = baseRest(function(object, props) {
  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
});

module.exports = pick;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    object = undefined;
    length = 1;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

module.exports = result;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 253 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    stringTag = '[object String]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf,
    nativeKeys = Object.keys;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return hasOwnProperty.call(object, key) ||
    (typeof object == 'object' && key in object && getPrototype(object) === null);
}

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  return nativeKeys(Object(object));
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
function getPrototype(value) {
  return nativeGetPrototype(Object(value));
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) &&
      (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
        !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseEach;


/***/ }),
/* 254 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _([1, 2]).forEach(function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, typeof iteratee == 'function' ? iteratee : identity);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forEach;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

/**
 * lodash 4.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 4.2.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseEach = __webpack_require__(253),
    baseIteratee = __webpack_require__(305);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Creates an array of values by running each element in `collection` through
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `curry`, `curryRight`, `drop`, `dropRight`, `every`, `fill`,
 * `invert`, `parseInt`, `random`, `range`, `rangeRight`, `slice`, `some`,
 * `sortBy`, `take`, `takeRight`, `template`, `trim`, `trimEnd`, `trimStart`,
 * and `words`
 *
 * @static
 * @memberOf _
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = map;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    result[key] = iteratee(value, key, object);
  });
  return result;
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = mapValues;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(69)(module)))

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    object = undefined;
    length = 1;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

module.exports = result;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 260 */
/***/ (function(module, exports) {


exports = module.exports = trim;

function trim(str){
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function(str){
  return str.replace(/^\s*/, '');
};

exports.right = function(str){
  return str.replace(/\s*$/, '');
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
  // Moderately fast, high quality
  var _rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(_rnds8);
    return _rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  _rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return _rnds;
  };
}

module.exports = rng;


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var _rng = __webpack_require__(261);

// Maps for number <-> hex string conversion
var _byteToHex = [];
var _hexToByte = {};
for (var i = 0; i < 256; i++) {
  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
  _hexToByte[_byteToHex[i]] = i;
}

// **`parse()` - Parse a UUID into it's component bytes**
function parse(s, buf, offset) {
  var i = (buf && offset) || 0, ii = 0;

  buf = buf || [];
  s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
    if (ii < 16) { // Don't overflow!
      buf[i + ii++] = _hexToByte[oct];
    }
  });

  // Zero out remaining bytes if string was short
  while (ii < 16) {
    buf[i + ii++] = 0;
  }

  return buf;
}

// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
function unparse(buf, offset) {
  var i = offset || 0, bth = _byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = _rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; n++) {
    b[i + n] = node[n];
  }

  return buf ? buf : unparse(b);
}

// **`v4()` - Generate random UUID**

// See https://github.com/broofa/node-uuid for API details
function v4(options, buf, offset) {
  // Deprecated - 'format' argument, as supported in v1.2
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || _rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ii++) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || unparse(rnds);
}

// Export public API
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
uuid.parse = parse;
uuid.unparse = unparse;

module.exports = uuid;


/***/ }),
/* 263 */,
/* 264 */,
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).Buffer))

/***/ }),
/* 266 */
/***/ (function(module, exports) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>
	Doctype: "doctype",

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var Parser = __webpack_require__(345),
    DomHandler = __webpack_require__(407);

function defineProp(name, value){
	delete module.exports[name];
	module.exports[name] = value;
	return value;
}

module.exports = {
	Parser: Parser,
	Tokenizer: __webpack_require__(346),
	ElementType: __webpack_require__(266),
	DomHandler: DomHandler,
	get FeedHandler(){
		return defineProp("FeedHandler", __webpack_require__(404));
	},
	get Stream(){
		return defineProp("Stream", __webpack_require__(406));
	},
	get WritableStream(){
		return defineProp("WritableStream", __webpack_require__(347));
	},
	get ProxyHandler(){
		return defineProp("ProxyHandler", __webpack_require__(405));
	},
	get DomUtils(){
		return defineProp("DomUtils", __webpack_require__(409));
	},
	get CollectingHandler(){
		return defineProp("CollectingHandler", __webpack_require__(403));
	},
	// For legacy support
	DefaultHandler: DomHandler,
	get RssHandler(){
		return defineProp("RssHandler", this.FeedHandler);
	},
	//helper methods
	parseDOM: function(data, options){
		var handler = new DomHandler(options);
		new Parser(handler, options).end(data);
		return handler.dom;
	},
	parseFeed: function(feed, options){
		var handler = new module.exports.FeedHandler(options);
		new Parser(handler, options).end(feed);
		return handler.dom;
	},
	createDomStream: function(cb, options, elementCb){
		var handler = new DomHandler(cb, options, elementCb);
		return new Parser(handler, options);
	},
	// List of all events that the parser emits
	EVENTS: { /* Format: eventname: number of arguments */
		attribute: 2,
		cdatastart: 0,
		cdataend: 0,
		text: 1,
		processinginstruction: 2,
		comment: 1,
		commentend: 0,
		closetag: 1,
		opentag: 2,
		opentagname: 1,
		error: 1,
		end: 0
	}
};


/***/ }),
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(67),
    noop = _require.noop;

// Type of touch.
// NOTE: Currently doesn't distinguish touch types greater than 2. If needed we can add TRIPE, QUADRUPLE, etc.


var TOUCH_TYPE_SINGLE = 'single';
var TOUCH_TYPE_DOUBLE = 'double';
var TOUCH_TYPE_MANY = 'many';

/**
 * Utility class To handle multi-touch detection. Pass an element in and it allow you to attach handlers for multi-touch.
 * Instances need to be destroyed when tracking is no longer needed.
 *
 * @param  {Object}  options.el Element to track.
 * @param  {Function}  [options.onSingleTouchStart] Callback to fire on single touch start.
 * @param  {Function}  [options.onSingleTouchMove] Callback to fire on single touch move.
 * @param  {Function}  [options.onSingleTouchEnd] Callback to fire on single touch end.
 * @param  {Function}  [options.onDoubleTouchStart] Callback to fire on double touch start.
 * @param  {Function}  [options.onDoubleTouchMove] Callback to fire on double touch move.
 * @param  {Function}  [options.onDoubleTouchEnd] Callback to fire on double touch end.
 * @param  {Function}  [options.onManyTouchStart] Callback to fire on many touch start.
 * @param  {Function}  [options.onManyTouchMove] Callback to fire on many touch move.
 * @param  {Function}  [options.onManyTouchEnd] Callback to fire on many touch end.
 */

var MultiTouchDetector = function () {
    function MultiTouchDetector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el,
            _ref$onSingleTouchSta = _ref.onSingleTouchStart,
            onSingleTouchStart = _ref$onSingleTouchSta === undefined ? noop : _ref$onSingleTouchSta,
            _ref$onSingleTouchMov = _ref.onSingleTouchMove,
            onSingleTouchMove = _ref$onSingleTouchMov === undefined ? noop : _ref$onSingleTouchMov,
            _ref$onSingleTouchEnd = _ref.onSingleTouchEnd,
            onSingleTouchEnd = _ref$onSingleTouchEnd === undefined ? noop : _ref$onSingleTouchEnd,
            _ref$onDoubleTouchSta = _ref.onDoubleTouchStart,
            onDoubleTouchStart = _ref$onDoubleTouchSta === undefined ? noop : _ref$onDoubleTouchSta,
            _ref$onDoubleTouchMov = _ref.onDoubleTouchMove,
            onDoubleTouchMove = _ref$onDoubleTouchMov === undefined ? noop : _ref$onDoubleTouchMov,
            _ref$onDoubleTouchEnd = _ref.onDoubleTouchEnd,
            onDoubleTouchEnd = _ref$onDoubleTouchEnd === undefined ? noop : _ref$onDoubleTouchEnd,
            _ref$onManyTouchStart = _ref.onManyTouchStart,
            onManyTouchStart = _ref$onManyTouchStart === undefined ? noop : _ref$onManyTouchStart,
            _ref$onManyTouchMove = _ref.onManyTouchMove,
            onManyTouchMove = _ref$onManyTouchMove === undefined ? noop : _ref$onManyTouchMove,
            _ref$onManyTouchEnd = _ref.onManyTouchEnd,
            onManyTouchEnd = _ref$onManyTouchEnd === undefined ? noop : _ref$onManyTouchEnd;

        _classCallCheck(this, MultiTouchDetector);

        if (!el) {
            throw new Error('Must pass `el` to MultiTouchDetector');
        }

        Object.assign(this, {
            _type: null,
            _el: el,
            _onSingleTouchStart: onSingleTouchStart,
            _onSingleTouchMove: onSingleTouchMove,
            _onSingleTouchEnd: onSingleTouchEnd,
            _onDoubleTouchStart: onDoubleTouchStart,
            _onDoubleTouchMove: onDoubleTouchMove,
            _onDoubleTouchEnd: onDoubleTouchEnd,
            _onManyTouchStart: onManyTouchStart,
            _onManyTouchMove: onManyTouchMove,
            _onManyTouchEnd: onManyTouchEnd,
            _onTouchStart: this._onTouchStart.bind(this),
            _onTouchMove: this._onTouchMove.bind(this),
            _onTouchEnd: this._onTouchEnd.bind(this)
        });

        this._el.addEventListener('touchstart', this._onTouchStart);
        this._el.addEventListener('touchmove', this._onTouchMove);
        this._el.addEventListener('touchend', this._onTouchEnd);
    }

    _createClass(MultiTouchDetector, [{
        key: 'destroy',
        value: function destroy() {
            this._el.removeEventListener('touchstart', this._onTouchStart);
            this._el.removeEventListener('touchmove', this._onTouchMove);
            this._el.removeEventListener('touchend', this._onTouchEnd);
        }
    }, {
        key: '_onTouchStart',
        value: function _onTouchStart(e) {
            var touches = e.touches;

            // If we've gone to many touch...

            if (touches.length > 2) {
                // if we were on double, end it.
                this._conditionalEndDouble(e);

                // if we were on single, end it.
                this._conditionalEndSingle(e);

                // if we're not already on many, go to many.
                this._conditionalStartMany(e);
                return;
            }

            // If we've gone to double...
            if (touches.length === 2) {
                // if we were on single, end it.
                this._conditionalEndSingle(e);

                // go to double.
                this._conditionalStartDouble(e);
                return;
            }

            // If we've gone to single...
            // go go to single.
            this._conditionalStartSingle(e);
        }
    }, {
        key: '_onTouchMove',
        value: function _onTouchMove(e) {
            if (this.isMany()) {
                this._onManyTouchMove(e);
                return;
            }

            if (this.isDouble()) {
                this._onDoubleTouchMove(e);
                return;
            }

            if (this.isSingle()) {
                this._onSingleTouchMove(e);
            }
        }
    }, {
        key: '_onTouchEnd',
        value: function _onTouchEnd(e) {
            var touches = e.touches;

            // If we're still on many touch, we'll just ignore the change.

            if (touches.length > 2) {
                return;
            }

            // If we've gone down to only 2 touches...
            if (touches.length === 2) {
                // if we were on many, end it.
                this._conditionalEndMany(e);

                // restart double.
                this._conditionalStartDouble(e);
                return;
            }

            // If we've gone down to 1 touch...
            if (touches.length === 1) {
                // if we were on many, end it.
                this._conditionalEndMany(e);

                // if we were on double, end it.
                this._conditionalEndDouble(e);

                // restart single.
                this._conditionalStartSingle(e);
                return;
            }

            // If we've removed all touches...
            // if we were on many, end it.
            this._conditionalEndMany(e);

            // if we were on double, end it.
            this._conditionalEndDouble(e);

            // if we were on single, end it.
            this._conditionalEndSingle(e);
            this._type = null;
        }
    }, {
        key: 'isSingle',
        value: function isSingle() {
            return this._type === TOUCH_TYPE_SINGLE;
        }
    }, {
        key: 'isDouble',
        value: function isDouble() {
            return this._type === TOUCH_TYPE_DOUBLE;
        }
    }, {
        key: 'isMany',
        value: function isMany() {
            return this._type === TOUCH_TYPE_MANY;
        }
    }, {
        key: '_conditionalEndSingle',
        value: function _conditionalEndSingle(e) {
            if (this.isSingle()) {
                this._onSingleTouchEnd(e);
            }
        }
    }, {
        key: '_conditionalEndDouble',
        value: function _conditionalEndDouble(e) {
            if (this.isDouble()) {
                this._onDoubleTouchEnd(e);
            }
        }
    }, {
        key: '_conditionalEndMany',
        value: function _conditionalEndMany(e) {
            if (this.isMany()) {
                this._onManyTouchEnd(e);
            }
        }
    }, {
        key: '_conditionalStartSingle',
        value: function _conditionalStartSingle(e) {
            if (!this.isSingle()) {
                this._type = TOUCH_TYPE_SINGLE;
                this._onSingleTouchStart(e);
            }
        }
    }, {
        key: '_conditionalStartDouble',
        value: function _conditionalStartDouble(e) {
            if (!this.isDouble()) {
                this._type = TOUCH_TYPE_DOUBLE;
                this._onDoubleTouchStart(e);
            }
        }
    }, {
        key: '_conditionalStartMany',
        value: function _conditionalStartMany(e) {
            if (!this.isMany()) {
                this._type = TOUCH_TYPE_MANY;
                this._onManyTouchStart(e);
            }
        }
    }]);

    return MultiTouchDetector;
}();

module.exports = MultiTouchDetector;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(338);


/***/ }),
/* 271 */,
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(273).EventEmitter;
var inherits = __webpack_require__(50);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(426);
Stream.Writable = __webpack_require__(428);
Stream.Duplex = __webpack_require__(424);
Stream.Transform = __webpack_require__(427);
Stream.PassThrough = __webpack_require__(425);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(472);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

module.exports = {
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _withProps = __webpack_require__(929);

var _withProps2 = _interopRequireDefault(_withProps);

var _setDisplayName = __webpack_require__(564);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(565);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _classnames = __webpack_require__(921);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeTheme(injectedTheme) {
    return function (BaseComponent) {
        var Themed = (0, _withProps2.default)(function (ownProps) {
            var theme = injectedTheme;
            if (ownProps && ownProps.theme) {
                var ownTheme = ownProps.theme;
                theme = Object.keys(ownTheme).filter(function (key) {
                    return !!injectedTheme[key];
                }).reduce(function (accum, key) {
                    accum[key] = (0, _classnames2.default)(ownTheme[key], injectedTheme[key]);
                    return accum;
                }, _extends({}, ownTheme, injectedTheme));
            }
            return { theme: theme };
        })(BaseComponent);
        (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'themed'))(Themed);
        return Themed;
    };
}

exports.default = mergeTheme;

/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Component = React.Component;

var sanitizeHtml = __webpack_require__(466);
var HtmlEntities = __webpack_require__(463).AllHtmlEntities;

var DEFAULT_ALLOWED_TAGS = ['br', 'a'];
var DEFAULT_ALLOWED_ATTRIBUTES = {
    a: ['href', 'target', 'rel', 'title']
};

/**
 * Sanitizes user input HTML. See documentation for `sanitize-html` for more infotmation.
 * Also allows optionally decoding HTML entities.
 */

var SanitizeHtml = function (_Component) {
    _inherits(SanitizeHtml, _Component);

    function SanitizeHtml() {
        _classCallCheck(this, SanitizeHtml);

        return _possibleConstructorReturn(this, (SanitizeHtml.__proto__ || Object.getPrototypeOf(SanitizeHtml)).apply(this, arguments));
    }

    _createClass(SanitizeHtml, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                content = _props.content,
                decodeEntities = _props.decodeEntities,
                allowedTags = _props.allowedTags,
                allowedAttributes = _props.allowedAttributes,
                other = _objectWithoutProperties(_props, ['content', 'decodeEntities', 'allowedTags', 'allowedAttributes']);

            var _content = String(content);

            if (decodeEntities) {
                _content = new HtmlEntities().decode(content);
            }

            // assign this._content for testing purposes only
            this._content = _content = sanitizeHtml(_content, {
                allowedTags: allowedTags,
                allowedAttributes: allowedAttributes
            });

            return React.createElement('span', _extends({}, other, {
                dangerouslySetInnerHTML: { __html: _content } }));
        }
    }]);

    return SanitizeHtml;
}(Component);

SanitizeHtml.propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    decodeEntities: PropTypes.bool,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    allowedTags: PropTypes.arrayOf(PropTypes.string),
    allowedAttributes: PropTypes.object
};

SanitizeHtml.defaultProps = {
    decodeEntities: false,
    content: '',
    allowedTags: DEFAULT_ALLOWED_TAGS,
    allowedAttributes: DEFAULT_ALLOWED_ATTRIBUTES
};

module.exports = SanitizeHtml;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Buffer = __webpack_require__(45).Buffer;

var isBufferEncoding = Buffer.isEncoding
  || function(encoding) {
       switch (encoding && encoding.toLowerCase()) {
         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
         default: return false;
       }
     }


function assertEncoding(encoding) {
  if (encoding && !isBufferEncoding(encoding)) {
    throw new Error('Unknown encoding: ' + encoding);
  }
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
var StringDecoder = exports.StringDecoder = function(encoding) {
  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
  assertEncoding(encoding);
  switch (this.encoding) {
    case 'utf8':
      // CESU-8 represents each of Surrogate Pair by 3-bytes
      this.surrogateSize = 3;
      break;
    case 'ucs2':
    case 'utf16le':
      // UTF-16 represents each of Surrogate Pair by 2-bytes
      this.surrogateSize = 2;
      this.detectIncompleteChar = utf16DetectIncompleteChar;
      break;
    case 'base64':
      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
      this.surrogateSize = 3;
      this.detectIncompleteChar = base64DetectIncompleteChar;
      break;
    default:
      this.write = passThroughWrite;
      return;
  }

  // Enough space to store all bytes of a single character. UTF-8 needs 4
  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
  this.charBuffer = new Buffer(6);
  // Number of bytes received for the current incomplete multi-byte character.
  this.charReceived = 0;
  // Number of bytes expected for the current incomplete multi-byte character.
  this.charLength = 0;
};


// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
  var charStr = '';
  // if our last write ended with an incomplete multibyte character
  while (this.charLength) {
    // determine how many remaining bytes this buffer has to offer for this char
    var available = (buffer.length >= this.charLength - this.charReceived) ?
        this.charLength - this.charReceived :
        buffer.length;

    // add the new bytes to the char buffer
    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    this.charReceived += available;

    if (this.charReceived < this.charLength) {
      // still not enough chars in this buffer? wait for more ...
      return '';
    }

    // remove bytes belonging to the current character from the buffer
    buffer = buffer.slice(available, buffer.length);

    // get the character that was split
    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    var charCode = charStr.charCodeAt(charStr.length - 1);
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      this.charLength += this.surrogateSize;
      charStr = '';
      continue;
    }
    this.charReceived = this.charLength = 0;

    // if there are no more bytes in this buffer, just emit our char
    if (buffer.length === 0) {
      return charStr;
    }
    break;
  }

  // determine and set charLength / charReceived
  this.detectIncompleteChar(buffer);

  var end = buffer.length;
  if (this.charLength) {
    // buffer the incomplete character bytes we got
    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    end -= this.charReceived;
  }

  charStr += buffer.toString(this.encoding, 0, end);

  var end = charStr.length - 1;
  var charCode = charStr.charCodeAt(end);
  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    var size = this.surrogateSize;
    this.charLength += size;
    this.charReceived += size;
    this.charBuffer.copy(this.charBuffer, size, 0, size);
    buffer.copy(this.charBuffer, 0, 0, size);
    return charStr.substring(0, end);
  }

  // or just emit the charStr
  return charStr;
};

// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
  // determine how many bytes we have to check at the end of this buffer
  var i = (buffer.length >= 3) ? 3 : buffer.length;

  // Figure out if one of the last i bytes of our buffer announces an
  // incomplete char.
  for (; i > 0; i--) {
    var c = buffer[buffer.length - i];

    // See http://en.wikipedia.org/wiki/UTF-8#Description

    // 110XXXXX
    if (i == 1 && c >> 5 == 0x06) {
      this.charLength = 2;
      break;
    }

    // 1110XXXX
    if (i <= 2 && c >> 4 == 0x0E) {
      this.charLength = 3;
      break;
    }

    // 11110XXX
    if (i <= 3 && c >> 3 == 0x1E) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = i;
};

StringDecoder.prototype.end = function(buffer) {
  var res = '';
  if (buffer && buffer.length)
    res = this.write(buffer);

  if (this.charReceived) {
    var cr = this.charReceived;
    var buf = this.charBuffer;
    var enc = this.encoding;
    res += buf.slice(0, cr).toString(enc);
  }

  return res;
};

function passThroughWrite(buffer) {
  return buffer.toString(this.encoding);
}

function utf16DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 2;
  this.charLength = this.charReceived ? 2 : 0;
}

function base64DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 3;
  this.charLength = this.charReceived ? 3 : 0;
}


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(98);

/*<replacement>*/
var util = __webpack_require__(265);
util.inherits = __webpack_require__(50);
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er) {
      done(stream, er);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

function done(stream, er) {
  if (er) return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/*<replacement>*/
var processNextTick = __webpack_require__(297);
/*</replacement>*/

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

/*<replacement>*/
var Buffer = __webpack_require__(45).Buffer;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(265);
util.inherits = __webpack_require__(50);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(422)
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = __webpack_require__(277);
  } catch (_) {} finally {
    if (!Stream) Stream = __webpack_require__(273).EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = __webpack_require__(45).Buffer;

util.inherits(Writable, Stream);

function nop() {}

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

var Duplex;
function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(98);

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // create the two objects needed to store the corked requests
  // they are not a linked list, as no new elements are inserted in there
  this.corkedRequestsFree = new CorkedRequest(this);
  this.corkedRequestsFree.next = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function writableStateGetBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
    });
  } catch (_) {}
})();

var Duplex;
function Writable(options) {
  Duplex = Duplex || __webpack_require__(98);

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe. Not readable.'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;

  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    var er = new TypeError('Invalid non-string/buffer chunk');
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = new Buffer(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) processNextTick(cb, er);else cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
        afterWrite(stream, state, finished, cb);
      }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    while (entry) {
      buffer[count] = entry;
      entry = entry.next;
      count += 1;
    }

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    state.corkedRequestsFree = holder.next;
    holder.next = null;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else {
      prefinish(stream, state);
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function (err) {
    var entry = _this.entry;
    _this.entry = null;
    while (entry) {
      var cb = entry.callback;
      state.pendingcb--;
      cb(err);
      entry = entry.next;
    }
    if (state.corkedRequestsFree) {
      state.corkedRequestsFree.next = _this;
    } else {
      state.corkedRequestsFree = _this;
    }
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111), __webpack_require__(44).setImmediate))

/***/ }),
/* 301 */,
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    createEnum: __webpack_require__(441),
    instanceOfEnum: __webpack_require__(442)
};

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/



Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(40);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__(566);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__(337);

var _classnames2 = _interopRequireDefault(_classnames);

var _utilsDefaultArrowRenderer = __webpack_require__(572);

var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);

var _utilsDefaultFilterOptions = __webpack_require__(444);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(445);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var _utilsDefaultClearRenderer = __webpack_require__(573);

var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);

var _Async = __webpack_require__(567);

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__(568);

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__(569);

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Option = __webpack_require__(570);

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__(571);

var _Value2 = _interopRequireDefault(_Value);

function stringifyValue(value) {
	var valueType = typeof value;
	if (valueType === 'string') {
		return value;
	} else if (valueType === 'object') {
		return JSON.stringify(value);
	} else if (valueType === 'number' || valueType === 'boolean') {
		return String(value);
	} else {
		return '';
	}
}

var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);

var instanceId = 1;

var Select = _react2['default'].createClass({

	displayName: 'Select',

	propTypes: {
		addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
		'aria-label': _react2['default'].PropTypes.string, // Aria label (for assistive tech)
		'aria-labelledby': _react2['default'].PropTypes.string, // HTML ID of an element that should be used as the label (for assistive tech)
		arrowRenderer: _react2['default'].PropTypes.func, // Create drop-down caret element
		autoBlur: _react2['default'].PropTypes.bool, // automatically blur the component when an option is selected
		autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
		autosize: _react2['default'].PropTypes.bool, // whether to enable autosizing or not
		backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _react2['default'].PropTypes.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _react2['default'].PropTypes.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _react2['default'].PropTypes.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
		deleteRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
		delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
		escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
		filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
		filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
		ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
		inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
		inputRenderer: _react2['default'].PropTypes.func, // returns a custom input component
		instanceId: _react2['default'].PropTypes.string, // set the components instanceId
		isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _react2['default'].PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
		matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
		matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
		menuBuffer: _react2['default'].PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
		menuRenderer: _react2['default'].PropTypes.func, // renders a custom menu with options
		menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
		multi: _react2['default'].PropTypes.bool, // multi-value input
		name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared on blur
		onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
		onClose: _react2['default'].PropTypes.func, // fires when the menu is closed
		onCloseResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
		onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _react2['default'].PropTypes.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _react2['default'].PropTypes.func, // fires when the menu is opened
		onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
		openAfterFocus: _react2['default'].PropTypes.bool, // boolean to enable opening dropdown when focused
		openOnFocus: _react2['default'].PropTypes.bool, // always open options menu on focus
		optionClassName: _react2['default'].PropTypes.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
		optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
		options: _react2['default'].PropTypes.array, // array of options
		pageSize: _react2['default'].PropTypes.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		required: _react2['default'].PropTypes.bool, // applies HTML5 required attribute when needed
		resetValue: _react2['default'].PropTypes.any, // value to use when you clear the control
		scrollMenuIntoView: _react2['default'].PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
		simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _react2['default'].PropTypes.object, // optional style to apply to the control
		tabIndex: _react2['default'].PropTypes.string, // optional tab index of the control
		tabSelectsValue: _react2['default'].PropTypes.bool, // whether to treat tabbing out while focused to be value selection
		value: _react2['default'].PropTypes.any, // initial field value
		valueComponent: _react2['default'].PropTypes.func, // value component to render
		valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
		valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
		wrapperStyle: _react2['default'].PropTypes.object },

	// optional style to apply to the component wrapper
	statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },

	getDefaultProps: function getDefaultProps() {
		return {
			addLabelText: 'Add "{label}"?',
			arrowRenderer: _utilsDefaultArrowRenderer2['default'],
			autosize: true,
			backspaceRemoves: true,
			backspaceToRemoveMessage: 'Press backspace to remove {label}',
			clearable: true,
			clearAllText: 'Clear all',
			clearRenderer: _utilsDefaultClearRenderer2['default'],
			clearValueText: 'Clear value',
			deleteRemoves: true,
			delimiter: ',',
			disabled: false,
			escapeClearsValue: true,
			filterOptions: _utilsDefaultFilterOptions2['default'],
			ignoreAccents: true,
			ignoreCase: true,
			inputProps: {},
			isLoading: false,
			joinValues: false,
			labelKey: 'label',
			matchPos: 'any',
			matchProp: 'any',
			menuBuffer: 0,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			multi: false,
			noResultsText: 'No results found',
			onBlurResetsInput: true,
			onCloseResetsInput: true,
			openAfterFocus: false,
			optionComponent: _Option2['default'],
			pageSize: 5,
			placeholder: 'Select...',
			required: false,
			scrollMenuIntoView: true,
			searchable: true,
			simpleValue: false,
			tabSelectsValue: true,
			valueComponent: _Value2['default'],
			valueKey: 'value'
		};
	},

	getInitialState: function getInitialState() {
		return {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
	},

	componentWillMount: function componentWillMount() {
		this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
		var valueArray = this.getValueArray(this.props.value);

		if (this.props.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], this.props.multi)
			});
		}
	},

	componentDidMount: function componentDidMount() {
		if (this.props.autofocus) {
			this.focus();
		}
	},

	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		var valueArray = this.getValueArray(nextProps.value, nextProps);

		if (nextProps.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], nextProps.multi)
			});
		}
	},

	componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
		if (nextState.isOpen !== this.state.isOpen) {
			this.toggleTouchOutsideEvent(nextState.isOpen);
			var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
			handler && handler();
		}
	},

	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		// focus to the selected option
		if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
			var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
			var menuNode = _reactDom2['default'].findDOMNode(this.menu);
			menuNode.scrollTop = focusedOptionNode.offsetTop;
			this.hasScrolledToOption = true;
		} else if (!this.state.isOpen) {
			this.hasScrolledToOption = false;
		}

		if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
			this._scrollToFocusedOptionOnUpdate = false;
			var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
			var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
			var focusedRect = focusedDOM.getBoundingClientRect();
			var menuRect = menuDOM.getBoundingClientRect();
			if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
				menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
			}
		}
		if (this.props.scrollMenuIntoView && this.menuContainer) {
			var menuContainerRect = this.menuContainer.getBoundingClientRect();
			if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
				window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
			}
		}
		if (prevProps.disabled !== this.props.disabled) {
			this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
			this.closeMenu();
		}
	},

	componentWillUnmount: function componentWillUnmount() {
		if (!document.removeEventListener && document.detachEvent) {
			document.detachEvent('ontouchstart', this.handleTouchOutside);
		} else {
			document.removeEventListener('touchstart', this.handleTouchOutside);
		}
	},

	toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
		if (enabled) {
			if (!document.addEventListener && document.attachEvent) {
				document.attachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.addEventListener('touchstart', this.handleTouchOutside);
			}
		} else {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	},

	handleTouchOutside: function handleTouchOutside(event) {
		// handle touch outside on ios to dismiss menu
		if (this.wrapper && !this.wrapper.contains(event.target)) {
			this.closeMenu();
		}
	},

	focus: function focus() {
		if (!this.input) return;
		this.input.focus();

		if (this.props.openAfterFocus) {
			this.setState({
				isOpen: true
			});
		}
	},

	blurInput: function blurInput() {
		if (!this.input) return;
		this.input.blur();
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.handleMouseDown(event);
	},

	handleTouchEndClearValue: function handleTouchEndClearValue(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Clear the value
		this.clearValue(event);
	},

	handleMouseDown: function handleMouseDown(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}

		if (event.target.tagName === 'INPUT') {
			return;
		}

		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();

		// for the non-searchable select, toggle the menu
		if (!this.props.searchable) {
			this.focus();
			return this.setState({
				isOpen: !this.state.isOpen
			});
		}

		if (this.state.isFocused) {
			// On iOS, we can get into a state where we think the input is focused but it isn't really,
			// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
			// Call focus() again here to be safe.
			this.focus();

			var input = this.input;
			if (typeof input.getInput === 'function') {
				// Get the actual DOM input if the ref is an <AutosizeInput /> component
				input = input.getInput();
			}

			// clears the value so that the cursor will be at the end of input when the component re-renders
			input.value = '';

			// if the input is focused, ensure the menu is open
			this.setState({
				isOpen: true,
				isPseudoFocused: false
			});
		} else {
			// otherwise, focus the input and open the menu
			this._openAfterFocus = true;
			this.focus();
		}
	},

	handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		// If the menu isn't open, let the event bubble to the main handleMouseDown
		if (!this.state.isOpen) {
			return;
		}
		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();
		// close the menu
		this.closeMenu();
	},

	handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();

		this._openAfterFocus = true;
		this.focus();
	},

	closeMenu: function closeMenu() {
		if (this.props.onCloseResetsInput) {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: ''
			});
		} else {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: this.state.inputValue
			});
		}
		this.hasScrolledToOption = false;
	},

	handleInputFocus: function handleInputFocus(event) {
		if (this.props.disabled) return;
		var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
		if (this.props.onFocus) {
			this.props.onFocus(event);
		}
		this.setState({
			isFocused: true,
			isOpen: isOpen
		});
		this._openAfterFocus = false;
	},

	handleInputBlur: function handleInputBlur(event) {
		// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
		if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
			this.focus();
			return;
		}

		if (this.props.onBlur) {
			this.props.onBlur(event);
		}
		var onBlurredState = {
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false
		};
		if (this.props.onBlurResetsInput) {
			onBlurredState.inputValue = '';
		}
		this.setState(onBlurredState);
	},

	handleInputChange: function handleInputChange(event) {
		var newInputValue = event.target.value;

		if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
			var nextState = this.props.onInputChange(newInputValue);
			// Note: != used deliberately here to catch undefined and null
			if (nextState != null && typeof nextState !== 'object') {
				newInputValue = '' + nextState;
			}
		}

		this.setState({
			isOpen: true,
			isPseudoFocused: false,
			inputValue: newInputValue
		});
	},

	handleKeyDown: function handleKeyDown(event) {
		if (this.props.disabled) return;

		if (typeof this.props.onInputKeyDown === 'function') {
			this.props.onInputKeyDown(event);
			if (event.defaultPrevented) {
				return;
			}
		}

		switch (event.keyCode) {
			case 8:
				// backspace
				if (!this.state.inputValue && this.props.backspaceRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			case 9:
				// tab
				if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
					return;
				}
				this.selectFocusedOption();
				return;
			case 13:
				// enter
				if (!this.state.isOpen) return;
				event.stopPropagation();
				this.selectFocusedOption();
				break;
			case 27:
				// escape
				if (this.state.isOpen) {
					this.closeMenu();
					event.stopPropagation();
				} else if (this.props.clearable && this.props.escapeClearsValue) {
					this.clearValue(event);
					event.stopPropagation();
				}
				break;
			case 38:
				// up
				this.focusPreviousOption();
				break;
			case 40:
				// down
				this.focusNextOption();
				break;
			case 33:
				// page up
				this.focusPageUpOption();
				break;
			case 34:
				// page down
				this.focusPageDownOption();
				break;
			case 35:
				// end key
				if (event.shiftKey) {
					return;
				}
				this.focusEndOption();
				break;
			case 36:
				// home key
				if (event.shiftKey) {
					return;
				}
				this.focusStartOption();
				break;
			case 46:
				// backspace
				if (!this.state.inputValue && this.props.deleteRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			default:
				return;
		}
		event.preventDefault();
	},

	handleValueClick: function handleValueClick(option, event) {
		if (!this.props.onValueClick) return;
		this.props.onValueClick(option, event);
	},

	handleMenuScroll: function handleMenuScroll(event) {
		if (!this.props.onMenuScrollToBottom) return;
		var target = event.target;

		if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
			this.props.onMenuScrollToBottom();
		}
	},

	handleRequired: function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	},

	getOptionLabel: function getOptionLabel(op) {
		return op[this.props.labelKey];
	},

	/**
  * Turns a value into an array from the given options
  * @param	{String|Number|Array}	value		- the value of the select input
  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
  * @returns	{Array}	the value of the select represented in an array
  */
	getValueArray: function getValueArray(value, nextProps) {
		var _this = this;

		/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
		var props = typeof nextProps === 'object' ? nextProps : this.props;
		if (props.multi) {
			if (typeof value === 'string') value = value.split(props.delimiter);
			if (!Array.isArray(value)) {
				if (value === null || value === undefined) return [];
				value = [value];
			}
			return value.map(function (value) {
				return _this.expandValue(value, props);
			}).filter(function (i) {
				return i;
			});
		}
		var expandedValue = this.expandValue(value, props);
		return expandedValue ? [expandedValue] : [];
	},

	/**
  * Retrieve a value from the given options and valueKey
  * @param	{String|Number|Array}	value	- the selected value(s)
  * @param	{Object}		props	- the Select component's props (or nextProps)
  */
	expandValue: function expandValue(value, props) {
		var valueType = typeof value;
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options;
		var valueKey = props.valueKey;

		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (options[i][valueKey] === value) return options[i];
		}
	},

	setValue: function setValue(value) {
		var _this2 = this;

		if (this.props.autoBlur) {
			this.blurInput();
		}
		if (!this.props.onChange) return;
		if (this.props.required) {
			var required = this.handleRequired(value, this.props.multi);
			this.setState({ required: required });
		}
		if (this.props.simpleValue && value) {
			value = this.props.multi ? value.map(function (i) {
				return i[_this2.props.valueKey];
			}).join(this.props.delimiter) : value[this.props.valueKey];
		}
		this.props.onChange(value);
	},

	selectValue: function selectValue(value) {
		var _this3 = this;

		//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
		this.hasScrolledToOption = false;
		if (this.props.multi) {
			this.setState({
				inputValue: '',
				focusedIndex: null
			}, function () {
				_this3.addValue(value);
			});
		} else {
			this.setState({
				isOpen: false,
				inputValue: '',
				isPseudoFocused: this.state.isFocused
			}, function () {
				_this3.setValue(value);
			});
		}
	},

	addValue: function addValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		var visibleOptions = this._visibleOptions.filter(function (val) {
			return !val.disabled;
		});
		var lastValueIndex = visibleOptions.indexOf(value);
		this.setValue(valueArray.concat(value));
		if (visibleOptions.length - 1 === lastValueIndex) {
			// the last option was selected; focus the second-last one
			this.focusOption(visibleOptions[lastValueIndex - 1]);
		} else if (visibleOptions.length > lastValueIndex) {
			// focus the option below the selected one
			this.focusOption(visibleOptions[lastValueIndex + 1]);
		}
	},

	popValue: function popValue() {
		var valueArray = this.getValueArray(this.props.value);
		if (!valueArray.length) return;
		if (valueArray[valueArray.length - 1].clearableValue === false) return;
		this.setValue(valueArray.slice(0, valueArray.length - 1));
	},

	removeValue: function removeValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		this.setValue(valueArray.filter(function (i) {
			return i !== value;
		}));
		this.focus();
	},

	clearValue: function clearValue(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, ignore it.
		if (event && event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();
		this.setValue(this.getResetValue());
		this.setState({
			isOpen: false,
			inputValue: ''
		}, this.focus);
	},

	getResetValue: function getResetValue() {
		if (this.props.resetValue !== undefined) {
			return this.props.resetValue;
		} else if (this.props.multi) {
			return [];
		} else {
			return null;
		}
	},

	focusOption: function focusOption(option) {
		this.setState({
			focusedOption: option
		});
	},

	focusNextOption: function focusNextOption() {
		this.focusAdjacentOption('next');
	},

	focusPreviousOption: function focusPreviousOption() {
		this.focusAdjacentOption('previous');
	},

	focusPageUpOption: function focusPageUpOption() {
		this.focusAdjacentOption('page_up');
	},

	focusPageDownOption: function focusPageDownOption() {
		this.focusAdjacentOption('page_down');
	},

	focusStartOption: function focusStartOption() {
		this.focusAdjacentOption('start');
	},

	focusEndOption: function focusEndOption() {
		this.focusAdjacentOption('end');
	},

	focusAdjacentOption: function focusAdjacentOption(dir) {
		var options = this._visibleOptions.map(function (option, index) {
			return { option: option, index: index };
		}).filter(function (option) {
			return !option.option.disabled;
		});
		this._scrollToFocusedOptionOnUpdate = true;
		if (!this.state.isOpen) {
			this.setState({
				isOpen: true,
				inputValue: '',
				focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
			});
			return;
		}
		if (!options.length) return;
		var focusedIndex = -1;
		for (var i = 0; i < options.length; i++) {
			if (this._focusedOption === options[i].option) {
				focusedIndex = i;
				break;
			}
		}
		if (dir === 'next' && focusedIndex !== -1) {
			focusedIndex = (focusedIndex + 1) % options.length;
		} else if (dir === 'previous') {
			if (focusedIndex > 0) {
				focusedIndex = focusedIndex - 1;
			} else {
				focusedIndex = options.length - 1;
			}
		} else if (dir === 'start') {
			focusedIndex = 0;
		} else if (dir === 'end') {
			focusedIndex = options.length - 1;
		} else if (dir === 'page_up') {
			var potentialIndex = focusedIndex - this.props.pageSize;
			if (potentialIndex < 0) {
				focusedIndex = 0;
			} else {
				focusedIndex = potentialIndex;
			}
		} else if (dir === 'page_down') {
			var potentialIndex = focusedIndex + this.props.pageSize;
			if (potentialIndex > options.length - 1) {
				focusedIndex = options.length - 1;
			} else {
				focusedIndex = potentialIndex;
			}
		}

		if (focusedIndex === -1) {
			focusedIndex = 0;
		}

		this.setState({
			focusedIndex: options[focusedIndex].index,
			focusedOption: options[focusedIndex].option
		});
	},

	getFocusedOption: function getFocusedOption() {
		return this._focusedOption;
	},

	getInputValue: function getInputValue() {
		return this.state.inputValue;
	},

	selectFocusedOption: function selectFocusedOption() {
		if (this._focusedOption) {
			return this.selectValue(this._focusedOption);
		}
	},

	renderLoading: function renderLoading() {
		if (!this.props.isLoading) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
			_react2['default'].createElement('span', { className: 'Select-loading' })
		);
	},

	renderValue: function renderValue(valueArray, isOpen) {
		var _this4 = this;

		var renderLabel = this.props.valueRenderer || this.getOptionLabel;
		var ValueComponent = this.props.valueComponent;
		if (!valueArray.length) {
			return !this.state.inputValue ? _react2['default'].createElement(
				'div',
				{ className: 'Select-placeholder' },
				this.props.placeholder
			) : null;
		}
		var onClick = this.props.onValueClick ? this.handleValueClick : null;
		if (this.props.multi) {
			return valueArray.map(function (value, i) {
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: _this4._instancePrefix + '-value-' + i,
						instancePrefix: _this4._instancePrefix,
						disabled: _this4.props.disabled || value.clearableValue === false,
						key: 'value-' + i + '-' + value[_this4.props.valueKey],
						onClick: onClick,
						onRemove: _this4.removeValue,
						value: value
					},
					renderLabel(value, i),
					_react2['default'].createElement(
						'span',
						{ className: 'Select-aria-only' },
						' '
					)
				);
			});
		} else if (!this.state.inputValue) {
			if (isOpen) onClick = null;
			return _react2['default'].createElement(
				ValueComponent,
				{
					id: this._instancePrefix + '-value-item',
					disabled: this.props.disabled,
					instancePrefix: this._instancePrefix,
					onClick: onClick,
					value: valueArray[0]
				},
				renderLabel(valueArray[0])
			);
		}
	},

	renderInput: function renderInput(valueArray, focusedOptionIndex) {
		var _classNames,
		    _this5 = this;

		var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
		var isOpen = !!this.state.isOpen;

		var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

		// TODO: Check how this project includes Object.assign()
		var inputProps = _extends({}, this.props.inputProps, {
			role: 'combobox',
			'aria-expanded': '' + isOpen,
			'aria-owns': ariaOwns,
			'aria-haspopup': '' + isOpen,
			'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
			'aria-labelledby': this.props['aria-labelledby'],
			'aria-label': this.props['aria-label'],
			className: className,
			tabIndex: this.props.tabIndex,
			onBlur: this.handleInputBlur,
			onChange: this.handleInputChange,
			onFocus: this.handleInputFocus,
			ref: function ref(_ref) {
				return _this5.input = _ref;
			},
			required: this.state.required,
			value: this.state.inputValue
		});

		if (this.props.inputRenderer) {
			return this.props.inputRenderer(inputProps);
		}

		if (this.props.disabled || !this.props.searchable) {
			var _props$inputProps = this.props.inputProps;
			var inputClassName = _props$inputProps.inputClassName;

			var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

			return _react2['default'].createElement('div', _extends({}, divProps, {
				role: 'combobox',
				'aria-expanded': isOpen,
				'aria-owns': isOpen ? this._instancePrefix + '-list' : this._instancePrefix + '-value',
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				className: className,
				tabIndex: this.props.tabIndex || 0,
				onBlur: this.handleInputBlur,
				onFocus: this.handleInputFocus,
				ref: function (ref) {
					return _this5.input = ref;
				},
				'aria-readonly': '' + !!this.props.disabled,
				style: { border: 0, width: 1, display: 'inline-block' } }));
		}

		if (this.props.autosize) {
			return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
		}
		return _react2['default'].createElement(
			'div',
			{ className: className },
			_react2['default'].createElement('input', inputProps)
		);
	},

	renderClear: function renderClear() {
		if (!this.props.clearable || !this.props.value || this.props.value === 0 || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
		var clear = this.props.clearRenderer();

		return _react2['default'].createElement(
			'span',
			{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				onMouseDown: this.clearValue,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEndClearValue
			},
			clear
		);
	},

	renderArrow: function renderArrow() {
		var onMouseDown = this.handleMouseDownOnArrow;
		var isOpen = this.state.isOpen;
		var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

		return _react2['default'].createElement(
			'span',
			{
				className: 'Select-arrow-zone',
				onMouseDown: onMouseDown
			},
			arrow
		);
	},

	filterOptions: function filterOptions(excludeOptions) {
		var filterValue = this.state.inputValue;
		var options = this.props.options || [];
		if (this.props.filterOptions) {
			// Maintain backwards compatibility with boolean attribute
			var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];

			return filterOptions(options, filterValue, excludeOptions, {
				filterOption: this.props.filterOption,
				ignoreAccents: this.props.ignoreAccents,
				ignoreCase: this.props.ignoreCase,
				labelKey: this.props.labelKey,
				matchPos: this.props.matchPos,
				matchProp: this.props.matchProp,
				valueKey: this.props.valueKey
			});
		} else {
			return options;
		}
	},

	onOptionRef: function onOptionRef(ref, isFocused) {
		if (isFocused) {
			this.focused = ref;
		}
	},

	renderMenu: function renderMenu(options, valueArray, focusedOption) {
		if (options && options.length) {
			return this.props.menuRenderer({
				focusedOption: focusedOption,
				focusOption: this.focusOption,
				instancePrefix: this._instancePrefix,
				labelKey: this.props.labelKey,
				onFocus: this.focusOption,
				onSelect: this.selectValue,
				optionClassName: this.props.optionClassName,
				optionComponent: this.props.optionComponent,
				optionRenderer: this.props.optionRenderer || this.getOptionLabel,
				options: options,
				selectValue: this.selectValue,
				valueArray: valueArray,
				valueKey: this.props.valueKey,
				onOptionRef: this.onOptionRef
			});
		} else if (this.props.noResultsText) {
			return _react2['default'].createElement(
				'div',
				{ className: 'Select-noresults' },
				this.props.noResultsText
			);
		} else {
			return null;
		}
	},

	renderHiddenField: function renderHiddenField(valueArray) {
		var _this6 = this;

		if (!this.props.name) return;
		if (this.props.joinValues) {
			var value = valueArray.map(function (i) {
				return stringifyValue(i[_this6.props.valueKey]);
			}).join(this.props.delimiter);
			return _react2['default'].createElement('input', {
				type: 'hidden',
				ref: function (ref) {
					return _this6.value = ref;
				},
				name: this.props.name,
				value: value,
				disabled: this.props.disabled });
		}
		return valueArray.map(function (item, index) {
			return _react2['default'].createElement('input', { key: 'hidden.' + index,
				type: 'hidden',
				ref: 'value' + index,
				name: _this6.props.name,
				value: stringifyValue(item[_this6.props.valueKey]),
				disabled: _this6.props.disabled });
		});
	},

	getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
		var options = this._visibleOptions;
		if (!options.length) return null;

		var focusedOption = this.state.focusedOption || selectedOption;
		if (focusedOption && !focusedOption.disabled) {
			var focusedOptionIndex = options.indexOf(focusedOption);
			if (focusedOptionIndex !== -1) {
				return focusedOptionIndex;
			}
		}

		for (var i = 0; i < options.length; i++) {
			if (!options[i].disabled) return i;
		}
		return null;
	},

	renderOuter: function renderOuter(options, valueArray, focusedOption) {
		var _this7 = this;

		var menu = this.renderMenu(options, valueArray, focusedOption);
		if (!menu) {
			return null;
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this7.menuContainer = ref;
				}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menu = ref;
					}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
					style: this.props.menuStyle,
					onScroll: this.handleMenuScroll,
					onMouseDown: this.handleMouseDownOnMenu },
				menu
			)
		);
	},

	render: function render() {
		var _this8 = this;

		var valueArray = this.getValueArray(this.props.value);
		var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
		var isOpen = this.state.isOpen;
		if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
		var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

		var focusedOption = null;
		if (focusedOptionIndex !== null) {
			focusedOption = this._focusedOption = options[focusedOptionIndex];
		} else {
			focusedOption = this._focusedOption = null;
		}
		var className = (0, _classnames2['default'])('Select', this.props.className, {
			'Select--multi': this.props.multi,
			'Select--single': !this.props.multi,
			'is-disabled': this.props.disabled,
			'is-focused': this.state.isFocused,
			'is-loading': this.props.isLoading,
			'is-open': isOpen,
			'is-pseudo-focused': this.state.isPseudoFocused,
			'is-searchable': this.props.searchable,
			'has-value': valueArray.length
		});

		var removeMessage = null;
		if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
			removeMessage = _react2['default'].createElement(
				'span',
				{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
				this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
			);
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this8.wrapper = ref;
				},
				className: className,
				style: this.props.wrapperStyle },
			this.renderHiddenField(valueArray),
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.control = ref;
					},
					className: 'Select-control',
					style: this.props.style,
					onKeyDown: this.handleKeyDown,
					onMouseDown: this.handleMouseDown,
					onTouchEnd: this.handleTouchEnd,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove
				},
				_react2['default'].createElement(
					'span',
					{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
					this.renderValue(valueArray, isOpen),
					this.renderInput(valueArray, focusedOptionIndex)
				),
				removeMessage,
				this.renderLoading(),
				this.renderClear(),
				this.renderArrow()
			),
			isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
		);
	}

});

exports['default'] = Select;
module.exports = exports['default'];

/***/ }),
/* 334 */,
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(67),
    noop = _require.noop;

/**
 * Base class for carousel "view-models". Defines the interface that derived classes must implement. It is expected that
 * wrapper carousels will be implemented that actually construct the model and pass it into the base carousel. The
 * `onMount` method should be called in the base carousel's `componentDidMount` lifecycle callback and `destroy` should
 * be called in the `componentWillUnmount` lifecycle callback. Derived classes should be aware that the `_el` property
 * will not be available the first time the style transformation methods are called so they should provide a default
 * style that does not depend on the el.
 * @class BaseModel
 */


var BaseModel = function () {
  function BaseModel() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$onStateChange = _ref.onStateChange,
        onStateChange = _ref$onStateChange === undefined ? noop : _ref$onStateChange;

    _classCallCheck(this, BaseModel);

    Object.assign(this, {
      _el: null,
      _onStateChange: onStateChange,
      _state: {}
    });
  }

  /**
   * Pass in the DOM element to manage. This should be a raw DOM element and not a React or jQuery object. The reason
   * the element cannot be passed into the constructor is that initial construction is meant to take place outside of
   * the base carousel but the element is only accessible after construction, once the base carousel has been rendered
   * for the first time. It is possible the "view-model" doesn't need to do anything with the element in which case
   * the `_el` property can be ignored.
   * @param  {Object} el DOM element to manage.
   */


  _createClass(BaseModel, [{
    key: 'onMount',
    value: function onMount(el) {
      if (!el) {
        throw new Error('Must pass `el` to carousel model on mount.');
      }

      this._el = el;
      this._afterMount();
    }

    /**
     * Call the state change callback with the current state.
     * @private
     */

  }, {
    key: '_updateState',
    value: function _updateState() {
      this._onStateChange(this._state);
    }

    /**
     * Return the current state.
     * @return {[type]} [description]
     */

  }, {
    key: 'getState',
    value: function getState() {
      return this._state;
    }

    /**
     * Do any cleanup necessary to avoid memory leaks, e.g. removing event listeners from the passed in element.
     * @abstract
     */

  }, {
    key: 'destroy',
    value: function destroy() {}

    /**
     * Modify the styles object for the carousel `ul`. This gets called before a re-render of the carousel.
     * @param  {Object} style Style object to mutate for the carousel `el`.
     * @abstract
     */

  }, {
    key: 'transformListStyle',
    value: function transformListStyle(style) {} // eslint-disable-line no-unused-vars

    /**
     * Modify the styles object for the carousel item `li`s. This gets called before a re-render of the carousel.
     * @param  {Object} style Style object to mutate for each carousel item `li`.
     * @param  {Number} i The index of the item.
     * @abstract
     */

  }, {
    key: 'transformItemStyle',
    value: function transformItemStyle(style, i) {} // eslint-disable-line no-unused-vars

    /**
     * Custom logic after an element is passed in `onMount`, e.g. adding event listeners on the element.
     * @abstract
     * @private
     */

  }, {
    key: '_afterMount',
    value: function _afterMount() {}
  }]);

  return BaseModel;
}();

module.exports = BaseModel;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ItemStore$handlers;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ = __webpack_require__(23);
var Qs = __webpack_require__(42);
// Todo: Remove SV dependency
var SV = __webpack_require__(17);
var BaseStore = __webpack_require__(13);
var Item = __webpack_require__(554);
var Price = __webpack_require__(66);
var detailsConfig = __webpack_require__(897);
var detailsHelpers = __webpack_require__(900);
var shard = __webpack_require__(658);
var tokenReplace = __webpack_require__(75);
var get = __webpack_require__(14);
var detailsConstants = __webpack_require__(507);
var enabler = __webpack_require__(63);
var loginActions = __webpack_require__(603);
var currencyActionConstants = __webpack_require__(287);

/** @type {string[]} */
var KEY_FIELDS = ['pieces', 'pricing', 'actions', 'returnPolicy', 'lowestShipmentQuote', // graphql response, gets transformed to shipmentQuotes to populate model properly
'status', 'title', 'activeHold'];

var ItemStore = function (_BaseStore) {
    _inherits(ItemStore, _BaseStore);

    function ItemStore(dispatcher) {
        _classCallCheck(this, ItemStore);

        var _this = _possibleConstructorReturn(this, (ItemStore.__proto__ || Object.getPrototypeOf(ItemStore)).call(this, dispatcher));

        _this._asyncItemData = {};

        _this.item = new Item();

        // Some components manipulate the Item model directly and could cause data for the entire page to change.
        // Creating clone to avoid inadvertent manipulations to the item model from components
        // Todo: Do not pass Item to components, instead pass properties that they need via store getters
        _this.itemClone = _this.item.clone();

        /**
         * Item needs to be ajaxed in on the client to avoid displaying stale price information
         * @type {boolean}
         */
        _this.isAsyncItemLoaded = false;

        /**
         * {object} detailsTitles
         * {object} detailsTitles.[vertical]
         * {string} detailsTitles.[vertical].[detail name] - title for that detail
         */
        _this.detailsTitles = {};

        /**
         * {object} detailLinks                                              - the links available for the pdp's details
         * {object} detailLinks.[type of detail]                             - the type of detail (creator, condition, etc.).
         *                                                                     the object contains the links available for that type of detail.
         * {string} detailLinks.[type of detail].[display string for detail] - what will appear on the page for that type of
         *                                                                     detail. the string is the link for what will appear.
         * ie : {
         *          creator: {
         *              'Tomaso Buzzi': '/creators/tomaso-buzzi/furniture/'
         *          }
         *      }
         */
        _this.detailLinks = {};

        /**
         * {string} detailTechniques - display data for the material notes detail
         */
        _this.detailTechniques = '';

        /**
         * {object} creatorRoleReferences                             - reference set for creator roles
         * {object} creatorRoleReferences.[creator name]
         * {string} creatorRoleReferences.[creator name].key
         * {string} creatorRoleReferences.[creator name].type
         * {string} creatorRoleReferences.[creator name].displayName
         * {string} creatorRoleReferences.[creator name].enumName
         * {string} creatorRoleReferences.[creator name].nonUniqueName
         */
        _this.creatorRoleReferences = {};

        /**
         * {object} periodReferences - reference set for jewelry periods
         * {object} periodReferences.[period name]
         * {string} periodReferences.[period name].key
         * {string} periodReferences.[period name].type
         * {string} periodReferences.[period name].displayName
         * {string} periodReferences.[period name].enumName
         * {string} periodReferences.[period name].nonUniqueName
         *
         * ie: {
         *         ART_DECO: {
         *                       displayName: 'Art Deco',
         *                       key: 'JPDDECO'
         *                   }
         *     }
         */
        _this.periodReferences = {};

        /**
         * {object} conditionReferences                                - reference set for conditions
         * {object} conditionReferences.[condition name]
         * {string} conditionReferences.[condition name].key
         * {string} conditionReferences.[condition name].type
         * {string} conditionReferences.[condition name].displayName
         * {string} conditionReferences.[condition name].enumName
         * {string} conditionReferences.[condition name].nonUniqueName
         *
         * ie: {
         *         EXCELLENT: {
         *                        displayName: 'Excellent',
         *                        key: 'FCNDXLNT'
         *                    }
         *     }
         */
        _this.conditionReferences = {};

        _this.returnsCopy = {};
        _this.breadcrumbs = {};
        _this.goodRelationsMeta = {};
        _this.pageData = {};
        _this.copy = {};
        _this.tradeReturnsEnabled = enabler.isEnabled('trade_returns_enabled');
        _this._canUserRequestNetPrice = false;
        _this._attributes = null;
        return _this;
    }

    _createClass(ItemStore, [{
        key: '_handleBootstrap',
        value: function _handleBootstrap(_ref) {
            var breadcrumbs = _ref.breadcrumbs,
                creatorRoleReferences = _ref.creatorRoleReferences,
                conditionReferences = _ref.conditionReferences,
                copy = _ref.copy,
                detailLinks = _ref.detailLinks,
                detailTechniques = _ref.detailTechniques,
                shouldShowSuspended = _ref.shouldShowSuspended,
                detailsTitles = _ref.detailsTitles,
                goodRelationsMeta = _ref.goodRelationsMeta,
                pageData = _ref.pageData,
                periodReferences = _ref.periodReferences,
                rawResult = _ref.rawResult,
                returnsCopy = _ref.returnsCopy,
                tradeReturnsEnabled = _ref.tradeReturnsEnabled,
                urlData = _ref.urlData;


            // Async Item data takes precedence; default to cached Item data from `payload`
            var data = Object.assign({}, rawResult, this._asyncItemData);
            this.item = new Item(data);
            this.itemClone = this.item.clone();

            this.breadcrumbs = breadcrumbs;
            this.creatorRoleReferences = creatorRoleReferences;
            this.conditionReferences = conditionReferences;
            this.copy = copy;
            this.detailLinks = detailLinks;
            this.detailTechniques = detailTechniques;
            this.detailsTitles = detailsTitles;
            this.goodRelationsMeta = goodRelationsMeta;
            this.pageData = pageData;
            this.periodReferences = periodReferences;
            this.returnsCopy = returnsCopy;
            this.tradeReturnsEnabled = tradeReturnsEnabled;
            this.urlData = urlData;
            this.shouldShowSuspended = shouldShowSuspended;
            this._attributes = data.attributes;

            if (this.getIsPreview()) {
                this.isAsyncItemLoaded = true;
                this.emitChange();
            }
        }
    }, {
        key: '_handleAsyncLoadItem',
        value: function _handleAsyncLoadItem() {
            var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var json = item.json;
            if (json) {
                var data = this.item.parse(json);

                // `pick` key properties to avoid polluting model with incomplete data
                data = _.pick(data, KEY_FIELDS);

                // graphql response provides a `lowestShipmentQuote` field
                if (data.lowestShipmentQuote) {
                    data.shipmentQuotes = data.lowestShipmentQuote;
                    delete data.lowestShipmentQuote;
                }

                this._asyncItemData = data;
                this.item.set(data);
                this.itemClone = this.item.clone();
            }

            // Always set to `true` regardless if json is defined to allow components to render with cached Item data
            this.isAsyncItemLoaded = true;
            this.emitChange();
        }
    }, {
        key: '_updateCurrency',
        value: function _updateCurrency(_ref2) {
            var currency = _ref2.currency;

            if (currency && this._currency !== currency) {
                this._currency = currency;
                this.emit('change');
            }
        }
    }, {
        key: '_updateNetPriceStatus',
        value: function _updateNetPriceStatus(_ref3) {
            var userCanRequestNetPrice = _ref3.userCanRequestNetPrice;

            this._canUserRequestNetPrice = userCanRequestNetPrice;
        }
    }, {
        key: 'getVpvParams',
        value: function getVpvParams() {
            var isTradeUser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var shipmentQuotes = this.itemClone.get('shipmentQuotes');
            var hasPreQuoteShipping = shipmentQuotes && shipmentQuotes.getNonLocalShipmentQuotes().length;
            var vpvParams = {
                dd: this.itemClone.get('seller.id'),
                dn: this.itemClone.get('seller.sellerProfile.company'),
                id: this.itemClone.get('id'),
                status: this._getStatus(isTradeUser),
                pur: this.itemClone.canMakePurchase() ? 'y' : 'n',
                neg: this.isNegotiablePrice() ? 'y' : 'n',
                ship: hasPreQuoteShipping ? 'y' : 'n',
                ret: _.result(this.itemClone.get('returnPolicy'), 'accepts') ? 'y' : 'n'
            };
            return decodeURIComponent(Qs.stringify(vpvParams).toLowerCase());
        }
    }, {
        key: '_getStatus',
        value: function _getStatus() {
            var isTradeUser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var item = this.itemClone;
            var seller = item.get('seller');
            var isNetPrice = !!item.getPriceByType('NET');
            var status = 'Available-Price';
            if (seller.isStatusSuspended() || item.isDeletedStatus()) {
                status = 'Suspended';
            } else if (item.isOnHold()) {
                status = 'Hold';
            } else if (item.isSold()) {
                status = 'Sold';
            } else if (isNetPrice && isTradeUser) {
                status = 'Available-Net Price';
            } else if (item.hidingPrice()) {
                status = 'Available-No Price';
            }
            return 'PDP-' + status;
        }

        // Todo: Do not pass Item to components, instead pass properties that they need via store getters
        /** @deprecated */

    }, {
        key: 'getItem',
        value: function getItem() {
            return this.itemClone;
        }
    }, {
        key: 'getPrice',
        value: function getPrice() {
            return this.getPriceByCurrency(Price.TYPE_RETAIL, this._currency);
        }
    }, {
        key: 'getInitialPrice',
        value: function getInitialPrice() {
            var originalPriceLock = this.item.getPriceLocksByType('ORIGINAL_PRICE');
            var originalPrice = originalPriceLock ? originalPriceLock.get('price.amount.convertedAmounts') : null;

            if (originalPrice) {
                return originalPrice.get(this._currency);
            }

            return null;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'getCategoryOrdinalNumber',
        value: function getCategoryOrdinalNumber() {
            var urls = this.item.getPdpUrls() || [];
            var urlData = this.getUrlData();
            var nth = 1;
            var i = 0;

            while (i < urls.length) {

                if (urls[i] === urlData.path) {
                    nth = i + 1;
                    break;
                }
                i++;
            }
            return nth;
        }
    }, {
        key: 'getItemCategories',
        value: function getItemCategories() {
            return this.item.getItemCategories();
        }
    }, {
        key: 'getItemCategoryGroup',
        value: function getItemCategoryGroup() {
            var nth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCategoryOrdinalNumber();

            return this.getItemCategories().findCategoryByPrecedence(nth);
        }

        /** * @deprecated */

    }, {
        key: 'getCategories',
        value: function getCategories() {
            return this.item.getCategories();
        }
    }, {
        key: 'getHidePrice',
        value: function getHidePrice() {
            return this.item.isPriceHidden();
        }
    }, {
        key: 'getCanMakePurchase',
        value: function getCanMakePurchase() {
            return this.item.canMakePurchase();
        }
    }, {
        key: 'getCreatorData',
        value: function getCreatorData() {
            var creator = this.getFromSV('item.creators.crea.creator_name.0');
            var result = { name: '', uri: '' };

            if (creator) {
                result.name = creator.name;
                result.link = creator.link;
            }

            return result;
        }
    }, {
        key: 'getCreator',
        value: function getCreator() {
            return this.item.getCreator();
        }
    }, {
        key: 'getPriceByCurrency',
        value: function getPriceByCurrency(type, currency) {
            return this.item.getPriceIn(type, currency);
        }
    }, {
        key: 'getIsArt',
        value: function getIsArt() {
            return this.item.isArt();
        }
    }, {
        key: 'getDetailsConfig',
        value: function getDetailsConfig() {
            var vertical = this.getFromItemModel('vertical');
            return detailsConfig[vertical];
        }
    }, {
        key: 'isNegotiablePrice',
        value: function isNegotiablePrice() {
            return this.item.isNegotiablePriceByType(Price.TYPE_RETAIL);
        }
    }, {
        key: 'isTradeReturnsEnabled',
        value: function isTradeReturnsEnabled() {
            return this.tradeReturnsEnabled;
        }

        /**
         * Grabs a set of helpers, based on the item's vertical, and uses those
         * helpers to calculate the pdp's details. Copy for the details titles
         * is not determined in these helpers. This method returns only the
         * information that will appear under a detail's title.
         * @returns {Object} - keys are the type of detail, ie: 'creator'
         *                     values are arrays that contain other arrays or objects in the format needed by the
         *                     component that will render them. see documentation for a specific
         *                     detail helper to find the format for that detail.
         */

    }, {
        key: 'getDetails',
        value: function getDetails() {
            var _this2 = this;

            var vertical = this.getFromItemModel('vertical');
            var helpers = detailsHelpers.getHelpers(vertical);
            var details = {};

            _.each(helpers, function (helper, key) {
                var data = helper({
                    item: _this2.item,
                    links: _this2.detailLinks,
                    creatorRoleReferences: _this2.creatorRoleReferences,
                    periodReferences: _this2.periodReferences,
                    conditionReferences: _this2.conditionReferences,
                    currency: _this2._currency,
                    detailTechniques: _this2.detailTechniques,
                    copy: _this2.copy
                });
                if (!_.isEmpty(data)) {
                    details[key] = data;
                }
            });
            return details;
        }
    }, {
        key: 'getDetailsTitles',
        value: function getDetailsTitles() {
            return this.detailsTitles;
        }
    }, {
        key: 'getDealerData',
        value: function getDealerData() {
            if (!this.dealer) {
                var dealer = _.clone(this.getFromSV('item.dealer'));
                // FINDING-6978 dealer logo does NOT return the cdn domain with the image
                dealer.logo = shard.getUrl(dealer.logo, this.getFromSV('settings.imagesHosts'));
                dealer.sinceYear = dealer.since_year;
                dealer.urlLabel = dealer.url_label;
                // Determine if this is a "dealer" or a "gallery".
                dealer.type = this.getFromSV('copy.dealer_info.title').toLowerCase();

                // clean up response data so consistent properties are used
                dealer.url_label = undefined; // eslint-disable-line camelcase
                dealer.since_year = undefined; // eslint-disable-line camelcase

                dealer.dealerReferenceTitle = get(this.detailsTitles, detailsConstants.title.dealerReference);
                dealer.dealerReferenceNumber = this.item.get('dealerReference');
                this.dealer = dealer;
            }
            return this.dealer;
        }
    }, {
        key: 'getUrl',
        value: function getUrl() {
            return document.URL;
        }
    }, {
        key: 'getUrlData',
        value: function getUrlData() {
            return this.urlData;
        }
    }, {
        key: 'getSoldIndividually',
        value: function getSoldIndividually() {
            var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (typeof model.isSoldIndividually === 'function') {
                return model.isSoldIndividually();
            }
            return this.item.soldIndividually();
        }
    }, {
        key: 'getIsOnHold',
        value: function getIsOnHold() {
            return this.item.isOnHold();
        }
    }, {
        key: 'getIsSold',
        value: function getIsSold() {
            // both of these conditions must stay combined together:
            // 1. (itemModel.isSold && SV.data.isSold)
            // 2. (itemModel.get('status.isCompleteStatus') === 'N' && shouldShowSuspended)
            // If #2 uses an OR operator, then shit breaks and doesn't show the price
            // b/c for whatever reason, it seems like a lot of itemModel status.isCompleteStatus === 'N'
            // even if they are on a category search page
            // Sold (using sold template) or suspended flow
            return this.item.isSold() && this.getFromSV('data.isSold') || !this.item.isCompleteStatus() && this.getShouldShowSuspended();
        }
    }, {
        key: 'getIsUnlisted',
        value: function getIsUnlisted() {
            return this.getFromSV('data.isUnlisted');
        }
    }, {
        key: 'getShouldShowSuspended',
        value: function getShouldShowSuspended() {
            return this.shouldShowSuspended;
        }
    }, {
        key: 'getSocialData',
        value: function getSocialData() {
            if (!this.socialData) {
                // FINDING-6978 no longer need to use shard for images
                this.socialData = _.clone(this.getFromSV('pdpSocialData'));
            }

            return this.socialData;
        }
    }, {
        key: 'getReturnsCopyFormatted',
        value: function getReturnsCopyFormatted(vertical) {
            var copy = Object.assign({}, this.returnsCopy);
            var verticalOverrides = copy.verticalOverrides;

            if (vertical && verticalOverrides && verticalOverrides[vertical]) {
                Object.assign(copy, verticalOverrides[vertical]);
            }

            return _.object(_.map(copy, function (text, key) {
                if (typeof text !== "string") {
                    return text;
                }
                return [key, tokenReplace(text, copy, '%')];
            }));
        }
    }, {
        key: 'getSupportCopy',
        value: function getSupportCopy() {
            return this.copy.support;
        }
    }, {
        key: 'getReturnMessage',
        value: function getReturnMessage() {
            var returnPolicy = this.getFromItemModel('returnPolicy');
            var vertical = this.getFromItemModel('vertical');
            var isTradeReturnAvailable = this.isTradeReturnAvailable();
            var returnMessage = void 0;

            if (!(returnPolicy && vertical)) {
                return returnMessage;
            }

            var acceptsReturns = returnPolicy.acceptsReturns();
            var notifyDays = returnPolicy.get('notifyDays');
            var copyFormatted = this.getReturnsCopyFormatted(vertical);

            if (!acceptsReturns) {
                if (isTradeReturnAvailable) {
                    return get(this, 'returnsCopy.tradeReturns.pdp.cannotBeReturned');
                }
                return this.returnsCopy.cannotBeReturned;
            }

            if (acceptsReturns && notifyDays) {
                returnMessage = notifyDays === 1 ? copyFormatted.returnsAcceptedSingular : copyFormatted.returnsAcceptedPlural;
                returnMessage = returnMessage.replace('%s', notifyDays);
            }

            if (isTradeReturnAvailable) {
                returnMessage = returnMessage + ' ' + get(this, 'returnsCopy.tradeReturns.pdp.returnsAccepted');
            }

            return returnMessage;
        }
    }, {
        key: 'isTradeReturnAvailable',
        value: function isTradeReturnAvailable() {
            var enabled = this.isTradeReturnsEnabled();
            var tradeBuyer = this._canUserRequestNetPrice;
            return enabled && tradeBuyer && this.item.isTradeReturnAvailable();
        }
    }, {
        key: 'getBreadcrumbs',
        value: function getBreadcrumbs() {
            return this.breadcrumbs;
        }
    }, {
        key: 'getGoodRelationsMeta',
        value: function getGoodRelationsMeta() {
            return this.goodRelationsMeta;
        }
    }, {
        key: 'getCopy',
        value: function getCopy() {
            return this.copy;
        }
    }, {
        key: 'getPageData',
        value: function getPageData() {
            return this.pageData || {};
        }
    }, {
        key: 'getFromSV',
        value: function getFromSV(key) {
            return SV.get(key);
        }
    }, {
        key: 'getFromItemModel',
        value: function getFromItemModel(key) {
            return this.item.get(key);
        }
    }, {
        key: 'getIsAsyncItemLoaded',
        value: function getIsAsyncItemLoaded() {
            return this.isAsyncItemLoaded;
        }
    }, {
        key: 'getIsPreview',
        value: function getIsPreview() {
            return this.getPageData().isPreview;
        }
    }, {
        key: 'getAttribute',
        value: function getAttribute(attribute) {
            return get(this._attributes, attribute) || null;
        }
    }, {
        key: 'getCustomizationNote',
        value: function getCustomizationNote() {
            return this.getAttribute('customizable[0].text') || '';
        }
    }]);

    return ItemStore;
}(BaseStore);

ItemStore.storeName = 'ItemStore';

ItemStore.handlers = (_ItemStore$handlers = {
    'BOOTSTRAP_ITEM_STORE': '_handleBootstrap',
    'ASYNC_LOAD_ITEM': '_handleAsyncLoadItem'
}, _defineProperty(_ItemStore$handlers, currencyActionConstants.CURRENCY_CHANGED, '_updateCurrency'), _defineProperty(_ItemStore$handlers, loginActions.ACTION_NET_PRICE, '_updateNetPriceStatus'), _ItemStore$handlers);

module.exports = ItemStore;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint react/no-did-update-set-state: 0 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var classNames = __webpack_require__(2);
	var lodashDebounce = __webpack_require__(3);
	var styles = __webpack_require__(4);
	
	var oppositeDirections = {
	    top: 'bottom',
	    bottom: 'top',
	    left: 'right',
	    right: 'left'
	};
	
	function getWindowBounds() {
	    return {
	        top: 0,
	        left: 0,
	        right: window.innerWidth,
	        bottom: window.innerHeight
	    };
	}
	
	function getHalfDimensions(element) {
	    return function (type) {
	        if (element.width && type === 'width') {
	            return element.width / 2;
	        }
	        if (element.height && type === 'height') {
	            return element.height / 2;
	        }
	        return 0;
	    };
	}
	
	var Tooltip = function (_React$Component) {
	    _inherits(Tooltip, _React$Component);
	
	    function Tooltip(props) {
	        _classCallCheck(this, Tooltip);
	
	        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	        _this.state = {
	            top: 0,
	            left: 0,
	            moved: false,
	            flippedFrom: null,
	            tooltipDirection: props.tooltipDirection,
	            isVisible: props.isVisible
	        };
	        return _this;
	    }
	
	    _createClass(Tooltip, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.isVisible) {
	                this._adjustPosition();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.props.isVisible && nextProps.isVisible) {
	                this.setState({
	                    tooltipDirection: nextProps.tooltipDirection || this.state.tooltipDirection
	                });
	            }
	
	            this.setState({
	                isVisible: nextProps.isVisible
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var _state = this.state,
	                isVisible = _state.isVisible,
	                moved = _state.moved;
	            var debounce = this.props.debounce;
	
	            var adjustPositionDebounced = lodashDebounce(this._adjustPosition, debounce).bind(this);
	            var shouldAdjust = isVisible && !moved;
	
	            if (shouldAdjust && debounce) {
	                adjustPositionDebounced();
	            } else if (shouldAdjust) {
	                this._adjustPosition();
	            } else if (!isVisible && moved) {
	                // make sure the position gets adjusted next time the tooltip is opened
	                this.setState({
	                    moved: false,
	                    flippedFrom: null
	                });
	            }
	        }
	    }, {
	        key: '_getInitialTooltipPosition',
	        value: function _getInitialTooltipPosition(elementRect, tooltipDirection, rootRect) {
	            var _props = this.props,
	                hasTriangle = _props.hasTriangle,
	                triangleSize = _props.triangleSize;
	
	            var triangleSpacing = hasTriangle ? triangleSize : triangleSize / 2;
	
	            var elementDimensions = getHalfDimensions(elementRect);
	            var rootDimensions = getHalfDimensions(rootRect);
	
	            var elementHalfWidth = elementDimensions('width');
	            var elementHalfHeight = elementDimensions('height');
	            var rootHalfWidth = rootDimensions('width');
	            var rootHalfHeight = rootDimensions('height');
	
	            var left = -1 * elementHalfWidth + rootHalfWidth;
	            var top = -1 * elementHalfHeight + rootHalfHeight;
	            var triangleLeft = elementHalfWidth - triangleSpacing;
	            var triangleTop = elementHalfHeight - triangleSize / 2;
	            var spacing = triangleSpacing + 3;
	
	            var positions = {
	                top: {
	                    top: -1 * (elementRect.height + spacing),
	                    left: left,
	                    triangleLeft: triangleLeft
	                },
	                bottom: {
	                    top: rootRect.height + spacing,
	                    left: left,
	                    triangleLeft: triangleLeft
	                },
	                left: {
	                    top: top,
	                    left: -1 * (elementRect.width + spacing),
	                    triangleTop: triangleTop
	                },
	                right: {
	                    top: top,
	                    left: rootRect.width + spacing,
	                    triangleTop: triangleTop
	                }
	            };
	
	            return positions[tooltipDirection];
	        }
	    }, {
	        key: '_getElementsPositions',
	        value: function _getElementsPositions() {
	            return {
	                elementRect: this._tooltip.childNodes[0].getBoundingClientRect(),
	                rootRect: this._tooltip.parentNode.getBoundingClientRect()
	            };
	        }
	
	        /**
	         * Adjusts the position of the tooltip element so that it's centered if possible. If it can't be centered because
	         * it would go offscreen, then offset the position so the whole tooltip is still displayed onscreen.
	         * @param  {Object} elementRect A rectangle indicating the dimensions of the tooltip element
	         */
	
	    }, {
	        key: '_adjustPosition',
	        value: function _adjustPosition() {
	            var _this2 = this;
	
	            if (!this.state.isVisible) {
	                return;
	            }
	
	            var _getElementsPositions2 = this._getElementsPositions(),
	                elementRect = _getElementsPositions2.elementRect,
	                rootRect = _getElementsPositions2.rootRect;
	
	            var tooltipDirection = this.state.tooltipDirection;
	            var _props2 = this.props,
	                thresholds = _props2.positionThresholds,
	                triangleSize = _props2.triangleSize;
	
	            var position = this._getInitialTooltipPosition(elementRect, tooltipDirection, rootRect);
	
	            // determine the area against which we are going to check the thresholds
	            var bounds = this.props.getBounds();
	            var overflowTop = rootRect.top - Math.abs(position.top) - bounds.top;
	            var overflowBottom = bounds.bottom - (rootRect.top + Math.abs(position.top) + elementRect.height);
	            var overflowLeft = rootRect.left + position.left - bounds.left;
	            var overflowRight = bounds.right - (rootRect.left + (position.left + elementRect.width));
	
	            var determineThresholds = {
	                top: function top() {
	                    return overflowTop;
	                },
	                bottom: function bottom() {
	                    return overflowBottom;
	                },
	                left: function left() {
	                    return overflowLeft;
	                },
	                right: function right() {
	                    return overflowRight;
	                }
	            };
	
	            var adjustHorizontal = function adjustHorizontal() {
	                var thresholdsLeft = overflowLeft - thresholds.left;
	                var thresholdsRight = overflowRight - thresholds.right;
	
	                if (overflowLeft < thresholds.left) {
	                    position.left -= thresholdsLeft;
	                    position.triangleLeft += thresholdsLeft;
	                    _this2.props.onThresholdPassed();
	                }
	
	                if (overflowRight < thresholds.right) {
	                    position.left += thresholdsRight;
	                    position.triangleLeft -= thresholdsRight;
	                    _this2.props.onThresholdPassed();
	                }
	            };
	
	            var adjustVertical = function adjustVertical() {
	                var thresholdsTop = overflowTop - thresholds.top;
	                var thresholdsBottom = overflowBottom + elementRect.height / 2;
	                var triangleHalfSize = triangleSize / 2;
	                var overflowTriangleTop = elementRect.height - triangleHalfSize - triangleSize;
	
	                if (overflowTop < thresholds.top) {
	                    position.top -= thresholdsTop;
	                    position.triangleTop += thresholdsTop;
	                    _this2.props.onThresholdPassed();
	                }
	
	                if (thresholdsBottom < thresholds.bottom) {
	                    position.top += thresholdsBottom + thresholds.bottom;
	                    position.triangleTop -= thresholdsBottom + thresholds.bottom;
	                    _this2.props.onThresholdPassed();
	                }
	
	                if (position.triangleTop <= 0) {
	                    position.triangleTop = triangleHalfSize;
	                } else if (position.triangleTop > overflowTriangleTop) {
	                    position.triangleTop = overflowTriangleTop;
	                }
	            };
	
	            var changeDirection = function changeDirection(direction) {
	                var oldState = tooltipDirection;
	                _this2.setState({
	                    tooltipDirection: direction,
	                    moved: false,
	                    flippedFrom: oldState
	                });
	                _this2.props.onThresholdPassed();
	            };
	
	            /*
	                This has the effect that if the tooltip doesn't fit on both the top and the bottom, we default to
	                displaying it on the top as per the spec
	             */
	            var canFlip = function canFlip() {
	                // if the previous tooltip direction was 'top' (i.e. it's on the bottom now), we can still flip back to the top
	                return !_this2.props.lockDirection && (!_this2.state.flippedFrom || _this2.state.flippedFrom === 'top');
	            };
	
	            var changeDirectionIfNecessary = function changeDirectionIfNecessary(changed, direction) {
	                if (!changed && canFlip() && tooltipDirection === direction) {
	                    var overflow = determineThresholds[direction]();
	                    if (overflow < thresholds[direction]) {
	                        changeDirection(oppositeDirections[direction]);
	                        changed = true;
	                    }
	                }
	                return changed;
	            };
	
	            var verticalOrientations = ['top', 'bottom'];
	            var horizontalOrientations = ['left', 'right'];
	
	            /*
	                If the tooltip is displayed on the top or bottom, adjust the horizontal position so it's all displayed inside
	                the window and flip it from top->bottom or vice-versa if necessary
	             */
	            if (verticalOrientations.indexOf(tooltipDirection) >= 0) {
	                adjustHorizontal();
	                if (verticalOrientations.reduce(changeDirectionIfNecessary, false)) {
	                    return;
	                }
	            }
	
	            /*
	                If the tooltip is displayed on the left or right flip it from left->right or vice-versa if necessary
	             */
	            if (horizontalOrientations.indexOf(tooltipDirection) >= 0) {
	                adjustVertical();
	                if (horizontalOrientations.reduce(changeDirectionIfNecessary, false)) {
	                    return;
	                }
	            }
	
	            this.setState(_extends({
	                moved: true
	            }, position));
	        }
	
	        /**
	         * Renders the tooltip contents if this.state.isVisible is true
	         * @param  {Object} style         The style of the tooltip container
	         */
	
	    }, {
	        key: '_renderContents',
	        value: function _renderContents(containerStyle) {
	            var _props3 = this.props,
	                className = _props3.className,
	                children = _props3.children,
	                hasTriangle = _props3.hasTriangle,
	                hasClose = _props3.hasClose,
	                containerClass = _props3.containerClass,
	                onClick = _props3.onClick;
	            var tooltipDirection = this.state.tooltipDirection;
	
	            var tooltipClass = classNames(styles[tooltipDirection], styles.container, className);
	            var tooltipInnerClass = classNames(styles.inner, containerClass);
	
	            return React.createElement(
	                'div',
	                { className: tooltipClass, style: containerStyle, onClick: onClick },
	                React.createElement(
	                    'div',
	                    { className: tooltipInnerClass },
	                    children
	                ),
	                hasTriangle ? this._renderTriangle(tooltipDirection) : null,
	                hasClose ? this._renderClose() : null
	            );
	        }
	
	        /**
	         * Renders the tooltip triangle if this.props.hasTriangle is true
	         */
	
	    }, {
	        key: '_renderTriangle',
	        value: function _renderTriangle(direction) {
	            var _props4 = this.props,
	                triangleSize = _props4.triangleSize,
	                triangleClass = _props4.triangleClass;
	            var _state2 = this.state,
	                left = _state2.triangleLeft,
	                top = _state2.triangleTop;
	
	            var triangleClassName = classNames(styles.triangle, triangleClass);
	            var triangleDirectionPosition = -1 * triangleSize;
	
	            var triangleStyle = {
	                top: {
	                    left: left,
	                    bottom: triangleDirectionPosition + 1
	                },
	                bottom: {
	                    left: left,
	                    top: triangleDirectionPosition + 1
	                },
	                left: {
	                    top: top,
	                    right: triangleDirectionPosition - 4
	                },
	                right: {
	                    top: top,
	                    left: triangleDirectionPosition - 4
	                }
	            };
	
	            return React.createElement(
	                'svg',
	                { className: triangleClassName, style: triangleStyle[direction], width: triangleSize * 2, height: triangleSize, viewBox: '0 0 20 10' },
	                React.createElement('polygon', { points: '9.65217424 0 19.3043485 9.25000032 0 9.25000032' }),
	                React.createElement('polygon', { className: styles.triangleStroke, strokeLinecap: 'square', points: '9.65723177 0.421508695 9.66228432 0.416666667 9.6572594 0.421535177 18.4448983 8.84302248 18.3478314 8.84165446 9.65723177 0.42156195 0.966632149 8.84165446 0.869565217 8.84302248 9.65720414 0.421535177 9.65217922 0.416666667' })
	            );
	        }
	
	        /**
	         * Renders the tooltip close if this.props.hasClose is true
	         */
	
	    }, {
	        key: '_renderClose',
	        value: function _renderClose() {
	            var _props5 = this.props,
	                closeClass = _props5.closeClass,
	                onCloseClick = _props5.onCloseClick;
	
	            var closeClassName = classNames(styles.close, closeClass);
	
	            return React.createElement(
	                'a',
	                { href: '#0', onClick: onCloseClick },
	                React.createElement(
	                    'svg',
	                    { className: closeClassName, viewBox: '0 0 25 25' },
	                    React.createElement('path', { d: 'M13.7001992,12.5 L24.7011952,23.500996 C25.0348606,23.8346614 25.0348606,24.37251 24.7011952,24.7011952 C24.3675299,25.0298805 23.8296813,25.0348606 23.500996,24.7011952 L12.5,13.7001992 L1.49900398,24.7011952 C1.16533865,25.0348606 0.62749004,25.0348606 0.298804781,24.7011952 C-0.0298804781,24.3675299 -0.0348605578,23.8296813 0.298804781,23.500996 L11.2998008,12.5 L0.298804781,1.49900398 C-0.0348605578,1.16533865 -0.0348605578,0.62749004 0.298804781,0.298804781 C0.63247012,-0.0298804781 1.17031873,-0.0348605578 1.49900398,0.298804781 L12.5,11.2998008 L23.500996,0.298804781 C23.8346614,-0.0348605578 24.37251,-0.0348605578 24.7011952,0.298804781 C25.0298805,0.63247012 25.0348606,1.17031873 24.7011952,1.49900398 L13.7001992,12.5 L13.7001992,12.5 Z' })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _state3 = this.state,
	                top = _state3.top,
	                left = _state3.left;
	
	            var containerStyle = { top: top, left: left };
	
	            return React.createElement(
	                'div',
	                { ref: function ref(tooltip) {
	                        _this3._tooltip = tooltip;
	                    } },
	                this.state.isVisible ? this._renderContents(containerStyle) : null
	            );
	        }
	    }]);
	
	    return Tooltip;
	}(React.Component);
	
	Tooltip.propTypes = {
	    children: React.PropTypes.node,
	    tooltipDirection: React.PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
	    lockDirection: React.PropTypes.bool,
	
	    isVisible: React.PropTypes.bool,
	    hasTriangle: React.PropTypes.bool,
	    hasClose: React.PropTypes.bool,
	
	    className: React.PropTypes.string,
	    containerClass: React.PropTypes.string,
	    triangleClass: React.PropTypes.string,
	    closeClass: React.PropTypes.string,
	
	    debounce: React.PropTypes.number,
	    triangleSize: React.PropTypes.number,
	    positionThresholds: React.PropTypes.shape({
	        top: React.PropTypes.number,
	        bottom: React.PropTypes.number,
	        left: React.PropTypes.number,
	        right: React.PropTypes.number
	    }),
	
	    onClick: React.PropTypes.func,
	    onCloseClick: React.PropTypes.func,
	    onThresholdPassed: React.PropTypes.func,
	    getBounds: React.PropTypes.func
	};
	
	Tooltip.defaultProps = {
	    className: '',
	    containerClass: styles.defaultStyle,
	    triangleClass: styles.defaultTriangle,
	    debounce: 0,
	    triangleSize: 10,
	    tooltipDirection: 'top',
	    lockDirection: false,
	    positionThresholds: {
	        top: 10,
	        bottom: 10,
	        left: 10,
	        right: 10
	    },
	    onClick: function onClick() {},
	    onCloseClick: function onCloseClick() {},
	    onThresholdPassed: function onThresholdPassed() {},
	    getBounds: getWindowBounds,
	    hasTriangle: true,
	    hasClose: false
	};
	
	module.exports = Tooltip;

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(105);

/***/ },
/* 4 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"defaultStyle":"Tooltip__defaultStyle___2PHGC","defaultClose":"Tooltip__defaultClose___3C4eQ","defaultTriangle":"Tooltip__defaultTriangle___2yE9C","container":"Tooltip__container___1iGSw","inner":"Tooltip__inner___34nOg","svg":"Tooltip__svg___1D5qj","close":"Tooltip__close___39mNB Tooltip__svg___1D5qj","triangle":"Tooltip__triangle___XBkZH Tooltip__svg___1D5qj","triangleStroke":"Tooltip__triangleStroke___1qO6p","top":"Tooltip__top___3PYiq","left":"Tooltip__left___2ocL0","right":"Tooltip__right___1Jius"};

/***/ }
/******/ ]);
//# sourceMappingURL=Tooltip.js.map

/***/ }),
/* 339 */,
/* 340 */,
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pageChangeTypeEnum = __webpack_require__(439);

/**
 * Helper to set the transform property. Sets any vendor prefixes necessary.
 * @param {Object} style      The style object to mutate.
 * @param {String} transform CSS string to add vendor prefixes to.
 */
function setTransformStyle(style, transform) {
    style.transform = transform;
    style.WebkitTransform = transform;
}

/**
 * Helper to set the transition property. Sets any vendor prefixes necessary.
 * @param {Object} style      The style object to mutate.
 * @param {String} transition CSS string to add vendor prefixes to.
 */
function setTransitionStyle(style, transition) {
    style.transition = transition;
    style.WebkitTransition = '-webkit-' + transition;
}

/**
 * Simple helper to set the width of items.
 * @param {[type]} style [description]
 * @param {[type]} width [description]
 */
function setWidthStyle(style, width) {
    // Need both min and max width for this to work consistently.
    style.minWidth = width + '%';
    style.maxWidth = width + '%';
}

/**
 * Calculate the total number of pages in a paged carousel.
 * @param  {Number} itemCount    Total number of items in the carousel.
 * @param  {Number} itemsPerPage Items to display per page.
 * @return {Number}
 */
function getTotalPages(itemCount, itemsPerPage) {
    return Math.ceil(itemCount / Math.floor(itemsPerPage));
}

/**
 * Get the default width pf items in a paged carousel.
 * @param  {Number} itemsPerPage Items to display per page.
 * @return {Number}
 */
function getPagedItemWidth(itemsPerPage) {
    return 100 / itemsPerPage;
}

/**
 * Get the width of each item when the last on is going to be partially hidden. The `numerator` and `denominator`
 * indicate how much of the last item should be hidden.  So calling `getScrollableItemWidth(2, 1, 3)` indicatedsthat 2
 * items will be shown and the second one will be one third hidden.
 * @param  {Number} numItems The number of items to display on the page.
 * @param  {Number} numerator The numerator of the portion to hide.
 * @param  {Number} denominator The denominator of the portion to hide.
 * @return {Number}
 */
function getScrollableItemWidth(numItems, numerator, denominator) {
    return 100 / (numItems - numerator / denominator);
}

/**
 * Calculate the default position of a paged carousel based on the current page.
 * @param {Number} page         The current page.
 * @return {Number}
 */
function getPagedOffset(page) {
    return -100 * page;
}

module.exports = {
    pageChangeTypeEnum: pageChangeTypeEnum,
    setTransformStyle: setTransformStyle,
    setTransitionStyle: setTransitionStyle,
    setWidthStyle: setWidthStyle,
    getTotalPages: getTotalPages,
    getPagedItemWidth: getPagedItemWidth,
    getScrollableItemWidth: getScrollableItemWidth,
    getPagedOffset: getPagedOffset
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    classes: {
        // GalleryWrapperView.es.js
        GALLERY: 'gallery',
        STATE_SHOW_DETAILS: 'show-details',

        // PhotoDetails.es.js
        PHOTO_DETAILS: 'photoDetails',

        PHOTO_TITLE: 'photoDetails-js-photoTitle',
        PHOTO_CAPTION: 'photoDetails-js-photoCaption',
        PHOTO_ATTRIBUTES: 'photoDetails-js-photoAttributes',

        PROJECT_NAME: 'photoDetails-js-projectName',
        PROJECT_LINK: 'photoDetails-js-projectLink',
        PROJECTS_LINK: 'photoDetails-js-projectsLink',

        FIRM_NAME: 'photoDetails-js-firmName',
        FIRM_LINK: 'photoDetails-js-firmLink',
        FIRM_IMAGE: 'photoDetails-js-firmImage',

        // SimilarItems
        SIMILAR_ITEMS: 'photoDetails-js-similarItems',
        SIMILAR_ITEMS_ALL: 'similarItems-seeAllLink',
        SIMILAR_ITEM_PDP: 'similarItems-itemLink',

        // MoreProjects
        MORE_PROJECTS: 'photoDetails-js-moreProjects',

        // GalleryArrowBox.es.js
        ARROW_BOX: 'gallery-arrowBox',

        // GalleryMobileNavWrapper.es.js
        MOBILE_NAV: 'gallery-mobileNavigationWrapper'
    },

    galleryPhotoClasses: {
        galleryPhotoWrapper: "galleryPhoto-wrapper",
        galleryPhotoImage: "galleryPhoto-image",
        galleryPhotoFadeIn: "fade-in"
    },

    /**
     * Classes used in GalleryModalWrapperView
     */
    galleryModalClasses: {
        PHOTO_PROJECT_LINK: 'photoDetails-js-projectLink',
        CLOSE_GALLERY_LINK: 'galleryModal-close',

        CONTENT_GALLERY: 'galleryModal-content',
        STATE_NOT_LOADED: 'not-loaded',

        SIMPLE_MODAL_CLASSES: {
            modal: 'galleryModal is-full-page not-loaded',
            contentWrapper: 'galleryModal-contentWrapper boxSizingWrapper containerFluid'
        }
    },

    pageTypes: {
        PDP: 'pdp'
    },

    switchActions: {
        NEXT: 'next',
        PREVIOUS: 'previous'
    },

    ITEM_TAG_INFO_CHAR_LIMIT: 40
};

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Abreve": "Ă",
	"abreve": "ă",
	"ac": "∾",
	"acd": "∿",
	"acE": "∾̳",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"Acy": "А",
	"acy": "а",
	"AElig": "Æ",
	"aelig": "æ",
	"af": "⁡",
	"Afr": "𝔄",
	"afr": "𝔞",
	"Agrave": "À",
	"agrave": "à",
	"alefsym": "ℵ",
	"aleph": "ℵ",
	"Alpha": "Α",
	"alpha": "α",
	"Amacr": "Ā",
	"amacr": "ā",
	"amalg": "⨿",
	"amp": "&",
	"AMP": "&",
	"andand": "⩕",
	"And": "⩓",
	"and": "∧",
	"andd": "⩜",
	"andslope": "⩘",
	"andv": "⩚",
	"ang": "∠",
	"ange": "⦤",
	"angle": "∠",
	"angmsdaa": "⦨",
	"angmsdab": "⦩",
	"angmsdac": "⦪",
	"angmsdad": "⦫",
	"angmsdae": "⦬",
	"angmsdaf": "⦭",
	"angmsdag": "⦮",
	"angmsdah": "⦯",
	"angmsd": "∡",
	"angrt": "∟",
	"angrtvb": "⊾",
	"angrtvbd": "⦝",
	"angsph": "∢",
	"angst": "Å",
	"angzarr": "⍼",
	"Aogon": "Ą",
	"aogon": "ą",
	"Aopf": "𝔸",
	"aopf": "𝕒",
	"apacir": "⩯",
	"ap": "≈",
	"apE": "⩰",
	"ape": "≊",
	"apid": "≋",
	"apos": "'",
	"ApplyFunction": "⁡",
	"approx": "≈",
	"approxeq": "≊",
	"Aring": "Å",
	"aring": "å",
	"Ascr": "𝒜",
	"ascr": "𝒶",
	"Assign": "≔",
	"ast": "*",
	"asymp": "≈",
	"asympeq": "≍",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"awconint": "∳",
	"awint": "⨑",
	"backcong": "≌",
	"backepsilon": "϶",
	"backprime": "‵",
	"backsim": "∽",
	"backsimeq": "⋍",
	"Backslash": "∖",
	"Barv": "⫧",
	"barvee": "⊽",
	"barwed": "⌅",
	"Barwed": "⌆",
	"barwedge": "⌅",
	"bbrk": "⎵",
	"bbrktbrk": "⎶",
	"bcong": "≌",
	"Bcy": "Б",
	"bcy": "б",
	"bdquo": "„",
	"becaus": "∵",
	"because": "∵",
	"Because": "∵",
	"bemptyv": "⦰",
	"bepsi": "϶",
	"bernou": "ℬ",
	"Bernoullis": "ℬ",
	"Beta": "Β",
	"beta": "β",
	"beth": "ℶ",
	"between": "≬",
	"Bfr": "𝔅",
	"bfr": "𝔟",
	"bigcap": "⋂",
	"bigcirc": "◯",
	"bigcup": "⋃",
	"bigodot": "⨀",
	"bigoplus": "⨁",
	"bigotimes": "⨂",
	"bigsqcup": "⨆",
	"bigstar": "★",
	"bigtriangledown": "▽",
	"bigtriangleup": "△",
	"biguplus": "⨄",
	"bigvee": "⋁",
	"bigwedge": "⋀",
	"bkarow": "⤍",
	"blacklozenge": "⧫",
	"blacksquare": "▪",
	"blacktriangle": "▴",
	"blacktriangledown": "▾",
	"blacktriangleleft": "◂",
	"blacktriangleright": "▸",
	"blank": "␣",
	"blk12": "▒",
	"blk14": "░",
	"blk34": "▓",
	"block": "█",
	"bne": "=⃥",
	"bnequiv": "≡⃥",
	"bNot": "⫭",
	"bnot": "⌐",
	"Bopf": "𝔹",
	"bopf": "𝕓",
	"bot": "⊥",
	"bottom": "⊥",
	"bowtie": "⋈",
	"boxbox": "⧉",
	"boxdl": "┐",
	"boxdL": "╕",
	"boxDl": "╖",
	"boxDL": "╗",
	"boxdr": "┌",
	"boxdR": "╒",
	"boxDr": "╓",
	"boxDR": "╔",
	"boxh": "─",
	"boxH": "═",
	"boxhd": "┬",
	"boxHd": "╤",
	"boxhD": "╥",
	"boxHD": "╦",
	"boxhu": "┴",
	"boxHu": "╧",
	"boxhU": "╨",
	"boxHU": "╩",
	"boxminus": "⊟",
	"boxplus": "⊞",
	"boxtimes": "⊠",
	"boxul": "┘",
	"boxuL": "╛",
	"boxUl": "╜",
	"boxUL": "╝",
	"boxur": "└",
	"boxuR": "╘",
	"boxUr": "╙",
	"boxUR": "╚",
	"boxv": "│",
	"boxV": "║",
	"boxvh": "┼",
	"boxvH": "╪",
	"boxVh": "╫",
	"boxVH": "╬",
	"boxvl": "┤",
	"boxvL": "╡",
	"boxVl": "╢",
	"boxVL": "╣",
	"boxvr": "├",
	"boxvR": "╞",
	"boxVr": "╟",
	"boxVR": "╠",
	"bprime": "‵",
	"breve": "˘",
	"Breve": "˘",
	"brvbar": "¦",
	"bscr": "𝒷",
	"Bscr": "ℬ",
	"bsemi": "⁏",
	"bsim": "∽",
	"bsime": "⋍",
	"bsolb": "⧅",
	"bsol": "\\",
	"bsolhsub": "⟈",
	"bull": "•",
	"bullet": "•",
	"bump": "≎",
	"bumpE": "⪮",
	"bumpe": "≏",
	"Bumpeq": "≎",
	"bumpeq": "≏",
	"Cacute": "Ć",
	"cacute": "ć",
	"capand": "⩄",
	"capbrcup": "⩉",
	"capcap": "⩋",
	"cap": "∩",
	"Cap": "⋒",
	"capcup": "⩇",
	"capdot": "⩀",
	"CapitalDifferentialD": "ⅅ",
	"caps": "∩︀",
	"caret": "⁁",
	"caron": "ˇ",
	"Cayleys": "ℭ",
	"ccaps": "⩍",
	"Ccaron": "Č",
	"ccaron": "č",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"Ccirc": "Ĉ",
	"ccirc": "ĉ",
	"Cconint": "∰",
	"ccups": "⩌",
	"ccupssm": "⩐",
	"Cdot": "Ċ",
	"cdot": "ċ",
	"cedil": "¸",
	"Cedilla": "¸",
	"cemptyv": "⦲",
	"cent": "¢",
	"centerdot": "·",
	"CenterDot": "·",
	"cfr": "𝔠",
	"Cfr": "ℭ",
	"CHcy": "Ч",
	"chcy": "ч",
	"check": "✓",
	"checkmark": "✓",
	"Chi": "Χ",
	"chi": "χ",
	"circ": "ˆ",
	"circeq": "≗",
	"circlearrowleft": "↺",
	"circlearrowright": "↻",
	"circledast": "⊛",
	"circledcirc": "⊚",
	"circleddash": "⊝",
	"CircleDot": "⊙",
	"circledR": "®",
	"circledS": "Ⓢ",
	"CircleMinus": "⊖",
	"CirclePlus": "⊕",
	"CircleTimes": "⊗",
	"cir": "○",
	"cirE": "⧃",
	"cire": "≗",
	"cirfnint": "⨐",
	"cirmid": "⫯",
	"cirscir": "⧂",
	"ClockwiseContourIntegral": "∲",
	"CloseCurlyDoubleQuote": "”",
	"CloseCurlyQuote": "’",
	"clubs": "♣",
	"clubsuit": "♣",
	"colon": ":",
	"Colon": "∷",
	"Colone": "⩴",
	"colone": "≔",
	"coloneq": "≔",
	"comma": ",",
	"commat": "@",
	"comp": "∁",
	"compfn": "∘",
	"complement": "∁",
	"complexes": "ℂ",
	"cong": "≅",
	"congdot": "⩭",
	"Congruent": "≡",
	"conint": "∮",
	"Conint": "∯",
	"ContourIntegral": "∮",
	"copf": "𝕔",
	"Copf": "ℂ",
	"coprod": "∐",
	"Coproduct": "∐",
	"copy": "©",
	"COPY": "©",
	"copysr": "℗",
	"CounterClockwiseContourIntegral": "∳",
	"crarr": "↵",
	"cross": "✗",
	"Cross": "⨯",
	"Cscr": "𝒞",
	"cscr": "𝒸",
	"csub": "⫏",
	"csube": "⫑",
	"csup": "⫐",
	"csupe": "⫒",
	"ctdot": "⋯",
	"cudarrl": "⤸",
	"cudarrr": "⤵",
	"cuepr": "⋞",
	"cuesc": "⋟",
	"cularr": "↶",
	"cularrp": "⤽",
	"cupbrcap": "⩈",
	"cupcap": "⩆",
	"CupCap": "≍",
	"cup": "∪",
	"Cup": "⋓",
	"cupcup": "⩊",
	"cupdot": "⊍",
	"cupor": "⩅",
	"cups": "∪︀",
	"curarr": "↷",
	"curarrm": "⤼",
	"curlyeqprec": "⋞",
	"curlyeqsucc": "⋟",
	"curlyvee": "⋎",
	"curlywedge": "⋏",
	"curren": "¤",
	"curvearrowleft": "↶",
	"curvearrowright": "↷",
	"cuvee": "⋎",
	"cuwed": "⋏",
	"cwconint": "∲",
	"cwint": "∱",
	"cylcty": "⌭",
	"dagger": "†",
	"Dagger": "‡",
	"daleth": "ℸ",
	"darr": "↓",
	"Darr": "↡",
	"dArr": "⇓",
	"dash": "‐",
	"Dashv": "⫤",
	"dashv": "⊣",
	"dbkarow": "⤏",
	"dblac": "˝",
	"Dcaron": "Ď",
	"dcaron": "ď",
	"Dcy": "Д",
	"dcy": "д",
	"ddagger": "‡",
	"ddarr": "⇊",
	"DD": "ⅅ",
	"dd": "ⅆ",
	"DDotrahd": "⤑",
	"ddotseq": "⩷",
	"deg": "°",
	"Del": "∇",
	"Delta": "Δ",
	"delta": "δ",
	"demptyv": "⦱",
	"dfisht": "⥿",
	"Dfr": "𝔇",
	"dfr": "𝔡",
	"dHar": "⥥",
	"dharl": "⇃",
	"dharr": "⇂",
	"DiacriticalAcute": "´",
	"DiacriticalDot": "˙",
	"DiacriticalDoubleAcute": "˝",
	"DiacriticalGrave": "`",
	"DiacriticalTilde": "˜",
	"diam": "⋄",
	"diamond": "⋄",
	"Diamond": "⋄",
	"diamondsuit": "♦",
	"diams": "♦",
	"die": "¨",
	"DifferentialD": "ⅆ",
	"digamma": "ϝ",
	"disin": "⋲",
	"div": "÷",
	"divide": "÷",
	"divideontimes": "⋇",
	"divonx": "⋇",
	"DJcy": "Ђ",
	"djcy": "ђ",
	"dlcorn": "⌞",
	"dlcrop": "⌍",
	"dollar": "$",
	"Dopf": "𝔻",
	"dopf": "𝕕",
	"Dot": "¨",
	"dot": "˙",
	"DotDot": "⃜",
	"doteq": "≐",
	"doteqdot": "≑",
	"DotEqual": "≐",
	"dotminus": "∸",
	"dotplus": "∔",
	"dotsquare": "⊡",
	"doublebarwedge": "⌆",
	"DoubleContourIntegral": "∯",
	"DoubleDot": "¨",
	"DoubleDownArrow": "⇓",
	"DoubleLeftArrow": "⇐",
	"DoubleLeftRightArrow": "⇔",
	"DoubleLeftTee": "⫤",
	"DoubleLongLeftArrow": "⟸",
	"DoubleLongLeftRightArrow": "⟺",
	"DoubleLongRightArrow": "⟹",
	"DoubleRightArrow": "⇒",
	"DoubleRightTee": "⊨",
	"DoubleUpArrow": "⇑",
	"DoubleUpDownArrow": "⇕",
	"DoubleVerticalBar": "∥",
	"DownArrowBar": "⤓",
	"downarrow": "↓",
	"DownArrow": "↓",
	"Downarrow": "⇓",
	"DownArrowUpArrow": "⇵",
	"DownBreve": "̑",
	"downdownarrows": "⇊",
	"downharpoonleft": "⇃",
	"downharpoonright": "⇂",
	"DownLeftRightVector": "⥐",
	"DownLeftTeeVector": "⥞",
	"DownLeftVectorBar": "⥖",
	"DownLeftVector": "↽",
	"DownRightTeeVector": "⥟",
	"DownRightVectorBar": "⥗",
	"DownRightVector": "⇁",
	"DownTeeArrow": "↧",
	"DownTee": "⊤",
	"drbkarow": "⤐",
	"drcorn": "⌟",
	"drcrop": "⌌",
	"Dscr": "𝒟",
	"dscr": "𝒹",
	"DScy": "Ѕ",
	"dscy": "ѕ",
	"dsol": "⧶",
	"Dstrok": "Đ",
	"dstrok": "đ",
	"dtdot": "⋱",
	"dtri": "▿",
	"dtrif": "▾",
	"duarr": "⇵",
	"duhar": "⥯",
	"dwangle": "⦦",
	"DZcy": "Џ",
	"dzcy": "џ",
	"dzigrarr": "⟿",
	"Eacute": "É",
	"eacute": "é",
	"easter": "⩮",
	"Ecaron": "Ě",
	"ecaron": "ě",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"ecir": "≖",
	"ecolon": "≕",
	"Ecy": "Э",
	"ecy": "э",
	"eDDot": "⩷",
	"Edot": "Ė",
	"edot": "ė",
	"eDot": "≑",
	"ee": "ⅇ",
	"efDot": "≒",
	"Efr": "𝔈",
	"efr": "𝔢",
	"eg": "⪚",
	"Egrave": "È",
	"egrave": "è",
	"egs": "⪖",
	"egsdot": "⪘",
	"el": "⪙",
	"Element": "∈",
	"elinters": "⏧",
	"ell": "ℓ",
	"els": "⪕",
	"elsdot": "⪗",
	"Emacr": "Ē",
	"emacr": "ē",
	"empty": "∅",
	"emptyset": "∅",
	"EmptySmallSquare": "◻",
	"emptyv": "∅",
	"EmptyVerySmallSquare": "▫",
	"emsp13": " ",
	"emsp14": " ",
	"emsp": " ",
	"ENG": "Ŋ",
	"eng": "ŋ",
	"ensp": " ",
	"Eogon": "Ę",
	"eogon": "ę",
	"Eopf": "𝔼",
	"eopf": "𝕖",
	"epar": "⋕",
	"eparsl": "⧣",
	"eplus": "⩱",
	"epsi": "ε",
	"Epsilon": "Ε",
	"epsilon": "ε",
	"epsiv": "ϵ",
	"eqcirc": "≖",
	"eqcolon": "≕",
	"eqsim": "≂",
	"eqslantgtr": "⪖",
	"eqslantless": "⪕",
	"Equal": "⩵",
	"equals": "=",
	"EqualTilde": "≂",
	"equest": "≟",
	"Equilibrium": "⇌",
	"equiv": "≡",
	"equivDD": "⩸",
	"eqvparsl": "⧥",
	"erarr": "⥱",
	"erDot": "≓",
	"escr": "ℯ",
	"Escr": "ℰ",
	"esdot": "≐",
	"Esim": "⩳",
	"esim": "≂",
	"Eta": "Η",
	"eta": "η",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"euro": "€",
	"excl": "!",
	"exist": "∃",
	"Exists": "∃",
	"expectation": "ℰ",
	"exponentiale": "ⅇ",
	"ExponentialE": "ⅇ",
	"fallingdotseq": "≒",
	"Fcy": "Ф",
	"fcy": "ф",
	"female": "♀",
	"ffilig": "ﬃ",
	"fflig": "ﬀ",
	"ffllig": "ﬄ",
	"Ffr": "𝔉",
	"ffr": "𝔣",
	"filig": "ﬁ",
	"FilledSmallSquare": "◼",
	"FilledVerySmallSquare": "▪",
	"fjlig": "fj",
	"flat": "♭",
	"fllig": "ﬂ",
	"fltns": "▱",
	"fnof": "ƒ",
	"Fopf": "𝔽",
	"fopf": "𝕗",
	"forall": "∀",
	"ForAll": "∀",
	"fork": "⋔",
	"forkv": "⫙",
	"Fouriertrf": "ℱ",
	"fpartint": "⨍",
	"frac12": "½",
	"frac13": "⅓",
	"frac14": "¼",
	"frac15": "⅕",
	"frac16": "⅙",
	"frac18": "⅛",
	"frac23": "⅔",
	"frac25": "⅖",
	"frac34": "¾",
	"frac35": "⅗",
	"frac38": "⅜",
	"frac45": "⅘",
	"frac56": "⅚",
	"frac58": "⅝",
	"frac78": "⅞",
	"frasl": "⁄",
	"frown": "⌢",
	"fscr": "𝒻",
	"Fscr": "ℱ",
	"gacute": "ǵ",
	"Gamma": "Γ",
	"gamma": "γ",
	"Gammad": "Ϝ",
	"gammad": "ϝ",
	"gap": "⪆",
	"Gbreve": "Ğ",
	"gbreve": "ğ",
	"Gcedil": "Ģ",
	"Gcirc": "Ĝ",
	"gcirc": "ĝ",
	"Gcy": "Г",
	"gcy": "г",
	"Gdot": "Ġ",
	"gdot": "ġ",
	"ge": "≥",
	"gE": "≧",
	"gEl": "⪌",
	"gel": "⋛",
	"geq": "≥",
	"geqq": "≧",
	"geqslant": "⩾",
	"gescc": "⪩",
	"ges": "⩾",
	"gesdot": "⪀",
	"gesdoto": "⪂",
	"gesdotol": "⪄",
	"gesl": "⋛︀",
	"gesles": "⪔",
	"Gfr": "𝔊",
	"gfr": "𝔤",
	"gg": "≫",
	"Gg": "⋙",
	"ggg": "⋙",
	"gimel": "ℷ",
	"GJcy": "Ѓ",
	"gjcy": "ѓ",
	"gla": "⪥",
	"gl": "≷",
	"glE": "⪒",
	"glj": "⪤",
	"gnap": "⪊",
	"gnapprox": "⪊",
	"gne": "⪈",
	"gnE": "≩",
	"gneq": "⪈",
	"gneqq": "≩",
	"gnsim": "⋧",
	"Gopf": "𝔾",
	"gopf": "𝕘",
	"grave": "`",
	"GreaterEqual": "≥",
	"GreaterEqualLess": "⋛",
	"GreaterFullEqual": "≧",
	"GreaterGreater": "⪢",
	"GreaterLess": "≷",
	"GreaterSlantEqual": "⩾",
	"GreaterTilde": "≳",
	"Gscr": "𝒢",
	"gscr": "ℊ",
	"gsim": "≳",
	"gsime": "⪎",
	"gsiml": "⪐",
	"gtcc": "⪧",
	"gtcir": "⩺",
	"gt": ">",
	"GT": ">",
	"Gt": "≫",
	"gtdot": "⋗",
	"gtlPar": "⦕",
	"gtquest": "⩼",
	"gtrapprox": "⪆",
	"gtrarr": "⥸",
	"gtrdot": "⋗",
	"gtreqless": "⋛",
	"gtreqqless": "⪌",
	"gtrless": "≷",
	"gtrsim": "≳",
	"gvertneqq": "≩︀",
	"gvnE": "≩︀",
	"Hacek": "ˇ",
	"hairsp": " ",
	"half": "½",
	"hamilt": "ℋ",
	"HARDcy": "Ъ",
	"hardcy": "ъ",
	"harrcir": "⥈",
	"harr": "↔",
	"hArr": "⇔",
	"harrw": "↭",
	"Hat": "^",
	"hbar": "ℏ",
	"Hcirc": "Ĥ",
	"hcirc": "ĥ",
	"hearts": "♥",
	"heartsuit": "♥",
	"hellip": "…",
	"hercon": "⊹",
	"hfr": "𝔥",
	"Hfr": "ℌ",
	"HilbertSpace": "ℋ",
	"hksearow": "⤥",
	"hkswarow": "⤦",
	"hoarr": "⇿",
	"homtht": "∻",
	"hookleftarrow": "↩",
	"hookrightarrow": "↪",
	"hopf": "𝕙",
	"Hopf": "ℍ",
	"horbar": "―",
	"HorizontalLine": "─",
	"hscr": "𝒽",
	"Hscr": "ℋ",
	"hslash": "ℏ",
	"Hstrok": "Ħ",
	"hstrok": "ħ",
	"HumpDownHump": "≎",
	"HumpEqual": "≏",
	"hybull": "⁃",
	"hyphen": "‐",
	"Iacute": "Í",
	"iacute": "í",
	"ic": "⁣",
	"Icirc": "Î",
	"icirc": "î",
	"Icy": "И",
	"icy": "и",
	"Idot": "İ",
	"IEcy": "Е",
	"iecy": "е",
	"iexcl": "¡",
	"iff": "⇔",
	"ifr": "𝔦",
	"Ifr": "ℑ",
	"Igrave": "Ì",
	"igrave": "ì",
	"ii": "ⅈ",
	"iiiint": "⨌",
	"iiint": "∭",
	"iinfin": "⧜",
	"iiota": "℩",
	"IJlig": "Ĳ",
	"ijlig": "ĳ",
	"Imacr": "Ī",
	"imacr": "ī",
	"image": "ℑ",
	"ImaginaryI": "ⅈ",
	"imagline": "ℐ",
	"imagpart": "ℑ",
	"imath": "ı",
	"Im": "ℑ",
	"imof": "⊷",
	"imped": "Ƶ",
	"Implies": "⇒",
	"incare": "℅",
	"in": "∈",
	"infin": "∞",
	"infintie": "⧝",
	"inodot": "ı",
	"intcal": "⊺",
	"int": "∫",
	"Int": "∬",
	"integers": "ℤ",
	"Integral": "∫",
	"intercal": "⊺",
	"Intersection": "⋂",
	"intlarhk": "⨗",
	"intprod": "⨼",
	"InvisibleComma": "⁣",
	"InvisibleTimes": "⁢",
	"IOcy": "Ё",
	"iocy": "ё",
	"Iogon": "Į",
	"iogon": "į",
	"Iopf": "𝕀",
	"iopf": "𝕚",
	"Iota": "Ι",
	"iota": "ι",
	"iprod": "⨼",
	"iquest": "¿",
	"iscr": "𝒾",
	"Iscr": "ℐ",
	"isin": "∈",
	"isindot": "⋵",
	"isinE": "⋹",
	"isins": "⋴",
	"isinsv": "⋳",
	"isinv": "∈",
	"it": "⁢",
	"Itilde": "Ĩ",
	"itilde": "ĩ",
	"Iukcy": "І",
	"iukcy": "і",
	"Iuml": "Ï",
	"iuml": "ï",
	"Jcirc": "Ĵ",
	"jcirc": "ĵ",
	"Jcy": "Й",
	"jcy": "й",
	"Jfr": "𝔍",
	"jfr": "𝔧",
	"jmath": "ȷ",
	"Jopf": "𝕁",
	"jopf": "𝕛",
	"Jscr": "𝒥",
	"jscr": "𝒿",
	"Jsercy": "Ј",
	"jsercy": "ј",
	"Jukcy": "Є",
	"jukcy": "є",
	"Kappa": "Κ",
	"kappa": "κ",
	"kappav": "ϰ",
	"Kcedil": "Ķ",
	"kcedil": "ķ",
	"Kcy": "К",
	"kcy": "к",
	"Kfr": "𝔎",
	"kfr": "𝔨",
	"kgreen": "ĸ",
	"KHcy": "Х",
	"khcy": "х",
	"KJcy": "Ќ",
	"kjcy": "ќ",
	"Kopf": "𝕂",
	"kopf": "𝕜",
	"Kscr": "𝒦",
	"kscr": "𝓀",
	"lAarr": "⇚",
	"Lacute": "Ĺ",
	"lacute": "ĺ",
	"laemptyv": "⦴",
	"lagran": "ℒ",
	"Lambda": "Λ",
	"lambda": "λ",
	"lang": "⟨",
	"Lang": "⟪",
	"langd": "⦑",
	"langle": "⟨",
	"lap": "⪅",
	"Laplacetrf": "ℒ",
	"laquo": "«",
	"larrb": "⇤",
	"larrbfs": "⤟",
	"larr": "←",
	"Larr": "↞",
	"lArr": "⇐",
	"larrfs": "⤝",
	"larrhk": "↩",
	"larrlp": "↫",
	"larrpl": "⤹",
	"larrsim": "⥳",
	"larrtl": "↢",
	"latail": "⤙",
	"lAtail": "⤛",
	"lat": "⪫",
	"late": "⪭",
	"lates": "⪭︀",
	"lbarr": "⤌",
	"lBarr": "⤎",
	"lbbrk": "❲",
	"lbrace": "{",
	"lbrack": "[",
	"lbrke": "⦋",
	"lbrksld": "⦏",
	"lbrkslu": "⦍",
	"Lcaron": "Ľ",
	"lcaron": "ľ",
	"Lcedil": "Ļ",
	"lcedil": "ļ",
	"lceil": "⌈",
	"lcub": "{",
	"Lcy": "Л",
	"lcy": "л",
	"ldca": "⤶",
	"ldquo": "“",
	"ldquor": "„",
	"ldrdhar": "⥧",
	"ldrushar": "⥋",
	"ldsh": "↲",
	"le": "≤",
	"lE": "≦",
	"LeftAngleBracket": "⟨",
	"LeftArrowBar": "⇤",
	"leftarrow": "←",
	"LeftArrow": "←",
	"Leftarrow": "⇐",
	"LeftArrowRightArrow": "⇆",
	"leftarrowtail": "↢",
	"LeftCeiling": "⌈",
	"LeftDoubleBracket": "⟦",
	"LeftDownTeeVector": "⥡",
	"LeftDownVectorBar": "⥙",
	"LeftDownVector": "⇃",
	"LeftFloor": "⌊",
	"leftharpoondown": "↽",
	"leftharpoonup": "↼",
	"leftleftarrows": "⇇",
	"leftrightarrow": "↔",
	"LeftRightArrow": "↔",
	"Leftrightarrow": "⇔",
	"leftrightarrows": "⇆",
	"leftrightharpoons": "⇋",
	"leftrightsquigarrow": "↭",
	"LeftRightVector": "⥎",
	"LeftTeeArrow": "↤",
	"LeftTee": "⊣",
	"LeftTeeVector": "⥚",
	"leftthreetimes": "⋋",
	"LeftTriangleBar": "⧏",
	"LeftTriangle": "⊲",
	"LeftTriangleEqual": "⊴",
	"LeftUpDownVector": "⥑",
	"LeftUpTeeVector": "⥠",
	"LeftUpVectorBar": "⥘",
	"LeftUpVector": "↿",
	"LeftVectorBar": "⥒",
	"LeftVector": "↼",
	"lEg": "⪋",
	"leg": "⋚",
	"leq": "≤",
	"leqq": "≦",
	"leqslant": "⩽",
	"lescc": "⪨",
	"les": "⩽",
	"lesdot": "⩿",
	"lesdoto": "⪁",
	"lesdotor": "⪃",
	"lesg": "⋚︀",
	"lesges": "⪓",
	"lessapprox": "⪅",
	"lessdot": "⋖",
	"lesseqgtr": "⋚",
	"lesseqqgtr": "⪋",
	"LessEqualGreater": "⋚",
	"LessFullEqual": "≦",
	"LessGreater": "≶",
	"lessgtr": "≶",
	"LessLess": "⪡",
	"lesssim": "≲",
	"LessSlantEqual": "⩽",
	"LessTilde": "≲",
	"lfisht": "⥼",
	"lfloor": "⌊",
	"Lfr": "𝔏",
	"lfr": "𝔩",
	"lg": "≶",
	"lgE": "⪑",
	"lHar": "⥢",
	"lhard": "↽",
	"lharu": "↼",
	"lharul": "⥪",
	"lhblk": "▄",
	"LJcy": "Љ",
	"ljcy": "љ",
	"llarr": "⇇",
	"ll": "≪",
	"Ll": "⋘",
	"llcorner": "⌞",
	"Lleftarrow": "⇚",
	"llhard": "⥫",
	"lltri": "◺",
	"Lmidot": "Ŀ",
	"lmidot": "ŀ",
	"lmoustache": "⎰",
	"lmoust": "⎰",
	"lnap": "⪉",
	"lnapprox": "⪉",
	"lne": "⪇",
	"lnE": "≨",
	"lneq": "⪇",
	"lneqq": "≨",
	"lnsim": "⋦",
	"loang": "⟬",
	"loarr": "⇽",
	"lobrk": "⟦",
	"longleftarrow": "⟵",
	"LongLeftArrow": "⟵",
	"Longleftarrow": "⟸",
	"longleftrightarrow": "⟷",
	"LongLeftRightArrow": "⟷",
	"Longleftrightarrow": "⟺",
	"longmapsto": "⟼",
	"longrightarrow": "⟶",
	"LongRightArrow": "⟶",
	"Longrightarrow": "⟹",
	"looparrowleft": "↫",
	"looparrowright": "↬",
	"lopar": "⦅",
	"Lopf": "𝕃",
	"lopf": "𝕝",
	"loplus": "⨭",
	"lotimes": "⨴",
	"lowast": "∗",
	"lowbar": "_",
	"LowerLeftArrow": "↙",
	"LowerRightArrow": "↘",
	"loz": "◊",
	"lozenge": "◊",
	"lozf": "⧫",
	"lpar": "(",
	"lparlt": "⦓",
	"lrarr": "⇆",
	"lrcorner": "⌟",
	"lrhar": "⇋",
	"lrhard": "⥭",
	"lrm": "‎",
	"lrtri": "⊿",
	"lsaquo": "‹",
	"lscr": "𝓁",
	"Lscr": "ℒ",
	"lsh": "↰",
	"Lsh": "↰",
	"lsim": "≲",
	"lsime": "⪍",
	"lsimg": "⪏",
	"lsqb": "[",
	"lsquo": "‘",
	"lsquor": "‚",
	"Lstrok": "Ł",
	"lstrok": "ł",
	"ltcc": "⪦",
	"ltcir": "⩹",
	"lt": "<",
	"LT": "<",
	"Lt": "≪",
	"ltdot": "⋖",
	"lthree": "⋋",
	"ltimes": "⋉",
	"ltlarr": "⥶",
	"ltquest": "⩻",
	"ltri": "◃",
	"ltrie": "⊴",
	"ltrif": "◂",
	"ltrPar": "⦖",
	"lurdshar": "⥊",
	"luruhar": "⥦",
	"lvertneqq": "≨︀",
	"lvnE": "≨︀",
	"macr": "¯",
	"male": "♂",
	"malt": "✠",
	"maltese": "✠",
	"Map": "⤅",
	"map": "↦",
	"mapsto": "↦",
	"mapstodown": "↧",
	"mapstoleft": "↤",
	"mapstoup": "↥",
	"marker": "▮",
	"mcomma": "⨩",
	"Mcy": "М",
	"mcy": "м",
	"mdash": "—",
	"mDDot": "∺",
	"measuredangle": "∡",
	"MediumSpace": " ",
	"Mellintrf": "ℳ",
	"Mfr": "𝔐",
	"mfr": "𝔪",
	"mho": "℧",
	"micro": "µ",
	"midast": "*",
	"midcir": "⫰",
	"mid": "∣",
	"middot": "·",
	"minusb": "⊟",
	"minus": "−",
	"minusd": "∸",
	"minusdu": "⨪",
	"MinusPlus": "∓",
	"mlcp": "⫛",
	"mldr": "…",
	"mnplus": "∓",
	"models": "⊧",
	"Mopf": "𝕄",
	"mopf": "𝕞",
	"mp": "∓",
	"mscr": "𝓂",
	"Mscr": "ℳ",
	"mstpos": "∾",
	"Mu": "Μ",
	"mu": "μ",
	"multimap": "⊸",
	"mumap": "⊸",
	"nabla": "∇",
	"Nacute": "Ń",
	"nacute": "ń",
	"nang": "∠⃒",
	"nap": "≉",
	"napE": "⩰̸",
	"napid": "≋̸",
	"napos": "ŉ",
	"napprox": "≉",
	"natural": "♮",
	"naturals": "ℕ",
	"natur": "♮",
	"nbsp": " ",
	"nbump": "≎̸",
	"nbumpe": "≏̸",
	"ncap": "⩃",
	"Ncaron": "Ň",
	"ncaron": "ň",
	"Ncedil": "Ņ",
	"ncedil": "ņ",
	"ncong": "≇",
	"ncongdot": "⩭̸",
	"ncup": "⩂",
	"Ncy": "Н",
	"ncy": "н",
	"ndash": "–",
	"nearhk": "⤤",
	"nearr": "↗",
	"neArr": "⇗",
	"nearrow": "↗",
	"ne": "≠",
	"nedot": "≐̸",
	"NegativeMediumSpace": "​",
	"NegativeThickSpace": "​",
	"NegativeThinSpace": "​",
	"NegativeVeryThinSpace": "​",
	"nequiv": "≢",
	"nesear": "⤨",
	"nesim": "≂̸",
	"NestedGreaterGreater": "≫",
	"NestedLessLess": "≪",
	"NewLine": "\n",
	"nexist": "∄",
	"nexists": "∄",
	"Nfr": "𝔑",
	"nfr": "𝔫",
	"ngE": "≧̸",
	"nge": "≱",
	"ngeq": "≱",
	"ngeqq": "≧̸",
	"ngeqslant": "⩾̸",
	"nges": "⩾̸",
	"nGg": "⋙̸",
	"ngsim": "≵",
	"nGt": "≫⃒",
	"ngt": "≯",
	"ngtr": "≯",
	"nGtv": "≫̸",
	"nharr": "↮",
	"nhArr": "⇎",
	"nhpar": "⫲",
	"ni": "∋",
	"nis": "⋼",
	"nisd": "⋺",
	"niv": "∋",
	"NJcy": "Њ",
	"njcy": "њ",
	"nlarr": "↚",
	"nlArr": "⇍",
	"nldr": "‥",
	"nlE": "≦̸",
	"nle": "≰",
	"nleftarrow": "↚",
	"nLeftarrow": "⇍",
	"nleftrightarrow": "↮",
	"nLeftrightarrow": "⇎",
	"nleq": "≰",
	"nleqq": "≦̸",
	"nleqslant": "⩽̸",
	"nles": "⩽̸",
	"nless": "≮",
	"nLl": "⋘̸",
	"nlsim": "≴",
	"nLt": "≪⃒",
	"nlt": "≮",
	"nltri": "⋪",
	"nltrie": "⋬",
	"nLtv": "≪̸",
	"nmid": "∤",
	"NoBreak": "⁠",
	"NonBreakingSpace": " ",
	"nopf": "𝕟",
	"Nopf": "ℕ",
	"Not": "⫬",
	"not": "¬",
	"NotCongruent": "≢",
	"NotCupCap": "≭",
	"NotDoubleVerticalBar": "∦",
	"NotElement": "∉",
	"NotEqual": "≠",
	"NotEqualTilde": "≂̸",
	"NotExists": "∄",
	"NotGreater": "≯",
	"NotGreaterEqual": "≱",
	"NotGreaterFullEqual": "≧̸",
	"NotGreaterGreater": "≫̸",
	"NotGreaterLess": "≹",
	"NotGreaterSlantEqual": "⩾̸",
	"NotGreaterTilde": "≵",
	"NotHumpDownHump": "≎̸",
	"NotHumpEqual": "≏̸",
	"notin": "∉",
	"notindot": "⋵̸",
	"notinE": "⋹̸",
	"notinva": "∉",
	"notinvb": "⋷",
	"notinvc": "⋶",
	"NotLeftTriangleBar": "⧏̸",
	"NotLeftTriangle": "⋪",
	"NotLeftTriangleEqual": "⋬",
	"NotLess": "≮",
	"NotLessEqual": "≰",
	"NotLessGreater": "≸",
	"NotLessLess": "≪̸",
	"NotLessSlantEqual": "⩽̸",
	"NotLessTilde": "≴",
	"NotNestedGreaterGreater": "⪢̸",
	"NotNestedLessLess": "⪡̸",
	"notni": "∌",
	"notniva": "∌",
	"notnivb": "⋾",
	"notnivc": "⋽",
	"NotPrecedes": "⊀",
	"NotPrecedesEqual": "⪯̸",
	"NotPrecedesSlantEqual": "⋠",
	"NotReverseElement": "∌",
	"NotRightTriangleBar": "⧐̸",
	"NotRightTriangle": "⋫",
	"NotRightTriangleEqual": "⋭",
	"NotSquareSubset": "⊏̸",
	"NotSquareSubsetEqual": "⋢",
	"NotSquareSuperset": "⊐̸",
	"NotSquareSupersetEqual": "⋣",
	"NotSubset": "⊂⃒",
	"NotSubsetEqual": "⊈",
	"NotSucceeds": "⊁",
	"NotSucceedsEqual": "⪰̸",
	"NotSucceedsSlantEqual": "⋡",
	"NotSucceedsTilde": "≿̸",
	"NotSuperset": "⊃⃒",
	"NotSupersetEqual": "⊉",
	"NotTilde": "≁",
	"NotTildeEqual": "≄",
	"NotTildeFullEqual": "≇",
	"NotTildeTilde": "≉",
	"NotVerticalBar": "∤",
	"nparallel": "∦",
	"npar": "∦",
	"nparsl": "⫽⃥",
	"npart": "∂̸",
	"npolint": "⨔",
	"npr": "⊀",
	"nprcue": "⋠",
	"nprec": "⊀",
	"npreceq": "⪯̸",
	"npre": "⪯̸",
	"nrarrc": "⤳̸",
	"nrarr": "↛",
	"nrArr": "⇏",
	"nrarrw": "↝̸",
	"nrightarrow": "↛",
	"nRightarrow": "⇏",
	"nrtri": "⋫",
	"nrtrie": "⋭",
	"nsc": "⊁",
	"nsccue": "⋡",
	"nsce": "⪰̸",
	"Nscr": "𝒩",
	"nscr": "𝓃",
	"nshortmid": "∤",
	"nshortparallel": "∦",
	"nsim": "≁",
	"nsime": "≄",
	"nsimeq": "≄",
	"nsmid": "∤",
	"nspar": "∦",
	"nsqsube": "⋢",
	"nsqsupe": "⋣",
	"nsub": "⊄",
	"nsubE": "⫅̸",
	"nsube": "⊈",
	"nsubset": "⊂⃒",
	"nsubseteq": "⊈",
	"nsubseteqq": "⫅̸",
	"nsucc": "⊁",
	"nsucceq": "⪰̸",
	"nsup": "⊅",
	"nsupE": "⫆̸",
	"nsupe": "⊉",
	"nsupset": "⊃⃒",
	"nsupseteq": "⊉",
	"nsupseteqq": "⫆̸",
	"ntgl": "≹",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"ntlg": "≸",
	"ntriangleleft": "⋪",
	"ntrianglelefteq": "⋬",
	"ntriangleright": "⋫",
	"ntrianglerighteq": "⋭",
	"Nu": "Ν",
	"nu": "ν",
	"num": "#",
	"numero": "№",
	"numsp": " ",
	"nvap": "≍⃒",
	"nvdash": "⊬",
	"nvDash": "⊭",
	"nVdash": "⊮",
	"nVDash": "⊯",
	"nvge": "≥⃒",
	"nvgt": ">⃒",
	"nvHarr": "⤄",
	"nvinfin": "⧞",
	"nvlArr": "⤂",
	"nvle": "≤⃒",
	"nvlt": "<⃒",
	"nvltrie": "⊴⃒",
	"nvrArr": "⤃",
	"nvrtrie": "⊵⃒",
	"nvsim": "∼⃒",
	"nwarhk": "⤣",
	"nwarr": "↖",
	"nwArr": "⇖",
	"nwarrow": "↖",
	"nwnear": "⤧",
	"Oacute": "Ó",
	"oacute": "ó",
	"oast": "⊛",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"ocir": "⊚",
	"Ocy": "О",
	"ocy": "о",
	"odash": "⊝",
	"Odblac": "Ő",
	"odblac": "ő",
	"odiv": "⨸",
	"odot": "⊙",
	"odsold": "⦼",
	"OElig": "Œ",
	"oelig": "œ",
	"ofcir": "⦿",
	"Ofr": "𝔒",
	"ofr": "𝔬",
	"ogon": "˛",
	"Ograve": "Ò",
	"ograve": "ò",
	"ogt": "⧁",
	"ohbar": "⦵",
	"ohm": "Ω",
	"oint": "∮",
	"olarr": "↺",
	"olcir": "⦾",
	"olcross": "⦻",
	"oline": "‾",
	"olt": "⧀",
	"Omacr": "Ō",
	"omacr": "ō",
	"Omega": "Ω",
	"omega": "ω",
	"Omicron": "Ο",
	"omicron": "ο",
	"omid": "⦶",
	"ominus": "⊖",
	"Oopf": "𝕆",
	"oopf": "𝕠",
	"opar": "⦷",
	"OpenCurlyDoubleQuote": "“",
	"OpenCurlyQuote": "‘",
	"operp": "⦹",
	"oplus": "⊕",
	"orarr": "↻",
	"Or": "⩔",
	"or": "∨",
	"ord": "⩝",
	"order": "ℴ",
	"orderof": "ℴ",
	"ordf": "ª",
	"ordm": "º",
	"origof": "⊶",
	"oror": "⩖",
	"orslope": "⩗",
	"orv": "⩛",
	"oS": "Ⓢ",
	"Oscr": "𝒪",
	"oscr": "ℴ",
	"Oslash": "Ø",
	"oslash": "ø",
	"osol": "⊘",
	"Otilde": "Õ",
	"otilde": "õ",
	"otimesas": "⨶",
	"Otimes": "⨷",
	"otimes": "⊗",
	"Ouml": "Ö",
	"ouml": "ö",
	"ovbar": "⌽",
	"OverBar": "‾",
	"OverBrace": "⏞",
	"OverBracket": "⎴",
	"OverParenthesis": "⏜",
	"para": "¶",
	"parallel": "∥",
	"par": "∥",
	"parsim": "⫳",
	"parsl": "⫽",
	"part": "∂",
	"PartialD": "∂",
	"Pcy": "П",
	"pcy": "п",
	"percnt": "%",
	"period": ".",
	"permil": "‰",
	"perp": "⊥",
	"pertenk": "‱",
	"Pfr": "𝔓",
	"pfr": "𝔭",
	"Phi": "Φ",
	"phi": "φ",
	"phiv": "ϕ",
	"phmmat": "ℳ",
	"phone": "☎",
	"Pi": "Π",
	"pi": "π",
	"pitchfork": "⋔",
	"piv": "ϖ",
	"planck": "ℏ",
	"planckh": "ℎ",
	"plankv": "ℏ",
	"plusacir": "⨣",
	"plusb": "⊞",
	"pluscir": "⨢",
	"plus": "+",
	"plusdo": "∔",
	"plusdu": "⨥",
	"pluse": "⩲",
	"PlusMinus": "±",
	"plusmn": "±",
	"plussim": "⨦",
	"plustwo": "⨧",
	"pm": "±",
	"Poincareplane": "ℌ",
	"pointint": "⨕",
	"popf": "𝕡",
	"Popf": "ℙ",
	"pound": "£",
	"prap": "⪷",
	"Pr": "⪻",
	"pr": "≺",
	"prcue": "≼",
	"precapprox": "⪷",
	"prec": "≺",
	"preccurlyeq": "≼",
	"Precedes": "≺",
	"PrecedesEqual": "⪯",
	"PrecedesSlantEqual": "≼",
	"PrecedesTilde": "≾",
	"preceq": "⪯",
	"precnapprox": "⪹",
	"precneqq": "⪵",
	"precnsim": "⋨",
	"pre": "⪯",
	"prE": "⪳",
	"precsim": "≾",
	"prime": "′",
	"Prime": "″",
	"primes": "ℙ",
	"prnap": "⪹",
	"prnE": "⪵",
	"prnsim": "⋨",
	"prod": "∏",
	"Product": "∏",
	"profalar": "⌮",
	"profline": "⌒",
	"profsurf": "⌓",
	"prop": "∝",
	"Proportional": "∝",
	"Proportion": "∷",
	"propto": "∝",
	"prsim": "≾",
	"prurel": "⊰",
	"Pscr": "𝒫",
	"pscr": "𝓅",
	"Psi": "Ψ",
	"psi": "ψ",
	"puncsp": " ",
	"Qfr": "𝔔",
	"qfr": "𝔮",
	"qint": "⨌",
	"qopf": "𝕢",
	"Qopf": "ℚ",
	"qprime": "⁗",
	"Qscr": "𝒬",
	"qscr": "𝓆",
	"quaternions": "ℍ",
	"quatint": "⨖",
	"quest": "?",
	"questeq": "≟",
	"quot": "\"",
	"QUOT": "\"",
	"rAarr": "⇛",
	"race": "∽̱",
	"Racute": "Ŕ",
	"racute": "ŕ",
	"radic": "√",
	"raemptyv": "⦳",
	"rang": "⟩",
	"Rang": "⟫",
	"rangd": "⦒",
	"range": "⦥",
	"rangle": "⟩",
	"raquo": "»",
	"rarrap": "⥵",
	"rarrb": "⇥",
	"rarrbfs": "⤠",
	"rarrc": "⤳",
	"rarr": "→",
	"Rarr": "↠",
	"rArr": "⇒",
	"rarrfs": "⤞",
	"rarrhk": "↪",
	"rarrlp": "↬",
	"rarrpl": "⥅",
	"rarrsim": "⥴",
	"Rarrtl": "⤖",
	"rarrtl": "↣",
	"rarrw": "↝",
	"ratail": "⤚",
	"rAtail": "⤜",
	"ratio": "∶",
	"rationals": "ℚ",
	"rbarr": "⤍",
	"rBarr": "⤏",
	"RBarr": "⤐",
	"rbbrk": "❳",
	"rbrace": "}",
	"rbrack": "]",
	"rbrke": "⦌",
	"rbrksld": "⦎",
	"rbrkslu": "⦐",
	"Rcaron": "Ř",
	"rcaron": "ř",
	"Rcedil": "Ŗ",
	"rcedil": "ŗ",
	"rceil": "⌉",
	"rcub": "}",
	"Rcy": "Р",
	"rcy": "р",
	"rdca": "⤷",
	"rdldhar": "⥩",
	"rdquo": "”",
	"rdquor": "”",
	"rdsh": "↳",
	"real": "ℜ",
	"realine": "ℛ",
	"realpart": "ℜ",
	"reals": "ℝ",
	"Re": "ℜ",
	"rect": "▭",
	"reg": "®",
	"REG": "®",
	"ReverseElement": "∋",
	"ReverseEquilibrium": "⇋",
	"ReverseUpEquilibrium": "⥯",
	"rfisht": "⥽",
	"rfloor": "⌋",
	"rfr": "𝔯",
	"Rfr": "ℜ",
	"rHar": "⥤",
	"rhard": "⇁",
	"rharu": "⇀",
	"rharul": "⥬",
	"Rho": "Ρ",
	"rho": "ρ",
	"rhov": "ϱ",
	"RightAngleBracket": "⟩",
	"RightArrowBar": "⇥",
	"rightarrow": "→",
	"RightArrow": "→",
	"Rightarrow": "⇒",
	"RightArrowLeftArrow": "⇄",
	"rightarrowtail": "↣",
	"RightCeiling": "⌉",
	"RightDoubleBracket": "⟧",
	"RightDownTeeVector": "⥝",
	"RightDownVectorBar": "⥕",
	"RightDownVector": "⇂",
	"RightFloor": "⌋",
	"rightharpoondown": "⇁",
	"rightharpoonup": "⇀",
	"rightleftarrows": "⇄",
	"rightleftharpoons": "⇌",
	"rightrightarrows": "⇉",
	"rightsquigarrow": "↝",
	"RightTeeArrow": "↦",
	"RightTee": "⊢",
	"RightTeeVector": "⥛",
	"rightthreetimes": "⋌",
	"RightTriangleBar": "⧐",
	"RightTriangle": "⊳",
	"RightTriangleEqual": "⊵",
	"RightUpDownVector": "⥏",
	"RightUpTeeVector": "⥜",
	"RightUpVectorBar": "⥔",
	"RightUpVector": "↾",
	"RightVectorBar": "⥓",
	"RightVector": "⇀",
	"ring": "˚",
	"risingdotseq": "≓",
	"rlarr": "⇄",
	"rlhar": "⇌",
	"rlm": "‏",
	"rmoustache": "⎱",
	"rmoust": "⎱",
	"rnmid": "⫮",
	"roang": "⟭",
	"roarr": "⇾",
	"robrk": "⟧",
	"ropar": "⦆",
	"ropf": "𝕣",
	"Ropf": "ℝ",
	"roplus": "⨮",
	"rotimes": "⨵",
	"RoundImplies": "⥰",
	"rpar": ")",
	"rpargt": "⦔",
	"rppolint": "⨒",
	"rrarr": "⇉",
	"Rrightarrow": "⇛",
	"rsaquo": "›",
	"rscr": "𝓇",
	"Rscr": "ℛ",
	"rsh": "↱",
	"Rsh": "↱",
	"rsqb": "]",
	"rsquo": "’",
	"rsquor": "’",
	"rthree": "⋌",
	"rtimes": "⋊",
	"rtri": "▹",
	"rtrie": "⊵",
	"rtrif": "▸",
	"rtriltri": "⧎",
	"RuleDelayed": "⧴",
	"ruluhar": "⥨",
	"rx": "℞",
	"Sacute": "Ś",
	"sacute": "ś",
	"sbquo": "‚",
	"scap": "⪸",
	"Scaron": "Š",
	"scaron": "š",
	"Sc": "⪼",
	"sc": "≻",
	"sccue": "≽",
	"sce": "⪰",
	"scE": "⪴",
	"Scedil": "Ş",
	"scedil": "ş",
	"Scirc": "Ŝ",
	"scirc": "ŝ",
	"scnap": "⪺",
	"scnE": "⪶",
	"scnsim": "⋩",
	"scpolint": "⨓",
	"scsim": "≿",
	"Scy": "С",
	"scy": "с",
	"sdotb": "⊡",
	"sdot": "⋅",
	"sdote": "⩦",
	"searhk": "⤥",
	"searr": "↘",
	"seArr": "⇘",
	"searrow": "↘",
	"sect": "§",
	"semi": ";",
	"seswar": "⤩",
	"setminus": "∖",
	"setmn": "∖",
	"sext": "✶",
	"Sfr": "𝔖",
	"sfr": "𝔰",
	"sfrown": "⌢",
	"sharp": "♯",
	"SHCHcy": "Щ",
	"shchcy": "щ",
	"SHcy": "Ш",
	"shcy": "ш",
	"ShortDownArrow": "↓",
	"ShortLeftArrow": "←",
	"shortmid": "∣",
	"shortparallel": "∥",
	"ShortRightArrow": "→",
	"ShortUpArrow": "↑",
	"shy": "­",
	"Sigma": "Σ",
	"sigma": "σ",
	"sigmaf": "ς",
	"sigmav": "ς",
	"sim": "∼",
	"simdot": "⩪",
	"sime": "≃",
	"simeq": "≃",
	"simg": "⪞",
	"simgE": "⪠",
	"siml": "⪝",
	"simlE": "⪟",
	"simne": "≆",
	"simplus": "⨤",
	"simrarr": "⥲",
	"slarr": "←",
	"SmallCircle": "∘",
	"smallsetminus": "∖",
	"smashp": "⨳",
	"smeparsl": "⧤",
	"smid": "∣",
	"smile": "⌣",
	"smt": "⪪",
	"smte": "⪬",
	"smtes": "⪬︀",
	"SOFTcy": "Ь",
	"softcy": "ь",
	"solbar": "⌿",
	"solb": "⧄",
	"sol": "/",
	"Sopf": "𝕊",
	"sopf": "𝕤",
	"spades": "♠",
	"spadesuit": "♠",
	"spar": "∥",
	"sqcap": "⊓",
	"sqcaps": "⊓︀",
	"sqcup": "⊔",
	"sqcups": "⊔︀",
	"Sqrt": "√",
	"sqsub": "⊏",
	"sqsube": "⊑",
	"sqsubset": "⊏",
	"sqsubseteq": "⊑",
	"sqsup": "⊐",
	"sqsupe": "⊒",
	"sqsupset": "⊐",
	"sqsupseteq": "⊒",
	"square": "□",
	"Square": "□",
	"SquareIntersection": "⊓",
	"SquareSubset": "⊏",
	"SquareSubsetEqual": "⊑",
	"SquareSuperset": "⊐",
	"SquareSupersetEqual": "⊒",
	"SquareUnion": "⊔",
	"squarf": "▪",
	"squ": "□",
	"squf": "▪",
	"srarr": "→",
	"Sscr": "𝒮",
	"sscr": "𝓈",
	"ssetmn": "∖",
	"ssmile": "⌣",
	"sstarf": "⋆",
	"Star": "⋆",
	"star": "☆",
	"starf": "★",
	"straightepsilon": "ϵ",
	"straightphi": "ϕ",
	"strns": "¯",
	"sub": "⊂",
	"Sub": "⋐",
	"subdot": "⪽",
	"subE": "⫅",
	"sube": "⊆",
	"subedot": "⫃",
	"submult": "⫁",
	"subnE": "⫋",
	"subne": "⊊",
	"subplus": "⪿",
	"subrarr": "⥹",
	"subset": "⊂",
	"Subset": "⋐",
	"subseteq": "⊆",
	"subseteqq": "⫅",
	"SubsetEqual": "⊆",
	"subsetneq": "⊊",
	"subsetneqq": "⫋",
	"subsim": "⫇",
	"subsub": "⫕",
	"subsup": "⫓",
	"succapprox": "⪸",
	"succ": "≻",
	"succcurlyeq": "≽",
	"Succeeds": "≻",
	"SucceedsEqual": "⪰",
	"SucceedsSlantEqual": "≽",
	"SucceedsTilde": "≿",
	"succeq": "⪰",
	"succnapprox": "⪺",
	"succneqq": "⪶",
	"succnsim": "⋩",
	"succsim": "≿",
	"SuchThat": "∋",
	"sum": "∑",
	"Sum": "∑",
	"sung": "♪",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"sup": "⊃",
	"Sup": "⋑",
	"supdot": "⪾",
	"supdsub": "⫘",
	"supE": "⫆",
	"supe": "⊇",
	"supedot": "⫄",
	"Superset": "⊃",
	"SupersetEqual": "⊇",
	"suphsol": "⟉",
	"suphsub": "⫗",
	"suplarr": "⥻",
	"supmult": "⫂",
	"supnE": "⫌",
	"supne": "⊋",
	"supplus": "⫀",
	"supset": "⊃",
	"Supset": "⋑",
	"supseteq": "⊇",
	"supseteqq": "⫆",
	"supsetneq": "⊋",
	"supsetneqq": "⫌",
	"supsim": "⫈",
	"supsub": "⫔",
	"supsup": "⫖",
	"swarhk": "⤦",
	"swarr": "↙",
	"swArr": "⇙",
	"swarrow": "↙",
	"swnwar": "⤪",
	"szlig": "ß",
	"Tab": "\t",
	"target": "⌖",
	"Tau": "Τ",
	"tau": "τ",
	"tbrk": "⎴",
	"Tcaron": "Ť",
	"tcaron": "ť",
	"Tcedil": "Ţ",
	"tcedil": "ţ",
	"Tcy": "Т",
	"tcy": "т",
	"tdot": "⃛",
	"telrec": "⌕",
	"Tfr": "𝔗",
	"tfr": "𝔱",
	"there4": "∴",
	"therefore": "∴",
	"Therefore": "∴",
	"Theta": "Θ",
	"theta": "θ",
	"thetasym": "ϑ",
	"thetav": "ϑ",
	"thickapprox": "≈",
	"thicksim": "∼",
	"ThickSpace": "  ",
	"ThinSpace": " ",
	"thinsp": " ",
	"thkap": "≈",
	"thksim": "∼",
	"THORN": "Þ",
	"thorn": "þ",
	"tilde": "˜",
	"Tilde": "∼",
	"TildeEqual": "≃",
	"TildeFullEqual": "≅",
	"TildeTilde": "≈",
	"timesbar": "⨱",
	"timesb": "⊠",
	"times": "×",
	"timesd": "⨰",
	"tint": "∭",
	"toea": "⤨",
	"topbot": "⌶",
	"topcir": "⫱",
	"top": "⊤",
	"Topf": "𝕋",
	"topf": "𝕥",
	"topfork": "⫚",
	"tosa": "⤩",
	"tprime": "‴",
	"trade": "™",
	"TRADE": "™",
	"triangle": "▵",
	"triangledown": "▿",
	"triangleleft": "◃",
	"trianglelefteq": "⊴",
	"triangleq": "≜",
	"triangleright": "▹",
	"trianglerighteq": "⊵",
	"tridot": "◬",
	"trie": "≜",
	"triminus": "⨺",
	"TripleDot": "⃛",
	"triplus": "⨹",
	"trisb": "⧍",
	"tritime": "⨻",
	"trpezium": "⏢",
	"Tscr": "𝒯",
	"tscr": "𝓉",
	"TScy": "Ц",
	"tscy": "ц",
	"TSHcy": "Ћ",
	"tshcy": "ћ",
	"Tstrok": "Ŧ",
	"tstrok": "ŧ",
	"twixt": "≬",
	"twoheadleftarrow": "↞",
	"twoheadrightarrow": "↠",
	"Uacute": "Ú",
	"uacute": "ú",
	"uarr": "↑",
	"Uarr": "↟",
	"uArr": "⇑",
	"Uarrocir": "⥉",
	"Ubrcy": "Ў",
	"ubrcy": "ў",
	"Ubreve": "Ŭ",
	"ubreve": "ŭ",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ucy": "У",
	"ucy": "у",
	"udarr": "⇅",
	"Udblac": "Ű",
	"udblac": "ű",
	"udhar": "⥮",
	"ufisht": "⥾",
	"Ufr": "𝔘",
	"ufr": "𝔲",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uHar": "⥣",
	"uharl": "↿",
	"uharr": "↾",
	"uhblk": "▀",
	"ulcorn": "⌜",
	"ulcorner": "⌜",
	"ulcrop": "⌏",
	"ultri": "◸",
	"Umacr": "Ū",
	"umacr": "ū",
	"uml": "¨",
	"UnderBar": "_",
	"UnderBrace": "⏟",
	"UnderBracket": "⎵",
	"UnderParenthesis": "⏝",
	"Union": "⋃",
	"UnionPlus": "⊎",
	"Uogon": "Ų",
	"uogon": "ų",
	"Uopf": "𝕌",
	"uopf": "𝕦",
	"UpArrowBar": "⤒",
	"uparrow": "↑",
	"UpArrow": "↑",
	"Uparrow": "⇑",
	"UpArrowDownArrow": "⇅",
	"updownarrow": "↕",
	"UpDownArrow": "↕",
	"Updownarrow": "⇕",
	"UpEquilibrium": "⥮",
	"upharpoonleft": "↿",
	"upharpoonright": "↾",
	"uplus": "⊎",
	"UpperLeftArrow": "↖",
	"UpperRightArrow": "↗",
	"upsi": "υ",
	"Upsi": "ϒ",
	"upsih": "ϒ",
	"Upsilon": "Υ",
	"upsilon": "υ",
	"UpTeeArrow": "↥",
	"UpTee": "⊥",
	"upuparrows": "⇈",
	"urcorn": "⌝",
	"urcorner": "⌝",
	"urcrop": "⌎",
	"Uring": "Ů",
	"uring": "ů",
	"urtri": "◹",
	"Uscr": "𝒰",
	"uscr": "𝓊",
	"utdot": "⋰",
	"Utilde": "Ũ",
	"utilde": "ũ",
	"utri": "▵",
	"utrif": "▴",
	"uuarr": "⇈",
	"Uuml": "Ü",
	"uuml": "ü",
	"uwangle": "⦧",
	"vangrt": "⦜",
	"varepsilon": "ϵ",
	"varkappa": "ϰ",
	"varnothing": "∅",
	"varphi": "ϕ",
	"varpi": "ϖ",
	"varpropto": "∝",
	"varr": "↕",
	"vArr": "⇕",
	"varrho": "ϱ",
	"varsigma": "ς",
	"varsubsetneq": "⊊︀",
	"varsubsetneqq": "⫋︀",
	"varsupsetneq": "⊋︀",
	"varsupsetneqq": "⫌︀",
	"vartheta": "ϑ",
	"vartriangleleft": "⊲",
	"vartriangleright": "⊳",
	"vBar": "⫨",
	"Vbar": "⫫",
	"vBarv": "⫩",
	"Vcy": "В",
	"vcy": "в",
	"vdash": "⊢",
	"vDash": "⊨",
	"Vdash": "⊩",
	"VDash": "⊫",
	"Vdashl": "⫦",
	"veebar": "⊻",
	"vee": "∨",
	"Vee": "⋁",
	"veeeq": "≚",
	"vellip": "⋮",
	"verbar": "|",
	"Verbar": "‖",
	"vert": "|",
	"Vert": "‖",
	"VerticalBar": "∣",
	"VerticalLine": "|",
	"VerticalSeparator": "❘",
	"VerticalTilde": "≀",
	"VeryThinSpace": " ",
	"Vfr": "𝔙",
	"vfr": "𝔳",
	"vltri": "⊲",
	"vnsub": "⊂⃒",
	"vnsup": "⊃⃒",
	"Vopf": "𝕍",
	"vopf": "𝕧",
	"vprop": "∝",
	"vrtri": "⊳",
	"Vscr": "𝒱",
	"vscr": "𝓋",
	"vsubnE": "⫋︀",
	"vsubne": "⊊︀",
	"vsupnE": "⫌︀",
	"vsupne": "⊋︀",
	"Vvdash": "⊪",
	"vzigzag": "⦚",
	"Wcirc": "Ŵ",
	"wcirc": "ŵ",
	"wedbar": "⩟",
	"wedge": "∧",
	"Wedge": "⋀",
	"wedgeq": "≙",
	"weierp": "℘",
	"Wfr": "𝔚",
	"wfr": "𝔴",
	"Wopf": "𝕎",
	"wopf": "𝕨",
	"wp": "℘",
	"wr": "≀",
	"wreath": "≀",
	"Wscr": "𝒲",
	"wscr": "𝓌",
	"xcap": "⋂",
	"xcirc": "◯",
	"xcup": "⋃",
	"xdtri": "▽",
	"Xfr": "𝔛",
	"xfr": "𝔵",
	"xharr": "⟷",
	"xhArr": "⟺",
	"Xi": "Ξ",
	"xi": "ξ",
	"xlarr": "⟵",
	"xlArr": "⟸",
	"xmap": "⟼",
	"xnis": "⋻",
	"xodot": "⨀",
	"Xopf": "𝕏",
	"xopf": "𝕩",
	"xoplus": "⨁",
	"xotime": "⨂",
	"xrarr": "⟶",
	"xrArr": "⟹",
	"Xscr": "𝒳",
	"xscr": "𝓍",
	"xsqcup": "⨆",
	"xuplus": "⨄",
	"xutri": "△",
	"xvee": "⋁",
	"xwedge": "⋀",
	"Yacute": "Ý",
	"yacute": "ý",
	"YAcy": "Я",
	"yacy": "я",
	"Ycirc": "Ŷ",
	"ycirc": "ŷ",
	"Ycy": "Ы",
	"ycy": "ы",
	"yen": "¥",
	"Yfr": "𝔜",
	"yfr": "𝔶",
	"YIcy": "Ї",
	"yicy": "ї",
	"Yopf": "𝕐",
	"yopf": "𝕪",
	"Yscr": "𝒴",
	"yscr": "𝓎",
	"YUcy": "Ю",
	"yucy": "ю",
	"yuml": "ÿ",
	"Yuml": "Ÿ",
	"Zacute": "Ź",
	"zacute": "ź",
	"Zcaron": "Ž",
	"zcaron": "ž",
	"Zcy": "З",
	"zcy": "з",
	"Zdot": "Ż",
	"zdot": "ż",
	"zeetrf": "ℨ",
	"ZeroWidthSpace": "​",
	"Zeta": "Ζ",
	"zeta": "ζ",
	"zfr": "𝔷",
	"Zfr": "ℨ",
	"ZHcy": "Ж",
	"zhcy": "ж",
	"zigrarr": "⇝",
	"zopf": "𝕫",
	"Zopf": "ℤ",
	"Zscr": "𝒵",
	"zscr": "𝓏",
	"zwj": "‍",
	"zwnj": "‌"
};

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var Tokenizer = __webpack_require__(346);

/*
	Options:

	xmlMode: Disables the special behavior for script/style tags (false by default)
	lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
	lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
*/

/*
	Callbacks:

	oncdataend,
	oncdatastart,
	onclosetag,
	oncomment,
	oncommentend,
	onerror,
	onopentag,
	onprocessinginstruction,
	onreset,
	ontext
*/

var formTags = {
	input: true,
	option: true,
	optgroup: true,
	select: true,
	button: true,
	datalist: true,
	textarea: true
};

var openImpliesClose = {
	tr      : { tr:true, th:true, td:true },
	th      : { th:true },
	td      : { thead:true, th:true, td:true },
	body    : { head:true, link:true, script:true },
	li      : { li:true },
	p       : { p:true },
	h1      : { p:true },
	h2      : { p:true },
	h3      : { p:true },
	h4      : { p:true },
	h5      : { p:true },
	h6      : { p:true },
	select  : formTags,
	input   : formTags,
	output  : formTags,
	button  : formTags,
	datalist: formTags,
	textarea: formTags,
	option  : { option:true },
	optgroup: { optgroup:true }
};

var voidElements = {
	__proto__: null,
	area: true,
	base: true,
	basefont: true,
	br: true,
	col: true,
	command: true,
	embed: true,
	frame: true,
	hr: true,
	img: true,
	input: true,
	isindex: true,
	keygen: true,
	link: true,
	meta: true,
	param: true,
	source: true,
	track: true,
	wbr: true,

	//common self closing svg elements
	path: true,
	circle: true,
	ellipse: true,
	line: true,
	rect: true,
	use: true,
	stop: true,
	polyline: true,
	polygon: true
};

var re_nameEnd = /\s|\//;

function Parser(cbs, options){
	this._options = options || {};
	this._cbs = cbs || {};

	this._tagname = "";
	this._attribname = "";
	this._attribvalue = "";
	this._attribs = null;
	this._stack = [];

	this.startIndex = 0;
	this.endIndex = null;

	this._lowerCaseTagNames = "lowerCaseTags" in this._options ?
									!!this._options.lowerCaseTags :
									!this._options.xmlMode;
	this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ?
									!!this._options.lowerCaseAttributeNames :
									!this._options.xmlMode;

	if(this._options.Tokenizer) {
		Tokenizer = this._options.Tokenizer;
	}
	this._tokenizer = new Tokenizer(this._options, this);

	if(this._cbs.onparserinit) this._cbs.onparserinit(this);
}

__webpack_require__(50)(Parser, __webpack_require__(273).EventEmitter);

Parser.prototype._updatePosition = function(initialOffset){
	if(this.endIndex === null){
		if(this._tokenizer._sectionStart <= initialOffset){
			this.startIndex = 0;
		} else {
			this.startIndex = this._tokenizer._sectionStart - initialOffset;
		}
	}
	else this.startIndex = this.endIndex + 1;
	this.endIndex = this._tokenizer.getAbsoluteIndex();
};

//Tokenizer event handlers
Parser.prototype.ontext = function(data){
	this._updatePosition(1);
	this.endIndex--;

	if(this._cbs.ontext) this._cbs.ontext(data);
};

Parser.prototype.onopentagname = function(name){
	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	this._tagname = name;

	if(!this._options.xmlMode && name in openImpliesClose) {
		for(
			var el;
			(el = this._stack[this._stack.length - 1]) in openImpliesClose[name];
			this.onclosetag(el)
		);
	}

	if(this._options.xmlMode || !(name in voidElements)){
		this._stack.push(name);
	}

	if(this._cbs.onopentagname) this._cbs.onopentagname(name);
	if(this._cbs.onopentag) this._attribs = {};
};

Parser.prototype.onopentagend = function(){
	this._updatePosition(1);

	if(this._attribs){
		if(this._cbs.onopentag) this._cbs.onopentag(this._tagname, this._attribs);
		this._attribs = null;
	}

	if(!this._options.xmlMode && this._cbs.onclosetag && this._tagname in voidElements){
		this._cbs.onclosetag(this._tagname);
	}

	this._tagname = "";
};

Parser.prototype.onclosetag = function(name){
	this._updatePosition(1);

	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	if(this._stack.length && (!(name in voidElements) || this._options.xmlMode)){
		var pos = this._stack.lastIndexOf(name);
		if(pos !== -1){
			if(this._cbs.onclosetag){
				pos = this._stack.length - pos;
				while(pos--) this._cbs.onclosetag(this._stack.pop());
			}
			else this._stack.length = pos;
		} else if(name === "p" && !this._options.xmlMode){
			this.onopentagname(name);
			this._closeCurrentTag();
		}
	} else if(!this._options.xmlMode && (name === "br" || name === "p")){
		this.onopentagname(name);
		this._closeCurrentTag();
	}
};

Parser.prototype.onselfclosingtag = function(){
	if(this._options.xmlMode || this._options.recognizeSelfClosing){
		this._closeCurrentTag();
	} else {
		this.onopentagend();
	}
};

Parser.prototype._closeCurrentTag = function(){
	var name = this._tagname;

	this.onopentagend();

	//self-closing tags will be on the top of the stack
	//(cheaper check than in onclosetag)
	if(this._stack[this._stack.length - 1] === name){
		if(this._cbs.onclosetag){
			this._cbs.onclosetag(name);
		}
		this._stack.pop();
	}
};

Parser.prototype.onattribname = function(name){
	if(this._lowerCaseAttributeNames){
		name = name.toLowerCase();
	}
	this._attribname = name;
};

Parser.prototype.onattribdata = function(value){
	this._attribvalue += value;
};

Parser.prototype.onattribend = function(){
	if(this._cbs.onattribute) this._cbs.onattribute(this._attribname, this._attribvalue);
	if(
		this._attribs &&
		!Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	){
		this._attribs[this._attribname] = this._attribvalue;
	}
	this._attribname = "";
	this._attribvalue = "";
};

Parser.prototype._getInstructionName = function(value){
	var idx = value.search(re_nameEnd),
	    name = idx < 0 ? value : value.substr(0, idx);

	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	return name;
};

Parser.prototype.ondeclaration = function(value){
	if(this._cbs.onprocessinginstruction){
		var name = this._getInstructionName(value);
		this._cbs.onprocessinginstruction("!" + name, "!" + value);
	}
};

Parser.prototype.onprocessinginstruction = function(value){
	if(this._cbs.onprocessinginstruction){
		var name = this._getInstructionName(value);
		this._cbs.onprocessinginstruction("?" + name, "?" + value);
	}
};

Parser.prototype.oncomment = function(value){
	this._updatePosition(4);

	if(this._cbs.oncomment) this._cbs.oncomment(value);
	if(this._cbs.oncommentend) this._cbs.oncommentend();
};

Parser.prototype.oncdata = function(value){
	this._updatePosition(1);

	if(this._options.xmlMode || this._options.recognizeCDATA){
		if(this._cbs.oncdatastart) this._cbs.oncdatastart();
		if(this._cbs.ontext) this._cbs.ontext(value);
		if(this._cbs.oncdataend) this._cbs.oncdataend();
	} else {
		this.oncomment("[CDATA[" + value + "]]");
	}
};

Parser.prototype.onerror = function(err){
	if(this._cbs.onerror) this._cbs.onerror(err);
};

Parser.prototype.onend = function(){
	if(this._cbs.onclosetag){
		for(
			var i = this._stack.length;
			i > 0;
			this._cbs.onclosetag(this._stack[--i])
		);
	}
	if(this._cbs.onend) this._cbs.onend();
};


//Resets the parser to a blank state, ready to parse a new HTML document
Parser.prototype.reset = function(){
	if(this._cbs.onreset) this._cbs.onreset();
	this._tokenizer.reset();

	this._tagname = "";
	this._attribname = "";
	this._attribs = null;
	this._stack = [];

	if(this._cbs.onparserinit) this._cbs.onparserinit(this);
};

//Parses a complete HTML document and pushes it to the handler
Parser.prototype.parseComplete = function(data){
	this.reset();
	this.end(data);
};

Parser.prototype.write = function(chunk){
	this._tokenizer.write(chunk);
};

Parser.prototype.end = function(chunk){
	this._tokenizer.end(chunk);
};

Parser.prototype.pause = function(){
	this._tokenizer.pause();
};

Parser.prototype.resume = function(){
	this._tokenizer.resume();
};

//alias for backwards compat
Parser.prototype.parseChunk = Parser.prototype.write;
Parser.prototype.done = Parser.prototype.end;

module.exports = Parser;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Tokenizer;

var decodeCodePoint = __webpack_require__(416),
    entityMap = __webpack_require__(418),
    legacyMap = __webpack_require__(419),
    xmlMap    = __webpack_require__(420),

    i = 0,

    TEXT                      = i++,
    BEFORE_TAG_NAME           = i++, //after <
    IN_TAG_NAME               = i++,
    IN_SELF_CLOSING_TAG       = i++,
    BEFORE_CLOSING_TAG_NAME   = i++,
    IN_CLOSING_TAG_NAME       = i++,
    AFTER_CLOSING_TAG_NAME    = i++,

    //attributes
    BEFORE_ATTRIBUTE_NAME     = i++,
    IN_ATTRIBUTE_NAME         = i++,
    AFTER_ATTRIBUTE_NAME      = i++,
    BEFORE_ATTRIBUTE_VALUE    = i++,
    IN_ATTRIBUTE_VALUE_DQ     = i++, // "
    IN_ATTRIBUTE_VALUE_SQ     = i++, // '
    IN_ATTRIBUTE_VALUE_NQ     = i++,

    //declarations
    BEFORE_DECLARATION        = i++, // !
    IN_DECLARATION            = i++,

    //processing instructions
    IN_PROCESSING_INSTRUCTION = i++, // ?

    //comments
    BEFORE_COMMENT            = i++,
    IN_COMMENT                = i++,
    AFTER_COMMENT_1           = i++,
    AFTER_COMMENT_2           = i++,

    //cdata
    BEFORE_CDATA_1            = i++, // [
    BEFORE_CDATA_2            = i++, // C
    BEFORE_CDATA_3            = i++, // D
    BEFORE_CDATA_4            = i++, // A
    BEFORE_CDATA_5            = i++, // T
    BEFORE_CDATA_6            = i++, // A
    IN_CDATA                  = i++, // [
    AFTER_CDATA_1             = i++, // ]
    AFTER_CDATA_2             = i++, // ]

    //special tags
    BEFORE_SPECIAL            = i++, //S
    BEFORE_SPECIAL_END        = i++,   //S

    BEFORE_SCRIPT_1           = i++, //C
    BEFORE_SCRIPT_2           = i++, //R
    BEFORE_SCRIPT_3           = i++, //I
    BEFORE_SCRIPT_4           = i++, //P
    BEFORE_SCRIPT_5           = i++, //T
    AFTER_SCRIPT_1            = i++, //C
    AFTER_SCRIPT_2            = i++, //R
    AFTER_SCRIPT_3            = i++, //I
    AFTER_SCRIPT_4            = i++, //P
    AFTER_SCRIPT_5            = i++, //T

    BEFORE_STYLE_1            = i++, //T
    BEFORE_STYLE_2            = i++, //Y
    BEFORE_STYLE_3            = i++, //L
    BEFORE_STYLE_4            = i++, //E
    AFTER_STYLE_1             = i++, //T
    AFTER_STYLE_2             = i++, //Y
    AFTER_STYLE_3             = i++, //L
    AFTER_STYLE_4             = i++, //E

    BEFORE_ENTITY             = i++, //&
    BEFORE_NUMERIC_ENTITY     = i++, //#
    IN_NAMED_ENTITY           = i++,
    IN_NUMERIC_ENTITY         = i++,
    IN_HEX_ENTITY             = i++, //X

    j = 0,

    SPECIAL_NONE              = j++,
    SPECIAL_SCRIPT            = j++,
    SPECIAL_STYLE             = j++;

function whitespace(c){
	return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}

function characterState(char, SUCCESS){
	return function(c){
		if(c === char) this._state = SUCCESS;
	};
}

function ifElseState(upper, SUCCESS, FAILURE){
	var lower = upper.toLowerCase();

	if(upper === lower){
		return function(c){
			if(c === lower){
				this._state = SUCCESS;
			} else {
				this._state = FAILURE;
				this._index--;
			}
		};
	} else {
		return function(c){
			if(c === lower || c === upper){
				this._state = SUCCESS;
			} else {
				this._state = FAILURE;
				this._index--;
			}
		};
	}
}

function consumeSpecialNameChar(upper, NEXT_STATE){
	var lower = upper.toLowerCase();

	return function(c){
		if(c === lower || c === upper){
			this._state = NEXT_STATE;
		} else {
			this._state = IN_TAG_NAME;
			this._index--; //consume the token again
		}
	};
}

function Tokenizer(options, cbs){
	this._state = TEXT;
	this._buffer = "";
	this._sectionStart = 0;
	this._index = 0;
	this._bufferOffset = 0; //chars removed from _buffer
	this._baseState = TEXT;
	this._special = SPECIAL_NONE;
	this._cbs = cbs;
	this._running = true;
	this._ended = false;
	this._xmlMode = !!(options && options.xmlMode);
	this._decodeEntities = !!(options && options.decodeEntities);
}

Tokenizer.prototype._stateText = function(c){
	if(c === "<"){
		if(this._index > this._sectionStart){
			this._cbs.ontext(this._getSection());
		}
		this._state = BEFORE_TAG_NAME;
		this._sectionStart = this._index;
	} else if(this._decodeEntities && this._special === SPECIAL_NONE && c === "&"){
		if(this._index > this._sectionStart){
			this._cbs.ontext(this._getSection());
		}
		this._baseState = TEXT;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeTagName = function(c){
	if(c === "/"){
		this._state = BEFORE_CLOSING_TAG_NAME;
	} else if(c === "<"){
		this._cbs.ontext(this._getSection());
		this._sectionStart = this._index;
	} else if(c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
		this._state = TEXT;
	} else if(c === "!"){
		this._state = BEFORE_DECLARATION;
		this._sectionStart = this._index + 1;
	} else if(c === "?"){
		this._state = IN_PROCESSING_INSTRUCTION;
		this._sectionStart = this._index + 1;
	} else {
		this._state = (!this._xmlMode && (c === "s" || c === "S")) ?
						BEFORE_SPECIAL : IN_TAG_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInTagName = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._emitToken("onopentagname");
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateBeforeCloseingTagName = function(c){
	if(whitespace(c));
	else if(c === ">"){
		this._state = TEXT;
	} else if(this._special !== SPECIAL_NONE){
		if(c === "s" || c === "S"){
			this._state = BEFORE_SPECIAL_END;
		} else {
			this._state = TEXT;
			this._index--;
		}
	} else {
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInCloseingTagName = function(c){
	if(c === ">" || whitespace(c)){
		this._emitToken("onclosetag");
		this._state = AFTER_CLOSING_TAG_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateAfterCloseingTagName = function(c){
	//skip everything until ">"
	if(c === ">"){
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateBeforeAttributeName = function(c){
	if(c === ">"){
		this._cbs.onopentagend();
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c === "/"){
		this._state = IN_SELF_CLOSING_TAG;
	} else if(!whitespace(c)){
		this._state = IN_ATTRIBUTE_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInSelfClosingTag = function(c){
	if(c === ">"){
		this._cbs.onselfclosingtag();
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(!whitespace(c)){
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateInAttributeName = function(c){
	if(c === "=" || c === "/" || c === ">" || whitespace(c)){
		this._cbs.onattribname(this._getSection());
		this._sectionStart = -1;
		this._state = AFTER_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateAfterAttributeName = function(c){
	if(c === "="){
		this._state = BEFORE_ATTRIBUTE_VALUE;
	} else if(c === "/" || c === ">"){
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	} else if(!whitespace(c)){
		this._cbs.onattribend();
		this._state = IN_ATTRIBUTE_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeAttributeValue = function(c){
	if(c === "\""){
		this._state = IN_ATTRIBUTE_VALUE_DQ;
		this._sectionStart = this._index + 1;
	} else if(c === "'"){
		this._state = IN_ATTRIBUTE_VALUE_SQ;
		this._sectionStart = this._index + 1;
	} else if(!whitespace(c)){
		this._state = IN_ATTRIBUTE_VALUE_NQ;
		this._sectionStart = this._index;
		this._index--; //reconsume token
	}
};

Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c){
	if(c === "\""){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c){
	if(c === "'"){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c){
	if(whitespace(c) || c === ">"){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeDeclaration = function(c){
	this._state = c === "[" ? BEFORE_CDATA_1 :
					c === "-" ? BEFORE_COMMENT :
						IN_DECLARATION;
};

Tokenizer.prototype._stateInDeclaration = function(c){
	if(c === ">"){
		this._cbs.ondeclaration(this._getSection());
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateInProcessingInstruction = function(c){
	if(c === ">"){
		this._cbs.onprocessinginstruction(this._getSection());
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateBeforeComment = function(c){
	if(c === "-"){
		this._state = IN_COMMENT;
		this._sectionStart = this._index + 1;
	} else {
		this._state = IN_DECLARATION;
	}
};

Tokenizer.prototype._stateInComment = function(c){
	if(c === "-") this._state = AFTER_COMMENT_1;
};

Tokenizer.prototype._stateAfterComment1 = function(c){
	if(c === "-"){
		this._state = AFTER_COMMENT_2;
	} else {
		this._state = IN_COMMENT;
	}
};

Tokenizer.prototype._stateAfterComment2 = function(c){
	if(c === ">"){
		//remove 2 trailing chars
		this._cbs.oncomment(this._buffer.substring(this._sectionStart, this._index - 2));
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c !== "-"){
		this._state = IN_COMMENT;
	}
	// else: stay in AFTER_COMMENT_2 (`--->`)
};

Tokenizer.prototype._stateBeforeCdata1 = ifElseState("C", BEFORE_CDATA_2, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata2 = ifElseState("D", BEFORE_CDATA_3, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata3 = ifElseState("A", BEFORE_CDATA_4, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata4 = ifElseState("T", BEFORE_CDATA_5, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata5 = ifElseState("A", BEFORE_CDATA_6, IN_DECLARATION);

Tokenizer.prototype._stateBeforeCdata6 = function(c){
	if(c === "["){
		this._state = IN_CDATA;
		this._sectionStart = this._index + 1;
	} else {
		this._state = IN_DECLARATION;
		this._index--;
	}
};

Tokenizer.prototype._stateInCdata = function(c){
	if(c === "]") this._state = AFTER_CDATA_1;
};

Tokenizer.prototype._stateAfterCdata1 = characterState("]", AFTER_CDATA_2);

Tokenizer.prototype._stateAfterCdata2 = function(c){
	if(c === ">"){
		//remove 2 trailing chars
		this._cbs.oncdata(this._buffer.substring(this._sectionStart, this._index - 2));
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c !== "]") {
		this._state = IN_CDATA;
	}
	//else: stay in AFTER_CDATA_2 (`]]]>`)
};

Tokenizer.prototype._stateBeforeSpecial = function(c){
	if(c === "c" || c === "C"){
		this._state = BEFORE_SCRIPT_1;
	} else if(c === "t" || c === "T"){
		this._state = BEFORE_STYLE_1;
	} else {
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	}
};

Tokenizer.prototype._stateBeforeSpecialEnd = function(c){
	if(this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")){
		this._state = AFTER_SCRIPT_1;
	} else if(this._special === SPECIAL_STYLE && (c === "t" || c === "T")){
		this._state = AFTER_STYLE_1;
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar("R", BEFORE_SCRIPT_2);
Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar("I", BEFORE_SCRIPT_3);
Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar("P", BEFORE_SCRIPT_4);
Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar("T", BEFORE_SCRIPT_5);

Tokenizer.prototype._stateBeforeScript5 = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._special = SPECIAL_SCRIPT;
	}
	this._state = IN_TAG_NAME;
	this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);

Tokenizer.prototype._stateAfterScript5 = function(c){
	if(c === ">" || whitespace(c)){
		this._special = SPECIAL_NONE;
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index - 6;
		this._index--; //reconsume the token
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar("Y", BEFORE_STYLE_2);
Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar("L", BEFORE_STYLE_3);
Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar("E", BEFORE_STYLE_4);

Tokenizer.prototype._stateBeforeStyle4 = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._special = SPECIAL_STYLE;
	}
	this._state = IN_TAG_NAME;
	this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);

Tokenizer.prototype._stateAfterStyle4 = function(c){
	if(c === ">" || whitespace(c)){
		this._special = SPECIAL_NONE;
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index - 5;
		this._index--; //reconsume the token
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeEntity = ifElseState("#", BEFORE_NUMERIC_ENTITY, IN_NAMED_ENTITY);
Tokenizer.prototype._stateBeforeNumericEntity = ifElseState("X", IN_HEX_ENTITY, IN_NUMERIC_ENTITY);

//for entities terminated with a semicolon
Tokenizer.prototype._parseNamedEntityStrict = function(){
	//offset = 1
	if(this._sectionStart + 1 < this._index){
		var entity = this._buffer.substring(this._sectionStart + 1, this._index),
		    map = this._xmlMode ? xmlMap : entityMap;

		if(map.hasOwnProperty(entity)){
			this._emitPartial(map[entity]);
			this._sectionStart = this._index + 1;
		}
	}
};


//parses legacy entities (without trailing semicolon)
Tokenizer.prototype._parseLegacyEntity = function(){
	var start = this._sectionStart + 1,
	    limit = this._index - start;

	if(limit > 6) limit = 6; //the max length of legacy entities is 6

	while(limit >= 2){ //the min length of legacy entities is 2
		var entity = this._buffer.substr(start, limit);

		if(legacyMap.hasOwnProperty(entity)){
			this._emitPartial(legacyMap[entity]);
			this._sectionStart += limit + 1;
			return;
		} else {
			limit--;
		}
	}
};

Tokenizer.prototype._stateInNamedEntity = function(c){
	if(c === ";"){
		this._parseNamedEntityStrict();
		if(this._sectionStart + 1 < this._index && !this._xmlMode){
			this._parseLegacyEntity();
		}
		this._state = this._baseState;
	} else if((c < "a" || c > "z") && (c < "A" || c > "Z") && (c < "0" || c > "9")){
		if(this._xmlMode);
		else if(this._sectionStart + 1 === this._index);
		else if(this._baseState !== TEXT){
			if(c !== "="){
				this._parseNamedEntityStrict();
			}
		} else {
			this._parseLegacyEntity();
		}

		this._state = this._baseState;
		this._index--;
	}
};

Tokenizer.prototype._decodeNumericEntity = function(offset, base){
	var sectionStart = this._sectionStart + offset;

	if(sectionStart !== this._index){
		//parse entity
		var entity = this._buffer.substring(sectionStart, this._index);
		var parsed = parseInt(entity, base);

		this._emitPartial(decodeCodePoint(parsed));
		this._sectionStart = this._index;
	} else {
		this._sectionStart--;
	}

	this._state = this._baseState;
};

Tokenizer.prototype._stateInNumericEntity = function(c){
	if(c === ";"){
		this._decodeNumericEntity(2, 10);
		this._sectionStart++;
	} else if(c < "0" || c > "9"){
		if(!this._xmlMode){
			this._decodeNumericEntity(2, 10);
		} else {
			this._state = this._baseState;
		}
		this._index--;
	}
};

Tokenizer.prototype._stateInHexEntity = function(c){
	if(c === ";"){
		this._decodeNumericEntity(3, 16);
		this._sectionStart++;
	} else if((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")){
		if(!this._xmlMode){
			this._decodeNumericEntity(3, 16);
		} else {
			this._state = this._baseState;
		}
		this._index--;
	}
};

Tokenizer.prototype._cleanup = function (){
	if(this._sectionStart < 0){
		this._buffer = "";
		this._bufferOffset += this._index;
		this._index = 0;
	} else if(this._running){
		if(this._state === TEXT){
			if(this._sectionStart !== this._index){
				this._cbs.ontext(this._buffer.substr(this._sectionStart));
			}
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else if(this._sectionStart === this._index){
			//the section just started
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else {
			//remove everything unnecessary
			this._buffer = this._buffer.substr(this._sectionStart);
			this._index -= this._sectionStart;
			this._bufferOffset += this._sectionStart;
		}

		this._sectionStart = 0;
	}
};

//TODO make events conditional
Tokenizer.prototype.write = function(chunk){
	if(this._ended) this._cbs.onerror(Error(".write() after done!"));

	this._buffer += chunk;
	this._parse();
};

Tokenizer.prototype._parse = function(){
	while(this._index < this._buffer.length && this._running){
		var c = this._buffer.charAt(this._index);
		if(this._state === TEXT) {
			this._stateText(c);
		} else if(this._state === BEFORE_TAG_NAME){
			this._stateBeforeTagName(c);
		} else if(this._state === IN_TAG_NAME) {
			this._stateInTagName(c);
		} else if(this._state === BEFORE_CLOSING_TAG_NAME){
			this._stateBeforeCloseingTagName(c);
		} else if(this._state === IN_CLOSING_TAG_NAME){
			this._stateInCloseingTagName(c);
		} else if(this._state === AFTER_CLOSING_TAG_NAME){
			this._stateAfterCloseingTagName(c);
		} else if(this._state === IN_SELF_CLOSING_TAG){
			this._stateInSelfClosingTag(c);
		}

		/*
		*	attributes
		*/
		else if(this._state === BEFORE_ATTRIBUTE_NAME){
			this._stateBeforeAttributeName(c);
		} else if(this._state === IN_ATTRIBUTE_NAME){
			this._stateInAttributeName(c);
		} else if(this._state === AFTER_ATTRIBUTE_NAME){
			this._stateAfterAttributeName(c);
		} else if(this._state === BEFORE_ATTRIBUTE_VALUE){
			this._stateBeforeAttributeValue(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_DQ){
			this._stateInAttributeValueDoubleQuotes(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_SQ){
			this._stateInAttributeValueSingleQuotes(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_NQ){
			this._stateInAttributeValueNoQuotes(c);
		}

		/*
		*	declarations
		*/
		else if(this._state === BEFORE_DECLARATION){
			this._stateBeforeDeclaration(c);
		} else if(this._state === IN_DECLARATION){
			this._stateInDeclaration(c);
		}

		/*
		*	processing instructions
		*/
		else if(this._state === IN_PROCESSING_INSTRUCTION){
			this._stateInProcessingInstruction(c);
		}

		/*
		*	comments
		*/
		else if(this._state === BEFORE_COMMENT){
			this._stateBeforeComment(c);
		} else if(this._state === IN_COMMENT){
			this._stateInComment(c);
		} else if(this._state === AFTER_COMMENT_1){
			this._stateAfterComment1(c);
		} else if(this._state === AFTER_COMMENT_2){
			this._stateAfterComment2(c);
		}

		/*
		*	cdata
		*/
		else if(this._state === BEFORE_CDATA_1){
			this._stateBeforeCdata1(c);
		} else if(this._state === BEFORE_CDATA_2){
			this._stateBeforeCdata2(c);
		} else if(this._state === BEFORE_CDATA_3){
			this._stateBeforeCdata3(c);
		} else if(this._state === BEFORE_CDATA_4){
			this._stateBeforeCdata4(c);
		} else if(this._state === BEFORE_CDATA_5){
			this._stateBeforeCdata5(c);
		} else if(this._state === BEFORE_CDATA_6){
			this._stateBeforeCdata6(c);
		} else if(this._state === IN_CDATA){
			this._stateInCdata(c);
		} else if(this._state === AFTER_CDATA_1){
			this._stateAfterCdata1(c);
		} else if(this._state === AFTER_CDATA_2){
			this._stateAfterCdata2(c);
		}

		/*
		* special tags
		*/
		else if(this._state === BEFORE_SPECIAL){
			this._stateBeforeSpecial(c);
		} else if(this._state === BEFORE_SPECIAL_END){
			this._stateBeforeSpecialEnd(c);
		}

		/*
		* script
		*/
		else if(this._state === BEFORE_SCRIPT_1){
			this._stateBeforeScript1(c);
		} else if(this._state === BEFORE_SCRIPT_2){
			this._stateBeforeScript2(c);
		} else if(this._state === BEFORE_SCRIPT_3){
			this._stateBeforeScript3(c);
		} else if(this._state === BEFORE_SCRIPT_4){
			this._stateBeforeScript4(c);
		} else if(this._state === BEFORE_SCRIPT_5){
			this._stateBeforeScript5(c);
		}

		else if(this._state === AFTER_SCRIPT_1){
			this._stateAfterScript1(c);
		} else if(this._state === AFTER_SCRIPT_2){
			this._stateAfterScript2(c);
		} else if(this._state === AFTER_SCRIPT_3){
			this._stateAfterScript3(c);
		} else if(this._state === AFTER_SCRIPT_4){
			this._stateAfterScript4(c);
		} else if(this._state === AFTER_SCRIPT_5){
			this._stateAfterScript5(c);
		}

		/*
		* style
		*/
		else if(this._state === BEFORE_STYLE_1){
			this._stateBeforeStyle1(c);
		} else if(this._state === BEFORE_STYLE_2){
			this._stateBeforeStyle2(c);
		} else if(this._state === BEFORE_STYLE_3){
			this._stateBeforeStyle3(c);
		} else if(this._state === BEFORE_STYLE_4){
			this._stateBeforeStyle4(c);
		}

		else if(this._state === AFTER_STYLE_1){
			this._stateAfterStyle1(c);
		} else if(this._state === AFTER_STYLE_2){
			this._stateAfterStyle2(c);
		} else if(this._state === AFTER_STYLE_3){
			this._stateAfterStyle3(c);
		} else if(this._state === AFTER_STYLE_4){
			this._stateAfterStyle4(c);
		}

		/*
		* entities
		*/
		else if(this._state === BEFORE_ENTITY){
			this._stateBeforeEntity(c);
		} else if(this._state === BEFORE_NUMERIC_ENTITY){
			this._stateBeforeNumericEntity(c);
		} else if(this._state === IN_NAMED_ENTITY){
			this._stateInNamedEntity(c);
		} else if(this._state === IN_NUMERIC_ENTITY){
			this._stateInNumericEntity(c);
		} else if(this._state === IN_HEX_ENTITY){
			this._stateInHexEntity(c);
		}

		else {
			this._cbs.onerror(Error("unknown _state"), this._state);
		}

		this._index++;
	}

	this._cleanup();
};

Tokenizer.prototype.pause = function(){
	this._running = false;
};
Tokenizer.prototype.resume = function(){
	this._running = true;

	if(this._index < this._buffer.length){
		this._parse();
	}
	if(this._ended){
		this._finish();
	}
};

Tokenizer.prototype.end = function(chunk){
	if(this._ended) this._cbs.onerror(Error(".end() after done!"));
	if(chunk) this.write(chunk);

	this._ended = true;

	if(this._running) this._finish();
};

Tokenizer.prototype._finish = function(){
	//if there is remaining data, emit it in a reasonable way
	if(this._sectionStart < this._index){
		this._handleTrailingData();
	}

	this._cbs.onend();
};

Tokenizer.prototype._handleTrailingData = function(){
	var data = this._buffer.substr(this._sectionStart);

	if(this._state === IN_CDATA || this._state === AFTER_CDATA_1 || this._state === AFTER_CDATA_2){
		this._cbs.oncdata(data);
	} else if(this._state === IN_COMMENT || this._state === AFTER_COMMENT_1 || this._state === AFTER_COMMENT_2){
		this._cbs.oncomment(data);
	} else if(this._state === IN_NAMED_ENTITY && !this._xmlMode){
		this._parseLegacyEntity();
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(this._state === IN_NUMERIC_ENTITY && !this._xmlMode){
		this._decodeNumericEntity(2, 10);
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(this._state === IN_HEX_ENTITY && !this._xmlMode){
		this._decodeNumericEntity(3, 16);
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(
		this._state !== IN_TAG_NAME &&
		this._state !== BEFORE_ATTRIBUTE_NAME &&
		this._state !== BEFORE_ATTRIBUTE_VALUE &&
		this._state !== AFTER_ATTRIBUTE_NAME &&
		this._state !== IN_ATTRIBUTE_NAME &&
		this._state !== IN_ATTRIBUTE_VALUE_SQ &&
		this._state !== IN_ATTRIBUTE_VALUE_DQ &&
		this._state !== IN_ATTRIBUTE_VALUE_NQ &&
		this._state !== IN_CLOSING_TAG_NAME
	){
		this._cbs.ontext(data);
	}
	//else, ignore remaining data
	//TODO add a way to remove current tag
};

Tokenizer.prototype.reset = function(){
	Tokenizer.call(this, {xmlMode: this._xmlMode, decodeEntities: this._decodeEntities}, this._cbs);
};

Tokenizer.prototype.getAbsoluteIndex = function(){
	return this._bufferOffset + this._index;
};

Tokenizer.prototype._getSection = function(){
	return this._buffer.substring(this._sectionStart, this._index);
};

Tokenizer.prototype._emitToken = function(name){
	this._cbs[name](this._getSection());
	this._sectionStart = -1;
};

Tokenizer.prototype._emitPartial = function(value){
	if(this._baseState !== TEXT){
		this._cbs.onattribdata(value); //TODO implement the new event
	} else {
		this._cbs.ontext(value);
	}
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(345),
    WritableStream = __webpack_require__(277).Writable || __webpack_require__(430).Writable,
    StringDecoder = __webpack_require__(298).StringDecoder,
    Buffer = __webpack_require__(45).Buffer;

function Stream(cbs, options){
	var parser = this._parser = new Parser(cbs, options);
	var decoder = this._decoder = new StringDecoder();

	WritableStream.call(this, {decodeStrings: false});

	this.once("finish", function(){
		parser.end(decoder.end());
	});
}

__webpack_require__(50)(Stream, WritableStream);

WritableStream.prototype._write = function(chunk, encoding, cb){
	if(chunk instanceof Buffer) chunk = this._decoder.write(chunk);
	this._parser.write(chunk);
	cb();
};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// This object will be used as the prototype for Nodes when creating a
// DOM-Level-1-compliant structure.
var NodePrototype = module.exports = {
	get firstChild() {
		var children = this.children;
		return children && children[0] || null;
	},
	get lastChild() {
		var children = this.children;
		return children && children[children.length - 1] || null;
	},
	get nodeType() {
		return nodeTypes[this.type] || nodeTypes.element;
	}
};

var domLvl1 = {
	tagName: "name",
	childNodes: "children",
	parentNode: "parent",
	previousSibling: "prev",
	nextSibling: "next",
	nodeValue: "data"
};

var nodeTypes = {
	element: 1,
	text: 3,
	cdata: 4,
	comment: 8
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(NodePrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(299);

/*<replacement>*/
var util = __webpack_require__(265);
util.inherits = __webpack_require__(50);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

module.exports = Readable;

/*<replacement>*/
var processNextTick = __webpack_require__(297);
/*</replacement>*/

/*<replacement>*/
var isArray = __webpack_require__(423);
/*</replacement>*/

/*<replacement>*/
var Buffer = __webpack_require__(45).Buffer;
/*</replacement>*/

Readable.ReadableState = ReadableState;

var EE = __webpack_require__(273);

/*<replacement>*/
var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = __webpack_require__(277);
  } catch (_) {} finally {
    if (!Stream) Stream = __webpack_require__(273).EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = __webpack_require__(45).Buffer;

/*<replacement>*/
var util = __webpack_require__(265);
util.inherits = __webpack_require__(50);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(431);
var debug = undefined;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var StringDecoder;

util.inherits(Readable, Stream);

var Duplex;
function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(98);

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  this.buffer = [];
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(298).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

var Duplex;
function Readable(options) {
  Duplex = Duplex || __webpack_require__(98);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options && typeof options.read === 'function') this._read = options.read;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;

  if (!state.objectMode && typeof chunk === 'string') {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = new Buffer(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var e = new Error('stream.unshift() after end event');
      stream.emit('error', e);
    } else {
      var skipAdd;
      if (state.decoder && !addToFront && !encoding) {
        chunk = state.decoder.write(chunk);
        skipAdd = !state.objectMode && chunk.length === 0;
      }

      if (!addToFront) state.reading = false;

      // Don't add to the buffer if we've decoded to an empty string chunk and
      // we're not in object mode
      if (!skipAdd) {
        // if we want the data now, just emit it.
        if (state.flowing && state.length === 0 && !state.sync) {
          stream.emit('data', chunk);
          stream.read(0);
        } else {
          // update the buffer info.
          state.length += state.objectMode ? 1 : chunk.length;
          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

          if (state.needReadable) emitReadable(stream);
        }
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(298).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

function howMuchToRead(n, state) {
  if (state.length === 0 && state.ended) return 0;

  if (state.objectMode) return n === 0 ? 0 : 1;

  if (n === null || isNaN(n)) {
    // only flow one buffer at a time
    if (state.flowing && state.buffer.length) return state.buffer[0].length;else return state.length;
  }

  if (n <= 0) return 0;

  // If we're asking for more than the target buffer level,
  // then raise the water mark.  Bump up to the next highest
  // power of 2, to prevent increasing it excessively in tiny
  // amounts.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);

  // don't have that much.  return null, unless we've ended.
  if (n > state.length) {
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    } else {
      return state.length;
    }
  }

  return n;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  var state = this._readableState;
  var nOrig = n;

  if (typeof n !== 'number' || n > 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  }

  if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
  }

  // If _read pushed data synchronously, then `reading` will be false,
  // and we need to re-evaluate how much data we can return to the user.
  if (doRead && !state.reading) n = howMuchToRead(nOrig, state);

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  }

  state.length -= n;

  // If we have nothing in the buffer, then we want to know
  // as soon as we *do* get something into the buffer.
  if (state.length === 0 && !state.ended) state.needReadable = true;

  // If we tried to read() past the EOF, then emit end on the next tick.
  if (nOrig !== n && state.ended && state.length === 0) endReadable(this);

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    if (false === ret) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      if (state.pipesCount === 1 && state.pipes[0] === dest && src.listenerCount('data') === 1 && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }
  // This is a brutally ugly hack to make sure that our error handler
  // is attached before any userland ones.  NEVER DO THIS.
  if (!dest._events || !dest._events.error) dest.on('error', onerror);else if (isArray(dest._events.error)) dest._events.error.unshift(onerror);else dest._events.error = [onerror, dest._events.error];

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var _i = 0; _i < len; _i++) {
      dests[_i].emit('unpipe', this);
    }return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1) return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  // If listening to data, and it has not explicitly been paused,
  // then call resume to start the flow of data on the next tick.
  if (ev === 'data' && false !== this._readableState.flowing) {
    this.resume();
  }

  if (ev === 'readable' && !this._readableState.endEmitted) {
    var state = this._readableState;
    if (!state.readableListening) {
      state.readableListening = true;
      state.emittedReadable = false;
      state.needReadable = true;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  if (state.flowing) {
    do {
      var chunk = stream.read();
    } while (null !== chunk && state.flowing);
  }
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function (ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
function fromList(n, state) {
  var list = state.buffer;
  var length = state.length;
  var stringMode = !!state.decoder;
  var objectMode = !!state.objectMode;
  var ret;

  // nothing in the list, definitely empty.
  if (list.length === 0) return null;

  if (length === 0) ret = null;else if (objectMode) ret = list.shift();else if (!n || n >= length) {
    // read it all, truncate the array.
    if (stringMode) ret = list.join('');else if (list.length === 1) ret = list[0];else ret = Buffer.concat(list, length);
    list.length = 0;
  } else {
    // read just some of it.
    if (n < list[0].length) {
      // just take a part of the first list item.
      // slice is the same for buffers and strings.
      var buf = list[0];
      ret = buf.slice(0, n);
      list[0] = buf.slice(n);
    } else if (n === list[0].length) {
      // first list is a perfect match
      ret = list.shift();
    } else {
      // complex case.
      // we have enough to cover it, but it spans past the first buffer.
      if (stringMode) ret = '';else ret = new Buffer(n);

      var c = 0;
      for (var i = 0, l = list.length; i < l && c < n; i++) {
        var buf = list[0];
        var cpy = Math.min(n - c, buf.length);

        if (stringMode) ret += buf.slice(0, cpy);else buf.copy(ret, c, 0, cpy);

        if (cpy < buf.length) list[0] = buf.slice(cpy);else list.shift();

        c += cpy;
      }
    }
  }

  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('endReadable called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ }),
/* 351 */,
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-arrow-left'].join(' '), viewBox: '-8.5 0 32 32' },
                React.createElement('path', { d: 'M14,32c-0.3,0-0.6-0.1-0.8-0.3l-13-15c-0.3-0.4-0.3-0.9,0-1.3l13-15c0.4-0.4,1-0.5,1.4-0.1 c0.4,0.4,0.5,1,0.1,1.4L2.3,16l12.4,14.3c0.4,0.4,0.3,1-0.1,1.4C14.4,31.9,14.2,32,14,32z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);

var GlobalContextBaseView = Backbone.BaseView.extend({
    constructor: function (options, parentView) {
        options = options || {};
        this.context = options.context;
        if (!this.context) {
            throw new Error("No context was provided to GlobalContextBaseView");
        }

        return Backbone.BaseView.call(this, options, parentView);
    },
    getContext : function () {
        return this.context;
    }
});

module.exports = GlobalContextBaseView;


/***/ }),
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reducers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var qs = __webpack_require__(42);
var get = __webpack_require__(14);
var isEmpty = __webpack_require__(264);
var tokenReplace = __webpack_require__(75);

var GAC = __webpack_require__(550);

var _require = __webpack_require__(342),
    switchActions = _require.switchActions;

var defaultGalleryCopy = __webpack_require__(1014);

/**
 * Checks if the store is ready
 *
 * @returns {boolean}
 */
function isSetup(state) {
    return state.isSetup;
}

/**
 * Checks if photos are loading
 *
 * @returns {boolean}
 */
function isLoadingPhotos(_ref) {
    var loadingPhotos = _ref.loadingPhotos;

    return loadingPhotos;
}

/**
 * Returns the number of photos in the gallery
 *
 * @returns {number}
 */
function getTotalNumberOfPhotos(_ref2) {
    var totalPhotos = _ref2.totalPhotos;

    return totalPhotos;
}

/**
 * Returns the count of the fully loaded i.e. available photos
 *
 * @returns {number}
 */
function getPhotosAvailableCount(_ref3) {
    var galleryPhotos = _ref3.galleryPhotos;

    return galleryPhotos.length;
}

/**
 * Returns the index of the current photo
 *
 * @returns {number}
 */
function getCurrentPhotoIndex(_ref4) {
    var photoIndex = _ref4.photoIndex;

    return photoIndex;
}

/**
 * Returns the last index in the _galleryPhotos array (convenience method)
 *
 * @returns {number}
 */
function getLastPhotoIndex(_ref5) {
    var totalPhotos = _ref5.totalPhotos;

    return totalPhotos - 1;
}

/**
 * Returns the gallery copy (or namespaced variable)
 *
 * @param {object} galleryCopy
 * @param {string} [ns]
 * @returns {*}
 */
function getGalleryCopy(_ref6, ns) {
    var galleryCopy = _ref6.galleryCopy;

    if (ns) {
        return get(galleryCopy, ns);
    }
    return galleryCopy;
}

/**
 * Returns the current photo (or namespaced variable)
 *
 * @param {object} photo
 * @param {string} [ns]
 * @param {*}      [fallback]
 * @returns {*}
 */
function getCurrentPhoto(_ref7, ns, fallback) {
    var photo = _ref7.photo;

    if (ns) {
        return get(photo, ns, fallback);
    }
    return photo;
}

/**
 * Returns data on the photo's project in an object
 *
 * @param {object} project
 * @param {object} photo
 * @param {string} ns
 * @returns {*}
 */
function getPhotoProject(_ref8, ns) {
    var project = _ref8.project,
        photo = _ref8.photo;

    project = isEmpty(project) ? photo.project : project;
    if (ns) {
        return get(project, ns);
    }
    return project;
}

/**
 * Returns data on the photo's firm in an object
 *
 * @param {object} firm
 * @param {object} photo
 * @param {string} ns
 * @returns {*}
 */
function getPhotoFirm(_ref9, ns) {
    var firm = _ref9.firm,
        photo = _ref9.photo;

    firm = isEmpty(firm) ? photo.firm : firm;
    if (ns) {
        return get(firm, ns);
    }
    return firm;
}

/**
 * Returns the index of the photo with the given id
 *
 * @param {array} galleryPhotos
 * @param {string|number} photoId
 */
function getPhotoIndex(_ref10, photoId) {
    var _ref10$galleryPhotos = _ref10.galleryPhotos,
        galleryPhotos = _ref10$galleryPhotos === undefined ? [] : _ref10$galleryPhotos;

    photoId = parseInt(photoId);
    return galleryPhotos.findIndex(function (photo) {
        return photo.id === photoId;
    });
}

/**
 * Returns the photo in _galleryPhotos with the given id
 *
 * @param {array} galleryPhotos
 * @param {string|number} photoId
 * @returns {object}
 */
function getPhotoById(_ref11, photoId) {
    var _ref11$galleryPhotos = _ref11.galleryPhotos,
        galleryPhotos = _ref11$galleryPhotos === undefined ? [] : _ref11$galleryPhotos;

    photoId = parseInt(photoId);
    return galleryPhotos.find(function (photo) {
        return photo.id === photoId;
    });
}

/**
 * Returns the photo in _galleryPhotos at the given index
 *
 * @param {array} galleryPhotos
 * @param {number} totalPhotos
 * @param {string|number} index
 * @returns {object}
 */
function getPhotoByIndex(_ref12, index) {
    var _ref12$galleryPhotos = _ref12.galleryPhotos,
        galleryPhotos = _ref12$galleryPhotos === undefined ? [] : _ref12$galleryPhotos,
        totalPhotos = _ref12.totalPhotos;

    index = parseInt(index);

    if (index > -1 && index < getTotalNumberOfPhotos({ totalPhotos: totalPhotos })) {
        return galleryPhotos[index];
    }

    return void 0;
}

/**
 * Returns the photo in _galleryPhotos with the given url
 *
 * @param {array} galleryPhotos
 * @param {string} photoUrl
 * @returns {object}
 */
function getPhotoByUrl(_ref13) {
    var _ref13$galleryPhotos = _ref13.galleryPhotos,
        galleryPhotos = _ref13$galleryPhotos === undefined ? [] : _ref13$galleryPhotos;
    var photoUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return galleryPhotos.find(function (photo) {
        return photo.url === photoUrl;
    });
}

/**
 * Returns the next index based on the action
 *
 * @param {number} photoIndex
 * @param {number} totalPhotos
 * @param {string} action
 * @param {number} [index]
 * @returns {number|bool}
 */
function getNewPhotoIndex(_ref14, action, index) {
    var photoIndex = _ref14.photoIndex,
        totalPhotos = _ref14.totalPhotos;

    index = typeof index === 'number' ? index : photoIndex;

    switch (action) {
        case switchActions.NEXT:
            if (index + 1 > getLastPhotoIndex({ totalPhotos: totalPhotos })) {
                return 0;
            }
            return index + 1;

        case switchActions.PREVIOUS:
            if (index - 1 < 0) {
                return getLastPhotoIndex({ totalPhotos: totalPhotos });
            }
            return index - 1;

        // No changes if action is invalid
        default:
            return false;
    }
}

/**
 * Returns gallery url with rt=partial for fetching similar items template
 *
 * @param {Object} state
 * @returns {String}
 */
function getSimilarItemsFullUrl(state) {
    var url = getCurrentPhoto(state, 'url');
    return url + '?' + qs.stringify({
        rt: 'json'
    });
}

/**
 * Returns base url with query params to fetch modal template
 *
 * @returns {string}
 */
function getFetchModalFullUrl(state) {
    var _ref15 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        galleryUrl = _ref15.galleryUrl;

    galleryUrl = galleryUrl || getCurrentPhoto(state, 'url');
    return galleryUrl + '?' + qs.stringify({
        rt: 'modal'
    });
}

/**
 * Returns base url with query params to load photos
 *
 * @returns {string}
 */
function getLoadPhotosFullUrl(state) {
    var url = state.loadPhotosBaseUrl;
    url += url.indexOf('?') > 0 ? '&' : '?';

    return url + qs.stringify({
        'psz': state.loadPhotosUrlPageSize,
        'pst': getPhotosAvailableCount(state),
        'rt': 'json'
    });
}

/**
 * Get Similar Items tracking for photo
 *
 * @param {Object} state
 */
function getSimilarItemsTracking(state) {
    return get(state, 'similarItemTemplates[' + getCurrentPhoto(state, 'id') + '].tracking') || {};
}

/**
 * Get Similar Items Urls for photo
 *
 * @param {Object} state
 */
function getSimilarItemsUrls(state) {
    return get(state, 'similarItemTemplates[' + getCurrentPhoto(state, 'id') + '].similarItemUrls');
}

/**
 * Get Similar Items Template for photo
 *
 * @param {Object} state
 */
function getSimilarItemsTemplate(state) {
    return get(state, 'similarItemTemplates[' + getCurrentPhoto(state, 'id') + '].template');
}

/**
 * Determines whether the similar items template should be fetched
 *
 * @returns {boolean}
 */
function shouldFetchSimilarItems(state) {
    return !getSimilarItemsTemplate(state);
}

/**
 * Get More Projects Template for photo
 *
 * @param {Object} state
 */
function getMoreProjectsTemplate(state) {
    return get(state, 'moreProjectsTemplates[' + getPhotoProject(state, 'url') + '].moreTemplate');
}

/**
 * Determines whether the more projects template should be fetched
 *
 * @returns {boolean}
 */
function shouldFetchMoreProjects(state) {
    return !getMoreProjectsTemplate(state);
}

/**
 * Determines whether the photos should asynchronously loaded
 *
 * @returns {boolean}
 */
function shouldLoadPhotos(state) {
    var photosAvailableCount = getPhotosAvailableCount(state);

    return !isLoadingPhotos(state) && photosAvailableCount !== getTotalNumberOfPhotos(state) && getCurrentPhotoIndex(state) + state.loadPhotosThreshold >= photosAvailableCount - 1;
}

/**
 * Helper for building the title string from the photo, firm and project
 *
 * @returns {string}
 */
function getTitleString(state) {
    var copy = getGalleryCopy(state, 'meta.title');
    var tokens = {
        firmName: getPhotoFirm(state, 'name'),
        photoRoom: getCurrentPhoto(state, 'room'),
        photoStyle: getCurrentPhoto(state, 'style'),
        projectLocation: getPhotoProject(state, 'location')
    };
    var replacedSegments = copy.reduce(function (segments, segment) {
        var replaced = tokenReplace(segment, tokens);
        if (replaced !== segment) {
            segments.push(replaced);
        }
        return segments;
    }, []);

    return replacedSegments.join(' ');
}

/**
 * Returns the title of the current photo
 *  - if the photo is named, then return the name
 *  - if the photo is not named but has a room type, then return the room type
 *  - otherwise return [Style] [Room] in [Location] by [Firm Name]
 */
function getCurrentPhotoTitle(state) {
    return getCurrentPhoto(state, 'name') || getCurrentPhoto(state, 'room') || getTitleString(state);
}

/**
 * Returns the page title for the <title> tag
 *  - if the photo is named, then return
 *              [Photo Name] - [Style] [Room] in [Location] by [Firm Name]
 *  - otherwise return
 *              [Style] [Room] in [Location] by [Firm Name]
 */
function getCurrentPageTitleTag(state) {
    var name = getCurrentPhoto(state, 'name');
    var title = getTitleString(state);
    return (name ? name + ' - ' : '') + title;
}

/**
 * Helper for building the url string from the photo's urlLabel and root id
 *
 * @param {object} state
 * @param {string} urlLabel
 * @param {number|string} rootId
 * @returns {string}
 */
function buildPhotoUrl(state) {
    var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        urlLabel = _ref16.urlLabel,
        rootId = _ref16.rootId;

    if (urlLabel && rootId) {
        // NOTE: leading and trailing slash is important for finding a photo by url
        return '/photo/' + urlLabel + '/' + rootId + '/';
    }
    return void 0;
}

var GalleryStore = {
    storeName: 'GalleryStore',
    initialState: {
        mobileUIState: {
            showDetails: false,
            showSocial: false
        },

        // set default gallery copy (can be overwritten by updateGalleryCopy)
        isSetup: false,
        loadingPhotos: false,
        similarItemTemplates: {},
        moreProjectsTemplates: {},
        galleryCopy: Object.assign({}, defaultGalleryCopy),

        firm: {},
        project: {},
        galleryPhotos: {},

        photo: {},
        photoIndex: 0,
        totalPhotos: 0,

        loadPhotosBaseUrl: '',
        loadPhotosUrlPageSize: 5,
        loadPhotosThreshold: 20
    },

    reducers: (_reducers = {}, _defineProperty(_reducers, GAC.GALLERY_SETUP_STORE, function setupStore(state, payload) {
        if (!isSetup(state) && payload) {
            return Object.assign({}, state, {
                isSetup: true,

                firm: payload.firm,
                project: payload.project,
                galleryPhotos: payload.galleryPhotos,

                photo: payload.initialPhoto,
                totalPhotos: payload.totalPhotos,
                photoIndex: getPhotoIndex(payload, get(payload, 'initialPhoto.id')),

                loadPhotosBaseUrl: payload.loadPhotosBaseUrl,
                loadPhotosUrlPageSize: payload.loadPhotosUrlPageSize,
                loadPhotosThreshold: payload.loadPhotosThreshold
            });
        }

        return state;
    }), _defineProperty(_reducers, GAC.GALLERY_RESET_STORE, function resetStore(state) {
        if (isSetup(state)) {
            return Object.assign({}, state, {
                isSetup: false
            });
        }
        return state;
    }), _defineProperty(_reducers, GAC.GALLERY_UPDATE_COPY, function updateGalleryCopy(state, payload) {
        if (payload.copy) {
            return Object.assign({}, state, {
                galleryCopy: Object.assign({}, state.galleryCopy, payload.copy)
            });
        }
        return state;
    }), _defineProperty(_reducers, GAC.GALLERY_SET_PHOTO, function setGalleryPhoto(state, payload) {
        var photo = payload.id ? getPhotoById(state, payload.id) : getPhotoByUrl(state, payload.url);

        if (photo && photo.id !== state.photo.id) {
            return Object.assign({}, state, {
                photo: photo,
                photoIndex: getPhotoIndex(state, photo.id)
            });
        }

        return state;
    }), _defineProperty(_reducers, GAC.GALLERY_SWITCH_PHOTO, function switchGalleryPhoto(state, payload) {
        var index = getNewPhotoIndex(state, payload.action);

        if (index < getPhotosAvailableCount(state) && index !== false) {
            // Change the Photo
            return Object.assign({}, state, {
                photoIndex: index,
                photo: getPhotoByIndex(state, index)
            });
        }

        return state;
    }), _defineProperty(_reducers, GAC.GALLERY_PHOTOS_LOAD_START, function onPhotosLoading(state) {
        return Object.assign({}, state, {
            loadingPhotos: true
        });
    }), _defineProperty(_reducers, GAC.GALLERY_PHOTOS_LOAD_DONE, function onPhotosLoaded(state) {
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _payload$photos = payload.photos,
            photos = _payload$photos === undefined ? [] : _payload$photos;


        if (photos && photos.length) {
            return Object.assign({}, state, {
                loadingPhotos: false,
                galleryPhotos: state.galleryPhotos.concat(photos)
            });
        }

        return Object.assign({}, state, { loadingPhotos: false });
    }), _defineProperty(_reducers, GAC.GALLERY_PHOTOS_LOAD_FAILED, function onPhotosLoadFailed(state) {
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        console.log('Error occured when loading additional photos: ', payload.error);
        return Object.assign({}, state, {
            loadingPhotos: false
        });
    }), _defineProperty(_reducers, GAC.GALLERY_ADD_SIMILAR_ITEMS_TEMPLATE, function addSimilarItemsTemplate(state, _ref17) {
        var photoId = _ref17.photoId,
            template = _ref17.template,
            similarItemUrls = _ref17.similarItemUrls,
            tracking = _ref17.tracking;

        photoId = photoId || getCurrentPhoto(state, 'id');

        return Object.assign({}, state, {
            similarItemTemplates: Object.assign({}, state.similarItemTemplates, _defineProperty({}, photoId, { template: template, similarItemUrls: similarItemUrls, tracking: tracking }))
        });
    }), _defineProperty(_reducers, GAC.GALLERY_ADD_MORE_PROJECTS_TEMPLATE, function addMoreProjectsTemplate(state, _ref18) {
        var projectUrl = _ref18.projectUrl,
            moreTemplate = _ref18.moreTemplate;

        projectUrl = projectUrl || getPhotoProject(state, 'url');
        return Object.assign({}, state, {
            moreProjectsTemplates: Object.assign({}, state.moreProjectsTemplates, _defineProperty({}, projectUrl, { moreTemplate: moreTemplate }))
        });
    }), _defineProperty(_reducers, GAC.GALLERY_MOBILE_SHOW_DETAILS, function (state) {
        var _ref19 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            showDetails = _ref19.showDetails;

        showDetails = showDetails !== false;

        if (showDetails !== state.mobileUIState.showDetails) {
            return Object.assign({}, state, {
                mobileUIState: Object.assign({}, state.mobileUIState, {
                    showDetails: showDetails,
                    showSocial: false
                })
            });
        }

        return state;
    }), _defineProperty(_reducers, GAC.GALLERY_MOBILE_SHOW_SOCIAL, function (state) {
        var _ref20 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            showSocial = _ref20.showSocial;

        showSocial = showSocial !== false;

        if (showSocial !== state.mobileUIState.showSocial) {
            return Object.assign({}, state, {
                mobileUIState: Object.assign({}, state.mobileUIState, {
                    showSocial: showSocial
                })
            });
        }

        return state;
    }), _reducers),

    getters: {
        isSetup: isSetup,
        getGalleryCopy: getGalleryCopy,
        isLoadingPhotos: isLoadingPhotos,
        shouldLoadPhotos: shouldLoadPhotos,
        shouldFetchSimilarItems: shouldFetchSimilarItems,
        shouldFetchMoreProjects: shouldFetchMoreProjects,

        showSocialMobile: function showSocialMobile(state) {
            return get(state, 'mobileUIState.showSocial', false);
        },
        showDetailsMobile: function showDetailsMobile(state) {
            return get(state, 'mobileUIState.showDetails', false);
        },

        getPhotoFirm: getPhotoFirm,
        getPhotoProject: getPhotoProject,
        getCurrentPhoto: getCurrentPhoto,
        getCurrentPhotoIndex: getCurrentPhotoIndex,
        getCurrentPhotoAlt: getTitleString,
        getCurrentPhotoId: function getCurrentPhotoId(state) {
            return getCurrentPhoto(state, 'id');
        },
        getCurrentPhotoUrl: function getCurrentPhotoUrl(state) {
            return getCurrentPhoto(state, 'url');
        },
        getCurrentPhotoSrc: function getCurrentPhotoSrc(state) {
            return getCurrentPhoto(state, 'path');
        },
        getCurrentPhotoTags: function getCurrentPhotoTags(state) {
            return getCurrentPhoto(state, 'tags');
        },
        getCurrentPhotoCaption: function getCurrentPhotoCaption(state) {
            return getCurrentPhoto(state, 'caption');
        },
        getCurrentPhotoItemTags: function getCurrentPhotoItemTags(state) {
            return getCurrentPhoto(state, 'itemTags', []);
        },
        getTitleString: getTitleString,
        getCurrentPhotoTitle: getCurrentPhotoTitle,
        getCurrentPageTitleTag: getCurrentPageTitleTag,

        getPhotoById: getPhotoById,
        getPhotoByIndex: getPhotoByIndex,
        getPhotoByUrl: getPhotoByUrl,
        getPhotoIndex: getPhotoIndex,
        getLastPhotoIndex: getLastPhotoIndex,
        getTotalNumberOfPhotos: getTotalNumberOfPhotos,
        getPhotosAvailableCount: getPhotosAvailableCount,

        getSimilarItemsUrls: getSimilarItemsUrls,
        getSimilarItemsTemplate: getSimilarItemsTemplate,
        getSimilarItemsTracking: getSimilarItemsTracking,
        getMoreProjectsTemplate: getMoreProjectsTemplate,

        getFetchModalFullUrl: getFetchModalFullUrl,
        getSimilarItemsFullUrl: getSimilarItemsFullUrl,
        getLoadPhotosFullUrl: getLoadPhotosFullUrl,

        buildPhotoUrl: buildPhotoUrl
    }
};

module.exports = GalleryStore;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function square(number) {
    return Math.pow(number, 2);
}

function hypotenuse(x, y) {
    return Math.sqrt(square(x) + square(y));
}

function absDistance(number1, number2) {
    return Math.abs(number1 - number2);
}

function getTouchDistance(position1, position2) {
    var x1 = position1.x,
        y1 = position1.y;
    var x2 = position2.x,
        y2 = position2.y;


    return hypotenuse(absDistance(x1, x2), absDistance(y1, y2));
}

function touchToCoordinates(target, touch) {
    return {
        x: touch.pageX - target.offsetLeft,
        y: touch.pageY - target.offsetTop
    };
}

module.exports = {
    square: square,
    hypotenuse: hypotenuse,
    absDistance: absDistance,
    getTouchDistance: getTouchDistance,
    touchToCoordinates: touchToCoordinates
};

/***/ }),
/* 359 */
/***/ (function(module, exports) {

var ENTITIES = [['Aacute', [193]], ['aacute', [225]], ['Abreve', [258]], ['abreve', [259]], ['ac', [8766]], ['acd', [8767]], ['acE', [8766, 819]], ['Acirc', [194]], ['acirc', [226]], ['acute', [180]], ['Acy', [1040]], ['acy', [1072]], ['AElig', [198]], ['aelig', [230]], ['af', [8289]], ['Afr', [120068]], ['afr', [120094]], ['Agrave', [192]], ['agrave', [224]], ['alefsym', [8501]], ['aleph', [8501]], ['Alpha', [913]], ['alpha', [945]], ['Amacr', [256]], ['amacr', [257]], ['amalg', [10815]], ['amp', [38]], ['AMP', [38]], ['andand', [10837]], ['And', [10835]], ['and', [8743]], ['andd', [10844]], ['andslope', [10840]], ['andv', [10842]], ['ang', [8736]], ['ange', [10660]], ['angle', [8736]], ['angmsdaa', [10664]], ['angmsdab', [10665]], ['angmsdac', [10666]], ['angmsdad', [10667]], ['angmsdae', [10668]], ['angmsdaf', [10669]], ['angmsdag', [10670]], ['angmsdah', [10671]], ['angmsd', [8737]], ['angrt', [8735]], ['angrtvb', [8894]], ['angrtvbd', [10653]], ['angsph', [8738]], ['angst', [197]], ['angzarr', [9084]], ['Aogon', [260]], ['aogon', [261]], ['Aopf', [120120]], ['aopf', [120146]], ['apacir', [10863]], ['ap', [8776]], ['apE', [10864]], ['ape', [8778]], ['apid', [8779]], ['apos', [39]], ['ApplyFunction', [8289]], ['approx', [8776]], ['approxeq', [8778]], ['Aring', [197]], ['aring', [229]], ['Ascr', [119964]], ['ascr', [119990]], ['Assign', [8788]], ['ast', [42]], ['asymp', [8776]], ['asympeq', [8781]], ['Atilde', [195]], ['atilde', [227]], ['Auml', [196]], ['auml', [228]], ['awconint', [8755]], ['awint', [10769]], ['backcong', [8780]], ['backepsilon', [1014]], ['backprime', [8245]], ['backsim', [8765]], ['backsimeq', [8909]], ['Backslash', [8726]], ['Barv', [10983]], ['barvee', [8893]], ['barwed', [8965]], ['Barwed', [8966]], ['barwedge', [8965]], ['bbrk', [9141]], ['bbrktbrk', [9142]], ['bcong', [8780]], ['Bcy', [1041]], ['bcy', [1073]], ['bdquo', [8222]], ['becaus', [8757]], ['because', [8757]], ['Because', [8757]], ['bemptyv', [10672]], ['bepsi', [1014]], ['bernou', [8492]], ['Bernoullis', [8492]], ['Beta', [914]], ['beta', [946]], ['beth', [8502]], ['between', [8812]], ['Bfr', [120069]], ['bfr', [120095]], ['bigcap', [8898]], ['bigcirc', [9711]], ['bigcup', [8899]], ['bigodot', [10752]], ['bigoplus', [10753]], ['bigotimes', [10754]], ['bigsqcup', [10758]], ['bigstar', [9733]], ['bigtriangledown', [9661]], ['bigtriangleup', [9651]], ['biguplus', [10756]], ['bigvee', [8897]], ['bigwedge', [8896]], ['bkarow', [10509]], ['blacklozenge', [10731]], ['blacksquare', [9642]], ['blacktriangle', [9652]], ['blacktriangledown', [9662]], ['blacktriangleleft', [9666]], ['blacktriangleright', [9656]], ['blank', [9251]], ['blk12', [9618]], ['blk14', [9617]], ['blk34', [9619]], ['block', [9608]], ['bne', [61, 8421]], ['bnequiv', [8801, 8421]], ['bNot', [10989]], ['bnot', [8976]], ['Bopf', [120121]], ['bopf', [120147]], ['bot', [8869]], ['bottom', [8869]], ['bowtie', [8904]], ['boxbox', [10697]], ['boxdl', [9488]], ['boxdL', [9557]], ['boxDl', [9558]], ['boxDL', [9559]], ['boxdr', [9484]], ['boxdR', [9554]], ['boxDr', [9555]], ['boxDR', [9556]], ['boxh', [9472]], ['boxH', [9552]], ['boxhd', [9516]], ['boxHd', [9572]], ['boxhD', [9573]], ['boxHD', [9574]], ['boxhu', [9524]], ['boxHu', [9575]], ['boxhU', [9576]], ['boxHU', [9577]], ['boxminus', [8863]], ['boxplus', [8862]], ['boxtimes', [8864]], ['boxul', [9496]], ['boxuL', [9563]], ['boxUl', [9564]], ['boxUL', [9565]], ['boxur', [9492]], ['boxuR', [9560]], ['boxUr', [9561]], ['boxUR', [9562]], ['boxv', [9474]], ['boxV', [9553]], ['boxvh', [9532]], ['boxvH', [9578]], ['boxVh', [9579]], ['boxVH', [9580]], ['boxvl', [9508]], ['boxvL', [9569]], ['boxVl', [9570]], ['boxVL', [9571]], ['boxvr', [9500]], ['boxvR', [9566]], ['boxVr', [9567]], ['boxVR', [9568]], ['bprime', [8245]], ['breve', [728]], ['Breve', [728]], ['brvbar', [166]], ['bscr', [119991]], ['Bscr', [8492]], ['bsemi', [8271]], ['bsim', [8765]], ['bsime', [8909]], ['bsolb', [10693]], ['bsol', [92]], ['bsolhsub', [10184]], ['bull', [8226]], ['bullet', [8226]], ['bump', [8782]], ['bumpE', [10926]], ['bumpe', [8783]], ['Bumpeq', [8782]], ['bumpeq', [8783]], ['Cacute', [262]], ['cacute', [263]], ['capand', [10820]], ['capbrcup', [10825]], ['capcap', [10827]], ['cap', [8745]], ['Cap', [8914]], ['capcup', [10823]], ['capdot', [10816]], ['CapitalDifferentialD', [8517]], ['caps', [8745, 65024]], ['caret', [8257]], ['caron', [711]], ['Cayleys', [8493]], ['ccaps', [10829]], ['Ccaron', [268]], ['ccaron', [269]], ['Ccedil', [199]], ['ccedil', [231]], ['Ccirc', [264]], ['ccirc', [265]], ['Cconint', [8752]], ['ccups', [10828]], ['ccupssm', [10832]], ['Cdot', [266]], ['cdot', [267]], ['cedil', [184]], ['Cedilla', [184]], ['cemptyv', [10674]], ['cent', [162]], ['centerdot', [183]], ['CenterDot', [183]], ['cfr', [120096]], ['Cfr', [8493]], ['CHcy', [1063]], ['chcy', [1095]], ['check', [10003]], ['checkmark', [10003]], ['Chi', [935]], ['chi', [967]], ['circ', [710]], ['circeq', [8791]], ['circlearrowleft', [8634]], ['circlearrowright', [8635]], ['circledast', [8859]], ['circledcirc', [8858]], ['circleddash', [8861]], ['CircleDot', [8857]], ['circledR', [174]], ['circledS', [9416]], ['CircleMinus', [8854]], ['CirclePlus', [8853]], ['CircleTimes', [8855]], ['cir', [9675]], ['cirE', [10691]], ['cire', [8791]], ['cirfnint', [10768]], ['cirmid', [10991]], ['cirscir', [10690]], ['ClockwiseContourIntegral', [8754]], ['CloseCurlyDoubleQuote', [8221]], ['CloseCurlyQuote', [8217]], ['clubs', [9827]], ['clubsuit', [9827]], ['colon', [58]], ['Colon', [8759]], ['Colone', [10868]], ['colone', [8788]], ['coloneq', [8788]], ['comma', [44]], ['commat', [64]], ['comp', [8705]], ['compfn', [8728]], ['complement', [8705]], ['complexes', [8450]], ['cong', [8773]], ['congdot', [10861]], ['Congruent', [8801]], ['conint', [8750]], ['Conint', [8751]], ['ContourIntegral', [8750]], ['copf', [120148]], ['Copf', [8450]], ['coprod', [8720]], ['Coproduct', [8720]], ['copy', [169]], ['COPY', [169]], ['copysr', [8471]], ['CounterClockwiseContourIntegral', [8755]], ['crarr', [8629]], ['cross', [10007]], ['Cross', [10799]], ['Cscr', [119966]], ['cscr', [119992]], ['csub', [10959]], ['csube', [10961]], ['csup', [10960]], ['csupe', [10962]], ['ctdot', [8943]], ['cudarrl', [10552]], ['cudarrr', [10549]], ['cuepr', [8926]], ['cuesc', [8927]], ['cularr', [8630]], ['cularrp', [10557]], ['cupbrcap', [10824]], ['cupcap', [10822]], ['CupCap', [8781]], ['cup', [8746]], ['Cup', [8915]], ['cupcup', [10826]], ['cupdot', [8845]], ['cupor', [10821]], ['cups', [8746, 65024]], ['curarr', [8631]], ['curarrm', [10556]], ['curlyeqprec', [8926]], ['curlyeqsucc', [8927]], ['curlyvee', [8910]], ['curlywedge', [8911]], ['curren', [164]], ['curvearrowleft', [8630]], ['curvearrowright', [8631]], ['cuvee', [8910]], ['cuwed', [8911]], ['cwconint', [8754]], ['cwint', [8753]], ['cylcty', [9005]], ['dagger', [8224]], ['Dagger', [8225]], ['daleth', [8504]], ['darr', [8595]], ['Darr', [8609]], ['dArr', [8659]], ['dash', [8208]], ['Dashv', [10980]], ['dashv', [8867]], ['dbkarow', [10511]], ['dblac', [733]], ['Dcaron', [270]], ['dcaron', [271]], ['Dcy', [1044]], ['dcy', [1076]], ['ddagger', [8225]], ['ddarr', [8650]], ['DD', [8517]], ['dd', [8518]], ['DDotrahd', [10513]], ['ddotseq', [10871]], ['deg', [176]], ['Del', [8711]], ['Delta', [916]], ['delta', [948]], ['demptyv', [10673]], ['dfisht', [10623]], ['Dfr', [120071]], ['dfr', [120097]], ['dHar', [10597]], ['dharl', [8643]], ['dharr', [8642]], ['DiacriticalAcute', [180]], ['DiacriticalDot', [729]], ['DiacriticalDoubleAcute', [733]], ['DiacriticalGrave', [96]], ['DiacriticalTilde', [732]], ['diam', [8900]], ['diamond', [8900]], ['Diamond', [8900]], ['diamondsuit', [9830]], ['diams', [9830]], ['die', [168]], ['DifferentialD', [8518]], ['digamma', [989]], ['disin', [8946]], ['div', [247]], ['divide', [247]], ['divideontimes', [8903]], ['divonx', [8903]], ['DJcy', [1026]], ['djcy', [1106]], ['dlcorn', [8990]], ['dlcrop', [8973]], ['dollar', [36]], ['Dopf', [120123]], ['dopf', [120149]], ['Dot', [168]], ['dot', [729]], ['DotDot', [8412]], ['doteq', [8784]], ['doteqdot', [8785]], ['DotEqual', [8784]], ['dotminus', [8760]], ['dotplus', [8724]], ['dotsquare', [8865]], ['doublebarwedge', [8966]], ['DoubleContourIntegral', [8751]], ['DoubleDot', [168]], ['DoubleDownArrow', [8659]], ['DoubleLeftArrow', [8656]], ['DoubleLeftRightArrow', [8660]], ['DoubleLeftTee', [10980]], ['DoubleLongLeftArrow', [10232]], ['DoubleLongLeftRightArrow', [10234]], ['DoubleLongRightArrow', [10233]], ['DoubleRightArrow', [8658]], ['DoubleRightTee', [8872]], ['DoubleUpArrow', [8657]], ['DoubleUpDownArrow', [8661]], ['DoubleVerticalBar', [8741]], ['DownArrowBar', [10515]], ['downarrow', [8595]], ['DownArrow', [8595]], ['Downarrow', [8659]], ['DownArrowUpArrow', [8693]], ['DownBreve', [785]], ['downdownarrows', [8650]], ['downharpoonleft', [8643]], ['downharpoonright', [8642]], ['DownLeftRightVector', [10576]], ['DownLeftTeeVector', [10590]], ['DownLeftVectorBar', [10582]], ['DownLeftVector', [8637]], ['DownRightTeeVector', [10591]], ['DownRightVectorBar', [10583]], ['DownRightVector', [8641]], ['DownTeeArrow', [8615]], ['DownTee', [8868]], ['drbkarow', [10512]], ['drcorn', [8991]], ['drcrop', [8972]], ['Dscr', [119967]], ['dscr', [119993]], ['DScy', [1029]], ['dscy', [1109]], ['dsol', [10742]], ['Dstrok', [272]], ['dstrok', [273]], ['dtdot', [8945]], ['dtri', [9663]], ['dtrif', [9662]], ['duarr', [8693]], ['duhar', [10607]], ['dwangle', [10662]], ['DZcy', [1039]], ['dzcy', [1119]], ['dzigrarr', [10239]], ['Eacute', [201]], ['eacute', [233]], ['easter', [10862]], ['Ecaron', [282]], ['ecaron', [283]], ['Ecirc', [202]], ['ecirc', [234]], ['ecir', [8790]], ['ecolon', [8789]], ['Ecy', [1069]], ['ecy', [1101]], ['eDDot', [10871]], ['Edot', [278]], ['edot', [279]], ['eDot', [8785]], ['ee', [8519]], ['efDot', [8786]], ['Efr', [120072]], ['efr', [120098]], ['eg', [10906]], ['Egrave', [200]], ['egrave', [232]], ['egs', [10902]], ['egsdot', [10904]], ['el', [10905]], ['Element', [8712]], ['elinters', [9191]], ['ell', [8467]], ['els', [10901]], ['elsdot', [10903]], ['Emacr', [274]], ['emacr', [275]], ['empty', [8709]], ['emptyset', [8709]], ['EmptySmallSquare', [9723]], ['emptyv', [8709]], ['EmptyVerySmallSquare', [9643]], ['emsp13', [8196]], ['emsp14', [8197]], ['emsp', [8195]], ['ENG', [330]], ['eng', [331]], ['ensp', [8194]], ['Eogon', [280]], ['eogon', [281]], ['Eopf', [120124]], ['eopf', [120150]], ['epar', [8917]], ['eparsl', [10723]], ['eplus', [10865]], ['epsi', [949]], ['Epsilon', [917]], ['epsilon', [949]], ['epsiv', [1013]], ['eqcirc', [8790]], ['eqcolon', [8789]], ['eqsim', [8770]], ['eqslantgtr', [10902]], ['eqslantless', [10901]], ['Equal', [10869]], ['equals', [61]], ['EqualTilde', [8770]], ['equest', [8799]], ['Equilibrium', [8652]], ['equiv', [8801]], ['equivDD', [10872]], ['eqvparsl', [10725]], ['erarr', [10609]], ['erDot', [8787]], ['escr', [8495]], ['Escr', [8496]], ['esdot', [8784]], ['Esim', [10867]], ['esim', [8770]], ['Eta', [919]], ['eta', [951]], ['ETH', [208]], ['eth', [240]], ['Euml', [203]], ['euml', [235]], ['euro', [8364]], ['excl', [33]], ['exist', [8707]], ['Exists', [8707]], ['expectation', [8496]], ['exponentiale', [8519]], ['ExponentialE', [8519]], ['fallingdotseq', [8786]], ['Fcy', [1060]], ['fcy', [1092]], ['female', [9792]], ['ffilig', [64259]], ['fflig', [64256]], ['ffllig', [64260]], ['Ffr', [120073]], ['ffr', [120099]], ['filig', [64257]], ['FilledSmallSquare', [9724]], ['FilledVerySmallSquare', [9642]], ['fjlig', [102, 106]], ['flat', [9837]], ['fllig', [64258]], ['fltns', [9649]], ['fnof', [402]], ['Fopf', [120125]], ['fopf', [120151]], ['forall', [8704]], ['ForAll', [8704]], ['fork', [8916]], ['forkv', [10969]], ['Fouriertrf', [8497]], ['fpartint', [10765]], ['frac12', [189]], ['frac13', [8531]], ['frac14', [188]], ['frac15', [8533]], ['frac16', [8537]], ['frac18', [8539]], ['frac23', [8532]], ['frac25', [8534]], ['frac34', [190]], ['frac35', [8535]], ['frac38', [8540]], ['frac45', [8536]], ['frac56', [8538]], ['frac58', [8541]], ['frac78', [8542]], ['frasl', [8260]], ['frown', [8994]], ['fscr', [119995]], ['Fscr', [8497]], ['gacute', [501]], ['Gamma', [915]], ['gamma', [947]], ['Gammad', [988]], ['gammad', [989]], ['gap', [10886]], ['Gbreve', [286]], ['gbreve', [287]], ['Gcedil', [290]], ['Gcirc', [284]], ['gcirc', [285]], ['Gcy', [1043]], ['gcy', [1075]], ['Gdot', [288]], ['gdot', [289]], ['ge', [8805]], ['gE', [8807]], ['gEl', [10892]], ['gel', [8923]], ['geq', [8805]], ['geqq', [8807]], ['geqslant', [10878]], ['gescc', [10921]], ['ges', [10878]], ['gesdot', [10880]], ['gesdoto', [10882]], ['gesdotol', [10884]], ['gesl', [8923, 65024]], ['gesles', [10900]], ['Gfr', [120074]], ['gfr', [120100]], ['gg', [8811]], ['Gg', [8921]], ['ggg', [8921]], ['gimel', [8503]], ['GJcy', [1027]], ['gjcy', [1107]], ['gla', [10917]], ['gl', [8823]], ['glE', [10898]], ['glj', [10916]], ['gnap', [10890]], ['gnapprox', [10890]], ['gne', [10888]], ['gnE', [8809]], ['gneq', [10888]], ['gneqq', [8809]], ['gnsim', [8935]], ['Gopf', [120126]], ['gopf', [120152]], ['grave', [96]], ['GreaterEqual', [8805]], ['GreaterEqualLess', [8923]], ['GreaterFullEqual', [8807]], ['GreaterGreater', [10914]], ['GreaterLess', [8823]], ['GreaterSlantEqual', [10878]], ['GreaterTilde', [8819]], ['Gscr', [119970]], ['gscr', [8458]], ['gsim', [8819]], ['gsime', [10894]], ['gsiml', [10896]], ['gtcc', [10919]], ['gtcir', [10874]], ['gt', [62]], ['GT', [62]], ['Gt', [8811]], ['gtdot', [8919]], ['gtlPar', [10645]], ['gtquest', [10876]], ['gtrapprox', [10886]], ['gtrarr', [10616]], ['gtrdot', [8919]], ['gtreqless', [8923]], ['gtreqqless', [10892]], ['gtrless', [8823]], ['gtrsim', [8819]], ['gvertneqq', [8809, 65024]], ['gvnE', [8809, 65024]], ['Hacek', [711]], ['hairsp', [8202]], ['half', [189]], ['hamilt', [8459]], ['HARDcy', [1066]], ['hardcy', [1098]], ['harrcir', [10568]], ['harr', [8596]], ['hArr', [8660]], ['harrw', [8621]], ['Hat', [94]], ['hbar', [8463]], ['Hcirc', [292]], ['hcirc', [293]], ['hearts', [9829]], ['heartsuit', [9829]], ['hellip', [8230]], ['hercon', [8889]], ['hfr', [120101]], ['Hfr', [8460]], ['HilbertSpace', [8459]], ['hksearow', [10533]], ['hkswarow', [10534]], ['hoarr', [8703]], ['homtht', [8763]], ['hookleftarrow', [8617]], ['hookrightarrow', [8618]], ['hopf', [120153]], ['Hopf', [8461]], ['horbar', [8213]], ['HorizontalLine', [9472]], ['hscr', [119997]], ['Hscr', [8459]], ['hslash', [8463]], ['Hstrok', [294]], ['hstrok', [295]], ['HumpDownHump', [8782]], ['HumpEqual', [8783]], ['hybull', [8259]], ['hyphen', [8208]], ['Iacute', [205]], ['iacute', [237]], ['ic', [8291]], ['Icirc', [206]], ['icirc', [238]], ['Icy', [1048]], ['icy', [1080]], ['Idot', [304]], ['IEcy', [1045]], ['iecy', [1077]], ['iexcl', [161]], ['iff', [8660]], ['ifr', [120102]], ['Ifr', [8465]], ['Igrave', [204]], ['igrave', [236]], ['ii', [8520]], ['iiiint', [10764]], ['iiint', [8749]], ['iinfin', [10716]], ['iiota', [8489]], ['IJlig', [306]], ['ijlig', [307]], ['Imacr', [298]], ['imacr', [299]], ['image', [8465]], ['ImaginaryI', [8520]], ['imagline', [8464]], ['imagpart', [8465]], ['imath', [305]], ['Im', [8465]], ['imof', [8887]], ['imped', [437]], ['Implies', [8658]], ['incare', [8453]], ['in', [8712]], ['infin', [8734]], ['infintie', [10717]], ['inodot', [305]], ['intcal', [8890]], ['int', [8747]], ['Int', [8748]], ['integers', [8484]], ['Integral', [8747]], ['intercal', [8890]], ['Intersection', [8898]], ['intlarhk', [10775]], ['intprod', [10812]], ['InvisibleComma', [8291]], ['InvisibleTimes', [8290]], ['IOcy', [1025]], ['iocy', [1105]], ['Iogon', [302]], ['iogon', [303]], ['Iopf', [120128]], ['iopf', [120154]], ['Iota', [921]], ['iota', [953]], ['iprod', [10812]], ['iquest', [191]], ['iscr', [119998]], ['Iscr', [8464]], ['isin', [8712]], ['isindot', [8949]], ['isinE', [8953]], ['isins', [8948]], ['isinsv', [8947]], ['isinv', [8712]], ['it', [8290]], ['Itilde', [296]], ['itilde', [297]], ['Iukcy', [1030]], ['iukcy', [1110]], ['Iuml', [207]], ['iuml', [239]], ['Jcirc', [308]], ['jcirc', [309]], ['Jcy', [1049]], ['jcy', [1081]], ['Jfr', [120077]], ['jfr', [120103]], ['jmath', [567]], ['Jopf', [120129]], ['jopf', [120155]], ['Jscr', [119973]], ['jscr', [119999]], ['Jsercy', [1032]], ['jsercy', [1112]], ['Jukcy', [1028]], ['jukcy', [1108]], ['Kappa', [922]], ['kappa', [954]], ['kappav', [1008]], ['Kcedil', [310]], ['kcedil', [311]], ['Kcy', [1050]], ['kcy', [1082]], ['Kfr', [120078]], ['kfr', [120104]], ['kgreen', [312]], ['KHcy', [1061]], ['khcy', [1093]], ['KJcy', [1036]], ['kjcy', [1116]], ['Kopf', [120130]], ['kopf', [120156]], ['Kscr', [119974]], ['kscr', [120000]], ['lAarr', [8666]], ['Lacute', [313]], ['lacute', [314]], ['laemptyv', [10676]], ['lagran', [8466]], ['Lambda', [923]], ['lambda', [955]], ['lang', [10216]], ['Lang', [10218]], ['langd', [10641]], ['langle', [10216]], ['lap', [10885]], ['Laplacetrf', [8466]], ['laquo', [171]], ['larrb', [8676]], ['larrbfs', [10527]], ['larr', [8592]], ['Larr', [8606]], ['lArr', [8656]], ['larrfs', [10525]], ['larrhk', [8617]], ['larrlp', [8619]], ['larrpl', [10553]], ['larrsim', [10611]], ['larrtl', [8610]], ['latail', [10521]], ['lAtail', [10523]], ['lat', [10923]], ['late', [10925]], ['lates', [10925, 65024]], ['lbarr', [10508]], ['lBarr', [10510]], ['lbbrk', [10098]], ['lbrace', [123]], ['lbrack', [91]], ['lbrke', [10635]], ['lbrksld', [10639]], ['lbrkslu', [10637]], ['Lcaron', [317]], ['lcaron', [318]], ['Lcedil', [315]], ['lcedil', [316]], ['lceil', [8968]], ['lcub', [123]], ['Lcy', [1051]], ['lcy', [1083]], ['ldca', [10550]], ['ldquo', [8220]], ['ldquor', [8222]], ['ldrdhar', [10599]], ['ldrushar', [10571]], ['ldsh', [8626]], ['le', [8804]], ['lE', [8806]], ['LeftAngleBracket', [10216]], ['LeftArrowBar', [8676]], ['leftarrow', [8592]], ['LeftArrow', [8592]], ['Leftarrow', [8656]], ['LeftArrowRightArrow', [8646]], ['leftarrowtail', [8610]], ['LeftCeiling', [8968]], ['LeftDoubleBracket', [10214]], ['LeftDownTeeVector', [10593]], ['LeftDownVectorBar', [10585]], ['LeftDownVector', [8643]], ['LeftFloor', [8970]], ['leftharpoondown', [8637]], ['leftharpoonup', [8636]], ['leftleftarrows', [8647]], ['leftrightarrow', [8596]], ['LeftRightArrow', [8596]], ['Leftrightarrow', [8660]], ['leftrightarrows', [8646]], ['leftrightharpoons', [8651]], ['leftrightsquigarrow', [8621]], ['LeftRightVector', [10574]], ['LeftTeeArrow', [8612]], ['LeftTee', [8867]], ['LeftTeeVector', [10586]], ['leftthreetimes', [8907]], ['LeftTriangleBar', [10703]], ['LeftTriangle', [8882]], ['LeftTriangleEqual', [8884]], ['LeftUpDownVector', [10577]], ['LeftUpTeeVector', [10592]], ['LeftUpVectorBar', [10584]], ['LeftUpVector', [8639]], ['LeftVectorBar', [10578]], ['LeftVector', [8636]], ['lEg', [10891]], ['leg', [8922]], ['leq', [8804]], ['leqq', [8806]], ['leqslant', [10877]], ['lescc', [10920]], ['les', [10877]], ['lesdot', [10879]], ['lesdoto', [10881]], ['lesdotor', [10883]], ['lesg', [8922, 65024]], ['lesges', [10899]], ['lessapprox', [10885]], ['lessdot', [8918]], ['lesseqgtr', [8922]], ['lesseqqgtr', [10891]], ['LessEqualGreater', [8922]], ['LessFullEqual', [8806]], ['LessGreater', [8822]], ['lessgtr', [8822]], ['LessLess', [10913]], ['lesssim', [8818]], ['LessSlantEqual', [10877]], ['LessTilde', [8818]], ['lfisht', [10620]], ['lfloor', [8970]], ['Lfr', [120079]], ['lfr', [120105]], ['lg', [8822]], ['lgE', [10897]], ['lHar', [10594]], ['lhard', [8637]], ['lharu', [8636]], ['lharul', [10602]], ['lhblk', [9604]], ['LJcy', [1033]], ['ljcy', [1113]], ['llarr', [8647]], ['ll', [8810]], ['Ll', [8920]], ['llcorner', [8990]], ['Lleftarrow', [8666]], ['llhard', [10603]], ['lltri', [9722]], ['Lmidot', [319]], ['lmidot', [320]], ['lmoustache', [9136]], ['lmoust', [9136]], ['lnap', [10889]], ['lnapprox', [10889]], ['lne', [10887]], ['lnE', [8808]], ['lneq', [10887]], ['lneqq', [8808]], ['lnsim', [8934]], ['loang', [10220]], ['loarr', [8701]], ['lobrk', [10214]], ['longleftarrow', [10229]], ['LongLeftArrow', [10229]], ['Longleftarrow', [10232]], ['longleftrightarrow', [10231]], ['LongLeftRightArrow', [10231]], ['Longleftrightarrow', [10234]], ['longmapsto', [10236]], ['longrightarrow', [10230]], ['LongRightArrow', [10230]], ['Longrightarrow', [10233]], ['looparrowleft', [8619]], ['looparrowright', [8620]], ['lopar', [10629]], ['Lopf', [120131]], ['lopf', [120157]], ['loplus', [10797]], ['lotimes', [10804]], ['lowast', [8727]], ['lowbar', [95]], ['LowerLeftArrow', [8601]], ['LowerRightArrow', [8600]], ['loz', [9674]], ['lozenge', [9674]], ['lozf', [10731]], ['lpar', [40]], ['lparlt', [10643]], ['lrarr', [8646]], ['lrcorner', [8991]], ['lrhar', [8651]], ['lrhard', [10605]], ['lrm', [8206]], ['lrtri', [8895]], ['lsaquo', [8249]], ['lscr', [120001]], ['Lscr', [8466]], ['lsh', [8624]], ['Lsh', [8624]], ['lsim', [8818]], ['lsime', [10893]], ['lsimg', [10895]], ['lsqb', [91]], ['lsquo', [8216]], ['lsquor', [8218]], ['Lstrok', [321]], ['lstrok', [322]], ['ltcc', [10918]], ['ltcir', [10873]], ['lt', [60]], ['LT', [60]], ['Lt', [8810]], ['ltdot', [8918]], ['lthree', [8907]], ['ltimes', [8905]], ['ltlarr', [10614]], ['ltquest', [10875]], ['ltri', [9667]], ['ltrie', [8884]], ['ltrif', [9666]], ['ltrPar', [10646]], ['lurdshar', [10570]], ['luruhar', [10598]], ['lvertneqq', [8808, 65024]], ['lvnE', [8808, 65024]], ['macr', [175]], ['male', [9794]], ['malt', [10016]], ['maltese', [10016]], ['Map', [10501]], ['map', [8614]], ['mapsto', [8614]], ['mapstodown', [8615]], ['mapstoleft', [8612]], ['mapstoup', [8613]], ['marker', [9646]], ['mcomma', [10793]], ['Mcy', [1052]], ['mcy', [1084]], ['mdash', [8212]], ['mDDot', [8762]], ['measuredangle', [8737]], ['MediumSpace', [8287]], ['Mellintrf', [8499]], ['Mfr', [120080]], ['mfr', [120106]], ['mho', [8487]], ['micro', [181]], ['midast', [42]], ['midcir', [10992]], ['mid', [8739]], ['middot', [183]], ['minusb', [8863]], ['minus', [8722]], ['minusd', [8760]], ['minusdu', [10794]], ['MinusPlus', [8723]], ['mlcp', [10971]], ['mldr', [8230]], ['mnplus', [8723]], ['models', [8871]], ['Mopf', [120132]], ['mopf', [120158]], ['mp', [8723]], ['mscr', [120002]], ['Mscr', [8499]], ['mstpos', [8766]], ['Mu', [924]], ['mu', [956]], ['multimap', [8888]], ['mumap', [8888]], ['nabla', [8711]], ['Nacute', [323]], ['nacute', [324]], ['nang', [8736, 8402]], ['nap', [8777]], ['napE', [10864, 824]], ['napid', [8779, 824]], ['napos', [329]], ['napprox', [8777]], ['natural', [9838]], ['naturals', [8469]], ['natur', [9838]], ['nbsp', [160]], ['nbump', [8782, 824]], ['nbumpe', [8783, 824]], ['ncap', [10819]], ['Ncaron', [327]], ['ncaron', [328]], ['Ncedil', [325]], ['ncedil', [326]], ['ncong', [8775]], ['ncongdot', [10861, 824]], ['ncup', [10818]], ['Ncy', [1053]], ['ncy', [1085]], ['ndash', [8211]], ['nearhk', [10532]], ['nearr', [8599]], ['neArr', [8663]], ['nearrow', [8599]], ['ne', [8800]], ['nedot', [8784, 824]], ['NegativeMediumSpace', [8203]], ['NegativeThickSpace', [8203]], ['NegativeThinSpace', [8203]], ['NegativeVeryThinSpace', [8203]], ['nequiv', [8802]], ['nesear', [10536]], ['nesim', [8770, 824]], ['NestedGreaterGreater', [8811]], ['NestedLessLess', [8810]], ['nexist', [8708]], ['nexists', [8708]], ['Nfr', [120081]], ['nfr', [120107]], ['ngE', [8807, 824]], ['nge', [8817]], ['ngeq', [8817]], ['ngeqq', [8807, 824]], ['ngeqslant', [10878, 824]], ['nges', [10878, 824]], ['nGg', [8921, 824]], ['ngsim', [8821]], ['nGt', [8811, 8402]], ['ngt', [8815]], ['ngtr', [8815]], ['nGtv', [8811, 824]], ['nharr', [8622]], ['nhArr', [8654]], ['nhpar', [10994]], ['ni', [8715]], ['nis', [8956]], ['nisd', [8954]], ['niv', [8715]], ['NJcy', [1034]], ['njcy', [1114]], ['nlarr', [8602]], ['nlArr', [8653]], ['nldr', [8229]], ['nlE', [8806, 824]], ['nle', [8816]], ['nleftarrow', [8602]], ['nLeftarrow', [8653]], ['nleftrightarrow', [8622]], ['nLeftrightarrow', [8654]], ['nleq', [8816]], ['nleqq', [8806, 824]], ['nleqslant', [10877, 824]], ['nles', [10877, 824]], ['nless', [8814]], ['nLl', [8920, 824]], ['nlsim', [8820]], ['nLt', [8810, 8402]], ['nlt', [8814]], ['nltri', [8938]], ['nltrie', [8940]], ['nLtv', [8810, 824]], ['nmid', [8740]], ['NoBreak', [8288]], ['NonBreakingSpace', [160]], ['nopf', [120159]], ['Nopf', [8469]], ['Not', [10988]], ['not', [172]], ['NotCongruent', [8802]], ['NotCupCap', [8813]], ['NotDoubleVerticalBar', [8742]], ['NotElement', [8713]], ['NotEqual', [8800]], ['NotEqualTilde', [8770, 824]], ['NotExists', [8708]], ['NotGreater', [8815]], ['NotGreaterEqual', [8817]], ['NotGreaterFullEqual', [8807, 824]], ['NotGreaterGreater', [8811, 824]], ['NotGreaterLess', [8825]], ['NotGreaterSlantEqual', [10878, 824]], ['NotGreaterTilde', [8821]], ['NotHumpDownHump', [8782, 824]], ['NotHumpEqual', [8783, 824]], ['notin', [8713]], ['notindot', [8949, 824]], ['notinE', [8953, 824]], ['notinva', [8713]], ['notinvb', [8951]], ['notinvc', [8950]], ['NotLeftTriangleBar', [10703, 824]], ['NotLeftTriangle', [8938]], ['NotLeftTriangleEqual', [8940]], ['NotLess', [8814]], ['NotLessEqual', [8816]], ['NotLessGreater', [8824]], ['NotLessLess', [8810, 824]], ['NotLessSlantEqual', [10877, 824]], ['NotLessTilde', [8820]], ['NotNestedGreaterGreater', [10914, 824]], ['NotNestedLessLess', [10913, 824]], ['notni', [8716]], ['notniva', [8716]], ['notnivb', [8958]], ['notnivc', [8957]], ['NotPrecedes', [8832]], ['NotPrecedesEqual', [10927, 824]], ['NotPrecedesSlantEqual', [8928]], ['NotReverseElement', [8716]], ['NotRightTriangleBar', [10704, 824]], ['NotRightTriangle', [8939]], ['NotRightTriangleEqual', [8941]], ['NotSquareSubset', [8847, 824]], ['NotSquareSubsetEqual', [8930]], ['NotSquareSuperset', [8848, 824]], ['NotSquareSupersetEqual', [8931]], ['NotSubset', [8834, 8402]], ['NotSubsetEqual', [8840]], ['NotSucceeds', [8833]], ['NotSucceedsEqual', [10928, 824]], ['NotSucceedsSlantEqual', [8929]], ['NotSucceedsTilde', [8831, 824]], ['NotSuperset', [8835, 8402]], ['NotSupersetEqual', [8841]], ['NotTilde', [8769]], ['NotTildeEqual', [8772]], ['NotTildeFullEqual', [8775]], ['NotTildeTilde', [8777]], ['NotVerticalBar', [8740]], ['nparallel', [8742]], ['npar', [8742]], ['nparsl', [11005, 8421]], ['npart', [8706, 824]], ['npolint', [10772]], ['npr', [8832]], ['nprcue', [8928]], ['nprec', [8832]], ['npreceq', [10927, 824]], ['npre', [10927, 824]], ['nrarrc', [10547, 824]], ['nrarr', [8603]], ['nrArr', [8655]], ['nrarrw', [8605, 824]], ['nrightarrow', [8603]], ['nRightarrow', [8655]], ['nrtri', [8939]], ['nrtrie', [8941]], ['nsc', [8833]], ['nsccue', [8929]], ['nsce', [10928, 824]], ['Nscr', [119977]], ['nscr', [120003]], ['nshortmid', [8740]], ['nshortparallel', [8742]], ['nsim', [8769]], ['nsime', [8772]], ['nsimeq', [8772]], ['nsmid', [8740]], ['nspar', [8742]], ['nsqsube', [8930]], ['nsqsupe', [8931]], ['nsub', [8836]], ['nsubE', [10949, 824]], ['nsube', [8840]], ['nsubset', [8834, 8402]], ['nsubseteq', [8840]], ['nsubseteqq', [10949, 824]], ['nsucc', [8833]], ['nsucceq', [10928, 824]], ['nsup', [8837]], ['nsupE', [10950, 824]], ['nsupe', [8841]], ['nsupset', [8835, 8402]], ['nsupseteq', [8841]], ['nsupseteqq', [10950, 824]], ['ntgl', [8825]], ['Ntilde', [209]], ['ntilde', [241]], ['ntlg', [8824]], ['ntriangleleft', [8938]], ['ntrianglelefteq', [8940]], ['ntriangleright', [8939]], ['ntrianglerighteq', [8941]], ['Nu', [925]], ['nu', [957]], ['num', [35]], ['numero', [8470]], ['numsp', [8199]], ['nvap', [8781, 8402]], ['nvdash', [8876]], ['nvDash', [8877]], ['nVdash', [8878]], ['nVDash', [8879]], ['nvge', [8805, 8402]], ['nvgt', [62, 8402]], ['nvHarr', [10500]], ['nvinfin', [10718]], ['nvlArr', [10498]], ['nvle', [8804, 8402]], ['nvlt', [60, 8402]], ['nvltrie', [8884, 8402]], ['nvrArr', [10499]], ['nvrtrie', [8885, 8402]], ['nvsim', [8764, 8402]], ['nwarhk', [10531]], ['nwarr', [8598]], ['nwArr', [8662]], ['nwarrow', [8598]], ['nwnear', [10535]], ['Oacute', [211]], ['oacute', [243]], ['oast', [8859]], ['Ocirc', [212]], ['ocirc', [244]], ['ocir', [8858]], ['Ocy', [1054]], ['ocy', [1086]], ['odash', [8861]], ['Odblac', [336]], ['odblac', [337]], ['odiv', [10808]], ['odot', [8857]], ['odsold', [10684]], ['OElig', [338]], ['oelig', [339]], ['ofcir', [10687]], ['Ofr', [120082]], ['ofr', [120108]], ['ogon', [731]], ['Ograve', [210]], ['ograve', [242]], ['ogt', [10689]], ['ohbar', [10677]], ['ohm', [937]], ['oint', [8750]], ['olarr', [8634]], ['olcir', [10686]], ['olcross', [10683]], ['oline', [8254]], ['olt', [10688]], ['Omacr', [332]], ['omacr', [333]], ['Omega', [937]], ['omega', [969]], ['Omicron', [927]], ['omicron', [959]], ['omid', [10678]], ['ominus', [8854]], ['Oopf', [120134]], ['oopf', [120160]], ['opar', [10679]], ['OpenCurlyDoubleQuote', [8220]], ['OpenCurlyQuote', [8216]], ['operp', [10681]], ['oplus', [8853]], ['orarr', [8635]], ['Or', [10836]], ['or', [8744]], ['ord', [10845]], ['order', [8500]], ['orderof', [8500]], ['ordf', [170]], ['ordm', [186]], ['origof', [8886]], ['oror', [10838]], ['orslope', [10839]], ['orv', [10843]], ['oS', [9416]], ['Oscr', [119978]], ['oscr', [8500]], ['Oslash', [216]], ['oslash', [248]], ['osol', [8856]], ['Otilde', [213]], ['otilde', [245]], ['otimesas', [10806]], ['Otimes', [10807]], ['otimes', [8855]], ['Ouml', [214]], ['ouml', [246]], ['ovbar', [9021]], ['OverBar', [8254]], ['OverBrace', [9182]], ['OverBracket', [9140]], ['OverParenthesis', [9180]], ['para', [182]], ['parallel', [8741]], ['par', [8741]], ['parsim', [10995]], ['parsl', [11005]], ['part', [8706]], ['PartialD', [8706]], ['Pcy', [1055]], ['pcy', [1087]], ['percnt', [37]], ['period', [46]], ['permil', [8240]], ['perp', [8869]], ['pertenk', [8241]], ['Pfr', [120083]], ['pfr', [120109]], ['Phi', [934]], ['phi', [966]], ['phiv', [981]], ['phmmat', [8499]], ['phone', [9742]], ['Pi', [928]], ['pi', [960]], ['pitchfork', [8916]], ['piv', [982]], ['planck', [8463]], ['planckh', [8462]], ['plankv', [8463]], ['plusacir', [10787]], ['plusb', [8862]], ['pluscir', [10786]], ['plus', [43]], ['plusdo', [8724]], ['plusdu', [10789]], ['pluse', [10866]], ['PlusMinus', [177]], ['plusmn', [177]], ['plussim', [10790]], ['plustwo', [10791]], ['pm', [177]], ['Poincareplane', [8460]], ['pointint', [10773]], ['popf', [120161]], ['Popf', [8473]], ['pound', [163]], ['prap', [10935]], ['Pr', [10939]], ['pr', [8826]], ['prcue', [8828]], ['precapprox', [10935]], ['prec', [8826]], ['preccurlyeq', [8828]], ['Precedes', [8826]], ['PrecedesEqual', [10927]], ['PrecedesSlantEqual', [8828]], ['PrecedesTilde', [8830]], ['preceq', [10927]], ['precnapprox', [10937]], ['precneqq', [10933]], ['precnsim', [8936]], ['pre', [10927]], ['prE', [10931]], ['precsim', [8830]], ['prime', [8242]], ['Prime', [8243]], ['primes', [8473]], ['prnap', [10937]], ['prnE', [10933]], ['prnsim', [8936]], ['prod', [8719]], ['Product', [8719]], ['profalar', [9006]], ['profline', [8978]], ['profsurf', [8979]], ['prop', [8733]], ['Proportional', [8733]], ['Proportion', [8759]], ['propto', [8733]], ['prsim', [8830]], ['prurel', [8880]], ['Pscr', [119979]], ['pscr', [120005]], ['Psi', [936]], ['psi', [968]], ['puncsp', [8200]], ['Qfr', [120084]], ['qfr', [120110]], ['qint', [10764]], ['qopf', [120162]], ['Qopf', [8474]], ['qprime', [8279]], ['Qscr', [119980]], ['qscr', [120006]], ['quaternions', [8461]], ['quatint', [10774]], ['quest', [63]], ['questeq', [8799]], ['quot', [34]], ['QUOT', [34]], ['rAarr', [8667]], ['race', [8765, 817]], ['Racute', [340]], ['racute', [341]], ['radic', [8730]], ['raemptyv', [10675]], ['rang', [10217]], ['Rang', [10219]], ['rangd', [10642]], ['range', [10661]], ['rangle', [10217]], ['raquo', [187]], ['rarrap', [10613]], ['rarrb', [8677]], ['rarrbfs', [10528]], ['rarrc', [10547]], ['rarr', [8594]], ['Rarr', [8608]], ['rArr', [8658]], ['rarrfs', [10526]], ['rarrhk', [8618]], ['rarrlp', [8620]], ['rarrpl', [10565]], ['rarrsim', [10612]], ['Rarrtl', [10518]], ['rarrtl', [8611]], ['rarrw', [8605]], ['ratail', [10522]], ['rAtail', [10524]], ['ratio', [8758]], ['rationals', [8474]], ['rbarr', [10509]], ['rBarr', [10511]], ['RBarr', [10512]], ['rbbrk', [10099]], ['rbrace', [125]], ['rbrack', [93]], ['rbrke', [10636]], ['rbrksld', [10638]], ['rbrkslu', [10640]], ['Rcaron', [344]], ['rcaron', [345]], ['Rcedil', [342]], ['rcedil', [343]], ['rceil', [8969]], ['rcub', [125]], ['Rcy', [1056]], ['rcy', [1088]], ['rdca', [10551]], ['rdldhar', [10601]], ['rdquo', [8221]], ['rdquor', [8221]], ['rdsh', [8627]], ['real', [8476]], ['realine', [8475]], ['realpart', [8476]], ['reals', [8477]], ['Re', [8476]], ['rect', [9645]], ['reg', [174]], ['REG', [174]], ['ReverseElement', [8715]], ['ReverseEquilibrium', [8651]], ['ReverseUpEquilibrium', [10607]], ['rfisht', [10621]], ['rfloor', [8971]], ['rfr', [120111]], ['Rfr', [8476]], ['rHar', [10596]], ['rhard', [8641]], ['rharu', [8640]], ['rharul', [10604]], ['Rho', [929]], ['rho', [961]], ['rhov', [1009]], ['RightAngleBracket', [10217]], ['RightArrowBar', [8677]], ['rightarrow', [8594]], ['RightArrow', [8594]], ['Rightarrow', [8658]], ['RightArrowLeftArrow', [8644]], ['rightarrowtail', [8611]], ['RightCeiling', [8969]], ['RightDoubleBracket', [10215]], ['RightDownTeeVector', [10589]], ['RightDownVectorBar', [10581]], ['RightDownVector', [8642]], ['RightFloor', [8971]], ['rightharpoondown', [8641]], ['rightharpoonup', [8640]], ['rightleftarrows', [8644]], ['rightleftharpoons', [8652]], ['rightrightarrows', [8649]], ['rightsquigarrow', [8605]], ['RightTeeArrow', [8614]], ['RightTee', [8866]], ['RightTeeVector', [10587]], ['rightthreetimes', [8908]], ['RightTriangleBar', [10704]], ['RightTriangle', [8883]], ['RightTriangleEqual', [8885]], ['RightUpDownVector', [10575]], ['RightUpTeeVector', [10588]], ['RightUpVectorBar', [10580]], ['RightUpVector', [8638]], ['RightVectorBar', [10579]], ['RightVector', [8640]], ['ring', [730]], ['risingdotseq', [8787]], ['rlarr', [8644]], ['rlhar', [8652]], ['rlm', [8207]], ['rmoustache', [9137]], ['rmoust', [9137]], ['rnmid', [10990]], ['roang', [10221]], ['roarr', [8702]], ['robrk', [10215]], ['ropar', [10630]], ['ropf', [120163]], ['Ropf', [8477]], ['roplus', [10798]], ['rotimes', [10805]], ['RoundImplies', [10608]], ['rpar', [41]], ['rpargt', [10644]], ['rppolint', [10770]], ['rrarr', [8649]], ['Rrightarrow', [8667]], ['rsaquo', [8250]], ['rscr', [120007]], ['Rscr', [8475]], ['rsh', [8625]], ['Rsh', [8625]], ['rsqb', [93]], ['rsquo', [8217]], ['rsquor', [8217]], ['rthree', [8908]], ['rtimes', [8906]], ['rtri', [9657]], ['rtrie', [8885]], ['rtrif', [9656]], ['rtriltri', [10702]], ['RuleDelayed', [10740]], ['ruluhar', [10600]], ['rx', [8478]], ['Sacute', [346]], ['sacute', [347]], ['sbquo', [8218]], ['scap', [10936]], ['Scaron', [352]], ['scaron', [353]], ['Sc', [10940]], ['sc', [8827]], ['sccue', [8829]], ['sce', [10928]], ['scE', [10932]], ['Scedil', [350]], ['scedil', [351]], ['Scirc', [348]], ['scirc', [349]], ['scnap', [10938]], ['scnE', [10934]], ['scnsim', [8937]], ['scpolint', [10771]], ['scsim', [8831]], ['Scy', [1057]], ['scy', [1089]], ['sdotb', [8865]], ['sdot', [8901]], ['sdote', [10854]], ['searhk', [10533]], ['searr', [8600]], ['seArr', [8664]], ['searrow', [8600]], ['sect', [167]], ['semi', [59]], ['seswar', [10537]], ['setminus', [8726]], ['setmn', [8726]], ['sext', [10038]], ['Sfr', [120086]], ['sfr', [120112]], ['sfrown', [8994]], ['sharp', [9839]], ['SHCHcy', [1065]], ['shchcy', [1097]], ['SHcy', [1064]], ['shcy', [1096]], ['ShortDownArrow', [8595]], ['ShortLeftArrow', [8592]], ['shortmid', [8739]], ['shortparallel', [8741]], ['ShortRightArrow', [8594]], ['ShortUpArrow', [8593]], ['shy', [173]], ['Sigma', [931]], ['sigma', [963]], ['sigmaf', [962]], ['sigmav', [962]], ['sim', [8764]], ['simdot', [10858]], ['sime', [8771]], ['simeq', [8771]], ['simg', [10910]], ['simgE', [10912]], ['siml', [10909]], ['simlE', [10911]], ['simne', [8774]], ['simplus', [10788]], ['simrarr', [10610]], ['slarr', [8592]], ['SmallCircle', [8728]], ['smallsetminus', [8726]], ['smashp', [10803]], ['smeparsl', [10724]], ['smid', [8739]], ['smile', [8995]], ['smt', [10922]], ['smte', [10924]], ['smtes', [10924, 65024]], ['SOFTcy', [1068]], ['softcy', [1100]], ['solbar', [9023]], ['solb', [10692]], ['sol', [47]], ['Sopf', [120138]], ['sopf', [120164]], ['spades', [9824]], ['spadesuit', [9824]], ['spar', [8741]], ['sqcap', [8851]], ['sqcaps', [8851, 65024]], ['sqcup', [8852]], ['sqcups', [8852, 65024]], ['Sqrt', [8730]], ['sqsub', [8847]], ['sqsube', [8849]], ['sqsubset', [8847]], ['sqsubseteq', [8849]], ['sqsup', [8848]], ['sqsupe', [8850]], ['sqsupset', [8848]], ['sqsupseteq', [8850]], ['square', [9633]], ['Square', [9633]], ['SquareIntersection', [8851]], ['SquareSubset', [8847]], ['SquareSubsetEqual', [8849]], ['SquareSuperset', [8848]], ['SquareSupersetEqual', [8850]], ['SquareUnion', [8852]], ['squarf', [9642]], ['squ', [9633]], ['squf', [9642]], ['srarr', [8594]], ['Sscr', [119982]], ['sscr', [120008]], ['ssetmn', [8726]], ['ssmile', [8995]], ['sstarf', [8902]], ['Star', [8902]], ['star', [9734]], ['starf', [9733]], ['straightepsilon', [1013]], ['straightphi', [981]], ['strns', [175]], ['sub', [8834]], ['Sub', [8912]], ['subdot', [10941]], ['subE', [10949]], ['sube', [8838]], ['subedot', [10947]], ['submult', [10945]], ['subnE', [10955]], ['subne', [8842]], ['subplus', [10943]], ['subrarr', [10617]], ['subset', [8834]], ['Subset', [8912]], ['subseteq', [8838]], ['subseteqq', [10949]], ['SubsetEqual', [8838]], ['subsetneq', [8842]], ['subsetneqq', [10955]], ['subsim', [10951]], ['subsub', [10965]], ['subsup', [10963]], ['succapprox', [10936]], ['succ', [8827]], ['succcurlyeq', [8829]], ['Succeeds', [8827]], ['SucceedsEqual', [10928]], ['SucceedsSlantEqual', [8829]], ['SucceedsTilde', [8831]], ['succeq', [10928]], ['succnapprox', [10938]], ['succneqq', [10934]], ['succnsim', [8937]], ['succsim', [8831]], ['SuchThat', [8715]], ['sum', [8721]], ['Sum', [8721]], ['sung', [9834]], ['sup1', [185]], ['sup2', [178]], ['sup3', [179]], ['sup', [8835]], ['Sup', [8913]], ['supdot', [10942]], ['supdsub', [10968]], ['supE', [10950]], ['supe', [8839]], ['supedot', [10948]], ['Superset', [8835]], ['SupersetEqual', [8839]], ['suphsol', [10185]], ['suphsub', [10967]], ['suplarr', [10619]], ['supmult', [10946]], ['supnE', [10956]], ['supne', [8843]], ['supplus', [10944]], ['supset', [8835]], ['Supset', [8913]], ['supseteq', [8839]], ['supseteqq', [10950]], ['supsetneq', [8843]], ['supsetneqq', [10956]], ['supsim', [10952]], ['supsub', [10964]], ['supsup', [10966]], ['swarhk', [10534]], ['swarr', [8601]], ['swArr', [8665]], ['swarrow', [8601]], ['swnwar', [10538]], ['szlig', [223]], ['Tab', [9]], ['target', [8982]], ['Tau', [932]], ['tau', [964]], ['tbrk', [9140]], ['Tcaron', [356]], ['tcaron', [357]], ['Tcedil', [354]], ['tcedil', [355]], ['Tcy', [1058]], ['tcy', [1090]], ['tdot', [8411]], ['telrec', [8981]], ['Tfr', [120087]], ['tfr', [120113]], ['there4', [8756]], ['therefore', [8756]], ['Therefore', [8756]], ['Theta', [920]], ['theta', [952]], ['thetasym', [977]], ['thetav', [977]], ['thickapprox', [8776]], ['thicksim', [8764]], ['ThickSpace', [8287, 8202]], ['ThinSpace', [8201]], ['thinsp', [8201]], ['thkap', [8776]], ['thksim', [8764]], ['THORN', [222]], ['thorn', [254]], ['tilde', [732]], ['Tilde', [8764]], ['TildeEqual', [8771]], ['TildeFullEqual', [8773]], ['TildeTilde', [8776]], ['timesbar', [10801]], ['timesb', [8864]], ['times', [215]], ['timesd', [10800]], ['tint', [8749]], ['toea', [10536]], ['topbot', [9014]], ['topcir', [10993]], ['top', [8868]], ['Topf', [120139]], ['topf', [120165]], ['topfork', [10970]], ['tosa', [10537]], ['tprime', [8244]], ['trade', [8482]], ['TRADE', [8482]], ['triangle', [9653]], ['triangledown', [9663]], ['triangleleft', [9667]], ['trianglelefteq', [8884]], ['triangleq', [8796]], ['triangleright', [9657]], ['trianglerighteq', [8885]], ['tridot', [9708]], ['trie', [8796]], ['triminus', [10810]], ['TripleDot', [8411]], ['triplus', [10809]], ['trisb', [10701]], ['tritime', [10811]], ['trpezium', [9186]], ['Tscr', [119983]], ['tscr', [120009]], ['TScy', [1062]], ['tscy', [1094]], ['TSHcy', [1035]], ['tshcy', [1115]], ['Tstrok', [358]], ['tstrok', [359]], ['twixt', [8812]], ['twoheadleftarrow', [8606]], ['twoheadrightarrow', [8608]], ['Uacute', [218]], ['uacute', [250]], ['uarr', [8593]], ['Uarr', [8607]], ['uArr', [8657]], ['Uarrocir', [10569]], ['Ubrcy', [1038]], ['ubrcy', [1118]], ['Ubreve', [364]], ['ubreve', [365]], ['Ucirc', [219]], ['ucirc', [251]], ['Ucy', [1059]], ['ucy', [1091]], ['udarr', [8645]], ['Udblac', [368]], ['udblac', [369]], ['udhar', [10606]], ['ufisht', [10622]], ['Ufr', [120088]], ['ufr', [120114]], ['Ugrave', [217]], ['ugrave', [249]], ['uHar', [10595]], ['uharl', [8639]], ['uharr', [8638]], ['uhblk', [9600]], ['ulcorn', [8988]], ['ulcorner', [8988]], ['ulcrop', [8975]], ['ultri', [9720]], ['Umacr', [362]], ['umacr', [363]], ['uml', [168]], ['UnderBar', [95]], ['UnderBrace', [9183]], ['UnderBracket', [9141]], ['UnderParenthesis', [9181]], ['Union', [8899]], ['UnionPlus', [8846]], ['Uogon', [370]], ['uogon', [371]], ['Uopf', [120140]], ['uopf', [120166]], ['UpArrowBar', [10514]], ['uparrow', [8593]], ['UpArrow', [8593]], ['Uparrow', [8657]], ['UpArrowDownArrow', [8645]], ['updownarrow', [8597]], ['UpDownArrow', [8597]], ['Updownarrow', [8661]], ['UpEquilibrium', [10606]], ['upharpoonleft', [8639]], ['upharpoonright', [8638]], ['uplus', [8846]], ['UpperLeftArrow', [8598]], ['UpperRightArrow', [8599]], ['upsi', [965]], ['Upsi', [978]], ['upsih', [978]], ['Upsilon', [933]], ['upsilon', [965]], ['UpTeeArrow', [8613]], ['UpTee', [8869]], ['upuparrows', [8648]], ['urcorn', [8989]], ['urcorner', [8989]], ['urcrop', [8974]], ['Uring', [366]], ['uring', [367]], ['urtri', [9721]], ['Uscr', [119984]], ['uscr', [120010]], ['utdot', [8944]], ['Utilde', [360]], ['utilde', [361]], ['utri', [9653]], ['utrif', [9652]], ['uuarr', [8648]], ['Uuml', [220]], ['uuml', [252]], ['uwangle', [10663]], ['vangrt', [10652]], ['varepsilon', [1013]], ['varkappa', [1008]], ['varnothing', [8709]], ['varphi', [981]], ['varpi', [982]], ['varpropto', [8733]], ['varr', [8597]], ['vArr', [8661]], ['varrho', [1009]], ['varsigma', [962]], ['varsubsetneq', [8842, 65024]], ['varsubsetneqq', [10955, 65024]], ['varsupsetneq', [8843, 65024]], ['varsupsetneqq', [10956, 65024]], ['vartheta', [977]], ['vartriangleleft', [8882]], ['vartriangleright', [8883]], ['vBar', [10984]], ['Vbar', [10987]], ['vBarv', [10985]], ['Vcy', [1042]], ['vcy', [1074]], ['vdash', [8866]], ['vDash', [8872]], ['Vdash', [8873]], ['VDash', [8875]], ['Vdashl', [10982]], ['veebar', [8891]], ['vee', [8744]], ['Vee', [8897]], ['veeeq', [8794]], ['vellip', [8942]], ['verbar', [124]], ['Verbar', [8214]], ['vert', [124]], ['Vert', [8214]], ['VerticalBar', [8739]], ['VerticalLine', [124]], ['VerticalSeparator', [10072]], ['VerticalTilde', [8768]], ['VeryThinSpace', [8202]], ['Vfr', [120089]], ['vfr', [120115]], ['vltri', [8882]], ['vnsub', [8834, 8402]], ['vnsup', [8835, 8402]], ['Vopf', [120141]], ['vopf', [120167]], ['vprop', [8733]], ['vrtri', [8883]], ['Vscr', [119985]], ['vscr', [120011]], ['vsubnE', [10955, 65024]], ['vsubne', [8842, 65024]], ['vsupnE', [10956, 65024]], ['vsupne', [8843, 65024]], ['Vvdash', [8874]], ['vzigzag', [10650]], ['Wcirc', [372]], ['wcirc', [373]], ['wedbar', [10847]], ['wedge', [8743]], ['Wedge', [8896]], ['wedgeq', [8793]], ['weierp', [8472]], ['Wfr', [120090]], ['wfr', [120116]], ['Wopf', [120142]], ['wopf', [120168]], ['wp', [8472]], ['wr', [8768]], ['wreath', [8768]], ['Wscr', [119986]], ['wscr', [120012]], ['xcap', [8898]], ['xcirc', [9711]], ['xcup', [8899]], ['xdtri', [9661]], ['Xfr', [120091]], ['xfr', [120117]], ['xharr', [10231]], ['xhArr', [10234]], ['Xi', [926]], ['xi', [958]], ['xlarr', [10229]], ['xlArr', [10232]], ['xmap', [10236]], ['xnis', [8955]], ['xodot', [10752]], ['Xopf', [120143]], ['xopf', [120169]], ['xoplus', [10753]], ['xotime', [10754]], ['xrarr', [10230]], ['xrArr', [10233]], ['Xscr', [119987]], ['xscr', [120013]], ['xsqcup', [10758]], ['xuplus', [10756]], ['xutri', [9651]], ['xvee', [8897]], ['xwedge', [8896]], ['Yacute', [221]], ['yacute', [253]], ['YAcy', [1071]], ['yacy', [1103]], ['Ycirc', [374]], ['ycirc', [375]], ['Ycy', [1067]], ['ycy', [1099]], ['yen', [165]], ['Yfr', [120092]], ['yfr', [120118]], ['YIcy', [1031]], ['yicy', [1111]], ['Yopf', [120144]], ['yopf', [120170]], ['Yscr', [119988]], ['yscr', [120014]], ['YUcy', [1070]], ['yucy', [1102]], ['yuml', [255]], ['Yuml', [376]], ['Zacute', [377]], ['zacute', [378]], ['Zcaron', [381]], ['zcaron', [382]], ['Zcy', [1047]], ['zcy', [1079]], ['Zdot', [379]], ['zdot', [380]], ['zeetrf', [8488]], ['ZeroWidthSpace', [8203]], ['Zeta', [918]], ['zeta', [950]], ['zfr', [120119]], ['Zfr', [8488]], ['ZHcy', [1046]], ['zhcy', [1078]], ['zigrarr', [8669]], ['zopf', [120171]], ['Zopf', [8484]], ['Zscr', [119989]], ['zscr', [120015]], ['zwj', [8205]], ['zwnj', [8204]]];

var alphaIndex = {};
var charIndex = {};

createIndexes(alphaIndex, charIndex);

/**
 * @constructor
 */
function Html5Entities() {}

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.decode = function(str) {
    if (str.length === 0) {
        return '';
    }
    return str.replace(/&(#?[\w\d]+);?/g, function(s, entity) {
        var char;
        if (entity.charAt(0) === "#") {
            var code = entity.charAt(1) === 'x' ?
                parseInt(entity.substr(2).toLowerCase(), 16) :
                parseInt(entity.substr(1));

            if (!(isNaN(code) || code < -32768 || code > 65535)) {
                char = String.fromCharCode(code);
            }
        } else {
            char = alphaIndex[entity];
        }
        return char || s;
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.encode = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var charInfo = charIndex[str.charCodeAt(i)];
        if (charInfo) {
            var alpha = charInfo[str.charCodeAt(i + 1)];
            if (alpha) {
                i++;
            } else {
                alpha = charInfo[''];
            }
            if (alpha) {
                result += "&" + alpha + ";";
                i++;
                continue;
            }
        }
        result += str.charAt(i);
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.encodeNonUTF = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        var charInfo = charIndex[c];
        if (charInfo) {
            var alpha = charInfo[str.charCodeAt(i + 1)];
            if (alpha) {
                i++;
            } else {
                alpha = charInfo[''];
            }
            if (alpha) {
                result += "&" + alpha + ";";
                i++;
                continue;
            }
        }
        if (c < 32 || c > 126) {
            result += '&#' + c + ';';
        } else {
            result += str.charAt(i);
        }
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.encodeNonASCII = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        if (c <= 255) {
            result += str[i++];
            continue;
        }
        result += '&#' + c + ';';
        i++
    }
    return result;
};

/**
 * @param {Object} alphaIndex Passed by reference.
 * @param {Object} charIndex Passed by reference.
 */
function createIndexes(alphaIndex, charIndex) {
    var i = ENTITIES.length;
    var _results = [];
    while (i--) {
        var e = ENTITIES[i];
        var alpha = e[0];
        var chars = e[1];
        var chr = chars[0];
        var addChar = (chr < 32 || chr > 126) || chr === 62 || chr === 60 || chr === 38 || chr === 34 || chr === 39;
        var charInfo;
        if (addChar) {
            charInfo = charIndex[chr] = charIndex[chr] || {};
        }
        if (chars[1]) {
            var chr2 = chars[1];
            alphaIndex[alpha] = String.fromCharCode(chr) + String.fromCharCode(chr2);
            _results.push(addChar && (charInfo[chr2] = alpha));
        } else {
            alphaIndex[alpha] = String.fromCharCode(chr);
            _results.push(addChar && (charInfo[''] = alpha));
        }
    }
}

module.exports = Html5Entities;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomByte = __webpack_require__(471);

function encode(lookup, number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = encode;


/***/ }),
/* 361 */,
/* 362 */,
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var get = __webpack_require__(14);

var _require = __webpack_require__(134),
    URL = _require.URL;

var _require2 = __webpack_require__(388),
    fetchWrapper = _require2.fetchWrapper;

var GAC = __webpack_require__(550);

// Stores
var GalleryStore = __webpack_require__(357);
var CreatorsStore = __webpack_require__(575);

// Actions
var shareActions = __webpack_require__(736);
var galleryPhotoUIActions = __webpack_require__(721);
var galleryTrackingActions = __webpack_require__(453);
var creatorsActions = __webpack_require__(1076);

/**
 * Sets up the store with photos from a single project and firm
 * @param ac
 * @param payload
 * @param done
 */
function setupStoreWithSingleProjectPhotos(ac, payload, done) {
    ac.dispatch(GAC.GALLERY_SETUP_STORE, {
        galleryPhotos: payload.photos,
        project: {
            name: payload.projectName,
            url: payload.projectUrl,
            location: payload.projectLocation
        },
        firm: {
            name: payload.firmName,
            url: payload.firmUrl,
            photo: payload.firmPhoto,
            urlLabel: payload.firmUrlLabel
        },
        initialPhoto: payload.photo,
        totalPhotos: (payload.photos || []).length
    });
    done();
}

/**
 * Sets up the store with photos from multiple projects and firms
 * @param ac
 * @param payload
 * @param done
 */
function setupStoreWithMultipleProjectPhotos(ac, payload, done) {
    ac.dispatch(GAC.GALLERY_SETUP_STORE, payload);
    done();
}

function resetSetupStore(ac, payload, done) {
    ac.dispatch(GAC.GALLERY_RESET_STORE, payload);
    done();
}

function addSimilarItemsTemplate(ac, payload, done) {
    ac.dispatch(GAC.GALLERY_ADD_SIMILAR_ITEMS_TEMPLATE, payload);
    done();
}

function addMoreProjectsTemplate(ac, payload, done) {
    ac.dispatch(GAC.GALLERY_ADD_MORE_PROJECTS_TEMPLATE, payload);
    done();
}

function fetchItemTagCreators(ac, payload, done) {
    var creatorsStore = ac.getStore(CreatorsStore);
    var itemTags = ac.getStore(GalleryStore).getCurrentPhotoItemTags();

    var creatorIds = itemTags.reduce(function (_creatorIds, itemTag) {
        var creatorId = get(itemTag, 'attributeProfile.dataMap.creatorId[0].value', '');

        if (!!creatorId && !creatorsStore.getCreatorById(creatorId)) {
            _creatorIds.push(creatorId);
        }

        return _creatorIds;
    }, []);

    if (creatorIds.length) {
        ac.executeAction(creatorsActions.fetchCreators, { creatorIds: creatorIds });
    }

    done();
}

function fetchSimilarItemsTemplate(ac, payload, done) {
    var galleryStore = ac.getStore(GalleryStore);

    // Check the store if similar items should be fetched
    if (galleryStore.shouldFetchSimilarItems()) {
        // Fetch Similar Items Template
        fetchWrapper(galleryStore.getSimilarItemsFullUrl()).then(function (response) {
            // Add Template to Gallery Store
            ac.executeAction(addSimilarItemsTemplate, response);
            done();
        }).catch(done);
        return;
    }

    done();
}

function fetchMoreProjectsTemplate(ac, payload, done) {
    var galleryStore = ac.getStore(GalleryStore);

    // Check the store if more projects should be fetched
    if (galleryStore.shouldFetchMoreProjects()) {
        // Fetch More Projects Template
        fetchWrapper(galleryStore.getSimilarItemsFullUrl()).then(function (response) {
            // Add Template to Gallery Store
            ac.executeAction(addMoreProjectsTemplate, response);
            done();
        }).catch(done);
        return;
    }

    done();
}

/**
 * Action for loading gallery photos asynchronously
 * @param ac
 * @param payload
 * @param done
 */
function loadPhotos(ac, payload, done) {
    var galleryStore = ac.getStore(GalleryStore);

    if (!galleryStore.shouldLoadPhotos()) {
        done();
    } else {
        ac.dispatch(GAC.GALLERY_PHOTOS_LOAD_START);

        fetchWrapper(galleryStore.getLoadPhotosFullUrl()).then(function (response) {
            ac.dispatch(GAC.GALLERY_PHOTOS_LOAD_DONE, response);
            done();
        }).catch(function (error) {
            ac.dispatch(GAC.GALLERY_PHOTOS_LOAD_FAILED, { error: error });
            done();
        });
    }
}

/**
 * Action for setting the gallery's photo to a particular photo by its id
 * @param ac
 * @param payload
 * @param done
 */
function setPhoto(ac, payload, done) {
    ac.dispatch(GAC.GALLERY_SET_PHOTO, payload);

    ac.executeAction(fetchItemTagCreators);
    ac.executeAction(loadPhotos);
    ac.executeAction(galleryPhotoUIActions.flashItemTagIndicators);

    ac.executeAction(fetchSimilarItemsTemplate, payload, function () {
        ac.executeAction(galleryTrackingActions.fireVPVAndImpressions);
        done();
    });

    ac.executeAction(fetchMoreProjectsTemplate);
}

/**
 * Action for switching the current photo (Next, Previous...)
 * @param ac
 * @param payload
 * @param done
 */
function switchPhoto(ac, payload, done) {
    ac.dispatch(GAC.GALLERY_SWITCH_PHOTO, payload);

    ac.executeAction(fetchItemTagCreators);
    ac.executeAction(loadPhotos);
    ac.executeAction(galleryPhotoUIActions.flashItemTagIndicators);

    // Switch Photo Tracking Actions
    // (Note: ordering of these tracking events is important
    //      for making sure events are associated with correct pages)
    ac.executeAction(galleryTrackingActions.trackPhotoSwitch, payload);
    ac.executeAction(fetchSimilarItemsTemplate, payload, function () {
        ac.executeAction(galleryTrackingActions.fireVPVAndImpressions);
        done();
    });

    ac.executeAction(fetchMoreProjectsTemplate);
}

/**
 * Action to show details on mobile
 */
function showDetailsMobile(ac, payload, done) {
    ac.dispatch(GAC.GALLERY_MOBILE_SHOW_DETAILS, payload);
    done();
}

function toggleDetailsMobile(ac, payload, done) {
    var showDetails = !ac.getStore(GalleryStore).showDetailsMobile();
    ac.executeAction(showDetailsMobile, { showDetails: showDetails });
    done();
}

function toggleSocialMobile(ac, payload, done) {
    var showSocial = !ac.getStore(GalleryStore).showSocialMobile();
    ac.dispatch(GAC.GALLERY_MOBILE_SHOW_SOCIAL, { showSocial: showSocial });
    done();
}

/**
 * Action for overwriting the gallery's default copy
 * @see '/json/copy/photoGallery.json'
 */
function updateCopy(ac, payload, done) {
    ac.dispatch(GAC.GALLERY_UPDATE_COPY, payload);
    done();
}

/**
 * Action for sharing the current photo
 *
 * @param ac
 * @param {string} type
 * @param {function} done
 */
function sharePhoto(ac, _ref, done) {
    var type = _ref.type;

    var url = URL.host + URL.path;
    var galleryStore = ac.getStore(GalleryStore);

    if (type && shareActions.types.indexOf(type) > -1) {
        ac.executeAction(shareActions.shareContent, {
            url: url,
            type: type,
            copy: galleryStore.getGalleryCopy('socialSharing'),
            image: galleryStore.getCurrentPhotoSrc(),
            tokens: {
                url: url,
                firmName: galleryStore.getPhotoFirm('name'),
                projectName: galleryStore.getPhotoProject('name')
            },
            tracking: {
                page: 'trade firm project image',
                shared: 'trade firm project image'
            }
        });
    }

    done();
}

module.exports = {
    setupStoreWithSingleProjectPhotos: setupStoreWithSingleProjectPhotos,
    setupStoreWithMultipleProjectPhotos: setupStoreWithMultipleProjectPhotos,
    resetSetupStore: resetSetupStore,
    switchPhoto: switchPhoto,
    setPhoto: setPhoto,
    loadPhotos: loadPhotos,
    updateCopy: updateCopy,
    fetchItemTagCreators: fetchItemTagCreators,
    showDetailsMobile: showDetailsMobile,
    toggleSocialMobile: toggleSocialMobile,
    toggleDetailsMobile: toggleDetailsMobile,
    addSimilarItemsTemplate: addSimilarItemsTemplate,
    addMoreProjectsTemplate: addMoreProjectsTemplate,
    fetchSimilarItemsTemplate: fetchSimilarItemsTemplate,
    fetchMoreProjectsTemplate: fetchMoreProjectsTemplate,
    sharePhoto: sharePhoto
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);
var BaseModel = __webpack_require__(335);

/**
 * Base carousel view component. "Concrete" carousel views should not extend from this class but should instead wrap it.
 * The model should be initialized in the "child" classes in the `componentWillMount` lifecycle callback.
 * @class
 */

var BaseCarousel = function (_React$Component) {
    _inherits(BaseCarousel, _React$Component);

    function BaseCarousel() {
        _classCallCheck(this, BaseCarousel);

        return _possibleConstructorReturn(this, (BaseCarousel.__proto__ || Object.getPrototypeOf(BaseCarousel)).apply(this, arguments));
    }

    _createClass(BaseCarousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Pass the `el` to the view-model
            this.props.model.onMount(this.refs.list);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // Do any view-model cleanup.
            this.props.model.destroy();
        }

        /**
         * Wraps the passed in children in an `li` so we can apply additional styles to the items.
         * @return {Array}
         */

    }, {
        key: '_getChildren',
        value: function _getChildren() {
            var _this2 = this;

            return React.Children.map(this.props.children, function (child, i) {
                var _props = _this2.props,
                    model = _props.model,
                    _props$classNames = _props.classNames,
                    classNames = _props$classNames === undefined ? {} : _props$classNames;

                var style = {};
                var className = classnames('base-carousel-item', _defineProperty({}, classNames.item, classNames.item));

                // Get any item styles specified by the view-model.
                model.transformItemStyle(style, i);

                return React.createElement(
                    'li',
                    { style: style, className: className },
                    child
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                model = _props2.model,
                _props2$classNames = _props2.classNames,
                classNames = _props2$classNames === undefined ? {} : _props2$classNames;

            var style = {};
            var className = classnames('base-carousel-list', _defineProperty({}, classNames.list, classNames.list));

            // Get any styles specified by the view-model.
            model.transformListStyle(style);

            return React.createElement(
                'ul',
                { ref: 'list', style: style, className: className },
                this._getChildren()
            );
        }
    }]);

    return BaseCarousel;
}(React.Component);

BaseCarousel.propTypes = {
    // View model derived from `BaseModel`
    model: PropTypes.instanceOf(BaseModel).isRequired,
    children: PropTypes.node,
    classNames: PropTypes.shape({
        // className to add to the `ul`
        list: PropTypes.string,
        // className to add to each item's `li`
        item: PropTypes.string
    })
};

module.exports = BaseCarousel;

/***/ }),
/* 365 */,
/* 366 */,
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 8/7/16.
 */



var _reducers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var currencyActionConstants = __webpack_require__(287);
var loginActions = __webpack_require__(603);
var priceHelpers = __webpack_require__(1081);

var PriceStore = {
    storeName: 'PriceStore',
    initialState: {
        fullProfile: {},
        currency: null,
        model: null,
        canRequestNetPrice: false
    },
    reducers: (_reducers = {}, _defineProperty(_reducers, loginActions.ACTION_NET_PRICE, function (state, _ref) {
        var userCanRequestNetPrice = _ref.userCanRequestNetPrice;

        return Object.assign({}, state, {
            canRequestNetPrice: userCanRequestNetPrice
        });
    }), _defineProperty(_reducers, currencyActionConstants.CURRENCY_CHANGED, function (state, _ref2) {
        var currency = _ref2.currency;

        return Object.assign({}, state, { currency: currency });
    }), _defineProperty(_reducers, loginActions.ACTION_FULL_PROFILE, function (state, _ref3) {
        var profile = _ref3.profile;

        return Object.assign({}, state, {
            fullProfile: typeof profile.toJSON === 'function' ? profile.toJSON() : profile
        });
    }), _reducers),
    getters: {
        processPrice: function processPrice(state, itemModel) {
            var fullProfile = state.fullProfile,
                currency = state.currency,
                canRequestNetPrice = state.canRequestNetPrice;

            var _priceHelpers$process = priceHelpers.processPriceData({ userProfile: fullProfile, itemModel: itemModel, currency: currency }),
                _priceHelpers$process2 = _priceHelpers$process.salePriceData,
                salePriceData = _priceHelpers$process2 === undefined ? {} : _priceHelpers$process2,
                _priceHelpers$process3 = _priceHelpers$process.netPriceData,
                netPriceData = _priceHelpers$process3 === undefined ? {} : _priceHelpers$process3,
                _priceHelpers$process4 = _priceHelpers$process.retailPriceData,
                retailPriceData = _priceHelpers$process4 === undefined ? {} : _priceHelpers$process4,
                _priceHelpers$process5 = _priceHelpers$process.originalPriceData,
                originalPriceData = _priceHelpers$process5 === undefined ? {} : _priceHelpers$process5;

            var itemProps = {
                canRequestNetPrice: canRequestNetPrice,
                salePriceData: salePriceData,
                netPriceData: netPriceData,
                retailPriceData: retailPriceData,
                originalPriceData: originalPriceData
            };
            var ctas = priceHelpers.getButtonOptions({ userProfile: fullProfile, currency: currency, itemModel: itemModel, itemProps: itemProps });
            var priceDisplays = priceHelpers.getPriceDisplayOptions({ userProfile: fullProfile, currency: currency, itemModel: itemModel, itemProps: itemProps });
            return Object.assign({}, state, {
                ctas: ctas,
                priceDisplays: priceDisplays,
                salePriceData: salePriceData,
                netPriceData: netPriceData,
                retailPriceData: retailPriceData,
                originalPriceData: originalPriceData
            });
        }
    }
};

module.exports = PriceStore;

/***/ }),
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(53))(368);

/***/ }),
/* 373 */,
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: gedas
 * Date: 08/12/14
 * Time: 5:15 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */


var userHelper = module.exports = {};
var User = __webpack_require__(15);
var authModalLoader = __webpack_require__(263).default;

/**
 * checkLogin allows for updating page content for logged-in specific content without a refresh
 * @param ga - {object} - tracking data
 * @return {object}
 */
userHelper.checkLogin = function (ga, flow, action) {
    if (!User.loggedIn()) {
        return authModalLoader.show({
            action: action || (User.everLoggedIn() ? authModalLoader.constants.LOGIN : authModalLoader.constants.REGISTER),
            flow: flow,
            ga: ga
        });
    }
    return User.load();
};


/***/ }),
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

function normalizeQueries(queries) {
    if (typeof queries === 'string') {
        return queries;
    }

    return queries.join(', ');
}

/**
 * Component that only renders its children if the passed-in media query is currently met. This allows you to, for
 * example, define different layouts on mobile and desktop. The `query` props is a simple media query string. Pre-
 * defined queries for screen size can be found in `global/core/commonjs/screenSize`. Each `MediaQuery` can only
 * have one direct child or an error will be thrown.
 *
 * Example:
 * const {queries} = require('global/core/commonjs/screenSize');
 *
 * ...
 *
 * render() {
 *     const props = this.props;
 *
 *     return (
 *         <div className="layout-container">
 *             <MediaQuery query={queries.mobile}>
 *                 <LayoutMobile {...props} />
 *             </MediaQuery>
 *             <MediaQuery query={queries.tablet}>
 *                 <LayoutTablet {...props} />
 *             </MediaQuery>
 *             <MediaQuery query={queries.desktop}>
 *                 <LayoutDesktop {...props} />
 *             </MediaQuery>
 *         </div>
 *     );
 * }
 *
 * The following will exclude desktop from displaying the layout element:
 *
 * render() {
 *      return (
 *          <div className="layout-container">
 *              <MediaQuery query={queries.desktop} exclude={true}>
 *                  <LayoutNonDesktop {...props} />
 *              </MediaQuery>
 *          </div>
 *      );
 * }
 *
 */

var MediaQuery = function (_React$Component) {
    _inherits(MediaQuery, _React$Component);

    function MediaQuery(props) {
        _classCallCheck(this, MediaQuery);

        var _this = _possibleConstructorReturn(this, (MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call(this, props));

        _this.state = {
            matches: false
        };

        _this._update = _this._update.bind(_this);
        return _this;
    }

    _createClass(MediaQuery, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._setQuery(normalizeQueries(this.props.query));
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this._setQuery(normalizeQueries(nextProps.query));
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._mql.removeListener(this._update);
        }
    }, {
        key: '_setQuery',
        value: function _setQuery(query) {
            if (this._mql) {
                this._mql.removeListener(this._update);
            }

            var mql = this._mql = window.matchMedia(query);

            this._update(mql);
            mql.addListener(this._update);
        }
    }, {
        key: '_update',
        value: function _update(mql) {
            var matches = this.props.exclude ? !mql.matches : mql.matches;

            if (this.state.matches === matches) {
                return;
            }

            this.setState({ matches: matches });
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.matches) {
                return null;
            }

            return React.Children.only(this.props.children);
        }
    }]);

    return MediaQuery;
}(React.Component);

MediaQuery.propTypes = {
    query: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    children: PropTypes.object.isRequired,
    exclude: PropTypes.bool
};

MediaQuery.defaultProps = {
    query: ''
};

module.exports = MediaQuery;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var get = __webpack_require__(14);
var ItemStore = __webpack_require__(336);

var _require = __webpack_require__(27),
    trackEvent = _require.trackEvent,
    trackSocial = _require.trackSocial,
    trackEcommerce = _require.trackEcommerce;

var PRODUCT_CATEGORY = 'product';
var NAVIGATION_CATEGORY = 'navigation';
var DEALER_CLICK_CATEGORY = 'dealer click';
var SIMILAR_CATEGORY = 'landing module interaction';
var PROMO_CATEGORY = 'promo interaction';

var SOCIAL_TYPE_FACEBOOK = 'facebook';
var SOCIAL_TYPE_PINTEREST = 'pinterest';

// PRIVATE

function trackDescriptionInteraction(label) {
    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'pdp description interaction',
        label: label
    });
}

function trackStorefrontNavigation(label) {
    trackEvent({
        category: DEALER_CLICK_CATEGORY,
        action: 'click to dealer storefront',
        label: label
    });
}

function trackCarouselInteraction(action, image, totalImages) {
    var label = image + '/' + totalImages;

    trackEvent({
        category: PRODUCT_CATEGORY,
        label: label,
        action: action
    });
}

function trackSocialShare(item, type, event) {
    trackSocial({
        name: type,
        'opt_target': item.get('title'),
        event: event
    });
}

function addEventSuffix(event, suffix) {
    if (suffix) {
        event += ' - ' + suffix;
    }

    return event;
}

// PUBLIC

function trackArtCreatorClick() {
    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'attribute click',
        label: 'creator'
    });
}

function trackBreadcrumbClick(actionContext, _ref) {
    var category = _ref.category;

    trackEvent({
        category: NAVIGATION_CATEGORY,
        action: 'breadcrumb click',
        label: 'pdp|' + category.toLowerCase()
    });
}

function trackDescriptionExpand() {
    trackDescriptionInteraction('expand');
}

function trackDescriptionCollapse() {
    trackDescriptionInteraction('collapse');
}

function trackDealerViewAllClick() {
    trackStorefrontNavigation('pdp more from dealer');
}

function trackDealerLogoClick() {
    trackStorefrontNavigation('pdp more from dealer logo click');
}

function trackNextImageClick(actionContext, _ref2) {
    var image = _ref2.image,
        totalImages = _ref2.totalImages;

    trackCarouselInteraction('pdp image carousel next button', image, totalImages);
}

function trackPreviousImageClick(actionContext, _ref3) {
    var image = _ref3.image,
        totalImages = _ref3.totalImages;

    trackCarouselInteraction('pdp image carousel previous button', image, totalImages);
}

function trackMobileModalInteraction(actionContext, _ref4) {
    var label = _ref4.label,
        image = _ref4.image,
        totalImages = _ref4.totalImages;

    trackCarouselInteraction(label, image, totalImages);
}

function trackFacebookClick(actionContext, _ref5) {
    var suffix = _ref5.suffix;

    var store = actionContext.getStore(ItemStore);

    trackSocialShare(store.getItem(), SOCIAL_TYPE_FACEBOOK, addEventSuffix('share intent', suffix));
}

function trackFacebookSuccess(actionContext, _ref6) {
    var response = _ref6.response,
        suffix = _ref6.suffix;

    if (response && response.post_id) {
        var store = actionContext.getStore(ItemStore);

        trackSocialShare(store.getItem(), SOCIAL_TYPE_FACEBOOK, addEventSuffix('share', suffix));
    }
}

function trackPinterestClick(actionContext, _ref7) {
    var suffix = _ref7.suffix;

    var store = actionContext.getStore(ItemStore);
    var category = 'share';

    trackSocialShare(store.getItem(), SOCIAL_TYPE_PINTEREST, addEventSuffix(category, suffix));

    trackEvent({
        action: 'product from PDP',
        label: document.location.href,
        category: category
    });
}

function trackGridProductImpressions(actionContext, _ref8) {
    var _ref8$product = _ref8.product,
        product = _ref8$product === undefined ? {} : _ref8$product,
        gridType = _ref8.gridType;

    var price = get(product, 'price.amounts.USD') || 0;

    // Strip $ sign and remove comma
    if (price) {
        price = parseInt(price.substring(1).replace(',', ''));
    }

    trackEcommerce({
        type: 'productImpression',
        products: [{
            id: product.id,
            name: product.title,
            position: product.index,
            price: price,
            brand: product.seller.id,
            category: product.categories ? product.categories.join('/') : '',
            list: gridType
        }]
    });
}

function trackGridProductClick(actionContext, _ref9) {
    var _ref9$product = _ref9.product,
        product = _ref9$product === undefined ? {} : _ref9$product,
        gridType = _ref9.gridType;

    var price = get(product, 'price.amounts.USD') || 0;

    // Strip $ sign and remove comma
    if (price) {
        price = parseInt(price.substring(1).replace(',', ''));
    }

    trackEcommerce({
        type: 'productClick',
        actionField: {
            list: gridType
        },
        products: [{
            id: product.id,
            name: product.title,
            position: product.index,
            price: price,
            brand: product.seller.id,
            category: product.categories ? product.categories.join('/') : ''
        }]
    });
}

function trackGridPhotoDisplay() {
    trackEvent({
        category: PROMO_CATEGORY,
        action: 'related rooms carousel',
        label: 'carousel displayed'
    });
}

function trackGridPhotoClick() {
    trackEvent({
        category: PROMO_CATEGORY,
        action: 'related rooms carousel',
        label: 'room clicked'
    });
}

function trackGridPhotoGalleryOpen() {
    trackEvent({
        category: 'trade firm project image interaction',
        action: 'gallery opened',
        label: 'PDP'
    });
}

function trackSeoLinkClick(actionContext, _ref10) {
    var label = _ref10.label;

    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'more ways to browse link click',
        label: label
    });
}

function trackDealerLinkClick(actionContext, _ref11) {
    var location = _ref11.location;

    trackEvent({
        category: 'dealer click',
        action: 'click to dealer storefront',
        label: 'pdp ' + location
    });
}

function trackContactDealer(actionContext, _ref12) {
    var _ref12$suffix = _ref12.suffix,
        suffix = _ref12$suffix === undefined ? 'more from dealer module' : _ref12$suffix,
        _ref12$action = _ref12.action,
        action = _ref12$action === undefined ? 'clicked' : _ref12$action;

    trackEvent({
        category: 'contact dealer',
        action: 'contact dealer ' + action,
        label: addEventSuffix('contact link in pdp ', suffix)
    });
}

function trackMakeOfferClick(actionContext, _ref13) {
    var isNegotiable = _ref13.isNegotiable,
        isPreQuote = _ref13.isPreQuote,
        isReturnable = _ref13.isReturnable;

    var neg = isNegotiable ? 'y' : 'n';
    var ship = isPreQuote ? 'y' : 'n';
    var ret = isReturnable ? 'y' : 'n';
    trackEvent({
        category: 'make offer click',
        action: 'contact dealer form',
        label: 'neg=' + neg + '|ship=' + ship + '|ret=' + ret
    });
}

function trackAddToCart(actionContext, _ref14) {
    var trackingVpvParams = _ref14.trackingVpvParams;

    trackEcommerce({
        type: 'addToCart',
        products: [_extends({}, trackingVpvParams)]
    });
}

function trackCheckoutRedirect(actionContext, _ref15) {
    var price = _ref15.price,
        offerAmount = _ref15.offerAmount;

    var offer = Number.parseFloat(offerAmount, 10);
    var percentage = Math.floor(offer * 10 / price);
    var range = percentage + '1-' + (percentage + 1) + '0';
    trackEvent({
        category: 'make offer form interaction',
        action: 'continue offer',
        label: 'neg=initial|custom|' + range + '%',
        value: 1
    });
}

function trackEmailFriend(actionContext, _ref16) {
    var itemPk = _ref16.itemPk;

    trackEvent({
        category: 'email a friend',
        action: 'email a friend initiated',
        label: 'item|' + itemPk
    });
}

function trackPrint(actionContext, _ref17) {
    var withPrice = _ref17.withPrice;

    var label = 'print ' + (withPrice ? 'with' : 'without') + ' price from pdp';

    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'print item',
        label: label
    });
}

function trackSupportClick() {
    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'contact 1stdibs click',
        label: 'pdp'
    });
}

function trackBuyerAssuranceClick() {
    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'buyer protection',
        label: 'popup expanded'
    });
}

function trackBuyerAssuranceLinkClick() {
    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'buyer protection',
        label: 'popup link clicked'
    });
}

function trackAttributeClick(actionContext, _ref18) {
    var label = _ref18.label;

    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'attribute click',
        label: label
    });
}

function trackShippingClick(actionContext, _ref19) {
    var label = _ref19.label;

    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'view shipping and returns details',
        label: label
    });
}

function trackDealerInfoClick(actionContext, _ref20) {
    var url = _ref20.url;

    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'view dealer details',
        label: url
    });
}

function trackExpandDealerInfo(actionContext, _ref21) {
    var itemPk = _ref21.itemPk;

    trackEvent({
        category: PRODUCT_CATEGORY,
        action: 'dealer details displayed',
        label: itemPk
    });
}

function trackSimilarItemsDisplayed() {
    trackEvent({
        category: SIMILAR_CATEGORY,
        action: 'landing module displayed',
        label: 'related items'
    });
}

function trackSimilarItemClick() {
    trackEvent({
        category: SIMILAR_CATEGORY,
        action: 'landing module clicked',
        label: 'related items'
    });
}

function trackSimilarViewAllClick() {
    trackEvent({
        category: SIMILAR_CATEGORY,
        action: 'landing module clicked',
        label: 'related items view all'
    });
}

module.exports = {
    trackArtCreatorClick: trackArtCreatorClick,
    trackBreadcrumbClick: trackBreadcrumbClick,
    trackDescriptionExpand: trackDescriptionExpand,
    trackDescriptionCollapse: trackDescriptionCollapse,
    trackDealerViewAllClick: trackDealerViewAllClick,
    trackDealerLogoClick: trackDealerLogoClick,
    trackMobileModalInteraction: trackMobileModalInteraction,
    trackNextImageClick: trackNextImageClick,
    trackPreviousImageClick: trackPreviousImageClick,
    trackFacebookClick: trackFacebookClick,
    trackFacebookSuccess: trackFacebookSuccess,
    trackPinterestClick: trackPinterestClick,
    trackGridProductImpressions: trackGridProductImpressions,
    trackGridProductClick: trackGridProductClick,
    trackSeoLinkClick: trackSeoLinkClick,
    trackDealerLinkClick: trackDealerLinkClick,
    trackEmailFriend: trackEmailFriend,
    trackPrint: trackPrint,
    trackContactDealer: trackContactDealer,
    trackMakeOfferClick: trackMakeOfferClick,
    trackAddToCart: trackAddToCart,
    trackCheckoutRedirect: trackCheckoutRedirect,
    trackSupportClick: trackSupportClick,
    trackBuyerAssuranceClick: trackBuyerAssuranceClick,
    trackBuyerAssuranceLinkClick: trackBuyerAssuranceLinkClick,
    trackAttributeClick: trackAttributeClick,
    trackShippingClick: trackShippingClick,
    trackExpandDealerInfo: trackExpandDealerInfo,
    trackDealerInfoClick: trackDealerInfoClick,
    trackSimilarItemsDisplayed: trackSimilarItemsDisplayed,
    trackSimilarItemClick: trackSimilarItemClick,
    trackSimilarViewAllClick: trackSimilarViewAllClick,
    trackGridPhotoDisplay: trackGridPhotoDisplay,
    trackGridPhotoClick: trackGridPhotoClick,
    trackGridPhotoGalleryOpen: trackGridPhotoGalleryOpen
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

console.warn('copyText has been migrated to an npm module called "copy-text". Please use that instead.');
module.exports = __webpack_require__(39);


/***/ }),
/* 381 */,
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ContactUIStore = __webpack_require__(94);
var gaActions = __webpack_require__(505);
var transactionActions = __webpack_require__(480);
var BunsenModal = __webpack_require__(690);
var FavoriteDealerView = __webpack_require__(829);
var FavoritePageStore = __webpack_require__(475);

var _require = __webpack_require__(355),
    TYPE_DEALER = _require.TYPE_DEALER;

var User = __webpack_require__(28);

var authConstants = __webpack_require__(263).default.constants;

var helpers = __webpack_require__(102);
var successModalCss = __webpack_require__(871);
var chatUtils = __webpack_require__(268);
var result = __webpack_require__(70);
var find = __webpack_require__(916);

var baseActions = module.exports = {
    initialLoad: function initialLoad(actionContext, payload) {
        var itemPk = payload.itemPk,
            sellerPk = payload.sellerPk,
            preloadedSeller = payload.preloadedSeller,
            linkLocation = payload.linkLocation,
            sendToOmtOnSuccess = payload.sendToOmtOnSuccess,
            copyText = payload.copyText,
            isNetPrice = payload.isNetPrice;

        actionContext.dispatch('contact:loading:start', { linkLocation: linkLocation, sendToOmtOnSuccess: sendToOmtOnSuccess, itemPk: itemPk });
        var gotItemOrSeller = void 0;
        if (itemPk) {
            gotItemOrSeller = helpers.loadItem(itemPk);
        } else if (sellerPk || preloadedSeller) {
            gotItemOrSeller = helpers.loadSeller(sellerPk, preloadedSeller);
        } else {
            throw new Error('payload must contain itemPk, preloadedSeller or sellerPk');
        }

        return gotItemOrSeller.then(function (options) {
            var item = options.item,
                seller = options.seller;

            return helpers.loadUser().then(function (user) {
                return helpers.checkEmailOptIn({
                    itemId: result(item, 'id'),
                    dealerId: result(seller, 'id')
                }).then(function (isOptIn) {
                    if (isOptIn) {
                        actionContext.dispatch('contact:showOptIn');
                    }
                    var params = Object.assign({}, options, { user: user, copyText: copyText, isNetPrice: isNetPrice });
                    actionContext.dispatch('contact:loading:done', params);
                });
            });
        }, actionContext.dispatch.bind(actionContext, 'contact:serverError'));
    },
    closeModal: function closeModal(ac) {
        baseActions.fireChatEvent(ac);
        ac.dispatch('contact:modal:close');
    },
    openModal: function openModal(ac, _ref) {
        var modalId = _ref.modalId;

        ac.dispatch('contact:modal:open', { modalId: modalId });
    },
    toggleOffer: function toggleOffer(actionContext) {
        if (!actionContext.getStore(ContactUIStore).state.isOfferEnabled) {
            gaActions.eventOfferEnable(actionContext);
        }
        actionContext.dispatch('contact:offer:toggle');
    },
    toggleMessage: function toggleMessage(actionContext) {
        actionContext.dispatch('contact:message:toggle');
    },
    authSuccess: function authSuccess(actionContext, payload) {
        var userJSON = payload.userJSON,
            authAction = payload.authAction;

        var user = new User(userJSON);
        actionContext.dispatch('contact:auth:done', { user: user });
        return {
            suppressSuccess: authAction === authConstants.REGISTER,
            user: user
        };
    },


    /**
     *  Opens the favorite dealer modal when successfully sending a message
     *
     *  @param payload.offerSent {boolean}
     *  @param payload.followDealerParams {object}
     *  @param payload.omtLinkParams {object}
     */
    submitSuccess: function submitSuccess(actionContext, payload) {
        actionContext.dispatch('contact:sending:done');
        baseActions.closeModal(actionContext);
        actionContext.dispatch('contact:reset');
        if (payload.suppressSuccess) {
            return;
        }
        var offerSent = payload.offerSent,
            followDealerParams = payload.followDealerParams,
            omtLinkParams = payload.omtLinkParams,
            componentContext = payload.componentContext;

        var state = actionContext.getStore(ContactUIStore).state;
        var dealerPk = state.seller.get('id');
        var content = document.createElement('div');
        var copyText = state.copyText;
        var modal = new BunsenModal({
            title: copyText.get('successHeader'),
            reuse: false,
            buttonAutoClose: true,
            classNames: {
                header: successModalCss.modalHeader,
                body: successModalCss.modalBody,
                content: successModalCss.modalContent
            },
            content: content
        });

        var isSaved = actionContext.getStore(FavoritePageStore).isSaved(TYPE_DEALER);

        new FavoriteDealerView({
            el: content,
            followDealerParams: followDealerParams,
            omtLinkParams: omtLinkParams,
            dealerUrl: state.seller.get('sellerPreferences.urlLabel'),
            dealerName: state.seller.get('sellerProfile.company'),
            closeModal: modal.hide.bind(modal),
            openModal: modal.show.bind(modal),
            isArtSeller: state.seller.isArtSeller(),
            copyText: copyText,
            offerSent: offerSent,
            dealerPk: dealerPk,
            componentContext: componentContext,
            isSaved: isSaved
        }).render();
    },
    setLowballOption: function setLowballOption(actionContext, payload) {
        var state = actionContext.getStore(ContactUIStore).state;
        var lowballOptions = state.lowballOptions;

        var selectedLowballOption = find(lowballOptions, function (option) {
            return option.value === payload.value;
        });
        if (selectedLowballOption.checked) {
            return;
        }
        actionContext.dispatch('contact:form:lowball:options:set', { selectedLowballOption: selectedLowballOption });
        if (selectedLowballOption.value === 'other') {
            transactionActions.editOfferField(actionContext, { field: payload.field, value: '' });
        } else {
            transactionActions.editOfferField(actionContext, payload);
        }
    },
    fireChatEvent: function fireChatEvent(actionContext) {
        var _actionContext$getSto = actionContext.getStore(ContactUIStore).state,
            chatSuccessEvent = _actionContext$getSto.chatSuccessEvent,
            chatAbandonEvent = _actionContext$getSto.chatAbandonEvent,
            formSubmitted = _actionContext$getSto.formSubmitted;

        var trackEvent = chatUtils.track[formSubmitted ? chatSuccessEvent : chatAbandonEvent];
        if (trackEvent) {
            trackEvent();
        }
    }
};

/***/ }),
/* 383 */,
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    /**
     * Get an array containing one object that DetailsItem.jsx will
     * use to render a detail. Each object will have a key 'value',
     * which holds the display name of an attribute on the item.
     *
     * @param {object} config
     * @param {object} config.item    - Bunsen Item model
     * @param {string} attributeName  - Bunsen Item model attribute you want to be the display name of a detail
     * @param {object} passedValue    - The value to use, overriding the model
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *               link: string
     *          }[]}
     */
    getSingleValueWithoutLink: function getSingleValueWithoutLink(config, attributeName, passedValue) {
        var contents = [];
        var item = config.item;
        var value = passedValue || item.get(attributeName);

        if (value) {
            contents.push({
                isLink: false,
                value: value
            });
        }

        return contents;
    },


    /**
     * Get an array containing one object that DetailsItem.jsx will
     * use to render a detail. Each object will have a key 'value',
     * which holds the display name of an attribute on the item.
     *
     * @param {object} config
     * @param {object} config.model        - Bunsen Item model
     * @param {string} config.modelKey     - Bunsen Item model attribute you want to be the display name of a detail
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *          }[]}
     */
    getSingleValueFromModelWithoutLink: function getSingleValueFromModelWithoutLink(config) {
        var model = config.model,
            modelKey = config.modelKey;

        var contents = [];
        var content = { isLink: false };

        if (model) {
            content.value = model.get(modelKey);
        }

        if (content.value) {
            contents.push(content);
        }

        return contents;
    },


    /**
     * Get an array containing one object that DetailsItem.jsx will
     * use to render a detail. Each object will have a key 'value',
     * which holds a display name either calculated elsewhere and
     * passed as a param or found on the item here.
     *
     * @param {object} config
     * @param {string} config.passedValue  - the display name for a detail
     * @param {object} config.model        - Bunsen Item model
     * @param {string} config.modelKey     - Bunsen Item model attribute you want to be the display name of a detail
     *                                       if config.passedValue is undefined
     * @param {string} config.linksKey     - the key under which links for a detail can be found in config.links
     * @param {object} config.links        - see this.detailLinks in ItemStore for definition {@link newPdp/ItemStore}
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *               link: string
     *          }[]}
     *
     */
    addToContents: function addToContents(config) {
        var passedValue = config.passedValue,
            model = config.model,
            modelKey = config.modelKey,
            links = config.links,
            linkKey = config.linkKey;

        var contents = [];
        var content = { isLink: false };
        var link = void 0;

        if (passedValue) {
            content.value = passedValue;
        } else if (model) {
            content.value = model.get(modelKey);
        }

        if (links && links[linkKey]) {
            var value = content.value;
            link = links[linkKey][value];
        }

        if (link) {
            content.isLink = true;
            content.link = link;
        }

        if (content.value) {
            contents.push(content);
        }

        return contents;
    }
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _pageUrlLabels;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pages = {
    HOME: 'profile',
    PROJECTS: 'projects',
    COLLECTIONS: 'favorites'
};

var pageUrlLabels = (_pageUrlLabels = {}, _defineProperty(_pageUrlLabels, pages.HOME, ''), _defineProperty(_pageUrlLabels, pages.PROJECTS, 'projects'), _defineProperty(_pageUrlLabels, pages.COLLECTIONS, 'favorites'), _pageUrlLabels);

var profileHeadStates = {
    FULL: 'full',
    TRANSITIONING: 'transitioning',
    STICKY: 'sticky',
    NARROW: 'narrow'
};

var els = {
    // View Elements
    PROFILE_WRAPPER: '#profile',
    PROFILE_HEAD: '#profileHead',
    PROFILE_PAGE: '#profilePage',
    PROFILE_TABS: '#profileTabs',
    PROFILE_BREADCRUMBS: '#profileBreadcrumbs',
    PROFILE_HOME: '#profileHome',
    DESIGNER_FAVORITES: '#profile-designerFavoritesBlock',
    INSTAGRAM_FEED: '#instagramFeed',
    PROFILE_PROJECTS: '#profileProjects',
    PROFILE_COLLECTIONS: '#profileCollections',
    COLLECTION_RESULTS: '#collectionResults',

    // PROFILE_WRAPPER Elements
    LOADING_SPINNER: '.profile-loadingSpinner',

    // PROFILE_HEAD Elements
    PROFILE_SHARE: '.profileHead-shareContainer',
    PROFILE_EMAIL: '.profileHead-emailContainer',
    PROFILE_PIC: '.profileHead-pictureWrapper',
    PROFILE_FOLLOW: '.profileHead-follow',

    // PROFILE_TABS Elements
    TAB: '.profileHead-tab',
    TAB_INDICATOR: '.profileHead-tabIndicator',

    // PROFILE_HOME Elements
    PROFILE_BUTTON: '.profile-button',
    READ_MORE: '.designerDetail-readMore',
    READ_LESS: '.designerDetail-readLess',
    OVERFLOW: '.designerDetail-overflow',
    OVERFLOW_TEXT: '.designerDetail-overflowText',
    DESIGNER_WEBLINK: '.designerDetail-webLink',
    CONTENT_LINK: '.contentLink'
};

var classes = {
    // PROFILE_HEAD state classes
    FULL: 'isFull',
    TRANS: 'isTransitioning',
    STICKY: 'isSticky',

    // PROFILE_HOME state classes
    HIDDEN: 'is-hidden',
    EXPANDED: 'expandDetails',

    PROFILE_PIC: 'profileHead-pictureWrapper',
    DESIGNER_FAVORITES_PRODUCTS: 'designerFavorites-products',
    PROJECT_TILE: 'projectTile'
};

// Events dispatched by profileHeadActions.es.js
var profileHeadEvents = {
    SETUP_STORE: 'head:setup-store',
    SET_STATE: 'head:set-state'
};

// Events dispatched by profilePageActions.es.js
var profilePageEvents = {
    SETUP_STORE: 'page:setup-store',
    SET_PAGE: 'page:set-page',
    SET_TEMPLATE: 'page:set-template',
    SET_ERROR: 'page:set-error'
};

// Events dispatched by collectionProductResultsActions.es.js
var collectionProductEvents = {
    SET_PORTFOLIO: 'product-results:set-portfolio',
    PRODUCTS_FETCHED: 'product-results:fetched'
};

module.exports = {
    ITEMS_IN_PREVIEW: 6,
    ITEMS_PER_PAGE: 60,

    profileHeadStates: profileHeadStates,
    pages: pages,
    pageUrlLabels: pageUrlLabels,
    els: els,
    classes: classes,
    profileHeadEvents: profileHeadEvents,
    profilePageEvents: profilePageEvents,
    collectionProductEvents: collectionProductEvents
};

/***/ }),
/* 386 */,
/* 387 */,
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var qs = __webpack_require__(515);
var getToken = __webpack_require__(510);

__webpack_require__(654);

/**
 * Since fetch doesn't return a rejected promise if the http status code is an error,
 * this approach is recommended here https://github.com/github/fetch
 * @param   {Response} response
 * @returns {Response}
 * @throws  {Error}
 */
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        var error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}

function responseToJson(response) {
    return Promise.resolve(response).then(function (r) {
        if (r.json) {
            return r.json();
        }
        return r;
    });
}

/**
 * Convenience method to add common headers
 * @param   {Object} data
 * @returns {Object}
 */
function addHeaders(data) {
    return Object.assign({}, data, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });
}

/**
 * Calls fetch (or isomorphic-fetch) and makes sure to throw an error if the status code is an error
 * @param   {Any} args
 * @returns {Promise}
 */
function fetchWrapper() {
    return fetch.apply(undefined, arguments).then(checkStatus).then(responseToJson);
}

/**
 * Adds a user token as a query parameter to url
 *
 * @param {String} url
 * @param {Object} [params]
 * @returns {String}
 */
function addTokenToUrl(url) {
    var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    return addParamsToUrl(url, Object.assign({}, getToken(), params));
}

/**
 * Adds a params to the url
 *
 * @param {String} url
 * @param {Object} params
 * @returns {String}
 */
function addParamsToUrl(url, params) {
    return url + '?' + qs.stringify(params);
}

/**
 * Some helper functions for simultaneously resolving/rejecting a Promise and calling a success/failure callback
 * @param {Function} resolve
 * @param {Function} reject
 * @param {Function} onSuccess
 * @param {Function} onFailure
 */
function conditionalPromiseHelpers(resolve, reject) {
    var onSuccess = arguments.length <= 2 || arguments[2] === undefined ? function () {} : arguments[2];
    var onFailure = arguments.length <= 3 || arguments[3] === undefined ? function () {} : arguments[3];

    var fail = function fail(args) {
        onFailure(args);
        return reject(args) || true;
    };
    var ok = function ok(args) {
        onSuccess(args);
        return resolve(args) || true;
    };
    var failIf = function failIf(cond, args) {
        return cond && fail(args);
    };

    // given an array of [condition, args], calls failIf with each args and returns false if any condition is false.
    var failIfAny = function failIfAny(conditionAndArgsList) {
        return conditionAndArgsList.reduce(function (prev, _ref) {
            var _ref2 = _slicedToArray(_ref, 2);

            var condition = _ref2[0];
            var args = _ref2[1];
            return prev || failIf(condition, args);
        }, false);
    };

    return { ok: ok, fail: fail, failIf: failIf, failIfAny: failIfAny };
}

module.exports = {
    addHeaders: addHeaders,
    fetchWrapper: fetchWrapper,
    addTokenToUrl: addTokenToUrl,
    addParamsToUrl: addParamsToUrl,
    conditionalPromiseHelpers: conditionalPromiseHelpers
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-heart-filled'].join(' '), viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M29.3,129.8c-6.5-8.5-27.7-37.7-28.9-57.4C-0.8,52.3,4.1,36.2,15,24.6C30.1,8.5,51.4,6.8,59.9,6.8c1.3,0,2.2,0,2.8,0.1 c16.2,0.4,39.5,7.6,58.9,39.4l3.4,5.6l3.6-5.5c16.8-25.7,37.1-39,60.3-39.5c3,0,28.9-0.9,48,20.6c7.2,8.1,15.1,22.5,12.5,45.6 c-1.9,16.9-16.2,39.3-24.3,50.4c-11.8,16.1-88.5,108.3-100.2,122L29.3,129.8z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Utility classes for detecting specific touch actions.
// This module can be moved to a separate repo.



module.exports = {
    MultiTouchDetector: __webpack_require__(269),
    DoubleTapDetector: __webpack_require__(460),
    PanDetector: __webpack_require__(461),
    SwipeDetector: __webpack_require__(450),
    PinchDetector: __webpack_require__(462)
};

/***/ }),
/* 391 */
/***/ (function(module, exports) {

/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  return (/input|select|textarea|button|object/.test(nodeName) ?
    !element.disabled :
    "a" === nodeName ?
      element.href || isTabIndexNotNaN :
      isTabIndexNotNaN) && visible(element);
}

function hidden(el) {
  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
    el.style.display === 'none';
}

function visible(element) {
  while (element) {
    if (element === document.body) break;
    if (hidden(element)) return false;
    element = element.parentNode;
  }
  return true;
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
    return tabbable(el);
  });
}

module.exports = findTabbableDescendants;



/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);
var shortid = __webpack_require__(451);

var styles = __webpack_require__(503);

/**
 * Represents a wrapper with dots navigation for carousels.
 * @class
 */

var DotCarousel = function (_React$Component) {
    _inherits(DotCarousel, _React$Component);

    function DotCarousel() {
        _classCallCheck(this, DotCarousel);

        return _possibleConstructorReturn(this, (DotCarousel.__proto__ || Object.getPrototypeOf(DotCarousel)).apply(this, arguments));
    }

    _createClass(DotCarousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // If auto prop is set to true, the carousel with switch pages automatically.
            if (this.props.auto) {
                this._run();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.auto) {
                clearInterval(this._timer);
            }
        }

        /**
         * Method used to create the dots for carousel pagination.
         *
         * @param {function} callback - optional callback.
         * @returns {object} - dots JSX.
         */

    }, {
        key: '_createDots',
        value: function _createDots(callback) {
            var model = this.props.model;


            if (model.canPaginate()) {
                var totalPages = model.getTotalPages();
                var active = model.getState().page;
                var dots = [];
                // TODO: Remove this and adjust default styles?
                var dotControlsClass = classnames(styles.dotControls, this.props.classNames.dotControls);

                for (var index = 0; index < totalPages; index++) {
                    var classes = ['' + styles.dot];

                    if (index === active) {
                        classes.push('' + styles.current);
                    }

                    dots.push(this._createDot(index, classes, callback));
                }

                return React.createElement(
                    'ul',
                    { className: dotControlsClass },
                    dots
                );
            } else {
                return null;
            }
        }

        /**
         * Method used to create an individual dot for dotted pagination.
         *
         * @param {int} - index, unique key for each dot.
         * @param {array} - array of classes to be applied to the dot.
         * @returns {object} - JSX of a dot.
         */

    }, {
        key: '_createDot',
        value: function _createDot(index, classes, callback) {
            var _classnames,
                _this2 = this;

            var dot = this.props.classNames.dot;

            var dotClassName = styles[this.props.dotsColorType];
            var dotClassNames = classnames((_classnames = {}, _defineProperty(_classnames, dotClassName, dotClassName), _defineProperty(_classnames, dot, dot), _classnames));

            return React.createElement(
                'li',
                { key: shortid.generate(), className: styles.dotWrapper },
                React.createElement(
                    'span',
                    {
                        className: classes.join(' ') + ' ' + dotClassNames,
                        key: index,
                        onClick: function onClick() {
                            return _this2._onDotClick(index, callback);
                        }
                    },
                    index
                )
            );
        }
    }, {
        key: '_onDotClick',
        value: function _onDotClick(index, callback) {
            var _props = this.props,
                onDotClick = _props.onDotClick,
                model = _props.model;


            this.props.setPage(index, model, callback);
            onDotClick(index);
        }

        /**
         * Method used to start the automatic carousel run.
         */

    }, {
        key: '_run',
        value: function _run() {
            var _this3 = this;

            var _props$model = this.props.model,
                itemsPerPage = _props$model._itemsPerPage,
                totalItems = _props$model._itemCount,
                state = _props$model._state;


            var auto = function auto() {
                _this3._timer = setInterval(function () {
                    var page = state.page;
                    var totalPages = totalItems / itemsPerPage;
                    var nextPage = page + 1;
                    if (nextPage >= totalPages) {
                        nextPage = 0;
                    }
                    _this3.props.setPage(nextPage, _this3.props.model);
                }, _this3.props.autoDuration);
            };

            this.restartInterval = function () {
                clearInterval(_this3._timer);
                auto();
            };
            auto();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                createCarousel = _props2.createCarousel,
                classNames = _props2.classNames,
                dotsPosition = _props2.dotsPosition,
                auto = _props2.auto;


            var dotCarouselWrapperProps = {
                className: classnames(styles.dotCarouselWrapper, classNames.dotCarouselWrapper || ''),
                'data-tn': auto ? 'auto-dots' : ''
            };

            var dotsPositionClass = classnames({
                'float-r': dotsPosition === 'right',
                'float-l': dotsPosition === 'left'
            });

            return React.createElement(
                'div',
                dotCarouselWrapperProps,
                React.createElement(
                    'div',
                    { className: 'arrow-carousel-wrapper' },
                    createCarousel()
                ),
                React.createElement(
                    'div',
                    { className: dotsPositionClass },
                    auto ? this._createDots(this.restartInterval) : this._createDots()
                ),
                React.createElement('div', { className: styles.clear })
            );
        }
    }]);

    return DotCarousel;
}(React.Component);

DotCarousel.propTypes = {
    model: PropTypes.object.isRequired,
    onDotClick: PropTypes.func,
    dotsColorType: PropTypes.oneOf(['buyer', 'trade']),
    dotsPosition: PropTypes.oneOf(['left', 'right']),
    createCarousel: PropTypes.func,
    setPage: PropTypes.func,
    classNames: PropTypes.object,
    auto: PropTypes.bool,
    autoDuration: PropTypes.number
};

DotCarousel.defaultProps = {
    auto: false
};

module.exports = DotCarousel;

/***/ }),
/* 393 */,
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_spinner__spinner__3jLpF","spin":"_spinner__spin__QWBLz","isFixed":"_spinner__isFixed__1zKem","isAbsolute":"_spinner__isAbsolute__Bj2Qa","isStatic":"_spinner__isStatic__2WevC"};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

/*
  Module dependencies
*/
var ElementType = __webpack_require__(396);
var entities = __webpack_require__(397);

/*
  Boolean Attributes
*/
var booleanAttributes = {
  __proto__: null,
  allowfullscreen: true,
  async: true,
  autofocus: true,
  autoplay: true,
  checked: true,
  controls: true,
  default: true,
  defer: true,
  disabled: true,
  hidden: true,
  ismap: true,
  loop: true,
  multiple: true,
  muted: true,
  open: true,
  readonly: true,
  required: true,
  reversed: true,
  scoped: true,
  seamless: true,
  selected: true,
  typemustmatch: true
};

var unencodedElements = {
  __proto__: null,
  style: true,
  script: true,
  xmp: true,
  iframe: true,
  noembed: true,
  noframes: true,
  plaintext: true,
  noscript: true
};

/*
  Format attributes
*/
function formatAttrs(attributes, opts) {
  if (!attributes) return;

  var output = '',
      value;

  // Loop through the attributes
  for (var key in attributes) {
    value = attributes[key];
    if (output) {
      output += ' ';
    }

    if (!value && booleanAttributes[key]) {
      output += key;
    } else {
      output += key + '="' + (opts.decodeEntities ? entities.encodeXML(value) : value) + '"';
    }
  }

  return output;
}

/*
  Self-enclosing tags (stolen from node-htmlparser)
*/
var singleTag = {
  __proto__: null,
  area: true,
  base: true,
  basefont: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  isindex: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
};


var render = module.exports = function(dom, opts) {
  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
  opts = opts || {};

  var output = '';

  for(var i = 0; i < dom.length; i++){
    var elem = dom[i];

    if (elem.type === 'root')
      output += render(elem.children, opts);
    else if (ElementType.isTag(elem))
      output += renderTag(elem, opts);
    else if (elem.type === ElementType.Directive)
      output += renderDirective(elem);
    else if (elem.type === ElementType.Comment)
      output += renderComment(elem);
    else if (elem.type === ElementType.CDATA)
      output += renderCdata(elem);
    else
      output += renderText(elem, opts);
  }

  return output;
};

function renderTag(elem, opts) {
  // Handle SVG
  if (elem.name === "svg") opts = {decodeEntities: opts.decodeEntities, xmlMode: true};

  var tag = '<' + elem.name,
      attribs = formatAttrs(elem.attribs, opts);

  if (attribs) {
    tag += ' ' + attribs;
  }

  if (
    opts.xmlMode
    && (!elem.children || elem.children.length === 0)
  ) {
    tag += '/>';
  } else {
    tag += '>';
    if (elem.children) {
      tag += render(elem.children, opts);
    }

    if (!singleTag[elem.name] || opts.xmlMode) {
      tag += '</' + elem.name + '>';
    }
  }

  return tag;
}

function renderDirective(elem) {
  return '<' + elem.data + '>';
}

function renderText(elem, opts) {
  var data = elem.data || '';

  // if entities weren't decoded, no need to encode them back
  if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
    data = entities.encodeXML(data);
  }

  return data;
}

function renderCdata(elem) {
  return '<![CDATA[' + elem.children[0].data + ']]>';
}

function renderComment(elem) {
  return '<!--' + elem.data + '-->';
}


/***/ }),
/* 396 */
/***/ (function(module, exports) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__(400),
    decode = __webpack_require__(398);

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__(343),
    legacyMap = __webpack_require__(402),
    xmlMap    = __webpack_require__(344),
    decodeCodePoint = __webpack_require__(399);

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(401);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__(344)),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__(343)),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = {
	"0": 65533,
	"128": 8364,
	"130": 8218,
	"131": 402,
	"132": 8222,
	"133": 8230,
	"134": 8224,
	"135": 8225,
	"136": 710,
	"137": 8240,
	"138": 352,
	"139": 8249,
	"140": 338,
	"142": 381,
	"145": 8216,
	"146": 8217,
	"147": 8220,
	"148": 8221,
	"149": 8226,
	"150": 8211,
	"151": 8212,
	"152": 732,
	"153": 8482,
	"154": 353,
	"155": 8250,
	"156": 339,
	"158": 382,
	"159": 376
};

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"AElig": "Æ",
	"aelig": "æ",
	"Agrave": "À",
	"agrave": "à",
	"amp": "&",
	"AMP": "&",
	"Aring": "Å",
	"aring": "å",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"brvbar": "¦",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"cedil": "¸",
	"cent": "¢",
	"copy": "©",
	"COPY": "©",
	"curren": "¤",
	"deg": "°",
	"divide": "÷",
	"Eacute": "É",
	"eacute": "é",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"Egrave": "È",
	"egrave": "è",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"frac12": "½",
	"frac14": "¼",
	"frac34": "¾",
	"gt": ">",
	"GT": ">",
	"Iacute": "Í",
	"iacute": "í",
	"Icirc": "Î",
	"icirc": "î",
	"iexcl": "¡",
	"Igrave": "Ì",
	"igrave": "ì",
	"iquest": "¿",
	"Iuml": "Ï",
	"iuml": "ï",
	"laquo": "«",
	"lt": "<",
	"LT": "<",
	"macr": "¯",
	"micro": "µ",
	"middot": "·",
	"nbsp": " ",
	"not": "¬",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"Oacute": "Ó",
	"oacute": "ó",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"Ograve": "Ò",
	"ograve": "ò",
	"ordf": "ª",
	"ordm": "º",
	"Oslash": "Ø",
	"oslash": "ø",
	"Otilde": "Õ",
	"otilde": "õ",
	"Ouml": "Ö",
	"ouml": "ö",
	"para": "¶",
	"plusmn": "±",
	"pound": "£",
	"quot": "\"",
	"QUOT": "\"",
	"raquo": "»",
	"reg": "®",
	"REG": "®",
	"sect": "§",
	"shy": "­",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"szlig": "ß",
	"THORN": "Þ",
	"thorn": "þ",
	"times": "×",
	"Uacute": "Ú",
	"uacute": "ú",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uml": "¨",
	"Uuml": "Ü",
	"uuml": "ü",
	"Yacute": "Ý",
	"yacute": "ý",
	"yen": "¥",
	"yuml": "ÿ"
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = CollectingHandler;

function CollectingHandler(cbs){
	this._cbs = cbs || {};
	this.events = [];
}

var EVENTS = __webpack_require__(267).EVENTS;
Object.keys(EVENTS).forEach(function(name){
	if(EVENTS[name] === 0){
		name = "on" + name;
		CollectingHandler.prototype[name] = function(){
			this.events.push([name]);
			if(this._cbs[name]) this._cbs[name]();
		};
	} else if(EVENTS[name] === 1){
		name = "on" + name;
		CollectingHandler.prototype[name] = function(a){
			this.events.push([name, a]);
			if(this._cbs[name]) this._cbs[name](a);
		};
	} else if(EVENTS[name] === 2){
		name = "on" + name;
		CollectingHandler.prototype[name] = function(a, b){
			this.events.push([name, a, b]);
			if(this._cbs[name]) this._cbs[name](a, b);
		};
	} else {
		throw Error("wrong number of arguments");
	}
});

CollectingHandler.prototype.onreset = function(){
	this.events = [];
	if(this._cbs.onreset) this._cbs.onreset();
};

CollectingHandler.prototype.restart = function(){
	if(this._cbs.onreset) this._cbs.onreset();

	for(var i = 0, len = this.events.length; i < len; i++){
		if(this._cbs[this.events[i][0]]){

			var num = this.events[i].length;

			if(num === 1){
				this._cbs[this.events[i][0]]();
			} else if(num === 2){
				this._cbs[this.events[i][0]](this.events[i][1]);
			} else {
				this._cbs[this.events[i][0]](this.events[i][1], this.events[i][2]);
			}
		}
	}
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var index = __webpack_require__(267),
    DomHandler = index.DomHandler,
    DomUtils = index.DomUtils;

//TODO: make this a streamable handler
function FeedHandler(callback, options){
	this.init(callback, options);
}

__webpack_require__(50)(FeedHandler, DomHandler);

FeedHandler.prototype.init = DomHandler;

function getElements(what, where){
	return DomUtils.getElementsByTagName(what, where, true);
}
function getOneElement(what, where){
	return DomUtils.getElementsByTagName(what, where, true, 1)[0];
}
function fetch(what, where, recurse){
	return DomUtils.getText(
		DomUtils.getElementsByTagName(what, where, recurse, 1)
	).trim();
}

function addConditionally(obj, prop, what, where, recurse){
	var tmp = fetch(what, where, recurse);
	if(tmp) obj[prop] = tmp;
}

var isValidFeed = function(value){
	return value === "rss" || value === "feed" || value === "rdf:RDF";
};

FeedHandler.prototype.onend = function(){
	var feed = {},
	    feedRoot = getOneElement(isValidFeed, this.dom),
	    tmp, childs;

	if(feedRoot){
		if(feedRoot.name === "feed"){
			childs = feedRoot.children;

			feed.type = "atom";
			addConditionally(feed, "id", "id", childs);
			addConditionally(feed, "title", "title", childs);
			if((tmp = getOneElement("link", childs)) && (tmp = tmp.attribs) && (tmp = tmp.href)) feed.link = tmp;
			addConditionally(feed, "description", "subtitle", childs);
			if((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
			addConditionally(feed, "author", "email", childs, true);

			feed.items = getElements("entry", childs).map(function(item){
				var entry = {}, tmp;

				item = item.children;

				addConditionally(entry, "id", "id", item);
				addConditionally(entry, "title", "title", item);
				if((tmp = getOneElement("link", item)) && (tmp = tmp.attribs) && (tmp = tmp.href)) entry.link = tmp;
				if((tmp = fetch("summary", item) || fetch("content", item))) entry.description = tmp;
				if((tmp = fetch("updated", item))) entry.pubDate = new Date(tmp);
				return entry;
			});
		} else {
			childs = getOneElement("channel", feedRoot.children).children;

			feed.type = feedRoot.name.substr(0, 3);
			feed.id = "";
			addConditionally(feed, "title", "title", childs);
			addConditionally(feed, "link", "link", childs);
			addConditionally(feed, "description", "description", childs);
			if((tmp = fetch("lastBuildDate", childs))) feed.updated = new Date(tmp);
			addConditionally(feed, "author", "managingEditor", childs, true);

			feed.items = getElements("item", feedRoot.children).map(function(item){
				var entry = {}, tmp;

				item = item.children;

				addConditionally(entry, "id", "guid", item);
				addConditionally(entry, "title", "title", item);
				addConditionally(entry, "link", "link", item);
				addConditionally(entry, "description", "description", item);
				if((tmp = fetch("pubDate", item))) entry.pubDate = new Date(tmp);
				return entry;
			});
		}
	}
	this.dom = feed;
	DomHandler.prototype._handleCallback.call(
		this, feedRoot ? null : Error("couldn't find root of feed")
	);
};

module.exports = FeedHandler;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = ProxyHandler;

function ProxyHandler(cbs){
	this._cbs = cbs || {};
}

var EVENTS = __webpack_require__(267).EVENTS;
Object.keys(EVENTS).forEach(function(name){
	if(EVENTS[name] === 0){
		name = "on" + name;
		ProxyHandler.prototype[name] = function(){
			if(this._cbs[name]) this._cbs[name]();
		};
	} else if(EVENTS[name] === 1){
		name = "on" + name;
		ProxyHandler.prototype[name] = function(a){
			if(this._cbs[name]) this._cbs[name](a);
		};
	} else if(EVENTS[name] === 2){
		name = "on" + name;
		ProxyHandler.prototype[name] = function(a, b){
			if(this._cbs[name]) this._cbs[name](a, b);
		};
	} else {
		throw Error("wrong number of arguments");
	}
});

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(347);

function Stream(options){
	Parser.call(this, new Cbs(this), options);
}

__webpack_require__(50)(Stream, Parser);

Stream.prototype.readable = true;

function Cbs(scope){
	this.scope = scope;
}

var EVENTS = __webpack_require__(267).EVENTS;

Object.keys(EVENTS).forEach(function(name){
	if(EVENTS[name] === 0){
		Cbs.prototype["on" + name] = function(){
			this.scope.emit(name);
		};
	} else if(EVENTS[name] === 1){
		Cbs.prototype["on" + name] = function(a){
			this.scope.emit(name, a);
		};
	} else if(EVENTS[name] === 2){
		Cbs.prototype["on" + name] = function(a, b){
			this.scope.emit(name, a, b);
		};
	} else {
		throw Error("wrong number of arguments!");
	}
});

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(266);

var re_whitespace = /\s+/g;
var NodePrototype = __webpack_require__(348);
var ElementPrototype = __webpack_require__(408);

function DomHandler(callback, options, elementCB){
	if(typeof callback === "object"){
		elementCB = options;
		options = callback;
		callback = null;
	} else if(typeof options === "function"){
		elementCB = options;
		options = defaultOpts;
	}
	this._callback = callback;
	this._options = options || defaultOpts;
	this._elementCB = elementCB;
	this.dom = [];
	this._done = false;
	this._tagStack = [];
	this._parser = this._parser || null;
}

//default options
var defaultOpts = {
	normalizeWhitespace: false, //Replace all whitespace with single spaces
	withStartIndices: false, //Add startIndex properties to nodes
	withEndIndices: false, //Add endIndex properties to nodes
};

DomHandler.prototype.onparserinit = function(parser){
	this._parser = parser;
};

//Resets the handler back to starting state
DomHandler.prototype.onreset = function(){
	DomHandler.call(this, this._callback, this._options, this._elementCB);
};

//Signals the handler that parsing is done
DomHandler.prototype.onend = function(){
	if(this._done) return;
	this._done = true;
	this._parser = null;
	this._handleCallback(null);
};

DomHandler.prototype._handleCallback =
DomHandler.prototype.onerror = function(error){
	if(typeof this._callback === "function"){
		this._callback(error, this.dom);
	} else {
		if(error) throw error;
	}
};

DomHandler.prototype.onclosetag = function(){
	//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
	
	var elem = this._tagStack.pop();

	if(this._options.withEndIndices){
		elem.endIndex = this._parser.endIndex;
	}

	if(this._elementCB) this._elementCB(elem);
};

DomHandler.prototype._createDomElement = function(properties){
	if (!this._options.withDomLvl1) return properties;

	var element;
	if (properties.type === "tag") {
		element = Object.create(ElementPrototype);
	} else {
		element = Object.create(NodePrototype);
	}

	for (var key in properties) {
		if (properties.hasOwnProperty(key)) {
			element[key] = properties[key];
		}
	}

	return element;
};

DomHandler.prototype._addDomElement = function(element){
	var parent = this._tagStack[this._tagStack.length - 1];
	var siblings = parent ? parent.children : this.dom;
	var previousSibling = siblings[siblings.length - 1];

	element.next = null;

	if(this._options.withStartIndices){
		element.startIndex = this._parser.startIndex;
	}
	if(this._options.withEndIndices){
		element.endIndex = this._parser.endIndex;
	}

	if(previousSibling){
		element.prev = previousSibling;
		previousSibling.next = element;
	} else {
		element.prev = null;
	}

	siblings.push(element);
	element.parent = parent || null;
};

DomHandler.prototype.onopentag = function(name, attribs){
	var properties = {
		type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
		name: name,
		attribs: attribs,
		children: []
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);

	this._tagStack.push(element);
};

DomHandler.prototype.ontext = function(data){
	//the ignoreWhitespace is officially dropped, but for now,
	//it's an alias for normalizeWhitespace
	var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;

	var lastTag;

	if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
		if(normalize){
			lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
		} else {
			lastTag.data += data;
		}
	} else {
		if(
			this._tagStack.length &&
			(lastTag = this._tagStack[this._tagStack.length - 1]) &&
			(lastTag = lastTag.children[lastTag.children.length - 1]) &&
			lastTag.type === ElementType.Text
		){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(normalize){
				data = data.replace(re_whitespace, " ");
			}

			var element = this._createDomElement({
				data: data,
				type: ElementType.Text
			});

			this._addDomElement(element);
		}
	}
};

DomHandler.prototype.oncomment = function(data){
	var lastTag = this._tagStack[this._tagStack.length - 1];

	if(lastTag && lastTag.type === ElementType.Comment){
		lastTag.data += data;
		return;
	}

	var properties = {
		data: data,
		type: ElementType.Comment
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncdatastart = function(){
	var properties = {
		children: [{
			data: "",
			type: ElementType.Text
		}],
		type: ElementType.CDATA
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
	this._tagStack.pop();
};

DomHandler.prototype.onprocessinginstruction = function(name, data){
	var element = this._createDomElement({
		name: name,
		data: data,
		type: ElementType.Directive
	});

	this._addDomElement(element);
};

module.exports = DomHandler;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// DOM-Level-1-compliant structure
var NodePrototype = __webpack_require__(348);
var ElementPrototype = module.exports = Object.create(NodePrototype);

var domLvl1 = {
	tagName: "name"
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(ElementPrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var DomUtils = module.exports;

[
	__webpack_require__(414),
	__webpack_require__(415),
	__webpack_require__(412),
	__webpack_require__(413),
	__webpack_require__(411),
	__webpack_require__(410)
].forEach(function(ext){
	Object.keys(ext).forEach(function(key){
		DomUtils[key] = ext[key].bind(DomUtils);
	});
});


/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removeSubsets
// Given an array of nodes, remove any member that is contained by another.
exports.removeSubsets = function(nodes) {
	var idx = nodes.length, node, ancestor, replace;

	// Check if each node (or one of its ancestors) is already contained in the
	// array.
	while (--idx > -1) {
		node = ancestor = nodes[idx];

		// Temporarily remove the node under consideration
		nodes[idx] = null;
		replace = true;

		while (ancestor) {
			if (nodes.indexOf(ancestor) > -1) {
				replace = false;
				nodes.splice(idx, 1);
				break;
			}
			ancestor = ancestor.parent;
		}

		// If the node has been found to be unique, re-insert it.
		if (replace) {
			nodes[idx] = node;
		}
	}

	return nodes;
};

// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
var POSITION = {
	DISCONNECTED: 1,
	PRECEDING: 2,
	FOLLOWING: 4,
	CONTAINS: 8,
	CONTAINED_BY: 16
};

// Compare the position of one node against another node in any other document.
// The return value is a bitmask with the following values:
//
// document order:
// > There is an ordering, document order, defined on all the nodes in the
// > document corresponding to the order in which the first character of the
// > XML representation of each node occurs in the XML representation of the
// > document after expansion of general entities. Thus, the document element
// > node will be the first node. Element nodes occur before their children.
// > Thus, document order orders element nodes in order of the occurrence of
// > their start-tag in the XML (after expansion of entities). The attribute
// > nodes of an element occur after the element and before its children. The
// > relative order of attribute nodes is implementation-dependent./
// Source:
// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
//
// @argument {Node} nodaA The first node to use in the comparison
// @argument {Node} nodeB The second node to use in the comparison
//
// @return {Number} A bitmask describing the input nodes' relative position.
//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
//         a description of these values.
var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
	var aParents = [];
	var bParents = [];
	var current, sharedParent, siblings, aSibling, bSibling, idx;

	if (nodeA === nodeB) {
		return 0;
	}

	current = nodeA;
	while (current) {
		aParents.unshift(current);
		current = current.parent;
	}
	current = nodeB;
	while (current) {
		bParents.unshift(current);
		current = current.parent;
	}

	idx = 0;
	while (aParents[idx] === bParents[idx]) {
		idx++;
	}

	if (idx === 0) {
		return POSITION.DISCONNECTED;
	}

	sharedParent = aParents[idx - 1];
	siblings = sharedParent.children;
	aSibling = aParents[idx];
	bSibling = bParents[idx];

	if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
		if (sharedParent === nodeB) {
			return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
		}
		return POSITION.FOLLOWING;
	} else {
		if (sharedParent === nodeA) {
			return POSITION.PRECEDING | POSITION.CONTAINS;
		}
		return POSITION.PRECEDING;
	}
};

// Sort an array of nodes based on their relative position in the document and
// remove any duplicate nodes. If the array contains nodes that do not belong
// to the same document, sort order is unspecified.
//
// @argument {Array} nodes Array of DOM nodes
//
// @returns {Array} collection of unique nodes, sorted in document order
exports.uniqueSort = function(nodes) {
	var idx = nodes.length, node, position;

	nodes = nodes.slice();

	while (--idx > -1) {
		node = nodes[idx];
		position = nodes.indexOf(node);
		if (position > -1 && position < idx) {
			nodes.splice(idx, 1);
		}
	}
	nodes.sort(function(a, b) {
		var relative = comparePos(a, b);
		if (relative & POSITION.PRECEDING) {
			return -1;
		} else if (relative & POSITION.FOLLOWING) {
			return 1;
		}
		return 0;
	});

	return nodes;
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(266);
var isTag = exports.isTag = ElementType.isTag;

exports.testElement = function(options, element){
	for(var key in options){
		if(!options.hasOwnProperty(key));
		else if(key === "tag_name"){
			if(!isTag(element) || !options.tag_name(element.name)){
				return false;
			}
		} else if(key === "tag_type"){
			if(!options.tag_type(element.type)) return false;
		} else if(key === "tag_contains"){
			if(isTag(element) || !options.tag_contains(element.data)){
				return false;
			}
		} else if(!element.attribs || !options[key](element.attribs[key])){
			return false;
		}
	}
	return true;
};

var Checks = {
	tag_name: function(name){
		if(typeof name === "function"){
			return function(elem){ return isTag(elem) && name(elem.name); };
		} else if(name === "*"){
			return isTag;
		} else {
			return function(elem){ return isTag(elem) && elem.name === name; };
		}
	},
	tag_type: function(type){
		if(typeof type === "function"){
			return function(elem){ return type(elem.type); };
		} else {
			return function(elem){ return elem.type === type; };
		}
	},
	tag_contains: function(data){
		if(typeof data === "function"){
			return function(elem){ return !isTag(elem) && data(elem.data); };
		} else {
			return function(elem){ return !isTag(elem) && elem.data === data; };
		}
	}
};

function getAttribCheck(attrib, value){
	if(typeof value === "function"){
		return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
	} else {
		return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
	}
}

function combineFuncs(a, b){
	return function(elem){
		return a(elem) || b(elem);
	};
}

exports.getElements = function(options, element, recurse, limit){
	var funcs = Object.keys(options).map(function(key){
		var value = options[key];
		return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
	});

	return funcs.length === 0 ? [] : this.filter(
		funcs.reduce(combineFuncs),
		element, recurse, limit
	);
};

exports.getElementById = function(id, element, recurse){
	if(!Array.isArray(element)) element = [element];
	return this.findOne(getAttribCheck("id", id), element, recurse !== false);
};

exports.getElementsByTagName = function(name, element, recurse, limit){
	return this.filter(Checks.tag_name(name), element, recurse, limit);
};

exports.getElementsByTagType = function(type, element, recurse, limit){
	return this.filter(Checks.tag_type(type), element, recurse, limit);
};


/***/ }),
/* 412 */
/***/ (function(module, exports) {

exports.removeElement = function(elem){
	if(elem.prev) elem.prev.next = elem.next;
	if(elem.next) elem.next.prev = elem.prev;

	if(elem.parent){
		var childs = elem.parent.children;
		childs.splice(childs.lastIndexOf(elem), 1);
	}
};

exports.replaceElement = function(elem, replacement){
	var prev = replacement.prev = elem.prev;
	if(prev){
		prev.next = replacement;
	}

	var next = replacement.next = elem.next;
	if(next){
		next.prev = replacement;
	}

	var parent = replacement.parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs[childs.lastIndexOf(elem)] = replacement;
	}
};

exports.appendChild = function(elem, child){
	child.parent = elem;

	if(elem.children.push(child) !== 1){
		var sibling = elem.children[elem.children.length - 2];
		sibling.next = child;
		child.prev = sibling;
		child.next = null;
	}
};

exports.append = function(elem, next){
	var parent = elem.parent,
		currNext = elem.next;

	next.next = currNext;
	next.prev = elem;
	elem.next = next;
	next.parent = parent;

	if(currNext){
		currNext.prev = next;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(currNext), 0, next);
		}
	} else if(parent){
		parent.children.push(next);
	}
};

exports.prepend = function(elem, prev){
	var parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs.splice(childs.lastIndexOf(elem), 0, prev);
	}

	if(elem.prev){
		elem.prev.next = prev;
	}
	
	prev.parent = parent;
	prev.prev = elem.prev;
	prev.next = elem;
	elem.prev = prev;
};




/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var isTag = __webpack_require__(266).isTag;

module.exports = {
	filter: filter,
	find: find,
	findOneChild: findOneChild,
	findOne: findOne,
	existsOne: existsOne,
	findAll: findAll
};

function filter(test, element, recurse, limit){
	if(!Array.isArray(element)) element = [element];

	if(typeof limit !== "number" || !isFinite(limit)){
		limit = Infinity;
	}
	return find(test, element, recurse !== false, limit);
}

function find(test, elems, recurse, limit){
	var result = [], childs;

	for(var i = 0, j = elems.length; i < j; i++){
		if(test(elems[i])){
			result.push(elems[i]);
			if(--limit <= 0) break;
		}

		childs = elems[i].children;
		if(recurse && childs && childs.length > 0){
			childs = find(test, childs, recurse, limit);
			result = result.concat(childs);
			limit -= childs.length;
			if(limit <= 0) break;
		}
	}

	return result;
}

function findOneChild(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(test(elems[i])) return elems[i];
	}

	return null;
}

function findOne(test, elems){
	var elem = null;

	for(var i = 0, l = elems.length; i < l && !elem; i++){
		if(!isTag(elems[i])){
			continue;
		} else if(test(elems[i])){
			elem = elems[i];
		} else if(elems[i].children.length > 0){
			elem = findOne(test, elems[i].children);
		}
	}

	return elem;
}

function existsOne(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(
			isTag(elems[i]) && (
				test(elems[i]) || (
					elems[i].children.length > 0 &&
					existsOne(test, elems[i].children)
				)
			)
		){
			return true;
		}
	}

	return false;
}

function findAll(test, rootElems){
	var result = [];
	var stack = [rootElems];
	while(stack.length){
		var elems = stack.pop();
		for(var i = 0, j = elems.length; i < j; i++){
			if(!isTag(elems[i])) continue;
			if(test(elems[i])) result.push(elems[i]);
		}
		while(j-- > 0){
			if(elems[j].children && elems[j].children.length > 0){
				stack.push(elems[j].children);
			}
		}
	}
	return result;
}


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(266),
    getOuterHTML = __webpack_require__(395),
    isTag = ElementType.isTag;

module.exports = {
	getInnerHTML: getInnerHTML,
	getOuterHTML: getOuterHTML,
	getText: getText
};

function getInnerHTML(elem, opts){
	return elem.children ? elem.children.map(function(elem){
		return getOuterHTML(elem, opts);
	}).join("") : "";
}

function getText(elem){
	if(Array.isArray(elem)) return elem.map(getText).join("");
	if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
	if(elem.type === ElementType.CDATA) return getText(elem.children);
	if(elem.type === ElementType.Text) return elem.data;
	return "";
}


/***/ }),
/* 415 */
/***/ (function(module, exports) {

var getChildren = exports.getChildren = function(elem){
	return elem.children;
};

var getParent = exports.getParent = function(elem){
	return elem.parent;
};

exports.getSiblings = function(elem){
	var parent = getParent(elem);
	return parent ? getChildren(parent) : [elem];
};

exports.getAttributeValue = function(elem, name){
	return elem.attribs && elem.attribs[name];
};

exports.hasAttrib = function(elem, name){
	return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
};

exports.getName = function(elem){
	return elem.name;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(417);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = {
	"0": 65533,
	"128": 8364,
	"130": 8218,
	"131": 402,
	"132": 8222,
	"133": 8230,
	"134": 8224,
	"135": 8225,
	"136": 710,
	"137": 8240,
	"138": 352,
	"139": 8249,
	"140": 338,
	"142": 381,
	"145": 8216,
	"146": 8217,
	"147": 8220,
	"148": 8221,
	"149": 8226,
	"150": 8211,
	"151": 8212,
	"152": 732,
	"153": 8482,
	"154": 353,
	"155": 8250,
	"156": 339,
	"158": 382,
	"159": 376
};

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Abreve": "Ă",
	"abreve": "ă",
	"ac": "∾",
	"acd": "∿",
	"acE": "∾̳",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"Acy": "А",
	"acy": "а",
	"AElig": "Æ",
	"aelig": "æ",
	"af": "⁡",
	"Afr": "𝔄",
	"afr": "𝔞",
	"Agrave": "À",
	"agrave": "à",
	"alefsym": "ℵ",
	"aleph": "ℵ",
	"Alpha": "Α",
	"alpha": "α",
	"Amacr": "Ā",
	"amacr": "ā",
	"amalg": "⨿",
	"amp": "&",
	"AMP": "&",
	"andand": "⩕",
	"And": "⩓",
	"and": "∧",
	"andd": "⩜",
	"andslope": "⩘",
	"andv": "⩚",
	"ang": "∠",
	"ange": "⦤",
	"angle": "∠",
	"angmsdaa": "⦨",
	"angmsdab": "⦩",
	"angmsdac": "⦪",
	"angmsdad": "⦫",
	"angmsdae": "⦬",
	"angmsdaf": "⦭",
	"angmsdag": "⦮",
	"angmsdah": "⦯",
	"angmsd": "∡",
	"angrt": "∟",
	"angrtvb": "⊾",
	"angrtvbd": "⦝",
	"angsph": "∢",
	"angst": "Å",
	"angzarr": "⍼",
	"Aogon": "Ą",
	"aogon": "ą",
	"Aopf": "𝔸",
	"aopf": "𝕒",
	"apacir": "⩯",
	"ap": "≈",
	"apE": "⩰",
	"ape": "≊",
	"apid": "≋",
	"apos": "'",
	"ApplyFunction": "⁡",
	"approx": "≈",
	"approxeq": "≊",
	"Aring": "Å",
	"aring": "å",
	"Ascr": "𝒜",
	"ascr": "𝒶",
	"Assign": "≔",
	"ast": "*",
	"asymp": "≈",
	"asympeq": "≍",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"awconint": "∳",
	"awint": "⨑",
	"backcong": "≌",
	"backepsilon": "϶",
	"backprime": "‵",
	"backsim": "∽",
	"backsimeq": "⋍",
	"Backslash": "∖",
	"Barv": "⫧",
	"barvee": "⊽",
	"barwed": "⌅",
	"Barwed": "⌆",
	"barwedge": "⌅",
	"bbrk": "⎵",
	"bbrktbrk": "⎶",
	"bcong": "≌",
	"Bcy": "Б",
	"bcy": "б",
	"bdquo": "„",
	"becaus": "∵",
	"because": "∵",
	"Because": "∵",
	"bemptyv": "⦰",
	"bepsi": "϶",
	"bernou": "ℬ",
	"Bernoullis": "ℬ",
	"Beta": "Β",
	"beta": "β",
	"beth": "ℶ",
	"between": "≬",
	"Bfr": "𝔅",
	"bfr": "𝔟",
	"bigcap": "⋂",
	"bigcirc": "◯",
	"bigcup": "⋃",
	"bigodot": "⨀",
	"bigoplus": "⨁",
	"bigotimes": "⨂",
	"bigsqcup": "⨆",
	"bigstar": "★",
	"bigtriangledown": "▽",
	"bigtriangleup": "△",
	"biguplus": "⨄",
	"bigvee": "⋁",
	"bigwedge": "⋀",
	"bkarow": "⤍",
	"blacklozenge": "⧫",
	"blacksquare": "▪",
	"blacktriangle": "▴",
	"blacktriangledown": "▾",
	"blacktriangleleft": "◂",
	"blacktriangleright": "▸",
	"blank": "␣",
	"blk12": "▒",
	"blk14": "░",
	"blk34": "▓",
	"block": "█",
	"bne": "=⃥",
	"bnequiv": "≡⃥",
	"bNot": "⫭",
	"bnot": "⌐",
	"Bopf": "𝔹",
	"bopf": "𝕓",
	"bot": "⊥",
	"bottom": "⊥",
	"bowtie": "⋈",
	"boxbox": "⧉",
	"boxdl": "┐",
	"boxdL": "╕",
	"boxDl": "╖",
	"boxDL": "╗",
	"boxdr": "┌",
	"boxdR": "╒",
	"boxDr": "╓",
	"boxDR": "╔",
	"boxh": "─",
	"boxH": "═",
	"boxhd": "┬",
	"boxHd": "╤",
	"boxhD": "╥",
	"boxHD": "╦",
	"boxhu": "┴",
	"boxHu": "╧",
	"boxhU": "╨",
	"boxHU": "╩",
	"boxminus": "⊟",
	"boxplus": "⊞",
	"boxtimes": "⊠",
	"boxul": "┘",
	"boxuL": "╛",
	"boxUl": "╜",
	"boxUL": "╝",
	"boxur": "└",
	"boxuR": "╘",
	"boxUr": "╙",
	"boxUR": "╚",
	"boxv": "│",
	"boxV": "║",
	"boxvh": "┼",
	"boxvH": "╪",
	"boxVh": "╫",
	"boxVH": "╬",
	"boxvl": "┤",
	"boxvL": "╡",
	"boxVl": "╢",
	"boxVL": "╣",
	"boxvr": "├",
	"boxvR": "╞",
	"boxVr": "╟",
	"boxVR": "╠",
	"bprime": "‵",
	"breve": "˘",
	"Breve": "˘",
	"brvbar": "¦",
	"bscr": "𝒷",
	"Bscr": "ℬ",
	"bsemi": "⁏",
	"bsim": "∽",
	"bsime": "⋍",
	"bsolb": "⧅",
	"bsol": "\\",
	"bsolhsub": "⟈",
	"bull": "•",
	"bullet": "•",
	"bump": "≎",
	"bumpE": "⪮",
	"bumpe": "≏",
	"Bumpeq": "≎",
	"bumpeq": "≏",
	"Cacute": "Ć",
	"cacute": "ć",
	"capand": "⩄",
	"capbrcup": "⩉",
	"capcap": "⩋",
	"cap": "∩",
	"Cap": "⋒",
	"capcup": "⩇",
	"capdot": "⩀",
	"CapitalDifferentialD": "ⅅ",
	"caps": "∩︀",
	"caret": "⁁",
	"caron": "ˇ",
	"Cayleys": "ℭ",
	"ccaps": "⩍",
	"Ccaron": "Č",
	"ccaron": "č",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"Ccirc": "Ĉ",
	"ccirc": "ĉ",
	"Cconint": "∰",
	"ccups": "⩌",
	"ccupssm": "⩐",
	"Cdot": "Ċ",
	"cdot": "ċ",
	"cedil": "¸",
	"Cedilla": "¸",
	"cemptyv": "⦲",
	"cent": "¢",
	"centerdot": "·",
	"CenterDot": "·",
	"cfr": "𝔠",
	"Cfr": "ℭ",
	"CHcy": "Ч",
	"chcy": "ч",
	"check": "✓",
	"checkmark": "✓",
	"Chi": "Χ",
	"chi": "χ",
	"circ": "ˆ",
	"circeq": "≗",
	"circlearrowleft": "↺",
	"circlearrowright": "↻",
	"circledast": "⊛",
	"circledcirc": "⊚",
	"circleddash": "⊝",
	"CircleDot": "⊙",
	"circledR": "®",
	"circledS": "Ⓢ",
	"CircleMinus": "⊖",
	"CirclePlus": "⊕",
	"CircleTimes": "⊗",
	"cir": "○",
	"cirE": "⧃",
	"cire": "≗",
	"cirfnint": "⨐",
	"cirmid": "⫯",
	"cirscir": "⧂",
	"ClockwiseContourIntegral": "∲",
	"CloseCurlyDoubleQuote": "”",
	"CloseCurlyQuote": "’",
	"clubs": "♣",
	"clubsuit": "♣",
	"colon": ":",
	"Colon": "∷",
	"Colone": "⩴",
	"colone": "≔",
	"coloneq": "≔",
	"comma": ",",
	"commat": "@",
	"comp": "∁",
	"compfn": "∘",
	"complement": "∁",
	"complexes": "ℂ",
	"cong": "≅",
	"congdot": "⩭",
	"Congruent": "≡",
	"conint": "∮",
	"Conint": "∯",
	"ContourIntegral": "∮",
	"copf": "𝕔",
	"Copf": "ℂ",
	"coprod": "∐",
	"Coproduct": "∐",
	"copy": "©",
	"COPY": "©",
	"copysr": "℗",
	"CounterClockwiseContourIntegral": "∳",
	"crarr": "↵",
	"cross": "✗",
	"Cross": "⨯",
	"Cscr": "𝒞",
	"cscr": "𝒸",
	"csub": "⫏",
	"csube": "⫑",
	"csup": "⫐",
	"csupe": "⫒",
	"ctdot": "⋯",
	"cudarrl": "⤸",
	"cudarrr": "⤵",
	"cuepr": "⋞",
	"cuesc": "⋟",
	"cularr": "↶",
	"cularrp": "⤽",
	"cupbrcap": "⩈",
	"cupcap": "⩆",
	"CupCap": "≍",
	"cup": "∪",
	"Cup": "⋓",
	"cupcup": "⩊",
	"cupdot": "⊍",
	"cupor": "⩅",
	"cups": "∪︀",
	"curarr": "↷",
	"curarrm": "⤼",
	"curlyeqprec": "⋞",
	"curlyeqsucc": "⋟",
	"curlyvee": "⋎",
	"curlywedge": "⋏",
	"curren": "¤",
	"curvearrowleft": "↶",
	"curvearrowright": "↷",
	"cuvee": "⋎",
	"cuwed": "⋏",
	"cwconint": "∲",
	"cwint": "∱",
	"cylcty": "⌭",
	"dagger": "†",
	"Dagger": "‡",
	"daleth": "ℸ",
	"darr": "↓",
	"Darr": "↡",
	"dArr": "⇓",
	"dash": "‐",
	"Dashv": "⫤",
	"dashv": "⊣",
	"dbkarow": "⤏",
	"dblac": "˝",
	"Dcaron": "Ď",
	"dcaron": "ď",
	"Dcy": "Д",
	"dcy": "д",
	"ddagger": "‡",
	"ddarr": "⇊",
	"DD": "ⅅ",
	"dd": "ⅆ",
	"DDotrahd": "⤑",
	"ddotseq": "⩷",
	"deg": "°",
	"Del": "∇",
	"Delta": "Δ",
	"delta": "δ",
	"demptyv": "⦱",
	"dfisht": "⥿",
	"Dfr": "𝔇",
	"dfr": "𝔡",
	"dHar": "⥥",
	"dharl": "⇃",
	"dharr": "⇂",
	"DiacriticalAcute": "´",
	"DiacriticalDot": "˙",
	"DiacriticalDoubleAcute": "˝",
	"DiacriticalGrave": "`",
	"DiacriticalTilde": "˜",
	"diam": "⋄",
	"diamond": "⋄",
	"Diamond": "⋄",
	"diamondsuit": "♦",
	"diams": "♦",
	"die": "¨",
	"DifferentialD": "ⅆ",
	"digamma": "ϝ",
	"disin": "⋲",
	"div": "÷",
	"divide": "÷",
	"divideontimes": "⋇",
	"divonx": "⋇",
	"DJcy": "Ђ",
	"djcy": "ђ",
	"dlcorn": "⌞",
	"dlcrop": "⌍",
	"dollar": "$",
	"Dopf": "𝔻",
	"dopf": "𝕕",
	"Dot": "¨",
	"dot": "˙",
	"DotDot": "⃜",
	"doteq": "≐",
	"doteqdot": "≑",
	"DotEqual": "≐",
	"dotminus": "∸",
	"dotplus": "∔",
	"dotsquare": "⊡",
	"doublebarwedge": "⌆",
	"DoubleContourIntegral": "∯",
	"DoubleDot": "¨",
	"DoubleDownArrow": "⇓",
	"DoubleLeftArrow": "⇐",
	"DoubleLeftRightArrow": "⇔",
	"DoubleLeftTee": "⫤",
	"DoubleLongLeftArrow": "⟸",
	"DoubleLongLeftRightArrow": "⟺",
	"DoubleLongRightArrow": "⟹",
	"DoubleRightArrow": "⇒",
	"DoubleRightTee": "⊨",
	"DoubleUpArrow": "⇑",
	"DoubleUpDownArrow": "⇕",
	"DoubleVerticalBar": "∥",
	"DownArrowBar": "⤓",
	"downarrow": "↓",
	"DownArrow": "↓",
	"Downarrow": "⇓",
	"DownArrowUpArrow": "⇵",
	"DownBreve": "̑",
	"downdownarrows": "⇊",
	"downharpoonleft": "⇃",
	"downharpoonright": "⇂",
	"DownLeftRightVector": "⥐",
	"DownLeftTeeVector": "⥞",
	"DownLeftVectorBar": "⥖",
	"DownLeftVector": "↽",
	"DownRightTeeVector": "⥟",
	"DownRightVectorBar": "⥗",
	"DownRightVector": "⇁",
	"DownTeeArrow": "↧",
	"DownTee": "⊤",
	"drbkarow": "⤐",
	"drcorn": "⌟",
	"drcrop": "⌌",
	"Dscr": "𝒟",
	"dscr": "𝒹",
	"DScy": "Ѕ",
	"dscy": "ѕ",
	"dsol": "⧶",
	"Dstrok": "Đ",
	"dstrok": "đ",
	"dtdot": "⋱",
	"dtri": "▿",
	"dtrif": "▾",
	"duarr": "⇵",
	"duhar": "⥯",
	"dwangle": "⦦",
	"DZcy": "Џ",
	"dzcy": "џ",
	"dzigrarr": "⟿",
	"Eacute": "É",
	"eacute": "é",
	"easter": "⩮",
	"Ecaron": "Ě",
	"ecaron": "ě",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"ecir": "≖",
	"ecolon": "≕",
	"Ecy": "Э",
	"ecy": "э",
	"eDDot": "⩷",
	"Edot": "Ė",
	"edot": "ė",
	"eDot": "≑",
	"ee": "ⅇ",
	"efDot": "≒",
	"Efr": "𝔈",
	"efr": "𝔢",
	"eg": "⪚",
	"Egrave": "È",
	"egrave": "è",
	"egs": "⪖",
	"egsdot": "⪘",
	"el": "⪙",
	"Element": "∈",
	"elinters": "⏧",
	"ell": "ℓ",
	"els": "⪕",
	"elsdot": "⪗",
	"Emacr": "Ē",
	"emacr": "ē",
	"empty": "∅",
	"emptyset": "∅",
	"EmptySmallSquare": "◻",
	"emptyv": "∅",
	"EmptyVerySmallSquare": "▫",
	"emsp13": " ",
	"emsp14": " ",
	"emsp": " ",
	"ENG": "Ŋ",
	"eng": "ŋ",
	"ensp": " ",
	"Eogon": "Ę",
	"eogon": "ę",
	"Eopf": "𝔼",
	"eopf": "𝕖",
	"epar": "⋕",
	"eparsl": "⧣",
	"eplus": "⩱",
	"epsi": "ε",
	"Epsilon": "Ε",
	"epsilon": "ε",
	"epsiv": "ϵ",
	"eqcirc": "≖",
	"eqcolon": "≕",
	"eqsim": "≂",
	"eqslantgtr": "⪖",
	"eqslantless": "⪕",
	"Equal": "⩵",
	"equals": "=",
	"EqualTilde": "≂",
	"equest": "≟",
	"Equilibrium": "⇌",
	"equiv": "≡",
	"equivDD": "⩸",
	"eqvparsl": "⧥",
	"erarr": "⥱",
	"erDot": "≓",
	"escr": "ℯ",
	"Escr": "ℰ",
	"esdot": "≐",
	"Esim": "⩳",
	"esim": "≂",
	"Eta": "Η",
	"eta": "η",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"euro": "€",
	"excl": "!",
	"exist": "∃",
	"Exists": "∃",
	"expectation": "ℰ",
	"exponentiale": "ⅇ",
	"ExponentialE": "ⅇ",
	"fallingdotseq": "≒",
	"Fcy": "Ф",
	"fcy": "ф",
	"female": "♀",
	"ffilig": "ﬃ",
	"fflig": "ﬀ",
	"ffllig": "ﬄ",
	"Ffr": "𝔉",
	"ffr": "𝔣",
	"filig": "ﬁ",
	"FilledSmallSquare": "◼",
	"FilledVerySmallSquare": "▪",
	"fjlig": "fj",
	"flat": "♭",
	"fllig": "ﬂ",
	"fltns": "▱",
	"fnof": "ƒ",
	"Fopf": "𝔽",
	"fopf": "𝕗",
	"forall": "∀",
	"ForAll": "∀",
	"fork": "⋔",
	"forkv": "⫙",
	"Fouriertrf": "ℱ",
	"fpartint": "⨍",
	"frac12": "½",
	"frac13": "⅓",
	"frac14": "¼",
	"frac15": "⅕",
	"frac16": "⅙",
	"frac18": "⅛",
	"frac23": "⅔",
	"frac25": "⅖",
	"frac34": "¾",
	"frac35": "⅗",
	"frac38": "⅜",
	"frac45": "⅘",
	"frac56": "⅚",
	"frac58": "⅝",
	"frac78": "⅞",
	"frasl": "⁄",
	"frown": "⌢",
	"fscr": "𝒻",
	"Fscr": "ℱ",
	"gacute": "ǵ",
	"Gamma": "Γ",
	"gamma": "γ",
	"Gammad": "Ϝ",
	"gammad": "ϝ",
	"gap": "⪆",
	"Gbreve": "Ğ",
	"gbreve": "ğ",
	"Gcedil": "Ģ",
	"Gcirc": "Ĝ",
	"gcirc": "ĝ",
	"Gcy": "Г",
	"gcy": "г",
	"Gdot": "Ġ",
	"gdot": "ġ",
	"ge": "≥",
	"gE": "≧",
	"gEl": "⪌",
	"gel": "⋛",
	"geq": "≥",
	"geqq": "≧",
	"geqslant": "⩾",
	"gescc": "⪩",
	"ges": "⩾",
	"gesdot": "⪀",
	"gesdoto": "⪂",
	"gesdotol": "⪄",
	"gesl": "⋛︀",
	"gesles": "⪔",
	"Gfr": "𝔊",
	"gfr": "𝔤",
	"gg": "≫",
	"Gg": "⋙",
	"ggg": "⋙",
	"gimel": "ℷ",
	"GJcy": "Ѓ",
	"gjcy": "ѓ",
	"gla": "⪥",
	"gl": "≷",
	"glE": "⪒",
	"glj": "⪤",
	"gnap": "⪊",
	"gnapprox": "⪊",
	"gne": "⪈",
	"gnE": "≩",
	"gneq": "⪈",
	"gneqq": "≩",
	"gnsim": "⋧",
	"Gopf": "𝔾",
	"gopf": "𝕘",
	"grave": "`",
	"GreaterEqual": "≥",
	"GreaterEqualLess": "⋛",
	"GreaterFullEqual": "≧",
	"GreaterGreater": "⪢",
	"GreaterLess": "≷",
	"GreaterSlantEqual": "⩾",
	"GreaterTilde": "≳",
	"Gscr": "𝒢",
	"gscr": "ℊ",
	"gsim": "≳",
	"gsime": "⪎",
	"gsiml": "⪐",
	"gtcc": "⪧",
	"gtcir": "⩺",
	"gt": ">",
	"GT": ">",
	"Gt": "≫",
	"gtdot": "⋗",
	"gtlPar": "⦕",
	"gtquest": "⩼",
	"gtrapprox": "⪆",
	"gtrarr": "⥸",
	"gtrdot": "⋗",
	"gtreqless": "⋛",
	"gtreqqless": "⪌",
	"gtrless": "≷",
	"gtrsim": "≳",
	"gvertneqq": "≩︀",
	"gvnE": "≩︀",
	"Hacek": "ˇ",
	"hairsp": " ",
	"half": "½",
	"hamilt": "ℋ",
	"HARDcy": "Ъ",
	"hardcy": "ъ",
	"harrcir": "⥈",
	"harr": "↔",
	"hArr": "⇔",
	"harrw": "↭",
	"Hat": "^",
	"hbar": "ℏ",
	"Hcirc": "Ĥ",
	"hcirc": "ĥ",
	"hearts": "♥",
	"heartsuit": "♥",
	"hellip": "…",
	"hercon": "⊹",
	"hfr": "𝔥",
	"Hfr": "ℌ",
	"HilbertSpace": "ℋ",
	"hksearow": "⤥",
	"hkswarow": "⤦",
	"hoarr": "⇿",
	"homtht": "∻",
	"hookleftarrow": "↩",
	"hookrightarrow": "↪",
	"hopf": "𝕙",
	"Hopf": "ℍ",
	"horbar": "―",
	"HorizontalLine": "─",
	"hscr": "𝒽",
	"Hscr": "ℋ",
	"hslash": "ℏ",
	"Hstrok": "Ħ",
	"hstrok": "ħ",
	"HumpDownHump": "≎",
	"HumpEqual": "≏",
	"hybull": "⁃",
	"hyphen": "‐",
	"Iacute": "Í",
	"iacute": "í",
	"ic": "⁣",
	"Icirc": "Î",
	"icirc": "î",
	"Icy": "И",
	"icy": "и",
	"Idot": "İ",
	"IEcy": "Е",
	"iecy": "е",
	"iexcl": "¡",
	"iff": "⇔",
	"ifr": "𝔦",
	"Ifr": "ℑ",
	"Igrave": "Ì",
	"igrave": "ì",
	"ii": "ⅈ",
	"iiiint": "⨌",
	"iiint": "∭",
	"iinfin": "⧜",
	"iiota": "℩",
	"IJlig": "Ĳ",
	"ijlig": "ĳ",
	"Imacr": "Ī",
	"imacr": "ī",
	"image": "ℑ",
	"ImaginaryI": "ⅈ",
	"imagline": "ℐ",
	"imagpart": "ℑ",
	"imath": "ı",
	"Im": "ℑ",
	"imof": "⊷",
	"imped": "Ƶ",
	"Implies": "⇒",
	"incare": "℅",
	"in": "∈",
	"infin": "∞",
	"infintie": "⧝",
	"inodot": "ı",
	"intcal": "⊺",
	"int": "∫",
	"Int": "∬",
	"integers": "ℤ",
	"Integral": "∫",
	"intercal": "⊺",
	"Intersection": "⋂",
	"intlarhk": "⨗",
	"intprod": "⨼",
	"InvisibleComma": "⁣",
	"InvisibleTimes": "⁢",
	"IOcy": "Ё",
	"iocy": "ё",
	"Iogon": "Į",
	"iogon": "į",
	"Iopf": "𝕀",
	"iopf": "𝕚",
	"Iota": "Ι",
	"iota": "ι",
	"iprod": "⨼",
	"iquest": "¿",
	"iscr": "𝒾",
	"Iscr": "ℐ",
	"isin": "∈",
	"isindot": "⋵",
	"isinE": "⋹",
	"isins": "⋴",
	"isinsv": "⋳",
	"isinv": "∈",
	"it": "⁢",
	"Itilde": "Ĩ",
	"itilde": "ĩ",
	"Iukcy": "І",
	"iukcy": "і",
	"Iuml": "Ï",
	"iuml": "ï",
	"Jcirc": "Ĵ",
	"jcirc": "ĵ",
	"Jcy": "Й",
	"jcy": "й",
	"Jfr": "𝔍",
	"jfr": "𝔧",
	"jmath": "ȷ",
	"Jopf": "𝕁",
	"jopf": "𝕛",
	"Jscr": "𝒥",
	"jscr": "𝒿",
	"Jsercy": "Ј",
	"jsercy": "ј",
	"Jukcy": "Є",
	"jukcy": "є",
	"Kappa": "Κ",
	"kappa": "κ",
	"kappav": "ϰ",
	"Kcedil": "Ķ",
	"kcedil": "ķ",
	"Kcy": "К",
	"kcy": "к",
	"Kfr": "𝔎",
	"kfr": "𝔨",
	"kgreen": "ĸ",
	"KHcy": "Х",
	"khcy": "х",
	"KJcy": "Ќ",
	"kjcy": "ќ",
	"Kopf": "𝕂",
	"kopf": "𝕜",
	"Kscr": "𝒦",
	"kscr": "𝓀",
	"lAarr": "⇚",
	"Lacute": "Ĺ",
	"lacute": "ĺ",
	"laemptyv": "⦴",
	"lagran": "ℒ",
	"Lambda": "Λ",
	"lambda": "λ",
	"lang": "⟨",
	"Lang": "⟪",
	"langd": "⦑",
	"langle": "⟨",
	"lap": "⪅",
	"Laplacetrf": "ℒ",
	"laquo": "«",
	"larrb": "⇤",
	"larrbfs": "⤟",
	"larr": "←",
	"Larr": "↞",
	"lArr": "⇐",
	"larrfs": "⤝",
	"larrhk": "↩",
	"larrlp": "↫",
	"larrpl": "⤹",
	"larrsim": "⥳",
	"larrtl": "↢",
	"latail": "⤙",
	"lAtail": "⤛",
	"lat": "⪫",
	"late": "⪭",
	"lates": "⪭︀",
	"lbarr": "⤌",
	"lBarr": "⤎",
	"lbbrk": "❲",
	"lbrace": "{",
	"lbrack": "[",
	"lbrke": "⦋",
	"lbrksld": "⦏",
	"lbrkslu": "⦍",
	"Lcaron": "Ľ",
	"lcaron": "ľ",
	"Lcedil": "Ļ",
	"lcedil": "ļ",
	"lceil": "⌈",
	"lcub": "{",
	"Lcy": "Л",
	"lcy": "л",
	"ldca": "⤶",
	"ldquo": "“",
	"ldquor": "„",
	"ldrdhar": "⥧",
	"ldrushar": "⥋",
	"ldsh": "↲",
	"le": "≤",
	"lE": "≦",
	"LeftAngleBracket": "⟨",
	"LeftArrowBar": "⇤",
	"leftarrow": "←",
	"LeftArrow": "←",
	"Leftarrow": "⇐",
	"LeftArrowRightArrow": "⇆",
	"leftarrowtail": "↢",
	"LeftCeiling": "⌈",
	"LeftDoubleBracket": "⟦",
	"LeftDownTeeVector": "⥡",
	"LeftDownVectorBar": "⥙",
	"LeftDownVector": "⇃",
	"LeftFloor": "⌊",
	"leftharpoondown": "↽",
	"leftharpoonup": "↼",
	"leftleftarrows": "⇇",
	"leftrightarrow": "↔",
	"LeftRightArrow": "↔",
	"Leftrightarrow": "⇔",
	"leftrightarrows": "⇆",
	"leftrightharpoons": "⇋",
	"leftrightsquigarrow": "↭",
	"LeftRightVector": "⥎",
	"LeftTeeArrow": "↤",
	"LeftTee": "⊣",
	"LeftTeeVector": "⥚",
	"leftthreetimes": "⋋",
	"LeftTriangleBar": "⧏",
	"LeftTriangle": "⊲",
	"LeftTriangleEqual": "⊴",
	"LeftUpDownVector": "⥑",
	"LeftUpTeeVector": "⥠",
	"LeftUpVectorBar": "⥘",
	"LeftUpVector": "↿",
	"LeftVectorBar": "⥒",
	"LeftVector": "↼",
	"lEg": "⪋",
	"leg": "⋚",
	"leq": "≤",
	"leqq": "≦",
	"leqslant": "⩽",
	"lescc": "⪨",
	"les": "⩽",
	"lesdot": "⩿",
	"lesdoto": "⪁",
	"lesdotor": "⪃",
	"lesg": "⋚︀",
	"lesges": "⪓",
	"lessapprox": "⪅",
	"lessdot": "⋖",
	"lesseqgtr": "⋚",
	"lesseqqgtr": "⪋",
	"LessEqualGreater": "⋚",
	"LessFullEqual": "≦",
	"LessGreater": "≶",
	"lessgtr": "≶",
	"LessLess": "⪡",
	"lesssim": "≲",
	"LessSlantEqual": "⩽",
	"LessTilde": "≲",
	"lfisht": "⥼",
	"lfloor": "⌊",
	"Lfr": "𝔏",
	"lfr": "𝔩",
	"lg": "≶",
	"lgE": "⪑",
	"lHar": "⥢",
	"lhard": "↽",
	"lharu": "↼",
	"lharul": "⥪",
	"lhblk": "▄",
	"LJcy": "Љ",
	"ljcy": "љ",
	"llarr": "⇇",
	"ll": "≪",
	"Ll": "⋘",
	"llcorner": "⌞",
	"Lleftarrow": "⇚",
	"llhard": "⥫",
	"lltri": "◺",
	"Lmidot": "Ŀ",
	"lmidot": "ŀ",
	"lmoustache": "⎰",
	"lmoust": "⎰",
	"lnap": "⪉",
	"lnapprox": "⪉",
	"lne": "⪇",
	"lnE": "≨",
	"lneq": "⪇",
	"lneqq": "≨",
	"lnsim": "⋦",
	"loang": "⟬",
	"loarr": "⇽",
	"lobrk": "⟦",
	"longleftarrow": "⟵",
	"LongLeftArrow": "⟵",
	"Longleftarrow": "⟸",
	"longleftrightarrow": "⟷",
	"LongLeftRightArrow": "⟷",
	"Longleftrightarrow": "⟺",
	"longmapsto": "⟼",
	"longrightarrow": "⟶",
	"LongRightArrow": "⟶",
	"Longrightarrow": "⟹",
	"looparrowleft": "↫",
	"looparrowright": "↬",
	"lopar": "⦅",
	"Lopf": "𝕃",
	"lopf": "𝕝",
	"loplus": "⨭",
	"lotimes": "⨴",
	"lowast": "∗",
	"lowbar": "_",
	"LowerLeftArrow": "↙",
	"LowerRightArrow": "↘",
	"loz": "◊",
	"lozenge": "◊",
	"lozf": "⧫",
	"lpar": "(",
	"lparlt": "⦓",
	"lrarr": "⇆",
	"lrcorner": "⌟",
	"lrhar": "⇋",
	"lrhard": "⥭",
	"lrm": "‎",
	"lrtri": "⊿",
	"lsaquo": "‹",
	"lscr": "𝓁",
	"Lscr": "ℒ",
	"lsh": "↰",
	"Lsh": "↰",
	"lsim": "≲",
	"lsime": "⪍",
	"lsimg": "⪏",
	"lsqb": "[",
	"lsquo": "‘",
	"lsquor": "‚",
	"Lstrok": "Ł",
	"lstrok": "ł",
	"ltcc": "⪦",
	"ltcir": "⩹",
	"lt": "<",
	"LT": "<",
	"Lt": "≪",
	"ltdot": "⋖",
	"lthree": "⋋",
	"ltimes": "⋉",
	"ltlarr": "⥶",
	"ltquest": "⩻",
	"ltri": "◃",
	"ltrie": "⊴",
	"ltrif": "◂",
	"ltrPar": "⦖",
	"lurdshar": "⥊",
	"luruhar": "⥦",
	"lvertneqq": "≨︀",
	"lvnE": "≨︀",
	"macr": "¯",
	"male": "♂",
	"malt": "✠",
	"maltese": "✠",
	"Map": "⤅",
	"map": "↦",
	"mapsto": "↦",
	"mapstodown": "↧",
	"mapstoleft": "↤",
	"mapstoup": "↥",
	"marker": "▮",
	"mcomma": "⨩",
	"Mcy": "М",
	"mcy": "м",
	"mdash": "—",
	"mDDot": "∺",
	"measuredangle": "∡",
	"MediumSpace": " ",
	"Mellintrf": "ℳ",
	"Mfr": "𝔐",
	"mfr": "𝔪",
	"mho": "℧",
	"micro": "µ",
	"midast": "*",
	"midcir": "⫰",
	"mid": "∣",
	"middot": "·",
	"minusb": "⊟",
	"minus": "−",
	"minusd": "∸",
	"minusdu": "⨪",
	"MinusPlus": "∓",
	"mlcp": "⫛",
	"mldr": "…",
	"mnplus": "∓",
	"models": "⊧",
	"Mopf": "𝕄",
	"mopf": "𝕞",
	"mp": "∓",
	"mscr": "𝓂",
	"Mscr": "ℳ",
	"mstpos": "∾",
	"Mu": "Μ",
	"mu": "μ",
	"multimap": "⊸",
	"mumap": "⊸",
	"nabla": "∇",
	"Nacute": "Ń",
	"nacute": "ń",
	"nang": "∠⃒",
	"nap": "≉",
	"napE": "⩰̸",
	"napid": "≋̸",
	"napos": "ŉ",
	"napprox": "≉",
	"natural": "♮",
	"naturals": "ℕ",
	"natur": "♮",
	"nbsp": " ",
	"nbump": "≎̸",
	"nbumpe": "≏̸",
	"ncap": "⩃",
	"Ncaron": "Ň",
	"ncaron": "ň",
	"Ncedil": "Ņ",
	"ncedil": "ņ",
	"ncong": "≇",
	"ncongdot": "⩭̸",
	"ncup": "⩂",
	"Ncy": "Н",
	"ncy": "н",
	"ndash": "–",
	"nearhk": "⤤",
	"nearr": "↗",
	"neArr": "⇗",
	"nearrow": "↗",
	"ne": "≠",
	"nedot": "≐̸",
	"NegativeMediumSpace": "​",
	"NegativeThickSpace": "​",
	"NegativeThinSpace": "​",
	"NegativeVeryThinSpace": "​",
	"nequiv": "≢",
	"nesear": "⤨",
	"nesim": "≂̸",
	"NestedGreaterGreater": "≫",
	"NestedLessLess": "≪",
	"NewLine": "\n",
	"nexist": "∄",
	"nexists": "∄",
	"Nfr": "𝔑",
	"nfr": "𝔫",
	"ngE": "≧̸",
	"nge": "≱",
	"ngeq": "≱",
	"ngeqq": "≧̸",
	"ngeqslant": "⩾̸",
	"nges": "⩾̸",
	"nGg": "⋙̸",
	"ngsim": "≵",
	"nGt": "≫⃒",
	"ngt": "≯",
	"ngtr": "≯",
	"nGtv": "≫̸",
	"nharr": "↮",
	"nhArr": "⇎",
	"nhpar": "⫲",
	"ni": "∋",
	"nis": "⋼",
	"nisd": "⋺",
	"niv": "∋",
	"NJcy": "Њ",
	"njcy": "њ",
	"nlarr": "↚",
	"nlArr": "⇍",
	"nldr": "‥",
	"nlE": "≦̸",
	"nle": "≰",
	"nleftarrow": "↚",
	"nLeftarrow": "⇍",
	"nleftrightarrow": "↮",
	"nLeftrightarrow": "⇎",
	"nleq": "≰",
	"nleqq": "≦̸",
	"nleqslant": "⩽̸",
	"nles": "⩽̸",
	"nless": "≮",
	"nLl": "⋘̸",
	"nlsim": "≴",
	"nLt": "≪⃒",
	"nlt": "≮",
	"nltri": "⋪",
	"nltrie": "⋬",
	"nLtv": "≪̸",
	"nmid": "∤",
	"NoBreak": "⁠",
	"NonBreakingSpace": " ",
	"nopf": "𝕟",
	"Nopf": "ℕ",
	"Not": "⫬",
	"not": "¬",
	"NotCongruent": "≢",
	"NotCupCap": "≭",
	"NotDoubleVerticalBar": "∦",
	"NotElement": "∉",
	"NotEqual": "≠",
	"NotEqualTilde": "≂̸",
	"NotExists": "∄",
	"NotGreater": "≯",
	"NotGreaterEqual": "≱",
	"NotGreaterFullEqual": "≧̸",
	"NotGreaterGreater": "≫̸",
	"NotGreaterLess": "≹",
	"NotGreaterSlantEqual": "⩾̸",
	"NotGreaterTilde": "≵",
	"NotHumpDownHump": "≎̸",
	"NotHumpEqual": "≏̸",
	"notin": "∉",
	"notindot": "⋵̸",
	"notinE": "⋹̸",
	"notinva": "∉",
	"notinvb": "⋷",
	"notinvc": "⋶",
	"NotLeftTriangleBar": "⧏̸",
	"NotLeftTriangle": "⋪",
	"NotLeftTriangleEqual": "⋬",
	"NotLess": "≮",
	"NotLessEqual": "≰",
	"NotLessGreater": "≸",
	"NotLessLess": "≪̸",
	"NotLessSlantEqual": "⩽̸",
	"NotLessTilde": "≴",
	"NotNestedGreaterGreater": "⪢̸",
	"NotNestedLessLess": "⪡̸",
	"notni": "∌",
	"notniva": "∌",
	"notnivb": "⋾",
	"notnivc": "⋽",
	"NotPrecedes": "⊀",
	"NotPrecedesEqual": "⪯̸",
	"NotPrecedesSlantEqual": "⋠",
	"NotReverseElement": "∌",
	"NotRightTriangleBar": "⧐̸",
	"NotRightTriangle": "⋫",
	"NotRightTriangleEqual": "⋭",
	"NotSquareSubset": "⊏̸",
	"NotSquareSubsetEqual": "⋢",
	"NotSquareSuperset": "⊐̸",
	"NotSquareSupersetEqual": "⋣",
	"NotSubset": "⊂⃒",
	"NotSubsetEqual": "⊈",
	"NotSucceeds": "⊁",
	"NotSucceedsEqual": "⪰̸",
	"NotSucceedsSlantEqual": "⋡",
	"NotSucceedsTilde": "≿̸",
	"NotSuperset": "⊃⃒",
	"NotSupersetEqual": "⊉",
	"NotTilde": "≁",
	"NotTildeEqual": "≄",
	"NotTildeFullEqual": "≇",
	"NotTildeTilde": "≉",
	"NotVerticalBar": "∤",
	"nparallel": "∦",
	"npar": "∦",
	"nparsl": "⫽⃥",
	"npart": "∂̸",
	"npolint": "⨔",
	"npr": "⊀",
	"nprcue": "⋠",
	"nprec": "⊀",
	"npreceq": "⪯̸",
	"npre": "⪯̸",
	"nrarrc": "⤳̸",
	"nrarr": "↛",
	"nrArr": "⇏",
	"nrarrw": "↝̸",
	"nrightarrow": "↛",
	"nRightarrow": "⇏",
	"nrtri": "⋫",
	"nrtrie": "⋭",
	"nsc": "⊁",
	"nsccue": "⋡",
	"nsce": "⪰̸",
	"Nscr": "𝒩",
	"nscr": "𝓃",
	"nshortmid": "∤",
	"nshortparallel": "∦",
	"nsim": "≁",
	"nsime": "≄",
	"nsimeq": "≄",
	"nsmid": "∤",
	"nspar": "∦",
	"nsqsube": "⋢",
	"nsqsupe": "⋣",
	"nsub": "⊄",
	"nsubE": "⫅̸",
	"nsube": "⊈",
	"nsubset": "⊂⃒",
	"nsubseteq": "⊈",
	"nsubseteqq": "⫅̸",
	"nsucc": "⊁",
	"nsucceq": "⪰̸",
	"nsup": "⊅",
	"nsupE": "⫆̸",
	"nsupe": "⊉",
	"nsupset": "⊃⃒",
	"nsupseteq": "⊉",
	"nsupseteqq": "⫆̸",
	"ntgl": "≹",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"ntlg": "≸",
	"ntriangleleft": "⋪",
	"ntrianglelefteq": "⋬",
	"ntriangleright": "⋫",
	"ntrianglerighteq": "⋭",
	"Nu": "Ν",
	"nu": "ν",
	"num": "#",
	"numero": "№",
	"numsp": " ",
	"nvap": "≍⃒",
	"nvdash": "⊬",
	"nvDash": "⊭",
	"nVdash": "⊮",
	"nVDash": "⊯",
	"nvge": "≥⃒",
	"nvgt": ">⃒",
	"nvHarr": "⤄",
	"nvinfin": "⧞",
	"nvlArr": "⤂",
	"nvle": "≤⃒",
	"nvlt": "<⃒",
	"nvltrie": "⊴⃒",
	"nvrArr": "⤃",
	"nvrtrie": "⊵⃒",
	"nvsim": "∼⃒",
	"nwarhk": "⤣",
	"nwarr": "↖",
	"nwArr": "⇖",
	"nwarrow": "↖",
	"nwnear": "⤧",
	"Oacute": "Ó",
	"oacute": "ó",
	"oast": "⊛",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"ocir": "⊚",
	"Ocy": "О",
	"ocy": "о",
	"odash": "⊝",
	"Odblac": "Ő",
	"odblac": "ő",
	"odiv": "⨸",
	"odot": "⊙",
	"odsold": "⦼",
	"OElig": "Œ",
	"oelig": "œ",
	"ofcir": "⦿",
	"Ofr": "𝔒",
	"ofr": "𝔬",
	"ogon": "˛",
	"Ograve": "Ò",
	"ograve": "ò",
	"ogt": "⧁",
	"ohbar": "⦵",
	"ohm": "Ω",
	"oint": "∮",
	"olarr": "↺",
	"olcir": "⦾",
	"olcross": "⦻",
	"oline": "‾",
	"olt": "⧀",
	"Omacr": "Ō",
	"omacr": "ō",
	"Omega": "Ω",
	"omega": "ω",
	"Omicron": "Ο",
	"omicron": "ο",
	"omid": "⦶",
	"ominus": "⊖",
	"Oopf": "𝕆",
	"oopf": "𝕠",
	"opar": "⦷",
	"OpenCurlyDoubleQuote": "“",
	"OpenCurlyQuote": "‘",
	"operp": "⦹",
	"oplus": "⊕",
	"orarr": "↻",
	"Or": "⩔",
	"or": "∨",
	"ord": "⩝",
	"order": "ℴ",
	"orderof": "ℴ",
	"ordf": "ª",
	"ordm": "º",
	"origof": "⊶",
	"oror": "⩖",
	"orslope": "⩗",
	"orv": "⩛",
	"oS": "Ⓢ",
	"Oscr": "𝒪",
	"oscr": "ℴ",
	"Oslash": "Ø",
	"oslash": "ø",
	"osol": "⊘",
	"Otilde": "Õ",
	"otilde": "õ",
	"otimesas": "⨶",
	"Otimes": "⨷",
	"otimes": "⊗",
	"Ouml": "Ö",
	"ouml": "ö",
	"ovbar": "⌽",
	"OverBar": "‾",
	"OverBrace": "⏞",
	"OverBracket": "⎴",
	"OverParenthesis": "⏜",
	"para": "¶",
	"parallel": "∥",
	"par": "∥",
	"parsim": "⫳",
	"parsl": "⫽",
	"part": "∂",
	"PartialD": "∂",
	"Pcy": "П",
	"pcy": "п",
	"percnt": "%",
	"period": ".",
	"permil": "‰",
	"perp": "⊥",
	"pertenk": "‱",
	"Pfr": "𝔓",
	"pfr": "𝔭",
	"Phi": "Φ",
	"phi": "φ",
	"phiv": "ϕ",
	"phmmat": "ℳ",
	"phone": "☎",
	"Pi": "Π",
	"pi": "π",
	"pitchfork": "⋔",
	"piv": "ϖ",
	"planck": "ℏ",
	"planckh": "ℎ",
	"plankv": "ℏ",
	"plusacir": "⨣",
	"plusb": "⊞",
	"pluscir": "⨢",
	"plus": "+",
	"plusdo": "∔",
	"plusdu": "⨥",
	"pluse": "⩲",
	"PlusMinus": "±",
	"plusmn": "±",
	"plussim": "⨦",
	"plustwo": "⨧",
	"pm": "±",
	"Poincareplane": "ℌ",
	"pointint": "⨕",
	"popf": "𝕡",
	"Popf": "ℙ",
	"pound": "£",
	"prap": "⪷",
	"Pr": "⪻",
	"pr": "≺",
	"prcue": "≼",
	"precapprox": "⪷",
	"prec": "≺",
	"preccurlyeq": "≼",
	"Precedes": "≺",
	"PrecedesEqual": "⪯",
	"PrecedesSlantEqual": "≼",
	"PrecedesTilde": "≾",
	"preceq": "⪯",
	"precnapprox": "⪹",
	"precneqq": "⪵",
	"precnsim": "⋨",
	"pre": "⪯",
	"prE": "⪳",
	"precsim": "≾",
	"prime": "′",
	"Prime": "″",
	"primes": "ℙ",
	"prnap": "⪹",
	"prnE": "⪵",
	"prnsim": "⋨",
	"prod": "∏",
	"Product": "∏",
	"profalar": "⌮",
	"profline": "⌒",
	"profsurf": "⌓",
	"prop": "∝",
	"Proportional": "∝",
	"Proportion": "∷",
	"propto": "∝",
	"prsim": "≾",
	"prurel": "⊰",
	"Pscr": "𝒫",
	"pscr": "𝓅",
	"Psi": "Ψ",
	"psi": "ψ",
	"puncsp": " ",
	"Qfr": "𝔔",
	"qfr": "𝔮",
	"qint": "⨌",
	"qopf": "𝕢",
	"Qopf": "ℚ",
	"qprime": "⁗",
	"Qscr": "𝒬",
	"qscr": "𝓆",
	"quaternions": "ℍ",
	"quatint": "⨖",
	"quest": "?",
	"questeq": "≟",
	"quot": "\"",
	"QUOT": "\"",
	"rAarr": "⇛",
	"race": "∽̱",
	"Racute": "Ŕ",
	"racute": "ŕ",
	"radic": "√",
	"raemptyv": "⦳",
	"rang": "⟩",
	"Rang": "⟫",
	"rangd": "⦒",
	"range": "⦥",
	"rangle": "⟩",
	"raquo": "»",
	"rarrap": "⥵",
	"rarrb": "⇥",
	"rarrbfs": "⤠",
	"rarrc": "⤳",
	"rarr": "→",
	"Rarr": "↠",
	"rArr": "⇒",
	"rarrfs": "⤞",
	"rarrhk": "↪",
	"rarrlp": "↬",
	"rarrpl": "⥅",
	"rarrsim": "⥴",
	"Rarrtl": "⤖",
	"rarrtl": "↣",
	"rarrw": "↝",
	"ratail": "⤚",
	"rAtail": "⤜",
	"ratio": "∶",
	"rationals": "ℚ",
	"rbarr": "⤍",
	"rBarr": "⤏",
	"RBarr": "⤐",
	"rbbrk": "❳",
	"rbrace": "}",
	"rbrack": "]",
	"rbrke": "⦌",
	"rbrksld": "⦎",
	"rbrkslu": "⦐",
	"Rcaron": "Ř",
	"rcaron": "ř",
	"Rcedil": "Ŗ",
	"rcedil": "ŗ",
	"rceil": "⌉",
	"rcub": "}",
	"Rcy": "Р",
	"rcy": "р",
	"rdca": "⤷",
	"rdldhar": "⥩",
	"rdquo": "”",
	"rdquor": "”",
	"rdsh": "↳",
	"real": "ℜ",
	"realine": "ℛ",
	"realpart": "ℜ",
	"reals": "ℝ",
	"Re": "ℜ",
	"rect": "▭",
	"reg": "®",
	"REG": "®",
	"ReverseElement": "∋",
	"ReverseEquilibrium": "⇋",
	"ReverseUpEquilibrium": "⥯",
	"rfisht": "⥽",
	"rfloor": "⌋",
	"rfr": "𝔯",
	"Rfr": "ℜ",
	"rHar": "⥤",
	"rhard": "⇁",
	"rharu": "⇀",
	"rharul": "⥬",
	"Rho": "Ρ",
	"rho": "ρ",
	"rhov": "ϱ",
	"RightAngleBracket": "⟩",
	"RightArrowBar": "⇥",
	"rightarrow": "→",
	"RightArrow": "→",
	"Rightarrow": "⇒",
	"RightArrowLeftArrow": "⇄",
	"rightarrowtail": "↣",
	"RightCeiling": "⌉",
	"RightDoubleBracket": "⟧",
	"RightDownTeeVector": "⥝",
	"RightDownVectorBar": "⥕",
	"RightDownVector": "⇂",
	"RightFloor": "⌋",
	"rightharpoondown": "⇁",
	"rightharpoonup": "⇀",
	"rightleftarrows": "⇄",
	"rightleftharpoons": "⇌",
	"rightrightarrows": "⇉",
	"rightsquigarrow": "↝",
	"RightTeeArrow": "↦",
	"RightTee": "⊢",
	"RightTeeVector": "⥛",
	"rightthreetimes": "⋌",
	"RightTriangleBar": "⧐",
	"RightTriangle": "⊳",
	"RightTriangleEqual": "⊵",
	"RightUpDownVector": "⥏",
	"RightUpTeeVector": "⥜",
	"RightUpVectorBar": "⥔",
	"RightUpVector": "↾",
	"RightVectorBar": "⥓",
	"RightVector": "⇀",
	"ring": "˚",
	"risingdotseq": "≓",
	"rlarr": "⇄",
	"rlhar": "⇌",
	"rlm": "‏",
	"rmoustache": "⎱",
	"rmoust": "⎱",
	"rnmid": "⫮",
	"roang": "⟭",
	"roarr": "⇾",
	"robrk": "⟧",
	"ropar": "⦆",
	"ropf": "𝕣",
	"Ropf": "ℝ",
	"roplus": "⨮",
	"rotimes": "⨵",
	"RoundImplies": "⥰",
	"rpar": ")",
	"rpargt": "⦔",
	"rppolint": "⨒",
	"rrarr": "⇉",
	"Rrightarrow": "⇛",
	"rsaquo": "›",
	"rscr": "𝓇",
	"Rscr": "ℛ",
	"rsh": "↱",
	"Rsh": "↱",
	"rsqb": "]",
	"rsquo": "’",
	"rsquor": "’",
	"rthree": "⋌",
	"rtimes": "⋊",
	"rtri": "▹",
	"rtrie": "⊵",
	"rtrif": "▸",
	"rtriltri": "⧎",
	"RuleDelayed": "⧴",
	"ruluhar": "⥨",
	"rx": "℞",
	"Sacute": "Ś",
	"sacute": "ś",
	"sbquo": "‚",
	"scap": "⪸",
	"Scaron": "Š",
	"scaron": "š",
	"Sc": "⪼",
	"sc": "≻",
	"sccue": "≽",
	"sce": "⪰",
	"scE": "⪴",
	"Scedil": "Ş",
	"scedil": "ş",
	"Scirc": "Ŝ",
	"scirc": "ŝ",
	"scnap": "⪺",
	"scnE": "⪶",
	"scnsim": "⋩",
	"scpolint": "⨓",
	"scsim": "≿",
	"Scy": "С",
	"scy": "с",
	"sdotb": "⊡",
	"sdot": "⋅",
	"sdote": "⩦",
	"searhk": "⤥",
	"searr": "↘",
	"seArr": "⇘",
	"searrow": "↘",
	"sect": "§",
	"semi": ";",
	"seswar": "⤩",
	"setminus": "∖",
	"setmn": "∖",
	"sext": "✶",
	"Sfr": "𝔖",
	"sfr": "𝔰",
	"sfrown": "⌢",
	"sharp": "♯",
	"SHCHcy": "Щ",
	"shchcy": "щ",
	"SHcy": "Ш",
	"shcy": "ш",
	"ShortDownArrow": "↓",
	"ShortLeftArrow": "←",
	"shortmid": "∣",
	"shortparallel": "∥",
	"ShortRightArrow": "→",
	"ShortUpArrow": "↑",
	"shy": "­",
	"Sigma": "Σ",
	"sigma": "σ",
	"sigmaf": "ς",
	"sigmav": "ς",
	"sim": "∼",
	"simdot": "⩪",
	"sime": "≃",
	"simeq": "≃",
	"simg": "⪞",
	"simgE": "⪠",
	"siml": "⪝",
	"simlE": "⪟",
	"simne": "≆",
	"simplus": "⨤",
	"simrarr": "⥲",
	"slarr": "←",
	"SmallCircle": "∘",
	"smallsetminus": "∖",
	"smashp": "⨳",
	"smeparsl": "⧤",
	"smid": "∣",
	"smile": "⌣",
	"smt": "⪪",
	"smte": "⪬",
	"smtes": "⪬︀",
	"SOFTcy": "Ь",
	"softcy": "ь",
	"solbar": "⌿",
	"solb": "⧄",
	"sol": "/",
	"Sopf": "𝕊",
	"sopf": "𝕤",
	"spades": "♠",
	"spadesuit": "♠",
	"spar": "∥",
	"sqcap": "⊓",
	"sqcaps": "⊓︀",
	"sqcup": "⊔",
	"sqcups": "⊔︀",
	"Sqrt": "√",
	"sqsub": "⊏",
	"sqsube": "⊑",
	"sqsubset": "⊏",
	"sqsubseteq": "⊑",
	"sqsup": "⊐",
	"sqsupe": "⊒",
	"sqsupset": "⊐",
	"sqsupseteq": "⊒",
	"square": "□",
	"Square": "□",
	"SquareIntersection": "⊓",
	"SquareSubset": "⊏",
	"SquareSubsetEqual": "⊑",
	"SquareSuperset": "⊐",
	"SquareSupersetEqual": "⊒",
	"SquareUnion": "⊔",
	"squarf": "▪",
	"squ": "□",
	"squf": "▪",
	"srarr": "→",
	"Sscr": "𝒮",
	"sscr": "𝓈",
	"ssetmn": "∖",
	"ssmile": "⌣",
	"sstarf": "⋆",
	"Star": "⋆",
	"star": "☆",
	"starf": "★",
	"straightepsilon": "ϵ",
	"straightphi": "ϕ",
	"strns": "¯",
	"sub": "⊂",
	"Sub": "⋐",
	"subdot": "⪽",
	"subE": "⫅",
	"sube": "⊆",
	"subedot": "⫃",
	"submult": "⫁",
	"subnE": "⫋",
	"subne": "⊊",
	"subplus": "⪿",
	"subrarr": "⥹",
	"subset": "⊂",
	"Subset": "⋐",
	"subseteq": "⊆",
	"subseteqq": "⫅",
	"SubsetEqual": "⊆",
	"subsetneq": "⊊",
	"subsetneqq": "⫋",
	"subsim": "⫇",
	"subsub": "⫕",
	"subsup": "⫓",
	"succapprox": "⪸",
	"succ": "≻",
	"succcurlyeq": "≽",
	"Succeeds": "≻",
	"SucceedsEqual": "⪰",
	"SucceedsSlantEqual": "≽",
	"SucceedsTilde": "≿",
	"succeq": "⪰",
	"succnapprox": "⪺",
	"succneqq": "⪶",
	"succnsim": "⋩",
	"succsim": "≿",
	"SuchThat": "∋",
	"sum": "∑",
	"Sum": "∑",
	"sung": "♪",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"sup": "⊃",
	"Sup": "⋑",
	"supdot": "⪾",
	"supdsub": "⫘",
	"supE": "⫆",
	"supe": "⊇",
	"supedot": "⫄",
	"Superset": "⊃",
	"SupersetEqual": "⊇",
	"suphsol": "⟉",
	"suphsub": "⫗",
	"suplarr": "⥻",
	"supmult": "⫂",
	"supnE": "⫌",
	"supne": "⊋",
	"supplus": "⫀",
	"supset": "⊃",
	"Supset": "⋑",
	"supseteq": "⊇",
	"supseteqq": "⫆",
	"supsetneq": "⊋",
	"supsetneqq": "⫌",
	"supsim": "⫈",
	"supsub": "⫔",
	"supsup": "⫖",
	"swarhk": "⤦",
	"swarr": "↙",
	"swArr": "⇙",
	"swarrow": "↙",
	"swnwar": "⤪",
	"szlig": "ß",
	"Tab": "\t",
	"target": "⌖",
	"Tau": "Τ",
	"tau": "τ",
	"tbrk": "⎴",
	"Tcaron": "Ť",
	"tcaron": "ť",
	"Tcedil": "Ţ",
	"tcedil": "ţ",
	"Tcy": "Т",
	"tcy": "т",
	"tdot": "⃛",
	"telrec": "⌕",
	"Tfr": "𝔗",
	"tfr": "𝔱",
	"there4": "∴",
	"therefore": "∴",
	"Therefore": "∴",
	"Theta": "Θ",
	"theta": "θ",
	"thetasym": "ϑ",
	"thetav": "ϑ",
	"thickapprox": "≈",
	"thicksim": "∼",
	"ThickSpace": "  ",
	"ThinSpace": " ",
	"thinsp": " ",
	"thkap": "≈",
	"thksim": "∼",
	"THORN": "Þ",
	"thorn": "þ",
	"tilde": "˜",
	"Tilde": "∼",
	"TildeEqual": "≃",
	"TildeFullEqual": "≅",
	"TildeTilde": "≈",
	"timesbar": "⨱",
	"timesb": "⊠",
	"times": "×",
	"timesd": "⨰",
	"tint": "∭",
	"toea": "⤨",
	"topbot": "⌶",
	"topcir": "⫱",
	"top": "⊤",
	"Topf": "𝕋",
	"topf": "𝕥",
	"topfork": "⫚",
	"tosa": "⤩",
	"tprime": "‴",
	"trade": "™",
	"TRADE": "™",
	"triangle": "▵",
	"triangledown": "▿",
	"triangleleft": "◃",
	"trianglelefteq": "⊴",
	"triangleq": "≜",
	"triangleright": "▹",
	"trianglerighteq": "⊵",
	"tridot": "◬",
	"trie": "≜",
	"triminus": "⨺",
	"TripleDot": "⃛",
	"triplus": "⨹",
	"trisb": "⧍",
	"tritime": "⨻",
	"trpezium": "⏢",
	"Tscr": "𝒯",
	"tscr": "𝓉",
	"TScy": "Ц",
	"tscy": "ц",
	"TSHcy": "Ћ",
	"tshcy": "ћ",
	"Tstrok": "Ŧ",
	"tstrok": "ŧ",
	"twixt": "≬",
	"twoheadleftarrow": "↞",
	"twoheadrightarrow": "↠",
	"Uacute": "Ú",
	"uacute": "ú",
	"uarr": "↑",
	"Uarr": "↟",
	"uArr": "⇑",
	"Uarrocir": "⥉",
	"Ubrcy": "Ў",
	"ubrcy": "ў",
	"Ubreve": "Ŭ",
	"ubreve": "ŭ",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ucy": "У",
	"ucy": "у",
	"udarr": "⇅",
	"Udblac": "Ű",
	"udblac": "ű",
	"udhar": "⥮",
	"ufisht": "⥾",
	"Ufr": "𝔘",
	"ufr": "𝔲",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uHar": "⥣",
	"uharl": "↿",
	"uharr": "↾",
	"uhblk": "▀",
	"ulcorn": "⌜",
	"ulcorner": "⌜",
	"ulcrop": "⌏",
	"ultri": "◸",
	"Umacr": "Ū",
	"umacr": "ū",
	"uml": "¨",
	"UnderBar": "_",
	"UnderBrace": "⏟",
	"UnderBracket": "⎵",
	"UnderParenthesis": "⏝",
	"Union": "⋃",
	"UnionPlus": "⊎",
	"Uogon": "Ų",
	"uogon": "ų",
	"Uopf": "𝕌",
	"uopf": "𝕦",
	"UpArrowBar": "⤒",
	"uparrow": "↑",
	"UpArrow": "↑",
	"Uparrow": "⇑",
	"UpArrowDownArrow": "⇅",
	"updownarrow": "↕",
	"UpDownArrow": "↕",
	"Updownarrow": "⇕",
	"UpEquilibrium": "⥮",
	"upharpoonleft": "↿",
	"upharpoonright": "↾",
	"uplus": "⊎",
	"UpperLeftArrow": "↖",
	"UpperRightArrow": "↗",
	"upsi": "υ",
	"Upsi": "ϒ",
	"upsih": "ϒ",
	"Upsilon": "Υ",
	"upsilon": "υ",
	"UpTeeArrow": "↥",
	"UpTee": "⊥",
	"upuparrows": "⇈",
	"urcorn": "⌝",
	"urcorner": "⌝",
	"urcrop": "⌎",
	"Uring": "Ů",
	"uring": "ů",
	"urtri": "◹",
	"Uscr": "𝒰",
	"uscr": "𝓊",
	"utdot": "⋰",
	"Utilde": "Ũ",
	"utilde": "ũ",
	"utri": "▵",
	"utrif": "▴",
	"uuarr": "⇈",
	"Uuml": "Ü",
	"uuml": "ü",
	"uwangle": "⦧",
	"vangrt": "⦜",
	"varepsilon": "ϵ",
	"varkappa": "ϰ",
	"varnothing": "∅",
	"varphi": "ϕ",
	"varpi": "ϖ",
	"varpropto": "∝",
	"varr": "↕",
	"vArr": "⇕",
	"varrho": "ϱ",
	"varsigma": "ς",
	"varsubsetneq": "⊊︀",
	"varsubsetneqq": "⫋︀",
	"varsupsetneq": "⊋︀",
	"varsupsetneqq": "⫌︀",
	"vartheta": "ϑ",
	"vartriangleleft": "⊲",
	"vartriangleright": "⊳",
	"vBar": "⫨",
	"Vbar": "⫫",
	"vBarv": "⫩",
	"Vcy": "В",
	"vcy": "в",
	"vdash": "⊢",
	"vDash": "⊨",
	"Vdash": "⊩",
	"VDash": "⊫",
	"Vdashl": "⫦",
	"veebar": "⊻",
	"vee": "∨",
	"Vee": "⋁",
	"veeeq": "≚",
	"vellip": "⋮",
	"verbar": "|",
	"Verbar": "‖",
	"vert": "|",
	"Vert": "‖",
	"VerticalBar": "∣",
	"VerticalLine": "|",
	"VerticalSeparator": "❘",
	"VerticalTilde": "≀",
	"VeryThinSpace": " ",
	"Vfr": "𝔙",
	"vfr": "𝔳",
	"vltri": "⊲",
	"vnsub": "⊂⃒",
	"vnsup": "⊃⃒",
	"Vopf": "𝕍",
	"vopf": "𝕧",
	"vprop": "∝",
	"vrtri": "⊳",
	"Vscr": "𝒱",
	"vscr": "𝓋",
	"vsubnE": "⫋︀",
	"vsubne": "⊊︀",
	"vsupnE": "⫌︀",
	"vsupne": "⊋︀",
	"Vvdash": "⊪",
	"vzigzag": "⦚",
	"Wcirc": "Ŵ",
	"wcirc": "ŵ",
	"wedbar": "⩟",
	"wedge": "∧",
	"Wedge": "⋀",
	"wedgeq": "≙",
	"weierp": "℘",
	"Wfr": "𝔚",
	"wfr": "𝔴",
	"Wopf": "𝕎",
	"wopf": "𝕨",
	"wp": "℘",
	"wr": "≀",
	"wreath": "≀",
	"Wscr": "𝒲",
	"wscr": "𝓌",
	"xcap": "⋂",
	"xcirc": "◯",
	"xcup": "⋃",
	"xdtri": "▽",
	"Xfr": "𝔛",
	"xfr": "𝔵",
	"xharr": "⟷",
	"xhArr": "⟺",
	"Xi": "Ξ",
	"xi": "ξ",
	"xlarr": "⟵",
	"xlArr": "⟸",
	"xmap": "⟼",
	"xnis": "⋻",
	"xodot": "⨀",
	"Xopf": "𝕏",
	"xopf": "𝕩",
	"xoplus": "⨁",
	"xotime": "⨂",
	"xrarr": "⟶",
	"xrArr": "⟹",
	"Xscr": "𝒳",
	"xscr": "𝓍",
	"xsqcup": "⨆",
	"xuplus": "⨄",
	"xutri": "△",
	"xvee": "⋁",
	"xwedge": "⋀",
	"Yacute": "Ý",
	"yacute": "ý",
	"YAcy": "Я",
	"yacy": "я",
	"Ycirc": "Ŷ",
	"ycirc": "ŷ",
	"Ycy": "Ы",
	"ycy": "ы",
	"yen": "¥",
	"Yfr": "𝔜",
	"yfr": "𝔶",
	"YIcy": "Ї",
	"yicy": "ї",
	"Yopf": "𝕐",
	"yopf": "𝕪",
	"Yscr": "𝒴",
	"yscr": "𝓎",
	"YUcy": "Ю",
	"yucy": "ю",
	"yuml": "ÿ",
	"Yuml": "Ÿ",
	"Zacute": "Ź",
	"zacute": "ź",
	"Zcaron": "Ž",
	"zcaron": "ž",
	"Zcy": "З",
	"zcy": "з",
	"Zdot": "Ż",
	"zdot": "ż",
	"zeetrf": "ℨ",
	"ZeroWidthSpace": "​",
	"Zeta": "Ζ",
	"zeta": "ζ",
	"zfr": "𝔷",
	"Zfr": "ℨ",
	"ZHcy": "Ж",
	"zhcy": "ж",
	"zigrarr": "⇝",
	"zopf": "𝕫",
	"Zopf": "ℤ",
	"Zscr": "𝒵",
	"zscr": "𝓏",
	"zwj": "‍",
	"zwnj": "‌"
};

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"AElig": "Æ",
	"aelig": "æ",
	"Agrave": "À",
	"agrave": "à",
	"amp": "&",
	"AMP": "&",
	"Aring": "Å",
	"aring": "å",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"brvbar": "¦",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"cedil": "¸",
	"cent": "¢",
	"copy": "©",
	"COPY": "©",
	"curren": "¤",
	"deg": "°",
	"divide": "÷",
	"Eacute": "É",
	"eacute": "é",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"Egrave": "È",
	"egrave": "è",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"frac12": "½",
	"frac14": "¼",
	"frac34": "¾",
	"gt": ">",
	"GT": ">",
	"Iacute": "Í",
	"iacute": "í",
	"Icirc": "Î",
	"icirc": "î",
	"iexcl": "¡",
	"Igrave": "Ì",
	"igrave": "ì",
	"iquest": "¿",
	"Iuml": "Ï",
	"iuml": "ï",
	"laquo": "«",
	"lt": "<",
	"LT": "<",
	"macr": "¯",
	"micro": "µ",
	"middot": "·",
	"nbsp": " ",
	"not": "¬",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"Oacute": "Ó",
	"oacute": "ó",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"Ograve": "Ò",
	"ograve": "ò",
	"ordf": "ª",
	"ordm": "º",
	"Oslash": "Ø",
	"oslash": "ø",
	"Otilde": "Õ",
	"otilde": "õ",
	"Ouml": "Ö",
	"ouml": "ö",
	"para": "¶",
	"plusmn": "±",
	"pound": "£",
	"quot": "\"",
	"QUOT": "\"",
	"raquo": "»",
	"reg": "®",
	"REG": "®",
	"sect": "§",
	"shy": "­",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"szlig": "ß",
	"THORN": "Þ",
	"thorn": "þ",
	"times": "×",
	"Uacute": "Ú",
	"uacute": "ú",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uml": "¨",
	"Uuml": "Ü",
	"uuml": "ü",
	"Yacute": "Ý",
	"yacute": "ý",
	"yen": "¥",
	"yuml": "ÿ"
};

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = function (string) {
  return string.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&")
}


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 423 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(98)


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(349)


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var Stream = (function (){
  try {
    return __webpack_require__(277); // hack to fix a circular dependency issue when used with browserify
  } catch(_){}
}());
exports = module.exports = __webpack_require__(350);
exports.Stream = Stream || exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(300);
exports.Duplex = __webpack_require__(98);
exports.Transform = __webpack_require__(299);
exports.PassThrough = __webpack_require__(349);


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(299)


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(300)


/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 430 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 431 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(434), __esModule: true };

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {//
// Form Validation Plugin
// @author rw
// @param requierments = an object describing the form fields.  Must be formatted as such:
// var requirements = {
//      'field_name' : {                // object keys are the form 'name' attributes.
//          required : 'true',          // boolean denoting whether the field is required or not
//          regex :                     // regex defining the field input.  if none pass null.
//      },
//      'field_name2' : {
//          // ...
//      }
// }
//
// NOTE: The requirements for each form are to be stored in separate files, so that these rules can be shared with
// the back end team.

(function (root, factory) {
    'use strict';
    if (true) {
        // CommonJS
        factory(module, __webpack_require__(5), __webpack_require__(0));
    } else {
        var m = {};
        // Browser globals
        factory(m, root.jQuery, root._);
    }
}(typeof window === 'undefined' ? global : window, function (module, $, _) {

    'use strict';

    var methods,
        current_event,
        /**
         * Convenience functions for sending either success or error below:
         * @param name - field name
         * @param message - message to pass to other scripts via event (sub-pub)
         * @return {Boolean}
         */
        sendSuccess = function (name, $field) {
            var config = this.data('dibsValidation');
            var requirements = config.requirements || {};
            var req = requirements[name] || {};

            $field = $field || this.find('[name=' + config.prefix + name + ']');
            req.status = true;
            req.message = 'success';
            $field.trigger('formErrorResolved', [$field, requirements[name], current_event]);
            return true;
        },

        /**
         * @param name - field name
         * @param message - message to pass to other scripts via event
         * @return {Boolean}
         */
        sendError = function (name, message, $field) {
            var config = this.data('dibsValidation');
            var req = config.requirements[name] || {};

            $field = $field || this.find('[name=' + config.prefix + name + ']');
            req.status = false;
            req.message = message || req.messages[name];
            $field.trigger(('formError'), [$field, req, current_event]);
            return false;
        },

        _validateOnChange = function () {
            var self = this;
            var events = ['change', 'focusout'];
            var dibsValidation = this.data('dibsValidation') || {};
            var customEvents = _.result(dibsValidation.options, 'on');
            if (customEvents) {
                events = events.concat(customEvents.split(' '));
            }
            events = _.map(events, function (s) {
                return s + '.dibsValidation.dibsValidationBlur';
            });
            events = events.join(' ');
            self.on(events, 'input, select, textarea', function (e) {
                // on focusin - remove the invalid class
                if ($(this).attr('type') !== 'submit') {
                    current_event = e;
                    methods.validateField.call(self, this);
                }
            });
        },

        _toggleRequire = function (fieldNames, onOff) {
            var config = this.data('dibsValidation');
            if (!fieldNames) {
                fieldNames = _.keys(config.requirements);
            } else if (!$.isArray(fieldNames)) {
                fieldNames = [fieldNames];
            }
            _.each(fieldNames, function (fieldName) {
                config._disableRequire[fieldName] = onOff;
            });
        },

        // Validates 1 form field based on that fieild's name.
        // Note: this function sets the internal status pointer for each field to true or false.
        _validateField = function (name, $field) {
            var self = this;
            var config = this.data('dibsValidation');
            var regexShouldMatch = true;
            var message = 'This field is invalid';
            var customValidators;
            var fieldIsRequired;
            var regexTesterFn;
            var customRes;
            var requirement;
            var type;
            var value;
            var test;
            var len;
            var i;

            if (name && typeof name === "object") {
                $field = (name instanceof $) ? name : self.find(name);
                name = $field.data('ruleset') || $field.attr('name');
            }

            if (name && name.indexOf(config.prefix) !== -1) {
                name = name.substr(config.prefix.length);
            }

            $field = $field || self.find('[name="' + config.prefix + name + '"]');

            requirement = config.requirements[name];

            // Use custom validators if found
            customValidators = config.customValidators[name];
            if (customValidators) {
                for (i = 0, len = customValidators.length; i < len; i++) {
                    // Grab the response from the custom validator function
                    customRes = customValidators[i].callback.call(customValidators[i].context || self, $field);
                    // If the custom validator callback returns a string, then use that as the message
                    if (typeof customRes === 'string') { message = customRes; }
                    // if the custom validator return value is anything but true, trigger a send error
                    if (customRes !== true) {
                        return sendError.call(self, name, message, $field);
                    }
                }
                // If there are no further requirements for this field, then we can send a success
                if (!requirement) {
                    return sendSuccess.call(self, name, $field);
                }
            }

            // ignore fields with no defined requirements:
            if (requirement) {
                type = $field.attr('type');
                value  = false;
                // Firstly, set the value to test against.
                // If the field is a radio, checking for the value is not enough, you have to check for the value of
                // the "checked" radio:
                if (type === 'radio') {
                    value = (self.find('input[name="' + $field.attr('name') + '"]', self).length) ?
                            self.find('input[name="' + $field.attr('name') + '"]', self).filter(':checked').val() : '';
                } else {
                    value = $field.val();
                }

                // Determine if the field is required by examining the rules and
                // see if the requirement wasn't disabled by disableRequire method
                fieldIsRequired = requirement.required && !config._disableRequire[name];
                // if field is not required, and is empty, return true:
                if (!fieldIsRequired && !value) {
                    return sendSuccess.call(self, name, $field);
                    // if field is required and empty, return false:
                }

                if (fieldIsRequired && !value) {
                    message = 'This field is required';
                    // For required fields, the error message should be stored under
                    // requirement.messages.default_message -- check for that before using default:
                    if (requirement.messages) {
                        if (requirement.messages.default_message) {
                            message = requirement.messages.default_message;
                        }
                    }
                    return sendError.call(self, name, message, $field);
                    // If the field has a value, and a regex, test against the regex:
                }

                if (requirement.regex_rules || requirement.regex_nomatch_rules) {
                    test = true;

                    // used to test regex validations
                    regexTesterFn =  function (val, key) {
                        var reg, currTest;
                        if (!test || !val) {
                            return;//No need to test further
                        }
                        reg = new RegExp(val);
                        currTest = reg.test(value);

                        // TODO: remove when PHantomJS version fix this regex bug
                        // PhantomJS toggle true and false on every regex test run
                        // This fix makes it stable so it will return the 'right' value every time
                        reg.test(value);

                        if (currTest !== regexShouldMatch) {
                            test = false;
                            // Set message based on key in messsages array:
                            message = requirement.messages && requirement.messages[key] ? requirement.messages[key] : message;
                        }
                    };

                    regexShouldMatch = true;
                    // for each regex - test against value and return for the first falsy evaluation.
                    _.each(requirement.regex_rules, regexTesterFn);

                    regexShouldMatch = false;
                    // for each regex_nomatch_rules - send success only if the pattern is NOT matched
                    _.each(requirement.regex_nomatch_rules, regexTesterFn);

                    // if only 1 test failed then 'test' will be false. Return a false response in this case:
                    if (test) {
                        // If all tests pass, return truthy evaluation:
                        return sendSuccess.call(self, name, $field);
                    }
                    return sendError.call(self, name, message, $field);
                }
                return sendSuccess.call(self, name, $field);
            }
            // for all fields with no defined requirements -- return true (ie. leave these alone)
            return true;
        };


    // *** PUBLIC FUNCTIONS :
    // *** the following functions are exposed so they can be accessed via other scripts.

    /**
     * Form Validation Plugin - The following functions are exposed so they can be accessed via other scripts.
     * They are used in {@link dibsValidation}
     * @namespace methods
     */
    methods = {
        /**
         * @memberof methods
         * @param requirements - an object describing the form fields
         * @param options
         */
        init: function (requirements, options) {
            var self = this;
            var yesOnSubmit;
            var validateOnChange;
            var config;
            options = options || {};
            yesOnSubmit = options.validateOnSubmit === false ? options.validateOnSubmit : true;
            validateOnChange = options.validateOnChange === false ? options.validateOnChange : true;
            config = {
                requirements : requirements || {},
                options: options,
                _origReqs : {},
                prefix : options.fieldNamePrefix || 'field-input-',
                isEnableScroll : options.isEnableScroll === false ? options.isEnableScroll : true,
                submitOnValidation : options.submitOnValidation === false ? options.submitOnValidation : true,
                customValidators : {},
                _disableRequire : {}
            };
            self.data('dibsValidation', config);

            // on submit,  check the status of each field.  If the form is not valid, trigger an event signifying
            // error, this event can be picked up on a per case basis to display an error message.
            if (yesOnSubmit) {
                self.on('submit.dibsValidation', function (e) {
                    current_event = e;
                    methods.validateForm.call(self, e);
                });
            }
            // for each form element, bind focusin and focusout events:

            if (validateOnChange) {
                _validateOnChange.call(self);
            }
            return self;
        },
        /**
         * @memberof methods
         * @param e
         * @returns {boolean}
         */
        validateForm: function (e) {
            var self = this;
            // will be the location of the first missed field to scroll to.
            var newTop = false;
            // noInvalidFields denotes that no fields have been marked invalid
            // whilst checking all fields. If any field does not pass validation
            // - the form may not submit.
            var noInvalidFields = true;
            var config = this.data('dibsValidation');
            var requirements = config.requirements;
            // update the field status for each of the form inputs- ie. style change.
            self.find('input, select, textarea').each(function () {
                var $this = $(this);
                var name = $this.data('ruleset') || $this.attr('name');
                var valid;

                if (name && name.indexOf(config.prefix) !== -1) {
                    name = name.substr(config.prefix.length);
                }
                // Note: only check the given field if it is not a submit button, AND it is in the requirements:
                if ($this.attr('type') !== 'submit' && (requirements[name] || config.customValidators[name])) {
                    valid = methods.validateField.call(self, this);
                    // if the field is not valid, scroll to the location of that field:
                    if (!valid) {
                        noInvalidFields = false;
                        if (config.isEnableScroll) {
                            if (!newTop) {
                                // to find the top positioning use jQuery's offset() - however, if the input is
                                // hidden, the top offset will always be the current scrollTop of the page, so grab
                                // the offset of the closest parent element:
                                if ($this.attr('type') === 'hidden' || $this.css('display') === 'none') {
                                    newTop = $this.parent().offset().top - 50;
                                } else {
                                    newTop = $this.offset().top - 50;
                                }
                            }
                            window.clearTimeout(self.scrollTimeout);
                            self.scrollTimeout = window.setTimeout(function () {
                                $('html').animate({scrollTop: newTop}, 'slow');//IE, FF
                                $('body').animate({scrollTop: newTop}, 'slow');//chrome, don't know if safari works
                            }, 500);
                        }
                    }
                }
            });
            //If submitOnValidation is false or fields are invalid prevent default event
            if (!noInvalidFields || !config.submitOnValidation) {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                //return false only if fields are invalid
                if (!noInvalidFields) {
                    return false;
                }
            }
            //Do not submit automatically if submitOnValidation is explicitly set to false (default is true)
            if (config.submitOnValidation) {
                self.trigger('validationSuccess');
            }
            return true;
        },
        /**
         * Creates an easily reversible change in a validation rule.
         * @memberof methods
         * @param {String} name
         * @param {Object} req Object that follows requirements pattern above
         */
        reqChange : function (name, req) {
            var config = this.data('dibsValidation') || {};
            var requirements = config.requirements || {};
            var origReqs = config._origReqs || {};

            requirements[name] = requirements[name] || {};
            // Should not overwrite origReq if it already exists
            if (!origReqs[name]) {
                origReqs[name] = $.extend(true, {}, requirements[name]);
            }
            $.extend(true, requirements[name], req);
            return this;
        },
        /**
         * Reverts a requirement change to what you originally passed it
         * @memberof methods
         * @param {String} name
         */
        undoReqChange : function (name) {
            var config = this.data('dibsValidation') || {};
            var requirements = config.requirements || {};
            var origReqs = config._origReqs || {};

            if (!origReqs[name]) {
                return false;
            }
            requirements[name] = origReqs[name];
            origReqs[name] = false;
            return this;
        },
        /**
         * To simply disable the 'required'
         * validation of a field temporarily (making it
         * optional), but leave other validation intact.
         * @param {string|string[]} [fieldNames]
         *      The field names or rulsets you would like to
         *      make optional. If left out, then all required
         *      fields will become optional.
         * @return jQuery
         */
        disableRequire: function (fieldNames) {
            _toggleRequire.call(this, fieldNames, true);
            return this;
        },
        /**
         * To undo the disabling of a field's requirement
         * with disableRequire. If a field doesn't have
         * 'required === true' in it's configuration
         * it will stay that way.
         * @param {string|string[]} [fieldNames]
         * @returns jQuery
         */
        enableRequire: function (fieldNames) {
            _toggleRequire.call(this, fieldNames, false);
        },
        /**
         * If you want to disable the validation on change
         * events ('focusout' and 'change' events)
         */
        disableOnChangeValidation: function () {
            this.off('.dibsValidationBlur');
        },
        /**
         * if you want to enable the validation on
         * change and focusout events.
         */
        enableOnChangeValidation: function () {
            _validateOnChange.call(this);
        },
        /**
         * If the standard config doesn't meet your needs, you can add a custom validator function
         * @memberof methods
         * @param obj
         * @returns {jQuery}
         */
        addCustomValidator : function (name, callback, context) {
            var config = this.data('dibsValidation');
            if (config && config.customValidators) {
                if (!config.customValidators[name]) {
                    config.customValidators[name] = [];
                }
                config.customValidators[name].push({
                    callback: callback,
                    context: context
                });
            }
            return this;
        },

        /**
         * Adds a set of custom validators.
         * @memberof methods
         * @example
         * // You can use any of the following map formats:
         *      { field-name : "callback-function" }
         *      { field-name : { callback: "callback-function", context: "callback-context" }
         *      { field-name : [ "callback-function", "callback-function", ... ] }
         *      { field-name : [ { callback: "callback-function", context: "callback-context" }, ... ] }
         * @param {Object} map An object with one of the above formats
         * @param {Object} context A context to use if a map value does not have its own context
         * @returns {jQuery}
         */
        addCustomValidators : function (map, context) {
            var callback;
            var key;
            var len;
            var i;
            for (key in map) {
                if (map.hasOwnProperty(key)) {
                    if (!$.isArray(map[key])) {
                        map[key] = [map[key]];
                    }
                    for (i = 0, len = map[key].length; i < len; i++) {
                        callback = (typeof map[key][i] === 'function') ? map[key][i] : map[key][i].callback;
                        methods.addCustomValidator.call(this, key, callback, map[key][i].context || context);
                    }
                }
            }
            return this;
        },

        // checks the status of a given field, and adds the class 'valid' or 'invalid' to the element based on
        // provided regex:
        /**
         * checks the status of a given field, and adds the class 'valid' or 'invalid' to the element based on
         * provided regex
         * @memberof methods
         * @param obj
         * @returns {boolean}
         */
        validateField : function (obj) {
            var $obj = $(obj);
            var type = $obj.attr('type');
            var name = $obj.data('ruleset') || $obj.attr('name');
            var test = _validateField.call(this, name, $obj);
            if (!test) {
                if (type !== "radio") {
                    $obj.removeClass('valid').addClass('invalid');
                }
                return false;
            }
            if (type !== "radio") {
                $obj.addClass('valid').removeClass('invalid');
            }
            return true;
        }

    };
    /**
     * Form Validation Plugin
     * @class
     * @param method {function} - a method belonging to the set of methods in {@link methods}
     * @param options {object} - any options associated with the method
     * @returns {*}
     */
    $.fn.dibsValidation = function (method, options) {

        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        }
        if (typeof method === 'object' || !method) {
            return methods.init.call(this, method, options);
        }
        $.error('Method ' +  method + ' does not exist on jQuery.dibsValidation');

        return this;
    };
    /**
     * @module dibsValidation
     * @type {Function|$.dibsValidation}
     */
    module.exports = $.fn.dibsValidation;

}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(69)(module)))

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(435);
module.exports = __webpack_require__(447).f('hasInstance');

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject       = __webpack_require__(546)
  , getPrototypeOf = __webpack_require__(372)
  , HAS_INSTANCE   = __webpack_require__(574)('hasInstance')
  , FunctionProto  = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(585).f(FunctionProto, HAS_INSTANCE, {value: function(O){
  if(typeof this != 'function' || !isObject(O))return false;
  if(!isObject(this.prototype))return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
  return false;
}});

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hexTable = (function () {
    var array = new Array(256);
    for (var i = 0; i < 256; ++i) {
        array[i] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    }

    return array;
}());

var has = Object.prototype.hasOwnProperty;

exports.arrayToObject = function (source, options) {
    var obj = options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function (target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

	return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
		return acc;
    }, mergeTarget);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += (hexTable[0xF0 | (c >> 18)] + hexTable[0x80 | ((c >> 12) & 0x3F)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
    }

    return out;
};

exports.compact = function (obj, references) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    var refs = references || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0; i < obj.length; ++i) {
            if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    for (var j = 0; j < keys.length; ++j) {
        var key = keys[j];
        obj[key] = exports.compact(obj[key], refs);
    }

    return obj;
};

exports.isRegExp = function (obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function (obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-info-circle'].join(' '), viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M125.7,0.5C57.1,0.5,1.2,56.4,1.2,125s55.9,124.5,124.5,124.5S250.2,193.6,250.2,125S194.4,0.5,125.7,0.5z M125.7,239.5 c-63.1,0-114.5-51.4-114.5-114.5S62.6,10.5,125.7,10.5S240.2,61.9,240.2,125S188.8,239.5,125.7,239.5z' }),
                React.createElement('path', { d: 'M134.8,187.9c-3.6,0-6.3-0.7-7.9-2c-1.6-1.3-2.4-3.8-2.4-7.5c0-1.5,0.2-3.5,0.7-5.9c0.5-2.4,1-4.9,1.7-7.4l10.2-40.8 c0.5-2,0.9-4,1.2-6s0.4-3.6,0.4-4.7c0-4.2-1.2-7.6-3.6-10.1c-2.4-2.5-6.2-3.7-11.4-3.7c-2.3,0-5.4,0.5-9.4,1.6 c-4,1.1-8.4,2.8-13.4,5l-1.4,6.1c1.2-0.3,3-0.7,5.3-1.2c2.3-0.4,4.2-0.7,5.6-0.7c3.6,0,6.1,0.6,7.2,1.8c1.2,1.2,1.8,3.6,1.8,7.2 c0,1.8-0.2,4-0.7,6.5c-0.5,2.6-1,5-1.5,7.2l-10.1,40.8c-0.6,2.4-1,4.5-1.2,6.1c-0.3,1.6-0.4,3.1-0.4,4.6c0,3.9,1.3,7.2,3.8,9.8 c2.6,2.7,6.4,4,11.5,4c2.5,0,5.5-0.5,9-1.4c3.5-0.9,8.2-2.6,14.1-4.9l1.4-6.1c-1.2,0.4-3,0.8-5.2,1.2 C137.8,187.8,136,187.9,134.8,187.9z' }),
                React.createElement('path', { d: 'M139.7,51.2c-3.3,0-6.1,1.3-8.4,3.9c-2.4,2.6-3.6,5.7-3.6,9.2c0,3.3,1.2,6.3,3.6,8.9c2.4,2.6,5.2,3.9,8.4,3.9 c3.5,0,6.5-1.4,8.8-4.1c2.4-2.7,3.6-5.9,3.6-9.6c0-3.3-1.2-6.1-3.5-8.6C146.3,52.5,143.3,51.2,139.7,51.2z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 438 */,
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(302),
    createEnum = _require.createEnum;

/**
 * Enum class representing a "type" of a carousel page change. Mostly useful for GA tracking purposes.
 */


module.exports = createEnum('next', 'previous', 'jump');

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Rip off logic used internally by React.PropTypes to create chainable/requirable prop type validators. The React
// team has not agreed to expose this so we'll need to maintain it ourselves. Some minor changes made to the
// implementation that shouldn't affect its operation.



var ANONYMOUS = '<<anonymous>>';

/**
 * Pass in a custom React prop types validation function to create a wrapped version of that validator that allows
 * marking it as required.
 *
 * See https://facebook.github.io/react/docs/reusable-components.html for some more information on custom validators.
 * @param  {Function} validate The validation function to wrap.
 * @return {Function}          Wrapped validator.
 */
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        var prop = props[propName];


        if (prop === null || prop === undefined) {
            if (isRequired) {
                return new Error('Required ' + location + ' `' + propFullName + '` was not specified in `' + componentName + '`');
            } else {
                return null;
            }
        } else {
            return validate(props, propName, componentName, location, propFullName);
        }
    }

    // Create a required and non-required version of the validator
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
}

module.exports = createChainableTypeChecker;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Need to manually require the babel runtime component for customizing instanceof.
// In native ES2015 this would be done with the "well-known" symbol `Symbol.hasInstance`

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var hasInstance = __webpack_require__(432).default;

/**
 * Uppercase the first letter of the passed in string.
 * @param  {String} str String to capitalize
 * @return {String}
 */
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
}

/**
 * Generate an enum type with the passed in variants. Enums will get a match method, a method for getting the raw
 * type name as a string a method for getting any contained data, and identity functions for every variant. An example
 * illustrates how this works:
 *
 * Here each variant wraps a class. When matching on the variant, the inner data is returned and can be manipulated.
 * const deviceTypeEnum = createEnum({
 *     mobile(...args) {
 *         return new Mobile(...args);
 *     },
 *     tablet(...args) {
 *         return new Tablet(...args);
 *     },
 *     desktop(...args) {
 *         return new Desktop(...args);
 *     }
 * });
 *
 * const instance = deviceTypeEnum.mobile();
 *
 * instance.isMobile() // true
 * instance.isTablet() // false
 * instance.isDesktop() // false
 * instance.variant() // 'mobile'
 * instance.data() // instance of class Mobile
 *
 * const test = instance.match({
 *     mobile: (inner) => inner,
 *     tablet: (inner) => inner,
 *     desktop: (inner) => inner
 * });
 *
 * console.log(test) // instance of class Mobile
 *
 * @param  {String} ...types List of enum variants.
 * @return {Enum}
 */
function createEnum() {
    for (var _len = arguments.length, variants = Array(_len), _key = 0; _key < _len; _key++) {
        variants[_key] = arguments[_key];
    }

    // Allow passing a list of variants instead of an object if we don't need to hold any data.
    if (_typeof(variants[0]) === 'object') {
        variants = variants[0];
    } else {
        variants = variants.reduce(function (acc, variant) {
            if (typeof variant !== 'string') {
                throw new Error('If not passing a config object to createEnum, all arguments must be strings.');
            }

            acc[variant] = function () {
                return null;
            };
            return acc;
        }, {});
    }

    // Brand the newly create enum "class" so instance of differentiates between different enums.
    // Symbols are guaranteed to be unique so there is no way to spoof this.
    var brand = Symbol();
    var keys = Object.keys(variants);

    var EnumClass = function () {
        function EnumClass(variant, data) {
            _classCallCheck(this, EnumClass);

            this.variant = variant;
            this.data = data;
            this[brand] = true;
        }

        // Matching function to avoid lots of if/else blocks using the identity methods directly.


        _createClass(EnumClass, [{
            key: 'match',
            value: function match(config) {
                var matcher = config[this.variant];

                // If a matching function is passed in, pass through the wrapped data.
                if (matcher) {
                    return matcher(this.data);
                }
            }
        }]);

        return EnumClass;
    }();

    // Add an "isVariant" method for each variant.
    keys.forEach(function (variant) {
        EnumClass.prototype['is' + capitalize(variant)] = function () {
            return this.variant === variant;
        };
    });

    // Freeze the object so it can't be tampered with.
    Object.freeze(EnumClass.prototype);
    return Object.freeze(keys.reduce(function (acc, variant) {
        // Add the variant construction functions.
        acc[variant] = function () {
            var _variants;

            return Object.freeze(new EnumClass(variant, (_variants = variants)[variant].apply(_variants, arguments)));
        };;
        return acc;
    }, _defineProperty({}, hasInstance, function (value) {
        return value[brand] || false;
    })));
}

module.exports = createEnum;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createChainableTypeChecker = __webpack_require__(440);

/**
 * Currently React's instanceOf PropTypes checker does not work with ES2015 customized instanceof checks. This is a
 * custom propType validator that will allow a component to check if a prop is an instance of a particular enum type.
 *
 * Example:
 * const myEnum = createEnum('one', 'two');
 * const enumInstance = myEnum.one();
 *
 * class MyReactComponent { ... }
 * MyReactComponent.propTypes = {
 *     enumProp: instanceOfEnum(myEnum).isRequired,
 *     moreEnums: PropTypes.arrayOf(instanceOfEnum(myEnum)).isRequired
 * }
 *
 * @param  {Enum} enumType The enum "class" to check for.
 * @return {Function}          A React prop types validation function for that enum.
 */
function instanceOfEnum(enumType) {
    // Make this prop type requireable with `isRequired`
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        // Prop is guaranteed to be defined at this point so no need to check for it.
        if (!(props[propName] instanceof enumType)) {
            // React requires custom validators to `return` an error and not `throw`
            return new Error('Must pass an enum instance of correct type to ' + location + ' `' + propFullName + '` in `' + componentName + '`');
        } else {
            return null;
        }
    });
}

module.exports = instanceOfEnum;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

_ = __webpack_require__(23);
module.exports = {
    "favoritesWrapperTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div id="portfolioNavMainContainer"></div>\n    <div id="portfolioLoadingContainer" class="portfolio-loading-container"></div>\n    <div id="portfolioTabContainer">\n        <div id="itemsContainer"></div>\n        <div id="followingContainer" class="boxSizingWrapper"></div>\n        <div id="errorContainer"></div>\n        <div id="messageContainer"></div>\n    </div>\n';
return __p
},
    "portfolioWrapperTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div id="sectionLists"></div>\n    <div id="sectionPortfolio"></div>\n';
return __p
},
    "portfolioPageTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div id="portfolioToolbarContainer"></div>\n    <div id="pageViewContainer"></div>\n';
return __p
},
    "portfolioNavMainTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="portfolio-nav-main">\n        <div class="portfolio-title h1">My Favorites</div>\n        <div class="portfolio-nav-main-container-inner cf">\n            <div class="portfolio-nav-main" data-tn="portfolio-nav-main">\n                <a href="#toggle-items" id="toggleItems" class="portfolio-toggle-section';
 if (obj.tab === 'items') { ;
__p += ' is-selected';
 } ;
__p += '" data-galabel="all items" data-tn="toggle-items">Items</a>\n                <a href="#toggle-following" id="toggleFollowing" class="portfolio-toggle-section';
 if (obj.tab === 'following') { ;
__p += ' is-selected';
 } ;
__p += '" data-galabel="following" data-tn="toggle-following">Following</a>\n            </div>\n        </div>\n        <div class="portfolio-nav-indicator-track">\n            <div class="portfolio-nav-indicator" data-tn="portfolio-nav-indicator"></div>\n        </div>\n    </div>\n';
return __p
},
    "settingsModalTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="modal-body" data-tn="settings-modal">\n        <div class="modal-section">\n            <div class="modal-label" data-tn="settings-modal-privacy-label">' +
((__t = ( obj.options.copy.settingsPrivacyHeader )) == null ? '' : __t) +
'</div>\n            <label class="prettycheck privacy-setting">\n                <input type="radio" name="privacySetting.privacyLevel" value="' +
((__t = ( obj.options.modelClass.PRIVACY_PUBLIC )) == null ? '' : __t) +
'" data-tn="settings-modal-privacy-public">\n                <span class="input-label fauxinput">' +
((__t = ( obj.options.copy.settingsPrivacyPublic )) == null ? '' : __t) +
'</span>\n            </label>\n            <label class="prettycheck privacy-setting">\n                <input type="radio\' name="privacySetting.privacyLevel" value="' +
((__t = ( obj.options.modelClass.PRIVACY_PRIVATE )) == null ? '' : __t) +
'"" data-tn="settings-modal-privacy-private">\n                <span class="input-label fauxinput">' +
((__t = ( obj.options.copy.settingsPrivacyPrivate )) == null ? '' : __t) +
'</span>\n            </label>\n        </div>\n        <div class="modal-actions">\n            <button class="modal-action button-medium button-primary" data-tn="settings-modal-privacy-save" save>' +
((__t = ( obj.options.copy.modalLabels.save )) == null ? '' : __t) +
'</button>\n        </div>\n    </div>\n';
return __p
},
    "settingPrivacyModal": function(obj) {
var __t, __p = '';
__p += '\n    <div class="modal-header">' +
((__t = ( obj.options.copy.modalLabels.sharingSettings )) == null ? '' : __t) +
'</div>\n    <div class="modal-body">\n        <div class="modal-section">\n            <div class="modal-label">' +
((__t = ( obj.options.copy.settingsPrivacyHeader )) == null ? '' : __t) +
'</div>\n            <label class="prettycheck privacy-setting">\n                <input type="radio" name="privacySetting.privacyLevel" value="' +
((__t = ( obj.options.modelClass.PRIVACY_PUBLIC )) == null ? '' : __t) +
'">\n                <span class="input-label fauxinput">' +
((__t = ( obj.options.copy.settingsPrivacyPublic )) == null ? '' : __t) +
'</span>\n            </label>\n            <label class="prettycheck privacy-setting">\n                <input type="radio" name="privacySetting.privacyLevel" value="' +
((__t = ( obj.options.modelClass.PRIVACY_PRIVATE )) == null ? '' : __t) +
'">\n                <span class="input-label fauxinput">' +
((__t = ( obj.options.copy.settingsPrivacyPrivate )) == null ? '' : __t) +
'</span>\n            </label>\n        </div>\n        <div class="modal-actions">\n            <button class="modal-action button-medium button-primary" save>' +
((__t = ( obj.options.copy.modalLabels.save )) == null ? '' : __t) +
'</button>\n        </div>\n    </div>\n';
return __p
},
    "settingEditNameModal": function(obj) {
var __t, __p = '';
__p += '\n    <div class="modal-header">' +
((__t = ( (2 < obj.options.level) ? obj.options.copy.modalLabels.editSubFolder : obj.options.copy.modalLabels.editFolder )) == null ? '' : __t) +
'</div>\n    <div class="modal-body">\n        <div class="modal-section">\n            <div class="modal-label">' +
((__t = ( obj.options.copy.modalLabels.name )) == null ? '' : __t) +
'\n                <span class="errflag"></span>\n            </div>\n            <input class="form-input" type="text" name="name" data-tn="settings-edit-name-input">\n        </div>\n        <div class="modal-actions">\n            <button class="modal-action button-medium button-primary" data-tn="settings-edit-name-save" save>' +
((__t = ( obj.options.copy.modalLabels.save )) == null ? '' : __t) +
'</button>\n        </div>\n    </div>\n';
return __p
},
    "portfolioToolbarTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="portfolio-toolbar cf"></div>\n';
return __p
},
    "editMenuItem": function(obj) {
var __t, __p = '';
__p += '\n    <li class="edit-dropdown-item" data-modal-show="' +
((__t = ( obj.modalName )) == null ? '' : __t) +
'">' +
((__t = ( obj.label )) == null ? '' : __t) +
'</li>\n';
return __p
},
    "portfolioDropdownTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    ';
 if (obj.dropdownPortfolios && obj.dropdownPortfolios.length) { ;
__p += '\n        <div class="portfolio-p3-dropdown">\n            <select class="portfolio-p3-dropdown-select';
 if (obj.isP2) { ;
__p += ' is-all';
 } ;
__p += '">\n                ';
 obj.dropdownPortfolios.each(function (portfolio, index) { ;
__p += '\n                    <option value="' +
((__t = ( index )) == null ? '' : __t) +
'"';
 if (portfolio.id === obj.selectedId) { ;
__p += ' selected="1"';
 } ;
__p += '>\n                        ';
 if (portfolio.id === obj.allId) { ;
__p += '\n                            All Subfolders\n                        ';
 } else { ;
__p += '\n                            ' +
((__t = ( portfolio.get('name') )) == null ? '' : __t) +
'\n                        ';
 } ;
__p += '\n                    </option>\n                ';
 }) ;
__p += '\n            </select>\n        </div>\n    ';
 } ;
__p += '\n';
return __p
},
    "portfolioSearchTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="portfolio-search">\n        <form class="portfolio-search-form cf">\n            <div class="portfolio-search-input-wrap">\n                <input type="text" name="portfolioSearch" class="portfolio-search-input" placeholder="' +
((__t = ( obj.copySearchPlaceholder )) == null ? '' : __t) +
'" value="">\n                <div class="portfolio-search-button-wrap">\n                    <a href="#clear-term" class="portfolio-search-clear-button">\n                        ' +
((__t = ( obj.closeIcon )) == null ? '' : __t) +
'\n                    </a>\n                    <button type="submit" class="portfolio-search-button">\n                        ' +
((__t = ( obj.magnifyingGlassIcon )) == null ? '' : __t) +
'\n                    </button>\n                </div>\n            </div>\n        </form>\n    </div>\n    ';
 if (obj.query) { ;
__p += '\n        <span class="portfolio-search-summary ellipsis">\n            ' +
((__t = ( obj.totalResults )) == null ? '' : __t) +
' result' +
((__t = ( obj.totalResults === 1 ? '' : 's' )) == null ? '' : __t) +
' for "' +
((__t = ( obj.query )) == null ? '' : __t) +
'"\n        </span>\n    ';
 } ;
__p += '\n';
return __p
},
    "portfolioToggleLayoutTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <a href="#toggle-row" id="toggleRow" class="' +
((__t = ( obj.toggleRowClass )) == null ? '' : __t) +
'" data-galabel="click to view as list">' +
((__t = ( obj.listIcon )) == null ? '' : __t) +
'</a>\n    <a href="#toggle-grid" id="toggleGrid" class="' +
((__t = ( obj.toggleGridClass )) == null ? '' : __t) +
'" data-galabel="click to view as grid">' +
((__t = ( obj.gridIcon )) == null ? '' : __t) +
'</a>\n';
return __p
},
    "portfolioRowItemTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="imageDiv colXs12 colMd3"></div>\n    <div class="colXs12 colMd6">\n        <div class="rowSectionCenter">\n            ' +
((__t = ( obj.titleHtml )) == null ? '' : __t) +
'\n            ' +
((__t = ( obj.dealerHtml )) == null ? '' : __t) +
'\n            ' +
((__t = ( obj.priceHtml )) == null ? '' : __t) +
'\n            ' +
((__t = ( obj.itemActionButtonsHtml)) == null ? '' : __t) +
'\n            <div class="js-contact-dealer"></div>\n            <div class="portfolio-row-item-contact-dealer-link-wrapper">\n                <a class="portfolio-row-item-contact-dealer-link" href="#">contact dealer</a>\n            </div>\n        </div>\n    </div>\n    <div class="colXs12 colMd3">\n        <div class="actionsDiv rowSectionRight"></div>\n    </div>\n';
return __p
},
    "portfolioRowPlaceholderTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <li class="portfolio-row-item">\n        <div class="portfolio-row-placeholder-inner"></div>\n        <div class="portfolio-row-placeholder-inner"></div>\n        <div class="portfolio-row-placeholder-inner"></div>\n    </li>\n';
return __p
},
    "portfolioGridItemTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-inner">\n        <div class="imageDiv isGrid"></div>\n        ' +
((__t = ( obj.titleHtml )) == null ? '' : __t) +
'\n        ' +
((__t = ( obj.dealerHtml )) == null ? '' : __t) +
'\n        ' +
((__t = ( obj.priceHtml )) == null ? '' : __t) +
'\n        <div class="actionsDiv"></div>\n    </div>\n';
return __p
},
    "portfolioItemImageTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    ';
 if (obj.isUnavailable) { ;
__p += '\n        <div class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-image-unavailable">\n            <div class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-image-unavailable-text">\n                <p>Image</p>\n                <p>Not</p>\n                <p>Available</p>\n            </div>\n        </div>\n    ';
 } else { ;
__p += '\n        <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link has-image link-pdp" data-galocation="item image">\n            <img src="' +
((__t = ( obj.imageUrl )) == null ? '' : __t) +
'" alt="' +
((__t = ( obj.title )) == null ? '' : __t) +
'" class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-image is-centered">\n        </a>\n    ';
 } ;
__p += '\n';
return __p
},
    "portfolioItemTitleTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-name" data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-name">\n        ';
 if (obj.isUnavailable) { ;
__p += '\n            <span class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link-name" data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link-name">\n                ' +
((__t = ( obj.title )) == null ? '' : __t) +
'\n            </span>\n        ';
 } else if (obj.isArtCreator) { ;
__p += '\n            <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link" class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link link-pdp';
 if (obj.isGrid) { ;
__p += ' ellipsis';
 } ;
__p += '" data-galocation="item title">\n                ' +
((__t = ( obj.creator )) == null ? '' : __t) +
'\n            </a>\n            <div data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-art-title" class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-art-title';
 if (obj.isGrid) { ;
__p += ' ellipsis multiline';
 } ;
__p += '">\n                <span class="italic">' +
((__t = ( obj.title )) == null ? '' : __t) +
'</span>';
 if (obj.creationDate) { ;
__p += ', ' +
((__t = ( obj.creationDate )) == null ? '' : __t);
 } ;
__p += '\n            </div>\n        ';
 } else { ;
__p += '\n            <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link" class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-product-link link-pdp';
 if (obj.isGrid) { ;
__p += ' ellipsis multiline';
 } ;
__p += '" data-galocation="item title">\n                ' +
((__t = ( obj.title )) == null ? '' : __t) +
'\n            </a>\n        ';
 } ;
__p += '\n    </div>\n';
return __p
},
    "portfolioItemDealerTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    ';
 if (!obj.isUnavailable) { ;
__p += '\n        <div class="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-dealer';
 if (obj.isGrid) { ;
__p += ' ellipsis';
 } ;
__p += '" data-tn="' +
((__t = ( obj.classPrefix )) == null ? '' : __t) +
'-dealer">\n            Offered by ' +
((__t = ( obj.dealerCompany )) == null ? '' : __t) +
'\n        </div>\n    ';
 } ;
__p += '\n';
return __p
},
    "portfolioItemPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="portfolio-price-wrapper"></div>\n';
return __p
},
    "portfolioItemActionButtonsTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="portfolio-row-action-buttons-container"></div>\n';
return __p
},
    "portfolioErrorTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="portfolio-error-container">\n        <div class="portfolio-error-message">\n            ' +
((__t = ( obj.copyServiceError )) == null ? '' : __t) +
'\n            ';
 if (obj.showError && obj.errorMessage) { ;
__p += '\n                <p class="portfolio-error-dev">' +
((__t = ( obj.errorMessage )) == null ? '' : __t) +
'</p>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n';
return __p
},
    "portfolioMessageTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="portfolio-message-container" data-tn="portfolio-message-container">\n        <div class="portfolio-message-message-container">\n            <div class="portfolio-message-message" data-tn="portfolio-message-copy">\n                ' +
((__t = ( obj.copy )) == null ? '' : __t) +
'\n            </div>\n        </div>\n        <div class="portfolio-message-link-group-container">\n            <div class="portfolio-message-link-left">\n                <div class="portfolio-message-link-group portfolio-message-verticals"></div>\n                <div class="portfolio-message-link-group portfolio-message-collections"></div>\n            </div>\n            <div class="portfolio-message-link-right">\n                <div class="portfolio-message-link-group portfolio-message-creators"></div>\n            </div>\n        </div>\n    </div>\n';
return __p
},
    "portfolioMessageLinkGroupTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <h3 class="portfolio-message-link-group-header">\n        ' +
((__t = ( obj.linkGroup.name )) == null ? '' : __t) +
'\n    </h3>\n    <ul>\n        ';
 _.each(obj.linkGroup.links, function(link, index) { ;
__p += '\n            <li class="portfolio-message-link-container">\n                <a href="' +
((__t = ( link.uri )) == null ? '' : __t) +
'" class="portfolio-link">\n                    ' +
((__t = ( link.name )) == null ? '' : __t) +
'\n                </a>\n            </li>\n        ';
 }); ;
__p += '\n    </ul>\n';
return __p
},
    "portfolioListsTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div id="portfolioList" class="portfolio-lists-container row cf">\n    </div>\n';
return __p
},
    "portfolioListsP2Tmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="portfolio-lists-p2-container-inner">\n        <div class="portfolio-lists-preview-main" data-tn="portfolio-favorite-preview-main">\n            ';
 if (obj.preview1) { ;
__p += '\n                <img src="' +
((__t = ( obj.preview1 )) == null ? '' : __t) +
'" class="portfolio-lists-preview-image" data-tn="portfolio-favorite-preview-image">\n            ';
 } ;
__p += '\n        </div>\n        <div class="portfolio-lists-preview-sub-container row cf">\n            ';
 for (var i=2; i<=4; i++) { ;
__p += '\n                <div class="portfolio-lists-preview-sub">\n                    ';
 var imgSrc = obj['preview' + i];
                    if (imgSrc) { ;
__p += '\n                        <img src="' +
((__t = ( imgSrc )) == null ? '' : __t) +
'" class="portfolio-lists-preview-image" data-tn="portfolio-favorite-preview-image-' +
((__t = ( i )) == null ? '' : __t) +
'">\n                    ';
 } ;
__p += '\n                </div>\n            ';
 } ;
__p += '\n        </div>\n        <div class="portfolio-lists-name-container">\n            <span class="portfolio-lists-name ellipsis">' +
((__t = ( obj.name )) == null ? '' : __t) +
'</span>\n            <span class="portfolio-lists-count"> - ' +
((__t = ( obj.numItemsCopy )) == null ? '' : __t) +
'</span>\n        </div>\n    </div>\n';
return __p
},
    "portfolioCreateP2Tmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="portfolio-lists-create-container-inner">\n        <div class="portfolio-lists-create-section toggle-overlay">\n            <div class="portfolio-lists-create-circle">\n                ' +
((__t = ( obj.plusIcon )) == null ? '' : __t) +
'\n            </div>\n            <div class="portfolio-lists-create-text">\n                ' +
((__t = ( obj.copyCreateP2 )) == null ? '' : __t) +
'\n            </div>\n        </div>\n        <div class="portfolio-lists-create-section is-hidden">\n            <div class="portfolio-lists-create-close toggle-overlay">\n                ' +
((__t = ( obj.closeIcon )) == null ? '' : __t) +
'\n            </div>\n            <form class="portfolio-lists-create-form">\n                <div class="portfolio-lists-create-label">\n                    ' +
((__t = ( obj.copyCreateP2 )) == null ? '' : __t) +
'\n                </div>\n                <input type="text" id="listName" name="listName" class="portfolio-lists-create-input validation-field" placeholder="' +
((__t = ( obj.copyCreateP2Placeholder )) == null ? '' : __t) +
'">\n                <button id="portfolioCreateP2Submit" class="portfolio-lists-create-button button-medium full-width button-primary">Create</button>\n            </form>\n        </div>\n    </div>\n';
return __p
},
    "portfolioShareTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <h2 class="modal-header">' +
((__t = ( obj.copyShareHeader )) == null ? '' : __t) +
'</h2>\n    <div class="modal-body">\n        <form class="portfolio-modal-form">\n            <fieldset class="portfolio-modal-fields">\n                <div class="portfolio-modal-form-row share-name">\n                <span class="is-hidden form-errflag-above">Required Field</span>\n                    <label for="userName" class="portfolio-modal-label">\n                        Your Name<span class="is-required">*</span>\n                    </label>\n                    <input type="text" id="userName" class="portfolio-modal-field is-required" name="senderName" value="' +
((__t = ( obj.userName || '' )) == null ? '' : __t) +
'" />\n                </div>\n                <div class="portfolio-modal-form-row share-to">\n                    <span class="is-hidden form-errflag-above">Required Field</span>\n                    <label for="shareTo" class="portfolio-modal-label">\n                        Recipient&#39;s Email<span class="is-required">*</span>\n                    </label>\n                    <input type="text" id="shareTo" class="portfolio-modal-field is-required" name="recepientEmails" />\n                    <div class="portfolio-modal-field-note">' +
((__t = ( obj.copyShareMultipleEmail )) == null ? '' : __t) +
'</div>\n                </div>\n                <div class="portfolio-modal-form-row share-message">\n                    <label for="userMessage" class="portfolio-modal-label">Message <span class="is-optional">(optional)</span></label>\n                    <textarea maxlength="500" rows="3" id="userMessage" class="portfolio-modal-field" name="message" placeholder="' +
((__t = ( obj.copyShareMessagePlaceholder )) == null ? '' : __t) +
'"></textarea>\n                </div>\n            </fieldset>\n        </form>\n        <div class="portfolio-modal-notice privacy-notice cf">\n            <span class="privacy-notice-inline">' +
((__t = ( obj.copySharePrivacyNotice )) == null ? '' : __t) +
'</span>\n        </div>\n        <div class="modal-actions">\n            <span class="modal-action portfolio-share-confirm button-medium button-primary">SEND EMAIL</span>\n        </div>\n    </div>\n';
return __p
},
    "page-view-container": function(obj) {
var __t, __p = '';
__p += '\n    <ul class="boxSizingWrapper containerFluid page-body is-' +
((__t = ( this.subViewOptions.layout )) == null ? '' : __t) +
' portfolio-' +
((__t = ( this.subViewOptions.layout )) == null ? '' : __t) +
'-container row cf is-sortable"></ul>\n    <div class="page-links-container page-links-bottom pagination"></div>\n';
return __p
},
    "favoriteContactedDealer": function(obj) {
var __t, __p = '';
__p += '\n    <div class="email-success email-success-message">\n         ' +
((__t = ( obj.successMessage )) == null ? '' : __t) +
'\n    </div>\n    <div class="favorite-dealer-info is-hidden">\n        <div class="email-success-divider"></div>\n        <div class="email-success email-success-header">\n            ' +
((__t = ( obj.copy('successInfoHeader') )) == null ? '' : __t) +
'\n        </div>\n        <div class="email-success email-success-subtext">\n            ' +
((__t = ( obj.successInfoSubtext )) == null ? '' : __t) +
'\n        </div>\n    </div>\n\n    <div class="favorite-dealer-cta-container"></div>\n\n    <div class="favorite-dealer-cta-wrapper is-hidden">\n        <a href="#" class="favorite-dealer-cta no-thanks">' +
((__t = ( obj.copy('noThanksCta') )) == null ? '' : __t) +
'</a>\n    </div>\n';
return __p
}
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _stripDiacritics = __webpack_require__(446);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2['default'])(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

module.exports = filterOptions;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _classnames = __webpack_require__(337);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption;
	var instancePrefix = _ref.instancePrefix;
	var labelKey = _ref.labelKey;
	var onFocus = _ref.onFocus;
	var onSelect = _ref.onSelect;
	var optionClassName = _ref.optionClassName;
	var optionComponent = _ref.optionComponent;
	var optionRenderer = _ref.optionRenderer;
	var options = _ref.options;
	var valueArray = _ref.valueArray;
	var valueKey = _ref.valueKey;
	var onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2['default'])(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2['default'].createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function (ref) {
					onOptionRef(ref, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

module.exports = menuRenderer;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

module.exports = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(53))(162);

/***/ }),
/* 448 */,
/* 449 */
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(67),
    noop = _require.noop;

var MultiTouchDetector = __webpack_require__(269);

var _require2 = __webpack_require__(302),
    createEnum = _require2.createEnum;

var math = __webpack_require__(459);

/**
 * Enum class representing a swipe direction.
 */
var swipeDirectionEnum = createEnum('left', 'right', 'up', 'down');

var quadarantDirectionMap = [swipeDirectionEnum.right, swipeDirectionEnum.up, swipeDirectionEnum.left, swipeDirectionEnum.down];

/**
 * Utility to detect the direction of the swipe.
 * @param {Array} - Array consisting of the touch coordinates [x, y]
 * @return {Object} - Enum class
 */
function swipeDirection(distance) {
    var quadrant = math.getQuadrant(math.getPointAngle(distance[0], distance[1]) + 45);
    return quadarantDirectionMap[quadrant]();
}

/**
 * Utility class To handle swipe detection. Pass an element in and get notified on a swipe on that element. Instances
 * need to be destroyed when tracking is no longer needed.
 *
 * @param  {Object}  options.el Element to track.
 * @param  {Function}  [options.onPartialSwipe] Callback to fire on initial panning. Allows you to get distance panned.
 * @param  {Function}  [options.onSwipeSuccess] Callback to fire on successful swipe. Callback is passed the swipe direction.
 * @param  {Function}  [options.onSwipeFailure] Callback to fire on failed swipe.
 */

var SwipeDetector = function () {
    function SwipeDetector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el,
            _ref$onPartialSwipe = _ref.onPartialSwipe,
            onPartialSwipe = _ref$onPartialSwipe === undefined ? noop : _ref$onPartialSwipe,
            _ref$onSwipeSuccess = _ref.onSwipeSuccess,
            onSwipeSuccess = _ref$onSwipeSuccess === undefined ? noop : _ref$onSwipeSuccess,
            _ref$onSwipeFailure = _ref.onSwipeFailure,
            onSwipeFailure = _ref$onSwipeFailure === undefined ? noop : _ref$onSwipeFailure;

        _classCallCheck(this, SwipeDetector);

        if (!el) {
            throw new Error('Must pass `el` to SwipeDetector');
        }

        Object.assign(this, {
            _distance: [null, null],
            _initialPosition: [null, null],
            _initialTime: null,
            _el: el,
            _onPartialSwipe: onPartialSwipe,
            _onSwipeSuccess: onSwipeSuccess,
            _onSwipeFailure: onSwipeFailure,
            _multiTouchDetector: new MultiTouchDetector({
                onSingleTouchStart: this._onSingleTouchStart.bind(this),
                onSingleTouchMove: this._onSingleTouchMove.bind(this),
                onSingleTouchEnd: this._onSingleTouchEnd.bind(this),
                el: el
            })
        });
    }

    _createClass(SwipeDetector, [{
        key: '_onSingleTouchStart',
        value: function _onSingleTouchStart(e) {
            // Get the initial position and time so we can do a difference on them later.
            this._initialPosition = [e.touches[0].clientX, e.touches[0].clientY];
            this._initialTime = Date.now();
        }
    }, {
        key: '_onSingleTouchMove',
        value: function _onSingleTouchMove(e) {
            this._distance = [e.touches[0].clientX - this._initialPosition[0], e.touches[0].clientY - this._initialPosition[1]];

            var direction = swipeDirection(this._distance);

            /**
             * We don't wanna messup the scrolling experience so we only call preventDefault when
             * swiping horizontaly.
             */
            if (direction.isRight() || direction.isLeft()) {
                e.preventDefault();
            }

            this._onPartialSwipe(this._distance, direction);
        }
    }, {
        key: '_onSingleTouchEnd',
        value: function _onSingleTouchEnd() {
            if (this._shouldRegisterSwipe()) {
                // Determine swipe direction based on sign of distance.
                this._onSwipeSuccess(swipeDirection(this._distance));
            } else {
                this._onSwipeFailure();
            }

            this._distance = [0, 0];
        }
    }, {
        key: '_shouldRegisterSwipe',
        value: function _shouldRegisterSwipe() {
            var _this = this;

            var totalTime = Date.now() - this._initialTime;
            var absoluteDistance = void 0;

            return this._distance.some(function (distance) {
                absoluteDistance = Math.abs(distance);

                // Register a swipe if:
                // slide duration is less than 250ms and if slide distance is greater than 20px
                // OR if slide distance is greater than half the width of the element.
                return absoluteDistance > _this._el.clientWidth / 2 || absoluteDistance > 20 && totalTime < 250;
            });
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this._multiTouchDetector.destroy();
        }
    }]);

    return SwipeDetector;
}();

module.exports = SwipeDetector;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(469);


/***/ }),
/* 452 */,
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isEmpty = __webpack_require__(264);

var tracking = __webpack_require__(27);
var trackingHelpers = __webpack_require__(740);

var GalleryStore = __webpack_require__(357);
var GAC = __webpack_require__(342);

// DATA LAYER settings for gallery
var DATA_LAYER_SETTINGS = Object.freeze({
    pageType: 'Other',
    pageLevel: 'Other',
    pageSubType: 'Trade Firm',

    countOfItems: 0,
    ecommerce: undefined
});

// List for e commerce events
var LIST_SIMILAR_ITEMS = 'related items on trade firm photo';

// Category for gallery events
var CATEGORY_TRADE_GALLERY = 'trade firm project image interaction';

// targets for trackLinkClick()
var GA_LINK_TARGETS = {
    CLOSE: 'close',
    MORE: 'more projects',
    PROJECT: 'trade firm project link',
    VIEW_SIMILAR: 'similar products see all',
    TOOLTIP_LINK: 'photo tag tooltip view similar pieces'
};

// helper for keeping track of which images have been zoomed
// since we do not track zooming the same image twice
var _isNotTracked = function () {
    var tracked = [];
    return function (photoId) {
        // has been tracked already
        if (tracked.indexOf(photoId) > -1) {
            return false;
        }

        // has not been tracked
        tracked.push(photoId);
        return true;
    };
}();

// Returns labels of the form [Index of Photo]/[Number of Photos]
function _getEventLabel(galleryStore) {
    var index = galleryStore.getCurrentPhotoIndex() + 1;
    var total = galleryStore.getTotalNumberOfPhotos();
    return index + '/' + total;
}

function trackPhotoSwitch(ac, _ref, done) {
    var action = _ref.action,
        pageType = _ref.pageType;

    var trackObj = void 0;

    if (pageType === GAC.pageTypes.PDP) {
        trackObj = {
            action: 'related rooms carousel',
            category: 'promo interaction',
            label: action + ' arrow clicked'
        };
    } else {
        trackObj = {
            action: 'image ' + action + ' image displayed',
            category: CATEGORY_TRADE_GALLERY,
            label: _getEventLabel(ac.getStore(GalleryStore))
        };
    }

    tracking.trackEvent(trackObj);
    done();
}

function trackMobileZoom(ac, payload, done) {
    var galleryStore = ac.getStore(GalleryStore);
    var photoId = galleryStore.getCurrentPhoto('id');

    if (_isNotTracked(photoId)) {
        tracking.trackEvent({
            action: 'mobile image zoom',
            category: CATEGORY_TRADE_GALLERY,
            label: _getEventLabel(ac.getStore(GalleryStore))
        });
    }

    done();
}

function trackLinkClick(ac, _ref2, done) {
    var target = _ref2.target,
        label = _ref2.label;

    tracking.trackEvent({
        category: CATEGORY_TRADE_GALLERY,
        action: target + ' clicked',
        label: label
    });
    done();
}

function trackTooltipDisplayed(ac, payload, done) {
    tracking.trackEvent({
        category: CATEGORY_TRADE_GALLERY,
        action: 'photo tag tooltip displayed'
    });
    done();
}

function trackSimilarItemImpressions(ac, payload, done) {
    var _ac$getStore$getSimil = ac.getStore(GalleryStore).getSimilarItemsTracking(),
        _ac$getStore$getSimil2 = _ac$getStore$getSimil.products,
        products = _ac$getStore$getSimil2 === undefined ? {} : _ac$getStore$getSimil2;

    if (!isEmpty(products)) {
        tracking.trackEcommerce({
            type: 'productImpression',
            products: Object.keys(products).map(function (id) {
                return Object.assign({}, products[id], {
                    list: LIST_SIMILAR_ITEMS
                });
            })
        });
    }
    done();
}

function trackSimilarItemClick(ac, _ref3, done) {
    var itemId = _ref3.itemId;

    if (typeof itemId === 'string') {
        var _ac$getStore$getSimil3 = ac.getStore(GalleryStore).getSimilarItemsTracking(),
            _ac$getStore$getSimil4 = _ac$getStore$getSimil3.products,
            products = _ac$getStore$getSimil4 === undefined ? {} : _ac$getStore$getSimil4;

        var product = products[itemId];

        if (typeof product !== 'undefined') {
            tracking.trackEcommerce({
                type: 'productClick',
                products: [product],
                actionField: {
                    list: LIST_SIMILAR_ITEMS
                }
            });
        }
    }
    done();
}

function updateCountOfItems(ac, payload, done) {
    var _ac$getStore$getSimil5 = ac.getStore(GalleryStore).getSimilarItemsTracking(),
        _ac$getStore$getSimil6 = _ac$getStore$getSimil5.countOfItems,
        countOfItems = _ac$getStore$getSimil6 === undefined ? 0 : _ac$getStore$getSimil6;

    tracking.addGTMMessage({ countOfItems: countOfItems });
    done();
}

function fireVPV(ac, payload, done) {
    var galleryStore = ac.getStore(GalleryStore);

    var _galleryStore$getSimi = galleryStore.getSimilarItemsTracking(),
        _galleryStore$getSimi2 = _galleryStore$getSimi.countOfItems,
        countOfItems = _galleryStore$getSimi2 === undefined ? 0 : _galleryStore$getSimi2;

    var firm = galleryStore.getPhotoFirm('urlLabel');
    var project = galleryStore.getPhotoProject('name', '').replace(/\s+/g, '-') // replace spaces with '-' for vpv
    .toLowerCase(); // lower case for vpv

    // update dataLayer object (before page view!)
    tracking.addGTMMessage(DATA_LAYER_SETTINGS);

    // fire pageview
    trackingHelpers.trackTradeProfilesVpv({
        page: 'gallery', firm: firm, project: project,
        customDimensions: { countOfItems: countOfItems }
    });

    done();
}

// (Note: ordering of these tracking events is important
//      for making sure events are associated with correct pages)
function fireVPVAndImpressions(ac, payload, done) {
    ac.executeAction(fireVPV);
    ac.executeAction(trackSimilarItemImpressions);
    done();
}

module.exports = {
    fireVPV: fireVPV,
    fireVPVAndImpressions: fireVPVAndImpressions,
    trackSimilarItemImpressions: trackSimilarItemImpressions,
    trackSimilarItemClick: trackSimilarItemClick,
    updateCountOfItems: updateCountOfItems,
    trackPhotoSwitch: trackPhotoSwitch,
    trackMobileZoom: trackMobileZoom,
    trackLinkClick: trackLinkClick,
    trackTooltipDisplayed: trackTooltipDisplayed,
    GA_LINK_TARGETS: GA_LINK_TARGETS
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var createWrapper = __webpack_require__(476),
    replaceHolders = __webpack_require__(501),
    restParam = __webpack_require__(274);

/** Used to compose bitmasks for wrapper metadata. */
var PARTIAL_FLAG = 32;

/**
 * Creates a `_.partial` or `_.partialRight` function.
 *
 * @private
 * @param {boolean} flag The partial bit flag.
 * @returns {Function} Returns the new partial function.
 */
function createPartial(flag) {
  var partialFunc = restParam(function(func, partials) {
    var holders = replaceHolders(partials, partialFunc.placeholder);
    return createWrapper(func, flag, undefined, partials, holders);
  });
  return partialFunc;
}

/**
 * Creates a function that invokes `func` with `partial` arguments prepended
 * to those provided to the new function. This method is like `_.bind` except
 * it does **not** alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method does not set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * var greet = function(greeting, name) {
 *   return greeting + ' ' + name;
 * };
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // using placeholders
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = createPartial(PARTIAL_FLAG);

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    /**
     * Calculates the angle for a given cartesian coordinate.
     * @method getPointAngle
     * @param  {Number} x - Point position on the X axis
     * @param  {Number} y - Point position on the Y axis
     * @return {Number} - Angle in degrees
     */
    getPointAngle: function getPointAngle(x, y) {
        var angle = Math.atan2(y, x) * (180 / Math.PI);

        if (angle < 0) {
            angle += 360;
        }

        return angle;
    },

    /**
     * Calculates the quadrant for a give angle.
     * @method getQuadrant
     * @param  {Number} angle - Angle in degrees from 0 to 360
     * @return {Number} - Quadrant from 0 to 3
     */
    getQuadrant: function getQuadrant(angle) {
        return Math.floor(angle / 90 % 4);
    }
};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(67),
    noop = _require.noop;

var _require2 = __webpack_require__(358),
    getTouchDistance = _require2.getTouchDistance,
    touchToCoordinates = _require2.touchToCoordinates;

var MultiTouchDetector = __webpack_require__(269);

var _require3 = __webpack_require__(302),
    createEnum = _require3.createEnum;

/**
 * Grab relevant state data from the passed in event.
 * @param  {Object} e Event
 * @return {Object}   State data
 */


function stateFromTouch(e) {
    var changedTouches = e.changedTouches,
        target = e.target;


    return {
        time: Date.now(),
        position: touchToCoordinates(target, changedTouches[0])
    };
}

// Maximum pixel distance of second tap from first tap.
var THRESHOLD_DISTANCE = 30;
// Maximum time in ms of second tap from first tap.
var THRESHOLD_TIME = 500;
// Maximum time in ms that a touch will count as a tap.
var THRESHOLD_HOLD_TIME = 100;

// State machine for keeping track of how many valid taps have occurred.
var stateEnum = createEnum({
    // Initial state before any taps
    ready: function ready() {},
    // One successful tap
    first: function first(data) {
        return data;
    },
    // Two successful taps
    second: function second(data) {
        return data;
    }
});

/**
 * Detect two quick, sequential taps on the given DOM element.
 *
 * @param {Object} options.el The DOM element.
 * @param {Function} [options.onDoubleTap] Callback to fire after a successful double tap.
 */

var DoubleTapDetector = function () {
    function DoubleTapDetector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el,
            _ref$onDoubleTap = _ref.onDoubleTap,
            onDoubleTap = _ref$onDoubleTap === undefined ? noop : _ref$onDoubleTap;

        _classCallCheck(this, DoubleTapDetector);

        if (!el) {
            throw new Error('Must pass `el` to DoubleTapDetector');
        }

        Object.assign(this, {
            _el: el,
            _onDoubleTap: onDoubleTap,
            _multiTouchDetector: new MultiTouchDetector({
                onSingleTouchStart: this._onSingleTouchStart.bind(this),
                onSingleTouchEnd: this._onSingleTouchEnd.bind(this),
                el: el
            })
        });

        // Set the initial state
        this._resetState();
    }

    _createClass(DoubleTapDetector, [{
        key: '_onSingleTouchStart',
        value: function _onSingleTouchStart(e) {
            var _this = this;

            var data = stateFromTouch(e);

            // transition to the next state after a tap
            this._state.match({
                ready: function ready() {
                    _this._state = stateEnum.first(data);
                    return _this._state;
                },
                first: function first() {
                    _this._state = stateEnum.second(data);
                    return _this._state;
                }
                // No need to handle "second" state here
            });
        }
    }, {
        key: '_onSingleTouchEnd',
        value: function _onSingleTouchEnd(e) {
            var _this2 = this;

            var endData = stateFromTouch(e);

            // Attempt to transition to the next state if the tap passes validation
            this._state.match({
                // No need to handle "ready" state here
                first: function first(data) {
                    return _this2._tryNextState(endData, data, function (newData) {
                        return _this2._handleFirstTap(newData);
                    });
                },
                second: function second(data) {
                    return _this2._tryNextState(endData, data, function (newData) {
                        return _this2._handleSecondTap(newData);
                    });
                }
            });
        }
    }, {
        key: '_resetState',
        value: function _resetState() {
            if (this._timer) {
                clearTimeout(this._timer);
            }

            this._timer = null;
            this._initialPosition = null;
            this._state = stateEnum.ready();
        }

        /**
         * Validate a tap after it ends and call the passed in callback if it passes.
         * @param  {Object}   endData   Data from previous tap
         * @param  {Object}   newData     Data from current tap
         * @param  {Function} callback  Callback to fire on successfuly validation
         */

    }, {
        key: '_tryNextState',
        value: function _tryNextState(endData, _ref2, callback) {
            var time = _ref2.time,
                position = _ref2.position;

            // Criteria for a successful tap:
            // The touch must not have been held for longer than THRESHOLD_HOLD_TIME
            // The touch must not have moved farther than THRESHOLD_DISTANCE
            if (endData.time - time > THRESHOLD_HOLD_TIME || getTouchDistance(endData.position, position) > THRESHOLD_DISTANCE) {
                this._resetState();
            } else {
                callback(endData);
            }
        }
    }, {
        key: '_handleFirstTap',
        value: function _handleFirstTap(data) {
            var _this3 = this;

            // Create a timer that expires if a second tap does not happen before THRESHOLD_TIME
            this._initialPosition = data.position;
            this._timer = setTimeout(function () {
                // If the timer finishes then start over because we didn't get a second tap in time.
                _this3._resetState();
            }, THRESHOLD_TIME);
        }
    }, {
        key: '_handleSecondTap',
        value: function _handleSecondTap(data) {
            var position = data.position;

            // Check if the second tap was within THRESHOLD_DISTANCE of the first tap

            if (getTouchDistance(position, this._initialPosition) > THRESHOLD_DISTANCE) {
                this._resetState();
            } else {
                this._onDoubleTap(position.x, position.y);
            }
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            clearTimeout(this._timer);
            this._multiTouchDetector.destroy();
        }
    }]);

    return DoubleTapDetector;
}();

module.exports = DoubleTapDetector;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(67),
    noop = _require.noop;

var MultiTouchDetector = __webpack_require__(269);

/**
 * Detect a "pan" (drag) on the given DOM element.
 * @param {Object} options.el The DOM element.
 * @param {Function} [options.onPan] Callback to fire on drag.
 */

var PanDetector = function () {
    function PanDetector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el,
            _ref$onPan = _ref.onPan,
            onPan = _ref$onPan === undefined ? noop : _ref$onPan;

        _classCallCheck(this, PanDetector);

        if (!el) {
            throw new Error('Must pass `el` to PanDetector');
        }

        Object.assign(this, {
            _previousX: null,
            _previousY: null,
            _el: el,
            _onPan: onPan,
            _multiTouchDetector: new MultiTouchDetector({
                onSingleTouchStart: this._onSingleTouchStart.bind(this),
                onSingleTouchMove: this._onSingleTouchMove.bind(this),
                el: el
            })
        });
    }

    _createClass(PanDetector, [{
        key: '_onSingleTouchStart',
        value: function _onSingleTouchStart(e) {
            var _e$touches$ = e.touches[0],
                clientX = _e$touches$.clientX,
                clientY = _e$touches$.clientY;

            // Get the initial position and time so we can do a difference on them later.

            this._previousX = clientX;
            this._previousY = clientY;
        }
    }, {
        key: '_onSingleTouchMove',
        value: function _onSingleTouchMove(e) {
            e.preventDefault();

            var _e$touches$2 = e.touches[0],
                clientX = _e$touches$2.clientX,
                clientY = _e$touches$2.clientY;

            // Pass the distance dragged to the callback

            this._onPan(clientX - this._previousX, clientY - this._previousY);

            this._previousX = clientX;
            this._previousY = clientY;
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this._multiTouchDetector.destroy();
        }
    }]);

    return PanDetector;
}();

module.exports = PanDetector;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(67),
    noop = _require.noop;

var _require2 = __webpack_require__(358),
    getTouchDistance = _require2.getTouchDistance,
    touchToCoordinates = _require2.touchToCoordinates;

var MultiTouchDetector = __webpack_require__(269);

function distanceFromTouches(e) {
    var target = e.target,
        touches = e.touches;


    return getTouchDistance(touchToCoordinates(target, touches[0]), touchToCoordinates(target, touches[1]));
}

/**
 * Detect a pinch on the given DOM element.
 * @param {Object} options.el The DOM element.
 * @param {Function} [options.onZoomIn] Callback to fire on zooming in.
 * @param {Function} [options.onZoomOut] Callback to fire on zooming out.
 */

var PinchDetector = function () {
    function PinchDetector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el,
            _ref$onZoomIn = _ref.onZoomIn,
            onZoomIn = _ref$onZoomIn === undefined ? noop : _ref$onZoomIn,
            _ref$onZoomOut = _ref.onZoomOut,
            onZoomOut = _ref$onZoomOut === undefined ? noop : _ref$onZoomOut;

        _classCallCheck(this, PinchDetector);

        if (!el) {
            throw new Error('Must pass `el` to PinchDetector');
        }

        Object.assign(this, {
            _previousDistance: null,
            _el: el,
            _onZoomIn: onZoomIn,
            _onZoomOut: onZoomOut,
            _multiTouchDetector: new MultiTouchDetector({
                onDoubleTouchStart: this._onDoubleTouchStart.bind(this),
                onDoubleTouchMove: this._onDoubleTouchMove.bind(this),
                el: el
            })
        });
    }

    _createClass(PinchDetector, [{
        key: '_onDoubleTouchStart',
        value: function _onDoubleTouchStart(e) {
            // Get the initial position and time so we can do a difference on them later.
            this._previousDistance = distanceFromTouches(e);
        }
    }, {
        key: '_onDoubleTouchMove',
        value: function _onDoubleTouchMove(e) {
            e.preventDefault();

            var distance = distanceFromTouches(e);
            var change = this._previousDistance - distance;
            var absChange = Math.abs(change);

            // Check if this is a zoom in or a zoom out based on the sign of the change and fire the appropriate callback.
            if (change < 0) {
                this._onZoomIn(absChange);
            } else {
                this._onZoomOut(absChange);
            }

            this._previousDistance = distance;
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this._multiTouchDetector.destroy();
        }
    }]);

    return PinchDetector;
}();

module.exports = PinchDetector;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  XmlEntities: __webpack_require__(465),
  Html4Entities: __webpack_require__(464),
  Html5Entities: __webpack_require__(359),
  AllHtmlEntities: __webpack_require__(359)
};


/***/ }),
/* 464 */
/***/ (function(module, exports) {

var HTML_ALPHA = ['apos', 'nbsp', 'iexcl', 'cent', 'pound', 'curren', 'yen', 'brvbar', 'sect', 'uml', 'copy', 'ordf', 'laquo', 'not', 'shy', 'reg', 'macr', 'deg', 'plusmn', 'sup2', 'sup3', 'acute', 'micro', 'para', 'middot', 'cedil', 'sup1', 'ordm', 'raquo', 'frac14', 'frac12', 'frac34', 'iquest', 'Agrave', 'Aacute', 'Acirc', 'Atilde', 'Auml', 'Aring', 'Aelig', 'Ccedil', 'Egrave', 'Eacute', 'Ecirc', 'Euml', 'Igrave', 'Iacute', 'Icirc', 'Iuml', 'ETH', 'Ntilde', 'Ograve', 'Oacute', 'Ocirc', 'Otilde', 'Ouml', 'times', 'Oslash', 'Ugrave', 'Uacute', 'Ucirc', 'Uuml', 'Yacute', 'THORN', 'szlig', 'agrave', 'aacute', 'acirc', 'atilde', 'auml', 'aring', 'aelig', 'ccedil', 'egrave', 'eacute', 'ecirc', 'euml', 'igrave', 'iacute', 'icirc', 'iuml', 'eth', 'ntilde', 'ograve', 'oacute', 'ocirc', 'otilde', 'ouml', 'divide', 'Oslash', 'ugrave', 'uacute', 'ucirc', 'uuml', 'yacute', 'thorn', 'yuml', 'quot', 'amp', 'lt', 'gt', 'oelig', 'oelig', 'scaron', 'scaron', 'yuml', 'circ', 'tilde', 'ensp', 'emsp', 'thinsp', 'zwnj', 'zwj', 'lrm', 'rlm', 'ndash', 'mdash', 'lsquo', 'rsquo', 'sbquo', 'ldquo', 'rdquo', 'bdquo', 'dagger', 'dagger', 'permil', 'lsaquo', 'rsaquo', 'euro', 'fnof', 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'eta', 'theta', 'iota', 'kappa', 'lambda', 'mu', 'nu', 'xi', 'omicron', 'pi', 'rho', 'sigma', 'tau', 'upsilon', 'phi', 'chi', 'psi', 'omega', 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'eta', 'theta', 'iota', 'kappa', 'lambda', 'mu', 'nu', 'xi', 'omicron', 'pi', 'rho', 'sigmaf', 'sigma', 'tau', 'upsilon', 'phi', 'chi', 'psi', 'omega', 'thetasym', 'upsih', 'piv', 'bull', 'hellip', 'prime', 'prime', 'oline', 'frasl', 'weierp', 'image', 'real', 'trade', 'alefsym', 'larr', 'uarr', 'rarr', 'darr', 'harr', 'crarr', 'larr', 'uarr', 'rarr', 'darr', 'harr', 'forall', 'part', 'exist', 'empty', 'nabla', 'isin', 'notin', 'ni', 'prod', 'sum', 'minus', 'lowast', 'radic', 'prop', 'infin', 'ang', 'and', 'or', 'cap', 'cup', 'int', 'there4', 'sim', 'cong', 'asymp', 'ne', 'equiv', 'le', 'ge', 'sub', 'sup', 'nsub', 'sube', 'supe', 'oplus', 'otimes', 'perp', 'sdot', 'lceil', 'rceil', 'lfloor', 'rfloor', 'lang', 'rang', 'loz', 'spades', 'clubs', 'hearts', 'diams'];
var HTML_CODES = [39, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 34, 38, 60, 62, 338, 339, 352, 353, 376, 710, 732, 8194, 8195, 8201, 8204, 8205, 8206, 8207, 8211, 8212, 8216, 8217, 8218, 8220, 8221, 8222, 8224, 8225, 8240, 8249, 8250, 8364, 402, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 977, 978, 982, 8226, 8230, 8242, 8243, 8254, 8260, 8472, 8465, 8476, 8482, 8501, 8592, 8593, 8594, 8595, 8596, 8629, 8656, 8657, 8658, 8659, 8660, 8704, 8706, 8707, 8709, 8711, 8712, 8713, 8715, 8719, 8721, 8722, 8727, 8730, 8733, 8734, 8736, 8743, 8744, 8745, 8746, 8747, 8756, 8764, 8773, 8776, 8800, 8801, 8804, 8805, 8834, 8835, 8836, 8838, 8839, 8853, 8855, 8869, 8901, 8968, 8969, 8970, 8971, 9001, 9002, 9674, 9824, 9827, 9829, 9830];

var alphaIndex = {};
var numIndex = {};

var i = 0;
var length = HTML_ALPHA.length;
while (i < length) {
    var a = HTML_ALPHA[i];
    var c = HTML_CODES[i];
    alphaIndex[a] = String.fromCharCode(c);
    numIndex[c] = a;
    i++;
}

/**
 * @constructor
 */
function Html4Entities() {}

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.decode = function(str) {
    if (str.length === 0) {
        return '';
    }
    return str.replace(/&(#?[\w\d]+);?/g, function(s, entity) {
        var chr;
        if (entity.charAt(0) === "#") {
            var code = entity.charAt(1).toLowerCase() === 'x' ?
                parseInt(entity.substr(2), 16) :
                parseInt(entity.substr(1));

            if (!(isNaN(code) || code < -32768 || code > 65535)) {
                chr = String.fromCharCode(code);
            }
        } else {
            chr = alphaIndex[entity];
        }
        return chr || s;
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encode = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var alpha = numIndex[str.charCodeAt(i)];
        result += alpha ? "&" + alpha + ";" : str.charAt(i);
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encodeNonUTF = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var cc = str.charCodeAt(i);
        var alpha = numIndex[cc];
        if (alpha) {
            result += "&" + alpha + ";";
        } else if (cc < 32 || cc > 126) {
            result += "&#" + cc + ";";
        } else {
            result += str.charAt(i);
        }
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encodeNonASCII = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        if (c <= 255) {
            result += str[i++];
            continue;
        }
        result += '&#' + c + ';';
        i++;
    }
    return result;
};

module.exports = Html4Entities;


/***/ }),
/* 465 */
/***/ (function(module, exports) {

var ALPHA_INDEX = {
    '&lt': '<',
    '&gt': '>',
    '&quot': '"',
    '&apos': '\'',
    '&amp': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': '\'',
    '&amp;': '&'
};

var CHAR_INDEX = {
    60: 'lt',
    62: 'gt',
    34: 'quot',
    39: 'apos',
    38: 'amp'
};

var CHAR_S_INDEX = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&apos;',
    '&': '&amp;'
};

/**
 * @constructor
 */
function XmlEntities() {}

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.encode = function(str) {
    if (str.length === 0) {
        return '';
    }
    return str.replace(/<|>|"|'|&/g, function(s) {
        return CHAR_S_INDEX[s];
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.decode = function(str) {
    if (str.length === 0) {
        return '';
    }
    return str.replace(/&#?[0-9a-zA-Z]+;?/g, function(s) {
        if (s.charAt(1) === '#') {
            var code = s.charAt(2).toLowerCase() === 'x' ?
                parseInt(s.substr(3), 16) :
                parseInt(s.substr(2));

            if (isNaN(code) || code < -32768 || code > 65535) {
                return '';
            }
            return String.fromCharCode(code);
        }
        return ALPHA_INDEX[s] || s;
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.encodeNonUTF = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        var alpha = CHAR_INDEX[c];
        if (alpha) {
            result += "&" + alpha + ";";
            i++;
            continue;
        }
        if (c < 32 || c > 126) {
            result += '&#' + c + ';';
        } else {
            result += str.charAt(i);
        }
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.encodeNonASCII = function(str) {
    var strLenght = str.length;
    if (strLenght === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLenght) {
        var c = str.charCodeAt(i);
        if (c <= 255) {
            result += str[i++];
            continue;
        }
        result += '&#' + c + ';';
        i++;
    }
    return result;
};

module.exports = XmlEntities;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var htmlparser = __webpack_require__(267);
var extend = __webpack_require__(429);
var quoteRegexp = __webpack_require__(421);

function each(obj, cb) {
  if (obj) Object.keys(obj).forEach(function (key) {
    cb(obj[key], key);
  });
}

// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function has(obj, key) {
  return ({}).hasOwnProperty.call(obj, key);
}

module.exports = sanitizeHtml;

// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105

function sanitizeHtml(html, options, _recursing) {
  var result = '';

  function Frame(tag, attribs) {
    var that = this;
    this.tag = tag;
    this.attribs = attribs || {};
    this.tagPosition = result.length;
    this.text = ''; // Node inner text

    this.updateParentNodeText = function() {
      if (stack.length) {
          var parentFrame = stack[stack.length - 1];
          parentFrame.text += that.text;
      }
    };
  }

  if (!options) {
    options = sanitizeHtml.defaults;
    options.parser = htmlParserDefaults;
  } else {
    options = extend(sanitizeHtml.defaults, options);
    if (options.parser) {
      options.parser = extend(htmlParserDefaults, options.parser);
    } else {
      options.parser = htmlParserDefaults;
    }
  }

  // Tags that contain something other than HTML, or where discarding
  // the text when the tag is disallowed makes sense for other reasons.
  // If we are not allowing these tags, we should drop their content too.
  // For other tags you would drop the tag but keep its content.
  var nonTextTagsArray = options.nonTextTags || [ 'script', 'style', 'textarea' ];
  var allowedAttributesMap;
  var allowedAttributesGlobMap;
  if(options.allowedAttributes) {
    allowedAttributesMap = {};
    allowedAttributesGlobMap = {};
    each(options.allowedAttributes, function(attributes, tag) {
      allowedAttributesMap[tag] = [];
      var globRegex = [];
      attributes.forEach(function(name) {
        if(name.indexOf('*') >= 0) {
          globRegex.push(quoteRegexp(name).replace(/\\\*/g, '.*'));
        } else {
          allowedAttributesMap[tag].push(name);
        }
      });
      allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
    });
  }
  var allowedClassesMap = {};
  each(options.allowedClasses, function(classes, tag) {
    // Implicitly allows the class attribute
    if(allowedAttributesMap) {
      if (!has(allowedAttributesMap, tag)) {
        allowedAttributesMap[tag] = [];
      }
      allowedAttributesMap[tag].push('class');
    }

    allowedClassesMap[tag] = classes;
  });

  var transformTagsMap = {};
  var transformTagsAll;
  each(options.transformTags, function(transform, tag) {
    var transFun;
    if (typeof transform === 'function') {
      transFun = transform;
    } else if (typeof transform === "string") {
      transFun = sanitizeHtml.simpleTransform(transform);
    }
    if (tag === '*') {
      transformTagsAll = transFun;
    } else {
      transformTagsMap[tag] = transFun;
    }
  });

  var depth = 0;
  var stack = [];
  var skipMap = {};
  var transformMap = {};
  var skipText = false;
  var skipTextDepth = 0;

  var parser = new htmlparser.Parser({
    onopentag: function(name, attribs) {
      if (skipText) {
        skipTextDepth++;
        return;
      }
      var frame = new Frame(name, attribs);
      stack.push(frame);

      var skip = false;
      var transformedTag;
      if (has(transformTagsMap, name)) {
        transformedTag = transformTagsMap[name](name, attribs);

        frame.attribs = attribs = transformedTag.attribs;

        if (transformedTag.text !== undefined) {
          frame.innerText = transformedTag.text;
        }

        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }
      if (transformTagsAll) {
        transformedTag = transformTagsAll(name, attribs);

        frame.attribs = attribs = transformedTag.attribs;
        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }

      if (options.allowedTags && options.allowedTags.indexOf(name) === -1) {
        skip = true;
        if (nonTextTagsArray.indexOf(name) !== -1) {
          skipText = true;
          skipTextDepth = 1;
        }
        skipMap[depth] = true;
      }
      depth++;
      if (skip) {
        // We want the contents but not this tag
        return;
      }
      result += '<' + name;
      if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap['*']) {
        each(attribs, function(value, a) {
          if (!allowedAttributesMap ||
              (has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 ) ||
              (allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1 ) ||
              (has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a)) ||
              (allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a))) {
            if ((a === 'href') || (a === 'src')) {
              if (naughtyHref(name, value)) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'class') {
              value = filterClasses(value, allowedClassesMap[name]);
              if (!value.length) {
                delete frame.attribs[a];
                return;
              }
            }
            result += ' ' + a;
            if (value.length) {
              result += '="' + escapeHtml(value) + '"';
            }
          } else {
            delete frame.attribs[a];
          }
        });
      }
      if (options.selfClosing.indexOf(name) !== -1) {
        result += " />";
      } else {
        result += ">";
      }
    },
    ontext: function(text) {
      if (skipText) {
        return;
      }
      var lastFrame = stack[stack.length-1];
      var tag;

      if (lastFrame) {
        tag = lastFrame.tag;
        // If inner text was set by transform function then let's use it
        text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
      }

      if ((tag === 'script') || (tag === 'style')) {
        // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
        // script tags is, by definition, game over for XSS protection, so if that's
        // your concern, don't allow them. The same is essentially true for style tags
        // which have their own collection of XSS vectors.
        result += text;
      } else {
        var escaped = escapeHtml(text);
        if (options.textFilter) {
          result += options.textFilter(escaped);
        } else {
          result += escaped;
        }
      }
      if (stack.length) {
           var frame = stack[stack.length - 1];
           frame.text += text;
      }
    },
    onclosetag: function(name) {

      if (skipText) {
        skipTextDepth--;
        if (!skipTextDepth) {
          skipText = false;
        } else {
          return;
        }
      }

      var frame = stack.pop();
      if (!frame) {
        // Do not crash on bad markup
        return;
      }
      skipText = false;
      depth--;
      if (skipMap[depth]) {
        delete skipMap[depth];
        frame.updateParentNodeText();
        return;
      }

      if (transformMap[depth]) {
        name = transformMap[depth];
        delete transformMap[depth];
      }

      if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
         result = result.substr(0, frame.tagPosition);
         return;
      }

      frame.updateParentNodeText();

      if (options.selfClosing.indexOf(name) !== -1) {
         // Already output />
         return;
      }

      result += "</" + name + ">";
    }
  }, options.parser);
  parser.write(html);
  parser.end();

  return result;

  function escapeHtml(s) {
    if (typeof(s) !== 'string') {
      s = s + '';
    }
    return s.replace(/\&/g, '&amp;').replace(/</g, '&lt;').replace(/\>/g, '&gt;').replace(/\"/g, '&quot;');
  }

  function naughtyHref(name, href) {
    // Browsers ignore character codes of 32 (space) and below in a surprising
    // number of situations. Start reading here:
    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
    href = href.replace(/[\x00-\x20]+/g, '');
    // Clobber any comments in URLs, which the browser might
    // interpret inside an XML data island, allowing
    // a javascript: URL to be snuck through
    href = href.replace(/<\!\-\-.*?\-\-\>/g, '');
    // Case insensitive so we don't get faked out by JAVASCRIPT #1
    var matches = href.match(/^([a-zA-Z]+)\:/);
    if (!matches) {
      // No scheme = no way to inject js (right?)
      return false;
    }
    var scheme = matches[1].toLowerCase();

    if (has(options.allowedSchemesByTag, name)) {
      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
    }

    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
  }

  function filterClasses(classes, allowed) {
    if (!allowed) {
      // The class attribute is allowed without filtering on this tag
      return classes;
    }
    classes = classes.split(/\s+/);
    return classes.filter(function(clss) {
      return allowed.indexOf(clss) !== -1;
    }).join(' ');
  }
}

// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish

var htmlParserDefaults = {
  decodeEntities: true
};
sanitizeHtml.defaults = {
  allowedTags: [ 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
    'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
    'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre' ],
  allowedAttributes: {
    a: [ 'href', 'name', 'target' ],
    // We don't currently allow img itself by default, but this
    // would make sense if we did
    img: [ 'src' ]
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: [ 'img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
  // URL schemes we permit
  allowedSchemes: [ 'http', 'https', 'ftp', 'mailto' ],
  allowedSchemesByTag: {}
};

sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
  merge = (merge === undefined) ? true : merge;
  newAttribs = newAttribs || {};

  return function(tagName, attribs) {
    var attrib;
    if (merge) {
      for (attrib in newAttribs) {
        attribs[attrib] = newAttribs[attrib];
      }
    } else {
      attribs = newAttribs;
    }

    return {
      tagName: newTagName,
      attribs: attribs
    };
  };
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encode = __webpack_require__(360);
var alphabet = __webpack_require__(283);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {

    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + encode(alphabet.lookup, version);
    str = str + encode(alphabet.lookup, clusterWorkerId);
    if (counter > 0) {
        str = str + encode(alphabet.lookup, counter);
    }
    str = str + encode(alphabet.lookup, seconds);

    return str;
}

module.exports = build;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(283);

/**
 * Decode the id to get the version and worker
 * Mainly for debugging and testing.
 * @param id - the shortid-generated id.
 */
function decode(id) {
    var characters = alphabet.shuffled();
    return {
        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
    };
}

module.exports = decode;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(283);
var encode = __webpack_require__(360);
var decode = __webpack_require__(468);
var build = __webpack_require__(467);
var isValid = __webpack_require__(470);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(473) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.decode = decode;
module.exports.isValid = isValid;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(283);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var characters = alphabet.characters();
    var len = id.length;
    for(var i = 0; i < len;i++) {
        if (characters.indexOf(id[i]) === -1) {
            return false;
        }
    }
    return true;
}

module.exports = isShortId;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

function randomByte() {
    if (!crypto || !crypto.getRandomValues) {
        return Math.floor(Math.random() * 256) & 0x30;
    }
    var dest = new Uint8Array(1);
    crypto.getRandomValues(dest);
    return dest[0] & 0x30;
}

module.exports = randomByte;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/*!
 * jquery.simpler-modal.js by Dale
 */
/**
 * Created with JetBrains PhpStorm.
 * User: daletan
 * Date: 10/11/12
 * Time: 10:54 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 * @namespace $.fn.dibsmodal
 * also includes $.fn.getViewport
 * to use - make sure the following scss file is included in your source:
 * bunsen/scss/modules/modal.scss
 */

(function (root, factory) {
    'use strict';
    if (true) {
        // CommonJS
        factory(module, root, __webpack_require__(5));
    } else {
        var m = {};
        // Browser globals
        factory(m, root, root.jQuery);

        // Don't need to put jQuery on root again.
        // root.jQuery = module.exports;
    }
}(typeof window === 'undefined' ? global : window, function (module, root, $) {

    'use strict';

    var document = root.document;

    // TODO: update all references to require the new bunsen/libraries/plugins/jquery.getViewport file
    $.fn.getViewport = $.fn.getViewport || function () {
        // $(window).height() is returning incorrect values
        var viewPortWidth;
        var viewPortHeight;
        viewPortWidth = root.innerWidth ||
            document.documentElement.clientWidth ||
            document.getElementsByTagName('body')[0].clientWidth;

        viewPortHeight = window.innerHeight ||
            document.documentElement.clientHeight ||
            document.getElementsByTagName('body')[0].clientHeight;

        return {
            'width': viewPortWidth,
            'height': viewPortHeight
        };
    };

    $.fn.dibsModal = $.fn.dibsModal || function (options) {
        return new Modal(options);
    };

    $.fn.dibsDialog = $.fn.dibsDialog || function (options) {
        return new Dialog(options);
    };

    // global.document.body.style.msTextCombineHorizontal: 11+ (http://stackoverflow.com/questions/18907131/detecting-ie11-using-css-properties)
    // global.document.documentMode: 7-10
    var isIE = (typeof document.body.style.msTextCombineHorizontal !== 'undefined') || !!document.documentMode;

    function Modal(opts) {
        var isOpen = false;
        var self = this;
        var $body = $('body');
        var $window = $(window);
         // used to keep track of modal content
        var storage = {};
        // current modal name
        var cName = '';
        // var $container;
        var $modalInnerContent;
        var $modalClose;
        var callBacks;
        var options;
        var classPrefix;
        var createMethods;

        self.$container = [];
        self.$modalContent = [];

        // callback functions
        callBacks = {
            'onClose': {}
        };
        options = $.extend(true, {
            // TODO: refactor all modal_ids references to modalIds
            modal_ids: {
                modal: 'modalOverlay',
                contentWrapper: 'modalOverlay-content-wrapper',
                content: 'modalOverlay-content',
                innerContent: 'modalOverlay-inner-content',
                close: 'modalOverlay-close',
                bg: 'modalOverlay-bg'
            },
            classPrefix: '',
            toggle : {
                mayClose : true
            },
            position: null
        }, opts);

        // TODO: really get this modal_ids stuff refactored to modalIds
        options.modalIds = $.extend(options.modal_ids, options.modalIds);

        if (options.classPrefix) {
            classPrefix = options.classPrefix;
        }

        createMethods = {
            addClassPrefix: function ($el, suffix) {
                if ($el && $el.length && classPrefix && suffix) {
                    $el.addClass(classPrefix + '-' + suffix);
                }
                return $el;
            },
            modal: function () {
                var id = options.modalIds.modal;
                var $modal = $body.find('#' + id);
                var $div;
                if (!$modal.length) {
                    $div = $(document.createElement('div'))
                        .attr('id', id)
                        .addClass('modal');
                    $div = this.addClassPrefix($div, 'modal');
                    $body.append($div);
                    $modal = $div;
                }
                self.$container = $modal;
                // = $container
                return this;
            },
            modalContent: function () {
                var contentWrapperId = options.modalIds.contentWrapper;
                var contentId = options.modalIds.content;
                var $contentWrapper;
                var $div;
                self.$modalContent = self.$container.find('#' + contentId);
                if (!self.$modalContent.length) {
                    $contentWrapper = $('<div>')
                        .attr('id', contentWrapperId)
                        .addClass('modal-content-wrapper');
                    $div = $(document.createElement('div'))
                        .attr('id', contentId)
                        .addClass('modal-content');
                    $div = this.addClassPrefix($div, 'modal-content');

                    self.$contentWrapper = $contentWrapper;
                    self.$modalContent = $div;

                    $contentWrapper.append($div);
                    self.$container.append($contentWrapper);
                }

                $modalInnerContent = this.modalInnerContent();
                $modalClose = this.modalClose();
                self.$modalContent.append($modalInnerContent, $modalClose);
                return this;
            },
            modalClose: function () {
                var closeId = options.modalIds.close;
                var $close;
                var $closeLink;
                $modalClose = self.$modalContent.find('#' + closeId);
                if (!$modalClose.length) {
                    $close = $(document.createElement('div'))
                        .attr('id', closeId)
                        .addClass('modal-close');
                    $closeLink = $(document.createElement('a'))
                        .attr({
                            id: 'modalOverlay-close-btn',
                            href: '#close-modal'
                        })
                        .addClass('modal-close-btn');
                    $close = this.addClassPrefix($close, 'modal-close');
                    $closeLink = this.addClassPrefix($closeLink, 'modal-close-btn');
                    $closeLink.append(this.closeButton());
                    $close.html($closeLink);
                    $modalClose = $close;
                }
                if (!options.toggle.mayClose) {
                    $modalClose.hide();
                }
                return $modalClose;
            },
            modalInnerContent: function () {
                var innerContentId = options.modalIds.innerContent;
                $modalInnerContent = self.$modalContent.find('#' + innerContentId);
                if (!$modalInnerContent.length) {
                    $modalInnerContent = $(document.createElement('div'))
                        .attr('id', innerContentId)
                        .addClass('modal-inner-content');
                    $modalInnerContent = this.addClassPrefix($modalInnerContent, 'modal-inner-content');
                }
                return $modalInnerContent;
            },
            closeButton: function () {
                var $icon;
                $icon = $('<i>', {
                    'class': 'bunsen-icon bunsen-icon-close pua-icon' + (classPrefix ? ' ' + classPrefix + '-icon-close' : '')
                });

                return $icon;
            }
        };

        this.options = options;

        this.getPosition = function () {
            return options.position;
        };

        this.getBgId = function () {
            return options.modalIds.bg;
        };

        this.getBody = function () {
            return $body;
        };

        /**
         * Store a copy of the modal UI ($content) under a key name
         * @param {string} name The key to store the modal $content in
         * @param {object} $content jQuery dom element
         * @returns {Modal}
         */
        this.update = function (name, $content) {
            // set current modal name
            cName = name;
            if (!storage[name]) {
                storage[name] = !$content ? storage[name] : $content;
            } else if (name && $content) {
                // update the stored object with new $content
                storage[name] = $content;
            }
            $modalInnerContent.html(storage[name]);
            $.publish('modal:update', [self, self.$modalContent]);
            return this;
        };

        /**
         * Opens up a modal
         * @param eventName {String} Optional. The event to fire, otherwise defaults to "modal:show"
         * @returns {*}
         */
        this.show = function (eventName) {
            this.preventScrolling();
            isOpen = true;
            self.$container.addClass(cName).show();
            self.center();
            $.publish((eventName || 'modal:show'), [self, self.$modalContent]);
            return this;
        };

        this.hideModal = function () {
            self.$container.hide();
        };

        this.showModal = function () {
            self.$container.show();
        };

        this.check = function (name) {
            return !!storage[name];
        };

        this.close = function (e) {
            if (e) {
                e.preventDefault();
            }
            // Allow page scrolling
            if (this.enableScrolling) {
                this.enableScrolling();
            }

            self.$container.hide().removeClass(cName);
            if (callBacks.onClose[cName]) {
                callBacks.onClose[cName]();
            }
            isOpen = false;
            cName = '';
            return false;
        };

        this.enableClose = function () {
            options.toggle.mayClose = true;
            $modalClose.show();
            return this;
        };

        this.disableClose = function () {
            $modalClose.hide();
            options.toggle.mayClose = false;
            return this;
        };

        this.onClose = function (name, callback) {
            callBacks.onClose[name] = callback;
        };

        this.check = function (name) {
            return storage[name];
        };

        function init() {
            createMethods.modal().modalContent();
            self.modalBg();
            self.$container.on('click', '#modalOverlay-close-btn', function (e) {
                $.publish('modal:close', e);
                return false;
            });
            $.subscribe('modal:close', function (e) {
                if (!options.toggle.mayClose) {
                    $.publish('modal:close:prevented', e);
                    return;
                }
                self.close(e);
            });
        }

        function checkScrollBar() {
            var outer = $('<div class="modal-measure-scrollbar" />').prependTo($body);
            var inner = $('<div class="inner" />').appendTo(outer);
            var width = outer.width() - inner.width();
            outer.remove();

            if (width > 0) {
                var css = '.modal-open #header .header-wrap { max-width:' + ($('#page').width() + width) + 'px;} .modal-open, .modal-open #header .header-search-box, .modal-open #header #toggleNavSearch { margin-right: ' + width + 'px; }';
                $('head').append('<style type="text/css">' + css + '</style>');
            }
        }

        $window.bind({
            resize: function () {
                self.center();
            },
            keyup: function (e) { // use keyCode for x-browser
                if (!isOpen) {
                    return;
                }
                if (e.keyCode === 27) { // escape
                    $.publish('modal:close', e);
                }
            }
        });

        checkScrollBar();
        init();

        return this;
    }

    Modal.fn = Modal.prototype;

    Modal.fn.center = function () {
        var h = this.$modalContent.height();
        var winH = $.fn.getViewport().height;
        var top = (winH - h) / 2;
        if (top < 0) {
            top = 0;
        }
        this.$modalContent.css('top', top);
        this.$container.css('position', 'fixed');
    };
    Modal.fn.modalBg = function () {
        var bgId = this.getBgId();
        var $container = this.$container;
        var $modalBg = $container.find('#' + bgId);
        if (!$modalBg.length) {
            var $div = $(document.createElement('div'))
                .attr('id', bgId)
                .addClass('modal-bg');
            $modalBg = $div;
            $container.append($div);
        }
        $modalBg.bind('click', function (e) {
            e.preventDefault();
            $.publish('modal:close', e);
        });
        return this;
    };
    Modal.fn.preventScrolling = function () {
        var ids = this.options.modalIds;
        var bgId = ids.bg;
        var $content = $("#" + ids.content);
        var $innerContent = $("#" + ids.innerContent);

        this.getBody().addClass('modal-open')
            .on("touchmove.modal-scroll", function (e) {
                //don't allow scrolling for touch devices
                if ($innerContent.height() > $content.height()) {
                    //but do allow divs inside modal to scroll
                    if (e.target.id === bgId) {
                        e.preventDefault();
                    }
                    //also do not allow page to scroll behind modal when scrollable div reaches limit
                    if ($content.scrollTop() === 0) {
                        $content.scrollTop(1);
                    } else if ($content.scrollTop() + $content.innerHeight() === $content[0].scrollHeight) {
                        $content[0].scrollTop -= 1;
                    }
                } else {
                    //don't allow any scrolling at all if modal doesn't scroll
                    //unless it has an inner list which needs to scroll
                    if ($(e.target).parents(".alpha-modal-lists-wrapper").length === 0) {
                        e.preventDefault();
                    }
                }
            });
    };
    Modal.fn.enableScrolling = function () {
        this.getBody().removeClass('modal-open').off("touchmove.modal-scroll");
    };

    function Dialog(opts) {
        Modal.call(this, opts);
    }

    Dialog.fn = Dialog.prototype = new Modal();
    Dialog.fn.center = function () {
        var top;
        var left;
        var elementPosition;
        var rightOverlap;
        var verticalOffset = 10;
        var position = this.getPosition();

        // if jquery element passed in, use it to position the dialog
        // jQuery = $
        if (position instanceof $) {
            // start at element position
            elementPosition = position.offset();
            top = elementPosition.top;
            left = elementPosition.left;
            // horizontally center dialog at element
            left += (position.width() / 2);
            left -= (this.$modalContent.width() / 2);
            // do not allow dialog to overlap right edge of screen
            rightOverlap = left + this.$modalContent.width() - $.fn.getViewport().width;
            if (rightOverlap > 0) {
                left -= rightOverlap;
            }
            // do not allow dialog to overlap left edge of screen
            if (left < 0) {
                left = 0;
            }
            // find vertical position above element
            top = top - this.$modalContent.height();
            top -= verticalOffset;
            // if above position of off screen, position below element
            if (top < $(window).scrollTop()) {
                top = elementPosition.top;
                top += position.height();
                top += verticalOffset;
            }
            // ie hack. ugh..
            if (isIE) {
                left -= 15;
            }

            // if top & left offsets passed in, use them
        } else if (position && position.top && position.left) {
            top = position.top;
            left = position.left;
        }

        if (top !== undefined && left !== undefined) {
            this.$modalContent.css('top', top);
            this.$modalContent.css('left', left);
            this.$container.css('position', 'static');
            this.$modalContent.css('position', 'absolute');
        }
    };
    Dialog.fn.modalBg = function () {
        var $modalBg = this.$container.find('#' + this.getBgId());
        // if unique id is not set for modal, background from another modal on page may exist
        if ($modalBg.length) {
            $modalBg.remove();
        }
        this.$modalContent.addClass('is-dialog');
        return this;
    };
    Dialog.fn.preventScrolling = function () {
        // do nothing - we do not want to prevent scrolling for dialogs
    };

    module.exports = Modal;

}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(69)(module)))

/***/ }),
/* 475 */,
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var root = __webpack_require__(278);

/** Used to compose bitmasks for wrapper metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_BOUND_FLAG = 4,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64,
    ARY_FLAG = 128,
    FLIP_FLAG = 512;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  var length = args.length;
  switch (length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = -1,
      result = [];

  while (++index < length) {
    if (array[index] === placeholder) {
      array[index] = PLACEHOLDER;
      result[++resIndex] = index;
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(prototype) {
    if (isObject(prototype)) {
      object.prototype = prototype;
      var result = new object;
      object.prototype = undefined;
    }
    return result || {};
  };
}());

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array|Object} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders) {
  var holdersLength = holders.length,
      argsIndex = -1,
      argsLength = nativeMax(args.length - holdersLength, 0),
      leftIndex = -1,
      leftLength = partials.length,
      result = Array(leftLength + argsLength);

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    result[holders[argsIndex]] = args[argsIndex];
  }
  while (argsLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array|Object} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders) {
  var holdersIndex = -1,
      holdersLength = holders.length,
      argsIndex = -1,
      argsLength = nativeMax(args.length - holdersLength, 0),
      rightIndex = -1,
      rightLength = partials.length,
      result = Array(argsLength + rightLength);

  while (++argsIndex < argsLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    result[offset + holders[holdersIndex]] = args[argsIndex++];
  }
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBaseWrapper(func, bitmask, thisArg) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtorWrapper(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtorWrapper(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors.
    // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurryWrapper(func, bitmask, arity) {
  var Ctor = createCtorWrapper(func);

  function wrapper() {
    var length = arguments.length,
        index = length,
        args = Array(length),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func,
        placeholder = wrapper.placeholder;

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    return length < arity
      ? createRecurryWrapper(func, bitmask, createHybridWrapper, placeholder, undefined, args, holders, undefined, undefined, arity - length)
      : apply(fn, this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & ARY_FLAG,
      isBind = bitmask & BIND_FLAG,
      isBindKey = bitmask & BIND_KEY_FLAG,
      isCurry = bitmask & CURRY_FLAG,
      isCurryRight = bitmask & CURRY_RIGHT_FLAG,
      isFlip = bitmask & FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtorWrapper(func);

  function wrapper() {
    var length = arguments.length,
        index = length,
        args = Array(length);

    while (index--) {
      args[index] = arguments[index];
    }
    if (partials) {
      args = composeArgs(args, partials, holders);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight);
    }
    if (isCurry || isCurryRight) {
      var placeholder = wrapper.placeholder,
          argsHolders = replaceHolders(args, placeholder);

      length -= argsHolders.length;
      if (length < arity) {
        return createRecurryWrapper(func, bitmask, createHybridWrapper, placeholder, thisArg, args, argsHolders, argPos, ary, arity - length);
      }
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && args.length > 1) {
      args.reverse();
    }
    if (isAry && ary < args.length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtorWrapper(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg` and the `partials` prepended to those provided to
 * the wrapper.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartialWrapper(func, bitmask, thisArg, partials) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtorWrapper(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder to replace.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & CURRY_FLAG,
      newArgPos = argPos ? copyArray(argPos) : undefined,
      newsHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

  if (!(bitmask & CURRY_BOUND_FLAG)) {
    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
  }
  var result = wrapFunc(func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, arity);

  result.placeholder = placeholder;
  return result;
}

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask of wrapper flags.
 *  The bitmask may be composed of the following flags:
 *     1 - `_.bind`
 *     2 - `_.bindKey`
 *     4 - `_.curry` or `_.curryRight` of a bound function
 *     8 - `_.curry`
 *    16 - `_.curryRight`
 *    32 - `_.partial`
 *    64 - `_.partialRight`
 *   128 - `_.rearg`
 *   256 - `_.ary`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] == null
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == BIND_FLAG) {
    var result = createBaseWrapper(func, bitmask, thisArg);
  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
    result = createCurryWrapper(func, bitmask, arity);
  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
    result = createPartialWrapper(func, bitmask, thisArg, partials);
  } else {
    result = createHybridWrapper.apply(undefined, newData);
  }
  return result;
}

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array constructors, and
  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This function is loosely based on [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3');
 * // => 3
 */
function toInteger(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  var remainder = value % 1;
  return value === value ? (remainder ? value - remainder : value) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3);
 * // => 3
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3');
 * // => 3
 */
function toNumber(value) {
  if (isObject(value)) {
    var other = isFunction(value.valueOf) ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = createWrapper;


/***/ }),
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ContactUIStore = __webpack_require__(94);
var ContactMessageStore = __webpack_require__(96);
var ContactTransactionStore = __webpack_require__(104);
var gaActions = __webpack_require__(505);
var Transaction = __webpack_require__(20);
var Transactions = __webpack_require__(1015);
var TransactionValidator = __webpack_require__(127);

var _require = __webpack_require__(29),
    Deferred = _require.Deferred;

var checkoutRedirects = __webpack_require__(339);
var contains = __webpack_require__(812);

var actions = module.exports = {
    editOfferField: function editOfferField(actionContext, payload) {
        if (payload.calculateAmountOff) {
            actionContext.dispatch('contact:form:lowball:options:offer', payload);
        }
        actionContext.dispatch('contact:offer:fieldEdited', payload);
    },


    /**
     *  Validates the transaction in the ContactTransactionStore.
     *
     *  @param payload.bypassLowball {bool}
     *  @param payload.showLowballOptions {bool}
     *  @param payload.source {string}
     *  @returns {array}
     */
    validateOffer: function validateOffer(actionContext, payload) {
        var _actionContext$getSto = actionContext.getStore(ContactUIStore).state,
            copyText = _actionContext$getSto.copyText,
            user = _actionContext$getSto.user;

        var _actionContext$getSto2 = actionContext.getStore(ContactTransactionStore),
            transaction = _actionContext$getSto2.transaction,
            offer = _actionContext$getSto2.offer;

        var item = transaction.get('item');
        var validator = new TransactionValidator({ copyText: copyText || payload.copyText });
        var errors = validator.validate(transaction).errors;
        var isTrade = user && user.isVerifiedTradeBuyer() && item && item.isFurniture();
        if (!errors.length && !payload.bypassLowball) {
            if (validator.validateLowball(transaction, { isTrade: isTrade })) {
                if (payload.showLowballOptions) {
                    actionContext.dispatch('contact:form:lowball:options:init', {
                        offerAmount: offer.get('amountPerItem.amount')
                    });
                }
                actionContext.dispatch('contact:form:lowBall:show');
                errors.push({
                    field: 'lowball',
                    message: copyText.get('offerLowballLabel')
                });
            }
        }
        if (errors.length) {
            gaActions.eventOfferError(actionContext, {
                source: payload.source,
                errorMessage: errors[0].message
            });
        }
        actionContext.dispatch('PDP_CONTACT_FORM_ERRORS', { errors: errors });
        return errors;
    },
    prepareOffer: function prepareOffer(actionContext) {
        // TODO: no longer send message when when notes are no longer used
        var message = actionContext.getStore(ContactMessageStore).message;
        actionContext.dispatch('contact:form:offer:valid', { message: message });
    },


    /**
     *  Submits an offer
     *
     *  @param payload.bypassLowball {object}
     *  @returns {Deferred}
     */
    offer: function offer(actionContext, payload) {
        actions.prepareOffer(actionContext);
        var transaction = actionContext.getStore(ContactTransactionStore).transaction;
        var state = actionContext.getStore(ContactUIStore).state;
        transaction.unset('shipment');
        var sendToOmtOnSuccess = state.sendToOmtOnSuccess;
        var existingTransactionId = void 0;
        return transaction.save().then(function () {
            return gaActions.eventOfferSuccess(actionContext, { isOfferLow: payload.bypassLowball });
        }, function (xhr) {
            var itemId = transaction.get('item.id');
            var userId = state.user.get('id');
            var sendToOmtErrors = [Transaction.ERROR_EXISTING_TRANSACTION, Transaction.ERROR_DUPLICATE_ORDER];
            if (xhr.responseJSON && contains(sendToOmtErrors, xhr.responseJSON.serviceResponseCode)) {
                return Transactions.fetchExistingActiveOffersAndOrders(itemId, userId).then(function (existingTransactions) {
                    if (existingTransactions.length) {
                        existingTransactionId = existingTransactions.first().id;
                        sendToOmtOnSuccess = true;
                    }
                });
            }
            return undefined;
        }).then(function () {
            if (!sendToOmtOnSuccess) {
                return { offerSent: true };
            }
            checkoutRedirects.goToOMT(existingTransactionId);
            return Deferred();
        });
    },


    /**
     *  Submits an offer for pre-negotiations 2.0
     *
     *  @param payload.lowballOptions {bool}
     *  @returns {Deferred}
     */
    offerPreN2: function offerPreN2(actionContext) {
        actions.prepareOffer(actionContext);

        var _actionContext$getSto3 = actionContext.getStore(ContactTransactionStore),
            transaction = _actionContext$getSto3.transaction,
            offer = _actionContext$getSto3.offer;

        var message = actionContext.getStore(ContactMessageStore).message;
        gaActions.eventOfferSuccessPreN2WithLowballOptions(actionContext, {
            offerAmount: offer.get('amountPerItem.amount')
        });
        offer.redirectToCheckout({
            message: message.get('textBody'),
            item: transaction.get('item')
        });

        // return pending deferred so no further action is taken
        return Deferred();
    },
    lowBallChange: function lowBallChange(actionContext) {
        actionContext.dispatch('contact:form:lowBall:hide');
    }
};

/***/ }),
/* 481 */,
/* 482 */,
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: British Carter
 * Date: 3/1/16
 * Time: 6:51 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var strings = __webpack_require__(376);

var FEET = 12;
var DEFAULT_FEET_CUTOFF = 48;
var LOWER_FEET_CUTOFF = 24;

var measurements = {
    inch: {
        toCm: function toCm(x) {
            return x * 2.54;
        },
        toFeet: function toFeet(x, feetCutOff) {

            var ret = void 0;
            var feet = void 0;
            var inches = void 0;
            var realFeet = void 0;

            feetCutOff = feetCutOff || 48;

            if (x < feetCutOff) {
                ret = x + '"';
            } else {
                realFeet = x / FEET;
                ret = realFeet + "'";
                if (realFeet % 1 !== 0) {
                    feet = Math.floor(realFeet);
                    inches = Math.round((realFeet - feet) * FEET);
                    ret = feet + "' " + inches + '"';
                }
            }
            return ret;
        }
    },
    cm: {
        toInch: function toInch(x) {
            return x * 0.3937;
        }
    },
    feet: {
        toInch: function toInch(x) {
            var ret = 0;
            // looking for single quote
            var ftIndex = x.indexOf("'");
            // looking for double quote
            var inchIndex = x.indexOf('"');
            var ft = void 0;
            var inch = void 0;
            if (ftIndex !== -1) {
                ft = parseInt(x.substring(0, ftIndex), 10);
                ret += ft * FEET;
            }

            if (inchIndex !== -1) {
                inch = parseInt(x.substring(ftIndex + 1, inchIndex), 10);
                ret += inch;
            }
            return ret;
        },
        toLongForm: function toLongForm(x) {
            return x.replace("'", " ft. ").replace('"', " in.");
        },
        toShortForm: function toShortForm(x) {
            return x.replace(" ft. ", "'").replace(" in.", '"');
        }
    }
};

/**
 * Converts a value into either a number or a string with the appropriate
 * measurement values
 * @param {number|string} num The value to convert from a number > measurement
 * @param {string} [to] Type of value to convert x to ("cm", "inches")
 *                      Note: for measurement conversions, to field is converted to "toX" format to increase
 *                      readability of measurement object
 *                      i.e. if to arg = "cm" the key for look-up in the measurement object will
 *                      be converted to "toCm"
 * @param {string} [from] Type of value to convert x from
 *                        |"inch" to "cm"
 *                        |"feet", "cm" to "inch", "feet" to "long_form").
 * @returns {String}
 */

function convert(options) {
    var num = undefined;
    var from = undefined;
    var to = undefined;
    var feetCutOff = undefined;

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
        num = options.num;
        from = options.from;
        to = options.to;
        feetCutOff = options.feetCutOff;
    } else {
        // original signature
        num = arguments[0];
        from = arguments[1];
        to = arguments[2];
    }

    if (!num && typeof num !== 'number') {
        return num;
    }

    to = to || "number";
    from = from || "currency";

    to = 'to' + strings.capitalize(to);
    if (typeof measurements[from][to] === "function") {
        num = measurements[from][to](num, feetCutOff);
        if (typeof num === "number") {
            num = Math.round(num * 100) / 100;
        }
    }
    return num;
}

module.exports = {
    convert: convert,
    DEFAULT_FEET_CUTOFF: DEFAULT_FEET_CUTOFF,
    LOWER_FEET_CUTOFF: LOWER_FEET_CUTOFF
};

/***/ }),
/* 484 */,
/* 485 */,
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 3/12/16
 * Time: 8:57 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classNames = __webpack_require__(16);
var styles = __webpack_require__(394);

/**
 * @param {object} props
 * @param {string} [props.additionalOverlayClasses]
 * @param {string} [props.additionalSpinnerClasses]
 * @param {string} [props.position="isFixed"] Accepts `isAbsolute`, `isStatic`, defaults to `isFixed`
 * @returns
 * @constructor
 */
var Overlay = function Overlay() {
    var _classNames2, _classNames3;

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var additionalWrapperClasses = props.additionalWrapperClasses,
        additionalOverlayClasses = props.additionalOverlayClasses,
        additionalSpinnerClasses = props.additionalSpinnerClasses,
        _props$position = props.position,
        position = _props$position === undefined ? "isFixed" : _props$position;

    var wrapperClasses = classNames(_defineProperty({
        'overlay-spinner-wrapper': true
    }, additionalWrapperClasses, !!additionalWrapperClasses));
    var overlayClasses = classNames((_classNames2 = {}, _defineProperty(_classNames2, styles.spinnerWrapper, styles.spinnerWrapper), _defineProperty(_classNames2, 'ajax-overlay', true), _defineProperty(_classNames2, additionalOverlayClasses, !!additionalOverlayClasses), _classNames2));
    var spinnerClasses = classNames((_classNames3 = {}, _defineProperty(_classNames3, styles.spinner, styles.spinner), _defineProperty(_classNames3, 'tn-overlaySpinner', true), _defineProperty(_classNames3, additionalSpinnerClasses, !!additionalSpinnerClasses), _defineProperty(_classNames3, styles[position], !!position), _classNames3));
    return React.createElement(
        'div',
        { className: wrapperClasses },
        React.createElement('div', { className: overlayClasses }),
        React.createElement('div', { className: spinnerClasses, 'data-tn': 'loading-check' })
    );
};

Overlay.propTypes = {
    additionalWrapperClasses: PropTypes.string,
    additionalOverlayClasses: PropTypes.string,
    additionalSpinnerClasses: PropTypes.string,
    position: PropTypes.string
};

module.exports = Overlay;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classnames = __webpack_require__(16);
var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var inViewport = __webpack_require__(600);
var scrollIntoView = __webpack_require__(584);
var SanitizeHtml = __webpack_require__(296);
var ContextComponent = __webpack_require__(61);
var ArrowRightIcon = __webpack_require__(351);
var style = __webpack_require__(634);

var Tooltip = __webpack_require__(270);
__webpack_require__(272);

var tradeTourActions = __webpack_require__(734);

var Tour = function (_ContextComponent) {
    _inherits(Tour, _ContextComponent);

    function Tour(props) {
        _classCallCheck(this, Tour);

        var _this = _possibleConstructorReturn(this, (Tour.__proto__ || Object.getPrototypeOf(Tour)).call(this, props));

        _this.onClose = _this.onClose.bind(_this);
        _this.onCtaClick = _this.onCtaClick.bind(_this);

        var isOpen = props.isTourOpen && props.step === props.currentStep;

        _this.state = {
            isOpen: isOpen,
            isVisible: isOpen
        };
        return _this;
    }

    _createClass(Tour, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var isOpen = this.state.isOpen;


            if (isOpen) {
                this.onOpen();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var step = nextProps.step,
                currentStep = nextProps.currentStep,
                isTourOpen = nextProps.isTourOpen;


            if (isTourOpen && step === currentStep) {
                this.setState({ isOpen: true });
                this._showTour();
            } else {
                this.setState({ isVisible: false });
                this._closeTour();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!prevState.isOpen && this.state.isOpen) {
                this.onOpen();
            }
        }
    }, {
        key: 'onOpen',
        value: function onOpen() {
            var _props = this.props,
                type = _props.type,
                subType = _props.subType,
                step = _props.step,
                onOpen = _props.onOpen;

            onOpen({ type: type, subType: subType, step: step });
        }
    }, {
        key: '_notInView',
        value: function _notInView() {
            return this._tourStep && !inViewport(this._tourStep);
        }
    }, {
        key: '_showTour',
        value: function _showTour() {
            var _this2 = this;

            var duration = this.props.duration;

            var timeout = 0;

            if (this._notInView()) {
                scrollIntoView(this._tourStep, { time: duration });
                timeout = duration;
            }

            this._clearTimeouts();
            this._timeout = setTimeout(function () {
                return _this2.setState({ isVisible: true });
            }, timeout);
        }
    }, {
        key: '_closeTour',
        value: function _closeTour() {
            var _this3 = this;

            var duration = this.props.duration;

            this._clearTimeouts();
            this._timeout = setTimeout(function () {
                return _this3.setState({ isOpen: false });
            }, duration ? 200 : 0);
        }
    }, {
        key: '_clearTimeouts',
        value: function _clearTimeouts() {
            clearTimeout(this._timeout);
        }
    }, {
        key: 'onClose',
        value: function onClose(event) {
            event.preventDefault();
            var _props2 = this.props,
                type = _props2.type,
                subType = _props2.subType,
                step = _props2.step,
                onClose = _props2.onClose;

            this.context.executeAction(tradeTourActions.closeTour, { type: type });
            onClose({ type: type, subType: subType, step: step });
        }
    }, {
        key: 'onCtaClick',
        value: function onCtaClick(event) {
            event.preventDefault();

            var _props3 = this.props,
                type = _props3.type,
                subType = _props3.subType,
                step = _props3.step,
                totalSteps = _props3.totalSteps,
                onCtaClick = _props3.onCtaClick;

            var action = void 0;

            if (step === totalSteps) {
                action = tradeTourActions.closeTour;
            } else {
                action = tradeTourActions.increaseStep;
            }

            this.context.executeAction(action, { type: type });
            onCtaClick({ type: type, subType: subType, step: step });
        }
    }, {
        key: 'getSvgArrow',
        value: function getSvgArrow(hasNext) {
            if (hasNext) {
                return React.createElement(ArrowRightIcon, { className: 'button-icon' });
            }

            return null;
        }
    }, {
        key: 'getCancel',
        value: function getCancel(copy) {
            if (copy.cancel) {
                return React.createElement(
                    'a',
                    { className: style.cancel, onClick: this.onClose, href: '#0' },
                    copy.cancel
                );
            }

            return null;
        }
    }, {
        key: 'getCopy',
        value: function getCopy() {
            var _props4 = this.props,
                step = _props4.step,
                copy = _props4.copy,
                subType = _props4.subType;

            var stepCopy = copy['step' + step];

            return stepCopy && stepCopy[subType] || stepCopy || {};
        }
    }, {
        key: 'getHeader',
        value: function getHeader(copy) {
            if (copy.header) {
                return React.createElement(
                    'div',
                    { className: style.header },
                    React.createElement(SanitizeHtml, { content: copy.header })
                );
            }

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                isOpen = _state.isOpen,
                isVisible = _state.isVisible;
            var _props5 = this.props,
                step = _props5.step,
                totalSteps = _props5.totalSteps,
                className = _props5.className,
                duration = _props5.duration,
                type = _props5.type,
                dataTn = _props5.dataTn;

            var copy = this.getCopy();
            var hasNext = step < totalSteps;
            var ctaClassName = classnames('button-primary button-small', style.cta, {
                'has-icon-right': hasNext
            });
            var tooltipClassName = classnames(style.tooltip, _defineProperty({}, style.visible, isVisible));

            var ctaWrapperClass = classnames(style.ctaWrapper, _defineProperty({}, style.hasCancel, copy.cancel));

            return React.createElement(
                'span',
                {
                    ref: function ref(tourStep) {
                        _this4._tourStep = tourStep;
                    },
                    className: style.wrapper + ' ' + className,
                    'data-tn': 'tour-' + dataTn
                },
                this.props.children,
                React.createElement(
                    Tooltip,
                    {
                        isVisible: isOpen,
                        'data-tn': 'tour-tooltip-' + type,
                        className: tooltipClassName,
                        containerClass: style.container,
                        tooltipDirection: 'left',
                        hasClose: true,
                        debounce: this._notInView() ? duration : 0,
                        closeClass: style.close,
                        onCloseClick: this.onClose
                    },
                    this.getHeader(copy),
                    React.createElement(
                        'div',
                        { className: style.step },
                        React.createElement(SanitizeHtml, { content: copy.step })
                    ),
                    React.createElement(
                        'div',
                        { className: style.content },
                        React.createElement(SanitizeHtml, { content: copy.content })
                    ),
                    React.createElement(
                        'div',
                        { className: ctaWrapperClass },
                        this.getCancel(copy),
                        React.createElement(
                            'a',
                            { className: ctaClassName, onClick: this.onCtaClick, href: '#0' },
                            copy.cta,
                            this.getSvgArrow(hasNext)
                        )
                    )
                )
            );
        }
    }]);

    return Tour;
}(ContextComponent);

Tour.propTypes = {
    copy: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    step: PropTypes.number.isRequired,
    isTourOpen: PropTypes.bool.isRequired,
    currentStep: PropTypes.number.isRequired,
    totalSteps: PropTypes.number.isRequired,
    duration: PropTypes.number,

    className: PropTypes.string,
    children: PropTypes.node,

    dataTn: PropTypes.string.isRequired,

    onCtaClick: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

Tour.defaultProps = {
    className: '',
    duration: 1000,
    onCtaClick: function onCtaClick() {},
    onOpen: function onOpen() {},
    onClose: function onClose() {}
};

module.exports = Tour;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(53))(108);

/***/ }),
/* 489 */,
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = __webpack_require__(605);

/**
 * Creates a memoize-less selector. The reason of using this instead of the default
 * `createSelector` for now is that with our current codebase we cannot guarantee
 * that we're using immutable data on each input which ruins object/array equality
 * checks we can do as a comparison.
 *
 * There's still benefits of creating selectors though (i.e. increased readability),
 * and this createSelector can also be tuned for increased performance by using a
 * more efficient memoize cache. See https://github.com/medikoo/memoizee for example
 */
exports.default = (0, _reselect.createSelectorCreator)(function (func) {
  return function () {
    return func.apply(undefined, arguments);
  };
});

/***/ }),
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-pinterest'].join(' '), viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M130.7,2C63.6,2,29.9,50,29.9,90c0,24.3,9.2,45.8,28.9,53.7c3.3,1.3,6.2,0,7.1-3.5c0.8-2.5,2.1-8.9,2.9-11.4 c1-3.5,0.8-4.8-2.1-7.7c-5.6-6.7-9.4-15.4-9.4-27.7c0-35.6,26.6-67.6,69.5-67.6c37.9,0,58.7,23.1,58.7,53.9 c0,40.8-17.9,74.9-44.9,74.9c-14.6,0-25.8-12.1-22.1-27c4.2-17.9,12.5-37,12.5-50.1c0-11.7-6.2-21.2-19.1-21.2 c-15,0-27.2,15.8-27.2,36.6c0,13.3,4.6,22.3,4.6,22.3s-15.6,65.5-18.1,76.8c-5.2,22.7-0.8,50.7-0.6,53.5c0.2,1.7,2.3,2.1,3.3,0.8 c1.3-1.9,19.5-24.1,25.6-46.2c1.7-6.2,9.8-38.9,9.8-38.9c4.8,9.4,19.3,17.5,34.5,17.5c45.3,0,76.1-41.2,76.1-96.7 C220,40.7,184.6,2,130.7,2z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(525);



/***/ }),
/* 500 */,
/* 501 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = -1,
      result = [];

  while (++index < length) {
    if (array[index] === placeholder) {
      array[index] = PLACEHOLDER;
      result[++resIndex] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var TemplateView; // required after export is defined to avoid circular dependency
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var normalizeToView = module.exports = function (options) {
    // TODO: test this
    var view;
    var constructorOptions;
    var defaultParentElement;
    var newContent;
    var useDefaultParentElement;
    if (undefined === options.content && !options.Constructor) {
        throw new Error("normalizeToView requires options.Constructor if options.content is missing");
    }
    options = $.extend({
        defaultParentElement: undefined,
        defaultContext: undefined,
        defaultTemplateVars: undefined,
        content: undefined,
        Constructor: TemplateView
    }, options);
    if (false === options.content) {
        return false;
    }
    if (options.content instanceof $) {
        options.content = options.content.get(0);
        view = new Backbone.View({el: options.content});
    }
    // content can't be jQuery below this line
    if (options.content instanceof global.HTMLElement) {
        view = new Backbone.View({el: options.content});
    }
    if (options.content && options.content.hasOwnProperty('el')) { // assume it's a backbone-style view if it has an `el` property
        view = options.content;
    }
    if (options.content instanceof Function) {
        defaultParentElement = undefined;
        if (options.defaultParentElement) {
            defaultParentElement = $(options.defaultParentElement).get(0);
        }
        newContent = options.content.call(options.defaultContext, defaultParentElement);
        if (!newContent) {
            return newContent;
        }
        view = normalizeToView(_.extend({}, options, {content: newContent}));
    }
    if (!view && options.Constructor) {
        constructorOptions = options.content;
        useDefaultParentElement = true;
        if (options.Constructor && _.result(options.Constructor.prototype.template, 'useInnerElement')) {
            useDefaultParentElement = false;
        }
        if (_.result(constructorOptions, 'useInnerElement')) {
            useDefaultParentElement = false;
        }
        if (useDefaultParentElement) {
            constructorOptions = _.extend({el: options.defaultParentElement}, constructorOptions);
        }
        if (options.Constructor.prototype.templateVars === TemplateView.prototype.templateVars && !constructorOptions.templateVars && !constructorOptions.model) {
            constructorOptions = _.extend({templateVars: options.defaultTemplateVars}, constructorOptions);
        }
        view = new options.Constructor(constructorOptions);
    }
    return view;
};
TemplateView = __webpack_require__(544);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dotControls":"arrowStyles__dotControls__16md7","dotWrapper":"arrowStyles__dotWrapper__3Of_L","dot":"arrowStyles__dot__3EdFv","current":"arrowStyles__current__1a1Fl","buyer":"arrowStyles__buyer__1YKvO","trade":"arrowStyles__trade__1nWCr","dotCarouselWrapper":"arrowStyles__dotCarouselWrapper__62_SD","clear":"arrowStyles__clear__39TNC"};

/***/ }),
/* 504 */,
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ContactUIStore = __webpack_require__(94);
var ContactGaStore = __webpack_require__(110);
var ContactMessageStore = __webpack_require__(96);
var PurchaseTracking = __webpack_require__(458);
var tracking = __webpack_require__(27);
var currencyUtil = __webpack_require__(62);
var undefined = void 0;

var actions = module.exports = {
    eventOfferEnable: function eventOfferEnable(actionContext) {
        var data = actionContext.getStore(ContactGaStore).data;

        // Tracking (E-commerce + make offer click)
        // Note: E-commerce tracking must precede event tracking
        new PurchaseTracking({
            item: data.item
        }).ecommerceAddToCartTracking();
        tracking.trackEvent({
            category: 'make offer click',
            action: 'contact dealer modal',
            label: data.purchaseStatus
        });
    },
    eventOfferSuccess: function eventOfferSuccess(actionContext, _ref) {
        var isOfferLow = _ref.isOfferLow;

        tracking.trackEvent({
            category: 'make offer form interaction',
            action: 'offer initiated',
            label: isOfferLow ? 'below asking price' : 'within range'
        });
    },
    eventOfferSuccessPreN2: function eventOfferSuccessPreN2(actionContext, _ref2) {
        var isOfferLow = _ref2.isOfferLow;

        tracking.trackEvent({
            category: 'make offer form interaction',
            action: 'continue offer',
            label: isOfferLow ? 'below asking price' : 'within range'
        });
    },
    eventOfferSuccessPreN2WithLowballOptions: function eventOfferSuccessPreN2WithLowballOptions(actionContext, _ref3) {
        var offerAmount = _ref3.offerAmount;
        var _actionContext$getSto = actionContext.getStore(ContactUIStore).state,
            selectedLowballOption = _actionContext$getSto.selectedLowballOption,
            priceValue = _actionContext$getSto.priceValue;

        var isOther = false;
        var isOriginalOffer = false;
        var percentage = void 0;
        if (selectedLowballOption) {
            isOther = selectedLowballOption.isOther;
            isOriginalOffer = selectedLowballOption.isOriginalOffer;
            percentage = 100 - selectedLowballOption.percentOff;
        } else {
            var offerValue = currencyUtil.parseFloat(offerAmount);
            percentage = offerValue / priceValue * 100;
        }
        var labelPartOne = selectedLowballOption && !isOriginalOffer ? 'revised' : 'initial';
        var labelPartTwo = !selectedLowballOption || isOther ? 'custom' : 'preset';
        var bucket = void 0;
        if (percentage === 100) {
            bucket = '100%';
        } else if (percentage > 90 && percentage < 100) {
            bucket = '91-99%';
        } else if (percentage > 80 && percentage <= 90) {
            bucket = '81-90%';
        } else if (percentage > 70 && percentage <= 80) {
            bucket = '71-80%';
        } else if (percentage > 60 && percentage <= 70) {
            bucket = '61-70%';
        } else if (percentage > 50 && percentage <= 60) {
            bucket = '51-60%';
        } else if (percentage > 40 && percentage <= 50) {
            bucket = '41-50%';
        } else if (percentage > 30 && percentage <= 40) {
            bucket = '31-40%';
        } else if (percentage > 20 && percentage <= 30) {
            bucket = '21-30%';
        } else if (percentage > 10 && percentage <= 20) {
            bucket = '11-20%';
        } else {
            bucket = '1-10%';
        }
        tracking.trackEvent({
            category: 'make offer form interaction',
            action: 'continue offer',
            label: labelPartOne + '|' + labelPartTwo + '|' + bucket
        });
    },
    eventOfferError: function eventOfferError(actionContext, _ref4) {
        var errorMessage = _ref4.errorMessage,
            source = _ref4.source;

        tracking.trackEvent({
            category: 'form error',
            action: 'make offer|' + source + ' form|offer amount',
            label: errorMessage
        });
    },
    eventLaunch: function eventLaunch(actionContext) {
        tracking.trackEvent(Object.assign(actions.contactDealerBaseOptions(actionContext), {
            action: 'contact dealer clicked'
        }));
    },
    eventContactSuccess: function eventContactSuccess(actionContext, _ref5) {
        var isOptIn = _ref5.isOptIn;

        var baseOptions = actions.contactDealerBaseOptions(actionContext);
        var options = {
            action: 'contact dealer submitted',
            value: isOptIn ? 1 : 0
        };
        if (actionContext.getStore(ContactGaStore).data.linkLocation === 'finding') {
            options.label = 'contact link in results – request price button';
        }
        tracking.trackEvent(Object.assign({}, baseOptions, options));
    },
    eventSend: function eventSend(actionContext) {
        var baseOptions = actions.contactDealerBaseOptions(actionContext);
        var isOfferEnabled = actionContext.getStore(ContactUIStore).state.isOfferEnabled;

        var options = {
            action: 'contact dealer send clicked',
            value: isOfferEnabled ? 1 : 0
        };
        if (actionContext.getStore(ContactGaStore).data.linkLocation === 'finding') {
            options.label = 'contact link in results – request price button';
        }
        tracking.trackEvent(Object.assign({}, baseOptions, options));
    },
    netPriceEventSend: function netPriceEventSend(actionContext) {
        new PurchaseTracking({
            pageContext: 'pdp',
            item: actionContext.getStore(ContactMessageStore).message.get('item')
        }).trackNetPriceEvent({ actionSuffix: 'submitted' });
    },
    pageView: function pageView(actionContext, _ref6) {
        var isSuccess = _ref6.isSuccess;

        var data = actionContext.getStore(ContactGaStore).data;
        var urlEnd = (isSuccess ? 'complete' : 'form') + '-' + (data.isItem ? 'item' : 'general');
        var url = ['', 'vpv', 'contact-dealer', urlEnd, ''].join('/') + '?' + data.vpvParamsQuery;

        // this prevents re-firing of any ecommerce events that already happened
        tracking.addGTMMessage({ ecommerce: undefined });
        tracking.trackPageview({
            url: url,
            additional: {
                pageType: 'Other',
                pageSubType: 'Contact Dealer Modal'
            }
        });
    },
    contactDealerBaseOptions: function contactDealerBaseOptions(actionContext) {
        var data = actionContext.getStore(ContactGaStore).data;
        return {
            category: 'contact dealer',
            label: data.linkLocation
        };
    },


    constants: {
        contactFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'contact dealer confirmation modal'
        },

        netPriceFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'net price confirmation modal'
        },

        offerFollowDealerParams: {
            category: 'dealer favoriting',
            action: 'dealer added',
            label: 'make offer confirmation modal'
        },

        contactOmtLinkParams: {
            category: 'contact dealer',
            action: 'contact dealer form interaction',
            label: 'view offer in bomt'
        },

        netPriceOmtLinkParams: {
            category: 'net price',
            action: 'net price form interaction',
            label: 'view offer in bomt'
        },

        offerOmtLinkParams: {
            category: 'make offer form interaction',
            action: 'view offer in bomt'
        }
    }
};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tracking = __webpack_require__(27);
var SV = __webpack_require__(17);
var get = __webpack_require__(14);

function getSVTrackingData(query, subType) {
    return SV.get(query + '.' + subType) || SV.get(query);
}

function track(_ref) {
    var type = _ref.type,
        subType = _ref.subType,
        step = _ref.step,
        trackAction = _ref.action;

    var _ref2 = getSVTrackingData('tourCopy.' + type + '.tracking', subType) || {},
        category = _ref2.category,
        action = _ref2.action;

    var label = get(getSVTrackingData('tourCopy.' + type + '.step' + step, subType), 'tracking.' + trackAction);

    if (category && action && label) {
        tracking.trackEvent({ category: category, action: action, label: label });
    }
}

var tourTracking = {
    trackOpen: function trackOpen(payload) {
        var action = 'open';
        track(Object.assign({ action: action }, payload));
    },
    trackClose: function trackClose(payload) {
        var action = 'close';
        track(Object.assign({ action: action }, payload));
    },
    trackCta: function trackCta(payload) {
        var action = 'cta';
        track(Object.assign({ action: action }, payload));
    },
    trackComplete: function trackComplete(payload) {
        var action = 'complete';
        track(Object.assign({ action: action }, payload));
    }
};

module.exports = tourTracking;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Object.freeze({
    components: {
        dimensions: 'dimensions',
        materialsAndTechniques: 'materialsAndTechniques',
        multiline: 'multiline',
        versions: 'versions'
    },
    title: {
        dealerReference: 'shared.dealerReference'
    },
    availableNow: 'Available Now'
});

/***/ }),
/* 508 */,
/* 509 */,
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var SV = __webpack_require__(17);
var cookies = __webpack_require__(514);

function getAdminUserData() {
    return SV.get('userData');
};

function getSellerData() {
    return SV.get('sellerData');
};

/**
 * Returns either a sellerToken or userToken depending on who is currently logged in.
 * @returns {String} The token for the currently logged in user.
 */
module.exports = function getToken() {
    var token;
    var tokenObj = {};
    var userData = getAdminUserData();
    var sellerData = getSellerData();
    var cookieToken = cookies.get('userToken');

    if (typeof window === 'undefined') {
        return {};
    }

    //Set user token for masquerade
    if (sellerData && userData) {
        token = cookieToken ? cookieToken : userData.token;
        tokenObj.userToken = token;
    //Be extra sure we only send the sellerToken when we're on an Admin page
    } else if (sellerData) {
        token = sellerData.token;
        tokenObj.sellerToken = token;
    } else if (cookieToken) {
        token = cookieToken;
        tokenObj.userToken = token;
    }
    return token ? tokenObj : null;
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-arrow-up'].join(' '), viewBox: '0 -8.5 32 32' },
                React.createElement('path', { d: 'M0,14c0-0.3,0.1-0.6,0.3-0.8l15-13c0.4-0.3,0.9-0.3,1.3,0l15,13c0.4,0.4,0.5,1,0.1,1.4 c-0.4,0.4-1,0.5-1.4,0.1L16,2.3L1.7,14.7c-0.4,0.4-1,0.3-1.4-0.1C0.1,14.4,0,14.2,0,14z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

var tracking = __webpack_require__(27);

var GalleryStore = __webpack_require__(357);
var GalleryModalStore = __webpack_require__(548);

var galleryActions = __webpack_require__(363);

function setupStoreWithServerVars(ac, payload, done) {
    ac.dispatch('gallery-modal:setup-store', payload);
    done();
}

function fetchGalleryTemplate(ac, payload, done) {
    var galleryStore = ac.getStore(GalleryStore);
    var galleryUrl = galleryStore.getFetchModalFullUrl(payload);

    fetch(galleryUrl).then(function (response) {
        return response.text();
    }).then(function (template) {
        ac.dispatch('gallery-modal:fetched', { template: template });
        done();
    }).catch(function () {
        ac.dispatch('gallery-modal:hide');
        done();
    });
}

function conditionallyFetchCurrentPhotoGalleryTemplate(ac, _ref, done) {
    _objectDestructuringEmpty(_ref);

    if (ac.getStore(GalleryModalStore).shouldFetchTemplate()) {

        ac.executeAction(fetchGalleryTemplate, {
            galleryUrl: ac.getStore(GalleryStore).getCurrentPhotoUrl()
        }, done);
    }
}

function fireOriginalVPV(ac, payload, done) {
    var galleryModalStore = ac.getStore(GalleryModalStore);

    // Need to reset the dataLayer (before page view!)
    tracking.addGTMMessage(Object.assign({}, galleryModalStore.getOriginalDataLayerInfo(), {
        countOfItems: null
    }));

    tracking.trackPageview({
        url: galleryModalStore.getOriginalVPVString()
    });
    done();
}

function showModal(ac, payload, done) {
    ac.dispatch('gallery-modal:show');
    ac.executeAction(conditionallyFetchCurrentPhotoGalleryTemplate);
    done();
}

function hideModal(ac, payload, done) {
    ac.dispatch('gallery-modal:hide');
    ac.executeAction(fireOriginalVPV);
    ac.executeAction(galleryActions.showDetailsMobile, { showDetails: false });
    done();
}

function resetModal(ac, payload, done) {
    ac.dispatch('gallery-modal:reset');
    done();
}

module.exports = {
    setupStoreWithServerVars: setupStoreWithServerVars,
    fetchGalleryTemplate: fetchGalleryTemplate,
    conditionallyFetchCurrentPhotoGalleryTemplate: conditionallyFetchCurrentPhotoGalleryTemplate,
    showModal: showModal,
    hideModal: hideModal,
    resetModal: resetModal
};

/***/ }),
/* 513 */,
/* 514 */
/***/ (function(module, exports) {

exports.defaults = {};

exports.set = function(name, value, options) {
  // Retrieve options and defaults
  var opts = options || {};
  var defaults = exports.defaults;

  // Apply default value for unspecified options
  var expires  = opts.expires  || defaults.expires;
  var domain   = opts.domain   || defaults.domain;
  var path     = opts.path     !== undefined ? opts.path     : (defaults.path !== undefined ? defaults.path : '/');
  var secure   = opts.secure   !== undefined ? opts.secure   : defaults.secure;
  var httponly = opts.httponly !== undefined ? opts.httponly : defaults.httponly;

  // Determine cookie expiration date
  // If succesful the result will be a valid Date, otherwise it will be an invalid Date or false(ish)
  var expDate = expires ? new Date(
      // in case expires is an integer, it should specify the number of days till the cookie expires
      typeof expires === 'number' ? new Date().getTime() + (expires * 864e5) :
      // else expires should be either a Date object or in a format recognized by Date.parse()
      expires
  ) : '';

  // Set cookie
  document.cookie = name.replace(/[^+#$&^`|]/g, encodeURIComponent)                // Encode cookie name
  .replace('(', '%28')
  .replace(')', '%29') +
  '=' + value.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) +                  // Encode cookie value (RFC6265)
  (expDate && expDate.getTime() >= 0 ? ';expires=' + expDate.toUTCString() : '') + // Add expiration date
  (domain   ? ';domain=' + domain : '') +                                          // Add domain
  (path     ? ';path='   + path   : '') +                                          // Add path
  (secure   ? ';secure'           : '') +                                          // Add secure option
  (httponly ? ';httponly'         : '');                                           // Add httponly option
};

exports.get = function(name) {
  var cookies = document.cookie.split(';');

  // Iterate all cookies
  for(var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var cookieLength = cookie.length;

    // Determine separator index ("name=value")
    var separatorIndex = cookie.indexOf('=');

    // IE<11 emits the equal sign when the cookie value is empty
    separatorIndex = separatorIndex < 0 ? cookieLength : separatorIndex;

    var cookie_name = decodeURIComponent(cookie.substring(0, separatorIndex).replace(/^\s+/, ''));

    // Return cookie value if the name matches
    if (cookie_name === name) {
      return decodeURIComponent(cookie.substring(separatorIndex + 1, cookieLength));
    }
  }

  // Return `null` as the cookie was not found
  return null;
};

exports.erase = function(name, options) {
  exports.set(name, '', {
    expires:  -1,
    domain:   options && options.domain,
    path:     options && options.path,
    secure:   0,
    httponly: 0}
  );
};

exports.all = function() {
  var all = {};
  var cookies = document.cookie.split(';');

  // Iterate all cookies
  for(var i = 0; i < cookies.length; i++) {
	  var cookie = cookies[i];
    var cookieLength = cookie.length;

	  // Determine separator index ("name=value")
	  var separatorIndex = cookie.indexOf('=');

	  // IE<11 emits the equal sign when the cookie value is empty
	  separatorIndex = separatorIndex < 0 ? cookieLength : separatorIndex;

    // add the cookie name and value to the `all` object
	  var cookie_name = decodeURIComponent(cookie.substring(0, separatorIndex).replace(/^\s+/, ''));
	  all[cookie_name] = decodeURIComponent(cookie.substring(separatorIndex + 1, cookieLength));
	}

  return all;
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Stringify = __webpack_require__(558);
var Parse = __webpack_require__(557);

module.exports = {
    stringify: Stringify,
    parse: Parse
};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(390),
    SwipeDetector = _require.SwipeDetector;

var BaseModel = __webpack_require__(335);

var _require2 = __webpack_require__(341),
    setTransformStyle = _require2.setTransformStyle,
    setTransitionStyle = _require2.setTransitionStyle,
    getTotalPages = _require2.getTotalPages,
    getPagedItemWidth = _require2.getPagedItemWidth,
    pageChangeTypeEnum = _require2.pageChangeTypeEnum,
    setWidthStyle = _require2.setWidthStyle;

var _require3 = __webpack_require__(67),
    noop = _require3.noop;

// The transition effect to use when the swipe occurs.


var TRANSITION = 'transform 250ms ease';
// The amount to slow down the dragging effect by when the user reaches the end of the list.
var SLOW_DOWN_FACTOR = 2.5;

function normalizePage(page, totalPages) {
    // If the requested page is less than 0, only go to the first page.
    if (page < 0) {
        page = 0;
    }

    // If the requested page is greater than the last page, only go to the last page.
    if (page >= totalPages) {
        page = totalPages - 1;
    }

    return page;
}

/**
 * View-model for carousels that are swiped through on a touch device.
 * @class
 */

var SwipeModel = function (_BaseModel) {
    _inherits(SwipeModel, _BaseModel);

    function SwipeModel() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            itemsPerPage = _ref.itemsPerPage,
            itemWidth = _ref.itemWidth,
            itemCount = _ref.itemCount,
            isCentered = _ref.isCentered,
            _ref$onPageChange = _ref.onPageChange,
            onPageChange = _ref$onPageChange === undefined ? noop : _ref$onPageChange,
            _ref$startingPage = _ref.startingPage,
            startingPage = _ref$startingPage === undefined ? 0 : _ref$startingPage,
            onStateChange = _ref.onStateChange;

        _classCallCheck(this, SwipeModel);

        var _this = _possibleConstructorReturn(this, (SwipeModel.__proto__ || Object.getPrototypeOf(SwipeModel)).call(this, { onStateChange: onStateChange }));

        var totalPages = getTotalPages(itemCount, itemsPerPage);

        Object.assign(_this, {
            _itemsPerPage: itemsPerPage,
            _itemCount: itemCount,
            _totalPages: totalPages,
            _onPageChange: onPageChange,
            _isCentered: isCentered,
            // Calculate the width of each item.
            _width: itemWidth || getPagedItemWidth(itemsPerPage),
            _swipeDetector: null,
            _state: {
                page: normalizePage(startingPage, totalPages),
                // Track the position of the items when dragging through the list.
                offset: 0,
                // Track whether we should use the transition effect during a given render.
                transition: true,
                disabled: false
            }
        });
        return _this;
    }

    _createClass(SwipeModel, [{
        key: 'enableSwipe',
        value: function enableSwipe() {
            this._state.disabled = false;
        }
    }, {
        key: 'disableSwipe',
        value: function disableSwipe() {
            this._state.disabled = true;
        }

        /**
         * Implement the `_afterMount` method from the `BaseModel`.
         */

    }, {
        key: '_afterMount',
        value: function _afterMount() {
            // Add swipe handlers.
            this._swipeDetector = new SwipeDetector({
                onPartialSwipe: this._updateOffset.bind(this),
                onSwipeSuccess: this._swipe.bind(this),
                onSwipeFailure: this._resetOffset.bind(this),
                el: this._el
            });
        }

        /**
         * Implement the `destroy` method from the `BaseModel`.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            // The swipe detector adds event listeners so we need to destroy it to prevent memory leaks.
            this._swipeDetector.destroy();
        }

        /**
         * The `_offset` is used to track the "panning" that happens when the user drags the carousel before the full swipe occurs
         *
         * @returns {object}
         */

    }, {
        key: '_getTransformValue',
        value: function _getTransformValue() {
            var fullContainerWidth = 100; // 100% - swipe carousel uses percentages for animations
            var percentage = -this._width * Math.floor(this._itemsPerPage) * this._state.page;

            // isCentered determines whether the carousel items are centered or aligned left
            // when itemWidth prop is set to less than 100
            if (this._isCentered) {
                percentage += (fullContainerWidth - this._width) / 2;
            }

            // Last page
            if (this._isLastPage() && this._itemsPerPage !== 1) {
                percentage = -this._width * this._itemCount + fullContainerWidth;
            }

            return percentage + '% + ' + this._state.offset + 'px';
        }

        /**
         * Implement the `transformListStyle` method from the `BaseModel`.
         */

    }, {
        key: 'transformListStyle',
        value: function transformListStyle(style) {
            var transformValue = this._getTransformValue();

            setTransformStyle(style, 'translateX(calc(' + transformValue + '))');

            // When the user is just "panning" we don't want to have a transition effect.
            if (this._state.transition) {
                setTransitionStyle(style, TRANSITION);
            }
        }

        /**
         * Implement the `transformItemStyle` method from the `BaseModel`.
         */

    }, {
        key: 'transformItemStyle',
        value: function transformItemStyle(style) {
            setWidthStyle(style, this._width);
        }

        /**
         * Update the position of the carousels in response to "drag/pan" by the user.
         * @param {Array} touchCords Array consisting of the touch coordinates [x, y], passed from the `SwipeDetector`.
         * @param {SwipeDirectionType} direction The swipe direction.
         */

    }, {
        key: '_updateOffset',
        value: function _updateOffset(touchCords, direction) {
            // We don't wanna move the carousel when the user is swiping vertically
            if (this._state.disabled || direction.isUp() || direction.isDown()) {
                return;
            }

            var xOffset = touchCords[0];

            if (this._isLastPage() && direction.isLeft() || this._isFirstPage() && direction.isRight()) {
                // If we've reached either end of the list, slow down the dragging effect to indicate to the user that they
                // can't continue.
                xOffset = xOffset / SLOW_DOWN_FACTOR;
            }

            this._state.transition = false;
            this._state.offset = xOffset;
            this._onStateChange();
        }

        /**
         * Call in response to a complete swipe.
         * @param  {SwipeDirectionType} direction The swipe direction.
         */

    }, {
        key: '_swipe',
        value: function _swipe(direction) {
            if (this._state.disabled) {
                return;
            }

            if (direction.isLeft()) {
                this._nextPage();
            } else if (direction.isRight()) {
                this._previousPage();
            }
        }

        /**
         * Unset the "drag" offset and go back to the initial page position.
         */

    }, {
        key: '_resetOffset',
        value: function _resetOffset() {
            if (this._state.disabled) {
                return;
            }

            this._state.transition = true;
            this._state.offset = 0;

            this._updateState();
        }

        /**
         * Set the new page. Handles bounds issues by going staying on either the first or last page.
         * @param {Number} page The page to go to.
         * @param {PageChangeType} type The type of the page change.
         */

    }, {
        key: '_setPage',
        value: function _setPage(page, type) {
            page = normalizePage(page, this._totalPages);

            // Only update if the page actually changed.
            if (page !== this._state.page) {
                this._state.transition = true;
                this._state.offset = 0;
                var previous = this._state.page;
                this._state.page = page;
                this._onPageChange(page, type, previous);
                this._updateState();
            }
        }

        /**
         * Return the total number of pages.
         * @return {Number}
         */

    }, {
        key: 'getTotalPages',
        value: function getTotalPages() {
            return this._totalPages;
        }

        /**
         * Go to the specified page.
         */

    }, {
        key: 'jumpToPage',
        value: function jumpToPage(page) {
            this._setPage(page, pageChangeTypeEnum.jump());
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: 'canPaginate',
        value: function canPaginate() {
            return this.getTotalPages() > 1;
        }

        /**
         * Go to the next page.
         */

    }, {
        key: '_nextPage',
        value: function _nextPage() {
            // If we are already on the last page, just stay there.
            if (this._isLastPage()) {
                this._resetOffset();
                return;
            }

            this._setPage(this._state.page + 1, pageChangeTypeEnum.next());
        }

        /**
         * Go to the previous page.
         */

    }, {
        key: '_previousPage',
        value: function _previousPage() {
            // If we are already on the first page, just stay there.
            if (this._isFirstPage()) {
                this._resetOffset();
                return;
            }

            this._setPage(this._state.page - 1, pageChangeTypeEnum.previous());
        }

        /**
         * Check if we are currently on the first page.
         * @return {Boolean}
         */

    }, {
        key: '_isFirstPage',
        value: function _isFirstPage() {
            return this._state.page === 0;
        }

        /**
         * Check if we are currently on the last page.
         * @return {Boolean}
         */

    }, {
        key: '_isLastPage',
        value: function _isLastPage() {
            return this._state.page === this._totalPages - 1;
        }
    }]);

    return SwipeModel;
}(BaseModel);

module.exports = SwipeModel;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);

var _require = __webpack_require__(67),
    noop = _require.noop;

var SwipeModel = __webpack_require__(520);
var BaseCarousel = __webpack_require__(364);
var DotCarousel = __webpack_require__(392);

/**
 * Represents a carousel with that the user can swipe through on a touch device.
 * @class
 */

var SwipeCarousel = function (_React$Component) {
    _inherits(SwipeCarousel, _React$Component);

    function SwipeCarousel(props) {
        _classCallCheck(this, SwipeCarousel);

        // Dummy state. State is held in the `_model` but this is necessary to force a re-render when the model updates.
        var _this = _possibleConstructorReturn(this, (SwipeCarousel.__proto__ || Object.getPrototypeOf(SwipeCarousel)).call(this, props));

        _this.state = {
            modelState: {}
        };
        return _this;
    }

    _createClass(SwipeCarousel, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            this._model = new SwipeModel({
                itemsPerPage: this.props.itemsPerPage,
                itemWidth: this.props.itemWidth,
                isCentered: this.props.isCentered,
                itemCount: React.Children.count(this.props.children),
                onPageChange: this.props.onPageChange,
                startingPage: this.props.startingPage,
                // Force a re-render if the model changes.
                onStateChange: function onStateChange(modelState) {
                    return _this2.setState({ modelState: modelState });
                }
            });

            // Set the initial model state. This is probably unnecessary but put here to avoid issues if state gets used
            // in `render` in the future.
            this.setState({ modelState: this._model.getState() });
        }

        /**
         * Imperatively set the page from outside the component, e.g. if the state of this carousel needs to be kept
         * constistent with another carousel.
         *
         * @param {number} page - The page to set.
         * @param {object} model - Model to update, needed for components where this method gets passed.
         * @param {function} callback
        */

    }, {
        key: 'setPage',
        value: function setPage(page) {
            var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._model;
            var callback = arguments[2];

            // Update the model which will in turn trigger an update to the view state and force a re-render.
            if (callback) {
                callback();
            }

            model.jumpToPage(page);
        }
    }, {
        key: 'enableSwipe',
        value: function enableSwipe() {
            this._model.enableSwipe();
        }
    }, {
        key: 'disableSwipe',
        value: function disableSwipe() {
            this._model.disableSwipe();
        }

        /**
         * Method to create a basic carousel which then can be shown or wrapped by other components.
         *
         * @returns {object} - JSX of a carousel.
         */

    }, {
        key: '_createCarousel',
        value: function _createCarousel() {
            var _classnames, _classnames2, _classnames3;

            var _props$classNames = this.props.classNames,
                wrapper = _props$classNames.wrapper,
                list = _props$classNames.list,
                item = _props$classNames.item;


            var wrapperClass = classnames((_classnames = {}, _defineProperty(_classnames, 'swipe-carousel-wrapper', true), _defineProperty(_classnames, wrapper, wrapper), _classnames));
            var listClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, 'swipe-carousel-list', true), _defineProperty(_classnames2, list, list), _classnames2));
            var itemClass = classnames((_classnames3 = {}, _defineProperty(_classnames3, 'swipe-carousel-item', true), _defineProperty(_classnames3, item, item), _classnames3));

            return React.createElement(
                'div',
                { className: wrapperClass },
                React.createElement(
                    BaseCarousel,
                    { model: this._model, classNames: { list: listClass, item: itemClass } },
                    this.props.children
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.useDotsNav) {
                return React.createElement(DotCarousel, {
                    classNames: this.props.classNames,
                    createCarousel: function createCarousel() {
                        return _this3._createCarousel();
                    },
                    setPage: this.setPage,
                    model: this._model,
                    onDotClick: this.props.onDotClick,
                    dotsColorType: this.props.dotsColorType
                });
            }

            return this._createCarousel();
        }
    }]);

    return SwipeCarousel;
}(React.Component);

SwipeCarousel.propTypes = {
    onPageChange: PropTypes.func,
    startingPage: PropTypes.number,
    // Change the number of items to display per carousel page.
    itemsPerPage: PropTypes.number,
    itemWidth: PropTypes.number,
    isCentered: PropTypes.bool,
    classNames: PropTypes.object,
    children: PropTypes.node,
    useDotsNav: PropTypes.bool,
    dotsColorType: PropTypes.oneOf(['buyer', 'trade']),
    onDotClick: PropTypes.func.isRequired
};

SwipeCarousel.defaultProps = {
    itemsPerPage: 1,
    onPageChange: noop,
    onDotClick: noop,
    startingPage: 0,
    classNames: {}
};

module.exports = SwipeCarousel;

/***/ }),
/* 522 */,
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var without = __webpack_require__(919);
var GlobalContextBaseView = __webpack_require__(353);

/**
 * @class ConnectedBaseView
 * @extends GlobalContextBaseView
 */
var ConnectedBaseView = GlobalContextBaseView.extend({
    props: {},
    defaultProps: {},
    stores: [],

    /**
     * @param {object}  options
     * @param {object} [options.defaultProps] - default prop values (if getPropsFromStores is not overridden)
     * @param {array}  [options.stores]       - array of store constructors
     * @param {BaseView} [parentView]
     */
    constructor: function constructor(options, parentView) {
        var _this = this;

        options = options || {};

        // bind store change handler to view
        this._updatePropsAndRender = this._updatePropsAndRender.bind(this);

        this.defaultProps = options.defaultProps || this.defaultProps;
        this.stores = options.stores || this.stores;
        this.context = options.context;
        this._contextStores = [];

        if (!this.context) {
            throw new Error("No context was provided to ConnectedBaseView.");
        }

        // Add all the stores to the view (attaching a _updatePropsAndRender change handler)
        this.stores.forEach(function (store) {
            return _this.addStore(store);
        });

        GlobalContextBaseView.call(this, options, parentView);

        // Set initial props and call render
        this._updatePropsAndRender();
    },


    /**
     * Add a single store to the view and attach change listener
     * @param store
     * @throws {Error} Store was not registered
     */
    addStore: function addStore(store) {
        var contextStore = this.context.getStore(store);
        if (this._contextStores.indexOf(contextStore) < 0) {
            this._contextStores.push(contextStore);
            contextStore.addChangeListener(this._updatePropsAndRender);
        }
    },


    /**
     * Removes a store from the view and removes its change listener
     * @param store
     * @throws {Error} Store was not registered
     */
    removeStore: function removeStore(store) {
        var contextStore = this.context.getStore(store);
        if (this._contextStores.indexOf(contextStore) > -1) {
            this._contextStores = without(this._contextStores, contextStore);
            contextStore.removeChangeListener(this._updatePropsAndRender);
        }
    },


    /**
     * Handler attached/removed from stores in view
     *  - attaches props to view
     *  - calls render
     * @private
     */
    _updatePropsAndRender: function _updatePropsAndRender() {
        var propsFromStores = this.getPropsFromStores.apply(this, this._contextStores);
        this.props = Object.assign({}, propsFromStores, this.defaultProps);
        this.render();
    },


    /**
     * Method called before render that should return an object to that will be set as the view's props
     *  (Should be overridden)
     * @returns {Object|null}
     */
    getPropsFromStores: function getPropsFromStores() /*store1, store2, store3...*/{}
});

module.exports = ConnectedBaseView;

/***/ }),
/* 524 */,
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(40);
var ExecutionEnvironment = __webpack_require__(516);
var ModalPortal = React.createFactory(__webpack_require__(526));
var ariaAppHider = __webpack_require__(527);
var elementClass = __webpack_require__(449);
var renderSubtreeIntoContainer = __webpack_require__(40).unstable_renderSubtreeIntoContainer;
var Assign = __webpack_require__(60);

var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};

var Modal = React.createClass({

  displayName: 'Modal',
  statics: {
    setAppElement: function(element) {
        AppElement = ariaAppHider.setElement(element);
    },
    injectCSS: function() {
      "production" !== 'production'
        && console.warn('React-Modal: injectCSS has been deprecated ' +
                        'and no longer has any effect. It will be removed in a later version');
    }
  },

  propTypes: {
    isOpen: React.PropTypes.bool.isRequired,
    style: React.PropTypes.shape({
      content: React.PropTypes.object,
      overlay: React.PropTypes.object
    }),
    appElement: React.PropTypes.instanceOf(SafeHTMLElement),
    onAfterOpen: React.PropTypes.func,
    onRequestClose: React.PropTypes.func,
    closeTimeoutMS: React.PropTypes.number,
    ariaHideApp: React.PropTypes.bool,
    shouldCloseOnOverlayClick: React.PropTypes.bool
  },

  getDefaultProps: function () {
    return {
      isOpen: false,
      ariaHideApp: true,
      closeTimeoutMS: 0,
      shouldCloseOnOverlayClick: true
    };
  },

  componentDidMount: function() {
    this.node = document.createElement('div');
    this.node.className = 'ReactModalPortal';
    document.body.appendChild(this.node);
    this.renderPortal(this.props);
  },

  componentWillReceiveProps: function(newProps) {
    this.renderPortal(newProps);
  },

  componentWillUnmount: function() {
    ReactDOM.unmountComponentAtNode(this.node);
    document.body.removeChild(this.node);
    elementClass(document.body).remove('ReactModal__Body--open');
  },

  renderPortal: function(props) {
    if (props.isOpen) {
      elementClass(document.body).add('ReactModal__Body--open');
    } else {
      elementClass(document.body).remove('ReactModal__Body--open');
    }

    if (props.ariaHideApp) {
      ariaAppHider.toggle(props.isOpen, props.appElement);
    }

    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
  },

  render: function () {
    return React.DOM.noscript();
  }
});

Modal.defaultStyles = {
  overlay: {
    position        : 'fixed',
    top             : 0,
    left            : 0,
    right           : 0,
    bottom          : 0,
    backgroundColor : 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position                : 'absolute',
    top                     : '40px',
    left                    : '40px',
    right                   : '40px',
    bottom                  : '40px',
    border                  : '1px solid #ccc',
    background              : '#fff',
    overflow                : 'auto',
    WebkitOverflowScrolling : 'touch',
    borderRadius            : '4px',
    outline                 : 'none',
    padding                 : '20px'
  }
}

module.exports = Modal


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);
var div = React.DOM.div;
var focusManager = __webpack_require__(528);
var scopeTab = __webpack_require__(529);
var Assign = __webpack_require__(60);

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: {
    base: 'ReactModal__Overlay',
    afterOpen: 'ReactModal__Overlay--after-open',
    beforeClose: 'ReactModal__Overlay--before-close'
  },
  content: {
    base: 'ReactModal__Content',
    afterOpen: 'ReactModal__Content--after-open',
    beforeClose: 'ReactModal__Content--before-close'
  }
};

var ModalPortal = module.exports = React.createClass({

  displayName: 'ModalPortal',

  getDefaultProps: function() {
    return {
      style: {
        overlay: {},
        content: {}
      }
    };
  },

  getInitialState: function() {
    return {
      afterOpen: false,
      beforeClose: false
    };
  },

  componentDidMount: function() {
    // Focus needs to be set when mounting and already open
    if (this.props.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    }
  },

  componentWillUnmount: function() {
    clearTimeout(this.closeTimer);
  },

  componentWillReceiveProps: function(newProps) {
    // Focus only needs to be set once when the modal is being opened
    if (!this.props.isOpen && newProps.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    } else if (this.props.isOpen && !newProps.isOpen) {
      this.close();
    }
  },

  componentDidUpdate: function () {
    if (this.focusAfterRender) {
      this.focusContent();
      this.setFocusAfterRender(false);
    }
  },

  setFocusAfterRender: function (focus) {
    this.focusAfterRender = focus;
  },

  open: function() {
    focusManager.setupScopedFocus(this.node);
    focusManager.markForFocusLater();
    this.setState({isOpen: true}, function() {
      this.setState({afterOpen: true});

      if (this.props.isOpen && this.props.onAfterOpen) {
        this.props.onAfterOpen();
      }
    }.bind(this));
  },

  close: function() {
    if (!this.ownerHandlesClose())
      return;
    if (this.props.closeTimeoutMS > 0)
      this.closeWithTimeout();
    else
      this.closeWithoutTimeout();
  },

  focusContent: function() {
    this.refs.content.focus();
  },

  closeWithTimeout: function() {
    this.setState({beforeClose: true}, function() {
      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
    }.bind(this));
  },

  closeWithoutTimeout: function() {
    this.setState({
      afterOpen: false,
      beforeClose: false
    }, this.afterClose);
  },

  afterClose: function() {
    focusManager.returnFocus();
    focusManager.teardownScopedFocus();
  },

  handleKeyDown: function(event) {
    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
    if (event.keyCode == 27 /*esc*/) {
      event.preventDefault();
      this.requestClose(event);
    }
  },

  handleOverlayClick: function(event) {
    var node = event.target

    while (node) {
      if (node === this.refs.content) return
      node = node.parentNode
    }

    if (this.props.shouldCloseOnOverlayClick) {
      if (this.ownerHandlesClose())
        this.requestClose(event);
      else
        this.focusContent();
    }
  },

  requestClose: function(event) {
    if (this.ownerHandlesClose())
      this.props.onRequestClose(event);
  },

  ownerHandlesClose: function() {
    return this.props.onRequestClose;
  },

  shouldBeClosed: function() {
    return !this.props.isOpen && !this.state.beforeClose;
  },

  buildClassName: function(which, additional) {
    var className = CLASS_NAMES[which].base;
    if (this.state.afterOpen)
      className += ' '+CLASS_NAMES[which].afterOpen;
    if (this.state.beforeClose)
      className += ' '+CLASS_NAMES[which].beforeClose;
    return additional ? className + ' ' + additional : className;
  },

  render: function() {
    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;

    return this.shouldBeClosed() ? div() : (
      div({
        ref: "overlay",
        className: this.buildClassName('overlay', this.props.overlayClassName),
        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
        onClick: this.handleOverlayClick
      },
        div({
          ref: "content",
          style: Assign({}, contentStyles, this.props.style.content || {}),
          className: this.buildClassName('content', this.props.className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown
        },
          this.props.children
        )
      )
    );
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports) {

var _element = typeof document !== 'undefined' ? document.body : null;

function setElement(element) {
  if (typeof element === 'string') {
    var el = document.querySelectorAll(element);
    element = 'length' in el ? el[0] : el;
  }
  _element = element || _element;
  return _element;
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || _element).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || _element).removeAttribute('aria-hidden');
}

function toggle(shouldHide, appElement) {
  if (shouldHide)
    hide(appElement);
  else
    show(appElement);
}

function validateElement(appElement) {
  if (!appElement && !_element)
    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
}

function resetForTesting() {
  _element = document.body;
}

exports.toggle = toggle;
exports.setElement = setElement;
exports.show = show;
exports.hide = hide;
exports.resetForTesting = resetForTesting;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(391);
var modalElement = null;
var focusLaterElement = null;
var needToFocus = false;

function handleBlur(event) {
  needToFocus = true;
}

function handleFocus(event) {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation 
    // is that the document.body gets focus, and then we focus our element right 
    // after, seems fine.
    setTimeout(function() {
      if (modalElement.contains(document.activeElement))
        return;
      var el = (findTabbable(modalElement)[0] || modalElement);
      el.focus();
    }, 0);
  }
}

exports.markForFocusLater = function() {
  focusLaterElement = document.activeElement;
};

exports.returnFocus = function() {
  try {
    focusLaterElement.focus();
  }
  catch (e) {
    console.warn('You tried to return focus to '+focusLaterElement+' but it is not in the DOM anymore');
  }
  focusLaterElement = null;
};

exports.setupScopedFocus = function(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
};

exports.teardownScopedFocus = function() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
};




/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(391);

module.exports = function(node, event) {
  var tabbable = findTabbable(node);
  if (!tabbable.length) {
      event.preventDefault();
      return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = (
    finalTabbable === document.activeElement ||
    // handle immediate shift+tab after opening with mouse
    node === document.activeElement
  );
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(53))(14);

/***/ }),
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(62);

/**
 * @param  {number} amount - The number to format.
 * @param  {string} currency - Accepts any currency from currencies file
 * @param  {object} passedOptions - Additional options for localizedCashFormatObj
 * @return {object} - An object containing the price, currency symbol, abbreviation and a negative sign
 */
module.exports = function intelligentFormatObj(amount, currency, passedOptions) {
    var options = util.getFormatOptions(amount, currency, passedOptions);
    return util.localizedCashFormatObj(amount, options);
};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-facebook'].join(' '), viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M141.7,250V135.8H180l5.7-44.3h-44.2V63.2c0-13,3.6-21.5,21.9-21.5H187v-40C183,1.1,169.1,0,152.8,0 c-34,0-57.2,20.8-57.2,58.7v32.8H57.6v44.3h38.3V250H141.7L141.7,250z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 8/28/16.
 */



var get = __webpack_require__(14);

var _require = __webpack_require__(673),
    formatPrice = _require.formatPrice;

var displayTransformations = __webpack_require__(1011);

var getAmount = function getAmount() {
    var amounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currency = arguments[1];
    return amounts.find(function (amount) {
        return amount && amount.currency === currency;
    }) || {};
};
var getFormattedPrice = function getFormattedPrice() {
    var amounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currency = arguments[1];

    var _getAmount = getAmount(amounts, currency),
        amount = _getAmount.amount;

    return formatPrice({ price: amount, currency: currency });
};

var createHandlingTimeCopy = function createHandlingTimeCopy(_ref) {
    var is1stdibsWhiteGloveQuote = _ref.is1stdibsWhiteGloveQuote,
        handlingType = _ref.handlingType,
        handlingTimeDisplay = _ref.handlingTimeDisplay,
        regionType = _ref.regionType;

    var str = handlingType + ': ' + handlingTimeDisplay;
    if (is1stdibsWhiteGloveQuote && regionType !== 'LOCAL') {
        str = '1stdibs ' + str;
    }
    return str;
};

var createOutputString = function createOutputString(_ref2) {
    var serviceMethod = _ref2.serviceMethod,
        _ref2$totalAmount = _ref2.totalAmount,
        totalAmount = _ref2$totalAmount === undefined ? {} : _ref2$totalAmount,
        currency = _ref2.currency,
        regionType = _ref2.regionType,
        isLocalPrimary = _ref2.isLocalPrimary;

    var region = get(serviceMethod, 'region.regionName');
    var amount = getAmount(get(totalAmount, 'convertedAmountList', []), currency);

    var _formatPrice = formatPrice({ price: amount.amount, currency: currency }),
        string = _formatPrice.string,
        abbreviation = _formatPrice.abbreviation;

    var output = string;
    if (amount.amount === 0) {
        output = 'Complimentary';
    } else if (abbreviation) {
        output = output + ' ' + abbreviation;
    }
    if (regionType === 'LOCAL' && !isLocalPrimary) {
        return 'Local shipping starts at ' + output;
    }
    if (region === 'Rest of the World') {
        region = 'anywhere in the world';
    }
    return output + ' shipping to ' + region;
};

var getShippingQuote = function getShippingQuote(_ref3) {
    var _ref3$item = _ref3.item,
        item = _ref3$item === undefined ? {} : _ref3$item,
        currency = _ref3.currency,
        regionType = _ref3.regionType,
        isLocalPrimary = _ref3.isLocalPrimary;

    if (item.node) {
        var _item$node = item.node,
            serviceMethod = _item$node.serviceMethod,
            totalAmount = _item$node.totalAmount,
            handlingTimeDisplay = _item$node.handlingTimeDisplay,
            is1stdibsWhiteGloveQuote = _item$node.is1stdibsWhiteGloveQuote;

        var key = item.node.__dataID__ || item.node.id;
        var handlingType = displayTransformations[serviceMethod.displayName] || serviceMethod.displayName || '';
        var handlingTimeCopy = createHandlingTimeCopy({ is1stdibsWhiteGloveQuote: is1stdibsWhiteGloveQuote, handlingType: handlingType, handlingTimeDisplay: handlingTimeDisplay, regionType: regionType });
        var output = createOutputString({ serviceMethod: serviceMethod, totalAmount: totalAmount, currency: currency, regionType: regionType, isLocalPrimary: isLocalPrimary });
        return {
            key: key,
            handlingTimeCopy: handlingTimeCopy,
            output: output
        };
    }
    return {};
};

var filterQuote = function filterQuote(_ref4) {
    var node = _ref4.node;
    return node && get(node, 'serviceMethod.serviceMethodType') !== 'LOCAL_PICKUP';
};
var filterQuotes = function filterQuotes() {
    var quotes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return quotes.filter(filterQuote);
};
var sortQuote = function sortQuote(prev, curr) {
    var prevMinTime = get(prev, 'node.serviceMethod.windowMin.numberOfUnits') || 0;
    var currMinTime = get(curr, 'node.serviceMethod.windowMin.numberOfUnits') || 0;
    var prevHandlingTime = get(prev, 'node.handlingTime.numberOfUnits') || 0;
    var currHandlingTime = get(curr, 'node.handlingTime.numberOfUnits') || 0;
    return prevMinTime + prevHandlingTime - (currMinTime + currHandlingTime);
};

var getShipmentPrequotes = function getShipmentPrequotes(_ref5) {
    var _ref5$domesticDeliver = _ref5.domesticDeliveryOptions,
        domesticDeliveryOptions = _ref5$domesticDeliver === undefined ? {} : _ref5$domesticDeliver,
        _ref5$localDeliveryOp = _ref5.localDeliveryOptions,
        localDeliveryOptions = _ref5$localDeliveryOp === undefined ? {} : _ref5$localDeliveryOp,
        _ref5$shipmentQuotes = _ref5.shipmentQuotes,
        shipmentQuotes = _ref5$shipmentQuotes === undefined ? {} : _ref5$shipmentQuotes;

    var domesticDeliveryQuotes = domesticDeliveryOptions.edges || [];
    var localDeliveryQuotes = localDeliveryOptions.edges || [];
    shipmentQuotes = shipmentQuotes.edges || [];

    return {
        domestic: filterQuotes(domesticDeliveryQuotes),
        local: filterQuotes(localDeliveryQuotes),
        shipmentQuotes: filterQuotes(shipmentQuotes)
    };
};

var helpers = {
    getValidQuote: function getValidQuote(_ref6) {
        var quotes = _ref6.quotes,
            regionType = _ref6.regionType,
            currency = _ref6.currency,
            _ref6$isLocalPrimary = _ref6.isLocalPrimary,
            isLocalPrimary = _ref6$isLocalPrimary === undefined ? false : _ref6$isLocalPrimary;

        var filteredQuotes = filterQuotes(quotes);
        return getShippingQuote({ item: filteredQuotes[0], regionType: regionType, currency: currency, isLocalPrimary: isLocalPrimary });
    },

    getFormattedPrice: getFormattedPrice,
    getShipmentPrequotes: getShipmentPrequotes,
    filterQuotes: filterQuotes,
    filterQuote: filterQuote,
    sortQuote: sortQuote
};

module.exports = helpers;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 5/17/14
 * Time: 5:59 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var $ = __webpack_require__(5);
var SV = __webpack_require__(17);
var tracking = __webpack_require__(27);
var strings = __webpack_require__(376);
var User = __webpack_require__(15);
var tokenReplace = __webpack_require__(75);
var get = __webpack_require__(14);

var IMAGE_EVENT_CATEGORY = 'product';

var trackedProductDetailDimensions = ['timePeriod', 'creator', 'onSale', 'newListing', 'dealerName', 'dealerID', 'dealerLocation', 'itemPostingLocation', 'purchaseStatus', 'askingPrice', 'priceType'];

// These lookup tables are used in trackGaImageEvent to build the action string for
// for events on the pdp Hero images and Zoom modal images
var imageActionStep = {
    'next': 'pdp image carousel {key} button',
    'previous': 'pdp image carousel {key} button',
    'mobile': 'pdp secondary image mobile selector click',
    'zoom': 'image zoomed'
};

/**
 * @param {*} label The current label being passed to GA
 * @returns {*}
 */
var getGaLabel = function getGaLabel(label) {
    // need this last null in there for FINDING-1485
    if (typeof label !== 'undefined' && label !== null) {
        return label.toString();
    } else if (label !== null) {
        return SV.data.gaString;
    }
    return null;
};

/**
 * @param {*} action The GA action
 * @returns {*}
 */
var getGaAction = function getGaAction(action) {
    if (typeof action !== 'undefined' && action !== null) {
        return action;
    }
    return location.href;
};

/**
 * @param {String} value the value to update
 * @param {Boolean} check set to y or n
 */
var updateCustomVar = function updateCustomVar(value, check) {
    var customVars = get(SV, 'tracking.customVars', false);

    if (!customVars) {
        return;
    }

    var len = customVars.length;

    for (var i = 0; i < len; i++) {
        var customVar = customVars[i];
        if (customVar.slot === 4) {
            var oldValue = customVar.value;
            customVar.value = exports.amendCustomVar(customVar.value, value, check);

            if (oldValue !== customVar.value) {
                //save in namespace to be consumed by gas.dibs.pageview.js->createCustomVar
                customVars[i] = customVar;
            }
        }
    }
};

exports.getInitialDataLayerInfo = function getInitialDataLayerInfo() {
    return get(SV, 'tracking.initialDataLayerInfo', false);
};

/**
 *
 * @param {String} customVar the customVar to update
 * @param {String} value the value to update
 * @param {Boolean} check set to y or n
 * @returns {String}
 */
exports.amendCustomVar = function amendCustomVar(customVar, value, check) {
    return strings.setInDelimitedString(customVar, value, check ? 'y' : 'n', '//|');
};

/**
 *
 * @param {string} category
 * @param {string} [action]
 * @param {string} [label]
 * @param {number} [value]
 * @param {boolean} [noninteraction]
 */
exports.trackGaEvent = function trackGaEvent(category, action, label, value, noninteraction) {
    action = getGaAction(action);
    label = getGaLabel(label);

    tracking.trackEvent({
        'category': category,
        'action': action,
        'label': label,
        'value': value,
        'noninteraction': noninteraction
    });
};

exports.updateGaLoginStatus = function updateGaLoginStatus() {
    updateCustomVar('log', User.loggedIn());
};

exports.updateGaReturns = function updateGaReturns(hasReturnPolicy) {
    updateCustomVar('ret', hasReturnPolicy);
};

exports.updateGaPageSubtype = function updateGaPageSubtype(priceStates) {
    var initialDataLayerInfo = exports.getInitialDataLayerInfo();
    var status = 'Available-Price';
    var purchaseStatus = void 0;

    if (!initialDataLayerInfo) {
        return;
    }

    // Suspended PDPs should never hit here
    if (priceStates.showOnHold) {
        status = 'Hold';
        purchaseStatus = exports.amendCustomVar(initialDataLayerInfo.purchaseStatus, 'pur', false);
        initialDataLayerInfo.purchaseStatus = purchaseStatus;
    } else if (priceStates.showSold) {
        status = 'Sold';
    } else if (priceStates.showNetPrice) {
        status = 'Available-Net Price';
    } else if (priceStates.showPriceUponRequest) {
        status = 'Available-No Price';
    }

    if (priceStates.showOnHoldCustom) {
        status += "-hold";
    }

    initialDataLayerInfo.pageSubType = 'PDP-' + status;
};

exports.unblockCustomVar = function unblockCustomVar() {
    $.publish('ga:unblockCustomVar');
};

/**
 * Tracks interaction with the carousel images on pdp pages
 * @param actionStepKey
 * @param locationKey
 * @param label
 */
exports.trackGaImgEvent = function trackGaImgEvent(actionStepKey, label) {
    var action = imageActionStep[actionStepKey];

    if (action) {
        action = tokenReplace(action, { key: actionStepKey });
        this.trackGaEvent(IMAGE_EVENT_CATEGORY, action, label);
    }
};

exports.trackSuggestionLinkEvent = function trackSuggestionLinkEvent(e) {
    var data = $(e.target).data() || {};
    this.trackGaEvent('PDP - Item Not For Sale - Related Item Clicked', data.gaaction, data.galabel);
};

exports.setupShippingStatusTracking = function () {
    tracking.setupShippingStatusTracking();
};

/**
 * Builds all page data that is derived from the user
 * @param gtmData
 * @param gtmUserAttributes
 */
exports.trackShippingStatusData = function () {
    var quotes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var canRequestShippingQuote = arguments[1];

    var shipPreQuote = get(quotes, 'shipmentQuotes', []).length ? 'y' : 'n';
    var quotesDomestic = get(quotes, 'domestic', []);
    var quotesLocal = get(quotes, 'local', []);
    var shipPreQuoteToLoc = quotesDomestic.length || quotesLocal.length ? 'y' : 'n';

    tracking.resolveShippingStatusDfdWith({
        shippingStatus: 'shipPreQuote=' + shipPreQuote + '|shipPreQuoteToLoc=' + shipPreQuoteToLoc + '|requestQuote=' + canRequestShippingQuote
    });
};

exports.trackProductDetail = function trackProductDetail() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var data = SV.get('data');
    var dimensionData = Object.assign({}, input, SV.get('tracking.initialDataLayerInfo'));
    tracking.trackEcommerce({
        type: "productDetail",
        products: [{
            url: data.canonicalUrl,
            id: data.pk,
            name: data.titleCondensed,
            brand: data.dealerPk,
            price: dimensionData.askingPrice,
            additional: tracking.getCustomDimensions(dimensionData, trackedProductDetailDimensions)
        }]
    });
};

exports.checkListingStatus = function checkListingStatus(listingStatuses, trackingOverrides) {
    listingStatuses = listingStatuses || {};
    trackingOverrides = trackingOverrides || {};
    var publishedKeys = Object.keys(listingStatuses)
    // filter out keys that aren't currently PUBLISHED
    .filter(function (key) {
        return get(listingStatuses, key + '.0') === 'PUBLISHED';
    })
    // flatten to an object so there's no need for an array check
    .reduce(function (acc, val) {
        return Object.assign({}, acc, _defineProperty({}, val, true));
    }, {});

    if (publishedKeys.FEATURED) {
        trackingOverrides.itemPostingLocation = 'New Listings';
    } else if (publishedKeys.MARKETPLACE) {
        trackingOverrides.itemPostingLocation = 'Marketplace';
    } else if (publishedKeys.DEALER_STOREFRONT) {
        trackingOverrides.itemPostingLocation = 'Storefront';
    }

    return trackingOverrides;
};

/***/ }),
/* 543 */,
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var extendCompose = __webpack_require__(43);
var composeClassNames = __webpack_require__(100);

/**
 * @class TemplateView is a lightweight view for rapid prototyping with a concise syntax, use it when you don't care to create a bunch of subclasses just to show a set of mostly static templates. To render a model's toJSON() into a template and package it into a Backbone view instance, it's just:
 *
 * new TemplateView({ // instantiating, not extending here; an instance of the object is ready to use
 *   template: myTemplate, // template can be passed through options or prototype
 *   model: myModel // model.toJSON gets passed to the template as data
 * });
 * You can also nest TemplateView configs inside of a scope property to build more complex views:
 *
 * new TemplateView({
 *   template: outerTemplate,
 *   model: outerModel,
 *   scope: {
 *     'sub-templateview-goes-here': { // plain objects used to create a new TemplateView
 *       template innerTemplate
 *       model: innerModel
 *     },
 *     'not-a-template-view': new MyOtherView() // instances of Backbone.View get appended directly
 *   }
 * });
 * where outerTemplate is:
 *
 * <div>
 *   <div data-append='sub-templateview-goes-here'>
 *     <!-- subview gets appended here, the element is
 *          identified by the key in the TemplateView
 *          instance's scope map -->
 *   </div>
 *   <div data-append='not-a-template-view'>
 *     <!-- myOtherview instance gets appended here -->
 *   </div>
 * </div>
 *
 * some notes:
 *  - the template can be specified on the prototype or through options.
 *  - this.model.toJSON() is automatically offered as as the data for the template
 *  - automatically appends subviews using a scope map, passed through prototype or options. Elements on which to append are declared with a data-append=<name-in-scope> attribute
 *
 * @param {boolean} templateSpec.useInnerElement - if true, then the first element in the template will be used as the element for the view, otherwise the template will be rendered into a wrapper element.
 * @param {boolean} templateSpec.local - a local-css map as exported by css-loader. It will be available as obj.local in your template.
 * @param {object} options.scope: a map of subviews to append to subview parent elements.
 *   the values in the map can of one of:
 *      @property {Function} - value is derived from execution
 *      @property {Backbone.View} - value is used directly
 *      @property {Object} - options object used to construct a new TemplateView
 *      @property {boolean} - if false, the container element will be detached
 *   TemplateView identifies subview parents by elements with a data-append=<subview name> attribute.
 *   TemplateView.Base (the BaseView version of TemplateView) identifies subview parents with a selector of .<subview name>-container.
 *   override getSubElement to change this behavior in your subclass. This is only recommended when subclassing the .NoBaseView version
 * @param {TemplateSpec} options.template : a template specification. Overrides tempalte from prototype if present.
 * @property {TemplateSpec} template :  (required if TemplateSpec is not specified on the prototype) a template specification. Specify on prototype of you inheriting class.
 * @description TemplateSpec identifies your template. It can be:
 *    a string identifying the ID of a template element on the page
 *    a function that works like an underscore template that takes a map of template vars
 *    an object that has the following properties:
 *       src: a function that works like an underscore template
 *       useInnerElement: a boolean that indicates if the first element in the template should be promoted to be this.el via `Backbone.View.prototype.setElement`
 *       local: a local-style map as exported from css-loader. Its values will be exposed to the template as obj.local
 * @property {object} [templateVars]: an object or function that returns the object that will be injected into the template. Defaults to this.model
 * @property .Base - This is a BaseView version of TemplateView that inherits from from Backbone.BaseView instead of Backbone.View. Subveiws are catalogged by BaseView's subview manager, but the user interface is identical.
 */

extendCompose = extendCompose.withMiddleware({ afterPrototype: function afterPrototype(parentPrototype, childPrototypeBefore, childPrototypeAfter) {
        if (!childPrototypeAfter.template) {
            return childPrototypeAfter;
        }
        var newLocalClassNames = void 0;
        if (childPrototypeAfter.template.local__) {
            newLocalClassNames = composeClassNames(childPrototypeAfter.template.local, childPrototypeAfter.template.local__);
        } else if (childPrototypeAfter.template.__local) {
            newLocalClassNames = composeClassNames(childPrototypeAfter.template.__local, childPrototypeAfter.template.local);
        } else {
            return childPrototypeAfter;
        }
        return Object.assign({}, childPrototypeAfter, {
            template: Object.assign({}, childPrototypeAfter.template, {
                local: newLocalClassNames
            })
        });
    } });
var TemplateView = module.exports = extendCompose.call(Backbone.View, {});
var normalizeToView = __webpack_require__(502);
var prototype = {
    templateVars: function templateVars() {
        return this.model ? this.model.toJSON() : {};
    },
    getSubElement: function getSubElement(subViewKey) {
        var subSelector = "[data-append=" + subViewKey + "]";
        var $subs = this.$(subSelector);
        if (this.$el.is(subSelector)) {
            $subs = $subs.add(this.el);
        }
        return $subs.first().get(0);
    },
    getSubView: function getSubView(subViewKey) {
        return this._subs[subViewKey];
    },
    initialize: function initialize(options) {
        var scope;
        var useInnerElement;
        var local;
        var $innerEls;
        var renderedTemplate;
        options = options || {};
        scope = options.scope || this.scope || {};
        this.templateVars = options.templateVars || this.templateVars;
        this.template = options.template || this.template;
        if (!_.isFunction(this.template) && this.template instanceof Object) {
            useInnerElement = this.template.useInnerElement;
            local = this.template.local;
            this.template = this.template.src;
        }
        if (undefined === useInnerElement) {
            useInnerElement = useInnerElement || options.useInnerElement;
        }
        if (this.templateVars instanceof Function) {
            this.templateVars = this.templateVars.apply(this);
        }
        if (scope instanceof Function) {
            scope = scope.apply(this);
        }
        if (!this.template) {
            throw new Error("no template provided to template view");
        }
        if (local) {
            this.templateVars = _.extend({ local: local }, this.templateVars);
        }
        renderedTemplate = this.template(this.templateVars);
        if (undefined === renderedTemplate) {
            renderedTemplate = "";
        }
        $innerEls = $("<div>").html(renderedTemplate.trim()).contents();
        if (useInnerElement) {
            if ($innerEls.size() > 1) {
                throw new Error("useInnerElement requires template with a single root element.");
            }
            this.setElement($innerEls);
        } else {
            this.$el.append($innerEls);
        }
        this._subs = _.chain(scope).map(function (subViews, appendKey) {
            var el = this.getSubElement(appendKey);
            var $el = $(el);
            var wasArray = true;
            if (!el) {
                return; // couldn't identify a subview parent
            }
            if (!_.isArray(subViews)) {
                subViews = [subViews];
                wasArray = false;
            }
            if (!subViews) {
                return;
            }
            subViews = _.map(subViews, function (subView, i) {
                var innerEl = el;
                var $innerEl;
                if (wasArray) {
                    innerEl = document.createElement(el.tagName);
                    innerEl.setAttribute('data-template-view-child', i);
                    el.appendChild(innerEl);
                }
                $innerEl = $(innerEl);
                subView = normalizeToView({
                    defaultContext: this,
                    defaultParentElement: innerEl,
                    defaultTemplateVars: this.templateVars,
                    content: subView,
                    Constructor: this.defaultConstructor
                });
                if (false === subView) {
                    // TODO: test this
                    $innerEl.detach();
                }
                if (!subView) {
                    return;
                }
                if (innerEl !== subView.el) {
                    $innerEl.append(subView.el);
                }
                return subView;
            }, this);
            if (!wasArray) {
                subViews = _.first(subViews);
            }
            if (this.subViewAppended) {
                this.subViewAppended(subViews);
            }
            if (!subViews) {
                return;
            }
            return [appendKey, subViews];
        }, this).compact().object().value();
        return options;
    },
    render: function render() {
        // overriding render so the subviews dont get blown away after initialize runs
        _.each(this._subs, function (subarray) {
            if (!_.isArray(subarray)) {
                subarray = [subarray];
            }
            _.each(subarray, function (sub) {
                _.result(sub, 'render');
            });
        });
        return this;
    }
};
TemplateView.extendSelf(prototype, {
    defaultConstructor: TemplateView
});
var TemplateBaseView = extendCompose.call(Backbone.BaseView, prototype);
TemplateBaseView = module.exports.Base = TemplateBaseView.extend({
    initialize__: function initialize__(options) {
        this.subs.useDefaultLocationSelectors();
        return options;
    },
    getSubElement: function getSubElement(subViewKey) {
        return this.$("." + subViewKey + "-container").first().get(0);
    },
    subViewAppended: function subViewAppended(subView) {
        return this.subs.addInstance(subView);
    }
});
TemplateBaseView.defaultConstructor = TemplateBaseView;

/***/ }),
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reducers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var get = __webpack_require__(14);

/**
 * Convenience method for setting data in the state
 *
 * @param {object} state
 * @param {object} data
 * @returns {object}
 */
function setData(state, data) {
    return Object.assign({}, state, {
        data: Object.assign({}, state.data, data)
    });
}

var GalleryModalStore = {
    storeName: 'GalleryModalStore',
    initialState: {
        isHidden: true,
        hasOpened: false,

        data: {
            template: void 0,
            originalUrl: void 0,
            originalVPVString: void 0,
            originalPageTitleTag: void 0,
            originalPageType: void 0,
            originalDataLayerInfo: void 0
        }
    },

    reducers: (_reducers = {}, _defineProperty(_reducers, 'gallery-modal:setup-store', function setupGalleryModal(state, payload) {
        return setData(state, {
            originalUrl: payload.originalUrl,
            originalVPVString: payload.originalVPVString,
            originalPageTitleTag: payload.originalPageTitleTag,
            originalPageType: payload.originalPageType,
            originalDataLayerInfo: payload.originalDataLayerInfo
        });
    }), _defineProperty(_reducers, 'gallery-modal:show', function showGalleryModal(state) {
        if (state.isHidden) {
            return Object.assign({}, state, {
                isHidden: false
            });
        }
        return state;
    }), _defineProperty(_reducers, 'gallery-modal:hide', function hideGalleryModal(state) {
        if (!state.isHidden) {
            return Object.assign({}, state, {
                isHidden: true,
                hasOpened: true
            });
        }
        return state;
    }), _defineProperty(_reducers, 'gallery-modal:fetched', function setGalleryTemplate(state, payload) {
        return setData(state, {
            template: payload.template
        });
    }), _defineProperty(_reducers, 'gallery-modal:reset', function resetModal(state) {
        return Object.assign({}, state, {
            hasOpened: false,
            data: Object.assign({}, state.data, {
                template: void 0
            })
        });
    }), _reducers),

    getters: {
        /**
         * Checks if the modal is closed
         * @returns {boolean}
         */
        isHidden: function isHidden(state) {
            return state.isHidden;
        },

        /**
         * Checks if the modal has been opened
         * @returns {boolean}
         */
        hasOpened: function hasOpened(state) {
            return state.hasOpened;
        },

        /**
         * Checks if the modal is open but has no template yet
         * @returns {boolean}
         */
        isLoading: function isLoading(state) {
            return !state.isHidden && !state.hasOpened && !get(state, 'data.template');
        },
        shouldFetchTemplate: function shouldFetchTemplate(state) {
            return !state.isHidden && !state.hasOpened && !get(state, 'data.template');
        },

        /**
         * Checks if the template has just loaded
         * @returns {boolean}
         */
        hasJustLoaded: function hasJustLoaded(state) {
            return !state.isHidden && !state.hasOpened && !!get(state, 'data.template');
        },

        /**
         * Returns the gallery template
         * @returns {string}
         */
        getTemplate: function getTemplate(state) {
            return get(state, 'data.template', '');
        },

        /**
         * Returns the original url
         *  (e.g. the url of the page that opens the gallery modal)
         * @returns {string}
         */
        getOriginalUrl: function getOriginalUrl(state) {
            return get(state, 'data.originalUrl', '');
        },

        /**
         * Returns the original vpv string
         *  (e.g. the vpv string of the page that opens the gallery modal)
         * @returns {string}
         */
        getOriginalVPVString: function getOriginalVPVString(state) {
            return get(state, 'data.originalVPVString', '');
        },

        /**
         * Returns the original page title tag
         *  (e.g. the text in the <title> tag of the page that opens the gallery modal)
         *  @returns {string}
         */
        getOriginalPageTitleTag: function getOriginalPageTitleTag(state) {
            return get(state, 'data.originalPageTitleTag', '');
        },

        /**
         * Returns the original page type
         *  (e.g. pdp, project, photos)
         *  @returns {string}
         */
        getOriginalPageType: function getOriginalPageType(state) {
            return get(state, 'data.originalPageType', '');
        },

        /**
         * Returns the original data layer object
         *  (e.g. pdp, project, photos)
         *  @returns {string}
         */
        getOriginalDataLayerInfo: function getOriginalDataLayerInfo(state) {
            return get(state, 'data.originalDataLayerInfo', {});
        }
    }
};

module.exports = GalleryModalStore;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);

var TradeMessageStore = function (_BaseStore) {
    _inherits(TradeMessageStore, _BaseStore);

    function TradeMessageStore(dispatcher) {
        _classCallCheck(this, TradeMessageStore);

        var _this = _possibleConstructorReturn(this, (TradeMessageStore.__proto__ || Object.getPrototypeOf(TradeMessageStore)).call(this, dispatcher));

        _this._state = {
            messageVisible: false
        };
        return _this;
    }

    _createClass(TradeMessageStore, [{
        key: 'onMessageToggle',
        value: function onMessageToggle(isVisible) {
            this._state.messageVisible = isVisible;
            this.emitChange();
        }
    }, {
        key: 'canShowMessage',
        value: function canShowMessage() {
            return this._state.messageVisible;
        }
    }, {
        key: 'isLoaded',
        value: function isLoaded() {
            return this._state.isLoaded;
        }
    }]);

    return TradeMessageStore;
}(BaseStore);

TradeMessageStore.storeName = 'TradeMessageStore';

TradeMessageStore.handlers = {
    'message:trade:toggle': 'onMessageToggle'
};

module.exports = TradeMessageStore;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    'GALLERY_SETUP_STORE': 'gallery:setup-store',
    'GALLERY_RESET_STORE': 'gallery:reset-store',
    'GALLERY_PHOTOS_LOAD_START': 'gallery:photos-load-start',
    'GALLERY_PHOTOS_LOAD_DONE': 'gallery:photos-load-done',
    'GALLERY_PHOTOS_LOAD_FAILED': 'gallery:photos-load-failed',
    'GALLERY_SET_PHOTO': 'gallery:set-photo',
    'GALLERY_SWITCH_PHOTO': 'gallery:switch-photo',
    'GALLERY_UPDATE_COPY': 'gallery:update-copy',
    'GALLERY_ADD_SIMILAR_ITEMS_TEMPLATE': 'gallery:similar-items-add-template',
    'GALLERY_ADD_MORE_PROJECTS_TEMPLATE': 'gallery:more-projects-add-template',
    'GALLERY_MOBILE_SHOW_SOCIAL': 'gallery:show-social-mobile',
    'GALLERY_MOBILE_SHOW_DETAILS': 'gallery:show-details-mobile',

    'PHOTO_UI_UPDATE_DIMENSIONS': 'PHOTO_UI_UPDATE_DIMENSIONS',
    'PHOTO_UI_SHOW_ITEM_TAGS': 'PHOTO_UI_SHOW_ITEM_TAGS',
    'PHOTO_UI_HIDE_ITEM_TAGS': 'PHOTO_UI_HIDE_ITEM_TAGS',
    'PHOTO_UI_SET_ITEM_TAG': 'PHOTO_UI_SET_ITEM_TAG',
    'PHOTO_UI_UNSET_ITEM_TAG': 'PHOTO_UI_UNSET_ITEM_TAG'
};


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Lior Elrom
 * Date: 5/6/15
 * Time: 4:19 PM
 */



var $ = __webpack_require__(5);
var _ = __webpack_require__(23);

var defaultDelay = 0;        // Default value for how long the delay will last
var defaultDuration = 'slow';  // Default value for how long the animation will run

var scrollHelper = module.exports = {
    /**
     * Get the absolute position of the scroll from the top of the screen
     * @returns {Number}
     */
    getWindowScroll: function () {
        return $(window).scrollTop();
    },

    /**
     * Get the position of the scroll from the top of the screen plus the header's height (returns the scroll of the bottom of the header)
     * @returns {Number}
     */
    getScrollTopOfPage: function () {
        return scrollHelper.getWindowScroll() + scrollHelper.headerHeight();
    },

    /**
     * Get the position of the scroll at the bottom of the screen
     * @returns {Number}
     */
    getScrollBottomOfPage: function () {
        return scrollHelper.getWindowScroll() + $(window).height();
    },

    /**
     * Get the element's top position of the scroll from the top of the page (without the header)
     * @param {jQuery} [$el] - the jQuery element
     * @returns {Number|null} the top position of the element
     */
    getScrollTop: function ($el) {
        if (!($el instanceof $)) {
            return null;
        }
        return $el.offset().top - scrollHelper.headerHeight();
    },

    /**
     * Get the element's bottom position of the scroll from the top of the page (without the header)
     * @param {jQuery} [$el] - the jQuery element
     * @returns {Number|null} - the bottom position of the element
     */
    getScrollBottom: function ($el) {
        if (!($el instanceof $)) {
            return null;
        }
        return scrollHelper.getScrollTop($el) + scrollHelper.getHeight($el);
    },

    /**
     * Get the jQuery element height (includes padding, border and optionally margin)
     * @param {jQuery} [$el] - the jQuery element
     * @param includeMargin {Boolean} element's height includes margin as well (default: false)
     * @returns {Number|null} - the element's height in pixels
     */
    getHeight: function ($el, includeMargin) {
        if (!($el instanceof $)) {
            return null;
        }
        includeMargin = !!includeMargin;
        return $el.outerHeight(includeMargin);
    },

    /**
     * Get the window height
     * @returns {Number} - the window height
     */
    windowHeight: function () {
        return $(window).height();
    },

    /**
     * Get the page height (deducting the header's height)
     * @returns {Number} - the page height
     */
    pageHeight: function () {
        return scrollHelper.windowHeight() - scrollHelper.headerHeight();
    },

    /**
     * Get the header height (header height might change when in different responsive view)
     * @returns {Number} - the header height
     */
    headerHeight: function () {
        return $('#header').height() || 0;
    },

    /**
     * Scroll to a specific position in the page
     * @param {Number} position - number in pixels
     * @param {Number} delay - number of milliseconds before scroll (default: 500)
     * @param {Number} duration - number of milliseconds of scroll (default: slow)
     */
    scrollTo: function (position, delay, duration) {
        position = position || 0;
        delay = _.isUndefined(delay) ? defaultDelay : delay;
        duration = _.isUndefined(duration) ? defaultDuration : duration;

        window.clearTimeout(scrollHelper.scrollTimeout);

        scrollHelper.scrollTimeout = window.setTimeout(function () {
            $('html, body').animate({ scrollTop: position }, duration);
        }, delay);
    },

    /**
     * Check if a position is above the top pf the page (behind the header or above it)
     * @param topPosition - number in pixel
     * @returns {boolean}
     */
    hasExceededTop: function (topPosition) {
        return topPosition < scrollHelper.getScrollTopOfPage();
    },

    /**
     * Check if a position is below the bottom of the page
     * @param bottomPosition - number in pixel
     * @returns {boolean}
     */
    hasExceededBottom: function (bottomPosition) {
        return bottomPosition > scrollHelper.getScrollBottomOfPage();
    },

    /**
     * Check if the top of an element is above the page (behind the header or above it)
     * @param $el - a jQuery object
     * @param offset - number of pixels from the top of an element (default: 0)
     * @returns {boolean}
     */
    isTopOfElOffTopOfScreen: function ($el, offset) {
        var topPosition = scrollHelper.getScrollTop($el) + (offset || 0);
        return scrollHelper.hasExceededTop(topPosition);
    },

    /**
     * Check if the bottom of an element is below the page
     * @param $el - a jQuery object
     * @param offset - number of pixels from the bottom of an element (default: 0)
     * @returns {boolean}
     */
    isBottomOfElOffBottomOfScreen: function ($el, offset) {
        var bottomPosition = scrollHelper.getScrollBottom($el) + (offset || 0);
        return scrollHelper.hasExceededBottom(bottomPosition);
    },

    /**
     * Check if the top of an element is below the page
     * @param $el - a jQuery object
     * @param offset - number of pixels from the top of an element (default: 0)
     * @returns {boolean}
     */
    isTopOfElOffBottomOfScreen: function ($el, offset) {
        var topPosition = scrollHelper.getScrollTop($el) + (offset || 0);
        return scrollHelper.hasExceededBottom(topPosition);
    },

    /**
     * Check if the bottom of an element is above the page (behind the header or above it)
     * @param $el - a jQuery object
     * @param offset - number of pixels from the bottom of an element (default: 0)
     * @returns {boolean}
     */
    isBottomOfElOffTopOfScreen: function ($el, offset) {
        var bottomPosition = scrollHelper.getScrollBottom($el) + offset;
        return scrollHelper.hasExceededTop(bottomPosition);
    },

    /**
     * Check if an element is completely outside of the page (above or below the page)
     * @param $el - a jQuery object
     * @param offsetTop - number of pixels from the top of an element (default: 0)
     * @param offsetBottom - number of pixels from the bottom of an element (default: 0)
     * @returns {boolean}
     */
    isCompletelyOffScreen: function ($el, offsetTop, offsetBottom) {
        offsetTop    = offsetTop    || 0;
        offsetBottom = offsetBottom || 0;
        return scrollHelper.isTopOfElOffBottomOfScreen($el, offsetTop) || scrollHelper.isBottomOfElOffTopOfScreen($el, offsetBottom);
    },

    /**
     * Check if an element is partially off of the page
     * @param $el - a jQuery object
     * @param offsetTop - number of pixels from the top of an element (default: 0)
     * @param offsetBottom - number of pixels from the bottom of an element (default: 0)
     * @returns {boolean}
     */
    isPartiallyOffScreen: function ($el, offsetTop, offsetBottom) {
        offsetTop    = offsetTop    || 0;
        offsetBottom = offsetBottom || 0;
        return scrollHelper.isTopOfElOffTopOfScreen($el, offsetTop) || scrollHelper.isBottomOfElOffBottomOfScreen($el, offsetBottom);
    },

    /**
     * Scroll element to the top of the page (up to the begging of the header)
     * @param $el - a jQuery object
     * @param offset - number of pixels from the top of an element (default: 0)
     * @param {Number} delay - number of milliseconds before scroll (default: 500)
     * @param {Number} duration - number of milliseconds of scroll (default: slow)
     */
    scrollElToTop: function ($el, offset, delay, duration) {
        var position;
        offset = offset || 0;
        position = scrollHelper.getScrollTop($el) + offset;
        scrollHelper.scrollTo(position, delay, duration);
    },

    /**
     * Scroll element to the bottom of the page (where the element's bottom reached the bottom of the page)
     * @param $el - a jQuery object
     * @param offset - number of pixels from the bottom of an element (default: 0)
     * @param {Number} delay - number of milliseconds before scroll (default: 500)
     * @param {Number} duration - number of milliseconds of scroll (default: slow)
     */
    scrollElToBottom: function ($el, offset, delay, duration) {
        var position;
        offset = offset || 0;
        position = scrollHelper.getScrollBottom($el) + offset - scrollHelper.pageHeight();
        scrollHelper.scrollTo(position, delay, duration);
    },

    /**
     * Get scroll position in percentage
     * @returns {Number} - scroll position percent
     */
    getScrollPercent: function () {
        var scrollTop = scrollHelper.getWindowScroll();
        var docHeight = $(document).height();
        var winHeight = scrollHelper.windowHeight();

        return Math.round(scrollTop / (docHeight - winHeight) * 100);
    }

};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(840), __esModule: true };

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(934);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 554 */,
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(530);

var emptyObject = __webpack_require__(488);
var _invariant = __webpack_require__(489);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context',
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */


  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {

    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @nosideeffects
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'

  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function (Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function (Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function (Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
    },
    contextTypes: function (Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function (Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function (Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function (Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function () {} };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
         false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
      }

      return;
    }

    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);

      var isInherited = name in Constructor;
      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function (newThis) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
        } else if (!args.length) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedMixin = {
    componentDidMount: function () {
      this.__isMounted = true;
    },
    componentWillUnmount: function () {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {

    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function (newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function () {
      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function () {};
  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedMixin);
    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(555);

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = __webpack_require__(436);

var internals = {
    delimiter: '&',
    depth: 5,
    arrayLimit: 20,
    parameterLimit: 1000,
    strictNullHandling: false,
    plainObjects: false,
    allowPrototypes: false,
    allowDots: false
};

var has = Object.prototype.hasOwnProperty;

internals.parseValues = function (str, options) {
    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        if (pos === -1) {
            obj[Utils.decode(part)] = '';

            if (options.strictNullHandling) {
                obj[Utils.decode(part)] = null;
            }
        } else {
            var key = Utils.decode(part.slice(0, pos));
            var val = Utils.decode(part.slice(pos + 1));

            if (has.call(obj, key)) {
                obj[key] = [].concat(obj[key]).concat(val);
            } else {
                obj[key] = val;
            }
        }
    }

    return obj;
};

internals.parseObject = function (chain, val, options) {
    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val, options));
    } else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
        var index = parseInt(cleanRoot, 10);
        if (
            !isNaN(index) &&
            root !== cleanRoot &&
            String(index) === cleanRoot &&
            index >= 0 &&
            (options.parseArrays && index <= options.arrayLimit)
        ) {
            obj = [];
            obj[index] = internals.parseObject(chain, val, options);
        } else {
            obj[cleanRoot] = internals.parseObject(chain, val, options);
        }
    }

    return obj;
};

internals.parseKeys = function (givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^\.\[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts || {};
    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : internals.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;

    if (
        str === '' ||
        str === null ||
        typeof str === 'undefined'
    ) {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = internals.parseKeys(key, tempObj[key], options);
        obj = Utils.merge(obj, newObj, options);
    }

    return Utils.compact(obj);
};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = __webpack_require__(436);

var internals = {
    delimiter: '&',
    arrayPrefixGenerators: {
        brackets: function (prefix) {
            return prefix + '[]';
        },
        indices: function (prefix, key) {
            return prefix + '[' + key + ']';
        },
        repeat: function (prefix) {
            return prefix;
        }
    },
    strictNullHandling: false,
    skipNulls: false,
    encode: true
};

internals.stringify = function (object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort, allowDots) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (Utils.isBuffer(obj)) {
        obj = String(obj);
    } else if (obj instanceof Date) {
        obj = obj.toISOString();
    } else if (obj === null) {
        if (strictNullHandling) {
            return encode ? Utils.encode(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean') {
        if (encode) {
            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
        }
        return [prefix + '=' + obj];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort, allowDots));
        } else {
            values = values.concat(internals.stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort, allowDots));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts || {};
    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : internals.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : internals.encode;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        objKeys = filter = options.filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in internals.arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort, allowDots));
    }

    return keys.join(delimiter);
};


/***/ }),
/* 559 */,
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var User = __webpack_require__(15);
var ContextComponent = __webpack_require__(61);
var favoritePageActions = __webpack_require__(810);

var FavoriteButton = function (_ContextComponent) {
    _inherits(FavoriteButton, _ContextComponent);

    function FavoriteButton(props) {
        _classCallCheck(this, FavoriteButton);

        var _this = _possibleConstructorReturn(this, (FavoriteButton.__proto__ || Object.getPrototypeOf(FavoriteButton)).call(this, props));

        _this._onMouseEnter = _this._onMouseEnter.bind(_this);
        _this._onMouseLeave = _this._onMouseLeave.bind(_this);
        _this._handleClick = _this._handleClick.bind(_this);

        _this.state = {
            mouseIsOver: false,
            isLoading: false
        };
        return _this;
    }

    _createClass(FavoriteButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            User.getCurrentUser().on('login:change', function () {
                _this2._fetchFavoritePage();
            });

            this._fetchFavoritePage();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isSaved !== this.props.isSaved) {
                this.setState({ isLoading: false });
            }
        }
    }, {
        key: '_fetchFavoritePage',
        value: function _fetchFavoritePage() {
            if (User.loggedIn()) {
                var _props = this.props,
                    resetCollection = _props.resetCollection,
                    _props$favoriteData = _props.favoriteData,
                    type = _props$favoriteData.type,
                    page = _props$favoriteData.page,
                    solrQuery = _props$favoriteData.solrQuery;

                this.context.executeAction(favoritePageActions.fetchFavoritePage, { resetCollection: resetCollection, type: type, page: page, solrQuery: solrQuery });
            }
        }
    }, {
        key: '_onMouseEnter',
        value: function _onMouseEnter() {
            this.setState({ mouseIsOver: true });
            this.props.onMouseEnter();
        }
    }, {
        key: '_onMouseLeave',
        value: function _onMouseLeave() {
            this.setState({ mouseIsOver: false });
            this.props.onMouseLeave();
        }
    }, {
        key: '_handleClick',
        value: function _handleClick(event) {
            event.preventDefault();
            var isLoading = this.state.isLoading;


            if (isLoading) {
                return;
            }

            if (User.loggedIn()) {
                this.setState({ isLoading: true });
            }

            if (this.props.isSaved) {
                this._removeFromFavorites();
            } else {
                this._saveToFavorites();
            }

            this.props.onClick();
            this.props.onMouseLeave();
        }
    }, {
        key: '_saveToFavorites',
        value: function _saveToFavorites() {
            var _props2 = this.props,
                _props2$favoriteData = _props2.favoriteData,
                solrQuery = _props2$favoriteData.solrQuery,
                page = _props2$favoriteData.page,
                type = _props2$favoriteData.type,
                name = _props2$favoriteData.name,
                primaryKey = _props2$favoriteData.primaryKey,
                authModalOptions = _props2$favoriteData.authModalOptions,
                tracking = _props2.tracking.save;

            var payload = { solrQuery: solrQuery, page: page, type: type, name: name, primaryKey: primaryKey, authModalOptions: authModalOptions, tracking: tracking };
            this.context.executeAction(favoritePageActions.saveToFavorites, payload);
        }
    }, {
        key: '_removeFromFavorites',
        value: function _removeFromFavorites() {
            var _props3 = this.props,
                id = _props3.id,
                tracking = _props3.tracking.remove;

            var payload = { id: id, tracking: tracking };
            this.context.executeAction(favoritePageActions.removeFromFavorites, payload);
        }
    }, {
        key: 'render',
        value: function render() {
            var mouseIsOver = this.state.mouseIsOver;
            var _props4 = this.props,
                cta = _props4.cta,
                isSaved = _props4.isSaved;

            var buttonText = cta[isSaved.toString()];

            if (buttonText && buttonText.default && buttonText.hover) {
                buttonText = mouseIsOver ? buttonText.hover : buttonText.default;
            }

            return React.createElement(
                'a',
                { href: '#', className: this.props.className,
                    'data-tn': 'item-save',
                    onMouseEnter: this._onMouseEnter,
                    onMouseLeave: this._onMouseLeave,
                    onClick: this._handleClick
                },
                buttonText
            );
        }
    }]);

    return FavoriteButton;
}(ContextComponent);

FavoriteButton.defaultProps = {
    favoriteData: {
        solrQuery: '',
        page: '',
        name: '',
        type: '',
        primaryKey: '', // used for favoriting dealers/designers
        authModalOptions: {}
    },
    tracking: {
        save: {},
        remove: {}
    },
    onClick: function onClick() {},
    onMouseEnter: function onMouseEnter() {},
    onMouseLeave: function onMouseLeave() {}
};

FavoriteButton.propTypes = {
    id: PropTypes.number,
    className: PropTypes.string,
    favoriteData: PropTypes.shape({
        solrQuery: PropTypes.string,
        type: PropTypes.string.isRequired,
        page: PropTypes.string,
        primaryKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        authModalOptions: PropTypes.object
    }),
    cta: PropTypes.object.isRequired,
    tracking: PropTypes.object,
    isSaved: PropTypes.bool.isRequired,
    isFetched: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    resetCollection: PropTypes.bool
};

module.exports = FavoriteButton;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _display;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Measurement = __webpack_require__(599);

module.exports = Object.freeze({
    display: (_display = {}, _defineProperty(_display, Measurement.units.IN, 'in.'), _defineProperty(_display, Measurement.units.MM, 'mm'), _defineProperty(_display, Measurement.units.CM, 'cm'), _display),
    labels: {
        // are there constants for these properties?
        height: 'H',
        width: 'W',
        depth: 'D',
        length: 'L'
    }
});

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(927);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(923);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var createClass = __webpack_require__(556);

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = createClass({
	propTypes: {
		className: PropTypes.string, // className for the outer element
		defaultValue: PropTypes.any, // default field value
		inputClassName: PropTypes.string, // className for the input element
		inputStyle: PropTypes.object, // css styles for the input element
		minWidth: PropTypes.oneOfType([// minimum width for input element
		PropTypes.number, PropTypes.string]),
		onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
		onChange: PropTypes.func, // onChange handler: function(newValue) {}
		placeholder: PropTypes.string, // placeholder text
		placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
		style: PropTypes.object, // css styles for the outer element
		value: PropTypes.any },
	// field value
	getDefaultProps: function getDefaultProps() {
		return {
			minWidth: 1
		};
	},
	getInitialState: function getInitialState() {
		return {
			inputWidth: this.props.minWidth
		};
	},
	componentDidMount: function componentDidMount() {
		this.mounted = true;
		this.copyInputStyles();
		this.updateInputWidth();
	},
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		if (prevState.inputWidth !== this.state.inputWidth) {
			if (typeof this.props.onAutosize === 'function') {
				this.props.onAutosize(this.state.inputWidth);
			}
		}
		this.updateInputWidth();
	},
	componentWillUnmount: function componentWillUnmount() {
		this.mounted = false;
	},
	inputRef: function inputRef(el) {
		this.input = el;
	},
	placeHolderSizerRef: function placeHolderSizerRef(el) {
		this.placeHolderSizer = el;
	},
	sizerRef: function sizerRef(el) {
		this.sizer = el;
	},
	copyInputStyles: function copyInputStyles() {
		if (this.mounted || !window.getComputedStyle) {
			return;
		}
		var inputStyle = this.input && window.getComputedStyle(this.input);
		if (!inputStyle) {
			return;
		}
		var widthNode = this.sizer;
		widthNode.style.fontSize = inputStyle.fontSize;
		widthNode.style.fontFamily = inputStyle.fontFamily;
		widthNode.style.fontWeight = inputStyle.fontWeight;
		widthNode.style.fontStyle = inputStyle.fontStyle;
		widthNode.style.letterSpacing = inputStyle.letterSpacing;
		widthNode.style.textTransform = inputStyle.textTransform;
		if (this.props.placeholder) {
			var placeholderNode = this.placeHolderSizer;
			placeholderNode.style.fontSize = inputStyle.fontSize;
			placeholderNode.style.fontFamily = inputStyle.fontFamily;
			placeholderNode.style.fontWeight = inputStyle.fontWeight;
			placeholderNode.style.fontStyle = inputStyle.fontStyle;
			placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			placeholderNode.style.textTransform = inputStyle.textTransform;
		}
	},
	updateInputWidth: function updateInputWidth() {
		if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
			return;
		}
		var newInputWidth = undefined;
		if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
			newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
		} else {
			newInputWidth = this.sizer.scrollWidth + 2;
		}
		if (newInputWidth < this.props.minWidth) {
			newInputWidth = this.props.minWidth;
		}
		if (newInputWidth !== this.state.inputWidth) {
			this.setState({
				inputWidth: newInputWidth
			});
		}
	},
	getInput: function getInput() {
		return this.input;
	},
	focus: function focus() {
		this.input.focus();
	},
	blur: function blur() {
		this.input.blur();
	},
	select: function select() {
		this.input.select();
	},
	render: function render() {
		var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
			if (previousValue !== null && previousValue !== undefined) {
				return previousValue;
			}
			return currentValue;
		});

		var wrapperStyle = this.props.style || {};
		if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
		var inputStyle = _extends({}, this.props.inputStyle);
		inputStyle.width = this.state.inputWidth + 'px';
		inputStyle.boxSizing = 'content-box';
		var inputProps = _extends({}, this.props);
		inputProps.className = this.props.inputClassName;
		inputProps.style = inputStyle;
		// ensure props meant for `AutosizeInput` don't end up on the `input`
		delete inputProps.inputClassName;
		delete inputProps.inputStyle;
		delete inputProps.minWidth;
		delete inputProps.onAutosize;
		delete inputProps.placeholderIsMinWidth;
		return React.createElement(
			'div',
			{ className: this.props.className, style: wrapperStyle },
			React.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
			React.createElement(
				'div',
				{ ref: this.sizerRef, style: sizerStyle },
				sizerValue
			),
			this.props.placeholder ? React.createElement(
				'div',
				{ ref: this.placeHolderSizerRef, style: sizerStyle },
				this.props.placeholder
			) : null
		);
	}
});

module.exports = AutosizeInput;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(333);

var _Select2 = _interopRequireDefault(_Select);

var _utilsStripDiacritics = __webpack_require__(446);

var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);

var propTypes = {
	autoload: _react2['default'].PropTypes.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _react2['default'].PropTypes.any, // object to use to cache results; set to null/false to disable caching
	children: _react2['default'].PropTypes.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _react2['default'].PropTypes.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _react2['default'].PropTypes.bool, // perform case-insensitive filtering; defaults to true
	loadingPlaceholder: _react2['default'].PropTypes.oneOfType([// replaces the placeholder while options are loading
	_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
	loadOptions: _react2['default'].PropTypes.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	options: _react.PropTypes.array.isRequired, // array of options
	placeholder: _react2['default'].PropTypes.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
	noResultsText: _react2['default'].PropTypes.oneOfType([// field noResultsText, displayed when no options come back from the server
	_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
	onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
	searchPromptText: _react2['default'].PropTypes.oneOfType([// label to prompt for search input
	_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
	onInputChange: _react2['default'].PropTypes.func, // optional for keeping track of what is being typed
	value: _react2['default'].PropTypes.any };

// initial field value
var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = (function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);

		this._cache = props.cache === defaultCache ? {} : props.cache;

		this.state = {
			isLoading: false,
			options: props.options
		};

		this._onInputChange = this._onInputChange.bind(this);
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;

			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			var _this = this;

			var propertiesToSync = ['options'];
			propertiesToSync.forEach(function (prop) {
				if (_this.props[prop] !== nextProps[prop]) {
					_this.setState(_defineProperty({}, prop, nextProps[prop]));
				}
			});
		}
	}, {
		key: 'clearOptions',
		value: function clearOptions() {
			this.setState({ options: [] });
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && cache.hasOwnProperty(inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this2._callback) {
					_this2._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}

			return inputValue;
		}
	}, {
		key: '_onInputChange',
		value: function _onInputChange(inputValue) {
			var _props = this.props;
			var ignoreAccents = _props.ignoreAccents;
			var ignoreCase = _props.ignoreCase;
			var onInputChange = _props.onInputChange;

			if (ignoreAccents) {
				inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
			}

			if (ignoreCase) {
				inputValue = inputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(inputValue);
			}

			return this.loadOptions(inputValue);
		}
	}, {
		key: 'inputValue',
		value: function inputValue() {
			if (this.select) {
				return this.select.state.inputValue;
			}
			return '';
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props;
			var loadingPlaceholder = _props2.loadingPlaceholder;
			var noResultsText = _props2.noResultsText;
			var searchPromptText = _props2.searchPromptText;
			var isLoading = this.state.isLoading;

			var inputValue = this.inputValue();

			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props;
			var children = _props3.children;
			var loadingPlaceholder = _props3.loadingPlaceholder;
			var placeholder = _props3.placeholder;
			var _state = this.state;
			var isLoading = _state.isLoading;
			var options = _state.options;

			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				},
				onChange: function onChange(newValues) {
					if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
						_this3.clearOptions();
					}
					_this3.props.onChange(newValues);
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this._onInputChange
			}));
		}
	}]);

	return Async;
})(_react.Component);

exports['default'] = Async;

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
};
module.exports = exports['default'];

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(333);

var _Select2 = _interopRequireDefault(_Select);

function reduce(obj) {
	var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatable = _react2['default'].createClass({
	displayName: 'AsyncCreatableSelect',

	render: function render() {
		var _this = this;

		return _react2['default'].createElement(
			_Select2['default'].Async,
			this.props,
			function (asyncProps) {
				return _react2['default'].createElement(
					_Select2['default'].Creatable,
					_this.props,
					function (creatableProps) {
						return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
							onInputChange: function (input) {
								creatableProps.onInputChange(input);
								return asyncProps.onInputChange(input);
							},
							ref: function (ref) {
								creatableProps.ref(ref);
								asyncProps.ref(ref);
							}
						}));
					}
				);
			}
		);
	}
});

module.exports = AsyncCreatable;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(333);

var _Select2 = _interopRequireDefault(_Select);

var _utilsDefaultFilterOptions = __webpack_require__(444);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(445);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var Creatable = _react2['default'].createClass({
	displayName: 'CreatableSelect',

	propTypes: {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _react2['default'].PropTypes.func,

		// See Select.propTypes.filterOptions
		filterOptions: _react2['default'].PropTypes.any,

		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _react2['default'].PropTypes.func,

		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _react2['default'].PropTypes.func,

		// See Select.propTypes.menuRenderer
		menuRenderer: _react2['default'].PropTypes.any,

		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _react2['default'].PropTypes.func,

		// input change handler: function (inputValue) {}
		onInputChange: _react2['default'].PropTypes.func,

		// input keyDown handler: function (event) {}
		onInputKeyDown: _react2['default'].PropTypes.func,

		// new option click handler: function (option) {}
		onNewOptionClick: _react2['default'].PropTypes.func,

		// See Select.propTypes.options
		options: _react2['default'].PropTypes.array,

		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _react2['default'].PropTypes.func,

		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _react2['default'].PropTypes.func
	},

	// Default prop methods
	statics: {
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	},

	getDefaultProps: function getDefaultProps() {
		return {
			filterOptions: _utilsDefaultFilterOptions2['default'],
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		};
	},

	createNewOption: function createNewOption() {
		var _props = this.props;
		var isValidNewOption = _props.isValidNewOption;
		var newOptionCreator = _props.newOptionCreator;
		var onNewOptionClick = _props.onNewOptionClick;
		var _props$options = _props.options;
		var options = _props$options === undefined ? [] : _props$options;
		var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;

		if (isValidNewOption({ label: this.inputValue })) {
			var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
			var _isOptionUnique = this.isOptionUnique({ option: option });

			// Don't add the same option twice.
			if (_isOptionUnique) {
				if (onNewOptionClick) {
					onNewOptionClick(option);
				} else {
					options.unshift(option);

					this.select.selectValue(option);
				}
			}
		}
	},

	filterOptions: function filterOptions() {
		var _props2 = this.props;
		var filterOptions = _props2.filterOptions;
		var isValidNewOption = _props2.isValidNewOption;
		var options = _props2.options;
		var promptTextCreator = _props2.promptTextCreator;

		// TRICKY Check currently selected options as well.
		// Don't display a create-prompt for a value that's selected.
		// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
		var excludeOptions = arguments[2] || [];

		var filteredOptions = filterOptions.apply(undefined, arguments) || [];

		if (isValidNewOption({ label: this.inputValue })) {
			var _newOptionCreator = this.props.newOptionCreator;

			var option = _newOptionCreator({
				label: this.inputValue,
				labelKey: this.labelKey,
				valueKey: this.valueKey
			});

			// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
			// For multi-selects, this would remove it from the filtered list.
			var _isOptionUnique2 = this.isOptionUnique({
				option: option,
				options: excludeOptions.concat(filteredOptions)
			});

			if (_isOptionUnique2) {
				var _prompt = promptTextCreator(this.inputValue);

				this._createPlaceholderOption = _newOptionCreator({
					label: _prompt,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				filteredOptions.unshift(this._createPlaceholderOption);
			}
		}

		return filteredOptions;
	},

	isOptionUnique: function isOptionUnique(_ref2) {
		var option = _ref2.option;
		var options = _ref2.options;
		var isOptionUnique = this.props.isOptionUnique;

		options = options || this.select.filterOptions();

		return isOptionUnique({
			labelKey: this.labelKey,
			option: option,
			options: options,
			valueKey: this.valueKey
		});
	},

	menuRenderer: function menuRenderer(params) {
		var menuRenderer = this.props.menuRenderer;

		return menuRenderer(_extends({}, params, {
			onSelect: this.onOptionSelect,
			selectValue: this.onOptionSelect
		}));
	},

	onInputChange: function onInputChange(input) {
		var onInputChange = this.props.onInputChange;

		if (onInputChange) {
			onInputChange(input);
		}

		// This value may be needed in between Select mounts (when this.select is null)
		this.inputValue = input;
	},

	onInputKeyDown: function onInputKeyDown(event) {
		var _props3 = this.props;
		var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
		var onInputKeyDown = _props3.onInputKeyDown;

		var focusedOption = this.select.getFocusedOption();

		if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
			this.createNewOption();

			// Prevent decorated Select from doing anything additional with this keyDown event
			event.preventDefault();
		} else if (onInputKeyDown) {
			onInputKeyDown(event);
		}
	},

	onOptionSelect: function onOptionSelect(option, event) {
		if (option === this._createPlaceholderOption) {
			this.createNewOption();
		} else {
			this.select.selectValue(option);
		}
	},

	render: function render() {
		var _this = this;

		var _props4 = this.props;
		var newOptionCreator = _props4.newOptionCreator;
		var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;

		var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);

		var children = this.props.children;

		// We can't use destructuring default values to set the children,
		// because it won't apply work if `children` is null. A falsy check is
		// more reliable in real world use-cases.
		if (!children) {
			children = defaultChildren;
		}

		var props = _extends({}, restProps, {
			allowCreate: true,
			filterOptions: this.filterOptions,
			menuRenderer: this.menuRenderer,
			onInputChange: this.onInputChange,
			onInputKeyDown: this.onInputKeyDown,
			ref: function ref(_ref) {
				_this.select = _ref;

				// These values may be needed in between Select mounts (when this.select is null)
				if (_ref) {
					_this.labelKey = _ref.props.labelKey;
					_this.valueKey = _ref.props.valueKey;
				}
			}
		});

		return children(props);
	}
});

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
};

function isOptionUnique(_ref3) {
	var option = _ref3.option;
	var options = _ref3.options;
	var labelKey = _ref3.labelKey;
	var valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
};

function newOptionCreator(_ref5) {
	var label = _ref5.label;
	var labelKey = _ref5.labelKey;
	var valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
};

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
	}

	return false;
};

module.exports = Creatable;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(337);

var _classnames2 = _interopRequireDefault(_classnames);

var Option = _react2['default'].createClass({
	displayName: 'Option',

	propTypes: {
		children: _react2['default'].PropTypes.node,
		className: _react2['default'].PropTypes.string, // className (based on mouse position)
		instancePrefix: _react2['default'].PropTypes.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
		isFocused: _react2['default'].PropTypes.bool, // the option is focused
		isSelected: _react2['default'].PropTypes.bool, // the option is selected
		onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
		onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
		onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
		option: _react2['default'].PropTypes.object.isRequired, // object that is base for that option
		optionIndex: _react2['default'].PropTypes.number },
	// index of the option, used to generate unique ids for aria
	blockEvent: function blockEvent(event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	},

	handleMouseDown: function handleMouseDown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	},

	handleMouseEnter: function handleMouseEnter(event) {
		this.onFocus(event);
	},

	handleMouseMove: function handleMouseMove(event) {
		this.onFocus(event);
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		this.handleMouseDown(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	onFocus: function onFocus(event) {
		if (!this.props.isFocused) {
			this.props.onFocus(this.props.option, event);
		}
	},
	render: function render() {
		var _props = this.props;
		var option = _props.option;
		var instancePrefix = _props.instancePrefix;
		var optionIndex = _props.optionIndex;

		var className = (0, _classnames2['default'])(this.props.className, option.className);

		return option.disabled ? _react2['default'].createElement(
			'div',
			{ className: className,
				onMouseDown: this.blockEvent,
				onClick: this.blockEvent },
			this.props.children
		) : _react2['default'].createElement(
			'div',
			{ className: className,
				style: option.style,
				role: 'option',
				onMouseDown: this.handleMouseDown,
				onMouseEnter: this.handleMouseEnter,
				onMouseMove: this.handleMouseMove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEnd,
				id: instancePrefix + '-option-' + optionIndex,
				title: option.title },
			this.props.children
		);
	}
});

module.exports = Option;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(337);

var _classnames2 = _interopRequireDefault(_classnames);

var Value = _react2['default'].createClass({

	displayName: 'Value',

	propTypes: {
		children: _react2['default'].PropTypes.node,
		disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
		id: _react2['default'].PropTypes.string, // Unique id for the value - used for aria
		onClick: _react2['default'].PropTypes.func, // method to handle click on value label
		onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
		value: _react2['default'].PropTypes.object.isRequired },

	// the option object for this value
	handleMouseDown: function handleMouseDown(event) {
		if (event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		if (this.props.onClick) {
			event.stopPropagation();
			this.props.onClick(this.props.value, event);
			return;
		}
		if (this.props.value.href) {
			event.stopPropagation();
		}
	},

	onRemove: function onRemove(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onRemove(this.props.value);
	},

	handleTouchEndRemove: function handleTouchEndRemove(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.onRemove(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	renderRemoveIcon: function renderRemoveIcon() {
		if (this.props.disabled || !this.props.onRemove) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-value-icon',
				'aria-hidden': 'true',
				onMouseDown: this.onRemove,
				onTouchEnd: this.handleTouchEndRemove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove },
			'×'
		);
	},

	renderLabel: function renderLabel() {
		var className = 'Select-value-label';
		return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
			'a',
			{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
			this.props.children
		) : _react2['default'].createElement(
			'span',
			{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
			this.props.children
		);
	},

	render: function render() {
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
				style: this.props.value.style,
				title: this.props.value.title
			},
			this.renderRemoveIcon(),
			this.renderLabel()
		);
	}

});

module.exports = Value;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports["default"] = arrowRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2["default"].createElement("span", {
		className: "Select-arrow",
		onMouseDown: onMouseDown
	});
}

;
module.exports = exports["default"];

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = clearRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function clearRenderer() {
	return _react2['default'].createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
}

;
module.exports = exports['default'];

/***/ }),
/* 574 */,
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CreatorsStore = {
    storeName: 'CreatorsStore',

    initialState: {
        creatorsMap: {}
    },

    reducers: {
        ADD_CREATOR: function ADD_CREATOR(state, creator) {
            return Object.assign({}, state, {
                creatorsMap: Object.assign({}, state.creatorsMap, _defineProperty({}, creator.id, creator))
            });
        },
        ADD_CREATORS: function ADD_CREATORS(state, creators) {
            return Object.assign({}, state, {
                creatorsMap: creators.reduce(function (creatorsMap, creator) {
                    creatorsMap[creator.id] = creator;
                    return creatorsMap;
                }, Object.assign({}, state.creatorsMap))
            });
        }
    },

    getters: {
        getCreatorsMap: function getCreatorsMap(state) {
            return state.creatorsMap;
        },
        getCreatorById: function getCreatorById(state, creatorId) {
            return state.creatorsMap[creatorId];
        }
    }

};

module.exports = CreatorsStore;

/***/ }),
/* 576 */,
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-buyer-assurance'].join(' '), viewBox: '0 0 518 518' },
                React.createElement(
                    'g',
                    null,
                    React.createElement('polygon', { points: '221.6,315.6 168.3,252.2 139.2,276.7 220.6,373.4 375.8,201.2 347.6,175.8    ' }),
                    React.createElement('path', { d: 'M488,205.8c-7-9.7-13-28-13-40v-34.8c0-16.8-12.5-34.1-28.5-39.3l-33.1-10.7c-11.4-3.7-27-15-34-24.7l-20.4-28.1 c-7.4-10.2-21-16.8-34.6-16.8c-4.1,0-7.9,0.6-11.5,1.8L279.7,24c-5.4,1.8-13.1,2.8-21,2.8c-8,0-15.6-1-21-2.8l-33.1-10.7 c-3.6-1.2-7.5-1.8-11.5-1.8c-13.6,0-27.2,6.6-34.6,16.8l-20.4,28.1c-7,9.7-22.6,21-34,24.7L71,91.8c-16,5.2-28.5,22.4-28.5,39.3 v34.8c0,12-5.9,30.3-13,40L9,233.9c-9.9,13.6-9.9,34.9,0,48.5l20.4,28.1c7,9.7,13,28,13,40v34.8c0,16.8,12.5,34.1,28.5,39.3 l33.1,10.7c11.4,3.7,27,15,34,24.7l20.4,28.1c7.4,10.2,21,16.8,34.6,16.8c4.1,0,7.9-0.6,11.5-1.8l33.1-10.7 c5.4-1.8,13.1-2.8,21-2.8c8,0,15.6,1,21,2.8l33.1,10.7c3.6,1.2,7.5,1.8,11.5,1.8c13.6,0,27.2-6.6,34.6-16.8l20.4-28.1 c7-9.7,22.6-21,34-24.7l33.1-10.7c16-5.2,28.5-22.4,28.5-39.3v-34.8c0-12,6-30.3,13-40l20.4-28.1c9.9-13.6,9.9-34.9,0-48.5 L488,205.8z M496.2,273.7l-20.4,28.1c-8.9,12.2-15.9,33.7-15.9,48.8v34.8c0,10.2-8.5,21.8-18.2,25l-33.1,10.7 c-14.4,4.7-32.6,17.9-41.5,30.2l-20.4,28.1c-4.5,6.2-13.8,10.6-22.5,10.6c-2.5,0-4.8-0.3-6.9-1l-33.1-10.7 c-6.9-2.3-16-3.5-25.7-3.5c-9.6,0-18.7,1.2-25.7,3.5L200,488.9c-2.1,0.7-4.4,1-6.9,1c-8.7,0-18-4.3-22.5-10.6l-20.4-28.1 c-8.9-12.2-27.1-25.5-41.5-30.2l-33.1-10.7c-9.7-3.1-18.2-14.8-18.2-25v-34.8c0-15.1-7-36.6-15.9-48.8l-20.4-28.1 c-6-8.2-6-22.7,0-30.9l20.4-28.1c8.9-12.2,15.9-33.7,15.9-48.8v-34.8c0-10.2,8.5-21.8,18.2-25l33.1-10.7 c14.4-4.7,32.6-17.9,41.5-30.2l20.4-28.1c4.5-6.2,13.8-10.6,22.5-10.6c2.5,0,4.8,0.3,6.9,1l33.1,10.7c6.9,2.3,16,3.5,25.7,3.5 c9.6,0,18.7-1.2,25.7-3.5l33.1-10.7c2.1-0.7,4.4-1,6.9-1c8.7,0,18,4.3,22.5,10.6l20.4,28.1c8.9,12.2,27.1,25.5,41.5,30.2l33.1,10.7 c9.7,3.1,18.2,14.8,18.2,25v34.8c0,15.1,7,36.6,15.9,48.8l20.4,28.1C502.2,251,502.2,265.4,496.2,273.7z' })
                )
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-envelope'].join(' '), viewBox: '0 0 518 518' },
                React.createElement('path', { d: 'M3,444.9V77.8h512v367.1H3z M498,427.9V107.4L259.5,315.5L20,106.3v321.6H498z M259.5,292.9l227-198.1H32.7 L259.5,292.9z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 579 */,
/* 580 */,
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ReactDOM = __webpack_require__(40);
var renderSubtreeIntoContainer = ReactDOM.unstable_renderSubtreeIntoContainer;
var root = __webpack_require__(97);

var ContextComponent = __webpack_require__(61);
var stickyAlertPortal = React.createFactory(__webpack_require__(637));

var StickyAlert = function (_ContextComponent) {
    _inherits(StickyAlert, _ContextComponent);

    function StickyAlert() {
        _classCallCheck(this, StickyAlert);

        return _possibleConstructorReturn(this, (StickyAlert.__proto__ || Object.getPrototypeOf(StickyAlert)).apply(this, arguments));
    }

    _createClass(StickyAlert, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var container = root.document.querySelector(this.props.nodeSelector);
            this.portal = document.createElement('div');
            this.portal.className = 'stickyAlertPortal';
            container.appendChild(this.portal);

            // creating `portal` where StickyAlert children will be placed when `isOpen` is `true`
            this._renderPortal(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this._renderPortal(newProps);
            this.portal.classList.toggle('isOpen', newProps.isOpen);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            ReactDOM.unmountComponentAtNode(this.portal);

            try {
                document.body.removeChild(this.portal);
            } catch (err) {
                // Nothing to catch
            }
        }
    }, {
        key: '_renderPortal',
        value: function _renderPortal(props) {
            this.portalComponent = renderSubtreeIntoContainer(this, stickyAlertPortal(props), this.portal);
        }
    }, {
        key: 'render',
        value: function render() {
            return React.DOM.noscript();
        }
    }]);

    return StickyAlert;
}(ContextComponent);

StickyAlert.propTypes = {
    isOpen: PropTypes.bool,
    nodeSelector: PropTypes.string.isRequired
};

module.exports = StickyAlert;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);

var _require = __webpack_require__(67),
    noop = _require.noop;

var PageModel = __webpack_require__(597);
var BaseCarousel = __webpack_require__(364);
var ArrowCarouselComponent = __webpack_require__(598);
var DotCarousel = __webpack_require__(392);

/**
 * Represents a carousel with arrows for paging through the list.
 * @class
 */

var ArrowCarousel = function (_React$Component) {
    _inherits(ArrowCarousel, _React$Component);

    function ArrowCarousel(props) {
        _classCallCheck(this, ArrowCarousel);

        // Todo refactor model logic into a store
        var _this = _possibleConstructorReturn(this, (ArrowCarousel.__proto__ || Object.getPrototypeOf(ArrowCarousel)).call(this, props));

        _this._model = new PageModel({
            itemsPerPage: props.itemsPerPage,
            itemCount: React.Children.count(props.children),
            onPageChange: props.onPageChange,
            startingPage: props.startingPage,
            transitionEffect: props.transitionEffect,
            // Force a re-render if the model changes.
            onStateChange: function onStateChange(modelState) {
                return _this.setState({ modelState: modelState });
            },
            customTransformItemStyle: props.customTransformItemStyle
        });

        //// Set the initial model state. This is probably unnecessary but put here to avoid issues if state gets used
        //// in `render` in the future.
        _this.state = {
            modelState: _this._model.getState()
        };

        _this._onLeftArrowClick = _this._onLeftArrowClick.bind(_this);
        _this._onRightArrowClick = _this._onRightArrowClick.bind(_this);
        return _this;
    }

    /**
     * Imperatively set the page from outside the component, e.g. if the state of this carousel needs to be kept
     * constistent with another carousel.
     *
     * @param {number} page - The page to set.
     * @param {object} model - Model to update, needed for components where this method gets passed.
     * @param {function} callback
    */


    _createClass(ArrowCarousel, [{
        key: 'setPage',
        value: function setPage(page) {
            var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._model;
            var callback = arguments[2];

            // Update the model which will in turn trigger an update to the view state and force a re-render.
            if (callback) {
                callback();
            }

            model.jumpToPage(page);
        }

        /**
         * Method to handle the left carousel arrow click.
         */

    }, {
        key: '_onLeftArrowClick',
        value: function _onLeftArrowClick() {
            var onLeftArrowClick = this.props.onLeftArrowClick;


            this._model.previousPage();

            if (onLeftArrowClick) {
                onLeftArrowClick(this._model.getState().page);
            }
        }

        /**
         * Method to handle the right carousel arrow click.
         */

    }, {
        key: '_onRightArrowClick',
        value: function _onRightArrowClick() {
            var onRightArrowClick = this.props.onRightArrowClick;


            this._model.nextPage();

            if (onRightArrowClick) {
                onRightArrowClick(this._model.getState().page);
            }
        }

        /**
         * Method to create a basic carousel which then can be shown or wrapped by other components.
         *
         * @returns {object} - JSX of a carousel.
         */

    }, {
        key: '_createCarousel',
        value: function _createCarousel() {
            return React.createElement(
                BaseCarousel,
                { model: this._model, classNames: { list: this._listClass, item: this._itemClass } },
                this.props.children
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _this2 = this;

            var _props = this.props,
                _props$classNames = _props.classNames,
                list = _props$classNames.list,
                item = _props$classNames.item,
                auto = _props.auto,
                useDotsNav = _props.useDotsNav;

            var canPaginate = this._model.canPaginate();

            this._listClass = classnames((_classnames = {}, _defineProperty(_classnames, 'arrow-carousel-list', true), _defineProperty(_classnames, list, list), _classnames));
            this._itemClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, 'arrow-carousel-item', true), _defineProperty(_classnames2, item, item), _classnames2));

            if (auto || useDotsNav) {
                return React.createElement(DotCarousel, {
                    model: this._model,
                    classNames: this.props.classNames,
                    createCarousel: function createCarousel() {
                        return _this2._createCarousel();
                    },
                    setPage: this.setPage,
                    autoDuration: this.props.autoDuration,
                    dotsPosition: this.props.dotsPosition,
                    dotsColorType: this.props.dotsColorType,
                    onDotClick: this.props.onDotClick,
                    auto: auto
                });
            }

            return React.createElement(ArrowCarouselComponent, {
                showArrows: canPaginate,
                createCarousel: function createCarousel() {
                    return _this2._createCarousel();
                },
                onLeftArrowClick: function onLeftArrowClick() {
                    return _this2._onLeftArrowClick();
                },
                onRightArrowClick: function onRightArrowClick() {
                    return _this2._onRightArrowClick();
                },
                classNames: this.props.classNames
            });
        }
    }]);

    return ArrowCarousel;
}(React.Component);

ArrowCarousel.propTypes = {
    onPageChange: PropTypes.func,
    // Change the number of items to display per carousel page.
    itemsPerPage: PropTypes.number,
    startingPage: PropTypes.number,
    transitionEffect: PropTypes.string,
    classNames: PropTypes.object,
    children: PropTypes.node,
    useDotsNav: PropTypes.bool,
    auto: PropTypes.bool,
    autoDuration: PropTypes.number,
    dotsColorType: PropTypes.oneOf(['buyer', 'trade']),
    dotsPosition: PropTypes.oneOf(['left', 'right']),
    onDotClick: PropTypes.func.isRequired,
    onLeftArrowClick: PropTypes.func,
    onRightArrowClick: PropTypes.func,
    customTransformItemStyle: PropTypes.func
};

ArrowCarousel.defaultProps = {
    autoDuration: 5000,
    itemsPerPage: 1,
    onPageChange: noop,
    onDotClick: noop,
    startingPage: 0,
    classNames: {},
    auto: false
};

module.exports = ArrowCarousel;

/***/ }),
/* 583 */,
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var raf = __webpack_require__(643),
    COMPLETE = 'complete',
    CANCELED = 'canceled';

function setElementScroll(element, x, y){
    if(element === window){
        element.scrollTo(x, y);
    }else{
        element.scrollLeft = x;
        element.scrollTop = y;
    }
}

function getTargetScrollLocation(target, parent, align){
    var targetPosition = target.getBoundingClientRect(),
        parentPosition,
        x,
        y,
        differenceX,
        differenceY,
        leftAlign = align && align.left != null ? align.left : 0.5,
        topAlign = align && align.top != null ? align.top : 0.5,
        leftScalar = leftAlign,
        topScalar = topAlign;

    if(parent === window){
        x = targetPosition.left + window.scrollX - window.innerWidth * leftScalar + Math.min(targetPosition.width, window.innerWidth) * leftScalar;
        y = targetPosition.top + window.scrollY - window.innerHeight * topScalar + Math.min(targetPosition.height, window.innerHeight) * topScalar;
        x = Math.max(Math.min(x, document.body.scrollWidth - window.innerWidth * leftScalar), 0);
        y = Math.max(Math.min(y, document.body.scrollHeight- window.innerHeight * topScalar), 0);
        differenceX = x - window.scrollX;
        differenceY = y - window.scrollY;
    }else{
        parentPosition = parent.getBoundingClientRect();
        var offsetTop = targetPosition.top - (parentPosition.top - parent.scrollTop);
        var offsetLeft = targetPosition.left - (parentPosition.left - parent.scrollLeft);
        x = offsetLeft + (targetPosition.width * leftScalar) - parent.clientWidth * leftScalar;
        y = offsetTop + (targetPosition.height * topScalar) - parent.clientHeight * topScalar;
        x = Math.max(Math.min(x, parent.scrollWidth - parent.clientWidth), 0);
        y = Math.max(Math.min(y, parent.scrollHeight - parent.clientHeight), 0);
        differenceX = x - parent.scrollLeft;
        differenceY = y - parent.scrollTop;
    }

    return {
        x: x,
        y: y,
        differenceX: differenceX,
        differenceY: differenceY
    };
}

function animate(parent){
    raf(function(){
        var scrollSettings = parent._scrollSettings;
        if(!scrollSettings){
            return;
        }

        var location = getTargetScrollLocation(scrollSettings.target, parent, scrollSettings.align),
            time = Date.now() - scrollSettings.startTime,
            timeValue = Math.min(1 / scrollSettings.time * time, 1);

        if(
            time > scrollSettings.time + 20 ||
            (Math.abs(location.differenceY) <= 1 && Math.abs(location.differenceX) <= 1)
        ){
            setElementScroll(parent, location.x, location.y);
            parent._scrollSettings = null;
            return scrollSettings.end(COMPLETE);
        }

        var valueX = timeValue,
            valueY = timeValue;

        setElementScroll(parent,
            location.x - location.differenceX * Math.pow(1 - valueX, valueX / 2),
            location.y - location.differenceY * Math.pow(1 - valueY, valueY / 2)
        );

        animate(parent);
    });
}

function transitionScrollTo(target, parent, settings, callback){
    var idle = !parent._scrollSettings;

    if(parent._scrollSettings){
        parent._scrollSettings.end(CANCELED);
    }

    function end(endType){
        parent._scrollSettings = null;
        callback(endType);
        parent.removeEventListener('touchstart', end);
    }

    parent._scrollSettings = {
        startTime: Date.now(),
        target: target,
        time: settings.time,
        ease: settings.ease,
        align: settings.align,
        end: end
    };
    parent.addEventListener('touchstart', end.bind(null, CANCELED));

    if(idle){
        animate(parent);
    }
}

module.exports = function(target, settings, callback){
    if(!target){
        return;
    }

    if(typeof settings === 'function'){
        callback = settings;
        settings = null;
    }

    if(!settings){
        settings = {};
    }

    settings.time = settings.time || 1000;
    settings.ease = settings.ease || function(v){return v;};

    var parent = target.parentElement,
        parents = 0;

    function done(endType){
        parents--;
        if(!parents){
            callback && callback(endType);
        }
    }

    while(parent){
        if(
            settings.validTarget ? settings.validTarget(parent, parents) : true &&
            parent === window ||
            (
                parent.scrollHeight !== parent.clientHeight ||
                parent.scrollWidth !== parent.clientWidth
            ) &&
            getComputedStyle(parent).overflow !== 'hidden'
        ){
            parents++;
            transitionScrollTo(target, parent, settings, done);
        }

        parent = parent.parentElement;

        if(!parent){
            return;
        }

        if(parent.tagName === 'BODY'){
            parent = window;
        }
    }
};

/***/ }),
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var partial = __webpack_require__(454);
var Tooltip = __webpack_require__(270);
__webpack_require__(272);
var root = __webpack_require__(97);
var mobileCheck = __webpack_require__(279);
var ContextComponent = __webpack_require__(61);
var CloseIcon = __webpack_require__(276);
var calloutActions = __webpack_require__(491);
var css = __webpack_require__(622);

var Callout = function (_ContextComponent) {
    _inherits(Callout, _ContextComponent);

    function Callout(props) {
        _classCallCheck(this, Callout);

        var _this = _possibleConstructorReturn(this, (Callout.__proto__ || Object.getPrototypeOf(Callout)).call(this, props));

        var calloutType = props.callout[props.type];

        _this.state = {
            isOpen: calloutType && calloutType.isOpen
        };

        _this._handleClick = _this._handleClick.bind(_this);
        _this._handleScroll = _this._handleScroll.bind(_this);
        _this._handleCloseClick = _this._handleCloseClick.bind(_this);
        return _this;
    }

    _createClass(Callout, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var calloutType = nextProps.callout[nextProps.type];
            this.setState({ isOpen: calloutType && calloutType.isOpen });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!prevState.isOpen && this.state.isOpen) {
                this._openTooltip();
            } else if (prevState.isOpen && !this.state.isOpen) {
                this._removeCloseListeners();
            }
        }
    }, {
        key: '_removeCloseListeners',
        value: function _removeCloseListeners() {
            root.removeEventListener('click', this._handleClick);
            root.removeEventListener('scroll', this._handleScroll);
        }
    }, {
        key: '_addCloseListeners',
        value: function _addCloseListeners() {
            this._handleScroll = partial(this._handleScroll, this.props.scrollToClose);

            if (this.props.scrollToClose > 0) {
                root.addEventListener('scroll', this._handleScroll);
            }

            if (this._handleScroll()) {
                root.addEventListener('click', this._handleClick);
            }
        }
    }, {
        key: '_handleClick',
        value: function _handleClick(event) {
            if (this._callout && !this._callout.contains(event.target)) {
                this._closeTooltip();
            }
        }
    }, {
        key: '_handleScroll',
        value: function _handleScroll(scrollToClose) {
            if (root.pageYOffset >= scrollToClose && scrollToClose !== 0) {
                this._closeTooltip();
                return false;
            }
            return true;
        }
    }, {
        key: '_openTooltip',
        value: function _openTooltip() {
            var _props = this.props,
                type = _props.type,
                onOpen = _props.onOpen;

            this._addCloseListeners();
            onOpen(type);
        }
    }, {
        key: '_closeTooltip',
        value: function _closeTooltip() {
            var type = this.props.type;

            this.context.executeAction(calloutActions.closeCallout, { type: type });
        }
    }, {
        key: '_handleCloseClick',
        value: function _handleCloseClick(event) {
            var onCloseClick = this.props.onCloseClick;

            event.preventDefault();
            if (onCloseClick) {
                onCloseClick();
            }
            this._closeTooltip();
            this.context.executeAction(calloutActions.stopCallouts);
        }
    }, {
        key: '_getMobileContent',
        value: function _getMobileContent() {
            var localCss = this.props.localCss;

            return React.createElement(
                'div',
                { className: localCss.content },
                this.props.copy.mobileText
            );
        }
    }, {
        key: '_getContent',
        value: function _getContent() {
            var _this2 = this;

            var localCss = this.props.localCss;
            var _props$copy = this.props.copy,
                header = _props$copy.header,
                text = _props$copy.text;

            return React.createElement(
                'div',
                { ref: function ref(callout) {
                        _this2._callout = callout;
                    } },
                React.createElement(
                    'div',
                    { className: localCss.title || css.title },
                    header
                ),
                React.createElement('div', { className: css.divider }),
                React.createElement(
                    'div',
                    null,
                    text
                ),
                React.createElement(
                    'a',
                    { href: '#0', className: localCss.close || css.close, onClick: this._handleCloseClick, 'data-tn': 'callout-close' },
                    React.createElement(CloseIcon, { className: localCss.closeButton || css.closeButton })
                )
            );
        }
    }, {
        key: '_getTooltipContent',
        value: function _getTooltipContent() {
            if (mobileCheck.any() && this.props.copy.mobileText) {
                return this._getMobileContent();
            }
            return this._getContent();
        }
    }, {
        key: 'render',
        value: function render() {
            var isOpen = this.state.isOpen;
            var _props2 = this.props,
                direction = _props2.direction,
                lockDirection = _props2.lockDirection,
                localCss = _props2.localCss;


            return React.createElement(
                Tooltip,
                { isVisible: isOpen,
                    tooltipDirection: direction,
                    lockDirection: lockDirection,
                    containerClass: localCss.tooltipContainer || css.tooltipContainer,
                    triangleClass: localCss.triangle || css.triangle
                },
                this._getTooltipContent()
            );
        }
    }]);

    return Callout;
}(ContextComponent);

Callout.propTypes = {
    type: PropTypes.string.isRequired,
    direction: PropTypes.string,
    lockDirection: PropTypes.bool,
    scrollToClose: PropTypes.number, // scroll pixels to close tooltip
    onOpen: PropTypes.func,
    copy: PropTypes.shape({
        header: PropTypes.string,
        text: PropTypes.string,
        mobileText: PropTypes.string
    }),
    callout: PropTypes.object,
    localCss: PropTypes.object
};

Callout.defaultProps = {
    direction: 'top',
    lockDirection: false,
    scrollToClose: 0,
    onOpen: function onOpen() {},

    copy: { header: '', text: '' },
    callout: {},
    localCss: {}
};

module.exports = Callout;

/***/ }),
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-share'].join(' '), viewBox: '0 0 250 250' },
                React.createElement(
                    'g',
                    null,
                    React.createElement('polygon', { points: '153,81 153,92 199,92 199,239 49,239 49,92 99,92 99,81 38,81 38,250 210,250 210,81  ' }),
                    React.createElement('polygon', { points: '120,21 120,180 131,180 131,21.7 161.9,55 169.8,47.6 125.8,0 81,45.9 88.6,53.5  ' })
                )
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 594 */,
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = __webpack_require__(120),
    provideContext = _require.provideContext,
    connectToStores = _require.connectToStores;

var FavoritePageStore = __webpack_require__(475);

var connectToStoresHelper = function connectToStoresHelper(_ref) {
    var component = _ref.component,
        stores = _ref.stores,
        type = _ref.type,
        mapStateToProps = _ref.mapStateToProps;

    return provideContext(connectToStores(component, [FavoritePageStore].concat(_toConsumableArray(stores || [])), function (context) {
        var store = context.getStore(FavoritePageStore);

        return Object.assign(mapStateToProps ? mapStateToProps(context) : {}, {
            id: store.getFavoriteId(type),
            isSaved: store.isSaved(type),
            isFetched: store.isFetched(type),
            isCanceled: store.isCanceled()
        });
    }));
};

module.exports = connectToStoresHelper;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Component = React.Component;

var ReactModal = __webpack_require__(499);
var animationFrame = __webpack_require__(893);
var root = __webpack_require__(97);

/**
 * Wrapper class for the `react-modal` component.
 */

var Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal(props) {
        _classCallCheck(this, Modal);

        var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

        var isOpen = props.isOpen,
            onRequestClose = props.onRequestClose;


        _this._onRequestClose = _this._onRequestClose.bind(_this, onRequestClose);
        _this.state = { opaque: !!isOpen };
        return _this;
    }

    _createClass(Modal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var nextIsOpen = _ref.isOpen;
            var isOpen = this.props.isOpen;

            // Allow opening/closing via a prop.

            if (nextIsOpen && !isOpen) {
                this._handleOpen();
                return;
            }

            if (!nextIsOpen && isOpen) {
                this._handleClose();
                return;
            }
        }
    }, {
        key: '_onRequestClose',
        value: function _onRequestClose(callback) {
            if (this.props.canClose) {
                callback();
            }
        }
    }, {
        key: '_handleOpen',
        value: function _handleOpen() {
            var _this2 = this;

            // Fade in on open.
            animationFrame(function () {
                return _this2.setState({ opaque: true });
            });
            this._addBodyClass();
        }
    }, {
        key: '_handleClose',
        value: function _handleClose() {
            var _this3 = this;

            // Fade out on close.
            animationFrame(function () {
                return _this3.setState({ opaque: false });
            });
            this._removeBodyClass();
        }
    }, {
        key: '_addBodyClass',
        value: function _addBodyClass() {
            if (this.props.addBodyClass) {
                root.document.getElementsByTagName('body')[0].classList.add('dibsModal__Body--open');
            }
        }
    }, {
        key: '_removeBodyClass',
        value: function _removeBodyClass() {
            if (this.props.addBodyClass) {
                root.document.getElementsByTagName('body')[0].classList.remove('dibsModal__Body--open');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                transitionDuration = _props.transitionDuration,
                children = _props.children,
                extraStyle = _props.style;
            var opaque = this.state.opaque;


            var style = {
                content: Object.assign({
                    opacity: opaque ? 1 : 0,
                    transition: 'opacity ' + transitionDuration + 'ms linear'
                }, extraStyle.content),
                overlay: Object.assign({
                    zIndex: 1000
                }, extraStyle.overlay)
            };

            return React.createElement(
                ReactModal,
                _extends({}, this.props, { onRequestClose: this._onRequestClose, closeTimeoutMS: transitionDuration, style: style }),
                children
            );
        }
    }]);

    return Modal;
}(Component);

Modal.propTypes = {
    isOpen: PropTypes.bool,
    addBodyClass: PropTypes.bool,
    transitionDuration: PropTypes.number,
    children: PropTypes.node,
    canClose: PropTypes.bool,
    style: PropTypes.shape({
        content: PropTypes.object,
        overlay: PropTypes.object
    })
};

Modal.defaultProps = {
    isOpen: false,
    addBodyClass: true,
    transitionDuration: 250,
    canClose: true,
    style: {},
    onRequestClose: function onRequestClose() {}
};

module.exports = Modal;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(341),
    setTransformStyle = _require.setTransformStyle,
    setTransitionStyle = _require.setTransitionStyle,
    getTotalPages = _require.getTotalPages,
    getPagedItemWidth = _require.getPagedItemWidth,
    pageChangeTypeEnum = _require.pageChangeTypeEnum,
    setWidthStyle = _require.setWidthStyle;

var _require2 = __webpack_require__(67),
    noop = _require2.noop;

var BaseModel = __webpack_require__(335);
var root = __webpack_require__(97);

var DEFAULT_TRANSITION_DURATION = 250;
var TRANSITION_EFFECT_FADE = 'fade';
var TRANSITION_EFFECT_SLIDE = 'slide';

function normalizePage(page, totalPages) {
    // If the requested page is lower than 0, just go to the last page.
    if (page < 0) {
        page = totalPages - 1;
    }

    // If the requested page is higher than the total number of pages, just go to the first page.
    if (page >= totalPages) {
        page = 0;
    }

    return page;
}

/**
 * View-model for carousels that are paged through.
 * @class
 */

var PageModel = function (_BaseModel) {
    _inherits(PageModel, _BaseModel);

    function PageModel() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            itemsPerPage = _ref.itemsPerPage,
            itemCount = _ref.itemCount,
            _ref$transitionEffect = _ref.transitionEffect,
            transitionEffect = _ref$transitionEffect === undefined ? TRANSITION_EFFECT_FADE : _ref$transitionEffect,
            _ref$transitionDurati = _ref.transitionDuration,
            transitionDuration = _ref$transitionDurati === undefined ? DEFAULT_TRANSITION_DURATION : _ref$transitionDurati,
            _ref$startingPage = _ref.startingPage,
            startingPage = _ref$startingPage === undefined ? 0 : _ref$startingPage,
            _ref$onPageChange = _ref.onPageChange,
            onPageChange = _ref$onPageChange === undefined ? noop : _ref$onPageChange,
            onStateChange = _ref.onStateChange,
            _ref$customTransformI = _ref.customTransformItemStyle,
            customTransformItemStyle = _ref$customTransformI === undefined ? noop : _ref$customTransformI;

        _classCallCheck(this, PageModel);

        var _this = _possibleConstructorReturn(this, (PageModel.__proto__ || Object.getPrototypeOf(PageModel)).call(this, { onStateChange: onStateChange }));

        if ([TRANSITION_EFFECT_FADE, TRANSITION_EFFECT_SLIDE].indexOf(transitionEffect) === -1) {
            throw new Error('Transition type must be "' + TRANSITION_EFFECT_FADE + '" or "' + TRANSITION_EFFECT_SLIDE + '"');
        }

        var totalPages = getTotalPages(itemCount, itemsPerPage);

        Object.assign(_this, {
            _itemsPerPage: itemsPerPage,
            _itemCount: itemCount,
            _totalPages: totalPages,
            _transitionEffect: transitionEffect,
            _transitionDuration: transitionDuration,
            _onPageChange: onPageChange,
            _handleContainerChange: _this._handleContainerChange.bind(_this),
            customTransformItemStyle: customTransformItemStyle.bind(_this),
            // Calculate the width of each item.
            _width: getPagedItemWidth(itemsPerPage),
            _state: {
                page: normalizePage(startingPage, totalPages),
                containerWidth: 0
            }
        });
        return _this;
    }

    /**
     * Set the page and handle and bounds issues by going to either the first or last page.
     * @param {Number} page The page to go to.
     * @param {PageChangeType} type The type of the page change.
     */


    _createClass(PageModel, [{
        key: '_setPage',
        value: function _setPage(page, type) {
            page = normalizePage(page, this._totalPages);

            // Only update if the page has actually changed.
            if (page !== this._state.page) {
                // TODO: We might want to add a `setState` method on the `BaseModel` like in React that handles calling the
                // `updateState` method so we don't have to remember to do it.
                var previous = this._state.page;
                this._state.page = page;
                this._onPageChange(page, type, previous);
                this._updateState();
            }
        }

        /**
         * Implement the `_afterMount` method from the `BaseModel`.
         */

    }, {
        key: '_afterMount',
        value: function _afterMount() {
            // Since the position of the items depends on the carousel container width, we want to update them
            // when the window size changes.
            root.addEventListener('resize', this._handleContainerChange);
            // Update carousel items after the component mounts.
            this._handleContainerChange();
        }

        /**
         * Implement the `destroy` method from the `BaseModel`.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            root.removeEventListener('resize', this._handleContainerChange);
        }

        /**
         * Go to the specified page.
         */

    }, {
        key: 'jumpToPage',
        value: function jumpToPage(page) {
            this._setPage(page, pageChangeTypeEnum.jump());
        }

        /**
         * Go to the next page.
         */

    }, {
        key: 'nextPage',
        value: function nextPage() {
            this._setPage(this._state.page + 1, pageChangeTypeEnum.next());
        }

        /**
         * Go to the previous page
         */

    }, {
        key: 'previousPage',
        value: function previousPage() {
            this._setPage(this._state.page - 1, pageChangeTypeEnum.previous());
        }
    }, {
        key: 'calculateStyleValues',
        value: function calculateStyleValues(i) {
            var transition = '';
            var opacity = '';

            var _itemsPerPage = this._itemsPerPage,
                _state = this._state,
                _width = this._width,
                _transitionDuration = this._transitionDuration,
                _transitionEffect = this._transitionEffect;
            var page = _state.page;

            var containerWidth = this._getContainerWidth();

            transition = _transitionDuration + 'ms linear';

            if (_transitionEffect === TRANSITION_EFFECT_FADE) {
                transition = 'opacity ' + transition;

                var startIndex = page * _itemsPerPage;
                var endIndex = startIndex + _itemsPerPage;
                opacity = 0;

                if (i >= startIndex && i < endIndex) {
                    opacity = 1;
                }
            } else if (_transitionEffect === TRANSITION_EFFECT_SLIDE) {
                transition = 'transform ' + transition;
            }

            return {
                widthValue: _width,
                transformValue: this._getTransformValue(containerWidth),
                transition: transition,
                opacity: opacity
            };
        }

        /**
         * Implement the `transformItemStyle` method from the `BaseModel`.
         * @param  {Object} style
         */

    }, {
        key: 'transformItemStyle',
        value: function transformItemStyle(style, i) {
            var containerWidth = this._getContainerWidth();

            // Sometimes the container might be mounted but invisible. We can't really know when it becomes visible,
            // so we update the width when there's interaction with the arrows.
            if (!containerWidth && this._el) {
                this._updateContainerWidth();
            }

            var styleResult = Object.assign(this.calculateStyleValues(i), this.customTransformItemStyle(i));

            setTransformStyle(style, 'translateX(' + styleResult.transformValue + 'px)');
            setWidthStyle(style, styleResult.widthValue);
            setTransitionStyle(style, styleResult.transition);
            style.opacity = styleResult.opacity;
        }

        /**
         * Return the total number of pages.
         * @return {Number}
         */

    }, {
        key: 'getTotalPages',
        value: function getTotalPages() {
            return this._totalPages;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: 'canPaginate',
        value: function canPaginate() {
            return this.getTotalPages() > 1;
        }

        /**
         * @return {Number}
         */

    }, {
        key: '_getContainerWidth',
        value: function _getContainerWidth() {
            return this._state.containerWidth;
        }

        /**
         * @return {Number}
         */

    }, {
        key: '_getTransformValue',
        value: function _getTransformValue(containerWidth) {
            var transformValue = -containerWidth * this._state.page;

            // Last page
            if (this.getTotalPages() === this._state.page + 1 && this._itemsPerPage !== 1) {
                var itemsInLastPage = this._itemCount - this._itemsPerPage * this._state.page;

                // Need to adjust transform width if don't have full row at the end
                if (itemsInLastPage < this._itemsPerPage && this._transitionEffect === TRANSITION_EFFECT_SLIDE) {
                    transformValue += containerWidth / this._itemsPerPage * (this._itemsPerPage - itemsInLastPage);
                }
            }

            return transformValue;
        }

        /**
         * Updates the container width.
         */

    }, {
        key: '_updateContainerWidth',
        value: function _updateContainerWidth() {
            var _el$getBoundingClient = this._el.getBoundingClientRect(),
                containerWidth = _el$getBoundingClient.width;

            this._state.containerWidth = containerWidth;
        }

        /**
         * Handles carousel container width changes.
         */

    }, {
        key: '_handleContainerChange',
        value: function _handleContainerChange() {
            this._updateContainerWidth();
            // We want to temporary disable transitions.
            var savedTransitionDuration = this._transitionDuration;

            this._transitionDuration = '0';
            // Trigger to re-render the carousel.
            this._updateState();
            // Re-enable transitions.
            this._transitionDuration = savedTransitionDuration;
        }
    }]);

    return PageModel;
}(BaseModel);

module.exports = PageModel;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ArrowSvgRight = __webpack_require__(351);
var ArrowSvgLeft = __webpack_require__(352);

var upperFirst = function upperFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

var Arrow = function Arrow(props) {
    var onClick = props.onClick,
        direction = props.direction,
        classNames = props.classNames;


    var arrowWrapperClass = classNames['arrowWrapper' + upperFirst(direction)] || 'arrow-carousel-arrow-wrapper-' + direction;
    var arrowClass = classNames['arrow' + upperFirst(direction)] || 'arrow-carousel-arrow-' + direction;
    var ArrowDirection = direction === 'right' ? ArrowSvgRight : ArrowSvgLeft;

    return React.createElement(
        'span',
        { className: arrowWrapperClass, onClick: onClick },
        React.createElement(ArrowDirection, { className: arrowClass })
    );
};

Arrow.propTypes = {
    onClick: PropTypes.func,
    direction: PropTypes.string,
    classNames: PropTypes.object
};

Arrow.defaultProps = {
    classNames: {}
};

var ArrowCarouselComponent = function ArrowCarouselComponent(props) {
    var showArrows = props.showArrows,
        onLeftArrowClick = props.onLeftArrowClick,
        onRightArrowClick = props.onRightArrowClick,
        createCarousel = props.createCarousel,
        classNames = props.classNames;

    return React.createElement(
        'div',
        { className: classNames.arrowCarouselWrapper || 'arrow-carousel-wrapper' },
        showArrows ? React.createElement(Arrow, { direction: 'left', onClick: onLeftArrowClick, classNames: classNames }) : null,
        createCarousel(),
        showArrows ? React.createElement(Arrow, { direction: 'right', onClick: onRightArrowClick, classNames: classNames }) : null
    );
};

ArrowCarouselComponent.displayName = 'ArrowCarouselComponent';

ArrowCarouselComponent.propTypes = {
    createCarousel: PropTypes.func,
    onLeftArrowClick: PropTypes.func,
    onRightArrowClick: PropTypes.func,
    classNames: PropTypes.object,
    showArrows: PropTypes.bool
};

ArrowCarouselComponent.defaultProps = {
    classNames: {}
};

module.exports = ArrowCarouselComponent;

/***/ }),
/* 599 */,
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = inViewport;

var instances = [];
var supportsMutationObserver = typeof global.MutationObserver === 'function';

function inViewport(elt, params, cb) {
  var opts = {
    container: global.document.body,
    offset: 0
  };

  if (params === undefined || typeof params === 'function') {
    cb = params;
    params = {};
  }

  var container = opts.container = params.container || opts.container;
  var offset = opts.offset = params.offset || opts.offset;

  for (var i = 0; i < instances.length; i++) {
    if (instances[i].container === container) {
      return instances[i].isInViewport(elt, offset, cb);
    }
  }

  return instances[
    instances.push(createInViewport(container)) - 1
  ].isInViewport(elt, offset, cb);
}

function addEvent(el, type, fn) {
  if (el.attachEvent) {
    el.attachEvent('on' + type, fn);
  } else {
    el.addEventListener(type, fn, false);
  }
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);

    function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }
  };
}

// https://github.com/jquery/sizzle/blob/3136f48b90e3edc84cbaaa6f6f7734ef03775a07/sizzle.js#L708
var contains = function() {
  if (!global.document) {
    return true;
  }
  return global.document.documentElement.compareDocumentPosition ?
    function (a, b) {
      return !!(a.compareDocumentPosition(b) & 16);
    } :
    global.document.documentElement.contains ?
      function (a, b) {
        return a !== b && ( a.contains ? a.contains(b) : false );
      } :
      function (a, b) {
        while (b = b.parentNode) {
          if (b === a) {
            return true;
          }
        }
        return false;
      };
}

function createInViewport(container) {
  var watches = createWatches();

  var scrollContainer = container === global.document.body ? global : container;
  var debouncedCheck = debounce(watches.checkAll(watchInViewport), 15);

  addEvent(scrollContainer, 'scroll', debouncedCheck);

  if (scrollContainer === global) {
    addEvent(global, 'resize', debouncedCheck);
  }

  if (supportsMutationObserver) {
    observeDOM(watches, container, debouncedCheck);
  }

  // failsafe check, every 200ms we check for visible images
  // usecase: a hidden parent containing eleements
  // when the parent becomes visible, we have no event that the children
  // became visible
  setInterval(debouncedCheck, 150);

  function isInViewport(elt, offset, cb) {
    if (!cb) {
      return isVisible(elt, offset);
    }

    var remote = createRemote(elt, offset, cb);
    remote.watch();
    return remote;
  }

  function createRemote(elt, offset, cb) {
    function watch() {
      watches.add(elt, offset, cb);
    }

    function dispose() {
      watches.remove(elt);
    }

    return {
      watch: watch,
      dispose: dispose
    };
  }

  function watchInViewport(elt, offset, cb) {
    if (isVisible(elt, offset)) {
      watches.remove(elt);
      cb(elt);
    }
  }

  function isVisible(elt, offset) {
    if (!contains(global.document.documentElement, elt) || !contains(global.document.documentElement, container)) {
      return false;
    }

    // Check if the element is visible
    // https://github.com/jquery/jquery/blob/740e190223d19a114d5373758127285d14d6b71e/src/css/hiddenVisibleSelectors.js
    if (!elt.offsetWidth || !elt.offsetHeight) {
      return false;
    }

    var eltRect = elt.getBoundingClientRect();
    var viewport = {};

    if (container === global.document.body) {
      viewport = {
        top: -offset,
        left: -offset,
        right: global.document.documentElement.clientWidth + offset,
        bottom: global.document.documentElement.clientHeight + offset
      };
    } else {
      var containerRect = container.getBoundingClientRect();
      viewport = {
        top: containerRect.top - offset,
        left: containerRect.left - offset,
        right: containerRect.right + offset,
        bottom: containerRect.bottom + offset
      };
    }

    // The element must overlap with the visible part of the viewport
    var visible =
      (
        eltRect.right >= viewport.left &&
        eltRect.left <= viewport.right &&
        eltRect.bottom >= viewport.top &&
        eltRect.top <= viewport.bottom
      );

    return visible;
  }

  return {
    container: container,
    isInViewport: isInViewport
  };
}

function createWatches() {
  var watches = [];

  function add(elt, offset, cb) {
    if (!isWatched(elt)) {
      watches.push([elt, offset, cb]);
    }
  }

  function remove(elt) {
    var pos = indexOf(elt);
    if (pos !== -1) {
      watches.splice(pos, 1);
    }
  }

  function indexOf(elt) {
    for (var i = watches.length - 1; i >= 0; i--) {
      if (watches[i][0] === elt) {
        return i;
      }
    }
    return -1;
  }

  function isWatched(elt) {
    return indexOf(elt) !== -1;
  }

  function checkAll(cb) {
    return function () {
      for (var i = watches.length - 1; i >= 0; i--) {
        cb.apply(this, watches[i]);
      }
    };
  }

  return {
    add: add,
    remove: remove,
    isWatched: isWatched,
    checkAll: checkAll
  };
}

function observeDOM(watches, container, cb) {
  var observer = new MutationObserver(watch);
  var filter = Array.prototype.filter;
  var concat = Array.prototype.concat;

  observer.observe(container, {
    childList: true,
    subtree: true,
    // changes like style/width/height/display will be catched
    attributes: true
  });

  function watch(mutations) {
    // some new DOM nodes where previously watched
    // we should check their positions
    if (mutations.some(knownNodes) === true) {
      setTimeout(cb, 0);
    }
  }

  function knownNodes(mutation) {
    var nodes = concat.call([],
      Array.prototype.slice.call(mutation.addedNodes),
      mutation.target
    );
    return filter.call(nodes, watches.isWatched).length > 0;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function defaultEqualityCheck(a, b) {
  return a === b;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];

  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
      return equalityCheck(value, lastArgs[index]);
    })) {
      lastResult = func.apply(undefined, args);
    }
    lastArgs = args;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    memoizeOptions[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      funcs[_key3] = arguments[_key3];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      return resultFunc.apply(undefined, arguments);
    }].concat(memoizeOptions));

    var selector = function selector(state, props) {
      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var params = dependencies.map(function (dependency) {
        return dependency.apply(undefined, [state, props].concat(args));
      });
      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
    };

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      values[_key5] = arguments[_key5];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 606 */,
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-chair-outlined'].join(' '), viewBox: '0 0 38 50' },
                React.createElement('path', { d: 'M20.2462,38.6456 C19.6062,38.6456 18.9232,38.6066 18.2442,38.5476 C18.1652,38.5476 9.7122,37.8686 5.1072,30.3186 L5.0672,30.2596 C5.0482,30.2196 2.3232,26.4746 1.7032,14.8216 L1.7032,14.8016 C1.7032,14.7426 1.1412,7.7936 2.5232,3.6276 L2.5432,3.5686 C2.5432,3.5496 3.0652,1.6256 4.2232,1.6256 C4.5452,1.6256 4.9022,1.7666 5.3222,2.0066 C5.3812,2.0456 5.9622,2.4066 7.1052,2.8266 C7.1442,4.2676 7.0462,7.8126 5.4832,11.3976 C5.4442,11.4956 4.4432,13.8596 4.4432,17.1026 C4.4232,17.4046 4.3412,20.2276 5.7232,23.0116 L5.7432,23.0306 C5.8412,23.2116 6.6852,24.7116 8.0042,24.9746 C8.4242,25.0526 9.0642,25.0526 9.7472,24.5156 L9.8262,24.4566 C10.3052,23.9776 11.1882,23.1136 11.5892,22.8736 C11.6672,22.8156 13.5132,21.6526 14.9342,23.3336 C15.0952,23.5926 16.1752,25.2966 17.2392,27.7776 C17.3372,27.9976 19.5632,33.1646 23.7682,34.2246 C24.3882,34.3856 25.9122,34.4446 26.8112,34.4446 L27.2112,34.4446 C28.5542,34.4056 30.7132,34.0636 32.8182,32.6226 C31.2002,34.8996 27.4982,38.6456 20.2462,38.6456 M27.0932,32.8586 C26.2732,32.8776 24.5492,32.7996 24.0902,32.6776 C22.4292,32.2576 21.1062,30.9736 20.1832,29.7336 C25.8292,29.4736 30.9172,29.5916 33.6192,29.7136 C31.4002,32.3206 28.6172,32.8196 27.0932,32.8586 M18.0242,3.6436 L22.5902,2.7206 L22.6292,2.7016 C22.6492,2.7016 23.8502,2.3796 25.2522,2.3796 C26.3322,2.3796 27.7762,2.5796 28.5152,3.5416 L28.5542,3.6006 L28.6322,3.6596 C28.7542,3.7806 29.5942,4.7586 28.1302,7.3226 C27.7692,7.8446 23.7252,13.8906 23.2462,19.1956 C23.1872,19.5176 23.0262,20.8366 23.8462,21.8576 C24.4082,22.5596 25.2872,22.8976 26.4102,22.8976 L26.5082,22.8976 C26.5872,22.8976 27.3882,22.8776 28.9702,22.3946 C28.9902,22.3946 31.0312,21.7546 32.9162,21.7546 C33.8392,21.7546 34.5772,21.9156 35.0402,22.2146 C35.1812,22.3366 36.5632,23.7966 34.9182,28.1626 C32.6762,28.0406 26.2492,27.8016 19.1392,28.1826 C18.7972,27.5816 18.6172,27.1806 18.6172,27.1616 C17.3962,24.3186 16.1942,22.4976 16.1552,22.4346 L16.1162,22.3756 C14.2552,20.1136 11.7102,20.8516 10.6502,21.5746 C10.0302,21.9746 8.9072,23.0976 8.6482,23.3376 C8.4672,23.4786 8.3502,23.4786 8.2672,23.4586 C7.8672,23.3806 7.3252,22.7366 7.1052,22.3166 C5.8842,19.8116 5.9822,17.2126 5.9822,17.1886 L5.9822,17.1496 C5.9822,14.2246 6.8852,12.0656 6.9052,12.0416 C8.4482,8.5156 8.6872,5.1116 8.6872,3.2906 C10.0502,3.6116 11.8522,3.8906 14.0742,3.8906 C15.3422,3.9066 16.6812,3.8236 18.0242,3.6436 M36.0252,20.9466 L36.0252,20.9466 C35.2642,20.4236 34.2432,20.1646 32.9632,20.1646 C30.8192,20.1646 28.6172,20.8636 28.5382,20.8876 C27.1952,21.2876 26.5552,21.3076 26.5362,21.3076 L26.4572,21.3076 C25.8372,21.3076 25.3782,21.1466 25.1342,20.8476 C24.7732,20.4086 24.8122,19.6856 24.8752,19.4466 L24.8952,19.3486 C25.3342,14.3386 29.4772,8.2296 29.5202,8.1706 L29.5592,8.1116 C31.5812,4.6056 30.1792,2.8656 29.7792,2.4656 C28.8562,1.3426 27.3172,0.7416 25.2952,0.7416 C23.7952,0.7416 22.4922,1.0636 22.2922,1.1226 L17.8432,2.0216 C16.5632,2.1826 15.2992,2.2616 14.1172,2.2616 C8.8132,2.2616 6.2292,0.6596 6.1862,0.6396 C5.5072,0.2196 4.8432,-0.0004 4.2232,-0.0004 C2.3232,-0.0004 1.2982,1.9436 1.0002,3.1256 C-0.4368,7.5496 0.0852,14.4566 0.1242,14.8996 C0.7642,26.5336 3.4892,30.6986 3.8072,31.1586 C8.4912,38.8266 16.6022,39.9686 18.0042,40.1096 L18.0042,45.6386 L12.5982,44.0716 L12.1382,45.6146 L15.6012,46.6156 L10.4342,48.2966 L10.9372,49.8196 L18.7272,47.2946 L26.5162,49.8196 L27.0192,48.2966 L21.8522,46.6156 L25.3152,45.6146 L24.8952,44.0716 L19.6262,45.6146 L19.6262,40.2086 C19.8262,40.2086 20.0852,40.2276 20.3282,40.2276 C26.1752,40.2276 29.9012,37.9036 32.0212,35.9636 C34.3212,33.8396 35.2052,31.7196 35.2442,31.6376 L36.4852,28.8336 L36.5042,28.7946 C38.6292,23.0276 36.3042,21.1466 36.0252,20.9466z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-folder'].join(' '), viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M229.2,63.9c-8.1-4-16-4-16.4-4h-77.4c-9.9,0-18.9-6.5-19.1-6.6L82.4,29.6c-1.4-1-8.1-5.8-10.7-7.1c-8.1-4-14.9-4-15.2-4 H38.2c-10.5,0-18.8,3.2-24.8,9.5c-10,10.4-9.8,25.4-9.7,27.1L3.4,200.5c0,23.4,19.9,31.6,30.5,32.6h182.7h0.2 c23.3-1.6,29.5-22.4,29.4-33.3v-107C246.2,75.8,237,67.7,229.2,63.9z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * @ignore
 * User: daletan
 * Date: 3/13/16
 * Time: 6:42 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(40);
var OverlaySpinner = __webpack_require__(486);
var overlayStyles = __webpack_require__(394);

var Overlay = function () {
    function Overlay() {
        _classCallCheck(this, Overlay);
    }

    _createClass(Overlay, [{
        key: '_calcOffsetLeft',

        /**
         * Create the offset left as a percentage for the element
         * Attached as a private method for testing
         * @param {object} options
         * @param {number} options.containerWidth
         * @param {number} options.elementWidth
         * @param {number} [options.offsetLeft]
         * @returns {number}
         * @private
         */
        value: function _calcOffsetLeft() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _options$containerWid = options.containerWidth,
                containerWidth = _options$containerWid === undefined ? 0 : _options$containerWid,
                _options$offsetLeft = options.offsetLeft,
                offsetLeft = _options$offsetLeft === undefined ? 0 : _options$offsetLeft,
                _options$elementWidth = options.elementWidth,
                elementWidth = _options$elementWidth === undefined ? 0 : _options$elementWidth;


            var targetWidth = containerWidth - offsetLeft;
            var targetCenter = targetWidth / 2;
            var elementCenter = elementWidth / 2;
            var elementLeft = targetCenter - elementCenter + offsetLeft;

            // turn this into a usable percentage
            return 100 * (elementLeft / containerWidth);
        }
        /**
         * Create the offset top as a pixel for the element
         * Attached as a private method for testing
         * @param {object} options
         * @param {number} options.containerHeight
         * @param {number} options.elementHeight
         * @param {number} [options.offsetTop]
         * @returns {number}
         * @private
         */

    }, {
        key: '_calcOffsetTop',
        value: function _calcOffsetTop() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _options$containerHei = options.containerHeight,
                containerHeight = _options$containerHei === undefined ? 0 : _options$containerHei,
                _options$offsetTop = options.offsetTop,
                offsetTop = _options$offsetTop === undefined ? 0 : _options$offsetTop,
                _options$elementHeigh = options.elementHeight,
                elementHeight = _options$elementHeigh === undefined ? 0 : _options$elementHeigh;

            var adjustmentHeight = elementHeight / 2;
            return (containerHeight - offsetTop) / 2 - adjustmentHeight + offsetTop;
        }
        /**
         * Readjust the spinner to be positioned relative
         * to the container dimensions
         *
         * HACK:
         * have to do this calculation here since
         * `componentDidMount` doesn't paint the DOM
         * with elements yet so you cannot access
         * dimensions of the element
         *
         * @private
         * @param {number} [options.leftOffset]
         * @param {number} [options.topOffset]
         * @param {number} [options.containerWidth]
         * @param {number} [options.containerHeight]
         */

    }, {
        key: '_adjustSpinner',
        value: function _adjustSpinner(options) {
            var _options$offsetLeft2 = options.offsetLeft,
                offsetLeft = _options$offsetLeft2 === undefined ? 0 : _options$offsetLeft2,
                _options$offsetTop2 = options.offsetTop,
                offsetTop = _options$offsetTop2 === undefined ? 0 : _options$offsetTop2,
                _options$containerWid2 = options.containerWidth,
                containerWidth = _options$containerWid2 === undefined ? 0 : _options$containerWid2,
                _options$containerHei2 = options.containerHeight,
                containerHeight = _options$containerHei2 === undefined ? 0 : _options$containerHei2;

            var $spinner = this._parent.querySelector('.' + overlayStyles.spinner);
            if ($spinner) {
                var left = this._calcOffsetLeft({
                    containerWidth: containerWidth,
                    offsetLeft: offsetLeft,
                    // use offsetWidth to compensate for borders
                    elementWidth: $spinner.offsetWidth
                });
                var top = this._calcOffsetTop({
                    containerHeight: containerHeight,
                    offsetTop: offsetTop,
                    // use offsetWidth to compensate for borders
                    elementHeight: $spinner.offsetHeight
                });

                this._positionSpinner($spinner, left, top);
            }
        }

        /**
         *
         * @param {DOMElement} $spinner The spinner element itself
         * @param {number} left The left position of the element as a percentage
         * @param {number} top The top position of the element as a pixel
         * @private
         */

    }, {
        key: '_positionSpinner',
        value: function _positionSpinner($spinner, left, top) {
            $spinner.style.left = left + '%';
            $spinner.style.top = top + 'px';
        }

        /**
         *
         * @param parent
         * @private
         */

    }, {
        key: '_setParent',
        value: function _setParent(_ref) {
            var _ref$parent = _ref.parent,
                parent = _ref$parent === undefined ? null : _ref$parent;

            this._parent = parent;
        }
        /**
         * @see this._adjustSpinner
         * @param {object} options
         * @param {HTMLElement} options.parent
         * @param {object} [options.componentOptions]
         */

    }, {
        key: 'show',
        value: function show(options) {
            this._setParent(options);
            if (this._parent instanceof HTMLElement && global && global.document) {
                ReactDOM.render(React.createElement(OverlaySpinner, options.componentOptions || {}), this._parent);
                this._parent.style.display = 'block';
                this._adjustSpinner(options);
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            if (this._parent instanceof HTMLElement) {
                ReactDOM.unmountComponentAtNode(this._parent);
                this._parent.style.display = 'none';
                this._parent = null;
            }
        }
    }]);

    return Overlay;
}();

module.exports = Overlay;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 610 */,
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _authModalLoader = __webpack_require__(263);

var _authModalLoader2 = _interopRequireDefault(_authModalLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// pass off authentication process to the Auth modal
module.exports = function (authProps) {
    var action = authProps.action,
        email = authProps.email,
        linkLocation = authProps.linkLocation,
        flow = authProps.flow;

    return _authModalLoader2.default.show({
        action: action,
        email: email,
        flow: flow || _authModalLoader2.default.constants.CONTACT_DEALER_FLOW,
        step: 1,
        ga: {
            label: linkLocation
        }
    });
};

/***/ }),
/* 612 */,
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TemplateView = __webpack_require__(544);
var extendCompose = __webpack_require__(43);
var $ = __webpack_require__(5);
var uiPosition = __webpack_require__(691);
var transitionEndEvent = __webpack_require__(692);
var bunsen = __webpack_require__(21);
var doc = __webpack_require__(97).document;
module.exports = extendCompose.call(TemplateView, {
    initialize__: function initialize__(options) {
        this._width = options.width;
        this._disableCentering = options.disableCentering;
    },
    animated: false,
    getMainElement: function getMainElement() {
        return this.el;
    },
    isCenteringDisabled: function isCenteringDisabled() {
        return this._disableCentering;
    },
    show: function show() {
        var $mainEl;
        if (this._width) {
            this.getMainElement().style.width = this._width;
        }
        this.$el.appendTo(document.body);
        $mainEl = $(this.getMainElement());
        $mainEl.off(transitionEndEvent + ".bunsen-tooltip");
        this.center();
        this.$el.removeClass('pre-animation');
        this.trigger('show');
        return this;
    },
    hide: function hide(eventData) {
        var $mainEl = $(this.getMainElement());
        this.$el.addClass('pre-animation'); // starts css animation
        if (doc && doc.hidden) {
            // if the tab isn't open, don't worry about any animations,
            // just close the darn modal
            this.$el.detach();
        } else if (transitionEndEvent && this.animated) {
            $mainEl.off(transitionEndEvent + ".bunsen-tooltip");
            $mainEl.one(transitionEndEvent + ".bunsen-tooltip", bunsen.gandalf($.proxy(this.$el, 'detach')));
        } else {
            this.$el.detach();
        }
        this.trigger('hide', eventData);
        return this;
    },
    center: function center() {
        if (this._disableCentering) {
            return;
        }
        var $mainEl = $(this.getMainElement());
        uiPosition.positionElement($mainEl.get(0), this.position);
    }
});

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var bunsen = __webpack_require__(21);
var bubbleMatch = __webpack_require__(689);
var $ = __webpack_require__(5);

/**
 * PresentationManager extracts the configuration of a view from a parent instance. Currently used for modals and tooltips.
 * @param {Boolean} options.reuse - if true, the modal will be re-used between opens and closes
 * @param {Backbone.View} options.parentView -  Backbone view that we are extending with a popModal-like interface. It should have a property identified by options.configGroup that maps keys for presentable views to the presentable view's configutacion object.
 * @param {String} options.viewConfigKey - key for the view that we will be presenting
 */

var PresentationManager = module.exports = function (options) {
    var configViewOptions;
    options = _.extend({
        configGroup: undefined,
        parentView: undefined, // the view that we are extending with a popModal-like interface
        viewConfigKey: undefined,
        reuse: false, // instead of creating a new modal, reuse the last modal if it exists
        viewOptions: {}
    }, options);
    this._configGroup = options.configGroup;
    this._parentView = options.parentView;
    this._viewConfigKey = options.viewConfigKey;
    this._disabled = options.disabled;
    if (!this._parentView) {
        throw new Error("options.parentView is required when building a PresentationManager");
    }
    if (!options.configGroup) {
        throw new Error("options.configGroup is required when building a PresentationManager");
    }
    configViewOptions = bunsen.result(this._parentView[options.configGroup], options.viewConfigKey, this._parentView);
    _.extend(options, _.pick(configViewOptions, 'reuse'));
    this._reuse = options.reuse;
    this._viewOptions = options.viewOptions;
    if (undefined === configViewOptions) {
        throw new Error("no config available for presentable view with key " + options.viewConfigKey);
    }
    this._viewOptions = _.extend({
        parentView: this._parentView
    }, configViewOptions, this._viewOptions);
};
var handleActivationEvent = function handleActivationEvent(viewType, handleGotKey, e) {
    // use BubbleMatch so this will still work if a child element of a [data-modal] was clicked
    var elUniqueAtttribute = 'data-' + viewType;
    var matchingEl = bubbleMatch({
        el: e.target,
        filter: '[' + elUniqueAtttribute + ']',
        parent: this.el
    });
    if (!matchingEl) {
        return;
    }
    // this.popModal($(matchingEl).attr(elUniqueAtttribute));
    handleGotKey.call(this, $(matchingEl).attr(elUniqueAtttribute), e);
    return false;
};
/**
 * construct (or retrieve from cache) the view that will be presented
 * @param {function(new:Backbone.View)} ViewConstructor - constructor for the view that will be returned
 */
PresentationManager.prototype.getView = function (ViewConstructor) {
    var cachedModal;
    if (bunsen.result(this, '_disabled', this._parentView)) {
        return;
    }
    var cacheKey = this._configGroup + "::" + this._viewConfigKey;
    cachedModal = this._reuse && _.result(this._parentView.__presentationCache__, cacheKey);
    if (cachedModal) {
        return cachedModal;
    }
    var view = new ViewConstructor(this._viewOptions);
    if (this._reuse) {
        if (!this._parentView.__presentationCache__) {
            this._parentView.__presentationCache__ = {};
        }
        this._parentView.__presentationCache__[cacheKey] = view;
    }
    return view;
};
PresentationManager.buildActivationEventHandler = function (options) {
    options = _.extend({
        dataAttribute: undefined,
        handleGotKey: undefined
    }, options);
    return _.partial(handleActivationEvent, options.dataAttribute, options.handleGotKey);
};

/***/ }),
/* 615 */,
/* 616 */,
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltipContainer":"Callout__tooltipContainer__36kZo","title":"Callout__title__2od6f","triangle":"Callout__triangle__KZ7ri","close":"Callout__close__3dkGO","closeButton":"Callout__closeButton__2OATl","divider":"Callout__divider__CmCNu","text":"Callout__text__2Hy3r"};

/***/ }),
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = __webpack_require__(605);

/**
 * Creates a memoize-less selector. The reason of using this instead of the default
 * `createSelector` for now is that with our current codebase we cannot guarantee
 * that we're using immutable data on each input which ruins object/array equality
 * checks we can do as a comparison.
 *
 * There's still benefits of creating selectors though (i.e. increased readability),
 * and this createSelector can also be tuned for increased performance by using a
 * more efficient memoize cache. See https://github.com/medikoo/memoizee for example
 */
exports.default = (0, _reselect.createSelectorCreator)(function (func) {
  return function () {
    return func.apply(undefined, arguments);
  };
});

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

module.exports = __webpack_require__(7);

/***/ },
/* 1 */
/***/ function(module, exports) {

module.exports = __webpack_require__(1);

/***/ },
/* 2 */
/***/ function(module, exports) {

module.exports = __webpack_require__(18);

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HeartWrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(2);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Heart = __webpack_require__(4);

var _Heart2 = _interopRequireDefault(_Heart);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _ModifyPortfolioItems = __webpack_require__(5);

var _ModifyPortfolioItems2 = _interopRequireDefault(_ModifyPortfolioItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @ignore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by shanie on 3/8/17.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// Components


// Helpers


// Mutations


var HeartWrapper = exports.HeartWrapper = function (_React$Component) {
    _inherits(HeartWrapper, _React$Component);

    function HeartWrapper(props) {
        _classCallCheck(this, HeartWrapper);

        var _this = _possibleConstructorReturn(this, (HeartWrapper.__proto__ || Object.getPrototypeOf(HeartWrapper)).call(this, props));

        _this.waitingForRelay = false;
        _this.favoriteItem = _this.favoriteItem.bind(_this);
        _this.onHeartClick = _this.onHeartClick.bind(_this);
        return _this;
    }

    _createClass(HeartWrapper, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            // Do not use forceFavoriteItem unless all props fetched in this component's
            // relay container are fetched from an external higher-order component and can be
            // passed along to this component as props
            if (nextProps.forceFavoriteItem) {
                this.props.onHeartClick(function (_ref) {
                    var portfolioId = _ref.portfolioId,
                        userId = _ref.userId;

                    var relayPortfolioId = (0, _lodash2.default)(_this2.props, 'viewer.userPortfolios.edges[0].node.serviceId');
                    if (!relayPortfolioId && portfolioId) {
                        _this2.favoriteItem({ portfolioId: portfolioId, userId: userId });
                    }
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.waitingForRelay && this.props.viewer.userPortfolios) {

                this.favoriteItem({
                    userId: this.props.userId,
                    portfolioId: (0, _lodash2.default)(this.props, 'viewer.userPortfolios.edges[0].node.serviceId')
                });

                this.waitingForRelay = false;
            }
        }
    }, {
        key: 'favoriteItem',
        value: function favoriteItem(_ref2) {
            var _this3 = this;

            var portfolioId = _ref2.portfolioId,
                userId = _ref2.userId;

            var heartPortfolioMatches = (0, _lodash2.default)(this.props, 'viewer.portfolioItemMatches') || [];
            var itemMatches = heartPortfolioMatches.reduce(function (matches, heart) {
                if ((0, _lodash2.default)(heart, 'item.serviceId') === _this3.props.itemId) {
                    matches.push(heart);
                }
                return matches;
            }, []);

            var action = itemMatches && itemMatches.length && !this.waitingForRelay ? 'REMOVE' : 'ADD';
            var portfolioItemIds = heartPortfolioMatches.reduce(function (matches, heart) {
                if ((0, _lodash2.default)(heart, 'item.serviceId') === _this3.props.itemId) {
                    matches.push(heart.portfolioItemId);
                }
                return matches;
            }, []);

            if (portfolioId) {
                this.props.relay.commitUpdate(new _ModifyPortfolioItems2.default({
                    action: action,
                    itemsIds: [this.props.itemId],
                    portfolioItemsIds: action === 'REMOVE' ? portfolioItemIds : null,
                    portfolioId: portfolioId,
                    userId: userId
                }), {
                    onSuccess: function onSuccess() {
                        // force-fetching to sync relay store without fat query or requiring user input via props
                        _this3.props.relay.forceFetch({}, function (readyState) {
                            if (readyState.done) {
                                if (action === 'REMOVE') {
                                    _this3.props.onUnFavorited();
                                } else {
                                    _this3.props.onFavorited();
                                }
                            }
                        });
                    },
                    onFailure: function onFailure(error) {
                        _this3.props.onError(error);
                    }
                });
            }
        }
    }, {
        key: 'onHeartClick',
        value: function onHeartClick(e) {
            var _this4 = this;

            e.preventDefault();
            this.props.onHeartClick(function (_ref3) {
                var portfolioId = _ref3.portfolioId,
                    userId = _ref3.userId;
                return _this4.favoriteItem({ portfolioId: portfolioId, userId: userId });
            });

            var portfolioId = (0, _lodash2.default)(this.props, 'viewer.userPortfolios.edges[0].node.serviceId');
            var userId = this.props.userId;


            if (this.props.userId) {
                this.favoriteItem({ portfolioId: portfolioId, userId: userId });
            } else {
                this.props.authModalShow(function () {
                    _this4.waitingForRelay = true;
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var heartPortfolioMatches = (0, _lodash2.default)(this.props, 'viewer.portfolioItemMatches') || [];
            var itemMatches = heartPortfolioMatches.reduce(function (matches, heart) {
                if ((0, _lodash2.default)(heart, 'item.serviceId') === _this5.props.itemId) {
                    matches.push(heart);
                }
                return matches;
            }, []);

            return _react2.default.createElement(_Heart2.default, {
                className: this.props.className,
                isFavorited: !!itemMatches && !!itemMatches.length,
                onClick: this.onHeartClick
            });
        }
    }]);

    return HeartWrapper;
}(_react2.default.Component);

HeartWrapper.defaultProps = {
    forceFavoriteItem: false,
    onError: function onError() {},
    onFavorited: function onFavorited() {},
    onHeartClick: function onHeartClick() {},
    onUnFavorited: function onUnFavorited() {},
    portfolioItemId: '',
    portfolioId: null,
    selectedItemIds: [],
    userId: ''
};

HeartWrapper.propTypes = {
    className: _propTypes2.default.string,
    authModalShow: _propTypes2.default.func.isRequired,
    forceFavoriteItem: _propTypes2.default.bool,
    itemId: _propTypes2.default.string.isRequired,
    onError: _propTypes2.default.func,
    onFavorited: _propTypes2.default.func,
    onHeartClick: _propTypes2.default.func,
    onUnFavorited: _propTypes2.default.func,
    portfolioId: _propTypes2.default.string,
    userId: _propTypes2.default.string
};

exports.default = _reactRelay2.default.createContainer(HeartWrapper, {
    initialVariables: {
        loadPortfolioData: false,
        selectedItemIds: [],
        userId: null,
        userIds: null
    },
    prepareVariables: function prepareVariables(params) {
        var userId = params.userIds && params.userIds.length ? params.userIds[0] : params.userId;
        return Object.assign({}, params, {
            loadPortfolioData: !!params.selectedItemIds && !!params.selectedItemIds.length && !!userId,
            userId: userId,
            userIds: params.userIds && params.userIds.length ? params.userIds : [params.userId]
        });
    },
    fragments: {
        viewer: function viewer() {
            return function () {
                return {
                    children: [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemIds',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'selectedItemIds'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'userIds',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userIds'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {
                                type: '[PortfolioTypes]'
                            },
                            name: 'portfolioTypes',
                            value: [{
                                kind: 'CallValue',
                                callValue: 'HEART'
                            }]
                        }],
                        children: [{
                            fieldName: 'portfolioId',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'portfolioItemId',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            children: [{
                                fieldName: 'serviceId',
                                kind: 'Field',
                                metadata: {},
                                type: 'ID'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'item',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'Item'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'loadPortfolioData'
                                }
                            }]
                        }],
                        fieldName: 'portfolioItemMatches',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id',
                            isPlural: true
                        },
                        type: 'PortfolioItemV2'
                    }, {
                        alias: 'userPortfolios',
                        calls: [{
                            kind: 'Call',
                            metadata: {
                                type: 'Int'
                            },
                            name: 'first',
                            value: {
                                kind: 'CallValue',
                                callValue: 1
                            }
                        }, {
                            kind: 'Call',
                            metadata: {
                                type: '[PortfolioTypes]'
                            },
                            name: 'portfolioTypes',
                            value: [{
                                kind: 'CallValue',
                                callValue: 'HEART'
                            }]
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'userIds',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userIds'
                            }
                        }],
                        children: [{
                            children: [{
                                children: [{
                                    fieldName: 'serviceId',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'ID'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'node',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isRequisite: true
                                },
                                type: 'PortfolioV2'
                            }, {
                                fieldName: 'cursor',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'String'
                            }],
                            fieldName: 'edges',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'PortfoliosEdge'
                        }, {
                            children: [{
                                fieldName: 'hasNextPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }, {
                                fieldName: 'hasPreviousPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }],
                            fieldName: 'pageInfo',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'PageInfo'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'loadPortfolioData'
                                }
                            }]
                        }],
                        fieldName: 'portfolios',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'PortfoliosConnection'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: _reactRelay2.default.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'HeartWrapper_ViewerRelayQL',
                    type: 'Viewer'
                };
            }();
        }
    }
});
//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _heartFilled = __webpack_require__(8);

var _heartFilled2 = _interopRequireDefault(_heartFilled);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _HeartStyles = __webpack_require__(6);

var _HeartStyles2 = _interopRequireDefault(_HeartStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * @ignore
                                                                                                                                                                                                                   * Created by shanie on 3/8/17.
                                                                                                                                                                                                                   */

// Components


// Styles


var Heart = function Heart(props) {
    var _classnames;

    var className = (0, _classnames3.default)(_HeartStyles2.default.heart, props.className);
    var iconClasses = (0, _classnames3.default)(_HeartStyles2.default.icon, (_classnames = {}, _defineProperty(_classnames, _HeartStyles2.default.isFilled, props.isFavorited), _defineProperty(_classnames, _HeartStyles2.default.outlined, !props.isFavorited), _classnames));

    var dataTn = props.isFavorited ? 'item-saved-icon' : 'item-save-icon';

    return _react2.default.createElement(
        'div',
        {
            className: className,
            'data-tn': dataTn,
            onClick: props.onClick
        },
        _react2.default.createElement(_heartFilled2.default, { className: iconClasses })
    );
};

Heart.defaultProps = {
    isFavorited: false
};

Heart.propTypes = {
    className: _propTypes2.default.string,
    isFavorited: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};

exports.default = Heart;
//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRelay = __webpack_require__(2);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModifyPortfolioItems = function (_Relay$Mutation) {
    _inherits(ModifyPortfolioItems, _Relay$Mutation);

    function ModifyPortfolioItems() {
        _classCallCheck(this, ModifyPortfolioItems);

        return _possibleConstructorReturn(this, (ModifyPortfolioItems.__proto__ || Object.getPrototypeOf(ModifyPortfolioItems)).apply(this, arguments));
    }

    _createClass(ModifyPortfolioItems, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'modifyPortfolioItems',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'ModifyPortfolioItemsInput!'
                    },
                    name: 'ModifyPortfolioItems',
                    responseType: 'ModifyPortfolioItemsPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            var _props = this.props,
                action = _props.action,
                itemsIds = _props.itemsIds,
                portfolioId = _props.portfolioId,
                portfolioItemsIds = _props.portfolioItemsIds,
                userId = _props.userId;


            if (action === 'REMOVE') {
                return { action: action, portfolioItemsIds: portfolioItemsIds, portfolioId: portfolioId, userId: userId };
            } else if (action === 'ADD') {
                return { action: action, itemsIds: itemsIds, portfolioId: portfolioId, userId: userId };
            }
            return null;
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'portfolio',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'PortfolioV2'
                    }],
                    id: _reactRelay2.default.QL.__id(),
                    kind: 'Fragment',
                    metadata: {
                        pattern: true
                    },
                    name: 'ModifyPortfolioItems_ValueRelayQL',
                    type: 'ModifyPortfolioItemsPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'REQUIRED_CHILDREN',
                children: [function () {
                    return {
                        children: [{
                            children: [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'portfolio',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'PortfolioV2'
                        }],
                        id: _reactRelay2.default.QL.__id(),
                        kind: 'Fragment',
                        metadata: {
                            pattern: true
                        },
                        name: 'ModifyPortfolioItems_ChildrenRelayQL',
                        type: 'ModifyPortfolioItemsPayload'
                    };
                }()]
            }];
        }
    }]);

    return ModifyPortfolioItems;
}(_reactRelay2.default.Mutation);

module.exports = ModifyPortfolioItems;
//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 6 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"heart":"Heart-Styles__heart__34F2Z","icon":"Heart-Styles__icon__1xb7o","isFilled":"Heart-Styles__isFilled__EjbGF","outlined":"Heart-Styles__outlined__1-Hj7"};

/***/ },
/* 7 */
/***/ function(module, exports) {

module.exports = __webpack_require__(629);

/***/ },
/* 8 */
/***/ function(module, exports) {

module.exports = __webpack_require__(389);

/***/ },
/* 9 */
/***/ function(module, exports) {

module.exports = __webpack_require__(630);

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HeartWrapper = __webpack_require__(3);

var _HeartWrapper2 = _interopRequireDefault(_HeartWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HeartWrapper2.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZVJvb3QiOiIvVXNlcnMvc2hhbmllL3Byb2plY3RzL2RpYnMtY29tcG9uZW50cy9kaWJzLXBvcnRmb2xpby1oZWFydCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBIZWFydFdyYXBwZXIgZnJvbSAnLi9IZWFydC9IZWFydFdyYXBwZXInO1xuZXhwb3J0IGRlZmF1bHQgSGVhcnRXcmFwcGVyO1xuIl19

/***/ }
/******/ ]);

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-circle-plus'].join(' '), viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M125.2-1.2C56.2-1.2,0,55,0,124s56.2,125.2,125.2,125.2c69.1,0,125.2-56.1,125.2-125.1S194.2-1.2,125.2-1.2z M125.3,240.1 C61.2,240.1,9.1,188,9.1,124S61.2,7.8,125.2,7.8c64.1,0,116.3,52,116.3,116.1S189.4,240.1,125.3,240.1z' }),
                React.createElement('polygon', { points: '133.1,79.4 115.1,79.4 115.1,115.4 77.6,115.4 77.6,133.4 115.1,133.4 115.1,171.6 133.1,171.6 133.1,133.4 169.8,133.4 169.8,115.4 133.1,115.4' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 632 */,
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"price":"pdp-price__price__2MFXP","portfolio":"pdp-price__portfolio__2ku6e pdp-price__price__2MFXP","sup":"pdp-price__sup__NaWcs","reduced":"pdp-price__reduced__15ffW"};

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"tour__wrapper__3rNuG","container":"tour__container__1c0MW","close":"tour__close__De8B-","header":"tour__header__XVXZf","step":"tour__step__26kRd","content":"tour__content__3h9Uu","ctaWrapper":"tour__ctaWrapper__2fenk","hasCancel":"tour__hasCancel__3vwKD","cta":"tour__cta__Os-6R","cancel":"tour__cancel__3ysuO","tooltip":"tour__tooltip__WeOHX","visible":"tour__visible__1AzzO"};

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GalleryPhotoItemTags__wrapper__AKHM5","itemTagWrapper":"GalleryPhotoItemTags__itemTagWrapper__2DaI1","showItemTags":"GalleryPhotoItemTags__showItemTags__10SGs","showActiveTag":"GalleryPhotoItemTags__showActiveTag__1pO4j","isActiveTag":"GalleryPhotoItemTags__isActiveTag__2Mo0a","itemTagTooltip":"GalleryPhotoItemTags__itemTagTooltip__KX6S4","itemTagHoverBounds":"GalleryPhotoItemTags__itemTagHoverBounds__3Mq0n","itemTagInfoWrapper":"GalleryPhotoItemTags__itemTagInfoWrapper__1xjol","itemTagName":"GalleryPhotoItemTags__itemTagName__27GI4","itemTagCategoryCreator":"GalleryPhotoItemTags__itemTagCategoryCreator__26Ols","itemTagLink":"GalleryPhotoItemTags__itemTagLink__bHZyf"};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 6/17/16.
 */



var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var _require = __webpack_require__(673),
    formatPrice = _require.formatPrice;

var styles = __webpack_require__(633);

var FormattedPrice = function FormattedPrice(props) {
    var copy = props.copy,
        isSoldIndividually = props.isSoldIndividually,
        currency = props.currency,
        type = props.type,
        price = props.price,
        doNotShowFormattedPrice = props.doNotShowFormattedPrice,
        priceDisplays = props.priceDisplays;

    var _ref = doNotShowFormattedPrice ? {} : formatPrice({ copy: copy, isSoldIndividually: isSoldIndividually, price: price, currency: currency }),
        string = _ref.string,
        abbreviation = _ref.abbreviation,
        perItem = _ref.perItem;

    var displayPrice = doNotShowFormattedPrice ? price : string;
    var wrapperTn = 'price-wrapper';
    var priceTn = 'pdp-retail-price';
    if (priceDisplays.showOnHold) {
        priceTn = 'on-hold-price';
    } else if (priceDisplays.showPriceUponRequest) {
        priceTn = 'price-upon-request';
    } else if (type === 'net') {
        priceTn = 'pdp-net-price';
    }
    var priceLabel = priceDisplays.showListPriceLabel && !priceDisplays.showNetPrice ? ' List Price' : '';
    if (type) {
        wrapperTn = wrapperTn + '-' + type;
    }

    return React.createElement(
        'span',
        { 'data-tn': wrapperTn },
        React.createElement(
            'span',
            { 'data-tn': priceTn },
            displayPrice
        ),
        doNotShowFormattedPrice ? false : React.createElement(
            'sup',
            { className: styles.sup, 'data-tn': 'price-abbreviation' },
            abbreviation
        ),
        doNotShowFormattedPrice ? false : React.createElement(
            'span',
            { 'data-tn': 'price-per-item' },
            perItem
        ),
        doNotShowFormattedPrice || !priceDisplays.showListPriceLabel ? false : React.createElement(
            'span',
            null,
            priceLabel
        )
    );
};

FormattedPrice.defaultProps = {
    copy: {},
    isSoldIndividually: false,
    priceIsString: false
};

FormattedPrice.propTypes = {
    copy: PropTypes.object.isRequired,
    isSoldIndividually: PropTypes.bool,
    doNotShowFormattedPrice: PropTypes.bool,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    priceDisplays: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    type: PropTypes.string
};

module.exports = FormattedPrice;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var debounce = __webpack_require__(105);
var ContextComponent = __webpack_require__(61);

var StickyAlertPortal = function (_ContextComponent) {
    _inherits(StickyAlertPortal, _ContextComponent);

    function StickyAlertPortal(props) {
        _classCallCheck(this, StickyAlertPortal);

        var _this = _possibleConstructorReturn(this, (StickyAlertPortal.__proto__ || Object.getPrototypeOf(StickyAlertPortal)).call(this, props));

        _this._close = debounce(_this._close, props.animationTime);

        _this.state = {
            isOpen: props.isOpen
        };
        return _this;
    }

    _createClass(StickyAlertPortal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.isOpen) {
                this._open(this.props);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var isOpen = this.props.isOpen;

            var isOpenChanged = isOpen !== nextProps.isOpen;

            if (isOpenChanged && nextProps.isOpen) {
                this._open(nextProps);
            } else if (isOpenChanged) {
                this._close(nextProps);
            }
        }
    }, {
        key: '_close',
        value: function _close(_ref) {
            var isOpen = _ref.isOpen;

            this.setState({ isOpen: isOpen }, this.props.onClose);
        }
    }, {
        key: '_open',
        value: function _open(_ref2) {
            var isOpen = _ref2.isOpen;
            var _props = this.props,
                onOpen = _props.onOpen,
                animationTime = _props.animationTime;

            this.setState({ isOpen: isOpen }, debounce(onOpen, animationTime));
        }
    }, {
        key: '_shouldBeClosed',
        value: function _shouldBeClosed() {
            return !this.state.isOpen;
        }
    }, {
        key: 'render',
        value: function render() {
            if (this._shouldBeClosed()) {
                return null;
            }

            return this.props.children;
        }
    }]);

    return StickyAlertPortal;
}(ContextComponent);

StickyAlertPortal.propTypes = {
    animationTime: PropTypes.number.isRequired,
    isOpen: PropTypes.bool,
    children: PropTypes.node,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

StickyAlertPortal.defaultProps = {
    animationTime: 500,
    onOpen: function onOpen() {},
    onClose: function onClose() {}
};

module.exports = StickyAlertPortal;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(40);

var _require = __webpack_require__(271),
    Provider = _require.Provider;

var _require2 = __webpack_require__(370),
    combineReducers = _require2.combineReducers,
    createStore = _require2.createStore,
    applyMiddleware = _require2.applyMiddleware;

var UserStore = __webpack_require__(109);
var ContactDealerRenderer = __webpack_require__(705);
var authProcess = __webpack_require__(611);

var authConstants = __webpack_require__(263).default.constants;

var _require3 = __webpack_require__(493),
    reducers = _require3.reducers;

var store = createStore(combineReducers(reducers), applyMiddleware(__webpack_require__(545).default));
var modalContainer = document.createElement('div');

var _require4 = __webpack_require__(268),
    track = _require4.track;

module.exports = function (options) {
    var itemPk = options.itemPk,
        linkLocation = options.linkLocation,
        dealerPk = options.dealerPk,
        sellerData = options.sellerData,
        context = options.context,
        currentStep = options.currentStep,
        handleCtaClick = options.handleCtaClick,
        modalContentData = options.modalContentData;

    var fluxibleContext = context.getComponentContext ? context.getComponentContext() : context;
    var props = {
        itemPk: itemPk,
        linkLocation: linkLocation,
        currentStep: currentStep,
        handleCtaClick: handleCtaClick,
        modalContentData: modalContentData,
        dealerPk: sellerData ? sellerData.id : dealerPk
    };
    var pageCurrency = fluxibleContext.getStore(UserStore).getCurrency();

    var modalProps = Object.assign({}, props, {
        pageCurrency: pageCurrency,
        chatTracking: track,
        startAuth: function startAuth(authProps) {
            return authProcess(_extends({}, authProps, { flow: authProps.makeOffer && authConstants.CONTACT_DEALER_FORM_FLOW }));
        }
    });

    ReactDOM.render(React.createElement(
        Provider,
        { store: store },
        React.createElement(ContactDealerRenderer, { modalProps: modalProps })
    ), modalContainer);
};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Public modules meant to be consumed by other React components. Any additional generic carousels like these should be
// added in this directory and exported here. The "base" components are not meant to consumed directly.



module.exports = {
    ArrowCarousel: __webpack_require__(582),
    SwipeCarousel: __webpack_require__(521),
    ScrollCarousel: __webpack_require__(712)
};

/***/ }),
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(644)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ }),
/* 645 */,
/* 646 */,
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */,
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reducers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = __webpack_require__(550),
    PHOTO_UI_UPDATE_DIMENSIONS = _require.PHOTO_UI_UPDATE_DIMENSIONS,
    PHOTO_UI_SHOW_ITEM_TAGS = _require.PHOTO_UI_SHOW_ITEM_TAGS,
    PHOTO_UI_HIDE_ITEM_TAGS = _require.PHOTO_UI_HIDE_ITEM_TAGS,
    PHOTO_UI_SET_ITEM_TAG = _require.PHOTO_UI_SET_ITEM_TAG,
    PHOTO_UI_UNSET_ITEM_TAG = _require.PHOTO_UI_UNSET_ITEM_TAG;

var isNumber = function isNumber(n) {
    return typeof n === 'number';
};

var GalleryPhotoUIStore = {
    storeName: 'GalleryPhotoUIStore',
    initialState: {
        // item tag state
        showItemTags: false,
        activeItemTag: void 0,

        imageDimensions: {
            width: 0,
            height: 0
        }
    },

    reducers: (_reducers = {}, _defineProperty(_reducers, PHOTO_UI_UPDATE_DIMENSIONS, function (state) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            width = _ref.width,
            height = _ref.height;

        if (isNumber(width) && isNumber(height)) {
            return Object.assign({}, state, {
                imageDimensions: Object.assign({}, state.imageDimensions, {
                    width: width, height: height
                })
            });
        }
        return state;
    }), _defineProperty(_reducers, PHOTO_UI_SET_ITEM_TAG, function (state, activeItemTag) {
        if (activeItemTag) {
            state = Object.assign({}, state, {
                activeItemTag: activeItemTag
            });
        }
        return state;
    }), _defineProperty(_reducers, PHOTO_UI_UNSET_ITEM_TAG, function (state) {
        if (state.activeItemTag) {
            state = Object.assign({}, state, {
                activeItemTag: void 0
            });
        }
        return state;
    }), _defineProperty(_reducers, PHOTO_UI_SHOW_ITEM_TAGS, function (state) {
        if (!state.showItemTags) {
            state = Object.assign({}, state, {
                showItemTags: true
            });
        }
        return state;
    }), _defineProperty(_reducers, PHOTO_UI_HIDE_ITEM_TAGS, function (state) {
        if (state.showItemTags) {
            state = Object.assign({}, state, {
                showItemTags: false
            });
        }
        return state;
    }), _reducers),

    getters: {
        getImageDimensions: function getImageDimensions(state) {
            return state.imageDimensions;
        },
        getItemTagsState: function getItemTagsState(state) {
            return {
                showItemTags: state.showItemTags,
                activeItemTag: state.activeItemTag
            };
        }
    }
};

module.exports = GalleryPhotoUIStore;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Recursive function used to build a mapping of category keys to categories
 *  (E.G.
 *      categories = [{
 *          key: 'F',
 *          children: [{
 *              key: 'F_SEA',
 *              children: [{
 *                  key: 'F_SEA_COU'
 *              }, {
 *                  key: 'F_SEA_ARM'
 *              }]
 *          }]
 *      },{
 *          key: 'A',
 *          children: [{
 *              key: 'A_PHO',
 *              children: [{
 *                  key: 'A_PHO_PIC'
 *              }]
 *          }]
 *      }]
 *  => OUTPUT = {
 *      F: {key: 'F'...}
 *      F_SEA: {key: 'F_SEA'...}
 *      F_SEA_COU: {key: 'F_SEA_COU'...},
 *      F_SEA_ARM: {key: 'F_SEA_ARM'...},
 *      A: {key: 'A'...}
 *      A_PHO: {key: 'A_PHO'}
 *      A_PHO_PIC: {key: 'A_PHO_PIC'}
 *  }
 *
 * @param {array} categories - an array of categories each with a key and children
 * @param {Object} [map] - Map that is ultimately output with each key=category.key and
 *  value=category
 * @returns {Object}
 */

function buildCategoriesMap(categories) {
    var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return categories.reduce(function (_map, category) {
        _map[category.key] = Object.assign({}, category);
        delete _map[category.key].children;

        if (category.children && category.children.length) {
            buildCategoriesMap(category.children, _map);
        }

        return _map;
    }, map);
}

var CategoriesStore = {
    storeName: 'CategoriesStore',

    initialState: {
        categories: [],
        categoriesMap: {}
    },

    reducers: {
        SET_CATEGORIES: function SET_CATEGORIES(state, categories) {
            return Object.assign({}, state, {
                categories: categories,
                categoriesMap: buildCategoriesMap(categories)
            });
        }
    },

    getters: {
        getCategories: function getCategories(state) {
            return state.categories;
        },
        getCategoriesMap: function getCategoriesMap(state) {
            return state.categoriesMap;
        },
        getCategoryByKey: function getCategoryByKey(state, categoryKey) {
            return state.categoriesMap[categoryKey];
        }
    }
};

module.exports = CategoriesStore;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeYesCheckSelector = exports.makeArrayCompareSelector = exports.makeEqualityCheckSelector = undefined;

var _createSelector = __webpack_require__(490);

var _createSelector2 = _interopRequireDefault(_createSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a selector factory whose input will be checked for equality against
 * the resulting selector that gets returned
 *
 * Example:
 *
 * const item = { id: 0 };
 * const getId = item => item.id;
 * const idCompareSelector = makeEqualityCheckSelector(getId);
 * const getIsIdZero = makeIdCompareSelector(0);
 * assert(getIsIdZero(item));
 */
var makeEqualityCheckSelector = exports.makeEqualityCheckSelector = function makeEqualityCheckSelector() {
    for (var _len = arguments.length, dependencySelectors = Array(_len), _key = 0; _key < _len; _key++) {
        dependencySelectors[_key] = arguments[_key];
    }

    return function (inputToCompare) {
        return _createSelector2.default.apply(undefined, dependencySelectors.concat([function (selectorInput) {
            return selectorInput === inputToCompare;
        }]));
    };
};

/**
 * Creates a selector factory whose input will checked to see if it exists
 * in the array that the returning selector returns.
 *
 * Example:
 *
 * const item = { attributes: ['green', 'little', 'shiny'] };
 * const getAttributes = item => item.attributes;
 * const attributeCheckSelector = makeArrayCompareSelector(getAttributes);
 * const getHasGreenAttribute = makeAttributeCheckSelector('green');
 * assert(getHasGreenAttribute(item));
 */
var makeArrayCompareSelector = exports.makeArrayCompareSelector = function makeArrayCompareSelector() {
    for (var _len2 = arguments.length, dependencySelectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        dependencySelectors[_key2] = arguments[_key2];
    }

    return function (inputToCompare) {
        return _createSelector2.default.apply(undefined, dependencySelectors.concat([function (arrayToCheck) {
            return arrayToCheck.indexOf(inputToCompare) > -1;
        }]));
    };
};

/**
 * Creates a selector factory that will compare the result of the selector with 'Y'.
 * For data that, instead of being stored as booleans, are stored as 'Y' or 'N'
 *
 * Example:
 *
 * const item = { available: 'Y' };
 * const getAvailable = item => item.available;
 * const getIsAvailable = makeYesCheckSelector(getAvailable);
 * assert(getIsAvailable(item));
 */
var makeYesCheckSelector = exports.makeYesCheckSelector = function makeYesCheckSelector() {
    for (var _len3 = arguments.length, dependencySelectors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        dependencySelectors[_key3] = arguments[_key3];
    }

    var selectorFunc = dependencySelectors.pop();
    var selector = function selector(input) {
        var prop = selectorFunc(input);
        return prop === 'Y' || prop === true;
    };
    return dependencySelectors.length ? _createSelector2.default.apply(undefined, dependencySelectors.concat([selector])) : selector;
};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 9/25/15
 * Time: 6:26 PM
 * Copyright 1stdibs.com, Inc. 2015. All Rights Reserved.
 */



module.exports = Object.freeze({
    height: 'height',
    width: 'width',
    depth: 'depth',
    condition: 'condition',
    length: 'length'
});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 658 */,
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var FIELDS = {
    FIELD_FIRST_NAME: 'firstName',
    FIELD_LAST_NAME: 'lastName',
    FIELD_COMPANY: 'company',
    FIELD_LINE1: 'line1',
    FIELD_LINE2: 'line2',
    FIELD_COUNTRY: 'country',
    FIELD_CITY: 'city',
    FIELD_STATE: 'state',
    FIELD_ZIP_CODE: 'zipCode',
    FIELD_PHONE_NUMBER: 'phoneNumber'
};

var fields = [
    FIELDS.FIELD_FIRST_NAME,
    FIELDS.FIELD_LAST_NAME,
    FIELDS.FIELD_COMPANY,
    FIELDS.FIELD_LINE1,
    FIELDS.FIELD_LINE2,
    FIELDS.FIELD_COUNTRY,
    FIELDS.FIELD_CITY,
    FIELDS.FIELD_STATE,
    FIELDS.FIELD_ZIP_CODE,
    FIELDS.FIELD_PHONE_NUMBER
];

var optionalFields = [
    FIELDS.FIELD_COMPANY,
    FIELDS.FIELD_LINE2
];

var regexMap = {
    specialCharacters: /[!@#$%^&*()+=><?]/,
    specialCharactersAddress: /[!@$%^&*()+=><?]/,
    poBox: /^.*P(\.|\s|OST)*O(\.|\s|FFICE)*b\s*o\s*x.*$/i,
    globalZipCode: /^(?!((\w|\s|-){1,9})$)/,
    usZipCode: /^(?!(\d{5}(?:[-\s]?\d{4})?$))/,
    usZipCodeShort: /^(?!(\d{5}?$))/,
    all: /^(?!(.*))/
};

module.exports = {
    FIELDS: FIELDS,
    fields: fields,
    optionalFields: optionalFields,
    regexMap: regexMap
};


/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = {
	"optional": "Optional",
	"required": "Required field",
	"specialCharacters": "Should not contain special characters: !@#$%^&*()+=><?",
	"specialCharactersShort": "No special characters",
	"specialCharactersAddress": "Should not contain special characters: !@$%^&*()+=><?",
	"poBox": "Item may not ship to PO Box",
	"globalZipCode": "This field may only contain no more than 9 letters, numbers, spaces, and hyphens",
	"usZipCode": "This field may only contain numbers, spaces, and hyphens",
	"usZipCodeShort": "Please enter a valid 5-digit U.S. ZIP code",
	"usZipCodeShipping": "Please enter a valid U.S. ZIP code"
};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(646);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(657);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
    var _props$size = props.size,
        size = _props$size === undefined ? 'large' : _props$size,
        children = props.children,
        theme = props.theme,
        className = props.className,
        btnProps = (0, _objectWithoutProperties3.default)(props, ['size', 'children', 'theme', 'className']);


    return theme ? _react2.default.createElement(
        'button',
        (0, _extends3.default)({}, btnProps, {
            className: (0, _classnames2.default)(theme.button, theme[size], className)
        }),
        children
    ) : null;
};

exports.default = Button;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FolderWrapper = undefined;

	var _FolderWrapper = __webpack_require__(1);

	var _FolderWrapper2 = _interopRequireDefault(_FolderWrapper);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.FolderWrapper = _FolderWrapper2.default;
	exports.default = _FolderWrapper2.default;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJGb2xkZXJXcmFwcGVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7OztRQUVTQSxhIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy9zaGFuaWUvcHJvamVjdHMvZGlicy1jb21wb25lbnRzL2RpYnMtcG9ydGZvbGlvLWZvbGRlciIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBGb2xkZXJXcmFwcGVyIGZyb20gJy4vRm9sZGVyV3JhcHBlcic7XG5cbmV4cG9ydCB7IEZvbGRlcldyYXBwZXIgfTtcbmV4cG9ydCBkZWZhdWx0IEZvbGRlcldyYXBwZXI7XG4iXX0=

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FolderWrapper = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _reactRelay = __webpack_require__(3);

	var _reactRelay2 = _interopRequireDefault(_reactRelay);

	var _AddToFolderModal = __webpack_require__(4);

	var _AddToFolderModal2 = _interopRequireDefault(_AddToFolderModal);

	var _Folder = __webpack_require__(20);

	var _Folder2 = _interopRequireDefault(_Folder);

	var _lodash = __webpack_require__(17);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _ModifyPortfolioItems = __webpack_require__(22);

	var _ModifyPortfolioItems2 = _interopRequireDefault(_ModifyPortfolioItems);

	var _ModifyPortfolios = __webpack_require__(23);

	var _ModifyPortfolios2 = _interopRequireDefault(_ModifyPortfolios);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	// Components


	// Helpers


	// Mutations


	var FolderWrapper = exports.FolderWrapper = function (_React$Component) {
	    _inherits(FolderWrapper, _React$Component);

	    function FolderWrapper(props) {
	        _classCallCheck(this, FolderWrapper);

	        var _this = _possibleConstructorReturn(this, (FolderWrapper.__proto__ || Object.getPrototypeOf(FolderWrapper)).call(this, props));

	        _this.state = {
	            showModal: false
	        };

	        _this.closeModal = _this.closeModal.bind(_this);
	        _this.onFolderClick = _this.onFolderClick.bind(_this);
	        _this.onFolderRemove = _this.onFolderRemove.bind(_this);
	        _this.onFolderSave = _this.onFolderSave.bind(_this);
	        _this.onNewFolderSave = _this.onNewFolderSave.bind(_this);
	        _this.createFolder = _this.createFolder.bind(_this);
	        _this.modifyItemInFolder = _this.modifyItemInFolder.bind(_this);
	        return _this;
	    }

	    _createClass(FolderWrapper, [{
	        key: 'closeModal',
	        value: function closeModal() {
	            this.props.onModalClose();
	            this.setState({ showModal: false });
	        }
	    }, {
	        key: 'modifyItemInFolder',
	        value: function modifyItemInFolder(_ref) {
	            var _this2 = this;

	            var portfolioId = _ref.portfolioId,
	                _ref$itemId = _ref.itemId,
	                itemId = _ref$itemId === undefined ? null : _ref$itemId,
	                _ref$itemNote = _ref.itemNote,
	                itemNote = _ref$itemNote === undefined ? '' : _ref$itemNote,
	                action = _ref.action;

	            // Argument itemId above is for forcing the addition/removal of item(s) to a portfolio only
	            var _props = this.props,
	                allowSavingMultipleItems = _props.allowSavingMultipleItems,
	                primaryItemPk = _props.primaryItemPk,
	                selectedItemIds = _props.selectedItemIds,
	                viewer = _props.viewer;

	            var matchingFolders = (0, _lodash2.default)(viewer, 'portfolioItemMatches') || [];
	            var portfolioItemsIds = matchingFolders.reduce(function (matches, folder) {
	                if (folder.portfolioId === portfolioId && folder.portfolioItemPk === primaryItemPk) {
	                    matches.push(folder.portfolioItemId);
	                }
	                return matches;
	            }, []);

	            var itemIds = void 0;

	            if (itemId) {
	                itemIds = itemId;
	            } else if (allowSavingMultipleItems && selectedItemIds) {
	                itemIds = selectedItemIds;
	            } else if (primaryItemPk) {
	                itemIds = [primaryItemPk];
	            }

	            if (itemIds) {
	                this.props.relay.commitUpdate(new _ModifyPortfolioItems2.default({
	                    action: action,
	                    itemsIds: itemId || itemIds,
	                    note: itemNote,
	                    portfolioItemsIds: primaryItemPk ? portfolioItemsIds : null,
	                    portfolioId: portfolioId,
	                    userId: this.props.userId
	                }), {
	                    onSuccess: function onSuccess() {
	                        // force-fetching to sync relay store without fat query or requiring user input via props
	                        _this2.props.relay.forceFetch({ pauseData: false }, function (readyState) {
	                            if (readyState.done) {
	                                if (action === 'ADD') {
	                                    _this2.props.onAddItemSuccess();
	                                    if (itemNote) {
	                                        _this2.modifyItemInFolder({ portfolioId: portfolioId, itemNote: itemNote, action: 'EDIT' });
	                                    }

	                                    if (typeof (0, _lodash2.default)(_this2.props, 'trackingHooks.trackItemAdded') === 'function') {
	                                        _this2.props.trackingHooks.trackItemAdded(!!itemNote);
	                                    }
	                                } else if (action === 'REMOVE') {
	                                    _this2.props.onRemoveItemSuccess();

	                                    if (typeof (0, _lodash2.default)(_this2.props, 'trackingHooks.trackItemRemoved') === 'function') {
	                                        _this2.props.trackingHooks.trackItemRemoved();
	                                    }
	                                } else if (action === 'EDIT') {
	                                    _this2.props.onAddNoteSuccess();
	                                }
	                            }
	                        });
	                    },
	                    onFailure: function onFailure() {
	                        if (action === 'ADD') {
	                            _this2.props.onAddItemError();
	                        } else if (action === 'REMOVE') {
	                            _this2.props.onRemoveItemError();
	                        } else if (action === 'EDIT') {
	                            _this2.props.onAddNoteError();
	                        }
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'createFolder',
	        value: function createFolder(_ref2) {
	            var _this3 = this;

	            var portfolioName = _ref2.portfolioName,
	                _ref2$itemNote = _ref2.itemNote,
	                itemNote = _ref2$itemNote === undefined ? '' : _ref2$itemNote;

	            this.props.relay.commitUpdate(new _ModifyPortfolios2.default({
	                action: 'ADD',
	                name: portfolioName,
	                portfoliosType: 'FOLDER',
	                privacyLevel: 'PUBLIC',
	                userId: this.props.userId
	            }), {
	                onSuccess: function onSuccess(res) {
	                    _this3.props.onCreateFolderSuccess();
	                    _this3.modifyItemInFolder({
	                        portfolioId: res.modifyPortfolios.portfolio.serviceId,
	                        itemNote: itemNote,
	                        action: 'ADD'
	                    });

	                    if (typeof (0, _lodash2.default)(_this3.props, 'trackingHooks.trackFolderCreated') === 'function') {
	                        _this3.props.trackingHooks.trackFolderCreated(!!itemNote);
	                    }
	                },
	                onFailure: function onFailure(error) {
	                    _this3.props.onCreateFolderError(error);
	                }
	            });
	        }
	    }, {
	        key: 'onFolderRemove',
	        value: function onFolderRemove(_ref3) {
	            var portfolioId = _ref3.portfolioId;

	            this.closeModal();
	            this.props.onFolderRemove();
	            this.modifyItemInFolder({ portfolioId: portfolioId, action: 'REMOVE' });
	        }
	    }, {
	        key: 'onFolderSave',
	        value: function (_onFolderSave) {
	            function onFolderSave(_x) {
	                return _onFolderSave.apply(this, arguments);
	            }

	            onFolderSave.toString = function () {
	                return _onFolderSave.toString();
	            };

	            return onFolderSave;
	        }(function (_ref4) {
	            var portfolioId = _ref4.portfolioId,
	                _ref4$itemNote = _ref4.itemNote,
	                itemNote = _ref4$itemNote === undefined ? '' : _ref4$itemNote;

	            this.closeModal();
	            this.props.onFolderSave();
	            this.modifyItemInFolder({ portfolioId: portfolioId, itemNote: itemNote, action: 'ADD' });
	        })
	    }, {
	        key: 'onNewFolderSave',
	        value: function onNewFolderSave(_ref5) {
	            var portfolioName = _ref5.portfolioName,
	                _ref5$itemNote = _ref5.itemNote,
	                itemNote = _ref5$itemNote === undefined ? '' : _ref5$itemNote;

	            this.closeModal();
	            this.props.onNewFolderSave();
	            this.createFolder({ portfolioName: portfolioName, itemNote: itemNote });
	        }
	    }, {
	        key: 'onFolderClick',
	        value: function onFolderClick(e) {
	            var _this4 = this;

	            e.preventDefault();
	            if (this.props.forceAddToFolder && this.props.userId) {
	                var addToFolder = function addToFolder(_ref6) {
	                    var action = _ref6.action,
	                        itemId = _ref6.itemId,
	                        portfolioId = _ref6.portfolioId;

	                    _this4.modifyItemInFolder({ action: action, itemId: itemId, portfolioId: portfolioId });
	                };
	                this.props.onFolderClick(addToFolder);
	            } else if (this.props.userId) {
	                this.props.relay.forceFetch({ pauseData: false }, function (readyState) {
	                    if (readyState.done) {
	                        _this4.setState({
	                            showModal: true
	                        }, function () {
	                            _this4.props.onFolderClick();
	                        });
	                    }
	                });
	            } else {
	                var showModal = function showModal() {
	                    _this4.setState({ showModal: true });
	                };
	                this.props.authModalShow(showModal);
	            }

	            if (typeof (0, _lodash2.default)(this.props, 'trackingHooks.trackFolderClick') === 'function') {
	                this.props.trackingHooks.trackFolderClick();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                primaryItemPk = _props2.primaryItemPk,
	                viewer = _props2.viewer;

	            var portfolioItemMatches = (0, _lodash2.default)(viewer, 'portfolioItemMatches') || [];
	            var matchingFolders = portfolioItemMatches.reduce(function (matches, folder) {
	                if (folder.portfolioItemPk === primaryItemPk) {
	                    matches.push(folder);
	                }
	                return matches;
	            }, []);

	            return _react2.default.createElement(
	                'div',
	                null,
	                this.state.showModal && this.props.viewer.portfolioItemMatches ? _react2.default.createElement(_AddToFolderModal2.default, {
	                    closeModal: this.closeModal,
	                    first: 12,
	                    item: this.props.viewer.item || null,
	                    loadItem: this.props.loadItemData,
	                    loadPortfolios: true,
	                    matchingFolders: matchingFolders,
	                    onFolderSave: this.onFolderSave,
	                    onFolderRemove: this.onFolderRemove,
	                    onNewFolderSave: this.onNewFolderSave,
	                    currentPortfolioId: this.props.currentPortfolioId,
	                    selectedItemImages: this.props.selectedItemImages,
	                    selectedItemTitles: this.props.selectedItemTitles,
	                    userId: this.props.userId,
	                    viewer: this.props.viewer
	                }) : null,
	                _react2.default.createElement(_Folder2.default, {
	                    disabledButton: this.props.disabledButton,
	                    iconText: this.props.iconText,
	                    isInFolder: !!matchingFolders && !!matchingFolders.length,
	                    onClick: this.onFolderClick
	                })
	            );
	        }
	    }]);

	    return FolderWrapper;
	}(_react2.default.Component);

	FolderWrapper.defaultProps = {
	    authModalShow: function authModalShow() {},
	    currentPortfolioId: '',
	    disabledButton: false,
	    forceAddToFolder: false,
	    allowSavingMultipleItems: false,
	    loadPortfolioData: true,
	    loadItemData: true,
	    onCreateFolderError: function onCreateFolderError() {},
	    onCreateFolderSuccess: function onCreateFolderSuccess() {},
	    onAddItemError: function onAddItemError() {},
	    onAddItemSuccess: function onAddItemSuccess() {},
	    onAddNoteError: function onAddNoteError() {},
	    onAddNoteSuccess: function onAddNoteSuccess() {},
	    onFolderClick: function onFolderClick() {},
	    onFolderRemove: function onFolderRemove() {},
	    onFolderSave: function onFolderSave() {},
	    onModalClose: function onModalClose() {},
	    onNewFolderSave: function onNewFolderSave() {},
	    onRemoveItemError: function onRemoveItemError() {},
	    onRemoveItemSuccess: function onRemoveItemSuccess() {},
	    portfolioItemId: '',
	    primaryItemPk: '',
	    selectedItemImages: [],
	    selectedItemTitles: [],
	    selectedItemIds: [],
	    iconText: ''
	};

	exports.default = _reactRelay2.default.createContainer(FolderWrapper, {
	    initialVariables: {
	        loadItemData: true,
	        loadPortfolioData: true,
	        pauseData: false,
	        primaryItemPk: null,
	        selectedItemIds: [],
	        userId: null,
	        userIds: null
	    },
	    prepareVariables: function prepareVariables(params) {
	        var userId = params.userIds && params.userIds.length ? params.userIds[0] : params.userId;
	        return Object.assign({}, params, {
	            loadPortfolioData: !!params.selectedItemIds && !!params.selectedItemIds.length && !!userId && !params.pauseData,
	            loadItemData: !!params.primaryItemPk && !!params.loadItemData && !!userId,
	            userId: userId,
	            userIds: params.userIds && params.userIds.length ? params.userIds : [params.userId]
	        });
	    },
	    fragments: {
	        viewer: function viewer(_ref7) {
	            var loadItemData = _ref7.loadItemData,
	                loadPortfolioData = _ref7.loadPortfolioData,
	                primaryItemPk = _ref7.primaryItemPk,
	                userId = _ref7.userId;
	            return function (RQL_0, RQL_1) {
	                return {
	                    children: [].concat.apply([], [{
	                        calls: [{
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'itemId',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'primaryItemPk'
	                            }
	                        }],
	                        children: [].concat.apply([], [{
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }, _reactRelay2.default.QL.__frag(RQL_0)]),
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'include',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'loadItemData'
	                                }
	                            }]
	                        }],
	                        fieldName: 'item',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Item'
	                    }, {
	                        calls: [{
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'itemIds',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'selectedItemIds'
	                            }
	                        }, {
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'userIds',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'userIds'
	                            }
	                        }, {
	                            kind: 'Call',
	                            metadata: {
	                                type: '[PortfolioTypes]'
	                            },
	                            name: 'portfolioTypes',
	                            value: [{
	                                kind: 'CallValue',
	                                callValue: 'FOLDER'
	                            }]
	                        }],
	                        children: [{
	                            fieldName: 'portfolioId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'portfolioItemId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'portfolioItemPk',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'include',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'loadPortfolioData'
	                                }
	                            }]
	                        }],
	                        fieldName: 'portfolioItemMatches',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id',
	                            isPlural: true
	                        },
	                        type: 'PortfolioItemV2'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }, _reactRelay2.default.QL.__frag(RQL_1)]),
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'FolderWrapper_ViewerRelayQL',
	                    type: 'Viewer'
	                };
	            }(_AddToFolderModal2.default.getFragment('item', { primaryItemPk: primaryItemPk, userId: userId, loadItemData: loadItemData }), _AddToFolderModal2.default.getFragment('viewer', { userId: userId, loadItem: loadItemData }).if(loadPortfolioData));
	        }
	    }
	});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1);

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(18);

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AddToFolderModal = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _reactRelay = __webpack_require__(3);

	var _reactRelay2 = _interopRequireDefault(_reactRelay);

	var _dibsComModal = __webpack_require__(5);

	var _CreateFolderInline = __webpack_require__(6);

	var _CreateFolderInline2 = _interopRequireDefault(_CreateFolderInline);

	var _ItemPreviews = __webpack_require__(13);

	var _ItemPreviews2 = _interopRequireDefault(_ItemPreviews);

	var _dibsOverlaySpinner = __webpack_require__(14);

	var _dibsOverlaySpinner2 = _interopRequireDefault(_dibsOverlaySpinner);

	var _Portfolios = __webpack_require__(15);

	var _Portfolios2 = _interopRequireDefault(_Portfolios);

	var _classnames4 = __webpack_require__(8);

	var _classnames5 = _interopRequireDefault(_classnames4);

	var _lodash = __webpack_require__(17);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _styles = __webpack_require__(9);

	var _styles2 = _interopRequireDefault(_styles);

	__webpack_require__(19);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	// Components


	// Helpers


	// Styles


	// eslint-disable-line

	var AddToFolderModal = exports.AddToFolderModal = function (_React$Component) {
	    _inherits(AddToFolderModal, _React$Component);

	    function AddToFolderModal(props) {
	        _classCallCheck(this, AddToFolderModal);

	        var _this = _possibleConstructorReturn(this, (AddToFolderModal.__proto__ || Object.getPrototypeOf(AddToFolderModal)).call(this, props));

	        _this.state = {
	            editInline: false,
	            itemNote: '',
	            loading: false,
	            portfolioName: ''
	        };

	        _this.postponeOnFolder = false;
	        _this.postponeOnNewFolderSave = false;

	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.onFolder = _this.onFolder.bind(_this);
	        _this.onNewFolderSave = _this.onNewFolderSave.bind(_this);
	        _this.setEditInline = _this.setEditInline.bind(_this);
	        _this.setItemNote = _this.setItemNote.bind(_this);
	        _this.setPortfolioName = _this.setPortfolioName.bind(_this);
	        return _this;
	    }

	    _createClass(AddToFolderModal, [{
	        key: 'handleScroll',
	        value: function handleScroll(event) {
	            var _this2 = this;

	            var threshold = event.target.scrollTop >= event.target.clientHeight / 4;
	            var hasMoreItems = (0, _lodash2.default)(this.props, 'viewer.portfolios.totalResults') > this.props.relay.variables.first;

	            if (threshold && hasMoreItems) {
	                this.props.relay.setVariables({
	                    first: this.props.relay.variables.first + 12
	                }, function (state) {
	                    _this2.setState({
	                        loading: !state.done
	                    }, function () {
	                        if (_this2.postponeOnFolder) {
	                            _this2.onFolder(_this2.postponeOnFolder);
	                            _this2.postponeOnFolder = false;
	                        } else if (_this2.postponeOnNewFolderSave) {
	                            _this2.onNewFolderSave();
	                            _this2.postponeOnNewFolderSave = false;
	                        }
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'onFolder',
	        value: function onFolder(_ref) {
	            var portfolioId = _ref.portfolioId,
	                action = _ref.action;

	            if (this.state.loading) {
	                this.postponeOnFolder = { portfolioId: portfolioId, action: action };
	                return;
	            }
	            if (action === 'ADD') {
	                this.props.onFolderSave({ portfolioId: portfolioId, itemNote: this.state.itemNote });
	            } else {
	                this.props.onFolderRemove({ portfolioId: portfolioId });
	            }
	        }
	    }, {
	        key: 'onNewFolderSave',
	        value: function onNewFolderSave() {
	            if (this.state.loading) {
	                this.postponeOnNewFolderSave = true;
	                return;
	            }
	            this.props.onNewFolderSave({
	                portfolioName: this.state.portfolioName,
	                itemNote: this.state.itemNote
	            });
	        }
	    }, {
	        key: 'setEditInline',
	        value: function setEditInline(editInline) {
	            this.setState({ editInline: editInline });
	        }
	    }, {
	        key: 'setItemNote',
	        value: function setItemNote(itemNote) {
	            this.setState({ itemNote: itemNote });
	        }
	    }, {
	        key: 'setPortfolioName',
	        value: function setPortfolioName(portfolioName) {
	            this.setState({ portfolioName: portfolioName });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classnames,
	                _classnames2,
	                _classnames3,
	                _this3 = this;

	            var _props = this.props,
	                viewer = _props.viewer,
	                item = _props.item;
	            var editInline = this.state.editInline;

	            var totalResults = viewer.portfolios && viewer.portfolios.totalResults;
	            if (this.props.currentPortfolioId) {
	                totalResults--;
	            }
	            var selectedItemImages = this.props.selectedItemImages || [];
	            var selectedItemTitles = this.props.selectedItemTitles || [];

	            if (!!item && !!item.title && !!item.firstPhotoWebPath) {
	                selectedItemImages = [item.firstPhotoWebPath];
	                selectedItemTitles = [item.title];
	            }

	            var buttonClasses = (0, _classnames5.default)(_styles2.default.button, (_classnames = {}, _defineProperty(_classnames, _styles2.default.fixedButton, totalResults > 0), _defineProperty(_classnames, _styles2.default.nullButton, totalResults <= 0 && !editInline), _defineProperty(_classnames, _styles2.default.inputButton, totalResults <= 0 && editInline), _classnames));

	            var portfoliosClasses = (0, _classnames5.default)((_classnames2 = {}, _defineProperty(_classnames2, _styles2.default.portfolios, totalResults > 0), _defineProperty(_classnames2, _styles2.default.nullPortfolios, totalResults <= 0), _classnames2));

	            var titleClasses = (0, _classnames5.default)(_styles2.default.titleHeader, (_classnames3 = {}, _defineProperty(_classnames3, _styles2.default.fixed, totalResults > 5 || selectedItemImages.length === 1), _defineProperty(_classnames3, _styles2.default.expand, selectedItemImages.length === 1), _classnames3));

	            var showRemove = selectedItemImages.length === 1;

	            return _react2.default.createElement(
	                _dibsComModal.Modal,
	                {
	                    dataTn: 'select-portfolio',
	                    closeModal: this.props.closeModal,
	                    isOpened: true
	                },
	                _react2.default.createElement(
	                    _dibsComModal.Header,
	                    { closeModal: this.props.closeModal, dataTn: 'select-portfolio' },
	                    'Add to Folder'
	                ),
	                _react2.default.createElement(
	                    _dibsComModal.Body,
	                    { dataTn: 'select-portfolio' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.body },
	                        _react2.default.createElement(
	                            'div',
	                            { className: titleClasses },
	                            _react2.default.createElement(_ItemPreviews2.default, {
	                                dataTnImage: 'select-portfolio-modal-item-previews',
	                                dataTnTitle: 'select-portfolio-modal-title',
	                                itemImages: selectedItemImages,
	                                itemTitles: selectedItemTitles
	                            }),
	                            selectedItemImages && selectedItemImages.length === 1 ? _react2.default.createElement(
	                                'div',
	                                { className: _styles2.default.input },
	                                _react2.default.createElement('input', {
	                                    'data-tn': 'select-portfolio-note-input',
	                                    onChange: function onChange(e) {
	                                        return _this3.setItemNote(e.currentTarget.value);
	                                    },
	                                    placeholder: 'Add an optional note to your item',
	                                    type: 'text',
	                                    value: this.state.itemNote.slice(0, 250)
	                                })
	                            ) : null
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: portfoliosClasses, onScroll: this.handleScroll },
	                            !this.props.viewer ? _react2.default.createElement(_dibsOverlaySpinner2.default, {
	                                additionalSpinnerClasses: _styles2.default.additionalSpinnerClasses,
	                                position: 'isRelative'
	                            }) : _react2.default.createElement(_Portfolios2.default, {
	                                loading: this.state.loading,
	                                onClick: function onClick() {
	                                    return _this3.onFolder.apply(_this3, arguments);
	                                },
	                                matchingFolders: this.props.matchingFolders,
	                                showRemove: showRemove,
	                                portfolios: viewer.portfolios,
	                                currentPortfolioId: this.props.currentPortfolioId
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: buttonClasses },
	                            _react2.default.createElement(_CreateFolderInline2.default, {
	                                editInline: this.state.editInline,
	                                onChange: function onChange(name) {
	                                    return _this3.setPortfolioName(name);
	                                },
	                                onClick: function onClick() {
	                                    return _this3.setEditInline(true);
	                                },
	                                onClose: function onClose() {
	                                    return _this3.setEditInline(false);
	                                },
	                                onNewFolderSave: this.onNewFolderSave,
	                                value: this.state.portfolioName
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);

	    return AddToFolderModal;
	}(_react2.default.Component);

	exports.default = _reactRelay2.default.createContainer(AddToFolderModal, {
	    initialVariables: {
	        first: 12,
	        loadItem: true,
	        loadPortfolios: true,
	        userId: null
	    },
	    fragments: {
	        viewer: function viewer() {
	            return function () {
	                return {
	                    children: [{
	                        calls: [{
	                            kind: 'Call',
	                            metadata: {
	                                type: 'Int'
	                            },
	                            name: 'first',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'first'
	                            }
	                        }, {
	                            kind: 'Call',
	                            metadata: {
	                                type: '[PortfolioTypes]'
	                            },
	                            name: 'portfolioTypes',
	                            value: [{
	                                kind: 'CallValue',
	                                callValue: 'FOLDER'
	                            }]
	                        }, {
	                            kind: 'Call',
	                            metadata: {
	                                type: 'PortfoliosSortByTypes'
	                            },
	                            name: 'sortBy',
	                            value: {
	                                kind: 'CallValue',
	                                callValue: 'CUSTOM'
	                            }
	                        }, {
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'userIds',
	                            value: [{
	                                kind: 'CallVariable',
	                                callVariableName: 'userId'
	                            }]
	                        }],
	                        children: [{
	                            fieldName: 'totalResults',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'Int'
	                        }, {
	                            children: [{
	                                children: [{
	                                    fieldName: 'name',
	                                    kind: 'Field',
	                                    metadata: {},
	                                    type: 'String'
	                                }, {
	                                    fieldName: 'serviceId',
	                                    kind: 'Field',
	                                    metadata: {},
	                                    type: 'ID'
	                                }, {
	                                    calls: [{
	                                        kind: 'Call',
	                                        metadata: {
	                                            type: 'Int'
	                                        },
	                                        name: 'first',
	                                        value: {
	                                            kind: 'CallValue',
	                                            callValue: 1
	                                        }
	                                    }, {
	                                        kind: 'Call',
	                                        metadata: {
	                                            type: 'PortfolioItemsSortByTypes'
	                                        },
	                                        name: 'sortBy',
	                                        value: {
	                                            kind: 'CallValue',
	                                            callValue: 'CUSTOM'
	                                        }
	                                    }],
	                                    children: [{
	                                        children: [{
	                                            children: [{
	                                                children: [{
	                                                    calls: [{
	                                                        kind: 'Call',
	                                                        metadata: {
	                                                            type: 'ImageVersionTypeName!'
	                                                        },
	                                                        name: 'size',
	                                                        value: {
	                                                            kind: 'CallValue',
	                                                            callValue: 'large'
	                                                        }
	                                                    }],
	                                                    fieldName: 'firstPhotoWebPath',
	                                                    kind: 'Field',
	                                                    metadata: {},
	                                                    type: 'String'
	                                                }, {
	                                                    fieldName: 'id',
	                                                    kind: 'Field',
	                                                    metadata: {
	                                                        isGenerated: true,
	                                                        isRequisite: true
	                                                    },
	                                                    type: 'ID'
	                                                }],
	                                                fieldName: 'item',
	                                                kind: 'Field',
	                                                metadata: {
	                                                    canHaveSubselections: true,
	                                                    inferredRootCallName: 'node',
	                                                    inferredPrimaryKey: 'id'
	                                                },
	                                                type: 'Item'
	                                            }, {
	                                                fieldName: 'id',
	                                                kind: 'Field',
	                                                metadata: {
	                                                    isGenerated: true,
	                                                    isRequisite: true
	                                                },
	                                                type: 'ID'
	                                            }],
	                                            fieldName: 'node',
	                                            kind: 'Field',
	                                            metadata: {
	                                                canHaveSubselections: true,
	                                                inferredRootCallName: 'node',
	                                                inferredPrimaryKey: 'id',
	                                                isRequisite: true
	                                            },
	                                            type: 'PortfolioItemV2'
	                                        }, {
	                                            fieldName: 'cursor',
	                                            kind: 'Field',
	                                            metadata: {
	                                                isGenerated: true,
	                                                isRequisite: true
	                                            },
	                                            type: 'String'
	                                        }],
	                                        fieldName: 'edges',
	                                        kind: 'Field',
	                                        metadata: {
	                                            canHaveSubselections: true,
	                                            isPlural: true
	                                        },
	                                        type: 'PortfolioItemsEdge'
	                                    }, {
	                                        children: [{
	                                            fieldName: 'hasNextPage',
	                                            kind: 'Field',
	                                            metadata: {
	                                                isGenerated: true,
	                                                isRequisite: true
	                                            },
	                                            type: 'Boolean'
	                                        }, {
	                                            fieldName: 'hasPreviousPage',
	                                            kind: 'Field',
	                                            metadata: {
	                                                isGenerated: true,
	                                                isRequisite: true
	                                            },
	                                            type: 'Boolean'
	                                        }],
	                                        fieldName: 'pageInfo',
	                                        kind: 'Field',
	                                        metadata: {
	                                            canHaveSubselections: true,
	                                            isGenerated: true,
	                                            isRequisite: true
	                                        },
	                                        type: 'PageInfo'
	                                    }],
	                                    fieldName: 'items',
	                                    kind: 'Field',
	                                    metadata: {
	                                        canHaveSubselections: true,
	                                        isConnection: true
	                                    },
	                                    type: 'PortfolioItemsConnection'
	                                }, {
	                                    fieldName: 'id',
	                                    kind: 'Field',
	                                    metadata: {
	                                        isGenerated: true,
	                                        isRequisite: true
	                                    },
	                                    type: 'ID'
	                                }],
	                                fieldName: 'node',
	                                kind: 'Field',
	                                metadata: {
	                                    canHaveSubselections: true,
	                                    inferredRootCallName: 'node',
	                                    inferredPrimaryKey: 'id',
	                                    isRequisite: true
	                                },
	                                type: 'PortfolioV2'
	                            }, {
	                                fieldName: 'cursor',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'String'
	                            }],
	                            fieldName: 'edges',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                isPlural: true
	                            },
	                            type: 'PortfoliosEdge'
	                        }, {
	                            children: [{
	                                fieldName: 'hasNextPage',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'Boolean'
	                            }, {
	                                fieldName: 'hasPreviousPage',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'Boolean'
	                            }],
	                            fieldName: 'pageInfo',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'PageInfo'
	                        }],
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'include',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'loadPortfolios'
	                                }
	                            }]
	                        }],
	                        fieldName: 'portfolios',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            isConnection: true
	                        },
	                        type: 'PortfoliosConnection'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'AddToFolderModal_ViewerRelayQL',
	                    type: 'Viewer'
	                };
	            }();
	        },
	        item: function item() {
	            return function () {
	                return {
	                    children: [{
	                        calls: [{
	                            kind: 'Call',
	                            metadata: {
	                                type: 'ImageVersionTypeName!'
	                            },
	                            name: 'size',
	                            value: {
	                                kind: 'CallValue',
	                                callValue: 'large'
	                            }
	                        }],
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'include',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'loadItem'
	                                }
	                            }]
	                        }],
	                        fieldName: 'firstPhotoWebPath',
	                        kind: 'Field',
	                        metadata: {},
	                        type: 'String'
	                    }, {
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'include',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'loadItem'
	                                }
	                            }]
	                        }],
	                        fieldName: 'title',
	                        kind: 'Field',
	                        metadata: {},
	                        type: 'String'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'AddToFolderModal_ItemRelayQL',
	                    type: 'Item'
	                };
	            }();
	        }
	    }
	});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(591);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _circlePlus = __webpack_require__(7);

	var _circlePlus2 = _interopRequireDefault(_circlePlus);

	var _classnames2 = __webpack_require__(8);

	var _classnames3 = _interopRequireDefault(_classnames2);

	var _styles = __webpack_require__(9);

	var _styles2 = _interopRequireDefault(_styles);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	// Components


	// Helpers


	// Styles


	var CreateFolderInline = function CreateFolderInline(props) {
	    var saveClasses = (0, _classnames3.default)(_styles2.default.saveButton + ' button button-primary button-large', _defineProperty({}, _styles2.default.disabled, !props.value));

	    if (props.editInline) {
	        return _react2.default.createElement(
	            'div',
	            { className: _styles2.default.inlineInput },
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.close, 'data-tn': 'select-portfolio-create-folder-close', onClick: props.onClose },
	                _react2.default.createElement(_circlePlus2.default, { className: _styles2.default.closeIcon })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.inline },
	                _react2.default.createElement('input', {
	                    'data-tn': 'select-portfolio-create-folder-input',
	                    onChange: function onChange(e) {
	                        return props.onChange(e.currentTarget.value);
	                    },
	                    placeholder: 'Enter folder name',
	                    type: 'text',
	                    value: props.value.slice(0, 250)
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.saveInline },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-tn': 'select-portfolio-create-folder-save',
	                        className: saveClasses,
	                        onClick: props.onNewFolderSave
	                    },
	                    'Save'
	                )
	            )
	        );
	    } else {
	        return _react2.default.createElement(
	            'div',
	            { className: _styles2.default.add, 'data-tn': 'select-portfolio-create-folder-button', onClick: props.onClick },
	            _react2.default.createElement(_circlePlus2.default, { className: _styles2.default.addIcon }),
	            _react2.default.createElement(
	                'span',
	                { className: _styles2.default.addText },
	                'Create New Folder'
	            )
	        );
	    }
	};

	exports.default = CreateFolderInline;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(631);

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(698);

/***/ },
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"folder":"src-styles---folder---bTafq","body":"src-styles---body---3JTUa","iconButton":"src-styles---iconButton---2H_H2","icon":"src-styles---icon---3K4sp","disabled":"src-styles---disabled---bNrPz","text":"src-styles---text---16qtR","isFilled":"src-styles---isFilled---3t4mc","isOutlined":"src-styles---isOutlined---5CJ0i","header":"src-styles---header---20Bo6","button":"src-styles---button---1v679","saveButton":"src-styles---saveButton---2Zjav","fixedButton":"src-styles---fixedButton---3GTBp","inlineInput":"src-styles---inlineInput---H_gZj","inputButton":"src-styles---inputButton---D2nk5","nullButton":"src-styles---nullButton---iJXBS","title":"src-styles---title---XHc_7","box":"src-styles---box---3n5vw","previewContainer":"src-styles---previewContainer---16cC1","chairIcon":"src-styles---chairIcon---2Zr6E","nullPortfolios":"src-styles---nullPortfolios---H-PLo","name":"src-styles---name---1getY","namePreview":"src-styles---namePreview---2MWto","organize":"src-styles---organize---2e-aT","bold":"src-styles---bold---2KUH7","info":"src-styles---info---1fe6w","photo":"src-styles---photo---2Wk-R","input":"src-styles---input---2Xtz4","inline":"src-styles---inline---1hhNg","add":"src-styles---add---3SbiL","addIcon":"src-styles---addIcon---3XDNt","close":"src-styles---close---jdMQl","closeIcon":"src-styles---closeIcon---1hE4f","addText":"src-styles---addText---24KTA","saveInline":"src-styles---saveInline---otP4q","additionalSpinnerClasses":"src-styles---additionalSpinnerClasses---2or1Y","under":"src-styles---under---2PHPU","titleHeader":"src-styles---titleHeader---3IK2i","fixed":"src-styles---fixed---32b6c","multi":"src-styles---multi---1FBlB","preview":"src-styles---preview---c8JU0","itemPreviews":"src-styles---itemPreviews---qJ055","mobileSave":"src-styles---mobileSave---c43nZ","desktopSave":"src-styles---desktopSave---2362g","portfolios":"src-styles---portfolios---1HUGu","portfolio":"src-styles---portfolio---Q590r"};

/***/ },
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _classnames2 = __webpack_require__(8);

	var _classnames3 = _interopRequireDefault(_classnames2);

	var _styles = __webpack_require__(9);

	var _styles2 = _interopRequireDefault(_styles);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	// Helpers


	// Styles


	var ItemPreviews = function (_React$Component) {
	    _inherits(ItemPreviews, _React$Component);

	    function ItemPreviews(props) {
	        _classCallCheck(this, ItemPreviews);

	        var _this = _possibleConstructorReturn(this, (ItemPreviews.__proto__ || Object.getPrototypeOf(ItemPreviews)).call(this, props));

	        _this.state = {
	            note: ''
	        };
	        return _this;
	    }

	    _createClass(ItemPreviews, [{
	        key: 'render',
	        value: function render() {
	            var nonPreviewedEl = void 0;
	            var itemImagesCount = (this.props.itemImages || []).length;
	            var itemImagePreviews = this.props.itemImages.slice().splice(0, 4);
	            var previewEls = itemImagePreviews.map(function (image, index) {
	                var imageClasses = (0, _classnames3.default)(_styles2.default.previewContainer, _defineProperty({}, _styles2.default.multi, itemImagesCount > 1));

	                return _react2.default.createElement(
	                    'div',
	                    { key: image + '-' + index, className: imageClasses },
	                    _react2.default.createElement('img', { className: _styles2.default.preview, src: image })
	                );
	            });

	            if (itemImagesCount > 4) {
	                nonPreviewedEl = _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.previewContainer },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.preview },
	                        '+',
	                        itemImagesCount - 4
	                    )
	                );
	            }

	            return _react2.default.createElement(
	                'div',
	                { className: _styles2.default.itemPreviews },
	                previewEls,
	                itemImagesCount === 1 ? _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.name + ' ' + _styles2.default.namePreview },
	                    this.props.itemTitles[0]
	                ) : null,
	                nonPreviewedEl
	            );
	        }
	    }]);

	    return ItemPreviews;
	}(_react2.default.Component);

	exports.default = ItemPreviews;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(368);

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _chairOutlined = __webpack_require__(16);

	var _chairOutlined2 = _interopRequireDefault(_chairOutlined);

	var _dibsOverlaySpinner = __webpack_require__(14);

	var _dibsOverlaySpinner2 = _interopRequireDefault(_dibsOverlaySpinner);

	var _lodash = __webpack_require__(17);

	var _lodash2 = _interopRequireDefault(_lodash);

	__webpack_require__(18);

	var _styles = __webpack_require__(9);

	var _styles2 = _interopRequireDefault(_styles);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// Styles
	var Portfolios = function Portfolios(_ref) {
	    var loading = _ref.loading,
	        matchingFolders = _ref.matchingFolders,
	        _onClick = _ref.onClick,
	        currentPortfolioId = _ref.currentPortfolioId,
	        portfolios = _ref.portfolios,
	        showRemove = _ref.showRemove;

	    var numPortfolios = portfolios ? portfolios.totalResults : 0;

	    // if portfolioId provided, remove it from total portfolio count
	    if (currentPortfolioId) {
	        numPortfolios--;
	    }

	    // If a user has portfolios....
	    if (numPortfolios > 0) {
	        var matches = void 0;

	        // If the user has selected only on item to "Folder", then find the matching folders (showRemove)
	        if (showRemove) {
	            matches = matchingFolders.map(function (matchingFolder) {
	                return matchingFolder.portfolioId;
	            });
	        }
	        var portfolioElements = portfolios.edges.map(function (portfolio) {
	            var portfolioId = portfolio.node.serviceId;

	            // If user is currently viewing this portfolio, remove it from list
	            if (portfolioId === currentPortfolioId) {
	                return null;
	            }

	            var buttonText = 'Save';
	            var buttonAction = 'ADD';

	            // Change the button text and action to 'Remove' if current portfolio is found in array of matching portfolios
	            if (showRemove && matches && matches.indexOf(portfolioId) !== -1) {
	                buttonText = 'Remove';
	                buttonAction = 'REMOVE';
	            }

	            // Grab associated portfolioId (for adding & removing items)
	            var src = (0, _lodash2.default)(portfolio, 'node.items.edges[0].node.item.firstPhotoWebPath', '');

	            return _react2.default.createElement(
	                'div',
	                { className: _styles2.default.portfolio, key: portfolioId },
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.box, 'data-tn': 'select-portfolio-folder-' + (src ? 'thumbnail' : 'empty-icon') + '-container' },
	                    src ? _react2.default.createElement('img', { className: _styles2.default.photo, 'data-tn': 'select-portfolio-folder-thumbnail', src: src, alt: portfolio.node.name }) : _react2.default.createElement(_chairOutlined2.default, { className: _styles2.default.chairIcon })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.name, 'data-tn': 'select-portfolio-folder-name' },
	                    portfolio.node.name
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.desktopSave },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            'data-tn': 'select-portfolio-modal-folder-button',
	                            className: 'button button-primary button-medium',
	                            onClick: function onClick() {
	                                return _onClick({ portfolioId: portfolioId, action: buttonAction });
	                            }
	                        },
	                        buttonText
	                    )
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: '#0', className: _styles2.default.mobileSave, onClick: function onClick() {
	                            return _onClick({ portfolioId: portfolioId, action: buttonAction });
	                        } },
	                    buttonText
	                )
	            );
	        });
	        return _react2.default.createElement(
	            'div',
	            null,
	            portfolioElements,
	            loading ? _react2.default.createElement(_dibsOverlaySpinner2.default, {
	                additionalSpinnerClasses: _styles2.default.additionalSpinnerClasses + ' ' + _styles2.default.under,
	                position: 'isRelative'
	            }) : null
	        );
	    } else {
	        // If a user has no portfolios...
	        return _react2.default.createElement(
	            'div',
	            { className: _styles2.default.organize },
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.bold },
	                'Organize your favorites in folders'
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _styles2.default.info },
	                'Create a new folder to get started (ex. bedroom project, beach house, jewelry wishlist)'
	            )
	        );
	    }
	};

	// Helpers


	// Components
	exports.default = Portfolios;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(607);

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(699);

/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(508);

/***/ },
/* 19 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(730);

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _folder = __webpack_require__(21);

	var _folder2 = _interopRequireDefault(_folder);

	var _classnames3 = __webpack_require__(8);

	var _classnames4 = _interopRequireDefault(_classnames3);

	var _styles = __webpack_require__(9);

	var _styles2 = _interopRequireDefault(_styles);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	// Components


	// Helpers


	// Styles


	var Folder = function Folder(props) {
	    var _classnames;

	    var iconClasses = (0, _classnames4.default)(_styles2.default.icon, (_classnames = {}, _defineProperty(_classnames, _styles2.default.isFilled, props.isInFolder), _defineProperty(_classnames, _styles2.default.isOutlined, !props.isInFolder), _classnames));

	    var dataTn = props.isInFolder ? 'folder-saved-icon' : 'folder-save-icon';

	    if (props.iconText) {
	        var buttonClasses = (0, _classnames4.default)(_styles2.default.iconButton, _defineProperty({}, _styles2.default.disabled, props.disabledButton));

	        return _react2.default.createElement(
	            'button',
	            { className: buttonClasses, 'data-tn': 'add-to-folder', onClick: props.onClick },
	            _react2.default.createElement(_folder2.default, { className: _styles2.default.icon }),
	            _react2.default.createElement(
	                'span',
	                { className: _styles2.default.text },
	                props.iconText
	            )
	        );
	    }
	    return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.folder, 'data-tn': dataTn, onClick: props.onClick },
	        _react2.default.createElement(_folder2.default, { className: iconClasses })
	    );
	};

	exports.default = Folder;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(608);

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _reactRelay = __webpack_require__(3);

	var _reactRelay2 = _interopRequireDefault(_reactRelay);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ModifyPortfolioItems = function (_Relay$Mutation) {
	    _inherits(ModifyPortfolioItems, _Relay$Mutation);

	    function ModifyPortfolioItems() {
	        _classCallCheck(this, ModifyPortfolioItems);

	        return _possibleConstructorReturn(this, (ModifyPortfolioItems.__proto__ || Object.getPrototypeOf(ModifyPortfolioItems)).apply(this, arguments));
	    }

	    _createClass(ModifyPortfolioItems, [{
	        key: 'getMutation',
	        value: function getMutation() {
	            return function () {
	                return {
	                    calls: [{
	                        kind: 'Call',
	                        metadata: {},
	                        name: 'modifyPortfolioItems',
	                        value: {
	                            kind: 'CallVariable',
	                            callVariableName: 'input'
	                        }
	                    }],
	                    children: [{
	                        fieldName: 'clientMutationId',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'String'
	                    }],
	                    kind: 'Mutation',
	                    metadata: {
	                        inputType: 'ModifyPortfolioItemsInput!'
	                    },
	                    name: 'ModifyPortfolioItems',
	                    responseType: 'ModifyPortfolioItemsPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getVariables',
	        value: function getVariables() {
	            var _props = this.props,
	                action = _props.action,
	                itemsIds = _props.itemsIds,
	                note = _props.note,
	                portfolioId = _props.portfolioId,
	                portfolioItemsIds = _props.portfolioItemsIds,
	                userId = _props.userId;


	            var inputs = { action: action, portfolioId: portfolioId, userId: userId };

	            if (action === 'REMOVE') {
	                return _extends({}, inputs, { portfolioItemsIds: portfolioItemsIds });
	            } else if (action === 'ADD') {
	                return _extends({}, inputs, { itemsIds: itemsIds });
	            } else if (action === 'EDIT') {
	                return _extends({}, inputs, { itemsIds: itemsIds, note: note, portfolioItemsIds: portfolioItemsIds, userId: userId });
	            }
	            return null;
	        }
	    }, {
	        key: 'getFatQuery',
	        value: function getFatQuery() {
	            return function () {
	                return {
	                    children: [{
	                        children: [{
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'portfolio',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'PortfolioV2'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {
	                        pattern: true
	                    },
	                    name: 'ModifyPortfolioItems_ValueRelayQL',
	                    type: 'ModifyPortfolioItemsPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getConfigs',
	        value: function getConfigs() {
	            return [{
	                type: 'REQUIRED_CHILDREN',
	                children: [function () {
	                    return {
	                        children: [{
	                            children: [{
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }],
	                            fieldName: 'portfolio',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'PortfolioV2'
	                        }],
	                        id: _reactRelay2.default.QL.__id(),
	                        kind: 'Fragment',
	                        metadata: {
	                            pattern: true
	                        },
	                        name: 'ModifyPortfolioItems_ChildrenRelayQL',
	                        type: 'ModifyPortfolioItemsPayload'
	                    };
	                }()]
	            }];
	        }
	    }]);

	    return ModifyPortfolioItems;
	}(_reactRelay2.default.Mutation);

	exports.default = ModifyPortfolioItems;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _reactRelay = __webpack_require__(3);

	var _reactRelay2 = _interopRequireDefault(_reactRelay);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ModifyPortfolios = function (_Relay$Mutation) {
	    _inherits(ModifyPortfolios, _Relay$Mutation);

	    function ModifyPortfolios() {
	        _classCallCheck(this, ModifyPortfolios);

	        return _possibleConstructorReturn(this, (ModifyPortfolios.__proto__ || Object.getPrototypeOf(ModifyPortfolios)).apply(this, arguments));
	    }

	    _createClass(ModifyPortfolios, [{
	        key: 'getMutation',
	        value: function getMutation() {
	            return function () {
	                return {
	                    calls: [{
	                        kind: 'Call',
	                        metadata: {},
	                        name: 'modifyPortfolios',
	                        value: {
	                            kind: 'CallVariable',
	                            callVariableName: 'input'
	                        }
	                    }],
	                    children: [{
	                        fieldName: 'clientMutationId',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'String'
	                    }],
	                    kind: 'Mutation',
	                    metadata: {
	                        inputType: 'ModifyPortfoliosInput!'
	                    },
	                    name: 'ModifyPortfolios',
	                    responseType: 'ModifyPortfoliosPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getVariables',
	        value: function getVariables() {
	            var _props = this.props,
	                action = _props.action,
	                portfoliosType = _props.portfoliosType,
	                userId = _props.userId;

	            if (action === 'ADD') {
	                var inputs = { action: action, name: this.props.name, portfoliosType: portfoliosType, userId: userId };
	                if (this.props.description) {
	                    inputs = _extends({}, inputs, { description: this.props.description });
	                }
	                if (this.props.privacyLevel) {
	                    inputs = _extends({}, inputs, { privacyLevel: this.props.privacyLevel });
	                }
	                return inputs;
	            }
	            return null;
	        }
	    }, {
	        key: 'getFatQuery',
	        value: function getFatQuery() {
	            return function () {
	                return {
	                    children: [{
	                        children: [{
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }, {
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }],
	                        fieldName: 'portfolio',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'PortfolioV2'
	                    }, {
	                        children: [{
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'portfolios',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id',
	                            isPlural: true
	                        },
	                        type: 'PortfolioV2'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {
	                        pattern: true
	                    },
	                    name: 'ModifyPortfolios_ValueRelayQL',
	                    type: 'ModifyPortfoliosPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getConfigs',
	        value: function getConfigs() {
	            return [{
	                type: 'REQUIRED_CHILDREN',
	                children: [function () {
	                    return {
	                        children: [{
	                            children: [{
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, {
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }],
	                            fieldName: 'portfolio',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'PortfolioV2'
	                        }, {
	                            children: [{
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, {
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }],
	                            fieldName: 'portfolios',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id',
	                                isPlural: true
	                            },
	                            type: 'PortfolioV2'
	                        }],
	                        id: _reactRelay2.default.QL.__id(),
	                        kind: 'Fragment',
	                        metadata: {
	                            pattern: true
	                        },
	                        name: 'ModifyPortfolios_ChildrenRelayQL',
	                        type: 'ModifyPortfoliosPayload'
	                    };
	                }()]
	            }];
	        }
	    }]);

	    return ModifyPortfolios;
	}(_reactRelay2.default.Mutation);

	exports.default = ModifyPortfolios;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }
/******/ ]);

/***/ }),
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 6/17/16.
 */



var intelligentFormatObj = __webpack_require__(536);

module.exports = {
    /**
     *
     * @param {object} copy
     * @param {boolean} isSoldIndividually
     * @param {number|string} price
     * @param {string} currency
     * @returns {{string, abbreviation, perItem: string}}
     */
    formatPrice: function formatPrice(_ref) {
        var _ref$copy = _ref.copy,
            copy = _ref$copy === undefined ? {} : _ref$copy,
            isSoldIndividually = _ref.isSoldIndividually,
            price = _ref.price,
            currency = _ref.currency;

        var priceStates = copy.priceStates || {};

        var _intelligentFormatObj = intelligentFormatObj(price, currency),
            sign = _intelligentFormatObj.sign,
            currencySymbol = _intelligentFormatObj.currencySymbol,
            number = _intelligentFormatObj.number,
            abbreviation = _intelligentFormatObj.abbreviation;

        var string = (sign + ' ' + currencySymbol + number).trim();
        var perItem = '';

        if (isSoldIndividually) {
            perItem += ' ' + priceStates.perItem;
        }

        return {
            string: string,
            abbreviation: abbreviation,
            perItem: perItem
        };
    },
    calculatePercentageOff: function calculatePercentageOff(_ref2) {
        var net = _ref2.net,
            retail = _ref2.retail;

        var percentage = net / retail * 100;
        return Math.round(100 - percentage) + '%';
    }
};

/***/ }),
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var assign = __webpack_require__(60);
var matches = __webpack_require__(719);
module.exports = function (options) {
    var curNode;
    options = assign({
        el : undefined,
        parent: document,
        filter: undefined,
        matchParent: false
    }, options);
    curNode = options.el;
    while (
        curNode &&
        curNode !== document &&
        curNode !== options.parent
    ) {
        if (matches(curNode, options.filter)) {
            return curNode;
        }
        curNode = curNode.parentNode;
    }
    if (options.matchParent && curNode.matches(options.filter)) {
        return curNode;
    }
};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * BunsenModal is a modal native to Bunsen and does not on jQuery plugins or external css files.
 * i.e. it can be used exactly the same way in .com and adminv2 without modifications to the
 * entry .js or base .twig file. Supports an extended subset of the modalMap interface from
 * adminv2's popModal view.
 *
 * @param {Object}        modalConfig         - modal config object. Provide as the value for your modalMap's attributes
 * @param {String}        modalConfig.title   - title of modal
 * @param {Function}      modalConfig.options - a function that returns an options map for the content view constructor
 * @param {Object}        modalConfig.options - an options map that will be passed to the modal content view constructor (see documentation for BunsenModal.prototype.initialize)
 * @param {Constructor}   modalConfig.View    - a Backbone View constructor that will be used to build the modal content
 * @param {Backbone.View} modalConfig.view    - a Backbone View instance (if provided, modalConfig.options will be ignored)
 * @example
 * Use with your view like this:
 *
 *    var extendCompose = require('bunsen/libraries/extendCompose');
 *    var Backbone = require('backbone');
 *
 *    var MyView = extendCompose.call(Backbone.View, [BunsenModal.mixin, {
 *        el: $("<div><div data-modal='myModal'>click to open my modal</div></div>"),
 *        modalMap: {
 *            myModal: {
 *                reuse: true, // set to false if the modal and content view is to be re-created every time it is opened
 *                title: "This is the modal's title",
 *                options: function () {
 *                    // return an options map to be passed to View constructor
 *                },
 *                View: MyModalContentView
 *            }
 *        }
 *    }]);
 */

__webpack_require__(703);
var template = __webpack_require__(716).template;
var PresentationManager = __webpack_require__(614);
var normalizeToView = __webpack_require__(502);
var Floater = __webpack_require__(613);
var ButtonView = __webpack_require__(695);
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var bind = __webpack_require__(108);
var newsy = __webpack_require__(41);
var Backbone = __webpack_require__(3);
var messageMixin = __webpack_require__(694);
var mobileCheck = __webpack_require__(279);
var BunsenModal;
var popModal;
var $window;
var $body;

var getButtonsAlignment = function (buttonsAlignment) {
    return _.contains(['center', 'right'], buttonsAlignment) ? buttonsAlignment : 'left';
};

popModal = function (modalName) {
    var modal = new PresentationManager({
        configGroup: 'modalMap',
        parentView: this,
        viewConfigKey: modalName
    }).getView(newsy.getConstructor({
        key: 'BunsenModal',
        defaultConstructor: BunsenModal
    }));

    modal.show();
    return modal;
};
BunsenModal = module.exports = Floater.extend([messageMixin, {
    animated: true,
    position: {
        my: "center",
        at: "center",
        of: window
    },
    template: {
        src: template,
        useInnerElement: true
    },
    events: {
        'transitionend' : function (e) {
            e.stopPropagation();
        },
        'keydown .bunsen-modal-body' : function (e) { // TODO: get this working. It's not handling events as expected
            if (27 !== e.keyCode) { // escape key
                return;
            }

            this.hide();
        },
        'click .bunsen-modal-close' : 'hide',
        'click .bunsen-modal-scrim' : 'hide'
    },
    /**
     * @param {Backbone.View} options.content - content view for the modal. `el` will be appended to the modal's content area
     * @param {String} options.content - Markup to be parsed with jQuery and used as content for the modal
     * @param {DOM Element} options.content - Dom element to be appended to the content area of the modal
     * @param {jQuery} options.content - jQuery element to whose first element will be appended to the content area of the modal
     * @param {Boolean} options.manageValidButtons - disables all buttons if the contentview's model becomes invalid.
     * @param {Boolean} options.nestedEvents - listens to nested events from associated model when checking for model changes.
     * @param {Boolean} options.buttonsAlignment - set the buttons alignment to center/left/right (default: left). This value is relayed to ButtonView as options.prependLoading so the loading indicator will appear to the left of the right/center-justified buttons.
     */
    initialize: function (options) {
        var view;
        var contentModel;
        var buttonView;
        var manageButtonStates;
        $window = $(window);
        $body = $('body');
        options = _.extend({
            width: undefined,
            parentView: this,
            css: undefined,
            buttonsAlignment: 'left',
            showClose: true,
            title: undefined,
            titleHTML: undefined,
            buttons: undefined,
            manageValidButtons: false,
            manageButtonsValidator: undefined,
            nestedEvents: false,
            content: {  // content for the modal, it goes through jquery.append, so it can be stright HTML or an element.
                template: _.template("")
            }
        }, options);
        this._bodyProps = {};
        this._buttonsAlignment = getButtonsAlignment(options.buttonsAlignment);
        this._buttons = options.buttons;
        this._buttonAutoClose = options.buttonAutoClose;
        this._classNames = _.extend({
            modal: '',
            body: '',
            scrim: '',
            header: '',
            content: '',
            buttons: '',
            close: ''
        }, this.classNames, options.classNames);

        if (_.isFunction(options.content)) {
            options.content = options.content.call(options.parentView);
        }
        view = normalizeToView(_.pick(options, 'content', 'Constructor'));
        BunsenModal.__super__.initialize.apply(this, arguments);
        contentModel = _.result(view, 'model');
        buttonView = this.getSubView('buttons');
        if (buttonView) {
            buttonView.defaultContext = view;
        }
        if (options.manageValidButtons && buttonView && contentModel) {
            manageButtonStates = function () {
                var isValid = !_.result(contentModel, 'validate');
                if (_.isFunction(options.manageButtonsValidator)) {
                    isValid = !options.manageButtonsValidator.call(view);
                }
                _.result(buttonView, isValid ? 'reEnableButtons' : 'disableButtons');
            };
            contentModel.on('change', manageButtonStates);
            if (options.nestedEvents) {
                contentModel.on('nested-change', manageButtonStates);
            }
            manageButtonStates();
        }
        this.$(".bunsen-modal-content").append(view.el);
        this.$modal = this.$(".bunsen-modal-body");
        if (options.css) {
            this.$modal.css(options.css);
        }
        if (options.overflowScroll) {
            this.$modal.addClass('overflow-scroll');
        }
        if (options.title && options.titleHTML) {
            throw new Error('options.title and options.titleHTML were both defined, this will cause undefined behavior.');
        }
        this.model = new Backbone.Model(_.pick(options, 'title', 'titleHTML', 'showClose'));
        _.bindAll(this, 'center');
        bind(this);
        return options;
    },
    getMainElement: function () {
        return this.$modal.get(0);
    },
    show__: function () {
        $window.on('resize', this.center);
        this.disableScrolling();
    },
    hide__: function () {
        $window.off('resize', this.center);
        this.enableScrolling();
    },
    close: function () { // TODO: remove all uses of this method
        console.warn("BunsenModal's close method is deprecated. Use .hide() instead");
        return this.hide.apply(this, arguments);
    },
    open: function () { // TODO: remove all uses of this method
        console.warn("BunsenModal's open method is deprecated. Use .show() instead");
        return this.show.apply(this, arguments);
    },
    disableScrolling: function () {
        var $mainEl = $(this.getMainElement());
        var height;
        var winHeight;
        var top;

        this._bodyProps.position = $body.css('position');

        $body.addClass('modal-open');

        if (mobileCheck.any()) {
            $body.css({position: 'static'});

            height = $mainEl.height();
            winHeight = $window.height();
            top = (winHeight - height) / 2;
            if (top < 0) {
                top = 0;
                $mainEl.height('100%');
                $mainEl.css('overflow', 'scroll');
            }

            $mainEl.parent().css('position', 'fixed');
            if (!this.isCenteringDisabled()) {
                $mainEl.css('top', top);
            }
        }
    },
    enableScrolling: function () {
        $body.removeClass('modal-open');
        $body.css({position: this._bodyProps.position});
    },
    updateHeader: function (title) {
        this.model.set('title', title);
    },
    templateVars__ : function (obj) {
        return _.extend({
            buttonsAlignment: this._buttonsAlignment,
            classNames: this._classNames
        }, obj);
    },
    scope : {
        buttons: function () {
            if (!this._buttons) {
                return false;
            }
            var buttonView = new ButtonView({
                btnTmpl: this.btnTmpl,
                prependLoading: this._buttonsAlignment !== 'left',
                buttons: this._buttons
            }).render();
            if (this._buttonAutoClose) {
                buttonView.on('buttonClick', function (btnConfig, state) {
                    if ('rejected' !== state) {
                        this.hide({button: btnConfig});
                    }
                }, this);
            }
            return buttonView;
        }
    }
}], {
    newsy: 'BunsenModal',
    mixin: { // intended for use with ExtendCompose
        popModal: popModal,
        events__: {
            'click': PresentationManager.buildActivationEventHandler({
                dataAttribute: 'modal',
                handleGotKey: popModal
            })
        },
        modalMap__: {}
    }
});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Adapted from https://github.com/jquery/jquery-ui/blob/master/ui/position.js:
// - commonjsified
// - does not depend on jquery ui

// description: Positions elements relative to other elements.
// docs: http://api.jqueryui.com/position/
// demos: http://jqueryui.com/position/

var $ = __webpack_require__(5);
var cachedScrollbarWidth;
var max = Math.max;
var abs = Math.abs;
var round = Math.round;
var rhorizontal = /left|center|right/;
var rvertical = /top|center|bottom/;
var roffset = /[\+\-]\d+(\.[\d]+)?%?/;
var rposition = /^\w+/;
var rpercent = /%$/;
// Support: IE <=9 only
var supportsOffsetFractions = function () {
    var element = $("<div>")
        .css("position", "absolute")
        .appendTo("body")
        .offset({
            top: 1.5,
            left: 1.5
        }),
        support = element.offset().top === 1.5;

    element.remove();

    supportsOffsetFractions = function () {
        return support;
    };

    return support;
};
var getOffsets = function (offsets, width, height) {
    return [
        parseFloat(offsets[0]) * (rpercent.test(offsets[0]) ? width / 100 : 1),
        parseFloat(offsets[1]) * (rpercent.test(offsets[1]) ? height / 100 : 1)
    ];
};
var parseCss = function (element, property) {
    return parseInt($.css(element, property), 10) || 0;
};
var getDimensions = function (elem) {
    var raw = elem[0];
    if (raw.nodeType === 9) {
        return {
            width: elem.width(),
            height: elem.height(),
            offset: { top: 0, left: 0 }
        };
    }
    if ($.isWindow(raw)) {
        return {
            width: elem.width(),
            height: elem.height(),
            offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
        };
    }
    if (raw.preventDefault) {
        return {
            width: 0,
            height: 0,
            offset: { top: raw.pageY, left: raw.pageX }
        };
    }
    return {
        width: elem.outerWidth(),
        height: elem.outerHeight(),
        offset: elem.offset()
    };
};
var scrollbarWidth = function () {
    var div;
    var innerDiv;
    var w1;
    var w2;
    if (cachedScrollbarWidth !== undefined) {
        return cachedScrollbarWidth;
    }
    div = $("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>");
    innerDiv = div.children()[0];
    $("body").append(div);
    w1 = innerDiv.offsetWidth;
    div.css("overflow", "scroll");
    w2 = innerDiv.offsetWidth;
    if (w1 === w2) {
        w2 = div[0].clientWidth;
    }
    div.remove();
    return (cachedScrollbarWidth = w1 - w2);
};
var getScrollInfo = function (within) {
    var overflowX = within.isWindow || within.isDocument ? "" : within.element.css("overflow-x");
    var overflowY = within.isWindow || within.isDocument ? "" : within.element.css("overflow-y");
    var hasOverflowX = overflowX === "scroll" || (overflowX === "auto" && within.width < within.element[0].scrollWidth);
    var hasOverflowY = overflowY === "scroll" || (overflowY === "auto" && within.height < within.element[0].scrollHeight);
    return {
        width: hasOverflowY ? scrollbarWidth() : 0,
        height: hasOverflowX ? scrollbarWidth() : 0
    };
};
var getWithinInfo = function (element) {
    var withinElement = $(element || window);
    var isWindow = $.isWindow(withinElement[0]);
    var isDocument = !!withinElement[0] && withinElement[0].nodeType === 9;
    return {
        element: withinElement,
        isWindow: isWindow,
        isDocument: isDocument,
        offset: withinElement.offset() || { left: 0, top: 0 },
        scrollLeft: withinElement.scrollLeft(),
        scrollTop: withinElement.scrollTop(),
        width: withinElement.outerWidth(),
        height: withinElement.outerHeight()
    };
};

var uiPosition = module.exports = {
    positionElement: function (element, options) {
        // make a copy, we don't want to modify arguments
        var $element;
        var target;
        var within;
        var scrollInfo;
        var collision;
        var offsets = {};
        var collisionPosition;
        var using;
        var elemWidth;
        var elemHeight;
        var marginLeft;
        var marginTop;
        var collisionWidth;
        var collisionHeight;
        var position;
        var myOffset;
        var atOffset;
        var targetWidth;
        var targetHeight;
        var targetOffset;
        var basePosition;
        var dimensions;

        options = $.extend({}, options);

        target = $(options.of);
        within = getWithinInfo(options.within);
        scrollInfo = getScrollInfo(within);
        collision = (options.collision || "flip").split(" ");

        dimensions = getDimensions(target);
        if (target[0].preventDefault) {
            // force left top to allow flipping
            options.at = "left top";
        }
        targetWidth = dimensions.width;
        targetHeight = dimensions.height;
        targetOffset = dimensions.offset;
        // clone to reuse original targetOffset later
        basePosition = $.extend({}, targetOffset);

        // force my and at to have valid horizontal and vertical positions
        // if a value is missing or invalid, it will be converted to center
        $.each(["my", "at"], function () {
            var pos = (options[this] || "").split(" "),
                horizontalOffset,
                verticalOffset;

            if (pos.length === 1) {
                pos = rhorizontal.test(pos[0]) ?
                    pos.concat(["center"]) :
                    rvertical.test(pos[0]) ?
                        ["center"].concat(pos) :
                        ["center", "center"];
            }
            pos[0] = rhorizontal.test(pos[0]) ? pos[0] : "center";
            pos[1] = rvertical.test(pos[1]) ? pos[1] : "center";

            // calculate offsets
            horizontalOffset = roffset.exec(pos[0]);
            verticalOffset = roffset.exec(pos[1]);
            offsets[this] = [
                horizontalOffset ? horizontalOffset[0] : 0,
                verticalOffset ? verticalOffset[0] : 0
            ];

            // reduce to just the positions without the offsets
            options[this] = [
                rposition.exec(pos[0])[0],
                rposition.exec(pos[1])[0]
            ];
        });

        // normalize collision option
        if (collision.length === 1) {
            collision[1] = collision[0];
        }

        if (options.at[0] === "right") {
            basePosition.left += targetWidth;
        } else if (options.at[0] === "center") {
            basePosition.left += targetWidth / 2;
        }

        if (options.at[1] === "bottom") {
            basePosition.top += targetHeight;
        } else if (options.at[1] === "center") {
            basePosition.top += targetHeight / 2;
        }

        atOffset = getOffsets(offsets.at, targetWidth, targetHeight);
        basePosition.left += atOffset[0];
        basePosition.top += atOffset[1];

        $element = $(element);
        elemWidth = $element.outerWidth();
        elemHeight = $element.outerHeight();
        marginLeft = parseCss(element, "marginLeft");
        marginTop = parseCss(element, "marginTop");
        collisionWidth = elemWidth + marginLeft + parseCss(element, "marginRight") + scrollInfo.width;
        collisionHeight = elemHeight + marginTop + parseCss(element, "marginBottom") + scrollInfo.height;
        position = $.extend({}, basePosition);
        myOffset = getOffsets(offsets.my, $element.outerWidth(), $element.outerHeight());

        if (options.my[0] === "right") {
            position.left -= elemWidth;
        } else if (options.my[0] === "center") {
            position.left -= elemWidth / 2;
        }

        if (options.my[1] === "bottom") {
            position.top -= elemHeight;
        } else if (options.my[1] === "center") {
            position.top -= elemHeight / 2;
        }

        position.left += myOffset[0];
        position.top += myOffset[1];

        // if the browser doesn't support fractions, then round for consistent results
        if (!supportsOffsetFractions()) {
            position.left = round(position.left);
            position.top = round(position.top);
        }

        collisionPosition = {
            marginLeft: marginLeft,
            marginTop: marginTop
        };

        $.each(["left", "top"], function (i, dir) {
            if (uiPosition[collision[i]]) {
                uiPosition[collision[i]][dir](position, {
                    targetWidth: targetWidth,
                    targetHeight: targetHeight,
                    elemWidth: elemWidth,
                    elemHeight: elemHeight,
                    collisionPosition: collisionPosition,
                    collisionWidth: collisionWidth,
                    collisionHeight: collisionHeight,
                    offset: [atOffset[0] + myOffset[0], atOffset[1] + myOffset[1]],
                    my: options.my,
                    at: options.at,
                    within: within,
                    elem: $element
                });
            }
        });

        if (options.using) {
            // adds feedback as second argument to using callback, if present
            using = function (props) {
                var left = targetOffset.left - position.left,
                    right = left + targetWidth - elemWidth,
                    top = targetOffset.top - position.top,
                    bottom = top + targetHeight - elemHeight,
                    feedback = {
                        target: {
                            element: target,
                            left: targetOffset.left,
                            top: targetOffset.top,
                            width: targetWidth,
                            height: targetHeight
                        },
                        element: {
                            element: $element,
                            left: position.left,
                            top: position.top,
                            width: elemWidth,
                            height: elemHeight
                        },
                        horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
                        vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
                    };
                if (targetWidth < elemWidth && abs(left + right) < targetWidth) {
                    feedback.horizontal = "center";
                }
                if (targetHeight < elemHeight && abs(top + bottom) < targetHeight) {
                    feedback.vertical = "middle";
                }
                if (max(abs(left), abs(right)) > max(abs(top), abs(bottom))) {
                    feedback.important = "horizontal";
                } else {
                    feedback.important = "vertical";
                }
                options.using.call(element, props, feedback);
            };
        }

        $element.offset($.extend(position, {using: using}));
    },
    fit: {
        left: function (position, data) {
            var within = data.within,
                withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
                outerWidth = within.width,
                collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                overLeft = withinOffset - collisionPosLeft,
                overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
                newOverRight;

            // element is wider than within
            if (data.collisionWidth > outerWidth) {
                // element is initially over the left side of within
                if (overLeft > 0 && overRight <= 0) {
                    newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
                    position.left += overLeft - newOverRight;
                // element is initially over right side of within
                } else if (overRight > 0 && overLeft <= 0) {
                    position.left = withinOffset;
                // element is initially over both left and right sides of within
                } else {
                    if (overLeft > overRight) {
                        position.left = withinOffset + outerWidth - data.collisionWidth;
                    } else {
                        position.left = withinOffset;
                    }
                }
            // too far left -> align with left edge
            } else if (overLeft > 0) {
                position.left += overLeft;
            // too far right -> align with right edge
            } else if (overRight > 0) {
                position.left -= overRight;
            // adjust based on position and margin
            } else {
                position.left = max(position.left - collisionPosLeft, position.left);
            }
        },
        top: function (position, data) {
            var within = data.within,
                withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
                outerHeight = data.within.height,
                collisionPosTop = position.top - data.collisionPosition.marginTop,
                overTop = withinOffset - collisionPosTop,
                overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
                newOverBottom;

            // element is taller than within
            if (data.collisionHeight > outerHeight) {
                // element is initially over the top of within
                if (overTop > 0 && overBottom <= 0) {
                    newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
                    position.top += overTop - newOverBottom;
                // element is initially over bottom of within
                } else if (overBottom > 0 && overTop <= 0) {
                    position.top = withinOffset;
                // element is initially over both top and bottom of within
                } else {
                    if (overTop > overBottom) {
                        position.top = withinOffset + outerHeight - data.collisionHeight;
                    } else {
                        position.top = withinOffset;
                    }
                }
            // too far up -> align with top
            } else if (overTop > 0) {
                position.top += overTop;
            // too far down -> align with bottom edge
            } else if (overBottom > 0) {
                position.top -= overBottom;
            // adjust based on position and margin
            } else {
                position.top = max(position.top - collisionPosTop, position.top);
            }
        }
    },
    flip: {
        left: function (position, data) {
            var within = data.within,
                withinOffset = within.offset.left + within.scrollLeft,
                outerWidth = within.width,
                offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
                collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                overLeft = collisionPosLeft - offsetLeft,
                overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
                myOffset = data.my[0] === "left" ?
                    -data.elemWidth :
                    data.my[0] === "right" ?
                        data.elemWidth :
                        0,
                atOffset = data.at[0] === "left" ?
                    data.targetWidth :
                    data.at[0] === "right" ?
                        -data.targetWidth :
                        0,
                offset = -2 * data.offset[0],
                newOverRight,
                newOverLeft;

            if (overLeft < 0) {
                newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
                if (newOverRight < 0 || newOverRight < abs(overLeft)) {
                    position.left += myOffset + atOffset + offset;
                }
            } else if (overRight > 0) {
                newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
                if (newOverLeft > 0 || abs(newOverLeft) < overRight) {
                    position.left += myOffset + atOffset + offset;
                }
            }
        },
        top: function (position, data) {
            var within = data.within,
                withinOffset = within.offset.top + within.scrollTop,
                outerHeight = within.height,
                offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
                collisionPosTop = position.top - data.collisionPosition.marginTop,
                overTop = collisionPosTop - offsetTop,
                overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
                top = data.my[1] === "top",
                myOffset = top ?
                    -data.elemHeight :
                    data.my[1] === "bottom" ?
                        data.elemHeight :
                        0,
                atOffset = data.at[1] === "top" ?
                    data.targetHeight :
                    data.at[1] === "bottom" ?
                        -data.targetHeight :
                        0,
                offset = -2 * data.offset[1],
                newOverTop,
                newOverBottom;
            if (overTop < 0) {
                newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
                if (newOverBottom < 0 || newOverBottom < abs(overTop)) {
                    position.top += myOffset + atOffset + offset;
                }
            } else if (overBottom > 0) {
                newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
                if (newOverTop > 0 || abs(newOverTop) < overBottom) {
                    position.top += myOffset + atOffset + offset;
                }
            }
        }
    },
    flipfit: {
        left: function () {
            uiPosition.flip.left.apply(this, arguments);
            uiPosition.fit.left.apply(this, arguments);
        },
        top: function () {
            uiPosition.flip.top.apply(this, arguments);
            uiPosition.fit.top.apply(this, arguments);
        }
    }
};


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// from modernizr according to http://davidwalsh.name/css-animation-callback
var t;
var el = document.createElement('fakeelement');
var transitions = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd'
};

for (t in transitions) {
    if (el.style[t] !== undefined) {
        module.exports = transitions[t];
        break;
    }
}


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var _ = __webpack_require__(534);
var Backbone = __webpack_require__(3);

'use strict';

var AlertView;

/**
 * @class AlertView
 * @extends Backbone.View
 *
 * Simple standardized view to render an alert DOM element
 *
 * @param {object} [options]
 * @param {string} [options.alert]
 *      The message to display
 * @param {string} [options.type]
 *      The kind of alert, can be an 'info', 'success', or an 'error' alert
 * @param {object} [options.config]
 * @param {boolean} [options.config.close]
 *      Whether the user is allowed to close the alert message or not
 * @param {boolean} [options.config.animate]
 *      Whether the alert message should be animated, true by default
 * @param {number} [options.config.autoClose]
 *      The number of milliseconds before automatically closing
 * @param {boolean} [options.config.noDefaultClasses]
 *      If true, will not add classes: 'alert alert-' + alert.type
 */
AlertView = Backbone.View.extend({

    template: _.template("<% if (obj.close) { %><button type='button' class='close' data-dismiss='alert'><span aria-hidden='true'><i class='fa fa-times'></i></span></button><% } %><%= obj.message %> <% _.each(obj.actions, function (v, k) { %> <span class='alert-action' data-action='<%- k %>'><%- v %></span><% }) %>"),

    initialize: function (options) {
        var events = {};
        this.alert = _.extend({
            type: 'info ',
            message: typeof options.alert === "string" ? options.alert : _.result(options.alert, 'responseText')
        }, _.pick(options, 'type', 'actions'));
        this.config = _.extend({ // default config
            animate: false,
            close: false,
            autoClose: 0,
            noDefaultClasses: false
        }, _.result(options, 'config'));
        if (this.config.close) {
            events['click .close'] = this.close;
        }
        // alias reset
        this.reset = this.resetMessage;
        this.actionEvents = _.reduce(options.actions, function (memo, value, actionKey) {
            memo['click [data-action=' + actionKey + ']'] = value.click;
            return memo;
        }, {});
        this.alert.actions = _.reduce(options.actions, function (memo, value, actionKey) {
            memo[actionKey] = value.label;
            return memo;
        }, {});
        this.delegateEvents(_.extend(events, options.events, this.actionEvents));
    },

    render: function () {
        var defaultClasses = 'alert alert-' + this.alert.type;
        var classes = (this.config.class) ? '' + this.config.class : '';
        var dataTn = 'alert-' + this.alert.type;

        if (!this.config.noDefaultClasses) {
            classes += ' ' + defaultClasses;
        }

        this.$el
            .html(this.template(_.extend(_.pick(this.config, 'close'), this.alert)))
            .attr('class', '')
            .attr('data-tn', dataTn)
            .addClass(classes);

        // If the user wants this alert div to be animated, then set the height and opacity to zero
        if (this.config.animate) {
            this.el.style.display = "none";
        }
        return this;
    },

    /**
     * Animates the element to expand it's container, then fade in
     * @param {function} after
     *      optional callback function after animation is complete
     * @memberOf AlertView#
     * @returns {AlertView}
     */
    slideFadeIn: function (after) {
        var that = this,
            height,
            padding,
            border = parseInt(that.$el.css("border-top-width"), 10) +
                parseInt(that.$el.css("border-bottom-width"), 10);

        that.$el.css({ display: 'block' });

        height = that.$el.height();
        padding = (that.$el.innerHeight() - height) / 2;

        that.$el.css({
            height: 0,
            opacity: 0,
            paddingTop: 0,
            paddingBottom: 0
        });

        that.animDfd = $.Deferred();
        that.$el.animate({
            height: height + (padding * 2) + border, // add padding since this is box-sizing border-box
            paddingTop: padding,
            paddingBottom: padding
        }, 300, function () {
            that.$el.animate({
                opacity: 1
            }, 200, function () {
                that.animDfd.resolve();
                that.$el.css('height', 'auto');
                if ($.isFunction(after)) {
                    after.apply(that);
                }
            });
        });

        this.setAutoClose();

        return this;
    },

    /**
     * Animate the element to fade out and then contract the element
     * until it's height is zero, used as the default close animation
     * @param after {Function}
     *      callback function after the animation is complete
     * @memberOf AlertView#
     * return {AlertView}
     */
    slideFadeOut: function (after) {
        var that = this;

        that.$el.animate({ opacity: 0 }, 200, function () {
            that.$el.slideToggle(300, function () {
                that.$el.removeAttr('style');
                that.$el.hide();
                if ($.isFunction(after)) {
                    after.apply(that);
                }
            });
        });
        return this;
    },

    /**
     * Display the alertView. Animates if
     * config.aminate is true
     * @memberOf AlertView#
     * @returns {AlertView}
     */
    open: function () {
        var self = this;

        if (this.config.animate) {
            this.slideFadeIn();
        } else {
            this.$el.show();
        }

        self.setAutoClose();

        return this;
    },

    /**
     * Hide the AlertView
     * @memberOf AlertView#
     * @return {Object} AlertView
     */
    close: function (event) {
        if (event) {
            event.stopPropagation();
        }

        if (typeof this.config.onClose === "function") {
            this.config.onClose.call(this);
        }

        if (this.config.animate) {
            this.slideFadeOut(this.remove);
        } else {
            this.$el.hide();
        }

        return this;
    },

    /**
     * Auto close the alertView after
     * config.autoClose time ms
     * @memberOf AlertView#
     */
    setAutoClose: function () {
        var self = this;
        if (self.timeout) {
            clearTimeout(self.timeout);
        }
        if (self.config.autoClose !== 0) {
            self.timeout = setTimeout(function () {
                self.$el.fadeOut(function () {
                    self.close();
                });
            }, self.config.autoClose);
        }
    },

    /**
     * @memberOf AlertView#
     * @param {string} newMessage
     * @param {string} newType
     */
    resetMessage: function (newMessage, newType) {
        this.$el.show();
        $.when(this.animDfd).done($.proxy(function () {
            if (this.config.animate) {
                this.animDfd = $.Deferred();
                this.$el.animate({opacity: 0}, $.proxy(function () {
                    this.alert.message = newMessage;
                    this.$el
                        .html(this.template(_.extend(_.pick(this.config, 'close'), this.alert)))
                        .removeClass('alert-' + this.alert.type)
                        .addClass('alert-' + newType)
                        .animate({ opacity: 1 }, this.animDfd.resolve());
                    this.alert.type = newType;
                }, this));
            } else {
                this.alert.message = newMessage;
                this.alert.type = newType;
                this.render();
            }
        }, this));
        this.setAutoClose();
    }
});

module.exports = AlertView;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by dev on 2/22/16.
 */


var AlertView = __webpack_require__(693);
var _ = __webpack_require__(534);
var $ = __webpack_require__(5);

/**
 * Adds alert message functionality to your view
 *
 *
 * @example
 * _.extend(MyView.prototype, viewMessage)
 * var test = new MyView();
 * test.message('Hello!, this message brought to you by message mixin', 'info', '.message-wrapper');
 *
 * @mixin messageMixin
 */
module.exports = /* @lends messageMixin */{
    /**
     * Display a message on the form view.
     * @param {string} text The text to display
     * @param {string} [type] The type of message (error, info, or success)
     * @param {string|HTMLElement|$} [where]
     *      Where to put the message (a selector or an element). If not provided
     *      it will look for a 'messageLocation' property on the view to use instead
     * @param {object} config The alertView config
     * @memberOf messageMixin
     * @return Backbone.View
     */
    message: function (options) {
        var key;
        var $where;
        if ("string" === typeof options) {
            options = {};
            options.text = arguments[0];
            options.type = arguments[1];
            options.where = arguments[2];
            options.config = arguments[3];
        }
        options = $.extend(true, {
            text: ((options.type === 'error') ? 'The server encountered an error.' : 'Your item is being saved...'),
            type: 'info',
            where: this.messageLocation,
            config: {
                animate: true,
                close: true
            }
        }, options);
        if (!options.where) {
            return this;
        }

        key = options.where;

        if (!_.isString(options.where)) {
            if (!this._messageLocations) {
                this._messageLocations = [];
            }
            key = _.indexOf(this._messageLocations, options.where);
            if (key === -1) {
                this._messageLocations[(key = this._messageLocations.length)] = options.where;
            }
        }

        if (!this._messages) {
            this._messages = {};
        }

        this._messages[key] = this._messages[key] || new AlertView($.extend(true,
                {alert: options.text},
                _.pick(options, 'type', 'config', 'actions')
            ));

        $where = this.$(options.where);

        if (!$where.find('.alert').length) {
            $where.html(this._messages[key].$el.stop());
            _.extend(this._messages[key].alert, {
                message: options.text,
                type: options.type
            });
            this._messages[key].render()
                .open()
                .delegateEvents();
        } else {
            this._messages[key].resetMessage(options.text, options.type);
        }

        return this;
    },
    /**
     * Close a message
     * @param {string|HTMLElement|$} where
     * @memberOf messageMixin
     * @returns {Backbone.View}
     */
    closeMessage: function (where) {
        var message;
        where = where || this.messageLocation;

        if (!this._messages) {
            return this;
        }

        message = this.getMessage(where);

        if (!message) {
            return this;
        }

        // don't execute close if element is already hidden
        if (message.$el.css('display') !== 'none') {
            message.close();
        }
        return this;
    },
    /**
     * Gets the message location view.
     * @param {string|HTMLElement|$} where
     * @returns {AlertView|false} View where message should be
     * @memberOf messageMixin
     */
    getMessage: function (where) {
        if (_.isString(where)) {
            return this._messages[where];
        }
        if (this._messageLocations) {
            return this._messages[_.indexOf(this._messageLocations, where)];
        }
        return false;
    }
};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by dev on 2/8/16.
 */


var Backbone = __webpack_require__(3);
var _ = __webpack_require__(535);
var $ = __webpack_require__(5);
var templates = __webpack_require__(717);

/**
 * A view to make a series of buttons in a simple wrapper
 *
 * @class ButtonView
 * @extends Backbone.BaseView
 *
 * @param {object} options
 *
 * @param {object[]} options.buttons
 *      An array of objects that will each be passed to the button-view template.
 *      Additionally, each object should have a 'handler' function that will be
 *      called on when the button is clicked
 * @param {string} [options.disabledClass=dibs-disable disabled]
 * @param {string} [options.loadingClass=icon icon-xlarge icon-spinner icon-spin]
 * @param {boolean} [options.prependLoading=false]
 */
var ButtonView = Backbone.BaseView.extend({
    tagName: 'ul',
    className: 'controls-group list-inline',
    disabledClass: 'disabled dibs-disable',
    loadingClass : 'icon icon-xlarge fa fa-spinner fa-spin',
    initialize: function (options) {
        this.options = options || {};
        this.btnTpl = options.btnTmpl || templates['button-view-template'];
        this._buttons = _.chain(options.buttons).map(function (btnOptions, btn) {
            if (!btnOptions) {
                return;
            }
            if (btnOptions instanceof Function) {
                btnOptions = {
                    handler: btnOptions
                };
            }
            btnOptions = _.extend({
                key: btn,
                text: btn
            }, btnOptions);
            return [btn, btnOptions];
        }, this).compact().object().value();
    },
    events: {
        'click [data-button]': 'clickBtn'
    },
    render: function () {
        _.extend(this, {
            disabledClass: this.options.disabledClass || this.disabledClass,
            loadingClass: this.options.loadingClass || this.loadingClass,
            prependLoading: !_.isUndefined(this.options.prependLoading) ? this.options.prependLoading : this.prependLoading
        });
        this.$el.empty();
        _.each(this._buttons, function (btnOptions, btn) {
            var $btn = $("<div>").html(this.btnTpl(btnOptions)).contents();
            if (btnOptions.attributes) {
                $btn.attr(btnOptions.attributes);
            }
            $btn.find('button').attr('data-button', btn);
            this.$el.append($btn);
        }, this);
        return this;
    },
    /**
     * @protected
     * @param {$.Event} e
     */
    clickBtn: function (e) {
        var $btn = $(e.currentTarget);
        var btnOptions = this._buttons[$btn.attr('data-button')];
        var context = btnOptions.context || this.defaultContext || this;
        var prom;
        var appendLoaderFunc = this.prependLoading ? 'prepend' : 'append';
        var $loading;
        var self = this;

        // Prevent the page from refreshing (we allow propagation however)
        e.preventDefault();

        if ($btn.hasClass('disabled') || $btn.hasClass(this.disabledClass)) {
            return;
        }
        if (btnOptions.handler) {
            prom = btnOptions.handler.call(context, e);
        }
        // Test to see if the handler returns a promise (the same way jQuery does it).
        if (prom && _.isFunction(prom.promise)) {
            $loading = $('<li data-loading class="' + self.loadingClass + '"></li>').css('padding', 0);
            self.$el[appendLoaderFunc]($loading);
            self.disableButtons($btn);
        }

        $.when(prom).always(function () {
            self.removeLoadingEl();
            self.reEnableButtons($btn);
            self.trigger('buttonClick', btnOptions, _.result(prom, 'state'));
        });
    },

    removeLoadingEl: function () {
        this.$('[data-loading]').remove();
    },

    reEnableButtons: function () {
        this.$('[data-button]').removeClass('disabled ' + this.disabledClass);
    },

    /**
     * Adds the disabledClass to each of the buttons
     */
    disableButtons: function () {
        var disabledClass = this.disabledClass;
        this.$('[data-button]').each(function (i, btn) {
            var $btn = $(btn);
            if ($btn.hasClass('disabled') || $btn.hasClass(disabledClass)) {
                return;
            }
            $btn.addClass('disabled disabled-by-btnView ' + disabledClass);
        });
    }
});

module.exports = ButtonView;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(661);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'button': 'Primary__button___3Jloz',
  'small': 'Primary__small___1mUB3',
  'medium': 'Primary__medium___GQjew',
  'large': 'Primary__large___27Jt8'
};

var PrimaryButton = (0, _mergeThemeHoc2.default)(style)(_Button2.default);
PrimaryButton.displayName = 'PrimaryButton';
exports.default = PrimaryButton;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(758);

Object.defineProperty(exports, 'BarHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index).default;
  }
});

var _Primary = __webpack_require__(696);

Object.defineProperty(exports, 'PrimaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Primary).default;
  }
});

var _Secondary = __webpack_require__(845);

Object.defineProperty(exports, 'SecondaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Secondary).default;
  }
});

var _index2 = __webpack_require__(846);

Object.defineProperty(exports, 'Checkbox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index2).default;
  }
});

var _index3 = __webpack_require__(847);

Object.defineProperty(exports, 'DurationSelect', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index3).default;
  }
});

var _index4 = __webpack_require__(848);

Object.defineProperty(exports, 'ModalBackButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index4).default;
  }
});

var _index5 = __webpack_require__(849);

Object.defineProperty(exports, 'ModalBody', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index5).default;
  }
});

var _index6 = __webpack_require__(759);

Object.defineProperty(exports, 'ModalCloseButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index6).default;
  }
});

var _index7 = __webpack_require__(760);

Object.defineProperty(exports, 'ModalContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index7).default;
  }
});

var _index8 = __webpack_require__(761);

Object.defineProperty(exports, 'Select', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index8).default;
  }
});

var _index9 = __webpack_require__(850);

Object.defineProperty(exports, 'Tabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index9).default;
  }
});

var _index10 = __webpack_require__(851);

Object.defineProperty(exports, 'Well', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index10).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-account-filled'].join(' '), viewBox: '0 0 500 500' },
                React.createElement('path', { d: 'M278.088764,500 C190.723711,500 100.959616,499.78903 11.3954418,499.367089 L0,499.367089 L0.799680128,487.552743 C1.19952019,480.801688 4.9980008,421.940928 14.3942423,399.78903 C15.9936026,395.780591 26.1895242,370.886076 51.9792083,361.181435 L130.747701,327.637131 L163.934426,312.236287 C164.534186,312.025316 179.128349,305.696203 183.126749,287.341772 C183.526589,284.599156 183.326669,280.801688 182.926829,279.746835 C181.127549,276.160338 181.127549,276.160338 176.729308,270.886076 L176.529388,270.675105 C175.129948,268.987342 143.942423,229.957806 136.745302,173.628692 C136.345462,170.886076 132.546981,144.092827 136.145542,112.447257 C141.143543,67.5105485 158.336665,34.3881857 186.12555,16.6666667 C187.32507,15.8227848 213.714514,0 251.09956,0 C272.890844,0 294.082367,5.48523207 314.07437,16.0337553 C321.271491,19.4092827 381.847261,51.0548523 365.253898,175.316456 C364.854058,179.324895 358.656537,228.691983 325.669732,270.675105 C324.870052,271.518987 324.070372,272.57384 323.070772,273.839662 C321.471411,275.738397 319.272291,278.059072 318.072771,280.168776 C317.872851,281.223629 317.473011,283.966245 318.472611,287.130802 L318.672531,287.763713 L318.872451,288.607595 C319.072371,289.029536 322.271092,304.219409 341.463415,313.080169 L384.446222,333.544304 L447.820872,360.337553 C449.220312,360.970464 487.005198,376.793249 495.001999,429.324895 L495.201919,430.379747 L500,499.578059 L488.604558,499.578059 C487.604958,499.367089 407.836865,500 278.088764,500 L278.088764,500 Z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 701 */,
/* 702 */,
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"BunsenModal-style__verticallyCentered__1tEL8","horizontallyRight":"BunsenModal-style__horizontallyRight__1trnD","horizontallyCentered":"BunsenModal-style__horizontallyCentered__18I6E","verticallyHorizontallyCentered":"BunsenModal-style__verticallyHorizontallyCentered__qFuNb"};

/***/ }),
/* 704 */,
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Component = React.Component;

var Relay = __webpack_require__(18);

var _require = __webpack_require__(493),
    PreContactDealer = _require.PreContactDealer,
    Confirmation = _require.Confirmation,
    ContactDealer = _require.ContactDealer,
    ContactDealerModal = _require.ContactDealerModal,
    GuidedCopy = _require.GuidedCopy,
    LowBall = _require.LowBall,
    MakeOffer = _require.MakeOffer,
    ModalWrapper = _require.ModalWrapper;

var authConstants = __webpack_require__(263).default.constants;

var getNetworkLayer = __webpack_require__(713);
var abExperiments = __webpack_require__(497);

var _require2 = __webpack_require__(334),
    getUserId = _require2.getUserId,
    cookieJarConstants = _require2.cookieJarConstants,
    getEverLoggedIn = _require2.getEverLoggedIn;

var optimizelyVariant = 'control';
if (abExperiments.guidedContactDealer) {
    Promise.resolve(abExperiments.guidedContactDealer).then(function (res) {
        optimizelyVariant = res;
    });
}

if (abExperiments.makeOfferCheckbox) {
    Promise.resolve(abExperiments.makeOfferCheckbox).then(function (res) {
        optimizelyVariant = res;
    });
}

function getNewEnvironment() {
    var e = new Relay.Environment();
    e.injectNetworkLayer(getNetworkLayer());
    return e;
}

var ContactDealerRenderer = function (_Component) {
    _inherits(ContactDealerRenderer, _Component);

    function ContactDealerRenderer() {
        _classCallCheck(this, ContactDealerRenderer);

        return _possibleConstructorReturn(this, (ContactDealerRenderer.__proto__ || Object.getPrototypeOf(ContactDealerRenderer)).apply(this, arguments));
    }

    _createClass(ContactDealerRenderer, [{
        key: 'startAuth',
        value: function startAuth(_ref) {
            var _this2 = this;

            var callback = _ref.callback,
                options = _ref.options;
            var modalProps = this.props.modalProps;

            return modalProps.authProcess({
                email: options.emailValue,
                dealerName: options.dealerName,
                action: options.userExists ? authConstants.LOGIN : authConstants.REGISTER
            }).then(function (userJSON) {
                _this2.forceUpdate(); // set new environment user token
                callback({
                    authAction: userJSON.newUser ? authConstants.REGISTER : authConstants.LOGIN
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var modalProps = this.props.modalProps;
            var itemPk = modalProps.itemPk,
                dealerPk = modalProps.dealerPk;


            var userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);

            // used for A/B test GA tracking (MCPERSON-2909 & MCPERSON-2910)
            var userHasEverLoggedIn = !!getEverLoggedIn(document.cookie);

            var queryConfig = {
                queries: {
                    viewer: function viewer(component, params) {
                        return function (RQL_0) {
                            return {
                                children: [].concat.apply([], [{
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }, Relay.QL.__frag(RQL_0)]),
                                fieldName: 'viewer',
                                kind: 'Query',
                                metadata: {},
                                name: 'ContactDealerRenderer',
                                type: 'Viewer'
                            };
                        }(component.getFragment('viewer', params));
                    }
                },
                name: 'ContactDealerModalRoute',
                params: {
                    shouldFetchItem: !!itemPk,
                    shouldFetchImage: optimizelyVariant === 'contactDealerSidebar',
                    shouldFetchUser: !!userId,
                    shouldFetchBuyerItemConv: !!itemPk && !!userId,
                    itemId: itemPk || null,
                    sellerId: dealerPk,
                    userId: userId
                }
            };

            var forceEnvironmentUpdate = function forceEnvironmentUpdate(variablesToSet) {
                // manually set variables in the queryConfig because relay.setVariables
                // causes a re-render, and we're already forcing a re-render with forceUpdate
                queryConfig.params = Object.assign({}, queryConfig.params, variablesToSet);
                _this3.forceUpdate();
            };
            return React.createElement(Relay.Renderer, {
                Container: ContactDealerModal,
                environment: getNewEnvironment(),
                queryConfig: queryConfig,
                render: function render(_ref2) {
                    var done = _ref2.done,
                        error = _ref2.error,
                        props = _ref2.props;

                    if (error) {
                        return React.createElement(ModalWrapper, {
                            openOnRender: true,
                            isError: true
                        });
                    } else if (done && props) {
                        var contactDealerProps = Object.assign({}, modalProps, props, { forceEnvironmentUpdate: forceEnvironmentUpdate, userHasEverLoggedIn: userHasEverLoggedIn, optimizelyVariant: optimizelyVariant });
                        return React.createElement(
                            ContactDealerModal,
                            contactDealerProps,
                            React.createElement(GuidedCopy, null),
                            React.createElement(ContactDealer, null),
                            React.createElement(Confirmation, null),
                            React.createElement(MakeOffer, { isContactDealer: true }),
                            React.createElement(LowBall, null),
                            React.createElement(PreContactDealer, null)
                        );
                    } else {
                        return React.createElement(ModalWrapper, {
                            openOnRender: true,
                            isLoading: true
                        });
                    }
                }
            });
        }
    }]);

    return ContactDealerRenderer;
}(Component);

ContactDealerRenderer.propTypes = {
    queryProps: PropTypes.object,
    modalProps: PropTypes.object
};

module.exports = ContactDealerRenderer;

/***/ }),
/* 706 */,
/* 707 */,
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackFolderClick = trackFolderClick;
exports.trackItemRemoved = trackItemRemoved;
exports.trackItemAdded = trackItemAdded;
exports.trackFolderCreated = trackFolderCreated;

var _dibsTracking = __webpack_require__(27);

var _pageTypeHelper = __webpack_require__(522);

var _pageTypes = __webpack_require__(383);

function getLabel() {
    if ((0, _pageTypeHelper.isPageType)(_pageTypes.PAGE_TYPE.PDP)) {
        return 'pdp';
    } else if ((0, _pageTypeHelper.isPageType)(_pageTypes.BROWSE_TYPES)) {
        return 'search/browse';
    } else if ((0, _pageTypeHelper.isPageType)(_pageTypes.PAGE_TYPE.FAVORITES)) {
        return 'my favorites';
    }
    return void 0;
}

function trackFolderEvent(action) {
    var noteIncluded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var label = getLabel();

    if (label) {
        (0, _dibsTracking.trackEvent)({
            label: label,
            action: action,
            category: "item favoriting",
            value: noteIncluded ? 1 : 0
        });
    }
}

function trackFolderClick() {
    trackFolderEvent("item favoriting folder clicked");
}

function trackItemRemoved() {
    trackFolderEvent("item removed from folder");
}

function trackItemAdded() {
    var noteIncluded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    trackFolderEvent("item added into folder", noteIncluded);
}

function trackFolderCreated() {
    var noteIncluded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    trackFolderEvent("item favoriting folder created", noteIncluded);
}

exports.default = {
    trackFolderClick: trackFolderClick,
    trackItemRemoved: trackItemRemoved,
    trackItemAdded: trackItemAdded,
    trackFolderCreated: trackFolderCreated
};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GalleryStore = __webpack_require__(357);
var GalleryModalStore = __webpack_require__(548);

function connectGalleryStoreToView(ConnectedBaseView) {
    var stores = ConnectedBaseView.prototype.stores || [];
    return ConnectedBaseView.extend({
        stores: stores.concat(GalleryStore)
    });
}

function connectGalleryModalStoreToView(ConnectedBaseView) {
    var stores = ConnectedBaseView.prototype.stores || [];
    return ConnectedBaseView.extend({
        stores: stores.concat(GalleryModalStore)
    });
}

module.exports = {
    connectGalleryStoreToView: connectGalleryStoreToView,
    connectGalleryModalStoreToView: connectGalleryModalStoreToView
};

/***/ }),
/* 710 */,
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseModel = __webpack_require__(335);

var _require = __webpack_require__(341),
    getScrollableItemWidth = _require.getScrollableItemWidth,
    setWidthStyle = _require.setWidthStyle;

/**
 * View-model for carousels that are scrolled through horizontally.
 * @class
 */


var ScrollModel = function (_BaseModel) {
    _inherits(ScrollModel, _BaseModel);

    function ScrollModel() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            itemsPerPage = _ref.itemsPerPage;

        _classCallCheck(this, ScrollModel);

        var _this = _possibleConstructorReturn(this, (ScrollModel.__proto__ || Object.getPrototypeOf(ScrollModel)).call(this));
        // There's no state to update so no need to pass the `onStateChange` callback.


        Object.assign(_this, {
            // The width of each item.
            _width: getScrollableItemWidth(itemsPerPage, 1, 3)
        });
        return _this;
    }

    /**
     * Implement the `transformItemStyle` method from the `BaseModel`.
     * @param  {Object} style
     */


    _createClass(ScrollModel, [{
        key: 'transformItemStyle',
        value: function transformItemStyle(style) {
            setWidthStyle(style, this._width);
        }
    }]);

    return ScrollModel;
}(BaseModel);

module.exports = ScrollModel;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ScrollModel = __webpack_require__(711);
var BaseCarousel = __webpack_require__(364);
var classnames = __webpack_require__(16);

/**
 * Represents a carousel with that a user scrolls through horizontally.
 * @class
 */

var ScrollCarousel = function (_React$Component) {
    _inherits(ScrollCarousel, _React$Component);

    function ScrollCarousel() {
        _classCallCheck(this, ScrollCarousel);

        return _possibleConstructorReturn(this, (ScrollCarousel.__proto__ || Object.getPrototypeOf(ScrollCarousel)).apply(this, arguments));
    }

    _createClass(ScrollCarousel, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this._model = new ScrollModel({
                itemsPerPage: this.props.itemsPerPage
            });

            // Dummy state. State is held in the `_model` but this is necessary to force a re-render when the model
            // updates.
            this.state = {
                modelState: this._model.getState()
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props$classNames = this.props.classNames,
                list = _props$classNames.list,
                item = _props$classNames.item;


            var listClass = classnames((_classnames = {}, _defineProperty(_classnames, 'scroll-carousel-list', true), _defineProperty(_classnames, list, list), _classnames));
            var itemClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, 'scroll-carousel-item', true), _defineProperty(_classnames2, item, item), _classnames2));

            return React.createElement(
                'div',
                { className: 'scroll-carousel-wrapper' },
                React.createElement(
                    BaseCarousel,
                    { model: this._model, classNames: { list: listClass, item: itemClass } },
                    this.props.children
                )
            );
        }
    }]);

    return ScrollCarousel;
}(React.Component);

ScrollCarousel.propTypes = {
    // Items to display per "page". This indicates the number of items that should be visible at once. One of the
    // items will be pushed partially off-page to indicate to the user that the list is scrollable.
    itemsPerPage: PropTypes.number,
    classNames: PropTypes.object,
    children: PropTypes.node
};

ScrollCarousel.defaultProps = {
    itemsPerPage: 2,
    classNames: {}
};

module.exports = ScrollCarousel;

/***/ }),
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

_ = __webpack_require__(0);
module.exports = {
    "template": function(obj) {
var __t, __p = '';
__p += '\n    <div class=\'bunsen-modal ' +
((__t = ( obj.classNames.modal )) == null ? '' : __t) +
' pre-animation\'>\n        <div class=\'bunsen-modal-scrim ' +
((__t = ( obj.classNames.scrim )) == null ? '' : __t) +
'\'></div>\n        <div class=\'bunsen-modal-body ' +
((__t = ( obj.classNames.body )) == null ? '' : __t) +
'\'>\n            <div class=\'bunsen-modal-header ' +
((__t = ( obj.classNames.header )) == null ? '' : __t) +
'\'>\n                <span data-model-bind=\'visible: model.title, text: model.title\'></span>\n                <span data-model-bind=\'visible: model.titleHTML, html: model.titleHTML\'></span>\n                <i data-model-bind=\'visible: model.showClose\' class="bunsen-modal-close ' +
((__t = ( obj.classNames.close )) == null ? '' : __t) +
' bunsen-icon bunsen-icon-close" aria-label="Close"></i>\n            </div>\n            <div class=\'bunsen-modal-content ' +
((__t = ( obj.classNames.content )) == null ? '' : __t) +
'\'></div>\n            <div class=\'bunsen-modal-buttons ' +
((__t = ( obj.classNames.buttons )) == null ? '' : __t) +
' text-' +
((__t = ( obj.buttonsAlignment )) == null ? '' : __t) +
'\' data-append=\'buttons\'></div>\n        </div>\n    </div>\n';
return __p
}
};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

_ = __webpack_require__(535);
module.exports = {
    "button-view-template": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <li class="top-align' +
((__t = ( obj.btnWrapperClass ? ' ' + obj.btnWrapperClass : '' )) == null ? '' : __t) +
'">\n        <button class="btn ' +
((__t = ( obj.className ? obj.className : 'btn-default' )) == null ? '' : __t) +
'' +
((__t = ( obj.type ? ' ' + obj.type : '' )) == null ? '' : __t) +
'' +
((__t = ( obj.primary ? ' button-primary' : '' )) == null ? '' : __t) +
'" ' +
((__t = ( obj.dataTn ? 'data-tn="' + obj.dataTn + '"' : '' )) == null ? '' : __t) +
'>' +
((__t = ( obj.text )) == null ? '' : __t) +
'</button>\n        ';
 if (obj.help) { ;
__p += '\n        <div class="help text-muted small-line-height' +
((__t = ( (obj.helpClass) ? ' ' + obj.helpClass : '')) == null ? '' : __t) +
'"><small>' +
((__t = ( obj.help )) == null ? '' : __t) +
'</small></div>\n        ';
 } ;
__p += '\n    </li>\n';
return __p
}
};

/***/ }),
/* 718 */,
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var proto = Element.prototype;
var vendor = proto.matches
  || proto.matchesSelector
  || proto.webkitMatchesSelector
  || proto.mozMatchesSelector
  || proto.msMatchesSelector
  || proto.oMatchesSelector;

module.exports = match;

/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function match(el, selector) {
  if (vendor) return vendor.call(el, selector);
  var nodes = el.parentNode.querySelectorAll(selector);
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i] == el) return true;
  }
  return false;
}

/***/ }),
/* 720 */,
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(550),
    PHOTO_UI_UPDATE_DIMENSIONS = _require.PHOTO_UI_UPDATE_DIMENSIONS,
    PHOTO_UI_SHOW_ITEM_TAGS = _require.PHOTO_UI_SHOW_ITEM_TAGS,
    PHOTO_UI_HIDE_ITEM_TAGS = _require.PHOTO_UI_HIDE_ITEM_TAGS,
    PHOTO_UI_SET_ITEM_TAG = _require.PHOTO_UI_SET_ITEM_TAG,
    PHOTO_UI_UNSET_ITEM_TAG = _require.PHOTO_UI_UNSET_ITEM_TAG;

var _require2 = __webpack_require__(453),
    trackTooltipDisplayed = _require2.trackTooltipDisplayed;

function updateImageDimensions(ac, payload, done) {
    ac.dispatch(PHOTO_UI_UPDATE_DIMENSIONS, payload);
    done();
}

function showItemTagIndicators(ac, payload, done) {
    ac.dispatch(PHOTO_UI_SHOW_ITEM_TAGS, payload);
    done();
}

function hideItemTagIndicators(ac, payload, done) {
    ac.dispatch(PHOTO_UI_HIDE_ITEM_TAGS, payload);
    done();
}

function flashItemTagIndicators(ac, payload, done) {
    ac.executeAction(showItemTagIndicators);
    setTimeout(function () {
        ac.executeAction(hideItemTagIndicators);
        done();
    }, 5000);
}

function showItemTagTooltip(ac, payload, done) {
    ac.dispatch(PHOTO_UI_SET_ITEM_TAG, payload);
    ac.executeAction(trackTooltipDisplayed, done);
}

function hideItemTagTooltip(ac, payload, done) {
    ac.dispatch(PHOTO_UI_UNSET_ITEM_TAG, payload);
    done();
}

module.exports = {
    updateImageDimensions: updateImageDimensions,
    showItemTagIndicators: showItemTagIndicators,
    hideItemTagIndicators: hideItemTagIndicators,
    flashItemTagIndicators: flashItemTagIndicators,
    showItemTagTooltip: showItemTagTooltip,
    hideItemTagTooltip: hideItemTagTooltip
};

/***/ }),
/* 722 */,
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPriceAmountByCurrency = exports.isPriceHidden = exports.isNegotiable = exports.getAmount = exports.getNegotiable = exports.getHidePrice = undefined;

var _createSelector = __webpack_require__(490);

var _createSelector2 = _interopRequireDefault(_createSelector);

var _makeSelectorHelpers = __webpack_require__(651);

var _amount = __webpack_require__(748);

var _lodash = __webpack_require__(652);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getHidePrice = exports.getHidePrice = function getHidePrice(price) {
  return (0, _lodash2.default)(price, 'hidePrice');
};
var getNegotiable = exports.getNegotiable = function getNegotiable(price) {
  return (0, _lodash2.default)(price, 'negotiable');
};
var getAmount = exports.getAmount = function getAmount(price) {
  return (0, _lodash2.default)(price, 'amount', {});
};

// Selectors
// ------------------------------------------

var isNegotiable = exports.isNegotiable = (0, _makeSelectorHelpers.makeYesCheckSelector)(getNegotiable);
var isPriceHidden = exports.isPriceHidden = (0, _makeSelectorHelpers.makeYesCheckSelector)(getHidePrice);
var getPriceAmountByCurrency = exports.getPriceAmountByCurrency = (0, _createSelector2.default)(getAmount, _amount.getAmountByCurrency);

/***/ }),
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */
/***/ (function(module, exports) {

module.exports = {
	"purchase": "Purchase",
	"makeOffer": "Make An Offer",
	"acceptOffer": "Accept Offer",
	"requestNetPrice": "Request Net Price",
	"purchaseNow": "Purchase Now"
};

/***/ }),
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(97);
var tracking = __webpack_require__(27);
var mapValues = __webpack_require__(107);
var querystring = __webpack_require__(679);
var tokenReplace = __webpack_require__(75);

var pinterest = __webpack_require__(714);
var twitter = __webpack_require__(784);

var FACEBOOK = 'facebook';
var PINTEREST = 'pinterest';
var TWITTER = 'twitter';
var ENVELOPE = 'envelope';
var EMAIL = 'email';

var types = [FACEBOOK, PINTEREST, TWITTER, ENVELOPE, EMAIL];

/**
 * Fills in an object of tokenStrings
 *
 * @param {object} copy   - copy for options
 * @param {object} tokens - tokens to fill in the copy
 * @returns {object}
 * @private
 */
function _getOptions(copy, tokens) {
    if (!copy) {
        return {};
    }

    tokens = tokens || {};
    return mapValues(copy, function (tokenString) {
        return tokenReplace(tokenString, tokens);
    });
}

/**
 * Fires tracking
 */
function fireTracking(type, url, options) {
    if (type === EMAIL || type === ENVELOPE) {
        tracking.trackEvent({
            label: 'share ' + options.shared,
            category: 'email a friend',
            action: 'email a friend initiated'
        });
    } else {
        tracking.trackEvent({
            label: url,
            category: 'share',
            action: options.page
        });
        tracking.trackSocial({
            name: type,
            event: 'share' + (type === FACEBOOK ? ' intent' : ''),
            'opt_target': url
        });
    }
}

/**
 * Shares on facebook
 *  (Note: setup root.FB.ui by requiring /social/facebook.js in the entry file)
 *
 * @param {FluxContext} ac
 * @param {string} image    - the image to share
 * @param {function} done   - called after window is closed
 *
 * @param {string} [url]    - the url to share
 * @param {object} [copy]
 * @param {string} [copy.title]
 * @param {string} [copy.caption]
 * @param {string} [copy.description]
 * @param {object} [tokens] - tokens to fill in the copy
 */
function shareViaFacebook(ac, _ref, done) {
    var image = _ref.image,
        url = _ref.url,
        copy = _ref.copy,
        tokens = _ref.tokens;

    if (root.FB && root.FB.ui && image) {
        // set base options
        var options = Object.assign({
            method: 'stream.share',
            href: url || root.location.href,
            image: image

            // check copy for title, caption and description for post
        }, _getOptions(copy, tokens));

        // Opens facebook in new window
        root.FB.ui(options, done);
        return;
    }

    done();
}

/**
 * Shares on pinterest
 *
 * @param {FluxContext} ac
 * @param {string} image    - the image to share
 * @param {function} done   - called after window is closed
 * @param {string} [url]    - the url to share
 * @param {object} [copy]
 * @param {string} [copy.description]
 * @param {object} [tokens] - tokens to fill in the copy
 */
function shareViaPinterest(ac, _ref2, done) {
    var image = _ref2.image,
        url = _ref2.url,
        copy = _ref2.copy,
        tokens = _ref2.tokens;

    if (image) {
        // set base options
        var options = Object.assign({
            pinterestWindow: pinterest.openWindow(),
            url: url || root.location.href,
            media: image

            // check copy for description for post
        }, _getOptions(copy, tokens));

        // Opens pinterest in new window
        pinterest.pin(options).then(done);
        return;
    }

    done();
}

/**
 * Shares on twitter
 *
 * @param {FluxContext} ac
 * @param {function} done   - called after window is closed
 * @param {string} [url]
 * @param {object} [copy]
 * @param {string} [copy.text]
 * @param {object} [tokens] - tokens to fill in the copy
 */
function shareViaTwitter(ac, _ref3, done) {
    var url = _ref3.url,
        copy = _ref3.copy,
        tokens = _ref3.tokens;

    var options = Object.assign({
        url: url
        // check copy for text for tweet
    }, _getOptions(copy, tokens));

    // Opens twitter in new window
    twitter.openWindow(options).then(done);
}

/**
 * Opens mail for sharing via email
 * @param {FluxContext} ac
 * @param {function} done       - called after window is opened
 * @param {object} [copy]
 * @param {string} [copy.subject]
 * @param {string} [copy.body]
 * @param {object} [tokens]
 */
function shareViaEmail(ac, _ref4, done) {
    var copy = _ref4.copy,
        tokens = _ref4.tokens;

    // check copy for subject and body of email
    root.location.href = 'mailto:?' + querystring.stringify(_getOptions(copy, tokens));
    done();
}

/**
 * Given a type, calls the appropriate share action
 *
 * @param {FluxContext} ac
 * @param {function} done
 * @param {object} payload
 * @param {string} payload.type
 * @param {object} payload.copy
 * @param {string} payload.image
 * @param {object} payload.tokens
 */
function shareContent(ac, payload, done) {
    payload = payload || {};
    var _payload = payload,
        type = _payload.type,
        tokens = _payload.tokens,
        image = _payload.image,
        url = _payload.url;

    var copy = payload.copy || {};

    if (payload.tracking && payload.tracking.page && payload.tracking.shared) {
        fireTracking(type, url, payload.tracking);
    }

    switch (type) {
        case FACEBOOK:
            ac.executeAction(shareViaFacebook, { copy: copy.facebook, tokens: tokens, image: image, url: url }, done);
            break;

        case PINTEREST:
            ac.executeAction(shareViaPinterest, { copy: copy.pinterest, tokens: tokens, image: image, url: url }, done);
            break;

        case TWITTER:
            ac.executeAction(shareViaTwitter, { copy: copy.twitter, tokens: tokens, image: image, url: url }, done);
            break;

        case ENVELOPE:
        case EMAIL:
            ac.executeAction(shareViaEmail, { copy: copy.email, tokens: tokens }, done);
            break;

        default:
            done();
    }
}

module.exports = {
    shareViaFacebook: shareViaFacebook,
    shareViaPinterest: shareViaPinterest,
    shareViaTwitter: shareViaTwitter,
    shareViaEmail: shareViaEmail,
    shareContent: shareContent,
    types: types
};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Component = React.Component;

var ZoomPanModel = __webpack_require__(892);

var _require = __webpack_require__(67),
    noop = _require.noop;

var classnames = __webpack_require__(16);

/**
 * Handle both pinching and zooming on the passed in children.
 */

var PinchZoomComponent = function (_Component) {
    _inherits(PinchZoomComponent, _Component);

    function PinchZoomComponent(props) {
        _classCallCheck(this, PinchZoomComponent);

        // Wire up touch detection.
        var _this = _possibleConstructorReturn(this, (PinchZoomComponent.__proto__ || Object.getPrototypeOf(PinchZoomComponent)).call(this, props));

        _this._model = new ZoomPanModel({
            onZoomIn: _this._onZoomIn.bind(_this),
            onZoomOut: _this._onZoomOut.bind(_this),
            onPan: _this._onPan.bind(_this)
        });

        if (!props.enabled) {
            _this._model.disable();
        }

        _this.state = {
            transition: false
        };
        return _this;
    }

    _createClass(PinchZoomComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._model.setEl(this.refs.wrapper);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Allow this component to be enabled/disabled via props.
            if (nextProps.enabled && !this.props.enabled) {
                this._model.enable();
                return;
            }

            if (!nextProps.enabled && this.props.enabled) {
                this._model.disable();
                return;
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._model.destroy();
        }
    }, {
        key: 'reset',
        value: function reset() {
            this._model.reset();
            this.forceUpdate();
        }

        /**
         * Set whether to use CSS transitions. Transition is meant to be set during zoom but not during pan.
         */

    }, {
        key: '_transition',
        value: function _transition() {
            var _this2 = this;

            var el = this.refs.wrapper;
            var timer = void 0;
            var handler = void 0;
            var innerHandler = function innerHandler() {
                _this2.setState({ transition: false });
                el.removeEventListener('transitionend', handler);
            };
            // Set a timeout in case the transitionend event fails for some reason. The timeout should be the same as the
            // CSS transition duration.
            timer = setTimeout(innerHandler, 300);
            handler = function handler() {
                innerHandler();
                clearTimeout(timer);
            };
            el.addEventListener('transitionend', handler);

            this.setState({ transition: true });
        }
    }, {
        key: '_onPan',
        value: function _onPan() {
            this.props.onPan();
            this.forceUpdate();
        }
    }, {
        key: '_onZoomIn',
        value: function _onZoomIn() {
            this.props.onZoomIn();
            this._transition();
        }
    }, {
        key: '_onZoomOut',
        value: function _onZoomOut() {
            this.props.onZoomOut();
            this._transition();
        }
    }, {
        key: 'render',
        value: function render() {
            var style = {};
            // Grab the styles from the model.
            this._model.getStyle(style);

            var className = classnames(_defineProperty({
                transition: this.state.transition
            }, this.props.className, this.props.className));

            return React.createElement(
                'div',
                { ref: 'wrapper', style: style, className: className },
                this.props.children
            );
        }
    }]);

    return PinchZoomComponent;
}(Component);

PinchZoomComponent.propTypes = {
    onZoomIn: PropTypes.func,
    onZoomOut: PropTypes.func,
    onPan: PropTypes.func,
    className: PropTypes.string,
    enabled: PropTypes.bool,
    children: PropTypes.node
};

PinchZoomComponent.defaultProps = {
    onZoomIn: noop,
    onZoomOut: noop,
    onPan: noop,
    enabled: true
};

module.exports = PinchZoomComponent;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(40);

var _eventlistener = __webpack_require__(765);

var _lodash = __webpack_require__(792);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(793);

var _lodash4 = _interopRequireDefault(_lodash3);

var _parentScroll = __webpack_require__(791);

var _parentScroll2 = _interopRequireDefault(_parentScroll);

var _inViewport = __webpack_require__(790);

var _inViewport2 = _interopRequireDefault(_inViewport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.lazyLoadHandler = _this.lazyLoadHandler.bind(_this);

    if (props.throttle > 0) {
      if (props.debounce) {
        _this.lazyLoadHandler = (0, _lodash2.default)(_this.lazyLoadHandler, props.throttle);
      } else {
        _this.lazyLoadHandler = (0, _lodash4.default)(_this.lazyLoadHandler, props.throttle);
      }
    }

    _this.state = { visible: false };
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._mounted = true;
      var eventNode = this.getEventNode();

      this.lazyLoadHandler();

      if (this.lazyLoadHandler.flush) {
        this.lazyLoadHandler.flush();
      }

      (0, _eventlistener.add)(window, 'resize', this.lazyLoadHandler);
      (0, _eventlistener.add)(eventNode, 'scroll', this.lazyLoadHandler);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (!this.state.visible) {
        this.lazyLoadHandler();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(_nextProps, nextState) {
      return nextState.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._mounted = false;
      if (this.lazyLoadHandler.cancel) {
        this.lazyLoadHandler.cancel();
      }

      this.detachListeners();
    }
  }, {
    key: 'getEventNode',
    value: function getEventNode() {
      return (0, _parentScroll2.default)((0, _reactDom.findDOMNode)(this));
    }
  }, {
    key: 'getOffset',
    value: function getOffset() {
      var _props = this.props,
          offset = _props.offset,
          offsetVertical = _props.offsetVertical,
          offsetHorizontal = _props.offsetHorizontal,
          offsetTop = _props.offsetTop,
          offsetBottom = _props.offsetBottom,
          offsetLeft = _props.offsetLeft,
          offsetRight = _props.offsetRight,
          threshold = _props.threshold;


      var _offsetAll = threshold || offset;
      var _offsetVertical = offsetVertical || _offsetAll;
      var _offsetHorizontal = offsetHorizontal || _offsetAll;

      return {
        top: offsetTop || _offsetVertical,
        bottom: offsetBottom || _offsetVertical,
        left: offsetLeft || _offsetHorizontal,
        right: offsetRight || _offsetHorizontal
      };
    }
  }, {
    key: 'lazyLoadHandler',
    value: function lazyLoadHandler() {
      if (!this._mounted) {
        return;
      }
      var offset = this.getOffset();
      var node = (0, _reactDom.findDOMNode)(this);
      var eventNode = this.getEventNode();

      if ((0, _inViewport2.default)(node, eventNode, offset)) {
        var onContentVisible = this.props.onContentVisible;


        this.setState({ visible: true }, function () {
          if (onContentVisible) {
            onContentVisible();
          }
        });
        this.detachListeners();
      }
    }
  }, {
    key: 'detachListeners',
    value: function detachListeners() {
      var eventNode = this.getEventNode();

      (0, _eventlistener.remove)(window, 'resize', this.lazyLoadHandler);
      (0, _eventlistener.remove)(eventNode, 'scroll', this.lazyLoadHandler);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          height = _props2.height,
          width = _props2.width;
      var visible = this.state.visible;


      var elStyles = { height: height, width: width };
      var elClasses = 'LazyLoad' + (visible ? ' is-visible' : '') + (className ? ' ' + className : '');

      return _react2.default.createElement(this.props.elementType, {
        className: elClasses,
        style: elStyles
      }, visible && _react.Children.only(children));
    }
  }]);

  return LazyLoad;
}(_react.Component);

exports.default = LazyLoad;


LazyLoad.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  debounce: _propTypes2.default.bool,
  elementType: _propTypes2.default.string,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  offset: _propTypes2.default.number,
  offsetBottom: _propTypes2.default.number,
  offsetHorizontal: _propTypes2.default.number,
  offsetLeft: _propTypes2.default.number,
  offsetRight: _propTypes2.default.number,
  offsetTop: _propTypes2.default.number,
  offsetVertical: _propTypes2.default.number,
  threshold: _propTypes2.default.number,
  throttle: _propTypes2.default.number,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onContentVisible: _propTypes2.default.func
};

LazyLoad.defaultProps = {
  elementType: 'div',
  debounce: true,
  offset: 0,
  offsetBottom: 0,
  offsetHorizontal: 0,
  offsetLeft: 0,
  offsetRight: 0,
  offsetTop: 0,
  offsetVertical: 0,
  throttle: 250
};

/***/ }),
/* 739 */,
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tokenReplace = __webpack_require__(75);
var tracking = __webpack_require__(27);

var breadcrumbLabelMap = {
    designers: 'interiors-main',

    profile: 'trade firm-profile',
    favorites: 'trade firm-favorites',
    projects: 'trade firm-projects',
    project: 'trade firm-project'
};

var vpvMap = {
    base: '/vpv/designers/{firm}/',
    profile: 'profile/',
    favorites: 'collections/',
    projects: 'projects/',
    project: 'projects/{project}/',
    gallery: 'projects/{project}/photos/'
};

function getTradeProfilesVpv(page, _ref) {
    var firm = _ref.firm,
        project = _ref.project;

    var vpv = vpvMap.base + vpvMap[page];
    return tokenReplace(vpv, { firm: firm, project: project });
}

function trackTradeProfilesVpv(_ref2) {
    var page = _ref2.page,
        firm = _ref2.firm,
        project = _ref2.project,
        customDimensions = _ref2.customDimensions;

    tracking.trackPageview({
        url: getTradeProfilesVpv(page, { firm: firm, project: project }),
        additional: customDimensions
    });
}

function trackTradeProfilesBreadcrumbClick(currPage, nextPage) {
    tracking.trackEvent({
        label: breadcrumbLabelMap[currPage] + '|' + breadcrumbLabelMap[nextPage],
        category: 'navigation',
        action: 'breadcrumb click'
    });
}

module.exports = {
    getTradeProfilesVpv: getTradeProfilesVpv,
    trackTradeProfilesVpv: trackTradeProfilesVpv,
    trackTradeProfilesBreadcrumbClick: trackTradeProfilesBreadcrumbClick
};

/***/ }),
/* 741 */,
/* 742 */,
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Object.freeze({
    ACTION_RECEIVE_PAGE: 'RECEIVE_PAGE',
    ACTION_CAROUSEL_INDEX: 'SET_HERO_CAROUSEL_INDEX',
    ACTION_HERO_EXPANDED: 'SET_HERO_EXPANDED',
    ACTION_HERO_CHANGING_SIZE: 'SET_HERO_CHANGING_SIZE',
    ACTION_TOGGLE_BUYER_ASSURANCE_SHOW_INFO: 'TOGGLE_BUYER_ASSURANCE_SHOW_INFO',
    ACTION_DELETE_BUYER_ASSURANCE_COOKIE: 'DELETE_BUYER_ASSURANCE_COOKIE',
    ACTION_PRINT_PAGE: 'SET_PRINT_PAGE'
});

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _PdpUiStore$handlers;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var $ = __webpack_require__(5);
var BaseStore = __webpack_require__(13);
var ItemStore = __webpack_require__(336);
var buyerAssurance = __webpack_require__(1012);
var loginActions = __webpack_require__(603);
var verticalHelpers = __webpack_require__(373);
var pdpActionsConstants = __webpack_require__(743);

__webpack_require__(625);

var PdpUiStore = function (_BaseStore) {
    _inherits(PdpUiStore, _BaseStore);

    function PdpUiStore(dispatcher) {
        _classCallCheck(this, PdpUiStore);

        var _this = _possibleConstructorReturn(this, (PdpUiStore.__proto__ || Object.getPrototypeOf(PdpUiStore)).call(this, dispatcher));

        _this.itemStore = dispatcher.getStore(ItemStore);
        _this.heroCarouselIndex = 0;
        _this.heroExpanded = false;

        _this.buyerAssuranceProps = {
            copy: buyerAssurance || {},
            state: {
                showInfo: false
            }
        };

        var vertical = _this.itemStore.getFromItemModel('vertical');
        _this.isNetPriceVertical = vertical === verticalHelpers.VERTICAL_FURNITURE;
        _this.enableRequestNetPrice = false;
        return _this;
    }

    _createClass(PdpUiStore, [{
        key: 'getHeroCarouselIndex',
        value: function getHeroCarouselIndex() {
            return this.heroCarouselIndex;
        }
    }, {
        key: 'onChangeIndex',
        value: function onChangeIndex(_ref) {
            var index = _ref.index;

            this.heroCarouselIndex = index;
            this.emitChange();
        }
    }, {
        key: 'getHeroExpanded',
        value: function getHeroExpanded() {
            return this.heroExpanded;
        }
    }, {
        key: 'onHeroExpanded',
        value: function onHeroExpanded(_ref2) {
            var heroExpanded = _ref2.heroExpanded;

            this.heroChangingSize = true;
            this.heroExpanded = heroExpanded;
            this.emitChange();
        }
    }, {
        key: 'setPrintPage',
        value: function setPrintPage(_ref3) {
            var isPrintPage = _ref3.isPrintPage,
                isPrintNP = _ref3.isPrintNP;

            this.isPrintPage = isPrintPage;
            this.isPrintNP = isPrintNP;
        }

        // Track whether or not the hero is currently changing size in a transition. This is useful for adjusting the size
        // of other components on the page in response to this.

    }, {
        key: 'onHeroChangingSize',
        value: function onHeroChangingSize(_ref4) {
            var heroChangingSize = _ref4.heroChangingSize;

            this.heroChangingSize = heroChangingSize;
            this.emitChange();
        }
    }, {
        key: 'getHeroChangingSize',
        value: function getHeroChangingSize() {
            return this.heroChangingSize;
        }

        /**
         * sets buyerAssurance state.showInfo which controls the hide/showing of the tooltip
         * @param {object}  payload
         * @param {boolean} payload.showInfo - show/hide buyer assurance tooltip/modal on pdp
         */

    }, {
        key: 'onToggleBuyerAssuranceShowInfo',
        value: function onToggleBuyerAssuranceShowInfo(payload) {
            var showInfo = payload.showInfo;


            if (showInfo === undefined) {
                showInfo = !this.buyerAssuranceProps.state.showInfo;
            }

            this.buyerAssuranceProps.state.showInfo = showInfo;
            this.emitChange();
        }
    }, {
        key: 'deleteBuyerAssuranceCookie',
        value: function deleteBuyerAssuranceCookie() {
            $.removeCookie('__buyerAssurance');
        }
    }, {
        key: 'getBuyerAssuranceProps',
        value: function getBuyerAssuranceProps() {
            if (this.itemStore.isTradeReturnAvailable()) {
                this.buyerAssuranceProps.copy.tooltip = this.buyerAssuranceProps.copy.tradeTooltip;
            }

            return this.buyerAssuranceProps;
        }
    }, {
        key: 'getEnableNetPrice',
        value: function getEnableNetPrice() {
            return this.enableRequestNetPrice;
        }
    }, {
        key: '_updateEnableNetPrice',
        value: function _updateEnableNetPrice(_ref5) {
            var userCanRequestNetPrice = _ref5.userCanRequestNetPrice;

            this.enableRequestNetPrice = !!(this.isNetPriceVertical && userCanRequestNetPrice);
        }
    }, {
        key: 'getIsPrintNP',
        value: function getIsPrintNP() {
            return this.isPrintNP;
        }
    }, {
        key: 'getIsPrintPage',
        value: function getIsPrintPage() {
            return this.isPrintPage;
        }
    }, {
        key: 'getSelectedImage',
        value: function getSelectedImage() {
            return Number(this.selectedImage) || 0;
        }
    }]);

    return PdpUiStore;
}(BaseStore);

PdpUiStore.storeName = 'PdpUiStore';
PdpUiStore.handlers = (_PdpUiStore$handlers = {}, _defineProperty(_PdpUiStore$handlers, pdpActionsConstants.ACTION_CAROUSEL_INDEX, 'onChangeIndex'), _defineProperty(_PdpUiStore$handlers, pdpActionsConstants.ACTION_HERO_EXPANDED, 'onHeroExpanded'), _defineProperty(_PdpUiStore$handlers, pdpActionsConstants.ACTION_HERO_CHANGING_SIZE, 'onHeroChangingSize'), _defineProperty(_PdpUiStore$handlers, pdpActionsConstants.ACTION_TOGGLE_BUYER_ASSURANCE_SHOW_INFO, 'onToggleBuyerAssuranceShowInfo'), _defineProperty(_PdpUiStore$handlers, pdpActionsConstants.ACTION_DELETE_BUYER_ASSURANCE_COOKIE, 'deleteBuyerAssuranceCookie'), _defineProperty(_PdpUiStore$handlers, loginActions.ACTION_NET_PRICE, '_updateEnableNetPrice'), _defineProperty(_PdpUiStore$handlers, pdpActionsConstants.ACTION_PRINT_PAGE, 'setPrintPage'), _PdpUiStore$handlers);

module.exports = PdpUiStore;

/***/ }),
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAmountByCurrency = exports.getConvertedAmountList = exports.getConvertedAmounts = exports.getBaseAmount = undefined;

var _createSelector = __webpack_require__(490);

var _createSelector2 = _interopRequireDefault(_createSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getBaseAmount = exports.getBaseAmount = function getBaseAmount(amount) {
    return amount ? amount.amount : undefined;
};
var getConvertedAmounts = exports.getConvertedAmounts = function getConvertedAmounts(amount) {
    return amount ? amount.convertedAmounts : undefined;
};
var getConvertedAmountList = exports.getConvertedAmountList = function getConvertedAmountList(amount) {
    return amount ? amount.convertedAmountList : undefined;
};

// Selectors
// ------------------------------------------

/**
 * @param {object} Item
 * @returns {function} A function that can take a currency and return the value amount as long as
 *                      amount is inflated (so amount and convertedAmounts are present)
 */
var getAmountByCurrency = exports.getAmountByCurrency = (0, _createSelector2.default)(getBaseAmount, getConvertedAmounts, getConvertedAmountList, function (baseAmount, convertedAmounts, convertedAmountList) {
    return function (currency) {
        if (baseAmount === 0) {
            return 0;
        } else if (convertedAmounts) {
            return convertedAmounts[currency];
        } else if (convertedAmountList) {
            return getBaseAmount(convertedAmountList.find(function (amount) {
                return amount.currency === currency;
            }));
        } else {
            return undefined;
        }
    };
});

/***/ }),
/* 749 */,
/* 750 */,
/* 751 */
/***/ (function(module, exports) {

module.exports = {
	"collapsed": "See a message from <span class=\"{repClass}\">{repFirstName}</span>, your trade specialist.",
	"expanded": [
		"Hi, this is {repFirstName}, your trade specialist. Please do not hesitate to reach out if I can be of assistance with anything from sourcing to pricing to shipping. I am available Monday through Friday from 9 am to 5 pm ET.",
		"Enjoy shopping!",
		"Sincerely,"
	]
};

/***/ }),
/* 752 */,
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * User: hella
 * Date: 6/22/14
 * Time: 3:11 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

var dibsConstants = __webpack_require__(455);

module.exports = {

    EMAIL: {
        //http://www.w3.org/TR/html5/forms.html#valid-e-mail-address
        FORMAT: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
        MAX_LENGTH: /^.{0,100}$/,
        FROM_NAME: /^.{0,50}$/
    },

    CURRENCY_REGEX_DEFAULT : {
        numFormat: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*?$/,
        zeroInput: /^0*(,[0-9]*?)*?(\.[0-9]*)?$/
    },
    CURRENCY_REGEX_EU: {
        numFormat: /^[+-]?[0-9]{1,3}(?:\.?[0-9]{3})*?$/,
        zeroInput: /^0*(\.[0-9]*)*?(,[0-9]*?)?$/
    },

    MSG_REGEX : /^(.|[\r\n]){0,2000}$/,

    CURRENCY_DEFAULT : dibsConstants.currency.codes.usd,
    CURRENCY_US      : dibsConstants.currency.codes.usd,
    CURRENCY_UK      : dibsConstants.currency.codes.gbp,
    CURRENCY_EU      : dibsConstants.currency.codes.eur,
    msgs: {
        // should move to static repo at some point
        numberFormat: 'Please enter a number in format '
    }

};


/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = {
	"subjectItem": "1stdibs Item Inquiry",
	"subjectItemNetPrice": "1stdibs Net Price",
	"subjectDealer": "1stdibs.com Dealer Inquiry",
	"contactDealerHeader": "Contact {dealer}",
	"header": "Contact {dealer}",
	"messagePlaceholder": "Request more information about this item.",
	"messagePlaceholderStorefront": "Ask the dealer a question.",
	"offerPerItem": "per item for",
	"labelOptIn": "Opt in to share your email address directly with {dealer}.",
	"optInInfo": "We keep your personal information private.",
	"labelEmail": "Your Email",
	"labelName": "Your Name",
	"labelMessage": "Your Message",
	"sendCta": "Send",
	"busyCta": "Sending...",
	"pretextPur": "I'm interested in this item. Can you please confirm the price?",
	"errorPriceFormat": "Please enter a number in format ###,###",
	"errorPriceFormatEur": "Please enter a number in format ###.###",
	"errorPositiveNumber": "Please enter a value greater than zero",
	"errorUnderListPrice": "Please enter an offer below the list price",
	"errorSpecialCharacters": "May not contain special characters",
	"errorValidEmail": "Please enter a valid email address",
	"errorRequired": "This field is required",
	"successHeader": "Thank you!",
	"successMessage": "Your message has been sent to {dealerName}. <br /> View all your messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageHold": "Request and message submitted! <br /> You will be notified if the dealer places the piece on hold for you. Dealers typically respond within one day. <br /> View all your requests and messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageNetPriceHold": "Requests submitted! <br /> You will be notified when the dealer responds with the net price and if the dealer places the piece on hold for you. Dealers typically respond within one day. View all your messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageOffer": "Your offer has been submitted and the dealer has 3 days to respond. View your offer details in <a href='/my/orders/' class='bomtLink'>My Orders</a>.",
	"viewAllYourMessagesIn": "View all your messages in ",
	"myConversations": "My Conversations",
	"successInfoHeader": "Stay Up-to-Date",
	"successInfoSubtext": "Follow to get weekly email alerts with new arrivals from this {dealerType}.",
	"noThanksCta": "No, thanks",
	"favoriteDealerCta": "FOLLOW DEALER",
	"labelMessageToggle": "Include a Message",
	"offerLowballTitle": "DON’T MISS OUT WITH A LOW OFFER",
	"makeOfferModalLinkPrompt": "Ready to negotiate? ",
	"makeOfferModalLinkCta": "Make an offer >",
	"serviceError": "An error occurred while processing your request. Please try again later.",
	"loading": "Loading",
	"holdRequestLabel": "Include a request to place this piece on hold",
	"holdRequestInfoChecked": "Please indicate for how long you are requesting a hold. If approved, this piece will be placed on hold exclusively for you.",
	"offerInfo": "The dealer may accept an offer below {price}.",
	"offerLowballMessage": "Your offer is substantially below list price and not likely to be considered. Starting the negotiation with a higher offer increases the likelihood of coming to agreement with the dealer.",
	"offerLowballChangeCta": "Increase Offer",
	"offerLowballContinueCta": "Continue",
	"labelOffer": "Make an Offer",
	"offerLowballLabelHeading": "Warning: ",
	"offerLowballLabel": "An offer significantly below the {type} price of {price} will likely be rejected. We recommend raising your offer.",
	"lowballListPriceOption": "Purchase now at list price",
	"lowballOtherOptionLabel": "Enter another offer",
	"lowballOptionAmountOff": "{amountOff} off, {percentOff}% discount",
	"originalOffer": "(original offer)",
	"placeholderPdp": "Request more information about this item.",
	"placeholderStorefront": "Ask the dealer a question.",
	"storeAddressByAppointmentOnly": "By appointment only",
	"address": "Address"
};

/***/ }),
/* 755 */,
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(99);
var isString = __webpack_require__(757);
var intelligentFormat = __webpack_require__(93);
var constants = __webpack_require__(275).currencies;
var currencyFormat;

currencyFormat = module.exports = {

    format: function (currency, model, financialAmount, options) {
        var isNegative = false;
        var amount;
        var result;
        var fn;
        if (financialAmount && isFunction(financialAmount.getAmountIn)) {
            amount = financialAmount.getAmountIn(currency);
        } else if (isString(financialAmount)) {
            fn = financialAmount;
            amount = model[fn](currency);
        }

        if (amount < 0) {
            isNegative = true;
            amount = amount * -1;
        }

        result = intelligentFormat(amount, currency, Object.assign(options || {}, {
            thousandsSeparator: ',',
            decimalMark: '.'
        }));

        return isNegative ? '- ' + result : result;
    },

    domtFormat: function (transaction, financialAmount) {
        var currency = transaction.getItemCurrency();
        return currencyFormat.format(currency, transaction, financialAmount, {});
    },

    iomtFormat: function (transaction, financialAmount) {
        var usdCurrency = '';
        var secCurrency = '';
        var itemCurrency = transaction.getItemCurrency();

        usdCurrency = currencyFormat.format(constants.CURRENCY_USD, transaction, financialAmount, {});

        if (itemCurrency !== constants.CURRENCY_USD) {
            secCurrency = ' (' + currencyFormat.domtFormat(transaction, financialAmount) + ')';
        }

        return usdCurrency + secCurrency;
    }

};


/***/ }),
/* 757 */
/***/ (function(module, exports) {

/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BarHeader = __webpack_require__(852);

var _BarHeader2 = _interopRequireDefault(_BarHeader);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'headerWrapper': 'Default__headerWrapper___1tOVZ',
  'title': 'Default__title___3Yc_T',
  'subtitle': 'Default__subtitle___2DgA6',
  'bottomBorder': 'Default__bottomBorder___3GVMZ'
};

var DefaultBarHeader = (0, _mergeThemeHoc2.default)(style)(_BarHeader2.default);
DefaultBarHeader.displayName = 'DefaultBarHeader';
exports.default = DefaultBarHeader;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalCloseButton = __webpack_require__(857);

var _ModalCloseButton2 = _interopRequireDefault(_ModalCloseButton);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'closeClickableArea': 'Default__closeClickableArea___H4Qno',
  'closeIcon': 'Default__closeIcon___39hKL',
  'closeButtonDisabled': 'Default__closeButtonDisabled___1LelM'
};

var DefaultModalCloseButton = (0, _mergeThemeHoc2.default)(style)(_ModalCloseButton2.default);
DefaultModalCloseButton.displayName = 'DefaultModalCloseButton';
exports.default = DefaultModalCloseButton;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalContainer = __webpack_require__(858);

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'stopBodyScroll': 'Default__stopBodyScroll___3oNKK',
  'overlayDefault': 'Default__overlayDefault___1Vj5A',
  'overlayFadeStart': 'Default__overlayFadeStart___sMsD1',
  'overlayDefaultOpening': 'Default__overlayDefaultOpening___8a5KA',
  'overlayDefaultClosing': 'Default__overlayDefaultClosing___3ToWB',
  'modalDefault': 'Default__modalDefault___2BfP6',
  'modalMedium': 'Default__modalMedium___yt_fR',
  'modalLarge': 'Default__modalLarge___1yXsP',
  'modalHeightCenter': 'Default__modalHeightCenter___1uOBs'
};

var DefaultModalContainer = (0, _mergeThemeHoc2.default)(style)(_ModalContainer2.default);
DefaultModalContainer.displayName = 'DefaultModalContainer';
exports.default = DefaultModalContainer;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = __webpack_require__(859);

var _Select2 = _interopRequireDefault(_Select);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'select': 'Default__select___Uuaqu'
};

var DefaultSelect = (0, _mergeThemeHoc2.default)(style)(_Select2.default);
DefaultSelect.displayName = 'DefaultSelect';
exports.default = DefaultSelect;

/***/ }),
/* 762 */,
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
            _inherits(Component, _React$Component);

            function Component() {
                        _classCallCheck(this, Component);

                        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
            }

            _createClass(Component, [{
                        key: 'render',
                        value: function render() {
                                    return React.createElement(
                                                'svg',
                                                { className: [this.props.className, 'dibsvg-svg dibsvg-logo-no-reg'].join(' '), viewBox: '0 0 100 25' },
                                                React.createElement(
                                                            'g',
                                                            null,
                                                            React.createElement('path', { d: 'M15.7,0L9.6,20.2c-0.3,1.1-0.5,1.7-0.5,2c0,0.3,0.1,0.6,0.3,0.9c0.2,0.3,0.5,0.5,0.7,0.6 c0.3,0.1,1,0.2,2.3,0.2l-0.2,0.6H0l0.2-0.6c1.2,0,2.1-0.1,2.6-0.3c0.5-0.2,0.9-0.5,1.2-0.9c0.3-0.4,0.6-1.2,1-2.5L8.5,8.2 c0.6-1.8,0.9-2.8,0.9-2.9C9.5,5,9.5,4.7,9.5,4.5C9.5,4,9.4,3.5,9,3.2C8.7,2.9,8.2,2.8,7.6,2.8c-0.3,0-0.9,0-1.8,0.1L5.7,2.2 L14.9,0H15.7z' }),
                                                            React.createElement('path', { d: 'M28.5,8.1l-0.8,5.5H27c-0.1-1.4-0.5-2.5-1.3-3.3c-0.8-0.8-1.6-1.2-2.5-1.2c-0.5,0-1,0.2-1.4,0.5 c-0.4,0.3-0.5,0.7-0.5,1.1c0,0.4,0.1,0.7,0.2,1.1c0.2,0.3,0.5,0.8,1,1.3c1.9,2,3,3.4,3.4,4.1c0.4,0.8,0.6,1.6,0.6,2.4 c0,0.9-0.2,1.8-0.7,2.6c-0.5,0.8-1.2,1.5-2.1,2c-1,0.5-1.9,0.7-3,0.7c-0.7,0-1.6-0.1-2.6-0.4c-0.7-0.2-1.2-0.3-1.5-0.3 c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.3-0.6,0.5h-0.7l0.9-5.9h0.6c0.4,1.4,0.8,2.5,1.2,3.1c0.4,0.6,0.9,1.1,1.5,1.5 c0.6,0.4,1.2,0.5,1.8,0.5c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.1-1.1-0.4-1.6c-0.3-0.5-0.9-1.3-1.9-2.4 c-1.4-1.5-2.3-2.7-2.8-3.5c-0.3-0.6-0.5-1.3-0.5-2c0-1.3,0.5-2.3,1.4-3.2c0.9-0.9,2.3-1.3,4-1.3c0.7,0,1.7,0.1,2.7,0.4 c0.5,0.1,1,0.2,1.3,0.2c0.5,0,0.8-0.2,1.1-0.6H28.5z' }),
                                                            React.createElement('path', { d: 'M40,3.8l-1.5,4.8h2l-0.6,2h-2L34.6,21c-0.2,0.6-0.3,1.1-0.3,1.5c0,0.1,0.1,0.2,0.2,0.3 c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.4-0.1,0.6-0.2c0.5-0.4,1.2-1.1,1.9-2.2l0.6,0.4c-0.8,1.4-1.7,2.5-2.7,3.1c-1,0.7-2,1-2.9,1 c-0.8,0-1.4-0.2-1.9-0.6c-0.4-0.4-0.7-0.9-0.7-1.5c0-0.7,0.2-1.6,0.5-2.6l3.1-9.6H31l0.3-1.3c1.5-0.6,2.7-1.2,3.8-1.9 c1.1-0.7,2.4-1.9,3.9-3.6H40z' }),
                                                            React.createElement('path', { d: 'M59.6,0l-6.1,19.8C53.2,21,53,21.7,53,22c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.7-0.3 c0.4-0.3,1-1,1.6-1.9l0.6,0.3c-1.7,2.9-3.5,4.4-5.6,4.4c-0.7,0-1.3-0.2-1.7-0.6c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.3,0.5-2.4 l0.6-1.8c-1.5,2.6-2.8,4.3-3.9,5.2c-0.8,0.6-1.7,1-2.4,1c-0.9,0-1.7-0.4-2.3-1.1S40,22.2,40,20.8c0-1.8,0.4-3.5,1.2-5.2 c0.8-1.7,1.7-3.1,2.8-4.3c1-1.1,2-2,3-2.4c0.9-0.5,1.9-0.7,2.8-0.7c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.8,0.6,1.3,1.1l1.4-4.4 c0.4-1.1,0.5-1.9,0.5-2.4c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.2,0-0.4,0-0.7,0.1l0.2-0.7L58.5,0H59.6z M51.6,11.2 c0-0.7-0.1-1.2-0.4-1.6c-0.3-0.3-0.6-0.5-1-0.5c-0.4,0-0.8,0.2-1.3,0.6c-0.9,0.8-1.8,2.3-2.7,4.6c-0.9,2.3-1.4,4.2-1.4,5.8 c0,0.6,0.1,1,0.3,1.3c0.2,0.3,0.4,0.4,0.7,0.4c0.4,0,0.9-0.2,1.3-0.6c1-0.9,2.1-2.4,3.1-4.6C51.1,14.3,51.6,12.5,51.6,11.2z' }),
                                                            React.createElement('path', { d: 'M66,0c0.7,0,1.4,0.3,1.9,0.8c0.5,0.5,0.8,1.1,0.8,1.8c0,0.7-0.3,1.3-0.8,1.8C67.4,5,66.8,5.2,66,5.2 c-0.7,0-1.3-0.3-1.9-0.8c-0.5-0.5-0.8-1.1-0.8-1.8c0-0.7,0.3-1.3,0.8-1.8C64.7,0.3,65.3,0,66,0z M67.5,8.1l-4,12.5 c-0.2,0.7-0.3,1.2-0.3,1.4c0,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.2,0,0.4-0.1,0.6-0.3c0.5-0.5,1.2-1.3,1.9-2.5l0.6,0.4 C65,23.4,63,25,61,25c-0.8,0-1.4-0.2-1.9-0.6c-0.5-0.4-0.7-1-0.7-1.6c0-0.4,0.1-1,0.3-1.7l2.8-8.5c0.3-0.8,0.4-1.4,0.4-1.8 c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.2,0-0.4,0-0.7,0l0.2-0.7l6.3-1H67.5z' }),
                                                            React.createElement('path', { d: 'M80,0l-3.2,10.6c0.9-1,1.7-1.7,2.3-2c0.6-0.3,1.3-0.5,2-0.5c1.4,0,2.4,0.5,3.1,1.5c0.7,1,1,2.2,1,3.5 c0,3.2-1.1,6-3.4,8.5c-2,2.2-4.4,3.3-7,3.3c-1.9,0-4-0.6-6.1-1.7l5.6-18.6c0.3-0.9,0.4-1.5,0.4-1.9c0-0.3-0.1-0.5-0.4-0.7 c-0.4-0.3-0.9-0.4-1.6-0.3l0.2-0.7L78.9,0H80z M73,23.5c0.5,0.4,1,0.5,1.5,0.5c0.6,0,1.1-0.1,1.5-0.4c0.7-0.4,1.3-1.1,2.1-2.2 c0.7-1.1,1.3-2.3,1.8-3.8c0.5-1.5,0.7-3,0.7-4.4c0-0.8-0.2-1.5-0.5-1.9c-0.4-0.4-0.8-0.7-1.2-0.7c-0.8,0-1.5,0.4-2,1.2 c-0.4,0.5-0.8,1.7-1.3,3.4L73,23.5z' }),
                                                            React.createElement('path', { d: 'M100,8.1l-0.8,5.5h-0.7c-0.1-1.4-0.5-2.5-1.3-3.3c-0.8-0.8-1.6-1.2-2.5-1.2c-0.5,0-1,0.2-1.4,0.5 c-0.4,0.3-0.5,0.7-0.5,1.1c0,0.4,0.1,0.7,0.2,1.1c0.2,0.3,0.5,0.8,1,1.3c1.9,2,3,3.4,3.4,4.1c0.4,0.8,0.6,1.6,0.6,2.4 c0,0.9-0.2,1.8-0.7,2.6c-0.5,0.8-1.2,1.5-2.1,2c-1,0.5-1.9,0.7-3,0.7c-0.7,0-1.6-0.1-2.6-0.4c-0.7-0.2-1.2-0.3-1.5-0.3 c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.3-0.6,0.5h-0.7l0.9-5.9h0.6c0.4,1.4,0.8,2.5,1.2,3.1c0.4,0.6,0.9,1.1,1.5,1.5 c0.6,0.4,1.2,0.5,1.8,0.5c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.1-1.1-0.4-1.6c-0.3-0.5-0.9-1.3-1.9-2.4 c-1.4-1.5-2.3-2.7-2.8-3.5c-0.3-0.6-0.5-1.3-0.5-2c0-1.3,0.5-2.3,1.4-3.2c0.9-0.9,2.3-1.3,4-1.3c0.7,0,1.7,0.1,2.7,0.4 c0.5,0.1,1,0.2,1.3,0.2c0.5,0,0.8-0.2,1.1-0.6H100z' })
                                                )
                                    );
                        }
            }]);

            return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 764 */,
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root,factory){
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.eventListener = factory();
  }
}(this, function () {
	function wrap(standard, fallback) {
		return function (el, evtName, listener, useCapture) {
			if (el[standard]) {
				el[standard](evtName, listener, useCapture);
			} else if (el[fallback]) {
				el[fallback]('on' + evtName, listener);
			}
		}
	}

    return {
		add: wrap('addEventListener', 'attachEvent'),
		remove: wrap('removeEventListener', 'detachEvent')
	};
}));

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"ItemActionButtons-style__verticallyCentered__2i4v9","horizontallyRight":"ItemActionButtons-style__horizontallyRight__1kKHh","horizontallyCentered":"ItemActionButtons-style__horizontallyCentered__1FViA","verticallyHorizontallyCentered":"ItemActionButtons-style__verticallyHorizontallyCentered__2UN6f","placeholderTwoButtons":"ItemActionButtons-style__placeholderTwoButtons__2IsA8","placeholderOneButton":"ItemActionButtons-style__placeholderOneButton__1YOti","itemActionWidget":"ItemActionButtons-style__itemActionWidget__28Dtz","itemActionRightArrow":"ItemActionButtons-style__itemActionRightArrow__1SYJD"};

/***/ }),
/* 767 */,
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalOverlay":"tradeWelcomeMessage__modalOverlay__1OslN","modalContent":"tradeWelcomeMessage__modalContent__3ZHg2","isExpanded":"tradeWelcomeMessage__isExpanded__qzHW6","isExpandedNoName":"tradeWelcomeMessage__isExpandedNoName__1R_W9","pictureWrapper":"tradeWelcomeMessage__pictureWrapper__2d3Ep","pictureTourWrapper":"tradeWelcomeMessage__pictureTourWrapper__3ytYN","picture":"tradeWelcomeMessage__picture__6MRiB","content":"tradeWelcomeMessage__content__3c36m","collapsedContent":"tradeWelcomeMessage__collapsedContent__2uBNd tradeWelcomeMessage__content__3c36m","expandedTitle":"tradeWelcomeMessage__expandedTitle__q1pnz","paragraph":"tradeWelcomeMessage__paragraph__30xgU","iconWrapper":"tradeWelcomeMessage__iconWrapper__3N_sW","icon":"tradeWelcomeMessage__icon__2G4YV","flip":"tradeWelcomeMessage__flip__kBx5v"};

/***/ }),
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var ContextComponent = __webpack_require__(61);
var Tooltip = __webpack_require__(270);
__webpack_require__(272);
var FavoriteButton = __webpack_require__(560);

var FavoriteCta = function (_ContextComponent) {
    _inherits(FavoriteCta, _ContextComponent);

    function FavoriteCta(props) {
        _classCallCheck(this, FavoriteCta);

        var _this = _possibleConstructorReturn(this, (FavoriteCta.__proto__ || Object.getPrototypeOf(FavoriteCta)).call(this, props));

        _this._onClick = _this._onClick.bind(_this);
        _this._onMouseEnter = _this._onMouseEnter.bind(_this);
        _this._onMouseLeave = _this._onMouseLeave.bind(_this);
        _this._closeConfirmationTooltip = _this._closeConfirmationTooltip.bind(_this);

        _this.state = {
            mouseIsOver: false,
            confirmationTooltipIsOpen: false,
            buttonClicked: false
        };
        return _this;
    }

    _createClass(FavoriteCta, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                isFetched = _props.isFetched,
                isSaved = _props.isSaved;
            var buttonClicked = this.state.buttonClicked;

            var canShowConfirmation = nextProps.showConfirmation || buttonClicked;

            if (nextProps.isCanceled) {
                this.setState({ buttonClicked: false });
            }

            // Should show success message components button was clicked, favorites were
            // fetched already and favorite was saved
            if (canShowConfirmation && isFetched && !isSaved && nextProps.isSaved || buttonClicked && !isFetched && nextProps.isFetched && nextProps.isSaved) {
                this._openConfirmationTooltip();
            } else if (isSaved && !nextProps.isSaved) {
                this._closeConfirmationTooltip();
            }
        }
    }, {
        key: '_openConfirmationTooltip',
        value: function _openConfirmationTooltip() {
            this.setState({
                confirmationTooltipIsOpen: true,
                buttonClicked: false
            });

            // Close confirmation tooltip after 5 seconds
            this._timeout = setTimeout(this._closeConfirmationTooltip, this.props.closeTimeout);
        }
    }, {
        key: '_closeConfirmationTooltip',
        value: function _closeConfirmationTooltip() {
            this.setState({
                confirmationTooltipIsOpen: false,
                buttonClicked: false
            });
            clearTimeout(this._timeout);
        }
    }, {
        key: '_onClick',
        value: function _onClick() {
            this.setState({ buttonClicked: true });
        }
    }, {
        key: '_onMouseEnter',
        value: function _onMouseEnter() {
            this.setState({ mouseIsOver: true });
        }
    }, {
        key: '_onMouseLeave',
        value: function _onMouseLeave() {
            this.setState({ mouseIsOver: false });
        }
    }, {
        key: '_getConfirmationTooltip',
        value: function _getConfirmationTooltip() {
            var confirmationTooltipIsOpen = this.state.confirmationTooltipIsOpen;
            var _props2 = this.props,
                confirmationTooltip = _props2.copy.confirmationTooltip,
                tooltipClass = _props2.tooltipClass;


            if (confirmationTooltip) {
                return React.createElement(
                    Tooltip,
                    { hasTriangle: false,
                        isVisible: confirmationTooltipIsOpen,
                        tooltipDirection: 'right'
                    },
                    React.createElement(
                        'div',
                        { className: tooltipClass, 'data-tn': 'favorite-confirmation-tooltip' },
                        confirmationTooltip
                    )
                );
            }

            return null;
        }
    }, {
        key: '_getCtaTooltip',
        value: function _getCtaTooltip() {
            var mouseIsOver = this.state.mouseIsOver;
            var _props3 = this.props,
                tooltipCanBeShown = _props3.tooltipCanBeShown,
                isSaved = _props3.isSaved,
                ctaTooltip = _props3.copy.ctaTooltip;

            var hoverTooltipIsOpen = tooltipCanBeShown && !isSaved && mouseIsOver;

            if (ctaTooltip) {
                return React.createElement(
                    Tooltip,
                    { isVisible: hoverTooltipIsOpen, tooltipDirection: 'bottom' },
                    ctaTooltip
                );
            }

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props4 = this.props,
                className = _props4.className,
                favoriteData = _props4.favoriteData,
                tracking = _props4.tracking,
                cta = _props4.copy.cta,
                children = _props4.children;


            return React.createElement(
                'div',
                { className: 'favorites-callout-wrap', ref: function ref(c) {
                        _this2._button = c;
                    } },
                React.createElement(FavoriteButton, _extends({ cta: cta,
                    resetCollection: true,
                    className: className,
                    onClick: this._onClick,
                    onMouseEnter: this._onMouseEnter,
                    onMouseLeave: this._onMouseLeave,
                    favoriteData: favoriteData,
                    tracking: tracking
                }, this.props)),
                this._getConfirmationTooltip(),
                this._getCtaTooltip(),
                children
            );
        }
    }]);

    return FavoriteCta;
}(ContextComponent);

FavoriteCta.propTypes = {
    isSaved: PropTypes.bool.isRequired,
    isFetched: PropTypes.bool.isRequired,
    isCanceled: PropTypes.bool.isRequired,
    tooltipCanBeShown: PropTypes.bool.isRequired,
    copy: PropTypes.object.isRequired,
    favoriteData: PropTypes.object.isRequired,
    className: PropTypes.string,
    tracking: PropTypes.object,
    closeTimeout: PropTypes.number.isRequired,
    tooltipClass: PropTypes.string
};

FavoriteCta.defaultProps = {
    showConfirmation: false,
    tooltipCanBeShown: true,
    closeTimeout: 5000
};

module.exports = FavoriteCta;

/***/ }),
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

var EnvelopeIcon = __webpack_require__(578);
var FacebookIcon = __webpack_require__(537);
var PinterestIcon = __webpack_require__(494);

var styles = __webpack_require__(1042);

var config = [{ type: 'envelope', Icon: EnvelopeIcon }, { type: 'facebook', Icon: FacebookIcon }, { type: 'pinterest', Icon: PinterestIcon }];

function onClick(type, sharePhoto) {
    return function (e) {
        e.stopPropagation();
        sharePhoto({ type: type, e: e });
    };
}

function GalleryPhotoSocial(_ref) {
    var classes = _ref.classes,
        sharePhoto = _ref.sharePhoto;

    return React.createElement(
        'div',
        { className: classes.wrapper },
        config.map(function (_ref2) {
            var type = _ref2.type,
                Icon = _ref2.Icon;
            return React.createElement(
                'div',
                { className: classes.icon, key: type, onClick: onClick(type, sharePhoto) },
                React.createElement(Icon, null)
            );
        })
    );
}

GalleryPhotoSocial.propTypes = {
    sharePhoto: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        wrapper: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired
    }).isRequired
};

GalleryPhotoSocial.defaultProps = {
    classes: styles
};

module.exports = GalleryPhotoSocial;

/***/ }),
/* 779 */,
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ReactModal = __webpack_require__(499);
var tokenReplace = __webpack_require__(75);

var ContextComponent = __webpack_require__(61);
var SanitizeHtml = __webpack_require__(296);
var styles = __webpack_require__(768);
var AccountFilledIcon = __webpack_require__(700);
var ArrowUpIcon = __webpack_require__(511);
var CloseIcon = __webpack_require__(276);
var classNames = __webpack_require__(16);
var copy = __webpack_require__(751);

var tradeMessageActions = __webpack_require__(1077);
var Tour = __webpack_require__(487);
var tourTracking = __webpack_require__(506);
var tradeWelcomeMessageTracking = __webpack_require__(781);

var TradeWelcomeMessage = function (_ContextComponent) {
    _inherits(TradeWelcomeMessage, _ContextComponent);

    function TradeWelcomeMessage(props) {
        _classCallCheck(this, TradeWelcomeMessage);

        var _this = _possibleConstructorReturn(this, (TradeWelcomeMessage.__proto__ || Object.getPrototypeOf(TradeWelcomeMessage)).call(this, props));

        _this.state = {
            isExpanded: false,
            isVisible: !props.tradeTour.isTourOpen && props.isVisible
        };

        _this.toggleExpand = _this.toggleExpand.bind(_this);
        _this.onCloseClick = _this.onCloseClick.bind(_this);
        return _this;
    }

    _createClass(TradeWelcomeMessage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.state.isVisible) {
                tradeWelcomeMessageTracking.trackOpen();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var isVisible = _ref.isVisible,
                tradeTour = _ref.tradeTour;

            var isLastStep = tradeTour.currentStep === tradeTour.totalSteps;
            if (tradeTour.isTourOpen && isLastStep) {
                this.setState({ isVisible: true });
            } else if (tradeTour.isTourOpen) {
                this.setState({ isVisible: false });
            } else {
                this.setState({ isVisible: isVisible });
            }
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            if (nextState.isVisible && !this.state.isVisible) {
                tradeWelcomeMessageTracking.trackOpen();
            }
        }
    }, {
        key: 'toggleExpand',
        value: function toggleExpand() {
            var isExpanded = !this.state.isExpanded;

            this.setState({ isExpanded: isExpanded });

            if (isExpanded) {
                tradeWelcomeMessageTracking.trackExpand();
            }
        }
    }, {
        key: 'onCloseClick',
        value: function onCloseClick() {
            this.context.executeAction(tradeMessageActions.hideTradeMessage);
            tradeWelcomeMessageTracking.trackClose();
        }
    }, {
        key: 'getCollapsedContent',
        value: function getCollapsedContent() {
            var repFirstName = this.props.tradeSalesRep.firstName;

            var content = tokenReplace(copy.collapsed, {
                repFirstName: repFirstName,
                repClass: styles.collapsedName
            });
            return React.createElement(
                'div',
                { onClick: this.toggleExpand, className: styles.collapsedContent },
                React.createElement(SanitizeHtml, { content: content, allowedTags: ['span'], allowedAttributes: { span: ['class'] } })
            );
        }
    }, {
        key: 'getExpandedContent',
        value: function getExpandedContent() {
            var props = this.props;
            var tradeSalesRep = props.tradeSalesRep,
                userFirstName = props.userFirstName;
            var repFirstName = tradeSalesRep.firstName;

            var showFirstName = userFirstName ? React.createElement(
                'div',
                { className: styles.expandedTitle + ' ' + styles.paragraph },
                userFirstName + ','
            ) : null;
            var displayName = tradeSalesRep.firstName + ' ' + tradeSalesRep.lastName;
            return React.createElement(
                'div',
                { className: styles.content },
                showFirstName,
                copy.expanded.map(function (text, index) {
                    return React.createElement(
                        'div',
                        { key: index, className: styles.paragraph },
                        tokenReplace(text, { repFirstName: repFirstName })
                    );
                }),
                React.createElement(
                    'div',
                    null,
                    displayName
                ),
                React.createElement(
                    'div',
                    null,
                    tradeSalesRep.phoneNumber
                ),
                React.createElement(
                    'div',
                    null,
                    tradeSalesRep.email
                )
            );
        }
    }, {
        key: 'onOpenWelcomeMessageTour',
        value: function onOpenWelcomeMessageTour(payload) {
            tourTracking.trackOpen(payload);
            tourTracking.trackComplete(payload);
        }
    }, {
        key: 'includeTour',
        value: function includeTour() {
            var isTourOpen = this.props.tradeTour.isTourOpen;

            if (isTourOpen) {
                return React.createElement(
                    Tour,
                    _extends({ dataTn: 'welcome-message-trade', step: 6 }, this.props.tradeTour, { onOpen: this.onOpenWelcomeMessageTour }),
                    React.createElement(
                        'div',
                        { className: styles.pictureTourWrapper },
                        React.createElement(AccountFilledIcon, { className: styles.picture })
                    )
                );
            }
            return React.createElement(AccountFilledIcon, { className: styles.picture });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                isVisible = _state.isVisible,
                isExpanded = _state.isExpanded;
            var userFirstName = this.props.userFirstName;
            var overlayClassName = styles.modalOverlay;

            var expandedClassName = userFirstName ? styles.isExpanded : styles.isExpandedNoName;
            var modalClassName = classNames(styles.modalContent, _defineProperty({}, expandedClassName, isExpanded));
            var toggleClass = classNames(styles.icon, _defineProperty({}, styles.flip, isExpanded));

            return React.createElement(
                ReactModal,
                { isOpen: isVisible, overlayClassName: overlayClassName, className: modalClassName },
                React.createElement(
                    'div',
                    { className: styles.iconWrapper },
                    React.createElement(
                        'a',
                        { href: '#0', onClick: this.toggleExpand },
                        React.createElement(ArrowUpIcon, { className: toggleClass })
                    ),
                    React.createElement(
                        'a',
                        { href: '#0', onClick: this.onCloseClick },
                        React.createElement(CloseIcon, { className: styles.icon })
                    )
                ),
                isExpanded ? this.getExpandedContent() : this.getCollapsedContent(),
                React.createElement(
                    'div',
                    { className: styles.pictureWrapper },
                    this.includeTour()
                )
            );
        }
    }]);

    return TradeWelcomeMessage;
}(ContextComponent);

TradeWelcomeMessage.propTypes = {
    userFirstName: PropTypes.string,
    tradeSalesRep: PropTypes.object.isRequired,
    tradeTour: PropTypes.object,
    step: PropTypes.number
};

TradeWelcomeMessage.defaultProps = {
    tradeTour: {
        isTourOpen: false
    }
};

module.exports = TradeWelcomeMessage;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tracking = __webpack_require__(27);

module.exports = {
    trackOpen: function trackOpen() {
        tracking.trackEvent({
            category: 'trade program education',
            action: 'trade welcome message',
            label: 'trade welcome docked message displayed'
        });
    },
    trackClose: function trackClose() {
        tracking.trackEvent({
            category: 'trade program education',
            action: 'trade welcome message',
            label: 'trade welcome docked message closed'
        });
    },
    trackExpand: function trackExpand() {
        tracking.trackEvent({
            category: 'trade program education',
            action: 'trade welcome message',
            label: 'trade welcome docked message expanded'
        });
    }
};

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 7/17/15.
 */



var React = __webpack_require__(1);

/**
 * Adds the child context types from Fluxible.provideContext to the passed in props.
 * This is a convenience method to avoid having to type it on every child class that needs a context.
 * @param props {object} The properties that will be passed to React.createClass
 */
module.exports = function (props) {
    return Object.assign({}, props, {
        contextTypes: {
            getStore: React.PropTypes.func.isRequired,
            executeAction: React.PropTypes.func.isRequired
        }
    });
};

/***/ }),
/* 783 */,
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var omit = __webpack_require__(95);
var querystring = __webpack_require__(679);
var getSocialWindowPosition = __webpack_require__(970);

var TWITTER_URL = "https://twitter.com/intent/tweet?";

var twitter = {
    _listenWindowClose: function _listenWindowClose(twitterWindow) {
        return new Promise(function (resolve) {
            var interval = setInterval(function () {
                try {
                    if (twitterWindow === null || twitterWindow.closed) {
                        clearInterval(interval);
                        resolve();
                    }
                } catch (e) {
                    resolve();
                }
            }, 500);
        });
    },


    /**
     * Builds the url for the twitter popup
     * @param {object} options
     * @param {string} [options.text]       - pre-filled tweet text
     * @param {string} [options.url]        - url following tweet text
     * @param {array}  [options.hashtags]   - twitter hashtags following tweet text
     * @param {string} [options.via]        - a handle for twitter to tag as 'via @handle'
     *
     * Example tweet:
     *  options = { text: "Beautiful Items on ", url: "1stdibs.com", hashtags: ["hashtag1", "hashtag2"], via: "1stdibs"}
     *      => Pre-filled tweet = "Beautiful Items on 1stdibs.com #hashtag1 #hashtag2 via @1stdibs"
     *
     * @see https://dev.twitter.com/web/tweet-button
     */
    buildUrl: function buildUrl(options) {

        // Twitter API
        var queryOptions = omit({
            text: options.text,
            url: options.url,
            hashtags: Array.isArray(options.hashtags) ? options.hashtags.join(',') : options.hashtags,
            via: options.via
        }, function (val) {
            return typeof val === 'undefined' || val === '';
        });

        return TWITTER_URL + querystring.stringify(queryOptions);
    },
    openWindow: function openWindow(options) {
        var width = 665;
        var height = 500;
        var windowOptions = {
            scrollbars: 'yes',
            resizable: 'no',
            toolbar: 'no',
            height: height,
            width: width,
            top: 0,
            left: 0
        };

        Object.assign(windowOptions, getSocialWindowPosition(height, width));
        return this._listenWindowClose(window.open(this.buildUrl(options), 'twitter', querystring.stringify(windowOptions, ',')));
    }
};

module.exports = twitter;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    QUOTES_RELEVANT_PDP: 'RELEVANT_PDP',
    QUOTES_ALL_PDP: 'PDP',
    FETCH_RELEVANT_QUOTE: 'FETCH_RELEVANT_QUOTE',
    FETCH_ALL_QUOTES: 'FETCH_ALL_QUOTES',
    BOOTSTRAP_SHIPPING_STORE: 'BOOTSTRAP_SHIPPING_STORE',
    OPEN_DETAILS_FROM_SIDEBAR: 'sidebar',
    OPEN_DETAILS_FROM_DESCRIPTION: 'description',
    TRACKING_COMPLETED: 'TRACKING_COMPLETED'
};

/***/ }),
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getElementPosition;
/*
* Finds element's position relative to the whole document,
* rather than to the viewport as it is the case with .getBoundingClientRect().
*/
function getElementPosition(element) {
  var rect = element.getBoundingClientRect();

  return {
    top: rect.top + window.pageYOffset,
    left: rect.left + window.pageXOffset
  };
}

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inViewport;

var _getElementPosition = __webpack_require__(789);

var _getElementPosition2 = _interopRequireDefault(_getElementPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isHidden = function isHidden(element) {
  return element.offsetParent === null;
};

function inViewport(element, container, customOffset) {
  if (isHidden(element)) {
    return false;
  }

  var top = void 0;
  var bottom = void 0;
  var left = void 0;
  var right = void 0;

  if (typeof container === 'undefined' || container === window) {
    top = window.pageYOffset;
    left = window.pageXOffset;
    bottom = top + window.innerHeight;
    right = left + window.innerWidth;
  } else {
    var containerPosition = (0, _getElementPosition2.default)(container);

    top = containerPosition.top;
    left = containerPosition.left;
    bottom = top + container.offsetHeight;
    right = left + container.offsetWidth;
  }

  var elementPosition = (0, _getElementPosition2.default)(element);

  return top <= elementPosition.top + element.offsetHeight + customOffset.top && bottom >= elementPosition.top - customOffset.bottom && left <= elementPosition.left + element.offsetWidth + customOffset.left && right >= elementPosition.left - customOffset.right;
}

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var style = function style(element, prop) {
  return typeof getComputedStyle !== 'undefined' ? getComputedStyle(element, null).getPropertyValue(prop) : element.style[prop];
};

var overflow = function overflow(element) {
  return style(element, 'overflow') + style(element, 'overflow-y') + style(element, 'overflow-x');
};

var scrollParent = function scrollParent(element) {
  if (!(element instanceof HTMLElement)) {
    return window;
  }

  var parent = element;

  while (parent) {
    if (parent === document.body || parent === document.documentElement) {
      break;
    }

    if (!parent.parentNode) {
      break;
    }

    if (/(scroll|auto)/.test(overflow(parent))) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return window;
};

exports.default = scrollParent;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 794 */,
/* 795 */,
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var actions = __webpack_require__(743);
var itemQuery = __webpack_require__(1334);
var pdpTracking = __webpack_require__(542);

var _require = __webpack_require__(541),
    getShipmentPrequotes = _require.getShipmentPrequotes;

var _require2 = __webpack_require__(334),
    getUserId = _require2.getUserId,
    getBuyerToken = _require2.getBuyerToken,
    cookieJarConstants = _require2.cookieJarConstants;

var MASQUERADE_BUYER = cookieJarConstants.MASQUERADE_BUYER;

var get = __webpack_require__(14);

var pdpActions = {

    bootstrapPage: function bootstrapPage(actionContext, payload) {
        actionContext.dispatch(actions.ACTION_RECEIVE_PAGE, payload);
    },

    setIndex: function setIndex(actionContext, payload) {
        actionContext.dispatch(actions.ACTION_CAROUSEL_INDEX, payload);
    },

    setHeroExpanded: function setHeroExpanded(actionContext, payload) {
        actionContext.dispatch(actions.ACTION_HERO_EXPANDED, payload);
    },

    setHeroChangingSize: function setHeroChangingSize(actionContext, payload) {
        actionContext.dispatch(actions.ACTION_HERO_CHANGING_SIZE, payload);
    },

    setPrintPage: function setPrintPage(actionContext, payload) {
        actionContext.dispatch(actions.ACTION_PRINT_PAGE, payload);
    },

    /**
     *
     * @param actionContext
     * @param {object}  payload
     * @param {boolean} payload.showInfo - show/hide buyer assurance tooltip/modal on pdp
     */
    toggleBuyerAssuranceShowInfo: function toggleBuyerAssuranceShowInfo(actionContext, payload) {
        actionContext.dispatch(actions.ACTION_TOGGLE_BUYER_ASSURANCE_SHOW_INFO, payload);
    },

    // FINDING-7016 : Pdp Buyer Assurance
    // to surface the new buyer assurance program, we need to show a highlighted border around the
    // Pdp Support Component...
    // todo: remove this after initial surfacing is done
    deleteBuyerAssurance: function deleteBuyerAssurance(actionContext) {
        actionContext.dispatch(actions.ACTION_DELETE_BUYER_ASSURANCE_COOKIE);
    },

    asyncLoadItem: function asyncLoadItem(actionContext, _ref) {
        var pk = _ref.pk;


        var userId = getUserId(document.cookie, MASQUERADE_BUYER);
        var userToken = get(getBuyerToken(document.cookie), 'userToken', '');
        var hasUserId = !!userId;

        $.ajax({
            method: 'POST',
            url: '/soa/graphql/' + (userToken ? '?userToken=' + userToken : ''),
            data: {
                query: itemQuery.query(pk, userId, hasUserId)
            }
        }).done(function (data) {
            var item = get(data, 'data.viewer.item', {});

            var _get = get(data, 'data.viewer', {}),
                domesticDeliveryOptions = _get.domesticDeliveryOptions,
                localDeliveryOptions = _get.localDeliveryOptions,
                shipmentQuotes = _get.shipmentQuotes;

            var quotes = getShipmentPrequotes({ localDeliveryOptions: localDeliveryOptions, domesticDeliveryOptions: domesticDeliveryOptions, shipmentQuotes: shipmentQuotes });
            var canRequestShippingQuote = get(data, 'data.viewer.user.canRequestShippingQuote') ? 'y' : 'n';

            actionContext.dispatch('ASYNC_LOAD_ITEM', { json: item });
            pdpTracking.trackShippingStatusData(quotes, canRequestShippingQuote);
        }).fail(function (jqXHR, textStatus) {
            console.warn('Call failed or exceeded 500ms--defaulting to cached Item.\n', new Error(textStatus));
            actionContext.dispatch('ASYNC_LOAD_ITEM');
        });
    }
};

module.exports = pdpActions;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(281),
    categories = _require.categories;

var _require2 = __webpack_require__(388),
    addHeaders = _require2.addHeaders,
    fetchWrapper = _require2.fetchWrapper,
    addParamsToUrl = _require2.addParamsToUrl;

/**
 * Action that makes categories service call to get the list of categories
 *  and update the store with retrieved categories
 *
 * @param {Context} ac
 * @param {Array}   keys - specific category keys to fetch from categories service
 * @param {Array}   fields - array of fields that to pass to categories endpoint
 * @param {function} done
 */


function fetchCategories(ac, _ref, done) {
    var keys = _ref.keys,
        fields = _ref.fields;

    var url = addParamsToUrl(categories(), { keys: keys, fields: fields });

    fetchWrapper(url, addHeaders({ method: 'get' })).then(function (response) {
        if (response.result) {
            ac.dispatch('SET_CATEGORIES', response.result);
        }
        done();
    }).catch(function (error) {
        ac.dispatch('SET_CATEGORIES_ERROR', { error: error });
        done();
    });
}

/**
 * Action for fetching categories needed for gallery
 *
 * @param ac
 * @param payload
 * @param done
 */
function fetchGalleryCategories(ac, payload, done) {
    ac.executeAction(fetchCategories, {
        keys: ['F', 'A'],
        fields: ['descendants']
    }, done);
}

module.exports = {
    fetchCategories: fetchCategories,
    fetchGalleryCategories: fetchGalleryCategories
};

/***/ }),
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeYesCheckSelector = exports.makeArrayCompareSelector = exports.makeEqualityCheckSelector = undefined;

var _createSelector = __webpack_require__(627);

var _createSelector2 = _interopRequireDefault(_createSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a selector factory whose input will be checked for equality against
 * the resulting selector that gets returned
 *
 * Example:
 *
 * const item = { id: 0 };
 * const getId = item => item.id;
 * const idCompareSelector = makeEqualityCheckSelector(getId);
 * const getIsIdZero = makeIdCompareSelector(0);
 * assert(getIsIdZero(item));
 */
var makeEqualityCheckSelector = exports.makeEqualityCheckSelector = function makeEqualityCheckSelector() {
    for (var _len = arguments.length, dependencySelectors = Array(_len), _key = 0; _key < _len; _key++) {
        dependencySelectors[_key] = arguments[_key];
    }

    return function (inputToCompare) {
        return _createSelector2.default.apply(undefined, dependencySelectors.concat([function (selectorInput) {
            return selectorInput === inputToCompare;
        }]));
    };
};

/**
 * Creates a selector factory whose input will checked to see if it exists
 * in the array that the returning selector returns.
 *
 * Example:
 *
 * const item = { attributes: ['green', 'little', 'shiny'] };
 * const getAttributes = item => item.attributes;
 * const attributeCheckSelector = makeArrayCompareSelector(getAttributes);
 * const getHasGreenAttribute = makeAttributeCheckSelector('green');
 * assert(getHasGreenAttribute(item));
 */
var makeArrayCompareSelector = exports.makeArrayCompareSelector = function makeArrayCompareSelector() {
    for (var _len2 = arguments.length, dependencySelectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        dependencySelectors[_key2] = arguments[_key2];
    }

    return function (inputToCompare) {
        return _createSelector2.default.apply(undefined, dependencySelectors.concat([function (arrayToCheck) {
            return arrayToCheck.indexOf(inputToCompare) > -1;
        }]));
    };
};

/**
 * Creates a selector factory that will compare the result of the selector with 'Y'.
 * For data that, instead of being stored as booleans, are stored as 'Y' or 'N'
 *
 * Example:
 *
 * const item = { available: 'Y' };
 * const getAvailable = item => item.available;
 * const getIsAvailable = makeYesCheckSelector(getAvailable);
 * assert(getIsAvailable(item));
 */
var makeYesCheckSelector = exports.makeYesCheckSelector = function makeYesCheckSelector() {
    for (var _len3 = arguments.length, dependencySelectors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        dependencySelectors[_key3] = arguments[_key3];
    }

    var selectorFunc = dependencySelectors.pop();
    var selector = function selector(input) {
        var prop = selectorFunc(input);
        return prop === 'Y' || prop === true;
    };
    return dependencySelectors.length ? _createSelector2.default.apply(undefined, dependencySelectors.concat([selector])) : selector;
};

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 804 */,
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isNetPrice":"styles__isNetPrice__dAuYR","price":"styles__price__1FaPK","net":"styles__net__35bHz","percentOff":"styles__percentOff__3hlB4","retail":"styles__retail__3D7Dx"};

/***/ }),
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Source attribution structure example:
 * [
 *     {
 *         "type": "TYPE",
 *         "date": "2016-08-03T16:56:26.000+03:00",
 *         "time": 1470232586378,
 *         "referer": "https://www.1stdibs.com/furniture/"
 *         "utmParams": {
 *             "landingPage": "/furniture/tables/",
 *             "visitCount": 1
 *         }
 *     }
 * ]
 */

var User = __webpack_require__(15);
var moment = __webpack_require__(30);
var endpoints = __webpack_require__(281);
var windowCheck = __webpack_require__(97);

var _require = __webpack_require__(280),
    localStorage = _require.localStorage;

var serviceFetchWrappers = __webpack_require__(388);

var SETTINGS = {
    DATE_FORMAT: 'YYYY-MM-DDTHH:mm:ss.SSSZ',

    PRE_REGISTRATION_PAGE_VISIT: {
        CAP: 100,
        STORAGE_KEY: '_dibsPreRegistrationPageVisit'
    }
};

var getStorageKey = function getStorageKey(type) {
    var _ref = SETTINGS[type] || {},
        STORAGE_KEY = _ref.STORAGE_KEY;

    return STORAGE_KEY || '';
};

var getCAP = function getCAP(type) {
    var _ref2 = SETTINGS[type] || {},
        CAP = _ref2.CAP;

    return CAP;
};

var getDateTime = function getDateTime() {
    var now = new Date();

    return {
        date: moment(now.toISOString()).format(SETTINGS.DATE_FORMAT),
        time: now.getTime()
    };
};

var generateAttribution = function generateAttribution(_ref3) {
    var type = _ref3.type,
        page = _ref3.page;

    return Object.assign(getDateTime(), {
        type: type,
        utmParams: {
            landingPage: page,
            visitCount: 1
        }
    });
};

var sortAttribution = function sortAttribution(a, b) {
    if (a.time < b.time) {
        return 1;
    } else if (a.time > b.time) {
        return -1;
    }

    return 0;
};

var getAttribution = function getAttribution(type) {
    return localStorage.getItem(getStorageKey(type)) || [];
};

var setAttribution = function setAttribution(_ref4) {
    var type = _ref4.type,
        sourceAttribution = _ref4.sourceAttribution;

    var CAP = getCAP(type);
    sourceAttribution = sourceAttribution.sort(sortAttribution).slice(0, CAP);
    localStorage.setItem(getStorageKey(type), sourceAttribution);
};

var clearAttribution = function clearAttribution(type) {
    localStorage.deleteItem(getStorageKey(type));
};

var prepareToSave = function prepareToSave(element) {
    delete element.time;
    return element;
};

var addPage = function addPage(_ref5) {
    var type = _ref5.type,
        page = _ref5.page;

    var sourceAttribution = getAttribution(type);
    var index = sourceAttribution.findIndex(function (_ref6) {
        var landingPage = _ref6.utmParams.landingPage;
        return landingPage === page;
    });

    if (index > -1) {
        var attributionElement = sourceAttribution[index];
        var visitCount = attributionElement.utmParams.visitCount + 1;

        Object.assign(attributionElement, getDateTime());
        Object.assign(attributionElement.utmParams, { visitCount: visitCount });
    } else {
        var atribution = generateAttribution({ type: type, page: page });
        sourceAttribution.push(atribution);
    }

    setAttribution({ type: type, sourceAttribution: sourceAttribution });
};

var sourceAttributionHelper = {

    TYPE: {
        PRE_REGISTRATION_PAGE_VISIT: 'PRE_REGISTRATION_PAGE_VISIT'
    },

    saveHistory: function saveHistory(_ref7) {
        var type = _ref7.type;

        if (User.loggedIn()) {
            var userId = User.getUserId();
            var endpoint = serviceFetchWrappers.addTokenToUrl(endpoints.userSourceAttribution(userId));
            var sourceAttribution = getAttribution(type).map(prepareToSave);

            return serviceFetchWrappers.fetchWrapper(endpoint, serviceFetchWrappers.addHeaders({
                method: 'POST',
                body: JSON.stringify({ elementList: sourceAttribution })
            })).then(function () {
                return clearAttribution(type);
            });
        }

        return Promise.resolve();
    },
    trackPreRegistrationPageVisit: function trackPreRegistrationPageVisit() {
        if (!User.loggedIn()) {
            var type = this.TYPE.PRE_REGISTRATION_PAGE_VISIT;
            var page = windowCheck.location.pathname;
            addPage({ type: type, page: page });
        }
    }
};

module.exports = sourceAttributionHelper;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActiveHoldByBuyerId = exports.getActiveHold = exports.isRetailPriceHidden = exports.getNetPrice = exports.getSalePrice = exports.getRetailPrice = exports.getPrices = exports.isArt = exports.isJewelry = exports.isFashion = exports.isFurniture = exports.isSold = exports.isOnHold = exports.isUnavailable = exports.getDealerReference = exports.getUrl = exports.getUnavailableReasonCode = exports.getStatus = exports.getSellerId = exports.getProductName = exports.getPricing = exports.getItemId = exports.getHolds = exports.getGender = exports.getCreator = exports.getCondition = exports.getCategory = undefined;

var _lodash = __webpack_require__(652);

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsVerticalHelpers = __webpack_require__(373);

var _dibsVerticalHelpers2 = _interopRequireDefault(_dibsVerticalHelpers);

var _createSelector = __webpack_require__(490);

var _createSelector2 = _interopRequireDefault(_createSelector);

var _makeSelectorHelpers = __webpack_require__(651);

var _price = __webpack_require__(723);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getCategory = exports.getCategory = function getCategory(item) {
  return (0, _lodash2.default)(item, 'vertical');
};
var getCondition = exports.getCondition = function getCondition(item) {
  return (0, _lodash2.default)(item, 'condition.state');
};
var getCreator = exports.getCreator = function getCreator(item) {
  var creator = (0, _lodash2.default)(item, 'creators[0].creator', {});
  return creator.displayName || creator.name;
};
var getGender = exports.getGender = function getGender(item) {
  return (0, _lodash2.default)(item, 'classification.gender');
};
var getHolds = exports.getHolds = function getHolds(item) {
  return (0, _lodash2.default)(item, 'holds', []);
};
var getItemId = exports.getItemId = function getItemId(item) {
  return (0, _lodash2.default)(item, 'id') || (0, _lodash2.default)(item, 'serviceId');
};
var getPricing = exports.getPricing = function getPricing(item) {
  return (0, _lodash2.default)(item, 'pricing', {});
};
var getProductName = exports.getProductName = function getProductName(item) {
  return (0, _lodash2.default)(item, 'title');
};
var getSellerId = exports.getSellerId = function getSellerId(item) {
  return (0, _lodash2.default)(item, 'seller.id');
};
var getStatus = exports.getStatus = function getStatus(item) {
  return (0, _lodash2.default)(item, 'status');
};
var getUnavailableReasonCode = exports.getUnavailableReasonCode = function getUnavailableReasonCode(item) {
  return (0, _lodash2.default)(item, 'unavailableReasonCode');
};
var getUrl = exports.getUrl = function getUrl(item) {
  return (0, _lodash2.default)(item, 'pdpUrls[0]') || (0, _lodash2.default)(item, 'pdpURL') || '';
};
var getDealerReference = exports.getDealerReference = function getDealerReference(item) {
  return (0, _lodash2.default)(item, 'dealerReference') || '';
};

// Selectors
// ------------------------------------------

/**
 * @param {string} status to compare to on the passed-in item
 * @returns {function} selector that checks the status with whats on the
 *                      passed-in item
 */
var itemStatusCheckSelector = (0, _makeSelectorHelpers.makeEqualityCheckSelector)(getStatus);
var isUnavailable = exports.isUnavailable = itemStatusCheckSelector('UNAVAILABLE');

/**
 * @param {...string} all reason codes to compare against the unavailable reason
 *                      code actually on the item
 * @returns {function} selector that checks the reason code on the item against the
 *                      given reason codes
 */
var itemUnavailabilityCheckSelector = function itemUnavailabilityCheckSelector() {
  for (var _len = arguments.length, reasonCodes = Array(_len), _key = 0; _key < _len; _key++) {
    reasonCodes[_key] = arguments[_key];
  }

  return (0, _createSelector2.default)(isUnavailable, getUnavailableReasonCode, function (itemIsUnavailable, unavailableReasonCode) {
    return itemIsUnavailable && reasonCodes.indexOf(unavailableReasonCode) > -1;
  });
};
var isOnHold = exports.isOnHold = itemUnavailabilityCheckSelector('ON_HOLD', 'ON_HOLD_CUSTOM');
var isSold = exports.isSold = itemUnavailabilityCheckSelector('SOLD', 'SOLD_ON_PLATFORM');

/**
 * @param {string} category to compare to on the passed-in item
 * @returns {function} selector that checks the vertical of the item
 */
var itemCategoryCheckSelector = (0, _makeSelectorHelpers.makeEqualityCheckSelector)(getCategory);
var isFurniture = exports.isFurniture = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_FURNITURE);
var isFashion = exports.isFashion = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_FASHION);
var isJewelry = exports.isJewelry = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_JEWELRY);
var isArt = exports.isArt = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_ART);

/**
 * @param {object} item
 * @returns {array} prices (i.e. retail, sale, etc) for the item
 */
var getPrices = exports.getPrices = (0, _createSelector2.default)(getPricing, function (pricing) {
  return pricing.prices || [];
});

/**
 * @param {string} price type to get from pricing
 * @returns {function} selector that gets the passed in price type from
 *                      pricing data
 */
var pricingPriceTypeSelector = function pricingPriceTypeSelector(typeToCheck) {
  return (0, _createSelector2.default)(getPrices, function (prices) {
    return prices.find(function (_ref) {
      var type = _ref.type,
          status = _ref.status;
      return type === typeToCheck && status === 'ACTIVE';
    });
  });
};
var getRetailPrice = exports.getRetailPrice = pricingPriceTypeSelector('RETAIL');
var getSalePrice = exports.getSalePrice = pricingPriceTypeSelector('WEEKLY_SALE');
var getNetPrice = exports.getNetPrice = pricingPriceTypeSelector('NET');

/**
 * @param {object} item
 * @returns {boolean} true if retail price is hidden
 */
var isRetailPriceHidden = exports.isRetailPriceHidden = (0, _createSelector2.default)(getRetailPrice, _price.isPriceHidden);

/**
 * @param {object} item
 * @returns {?object} the active hold if there is one, undefined otherwise
 */
var getActiveHold = exports.getActiveHold = (0, _createSelector2.default)(getHolds, function (holds) {
  return holds.find(function (hold) {
    return hold.status === 'ACTIVE';
  });
});

/**
 * @param {object} item
 * @returns {function} function that if given a buyer id will return true/false if the buyer
 *                      owns the active hold
 */
var isActiveHoldByBuyerId = exports.isActiveHoldByBuyerId = (0, _createSelector2.default)(getActiveHold, function (hold) {
  return function (buyerId) {
    if (!buyerId) {
      return false;
    }
    return (0, _lodash2.default)(hold, 'buyer.id') === buyerId || (0, _lodash2.default)(hold, 'buyer.serviceId') === buyerId;
  };
});

/***/ }),
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Formally FavoriteDealer.js by Vincent Y
 *
 * Renamed and modified by liliana
 */



var $ = __webpack_require__(5);
var Backbone = __webpack_require__(3);
var template = __webpack_require__(443);
var tokenReplace = __webpack_require__(75);
var tracking = __webpack_require__(27);
var SV = __webpack_require__(17);
var copyText = __webpack_require__(380)();

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(40);
var favoriteCtaConnectToStoresHelper = __webpack_require__(595);
var FavoriteButton = __webpack_require__(560);
var FAVORITE_TRACKING = __webpack_require__(672);
var favoriteCtaCopy = SV.get('favoriteCta.messageCenter.cta');
var FavoriteModel = __webpack_require__(355);
var TYPE_DEALER = FavoriteModel.TYPE_DEALER;

var FavoriteButtonConnected = favoriteCtaConnectToStoresHelper({
    component: FavoriteButton,
    type: TYPE_DEALER
});
var FavoriteDealerView;

__webpack_require__(870);

FavoriteDealerView = module.exports = Backbone.BaseView.extend({
    model: new Backbone.AssociatedModel(),

    template: template.favoriteContactedDealer,

    className: 'email-success-wrapper',

    timeOut: 3000,

    events: {
        'mouseover': 'modalMouseOver',
        'mouseout': 'modalMouseOut',
        'click .no-thanks': function (e) {
            e.preventDefault();
            this._closeModal();
        },
        'click .bomtLink': function () {
            tracking.trackEvent(this._omtLinkParams);
        }
    },

    initialize: function (options) {
        options = options || {};
        this._dealerUrl = options.dealerUrl || SV.get('modalData.dealerUrl');
        this._dealerPk = options.dealerPk || SV.get('modalData.dealerPk');
        this._dealerName = options.dealerName || SV.get('modalData.dealerName');
        this._copyText = options.copyText || copyText.extend(SV.get('modalData.copy'));
        this._closeModal = options.closeModal || this.closeModal;
        this._openModal = options.openModal;
        this._followDealerParams = options.followDealerParams;
        this._omtLinkParams = options.omtLinkParams;
        this._offerSent = options.offerSent;
        this._holdRequestSent = options.holdRequestSent;
        this._componentContext = options.componentContext;
        this._isSaved = options.isSaved;
        this._isArtSeller = options.isArtSeller;
    },

    render: function () {
        FavoriteDealerView.__super__.render.apply(this, arguments);
        if (!this._isSaved) {
            ReactDOM.render(
                React.createElement(
                    'div',
                    {className: 'favorite-dealer-cta-wrapper is-hidden'},
                    React.createElement(FavoriteButtonConnected, {
                        context: this._componentContext,
                        className: 'button-medium button-primary favorite-dealer-cta add-favorite',
                        cta: favoriteCtaCopy,
                        favoriteData: {
                            type: TYPE_DEALER,
                            page: this._dealerUrl,
                            primaryKey: this._dealerPk
                        },
                        tracking: FAVORITE_TRACKING.DEALER.CONTACT_MODAL,
                        onClick: this._closeModal
                    })
                ), this.$('.favorite-dealer-cta-container')[0]
            );
        }

        this.$('.favorite-dealer-cta-wrapper, .favorite-dealer-info').removeClass('is-hidden');
        this.timeOut = 10000;

        this.model.set('showingFavDealerCtas', !this._isSaved);
        this.setModalTimeout(this.timeOut);
        this._openModal();
        return this;
    },
    templateVars: function () {
        var successMsg;
        var successSubtext = this._copyText.get('successInfoSubtext');
        if (this._holdRequestSent) {
            successMsg = this._copyText.get(this._isNetPrice ?
                'successMessageNetPriceHold' : 'successMessageHold');
        } else {
            successMsg = this._copyText.get(this._offerSent ?
                'successMessageOffer' : 'successMessage');
        }
        return {
            successMessage: tokenReplace(successMsg, {
                dealerName: this._dealerName
            }),
            successInfoSubtext: tokenReplace(successSubtext, {
                dealerType: this._isArtSeller ? 'gallery' : 'dealer'
            }),
            copy: this._copyText.get.bind(this._copyText)
        };
    },

    closeModal: function () {
        $.publish('modal:close');
    },

    setModalTimeout: function (interval) {
        this.modalTimeout = setTimeout(this._closeModal, interval || 5000);
    },

    modalMouseOver: function () {
        clearTimeout(this.modalTimeout);
    },

    modalMouseOut: function () {
        clearTimeout(this.modalTimeout);
        this.setModalTimeout();
    }
});


/***/ }),
/* 830 */,
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 12/22/14
 * Time: 4:45 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var $ = __webpack_require__(5);
var indexOf = __webpack_require__(917);
var Backbone = __webpack_require__(3);
var templates = __webpack_require__(914);
var tracking = __webpack_require__(27);

var LIST_NAME = 'recent items history';
// duplicate ref in FindingProductTracking
var ECOM_TYPE_CLICK = 'productClick';
var ECOM_TYPE_IMRESSION = 'productImpression';

__webpack_require__(722);

module.exports = Backbone.BaseView.extend({
    tagName: 'ul',
    className: 'recent-history-list rowFlexTransition',
    events: {
        'click .recent-history-item': 'trackItemClick'
    },
    initialize: function () {
    },
    trackItemClick: function (e) {
        var $this = $(e.currentTarget);
        var itemIndex = this.getItemIndex(e.currentTarget);
        var eventObj = {
            category: "Results Page Filters and Actions",
            action: "recent history sidebar - click to pdp",
            label: itemIndex
        };
        tracking.trackEvent(eventObj);

        // Tracking for google tag manager productClick
        this.trackEcommerce(ECOM_TYPE_CLICK, this.getTrackProduct($this), LIST_NAME);
    },
    /**
     *
     * @param {string|jQuery object} $el
     * @returns {*}
     */
    getItemTitle: function ($el) {
        var titleCheck = 'at 1stdibs';
        var title = $el;
        if ($el instanceof $) {
            title = $el.attr('title') || $el.find('img').attr('title');
        }
        if (title.indexOf(titleCheck) > -1) {
            title = $.trim(title.split(titleCheck)[0]);
        }
        return title;
    },
    /**
     * tracks the google tag manager ecommerce impression for recent history items
     * @param e
     * @param items
     */
    trackImpression: function () {
        var self = this;
        var $listEl = self.$('.recent-history-item');
        var products = [];
        $.each($listEl, function (index, el) {
            products.push(self.getTrackProduct($(el), LIST_NAME));
        });
        this.trackEcommerce(ECOM_TYPE_IMRESSION, products);
    },
    /**
     * takes a list item (li) and returns an product object for google tag manager to track
     * @param {jQuery} $el
     * @param {string} [list]
     */
    getTrackProduct : function ($el, list) {
        var $anchor = $el.find('.recent-history-link');
        var dealerPk = $anchor.data('dealerpk');
        var name = this.getItemTitle($el);
        var product = {
            url : $anchor.attr('href'),
            position : $el.index() + 1
        };
        if (name) {
            product.name = name;
        }
        if (dealerPk) {
            product.brand = dealerPk;
        }
        if (list) {
            product.list = list;
        }
        return product;
    },
    /**
     * @param {string} type
     * @param {array|object} products
     * @param {string} [list]
     */
    trackEcommerce : function (type, products, list) {
        tracking.trackEcommerce({
            type : type,
            products : Array.isArray(products) ? products : [products],
            actionField : {
                list : list
            }
        });
    },
    getItemIndex: function (item) {
        var items = this.$(".recent-history-item");
        return item ? [indexOf(items, item) + 1, "/", items.length].join("") : 0;
    },
    getImageUrl: function (obj) {
        // switching data to use camelCase properties
        // but there are still under_scored ones
        var ret;
        if (obj) {
            if (obj.itemImageUrl) {
                ret = obj.itemImageUrl.src || obj.itemImageUrl;
            } else if (obj.item_image_url) {
                ret = obj.item_image_url.src || obj.item_image_url;
            }
        }
        return ret;
    },
    formatAttributes: function (attrs) {
        return {
            url: attrs.itemPdpUrl || attrs.item_pdp_url,
            imageUrl: this.getImageUrl(attrs),
            title: attrs.itemTitle || attrs.item_title,
            dealerPk: attrs.dealerPk
        };
    },
    render: function () {
        this.$el.empty();

        this.collection.each(function (model) {
            var attrs = this.formatAttributes(model.toJSON());
            attrs.additionalClasses = 'colXs12 colLg12';

            this.$el.append(templates.tmplRecentHistoryItem(attrs));
        }, this);

        // Tracking for google tag manager productClick
        this.trackImpression();
        return this;
    }
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 12/22/14
 * Time: 7:30 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */


var Backbone = __webpack_require__(3);
var headerStr = 'YOUR RECENT HISTORY';

module.exports = Backbone.BaseView.extend({
    className: "recent-history-title",
    render: function () {
        this.$el.html(headerStr);
        return this;
    }
});

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 12/22/14
 * Time: 4:54 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var $ = __webpack_require__(5);
var Backbone = __webpack_require__(3);
var RecentHistoryTitleView = __webpack_require__(832);
var RecentHistoryListView = __webpack_require__(831);
var targetEl = '#mainFacets';

module.exports = Backbone.BaseView.extend({

    className: 'recent-history-wrap',

    subViewConfig: {
        header: {
            singleton: true,
            construct: RecentHistoryTitleView
        },
        list: {
            singleton: true,
            construct: RecentHistoryListView
        }
    },

    initialize: function (options) {
        options = options || {};
        // vertical or horizontal, only vertical is used at the moment
        var orientationClass = 'is-' + (options.orientation || 'vertical');
        this.$el.addClass(orientationClass + ' facet-nav-content');
        this.subs.add({
            header: {},
            list: {
                collection: options.listCollection
            }
        });

        if (options.targetEl) {
            targetEl = options.targetEl;
        }

    },

    render: function () {
        var $target = $(targetEl);
        if ($target.length) {
            this.subs.renderAppend(this.$el);
            this.$el.insertAfter($target);
        }
        return this;
    }
});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 12/22/14
 * Time: 5:17 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

var $ = __webpack_require__(5);
var _ = __webpack_require__(23);
var Backbone = __webpack_require__(3);
var _localStorage = __webpack_require__(280).localStorage;
var DC = __webpack_require__(455);
var SV = __webpack_require__(17);
var uriHelper = __webpack_require__(640);
var RecentHistoryWrapperView = __webpack_require__(833);
var KEY = "recent_history_list";
var COUNT_KEY = "recent_history_count";
var queryParamWhiteList = ['cur_tab'];
var MAX_ITEMS = 6;
var MAX_DAYS = 30;
var daysBetween;
var getItemId;
var isCurrentItem;
var getUrlParams;
var getPdpUrl;
var isPdp;
var isSuspended;
var isAllowed;
var getList;
var addItem;
var renderList;

__webpack_require__(722);

/**
 *
 * calculate days between two given timestamps
 * @param  {number} timestamp1  timestamp in ms, ie 1392139288947
 * @param  {number} timestamp2
 * @return {Number} rounded difference in days
 */
daysBetween = function (timestamp1, timestamp2) {
    var msDiff = Math.abs(timestamp1 - timestamp2);
    var oneDayInMs = 86400000; // 24h/d * 60m/h * 60s/m * 1000ms/s
    return Math.round(msDiff / oneDayInMs);
};
getItemId = function (item) {
    // switching data to use camelCase properties
    // but there are still under_scored ones
    return item.itemId || item.item_id;
};
isCurrentItem = function (item, currentItem) {
    var itemId = getItemId(item);
    var curItemId;
    if (currentItem) {
        curItemId = currentItem.itemId || currentItem.item_id;
    }
    return itemId === curItemId;
};

/**
 * checks for any whitelisted query params to add back to the item URI
 * @returns {string}
 */
getUrlParams = function () {
    var queryKey = uriHelper.URL.queryKey;
    var result = [];

    _.each(queryParamWhiteList, function (key) {
        if (queryKey[key]) {
            result.push(key + '=' + queryKey[key]);
        }
    });

    if (result.length) {
        return '?' + result.join('&');
    }
    return '';
};

/**
 * TRANACT-2207 return a url for PDP pages with whitelisted param, if applicable
 *
 * @returns {string}
 */
getPdpUrl = function () {
    var params = getUrlParams();
    return uriHelper.URL.path + params;
};

/**
 * is the user on a pdp?
 * @returns {boolean}
 */
isPdp = function () {
    return SV.data && SV.data.pdp;
};
/**
 *
 * @param {object} itemData Item data from the server, NOT the inventory item model
 * @returns {boolean}
 */
isSuspended = function (itemData) {
    // TRANACT-2007 filtered out deleted/unpublished/dealer suspended items from the list
    // these `itemData[prop]` values come from php
    return itemData && (itemData.isDeleted || itemData.isUnpublished || itemData.isDealerSuspended);
};
/**
 * Is the item allowed to be put into the recent history stack?
 * @param {object} item The
 * @param {object} [currentItem]
 * @returns {boolean}
 */
isAllowed = function (item, currentItem) {
    // original logic: (daysBetween(itemTimestamp, _now) >= 30 || (currentItem && currentItem.itemId === itemId))
    var _now = currentItem ? currentItem.timestamp : new Date().getTime();
    return daysBetween(item.timestamp, _now) >= MAX_DAYS || isCurrentItem(item, currentItem);
};
/**
 * return the list without the item(s) that is: >30 days old || already in the list || falsey value
 * @param  {Array} historyList    the history list, optional
 * @param  {Number} currentItem item id, will NOT perform uniqueness check if not given
 * @return {Array}
 */
getList = function (historyList, currentItem) {
    var recentHistoryList = historyList || _localStorage.getItem(KEY);
    var itemCount;

    _.each(recentHistoryList, function (item, index) {
        if (isAllowed(item, currentItem)) {
            recentHistoryList[index] = null;
        }
    });

    // remove falsey element(s) in the list
    // how can anything be falsy in this case?
    recentHistoryList = _.compact(recentHistoryList);

    itemCount = recentHistoryList.length;
    while (itemCount > MAX_ITEMS) {
        recentHistoryList = recentHistoryList.slice(1, itemCount);
        itemCount--;
    }

    _localStorage.setItem(COUNT_KEY, recentHistoryList.length);
    return recentHistoryList;
};
/**
 * Add an item to the user's localStorage object
 * @param {object} itemData
 * @param {string} itemData.smallImage The item image
 * @param {string} [itemData.pk] The item pk
 * @returns {*}
 */
addItem = function (itemData) {
    var _now;
    var storedList;
    var recentHistoryList;
    var currentItem;

    if (isSuspended(itemData) || !itemData.smallImage) {
        // TRANACT-2007 add to the list only if it is not suspended
        return false;
    }

    _now = new Date();
    storedList = _localStorage.getItem(KEY);
    recentHistoryList = storedList || [];
    currentItem = {
        itemTitle: itemData.titleCondensed || itemData.title || document.title,
        itemId: itemData.pk || "",
        itemImageUrl: itemData.smallImage,
        itemPdpUrl: getPdpUrl(),
        dealerPk: itemData.dealerPk,
        timestamp: _now.getTime(),
        lastVisited: _now
    };

    recentHistoryList = getList(recentHistoryList, currentItem);
    recentHistoryList.push(currentItem);

    return _localStorage.setItem(KEY, JSON.stringify(recentHistoryList));
};
renderList = function (targetEl) {
    // on Seach & Browse
    var cleanedList = getList();
    var collectionView;

    if (!isPdp() && cleanedList.length) {
        // only render this view on a non-pdp
        collectionView = new RecentHistoryWrapperView({
            listCollection: new Backbone.Collection(cleanedList.reverse()),
            targetEl: targetEl || null
        });
        collectionView.render();
    }
};

module.exports = {
    // for testing purposes
    MAX_DAYS: MAX_DAYS,
    MAX_ITEMS: MAX_ITEMS,
    STORAGE_KEY: KEY,
    COUNT_KEY: COUNT_KEY,
    addItem: addItem,
    daysBetween: daysBetween,
    getList: getList,
    renderList: renderList,
    clearList: function () {
        _localStorage.deleteItem(KEY);
        _localStorage.deleteItem(COUNT_KEY);
    }
};

$(function () {
    if (isPdp()) {
        // on PDP
        addItem(SV.data);
        return;
    }
    $.publish("recentHistory:render");
});

$.subscribe('recentHistory:render ' + DC.pageEventPrefix + ':updated', function () {
    renderList();
});



/***/ }),
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(841);
module.exports = __webpack_require__(794).Object.getPrototypeOf;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(1152)
  , $getPrototypeOf = __webpack_require__(372);

__webpack_require__(933)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(659);
var validation = __webpack_require__(843);
var messages = __webpack_require__(660);
var addressFields = constants.fields;
var addressOptionalFields = constants.optionalFields;

function getOptionalFields (options) {
    var optionalFields = [];
    if (!options.isCountryUS) {
        optionalFields.push(constants.FIELDS.FIELD_STATE);
    }
    if (!options.isPhoneRequired) {
        optionalFields.push(constants.FIELDS.FIELD_PHONE_NUMBER);
    }
    return addressOptionalFields.concat(optionalFields);
}

function getErrorMessage (field, address, options) {
    var value = address[field];
    var isRequired = !getOptionalFields(options).includes(field);
    var validationRules = validation.rules[field] ? validation.rules[field](address, options) : [];
    var failedRules = !!value ? validationRules.filter(function(rule) {
        return !rule.isValid;
    }) : [];

    return failedRules.length ?
        failedRules[0].message :
        isRequired && !value && messages.required;
}

/**
 * Return an Object with two properties: errors and isValid:
 * errors (Object): field name and error message (Example -> { firstName: "Required field", line1: "Item may not ship to PO Box" })
 * isValid (Boolean): check if the address has any errors
 * @param address (Object): field names and values
 * @param options (Object): can except one of the following keys:
 * fields (Array) - custom list of fields to validate
 * allowPOBox (Boolean) - default: false
 * allowLongUSZipCode (Boolean) - default: true
 * isPhoneRequired (Boolean) - default: true
 */
function validate (_address, _options) {
    var address = _address || {};
    var options = Object.assign({}, validation.defaultOptions, _options || {}, {
        isCountryUS: address.country === 'US'
    });
    var errors = (options.fields || addressFields).reduce(function(_errors, field) {
        var message = getErrorMessage(field, address, options);
        if (message) {
            _errors[field] = message;
        }
        return _errors;
    }, {});

    return {
        errors: errors,
        isValid: !Object.keys(errors).length
    };
}

module.exports = validate;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var messages = __webpack_require__(660);
var regexMap = __webpack_require__(659).regexMap;

var defaultOptions = {
    allowPOBox: false,
    allowLongUSZipCode: true,
    isPhoneRequired: true
};

var rules = {
    firstName: function (address) {
        return [{
            isValid: !regexMap.specialCharacters.test(address.firstName),
            message: messages.specialCharactersShort
        }];
    },
    lastName: function (address) {
        return [{
            isValid: !regexMap.specialCharacters.test(address.lastName),
            message: messages.specialCharactersShort
        }];
    },
    country: function (address) {
        return [{
            isValid: !regexMap.specialCharacters.test(address.country),
            message: messages.specialCharacters
        }];
    },
    line1: function (address, options) {
        return [{
            isValid: !regexMap.specialCharactersAddress.test(address.line1),
            message: messages.specialCharactersAddress
        }, {
            isValid: !regexMap[options.allowPOBox ? 'all' : 'poBox'].test(address.line1),
            message: messages[options.allowPOBox ? '' : 'poBox']
        }];
    },
    line2: function (address, options) {
        return [{
            isValid: !regexMap.specialCharactersAddress.test(address.line2),
            message: messages.specialCharactersAddress
        }, {
            isValid: !regexMap[options.allowPOBox ? 'all' : 'poBox'].test(address.line2),
            message: messages[options.allowPOBox ? '' : 'poBox']
        }];
    },
    city: function (address) {
        return [{
            isValid: !regexMap.specialCharacters.test(address.city),
            message: messages.specialCharactersShort
        }];
    },
    state: function (address) {
        return [{
            isValid: !regexMap.specialCharacters.test(address.state),
            message: messages.specialCharactersAddress
        }];
    },
    zipCode: function (address, options) {
        return [{
            isValid: !regexMap[options.isCountryUS ? (options.allowLongUSZipCode ? 'usZipCode' : 'usZipCodeShort') : 'globalZipCode'].test(address.zipCode),
            message: messages[options.isCountryUS ? (options.allowLongUSZipCode ? 'usZipCodeShipping' : 'usZipCodeShort') : 'globalZipCode']
        }];
    }
};

module.exports = {
    defaultOptions: defaultOptions,
    rules: rules
};


/***/ }),
/* 844 */,
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(661);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'button': 'Secondary__button___183vh',
  'small': 'Secondary__small___1JjIL',
  'medium': 'Secondary__medium___2PQuO',
  'large': 'Secondary__large___eBhCW'
};

var SecondaryButton = (0, _mergeThemeHoc2.default)(style)(_Button2.default);
SecondaryButton.displayName = 'SecondaryButton';
exports.default = SecondaryButton;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(853);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'hiddenInput': 'Default__hiddenInput___3fGAk',
  'container': 'Default__container___2viz_',
  'checkboxUnchecked': 'Default__checkboxUnchecked___2TvQ-',
  'checkbox': 'Default__checkbox___2gFBy',
  'checkboxChecked': 'Default__checkboxChecked___3pdpQ',
  'checkmark': 'Default__checkmark___ApF0J',
  'label': 'Default__label___2_a4i'
};

var DefaultCheckbox = (0, _mergeThemeHoc2.default)(style)(_Checkbox2.default);
DefaultCheckbox.displayName = 'DefaultCheckbox';
exports.default = DefaultCheckbox;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DurationSelect = __webpack_require__(854);

var _DurationSelect2 = _interopRequireDefault(_DurationSelect);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'expirationSelect': 'Default__expirationSelect___E80hx',
  'arrow': 'Default__arrow___1DJV2',
  'expirationLabel': 'Default__expirationLabel___lM6Eb'
};

var DefaultDurationSelect = (0, _mergeThemeHoc2.default)(style)(_DurationSelect2.default);
DefaultDurationSelect.displayName = 'DefaultDurationSelect';
exports.default = DefaultDurationSelect;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalBackButton = __webpack_require__(855);

var _ModalBackButton2 = _interopRequireDefault(_ModalBackButton);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'backButtonClickableArea': 'Default__backButtonClickableArea___20Pmi',
  'backIcon': 'Default__backIcon___30oHQ',
  'backButtonDisabled': 'Default__backButtonDisabled___3UhhH'
};

var DefaultModalBackButton = (0, _mergeThemeHoc2.default)(style)(_ModalBackButton2.default);
DefaultModalBackButton.displayName = 'DefaultModalBackButton';
exports.default = DefaultModalBackButton;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalBody = __webpack_require__(856);

var _ModalBody2 = _interopRequireDefault(_ModalBody);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'modalBody': 'Default__modalBody___2EzQf'
};

var DefaultModalBody = (0, _mergeThemeHoc2.default)(style)(_ModalBody2.default);
DefaultModalBody.displayName = 'DefaultModalBody';
exports.default = DefaultModalBody;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = __webpack_require__(860);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'tabs': 'Default__tabs___1Ur8h',
  'tab': 'Default__tab___1-pJG',
  'tabItem': 'Default__tabItem___xh5Kp',
  'active': 'Default__active___1EPBD',
  'collapsed': 'Default__collapsed___VOgGk'
};

var DefaultTabs = (0, _mergeThemeHoc2.default)(style)(_Tabs2.default);
DefaultTabs.displayName = 'DefaultTabs';
exports.default = DefaultTabs;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Well = __webpack_require__(861);

var _Well2 = _interopRequireDefault(_Well);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__(288);

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'well': 'Default__well___-PRFz',
  'label': 'Default__label___2_a4i'
};

var DefaultWell = (0, _mergeThemeHoc2.default)(style)(_Well2.default);
DefaultWell.displayName = 'DefaultWell';
exports.default = DefaultWell;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BarHeader = function BarHeader(props) {
    var title = props.title,
        subtitle = props.subtitle,
        theme = props.theme;


    if (!theme) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: theme.headerWrapper },
        _react2.default.createElement(
            'div',
            { className: theme.title },
            title
        ),
        subtitle && _react2.default.createElement(
            'div',
            { className: theme.subtitle },
            subtitle
        ),
        _react2.default.createElement('div', { className: theme.bottomBorder })
    );
};

exports.default = BarHeader;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(552);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(531);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(553);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(602);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(601);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _checkmark = __webpack_require__(448);

var _checkmark2 = _interopRequireDefault(_checkmark);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function (_React$Component) {
    (0, _inherits3.default)(Checkbox, _React$Component);

    function Checkbox(props) {
        (0, _classCallCheck3.default)(this, Checkbox);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call(this, props));

        _this.state = {
            checked: _this.props.checked
        };

        _this._onChange = _this._onChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Checkbox, [{
        key: '_onChange',
        value: function _onChange(e) {
            var onChange = this.props.onChange;

            var _ref = e && e.target,
                checked = _ref.checked;

            if (typeof checked === 'boolean') {
                this.setState({
                    checked: checked
                });

                if (onChange) {
                    onChange(checked);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                wrapperClass = _props.wrapperClass,
                labelClass = _props.labelClass,
                name = _props.name,
                label = _props.label,
                _props$theme = _props.theme,
                theme = _props$theme === undefined ? {} : _props$theme;
            var checked = this.state.checked;

            return _react2.default.createElement(
                'div',
                { className: wrapperClass },
                _react2.default.createElement('input', {
                    id: name,
                    name: name,
                    type: 'checkbox',
                    className: theme.hiddenInput,
                    checked: checked,
                    onChange: this._onChange
                }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: name, className: theme.container },
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)(theme.checkbox, checked ? theme.checkboxChecked : theme.checkboxUnchecked) },
                        checked ? _react2.default.createElement(_checkmark2.default, { className: theme.checkmark }) : null
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)(theme.label, labelClass) },
                        label
                    )
                )
            );
        }
    }]);
    return Checkbox;
}(_react2.default.Component);

exports.default = Checkbox;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(552);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(531);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(553);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(602);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(601);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _arrowDown = __webpack_require__(606);

var _arrowDown2 = _interopRequireDefault(_arrowDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DurationSelect = function (_Component) {
    (0, _inherits3.default)(DurationSelect, _Component);

    function DurationSelect(props) {
        (0, _classCallCheck3.default)(this, DurationSelect);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DurationSelect.__proto__ || (0, _getPrototypeOf2.default)(DurationSelect)).call(this, props));

        _this.setOptionElements = _this.setOptionElements.bind(_this);
        _this.setOptionElements(props.durations);
        return _this;
    }

    (0, _createClass3.default)(DurationSelect, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var durations = nextProps.durations;

            if (durations !== this.props.durations) {
                this.setOptionElements(durations);
            }
        }
    }, {
        key: 'setOptionElements',
        value: function setOptionElements(durations) {
            this._optionElements = durations.map(function (days) {
                var text = void 0;
                if (days === -1) {
                    text = 'no expiration';
                } else {
                    text = days + ' ' + (days === 1 ? 'day' : 'days');
                }
                return _react2.default.createElement(
                    'option',
                    { key: days, value: days },
                    text
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var theme = this.props.theme;

            return theme ? _react2.default.createElement(
                'label',
                { className: theme.expirationLabel },
                this.props.label,
                _react2.default.createElement(_arrowDown2.default, { className: theme.arrow }),
                _react2.default.createElement(
                    'select',
                    {
                        name: this.props.name,
                        className: theme.expirationSelect,
                        value: this.props.value,
                        disabled: this.props.disabled,
                        onChange: function onChange(e) {
                            return _this2.props.onChange(parseInt(e.target.value));
                        }
                    },
                    this._optionElements
                )
            ) : null;
        }
    }]);
    return DurationSelect;
}(_react.Component);

exports.default = DurationSelect;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(532);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _arrowLeft = __webpack_require__(352);

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _classnames2 = __webpack_require__(132);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBackButton = function ModalBackButton(props) {
    var theme = props.theme,
        className = props.className,
        onClick = props.onClick,
        disabled = props.disabled;

    if (!theme) {
        return null;
    }

    var wrapperClass = (0, _classnames3.default)(theme.backButtonClickableArea, className, (0, _defineProperty3.default)({}, theme.backButtonDisabled, disabled));

    return _react2.default.createElement(
        'div',
        { className: wrapperClass, onClick: disabled ? function () {} : onClick },
        _react2.default.createElement(
            'div',
            { className: theme.backIcon },
            _react2.default.createElement(_arrowLeft2.default, null)
        )
    );
};

exports.default = ModalBackButton;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBody = function ModalBody(props) {
    var theme = props.theme,
        className = props.className,
        children = props.children;

    if (!theme) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(theme.modalBody, className) },
        children
    );
};

exports.default = ModalBody;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(532);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _close = __webpack_require__(276);

var _close2 = _interopRequireDefault(_close);

var _classnames2 = __webpack_require__(132);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalCloseButton = function ModalCloseButton(props) {
    var theme = props.theme,
        className = props.className,
        onClick = props.onClick,
        disabled = props.disabled;

    if (!theme) {
        return null;
    }

    var wrapperClass = (0, _classnames3.default)(theme.closeClickableArea, className, (0, _defineProperty3.default)({}, theme.closeButtonDisabled, disabled));

    return _react2.default.createElement(
        'div',
        { className: wrapperClass, onClick: disabled ? function () {} : onClick },
        _react2.default.createElement(
            'div',
            { className: theme.closeIcon },
            _react2.default.createElement(_close2.default, null)
        )
    );
};

exports.default = ModalCloseButton;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(532);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(552);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(531);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(553);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(602);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(601);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactPortal = __webpack_require__(930);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _elementClass = __webpack_require__(449);

var _elementClass2 = _interopRequireDefault(_elementClass);

var _classnames3 = __webpack_require__(132);

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTest = 'production' === 'test';

var ModalContainer = function (_Component) {
    (0, _inherits3.default)(ModalContainer, _Component);

    function ModalContainer(props) {
        (0, _classCallCheck3.default)(this, ModalContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ModalContainer.__proto__ || (0, _getPrototypeOf2.default)(ModalContainer)).call(this, props));

        _this.handleKeydown = _this.handleKeydown.bind(_this);
        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        _this.openModal = _this.openModal.bind(_this);
        _this.endCloseAnimation = _this.endCloseAnimation.bind(_this);
        _this.timeouts = [];
        _this.state = {
            modalOpened: false,
            animation: null
        };
        return _this;
    }

    (0, _createClass3.default)(ModalContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.isOpen && !this.state.modalOpened) {
                this.openModal();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isOpen && !this.state.modalOpened) {
                this.openModal();
            } else if (!nextProps.isOpen && this.state.modalOpened) {
                this.closeModal();
            };
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
            var _props = this.props,
                theme = _props.theme,
                appendToBody = _props.appendToBody;

            if (theme && appendToBody) {
                (0, _elementClass2.default)(document.body).remove(theme.stopBodyScroll);
            }
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            this.timeouts.forEach(clearTimeout);
        }
    }, {
        key: 'openModal',
        value: function openModal() {
            var _this2 = this;

            var _props2 = this.props,
                closeOnEsc = _props2.closeOnEsc,
                theme = _props2.theme,
                appendToBody = _props2.appendToBody,
                animates = _props2.animates,
                onOpen = _props2.onOpen;


            if (closeOnEsc) {
                document.addEventListener('keydown', this.handleKeydown);
            }

            if (theme && appendToBody) {
                (0, _elementClass2.default)(document.body).add(theme.stopBodyScroll);
            }

            if (onOpen) {
                onOpen();
            }

            if (animates) {
                this.setState({
                    modalOpened: true
                }, function () {
                    _this2.timeouts.push(setTimeout(function () {
                        return _this2.setState({ animation: "opening" });
                    }, 10));
                });
            } else {
                this.setState({
                    modalOpened: true
                });
            }
        }
    }, {
        key: 'endCloseAnimation',
        value: function endCloseAnimation() {
            this.setState({ modalOpened: false, animation: null });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            var _this3 = this;

            var _props3 = this.props,
                closeOnEsc = _props3.closeOnEsc,
                theme = _props3.theme,
                appendToBody = _props3.appendToBody,
                animates = _props3.animates;

            if (closeOnEsc) {
                document.removeEventListener('keydown', this.handleKeydown);
            }

            if (theme && appendToBody) {
                (0, _elementClass2.default)(document.body).remove(theme.stopBodyScroll);
            }

            if (animates && this.state.modalOpened) {
                this.setState({
                    animation: "closing"
                }, function () {
                    _this3.timeouts.push(setTimeout(_this3.endCloseAnimation, 300));
                });
            } else {
                this.setState({
                    modalOpened: false
                });
            }
        }
    }, {
        key: 'handleKeydown',
        value: function handleKeydown(e) {
            switch (e.key) {
                case "Escape":
                    if (this.props.closeOnEsc) {
                        this.props.onClose();
                    };
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'handleOutsideClick',
        value: function handleOutsideClick() {
            var _props4 = this.props,
                closeOnOutsideClick = _props4.closeOnOutsideClick,
                onClose = _props4.onClose;

            if (closeOnOutsideClick) {
                onClose();
            }
        }
    }, {
        key: 'handleInsideClick',
        value: function handleInsideClick(e) {
            e.stopPropagation();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props5 = this.props,
                onClose = _props5.onClose,
                animates = _props5.animates,
                overlayClass = _props5.overlayClass,
                modalClass = _props5.modalClass,
                children = _props5.children,
                dataTn = _props5.dataTn,
                modalPosition = _props5.modalPosition,
                modalSize = _props5.modalSize,
                theme = _props5.theme,
                appendToBody = _props5.appendToBody;
            var _state = this.state,
                modalOpened = _state.modalOpened,
                animation = _state.animation;


            if (!theme) {
                return null;
            }

            var overlayClasses = (0, _classnames4.default)(theme.overlayDefault, (_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.overlayFadeStart, animates), (0, _defineProperty3.default)(_classnames, theme.overlayDefaultOpening, animates && animation === "opening"), (0, _defineProperty3.default)(_classnames, theme.overlayDefaultClosing, animates && animation === "closing"), _classnames), overlayClass);

            var modalClasses = (0, _classnames4.default)(theme.modalDefault, (_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, theme.modalMedium, modalSize === 'medium'), (0, _defineProperty3.default)(_classnames2, theme.modalLarge, modalSize === 'large'), (0, _defineProperty3.default)(_classnames2, theme.modalHeightCenter, modalPosition === 'center'), _classnames2), modalClass);

            var modal = _react2.default.createElement(
                'div',
                { onClick: this.handleOutsideClick, id: 'ModalOverlay', className: overlayClasses },
                _react2.default.createElement(
                    'div',
                    {
                        id: 'Modal',
                        onClick: this.handleInsideClick,
                        className: modalClasses,
                        'data-tn': dataTn
                    },
                    children
                )
            );
            if (appendToBody) {
                return _react2.default.createElement(
                    _reactPortal2.default,
                    {
                        isOpened: modalOpened,
                        onClose: onClose,
                        closeOnOutsideClick: false,
                        closeOnEsc: false
                    },
                    modal
                );
            }

            return modal;
        }
    }]);
    return ModalContainer;
}(_react.Component);

ModalContainer.defaultProps = {
    animates: true,
    closeOnEsc: true,
    closeOnOutsideClick: true,
    modalPosition: 'top',
    modalSize: 'default',
    appendToBody: isTest ? false : true
};
;

exports.default = ModalContainer;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(646);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(657);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(333);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Simplified interface to react-select with styling
 */
var Select = function Select(props) {
    var theme = props.theme,
        selectProps = (0, _objectWithoutProperties3.default)(props, ['theme']);

    return _react2.default.createElement(_reactSelect2.default, (0, _extends3.default)({}, selectProps, {
        clearable: false,
        searchable: false,
        className: theme && theme.select
    }));
};

Select.displayName = 'Select';

exports.default = Select;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(532);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tabs = function Tabs(_ref) {
    var activeTabIndex = _ref.activeTabIndex,
        activeTabClassName = _ref.activeTabClassName,
        collapsed = _ref.collapsed,
        containerClassName = _ref.containerClassName,
        onKeyDownTab = _ref.onKeyDownTab,
        onSelectTab = _ref.onSelectTab,
        tabClassName = _ref.tabClassName,
        tabLabels = _ref.tabLabels,
        theme = _ref.theme;

    var style = theme;
    return style ? _react2.default.createElement(
        'ul',
        { className: (0, _classnames2.default)(style.tabs, containerClassName, (0, _defineProperty3.default)({}, style.collapsed, collapsed)) },
        tabLabels.map(function (tabLabel, index) {
            var active = activeTabIndex === index;
            var finalTabClassName = (0, _classnames2.default)(style.tab, (0, _defineProperty3.default)({}, (0, _classnames2.default)(style.active, activeTabClassName), active), tabClassName);
            return _react2.default.createElement(
                'li',
                {
                    className: finalTabClassName,
                    key: [index, tabLabel].join('_'),
                    role: 'tablist'
                },
                _react2.default.createElement(
                    'a',
                    {
                        className: style.tabItem,
                        'aria-selected': active ? 'true' : 'false',
                        onClick: onSelectTab ? onSelectTab(index) : undefined,
                        onKeyDown: onKeyDownTab ? onKeyDownTab(index) : undefined,
                        onFocus: onSelectTab ? onSelectTab(index) : undefined,
                        role: 'tab'
                    },
                    tabLabel
                )
            );
        })
    ) : null;
};

exports.default = Tabs;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(132);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Well = function Well(_ref) {
    var className = _ref.className,
        children = _ref.children,
        label = _ref.label,
        labelClassName = _ref.labelClassName,
        theme = _ref.theme;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('clearfix', className, theme && theme.well) },
        label && _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(labelClassName, theme && theme.label) },
            label
        ),
        children
    );
};

exports.default = Well;

/***/ }),
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalHeader":"successModal__modalHeader__1RSwy","modalBody":"successModal__modalBody__3n4jk","modalContent":"successModal__modalContent__8MaNA"};

/***/ }),
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 6/17/16.
 */



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

// Stores
var UserStore = __webpack_require__(109);
var PriceStore = __webpack_require__(367);
var ItemStore = __webpack_require__(336);

// Components
var FormattedPrice = __webpack_require__(636);

// Helpers
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);

var _require = __webpack_require__(673),
    calculatePercentageOff = _require.calculatePercentageOff;

var pageTypes = __webpack_require__(383);
var classnames = __webpack_require__(16);

// Styles
var styles = __webpack_require__(805);

var classesMap = {
    net: 'price-net ' + styles.net,
    retail: 'price-retail ' + styles.retail
};

// don't conflate this with classes
// since classes can be more fluid
var dataTnNames = {
    net: 'net-price',
    retail: 'retail-price'
};

function getTestName(pageType, type) {
    var tn = dataTnNames[type] || '';
    if (tn) {
        return pageType + '-' + tn;
    } else if (pageType && type) {
        return pageType + '-' + type;
    }
    return type;
}

var PriceComponent = function PriceComponent(props) {
    var currency = props.currency,
        retailPrice = props.retailPrice,
        netPrice = props.netPrice,
        _props$copy = props.copy,
        copy = _props$copy === undefined ? {} : _props$copy,
        isSoldIndividually = props.isSoldIndividually,
        type = props.type,
        priceDisplays = props.priceDisplays,
        _props$pageType = props.pageType,
        pageType = _props$pageType === undefined ? 'pdp' : _props$pageType,
        _props$showPriceTypeC = props.showPriceTypeCopy,
        showPriceTypeCopy = _props$showPriceTypeC === undefined ? true : _props$showPriceTypeC;

    var _ref = copy || {},
        priceStates = _ref.priceStates;

    var priceCopy = priceStates[type + 'Price'] || '';
    var price = type === 'retail' ? retailPrice : netPrice;
    var testName = getTestName(pageType, type);
    var wrappingClass = classesMap[type];
    var classes = classnames(wrappingClass, 'notranslate', _defineProperty({}, styles.hasNetPrice, priceDisplays.showNetPrice));
    return React.createElement(
        'div',
        { className: classes, 'data-tn': testName },
        React.createElement(FormattedPrice, {
            copy: copy,
            priceDisplays: priceDisplays,
            isSoldIndividually: isSoldIndividually,
            price: price,
            currency: currency,
            type: type
        }),
        showPriceTypeCopy ? ' ' + priceCopy : false
    );
};

PriceComponent.defaultProps = {
    type: 'net'
};

PriceComponent.propTypes = {
    type: PropTypes.string,
    isSoldIndividually: PropTypes.bool,
    currency: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    retailPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    netPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    copy: PropTypes.object,
    pageType: PropTypes.string,
    showPriceTypeCopy: PropTypes.bool,
    priceDisplays: PropTypes.object.isRequired
};

var PriceComponentConnected = provideContext(connectToStores(PriceComponent, [ItemStore, PriceStore, UserStore], function (context) {
    var userStore = context.getStore(UserStore);
    var itemStore = context.getStore(ItemStore);
    var item = itemStore.getItem();
    var priceStore = context.getStore(PriceStore);
    var processedPriceData = priceStore.processPrice(item);
    var _processedPriceData$n = processedPriceData.netPriceData,
        netPriceData = _processedPriceData$n === undefined ? {} : _processedPriceData$n,
        _processedPriceData$r = processedPriceData.retailPriceData,
        retailPriceData = _processedPriceData$r === undefined ? {} : _processedPriceData$r;

    return {
        copy: itemStore.getCopy(),
        currency: userStore.getCurrency(),
        isSoldIndividually: itemStore.getSoldIndividually(netPriceData.model || retailPriceData.model),
        netPrice: netPriceData.price,
        priceDisplays: processedPriceData.priceDisplays,
        retailPrice: retailPriceData.price
    };
}));

var PercentageOffComponent = function PercentageOffComponent(props) {
    var retailPrice = props.retailPrice,
        netPrice = props.netPrice,
        _props$copy2 = props.copy,
        copy = _props$copy2 === undefined ? {} : _props$copy2,
        _props$pageType2 = props.pageType,
        pageType = _props$pageType2 === undefined ? 'pdp' : _props$pageType2;

    var _ref2 = copy || {},
        priceStates = _ref2.priceStates;

    var percentage = calculatePercentageOff({ net: netPrice, retail: retailPrice });
    var classes = classnames('price-percent-off', 'notranslate', styles.percentOff);
    return React.createElement(
        'span',
        { className: classes, 'data-tn': pageType + '-percentage-diff' },
        percentage + ' ' + priceStates.off
    );
};

PercentageOffComponent.defaultProps = {
    type: 'net'
};

PercentageOffComponent.propTypes = {
    retailPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    netPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    copy: PropTypes.object,
    pageType: PropTypes.string
};

var PercentageOffComponentConnected = provideContext(connectToStores(PercentageOffComponent, [ItemStore, PriceStore, UserStore], function (context) {
    var itemStore = context.getStore(ItemStore);
    var item = itemStore.getItem();
    var priceStore = context.getStore(PriceStore);
    var processedPriceData = priceStore.processPrice(item);
    var _processedPriceData$n2 = processedPriceData.netPriceData,
        netPriceData = _processedPriceData$n2 === undefined ? {} : _processedPriceData$n2,
        _processedPriceData$r2 = processedPriceData.retailPriceData,
        retailPriceData = _processedPriceData$r2 === undefined ? {} : _processedPriceData$r2;

    return {
        copy: itemStore.getCopy(),
        netPrice: netPriceData.price,
        pageType: pageTypes.PAGE_TYPE.PDP,
        retailPrice: retailPriceData.price
    };
}));

module.exports = {
    PriceComponent: PriceComponentConnected,
    PercentageOffComponent: PercentageOffComponentConnected,
    RawPriceComponent: PriceComponent,
    RawPercentageOffComponent: PercentageOffComponent
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(1032);

var root = __webpack_require__(97);
var classNames = __webpack_require__(16);

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var debounce = __webpack_require__(105);
var ContextComponent = __webpack_require__(61);
var CloseIcon = __webpack_require__(276);
var StickyAlert = __webpack_require__(581);

var StickyAlertMiddle = function (_ContextComponent) {
    _inherits(StickyAlertMiddle, _ContextComponent);

    function StickyAlertMiddle(props) {
        _classCallCheck(this, StickyAlertMiddle);

        var _this = _possibleConstructorReturn(this, (StickyAlertMiddle.__proto__ || Object.getPrototypeOf(StickyAlertMiddle)).call(this, props));

        _this._close = _this._close.bind(_this);
        _this._setVisibility = debounce(_this._setVisibility, 100);
        _this._scrollCallback = _this._scrollCallback.bind(_this);

        _this.state = {
            isSticky: false,
            isVisible: props.isOpen
        };
        return _this;
    }

    _createClass(StickyAlertMiddle, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._breakpoint = root.document.querySelector('.js-nav-utils-wrap').getBoundingClientRect().height;
            root.addEventListener('scroll', this._scrollCallback);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ isOpen: nextProps.isOpen });
            this._setVisibility(nextProps);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            root.removeEventListener('scroll', this._scrollCallback);
        }
    }, {
        key: '_close',
        value: function _close(event) {
            this.setState({ isVisible: false });

            if (event.currentTarget) {
                this.props.onCloseClick();
            } else {
                this.props.onClose();
            }
        }
    }, {
        key: '_setVisibility',
        value: function _setVisibility(_ref) {
            var isOpen = _ref.isOpen;

            this.setState({ isVisible: isOpen });
        }
    }, {
        key: '_scrollCallback',
        value: function _scrollCallback() {
            var portalBoundingClientRect = this._stickyAlertPortal.getBoundingClientRect();

            if (this._breakpoint && portalBoundingClientRect) {
                var elementPositionTop = portalBoundingClientRect.top;
                var isSticky = elementPositionTop < (this._breakpoint || 0);
                this.setState({ isSticky: isSticky });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                isSticky = _state.isSticky,
                isVisible = _state.isVisible;
            var _props = this.props,
                nodeSelector = _props.nodeSelector,
                isOpen = _props.isOpen,
                onOpen = _props.onOpen,
                onClose = _props.onClose;

            var wrapperClasses = classNames('sticky-alert-wrapper', {
                'is-sticky': isSticky
            });

            var classes = classNames('sticky-alert', {
                'is-collapsed': !isVisible
            });

            return React.createElement(
                StickyAlert,
                { ref: function ref(c) {
                        _this2._stickyAlertPortal = c && c.portal;
                    }, isOpen: isOpen,
                    onOpen: onOpen,
                    onClose: onClose,
                    nodeSelector: nodeSelector
                },
                React.createElement(
                    'div',
                    { className: wrapperClasses },
                    React.createElement(
                        'div',
                        { className: classes },
                        this.props.children,
                        React.createElement(
                            'span',
                            { className: 'sticky-alert-close', onClick: this._close },
                            React.createElement(CloseIcon, null)
                        )
                    )
                )
            );
        }
    }]);

    return StickyAlertMiddle;
}(ContextComponent);

StickyAlertMiddle.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    nodeSelector: PropTypes.string,

    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired
};

StickyAlertMiddle.defaultProps = {
    nodeSelector: '.js-notification-container-middle',
    onOpen: function onOpen() {},
    onClose: function onClose() {},
    onCloseClick: function onCloseClick() {}
};

module.exports = StickyAlertMiddle;

/***/ }),
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var TYPE_LIGHT = 'light';
var TYPE_DARK = 'dark';
var TYPE_TRANSPARENT = 'transparent';
var TYPE_COLORED = 'colored';

var SocialIcon = React.createClass({
    displayName: 'SocialIcon',

    propTypes: {
        Icon: PropTypes.func.isRequired,
        iconName: PropTypes.string.isRequired,
        iconType: PropTypes.oneOf([TYPE_LIGHT, TYPE_DARK, TYPE_TRANSPARENT, TYPE_COLORED])
    },

    getDefaultProps: function getDefaultProps() {
        return {
            iconType: TYPE_LIGHT
        };
    },
    render: function render() {
        var _props = this.props,
            Icon = _props.Icon,
            iconName = _props.iconName,
            iconType = _props.iconType,
            other = _objectWithoutProperties(_props, ['Icon', 'iconName', 'iconType']);

        return React.createElement(
            'div',
            _extends({ className: 'svg-icon-wrapper social-button-' + iconType + ' ' + iconName, title: iconName }, other),
            React.createElement(Icon, { className: 'social-icon' })
        );
    }
});

module.exports = SocialIcon;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// TODO: This file should be grouped together in a subdirectory with PinchZoomComponent.



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(390),
    PinchDetector = _require.PinchDetector,
    PanDetector = _require.PanDetector,
    DoubleTapDetector = _require.DoubleTapDetector;
// TODO: Move this dependency to a separate location.


var _require2 = __webpack_require__(341),
    setTransformStyle = _require2.setTransformStyle;

var _require3 = __webpack_require__(67),
    noop = _require3.noop;

function getBounds(zoom, dimension) {
    return (zoom * dimension - dimension) / 2;
}

/**
 * Handles zooming and panning on a React component. Meant to be used with PinchZoomComponent.
 *
 * @param {Number} [options.maxZoom] Maximum zoom factor. Defaults to 2.
 * @param {Number} [options.onZoomIn] Callback to fire on zoom in.
 * @param {Number} [options.onZoomOut] Callback to fire on zoom out.
 * @param {Number} [options.onPan] Callback to fire on pan.
 */

var ZoomPanModel = function () {
    function ZoomPanModel(_ref) {
        var _ref$maxZoom = _ref.maxZoom,
            maxZoom = _ref$maxZoom === undefined ? 2 : _ref$maxZoom,
            _ref$onZoomIn = _ref.onZoomIn,
            onZoomIn = _ref$onZoomIn === undefined ? noop : _ref$onZoomIn,
            _ref$onZoomOut = _ref.onZoomOut,
            onZoomOut = _ref$onZoomOut === undefined ? noop : _ref$onZoomOut,
            _ref$onPan = _ref.onPan,
            onPan = _ref$onPan === undefined ? noop : _ref$onPan;

        _classCallCheck(this, ZoomPanModel);

        Object.assign(this, {
            _pinchDetector: null,
            _panDetector: null,
            _doubleTapDetector: null,
            _zoomInCallback: onZoomIn,
            _zoomOutCallback: onZoomOut,
            _panCallback: onPan,
            _maxZoom: maxZoom,
            _el: null,
            _state: {}
        });

        this._setInitialState();
    }

    _createClass(ZoomPanModel, [{
        key: 'setEl',
        value: function setEl(el) {
            var _this = this;

            this._el = el;

            // Wire up the touch detection components.
            this._pinchDetector = new PinchDetector({
                onZoomIn: function onZoomIn() {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    return _this._doCallback(function () {
                        return _this._onZoomIn.apply(_this, args);
                    });
                },
                onZoomOut: function onZoomOut() {
                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    return _this._doCallback(function () {
                        return _this._onZoomOut.apply(_this, args);
                    });
                },
                el: el
            });

            this._panDetector = new PanDetector({
                onPan: function onPan() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        args[_key3] = arguments[_key3];
                    }

                    return _this._doCallback(function () {
                        return _this._onPanUpdate.apply(_this, args);
                    });
                },
                el: el
            });

            this._doubleTapDetector = new DoubleTapDetector({
                onDoubleTap: function onDoubleTap() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4];
                    }

                    return _this._doCallback(function () {
                        return _this._onDoubleTap.apply(_this, args);
                    });
                },
                el: el
            });
        }

        /**
         * Enable touch detection.
         */

    }, {
        key: 'enable',
        value: function enable() {
            this._state.enabled = true;
        }

        /**
         * Disable touch detection.
         */

    }, {
        key: 'disable',
        value: function disable() {
            this._state.enabled = false;
        }
    }, {
        key: '_doCallback',
        value: function _doCallback(callback) {
            // Check if touch detection is enabled and then fire the callback if it is.
            if (this._state.enabled) {
                callback();
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            this._setInitialState();
        }
    }, {
        key: '_setInitialState',
        value: function _setInitialState() {
            this._state.zoom = 1;
            this._state.left = 0;
            this._state.top = 0;
            this._state.panX = 0;
            this._state.panY = 0;
            this._state.enabled = true;
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            // The touch detectors add event listeners so we need to destroy it to prevent memory leaks.
            this._pinchDetector.destroy();
            this._panDetector.destroy();
            this._doubleTapDetector.destroy();
        }

        /**
         * Add the necessary styles based on the pan position and zoom. Meant to be called during render of the React view.
         * @param  {Object} style The style object to add properties to.
         */

    }, {
        key: 'getStyle',
        value: function getStyle(style) {
            var _state = this._state,
                zoom = _state.zoom,
                panX = _state.panX,
                panY = _state.panY;


            setTransformStyle(style, 'scale(' + zoom + ') translateX(' + panX + 'px) translateY(' + panY + 'px)');
        }

        /**
         * Go to max zoom factor after a double tap.
         */

    }, {
        key: '_onDoubleTap',
        value: function _onDoubleTap() {
            if (this._state.zoom === this._maxZoom) {
                this._onZoomOut();
            } else {
                this._onZoomIn();
            }
        }

        /**
         * Set the current bounds on panning based on the size of the element and the current zoom factor.
         * @param {Number} zoom Current zoom factor.
         */

    }, {
        key: '_setBounds',
        value: function _setBounds(zoom) {
            var width = this._el.clientWidth;
            var height = this._el.clientHeight;

            this._state.left = getBounds(zoom, width);
            this._state.top = getBounds(zoom, height);
        }
    }, {
        key: '_onZoomIn',
        value: function _onZoomIn() {
            var zoom = this._state.zoom = this._maxZoom;

            this._setBounds(zoom);
            this._zoomInCallback();
        }
    }, {
        key: '_onZoomOut',
        value: function _onZoomOut() {
            var zoom = this._state.zoom = 1;
            this._state.panX = 0;
            this._state.panY = 0;

            this._setBounds(zoom);
            this._zoomOutCallback();
        }

        /**
         * Prevent panning beyond a certain boundary so that the element cannot be dragged off screen.
         * @param  {Number} pan  Actual pan distance.
         * @param  {Number} edge Position of top or left boundary.
         * @return {Number}      Constrained pan distance.
         */

    }, {
        key: '_constrainPan',
        value: function _constrainPan(pan, edge) {
            var zoom = this._state.zoom;


            if (pan > 0 && Math.abs(pan * zoom) >= edge) {
                pan = edge / zoom;
            }

            if (pan < 0 && Math.abs(pan * this._state.zoom) >= edge) {
                pan = -edge / zoom;
            }

            return pan;
        }
    }, {
        key: '_onPanUpdate',
        value: function _onPanUpdate(distanceX, distanceY) {
            var zoom = this._state.zoom;

            // Constrain the actual pan distance based on the boundaries.

            this._state.panX = this._constrainPan(this._state.panX + distanceX / zoom, this._state.left);
            this._state.panY = this._constrainPan(this._state.panY + distanceY / zoom, this._state.top);

            this._panCallback();
        }
    }]);

    return ZoomPanModel;
}();

module.exports = ZoomPanModel;

/***/ }),
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var CarouselItem = React.createClass({
    displayName: 'CarouselItem',

    propTypes: {
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
        className: PropTypes.string.isRequired,
        index: PropTypes.number.isRequired
    },

    render: function render() {
        var _props = this.props,
            className = _props.className,
            src = _props.src,
            alt = _props.alt,
            index = _props.index,
            props = _objectWithoutProperties(_props, ['className', 'src', 'alt', 'index']);

        return React.createElement('img', _extends({
            src: src,
            alt: alt,
            className: className,
            'data-index': index
        }, props));
    }
});

module.exports = CarouselItem;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The config arrays exported below contain objects used to find various information for a detail.
 *
 * Each object has
 * - a title key used to grab the title for a detail from an object from the static repo
 * - a contents key to grab detail data from an object created by ItemStore's getDetails method,
 * - a testName key to grab the testName mechaGodzilla looks for on a detail's markup during it's tests.
 *
 * Additionaly, an object may have
 *   - a gaLabel key if a detail has links that need to be tracked
 *   - a components key if a component other than DetailsItem.jsx should render a detail.
 *
 * Note that order matters. The order of the objects in the array determine the order the details
 * will appear on the pdp.
 */

var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var verticals = __webpack_require__(373);
var findNameSpace = __webpack_require__(285);
var detailsConstants = __webpack_require__(507);

var sharedConfigs = {
    creator: {
        title: 'shared.creator',
        contents: 'creator',
        gaLabel: 'creator',
        testName: 'pdp-spec-creator'
    },
    periodOf: {
        title: 'shared.periodOf',
        contents: 'periodOf',
        gaLabel: 'style',
        testName: 'pdp-spec-of-the-period'
    },
    styleOf: {
        title: 'shared.styleOf',
        contents: 'styleOf',
        gaLabel: 'style',
        testName: 'pdp-spec-in-the-style-of'
    },
    placeOfOrigin: {
        title: 'shared.placeOfOrigin',
        contents: 'placeOfOrigin',
        gaLabel: 'origin',
        testName: 'pdp-spec-place-of-origin'
    },
    dateOfManufacture: {
        title: 'shared.dateOfManufacture',
        contents: 'dateOfManufacture',
        testName: 'pdp-spec-date-of-manufacture'
    },
    period: {
        title: 'shared.period',
        contents: 'period',
        gaLabel: 'period',
        testName: 'pdp-spec-period'
    },
    condition: {
        title: 'shared.condition',
        contents: 'condition',
        testName: 'pdp-spec-condition'
    },
    wear: {
        title: 'shared.wear',
        contents: 'wear',
        testName: 'pdp-spec-wear'
    },
    dimensions: {
        title: 'shared.dimensions',
        contents: 'dimensions',
        component: findNameSpace('components.dimensions', detailsConstants),
        testName: 'pdp-spec-dimensions'
    },
    diameter: {
        title: 'shared.diameter',
        contents: 'diameter',
        testName: 'pdp-spec-diameter'
    },
    length: {
        title: 'shared.length',
        contents: 'length',
        testName: 'pdp-spec-length'
    },
    weight: {
        title: 'shared.weight',
        contents: 'weight',
        testName: 'pdp-spec-weight'
    },
    dealerLocation: {
        title: 'shared.dealerLocation',
        contents: 'dealerLocation',
        testName: 'pdp-spec-dealer-location'
    },
    dealerReference: {
        title: detailsConstants.title.dealerReference,
        contents: 'dealerReference',
        testName: 'pdp-spec-dealer-reference'
    },
    quantity: {
        title: 'shared.quantity',
        contents: 'quantity',
        testName: 'pdp-spec-number-of-items'
    },
    referenceNumber: {
        title: 'shared.referenceNumber',
        contents: 'referenceNumber',
        testName: 'pdp-spec-reference-number'
    },
    itemLocation: {
        title: 'shared.itemLocation',
        contents: 'itemLocation',
        gaLabel: 'item location',
        component: findNameSpace('components.multiline', detailsConstants),
        testName: 'pdp-spec-item-location'
    }
};

// The order of these is the order in which they appear on the page
module.exports = (_module$exports = {}, _defineProperty(_module$exports, verticals.VERTICAL_FURNITURE, [sharedConfigs.creator, {
    title: 'furniture.productionType',
    contents: 'productionType',
    testName: 'pdp-spec-production-type'
}, {
    title: 'furniture.leadTime',
    contents: 'leadTime',
    testName: 'pdp-spec-lead-time'
}, sharedConfigs.periodOf, sharedConfigs.styleOf, sharedConfigs.placeOfOrigin, sharedConfigs.dateOfManufacture, sharedConfigs.period, {
    title: 'shared.materialsAndTechniques',
    contents: 'materialsAndTechniques',
    gaLabel: 'material',
    component: findNameSpace('components.materialsAndTechniques', detailsConstants),
    testName: 'pdp-spec-materials-and-techniques'
}, sharedConfigs.condition, sharedConfigs.wear, sharedConfigs.dimensions, sharedConfigs.diameter, sharedConfigs.weight, {
    title: 'furniture.seatHeight',
    contents: 'seatHeight',
    testName: 'pdp-spec-seat-height'
}, sharedConfigs.dealerLocation, sharedConfigs.dealerReference, sharedConfigs.itemLocation, sharedConfigs.quantity, sharedConfigs.referenceNumber]), _defineProperty(_module$exports, verticals.VERTICAL_JEWELRY, [sharedConfigs.creator, sharedConfigs.periodOf, sharedConfigs.placeOfOrigin, sharedConfigs.dateOfManufacture, sharedConfigs.period, {
    title: 'jewelry.metal',
    contents: 'metal',
    gaLabel: 'metal',
    testName: 'pdp-spec-metal'
}, {
    title: 'jewelry.stone',
    contents: 'stone',
    gaLabel: 'stone',
    testName: 'pdp-spec-stone'
}, sharedConfigs.condition, sharedConfigs.wear, sharedConfigs.dimensions, sharedConfigs.diameter, sharedConfigs.length, sharedConfigs.weight, sharedConfigs.dealerLocation, sharedConfigs.dealerReference, sharedConfigs.itemLocation, sharedConfigs.quantity, sharedConfigs.referenceNumber]), _defineProperty(_module$exports, verticals.VERTICAL_ART, [{
    title: 'art.artist',
    contents: 'creator',
    gaLabel: 'creator',
    testName: 'pdp-spec-artist'
}, {
    title: 'art.creationYear',
    contents: 'dateOfManufacture',
    testName: 'pdp-spec-creation-year'
}, sharedConfigs.placeOfOrigin, {
    title: 'art.medium',
    contents: 'medium',
    gaLabel: 'material',
    testName: 'pdp-spec-medium'
}, {
    title: 'art.movementAndStyle',
    contents: 'styleOf',
    gaLabel: 'style',
    testName: 'pdp-spec-movement-style'
}, sharedConfigs.condition, sharedConfigs.wear, sharedConfigs.dimensions, sharedConfigs.diameter, sharedConfigs.length, sharedConfigs.weight, {
    title: 'art.galleryLocation',
    contents: 'dealerLocation',
    testName: 'pdp-spec-gallery-location'
}, sharedConfigs.itemLocation, sharedConfigs.quantity, sharedConfigs.referenceNumber, sharedConfigs.dealerReference, {
    title: 'art.versions',
    contents: 'versions',
    component: findNameSpace('components.multiline', detailsConstants),
    testName: 'pdp-spec-more-editions-sizes'
}]), _defineProperty(_module$exports, verticals.VERTICAL_FASHION, [{
    title: 'fashion.creator',
    contents: 'creator',
    gaLabel: 'creator',
    testName: 'pdp-spec-creator'
}, {
    title: 'fashion.brand',
    contents: 'brand',
    testName: 'pdp-spec-brand'
}, sharedConfigs.styleOf, sharedConfigs.placeOfOrigin, sharedConfigs.period, {
    title: 'fashion.materialNotes',
    contents: 'materialNotes',
    testName: 'pdp-spec-materials-notes'
}, sharedConfigs.condition, sharedConfigs.wear, sharedConfigs.dimensions, {
    title: 'fashion.markedSize',
    contents: 'markedSize',
    testName: 'pdp-spec-size-as-marked'
}, {
    title: 'fashion.bust',
    contents: 'bust',
    testName: 'pdp-spec-bust'
}, {
    title: 'fashion.waist',
    contents: 'waist',
    testName: 'pdp-spec-waist'
}, {
    title: 'fashion.hip',
    contents: 'hip',
    testName: 'pdp-spec-hip'
}, sharedConfigs.length, {
    title: 'fashion.shoulderToHem',
    contents: 'shoulderToHem',
    testName: 'pdp-spec-shoulder-to-hem'
}, {
    title: 'fashion.inseam',
    contents: 'inseam',
    testName: 'pdp-spec-inseam'
}, sharedConfigs.diameter, sharedConfigs.weight, sharedConfigs.dealerLocation, sharedConfigs.dealerReference, sharedConfigs.itemLocation, sharedConfigs.quantity, sharedConfigs.referenceNumber]), _module$exports);

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The helpers exported in this file are used to calculate
 * the condition details that will appear on the pdp.
 * Copy for the details titles is not determined in these helpers.
 * These methods return only the information that will
 * appear under a detail's title.
 */

var schemaTypes = __webpack_require__(656);

module.exports = {
    /**
     *
     * Get an array containing one object that DetailsItem.jsx will use to render this detail.
     * The object will have a key 'value', which holds the display data for the condition.
     *
     * @param {object} config
     * @param {object} config.item                 - Bunsen Item Model
     * @param {object} config.conditionReferences  - see this.conditionReferences in ItemStore for definition {@link newPdp/ItemStore}
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *          }[]}
     *
     * ie: [{
     *          value: 'Excellent',
     *          isLink: boolean
     *     }]
     */
    getCondition: function getCondition(config) {
        var item = config.item,
            conditionReferences = config.conditionReferences;

        var contents = [];

        var conditions = [];
        // Want to check if the item has each of these conditions.
        var conditionState = item.get('condition.state');
        var conditionDescription = item.get('condition.description');
        var conditionOriginalBox = item.get('condition.hasOriginalBox');
        var conditionFormatted = void 0;

        // Then apply specific logic for each condition,
        // to transform it into a more display friendly format.
        if (conditionState && conditionReferences) {
            var reference = conditionReferences[conditionState];
            var displayName = reference && reference.displayName ? reference.displayName : '';
            conditions.push(displayName);
        }

        if (conditionDescription) {
            conditionDescription = conditionDescription.charAt(0).toUpperCase() + conditionDescription.substring(1);
            conditions.push(conditionDescription);
        }

        if (conditionOriginalBox && conditionOriginalBox === 'Y') {
            conditions.push('In original box');
        }

        // Add a string with one space so when we perform a join
        // below, the last string in conditions has a period.
        if (conditions.length > 1) {
            conditions.push(' ');
        }

        if (conditions.length > 0) {
            // And finally join the conditions into one string.
            conditionFormatted = conditions.join('. ').trim();
            contents.push({
                isLink: false,
                value: conditionFormatted,
                schemaType: schemaTypes.condition
            });
        }

        return contents;
    },

    /**
     *
     * Get an array containing one object that DetailsItem.jsx will use to render this detail.
     * The object will have a key 'value', which holds the display data for the wear.
     *
     * @param {object} config
     * @param {object} config.item - Bunsen Item Model
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *          }[]}
     *
     * ie: [{
     *          value: 'Wear consistent with age and use',
     *          isLink: boolean
     *     }]
     */
    getWear: function getWear(config) {
        var contents = [];
        var item = config.item;

        var wear = [];
        var wearKeys = ['damageLight', 'damageDesignerAltered', 'damageOtherAltered', 'damageLosses', 'damageSound', 'damageFading', 'damageRestored', 'damageServiced'];
        var wearCopy = {
            damageLight: 'Wear consistent with age and use',
            damageDesignerAltered: 'Alteration made by original designer',
            damageOtherAltered: 'Altered (not by designer)',
            damageLosses: 'Minor losses',
            damageSound: 'Minor structural damages',
            damageFading: 'Minor fading',
            damageRestored: 'Restored',
            damageServiced: 'Recently Serviced'
        };
        var condition = item.get('condition');

        var wearKey = void 0;
        var wearFormatted = void 0;

        if (!condition) {
            return contents;
        }

        // If the item's condition has one of these wear as a key,
        // and the value is 'Y', push the copy for that wear.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = wearKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                wearKey = _step.value;

                if (condition.get(wearKey) && condition.get(wearKey) === 'Y') {
                    wear.push(wearCopy[wearKey]);
                }
            }

            // Add a string with one space so when we perform a join
            // below, the last string in wear has a period.
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        if (wear.length > 1) {
            wear.push(' ');
        }

        if (wear.length > 0) {
            // Join the wear into one string.
            wearFormatted = wear.join('. ').trim();
            contents.push({
                isLink: false,
                value: wearFormatted,
                schemaType: schemaTypes.condition
            });
        }

        return contents;
    }
};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The helpers exported in this file are used to calculate
 * the creator details that will appear on the pdp.
 * Copy for the details titles is not determined in these helpers.
 * These methods return only the information that will
 * appear under a detail's title.
 */

var _ = __webpack_require__(23);
var sharedHelpers = __webpack_require__(384);
var findNameSpace = __webpack_require__(285);

// Private Methods

/**
 *
 * Get an array of objects that DetailsItem.jsx will use to render this detail. Each object will have a key
 * 'value', which holds the display name of a creator.
 *
 * @param {object} config
 * @param {object} config.item                              - Bunsen Item Model
 * @param {string} config.linksKey                          - the key under which links for this detail can be found in config.links
 * @param {object} config.links                             - see this.detailLinks in ItemStore for definition {@link newPdp/ItemStore}
 * @param {object} config.creatorRoleReferences             - see this.creatorRoleReferences in ItemStore for definition {@link newPdp/ItemStore}
 * @param {object} config.attributions                      - the attributions you want creators for
 * @param {boolean} config.attributions.[attribution name]  - the boolean represents if you want a the creator who has that attribution
 *
 * @returns {{
 *               value: string,
 *               isLink: boolean,
 *               link: string,
 *               extraCopy: string
 *          }[]}
 *
 * ie: [{
 *          value: 'Tomaso Buzzi',
 *          isLink: true,
 *          link: '/creators/tomaso-buzzi/furniture/',
 *          extraCopy: '(Designer)'
 *     }]
 */
function getCreatorsByAttribution(config) {
    var item = config.item,
        linksKey = config.linksKey,
        links = config.links,
        creatorRoleReferences = config.creatorRoleReferences,
        attributions = config.attributions;

    var contents = [];
    var creators = item.get('creators');

    if (!creators) {
        return contents;
    }

    creators.each(function (creator) {
        var content = { isLink: false };
        var attribution = creator.get('attribution');
        var roles = creator.get('roles');
        var link = void 0;

        // Display name for creator
        // Default to creator.name if creator.displayName is unavailable
        content.value = creator.get('creator.displayName') || creator.get('creator.name');

        if (!_.isEmpty(roles)) {
            // If creator has a role, we want to show that next to the creator's
            // displayName on the pdp. So we have to save that information for the
            // component that will display it.
            var creatorRole = roles[0];
            var creatorRoleDisplayName = findNameSpace(creatorRole + '.displayName', creatorRoleReferences);

            if (creatorRoleDisplayName) {
                content.extraCopy = '(' + creatorRoleDisplayName + ')';
            }
        }

        // Check if there is a link for the type of detail
        // ie links && links['creator']
        if (links && links[linksKey]) {
            var value = content.value;
            // Grab the link for that type of detail and the creator's display name
            // ie links['creator'] = {'Tomaso Buzzi': '/creators/tomaso-buzzi/furniture/'} so
            // link = links['creator']['Tomaso Buzzi']
            link = links[linksKey][value];
        }

        if (link) {
            content.isLink = true;
            content.link = link;
        }

        // We want the object for this creator only if it has an attribution
        // matching the attributions marked as true in config.attributions object
        if (content.value && attribution && attributions[attribution]) {
            contents.push(content);
        }
    });

    return contents;
}

/**
 * Get the dates that the creator was born and/or died based
 * on what information is available on the creator model.
 *
 * @param {object} creator  - Bunsen Creator model
 * @returns {string}        - DOB-DOD|b. DOB|d. DOD
 */
function getCreatorsArtDate(creator) {
    var dateOfBirth = creator.get('creator.dateOfBirth');
    var dateOfDeath = creator.get('creator.dateOfDeath');
    var fallbackDate = creator.get('creator.date');

    var birthDateText = '' + (dateOfDeath ? '' : 'b. ') + dateOfBirth;
    var deathDateText = '' + (dateOfBirth ? '-' : 'd. ') + dateOfDeath;
    var formattedDate = '' + (dateOfBirth ? birthDateText : '') + (dateOfDeath ? deathDateText : '');

    return formattedDate || fallbackDate;
}

/**
 *
 * Get a display name for art creators
 *
 * @param {object} nameData
 * @param {string} nameData.name               - artist display name
 * @param {string} [nameData.date]             - dates artist was born and/or died (optional)
 * @param {string} [nameData.countryOfOrigin]  - artist country of origin (optional)
 * @returns {string}                           - Artist Name, (DOB-DOD|b. DOB|d. DOD, Country)
 *
 * ie: Timothy Roepe (1962, United States)
 */
function formatCreatorsArtName(nameData) {
    var name = nameData.name,
        date = nameData.date,
        countryOfOrigin = nameData.countryOfOrigin;

    var extraInfo = [date, countryOfOrigin];
    var value = void 0;

    extraInfo = extraInfo.filter(function (info) {
        return !!info;
    });

    if (name) {
        var extraInfoString = extraInfo.length > 0 ? ' (' + extraInfo.join(', ') + ')' : '';
        value = '' + name + extraInfoString;
    }

    return value;
}

function getCreatorName() {
    var creator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (creator.length && typeof creator[0].get === 'function') {
        return creator[0].get('creator.name');
    }
    return '';
}

function getFashionJewelryCreator(_ref) {
    var item = _ref.item,
        links = _ref.links;

    return sharedHelpers.addToContents({
        passedValue: getCreatorName(item.getCreatorsByRole('DESIGNER')),
        links: links,
        linkKey: 'creator'
    });
}

function getCreatorByType(_ref2) {
    var config = _ref2.config,
        _ref2$type = _ref2.type,
        type = _ref2$type === undefined ? '' : _ref2$type;
    var item = config.item;

    var creatorName = '';
    if (item && typeof item.getCreatorsByRole === 'function') {
        creatorName = getCreatorName(item.getCreatorsByRole(type.toUpperCase()));
    }
    return sharedHelpers.getSingleValueWithoutLink(config, type, creatorName);
}

module.exports = {
    /**
     * See definition for private method getCreatorsByAttribution above
     */
    getCreatorsFurniture: function getCreatorsFurniture(config) {
        var inflatedConfig = Object.assign({
            attributions: { BY: true, BY_AND_DOCUMENTED: true },
            linksKey: 'creator'
        }, config);
        return getCreatorsByAttribution(inflatedConfig);
    },

    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getCreatorJewelry: function getCreatorJewelry(config) {
        return getFashionJewelryCreator(config);
    },

    /**
     * See definition for addToContents in DetailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getCreatorArt: function getCreatorArt(config) {
        var item = config.item,
            links = config.links;

        var creators = item.get('creators');
        var creator = creators && creators.first();
        var value = void 0;

        if (creator) {
            // Default to creator.name if creator.displayName is unavailable
            var name = creator.get('creator.displayName') || creator.get('creator.name');
            var date = getCreatorsArtDate(creator);
            var countryOfOrigin = creator.get('creator.countryOfOrigin');

            value = formatCreatorsArtName({ name: name, date: date, countryOfOrigin: countryOfOrigin });
        }

        return sharedHelpers.addToContents({
            passedValue: value,
            links: links,
            linkKey: 'creator'
        });
    },

    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getCreatorFashion: function getCreatorFashion(config) {
        return getFashionJewelryCreator(config);
    },

    /**
     * See definition for getSingleValueWithoutLink in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getManufacturer: function getManufacturer(config) {
        return getCreatorByType({ config: config, type: 'manufacturer' });
    },

    /**
     * See definition for getSingleValueWithoutLink in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getDesigner: function getDesigner(config) {
        return getCreatorByType({ config: config, type: 'designer' });
    }
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * newPdp/stores/ItemStore uses the helpers in this file to calculate
 * the details that will appear on the pdp based on the
 * item's vertical. Copy for the details titles is not determined in
 * these helpers. These methods return only the information that will
 * appear under a detail's title.
 */

var creatorHelpers = __webpack_require__(899);
var originHelpers = __webpack_require__(904);
var periodHelpers = __webpack_require__(905);
var styleHelpers = __webpack_require__(906);
var materialHelpers = __webpack_require__(901);
var conditionHelpers = __webpack_require__(898);
var measurementHelpers = __webpack_require__(902);
var miscellaneousHelpers = __webpack_require__(903);
var verticals = __webpack_require__(373);

// Helpers for calculating the pdp details that appear
// for items in every vertical
var sharedGetters = {
    condition: conditionHelpers.getCondition,
    wear: conditionHelpers.getWear,
    dimensions: measurementHelpers.getDimensions,
    diameter: measurementHelpers.getDiameter,
    length: measurementHelpers.getLength,
    weight: measurementHelpers.getWeight,
    dealerLocation: miscellaneousHelpers.getDealerLocation,
    dealerReference: miscellaneousHelpers.getDealerReference,
    quantity: miscellaneousHelpers.getQuantity,
    referenceNumber: miscellaneousHelpers.getReferenceNumber,
    itemLocation: miscellaneousHelpers.getItemLocation,
    period: periodHelpers.getPeriod
};

// Helpers for calculating the pdp details that appear
// for items in the furniture vertical
var furnitureGetters = {
    creator: creatorHelpers.getCreatorsFurniture,
    productionType: miscellaneousHelpers.getProductionType,
    leadTime: miscellaneousHelpers.getLeadTime,
    periodOf: styleHelpers.getPeriodOf,
    styleOf: styleHelpers.getStyleOf,
    placeOfOrigin: originHelpers.getPlaceOfOriginFurniture,
    dateOfManufacture: miscellaneousHelpers.getDateOfManufacture,
    materialsAndTechniques: materialHelpers.getMaterialsAndTechniques,
    seatHeight: measurementHelpers.getSeatHeight
};

// Helpers for calculating the pdp details that appear
// for items in the jewelry vertical
var jewelryGetters = {
    creator: creatorHelpers.getCreatorJewelry,
    periodOf: styleHelpers.getPeriodOf,
    placeOfOrigin: originHelpers.getPlaceOfOrigin,
    dateOfManufacture: miscellaneousHelpers.getDateOfManufacture,
    metal: materialHelpers.getMetals,
    stone: materialHelpers.getStones
};

// Helpers for calculating the pdp details that appear
// for items in the art vertical
var artGetters = {
    creator: creatorHelpers.getCreatorArt,
    placeOfOrigin: originHelpers.getPlaceOfOrigin,
    dateOfManufacture: miscellaneousHelpers.getDateOfManufacture,
    medium: materialHelpers.getMediums,
    styleOf: styleHelpers.getStyleOf,
    versions: miscellaneousHelpers.getVersions
};

// Helpers for calculating the pdp details that appear
// for items in the fashion vertical
var fashionGetters = {
    creator: creatorHelpers.getCreatorFashion,
    brand: creatorHelpers.getManufacturer,
    styleOf: styleHelpers.getStyleOfLegacy,
    placeOfOrigin: originHelpers.getPlaceOfOrigin,
    materialNotes: materialHelpers.getMaterialsNotes,
    markedSize: measurementHelpers.getMarkedSize,
    bust: measurementHelpers.getBust,
    waist: measurementHelpers.getWaist,
    hip: measurementHelpers.getHip,
    shoulderToHem: measurementHelpers.getShoulderHem,
    inseam: measurementHelpers.getInseam
};

module.exports = {
    /**
     * Grabs an object containing the helpers used to calculate the
     * pdp details for the item's vertical, merges that with the object
     * containing the helpers that appear in every vertical, and returns
     * the combined object.
     *
     * @param {string} vertical  - the item's vertical
     * @returns {Object}         - keys are the type of detail, ie: 'creator'
     *                             values are a method used to calculate that detail
     */
    getHelpers: function getHelpers(vertical) {
        var helpers = void 0;

        switch (vertical) {
            case verticals.VERTICAL_FURNITURE:
                helpers = furnitureGetters;
                break;
            case verticals.VERTICAL_JEWELRY:
                helpers = jewelryGetters;
                break;
            case verticals.VERTICAL_ART:
                helpers = artGetters;
                break;
            case verticals.VERTICAL_FASHION:
                helpers = fashionGetters;
                break;
        }

        return Object.assign({}, helpers, sharedGetters);
    }
};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The helpers exported in this file are used to calculate
 * the material details that will appear on the pdp.
 * Copy for the details titles is not determined in these helpers.
 * These methods return only the information that will
 * appear under a detail's title.
 */

var findNameSpace = __webpack_require__(285);
var helpers = __webpack_require__(384);

/**
 * Checks if an object, or nested objects under the key 'parent', have
 * a name value that matches the one passed as a param
 *
 * @param {object} parent
 * @param {string} parent.name
 * @param {object} parent.parent
 * @param {string} name           - string to compare parent.name against
 * @returns {boolean}             - true if parent.name = name, false otherwise
 */
function hasAncestor(parent, name) {
    var _name = findNameSpace('name', parent);
    var _parent = findNameSpace('parent', parent);

    if (_name && _name.toLowerCase() === name) {
        return true;
    } else if (_parent) {
        return hasAncestor(_parent, name);
    }

    return false;
}

/**
 * Get the item's material attributes that have a metal ancestor
 *
 * @param item       - Bunsen Item model
 * @returns {Array}  - item's material objects that are metals
 */
function getMetalModels(item) {
    var materials = item.get('attributes.material');
    var metals = [];

    if (!materials) {
        return metals;
    }

    materials.each(function (material) {
        var parent = material.get('option.parent');

        if (hasAncestor(parent, 'metal')) {
            metals.push(material);
        }
    });

    return metals;
}

/**
 * Get the item's material attributes that have a stone ancestor
 *
 * @param item       - Bunsen Item model
 * @returns {Array}  - item's material objects that are stones
 */
function getStoneModels(item) {
    var materials = item.get('attributes.material');
    var stones = [];

    if (!materials) {
        return stones;
    }

    materials.each(function (material) {
        var parent = material.get('option.parent');

        if (hasAncestor(parent, 'stone')) {
            stones.push(material);
        }
    });

    return stones;
}
/**
 *
 * Get an array of objects that DetailsItem.jsx will use to render a detail. Each object will have a key
 * 'value', which holds the display name of a material.
 *
 * @param {object} config
 * @param {object} config.item      - Bunsen Item Model
 * @param {string} config.linksKey  - the key under which links for this detail can be found in config.links
 * @param {object} config.links     - see this.detailLinks in ItemStore for definition {@link newPdp/ItemStore}
 * @param {Function} config.getter  - a function for grabbing materials from the item
 *
 * @returns {{
 *               value: string,
 *               isLink: boolean,
 *               link: string
 *          }[]}
 *
 * ie: [{
 *          value: '18k Gold',
 *          isLink: true,
 *          link: '/jewelry/rings/cocktail-rings/metal/18k-gold/'
 *     }]
 */
function getMaterialByMethod(config) {
    var contents = [];
    var item = config.item,
        links = config.links,
        linkKey = config.linkKey,
        getter = config.getter;
    // Grab the materials you want to return info for
    // in this method

    var materials = getter(item);
    var material = void 0;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = materials[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            material = _step.value;

            var content = { isLink: false };
            var link = void 0;

            // Display name for material
            content.value = material.get('option.name');

            // Check if there is a link for the type of detail
            // ie links && links['metal']
            if (links && links[linkKey]) {
                var value = content.value;
                // Grab the link for that type of detail and the material's display name
                // ie links['metal'] = {'18k Gold': '/jewelry/rings/cocktail-rings/metal/18k-gold/'} so
                // link = links['metal']['18k Gold']
                link = links[linkKey][value];
            }

            if (link) {
                content.isLink = true;
                content.link = link;
            }

            if (content.value) {
                contents.push(content);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return contents;
}

/**
 * Get an attribute's group key. If the groupKey is
 * undefined, a default value 'noGroupKey' will be returned.
 *
 * @param {object} model - Bunsen ItemAttribute model
 * @returns {string}
 */
function materialsAndTechniquesGroup(model) {
    var groupKey = model.get('groupKey');
    if (groupKey) {
        return groupKey;
    }

    return 'noGroupKey';
}

/**
 * Get a callback to be used on an ItemAttributes collection's each method for the purpose
 * of creating an array of arrays containing objects with info that should appear for a detail
 *
 * @param {object} config
 * @param {object} config.contents                - array containing arrays of objects with info that
 *                                                  should appear for a detail
 * @param {object} config.hash                    - hash used to check if a material has already been added
 *                                                  to config.contents
 * @param {boolean} config.hash.[attribute name]  - true if attribute is already in config.contents, false otherwise
 * @param {object} config.links                   - see this.detailLinks in ItemStore for definition {@link newPdp/ItemStore}
 * @returns {Function}
 */
function getMaterialsAndTechniquesContentCallback(config) {
    var contents = config.contents,
        hash = config.hash,
        links = config.links;


    return function (attribute) {
        var content = {
            isLink: false,
            value: attribute.get('option.name')
        };
        var link = void 0;

        if (hash[content.value]) {
            return;
        }

        if (links && links.materialsAndTechniques) {
            var value = content.value;
            link = links.materialsAndTechniques[value];
        }

        if (link) {
            content.isLink = true;
            content.link = link;
        }

        if (content.value) {
            contents.push([content]);
        }
    };
}

/**
 * Get an array containing one object with display info for a technique and
 * another object with display info for a material in that order. Returns an
 * empty array if the material or technique's display name is missing.
 *
 * @param config
 * @param {object} config.material   - Bunsen ItemAttributes model
 * @param {object} config.technique  - Bunsen ItemAttributes model
 * @param {object} config.links      - see this.detailLinks in ItemStore for definition {@link newPdp/ItemStore}
 * @returns {Array}
 */
function formatMaterialAndTechnique(config) {
    var material = config.material,
        technique = config.technique,
        links = config.links;


    var content = [];
    var techniqueContent = {
        isLink: false,
        value: technique.get('option.name')
    };
    var materialContent = {
        isLink: false,
        value: material.get('option.name')
    };

    var techniqueLink = void 0;
    var materialLink = void 0;

    if (links && links.materialsAndTechniques) {
        var techniqueValue = techniqueContent.value;
        var materialValue = materialContent.value;
        techniqueLink = links.materialsAndTechniques[techniqueValue];
        materialLink = links.materialsAndTechniques[materialValue];
    }

    if (techniqueLink) {
        techniqueContent.isLink = true;
        techniqueContent.link = techniqueLink;
    }

    if (materialLink) {
        materialContent.isLink = true;
        materialContent.link = materialLink;
    }

    // Technique should be pushed first
    if (techniqueContent.value && materialContent.value) {
        content.push(techniqueContent);
        content.push(materialContent);
    }

    return content;
}

module.exports = {
    /**
     *
     * Get an array of arrays containing objects that DetailsMaterialsAndTechniques.jsx
     * will use to render this detail. Each object will have a key 'value', which holds the
     * display name of a material or technique.
     *
     * @param {object} config
     * @param {object} config.item   - Bunsen Item Model
     * @param {object} config.links  - see this.detailLinks in ItemStore for definition {@link newPdp/ItemStore}
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *               link: string,
     *               extraCopy: string
     *          }[][]}
     *
     * ie: [
     *         [
     *             {
     *                 isLink: true,
     *                 value: 'Polished',
     *                 link: '/furniture/storage-case-pieces/credenzas/technique/polished/'
     *             },
     *             {
     *                 isLink: true,
     *                 value: 'Brass',
     *                 link: '/furniture/storage-case-pieces/credenzas/material/brass/'
     *             }
     *         ],
     *         [
     *             {
     *                 isLink: true,
     *                 value: 'Walnut',
     *                 link: '/furniture/storage-case-pieces/credenzas/material/walnut/'
     *             }
     *         ]
     *     ]
     */
    getMaterialsAndTechniques: function getMaterialsAndTechniques(config) {
        var item = config.item,
            links = config.links;

        var contents = [];

        var techniques = item.get('attributes.technique');
        var materials = item.get('attributes.material');

        // Hashes track what materials and techniques have been paired
        var techniquesHash = {};
        var materialsHash = {};

        if (materials && techniques) {
            // Get an object in which the keys are group keys and the values are arrays
            // containing all models with that group key.
            var groupedMaterials = materials.groupBy(materialsAndTechniquesGroup);
            var groupedTechniques = techniques.groupBy(materialsAndTechniquesGroup);
            var keys = Object.keys(groupedMaterials);
            // Get the keys for which there are a material and a technique with the same group key
            var filteredKeys = keys.filter(function (key) {
                return key !== 'noGroupKey' && groupedMaterials[key][0] && groupedTechniques[key] && groupedTechniques[key][0];
            });

            // Material and techniques are supposed to appear on the pdp like so:
            // Technique + Material if the two have the same group key.
            // ie: 'Carved Giltwood '
            filteredKeys.forEach(function (key) {
                var material = groupedMaterials[key][0];
                var technique = groupedTechniques[key][0];

                materialsHash[material.get('option.name')] = true;
                techniquesHash[technique.get('option.name')] = true;
                // Get a subarray with the material and technique
                // ie [{value: 'material'}, {value: 'technique'}]
                var formattedInfo = formatMaterialAndTechnique({ material: material, technique: technique, links: links });

                if (formattedInfo) {
                    contents.push(formattedInfo);
                }
            });
        }

        // Get a function that will return a subarray for a technique that isn't paired
        // ie: [{value: 'technique'}]
        var techniquesCallback = getMaterialsAndTechniquesContentCallback({ contents: contents, hash: techniquesHash, links: links });

        // Material and techniques are supposed to appear on the pdp like so:
        // Technique if the technique hasn't already been paired with a material
        // ie: 'Polished'
        if (techniques) {
            techniques.each(techniquesCallback);
        }

        // Get a function that will return a subarray for a material that isn't paired
        // ie: [{value: 'material'}]
        var materialsCallback = getMaterialsAndTechniquesContentCallback({ contents: contents, hash: materialsHash, links: links });

        // Material and techniques are supposed to appear on the pdp like so:
        // Material if the material hasn't already been paired with a technique
        // ie: 'Marble'
        if (materials) {
            materials.each(materialsCallback);
        }

        return contents;
    },

    /**
     * See definition for private method getCreatorsByAttribution above
     */
    getMetals: function getMetals(config) {
        var inflatedConfig = Object.assign({
            linkKey: 'metal',
            getter: getMetalModels
        }, config);
        return getMaterialByMethod(inflatedConfig);
    },

    /**
     * See definition for private method getCreatorsByAttribution above
     */
    getStones: function getStones(config) {
        var inflatedConfig = Object.assign({
            linkKey: 'stone',
            getter: getStoneModels
        }, config);
        return getMaterialByMethod(inflatedConfig);
    },

    /**
     * Get an array of objects that DetailsItem.jsx will use to render a detail. Each object will have a key
     * 'value', which holds the display data for a medium.
     *
     * @param {object} config
     * @param {object} config.item      - Bunsen Item Model
     * @param {string} config.linksKey  - the key under which links for this detail can be found in config.links
     * @param {object} config.links     - see this.detailLinks in ItemStore for definition {@link newPdp/ItemStore}
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean,
     *               link: string
     *          }[]}
     *
     * ie: [{
     *          value: 'Archival Pigment Print',
     *          isLink: true,
     *          link: '/art/photography/material/archival-pigment-print/'
     *     }]
     */
    getMediums: function getMediums(config) {
        var contents = [];
        var item = config.item;
        var links = config.links;
        var materials = item.get('attributes.material');

        if (!materials) {
            return contents;
        }

        materials.each(function (material) {
            var content = { isLink: false };
            var link = void 0;

            content.value = material.get('option.name');

            if (links && links.medium) {
                var value = content.value;
                link = links.medium[value];
            }

            if (link) {
                content.isLink = true;
                content.link = link;
            }

            if (content.value) {
                contents.push(content);
            }
        });

        return contents;
    },

    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getMaterialsNotes: function getMaterialsNotes(config) {
        // The service response for a fashion item on a pdp returns only the ids for
        // techniques. We then make a queryservice call to find them. Since there is no proper
        // way to add that queryservice response to an instance of Bunsen/Models/Inventory/Item.js,
        // the display value for the material notes detail was just set as a server var (detailTechniques).
        // Rather than getting that info from an instance of Item.js, like for other details.
        var techniques = config.detailTechniques;
        var inflatedConfig = Object.assign({
            passedValue: techniques
        }, config);

        return helpers.addToContents(inflatedConfig);
    }
};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Measurement = __webpack_require__(599);
var displayConstants = __webpack_require__(561).display;
var formatters = __webpack_require__(907);
var measurementConstants = __webpack_require__(561);

var _require = __webpack_require__(483),
    DEFAULT_FEET_CUTOFF = _require.DEFAULT_FEET_CUTOFF,
    LOWER_FEET_CUTOFF = _require.LOWER_FEET_CUTOFF;

var measurementLabels = measurementConstants.labels;
var schemaTypes = __webpack_require__(656);

/**
 *
 * @param {object} obj
 * @param {string|number} obj.value The value to use for the dimension
 * @param {string} obj.unit The unit of the dimension
 * @param {string} obj.unitLabel The label for the unit/dimension
 * @returns {boolean}
 */
function filterMeasurements(obj) {
    return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && (typeof obj.value === 'string' || typeof obj.value === 'number') && !!obj.unit && !!obj.unitLabel;
}

function hasCategory(item, categoryLabel) {
    var itemCategories = item.getItemCategories();

    if (itemCategories) {
        var itemCategory = itemCategories.at(0);

        if (itemCategory) {
            var category = itemCategory.getCategory();

            if (category) {
                var url = category.getBrowseUrl();

                if (url && url.indexOf(categoryLabel) > -1) {
                    return true;
                }
            }
        }
    }

    return false;
}

function showFeet(item) {
    return hasCategory(item, 'rug') || hasCategory(item, 'mirror');
}

function getMeasurement(config, key) {
    var contents = [];
    var item = config.item;
    var value = item.get('measurement.' + key);
    var units = item.get('measurement.unit');
    var shouldShowFeet = showFeet(item);
    var isFurniture = item.isFurniture();
    var formattedValue = void 0;
    if (value && units) {
        formattedValue = formatters.formatMeasurement(value, units, shouldShowFeet, isFurniture);
    }

    if (formattedValue) {
        contents.push({
            isLink: false,
            value: formattedValue
        });
    }

    return contents;
}

function getMeasurementCustom(config) {
    var item = config.item,
        valueKey = config.valueKey,
        unitsKey = config.unitsKey,
        transform = config.transform;

    var contents = [];
    var value = item.get('measurement.' + valueKey);
    var units = item.get('measurement.' + unitsKey);
    var formattedValue = void 0;

    if (value && units) {
        formattedValue = transform(value, units);
    }

    if (formattedValue) {
        contents.push({
            isLink: false,
            value: formattedValue
        });
    }

    return contents;
}

/**
 * Create dimensions sets in an ordered manner
 * @param {object} config
 * @param {object} dimensions
 * @param {{ value: string, unit: string, unitLabel: string }[]} [dimensions.IN] Array of objects for height, width, depth
 * @param {{ value: string, unit: string, unitLabel: string }[]} [dimensions.CM] Array of objects for height, width, depth
 * @param {{ value: string, unit: string, unitLabel: string }[]} [dimensions.MM] Array of objects for height, width, depth
 * @returns {Array}
 */
function pushDimensionsInOrder(config, dimensions) {
    var item = config.item;
    var IN = dimensions.IN,
        CM = dimensions.CM,
        MM = dimensions.MM;

    var contents = [];

    if (IN && IN.length > 0) {
        contents.push(IN);
    }

    if (CM && CM.length > 0) {
        contents.push(CM);
    }

    if (MM && MM.length > 0) {
        contents.push(MM);
    }

    return contents;
}

function getDisplayValue(shouldShowFeet) {
    var formattersMap = _defineProperty({}, Measurement.units.IN, formatters.formatInchesNoFeet.bind(formatters));
    var rugsOrMirrorsFormattersMap = _defineProperty({}, Measurement.units.IN, formatters.formatInchesAndFeet.bind(formatters));

    return function (_ref) {
        var value = _ref.value,
            unit = _ref.unit;

        var displayValue = void 0;

        if (!shouldShowFeet && formattersMap[unit]) {
            displayValue = formattersMap[unit]({ value: value });
        } else if (shouldShowFeet && rugsOrMirrorsFormattersMap[unit]) {
            displayValue = rugsOrMirrorsFormattersMap[unit]({ value: value, feetCutOff: LOWER_FEET_CUTOFF });
        }

        return displayValue;
    };
}

function getDimensionsFormatted(config, units) {
    var _unitsReverse, _unitsLabels, _unitsLabelsReverse, _convertersMap;

    var item = config.item;

    var measurementNames = ['height', 'width', 'depth', 'length'];
    var measurementsMap = { height: false, width: false, depth: false, length: false };
    var unitsReverse = (_unitsReverse = {}, _defineProperty(_unitsReverse, Measurement.units.CM, Measurement.units.IN), _defineProperty(_unitsReverse, Measurement.units.IN, Measurement.units.CM), _unitsReverse);
    var unitsLabels = (_unitsLabels = {}, _defineProperty(_unitsLabels, Measurement.units.CM, displayConstants[Measurement.units.CM]), _defineProperty(_unitsLabels, Measurement.units.IN, displayConstants[Measurement.units.IN]), _unitsLabels);
    var unitsLabelsReverse = (_unitsLabelsReverse = {}, _defineProperty(_unitsLabelsReverse, Measurement.units.CM, displayConstants[Measurement.units.IN]), _defineProperty(_unitsLabelsReverse, Measurement.units.IN, displayConstants[Measurement.units.CM]), _unitsLabelsReverse);
    var convertersMap = (_convertersMap = {}, _defineProperty(_convertersMap, Measurement.units.CM, formatters.centimetersToInches), _defineProperty(_convertersMap, Measurement.units.IN, formatters.inchesToCentimeters), _convertersMap);
    var dimensions = {};

    var shouldShowFeet = showFeet(item);

    dimensions[units] = measurementNames.map(function (name) {
        var value = item.get('measurement.' + name);
        var measurement = void 0;

        if (value) {
            measurementsMap[name] = true;

            measurement = {
                value: value,
                unit: unitsLabels[units],
                unitLabel: measurementLabels[name],
                schemaType: schemaTypes[name]
            };

            var displayValueCheck = getDisplayValue(shouldShowFeet);
            var displayValue = displayValueCheck({ value: value, unit: units });
            if (displayValue) {
                measurement.displayValue = displayValue;
            }
        }

        return measurement;
    }).filter(filterMeasurements);

    var unitsReversed = unitsReverse[units];
    dimensions[unitsReversed] = measurementNames.map(function (name) {
        var value = item.get('measurement.' + name);
        var measurement = void 0;

        if (value && measurementsMap[name]) {
            var converterMethod = convertersMap[units];
            var convertedValue = converterMethod({ value: value, feetCutOff: shouldShowFeet ? LOWER_FEET_CUTOFF : DEFAULT_FEET_CUTOFF });

            measurement = {
                value: convertedValue,
                unit: unitsLabelsReverse[units],
                unitLabel: measurementLabels[name],
                schemaType: schemaTypes[name]
            };

            var displayValueCheck = getDisplayValue(shouldShowFeet);
            var displayValue = displayValueCheck({ value: convertedValue, unit: unitsReversed });
            if (displayValue) {
                measurement.displayValue = displayValue;
            }
        }

        return measurement;
    }).filter(filterMeasurements);

    return pushDimensionsInOrder(config, dimensions);
}

/**
 *
 * @param config
 * @returns {Array}
 */
function getDimensionsFormattedMm(config) {
    var item = config.item;

    var measurementNames = ['height', 'width', 'depth'];
    var dimensions = {};
    // use this data structure since the `pushDimensionsInOrder` method
    // is expecting an object with keys in `IN`, `CM`, or `MM` format
    dimensions[Measurement.units.MM] = measurementNames.map(function (name) {
        var value = item.get('measurement.' + name);
        var measurement = void 0;

        if (value) {
            measurement = {
                value: value,
                unit: displayConstants[Measurement.units.MM],
                unitLabel: measurementLabels[name],
                schemaType: schemaTypes[name]
            };
        }

        return measurement;
    }).filter(filterMeasurements);

    return pushDimensionsInOrder(config, dimensions);
}

module.exports = {
    getDimensions: function getDimensions(config) {
        var item = config.item;

        var units = item.get('measurement.unit');
        var contents = void 0;

        switch (units) {
            case Measurement.units.MM:
                contents = getDimensionsFormattedMm(config);
                break;
            case Measurement.units.CM:
            case Measurement.units.IN:
                contents = getDimensionsFormatted(config, units);
                break;
            default:
                contents = [];
                break;
        }

        return contents;
    },


    getDiameter: function getDiameter(config) {
        return getMeasurement(config, 'diameter');
    },

    getLength: function getLength(config) {
        return getMeasurement(config, 'length');
    },
    getWeight: function getWeight(config) {
        var inflatedConfig = Object.assign({
            valueKey: 'weight.value',
            unitsKey: 'weight.unit',
            transform: formatters.addUnits
        }, config);
        return getMeasurementCustom(inflatedConfig);
    },
    getSeatHeight: function getSeatHeight(config) {
        return getMeasurement(config, 'secondaryHeight');
    },
    getMarkedSize: function getMarkedSize(config) {
        var inflatedConfig = Object.assign({
            valueKey: 'size.value',
            unitsKey: 'size.standard',
            transform: formatters.addUnitsInParenthesis
        }, config);
        return getMeasurementCustom(inflatedConfig);
    },
    getBust: function getBust(config) {
        return getMeasurement(config, 'chest');
    },
    getWaist: function getWaist(config) {
        return getMeasurement(config, 'waist');
    },
    getHip: function getHip(config) {
        return getMeasurement(config, 'hip');
    },
    getShoulderHem: function getShoulderHem(config) {
        return getMeasurement(config, 'shoulderToHem');
    },
    getInseam: function getInseam(config) {
        return getMeasurement(config, 'inseam');
    }
};

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The helpers exported in this file are used to calculate
 * details that will appear on the pdp. Copy for the details
 * titles is not determined in these helpers. These methods
 * return only the information that will appear under a detail's title.
 */

var findNameSpace = __webpack_require__(285);
var sharedHelpers = __webpack_require__(384);
var constants = __webpack_require__(507);
var currencyFormat = __webpack_require__(756);

var _require = __webpack_require__(275),
    currencyConstants = _require.currencies;

module.exports = {
    /**
     * See definition for getSingleValueWithoutLink in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getDateOfManufacture: function getDateOfManufacture(config) {
        return sharedHelpers.getSingleValueWithoutLink(config, 'classification.creationDate');
    },


    /**
     *
     * Get an array containing one object that DetailsItem.jsx will
     * use to render this detail. The object will have a key 'value',
     * which holds the display data for the date of manufacture.
     *
     * @deprecated
     * @param {object} config
     * @param {object} config.item              - Bunsen Item Model
     * @param {object} config.periodReferences  - see this.periodReferences in ItemStore for definition {@link newPdp/ItemStore}
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean
     *          }[]}
     *
     * ie: [{
     *          value: '1990s',
     *          isLink: false
     *     }]
     */
    getDateOfManufactureFashion: function getDateOfManufactureFashion(config) {
        var item = config.item,
            periodReferences = config.periodReferences;

        var contents = [];

        // First check if the creationDate is available
        var date = item.get('classification.creationDate');
        var reference = void 0;

        // If the creationDate is not available,
        // grab the period and pass that through the jewelry
        // period reference set
        if (!date && periodReferences) {
            date = item.get('classification.period');
            reference = periodReferences[date];
        }

        // If there is a no creation date, but there is a period, return reference.displayName
        // If there is a creation date or no creation date and no period, return date
        var dateFormatted = reference && reference.displayName ? reference.displayName : date;

        // dateFormatted is now either a string or undefined
        if (dateFormatted) {
            contents.push({
                isLink: false,
                value: dateFormatted
            });
        }

        return contents;
    },


    /**
     *
     * Get an array containing one object that DetailsItem.jsx will use
     * to render this detail. The object will have a key 'value', which
     * holds the display data for the dealer's location.
     *
     * @param {object} config
     * @param {object} config.item - Bunsen Item Model
     *
     * @returns {{
     *               value: string,
     *               isLink: boolean
     *          }[]}
     *
     * ie: [{
     *          value: 'New York, NY',
     *          isLink: false
     *     }]
     */
    getDealerLocation: function getDealerLocation(config) {
        var contents = [];
        var item = config.item;

        var location = [];
        // We use the seller's shipping address to determine dealer location
        var city = item.get('seller.shippingAddress.city');
        var state = item.get('seller.shippingAddress.state');
        var country = item.get('seller.shippingAddress.country');
        var shouldPushValue = false;

        if (city) {
            location.push(city);
        }

        // Calculate the location only if the seller has a ciy and country
        shouldPushValue = location.length === 1 && country;

        if (shouldPushValue && country === 'US' && state) {
            // If the seller is located in the US,
            // dealer location should be formatted: City, State
            location.push(state);
        } else if (shouldPushValue) {
            // If the seller is located outside the US,
            // dealer location should be formatted: City, Country
            location.push(country);
        }

        // Should be true only if seller has city and state or
        // city and country already pushed into location array
        if (location.length === 2) {
            var locationFormatted = location.join(', ');
            contents.push({
                isLink: false,
                value: locationFormatted
            });
        }

        return contents;
    },


    /**
     * See definition for getSingleValueWithoutLink in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getDealerReference: function getDealerReference(config) {
        return sharedHelpers.getSingleValueWithoutLink(config, 'dealerReference');
    },


    /**
     * @param config
     * @param {boolean} config.item - bunsen item model
     * @param {object} config.copy  - pdp copy
     * @returns {Array}
     *
     * ie: [
     *         {
     *             isLink: true,
     *             link: '/nydc/',
     *             value: '1stdibs Gallery'
     *         },
     *         {
     *             isLink: false,
     *             value: '200 Lexington'
     *         },
     *         {
     *             isLink: false,
     *             value: 'New York, NY'
     *         }
     *
     *     ]
     */
    getItemLocation: function getItemLocation(config) {
        var item = config.item,
            copy = config.copy;

        var isNydc = item.isNydc() && item.get('seller.associations.nydcStatus') === 'Y';
        var contents = [];

        if (isNydc) {
            var _copy$nydc = copy.nydc,
                galleryName = _copy$nydc.galleryName,
                urlPath = _copy$nydc.urlPath,
                streetAddress = _copy$nydc.streetAddress,
                cityStateAddress = _copy$nydc.cityStateAddress;


            contents.push({
                isLink: true,
                link: urlPath,
                value: galleryName
            });

            contents.push({
                isLink: false,
                value: streetAddress
            });

            contents.push({
                isLink: false,
                value: cityStateAddress
            });
        }

        return contents;
    },


    /**
     * See definition for getSingleValueWithoutLink in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getQuantity: function getQuantity(config) {
        return sharedHelpers.getSingleValueWithoutLink(config, 'pieces');
    },


    /**
     * See definition for getSingleValueWithoutLink in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getReferenceNumber: function getReferenceNumber(config) {
        return sharedHelpers.getSingleValueWithoutLink(config, 'dibsReference');
    },


    /**
     *
     * Get an array of objects that DetailsVersions.jsx will
     * use to render this detail. Each object will have a key 'value',
     * which holds the display data for an item's version.
     *
     * @param {object} config
     * @param {object} config.item - Bunsen Item Model
     *
     * @returns {{
     *               value: string
     *          }[]}
     *
     * ie: [{
     *          value: '75x53 Price: $7,800'
     *     }]
     */
    getVersions: function getVersions(config) {
        var item = config.item,
            copy = config.copy;

        var contents = [];
        var versions = item.get('versions');
        var currency = config.currency || currencyConstants.CURRENCY_USD;
        var priceCopy = findNameSpace('details.price', copy);

        if (!versions) {
            return contents;
        }

        versions.each(function (version) {
            var description = version.get('description');
            var financialAmount = version.get('price');
            var price = void 0;
            var data = void 0;

            // Need to check that financialAmount.get('amount') is defined,
            // because getDisplayPrice will return $0 if it is undefined.
            if (financialAmount && financialAmount.get('amount')) {
                price = currencyFormat.format(currency, null, financialAmount, { showDecimal: false });
            }

            if (description && price) {
                data = description + ' ' + priceCopy + ' ' + price;
            } else if (description) {
                data = description;
            }

            if (data) {
                contents.push({
                    value: data
                });
            }
        });

        return contents;
    },
    getLeadTime: function getLeadTime(config) {
        var item = config.item;

        var leadTime = item.get('attributes.lead_time');

        if (!leadTime) {
            return null;
        }

        var model = leadTime.first();

        var leadTimeItem = sharedHelpers.getSingleValueFromModelWithoutLink({ model: model, modelKey: 'option.name' });
        var leadTimeValue = leadTimeItem[0].value;
        if (leadTimeItem && leadTimeValue !== constants.availableNow) {
            leadTimeItem[0].value = 'It will take ' + leadTimeValue + ' to make this piece';
        }

        return leadTimeItem;
    },
    getProductionType: function getProductionType(config) {
        var item = config.item;

        var productionType = item.get('attributes.production_type');

        if (!productionType) {
            return null;
        }

        var model = productionType.first();

        return sharedHelpers.getSingleValueFromModelWithoutLink({ model: model, modelKey: 'option.name' });
    }
};

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The helpers exported in this file are used to calculate
 * the origin details that will appear on the pdp.
 * Copy for the details titles is not determined in these helpers.
 * These methods return only the information that will
 * appear under a detail's title.
 *
 */

var sharedHelpers = __webpack_require__(384);

/**
 * @param {object} item           - Bunsen Item model
 * @returns {object} originModel  - the first origin attribute model of an item
 */
function getPlaceOfOriginModel(item) {
    var origin = item.get('attributes.origin');
    var originModel = void 0;

    if (origin) {
        originModel = origin.first();
    }

    return originModel;
}

module.exports = {
    /**
     * See definition for getSingleValueWithoutLink in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getPlaceOfOrigin: function getPlaceOfOrigin(config) {
        return sharedHelpers.getSingleValueWithoutLink(config, 'classification.countryOfOrigin');
    },

    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getPlaceOfOriginFurniture: function getPlaceOfOriginFurniture(config) {
        var item = config.item,
            links = config.links;

        var origin = getPlaceOfOriginModel(item);

        return sharedHelpers.addToContents({
            model: origin,
            modelKey: 'value',
            links: links,
            linkKey: 'placeOfOrigin'
        });
    }
};

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The helpers exported in this file are used to calculate
 * the period details that will appear on the pdp.
 * Copy for the details titles is not determined in these helpers.
 * These methods return only the information that will
 * appear under a detail's title.
 */

var sharedHelpers = __webpack_require__(384);

/**
 * @param {object} item           - Bunsen Item model
 * @returns {object} periodModel  - the first period attribute model of an item
 */
function getPeriodModel(item) {
    var period = item.get('attributes.period');
    var periodModel = void 0;

    if (period) {
        periodModel = period.first();
    }

    return periodModel;
}

module.exports = {
    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getPeriod: function getPeriod(config) {
        var item = config.item,
            links = config.links;

        var period = getPeriodModel(item);

        return sharedHelpers.addToContents({
            model: period,
            modelKey: 'option.name',
            links: links,
            linkKey: 'period'
        });
    }
};

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The helpers exported in this file are used to calculate
 * the style details that will appear on the pdp.
 * Copy for the details titles is not determined in these helpers.
 * These methods return only the information that will
 * appear under a detail's title.
 */

var sharedHelpers = __webpack_require__(384);

/**
 *
 * @param {object} item  - Bunsen Item model
 * @returns {string}     - option.name value of the first style_of attribute model of an item
 */
function getStyleOfLabel(item) {
    var styleOf = item.get('attributes.style_of');
    var styleOfModel = void 0;
    var styleOfLabel = void 0;

    if (styleOf) {
        styleOfModel = styleOf.first();
    }

    if (styleOfModel) {
        styleOfLabel = styleOfModel.get('option.name');
    }

    return styleOfLabel;
}

/**
 * Get the first style attribute model of an item, if the item's
 * style_of attribute is 'OF_THE_PERIOD' or it is a jewelry item
 *
 * @param {object} item          - Bunsen Item model
 * @returns {object} styleModel
 */
function getPeriodOfModel(item) {
    var style = item.get('attributes.style');
    var styleOfLabel = getStyleOfLabel(item);
    var styleOfIsValid = false;
    var styleOfLabelUppercase = void 0;
    var styleModel = void 0;

    if (style && styleOfLabel) {
        styleOfLabelUppercase = styleOfLabel.replace(/\s/g, '_').toUpperCase();
        // Todo put 'OF_THE_PERIOD' in a constant somewhere
        styleOfIsValid = styleOfLabelUppercase === 'OF_THE_PERIOD';
    }

    // Style on jewelry items should always be displayed as 'Of the period'
    if (style && item.get('vertical') === 'jewelry') {
        styleOfIsValid = true;
    }

    if (styleOfIsValid) {
        styleModel = style.first();
    }

    return styleModel;
}

/**
 * Get the first style attribute model of an item, if the item's
 * style_of attribute is 'IN_THE_STYLE_OF' or it is an art item
 *
 * @param {object} item - Bunsen Item model
 * @returns {object} styleModel
 */
function getStyleOfModel(item) {
    var style = item.get('attributes.style');
    var styleOfLabel = getStyleOfLabel(item);
    var styleOfIsValid = false;
    var styleModel = void 0;

    if (style && styleOfLabel && item.get('vertical') === 'furniture') {
        // Todo put IN_THE_STYLE_OF as a constant somewhere
        styleOfIsValid = styleOfLabel.replace(/\s/g, '_').toUpperCase() === 'IN_THE_STYLE_OF';
    }

    if (style && item.get('vertical') === 'art') {
        styleOfIsValid = true;
    }

    if (styleOfIsValid) {
        styleModel = style.first();
    }

    return styleModel;
}

module.exports = {
    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getPeriodOf: function getPeriodOf(config) {
        var item = config.item,
            links = config.links;

        var periodOf = getPeriodOfModel(item);

        return sharedHelpers.addToContents({
            model: periodOf,
            modelKey: 'option.name',
            links: links,
            linkKey: 'periodOf'
        });
    },


    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getStyleOf: function getStyleOf(config) {
        var item = config.item,
            links = config.links;

        var styleOf = getStyleOfModel(item);

        return sharedHelpers.addToContents({
            model: styleOf,
            modelKey: 'option.name',
            links: links,
            linkKey: 'styleOf'
        });
    },


    /**
     * See definition for getSingleValueWithoutLink in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getStyleOfLegacy: function getStyleOfLegacy(config) {
        return sharedHelpers.getSingleValueWithoutLink(config, 'classification.style.name');
    }
};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Measurement = __webpack_require__(599);
var displayConstants = __webpack_require__(561).display;
var numberConversions = __webpack_require__(483);

module.exports = {
    /**
     * @param {string|number} value The measurement value
     * @param {string} units The measurement unit
     * @returns string
     */
    addUnits: function addUnits(value, units) {
        return '' + value + units;
    },


    /**
     * @param {string|number} value The measurement value
     * @param {string} units The measurement unit
     * @returns string
     */
    addUnitsInParenthesis: function addUnitsInParenthesis(value, units) {
        return value + ' (' + units + ')';
    },


    /**
     * @param {string|number} centimeters The measurement in centimeters to convert to inches
     * @returns number
     */
    centimetersToInches: function centimetersToInches(_ref) {
        var value = _ref.value,
            _ref$feetCutOff = _ref.feetCutOff,
            feetCutOff = _ref$feetCutOff === undefined ? numberConversions.DEFAULT_FEET_CUTOFF : _ref$feetCutOff;

        var centimetersNum = parseFloat(value);
        var inches = void 0;

        if (centimetersNum) {
            inches = numberConversions.convert({
                num: centimetersNum,
                from: 'cm',
                to: 'inch',
                feetCutOff: feetCutOff
            });
        }

        return inches;
    },


    /**
     * @param {string|number} inches The measurement in inches to convert to centimeters
     * @param {boolean} round Round the result? Defaults to `true` per existing logic
     * @returns number
     */
    inchesToCentimeters: function inchesToCentimeters(_ref2) {
        var value = _ref2.value,
            _ref2$round = _ref2.round,
            round = _ref2$round === undefined ? true : _ref2$round,
            _ref2$feetCutOff = _ref2.feetCutOff,
            feetCutOff = _ref2$feetCutOff === undefined ? numberConversions.DEFAULT_FEET_CUTOFF : _ref2$feetCutOff;

        var inchesNum = parseFloat(value);
        var centimeters = void 0;

        if (inchesNum) {
            centimeters = numberConversions.convert({
                num: inchesNum,
                from: 'inch',
                to: 'cm',
                feetCutOff: feetCutOff
            });
        }

        return round ? Math.round(centimeters) : centimeters;
    },


    /**
     * Creates a formatted string for inches in `longForm` format
     * @param {number|string} inches
     * @returns {string}
     */
    formatInchesNoFeet: function formatInchesNoFeet(_ref3) {
        var value = _ref3.value,
            _ref3$feetCutOff = _ref3.feetCutOff,
            feetCutOff = _ref3$feetCutOff === undefined ? numberConversions.DEFAULT_FEET_CUTOFF : _ref3$feetCutOff;

        // convert is expecting either ' or "
        value += '"';

        return numberConversions.convert({ num: value, from: 'feet', to: 'longForm', feetCutOff: feetCutOff });
    },


    /**
     * Creates a formatted string for inches in `longForm` format
     * @param {number|string} inches
     * @returns {string}
     */
    formatInchesAndFeet: function formatInchesAndFeet(_ref4) {
        var value = _ref4.value,
            _ref4$feetCutOff = _ref4.feetCutOff,
            feetCutOff = _ref4$feetCutOff === undefined ? numberConversions.DEFAULT_FEET_CUTOFF : _ref4$feetCutOff;

        var feet = numberConversions.convert({
            num: value,
            from: 'inch',
            to: 'feet',
            feetCutOff: feetCutOff
        });
        return numberConversions.convert({
            num: feet,
            from: 'feet',
            to: 'longForm',
            feetCutOff: feetCutOff
        });
    },


    /**
     * Creates a formatted string of dimensions in "# in. (# cm)" format or "# mm" format
     * question: should this formatting round by default?
     * @param {string|number} measurement The measurement value
     * @param {string} units The measurement unit
     * @param {bool} rugOrMirror Is item a rug or mirror
     * @returns {string}
     */
    formatMeasurement: function formatMeasurement(measurement, units) {
        var rugOrMirror = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isFurniture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var formattedMeasurement = void 0;

        switch (units) {
            case Measurement.units.MM:
                formattedMeasurement = measurement + ' ' + displayConstants[Measurement.units.MM];
                break;
            case Measurement.units.CM:
            case Measurement.units.IN:
                var centimeters = void 0;
                var inches = void 0;
                var formattedInches = void 0;
                var feetCutoff = rugOrMirror ? numberConversions.LOWER_FEET_CUTOFF : numberConversions.DEFAULT_FEET_CUTOFF;
                // reassigning all of these vars for clarity
                if (units === Measurement.units.CM) {
                    centimeters = measurement;
                    inches = this.centimetersToInches({ value: measurement });
                    formattedInches = isFurniture ? this.formatInchesAndFeet({ value: inches, feetCutOff: feetCutoff }) : this.formatInchesNoFeet({ value: inches, feetCutOff: feetCutoff });
                } else {
                    centimeters = this.inchesToCentimeters({ value: measurement });
                    inches = measurement;
                    formattedInches = isFurniture ? this.formatInchesAndFeet({ value: inches, feetCutOff: feetCutoff }) : this.formatInchesNoFeet({ value: inches, feetCutOff: feetCutoff });
                }
                // old logic: always put `cm` in parens
                formattedMeasurement = formattedInches + ' (' + centimeters + ' ' + displayConstants[Measurement.units.CM] + ')';
                break;
        }

        return formattedMeasurement;
    }
};

/***/ }),
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

_ = __webpack_require__(23);
module.exports = {
    "tmplRecentHistoryItem": function(obj) {
var __t, __p = '';
__p += '\n    <li class="recent-history-item ' +
((__t = ( obj.additionalClasses )) == null ? '' : __t) +
'">\n        <a href="' +
((__t = ( obj.url )) == null ? '' : __t) +
'" title="' +
((__t = ( obj.title )) == null ? '' : __t) +
'" data-dealerpk="' +
((__t = ( obj.dealerPk )) == null ? '' : __t) +
'" class="recent-history-link">\n            <img src="' +
((__t = ( obj.imageUrl  )) == null ? '' : __t) +
'" title="' +
((__t = ( obj.title )) == null ? '' : __t) +
'" class="recent-history-item-img">\n        </a>\n    </li>\n';
return __p
}
};

/***/ }),
/* 915 */,
/* 916 */,
/* 917 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array ? array.length : 0;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseIndexOf(array, value, index);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = indexOf;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var debounce = __webpack_require__(105);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed invocations. Provide an options object to indicate
 * that `func` should be invoked on the leading and/or trailing edge of the
 * `wait` timeout. Subsequent calls to the throttled function return the
 * result of the last `func` call.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
 * on the trailing edge of the timeout only if the the throttled function is
 * invoked more than once during the `wait` timeout.
 *
 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.leading=true] Specify invoking on the leading
 *  edge of the timeout.
 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
 *  edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // avoid excessively updating the position while scrolling
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
 * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
 *   'trailing': false
 * }));
 *
 * // cancel a trailing throttled call
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (options === false) {
    leading = false;
  } else if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = throttle;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseDifference = __webpack_require__(121),
    restParam = __webpack_require__(274);

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Creates an array excluding all provided values using
 * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to filter.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.without([1, 2, 1, 3], 1, 2);
 * // => [3]
 */
var without = restParam(function(array, values) {
  return isArrayLike(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 920 */,
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__(928);

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__(925);

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

exports.default = isClassComponent;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isClassComponent = __webpack_require__(924);

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && ('production' === 'production' || !Component.propTypes));
};

exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setDisplayName = __webpack_require__(564);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(565);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(922);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

exports.default = mapProps;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component = type;

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

exports.default = createEagerElementUtil;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _wrapDisplayName = __webpack_require__(565);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _setDisplayName = __webpack_require__(564);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _mapProps = __webpack_require__(926);

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withProps = function withProps(input) {
  var hoc = (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

exports.default = withProps;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(40);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27
};

var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

    _this.state = { active: false };
    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.portal = null;
    _this.node = null;
    return _this;
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('mouseup', this.handleOutsideMouseClick);
        document.addEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.isOpened) {
        this.openPortal();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
      }

      this.closePortal(true);
    }
  }, {
    key: 'handleWrapperClick',
    value: function handleWrapperClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.state.active) {
        return;
      }
      this.openPortal();
    }
  }, {
    key: 'openPortal',
    value: function openPortal() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setState({ active: true });
      this.renderPortal(props);
      this.props.onOpen(this.node);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      var _this2 = this;

      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var resetPortalState = function resetPortalState() {
        if (_this2.node) {
          _reactDom2.default.unmountComponentAtNode(_this2.node);
          document.body.removeChild(_this2.node);
        }
        _this2.portal = null;
        _this2.node = null;
        if (isUnmounted !== true) {
          _this2.setState({ active: false });
        }
      };

      if (this.state.active) {
        if (this.props.beforeClose) {
          this.props.beforeClose(this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        this.props.onClose();
      }
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(this.portal);
      if (root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      e.stopPropagation();
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.node) {
        this.node = document.createElement('div');
        document.body.appendChild(this.node);
      }

      var children = props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof props.children.type === 'function') {
        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
      }

      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
      }
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

exports.default = Portal;


Portal.propTypes = {
  children: _propTypes2.default.element.isRequired,
  openByClickOn: _propTypes2.default.element,
  closeOnEsc: _propTypes2.default.bool,
  closeOnOutsideClick: _propTypes2.default.bool,
  isOpened: _propTypes2.default.bool,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  beforeClose: _propTypes2.default.func,
  onUpdate: _propTypes2.default.func
};

Portal.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
};
module.exports = exports['default'];


/***/ }),
/* 931 */,
/* 932 */,
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(53))(235);

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(53))(327);

/***/ }),
/* 935 */,
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: gedas
 * Date: 10/8/14
 * Time: 9:00 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * AdWords Remarketing Tag
 * https://developers.google.com/adwords-remarketing-tag/
 * exp: //googleads.g.doubleclick.net/pagead/viewthroughconversion/123456789/?value=0&guid=ON&script=0&data.ecomm_prodid=abc123&data.ecomm_pagetype=product
 */


var $ = __webpack_require__(5);
var $body = $('body');
var conversionId = 1009889750;
var imageSrc = '//googleads.g.doubleclick.net/pagead/viewthroughconversion/' + conversionId + '/?value=0&guid=ON&script=0';
var paramsMap;
var pageTypesMap;

// Map parameters to more meaningful names to us
// https://developers.google.com/adwords-remarketing-tag/parameters
paramsMap = {
    productId:      'ecomm_prodid',
    pageType:       'ecomm_pagetype',
    productPrice:   'ecomm_pvalue',
    totalPrice:     'ecomm_totalvalue'
};

// Map page types to more meaningful names to us
pageTypesMap = {
    home:       'home',
    search:     'searchresults',
    browse:     'category',
    pdp:        'product',
    cart:       'cart',
    checkout:   'purchase',
    other:      'other'
};

/**
 * Add pixel/tag image
 *
 * @param {string} src
 */
function addImage(src) {
    $body.append($('<img>', {
        height: '1',
        width: '1',
        style: 'border-style: none;',
        alt: '',
        src: src
    }).addClass('remarketing-tag'));
}

module.exports = {
    /**
     * @param {string} id
     * @param {number} price
     * @param {string} pageType
     */
    product: function (id, price, pageType) {
        var parameters = {};
        pageType = pageTypesMap[pageType] || pageTypesMap.pdp;

        if (!id || !price) {
            return;
        }

        // Can have just alphanumeric value for id
        id = ('' + id).replace(/[^a-z0-9]/gi, '');

        parameters[paramsMap.pageType] = pageType;
        parameters[paramsMap.productId] = id;
        parameters[paramsMap.totalPrice] = price;

        this.create(parameters);
    },

    /**
     * @param {object} parameters
     */
    create: function (parameters) {
        var src = imageSrc;
        parameters = parameters || {};

        // Add params to image src
        $.each(parameters, function (key, value) {
            src += '&data.' + key + '=' + encodeURIComponent(value);
        });

        // Add random param to avoid caching issues
        src += '&' + 'random=' + new Date().getTime();

        addImage(src);
    }
};


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var $ = __webpack_require__(5);
var SV = __webpack_require__(17);
var tokenReplace = __webpack_require__(75);
var tracking = __webpack_require__(27);

var methods = {
    updateCounter: function ($pin) {
        if (!$pin || !$pin.length) {
            return false;
        }
        $.ajax({
            url: SV.get('settings.siteProtocol') + '://api.pinterest.com/v1/urls/count.json?callback=?',
            data: {
                url: $pin.data('url')
            },
            success: function (data) {
                if (data.count > 0) {
                    $('#PinCountBubble').html(data.count);
                }
            },
            dataType: 'jsonp'
        });
        return true;
    },

    //Opens a Pin Modal window with image to be pinned and text
    updatePinImage: function (e, src, isModal) {
        var defer = new $.Deferred();
        var $a = e.currentTarget ? $(e.currentTarget) : e;
        var data = $a.data();
        var windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no';
        var top = 0;
        var width = 665;
        var height = 350;
        var winHeight = screen.height;
        var winWidth = screen.width;
        var left = Math.round((winWidth / 2) - (width / 2));
        var win;
        var id;
        var action;
        src = src.indexOf('http') < 0 ? window.location.protocol + src : src;

        if (winHeight > height) {
            top = Math.round((winHeight / 2) - (height / 2));
        }
        win = window.open(
            tokenReplace(
                SV.settings.siteProtocol + '://pinterest.com/pin/create/button/?url={url}&media={media}&description={desc}',
                { url: data.url, media: src, desc: data.title }
            ),
            'pinterest',
            windowOptions + ',height=' + height + ',width=' + width + ',left=' + left + ',top=' + top
        );
        id = setInterval(function () {
            // if applicable, update the counter once the user has pinned and closed the pinterest popup
            if (win && win.closed) {
                clearTimeout(id);
                defer.resolve();
            }
        }, 750);

        action = 'share';
        if (isModal) {
            action += ' - zoom modal';
        }
        this.track(action, data.url, data.title);

        return defer.promise();
    },

    track: function (action, url, target) {
        tracking.trackSocial({
            name: 'pinterest',
            event: action,
            'opt_target': target
        });

        // todo action may have to change to 'product from Item'
        tracking.trackEvent({
            'category': 'share',
            'action': 'product from PDP',
            'label': url
        });
    },
    init: function () {
        var self = this;
        var $pin = $('.js-pinterest-share');
        var $pinBtn = $pin.find('a').first();
        var $pinSub = $pin.find('.sub-nav-list-item').first();
        var $itemHero = $('#itemHero');
        var clickHandler;
        var src;

        this.updateCounter($pinBtn);
        if ($itemHero.length === 0) {
            // generic pinit click for non PDP pages
            clickHandler = function (e) {
                e.preventDefault();
                src = $pinBtn.data('image');
                self.updatePinImage($pinBtn, src).done(function () {
                    // $this should be the pinterest button which should have a data-url attribute
                    self.updateCounter($pinBtn);
                });
            };
            $pinBtn.on('click', clickHandler);
        } else {
            // currently only usable on the PDP page
            clickHandler = function (e) {
                var $container = $itemHero.find('.item-slideshow');
                var $selected = $container.find('.is-selected');
                e.preventDefault();
                if ($selected.length) {
                    src = $selected.find('img').attr('src');
                    self.updatePinImage($pinBtn, src).done(function () {
                        // $this should be the pinterest button which should have a data-url attribute
                        self.updateCounter($pinBtn);
                    });
                }
                return true;
            };
            $pinBtn.on('click', clickHandler);
            $pinSub.on('click', clickHandler);

            $.subscribe('modal:show-hero', function (e, Modal, $overlay) {
                // add a pinterest button to the modal
                var $modal = $overlay.find("#modalOverlay-inner-content");
                // create a separate container since the modal pinterest button does not have the count
                var $pinit = $('<div>').attr('id', 'pinitModal');
                var $a = $pinBtn.clone().appendTo($pinit);
                $pinit.appendTo($modal);
                $a.on('click', function (event) {
                    var $this = $(this);
                    event.preventDefault();
                    // need to fix this to not rely on the .swiper-slide-visible class
                    // something more generic should be used instead
                    src = $overlay.find('.swiper-slide-visible img').attr('src');
                    self.updatePinImage($this, src, true).done(function () {
                        // $this should be the pinterest button which should have a data-url attribute
                        self.updateCounter($this);
                    });
                    return true;
                });
            });
        }
    }
};

module.exports = methods;


/***/ }),
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 6/22/14
 * Time: 3:07 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var _ = __webpack_require__(23);
var $ = __webpack_require__(5);
var SV = __webpack_require__(17);
var strings = __webpack_require__(376);
var purchaseTracking = __webpack_require__(458);
var tracking = __webpack_require__(27);
var pdpTracking = __webpack_require__(542);
var copyText = __webpack_require__(380)();
var undefined = void (0);

/**
 * initialize ga
 * @param dom {Object} object containing form dom elements
 * @param options.type {string} friend or dealer
 */
var ModalEmailTracking = module.exports = function () {
    var customVars = SV.get('tracking.customVars');

    if (customVars && customVars.length) {
        this._customVar4 = customVars[0].value;
    }
};
_.extend(ModalEmailTracking.prototype, {
    _subType: 'Email Friend Modal',
    /**
     * virtual page view
     * @param virtualUrl {string} vpv string
     */
    firePageViewGAEvent: function (virtualUrl) {
        // this prevents re-firing of any ecommerce events that already happened
        tracking.addGTMMessage({ecommerce: undefined});
        return tracking.trackPageview({
            url: pdpTracking.amendCustomVar(virtualUrl, 'ret', this._getValueFromCustomVarString('ret') === 'y'),
            additional: {
                pageType: 'Other',
                pageSubType: this._subType
            }
        });
    },

    resetPageViewVars: function () {
        return tracking.addGTMMessage({
            pageType: SV.get('tracking.initialDataLayerInfo.pageType'),
            pageSubType: SV.get('tracking.initialDataLayerInfo.pageSubType')
        });
    },

    /**
     * @param options.linkLocation where was link/button located that launched the modal
     * @param options.fromForm form submitted or contact dealer or email friend clicked
     * @param options.emailShared
     */
    fireCommunicationGAEvent: function (options) {
        var details = this._details(options);
        return tracking.trackEvent(_.extend(details, {
            value: options.emailShared,
            category: details.event
        }));
    },
    /**
     *
     * @param options.fromForm flag that determines if form was submitted or contact dealer or email friend was clicked
     * @param options.itemPk string that contains the emailed item's PK, in case you're on a page with more than one item (eg favorites)
     * @returns details about friend needed for fireContactGAEvent
     */
    _details: function (options) {
        var details = {};

        details.event = 'email a friend';
        details.label = options.itemPk || this._getValueFromCustomVarString('id');

        if ('' + details.label) {
            details.label = 'item|' + details.label;
            details.shareType = 'item';
        } else {
            details.label = 'folder';
            details.shareType = 'folder';
        }

        if (options.fromForm) {
            details.action = 'email a friend sent';
        } else {
            details.action = 'email a friend initiated';
            delete details.shareType;
        }

        return details;
    },
    _getActionBase: function () {
        return 'email a friend';
    },
    /**
     * validation error fields
     * @param options.errors {Array} fire one event for each error
     * @param [options.isOffer] {boolean} error relates to offer
     */

    fireValidationGAEvent: function (options) {
        options = _.extend({
            errors: []
        }, options);
        return options.errors.map(function (error) {
            return tracking.trackFormError({
                action: this._getActionBase(_.pick(options, 'isOffer')) + '|modal email form|' + error.name,
                label: error.message.toLowerCase()
            });
        }.bind(this));
    },

    fireDealerSendGAEvent: function (linkLocation) {
        return tracking.trackEvent({
            category: 'contact dealer',
            action: 'contact dealer send clicked',
            label: linkLocation
        });
    },

    fireAddToCartGAEvent: function () {
        return purchaseTracking.ecommerceAddToCartTracking({
            id: SV.get('data.pk'),
            name: SV.get('data.titleCondensed'),
            brand: SV.get('tracking.initialDataLayerInfo.dealerID'),
            price: SV.get('tracking.initialDataLayerInfo.askingPrice'),
            category: SV.get('tracking.initialDataLayerInfo.pageSection').replace(' ', '-').toLowerCase()
        });
    },

    /**
     * fire offer related event
     * @param {string} options.action ga action
     * @param {boolean} [options.prependOfferLowMsg] prepend lowball offer error copy to action
     * @param {boolean} [options.isError]
     */
    fireOfferGAEvent: function (options) {
        var actionVal = [];
        var event;
        var label;
        options = _.extend({
            action: undefined,
            prependOfferLowMsg: undefined,
            isError: undefined
        }, options);
        event = options.isError ? 'Offer Errors' : 'Offer Actions';
        label = [
            'neg=' + this._getValueFromCustomVarString('neg'),
            //MONEY-14 need to get fresh shipping and return info from custom var since PDPs cached
            'ship=' + this._getValueFromCustomVarString('ship'),
            'ret=' + this._getValueFromCustomVarString('ret')
        ].join('|');

        if (options.prependOfferLowMsg) {
            actionVal.push(copyText.get('contactDealer.lowballTitle'));
            if (options.action) {
                // if there's a header and an action value, make sure to add a separator
                actionVal.push(' - ');
            }
        }
        // if there is no `action` variable, the action will become an empty string
        actionVal.push(options.action || '');
        return tracking.trackEvent({
            category: event,
            action: actionVal.join(''),
            label: label
        });
    },

    /**
     * pull values from custom var.
     * If key=A, customVar4='A=x|B=y|C=z', it will return x
     * @param key {string} search key
     * @returns {String|Boolean}
     */
    _getValueFromCustomVarString: function (key) {
        return strings.getFromDelimitedString(this._customVar4, key, '\\|');
    }
});
module.exports.Dealer = function () {
    return ModalEmailTracking.apply(this, arguments);
};
module.exports.Dealer.prototype = _.extend({}, ModalEmailTracking.prototype, {
    _getActionBase: function (options) {
        options = _.extend({
            isOffer: undefined
        }, options);
        return options.isOffer ? 'offer' : 'contact dealer';
    },
    _subType: 'Contact Dealer Modal',
    /**
     * @param linkLocation where was link/button located that launched the modal
     * @param form flag that determines if form was submitted or contact dealer or email friend was clicked
     * @value if true indicates that user has shared email with the dealer
     * @returns details about dealer needed for fireContactGAEvent
     */
    _details: function (options) {
        var details = {
            event: 'contact dealer',
            label: options.linkLocation,
            action: 'contact dealer clicked'
        };
        if (!options.fromForm) {
            return details;
        }
        $.publish('ga:visitor:contactDealer'); // TODO: remove this line if it is in any way related to tracking
        return _.extend(details, {
            action: 'contact dealer submitted',
            additional: {
                contactDealerStatus: 'dealer contacted'
            }
        });
    }
});


/***/ }),
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPriceAmountByCurrency = exports.isPriceHidden = exports.isNegotiable = exports.getAmount = exports.getNegotiable = exports.getHidePrice = undefined;

var _createSelector = __webpack_require__(627);

var _createSelector2 = _interopRequireDefault(_createSelector);

var _makeSelectorHelpers = __webpack_require__(802);

var _amount = __webpack_require__(1218);

var _lodash = __webpack_require__(803);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getHidePrice = exports.getHidePrice = function getHidePrice(price) {
  return (0, _lodash2.default)(price, 'hidePrice');
};
var getNegotiable = exports.getNegotiable = function getNegotiable(price) {
  return (0, _lodash2.default)(price, 'negotiable');
};
var getAmount = exports.getAmount = function getAmount(price) {
  return (0, _lodash2.default)(price, 'amount', {});
};

// Selectors
// ------------------------------------------

var isNegotiable = exports.isNegotiable = (0, _makeSelectorHelpers.makeYesCheckSelector)(getNegotiable);
var isPriceHidden = exports.isPriceHidden = (0, _makeSelectorHelpers.makeYesCheckSelector)(getHidePrice);
var getPriceAmountByCurrency = exports.getPriceAmountByCurrency = (0, _createSelector2.default)(getAmount, _amount.getAmountByCurrency);

/***/ }),
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(40);
var Relay = __webpack_require__(18);

var _require = __webpack_require__(271),
    Provider = _require.Provider;

var _require2 = __webpack_require__(370),
    combineReducers = _require2.combineReducers,
    createStore = _require2.createStore,
    applyMiddleware = _require2.applyMiddleware;

var _require3 = __webpack_require__(493),
    NetPriceModal = _require3.NetPriceModal,
    ModalWrapper = _require3.ModalWrapper,
    reducers = _require3.reducers;

var fields = reducers.fields,
    modalWrapper = reducers.modalWrapper,
    tracking = reducers.tracking,
    validation = reducers.validation;

var store = createStore(combineReducers({ fields: fields, modalWrapper: modalWrapper, tracking: tracking, validation: validation }), applyMiddleware(__webpack_require__(545).default));

var _require4 = __webpack_require__(268),
    track = _require4.track;

var modalContainer = document.createElement('div');

var _require5 = __webpack_require__(334),
    getUserId = _require5.getUserId,
    cookieJarConstants = _require5.cookieJarConstants;

var getEnvironment = __webpack_require__(482).default.getEnvironment;

module.exports = function (options) {
    var item = options.item,
        itemPk = options.itemPk,
        currency = options.currency,
        linkLocation = options.linkLocation;


    var sellerId = item.get('seller.id');
    var userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);

    var queryConfig = {
        queries: {
            viewer: function viewer(Component, params) {
                return function (RQL_0) {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_0)]),
                        fieldName: 'viewer',
                        kind: 'Query',
                        metadata: {},
                        name: 'NetPriceLauncher',
                        type: 'Viewer'
                    };
                }(Component.getFragment('viewer', params));
            }
        },
        name: 'NetPriceModalRoute',
        params: {
            userId: userId,
            sellerId: sellerId,
            itemId: itemPk,
            shouldFetchItem: !!itemPk,
            shouldFetchUser: !!userId,
            shouldFetchBuyerItemConv: !!itemPk && !!userId
        }
    };

    ReactDOM.render(React.createElement(
        Provider,
        { store: store },
        React.createElement(Relay.Renderer, {
            Container: NetPriceModal,
            environment: getEnvironment(),
            queryConfig: queryConfig,
            render: function render(_ref) {
                var done = _ref.done,
                    error = _ref.error,
                    props = _ref.props;

                if (error) {
                    return React.createElement(ModalWrapper, {
                        openOnRender: true,
                        isError: true
                    });
                } else if (done && props) {
                    var netPriceProps = Object.assign({}, props, {
                        chatTracking: track,
                        currency: currency,
                        linkLocation: linkLocation
                    });
                    return React.createElement(NetPriceModal, netPriceProps);
                } else {
                    return React.createElement(ModalWrapper, {
                        openOnRender: true,
                        isLoading: true
                    });
                }
            }
        })
    ), modalContainer);
};

/***/ }),
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tracking = __webpack_require__(27);
var get = __webpack_require__(14);

var getProp = function getProp(list, prop) {
    return list.reduce(function (prev, listItem) {
        if (listItem[prop]) {
            prev.push(listItem[prop]);
        }
        return prev;
    }, []);
};

var getCategory = function getCategory() {
    var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var inflatedCategories = categories.length ? categories[categories.length - 1] : false;
    return inflatedCategories ? getProp(inflatedCategories, 'label').join('/') : undefined;
};

var getItemData = function getItemData() {
    var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var index = arguments[1];

    var item = product.item || {};
    var id = item.id,
        name = item.title;

    return {
        name: name,
        id: id,
        category: getCategory(get(item, 'classification.inflatedCategories')),
        brand: get(item, 'seller.id'),
        price: get(item, 'pricing.totalAmount.convertedAmounts.USD'),
        position: index + 1,
        list: 'cart'
    };
};

var getProducts = function getProducts(portfolioItems) {
    return portfolioItems.map(function (product, index) {
        var productJson = product;
        if (typeof product.toJSON === 'function') {
            productJson = product.toJSON();
        }
        return getItemData(productJson, index);
    });
};

module.exports = {
    trackPageView: function trackPageView(_ref) {
        var pageType = _ref.pageType,
            pageSubType = _ref.pageSubType;

        tracking.trackPageview({
            pageType: pageType,
            pageSubType: pageSubType
        });
    },

    trackEcommerce: function trackEcommerce(type, portfolioItems) {
        var obj = {
            type: type,
            products: getProducts(Array.isArray(portfolioItems) ? portfolioItems : [portfolioItems])
        };

        if (type === 'productClick') {
            obj.actionField = {
                list: 'cart'
            };
        }

        tracking.trackEcommerce(obj);
    },
    trackBackToShopping: function trackBackToShopping() {
        tracking.trackEvent({
            'category': 'cart actions',
            'action': 'back to shopping click'
        });
    }
};

/***/ }),
/* 966 */,
/* 967 */,
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var variants = exports.variants = {
    OPOP: 'opop',
    CONTACT1: 'contact1',
    CONTACT2: 'contact2',
    CONTACT3: 'contact3',
    CONTROL: 'control'
};

/***/ }),
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(97);
var ConnectedBaseView = __webpack_require__(523);

var _require = __webpack_require__(709),
    connectGalleryStoreToView = _require.connectGalleryStoreToView;

var GalleryMobileNavWrapper = __webpack_require__(1073);
var GalleryPhotoWrapper = __webpack_require__(1074);
var GalleryArrowBox = __webpack_require__(1072);
var PhotoDetails = __webpack_require__(1075);

var _require2 = __webpack_require__(342),
    classes = _require2.classes;

/**
 * GalleryWrapperView
 * Top Level Connected Wrapper for views on Gallery Page
 */


var GalleryWrapperView = connectGalleryStoreToView(ConnectedBaseView).extend({
    el: '.' + classes.GALLERY,

    /**
     * Props Object set by getPropsFromStore()
     *
     * @property {object} props
     * @property {bool}   props.isSetup
     * @property {string} [props.titleTag]
     * @property {string} [props.photoTitle]
     * @property {object} [props.photoFirm]
     * @property {object} [props.photoProject]
     * @property {array}  [props.photoAttrTags]
     */
    props: {},
    isModal: false, // set to true in GalleryModalWrapper
    pageType: '', // set in GalleryModalWrapper
    subViewsAreInitialized: false,
    subViewConfig: {
        mobileNav: {
            construct: GalleryMobileNavWrapper,
            singleton: true
        },
        photo: {
            construct: GalleryPhotoWrapper,
            singleton: true
        },
        arrows: {
            construct: GalleryArrowBox
        },
        details: {
            construct: PhotoDetails,
            singleton: true
        }
    },

    /**
     * Initializes each of the subviews and passes each the context
     */
    _initSubViews: function _initSubViews() {
        this.subs.add('mobileNav', { context: this.context, isModal: this.isModal });
        this.subs.add('photo', { context: this.context, isModal: this.isModal, pageType: this.pageType });
        this.subs.add('arrows', { context: this.context, isModal: this.isModal, pageType: this.pageType });
        this.subs.add('details', { context: this.context });
    },


    /**
     * Processes galleryStore and sets props before render
     * @see /gallery/stores/GalleryStore
     */
    getPropsFromStores: function getPropsFromStores(galleryStore) {
        var isSetup = galleryStore.isSetup();

        if (!isSetup) {
            return { isSetup: isSetup };
        }

        return {
            isSetup: isSetup,
            titleTag: galleryStore.getCurrentPageTitleTag(),
            showDetailsMobile: galleryStore.showDetailsMobile(),

            // props passed to PhotoDetails.es.js
            photoTitle: galleryStore.getCurrentPhotoTitle(),
            photoFirm: galleryStore.getPhotoFirm(),
            photoProject: galleryStore.getPhotoProject(),
            photoAttrTags: galleryStore.getCurrentPhotoTags(),
            photoCaption: galleryStore.getCurrentPhotoCaption(),
            similarItemsTemplate: galleryStore.getSimilarItemsTemplate(),
            moreProjectsTemplate: galleryStore.getMoreProjectsTemplate()
        };
    },


    /**
     * Changes the title tag each time the galleryStore changes
     */
    render: function render() {
        if (this.props.isSetup) {
            if (!this.subViewsAreInitialized) {
                this._initSubViews();
                this.subViewsAreInitialized = true;
            }

            this._updateDetails()._updateTitleTag();
        }
    },


    /**
     * Updates the gallery details
     * @returns {GalleryWrapperView}
     * @private
     */
    _updateDetails: function _updateDetails() {
        var showDetailsMobile = this.props.showDetailsMobile;


        this.subs.get('details').passProps(this.props);

        if (showDetailsMobile) {
            this.$el.addClass(classes.STATE_SHOW_DETAILS);
        } else {
            this.$el.removeClass(classes.STATE_SHOW_DETAILS);
        }

        return this;
    },


    /**
     * Updates page's title
     * @returns {GalleryWrapperView}
     * @private
     */
    _updateTitleTag: function _updateTitleTag() {
        var titleTag = this.props.titleTag;


        if (root.document.title !== titleTag) {
            root.document.title = titleTag;
        }

        return this;
    }
});

module.exports = GalleryWrapperView;

/***/ }),
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-cart-open'].join(' '), viewBox: '0 0 250 250' },
                React.createElement(
                    'g',
                    null,
                    React.createElement('polygon', { points: '239.5,73.2 216.5,163 83.2,163 51.8,37 1,37 1,47 44,47 75.4,173 224.3,173 250.3,73.2' }),
                    React.createElement('circle', { cx: '107.3', cy: '201.7', r: '11.7' }),
                    React.createElement('circle', { cx: '193.3', cy: '201.7', r: '11.7' })
                )
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 8/21/14
 * Time: 11:07 AM
 */



var $ = __webpack_require__(5);
var scrollHelper = __webpack_require__(551);

/**
 * extend this onto a Validation form view to make it compatible with .com forms and validations
 * @type {{showValidationError: Function, hideValidationError: Function}}
 */
module.exports = {
    showValidationError: function (event, $input, obj) {
        var $field;
        var $err;
        var $errDiv;
        var dataTn;
        if ($input.attr('data-tn')) {
            dataTn = $input.attr('data-tn') + '-validation-error';
        } else {
            dataTn = 'validation-error-unknown-source';
        }


        if ($input) {
            $field = $input.parents('.com-form-input-wrapper').first();
            $err = $field.find('.err-message');
            if ($err.length) {
                $err.addClass('active').html(obj.message);
                $err.attr('data-tn', dataTn);

            } else {
                $errDiv = $('<div>').addClass('err-message active').attr('data-tn', dataTn).html(obj.message);
                $field.append($errDiv);
            }
            $input.addClass('err-message-field');
        }
    },
    hideValidationError: function (event, $input) {
        var $field;
        if ($input) {
            $field = $input.parents('.com-form-input-wrapper').first();
            $field.find('.err-message').removeClass('active').empty();
            $input.removeClass('err-message-field');
        }
    },
    scrollToFirstError: function ($err, offset) {
        var $field = $err.parent('.com-form-input-wrapper');

        offset = Math.abs(offset || 20) * -1;

        if (!$field.length) {
            return;
        }
        scrollHelper.scrollElToTop($field, offset);
    }
};


/***/ }),
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */
/***/ (function(module, exports) {

module.exports = {
	"DOMESTIC": "DOMESTIC",
	"LOCAL": "LOCAL",
	"title": "Shipping & Returns"
};

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = {
	"Standard Parcel": "Standard",
	"Express Parcel": "Express",
	"Front Door Freight": "Front Door"
};

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = {
	"buyerAssurance": "Purchases made on 1stdibs are covered by our buyer protection program.",
	"meta": {
		"title": "Buyer Protection on 1stdibs"
	},
	"staticMarketing": {
		"banner": "Buyer Protection on 1stdibs",
		"bannerImgAttrs": {
			"src": "/static/images/buyers/buyerAssuranceBannerImage.jpg",
			"alt": "Buyer Assurance Banner"
		},
		"description": [
			"We know buying unique pieces online requires trust. Thanks to our buyer protection program, you can shop world’s most iconic pieces and signature works with confidence. As long as you order via the 1stdibs secure checkout, your purchase will be fully protected.",
			"In the unlikely event you make a purchase through our secure checkout and receive an item that is significantly not as described or has been damaged in transit, we want to make it right <a href='#details'>(see details)</a>. Please email <a href='mailto:support@1stdibs.com' target='_blank'>support@1stdibs.com</a> within 7 days of receiving your item to let us know there is a problem, and we will work with you and the dealer to reach the best possible resolution, whether that be arranging for a return, a full refund, or a repair with a trusted restorer.",
			"Buyer protection is a part of our broader promise to 1stdibs customers."
		],
		"benefitsTitle": "The 1stdibs Promise: Shop With Confidence",
		"benefits": [
			{
				"name": "Buyer Protection",
				"description": "Guaranteed purchase protection when you check out on 1stdibs",
				"svgId": "buyer-assurance"
			},
			{
				"name": "Secure Online Transactions",
				"description": "Safe and secure payment through our checkout process",
				"svgId": "lock"
			},
			{
				"name": "Store-To-Door Shipping",
				"description": "Easy shipping around the world",
				"svgId": "truck-moving"
			},
			{
				"name": "Dedicated Customer Support",
				"description": "Timely answers to all your questions from our support specialists",
				"svgId": "customer-support"
			}
		]
	},
	"programDetails": [
		{
			"heading": "In order to qualify for our Buyer Protection Program, your purchase must meet the following criteria:",
			"details": [
				[
					"The order was placed online through our secure checkout",
					"The item was significantly not as described, damaged in transit or never arrived",
					"You reported the issue within 7 days of delivery date (or within 180 days of the purchase date if the item never arrived)"
				]
			]
		},
		{
			"heading": "The Buyer Protection Program does not apply if:",
			"details": [
				[
					"You are returning an accurately described item, outside of the dealer's stated return policy",
					"You elected to arrange your own shipping or pick the item up in person, and the item was damaged at pickup or during shipping",
					"You purchased the item directly from the dealer (e.g. in store) without using our secure checkout"
				]
			],
			"footer": [
				"For more detailed examples pertaining to buyer protection eligibility, please visit our <a href='https://support.1stdibs.com/s/article/Buyer-Protection-Guaranteed' target='_blank'>support center</a>."
			]
		}
	],
	"svgIcon": "buyer-assurance",
	"text": "Buyer Protection Guaranteed",
	"tooltip": {
		"title": "Buyer Protection",
		"text": "Purchases made on 1stdibs are covered by our buyer protection program. In the rare instance that a purchase doesn't meet your expectations, our team of specialists is here to help. <a href='/about/promise/' target='_blank'>View details.</a>"
	},
	"tradeTooltip": {
		"title": "Buyer Protection",
		"text": "Purchases made on 1stdibs are covered by our buyer protection program. In the rare instance that a purchase doesn't meet your expectations, our team of specialists is here to help. <a href='/trade/promise/' target='_blank'>View details.</a>"
	}
};

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = {
	"offerInfo": "The dealer may accept an offer below the list price of {price}.",
	"offerInfoQty": "The dealer may accept an offer below the list price of {price} per item.",
	"labelOffer": "Your Best Offer",
	"continueCta": "Continue",
	"makeOfferHeader": "Make an Offer",
	"makeOfferPlaceholderPdp": "Let the dealer know why you are interested.",
	"footer": "You will be prompted for your shipping and payment information, but you will not be charged unless your offer is accepted.",
	"lowBallHeader": "Make an Offer",
	"lowBallLabelHeading": "Warning: ",
	"lowBallLabel": "An offer significantly below the {type} price of {price} will likely be rejected. We recommend raising your offer.",
	"lowBallOtherOptionLabel": "Enter another offer",
	"lowBallOptionAmountOff": "{amountOff} off, {percentOff}% discount",
	"lowBallOriginalOffer": "(original offer)",
	"cta": "Continue",
	"header": "Make an Offer",
	"placeholderPdp": "Let the dealer know why you are interested."
};

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = {
	"meta": {
		"title": [
			"{photoStyle}",
			"{photoRoom}",
			"in {projectLocation}",
			"by {firmName}"
		]
	},
	"socialSharing": {
		"facebook": {
			"title": "Featured Project: {firmName}",
			"description": "Tour a {projectName} on 1stdibs"
		},
		"email": {
			"subject": "Design Inspiration on 1stdibs",
			"body": "Check out {firmName}'s {projectName} project on 1stdibs. {url}"
		},
		"pinterest": {
			"description": "See more of {firmName}'s {projectName} on 1stdibs"
		}
	}
};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var SolrCollection = __webpack_require__(1203);
var Transactions = module.exports = SolrCollection.extend();

var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var Transaction = __webpack_require__(20);
var Party = __webpack_require__(8);
var endpoints = __webpack_require__(6);
var root = typeof window === 'undefined' ? global : window;

// root.bunsen for console debugging
root.bunsen = root.bunsen || {};
root.bunsen.Transactions = Transactions;

_.extend(Transactions.prototype, {
    model: Transaction,
    url : endpoints.transactionsSolr(),
    params: {},
    defaultParams: {
        pageStart: 0,
        pageSize: 15,
        sort: 'createdDate desc'
    },

    /**
     * @memberof bunsen.Transactions
     * @param models
     * @param [options]
     */
    initialize : function (models, options) {
        this.options = options;
        this.resetParams();
    },
    inflateItems : function (fields) {
        var items = this.pluck('item');
        var fetches = [];

        _.each(items, function (item) {
            fetches.push(item.fetch({
                data: {
                    fields : fields || 'classification,measurement,condition,basic'
                }
            }));
        });
        return fetches;
    },
    /**
     * adds a "sameItemTransactions" property to each transaction with the
     * number of transactions that exist for the same item
     */
    getSameItemTransactions: function (options) {
        var searchTransactions = new Transactions();
        var self = this;
        var sellerId = this.getParam('sellerId', {filterQuery: true});
        var deferred = new $.Deferred();
        var itemIds = this.pluck('item.id').join(" ");

        // Only run this if there are actually some items (collection isn't empty)
        if (itemIds === '') {
            return null;
        }

        searchTransactions.setParam('viewName', 'dealer.preConfirmation');
        searchTransactions.setParam('itemId', itemIds, {filterQuery: true});
        searchTransactions.setParam('inflate', false);

        // Limit results to the current seller if we are already filtering by seller
        if (sellerId) {
            searchTransactions.setParam('sellerId', sellerId, {filterQuery: true});
        }

        $.when(searchTransactions.fetchWithParameters(options)).done(function () {
            var byId = searchTransactions.groupBy('item.id');
            self.each(function (transaction) {
                var itemId = transaction.get('item.id');
                if (byId[itemId]) {
                    transaction.sameItemTransactions = byId[itemId].length;
                } else {
                    transaction.sameItemTransactions = null;
                }
            });
            deferred.resolve();
        }).fail(function () {
            deferred.reject();
        });
        return deferred;
    },

    /**
     * adds conversations to a transaction depending on buyerId and itemId
     */
    setTransactionConversations: function (conversations) {
        var uniqueId = conversations.groupBy(function (c) {
            var buyerId = c.get('members').findWhere({ userType: Party.ROLE_BUYER }).get('user.id');
            return c.get('item.id') + buyerId;
        });
        this.forEach(function (transaction) {
            var itemId = transaction.get('item.id');
            var buyerId = transaction.get('buyer.id');
            if (uniqueId[itemId + buyerId]) {
                transaction.conversation = uniqueId[itemId + buyerId].pop();
            }
        });
        this.trigger('added:conversations');
    }
});

_.extend(Transactions, {
    /**
     * Check if the buyer has any private offers for this item
     * return a private offer transaction or a rejected promise if expired
     */
    fetchExistingOffer: function (itemId, buyerId) {
        var transactions = new Transactions();
        var transaction;
        var offer;
        var isExpired;

        transactions.setParam('itemId',  itemId,  { filterQuery: true });
        transactions.setParam('buyerId', buyerId, { filterQuery: true });
        transactions.setParam('viewName', 'buyer.checkoutOffer');

        return transactions.fetchWithParameters().then(function () {
            transaction = transactions.last();
            offer = transaction && transaction.getMostRecentOffer();
            isExpired = offer && offer.isExpired();
            if (offer && !isExpired) {
                return transaction;
            }
            return $.Deferred().reject({
                transaction: transaction,
                hasPrivateOffer: !!offer,
                isExpired: isExpired
            });
        });
    },
    /**
     * Does this buyer have any other valid active transactions for this item
     * @param itemId
     * @param buyerId
     */
    fetchExistingActiveTransactions: function (itemId, buyerId) {
        var transactions = new Transactions();
        transactions.setParam('itemId',  itemId,  {filterQuery : true});
        transactions.setParam('buyerId', buyerId, {filterQuery : true});
        transactions.setParam('sort', 'createdDate desc');
        transactions.setParam('viewName', 'buyer.existingTransaction');
        return transactions.fetchWithParameters().then(function () {
            return transactions;
        });
    },
    /**
     * Does this buyer have any active offer (buyer- or dealer- initiated) or order for this item
     * @param itemId
     * @param buyerId
     */
    fetchExistingActiveOffersAndOrders: function (itemId, buyerId) {
        var transactions = new Transactions();
        transactions.setParam('itemId',  itemId,  {filterQuery : true});
        transactions.setParam('buyerId', buyerId, {filterQuery : true});
        transactions.setParam('sort', 'createdDate desc');
        transactions.setParam('viewName', 'buyer.offersAndOrders');
        return transactions.fetchWithParameters().then(function () {
            return transactions;
        });
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-american-express'].join(' '), viewBox: '0 0 500 312' },
                React.createElement('rect', { className: 'dibsvg-color-holder', width: '500', height: '312', fill: '#F8F8F8' }),
                React.createElement(
                    'g',
                    { className: 'dibsvg-color-letters', fill: '#2E77BC', transform: 'translate(7.028 73.293)' },
                    React.createElement('path', { d: 'M430.17905 123.410308C433.3166 126.547858 434.36245 129.685408 434.36245 134.914659 434.36245 147.464859 427.041499 152.69411 413.445448 152.69411L387.299197 152.69411 387.299197 141.189759 413.445448 141.189759C415.537149 141.189759 417.628849 141.189759 418.674699 140.143909 419.720549 139.098059 420.766399 138.052209 420.766399 137.006359 420.766399 134.914659 419.720549 133.868809 418.674699 132.822959 417.628849 131.777108 416.582999 131.777108 413.445448 131.777108 400.895248 131.777108 385.207497 131.777108 385.207497 113.997657 385.207497 105.630857 390.436747 97.2640562 405.078648 97.2640562L432.27075 97.2640562 432.27075 108.768407 407.170348 108.768407C405.078648 108.768407 402.986948 108.768407 401.941098 109.814257 399.849398 110.860107 399.849398 112.951807 399.849398 113.997657 399.849398 116.089357 400.895248 117.135207 402.986948 118.181058 404.032798 118.181058 406.124498 119.226908 408.216198 119.226908L415.537149 119.226908C422.858099 119.226908 427.041499 120.272758 430.17905 123.410308L430.17905 123.410308 430.17905 123.410308zM482.471553 123.410308C485.609103 126.547858 486.654953 129.685408 486.654953 134.914659 486.654953 147.464859 479.334003 152.69411 465.737952 152.69411L439.5917 152.69411 439.5917 141.189759 465.737952 141.189759C467.829652 141.189759 469.921352 141.189759 470.967202 140.143909 472.013052 139.098059 473.058902 138.052209 473.058902 137.006359 473.058902 134.914659 472.013052 133.868809 470.967202 132.822959 469.921352 131.777108 468.875502 131.777108 465.737952 131.777108 453.187751 131.777108 437.5 131.777108 437.5 113.997657 437.5 105.630857 442.72925 97.2640562 457.371151 97.2640562L483.517403 97.2640562 483.517403 108.768407 458.417001 108.768407C456.325301 108.768407 454.233601 108.768407 453.187751 109.814257 452.141901 110.860107 451.096051 111.905957 451.096051 113.997657 451.096051 116.089357 452.141901 117.135207 454.233601 118.181058 455.279451 118.181058 457.371151 119.226908 459.462851 119.226908L466.783802 119.226908C474.104752 119.226908 479.334003 120.272758 482.471553 123.410308L482.471553 123.410308 482.471553 123.410308z' }),
                    React.createElement('path', { d: 'M316.181392 127.593708C319.318942 126.547858 325.594043 121.318608 325.594043 112.951807 325.594043 106.676707 322.456493 103.539157 318.273092 100.401606 314.089692 98.3099063 308.860442 97.2640562 301.539491 97.2640562L270.163989 97.2640562 270.163989 153.73996 284.80589 153.73996 284.80589 132.822959 299.447791 132.822959C304.677041 132.822959 307.814592 132.822959 309.906292 134.914659 311.997992 137.006359 311.997992 142.235609 311.997992 145.373159L311.997992 152.69411 325.594043 152.69411 325.594043 141.189759C325.594043 135.960509 325.594043 133.868809 323.502343 130.731258 321.410643 130.731258 319.318942 128.639558 316.181392 127.593708L316.181392 127.593708zM307.814592 120.272758C305.722892 121.318608 303.631191 121.318608 301.539491 121.318608L284.80589 121.318608 284.80589 108.768407 301.539491 108.768407C303.631191 108.768407 306.768742 108.768407 307.814592 109.814257 309.906292 110.860107 310.952142 112.951807 310.952142 115.043507 310.952142 117.135207 309.906292 119.226908 307.814592 120.272758L307.814592 120.272758zM241.926037 97.2640562L198.000335 97.2640562 180.220884 116.089357 163.487282 97.2640562 109.103079 97.2640562 109.103079 153.73996 163.487282 153.73996 181.266734 134.914659 198.000335 153.73996 224.146586 153.73996 224.146586 134.914659 240.880187 134.914659C252.384538 134.914659 264.934739 131.777108 264.934739 116.089357 264.934739 100.401606 252.384538 97.2640562 241.926037 97.2640562L241.926037 97.2640562zM156.166332 141.189759L122.69913 141.189759 122.69913 129.685408 153.028782 129.685408 153.028782 118.181058 122.69913 118.181058 122.69913 107.722557 157.212182 107.722557 171.854083 124.456158 156.166332 141.189759 156.166332 141.189759zM210.550535 148.51071L189.633534 125.502008 210.550535 103.539157 210.550535 148.51071 210.550535 148.51071zM241.926037 123.410308L224.146586 123.410308 224.146586 108.768407 241.926037 108.768407C247.155288 108.768407 250.292838 110.860107 250.292838 116.089357 250.292838 120.272758 247.155288 123.410308 241.926037 123.410308L241.926037 123.410308zM450.050201 56.4759036L431.2249 56.4759036 405.078648 14.6419009 405.078648 56.4759036 377.886546 56.4759036 372.657296 43.9257028 344.419344 43.9257028 339.190094 56.4759036 323.502343 56.4759036C317.227242 56.4759036 308.860442 55.4300535 303.631191 50.2008032 298.401941 46.0174029 295.264391 39.7423025 295.264391 29.2838019 295.264391 20.9170013 296.310241 13.5960509 302.585341 7.32095047 306.768742 3.1375502 314.089692 1.04585007 323.502343 1.04585007L337.098394 1.04585007 337.098394 12.5502008 324.548193 12.5502008C319.318942 12.5502008 317.227242 13.5960509 314.089692 15.687751 310.952142 18.8253012 309.906292 23.0087015 309.906292 29.2838019 309.906292 35.5589023 310.952142 39.7423025 314.089692 42.8798527 316.181392 44.9715529 320.364793 46.0174029 323.502343 46.0174029L329.777443 46.0174029 347.556894 1.04585007 368.473896 1.04585007 391.482597 54.3842035 391.482597 1.04585007 412.399598 1.04585007 436.45415 39.7423025 436.45415 1.04585007 450.050201 1.04585007 450.050201 56.4759036 450.050201 56.4759036zM366.382195 32.4213521L356.969545 10.4585007 347.556894 32.4213521 366.382195 32.4213521 366.382195 32.4213521z' }),
                    React.createElement('path', { d: 'M257.613788,30.3296519 C260.751339,29.2838019 267.026439,24.0545515 267.026439,15.687751 C267.026439,9.4126506 264.934739,6.2751004 259.705489,3.1375502 C255.522088,1.04585007 250.292838,3.90798505e-14 242.971888,3.90798505e-14 L211.596386,3.90798505e-14 L211.596386,56.4759036 L225.192436,56.4759036 L225.192436,35.5589023 L239.834337,35.5589023 C245.063588,35.5589023 248.201138,35.5589023 249.246988,37.6506024 C251.338688,40.7881526 251.338688,44.9715529 251.338688,48.1091031 L251.338688,55.4300535 L264.934739,55.4300535 L264.934739,43.9257028 C264.934739,38.6964525 264.934739,36.6047523 262.843039,33.4672021 C262.843039,33.4672021 260.751339,32.4213521 257.613788,30.3296519 L257.613788,30.3296519 Z M249.246988,24.0545515 C247.155288,25.1004016 245.063588,25.1004016 242.971888,25.1004016 L226.238286,25.1004016 L226.238286,12.5502008 L242.971888,12.5502008 C245.063588,12.5502008 248.201138,12.5502008 249.246988,13.5960509 C251.338688,14.6419009 252.384538,15.687751 252.384538,18.8253012 C252.384538,20.9170013 251.338688,23.0087015 249.246988,24.0545515 L249.246988,24.0545515 Z' }),
                    React.createElement('path', { d: 'M147.799531,56.4759036 L134.203481,56.4759036 L134.203481,12.5502008 L114.332329,56.4759036 L102.827979,56.4759036 L81.9109772,12.5502008 L81.9109772,56.4759036 L54.7188755,56.4759036 L49.4896252,43.9257028 L21.2516734,43.9257028 L16.022423,56.4759036 L0.334672021,56.4759036 L24.3892236,3.90798505e-14 L44.2603748,3.90798505e-14 L67.2690763,53.3383534 L67.2690763,1.04585007 L89.2319277,1.04585007 L107.011379,38.6964525 L123.74498,1.04585007 L146.753681,1.04585007 L147.799531,56.4759036 L147.799531,56.4759036 L147.799531,56.4759036 Z M44.2603748,32.4213521 L34.8477242,10.4585007 L25.4350736,32.4213521 L44.2603748,32.4213521 L44.2603748,32.4213521 Z' }),
                    React.createElement('polygon', { points: '332.915 97.264 378.932 97.264 378.932 108.768 346.511 108.768 346.511 119.227 377.887 119.227 377.887 130.731 346.511 130.731 346.511 141.19 378.932 141.19 378.932 153.74 332.915 153.74' }),
                    React.createElement('polygon', { points: '275.393 1.046 288.989 1.046 288.989 56.476 275.393 56.476' }),
                    React.createElement('polygon', { points: '203.23 56.476 157.212 56.476 157.212 1.046 203.23 1.046 203.23 12.55 170.808 12.55 170.808 23.009 202.184 23.009 202.184 34.513 170.808 34.513 170.808 44.972 203.23 44.972' })
                )
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-check'].join(' '), viewBox: '0 0 500 312' },
                React.createElement('rect', { className: 'dibsvg-color-holder', width: '500', height: '312', fill: '#F8F8F8' }),
                React.createElement('path', { className: 'dibsvg-color-letters', d: 'M446.339807,190.42907 L420.193555,155.916018 L412.872605,164.282819 L412.872605,190.42907 L399.276554,190.42907 L399.276554,107.806915 L412.872605,107.806915 L412.872605,147.549218 L444.248107,107.806915 L460.981708,107.806915 L429.606206,146.503368 L464.119258,190.42907 L446.339807,190.42907 Z M303.058348,149.640918 C303.058348,124.540516 320.837799,106.761065 344.892351,106.761065 C360.580102,106.761065 371.038602,115.127866 376.267853,125.586366 L364.763502,131.861467 C360.580102,125.586366 353.259151,120.357116 344.892351,120.357116 C329.2046,120.357116 317.700249,132.907317 317.700249,149.640918 C317.700249,166.374519 329.2046,178.92472 344.892351,178.92472 C353.259151,178.92472 360.580102,173.695469 364.763502,167.420369 L376.267853,173.695469 C369.992752,183.10812 360.580102,192.520771 344.892351,192.520771 C320.837799,191.474921 303.058348,174.741319 303.058348,149.640918 Z M226.711293,190.42907 L226.711293,107.806915 L281.095497,107.806915 L281.095497,120.357116 L240.307344,120.357116 L240.307344,142.319967 L280.049647,142.319967 L280.049647,154.870168 L240.307344,154.870168 L240.307344,177.87887 L281.095497,177.87887 L281.095497,190.42907 L226.711293,190.42907 Z M33.2290307,149.640918 C33.2290307,124.540516 51.0084818,106.761065 75.0630334,106.761065 C90.7507844,106.761065 101.209285,115.127866 106.438535,125.586366 L94.9341847,131.861467 C90.7507844,124.540516 83.4298339,119.311266 75.0630334,119.311266 C59.3752824,119.311266 47.8709316,131.861467 47.8709316,148.595068 C47.8709316,165.328669 59.3752824,178.92472 75.0630334,178.92472 C83.4298339,178.92472 90.7507844,173.695469 94.9341847,167.420369 L106.438535,173.695469 C100.163435,183.10812 90.7507844,192.520771 75.0630334,192.520771 C51.0084818,191.474921 33.2290307,174.741319 33.2290307,149.640918 Z M183.83144,190.42907 L183.83144,154.870168 L143.043288,154.870168 L143.043288,190.42907 L129.447237,190.42907 L129.447237,107.806915 L143.043288,107.806915 L143.043288,142.319967 L183.83144,142.319967 L183.83144,107.806915 L198.473341,107.806915 L198.473341,190.42907 L183.83144,190.42907 Z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-discover'].join(' '), viewBox: '0 0 500 312' },
                React.createElement('rect', { className: 'dibsvg-color-holder', width: '500', height: '312', fill: '#F8F8F8' }),
                React.createElement('path', { className: 'dibsvg-color-triangle', fill: '#F6821F', d: 'M500,311.122244 L500,178.565464 C466.599866,199.440548 341.349365,271.459586 136.773547,311.122244 L500,311.122244 L500,311.122244 Z' }),
                React.createElement('path', { className: 'dibsvg-color-circle', fill: '#F6821F', d: 'M0,31.3126253 C0,48.0126921 12.5250501,60.5377422 28.1813627,60.5377422 C43.8376754,60.5377422 56.3627255,48.0126921 56.3627255,31.3126253 C56.3627255,15.6563126 43.8376754,3.13126253 28.1813627,3.13126253 C12.5250501,3.13126253 0,15.6563126 0,31.3126253 L0,31.3126253 Z', transform: 'translate(228.624 112.809)' }),
                React.createElement(
                    'g',
                    { className: 'dibsvg-color-letters', fill: '#202020', transform: 'translate(81.162 115.23)' },
                    React.createElement('path', { d: 'M332.206079 2.79726119C330.11857 2.79726119 328.031062 4.88476954 328.031062 6.97227789 328.031062 9.05978624 330.11857 11.1472946 332.206079 11.1472946 334.293587 11.1472946 336.381096 9.05978624 336.381096 6.97227789 336.381096 4.88476954 334.293587 2.79726119 332.206079 2.79726119L332.206079 2.79726119 332.206079 2.79726119zM332.206079 10.1035404C330.11857 10.1035404 329.074816 9.05978624 329.074816 6.97227789 329.074816 4.88476954 330.11857 3.84101536 332.206079 3.84101536 334.293587 3.84101536 335.337341 5.92852371 335.337341 6.97227789 335.337341 9.05978624 334.293587 10.1035404 332.206079 10.1035404L332.206079 10.1035404 332.206079 10.1035404zM326.987308 18.4535738C326.987308 8.01603206 319.681029 1.75350701 308.199733 1.75350701L292.54342 1.75350701 292.54342 57.0724783 302.980962 57.0724783 302.980962 35.1536406 304.024716 35.1536406 318.637275 57.0724783 331.162325 57.0724783 314.462258 34.1098864C322.812291 32.0223781 326.987308 26.8036072 326.987308 18.4535738L326.987308 18.4535738 326.987308 18.4535738zM306.112224 27.8473614L302.980962 27.8473614 302.980962 11.1472946 306.112224 11.1472946C312.374749 11.1472946 315.506012 14.2785571 315.506012 19.497328 316.549766 24.7160989 312.374749 27.8473614 306.112224 27.8473614L306.112224 27.8473614 306.112224 27.8473614z' }),
                    React.createElement('path', { d: 'M102.58016 29.9348697C102.58016 46.6349365 115.10521 59.1599866 130.761523 59.1599866 134.93654 59.1599866 139.111556 58.1162325 143.286573 56.0287241L143.286573 43.503674C139.111556 47.6786907 135.980294 49.7661991 130.761523 49.7661991 120.323981 49.7661991 113.017702 41.4161657 113.017702 30.9786239 113.017702 20.5410822 120.323981 12.1910488 130.761523 12.1910488 135.980294 12.1910488 139.111556 14.2785571 143.286573 18.4535738L143.286573 5.92852371C139.111556 3.84101536 134.93654 2.79726119 130.761523 2.79726119 115.10521.709752839 102.58016 13.2348029 102.58016 29.9348697M83.7925852 23.6723447C77.5300601 21.5848363 75.4425518 19.497328 75.4425518 16.3660655 75.4425518 13.2348029 78.5738143 10.1035404 82.748831 10.1035404 85.8800935 10.1035404 87.9676019 11.1472946 91.0988644 14.2785571L96.3176353 6.97227789C92.1426186 2.79726119 86.9238477.709752839 80.6613226.709752839 71.2675351.709752839 63.9612558 6.97227789 63.9612558 16.3660655 63.9612558 23.6723447 67.0925184 27.8473614 76.4863059 30.9786239 80.6613226 32.0223781 82.748831 33.0661323 83.7925852 34.1098864 85.8800935 35.1536406 86.9238477 37.241149 86.9238477 39.3286573 86.9238477 43.503674 83.7925852 46.6349365 78.5738143 46.6349365 73.3550434 46.6349365 70.2237809 44.5474282 67.0925184 39.3286573L60.8299933 45.5911824C66.0487642 52.8974616 71.2675351 56.0287241 79.6175685 56.0287241 90.0551102 56.0287241 97.3613894 48.7224449 97.3613894 38.2849031 99.4488978 32.0223781 95.2738811 27.8473614 83.7925852 23.6723447' }),
                    React.createElement('path', { d: 'M14.9048096,1.75350701 L0.292251169,1.75350701 L0.292251169,57.0724783 L14.9048096,57.0724783 C23.254843,57.0724783 28.4736139,54.9849699 33.6923848,50.8099532 C39.9549098,45.5911824 43.0861723,37.241149 43.0861723,29.9348697 C44.1299265,13.2348029 31.6048764,1.75350701 14.9048096,1.75350701 L14.9048096,1.75350701 L14.9048096,1.75350701 Z M27.4298597,43.503674 C24.2985972,46.6349365 20.1235805,47.6786907 12.8173013,47.6786907 L10.7297929,47.6786907 L10.7297929,11.1472946 L13.8610554,11.1472946 C20.1235805,11.1472946 24.2985972,12.1910488 28.4736139,15.3223113 C31.6048764,18.4535738 33.6923848,23.6723447 33.6923848,28.8911156 C32.6486306,35.1536406 30.5611222,40.3724115 27.4298597,43.503674 L27.4298597,43.503674 L27.4298597,43.503674 Z' }),
                    React.createElement('polyline', { points: '257.056 57.072 286.281 57.072 286.281 47.679 267.493 47.679 267.493 33.066 285.237 33.066 285.237 23.672 267.493 23.672 267.493 11.147 286.281 11.147 286.281 1.754 257.056 1.754 257.056 57.072' }),
                    React.createElement('polyline', { points: '226.787 39.329 212.174 1.754 201.737 1.754 223.656 58.116 228.874 58.116 251.837 1.754 240.356 1.754 226.787 39.329' }),
                    React.createElement('polygon', { points: '48.305 1.754 58.742 1.754 58.742 57.072 48.305 57.072' })
                )
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-mastercard'].join(' '), viewBox: '0 0 500 312' },
                React.createElement('rect', { className: 'dibsvg-color-holder', width: '500', height: '312', fill: '#F8F8F8' }),
                React.createElement('rect', { className: 'dibsvg-color-middle', fill: '#FF5F00', width: '102.882', height: '167.813', x: '198.707', y: '45.126' }),
                React.createElement('path', { className: 'dibsvg-color-letter', fill: '#000000', d: 'M139.705882,289.433112 L139.705882,271.643738 C139.705882,264.824478 135.555028,260.377135 128.735769,260.377135 C125.177894,260.377135 121.323529,261.563093 118.655123,265.417457 C116.579696,262.156072 113.614801,260.377135 109.167457,260.377135 C106.202562,260.377135 102.941176,261.266603 100.56926,264.527989 L100.56926,260.970114 L94.9359583,260.970114 L94.9359583,289.433112 L100.56926,289.433112 L100.56926,273.126186 C100.56926,268.085863 103.534156,265.713947 107.685009,265.713947 C111.835863,265.713947 114.20778,268.382353 114.20778,273.126186 L114.20778,289.433112 L119.841082,289.433112 L119.841082,273.126186 C119.841082,268.085863 122.805977,265.713947 126.956831,265.713947 C131.107685,265.713947 133.479602,268.382353 133.479602,273.126186 L133.479602,289.433112 L139.705882,289.433112 Z M232.210626,261.266603 L221.833491,261.266603 L221.833491,252.668406 L216.20019,252.668406 L216.20019,261.266603 L210.270398,261.266603 L210.270398,266.306926 L216.20019,266.306926 L216.20019,279.648956 C216.20019,286.171727 218.572106,290.026091 225.687856,290.026091 C228.356262,290.026091 231.321157,289.136622 233.396584,287.950664 L231.617647,282.910342 C229.83871,284.0963 227.763283,284.392789 226.280835,284.392789 C223.315939,284.392789 221.833491,282.613852 221.833491,279.648956 L221.833491,266.010436 L232.210626,266.010436 L232.210626,261.266603 Z M284.985769,260.377135 C281.427894,260.377135 278.759488,262.156072 277.27704,264.527989 L277.27704,260.970114 L271.643738,260.970114 L271.643738,289.433112 L277.27704,289.433112 L277.27704,273.422676 C277.27704,268.678843 279.648956,265.713947 283.503321,265.713947 C284.689279,265.713947 286.171727,266.010436 287.357685,266.306926 L289.136622,260.970114 C287.950664,260.673624 286.171727,260.377135 284.985769,260.377135 L284.985769,260.377135 Z M205.230076,263.34203 C202.26518,261.266603 198.114326,260.377135 193.666983,260.377135 C186.551233,260.377135 182.10389,263.63852 182.10389,269.271822 C182.10389,274.015655 185.365275,276.684061 191.591556,277.573529 L194.556452,277.870019 C197.817837,278.462998 199.893264,279.648956 199.893264,281.131404 C199.893264,283.206831 197.521347,284.689279 193.074004,284.689279 C188.62666,284.689279 185.661765,283.206831 183.586338,281.724383 L180.621442,286.171727 C184.772296,289.136622 189.812619,289.729602 192.777514,289.729602 C201.079222,289.729602 205.526565,285.875237 205.526565,280.538425 C205.526565,275.498102 201.968691,273.126186 195.74241,272.236717 L192.777514,271.940228 C190.109108,271.643738 187.737192,270.754269 187.737192,268.975332 C187.737192,266.899905 190.109108,265.417457 193.370493,265.417457 C196.928368,265.417457 200.486243,266.899905 202.26518,267.789374 L205.230076,263.34203 Z M291.212049,275.201613 C291.212049,283.79981 296.845351,290.026091 306.036528,290.026091 C310.187381,290.026091 313.152277,289.136622 316.117173,286.764706 L313.152277,282.317362 C310.780361,284.0963 308.408444,284.985769 305.740038,284.985769 C300.699715,284.985769 296.845351,281.131404 296.845351,275.498102 C296.845351,269.864801 300.699715,266.010436 305.740038,266.010436 C308.408444,266.010436 310.780361,266.899905 313.152277,268.678843 L316.117173,264.231499 C313.152277,261.859583 310.187381,260.970114 306.036528,260.970114 C297.141841,260.377135 291.212049,266.603416 291.212049,275.201613 L291.212049,275.201613 Z M251.482448,260.377135 C243.18074,260.377135 237.547438,266.306926 237.547438,275.201613 C237.547438,284.0963 243.47723,290.026091 252.075427,290.026091 C256.226281,290.026091 260.377135,288.840133 263.63852,286.171727 L260.673624,282.020873 C258.301708,283.79981 255.336812,284.985769 252.371917,284.985769 C248.517552,284.985769 244.366698,282.613852 243.773719,277.573529 L264.824478,277.573529 L264.824478,275.201613 C264.824478,266.306926 259.487666,260.377135 251.482448,260.377135 L251.482448,260.377135 Z M251.185958,265.713947 C255.336812,265.713947 258.301708,268.382353 258.598197,272.829696 L243.18074,272.829696 C244.070209,268.678843 246.738615,265.713947 251.185958,265.713947 L251.185958,265.713947 Z M174.395161,275.201613 L174.395161,260.970114 L168.76186,260.970114 L168.76186,264.527989 C166.686433,261.859583 163.721537,260.377135 159.570683,260.377135 C151.565465,260.377135 145.635674,266.603416 145.635674,275.201613 C145.635674,283.79981 151.565465,290.026091 159.570683,290.026091 C163.721537,290.026091 166.686433,288.543643 168.76186,285.875237 L168.76186,289.433112 L174.395161,289.433112 L174.395161,275.201613 Z M151.565465,275.201613 C151.565465,269.864801 154.82685,265.713947 160.460152,265.713947 C165.796964,265.713947 169.058349,269.864801 169.058349,275.201613 C169.058349,280.834915 165.500474,284.689279 160.460152,284.689279 C154.82685,284.985769 151.565465,280.538425 151.565465,275.201613 L151.565465,275.201613 Z M370.671252,260.377135 C367.113378,260.377135 364.444972,262.156072 362.962524,264.527989 L362.962524,260.970114 L357.329222,260.970114 L357.329222,289.433112 L362.962524,289.433112 L362.962524,273.422676 C362.962524,268.678843 365.33444,265.713947 369.188805,265.713947 C370.374763,265.713947 371.857211,266.010436 373.043169,266.306926 L374.822106,260.970114 C373.636148,260.673624 371.857211,260.377135 370.671252,260.377135 L370.671252,260.377135 Z M348.731025,275.201613 L348.731025,260.970114 L343.097723,260.970114 L343.097723,264.527989 C341.022296,261.859583 338.0574,260.377135 333.906546,260.377135 C325.901328,260.377135 319.971537,266.603416 319.971537,275.201613 C319.971537,283.79981 325.901328,290.026091 333.906546,290.026091 C338.0574,290.026091 341.022296,288.543643 343.097723,285.875237 L343.097723,289.433112 L348.731025,289.433112 L348.731025,275.201613 Z M325.901328,275.201613 C325.901328,269.864801 329.162713,265.713947 334.796015,265.713947 C340.132827,265.713947 343.394213,269.864801 343.394213,275.201613 C343.394213,280.834915 339.836338,284.689279 334.796015,284.689279 C329.162713,284.985769 325.901328,280.538425 325.901328,275.201613 L325.901328,275.201613 Z M405.95351,275.201613 L405.95351,249.70351 L400.320209,249.70351 L400.320209,264.527989 C398.244782,261.859583 395.279886,260.377135 391.129032,260.377135 C383.123814,260.377135 377.194023,266.603416 377.194023,275.201613 C377.194023,283.79981 383.123814,290.026091 391.129032,290.026091 C395.279886,290.026091 398.244782,288.543643 400.320209,285.875237 L400.320209,289.433112 L405.95351,289.433112 L405.95351,275.201613 Z M383.123814,275.201613 C383.123814,269.864801 386.385199,265.713947 392.018501,265.713947 C397.355313,265.713947 400.616698,269.864801 400.616698,275.201613 C400.616698,280.834915 397.058824,284.689279 392.018501,284.689279 C386.385199,284.985769 383.123814,280.538425 383.123814,275.201613 Z' }),
                React.createElement('path', { className: 'dibsvg-color-left', fill: '#EB001B', d: 'M209.08444,129.032258 C209.08444,94.9359583 225.094877,64.6940228 249.70351,45.1257116 C231.617647,30.8942125 208.787951,22.2960152 183.882827,22.2960152 C124.881404,22.2960152 77.1465844,70.0308349 77.1465844,129.032258 C77.1465844,188.033681 124.881404,235.768501 183.882827,235.768501 C208.787951,235.768501 231.617647,227.170304 249.70351,212.938805 C225.094877,193.370493 209.08444,163.128558 209.08444,129.032258 Z' }),
                React.createElement('path', { className: 'dibsvg-color-right', fill: '#F79E1B', d: 'M422.556926,129.032258 C422.556926,188.033681 374.822106,235.768501 315.820683,235.768501 C290.91556,235.768501 268.085863,227.170304 250,212.938805 C274.905123,193.370493 290.61907,163.128558 290.61907,129.032258 C290.61907,94.9359583 274.608634,64.6940228 250,45.1257116 C268.085863,30.8942125 290.91556,22.2960152 315.820683,22.2960152 C374.822106,22.2960152 422.556926,70.0308349 422.556926,129.032258 Z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    _classCallCheck(this, Component);

    return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
  }

  _createClass(Component, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'svg',
        { className: [this.props.className, 'dibsvg-svg dibsvg-paypal'].join(' '), viewBox: '0 0 500 312' },
        React.createElement('rect', { className: 'dibsvg-color-holder', width: '500', height: '312', fill: '#F8F8F8' }),
        React.createElement(
          'g',
          { className: 'dibsvg-color-left', fill: '#1C3664', transform: 'translate(0 33)' },
          React.createElement('path', { d: 'M240.529883,117.064558 C237.813712,117.064558 234.251136,114.876105 232.564722,112.231283 C232.564722,112.231283 214.395797,81.2193602 212.611311,78.1202906 C211.64125,76.4540101 210.658396,77.5132126 210.494232,78.1330265 C210.362048,78.8865674 204.863614,112.027508 204.863614,112.027508 C204.245333,114.69568 201.446014,116.986019 197.945266,116.975406 L186.615804,116.958425 C183.884709,116.958425 182.181239,114.780586 182.78886,112.148499 C182.78886,112.148499 191.449054,63.2765964 193.1376,51.7824445 C193.979741,45.4251065 193.050188,44.2979791 193.050188,44.2979791 L181.823063,24.8078032 C180.179289,22.1651034 181.078994,20 183.797297,20 L196.926168,20.0106133 C199.644472,20.0106133 203.245424,22.1651034 204.863614,24.8120485 L255.370752,109.860282 C255.370752,109.860282 260.20187,117.126114 255.745985,117.064558 C252.707881,117.022105 240.529883,117.064558 240.529883,117.064558', transform: 'matrix(1 0 0 -1 0 137.065)' }),
          React.createElement('path', { d: 'M145.313762,37.8366313 C143.740345,36.8495989 142.079515,36.0090293 140.337669,35.2873282 C137.99673,34.3512394 135.766655,33.8545392 133.719933,33.8545392 C130.577361,33.8545392 128.14901,34.3002958 126.5095,35.2448752 C124.872123,36.1470016 124.008662,37.7113949 124.036378,39.9529138 C124.036378,42.531934 124.641866,44.5442066 125.88056,46.1149679 C127.132045,47.6305403 128.980491,48.8510643 131.283054,49.757436 C133.579221,50.534326 136.404124,51.1626305 139.644768,51.6190004 C142.535763,51.9819736 148.258058,52.6357499 148.987203,52.6463632 C149.712083,52.6484858 150.200312,53.053912 149.874116,51.1138096 C149.733403,50.2711174 148.081102,43.5210891 147.324241,40.4559819 C147.096116,39.532629 145.868083,38.1932366 145.313762,37.8366313 Z M167.746692,85.2502733 C162.932631,87.9248128 155.40453,89.2748185 145.100562,89.2748185 C140.002944,89.2748185 134.884006,88.8715149 129.743748,88.075521 C125.96584,87.5045281 125.586343,87.4068861 123.241141,86.8995727 C118.418551,85.8509834 117.676614,81.0495482 117.676614,81.0495482 L116.12878,74.7070688 C115.252527,70.6549292 117.574278,70.8226186 118.604035,71.1367708 C120.704058,71.7693206 121.851075,72.3955025 126.144928,73.3676764 C130.242637,74.2910293 134.585526,74.9830133 138.041502,74.9596642 C143.119932,74.9596642 146.974592,74.4077751 149.539391,73.3422046 C152.108454,72.2278131 153.372732,70.3259184 153.372732,67.6131711 C153.389788,66.9678854 153.40258,66.3565621 153.174455,65.8280222 C152.959123,65.3270767 152.549779,64.8494803 151.336669,64.6881589 C144.102785,64.2530156 138.907095,63.5971166 132.636876,62.6886222 C126.460464,61.8225809 121.05797,60.3388482 116.538125,58.2862453 C111.721931,56.1593496 108.123111,53.3086301 105.643592,49.7043697 C103.217373,46.0831281 102.004264,41.6956097 102,36.5248334 C102,31.6427374 103.765298,27.6564 107.172238,24.565821 C110.626082,21.5134497 115.111815,20 120.544158,20 C123.940438,20.0233492 126.594781,20.2716993 128.505055,20.740805 C130.387613,21.2184013 132.444995,21.8870362 134.606846,22.823125 C136.235696,23.4981279 137.981806,24.4787923 139.832384,25.701439 C141.678698,26.9283309 142.966428,27.8007402 144.616598,28.8726787 L144.667766,28.7729141 L144.205121,26.7436603 C144.200857,26.7245565 144.175273,26.7118206 144.175273,26.6884714 L144.194461,26.6566317 C143.665724,24.2028478 145.138938,22.1693487 147.575817,21.9337345 L147.605665,21.8870362 L147.818865,21.8870362 L147.825261,21.8721777 C149.445583,21.8721777 154.995186,21.8806683 157.581305,21.8870362 L159.393507,21.8870362 C159.515031,21.8870362 159.532087,21.9273666 159.570463,21.9528384 C162.062774,22.264868 164.437825,24.2771406 165.004937,26.6884714 L174.264224,66.4817985 C174.47316,67.4157647 174.64372,68.4961937 174.737529,69.7379442 C174.861185,71.0009212 174.995501,72.0304066 174.959257,72.7754569 C174.980577,78.4110937 172.54583,82.5736112 167.746692,85.2502733 L167.746692,85.2502733 Z', transform: 'matrix(1 0 0 -1 0 109.275)' }),
          React.createElement('path', { d: 'M107.440926,74.250311 C105.865376,77.3111729 103.503118,79.7967965 100.488466,81.6732195 C97.3608185,83.5942181 93.7236223,84.9187519 89.4830694,85.7168685 C85.2169324,86.4789 80.2344426,86.8524865 74.518544,86.9034301 L48.0518652,86.8843262 C45.301582,86.8524865 42.6067309,84.7043643 41.9713941,82.0722778 L24.1244014,4.82690701 C23.5103847,2.18420726 25.2287787,1.42108547e-14 27.9684019,1.42108547e-14 L40.6474206,1.42108547e-14 C43.3891758,1.42108547e-14 46.1053469,2.1268957 46.7214957,4.82690701 L51.0899687,23.5720327 C51.6741374,26.1935059 54.3839126,28.3628547 57.1320638,28.3628547 L60.756468,28.3628547 C76.262522,28.3777132 88.289148,31.536217 96.932286,37.8574699 C105.562632,44.1659869 109.879937,52.5292295 109.858617,62.8707822 C109.879937,67.4132541 109.088964,71.214921 107.440926,74.250311 M80.0638824,49.0119978 C76.241202,46.2292031 70.9431758,44.8346218 64.0653358,44.8346218 L60.9568762,44.8346218 C58.217253,44.8346218 56.488199,46.9976025 57.0915557,49.6551608 L60.9078402,66.029286 C61.4898768,68.6677405 64.223104,70.856193 66.9627272,70.8307212 L71.111604,70.856193 C75.9576456,70.856193 79.6417459,70.030482 82.1276608,68.3875506 C84.5773317,66.7891949 85.8224211,64.2653635 85.7797811,60.8712456 C85.8522691,55.7599034 83.9057509,51.803283 80.0638824,49.0119978', transform: 'matrix(1 0 0 -1 0 86.903)' }),
          React.createElement('path', { d: 'M0,151 L231.996754,151 C235.312255,151 238,153.683013 238,156.994641 L238,238.005359 C238,241.316108 235.31937,244 231.996754,244 L0,244 L0,151 Z' })
        ),
        React.createElement(
          'g',
          { className: 'dibsvg-color-right', fill: '#336699', transform: 'translate(255 33)' },
          React.createElement('path', { d: 'M83.4576541,74.2525089 C81.8778402,77.3133708 79.4921295,79.7777679 76.475346,81.6966439 C73.3818104,83.6112745 69.7062381,84.9464216 65.4507611,85.7254343 C61.2421882,86.4598714 56.2383784,86.8801561 50.5374038,86.892892 L24.011029,86.8801561 C21.2799338,86.8334578 18.6000067,84.6980715 17.968934,82.0681077 L0.134733226,4.79938778 C-0.51552753,2.17366923 1.25829853,-0.0147833333 3.94035765,7.52194814e-05 L16.6684124,0.0234243739 C19.3675276,7.52194814e-05 22.1178108,2.17366923 22.7552795,4.79938778 L27.0576605,23.5508814 C27.6610172,26.1787226 30.4049044,28.3799111 33.1487916,28.3417034 L36.7667998,28.3417034 C52.2920418,28.3417034 64.3293278,31.5171884 72.9490139,37.8384413 C81.5473798,44.1915339 85.8753449,52.5250594 85.8753449,62.8899613 C85.8476288,67.415452 85.0737119,71.2277321 83.4576541,74.2525089 M56.0912703,48.9802332 C52.2920418,46.2292783 46.9599036,44.8495555 40.0991197,44.8495555 L36.943756,44.8495555 C34.2147928,44.8177158 32.4516268,47.014659 33.0997555,49.6488681 L36.903248,66.0484651 C37.4703606,68.6423439 40.2398318,70.8499003 42.930419,70.8286738 L47.0984838,70.8499003 C51.9637135,70.8286738 55.6030417,70.0178213 58.1166726,68.4067297 C60.5876635,66.7765342 61.7858489,64.2484576 61.8050369,60.8798114 C61.8156969,55.7451201 59.9075547,51.7948677 56.0912703,48.9802332', transform: 'matrix(1 0 0 -1 0 86.893)' }),
          React.createElement('path', { d: 'M186.516786,87.1817289 L175.172401,87.1817289 C175.166005,87.1817289 175.159609,87.1796063 175.155345,87.1796063 L175.148949,87.1817289 C172.55217,87.1817289 169.917015,85.2012961 169.181474,82.6817101 C169.151626,82.5798229 169.100458,82.4821809 169.077006,82.3760484 C169.077006,82.3760484 168.806242,81.1470338 168.337201,79.0222608 L152.754395,8.698853 C152.394087,7.10898785 152.15317,6.07313446 152.080682,5.80355786 L152.11053,5.76535015 C151.571134,3.30732099 153.055007,1.2738219 155.491886,1.04669831 L155.523866,1 L167.298916,1 C169.878639,1 172.496738,2.96132897 173.255731,5.44907524 C173.291975,5.57006631 173.349539,5.68256678 173.377255,5.80355786 L190.375711,82.3802937 L190.350127,82.3887843 C190.927899,85.0081349 189.232957,87.1817289 186.516786,87.1817289', transform: 'matrix(1 0 0 -1 0 88.182)' }),
          React.createElement('path', { d: 'M122.313762,37.2366252 C120.740345,36.2495928 119.077383,35.4047779 117.335537,34.6851994 C114.994598,33.7448653 112.775183,33.2524104 110.722065,33.2524104 C107.570965,33.2524104 105.14901,33.6960443 103.511632,34.6448691 C101.872123,35.5448728 101.012926,37.1092662 101.040642,39.3486624 C101.040642,41.9340506 101.639734,43.9399552 102.88056,45.5128391 C104.129913,47.0262889 105.986887,48.2446902 108.28945,49.1531846 C110.579221,49.9258293 113.395596,50.5626244 116.6469,51.0189943 C119.537895,51.3819675 125.253794,52.0378665 125.985071,52.0421118 C126.716347,52.0484797 127.202444,52.4496606 126.876248,50.5095582 C126.731271,49.666866 125.081102,42.921083 124.324241,39.8538532 C124.104644,38.9347455 122.876611,37.5953531 122.313762,37.2366252 Z M144.746692,84.6481446 C139.932631,87.3226841 132.402398,88.6748124 122.09843,88.6748124 C117.002944,88.6748124 111.881874,88.2672635 106.743748,87.4733923 C102.972236,86.898154 102.584211,86.8026347 100.241141,86.2953213 C95.4206831,85.2509773 94.6766142,80.4452968 94.6766142,80.4452968 L93.1287804,74.1070627 C92.2503954,70.0528004 94.5700141,70.2204898 95.6040353,70.5346421 C97.7083217,71.1671919 98.8489431,71.7954964 103.142796,72.763425 C107.246901,73.6910232 111.583394,74.3851299 115.043634,74.3575354 C120.1178,74.3575354 123.976724,73.8035237 126.541523,72.7379532 C129.108454,71.6235617 130.379128,69.7259123 130.379128,67.0110424 C130.387656,66.3657567 130.404712,65.756556 130.170191,65.2237708 C129.959123,64.7270706 129.554043,64.2473516 128.340933,64.0839075 C121.098521,63.6551321 115.900699,62.9971105 109.64114,62.0886161 C103.464728,61.2225747 98.0601022,59.7388421 93.5423889,57.6841165 C88.7261953,55.5572208 85.1231111,52.7107466 82.6393282,49.1043636 C80.2216374,45.4809994 79.006396,41.093481 79,35.9248273 C79,31.0406087 80.763166,27.0563939 84.17437,23.9636923 C87.626082,20.911321 92.1160792,19.3999939 97.5484216,19.3999939 C100.94257,19.4233431 103.599045,19.6674478 105.502923,20.1407989 C107.387613,20.6141499 109.442863,21.2870301 111.613242,22.2231189 C113.235696,22.8981218 114.98607,23.8745409 116.834516,25.0993102 C118.685094,26.3283248 119.966428,27.2007341 121.610202,28.2726726 L121.669898,28.1707854 L121.207253,26.1394089 C121.205121,26.1203051 121.177405,26.1096918 121.177405,26.090588 L121.192329,26.0523803 C120.663592,23.6049643 122.14107,21.5693426 124.575817,21.3294831 L124.605665,21.2870301 L124.820997,21.2870301 L124.829525,21.2764169 C126.445583,21.2764169 131.993054,21.2785395 134.585569,21.2870301 L136.395639,21.2870301 C136.515031,21.2870301 136.527823,21.3231152 136.574727,21.3507096 C139.060642,21.6542486 141.444221,23.6707665 142.004937,26.090588 L151.264224,65.8796697 C151.477424,66.8157586 151.645852,67.8961876 151.746057,69.1400607 C151.861185,70.3966698 151.997633,71.4304005 151.957125,72.1775735 C151.978445,77.808965 149.547962,81.9714824 144.746692,84.6481446 L144.746692,84.6481446 Z', transform: 'matrix(1 0 0 -1 0 108.075)' }),
          React.createElement('path', { d: 'M208.49408,0.799761517 C208.033567,0.736082005 207.619959,0.699996948 207.263914,0.699996948 C205.997505,0.699996948 205.042368,1.03962101 204.387843,1.71250119 C203.731186,2.38750402 203.40499,3.47005572 203.40499,4.95803365 L203.40499,11.4894289 L202,11.4894289 L202,13.2300023 L203.40499,13.2300023 L203.40499,16.7599699 L205.479428,16.7599699 L205.479428,13.2300023 L209.764753,13.2300023 L209.764753,11.4894289 L205.479428,11.4894289 L205.479428,5.89199983 C205.479428,5.24883676 205.498616,4.74364596 205.5242,4.38067274 C205.55618,4.01557687 205.658516,3.67807546 205.835472,3.3639232 C205.995373,3.0688748 206.217101,2.85660976 206.502789,2.72076013 C206.788478,2.58278785 207.221274,2.51486304 207.803311,2.51486304 C208.140167,2.51486304 208.49408,2.56580665 208.865048,2.66557122 C209.22962,2.76321314 209.496121,2.8459965 209.658153,2.91179867 L209.764753,2.91179867 L209.764753,1.05235691 C209.378861,0.950469696 208.956724,0.86556368 208.49408,0.799761517 Z', transform: 'matrix(1 0 0 -1 0 17.46)' }),
          React.createElement('path', { d: 'M230.011157,3.8999939 L227.936719,3.8999939 L227.936719,10.8962496 C227.936719,11.4226669 227.911134,11.9342257 227.862098,12.4245579 C227.813062,12.9170128 227.708594,13.3075805 227.557222,13.6026289 C227.386662,13.9167811 227.145746,14.1566406 226.828077,14.3158394 C226.510409,14.4771608 226.056292,14.5578216 225.459332,14.5578216 C224.875163,14.5578216 224.29739,14.4134813 223.713222,14.1226782 C223.131185,13.8339978 222.55128,13.4667793 221.969244,13.0189 C221.990564,12.849088 222.00762,12.6538042 222.022544,12.4288032 C222.0396,12.2059249 222.045996,11.9851693 222.045996,11.7644136 L222.045996,3.8999939 L219.971557,3.8999939 L219.971557,10.8962496 C219.971557,11.4396481 219.943841,11.9533295 219.896937,12.4415391 C219.850033,12.9297487 219.745565,13.3181937 219.594193,13.6111195 C219.421501,13.9273944 219.178452,14.1630086 218.860784,14.3222074 C218.545248,14.4792835 218.088999,14.5578216 217.492038,14.5578216 C216.924926,14.5578216 216.359945,14.4177266 215.786436,14.1396594 C215.21506,13.8615922 214.647947,13.5071096 214.078702,13.0740889 L214.078702,3.8999939 L212,3.8999939 L212,16.1858944 L214.078702,16.1858944 L214.078702,14.8231529 C214.728963,15.3580608 215.37496,15.7762229 216.018825,16.0776392 C216.666953,16.3748103 217.347062,16.5276411 218.078339,16.5276411 C218.916216,16.5276411 219.630437,16.3514611 220.216738,16.0012238 C220.800906,15.6467412 221.237967,15.1606543 221.525787,14.5365951 C222.363664,15.241315 223.131185,15.7507511 223.824086,16.060658 C224.514855,16.370565 225.254659,16.5276411 226.0435,16.5276411 C227.399454,16.5276411 228.399363,16.1179696 229.043228,15.3028719 C229.687093,14.4835288 230.011157,13.3415429 230.011157,11.8747915 L230.011157,3.8999939', transform: 'matrix(1 0 0 -1 0 20.428)' }),
          React.createElement('rect', { width: '188', height: '93', x: '2', y: '151', rx: '6' })
        )
      );
    }
  }]);

  return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-visa'].join(' '), viewBox: '0 0 500 312' },
                React.createElement('rect', { className: 'dibsvg-color-holder', width: '500', height: '312', fill: '#F8F8F8' }),
                React.createElement(
                    'g',
                    { className: 'dibsvg-color-letters', fill: '#0066B2', transform: 'translate(53 93)' },
                    React.createElement('path', { d: 'M5.20833333,6.25 C5.20833333,3.125 8.33333333,0 11.4583333,0 C14.5833333,0 17.7083333,3.125 17.7083333,6.25 C17.7083333,9.375 14.5833333,12.5 11.4583333,12.5 C8.33333333,12.5 5.20833333,9.375 5.20833333,6.25 L5.20833333,6.25 L5.20833333,6.25 Z M11.4583333,10.4166667 C14.5833333,10.4166667 16.6666667,8.33333333 16.6666667,5.20833333 C16.6666667,2.08333333 14.5833333,0 11.4583333,0 C8.33333333,0 6.25,2.08333333 6.25,5.20833333 C6.25,8.33333333 8.33333333,10.4166667 11.4583333,10.4166667 L11.4583333,10.4166667 L11.4583333,10.4166667 Z M10.4166667,8.33333333 L9.375,8.33333333 L9.375,3.125 L11.4583333,3.125 L12.5,3.125 L13.5416667,4.16666667 C13.5416667,5.20833333 13.5416667,5.20833333 12.5,5.20833333 L13.5416667,7.29166667 L12.5,7.29166667 L11.4583333,6.25 L10.4166667,6.25 L10.4166667,8.33333333 L10.4166667,8.33333333 L10.4166667,8.33333333 Z M10.4166667,5.20833333 L10.4166667,5.20833333 L11.4583333,5.20833333 C11.4583333,5.20833333 11.4583333,5.20833333 11.4583333,4.16666667 C11.4583333,4.16666667 11.4583333,4.16666667 11.4583333,3.125 L10.4166667,3.125 L10.4166667,3.125 L10.4166667,5.20833333 L10.4166667,5.20833333 L10.4166667,5.20833333 Z', transform: 'translate(384.578 107.562)' }),
                    React.createElement('path', { d: 'M357.458333 120.625L386.625 120.625 361.625 1.875 336.625 1.875C325.166667 1.875 322.041667 10.2083333 322.041667 10.2083333L275.166667 119.583333 308.5 119.583333 314.75 101.875 354.333333 101.875 357.458333 120.625 357.458333 120.625zM323.083333 78.9583333L339.75 35.2083333 349.125 78.9583333 323.083333 78.9583333 323.083333 78.9583333zM277.25 31.0416667L281.416667 6.04166667C281.416667 6.04166667 267.875.833333333 253.291667.833333333 237.666667.833333333 200.166667 7.08333333 200.166667 39.375 200.166667 69.5833333 243.916667 70.625 243.916667 86.25 243.916667 101.875 204.333333 99.7916667 191.833333 89.375L187.666667 115.416667C187.666667 115.416667 201.208333 121.666667 223.083333 121.666667 244.958333 121.666667 277.25 111.25 277.25 81.0416667 277.25 50.8333333 233.5 47.7083333 233.5 34.1666667 232.458333 21.6666667 263.708333 23.75 277.25 31.0416667' }),
                    React.createElement('path', { d: 'M65.7916667,13.3333333 L76.2083333,66.4583333 L76.2083333,66.4583333 L76.2083333,66.4583333 L65.7916667,13.3333333 C65.7916667,13.3333333 64.75,2.91666667 51.2083333,2.91666667 L26.2083333,2.91666667 L61.625,27.9166667 L76.2083333,66.4583333 L76.2083333,66.4583333 L79.3333333,84.1666667 L109.541667,2.91666667 L143.916667,2.91666667 L93.9166667,120.625 L60.5833333,120.625 L33.5,18.5416667 C15.7916667,8.125 0.166666667,5 0.166666667,5 L1.20833333,2.91666667 L26.2083333,2.91666667' }),
                    React.createElement('polyline', { points: '167.875 120.625 136.625 120.625 155.375 1.875 187.667 1.875 167.875 120.625' })
                ),
                React.createElement('path', { className: 'dibsvg-color-letters-top', fill: '#F9A533', d: 'M129.208333,159.458333 L118.791667,106.333333 C118.791667,106.333333 117.75,95.9166667 104.208333,95.9166667 L54.2083333,95.9166667 L53.1666667,96.9583333 C53.1666667,96.9583333 77.125,102.166667 100.041667,119.875 C121.916667,137.583333 129.208333,159.458333 129.208333,159.458333' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-wire-transfer'].join(' '), viewBox: '0 0 500 312' },
                React.createElement('rect', { className: 'dibsvg-color-holder', width: '500', height: '312', fill: '#F8F8F8' }),
                React.createElement(
                    'g',
                    { className: 'dibsvg-color-letters', transform: 'translate(31 68)' },
                    React.createElement('polygon', { points: '146.083 .75 131.5 63.25 114.833 .75 104.417 .75 87.75 63.25 73.167 .75 57.542 .75 79.417 82 94 82 109.625 22.625 125.25 82 139.833 82 161.708 .75' }),
                    React.createElement('polygon', { points: '182.542 82 197.125 82 197.125 .75 182.542 .75' }),
                    React.createElement('polygon', { points: '310.667 82 310.667 .75 364.833 .75 364.833 13.25 325.25 13.25 325.25 35.125 363.792 35.125 363.792 47.625 325.25 47.625 325.25 69.5 364.833 69.5 364.833 82' }),
                    React.createElement('polygon', { points: '15.875 172.625 15.875 127.833 .25 127.833 .25 119.5 40.875 119.5 40.875 127.833 25.25 127.833 25.25 172.625' }),
                    React.createElement('polygon', { points: '209.625 172.625 182.542 135.125 182.542 172.625 173.167 172.625 173.167 119.5 182.542 119.5 208.583 157 208.583 119.5 217.958 119.5 217.958 172.625' }),
                    React.createElement('polygon', { points: '290.875 172.625 290.875 119.5 327.333 119.5 327.333 127.833 300.25 127.833 300.25 141.375 326.292 141.375 326.292 149.708 300.25 149.708 300.25 172.625' }),
                    React.createElement('polygon', { points: '342.958 172.625 342.958 119.5 378.375 119.5 378.375 127.833 352.333 127.833 352.333 141.375 378.375 141.375 378.375 149.708 352.333 149.708 352.333 164.292 378.375 164.292 378.375 172.625' }),
                    React.createElement('path', { d: 'M271.083333,26.7916667 C271.083333,18.4583333 265.875,14.2916667 257.541667,14.2916667 L238.791667,14.2916667 L238.791667,40.3333333 L257.541667,40.3333333 C265.875,39.2916667 271.083333,34.0833333 271.083333,26.7916667 L271.083333,26.7916667 L271.083333,26.7916667 Z M270.041667,82 L252.333333,51.7916667 L238.791667,51.7916667 L238.791667,82 L225.25,82 L225.25,0.75 L259.625,0.75 C275.25,0.75 285.666667,11.1666667 285.666667,25.75 C285.666667,40.3333333 276.291667,47.625 266.916667,49.7083333 L285.666667,80.9583333 L270.041667,82 L270.041667,82 L270.041667,82 Z' }),
                    React.createElement('path', { d: 'M86.7083333 136.166667C86.7083333 130.958333 82.5416667 127.833333 78.375 127.833333L65.875 127.833333 65.875 144.5 78.375 144.5C83.5833333 144.5 86.7083333 141.375 86.7083333 136.166667L86.7083333 136.166667 86.7083333 136.166667zM85.6666667 172.625L74.2083333 152.833333 65.875 152.833333 65.875 172.625 56.5 172.625 56.5 119.5 79.4166667 119.5C89.8333333 119.5 96.0833333 126.791667 96.0833333 136.166667 96.0833333 145.541667 89.8333333 150.75 83.5833333 151.791667L96.0833333 172.625 85.6666667 172.625 85.6666667 172.625zM133.583333 128.875L124.208333 153.875 142.958333 153.875 133.583333 128.875 133.583333 128.875zM149.208333 172.625L145.041667 162.208333 121.083333 162.208333 116.916667 172.625 106.5 172.625 127.333333 119.5 138.791667 119.5 159.625 172.625 149.208333 172.625 149.208333 172.625z' }),
                    React.createElement('path', { d: 'M233.583333,165.333333 L238.791667,158.041667 C241.916667,162.208333 248.166667,165.333333 255.458333,165.333333 C262.75,165.333333 265.875,161.166667 265.875,158.041667 C265.875,146.583333 235.666667,153.875 235.666667,134.083333 C235.666667,124.708333 242.958333,118.458333 254.416667,118.458333 C262.75,118.458333 269,121.583333 274.208333,125.75 L269,133.041667 C264.833333,128.875 259.625,126.791667 254.416667,126.791667 C249.208333,126.791667 246.083333,129.916667 246.083333,133.041667 C246.083333,143.458333 276.291667,137.208333 276.291667,157 C276.291667,166.375 270.041667,173.666667 256.5,173.666667 C245.041667,173.666667 238.791667,170.541667 233.583333,165.333333' }),
                    React.createElement('path', { d: 'M426.291667,136.166667 C426.291667,130.958333 422.125,127.833333 417.958333,127.833333 L405.458333,127.833333 L405.458333,144.5 L416.916667,144.5 C422.125,144.5 426.291667,141.375 426.291667,136.166667 L426.291667,136.166667 L426.291667,136.166667 Z M425.25,172.625 L413.791667,152.833333 L404.416667,152.833333 L404.416667,172.625 L396.083333,172.625 L396.083333,119.5 L419,119.5 C429.416667,119.5 435.666667,126.791667 435.666667,136.166667 C435.666667,145.541667 429.416667,150.75 423.166667,151.791667 L435.666667,172.625 L425.25,172.625 L425.25,172.625 Z' })
                )
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-print'].join(' '), viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M63,250v-40H35.1c-3,0-12.9-0.7-20.5-7.8C9.2,197,6,189.6,7,180.5v-107c0-1.3,0-13.4,8.6-21.3c4.8-4.6,11.1-6.9,19.1-6.9 c0.6,0,1.4,0,2.1,0l12.2,0V32.6l-0.2-0.1c0.5-7.1,6.3-9.7,9.4-10.1l0,0l4.8-0.1V0h124v22.1l5.3,0.1l0.1,0c3.1,0.4,9,3,9.6,10.1 l0,0.1V46h10.8c0.6,0,1.3-0.5,1.9-0.5c7.9,0,14.5,2.1,19.3,6.7c8.8,8.3,9,20.6,9,21.1v107.1c0,9.3-2.6,16.5-8.4,21.9 c-7.3,7-17.8,7.8-20.8,7.8H187v40H63z M177,239v-57H74v57H177z M34.4,55.2c-5,0-9,1.3-11.8,4c-5.5,5.1-5.6,14-5.6,14.1v80.5 c8-8.6,21.5-9.8,27.2-9.8c1.2,0,2-0.1,2.3-0.1h159.1c14.2,0,22.4,4.7,27.4,9.5V73.3c0-0.4-0.3-8.9-5.9-14.1c-2.8-2.7-6.9-4-11.9-4 c-0.6,0-1.2,0-1.8,0.1l-177.1,0C35.6,55.3,35,55.2,34.4,55.2z M177,44V10H74v34H177z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GalleryMobileNavWrapper-style__wrapper__3o8Wd","button":"GalleryMobileNavWrapper-style__button__1VT_X","leftButton":"GalleryMobileNavWrapper-style__leftButton__TVQt4","middleSection":"GalleryMobileNavWrapper-style__middleSection__3Yu2d","rightButton":"GalleryMobileNavWrapper-style__rightButton__2dXmW","icon":"GalleryMobileNavWrapper-style__icon__3fWj_","text":"GalleryMobileNavWrapper-style__text__2j-YE","details":"GalleryMobileNavWrapper-style__details__3c5ak","showDetails":"GalleryMobileNavWrapper-style__showDetails__1roXo","share":"GalleryMobileNavWrapper-style__share__27eu6","showSocial":"GalleryMobileNavWrapper-style__showSocial__2ZFsi","socialIcons":"GalleryMobileNavWrapper-style__socialIcons__1QoEb","socialIcon":"GalleryMobileNavWrapper-style__socialIcon__1bAeU"};

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"GalleryPhotoContainer-style__container__1iihr"};

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GalleryPhotoPagination-style__wrapper__1sb5g","pagination":"GalleryPhotoPagination-style__pagination__1pvFS"};

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GalleryPhotoSocial-styles__wrapper__L6tu8","icon":"GalleryPhotoSocial-styles__icon__V2U1D"};

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"radius":"ItemTagIndicator__radius__1uZBv","wrapper":"ItemTagIndicator__wrapper__gJD3F","center":"ItemTagIndicator__center__3mjSh","pulse":"ItemTagIndicator__pulse__3NdjW","echo":"ItemTagIndicator__echo__2SeDi"};

/***/ }),
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseActions = __webpack_require__(382);
var copyText = __webpack_require__(380)().extend(Object.assign({}, __webpack_require__(754), __webpack_require__(1013)));

var MakeOfferActions = {
    renderModal: function renderModal(ac, payload, done) {
        var props = payload.props,
            linkLocation = payload.linkLocation,
            modalId = payload.modalId;

        var itemPk = props.item.get('id');
        ac.executeAction(baseActions.initialLoad, {
            sendToOmtOnSuccess: !!props.isMessageCenter,
            itemPk: itemPk,
            copyText: copyText,
            linkLocation: linkLocation
        });
        ac.executeAction(MakeOfferActions.setChatEvents);
        ac.executeAction(baseActions.openModal, { modalId: modalId });
        done();
    },
    setChatEvents: function setChatEvents(actionContext) {
        actionContext.dispatch('contact:chat:setEvents', {
            chatAbandonEvent: 'abandonMakeOffer',
            chatSuccessEvent: ''
        });
    },
    trackPageLoadModal: function trackPageLoadModal(ac, payload) {
        var props = payload.props,
            purchaseTracking = payload.purchaseTracking;

        var action = 'email make offer button - ' + props.tracking.emailTmplName;

        if (props.referredFromAmp) {
            action = 'pdp make offer button-amppage';
        }

        purchaseTracking.trackOfferEvent({
            category: 'make offer click',
            action: action
        });
    }
};

module.exports = { MakeOfferActions: MakeOfferActions };

/***/ }),
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

var CloseIcon = __webpack_require__(276);
var ShareIcon = __webpack_require__(593);
var BackIcon = __webpack_require__(352);
var InfoIcon = __webpack_require__(437);
var GalleryPhotoSocial = __webpack_require__(778);

var classNames = __webpack_require__(16);

function GalleryMobileNavWrapper(_ref) {
    var _classNames;

    var styles = _ref.styles,
        isModal = _ref.isModal,
        showSocial = _ref.showSocial,
        showDetails = _ref.showDetails,
        actions = _ref.actions;

    var DetailsIcon = showDetails ? BackIcon : InfoIcon;

    var className = classNames(styles.wrapper, (_classNames = {}, _defineProperty(_classNames, styles.showSocial, showSocial), _defineProperty(_classNames, styles.showDetails, showDetails), _classNames));

    return React.createElement(
        'div',
        { className: className },
        React.createElement(
            'div',
            { className: classNames(styles.details, styles.button, styles.leftButton), onClick: actions.toggleDetails },
            React.createElement(
                'div',
                null,
                React.createElement(DetailsIcon, { className: styles.icon }),
                React.createElement(
                    'p',
                    { className: styles.text },
                    showDetails ? 'BACK' : 'DETAILS'
                )
            )
        ),
        React.createElement(
            'div',
            { className: classNames(styles.share, styles.button, styles.leftButton), onClick: actions.toggleSocial },
            React.createElement(
                'div',
                null,
                React.createElement(ShareIcon, { className: styles.icon }),
                React.createElement(
                    'p',
                    { className: styles.text },
                    'SHARE'
                )
            )
        ),
        React.createElement(
            'div',
            { className: classNames(styles.social, styles.middleSection) },
            React.createElement(GalleryPhotoSocial, { classes: { wrapper: styles.socialIcons, icon: styles.socialIcon }, sharePhoto: actions.sharePhoto })
        ),
        isModal ? React.createElement(
            'div',
            { className: classNames(styles.close, styles.button, styles.rightButton), onClick: actions.hideModal },
            React.createElement(CloseIcon, { className: styles.icon })
        ) : null
    );
}

GalleryMobileNavWrapper.propTypes = {
    isModal: PropTypes.bool.isRequired,
    showSocial: PropTypes.bool.isRequired,
    showDetails: PropTypes.bool.isRequired,

    actions: PropTypes.shape({
        hideModal: PropTypes.func.isRequired,
        sharePhoto: PropTypes.func.isRequired,
        toggleSocial: PropTypes.func.isRequired,
        toggleDetails: PropTypes.func.isRequired
    }).isRequired,
    styles: PropTypes.shape({
        showSocial: PropTypes.string,
        showDetails: PropTypes.string,

        wrapper: PropTypes.string,
        details: PropTypes.string,
        share: PropTypes.string,
        social: PropTypes.string,
        close: PropTypes.string,
        socialIcons: PropTypes.string,
        socialIcon: PropTypes.string,

        icon: PropTypes.string,
        text: PropTypes.string,
        button: PropTypes.string,
        leftButton: PropTypes.string,
        rightButton: PropTypes.string,
        middleSection: PropTypes.string
    }).isRequired
};

GalleryMobileNavWrapper.defaultProps = {
    styles: __webpack_require__(1039)
};

module.exports = GalleryMobileNavWrapper;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ReactDOM = __webpack_require__(40);

var root = __webpack_require__(97);

var _require = __webpack_require__(67),
    noop = _require.noop;

var _require2 = __webpack_require__(390),
    SwipeDetector = _require2.SwipeDetector;

var PinchZoomComponent = __webpack_require__(737);

var styles = __webpack_require__(1040);

var GalleryPhotoContainer = function (_React$Component) {
    _inherits(GalleryPhotoContainer, _React$Component);

    function GalleryPhotoContainer(props) {
        _classCallCheck(this, GalleryPhotoContainer);

        var _this = _possibleConstructorReturn(this, (GalleryPhotoContainer.__proto__ || Object.getPrototypeOf(GalleryPhotoContainer)).call(this, props));

        _this._onKeyDown = _this._onKeyDown.bind(_this);
        _this._onClick = _this._onClick.bind(_this);
        _this._onSwipe = _this._onSwipe.bind(_this);
        _this._onZoomIn = _this._onZoomIn.bind(_this);
        _this._onZoomOut = _this._onZoomOut.bind(_this);
        return _this;
    }

    _createClass(GalleryPhotoContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.enableSwipe();
            this.enableArrowNavigation();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.disableArrowNavigation();
        }
    }, {
        key: 'enableArrowNavigation',
        value: function enableArrowNavigation() {
            root.addEventListener('keydown', this._onKeyDown);
        }
    }, {
        key: 'disableArrowNavigation',
        value: function disableArrowNavigation() {
            root.removeEventListener('keydown', this._onKeyDown);
        }
    }, {
        key: 'enableSwipe',
        value: function enableSwipe() {
            if (!this._swipeDetector && this.props.allowTouchEvents) {
                this._swipeDetector = new SwipeDetector({
                    el: ReactDOM.findDOMNode(this._pz),
                    onSwipeSuccess: this._onSwipe
                });
            }
        }
    }, {
        key: 'disableSwipe',
        value: function disableSwipe() {
            if (this._swipeDetector) {
                this._swipeDetector.destroy();
                this._swipeDetector = undefined;
            }
        }
    }, {
        key: '_onKeyDown',
        value: function _onKeyDown(e) {
            var keyCode = e.keyCode,
                keyIdentifier = e.keyIdentifier,
                key = e.key;


            if (keyIdentifier === 'Right' || key === 'Right' || keyCode === 39) {
                this.props.next(this.props.photoData);
            } else if (keyIdentifier === 'Left' || key === 'Left' || keyCode === 37) {
                this.props.prev(this.props.photoData);
            }
        }
    }, {
        key: '_onClick',
        value: function _onClick(e) {
            if (e.currentTarget && e.currentTarget.getBoundingClientRect) {
                var _e$currentTarget$getB = e.currentTarget.getBoundingClientRect(),
                    right = _e$currentTarget$getB.right,
                    left = _e$currentTarget$getB.left;

                if ((right + left) / 2 > e.pageX) {
                    this.props.prev(this.props.photoData);
                } else {
                    this.props.next(this.props.photoData);
                }
            }
        }
    }, {
        key: '_onSwipe',
        value: function _onSwipe(direction) {
            var _this2 = this;

            direction.match({
                left: function left() {
                    return _this2.props.next(_this2.props.photoData);
                },
                right: function right() {
                    return _this2.props.prev(_this2.props.photoData);
                }
            });
        }
    }, {
        key: '_onZoomIn',
        value: function _onZoomIn() {
            this.disableSwipe();
            this.props.zoomIn(this.props.photoData);
        }
    }, {
        key: '_onZoomOut',
        value: function _onZoomOut() {
            this.enableSwipe();
            this.props.zoomOut(this.props.photoData);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.allowTouchEvents) {
                return React.createElement(
                    PinchZoomComponent,
                    {
                        ref: function ref(el) {
                            _this3._pz = el;
                        },
                        className: styles.container,
                        onZoomIn: this._onZoomIn,
                        onZoomOut: this._onZoomOut },
                    this.props.children
                );
            } else {
                return React.createElement(
                    'div',
                    { className: styles.container, onClick: this._onClick },
                    this.props.children
                );
            }
        }
    }]);

    return GalleryPhotoContainer;
}(React.Component);

GalleryPhotoContainer.propTypes = {
    next: PropTypes.func,
    prev: PropTypes.func,
    zoomIn: PropTypes.func,
    zoomOut: PropTypes.func,

    photoData: PropTypes.object,
    allowTouchEvents: PropTypes.bool,

    children: PropTypes.array.isRequired
};

GalleryPhotoContainer.defaultProps = {
    next: noop,
    prev: noop,
    zoomIn: noop,
    zoomOut: noop,
    allowTouchEvents: false
};

module.exports = GalleryPhotoContainer;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);
var throttle = __webpack_require__(918);
var root = __webpack_require__(97);

var _require$galleryPhoto = __webpack_require__(342).galleryPhotoClasses,
    galleryPhotoImage = _require$galleryPhoto.galleryPhotoImage,
    galleryPhotoFadeIn = _require$galleryPhoto.galleryPhotoFadeIn;

var GalleryPhotoImage = function (_React$Component) {
    _inherits(GalleryPhotoImage, _React$Component);

    function GalleryPhotoImage(props) {
        _classCallCheck(this, GalleryPhotoImage);

        var _this = _possibleConstructorReturn(this, (GalleryPhotoImage.__proto__ || Object.getPrototypeOf(GalleryPhotoImage)).call(this, props));

        _this._onLoad = _this._onLoad.bind(_this);
        _this._updateImageDimensions = _this._updateImageDimensions.bind(_this);

        // Throttle so that the image dimensions are only updated once when the window is resized
        _this._onResize = throttle(_this._updateImageDimensions, 500, { leading: false, trailing: true });
        return _this;
    }

    _createClass(GalleryPhotoImage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Immediately show the image
            this._showImage();

            // Once the photo loads get the dimensions of the image (used to render itemTags)
            root.addEventListener('resize', this._onResize);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var photoId = _ref.photoId;

            // Each time the photo is changed, hide the img component so that when then
            // new image is loaded it can be faded in
            if (photoId !== this.props.photoId) {
                this._hideImage();
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(_ref2) {
            var photoId = _ref2.photoId;

            return photoId !== this.props.photoId;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            root.removeEventListener('resize', this._onResize);
        }
    }, {
        key: '_updateImageDimensions',
        value: function _updateImageDimensions() {
            if (this._img) {
                this.props.updateImageDimensions({
                    height: 2 * this._img.offsetHeight,
                    width: 2 * this._img.offsetWidth
                });
            }
        }

        /**
         * Fades the image in by adding the 'fade-in' class
         */

    }, {
        key: '_showImage',
        value: function _showImage() {
            if (this._img) {
                this._img.className = classnames(galleryPhotoImage, galleryPhotoFadeIn);
            }
        }

        /**
         * Fades the image out of view by removing the 'fade-in' class
         */

    }, {
        key: '_hideImage',
        value: function _hideImage() {
            if (this._img) {
                this._img.className = galleryPhotoImage;
            }
        }

        /**
         * Handler for img onLoad event
         *  - fades the image in
         * @private
         */

    }, {
        key: '_onLoad',
        value: function _onLoad() {
            var _this2 = this;

            // set a delay to give the image time to fade in
            setTimeout(function () {
                return _this2._showImage();
            }, 30);

            // Once the photo loads get the dimensions of the image (used to render itemTags)
            this._updateImageDimensions();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                photoSrc = _props.photoSrc,
                photoAlt = _props.photoAlt;


            return React.createElement('img', { ref: function ref(img) {
                    _this3._img = img;
                },
                className: galleryPhotoImage,
                src: photoSrc,
                alt: photoAlt,
                onLoad: this._onLoad
            });
        }
    }]);

    return GalleryPhotoImage;
}(React.Component);

GalleryPhotoImage.propTypes = {
    photoId: PropTypes.number.isRequired,
    photoSrc: PropTypes.string.isRequired,
    photoAlt: PropTypes.string.isRequired,

    // Actions
    updateImageDimensions: PropTypes.func.isRequired
};

module.exports = GalleryPhotoImage;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classNames = __webpack_require__(16);
var root = __webpack_require__(97);

var Tooltip = __webpack_require__(270);
__webpack_require__(272);
var ItemTagIndicator = __webpack_require__(1070);
var GalleryPhotoItemTagInfo = __webpack_require__(1066);

var styles = __webpack_require__(635);

var heightOfGlobalNav = 60;
var tooltipBoundMargin = 10;

/**
 * Returns the bounds of where the tooltip can be rendered
 *  (relative to the window @see dibs-react-tooltip)
 *
 * @returns {Object}
 */
function getBounds() {
    var wrapper = root.document.getElementsByClassName(styles.wrapper)[0];

    // Tooltip bounds to keep it from going outside the window
    var windowTopBound = heightOfGlobalNav;
    var windowLeftBound = 0;
    var windowRightBound = root.innerWidth;
    var windowBottomBound = root.innerHeight;

    // If for some reason wrapper isn't rendered, just return the window bounds
    if (!wrapper || !wrapper.getBoundingClientRect) {
        return {
            top: windowTopBound,
            left: windowLeftBound,
            right: windowRightBound,
            bottom: windowBottomBound
        };
    }

    // Get image position relative to the window
    var imgPos = wrapper.getBoundingClientRect();

    // Tooltip bounds to keep it from going outside the image
    var imageTopBound = imgPos.top;
    var imageLeftBound = imgPos.left - tooltipBoundMargin;
    var imageRightBound = imgPos.right + tooltipBoundMargin;
    var imageBottomBound = imgPos.bottom;

    return {
        top: Math.max(imageTopBound, windowTopBound),
        left: Math.max(imageLeftBound, windowLeftBound),
        right: Math.min(imageRightBound, windowRightBound),
        bottom: Math.min(imageBottomBound, windowBottomBound)
    };
}

function tooltipProps(_ref) {
    var tooltipVisible = _ref.tooltipVisible;

    return {
        containerClass: styles.itemTagTooltip,
        getBounds: getBounds,
        isVisible: tooltipVisible,
        positionThreshold: {
            top: 0, left: 0,
            bottom: 0, right: 0
        }
    };
}

function onMouseEnter(_ref2) {
    var id = _ref2.id,
        showItemTagTooltip = _ref2.showItemTagTooltip;

    return function () {
        return showItemTagTooltip(id);
    };
}

function onMouseLeave(_ref3) {
    var hideItemTagTooltip = _ref3.hideItemTagTooltip;

    return function () {
        return hideItemTagTooltip();
    };
}

function GalleryPhotoItemTag(props) {
    var point = props.point,
        isActiveTag = props.isActiveTag;

    var itemTagPosition = {
        top: point.y + '%',
        left: point.x + '%'
    };
    var className = classNames(styles.itemTagWrapper, _defineProperty({}, styles.isActiveTag, isActiveTag));

    return React.createElement(
        'div',
        {
            className: className,
            style: itemTagPosition,
            onMouseEnter: onMouseEnter(props),
            onMouseLeave: onMouseLeave(props)
        },
        React.createElement(
            Tooltip,
            tooltipProps(props),
            React.createElement(GalleryPhotoItemTagInfo, {
                name: props.name,
                creator: props.creator,
                category: props.category,
                similarItemsUrl: props.similarItemsUrl,
                trackLinkClick: props.trackLinkClick
            }),
            React.createElement('div', { className: styles.itemTagHoverBounds })
        ),
        React.createElement(ItemTagIndicator, null)
    );
}

GalleryPhotoItemTag.propTypes = {
    isActiveTag: PropTypes.bool.isRequired,
    tooltipVisible: PropTypes.bool.isRequired,

    id: PropTypes.number,
    name: PropTypes.string,
    creator: PropTypes.string,
    category: PropTypes.string,
    point: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
    }),
    similarItemsUrl: PropTypes.string,

    showItemTagTooltip: PropTypes.func.isRequired,
    hideItemTagTooltip: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired
};

module.exports = GalleryPhotoItemTag;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

var _require = __webpack_require__(342),
    ITEM_TAG_INFO_CHAR_LIMIT = _require.ITEM_TAG_INFO_CHAR_LIMIT;

var _require2 = __webpack_require__(453),
    GA_LINK_TARGETS = _require2.GA_LINK_TARGETS;

var styles = __webpack_require__(635);

function onClickLink() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        trackLinkClick = _ref.trackLinkClick;

    return function (e) {
        trackLinkClick({
            target: GA_LINK_TARGETS.TOOLTIP_LINK,
            label: e.currentTarget.href
        });
    };
}

/**
 * Returns text under char limit
 *
 * @param {string} text
 * @returns {string}
 */
function getText() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (text.length < ITEM_TAG_INFO_CHAR_LIMIT) {
        return text;
    }
    return text.slice(0, ITEM_TAG_INFO_CHAR_LIMIT) + '...';
}

function GalleryPhotoItemTagInfo(props) {
    var name = props.name,
        category = props.category,
        creator = props.creator,
        similarItemsUrl = props.similarItemsUrl;

    var categoryCreator = category + (creator ? ' \u2022 ' + creator : '');

    return React.createElement(
        'div',
        { className: styles.itemTagInfoWrapper, onClick: function onClick(e) {
                return e.stopPropagation();
            } },
        React.createElement(
            'p',
            { className: styles.itemTagName, title: name },
            getText(name)
        ),
        React.createElement(
            'p',
            { className: styles.itemTagCategoryCreator, title: categoryCreator },
            getText(categoryCreator)
        ),
        similarItemsUrl ? React.createElement(
            'a',
            { className: styles.itemTagLink, href: similarItemsUrl, target: '_blank', onClick: onClickLink(props) },
            'View Similar Pieces'
        ) : null
    );
}

GalleryPhotoItemTagInfo.propTypes = {
    name: PropTypes.string,
    creator: PropTypes.string,
    category: PropTypes.string,
    similarItemsUrl: PropTypes.string,
    trackLinkClick: PropTypes.func.isRequired
};

module.exports = GalleryPhotoItemTagInfo;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classNames = __webpack_require__(16);

var get = __webpack_require__(14);
var isEmpty = __webpack_require__(264);

var GalleryPhotoItemTag = __webpack_require__(1065);

var styles = __webpack_require__(635);
var help = __webpack_require__(1071);

var GalleryPhotoItemTags = function (_React$Component) {
    _inherits(GalleryPhotoItemTags, _React$Component);

    function GalleryPhotoItemTags() {
        _classCallCheck(this, GalleryPhotoItemTags);

        return _possibleConstructorReturn(this, (GalleryPhotoItemTags.__proto__ || Object.getPrototypeOf(GalleryPhotoItemTags)).apply(this, arguments));
    }

    _createClass(GalleryPhotoItemTags, [{
        key: 'eventHandlers',

        /**
         * EventHandlers on the wrapping component
         * @returns {object}
         */
        value: function eventHandlers() {
            var _this2 = this;

            return {
                onClick: function onClick(e) {
                    if (_this2.props.itemTagsState.activeItemTag) {
                        e.stopPropagation();
                    }
                },
                onMouseOver: function onMouseOver() {
                    if (!_this2.props.itemTagsState.showItemTags) {
                        _this2.props.showItemTagIndicators();
                    }
                },
                onMouseLeave: function onMouseLeave() {
                    _this2.props.hideItemTagIndicators();
                }
            };
        }

        /**
         * Props passed to GalleryPhotoItemTag for the given itemTag
         * @returns {object}
         */

    }, {
        key: 'itemTagProps',
        value: function itemTagProps(itemTag) {
            var _props$itemTagsState = this.props.itemTagsState,
                showItemTags = _props$itemTagsState.showItemTags,
                activeItemTag = _props$itemTagsState.activeItemTag;
            var _props = this.props,
                showItemTagTooltip = _props.showItemTagTooltip,
                hideItemTagTooltip = _props.hideItemTagTooltip,
                trackLinkClick = _props.trackLinkClick;


            var creatorId = help.getCreatorId(itemTag);
            var creator = get(this.props, 'creatorsMap[' + creatorId + '].displayName');

            var categoryKey = help.getCategoryKey(itemTag);
            var category = get(this.props, 'categoriesMap[' + categoryKey + '].name');

            var similarItemsUrls = this.props.similarItemsUrls;
            var similarItemsUrl = get(this.props, 'similarItemsUrls[' + itemTag.id + ']');

            // active tag = currently focused tag
            var isActiveTag = showItemTags && itemTag.id === activeItemTag;

            // only show tooltip if active and all info loaded
            var tooltipVisible = isActiveTag && !isEmpty(category) && similarItemsUrls !== void 0 && (!creatorId || !isEmpty(creator));

            return {
                // state
                key: itemTag.id,
                isActiveTag: isActiveTag, tooltipVisible: tooltipVisible,

                // tag data
                id: itemTag.id,
                name: itemTag.name,
                point: itemTag.coordinate.point,
                creator: creator, category: category, similarItemsUrl: similarItemsUrl,

                // actions
                showItemTagTooltip: showItemTagTooltip, hideItemTagTooltip: hideItemTagTooltip, trackLinkClick: trackLinkClick
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this3 = this;

            var _props2 = this.props,
                itemTags = _props2.itemTags,
                imageDimensions = _props2.imageDimensions;
            var _props$itemTagsState2 = this.props.itemTagsState,
                showItemTags = _props$itemTagsState2.showItemTags,
                activeItemTag = _props$itemTagsState2.activeItemTag;


            var className = classNames(styles.wrapper, (_classNames = {}, _defineProperty(_classNames, styles.showItemTags, showItemTags && !activeItemTag), _defineProperty(_classNames, styles.showActiveTag, !!activeItemTag), _classNames));

            return React.createElement(
                'div',
                _extends({ className: className, style: imageDimensions }, this.eventHandlers()),
                itemTags.map(function (itemTag) {
                    return React.createElement(GalleryPhotoItemTag, _this3.itemTagProps(itemTag));
                })
            );
        }
    }]);

    return GalleryPhotoItemTags;
}(React.Component);

GalleryPhotoItemTags.propTypes = {
    itemTags: PropTypes.array.isRequired,
    similarItemsUrls: PropTypes.object,

    itemTagsState: PropTypes.shape({
        activeItemTag: PropTypes.number,
        showItemTags: PropTypes.bool.isRequired
    }).isRequired,
    imageDimensions: PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired
    }).isRequired,
    creatorsMap: PropTypes.object.isRequired,
    categoriesMap: PropTypes.object.isRequired,

    // Actions
    showItemTagIndicators: PropTypes.func.isRequired,
    hideItemTagIndicators: PropTypes.func.isRequired,
    showItemTagTooltip: PropTypes.func.isRequired,
    hideItemTagTooltip: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired
};

module.exports = GalleryPhotoItemTags;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

/**
 * Render the Gallery Photo Pagination
 *
 * @param {object} styles
 * @param {number} photoIndex
 * @param {number} totalPhotos
 */
var GalleryPhotoPagination = function GalleryPhotoPagination(_ref) {
    var styles = _ref.styles,
        photoIndex = _ref.photoIndex,
        totalPhotos = _ref.totalPhotos;

    return React.createElement(
        'div',
        { className: styles.wrapper },
        React.createElement(
            'span',
            { className: styles.pagination },
            photoIndex + 1,
            ' of ',
            totalPhotos
        )
    );
};

GalleryPhotoPagination.propTypes = {
    photoIndex: PropTypes.number.isRequired,
    totalPhotos: PropTypes.number.isRequired,
    styles: PropTypes.shape({
        wrapper: PropTypes.string,
        pagination: PropTypes.string
    }).isRequired
};

GalleryPhotoPagination.defaultProps = {
    styles: __webpack_require__(1041)
};

module.exports = GalleryPhotoPagination;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

var MediaQuery = __webpack_require__(378);
var GalleryPhotoContainer = __webpack_require__(1063);
var GalleryPhotoImage = __webpack_require__(1064);
var GalleryPhotoItemTags = __webpack_require__(1067);
var GalleryPhotoSocial = __webpack_require__(778);
var GalleryPhotoPagination = __webpack_require__(1068);

var _require = __webpack_require__(365),
    queries = _require.queries;

function GalleryPhotoWrapper(props) {
    var photoData = props.photoData,
        handlers = props.handlers,
        allowTouchEvents = props.allowTouchEvents,
        updateImageDimensions = props.updateImageDimensions;


    return React.createElement(
        GalleryPhotoContainer,
        _extends({}, handlers, { allowTouchEvents: allowTouchEvents, photoData: photoData }),
        React.createElement(GalleryPhotoImage, {
            photoId: photoData.photoId,
            photoSrc: photoData.photoSrc,
            photoAlt: photoData.photoAlt,
            updateImageDimensions: updateImageDimensions
        }),
        !allowTouchEvents && photoData.itemTags.length ? React.createElement(
            MediaQuery,
            { query: [queries.lg, queries.xl] },
            React.createElement(GalleryPhotoItemTags, {
                key: photoData.photoId,
                itemTags: photoData.itemTags,
                itemTagsState: props.itemTagsState,
                creatorsMap: photoData.creatorsMap,
                categoriesMap: photoData.categoriesMap,
                imageDimensions: photoData.imageDimensions,
                similarItemsUrls: photoData.similarItemsUrls,
                showItemTagTooltip: props.showItemTagTooltip,
                hideItemTagTooltip: props.hideItemTagTooltip,
                showItemTagIndicators: props.showItemTagIndicators,
                hideItemTagIndicators: props.hideItemTagIndicators,
                trackLinkClick: props.trackLinkClick
            })
        ) : null,
        React.createElement(
            MediaQuery,
            { query: [queries.lg, queries.xl] },
            React.createElement(GalleryPhotoSocial, { sharePhoto: props.sharePhoto })
        ),
        React.createElement(GalleryPhotoPagination, {
            photoIndex: photoData.photoIndex,
            totalPhotos: photoData.totalPhotos
        })
    );
}

GalleryPhotoWrapper.propTypes = {
    photoData: PropTypes.shape({
        itemTags: PropTypes.array.isRequired,
        photoId: PropTypes.number.isRequired,
        photoSrc: PropTypes.string.isRequired,
        photoAlt: PropTypes.string.isRequired,
        photoIndex: PropTypes.number.isRequired,
        totalPhotos: PropTypes.number.isRequired,

        creatorsMap: PropTypes.object.isRequired,
        categoriesMap: PropTypes.object.isRequired,
        imageDimensions: PropTypes.shape({
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired
        }).isRequired,
        similarItemsUrls: PropTypes.object
    }).isRequired,
    itemTagsState: PropTypes.shape({
        activeItemTag: PropTypes.number,
        showItemTags: PropTypes.bool.isRequired
    }).isRequired,
    allowTouchEvents: PropTypes.bool.isRequired,

    // Actions
    handlers: PropTypes.shape({
        next: PropTypes.func.isRequired,
        prev: PropTypes.func.isRequired,
        zoomIn: PropTypes.func.isRequired
    }).isRequired,
    updateImageDimensions: PropTypes.func.isRequired,
    showItemTagIndicators: PropTypes.func.isRequired,
    hideItemTagIndicators: PropTypes.func.isRequired,
    showItemTagTooltip: PropTypes.func.isRequired,
    hideItemTagTooltip: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired,
    sharePhoto: PropTypes.func.isRequired
};

module.exports = GalleryPhotoWrapper;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

function ItemTagIndicator(_ref) {
    var styles = _ref.styles;

    return React.createElement(
        'div',
        { className: styles.wrapper },
        React.createElement('div', { className: styles.radius + ' ' + styles.center }),
        React.createElement('div', { className: styles.radius + ' ' + styles.pulse }),
        React.createElement('div', { className: styles.radius + ' ' + styles.echo })
    );
}

ItemTagIndicator.propTypes = {
    styles: PropTypes.shape({
        wrapper: PropTypes.string,
        radius: PropTypes.string,
        center: PropTypes.string,
        pulse: PropTypes.string,
        echo: PropTypes.string
    }).isRequired
};

ItemTagIndicator.defaultProps = {
    styles: __webpack_require__(1043)
};

module.exports = ItemTagIndicator;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var get = __webpack_require__(14);

/**
 * Returns the value of an itemTag's attribute
 *
 * @param {object}        itemTag
 * @param {string}        attr
 * @param {number|string} [index]
 * @returns {string}
 */
function getAttributeValue() {
    var itemTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    return get(itemTag, 'attributeProfile.dataMap.' + attr + '[' + index + '].value', '');
}

/**
 * Return's the itemTag's categoryKey (from its attributeProfile)
 *
 * @param {object} itemTag
 * @param {string} itemTag.attributeProfile.dataMap.categoryKey[0].value
 * @returns {string}
 */
function getCategoryKey(itemTag) {
    return getAttributeValue(itemTag, 'categoryKey');
}

/**
 * Return's the itemTag's creatorId (from its attributeProfile)
 *
 * @param {object} itemTag
 * @param {string} itemTag.attributeProfile.dataMap.creatorId[0].value
 * @returns {string}
 */
function getCreatorId(itemTag) {
    return getAttributeValue(itemTag, 'creatorId');
}

module.exports = {
    getCategoryKey: getCategoryKey,
    getCreatorId: getCreatorId
};

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GlobalContextBaseView = __webpack_require__(353);
var galleryActions = __webpack_require__(363);

var _require = __webpack_require__(342),
    classes = _require.classes,
    switchActions = _require.switchActions;

var contains = __webpack_require__(812);

var GalleryArrowBox = GlobalContextBaseView.extend({
    el: '.' + classes.ARROW_BOX,

    events: {
        click: 'onClickArrow'
    },

    constructor: function constructor() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            pageType = _ref.pageType,
            isModal = _ref.isModal;

        this.pageType = pageType;
        this.isModal = isModal;

        GlobalContextBaseView.prototype.constructor.apply(this, arguments);
    },


    /**
     * Event handler for when user clicks on an arrow
     */
    onClickArrow: function onClickArrow(e) {
        var action = e.currentTarget.dataset.action;

        var pageType = this.pageType;

        if (contains(switchActions, action)) {
            this.context.executeAction(galleryActions.switchPhoto, { action: action, pageType: pageType });
            e.preventDefault();
        }
    }
});

module.exports = GalleryArrowBox;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(40);
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var GlobalContextBaseView = __webpack_require__(353);

// Stores
var GalleryStore = __webpack_require__(357);

// Actions
var galleryActions = __webpack_require__(363);
var galleryModalActions = __webpack_require__(512);

var _require = __webpack_require__(342),
    classes = _require.classes;

var GalleryMobileNavWrapperConnected = provideContext(connectToStores(__webpack_require__(1062), [GalleryStore], function (context) {
    var galleryStore = context.getStore(GalleryStore);

    return {
        showSocial: galleryStore.showSocialMobile(),
        showDetails: galleryStore.showDetailsMobile()
    };
}));

var GalleryMobileNavWrapper = GlobalContextBaseView.extend({
    el: '.' + classes.MOBILE_NAV,
    initialize: function initialize(_ref) {
        var context = _ref.context,
            isModal = _ref.isModal;

        ReactDOM.render(React.createElement(GalleryMobileNavWrapperConnected, {
            context: context.getComponentContext(),
            isModal: isModal,
            actions: {
                hideModal: function hideModal(payload) {
                    return context.executeAction(galleryModalActions.hideModal, payload);
                },
                sharePhoto: function sharePhoto(payload) {
                    return context.executeAction(galleryActions.sharePhoto, payload);
                },
                toggleSocial: function toggleSocial(payload) {
                    return context.executeAction(galleryActions.toggleSocialMobile, payload);
                },
                toggleDetails: function toggleDetails(payload) {
                    return context.executeAction(galleryActions.toggleDetailsMobile, payload);
                }
            }
        }), this.el);
    }
});

module.exports = GalleryMobileNavWrapper;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mobileCheck = __webpack_require__(279);

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(40);
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var GlobalContextBaseView = __webpack_require__(353);

// Stores
var GalleryStore = __webpack_require__(357);
var GalleryPhotoUIStore = __webpack_require__(649);
var CategoriesStore = __webpack_require__(650);
var CreatorsStore = __webpack_require__(575);

// Actions
var galleryActions = __webpack_require__(363);
var galleryPhotoUIActions = __webpack_require__(721);
var galleryTrackingActions = __webpack_require__(453);

var constants = __webpack_require__(342);
var galleryPhotoWrapper = constants.galleryPhotoClasses.galleryPhotoWrapper;
var _constants$switchActi = constants.switchActions,
    NEXT = _constants$switchActi.NEXT,
    PREVIOUS = _constants$switchActi.PREVIOUS;

// Connected Gallery Photo React Component

var GalleryPhotoWrapperConnected = provideContext(connectToStores(__webpack_require__(1069), [GalleryStore, GalleryPhotoUIStore, CategoriesStore, CreatorsStore], function (context) {
    var galleryStore = context.getStore(GalleryStore);
    var categoriesStore = context.getStore(CategoriesStore);
    var galleryUIStore = context.getStore(GalleryPhotoUIStore);
    var creatorsStore = context.getStore(CreatorsStore);

    return {
        itemTagsState: galleryUIStore.getItemTagsState(),
        photoData: {
            /* For GalleryPhotoItemTags.jsx */
            photoId: galleryStore.getCurrentPhotoId(),
            photoSrc: galleryStore.getCurrentPhotoSrc(),
            photoAlt: galleryStore.getCurrentPhotoAlt(),
            photoIndex: galleryStore.getCurrentPhotoIndex(),
            totalPhotos: galleryStore.getTotalNumberOfPhotos(),

            /* For GalleryPhotoImage.jsx */
            itemTags: galleryStore.getCurrentPhotoItemTags(),
            creatorsMap: creatorsStore.getCreatorsMap(),
            categoriesMap: categoriesStore.getCategoriesMap(),
            imageDimensions: galleryUIStore.getImageDimensions(),
            similarItemsUrls: galleryStore.getSimilarItemsUrls()
        }
    };
}));

var GalleryPhotoWrapper = GlobalContextBaseView.extend({
    el: '.' + galleryPhotoWrapper,

    initialize: function initialize(_ref) {
        var context = _ref.context,
            pageType = _ref.pageType;

        ReactDOM.render(React.createElement(GalleryPhotoWrapperConnected, {
            context: context.getComponentContext(),
            allowTouchEvents: mobileCheck.any(),
            handlers: {
                next: function next() {
                    return context.executeAction(galleryActions.switchPhoto, { action: NEXT, pageType: pageType });
                },
                prev: function prev() {
                    return context.executeAction(galleryActions.switchPhoto, { action: PREVIOUS, pageType: pageType });
                },
                zoomIn: function zoomIn() {
                    return context.executeAction(galleryTrackingActions.trackMobileZoom);
                }
            },
            updateImageDimensions: function updateImageDimensions(payload) {
                return context.executeAction(galleryPhotoUIActions.updateImageDimensions, payload);
            },
            showItemTagIndicators: function showItemTagIndicators(payload) {
                return context.executeAction(galleryPhotoUIActions.showItemTagIndicators, payload);
            },
            hideItemTagIndicators: function hideItemTagIndicators(payload) {
                return context.executeAction(galleryPhotoUIActions.hideItemTagIndicators, payload);
            },
            showItemTagTooltip: function showItemTagTooltip(payload) {
                return context.executeAction(galleryPhotoUIActions.showItemTagTooltip, payload);
            },
            hideItemTagTooltip: function hideItemTagTooltip(payload) {
                return context.executeAction(galleryPhotoUIActions.hideItemTagTooltip, payload);
            },
            trackLinkClick: function trackLinkClick(payload) {
                return context.executeAction(galleryTrackingActions.trackLinkClick, payload);
            },
            sharePhoto: function sharePhoto(payload) {
                return context.executeAction(galleryActions.sharePhoto, payload);
            }
        }), this.el);
    }
});

module.exports = GalleryPhotoWrapper;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _events;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GlobalContextBaseView = __webpack_require__(353);

var galleryTrackingActions = __webpack_require__(453);

var GA_LINK_TARGETS = galleryTrackingActions.GA_LINK_TARGETS;

var _require = __webpack_require__(342),
    classes = _require.classes;

var _require2 = __webpack_require__(385),
    pages = _require2.pages,
    pageUrlLabels = _require2.pageUrlLabels;

/**
 * View for Gallery's Photo Details (Right Margin)
 *  - handles changing the photoTitle
 *  - handles changing the photoTags
 *  - handles changing the firm name/url
 *  - handles changing the project name/url
 */


var PhotoDetails = GlobalContextBaseView.extend({
    el: '.' + classes.PHOTO_DETAILS,
    props: {},
    events: (_events = {}, _defineProperty(_events, 'click .' + classes.PROJECT_LINK, '_onClickProjectLink'), _defineProperty(_events, 'click .' + classes.PROJECTS_LINK, '_onClickMoreProjectsLink'), _defineProperty(_events, 'click .' + classes.SIMILAR_ITEMS_ALL, '_onClickSimilarItemsLink'), _defineProperty(_events, 'click .' + classes.SIMILAR_ITEM_PDP, '_onClickSimilarItem'), _events),

    initialize: function initialize() {
        this.$photoTitle = this.$('.' + classes.PHOTO_TITLE);
        this.$photoCaption = this.$('.' + classes.PHOTO_CAPTION);
        this.$photoAttributes = this.$('.' + classes.PHOTO_ATTRIBUTES);

        this.$projectName = this.$('.' + classes.PROJECT_NAME);
        this.$projectLink = this.$('.' + classes.PROJECT_LINK);
        this.$projectsLink = this.$('.' + classes.PROJECTS_LINK);

        this.$firmName = this.$('.' + classes.FIRM_NAME);
        this.$firmLink = this.$('.' + classes.FIRM_LINK);
        this.$firmImage = this.$('.' + classes.FIRM_IMAGE);

        this.$similarItems = this.$('.' + classes.SIMILAR_ITEMS);
        this.$moreProjects = this.$('.' + classes.MORE_PROJECTS);
    },


    /**
     * Updates props and calls render
     *  (Note: parent calls passProps() @see GalleryWrapperView.es.js)
     *
     * @param {object} props
     * @param {string} props.photoTitle
     * @param {string} props.photoCaption
     * @param {string} props.similarItemsTemplate
     *
     * @param {string} props.photoFirm.url
     * @param {string} props.photoFirm.name
     * @param {string} props.photoFirm.photo.images.thumb
     *
     * @param {string} props.photoProject.url
     * @param {string} props.photoProject.name
     *
     * @param {array}  props.photoAttrTags
     */
    passProps: function passProps(props) {
        this.props = props;
        this.render();
    },


    /**
     * Render function
     *  - Updates all details each time the photo is changed
     */
    render: function render() {
        this._updatePhotoData()._updatePhotoFirm()._updatePhotoProject()._updatePhotoAttributeTags();

        return this;
    },


    /**
     * Updates the photo's title and caption
     *
     * @returns {PhotoDetails}
     * @private
     */
    _updatePhotoData: function _updatePhotoData() {
        var _props = this.props,
            photoTitle = _props.photoTitle,
            photoCaption = _props.photoCaption;

        var prevTemplate = this.$similarItems[0].innerHTML;
        var nextTemplate = this.props.similarItemsTemplate;

        if (prevTemplate !== nextTemplate) {
            this.$similarItems.empty().append(nextTemplate);
        }

        this.$photoTitle.text(photoTitle);
        this.$photoCaption.text(photoCaption);

        return this;
    },


    /**
     * Updates photo's firm name, links and image
     * @returns {PhotoDetails}
     * @private
     */
    _updatePhotoFirm: function _updatePhotoFirm() {
        var _ref = this.props.photoFirm || {},
            name = _ref.name,
            url = _ref.url,
            _ref$photo = _ref.photo,
            photo = _ref$photo === undefined ? {} : _ref$photo;

        var prevTemplate = this.$moreProjects[0].innerHTML;
        var nextTemplate = this.props.moreProjectsTemplate;

        this.$firmName.text(name);
        this.$firmLink.attr('href', url);
        this.$firmImage.attr('src', photo.images.thumb);
        this.$projectsLink.attr('href', '' + url + pageUrlLabels[pages.PROJECTS] + '/');

        if (prevTemplate !== nextTemplate) {
            this.$moreProjects.empty().append(nextTemplate);
        }

        return this;
    },


    /**
     * Updates photo's project name and links
     * @returns {PhotoDetails}
     * @private
     */
    _updatePhotoProject: function _updatePhotoProject() {
        var _ref2 = this.props.photoProject || {},
            name = _ref2.name,
            url = _ref2.url;

        this.$projectLink.attr('href', url);
        this.$projectName.text(name);
        return this;
    },


    /**
     * Updates photo's attribute tags
     * @returns {PhotoDetails}
     * @private
     */
    _updatePhotoAttributeTags: function _updatePhotoAttributeTags() {
        var _props$photoAttrTags = this.props.photoAttrTags,
            photoAttrTags = _props$photoAttrTags === undefined ? [] : _props$photoAttrTags;

        var links = photoAttrTags.map(function (_ref3) {
            var url = _ref3.url,
                value = _ref3.value;
            return '<a href="' + url + '" target="_blank">' + value + '</a>';
        });
        this.$photoAttributes.html(links.join('<span>, </span>'));

        return this;
    },
    _onClickProjectLink: function _onClickProjectLink() {
        this.context.executeAction(galleryTrackingActions.trackLinkClick, { target: GA_LINK_TARGETS.PROJECT });
    },
    _onClickMoreProjectsLink: function _onClickMoreProjectsLink() {
        this.context.executeAction(galleryTrackingActions.trackLinkClick, { target: GA_LINK_TARGETS.MORE });
    },
    _onClickSimilarItemsLink: function _onClickSimilarItemsLink(e) {
        this.context.executeAction(galleryTrackingActions.trackLinkClick, {
            target: GA_LINK_TARGETS.VIEW_SIMILAR,
            label: e.currentTarget.href
        });
    },
    _onClickSimilarItem: function _onClickSimilarItem(e) {
        this.context.executeAction(galleryTrackingActions.trackSimilarItemClick, e.currentTarget.dataset);
    }
});

module.exports = PhotoDetails;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(281),
    creatorById = _require.creatorById;

var _require2 = __webpack_require__(388),
    addHeaders = _require2.addHeaders,
    fetchWrapper = _require2.fetchWrapper;

function fetchCreators(ac, _ref, done) {
    var creatorIds = _ref.creatorIds;

    if (creatorIds && creatorIds.length) {
        var requests = creatorIds.map(function (creatorId) {
            return fetchWrapper(creatorById(creatorId), addHeaders({ method: 'get' }));
        });

        Promise.all(requests).then(function (responses) {
            ac.dispatch('ADD_CREATORS', responses.map(function (_ref2) {
                var result = _ref2.result;
                return result;
            }));
            done();
        }).catch(done);
    }
}

module.exports = {
    fetchCreators: fetchCreators
};

/***/ }),
/* 1077 */,
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

/**
 *
 * @type {{label: string, trackingLabel: string, path: string}[]}
 */
var INITIAL_CONFIG = [{
    label: 'Home',
    trackingLabel: 'home',
    path: '/'
}];

/**
 * Render a breadcrumb arrow.
 */
var Arrow = function Arrow(_ref) {
    var breadcrumbIndex = _ref.breadcrumbIndex,
        totalBreadcrumbs = _ref.totalBreadcrumbs;

    // Don't add the arrow if this is the last breadcrumb.
    if (breadcrumbIndex + 1 === totalBreadcrumbs) {
        return null;
    }
    return React.createElement(
        'span',
        { className: 'page-breadcrumb-divider' },
        '/'
    );
};

Arrow.propTypes = {
    // The index of the current breadcrumb
    breadcrumbIndex: PropTypes.number.isRequired,

    // The total number of breadcrumbs
    totalBreadcrumbs: PropTypes.number.isRequired
};

/**
 * Render an individual breadcrumb.
 */
var Breadcrumb = function Breadcrumb(_ref2) {
    var breadcrumbData = _ref2.breadcrumbData,
        breadcrumbIndex = _ref2.breadcrumbIndex,
        totalBreadcrumbs = _ref2.totalBreadcrumbs,
        _ref2$callback = _ref2.callback,
        callback = _ref2$callback === undefined ? function () {} : _ref2$callback;
    var path = breadcrumbData.path,
        label = breadcrumbData.label;


    return React.createElement(
        'li',
        { className: 'page-breadcrumb', key: breadcrumbIndex },
        React.createElement(
            'a',
            { className: 'page-breadcrumb-link', href: path, onClick: function onClick() {
                    return callback(breadcrumbData);
                } },
            React.createElement(
                'span',
                null,
                label
            )
        ),
        React.createElement('meta', { content: breadcrumbIndex + 1 }),
        Arrow({ // eslint-disable-line new-cap
            breadcrumbIndex: breadcrumbIndex,
            totalBreadcrumbs: totalBreadcrumbs
        })
    );
};

Breadcrumb.propTypes = {
    // The configuration for the current breadcrumb
    breadcrumbData: PropTypes.shape({
        path: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        trackingLabel: PropTypes.string
    }).isRequired,

    // The index of the current breadcrumb
    breadcrumbIndex: PropTypes.number.isRequired,

    // The total number of breadcrumbs
    totalBreadcrumbs: PropTypes.number.isRequired,

    // Optional callback to fire on breadcrumb click
    callback: PropTypes.func
};

/**
 * Render breadcrumbs for page.
 */
var PageBreadcrumbs = function PageBreadcrumbs(_ref3) {
    var config = _ref3.config,
        addInitialConfig = _ref3.addInitialConfig,
        itemClickCallback = _ref3.itemClickCallback;


    if (addInitialConfig) {
        config = INITIAL_CONFIG.concat(config);
    }
    return (
        // Todo: Move that helper file somewhere more global
        React.createElement(
            'ul',
            { className: 'page-breadcrumbs' },
            config.map(function (breadcrumbData, breadcrumbIndex) {
                return Breadcrumb({ // eslint-disable-line new-cap
                    callback: itemClickCallback,
                    totalBreadcrumbs: config.length,
                    breadcrumbData: breadcrumbData,
                    breadcrumbIndex: breadcrumbIndex
                });
            })
        )
    );
};

PageBreadcrumbs.propTypes = {
    config: PropTypes.arrayOf(PropTypes.shape({
        path: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        trackingLabel: PropTypes.string
    })).isRequired,

    // Optional boolean that if true, prepends initial config to config in props
    addInitialConfig: PropTypes.bool,

    // Optional callback to be passed to each individual breadcrumb. This will be passed an object containing the
    // `path`, `label` and `trackingLabel` for that breadcrumb.
    itemClickCallback: PropTypes.func
};

module.exports = PageBreadcrumbs;

/***/ }),
/* 1079 */,
/* 1080 */,
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 7/6/16.
 */



var SV = __webpack_require__(17);
var Price = __webpack_require__(66);
var PriceLock = __webpack_require__(1348);
var enabler = __webpack_require__(63);
var get = __webpack_require__(14);

var getPriceIn = function getPriceIn(_ref) {
    var itemModel = _ref.itemModel,
        currency = _ref.currency;

    return function (_ref2) {
        var type = _ref2.type;

        return itemModel.getPriceIn(type, currency);
    };
};

var validPrice = function validPrice(_ref3) {
    var _ref3$targetPrice = _ref3.targetPrice,
        targetPrice = _ref3$targetPrice === undefined ? 0 : _ref3$targetPrice,
        _ref3$retailPrice = _ref3.retailPrice,
        retailPrice = _ref3$retailPrice === undefined ? 0 : _ref3$retailPrice;

    var validTargetPrice = !!(targetPrice && targetPrice !== 0);
    // no retailPrice but validTargetPrice = net price + PUR item
    return !!(validTargetPrice && (!retailPrice || targetPrice < retailPrice));
};

var getPriceByType = function getPriceByType(_ref4) {
    var itemModel = _ref4.itemModel,
        type = _ref4.type;

    return itemModel.getPriceByType(type) || {};
};

var createPriceTypes = function createPriceTypes(_ref5) {
    var itemModel = _ref5.itemModel,
        currency = _ref5.currency;

    var priceTypes = [Price.TYPE_NET, Price.TYPE_RETAIL, Price.TYPE_SALE];
    return priceTypes.reduce(function (prev, type) {
        var model = getPriceByType({ itemModel: itemModel, type: type });
        var price = getPriceIn({ itemModel: itemModel, currency: currency })({ type: type });
        if (model && price) {
            prev[type] = {
                model: model,
                price: price
            };
        }
        return prev;
    }, {});
};

var getOriginalPrice = function getOriginalPrice(_ref6) {
    var itemModel = _ref6.itemModel,
        currency = _ref6.currency;

    var model = itemModel.getPriceLocksByType(PriceLock.LOCK_TYPE_ORIGINAL);
    var price = itemModel.getPriceLocksIn(PriceLock.LOCK_TYPE_ORIGINAL, currency);
    return {
        model: model,
        price: price
    };
};

var userIsLoggedOut = function userIsLoggedOut() {
    var userProfile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return userProfile !== null && userProfile.type === 'NOT_LOGGED_IN';
};

var holdBelongsToUser = function holdBelongsToUser(_ref7) {
    var userId = _ref7.userId,
        itemModel = _ref7.itemModel;

    if (!itemModel || typeof itemModel.get !== 'function') {
        return false;
    }
    // Retrieve custom holds (injected via graphql)
    var customHold = itemModel.get('activeHold');
    if (customHold) {
        // If there is an active custom hold, get the buyer id
        var buyerId = get(customHold, 'buyer.serviceId', '');
        // If there is a custom hold, does is belong to the user?
        return buyerId === userId;
    }

    // Fallback to normal attrs if activeHold not injected
    var holds = itemModel.get('holds');
    var activeHold = holds ? holds.getActiveHold() : undefined;
    if (activeHold) {
        return userId === activeHold.get('buyer.id');
    }
    return false;
};

var priceHelpers = {
    /**
     * Get the main retail, net, and sale price data
     * Returns an object of different price types with
     * a `model` and `price` property
     * @param {object} userProfile
     * @param {object} itemModel
     * @param {string} currency
     * @returns {{salePriceData: { model: Backbone.Model, price}, netPriceData: (*|{}), retailPriceData: (*|{})}}
     */
    processPriceData: function processPriceData(_ref8) {
        var _ref8$userProfile = _ref8.userProfile,
            userProfile = _ref8$userProfile === undefined ? {} : _ref8$userProfile,
            itemModel = _ref8.itemModel,
            currency = _ref8.currency;

        var priceModels = createPriceTypes({ itemModel: itemModel, currency: currency });
        var originalPriceData = getOriginalPrice({ itemModel: itemModel, currency: currency });
        var salePriceData = priceModels[Price.TYPE_SALE] || {};
        var netPriceData = priceModels[Price.TYPE_NET] || {};
        var retailPriceData = priceModels[Price.TYPE_RETAIL] || {};
        var priceData = {
            originalPriceData: originalPriceData,
            salePriceData: salePriceData,
            retailPriceData: retailPriceData
        };

        if (!userIsLoggedOut(userProfile)) {
            priceData.netPriceData = netPriceData;
        }

        return priceData;
    },


    // If user is trade and item is in furniture vertical with a valid net price
    showNetPrice: function showNetPrice(_ref9) {
        var canUserRequestNetPrice = _ref9.canUserRequestNetPrice,
            userProfile = _ref9.userProfile,
            itemModel = _ref9.itemModel,
            validNetPrice = _ref9.validNetPrice;

        if (userIsLoggedOut(userProfile)) {
            return false;
        }
        return !!(enabler.isEnabled('enable_net_price') && !!validNetPrice && itemModel.isFurniture() && (!!SV.get('data.netPrice') || canUserRequestNetPrice));
    },
    showSalePrice: function showSalePrice(salePrice, originalPrice) {
        return salePrice > 0 && salePrice < originalPrice;
    },
    getButtonOptions: function getButtonOptions(props) {
        var itemModel = props.itemModel,
            itemProps = props.itemProps,
            userProfile = props.userProfile;
        var userId = userProfile.id;
        var canRequestNetPrice = itemProps.canRequestNetPrice,
            salePriceData = itemProps.salePriceData,
            netPriceData = itemProps.netPriceData,
            retailPriceData = itemProps.retailPriceData,
            originalPriceData = itemProps.originalPriceData;

        var retailPrice = retailPriceData.price;
        var netPrice = netPriceData.price;
        var salePrice = salePriceData.price;
        var originalPrice = originalPriceData.price;
        var showSalePrice = priceHelpers.showSalePrice(salePrice, originalPrice);
        var validNetPrice = validPrice({ targetPrice: netPrice, retailPrice: retailPrice });
        var isRetailPriceHidden = itemModel.isPriceHiddenByType(Price.TYPE_RETAIL);
        var isRetailPriceNegotiable = itemModel.isNegotiablePriceByType(Price.TYPE_RETAIL);
        var isSalePriceNegotiable = itemModel.isNegotiablePriceByType(Price.TYPE_SALE);
        // Does the item have an unavailable reason code that is either 'ON_HOLD' of 'ON_HOLD_CUSTOM'?
        var isOnHold = itemModel.isOnHold();
        var isSold = itemModel.isSold();
        var showRequestNetPrice = void 0;
        var showRequestPrice = void 0;
        var showPurchaseButton = void 0;
        var showMakeOffer = void 0;
        var showMakeOfferMC = void 0;

        if (isOnHold && !holdBelongsToUser({ userId: userId, itemModel: itemModel }) || isSold) {
            // If the item is "On Hold" && the hold does not belong to the current user, then return no buttons
            showRequestNetPrice = false;
            showRequestPrice = false;
            showPurchaseButton = false;
            showMakeOffer = false;
            showMakeOfferMC = false;
        } else if (canRequestNetPrice && itemModel.isFurniture()) {
            // Otherwise, if Trade User viewing items that are in furniture vertical
            // Show the "Request Net Price" Button if item is not on sale and has a hidden net price (PUR)
            showRequestNetPrice = !showSalePrice && !validNetPrice;
            // Never show the "Request Price Button"
            showRequestPrice = false;
            // Show the "Purchase" Button if item is on sale, has a valid net price, or a non-hidden list price
            showPurchaseButton = showSalePrice || validNetPrice || !isRetailPriceHidden;
            // Show the "Make Offer" Button if item is on sale and negotiable
            showMakeOffer = showSalePrice && isSalePriceNegotiable;
            // Show the "Make Offer Button" in Message Center if Sale Price is Negotiable or Retail Price is Negotiable, regardless of user type
            showMakeOfferMC = showSalePrice && isSalePriceNegotiable || !isRetailPriceHidden && isRetailPriceNegotiable;
        } else {
            // Otherwise, if non-Furniture-Trade User...
            // Never show the "Request Net Price" Button
            showRequestNetPrice = false;
            // Show the "Request Price" Button if item is not on sale and has a hidden list/retail price (PUR)
            showRequestPrice = !showSalePrice && isRetailPriceHidden;
            // Show the "Purchase" Button if item is on sale, or has a non-hidden retail price
            showPurchaseButton = showSalePrice || !isRetailPriceHidden;
            // Show the "Make Offer" Button if item is on sale and negotiable, or is not on sale has a non-hidden, negotiable retail price
            showMakeOffer = showSalePrice ? isSalePriceNegotiable : !isRetailPriceHidden && isRetailPriceNegotiable;
            // Show the "Purchase Button" in Message Center if Sale Price is Negotiable or Retail Price is Negotiable, regardless of user type
            showMakeOfferMC = showSalePrice && isSalePriceNegotiable || !isRetailPriceHidden && isRetailPriceNegotiable;
        }

        return {
            showRequestNetPrice: showRequestNetPrice,
            showRequestPrice: showRequestPrice,
            showPurchaseButton: showPurchaseButton,
            showMakeOffer: showMakeOffer,
            showMakeOfferMC: showMakeOfferMC
        };
    },
    getPriceDisplayOptions: function getPriceDisplayOptions(props) {
        var itemModel = props.itemModel,
            itemProps = props.itemProps,
            userProfile = props.userProfile;
        var userId = userProfile.id;
        var canRequestNetPrice = itemProps.canRequestNetPrice,
            salePriceData = itemProps.salePriceData,
            netPriceData = itemProps.netPriceData,
            retailPriceData = itemProps.retailPriceData,
            originalPriceData = itemProps.originalPriceData;

        var retailPrice = retailPriceData.price;
        var netPrice = netPriceData.price;
        var salePrice = salePriceData.price;
        var originalPrice = originalPriceData.price;
        var validNetPrice = validPrice({ targetPrice: netPrice, retailPrice: retailPrice });
        var isRetailPriceHidden = itemModel.isPriceHiddenByType(Price.TYPE_RETAIL);
        var showSold = itemModel.isSold();
        // Does the item have an unavailable reason code that is either 'ON_HOLD' of 'ON_HOLD_CUSTOM'?
        var isOnHold = itemModel.isOnHold();
        // Show the "On Hold" custom display if there is a hold that belongs to user
        var showOnHoldCustom = holdBelongsToUser({ userId: userId, itemModel: itemModel });
        var showOnHold = isOnHold && !showOnHoldCustom;

        var showSalePrice = priceHelpers.showSalePrice(salePrice, originalPrice);
        var showNetPrice = void 0;
        var showRetailPrice = !showSalePrice && !isRetailPriceHidden;
        var showPriceUponRequest = void 0;
        var showListPriceLabel = void 0;

        if (showSold) {
            showSalePrice = false;
            showNetPrice = false;
            showRetailPrice = false;
            showPriceUponRequest = false;
            showListPriceLabel = false;
        } else {
            if (canRequestNetPrice && itemModel.isFurniture()) {
                // Otherwise, if Trade User viewing items that are in furniture vertical
                // Display "Net Price" if it is valid and if we do not display the "Sale Price"
                showNetPrice = !showSalePrice && validNetPrice;
                // Display "List Price Label" if we display the "List Price"
                showListPriceLabel = showRetailPrice;
            } else {
                // Otherwise, if non-Furniture-Trade User...
                // Never display "Net Price"
                showNetPrice = false;
                // Never Display "List Price Label"
                showListPriceLabel = false;
            }
            // Display "List Price" if it is not hidden and if we do not display the "Sale Price"
            showRetailPrice = !showSalePrice && !isRetailPriceHidden;
            // Display "Price Upon Request" if we display neither "Net Price" nor "List Price"
            showPriceUponRequest = !showNetPrice && !showRetailPrice && !showSalePrice;
        }

        return {
            showSalePrice: showSalePrice,
            showNetPrice: showNetPrice,
            showRetailPrice: showRetailPrice,
            showPriceUponRequest: showPriceUponRequest,
            showListPriceLabel: showListPriceLabel,
            showOnHoldCustom: showOnHoldCustom,
            showOnHold: showOnHold,
            showSold: showSold
        };
    }
};

module.exports = priceHelpers;

/***/ }),
/* 1082 */,
/* 1083 */,
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__(18);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _VerifiedTradePromoInfo = __webpack_require__(1868);

var _VerifiedTradePromoInfo2 = _interopRequireDefault(_VerifiedTradePromoInfo);

var _verifiedTradePromoHelpers = __webpack_require__(1340);

var _verifiedTradePromoFragments = __webpack_require__(1339);

var _verifiedTradePromoConstants = __webpack_require__(1085);

var _VerifiedTradePromo = __webpack_require__(1256);

var _VerifiedTradePromo2 = _interopRequireDefault(_VerifiedTradePromo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _getShippingPromoString = function _getShippingPromoString(shippingAmount) {
    var texts = _verifiedTradePromoConstants.shipping.texts;

    return (0, _verifiedTradePromoHelpers.promoCoversShipping)(shippingAmount) ? texts.FREE_SHIPPING : texts.CREDIT_APPLIED;
};

var VerifiedTradePromo = function VerifiedTradePromo(props) {
    var viewer = props.viewer,
        inShippingModal = props.inShippingModal,
        shippingAmount = props.shippingAmount;
    var texts = _verifiedTradePromoConstants.shipping.texts;


    return (0, _verifiedTradePromoHelpers.applyPromo)(viewer) ? _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_VerifiedTradePromo2.default.promoContainer, _defineProperty({}, _VerifiedTradePromo2.default.inShippingModal, inShippingModal)) },
        _react2.default.createElement(
            'div',
            { className: _VerifiedTradePromo2.default.textContainer },
            _react2.default.createElement(
                'span',
                { className: _VerifiedTradePromo2.default.highlightedText },
                inShippingModal ? _getShippingPromoString(shippingAmount) : texts.FREE_SHIPPING
            ),
            !inShippingModal && texts.FIRST_ORDER
        ),
        _react2.default.createElement(_VerifiedTradePromoInfo2.default, { tooltipDirection: inShippingModal ? 'left' : 'top' })
    ) : null;
};

VerifiedTradePromo.propTypes = {
    viewer: _propTypes2.default.object,
    inShippingModal: _propTypes2.default.bool,
    shippingAmount: _propTypes2.default.object
};

exports.default = _reactRelay2.default.createContainer(VerifiedTradePromo, {
    initialVariables: {
        userId: null,
        itemId: null
    },
    fragments: {
        viewer: function viewer() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, _reactRelay2.default.QL.__frag(RQL_0)]),
                    id: _reactRelay2.default.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'VerifiedTradePromo_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(_verifiedTradePromoFragments.ViewerFragment);
        }
    }
});

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var shipping = exports.shipping = {
    amounts: {
        MIN_ITEM_PRICE_USD: 1000,
        PROMO_AMOUNT_USD: 500
    },
    texts: {
        FREE_SHIPPING: 'Free shipping',
        FIRST_ORDER: ' on your first order',
        CREDIT_APPLIED: 'Your 500$ shipping credit will be applied'
    },
    tooltip: {
        texts: {
            MAIN: 'Save up to $500 off shipping costs when you enter code TRADESHIP at checkout.',
            END: 'apply.'
        },
        link: {
            URL: '/info/tradeship/',
            TEXT: 'T & C'
        }
    }
};

/***/ }),
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _events;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ConnectedBaseView = __webpack_require__(523);

var _require = __webpack_require__(709),
    connectGalleryModalStoreToView = _require.connectGalleryModalStoreToView;

// Subviews


var SimpleModal = __webpack_require__(983);
var GalleryModalView = __webpack_require__(1330);

// Actions
var galleryTrackingActions = __webpack_require__(453);
var galleryModalActions = __webpack_require__(512);
var galleryActions = __webpack_require__(363);

var classes = __webpack_require__(342).galleryModalClasses;
var GA_LINK_TARGETS = galleryTrackingActions.GA_LINK_TARGETS;


var Overlay = __webpack_require__(609);

/**
 * Wrapper View For GalleryModal
 *  - initializes SimpleModal
 *  - renders the server-side template in the modal
 *  - initializes the Gallery Subview once the template is rendered in the dom
 *  - shows/hides the modal
 */
var GalleryModalWrapperView = connectGalleryModalStoreToView(ConnectedBaseView).extend({
    className: classes.CONTENT_GALLERY,

    events: (_events = {}, _defineProperty(_events, 'click .' + classes.PHOTO_PROJECT_LINK, '_toProject'), _defineProperty(_events, 'click .' + classes.CLOSE_GALLERY_LINK, '_hideModal'), _events),

    subViewConfig: {
        modal: {
            construct: SimpleModal,
            singleton: true
        },
        gallery: {
            construct: GalleryModalView,
            singleton: true
        }
    },

    initialize: function initialize(_ref) {
        var _this = this;

        var context = _ref.context;

        // Initializing the modal subView
        this.subs.add('modal', {
            content: this,
            closeButton: false,
            // callback triggered after the user presses esc
            manualHideCallback: function manualHideCallback() {
                var gallery = _this.subs.get('gallery');
                if (gallery) {
                    context.executeAction(galleryModalActions.hideModal);
                }
            },
            classNames: classes.SIMPLE_MODAL_CLASSES
        });
        this.subs.get('modal').render();
        this.overlay = new Overlay();
    },


    /**
     * Calls all necessary methods for resetting the gallery for pages that have more than one gallery modal
     *  - resets the gallery store
     *  - resets the gallery modal store
     *  - removes existing modal view and its subviews
     */
    resetGalleryModal: function resetGalleryModal() {
        // Call actions to reset the stores
        this.context.executeAction(galleryActions.resetSetupStore);
        this.context.executeAction(galleryModalActions.resetModal);

        // Remove existing gallery view, so new one renders correctly
        if (typeof this.subs.get('gallery') !== 'undefined') {
            this.subs.get('gallery').remove();
            this.subs.remove('gallery');
        }
    },


    /**
     * Sets the props
     */
    getPropsFromStores: function getPropsFromStores(galleryModalStore) {
        var galleryModalOpen = this.subs.get('modal').$el.hasClass('open');

        return {
            isLoading: galleryModalStore.isLoading(),
            hasJustLoaded: galleryModalStore.hasJustLoaded(),
            template: galleryModalStore.getTemplate(),
            shouldShow: !galleryModalStore.isHidden() && !galleryModalOpen,
            shouldClose: galleryModalStore.isHidden() && galleryModalOpen,
            getOriginalUrl: galleryModalStore.getOriginalUrl(),
            originalPageType: galleryModalStore.getOriginalPageType()
        };
    },
    showOverlay: function showOverlay() {
        this.overlay.show({
            // need the `parent` every time b/c the DOM
            // is completely rewritten on each ajax request
            parent: this.$el[0],
            // use the global (window) object for the width basis since it's a fixed element
            containerWidth: global.innerWidth,
            containerHeight: global.innerHeight
        });
    },


    /**
     * Render method called after the view receives new props
     *  - Opens/closes the modal
     *  - Renders the template in the modal (the first open only)
     */
    render: function render() {
        var props = this.props;
        var galleryModal = this.subs.get('modal');

        // If the modal content is loading then render loading content
        // and show the modal
        if (props.isLoading) {
            galleryModal.$el.addClass(classes.STATE_NOT_LOADED);
            this.showOverlay();
            galleryModal.show();

            // If the modal is loaded but has never been opened before then render
            // the template and show the modal
        } else if (props.hasJustLoaded) {
            this.$el.html(props.template);
            this.subs.add('gallery', { context: this.context, isModal: true, pageType: props.originalPageType });

            galleryModal.$el.removeClass(classes.STATE_NOT_LOADED);
            galleryModal.show();

            // Show the modal
        } else if (props.shouldShow) {
            galleryModal.show();

            // Hide the modal
        } else if (props.shouldClose) {
            galleryModal.hide();
        }
    },


    /**
     * Event Handler - executes action to to hide the modal
     *  (invoked either when the close button is clicked or when the link to the projects is clicked)
     */
    _hideModal: function _hideModal(e) {
        e.preventDefault();
        this.getContext().executeAction(galleryModalActions.hideModal);
        this.getContext().executeAction(galleryTrackingActions.trackLinkClick, { target: GA_LINK_TARGETS.CLOSE });
    },
    _toProject: function _toProject(event) {
        var projectUrl = this.$('.' + classes.PHOTO_PROJECT_LINK).attr('href');

        if (projectUrl === this.props.getOriginalUrl) {
            this._hideModal(event);
        }
    }
});

module.exports = GalleryModalWrapperView;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */
/***/ (function(module, exports) {

module.exports = {
	"details": {
		"mainTitle": "Details",
		"price": "Price:",
		"requestInfo": "Request More Info"
	},
	"sidebar": {
		"requestInfo": "Request More Info",
		"customizeItem": "Request Customization"
	},
	"shipping": {
		"mainTitle": "Shipping & Returns",
		"estimateTitle": "Shipping",
		"returnTitle": "Return Policy",
		"viewMoreTitle": "View More Details",
		"viewAllQuotes": "View all shipping quotes",
		"hasQuote": {
			"href": "#all-shipping",
			"canRequest": "View and request shipping quotes",
			"cannotRequest": "View all shipping quotes"
		},
		"noQuote": {
			"href": "#all-shipping-global",
			"canRequest": "Request a shipping quote",
			"cannotRequest": "View details"
		}
	},
	"dealer": {
		"sinceYear": "1stdibs {type} since {sinceYear}",
		"location": "Located in {location}",
		"contact": "contact",
		"infoExpanded": "Additional Information &#8211;",
		"infoCollapsed": "Additional Information &#43;",
		"carouselHeader": "More from this {type}",
		"offeredBy": "Offered By",
		"callDealerCta": "Call Seller"
	},
	"suggestion": {
		"carouselHeader": "You May Also Like",
		"soldCarouselHeader": "Browse Similar Items",
		"recommendedForYou": "Recommended %s for You"
	},
	"priceStates": {
		"reducedFrom": "Reduced From",
		"onHold": "On Hold",
		"onHoldForUser": "On Hold For You",
		"sold": "Sold",
		"unavailable": "Unavailable",
		"perItem": "per item",
		"uponRequest": "Price Upon Request",
		"soldWithLink": "Sorry, this item from <a href=\"%s\">%s</a> has been sold.",
		"suspended": "Sorry, this item is not currently available.",
		"netPrice": "Net Price",
		"retailPrice": "List Price",
		"off": "Off"
	},
	"linkText": {
		"heroSuspendedPriceLinkText": "Browse %s other %s",
		"viewProfileLinktext": "View Profile"
	},
	"support": {
		"cta": "<span>Questions about your online purchase?</span><br /><span>We're here to help.</span>",
		"linkUrl": "https://support.1stdibs.com/",
		"linkText": "Contact 1stdibs"
	},
	"nydc": {
		"galleryName": "1stdibs Gallery at 200 LEX",
		"streetAddress": "200 Lexington Avenue",
		"cityStateAddress": "New York, NY 10016",
		"urlPath": "/nydc/"
	},
	"print": {
		"print": "Print",
		"printNoPrice": "Print without Price"
	},
	"similar": {
		"header": "Items Similar to",
		"soldHeader": "This <i>{itemTitle}</i> is no longer available.",
		"soldSubheader": "View Similar Items",
		"cta": "View More"
	},
	"productionTime": {
		"title": "Estimated Production Time:"
	},
	"heroTitles": {
		"about": "About",
		"customizationOptions": "Customization Options",
		"aboutTheMaker": "About the Maker"
	},
	"benefits": {
		"title": "Buy Online to Receive Trade Benefits",
		"linkText": "Learn More",
		"linkUrl": "/info/trade/benefits/",
		"fields": [
			{
				"title": "Buyer Protection on every purchase"
			},
			{
				"title": "Lowest advertised net price"
			},
			{
				"title": "Trade Concierge order assistance"
			}
		]
	},
	"guarantee": {
		"title": "Trade Price Guarantee",
		"tooltip": {
			"title": "Trade Price Guarantee",
			"description": "As a trade member, you receive the lowest advertised net price when you purchase through 1stdibs online checkout.",
			"linkText": "Learn More",
			"linkUrl": "/info/trade/net-price-guarantee/"
		}
	},
	"urgency": {
		"title": "In high demand",
		"text": "people are viewing this item"
	}
};

/***/ }),
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reducers = exports.default = undefined;

	var _component = __webpack_require__(1);

	var _component2 = _interopRequireDefault(_component);

	var _relay = __webpack_require__(44);

	var _relay2 = _interopRequireDefault(_relay);

	var _redux = __webpack_require__(46);

	var _redux2 = _interopRequireDefault(_redux);

	var _reducers = __webpack_require__(47);

	var _reducers2 = _interopRequireDefault(_reducers);

	var _recompose = __webpack_require__(35);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var wrappedComponent = (0, _recompose.hoistStatics)((0, _recompose.compose)(_relay2.default, _redux2.default))(_component2.default);

	exports.default = wrappedComponent;
	exports.reducers = _reducers2.default;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _dibsElements = __webpack_require__(4);

	var _copyText = __webpack_require__(5);

	var _copyText2 = _interopRequireDefault(_copyText);

	var _tracking = __webpack_require__(6);

	var _tracking2 = _interopRequireDefault(_tracking);

	var _Shipping = __webpack_require__(8);

	var _Shipping2 = _interopRequireDefault(_Shipping);

	var _SuccessContent = __webpack_require__(28);

	var _SuccessContent2 = _interopRequireDefault(_SuccessContent);

	var _copy = __webpack_require__(19);

	var _copy2 = _interopRequireDefault(_copy);

	var _styles = __webpack_require__(33);

	var _styles2 = _interopRequireDefault(_styles);

	__webpack_require__(14);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var RequestShippingQuoteModal = function (_Component) {
	    _inherits(RequestShippingQuoteModal, _Component);

	    function RequestShippingQuoteModal(props) {
	        _classCallCheck(this, RequestShippingQuoteModal);

	        var _this = _possibleConstructorReturn(this, (RequestShippingQuoteModal.__proto__ || Object.getPrototypeOf(RequestShippingQuoteModal)).call(this, props));

	        _this.copy = (0, _copyText2.default)().extend(_copy2.default);

	        _this.hasInitialStepOverride = _react2.default.Children.count(_this.props.children) === 1;

	        _this.onSuccess = _this.onSuccess.bind(_this);
	        _this.onFailure = _this.onFailure.bind(_this);
	        return _this;
	    }

	    _createClass(RequestShippingQuoteModal, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                isOpened = _props.isOpened,
	                modalKey = _props.modalKey,
	                userId = _props.userId,
	                relay = _props.relay,
	                setOpenModalKey = _props.setOpenModalKey,
	                setCurrentStep = _props.setCurrentStep,
	                clearState = _props.clearState;


	            if (!isOpened && nextProps.isOpened) {
	                setOpenModalKey(modalKey);

	                if (this.hasInitialStepOverride) {
	                    setCurrentStep('initialStepOverride');
	                }
	            }

	            if (isOpened && !nextProps.isOpened) {
	                clearState();
	            }

	            if (!userId && nextProps.userId) {
	                relay.setVariables({ currentUserId: userId });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.clearState();
	        }
	    }, {
	        key: 'onSuccess',
	        value: function onSuccess() {
	            var _props2 = this.props,
	                trackingLocation = _props2.trackingLocation,
	                setCurrentStep = _props2.setCurrentStep;

	            _tracking2.default.trackSubmitted({ label: trackingLocation });
	            setCurrentStep('requestSuccess');
	        }
	    }, {
	        key: 'onFailure',
	        value: function onFailure() {
	            this.props.setErrorMessage({ errorMessage: this.copy.get('sqrMutationError') });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                relay = _props3.relay,
	                user = _props3.user,
	                environment = _props3.environment,
	                isOpened = _props3.isOpened,
	                requestedShipmentQuote = _props3.requestedShipmentQuote,
	                conversationId = _props3.conversationId,
	                currentStep = _props3.currentStep,
	                buyerDisplayName = _props3.buyerDisplayName,
	                onOpen = _props3.onOpen,
	                children = _props3.children,
	                onShowQuoteRequest = _props3.onShowQuoteRequest,
	                setCurrentStep = _props3.setCurrentStep,
	                closeShippingModal = _props3.closeShippingModal,
	                clearState = _props3.clearState,
	                transactionIsCanceled = _props3.transactionIsCanceled,
	                transactionId = _props3.transactionId,
	                transactionHasCompletedCheckout = _props3.transactionHasCompletedCheckout,
	                userId = _props3.userId,
	                userRelayId = _props3.userRelayId,
	                itemId = _props3.itemId,
	                itemTitle = _props3.itemTitle,
	                seller = _props3.seller,
	                dealerPk = _props3.dealerPk,
	                isMC = _props3.isMC,
	                trackingLocation = _props3.trackingLocation,
	                conversationRelayId = _props3.conversationRelayId,
	                transactionRelayId = _props3.transactionRelayId,
	                pageContext = _props3.pageContext,
	                errorMessage = _props3.errorMessage;

	            var shouldShowSuccess = currentStep === 'requestSuccess';
	            var hasOverrideInitialStep = currentStep === 'initialStepOverride';
	            var shouldShowSQR = !hasOverrideInitialStep && !shouldShowSuccess;

	            // user may submit another request if transaction was canceled
	            if (isOpened && currentStep === 'quoteRequest' && !transactionIsCanceled) {
	                if (transactionHasCompletedCheckout) {
	                    window.location.href = '/my/orders/order/' + transactionId + '/';
	                } else if (requestedShipmentQuote) {
	                    window.location.href = '/my/conversations/' + conversationId + '/';
	                }
	            }

	            var handleBackClick = function handleBackClick() {
	                clearState();
	                setCurrentStep('initialStepOverride');
	            };

	            var barHeaderTitle = shouldShowSuccess ? this.copy.get('sqrSuccessHeader') : this.copy.get('sqrHeader');

	            return _react2.default.createElement(
	                _dibsElements.ModalContainer,
	                {
	                    modalClass: _styles2.default.sqrModalWrapper,
	                    isOpen: isOpened,
	                    onOpen: onOpen,
	                    onClose: closeShippingModal,
	                    modalSize: 'medium'
	                },
	                _react2.default.createElement(_dibsElements.ModalCloseButton, { onClick: closeShippingModal }),
	                hasOverrideInitialStep && !shouldShowSuccess && _react2.default.cloneElement(_react2.default.Children.only(children), {
	                    openQuoteRequestModal: function openQuoteRequestModal() {
	                        setCurrentStep('quoteRequest');
	                        _tracking2.default.trackClicked({ label: trackingLocation });
	                        if (onShowQuoteRequest) {
	                            onShowQuoteRequest();
	                        }
	                    },
	                    closeModal: closeShippingModal
	                }),
	                shouldShowSQR && _react2.default.createElement(_dibsElements.BarHeader, { title: barHeaderTitle }),
	                shouldShowSQR && _react2.default.createElement(
	                    _dibsElements.ModalBody,
	                    null,
	                    _react2.default.createElement(_Shipping2.default, {
	                        relay: relay,
	                        user: user,
	                        buyerDisplayName: buyerDisplayName,
	                        environment: environment,
	                        userId: userId,
	                        itemId: itemId,
	                        itemTitle: itemTitle,
	                        conversationId: conversationId,
	                        dealerPk: dealerPk,
	                        transactionId: transactionId,
	                        conversationRelayId: conversationRelayId,
	                        transactionRelayId: transactionRelayId,
	                        userRelayId: userRelayId,
	                        pageContext: pageContext,
	                        copy: this.copy,
	                        onSuccess: this.onSuccess,
	                        onFailure: this.onFailure
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.sqrError },
	                        errorMessage
	                    ),
	                    children ? _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.sqrFooterBackLink, onClick: handleBackClick },
	                        this.copy.get('sqrBack')
	                    ) : null
	                ),
	                shouldShowSuccess && _react2.default.createElement(_SuccessContent2.default, {
	                    isMC: isMC,
	                    userId: userId,
	                    seller: seller,
	                    copy: this.copy
	                })
	            );
	        }
	    }]);

	    return RequestShippingQuoteModal;
	}(_react.Component);

	RequestShippingQuoteModal.propTypes = {
	    environment: _propTypes2.default.object.isRequired,
	    isOpened: _propTypes2.default.bool,
	    viewer: _propTypes2.default.object,
	    relay: _propTypes2.default.object,
	    userId: _propTypes2.default.string,
	    conversationId: _propTypes2.default.string,
	    transactionId: _propTypes2.default.string,
	    itemId: _propTypes2.default.string.isRequired,
	    dealerPk: _propTypes2.default.string.isRequired,
	    setCurrentStep: _propTypes2.default.func,
	    setErrorMessage: _propTypes2.default.func,
	    requestedShipmentQuote: _propTypes2.default.object,
	    buyerDisplayName: _propTypes2.default.string,
	    onOpen: _propTypes2.default.func,
	    children: _propTypes2.default.object,
	    openQuoteRequestModal: _propTypes2.default.func,
	    itemTitle: _propTypes2.default.string,
	    userRelayId: _propTypes2.default.string,
	    conversationRelayId: _propTypes2.default.string,
	    transactionRelayId: _propTypes2.default.string,
	    clearState: _propTypes2.default.func,
	    pageContext: _propTypes2.default.string,
	    trackingLocation: _propTypes2.default.string,
	    currentStep: _propTypes2.default.string,
	    onShowQuoteRequest: _propTypes2.default.func,
	    transactionIsCanceled: _propTypes2.default.bool,
	    transactionHasCompletedCheckout: _propTypes2.default.bool,
	    closeShippingModal: _propTypes2.default.func,
	    modalKey: _propTypes2.default.string,
	    setOpenModalKey: _propTypes2.default.func,
	    user: _propTypes2.default.object,
	    seller: _propTypes2.default.object,
	    isMC: _propTypes2.default.bool,
	    errorMessage: _propTypes2.default.string
	};

	RequestShippingQuoteModal.defaultProps = {
	    pageContext: 'DEALER_SHIPPING_REQUEST'
	};

	exports.default = RequestShippingQuoteModal;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1);

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1633);

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(697);

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(39);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _dibsTracking = __webpack_require__(7);

	var _dibsTracking2 = _interopRequireDefault(_dibsTracking);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var trackFollowDealer = function trackFollowDealer(_ref) {
	    var isMC = _ref.isMC,
	        action = _ref.action;
	    return _dibsTracking2.default.trackEvent({
	        category: 'dealer favoriting',
	        label: isMC ? 'message center' : 'pdp',
	        action: action
	    });
	};

	var sqrTracking = {
	    trackClicked: function trackClicked(_ref2) {
	        var label = _ref2.label;
	        return _dibsTracking2.default.trackEvent({
	            action: 'request shipping quote clicked',
	            category: 'product',
	            label: label
	        });
	    },
	    trackSubmitted: function trackSubmitted(_ref3) {
	        var label = _ref3.label;
	        return _dibsTracking2.default.trackEvent({
	            action: 'request shipping quote submitted',
	            category: 'product',
	            label: label
	        });
	    },
	    trackDealerFollowed: function trackDealerFollowed(_ref4) {
	        var isMC = _ref4.isMC;
	        return trackFollowDealer({ isMC: isMC, action: 'dealer added' });
	    },
	    trackDealerUnFollowed: function trackDealerUnFollowed(_ref5) {
	        var isMC = _ref5.isMC;
	        return trackFollowDealer({ isMC: isMC, action: 'dealer removed' });
	    }
	};

	exports.default = sqrTracking;

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(27);

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(9);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _shipping = __webpack_require__(10);

	var _shipping2 = _interopRequireDefault(_shipping);

	__webpack_require__(14);

	var _updateBuyerProfileMutation = __webpack_require__(15);

	var _updateBuyerProfileMutation2 = _interopRequireDefault(_updateBuyerProfileMutation);

	var _UserAddAddressMutation = __webpack_require__(17);

	var _UserAddAddressMutation2 = _interopRequireDefault(_UserAddAddressMutation);

	var _requestShipmentQuoteMutation = __webpack_require__(18);

	var _requestShipmentQuoteMutation2 = _interopRequireDefault(_requestShipmentQuoteMutation);

	var _dibsAddressForm = __webpack_require__(20);

	var _dibsAddressForm2 = _interopRequireDefault(_dibsAddressForm);

	var _Select = __webpack_require__(21);

	var _Select2 = _interopRequireDefault(_Select);

	var _Option = __webpack_require__(24);

	var _Option2 = _interopRequireDefault(_Option);

	var _Submit = __webpack_require__(25);

	var _Submit2 = _interopRequireDefault(_Submit);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var OPTIONS = {
	    OPTION_NEW: 'NEW',
	    OPTION_ADD: 'ADD',
	    OPTION_EXIST: 'EXIST',
	    OPTION_REQUEST: 'REQUEST'
	};

	// mutations


	// components

	var Shipping = function (_Component) {
	    _inherits(Shipping, _Component);

	    function Shipping(props) {
	        _classCallCheck(this, Shipping);

	        var _this = _possibleConstructorReturn(this, (Shipping.__proto__ || Object.getPrototypeOf(Shipping)).call(this, props));

	        var firstValidShippingAddressId = (0, _lodash2.default)(props, 'user.firstValidShippingAddress.serviceId');
	        var shippingAddress = (0, _lodash2.default)(props, 'transaction.shipment.shippingAddress') || {};
	        var shippingAddressId = shippingAddress.sourceId || shippingAddress.serviceId;
	        var addressList = (0, _lodash2.default)(props, 'user.addressBook.addressList') || [];
	        var addressExist = addressList.find(function (a) {
	            return a.serviceId === shippingAddressId;
	        });
	        var isExist = !!(shippingAddressId && addressExist);
	        var selectedAddressId = isExist && shippingAddressId || firstValidShippingAddressId || null;

	        _this.onChange = _this.onChange.bind(_this);
	        _this.failureHandler = _this.failureHandler.bind(_this);
	        _this.onSubmit = _this.onSubmit.bind(_this);

	        _this.state = {
	            selected: selectedAddressId || OPTIONS.OPTION_ADD,
	            selectedAddress: selectedAddressId,
	            isSaving: false
	        };
	        return _this;
	    }

	    _createClass(Shipping, [{
	        key: 'onChange',
	        value: function onChange(event) {
	            var selected = event.target.value;

	            var selectedAddress = selected === OPTIONS.OPTION_ADD ? this.state.selectedAddress : selected;
	            this.setState({ selected: selected, selectedAddress: selectedAddress });
	        }
	    }, {
	        key: 'failureHandler',
	        value: function failureHandler() {
	            this.setState({ isSaving: false });
	            this.props.onFailure();
	        }
	    }, {
	        key: 'requestShipmentQuote',
	        value: function requestShipmentQuote(address) {
	            var _props = this.props,
	                relay = _props.relay,
	                userId = _props.userId,
	                user = _props.user,
	                itemId = _props.itemId,
	                itemTitle = _props.itemTitle,
	                conversationId = _props.conversationId,
	                dealerPk = _props.dealerPk,
	                transactionId = _props.transactionId,
	                conversationRelayId = _props.conversationRelayId,
	                transactionRelayId = _props.transactionRelayId,
	                userRelayId = _props.userRelayId,
	                pageContext = _props.pageContext,
	                onSuccess = _props.onSuccess;


	            var requestQuote = new _requestShipmentQuoteMutation2.default({
	                userId: userId,
	                itemId: itemId,
	                dealerPk: dealerPk,
	                conversationId: conversationId,
	                transactionId: transactionId,
	                conversationRelayId: conversationRelayId,
	                transactionRelayId: transactionRelayId,
	                userRelayId: userRelayId,
	                itemTitle: itemTitle,
	                pageContext: pageContext,
	                shippingAddressId: address.serviceId
	            });

	            var _ref = (0, _lodash2.default)(user, 'profile') || {},
	                firstName = _ref.firstName,
	                lastName = _ref.lastName;

	            /**
	             * If firstName and lastName are undefined update user profile with display name,
	             * then request a shipping quote
	             */


	            if (!firstName && !lastName) {
	                return relay.commitUpdate(new _updateBuyerProfileMutation2.default({
	                    displayName: address.firstName + ' ' + address.lastName,
	                    userId: userId,
	                    userRelayId: userRelayId
	                }), {
	                    onSuccess: relay.commitUpdate(requestQuote, {
	                        onSuccess: onSuccess,
	                        onFailure: this.failureHandler
	                    }),
	                    onFailure: this.failureHandler
	                });
	            }

	            return relay.commitUpdate(requestQuote, {
	                onSuccess: onSuccess,
	                onFailure: this.failureHandler
	            });
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit(_ref2) {
	            var _this2 = this;

	            var address = _ref2.address,
	                isValid = _ref2.isValid;
	            var selected = this.state.selected;
	            var _props2 = this.props,
	                relay = _props2.relay,
	                user = _props2.user,
	                userId = _props2.userId;


	            var isAdding = selected === OPTIONS.OPTION_ADD;
	            var existingAddress = ((0, _lodash2.default)(user, 'addressBook.addressList') || []).find(function (a) {
	                return a.serviceId === selected;
	            });
	            isValid = isValid || !isAdding && !!existingAddress;

	            if (isValid) {
	                this.setState({ isSaving: true });

	                if (isAdding) {
	                    relay.commitUpdate(new _UserAddAddressMutation2.default({
	                        userId: userId,
	                        address: address
	                    }), {
	                        onSuccess: function onSuccess(payload) {
	                            _this2.requestShipmentQuote((0, _lodash2.default)(payload, 'userAddAddress.address'));
	                        },
	                        onFailure: this.failureHandler
	                    });
	                } else {
	                    this.requestShipmentQuote(existingAddress);
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                selected = _state.selected,
	                selectedAddress = _state.selectedAddress,
	                isSaving = _state.isSaving;
	            var _props3 = this.props,
	                environment = _props3.environment,
	                user = _props3.user,
	                copy = _props3.copy;

	            var isAdding = selected === OPTIONS.OPTION_ADD;
	            var addresses = ((0, _lodash2.default)(user, 'addressBook.addressList') || []).filter(function (a) {
	                return (0, _lodash2.default)(a, 'validation.buyerShipping.valid');
	            });
	            var addressOptions = addresses.map(function (address) {
	                return {
	                    value: address.serviceId,
	                    label: [address.displayName].concat(address.formattedAddress, [address.displayCountry]).join(', ')
	                };
	            });
	            var showAddresses = !!addressOptions.length;
	            var showAddressForm = isAdding || !addresses.length;

	            return _react2.default.createElement(
	                'div',
	                null,
	                showAddresses && _react2.default.createElement(
	                    'div',
	                    { className: _shipping2.default.subContentWrapper },
	                    _react2.default.createElement(_Option2.default, {
	                        label: copy.get('sqrAddFromSavedAddresses'),
	                        value: selectedAddress,
	                        checked: selected !== OPTIONS.OPTION_ADD,
	                        isDisabled: isSaving,
	                        onChange: this.onChange
	                    }),
	                    !showAddressForm && _react2.default.createElement(_Select2.default, {
	                        wrapperClasses: _shipping2.default.subContent,
	                        name: 'address',
	                        value: selectedAddress,
	                        options: addressOptions,
	                        isDisabled: isSaving,
	                        onChange: this.onChange
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _shipping2.default.subContentWrapper },
	                    showAddresses && _react2.default.createElement(_Option2.default, {
	                        label: copy.get('sqrAddNewAddress'),
	                        value: OPTIONS.OPTION_ADD,
	                        checked: isAdding,
	                        isDisabled: isSaving,
	                        onChange: this.onChange
	                    }),
	                    showAddressForm && _react2.default.createElement(_dibsAddressForm2.default, {
	                        environment: environment,
	                        formClass: showAddresses ? _shipping2.default.subContent : _shipping2.default.singleFormWrapper,
	                        submitLabel: copy.get('sqrSend'),
	                        onSubmit: this.onSubmit
	                    })
	                ),
	                !showAddressForm && _react2.default.createElement(_Submit2.default, {
	                    label: copy.get('sqrSend'),
	                    isSaving: isSaving,
	                    onClick: this.onSubmit
	                })
	            );
	        }
	    }]);

	    return Shipping;
	}(_react.Component);

	Shipping.propTypes = {
	    relay: _propTypes2.default.object.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    environment: _propTypes2.default.object.isRequired,
	    userId: _propTypes2.default.string,
	    itemId: _propTypes2.default.string.isRequired,
	    itemTitle: _propTypes2.default.string,
	    conversationId: _propTypes2.default.string,
	    dealerPk: _propTypes2.default.string.isRequired,
	    transactionId: _propTypes2.default.string,
	    conversationRelayId: _propTypes2.default.string,
	    transactionRelayId: _propTypes2.default.string,
	    userRelayId: _propTypes2.default.string,
	    pageContext: _propTypes2.default.string,
	    copy: _propTypes2.default.object.isRequired,
	    onSuccess: _propTypes2.default.func.isRequired,
	    onFailure: _propTypes2.default.func.isRequired
	};

	exports.default = Shipping;

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1630);

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"subContentWrapper":"src-ShippingRequestModal-shipping---subContentWrapper---10PIZ","subContent":"src-ShippingRequestModal-shipping---subContent---2c6Hb","fieldsWrapper":"src-ShippingRequestModal-shipping---fieldsWrapper---x7u6r","halfFieldLeft":"src-ShippingRequestModal-shipping---halfFieldLeft---fKnvJ","halfFieldRight":"src-ShippingRequestModal-shipping---halfFieldRight---3P0VW","halfFieldWrapper":"src-ShippingRequestModal-shipping---halfFieldWrapper---2oaIe src-ShippingRequestModal-shipping---fieldsWrapper---x7u6r src-ShippingRequestModal-shipping---halfFieldLeft---fKnvJ","halfFieldRightLabel":"src-ShippingRequestModal-shipping---halfFieldRightLabel---1ukCC src-ShippingRequestModal-shipping---halfFieldRight---3P0VW","singleFormWrapper":"src-ShippingRequestModal-shipping---singleFormWrapper---7z2X1","formContainer":"src-ShippingRequestModal-shipping---formContainer---2j_kE","label":"src-ShippingRequestModal-shipping---label---NMqM4","subLabel":"src-ShippingRequestModal-shipping---subLabel---fSn9Q","radioInput":"src-ShippingRequestModal-shipping---radioInput---uqeIT","addressInfoWrapper":"src-ShippingRequestModal-shipping---addressInfoWrapper---1Bq24","select":"src-ShippingRequestModal-shipping---select---2sR88","selectWrapper":"src-ShippingRequestModal-shipping---selectWrapper---1C-BK","selectTriangle":"src-ShippingRequestModal-shipping---selectTriangle---3yxc4","textareaWrapper":"src-ShippingRequestModal-shipping---textareaWrapper---3nN-y","textareaLabel":"src-ShippingRequestModal-shipping---textareaLabel---R_v2W","textarea":"src-ShippingRequestModal-shipping---textarea---1FPOS","quoteWrapper":"src-ShippingRequestModal-shipping---quoteWrapper---2nC56","quoteLabel":"src-ShippingRequestModal-shipping---quoteLabel---20H7Y","quote":"src-ShippingRequestModal-shipping---quote---3yxb5","quoteMethod":"src-ShippingRequestModal-shipping---quoteMethod---2kzFD src-ShippingRequestModal-shipping---quote---3yxb5","quoteDestination":"src-ShippingRequestModal-shipping---quoteDestination---3qAEM src-ShippingRequestModal-shipping---quote---3yxb5","quoteHandlingTime":"src-ShippingRequestModal-shipping---quoteHandlingTime---20_lA src-ShippingRequestModal-shipping---quote---3yxb5","quoteAmount":"src-ShippingRequestModal-shipping---quoteAmount---Tpxw0 src-ShippingRequestModal-shipping---quote---3yxb5","valid":"src-ShippingRequestModal-shipping---valid---32uDx","submit":"src-ShippingRequestModal-shipping---submit---2Azt6","disable":"src-ShippingRequestModal-shipping---disable---2V0Y7","error":"src-ShippingRequestModal-shipping---error---1Tnje","errorMessage":"src-ShippingRequestModal-shipping---errorMessage---3fVZH","inlineSpinner":"src-ShippingRequestModal-shipping---inlineSpinner---3OVZV"};

/***/ },
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1734);

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Relay = __webpack_require__(16);

	var BuyerProfileMutation = function (_Relay$Mutation) {
	    _inherits(BuyerProfileMutation, _Relay$Mutation);

	    function BuyerProfileMutation() {
	        _classCallCheck(this, BuyerProfileMutation);

	        return _possibleConstructorReturn(this, (BuyerProfileMutation.__proto__ || Object.getPrototypeOf(BuyerProfileMutation)).apply(this, arguments));
	    }

	    _createClass(BuyerProfileMutation, [{
	        key: 'getMutation',
	        value: function getMutation() {
	            return function () {
	                return {
	                    calls: [{
	                        kind: 'Call',
	                        metadata: {},
	                        name: 'updateBuyerProfileName',
	                        value: {
	                            kind: 'CallVariable',
	                            callVariableName: 'input'
	                        }
	                    }],
	                    children: [{
	                        fieldName: 'clientMutationId',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'String'
	                    }],
	                    kind: 'Mutation',
	                    metadata: {
	                        inputType: 'UpdateBuyerProfileNameInput!'
	                    },
	                    name: 'UpdateBuyerProfileMutation',
	                    responseType: 'UpdateBuyerProfileNamePayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getVariables',
	        value: function getVariables() {
	            var _props = this.props,
	                userId = _props.userId,
	                displayName = _props.displayName;


	            return {
	                userServiceId: userId,
	                displayName: displayName
	            };
	        }
	    }, {
	        key: 'getFatQuery',
	        value: function getFatQuery() {
	            return function () {
	                return {
	                    children: [{
	                        children: [{
	                            children: [{
	                                fieldName: 'displayName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'firstName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'lastName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }],
	                            fieldName: 'profile',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true
	                            },
	                            type: 'Profile'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'user',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'User'
	                    }],
	                    id: Relay.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'UpdateBuyerProfileMutationRelayQL',
	                    type: 'UpdateBuyerProfileNamePayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getConfigs',
	        value: function getConfigs() {
	            return [{
	                type: 'FIELDS_CHANGE',
	                fieldIDs: { user: this.props.userRelayId }
	            }];
	        }
	    }]);

	    return BuyerProfileMutation;
	}(Relay.Mutation);

	BuyerProfileMutation.fragments = {
	    user: function user() {
	        return function () {
	            return {
	                children: [{
	                    fieldName: 'id',
	                    kind: 'Field',
	                    metadata: {
	                        isRequisite: true
	                    },
	                    type: 'ID'
	                }, {
	                    children: [{
	                        fieldName: 'displayName',
	                        kind: 'Field',
	                        metadata: {},
	                        type: 'String'
	                    }],
	                    fieldName: 'profile',
	                    kind: 'Field',
	                    metadata: {
	                        canHaveSubselections: true
	                    },
	                    type: 'Profile'
	                }],
	                id: Relay.QL.__id(),
	                kind: 'Fragment',
	                metadata: {},
	                name: 'UpdateBuyerProfileMutation_UserRelayQL',
	                type: 'User'
	            };
	        }();
	    }
	};

	module.exports = BuyerProfileMutation;

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(18);

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Relay = __webpack_require__(16);
	var React = __webpack_require__(2);
	var PropTypes = React.PropTypes;

	var UserAddAddressMutation = function (_Relay$Mutation) {
	    _inherits(UserAddAddressMutation, _Relay$Mutation);

	    function UserAddAddressMutation() {
	        _classCallCheck(this, UserAddAddressMutation);

	        return _possibleConstructorReturn(this, (UserAddAddressMutation.__proto__ || Object.getPrototypeOf(UserAddAddressMutation)).apply(this, arguments));
	    }

	    _createClass(UserAddAddressMutation, [{
	        key: 'getMutation',
	        value: function getMutation() {
	            return function () {
	                return {
	                    calls: [{
	                        kind: 'Call',
	                        metadata: {},
	                        name: 'userAddAddress',
	                        value: {
	                            kind: 'CallVariable',
	                            callVariableName: 'input'
	                        }
	                    }],
	                    children: [{
	                        fieldName: 'clientMutationId',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'String'
	                    }],
	                    kind: 'Mutation',
	                    metadata: {
	                        inputType: 'UserAddAddressInput!'
	                    },
	                    name: 'UserAddAddressMutation',
	                    responseType: 'UserAddAddressPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getVariables',
	        value: function getVariables() {
	            var _props = this.props,
	                userId = _props.userId,
	                address = _props.address;

	            return { userId: userId, address: address };
	        }
	    }, {
	        key: 'getFatQuery',
	        value: function getFatQuery() {
	            return function () {
	                return {
	                    children: [{
	                        children: [{
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'address',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Address'
	                    }],
	                    id: Relay.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'UserAddAddressMutationRelayQL',
	                    type: 'UserAddAddressPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getConfigs',
	        value: function getConfigs() {
	            return [{
	                type: 'REQUIRED_CHILDREN',
	                children: [function () {
	                    return {
	                        children: [{
	                            children: [{
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }, {
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }],
	                            fieldName: 'address',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'Address'
	                        }],
	                        id: Relay.QL.__id(),
	                        kind: 'Fragment',
	                        metadata: {},
	                        name: 'UserAddAddressMutation_ChildrenRelayQL',
	                        type: 'UserAddAddressPayload'
	                    };
	                }()]
	            }];
	        }
	    }]);

	    return UserAddAddressMutation;
	}(Relay.Mutation);

	UserAddAddressMutation.propTypes = {
	    userId: PropTypes.string.isRequired,
	    address: PropTypes.shape({
	        firstName: PropTypes.string.isRequired,
	        lastName: PropTypes.string.isRequired,
	        company: PropTypes.string,
	        country: PropTypes.string.isRequired,
	        line1: PropTypes.string.isRequired,
	        line2: PropTypes.string,
	        zipCode: PropTypes.string.isRequired,
	        city: PropTypes.string.isRequired,
	        state: PropTypes.string.isRequired,
	        phoneNumber: PropTypes.string.isRequired
	    }).isRequired
	};

	module.exports = UserAddAddressMutation;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _copyText = __webpack_require__(5);

	var _copyText2 = _interopRequireDefault(_copyText);

	var _copy = __webpack_require__(19);

	var _copy2 = _interopRequireDefault(_copy);

	var _reactRelay = __webpack_require__(16);

	var _reactRelay2 = _interopRequireDefault(_reactRelay);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var copyObj = (0, _copyText2.default)().extend(_copy2.default);

	var RequestShipmentQuoteMutation = function (_Relay$Mutation) {
	    _inherits(RequestShipmentQuoteMutation, _Relay$Mutation);

	    function RequestShipmentQuoteMutation() {
	        _classCallCheck(this, RequestShipmentQuoteMutation);

	        return _possibleConstructorReturn(this, (RequestShipmentQuoteMutation.__proto__ || Object.getPrototypeOf(RequestShipmentQuoteMutation)).apply(this, arguments));
	    }

	    _createClass(RequestShipmentQuoteMutation, [{
	        key: 'getMutation',
	        value: function getMutation() {
	            return function () {
	                return {
	                    calls: [{
	                        kind: 'Call',
	                        metadata: {},
	                        name: 'shipmentQuoteRequest',
	                        value: {
	                            kind: 'CallVariable',
	                            callVariableName: 'input'
	                        }
	                    }],
	                    children: [{
	                        fieldName: 'clientMutationId',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'String'
	                    }],
	                    kind: 'Mutation',
	                    metadata: {
	                        inputType: 'ShipmentQuoteRequestInput!'
	                    },
	                    name: 'RequestShipmentQuoteMutation',
	                    responseType: 'ShipmentQuoteRequestPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getVariables',
	        value: function getVariables() {
	            var subject = copyObj.get('sqrSubjectLine') + ' ' + this.props.itemTitle;
	            var action = 'SHIPPING_REQUEST';
	            return {
	                // required fields:
	                buyerId: this.props.userId,
	                itemPk: this.props.itemId,
	                dealerPk: this.props.dealerPk,
	                subject: subject,
	                // optional fields:
	                shippingAddressId: this.props.shippingAddressId,
	                conversationId: this.props.conversationId,
	                country: this.props.country,
	                city: this.props.city,
	                message: this.props.message || '',
	                state: this.props.state,
	                transactionId: this.props.transactionId,
	                zipCode: this.props.zipCode,
	                pageContext: this.props.pageContext,
	                action: action
	            };
	        }
	    }, {
	        key: 'getFatQuery',
	        value: function getFatQuery() {
	            return function () {
	                return {
	                    children: [{
	                        children: [{
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }, {
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }, {
	                            children: [{
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, {
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }],
	                            fieldName: 'transaction',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'Transaction'
	                        }],
	                        fieldName: 'conversation',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Conversation'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'RequestShipmentQuoteMutationRelayQL',
	                    type: 'ShipmentQuoteRequestPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getConfigs',
	        value: function getConfigs() {
	            return [{
	                type: 'FIELDS_CHANGE',
	                fieldIDs: {
	                    conversation: this.props.conversationRelayId
	                }
	            }];
	        }
	    }]);

	    return RequestShipmentQuoteMutation;
	}(_reactRelay2.default.Mutation);

	module.exports = RequestShipmentQuoteMutation;

/***/ },
/* 19 */
/***/ function(module, exports) {

	module.exports = {
		"sqrHeader": "Add Shipping Address & Shipping Quote",
		"sqrSend": "Save & Continue",
		"sqrSuccessMessage": "Your request has been sent. You will be notified by email when a custom shipping quote is available for your review.",
		"sqrViewRequest": "You can view your request at any time in",
		"sqrMyConversations": "My Conversations",
		"sqrSuccessHeader": "Request Sent",
		"sqrAddFromSavedAddresses": "Add from saved addresses",
		"sqrAddNewAddress": "Add new address",
		"sqrSuccessFooterTitle": "stay up to date",
		"sqrSuccessFooterText": "Follow this dealer to get weekly updates on new arrivals.",
		"sqrBack": "back",
		"sqrSubjectLine": "1stdibs Shipping Quote Request for",
		"sqrMutationError": "There was an error submitting your request. Please refresh the page and try again."
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1597);

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _lodash = __webpack_require__(9);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _classnames = __webpack_require__(22);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _shipping = __webpack_require__(10);

	var _shipping2 = _interopRequireDefault(_shipping);

	var _Select = __webpack_require__(23);

	var _Select2 = _interopRequireDefault(_Select);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var InvoiceSelect = function InvoiceSelect(_ref) {
	    var wrapperClasses = _ref.wrapperClasses,
	        name = _ref.name,
	        value = _ref.value,
	        options = _ref.options,
	        isDisabled = _ref.isDisabled,
	        _onChange = _ref.onChange;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(wrapperClasses, [_shipping2.default.selectWrapper]), 'data-field': 'addresses' },
	        _react2.default.createElement(_Select2.default, {
	            theme: _shipping2.default,
	            name: name,
	            value: value,
	            options: options,
	            searchable: false,
	            disabled: isDisabled,
	            onChange: function onChange(payload) {
	                return _onChange({ target: { name: name, value: (0, _lodash2.default)(payload, 'value') || '' } });
	            }
	        })
	    );
	};

	// components


	InvoiceSelect.propTypes = {
	    wrapperClasses: _propTypes2.default.string,
	    name: _propTypes2.default.any.isRequired,
	    value: _propTypes2.default.any.isRequired,
	    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        value: _propTypes2.default.any.isRequired,
	        label: _propTypes2.default.any.isRequired
	    })).isRequired,
	    isDisabled: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func.isRequired
	};

	InvoiceSelect.defaultProps = {
	    wrapperClasses: '',
	    isDisabled: false
	};

	exports.default = InvoiceSelect;

/***/ },
/* 22 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(16);

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(761);

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _shipping = __webpack_require__(10);

	var _shipping2 = _interopRequireDefault(_shipping);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Option = function Option(_ref) {
	    var label = _ref.label,
	        value = _ref.value,
	        checked = _ref.checked,
	        isDisabled = _ref.isDisabled,
	        onChange = _ref.onChange;
	    return _react2.default.createElement(
	        'label',
	        { className: _shipping2.default.label },
	        _react2.default.createElement('input', {
	            className: _shipping2.default.radioInput,
	            type: 'radio',
	            value: value,
	            checked: checked,
	            onChange: onChange,
	            disabled: isDisabled
	        }),
	        label
	    );
	};

	Option.propTypes = {
	    label: _propTypes2.default.string.isRequired,
	    value: _propTypes2.default.string.isRequired,
	    checked: _propTypes2.default.bool.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    isDisabled: _propTypes2.default.bool
	};

	Option.defaultProps = {
	    isDisabled: false
	};

	exports.default = Option;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _classnames = __webpack_require__(22);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _shipping = __webpack_require__(10);

	var _shipping2 = _interopRequireDefault(_shipping);

	var _Primary = __webpack_require__(26);

	var _Primary2 = _interopRequireDefault(_Primary);

	var _dibsOverlaySpinner = __webpack_require__(27);

	var _dibsOverlaySpinner2 = _interopRequireDefault(_dibsOverlaySpinner);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	// components


	var Submit = function Submit(_ref) {
	    var _classNames;

	    var label = _ref.label,
	        isSaving = _ref.isSaving,
	        isDisabled = _ref.isDisabled,
	        onClick = _ref.onClick;

	    var buttonClasses = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _shipping2.default.submit, true), _defineProperty(_classNames, _shipping2.default.disable, isDisabled), _classNames));
	    return _react2.default.createElement(
	        _Primary2.default,
	        { className: buttonClasses, disabled: isSaving, onClick: onClick },
	        isSaving && _react2.default.createElement(_dibsOverlaySpinner2.default, {
	            size: 'small',
	            position: 'isStatic',
	            additionalWrapperClasses: _shipping2.default.inlineSpinner
	        }),
	        isSaving ? 'Saving...' : label
	    );
	};

	Submit.propTypes = {
	    label: _propTypes2.default.string,
	    isSaving: _propTypes2.default.bool,
	    isDisabled: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func.isRequired
	};

	Submit.defaultProps = {
	    label: 'Save',
	    isSaving: false,
	    isDisabled: false
	};

	exports.default = Submit;

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(696);

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(368);

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SuccessContent;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _dibsElements = __webpack_require__(4);

	var _FollowDealer = __webpack_require__(29);

	var _FollowDealer2 = _interopRequireDefault(_FollowDealer);

	var _arrowRight = __webpack_require__(41);

	var _arrowRight2 = _interopRequireDefault(_arrowRight);

	var _successContent = __webpack_require__(42);

	var _successContent2 = _interopRequireDefault(_successContent);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function SuccessContent(props) {
	    var seller = props.seller,
	        userId = props.userId,
	        isMC = props.isMC,
	        copy = props.copy;


	    return _react2.default.createElement(
	        'div',
	        { 'data-tn': 'shipping-request-modal-success' },
	        _react2.default.createElement(
	            _dibsElements.ModalBody,
	            null,
	            _react2.default.createElement(
	                'p',
	                { className: _successContent2.default.sqrSuccessMessage },
	                copy.get('sqrSuccessMessage')
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: _successContent2.default.sqrSuccessMessage },
	                copy.get('sqrViewRequest'),
	                _react2.default.createElement(
	                    'a',
	                    { href: '/my/conversations/', className: _successContent2.default.sqrSuccessLink },
	                    copy.get('sqrMyConversations'),
	                    _react2.default.createElement(_arrowRight2.default, { className: _successContent2.default.sqrCtaArrow })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _successContent2.default.sqrSuccessFooter },
	            _react2.default.createElement(
	                'div',
	                { className: _successContent2.default.sqrSuccessFooterTitle },
	                copy.get('sqrSuccessFooterTitle')
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _successContent2.default.sqrSuccessFooterText },
	                copy.get('sqrSuccessFooterText')
	            ),
	            _react2.default.createElement(_FollowDealer2.default, {
	                seller: seller,
	                currentUserId: userId,
	                isMC: isMC
	            })
	        )
	    );
	};

	SuccessContent.propTypes = {
	    seller: _react.PropTypes.object.isRequired,
	    userId: _react.PropTypes.string,
	    isMC: _react.PropTypes.bool,
	    copy: _react.PropTypes.object
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _component = __webpack_require__(30);

	var _component2 = _interopRequireDefault(_component);

	var _recompose = __webpack_require__(35);

	var _relay = __webpack_require__(36);

	var _relay2 = _interopRequireDefault(_relay);

	var _redux = __webpack_require__(38);

	var _redux2 = _interopRequireDefault(_redux);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = (0, _recompose.hoistStatics)((0, _recompose.compose)(_redux2.default, _relay2.default))(_component2.default);

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _copyText = __webpack_require__(5);

	var _copyText2 = _interopRequireDefault(_copyText);

	var _lodash = __webpack_require__(31);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _followDealerCopy = __webpack_require__(32);

	var _followDealerCopy2 = _interopRequireDefault(_followDealerCopy);

	var _tracking = __webpack_require__(6);

	var _tracking2 = _interopRequireDefault(_tracking);

	var _styles = __webpack_require__(33);

	var _styles2 = _interopRequireDefault(_styles);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var FollowDealer = function (_Component) {
	    _inherits(FollowDealer, _Component);

	    function FollowDealer(props) {
	        _classCallCheck(this, FollowDealer);

	        var _this = _possibleConstructorReturn(this, (FollowDealer.__proto__ || Object.getPrototypeOf(FollowDealer)).call(this, props));

	        _this.copy = (0, _copyText2.default)().extend(_followDealerCopy2.default);
	        return _this;
	    }

	    _createClass(FollowDealer, [{
	        key: '_followSeller',
	        value: function _followSeller() {
	            var _this2 = this;

	            this.props.favoriteSeller(Object.assign({
	                onFailure: function onFailure() {
	                    return _this2.props.setErrorMessage({ errorMessage: _this2.copy.get('followSellerError') });
	                },
	                onSuccess: function onSuccess() {
	                    return _tracking2.default.trackDealerFollowed({ isMC: _this2.props.isMC });
	                }
	            }, (0, _lodash2.default)(this.props, 'currentUserId', 'seller', 'favoriteId', 'relay')));
	        }
	    }, {
	        key: '_unfollowSeller',
	        value: function _unfollowSeller() {
	            var _this3 = this;

	            this.props.favoriteSeller(Object.assign({
	                onFailure: function onFailure() {
	                    return _this3.props.setErrorMessage({ errorMessage: _this3.copy.get('unFollowSellerError') });
	                },
	                onSuccess: function onSuccess() {
	                    return _tracking2.default.trackDealerUnFollowed({ isMC: _this3.props.isMC });
	                }
	            }, (0, _lodash2.default)(this.props, 'currentUserId', 'seller', 'favoriteId', 'relay')));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                favoriteId = _props.favoriteId,
	                isMC = _props.isMC,
	                errorMessage = _props.errorMessage;


	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    {
	                        onClick: (favoriteId ? this._unfollowSeller : this._followSeller).bind(this),
	                        className: 'button button-primary button-large ' + _styles2.default.followDealerCta,
	                        'data-tn': isMC ? 'mc-follow-dealer-cta' : ''
	                    },
	                    this.copy.get(favoriteId ? 'unfollowSellerCta' : 'followSellerCta')
	                ),
	                errorMessage ? _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.sqrError },
	                    errorMessage
	                ) : null
	            );
	        }
	    }]);

	    return FollowDealer;
	}(_react.Component);

	FollowDealer.propTypes = {
	    seller: _propTypes2.default.object.isRequired,
	    favoriteId: _propTypes2.default.string,
	    company: _propTypes2.default.string.isRequired,
	    favoriteSeller: _propTypes2.default.func.isRequired,
	    setErrorMessage: _propTypes2.default.func.isRequired,
	    currentUserId: _propTypes2.default.string.isRequired,
	    errorMessage: _propTypes2.default.string,
	    isMC: _propTypes2.default.bool
	};

	exports.default = FollowDealer;

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1631);

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = {
		"followSellerError": "An error occurred when attempting to follow this dealer. Please try again later.",
		"unFollowSellerError": "An error occurred when attempting to no longer follow this dealer. Please try again later.",
		"followSellerCta": "follow dealer",
		"unfollowSellerCta": "dealer followed"
	};

/***/ },
/* 33 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sqrFullWidthBtn":"src-styles---sqrFullWidthBtn---16wyl","sqrModalWrapper":"src-styles---sqrModalWrapper---2i54e","sqrError":"src-styles---sqrError---2HVpJ","sqrSubmitWrapper":"src-styles---sqrSubmitWrapper---301J2","sqrFooterBackLink":"src-styles---sqrFooterBackLink---5UxT-","followDealerCta":"src-styles---followDealerCta---1hFjn"};

/***/ },
/* 34 */,
/* 35 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(821);

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _reactRelay = __webpack_require__(16);

	var _reactRelay2 = _interopRequireDefault(_reactRelay);

	var _favoriteSeller = __webpack_require__(37);

	var _favoriteSeller2 = _interopRequireDefault(_favoriteSeller);

	var _recompose = __webpack_require__(35);

	var _lodash = __webpack_require__(9);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var favoriteSeller = function favoriteSeller(_ref) {
	    var currentUserId = _ref.currentUserId,
	        seller = _ref.seller,
	        favoriteId = _ref.favoriteId,
	        relay = _ref.relay,
	        onSuccess = _ref.onSuccess,
	        onFailure = _ref.onFailure;

	    relay.commitUpdate(new _favoriteSeller2.default({
	        currentUserId: currentUserId,
	        seller: seller,
	        favoriteId: favoriteId
	    }), { onSuccess: onSuccess, onFailure: onFailure });
	};

	var query = {
	    initialVariables: {
	        currentUserId: null,
	        shouldFetchFavorites: null
	    },
	    prepareVariables: function prepareVariables(vars) {
	        return Object.assign({}, vars, {
	            shouldFetchFavorites: !!vars.currentUserId
	        });
	    },
	    fragments: {
	        seller: function seller() {
	            return function (RQL_0) {
	                return {
	                    children: [].concat.apply([], [{
	                        calls: [{
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'userIds',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'currentUserId'
	                            }
	                        }],
	                        children: [{
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'include',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'shouldFetchFavorites'
	                                }
	                            }]
	                        }],
	                        fieldName: 'favoritesByUser',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id',
	                            isPlural: true
	                        },
	                        type: 'Favorite'
	                    }, {
	                        children: [{
	                            fieldName: 'company',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }],
	                        fieldName: 'sellerProfile',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true
	                        },
	                        type: 'SellerProfile'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }, _reactRelay2.default.QL.__frag(RQL_0)]),
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'Relay_SellerRelayQL',
	                    type: 'Seller'
	                };
	            }(_favoriteSeller2.default.getFragment('seller'));
	        }
	    }
	};

	exports.default = (0, _recompose.hoistStatics)((0, _recompose.compose)(function (BaseComponent) {
	    return _reactRelay2.default.createContainer(BaseComponent, query);
	}, (0, _recompose.flattenProp)('seller'), (0, _recompose.flattenProp)('sellerProfile'), (0, _recompose.withProps)(function (props) {
	    return {
	        favoriteId: (0, _lodash2.default)(props, 'favoritesByUser[0].serviceId'),
	        favoriteSeller: favoriteSeller
	    };
	})));

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Relay = __webpack_require__(16);

	var FavoriteSeller = function (_Relay$Mutation) {
	    _inherits(FavoriteSeller, _Relay$Mutation);

	    function FavoriteSeller() {
	        _classCallCheck(this, FavoriteSeller);

	        return _possibleConstructorReturn(this, (FavoriteSeller.__proto__ || Object.getPrototypeOf(FavoriteSeller)).apply(this, arguments));
	    }

	    _createClass(FavoriteSeller, [{
	        key: 'getMutation',
	        value: function getMutation() {
	            return function () {
	                return {
	                    calls: [{
	                        kind: 'Call',
	                        metadata: {},
	                        name: 'favoriteSeller',
	                        value: {
	                            kind: 'CallVariable',
	                            callVariableName: 'input'
	                        }
	                    }],
	                    children: [{
	                        fieldName: 'clientMutationId',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'String'
	                    }],
	                    kind: 'Mutation',
	                    metadata: {
	                        inputType: 'FavoriteSellerInput!'
	                    },
	                    name: 'FavoriteSeller',
	                    responseType: 'FavoriteSellerPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getVariables',
	        value: function getVariables() {
	            var _props = this.props,
	                currentUserId = _props.currentUserId,
	                serviceId = _props.seller.serviceId,
	                favoriteId = _props.favoriteId;

	            return {
	                userId: currentUserId,
	                sellerPk: serviceId,
	                favoriteId: favoriteId
	            };
	        }
	    }, {
	        key: 'getFatQuery',
	        value: function getFatQuery() {
	            return function () {
	                return {
	                    children: [{
	                        children: [{
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'seller',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Seller'
	                    }],
	                    id: Relay.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'FavoriteSellerRelayQL',
	                    type: 'FavoriteSellerPayload'
	                };
	            }();
	        }
	    }, {
	        key: 'getConfigs',
	        value: function getConfigs() {
	            return [{
	                type: 'FIELDS_CHANGE',
	                fieldIDs: { seller: this.props.seller.id }
	            }];
	        }
	    }]);

	    return FavoriteSeller;
	}(Relay.Mutation);

	FavoriteSeller.fragments = {
	    seller: function seller() {
	        return function () {
	            return {
	                children: [{
	                    fieldName: 'id',
	                    kind: 'Field',
	                    metadata: {
	                        isRequisite: true
	                    },
	                    type: 'ID'
	                }, {
	                    fieldName: 'serviceId',
	                    kind: 'Field',
	                    metadata: {},
	                    type: 'ID'
	                }],
	                id: Relay.QL.__id(),
	                kind: 'Fragment',
	                metadata: {},
	                name: 'FavoriteSeller_SellerRelayQL',
	                type: 'Seller'
	            };
	        }();
	    }
	};

	exports.default = FavoriteSeller;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _actions = __webpack_require__(39);

	var _actions2 = _interopRequireDefault(_actions);

	var _reactRedux = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var mapStateToProps = function mapStateToProps(_ref) {
	  var shippingQuoteModal = _ref.shippingQuoteModal;
	  return { errorMessage: shippingQuoteModal.errorMessage };
	};

	exports.default = (0, _reactRedux.connect)(mapStateToProps, _actions2.default);

/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    setOpenModalKey: function setOpenModalKey(modalKey) {
	        return {
	            type: 'SQR_SET_OPEN_MODAL_KEY',
	            modalKey: modalKey
	        };
	    },
	    setErrorMessage: function setErrorMessage(_ref) {
	        var errorMessage = _ref.errorMessage;
	        return {
	            type: 'SQR_SET_ERROR_MSG',
	            errorMessage: errorMessage
	        };
	    },
	    setCurrentStep: function setCurrentStep(step) {
	        return {
	            type: 'SQR_SET_CURRENT_STEP',
	            step: step
	        };
	    },
	    clearState: function clearState() {
	        return {
	            type: 'SQR_CLEAR_STATE'
	        };
	    }
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(271);

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(351);

/***/ },
/* 42 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sqrCtaArrow":"src-ShippingRequestModal-successContent---sqrCtaArrow---3Um6q","sqrSuccessMessage":"src-ShippingRequestModal-successContent---sqrSuccessMessage---26Kcq","sqrSuccessLink":"src-ShippingRequestModal-successContent---sqrSuccessLink---2JeLC","sqrSuccessFooter":"src-ShippingRequestModal-successContent---sqrSuccessFooter---3PYm0","sqrCta":"src-ShippingRequestModal-successContent---sqrCta---rnGjC","sqrSuccessFooterText":"src-ShippingRequestModal-successContent---sqrSuccessFooterText---cJB5P","sqrSuccessFooterTitle":"src-ShippingRequestModal-successContent---sqrSuccessFooterTitle---1PHiZ"};

/***/ },
/* 43 */,
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _reactRelay = __webpack_require__(16);

	var _reactRelay2 = _interopRequireDefault(_reactRelay);

	var _recompose = __webpack_require__(35);

	var _withProps = __webpack_require__(45);

	var _withProps2 = _interopRequireDefault(_withProps);

	var _FollowDealer = __webpack_require__(29);

	var _FollowDealer2 = _interopRequireDefault(_FollowDealer);

	var _lodash = __webpack_require__(9);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _updateBuyerProfileMutation = __webpack_require__(15);

	var _updateBuyerProfileMutation2 = _interopRequireDefault(_updateBuyerProfileMutation);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var query = {
	    initialVariables: {
	        userId: null,
	        itemId: null,
	        shouldFetchConversation: null,
	        isMC: false
	    },
	    prepareVariables: function prepareVariables(vars) {
	        return Object.assign({}, vars, {
	            shouldFetchConversation: vars.userId && vars.itemId && !vars.isMC
	        });
	    },
	    fragments: {
	        user: function user() {
	            return function (RQL_0) {
	                return {
	                    children: [].concat.apply([], [{
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }, {
	                        children: [{
	                            fieldName: 'displayName',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'firstName',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'lastName',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'email',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }],
	                        fieldName: 'profile',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true
	                        },
	                        type: 'Profile'
	                    }, {
	                        fieldName: 'serviceId',
	                        kind: 'Field',
	                        metadata: {},
	                        type: 'ID'
	                    }, {
	                        children: [{
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }, {
	                            fieldName: 'country',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'city',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'state',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'zipCode',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'firstValidShippingAddress',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Address'
	                    }, {
	                        children: [{
	                            children: [{
	                                fieldName: 'sourceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }, {
	                                fieldName: 'displayName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'formattedAddress',
	                                kind: 'Field',
	                                metadata: {
	                                    isPlural: true
	                                },
	                                type: 'String'
	                            }, {
	                                fieldName: 'displayCountry',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'firstName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'lastName',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'line1',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'line2',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'country',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'city',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'state',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'zipCode',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                fieldName: 'phoneNumber',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'String'
	                            }, {
	                                children: [{
	                                    children: [{
	                                        fieldName: 'valid',
	                                        kind: 'Field',
	                                        metadata: {},
	                                        type: 'YesNo'
	                                    }],
	                                    fieldName: 'buyerShipping',
	                                    kind: 'Field',
	                                    metadata: {
	                                        canHaveSubselections: true
	                                    },
	                                    type: 'ValidationResult'
	                                }],
	                                fieldName: 'validation',
	                                kind: 'Field',
	                                metadata: {
	                                    canHaveSubselections: true
	                                },
	                                type: 'AddressValidation'
	                            }, {
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }],
	                            fieldName: 'addressList',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id',
	                                isPlural: true
	                            },
	                            type: 'Address'
	                        }],
	                        fieldName: 'addressBook',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true
	                        },
	                        type: 'AddressBook'
	                    }, _reactRelay2.default.QL.__frag(RQL_0)]),
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'Relay_UserRelayQL',
	                    type: 'User'
	                };
	            }(_updateBuyerProfileMutation2.default.getFragment('user'));
	        },
	        // conversation fragment is only used in MC, where we never need to update the buyer profile
	        conversation: function conversation(_ref) {
	            var userId = _ref.userId;
	            return function (RQL_0) {
	                return {
	                    children: [{
	                        fieldName: 'serviceId',
	                        kind: 'Field',
	                        metadata: {},
	                        type: 'ID'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }, {
	                        children: [{
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'transaction',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Transaction'
	                    }, {
	                        children: [{
	                            children: [{
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, {
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }, {
	                                children: [{
	                                    fieldName: 'displayName',
	                                    kind: 'Field',
	                                    metadata: {},
	                                    type: 'String'
	                                }, {
	                                    fieldName: 'email',
	                                    kind: 'Field',
	                                    metadata: {},
	                                    type: 'String'
	                                }],
	                                fieldName: 'profile',
	                                kind: 'Field',
	                                metadata: {
	                                    canHaveSubselections: true
	                                },
	                                type: 'Profile'
	                            }],
	                            fieldName: 'user',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'User'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'originalBuyer',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'ConversationMember'
	                    }, {
	                        children: [{
	                            children: [].concat.apply([], [{
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }, {
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, _reactRelay2.default.QL.__frag(RQL_0)]),
	                            fieldName: 'seller',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'Seller'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        fieldName: 'originalSeller',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'ConversationMember'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'Relay_ConversationRelayQL',
	                    type: 'Conversation'
	                };
	            }(_FollowDealer2.default.getFragment('seller', { currentUserId: userId }));
	        },
	        viewer: function viewer(_ref2) {
	            var userId = _ref2.userId;
	            return function (RQL_0) {
	                return {
	                    children: [{
	                        alias: 'conversation',
	                        calls: [{
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'buyerId',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'userId'
	                            }
	                        }, {
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'itemId',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'itemId'
	                            }
	                        }],
	                        children: [{
	                            fieldName: 'serviceId',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'ID'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }, {
	                            children: [{
	                                fieldName: 'serviceId',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'ID'
	                            }, {
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, {
	                                fieldName: 'isCanceled',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'Boolean'
	                            }, {
	                                fieldName: 'hasCompletedCheckout',
	                                kind: 'Field',
	                                metadata: {},
	                                type: 'Boolean'
	                            }, {
	                                children: [{
	                                    fieldName: 'id',
	                                    kind: 'Field',
	                                    metadata: {
	                                        isRequisite: true
	                                    },
	                                    type: 'ID'
	                                }],
	                                fieldName: 'requestedQuote',
	                                kind: 'Field',
	                                metadata: {
	                                    canHaveSubselections: true,
	                                    inferredRootCallName: 'node',
	                                    inferredPrimaryKey: 'id'
	                                },
	                                type: 'ShipmentQuote'
	                            }],
	                            fieldName: 'transaction',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'Transaction'
	                        }],
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'include',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'shouldFetchConversation'
	                                }
	                            }]
	                        }],
	                        fieldName: 'buyerItemConversation',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Conversation'
	                    }, {
	                        calls: [{
	                            kind: 'Call',
	                            metadata: {},
	                            name: 'itemId',
	                            value: {
	                                kind: 'CallVariable',
	                                callVariableName: 'itemId'
	                            }
	                        }],
	                        children: [{
	                            fieldName: 'title',
	                            kind: 'Field',
	                            metadata: {},
	                            type: 'String'
	                        }, {
	                            children: [].concat.apply([], [{
	                                fieldName: 'id',
	                                kind: 'Field',
	                                metadata: {
	                                    isGenerated: true,
	                                    isRequisite: true
	                                },
	                                type: 'ID'
	                            }, _reactRelay2.default.QL.__frag(RQL_0)]),
	                            fieldName: 'seller',
	                            kind: 'Field',
	                            metadata: {
	                                canHaveSubselections: true,
	                                inferredRootCallName: 'node',
	                                inferredPrimaryKey: 'id'
	                            },
	                            type: 'Seller'
	                        }, {
	                            fieldName: 'id',
	                            kind: 'Field',
	                            metadata: {
	                                isGenerated: true,
	                                isRequisite: true
	                            },
	                            type: 'ID'
	                        }],
	                        directives: [{
	                            kind: 'Directive',
	                            name: 'skip',
	                            args: [{
	                                name: 'if',
	                                value: {
	                                    kind: 'CallVariable',
	                                    callVariableName: 'isMC'
	                                }
	                            }]
	                        }],
	                        fieldName: 'item',
	                        kind: 'Field',
	                        metadata: {
	                            canHaveSubselections: true,
	                            inferredRootCallName: 'node',
	                            inferredPrimaryKey: 'id'
	                        },
	                        type: 'Item'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'Relay_ViewerRelayQL',
	                    type: 'Viewer'
	                };
	            }(_FollowDealer2.default.getFragment('seller', { currentUserId: userId }));
	        },
	        item: function item() {
	            return function () {
	                return {
	                    children: [{
	                        fieldName: 'title',
	                        kind: 'Field',
	                        metadata: {},
	                        type: 'String'
	                    }, {
	                        fieldName: 'id',
	                        kind: 'Field',
	                        metadata: {
	                            isGenerated: true,
	                            isRequisite: true
	                        },
	                        type: 'ID'
	                    }],
	                    id: _reactRelay2.default.QL.__id(),
	                    kind: 'Fragment',
	                    metadata: {},
	                    name: 'Relay_ItemRelayQL',
	                    type: 'Item'
	                };
	            }();
	        }
	    }
	};

	exports.default = function (Component) {
	    return (0, _recompose.hoistStatics)((0, _recompose.compose)(function (BaseComponent) {
	        return _reactRelay2.default.createContainer(BaseComponent, query);
	    }, (0, _withProps2.default)(function (baseProps) {
	        var user = baseProps.user,
	            isMC = baseProps.isMC,
	            viewer = baseProps.viewer;

	        var conversation = void 0;
	        var item = void 0;
	        var extraProps = void 0;

	        if (isMC) {
	            conversation = (0, _lodash2.default)(baseProps, 'conversation');
	            item = (0, _lodash2.default)(baseProps, 'item');
	            extraProps = {
	                user: (0, _lodash2.default)(conversation, 'originalBuyer.user'),
	                userId: (0, _lodash2.default)(conversation, 'originalBuyer.user.serviceId'),
	                userRelayId: (0, _lodash2.default)(conversation, 'originalBuyer.user.id'),
	                buyerDisplayName: (0, _lodash2.default)(conversation, 'originalBuyer.user.profile.displayName'),
	                dealerPk: (0, _lodash2.default)(conversation, 'originalSeller.seller.serviceId')
	            };
	        } else {
	            conversation = (0, _lodash2.default)(viewer, 'conversation');
	            item = (0, _lodash2.default)(viewer, 'item');
	            extraProps = {
	                requestedShipmentQuote: (0, _lodash2.default)(conversation, 'transaction.requestedQuote'),
	                transactionHasCompletedCheckout: (0, _lodash2.default)(conversation, 'transaction.hasCompletedCheckout'),
	                transactionIsCanceled: (0, _lodash2.default)(conversation, 'transaction.isCanceled'),
	                userRelayId: (0, _lodash2.default)(user, 'id'),
	                buyerDisplayName: (0, _lodash2.default)(user, 'profile.displayName')
	            };
	        }

	        return Object.assign({}, {
	            itemTitle: (0, _lodash2.default)(item, 'title'),
	            conversationId: (0, _lodash2.default)(conversation, 'serviceId'),
	            conversationRelayId: (0, _lodash2.default)(conversation, 'id'),
	            transactionId: (0, _lodash2.default)(conversation, 'transaction.serviceId'),
	            transactionRelayId: (0, _lodash2.default)(conversation, 'transaction.id'),
	            seller: (0, _lodash2.default)(conversation, 'originalSeller.seller') || (0, _lodash2.default)(item, 'seller')
	        }, extraProps);
	    })))(Component);
	};

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(579);

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _reactRedux = __webpack_require__(40);

	var _actions = __webpack_require__(39);

	var _actions2 = _interopRequireDefault(_actions);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = (0, _reactRedux.connect)(function (_ref) {
	    var shippingQuoteModal = _ref.shippingQuoteModal;
	    return shippingQuoteModal;
	}, _actions2.default);

/***/ },
/* 47 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var defaultState = {
	    errorMessage: '',
	    currentStep: 'quoteRequest',
	    openModalKey: ''
	};

	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];

	    switch (action.type) {
	        case 'SQR_SET_OPEN_MODAL_KEY':
	            return Object.assign({}, state, {
	                openModalKey: action.modalKey
	            });
	        case 'SQR_SET_ERROR_MSG':
	            return Object.assign({}, state, {
	                errorMessage: action.errorMessage
	            });
	        case 'SQR_SET_CURRENT_STEP':
	            return Object.assign({}, state, {
	                currentStep: action.step
	            });
	        case 'SQR_CLEAR_STATE':
	            return defaultState;
	        default:
	            return state;
	    }
	};

/***/ }
/******/ ]);

/***/ }),
/* 1117 */,
/* 1118 */,
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-info-circle-filled'].join(' '), viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M125.7,0.5 C57.1,0.5 1.20000005,56.4 1.20000005,125 C1.20000005,193.6 57.1,249.5 125.7,249.5 C194.3,249.5 250.2,193.6 250.2,125 C250.2,56.4 194.4,0.5 125.7,0.5 L125.7,0.5 L125.7,0.5 Z M139.7,51.2 C136.4,51.2 133.6,52.5 131.3,55.1 C128.9,57.7 127.7,60.8 127.7,64.3 C127.7,67.6 128.9,70.6 131.3,73.2 C133.7,75.8 136.5,77.1 139.7,77.1 C143.2,77.1 146.2,75.7 148.5,73 C150.9,70.3 152.1,67.1 152.1,63.4 C152.1,60.1 150.9,57.3 148.6,54.8 C146.3,52.5 143.3,51.2 139.7,51.2 L139.7,51.2 L139.7,51.2 Z M134.8,187.9 C131.2,187.9 128.5,187.2 126.9,185.9 C125.3,184.6 124.5,182.1 124.5,178.4 C124.5,176.9 124.7,174.9 125.2,172.5 C125.7,170.1 126.2,167.6 126.9,165.1 L137.1,124.3 C137.6,122.3 138,120.3 138.3,118.3 C138.6,116.3 138.7,114.7 138.7,113.6 C138.7,109.4 137.5,106 135.1,103.5 C132.7,101 128.9,99.8 123.7,99.8 C121.4,99.8 118.3,100.3 114.3,101.4 C110.3,102.5 105.9,104.2 100.9,106.4 L99.5,112.5 C100.7,112.2 102.5,111.8 104.8,111.3 C107.1,110.9 109,110.6 110.4,110.6 C114,110.6 116.5,111.2 117.6,112.4 C118.8,113.6 119.4,116 119.4,119.6 C119.4,121.4 119.2,123.6 118.7,126.1 C118.2,128.7 117.7,131.1 117.2,133.3 L107.1,174.1 C106.5,176.5 106.1,178.6 105.9,180.2 C105.6,181.8 105.5,183.3 105.5,184.8 C105.5,188.7 106.8,192 109.3,194.6 C111.9,197.3 115.7,198.6 120.8,198.6 C123.3,198.6 126.3,198.1 129.8,197.2 C133.3,196.3 138,194.6 143.9,192.3 L145.3,186.2 C144.1,186.6 142.3,187 140.1,187.4 C137.8,187.8 136,187.9 134.8,187.9 L134.8,187.9 L134.8,187.9 Z', fillRule: 'evenodd' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 7/27/15.
 */



var cartTracking = __webpack_require__(965);
var CartStore = __webpack_require__(106);
var NC = __webpack_require__(1431);
var mobileCheck = __webpack_require__(279);
var chatUtils = __webpack_require__(268);

var cartActions = {

    /**
     * Navigates to the cart page.
     * @param actionContext
     * @param payload
     * @param done
     */
    goToCart: function goToCart(actionContext, payload, done) {
        var cartStore = actionContext.getStore(CartStore);
        window.location.href = cartStore.getCartUrl();
        done();
    },

    /**
     * Adds an item to the cart.
     * @param actionContext
     * @param payload
     * @param payload.item {Item} The Backbone item model to add
     * @param done
     */
    addToCart: function addToCart(actionContext, payload, done) {
        var item = payload.item;

        var cartStore = actionContext.getStore(CartStore);

        var loadImages = function loadImages(i) {
            return i.get('images') || actionContext.executeAction(cartActions.updateItemModel, { item: i });
        };

        Promise.resolve(loadImages(item)).then(function () {
            if (!cartStore.isItemInCart(item)) {
                actionContext.dispatch('cart:itemAdded', { item: item });
                chatUtils.track.addToCart();
                done();
            } else {
                actionContext.dispatch('cart:itemExists', { item: item });
                done();
            }
        }).catch(function (err) {
            done(err);
        });
    },

    /**
     * Adds an item to the cart and displays the nav bar hover menu. This is a separate action to avoid
     * adding extra if conditions to the 'addToCart' action.
     * @param actionContext
     * @param payload
     * @param done
     */
    addToCartAndNotify: function addToCartAndNotify(actionContext, payload, done) {
        var item = payload.item;


        var redirectTo = null;

        actionContext.executeAction(cartActions.addToCart, { item: item }).then(function () {
            if (!redirectTo) {
                actionContext.executeAction(cartActions.showRecentlyAddedItems, { items: [item] });
            } else {
                window.location.href = redirectTo;
            }
            done();
        }).catch(function (err) {
            done(err);
        });
    },

    /**
     *
     * @param actionContext
     * @param payload
     * @param payload.item {Backbone.Model} The item to remove
     * @param payload.waitFor {Promise|Deferred} Wait for this in addition to the destroy() before dispatching.
     * @param done
     * @returns {*}
     */
    removeFromCart: function removeFromCart(actionContext, payload, done) {
        var item = payload.item,
            waitFor = payload.waitFor;


        var promises = [item.destroy()];
        if (waitFor) {
            promises.push(waitFor);
        }

        return Promise.all(promises).then(function () {
            actionContext.dispatch('cart:itemRemoved', { item: item });
            done();
        }).catch(function (err) {
            actionContext.dispatch('cart:itemRemoved:error', { item: item, message: 'error deleting cart item' });
            done(err);
        });
    },

    removeFromCartById: function removeFromCartById(actionContext, payload, done) {
        var cartStore = actionContext.getStore(CartStore);
        var item = cartStore.getItemById(payload.itemId);
        return cartActions.removeFromCart(actionContext, Object.assign({}, payload, { item: item }), done);
    },

    removeFromCartAtIndex: function removeFromCartAtIndex(actionContext, payload, done) {
        var cartStore = actionContext.getStore(CartStore);
        var item = cartStore.getItemAtIndex(payload.index);
        return cartActions.removeFromCart(actionContext, Object.assign({}, payload, { item: item }), done);
    },

    /**
     * Triggers a fetch of the shopping cart to update the data, and dispatches
     * the appropriate message to the CartStore.
     * @param actionContext
     * @param payload
     * @param payload.track {boolean} True if a GA tracking event should be fired.
     * @param done
     */
    loadCartPortfolio: function loadCartPortfolio(actionContext, payload, done) {
        var cartStore = actionContext.getStore(CartStore);
        var collection = cartStore.getItemsCollection();
        var track = payload.track;


        return Promise.resolve(collection.fetch()).then(function () {
            if (track) {
                cartTracking.trackEcommerce('productImpression', collection.models);
            }
            return collection.length;
        }).then(function (itemCount) {
            actionContext.dispatch('cart:portfolio:loaded', { itemCount: itemCount });
            done();
        }).catch(function (err) {
            actionContext.dispatch('cart:portfolio:error', { message: err });
            done(err);
        });
    },

    /**
     * Updates the item model and dispatches a notification to the store when complete.
     * This is mainly used to update the item's image for display in the cart dropdown menu.
     * @param actionContext
     * @param payload
     * @param payload.item {Item} The Backbone item model to update.
     * @param done
     */
    updateItemModel: function updateItemModel(actionContext, payload, done) {
        // TODO: maybe this should probably go in a more general 'portfolio actions' or 'item actions'
        var item = payload.item;


        actionContext.dispatch('item:update:start', { item: item });
        Promise.resolve(item.fetch()).then(function () {
            actionContext.dispatch('item:update:done', { item: item });
            done();
        }).catch(function (err) {
            actionContext.dispatch('item:update:failed', { err: err });
            done(err);
        });
    },

    /**
     * Displays the recently added item in the hover menu in the nav bar cart icon
     * @param actionContext
     * @param payload
     * @param payload.items {Array} The items to display in the menu
     * @param payload.timeout {Number} The number of milliseconds before the notification disappears
     * @param done
     */
    showRecentlyAddedItems: function showRecentlyAddedItems(actionContext, payload, done) {
        var items = payload.items,
            timeout = payload.timeout;

        var defaultTimeout = 7000;

        if (!mobileCheck.any()) {
            var el = document.getElementById(NC.TOGGLE_NAV_CART.replace(/#/, ''));
            if (el) {
                el.classList.add('is-hover');
                actionContext.dispatch('cart:notification:show', { items: items });
            }
            setTimeout(function () {
                actionContext.executeAction(cartActions.hideRecentlyAddedItems);
            }, timeout || defaultTimeout);
        }

        done();
    },

    /**
     * Hides the recently added items notification.
     * @param actionContext
     * @param payload
     * @param done
     */
    hideRecentlyAddedItems: function hideRecentlyAddedItems(actionContext, payload, done) {
        var el = document.getElementById(NC.TOGGLE_NAV_CART.replace(/#/, ''));
        if (el) {
            el.classList.remove('is-hover');
            actionContext.dispatch('cart:notification:hide');
        }
        done();
    }

};

module.exports = cartActions;

/***/ }),
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(3),
    Router = _require.Router;

var GalleryStore = __webpack_require__(357);
var galleryActions = __webpack_require__(363);

var GalleryRouter = Router.extend({
    stores: [GalleryStore],

    routes: {
        'photo/:urlLabel/:id(/)': '_setPhoto',
        '*splat': 'refresh'
    },

    initialize: function initialize(options) {
        var _this = this;

        this._updatePropsAndNavigate = this._updatePropsAndNavigate.bind(this);

        this.context = options.context;
        this._contextStores = [];

        this.stores.forEach(function (store) {
            _this._contextStores.push(_this.context.getStore(store));
            _this.context.getStore(store).addChangeListener(_this._updatePropsAndNavigate);
        });
    },
    _updatePropsAndNavigate: function _updatePropsAndNavigate() {
        this.props = this.getPropsFromStores.apply(this, this._contextStores);
        this.update();
    },


    /**
     *
     */
    getPropsFromStores: function getPropsFromStores(galleryStore) {
        return { route: galleryStore.getCurrentPhotoUrl() };
    },


    /**
     * Update function called each time the galleryStore emits a change
     *  - Changes the url
     */
    update: function update() {
        if (this.props.route) {
            // Note: this will NOT also call the route method
            this.navigate(this.props.route);
        }
    },


    /**
     * Route Handler - executes action to set photo
     *  (invoked mostly when the user hits the back button)
     */
    _setPhoto: function _setPhoto(urlLabel, rootId) {
        var galleryStore = this.context.getStore(GalleryStore);
        var url = galleryStore.buildPhotoUrl({ urlLabel: urlLabel, rootId: rootId });

        if (url && typeof galleryStore.getPhotoByUrl(url) !== 'undefined') {

            // If Photo url exists, set url
            this.context.executeAction(galleryActions.setPhoto, { url: url });
        } else {

            // Else refresh b/c navigating to photo URL outside of current gallery
            this.refresh();
        }
    },


    /**
     * Trigger page refresh
     */
    refresh: function refresh() {
        location.reload();
    }
});

module.exports = GalleryRouter;

/***/ }),
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);

var ModalEmail = module.exports = Backbone.BaseView.extend();

var $ = __webpack_require__(5);
var _ = __webpack_require__(23);
var SV = __webpack_require__(17);
var mobileCheck = __webpack_require__(279);
var ModalEmailTracking = __webpack_require__(943);
var User = __webpack_require__(15);
var cssVars = __webpack_require__(362).breakpoints;
var price = __webpack_require__(941);
var authModalLoader = __webpack_require__(263).default;
var findNamespaceValue = __webpack_require__(285);
var Conversation = __webpack_require__(131);
var AnchorLists = __webpack_require__(117);
var SendToFriendView = __webpack_require__(1192);
var ModalEmailModel = __webpack_require__(1188);
var requ = __webpack_require__(1150);
var simplyDeferred = __webpack_require__(29);
var Deferred = simplyDeferred.Deferred;

__webpack_require__(474);

_.extend(ModalEmail.prototype, price, {
    $modal: {},
    el: '#modalOverlay',
    viewEvents: {
        'showSuccess': 'showSuccess',
        'showServerError': 'showServerError',
        'hideModal': 'hideModal',
        'showModal': 'showModal'
    },
    subViewConfig: {
        friend: {
            construct: SendToFriendView,
            singleton: true
        }
    },
    events: {
        'click .show-login': function (e) {
            e.stopImmediatePropagation();

            // close the email modal
            this.closeModal();

            // open the login modal
            authModalLoader.show({
                action: authModalLoader.constants.LOGIN,
                ga: {
                    label: 'login link - contact dealer thank you page'
                }
            });
        },
        'click .show-register': function (e) {
            e.stopImmediatePropagation();

            // close the email modal
            this.closeModal();

            // open the registration modal
            authModalLoader.show({
                action: authModalLoader.constants.REGISTER,
                email: this.modal.get('message.emailDataMap.from_email'),
                ga: {
                    label: 'register link -email a friend thank you page'
                }
            });
        }
    },
    /**
     *
     * @param {object} options
     * @param {string} options.type "dealer" or "friend"
     * @param {string} options.pageType "item" or "seller"
     * @param {string} options.linkLocation Where the link click occured (tracking)
     **/
    initialize: function (options) {
        var ThisModalEmailTracking = ModalEmailTracking;
        this.options = options || {};
        this.$body = $('body');
        this.model = new ModalEmailModel({
            isMobile: cssVars.integer && $(window).width() <= cssVars.integer['mobile-large-landscape'],
            isDesktop: cssVars.integer && $(window).width() >= cssVars.integer.desktop,
            pageSV: options.pageData || SV.get('data'),
            type: options.type,
            pageType: options.pageType,
            queryString: window.location.search,
            user: {
                id: User.getUserId(),
                profile: User.getUserProfile()
            },
            tracking: {
                linkLocation: options.linkLocation
            }
        });
        this.$spinner = $('<div>').addClass('email-modal-spinner-container')
            .append($('<img>').attr('src', findNamespaceValue('settings.assets.loadingGif', SV)));
        if (!this.$modal.fn) {
            this.$modal = {
                fn: $.fn.dibsModal()
            };
        }

        if (_.isFunction(this.$modal.fn.close)) {
            $.subscribe('modal:close', function () {
                // MCPERSON-294 clean up modal classes after close
                this.$modal.fn.close.call(this);
                this._tracking.resetPageViewVars();
                $.unsubscribe('modal:close');
            }.bind(this));
        }
        this._tracking = new ThisModalEmailTracking();
    },
    show: function (data, trackOnLoad) {
        if (!this._ajaxContent) {
            this.load(data, trackOnLoad);
        } else {
            //doesn't seem like this ever happens
            this.$modal.fn.update('email-modal').show();
        }
    },
    /**
     * loads the content of the email modal via ajax
     * @param data
     * @returns {*} promise object for ajax call
     */
    load: function (data, trackOnLoad) {
        var self = this;
        var type = this.model.get('type');
        var conversation = new Conversation();
        var anchorLists = new AnchorLists();
        var dealerPk;
        var gotConversationList;
        var status;
        var vpvString;

        data = data || {};
        dealerPk = data.dealerPk || SV.get('data.dealerPk') || SV.get('contactSellerData.id');

        this.showSpinner();
        $.extend(true, data, {type: type});

        gotConversationList = anchorLists.fetchSellerOnList(dealerPk, AnchorLists.listNames.OPOP, 'SELLER_POLICY').then(function () {
            if (anchorLists.length > 0) {
                return undefined;
            }
            // old dealer policy (pre Aug 2015)
            if (!User.getUserId()) {
                // buyer is logged out -- will not check conversation history
                this.showShareEmailCheckbox = true;
                return undefined;
            }
            return conversation.fetchConversationForBuyerAndItem({
                buyerId: User.getUserId(),
                itemId: SV.get('data.pk')
            }).then(null, function (response) {
                if (response.status === 404) {
                    // conversation is not found (buyer has not contacted dealer about this item)
                    this.showShareEmailCheckbox = true;
                }
                return new Deferred().resolve();
            }.bind(this));
        }.bind(this), function () {
            return new Deferred().resolve();
        });


        return simplyDeferred.when(gotConversationList, requ({
            url: this.model.getAjaxContentPath(),
            dataType: 'json',
            data: data
        })).done(function (convResp, modalContentResp) {
            this._ajaxContent = _.chain(modalContentResp).result('shift').result('data').value();
            this.render();
            // FINDING-3602 prices being loaded using PriceLoader instance in pdp.js
            $.publish('modal-email:load', [this.model.get('type'), this.model.get('shouldShowPrice'), this.model.get('pageType')]);
            status = SV.get('tracking.initialDataLayerInfo.pageSubType');
            vpvString = SV.get('modalData.vpvString');
            vpvString += "&status=" + status.toLowerCase();
            this._tracking.firePageViewGAEvent(vpvString);
            if (trackOnLoad) {
                this._tracking.fireCommunicationGAEvent({
                    linkLocation: self.model.get('tracking.linkLocation'),
                    fromForm: false,
                    itemPk: SV.get('modalData.itemPk')
                });
            }
        }.bind(this));
    },
    showSpinner: function () {
        this.$modal.fn.update('email-modal', this.$spinner).show();
    },
    showSuccess: function () {
        var type = this.model.get('type');
        if (type === 'friend') {
            this.$('.email-send-container').hide();
        } else {
            this.form.$sendContainer.hide();
        }
        this.form.$successMessage.removeClass('is-hidden');
        if (!User.loggedIn()) {
            this.form.$successSubtext.removeClass('is-hidden');
        }
        $.publish('modal-email:success', [type]);
        this._tracking.firePageViewGAEvent(SV.get('modalData.vpvSuccessString'));
        this._tracking.fireCommunicationGAEvent({
            linkLocation: this.model.get('tracking.linkLocation'),
            fromForm: true,
            emailShared: this.$('#isShowSenderEmail').is(":checked"),
            itemPk: SV.get('modalData.itemPk')
        });
    },
    showServerError: function () {
        this.form.$serverErrorMsg.show();
    },
    /**
     * different implementation than usual backbone view.
     * content is loaded via ajax, so rather than render it
     * we'll map it to subviews for internal use.
     */
    render: function () {
        var type = this.model.get('type');

        if (!this._ajaxContent) {
            return this;
        }
        this.$modal.fn.update('email-modal', this._ajaxContent); // this._ajaxContent will add additional serverVars, so watch out!
        this.$modal.fn.show();

        if (this.showShareEmailCheckbox) {
            this.$('.dealer-modal-opt-in-container').removeClass('is-hidden');
        }
        this.form = this.subs.add(this.model.get('type'), {model: this.model}).newest;
        switch (this.model.get('pageType')) {
            case 'item':
                this.$el.addClass('email-item-modal');
                break;
            case 'seller':
                this.$el.addClass('seller-sf');
                break;
        }
        // note: used toggleClass() here because class remains on next modal that is opened
        this.$el.toggleClass('dealer-modal', type === 'dealer');
        this.$el.toggleClass('friend-modal', type === 'friend');
        this.updatePrices(true, this.model.get('currency'));
        this.form.initValidation();
        this.handleMobileKeyboard();
        return this;
    },
    hideModal: function () {
        this.$modal.fn.enableScrolling();
        this.$modal.fn.hideModal();
    },
    showModal: function () {
        this.$modal.fn.showModal();
    },
    //FINDING-2131: deals with iOS bug where fixed position elements don't get resized when keyboard is open
    handleMobileKeyboard: function () {
        var self = this;
        var modalContentHeight;
        if (mobileCheck.iOS()) {
            modalContentHeight = this.$el.height();
            this.form.$el.find(':input').blur(function () {
                if (mobileCheck.iPad()) {
                    self.$body.bind('touchmove.modal', function (e) {
                        e.preventDefault();
                    });
                } else {
                    self.$el.css({ height: modalContentHeight, 'position': 'absolute' });
                }
            });
            this.form.$el.find(':input').blur(function () {
                if (mobileCheck.iPad()) {
                    self.$body.unbind('touchmove.modal');
                } else {
                    self.$el.css({ height: '', 'position': 'fixed' });
                }
            });
        }
    },
    closeModal: function () {
        $.publish('modal:close');
    }
});


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: hella
 * Date: 6/22/14
 * Time: 3:21 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */


var $ = __webpack_require__(5);
var MEC = __webpack_require__(753);
var SV = __webpack_require__(17);
var findNamespaceValue = __webpack_require__(285);

module.exports = {
    /**
     * custom dibsvalidation function for emaillist
     * @returns {String} if false {Boolean} if true
     */
    validateEmailList : function validateEmailList(val) {
        var i = 0;
        var addresses = val.split(',');
        var valid = addresses.length > 0;
        while (valid && (i < addresses.length)) {
            valid = MEC.EMAIL.FORMAT.test($.trim(addresses[i]));
            i++;
        }
        if (valid) {
            return true;
        }
        return findNamespaceValue('modalData.validationCopy.emailListMessage', SV);
    }
};


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var SOAModel = __webpack_require__(2);

var ModalEmailModel = module.exports = SOAModel.extend();

var _ = __webpack_require__(23);
var currencyParseFloat = __webpack_require__(62).parseFloat;
var MEC = __webpack_require__(753);
var Backbone = __webpack_require__(3);
var UserModel = __webpack_require__(15);
var SMTPMessage = __webpack_require__(1189);
var SV = __webpack_require__(17);

/**
 * parses and interprets severvars,
 * determines SMTP or Usercomm for message flow
 * determines currency based on available user info
 */

_.extend(ModalEmailModel.prototype, {
    defaults : {
        type        : 'dealer',
        pageType    : 'seller',
        queryString : '',
        currency    : MEC.CURRENCY_DEFAULT,
        isMobile    : false,
        tracking    : {}
    },
    relations: function () {
        return [
            {
                key : 'pageSV',
                relatedModel : Backbone.AssociatedModel.extend(),
                type : Backbone.One
            },
            {
                key : 'tracking',
                relatedModel : Backbone.AssociatedModel.extend(),
                type : Backbone.One
            },
            {
                key : 'user',
                relatedModel : UserModel,
                type: Backbone.One
            }
        ];
    },
    initialize : function () {
        var type = this.get('type');
        var message;
        if (!this.get('message')) {
            message  = new SMTPMessage(); // email friend messages are sent through smtp
            message.url = ['', 'email', type, ''].join('/') + this.get('queryString');
            this.set('message', message);
        }
        if (this.get('pageSV')) {
            this.set('shouldShowPrice', this.getShouldShowPrice());
        }
        this.on('change:pageSV', function () {
            this.set('shouldShowPrice', this.getShouldShowPrice());
        });
        if (this.get('user') && this.get('user.profile')) {
            this.set('currency', this.get('user.profile.currency') || MEC.CURRENCY_DEFAULT);
        }
        this.on('change:user.profile change:user', function () {
            this.set('currency', this.get('user.profile.currency'));
        });
    },
    getAjaxContentPath : function () {
        return (this.get('pageType') === 'seller' ? '/seller/modal/email/' : '/item/ajax/email/') +
               this.get('queryString');
    },
    /**
     * sugar method for input default, blank string if user is not logged in
     * @returns {String}
     */
    getUserName : function () {
        var name = '';
        var lastName;
        if (this.get('user') && this.get('user.profile')) {
            name = this.get('user.profile.firstName') || '';
            lastName = this.get('user.profile.lastName') || '';
            if (name && lastName) {
                name += ' ';
            }
            name += lastName;
        }
        return name;
    },
    /**
     * sugar method for input default, blank string if user is not logged in
     * @returns {String}
     */
    getUserEmail : function () {
        if (this.get('user') && this.get('user.profile')) {
            return this.get('user.profile.email');
        }
        return '';
    },
    /**
     * sugar method for determining whether or not to show price
     * @returns {boolean}
     */
    getShouldShowPrice : function () {
        return this.get('pageType') === 'item' &&
            !this.get('pageSV.isHidePrice') &&
            !this.get('pageSV.isSold') &&
            !this.get('pageSV.isHold');
    },
    /**
     * sugar method for currency converted list price
     * all prices come back with periods for decimals, not commas
     * so no need to format the numbers before passing into parseFloat
     * @returns {Number}
     */
    getListPrice : function () {
        var price = SV.get('modalData.priceCurrencies')[this.get('currency')] + '';
        return currencyParseFloat(price);
    },
    /**
     * based on currency preference, returns regex and error message for dibsvalidation validator
     * required parameter defaults to true
     * @returns {{required: boolean, messages: {number_required: string}, regex_rules: {number_required: *}}}
     */
    getCurrencyValidation : function () {
        var msg = MEC.msgs.numberFormat;
        var regExs;
        var noMatchRegEx;
        var regEx;
        switch (this.get('currency')) {
            case MEC.CURRENCY_EU :
                regExs = MEC.CURRENCY_REGEX_EU;
                regEx = regExs.numFormat;
                noMatchRegEx = regExs.zeroInput;
                msg = msg + '###.###';
                break;
            default:
                regExs = MEC.CURRENCY_REGEX_DEFAULT;
                regEx = regExs.numFormat;
                noMatchRegEx = regExs.zeroInput;
                msg = msg + '###,###';
                break;
        }
        return {
            required: true,
            messages: {
                number_required : msg,
                zero: SV.get('modalData.validationCopy').zeroMessage
            },

            regex_rules: {
                number_required : regEx
            },
            regex_nomatch_rules: {
                zero: noMatchRegEx
            }
        };
    },
    getShareEmailTracking: function () {
        var shared = this.get('message.emailDataMap.isShowSenderEmail') === true;
        return 'share=' + (shared ? 'y' : 'n');
    },
    getFavDealerCtasTracking: function () {
        var showing = this.get('showingFavDealerCtas');
        return 'fav=' + (showing ? 'y' : 'n');
    },
    getPlaceholderCopy: function () {
        var copy = SV.get('modalData.copy');
        var pageType = this.get('pageType') === 'item' ? 'Pdp' : 'Storefront';
        return copy ? copy['placeholder' + pageType] : '';
    }
});


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SOAModel = __webpack_require__(2);

var SMTPMessage = module.exports = SOAModel.extend();

var _ = __webpack_require__(23);
var Backbone = __webpack_require__(3);

_.extend(SMTPMessage.prototype, {

    relations : function () {
        return [
            {
                key: 'emailDataMap',
                relatedModel : Backbone.AssociatedModel.extend(),
                type : Backbone.One
            }
        ];
    }
});

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var _ = __webpack_require__(23);
var $ = __webpack_require__(5);

var EmailView = module.exports = Backbone.BaseView.extend();

var mixins = __webpack_require__(1187);
var ModalEmailTracking = __webpack_require__(943);
var MEC = __webpack_require__(753);
var InputView = __webpack_require__(1191);
var serverVars = __webpack_require__(17);
var formviewValidation = __webpack_require__(1006);
var SV = __webpack_require__(17);
var Deferred = __webpack_require__(29).Deferred;
var when = __webpack_require__(29).when;

__webpack_require__(309);
__webpack_require__(433);

_.extend(EmailView.prototype, mixins, {

    el: '#modalOverlay-inner-content .email-form',
    subViewConfig : {
        inputField : {
            singleton: false,
            construct : InputView
        }
    },
    events : {
        'submit' : function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.send();
        }
    },
    viewEvents : {
        'validationCheck' : function () {
            this.$el.dibsValidation('validateForm');
        }
    },
    _getSendActions: function () {
        return [
            this._prepareToSend,
            this._saveUserNameIfNoneAssociated,
            this._postMessage
        ];
    },
    send: function () {
        return this._getSendActions().reduce(function (ready, action) {
            return when(ready).then(action.bind(this));
        }.bind(this), undefined).then(
            this._globalSuccess.bind(this),
            this._globalFailure.bind(this)
        );
    },
    initialize : function (options) {
        var validationCopy = SV.get('modalData.validationCopy');
        var ThisModalEmailTracking = ModalEmailTracking;

        this.options = options || {};
        if ('dealer' === this.model.get('type')) {
            ThisModalEmailTracking = ModalEmailTracking.Dealer;
        }
        this._tracking = new ThisModalEmailTracking({
            gaString: SV.get('modalData.gaString')
        });
        this.$body = $('body');
        this.subs.add('inputField', {
            el: '#from_name',
            value: this.model.getUserName(),
            validation: {
                regex_rules: { //eslint-disable-line camelcase
                    maxLength: MEC.EMAIL.FROM_NAME
                },
                messages: {
                    maxLength: 'must be under 50 characters'
                }
            }
        });
        this.subs.add('inputField', {
            el: '#from_email',
            value: this.model.getUserEmail(),
            validation : {
                required : true,
                regex_rules: { //eslint-disable-line camelcase
                    format: MEC.EMAIL.FORMAT,
                    maxLength: MEC.EMAIL.MAX_LENGTH
                },
                messages: {
                    format: validationCopy.emailMessage,
                    maxLength: 'must be under 100 characters'
                }
            }
        });
        this.subs.add('inputField', {
            el: '#message',
            validation : {
                regex_rules: { //eslint-disable-line camelcase
                    length: MEC.MSG_REGEX
                },
                messages: {
                    length: validationCopy.messageMessage,
                    default_message: validationCopy.requiredMessage //eslint-disable-line camelcase
                }
            }
        });
        this.$sendContainer = this.$('#sendButtonContainer').first();
        this.$sendButton = this.$sendContainer.find('#sendButton').first();
        this.$successMessage = this.$('.email-success-message').first();
        this.$successSubtext = this.$('.email-success-subtext').first();
        this.$serverErrorMsg = $('#serverError');

        this.focusOnFirstEmptyElm();
    },
    focusOnFirstEmptyElm: function () {
        var emptyFields = _.filter(this.$('#from_name, #from_email, #message'), function (elm) {
            return !elm.value;
        });
        if (this.model.get('isDesktop')) {
            _.result(emptyFields[0], 'focus');
        }
    },
    _prepareToSend : function () {
        var invalid;
        this.disable();
        this.$el.dibsValidation('validateForm');
        invalid = this.getClientErrors();
        // client-side validation failed
        if (invalid.length > 0) {
            this.enable();
            this._tracking.fireValidationGAEvent({
                errors: invalid,
                isClient: true
            });
            return false;
        }
        this.removeAllErrors();
    },
    _getFromName: function () {
        return this.$('#from_name').val();
    },
    _saveUserNameIfNoneAssociated: function () {
        var inputName = this._getFromName();
        var profile = this.model.get('user.profile');
        if (!profile) {
            return Deferred().resolve();
        }
        if (!inputName) {
            return undefined;
        }
        if (this.model.getUserName()) {
            return undefined;
        }
        return profile.setDisplayName(inputName).save();
    },
    _postMessage : function () {
        var msg = this.model.get('message');
        var itemId = typeof serverVars.data === 'object' ? serverVars.data.pk || serverVars.data.pageLabel || 'storefront' : 'null';
        this.populateMessage();
        // monkey-patch the item id to the URL so it shows in the access log (you can thank Vadim and Ross for this ;-| )
        return msg.save(null, { emulateJSON : true, queries: { itemId: itemId } })
            .then(
                function (data, status) {
                    var invalidInput;
                    var errors;
                    if (status !== 'success') {
                        return Deferred().reject();
                    }
                    if (_.result(data, 'success')) {
                        return undefined;
                    }
                    errors = data.errors || [];
                    if (0 === errors.length) {
                        return undefined; // TODO: figure out if this is an error or success scenario
                    }
                    _.each(errors, function (error) {
                        invalidInput = this.subs.findWhere({name: error.name});
                        if (invalidInput) {
                            formviewValidation.showValidationError(null, invalidInput.$el, { message: error.message });
                        }
                    }.bind(this));
                    this.enable();
                    this._tracking.fireValidationGAEvent({
                        errors: errors
                    });
                    return Deferred().reject({triggerBubble: 'userError'});
                }.bind(this));
    },
    _globalSuccess: function (options) {
        options = _.extend({
            triggerBubble: 'showSuccess'
        }, options);
        if (options.triggerBubble) {
            this.triggerBubble(options.triggerBubble);
        }
    },
    _globalFailure: function (options) {
        options = _.extend({
            triggerBubble: 'showServerError'
        }, options);
        if (options.triggerBubble) {
            this.triggerBubble(options.triggerBubble);
        }
    },
    populateMessage : function () {
        var msg = this.model.get('message');
        var emailDataMap = {};
        //hidden fields at the top level of the form element
        _.each(this.$el.serializeArray(), function (field) {
            emailDataMap[field.name] = $.trim(field.value);
        });
        //actual inputs which are down a level and thus unreachable by serializeArray?
        _.each(this.subs.getByType('inputField'), function (field) {
            emailDataMap[field.name] = field.getValue();
        });

        emailDataMap.subject = msg.get('subject');
        msg.set('emailDataMap', emailDataMap);
        return msg;
    },
    enable : function () {
        this.$sendButton.prop('disabled', false);
        this.$sendButton.removeClass('is-disabled');
        this.triggerDescend('enableInputs');
    },
    disable : function () {
        this.$sendButton.prop('disabled', true);
        this.$sendButton.addClass('is-disabled');
        this.triggerDescend('disableInputs');
    },
    initValidation : function () {
        this.$el.dibsValidation(this.getValidationRules(), {
            isEnableScroll: false,
            validateOnChange: false
        }).on('formError', formviewValidation.showValidationError)
            .on('formErrorResolved', formviewValidation.hideValidationError);
    },
    getValidationRules : function () {
        return _.chain(this.subs.get('inputField')).map(function (inputField) {
            return [inputField.name, inputField.validation];
        }).object().value();
    },
    getClientErrors : function () {
        return _.chain(this.subs.get('inputField')).map(function (view) {
            var $error = view.$el.siblings('.err-message.active');
            if ($error.length) {
                return {
                    name: view.name,
                    message: $error.text()
                };
            }
        }).compact().value();
    },
    removeAllErrors : function () {
        _.each(this.subs.get('inputField'), function (view) {
            formviewValidation.hideValidationError(null, view.$el);
        });
        this.subs.descend('removeAllErrors');
    }

});


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var _ = __webpack_require__(23);
var Backbone = __webpack_require__(3);
var SV = __webpack_require__(17);
var findNamespaceValue = __webpack_require__(285);

var InputFieldView = module.exports = Backbone.BaseView.extend();

_.extend(InputFieldView.prototype,
    {
        defaults : {
            validation : {
                required : true,
                messages: {},
                regex_rules: {}
            },
            value: ''
        },
        viewEvents : {
            'disableInputs' : 'disable',
            'enableInputs' : 'enable'
        },

        initialize : function (options) {
            this.options = options || {};
            this.setValue(this.options.value);
            //todo I think this has to come from server vars (mapped to parent view model)
            this.defaults.validation.messages.default_message = findNamespaceValue('modalData.validationCopy.requiredMessage', SV);
            this.validation = $.extend(true, {}, this.defaults.validation, this.options.validation);
            this.name = this.$el.attr('name');
        },
        enable : function () {
            this.$el.prop('readonly', false);
            this.$el.removeClass('is-disabled');
            this.$el.prop('disabled', false);
        },
        disable : function () {
            this.$el.prop('readonly', true);
            this.$el.addClass('is-disabled');
            this.$el.prop('disabled', true);
        },
        saveValue : function () {
            this.$el.data('cleared-value', this.getValue());
        },
        restoreValue: function () {
            this.setValue(this.$el.data('cleared-value'));
        },
        clear : function () {
            this.$el.val('');
        },
        getValue : function () {
            return $.trim(this.$el.val());
        },
        setValue : function (val) {
            this.$el.val(val);
        }
    }
);


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EmailView = __webpack_require__(1190);
var SendToFriendView = module.exports = EmailView.extend();
var _ = __webpack_require__(23);

__webpack_require__(433);

_.extend(SendToFriendView.prototype, {

    initialize : function (options) {
        this.options = options || {};
        EmailView.prototype.initialize.apply(this, arguments);
        this.subs.add('inputField', {
            el: '#to_email'
        });
        this.subs.findWhere({name: 'message'}).validation.required = false;
    },
    initValidation : function () {
        EmailView.prototype.initValidation.apply(this);
        this.$el.dibsValidation('addCustomValidator', 'to_email', this.isRecipientFieldValid, this);
    },
    /**
     * custom dibsvalidation function for emaillist
     * @returns {String} if false {Boolean} if true
     */
    isRecipientFieldValid : function () {
        return this.validateEmailList(this.subs.findWhere({name: 'to_email'}).getValue());
    }
});

/***/ }),
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tracking = __webpack_require__(27);
var dataProvider = __webpack_require__(755);
var parseFloat = __webpack_require__(62).parseFloat;
var purchaseTracking = __webpack_require__(458);
var carouselHelpers = __webpack_require__(1341);

// Pulled from `PdpPrice`. This should really be extracted somewhere more easily accessible.
function getTrackingData() {
    var price = dataProvider.get('tracking.initialDataLayerInfo.askingPrice');
    return {
        brand  : dataProvider.get('data.dealerPk'),
        name   : dataProvider.get('data.titleCondensed'),
        price  : parseFloat(price),
        url    : dataProvider.get('data.canonicalUrl') || document.URL
    };
}

function ModalCarouselTracking(options) {
    this._category = carouselHelpers.getCarouselCategory(options.owner);
    this._imageslength = options.imagesLength;
    this._item = options.item;
}

ModalCarouselTracking.prototype.purchase = function purchase() {
    purchaseTracking.firePurchaseButtonTracking(this._item, undefined, 'image zoom modal purchase button');
    purchaseTracking.ecommerceAddToCartTracking(getTrackingData());
};

ModalCarouselTracking.prototype.showModal = function showModal(index) {
    tracking.trackEvent({
        'category': this._category,
        'action': 'primary image click',
        'label': (index + 1) + '/' + this._imageslength
    });
};

ModalCarouselTracking.prototype.thumbnailClick = function thumbnailClick(index) {
    tracking.trackEvent({
        'category': this._category,
        'action': 'image zoom modal thumbnail click',
        'label': (index + 1) + '/' + this._imageslength
    });
};

ModalCarouselTracking.prototype.previousClick = function previousClick(index) {
    tracking.trackEvent({
        'category': this._category,
        'action': 'image zoom modal previous button',
        'label': (index + 1) + '/' + this._imageslength
    });
};

ModalCarouselTracking.prototype.nextClick = function nextClick(index) {
    tracking.trackEvent({
        'category': this._category,
        'action': 'image zoom modal next button',
        'label': (index + 1) + '/' + this._imageslength
    });
};

module.exports = ModalCarouselTracking;


/***/ }),
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */
/***/ (function(module, exports) {

module.exports = {
	"returnPolicy": {
		"returnsAccepted": "Exclusive: As a trade member, you have an additional 7 days to initiate your return. Fees and limitations apply.",
		"returnsNotAccepted": "Exclusive: As a trade member, you may initiate a return of this item within 7 days of delivery. Fees and limitations apply."
	},
	"returnPolicyModal": {
		"returnsAccepted": "Exclusive: As a trade member, you have an additional 7 days to return this item.",
		"returnsNotAccepted": "Exclusive: As a trade member, you may initiate a return of this item within 7 days of delivery."
	},
	"tradeResponsibility": {
		"body": "You are responsible for the unsubsidized cost of return shipping for this item, which may be significantly higher than the cost to have the item shipped to you. Your exclusive return period is valid only on shipments within the U.S. and a 10% restocking fee applies. ",
		"linkCTA": "Learn More",
		"link": "https://www.1stdibs.com/trade/returns/"
	},
	"title": "Return Policy",
	"buyerProtection": {
		"header": "Buyer Protection Guaranteed",
		"beforeLink": "All purchases made through our online checkout are covered by our ",
		"linkHref": "https://www.1stdibs.com/about/promise/",
		"linkCTA": "buyer protection program",
		"afterLink": ". Regardless of the dealer's return policy, we’re here to help in the unlikely event your purchase is damaged in transit or significantly not as described."
	},
	"meta": {
		"title": "Buyer Protection on 1stdibs"
	},
	"staticMarketing": {
		"banner": "Buyer Protection on 1stdibs",
		"bannerImgAttrs": {
			"src": "/static/images/buyers/buyerAssuranceBannerImage.jpg",
			"alt": "Buyer Assurance Banner"
		},
		"description": [
			"We know buying unique pieces online requires trust. Thanks to our buyer protection program, you can shop world’s most iconic pieces and signature works with confidence. As long as you order via the 1stdibs secure checkout, your purchase will be fully protected.",
			"In the unlikely event you make a purchase through our secure checkout and receive an item that is significantly not as described or has been damaged in transit, we want to make it right <a href='#details'>(see details)</a>. Please email <a href='mailto:support@1stdibs.com' target='_blank'>support@1stdibs.com</a> within 7 days of receiving your item to let us know there is a problem, and we will work with you and the dealer to reach the best possible resolution, whether that be arranging for a return, a full refund, or a repair with a trusted restorer.",
			"As a trade member, you may also return qualifying items under the returns program for the trade. <a href='/trade/returns/'>Learn more</a>."
		],
		"benefitsTitle": "The 1stdibs Promise: Shop With Confidence",
		"benefits": [
			{
				"name": "Buyer Protection",
				"description": "Guaranteed purchase protection when you check out on 1stdibs",
				"svgId": "buyer-assurance"
			},
			{
				"name": "Secure Online Transactions",
				"description": "Safe and secure payment through our checkout process",
				"svgId": "lock"
			},
			{
				"name": "Store-To-Door Shipping",
				"description": "Easy shipping around the world",
				"svgId": "truck-moving"
			},
			{
				"name": "Dedicated Customer Support",
				"description": "Timely answers to all your questions from our support specialists",
				"svgId": "customer-support"
			}
		]
	},
	"programDetails": [
		{
			"heading": "In order to qualify for our Buyer Protection Program, your purchase must meet the following criteria:",
			"details": [
				[
					"The order was placed online through our secure checkout",
					"The item was significantly not as described, damaged in transit or never arrived",
					"You reported the issue within 7 days of delivery date (or within 180 days of the purchase date if the item never arrived)"
				]
			]
		},
		{
			"heading": "The Buyer Protection Program does not apply if:",
			"details": [
				[
					"You are returning an accurately described item, outside of the dealer's stated return policy",
					"You elected to arrange your own shipping or pick the item up in person, and the item was damaged at pickup or during shipping",
					"You purchased the item directly from the dealer (e.g. in store) without using our secure checkout"
				]
			],
			"footer": [
				"For more detailed examples pertaining to buyer protection eligibility, please visit our <a href='https://support.1stdibs.com/s/article/Buyer-Protection-Guaranteed' target='_blank'>support center</a>."
			]
		}
	],
	"svgIcon": "buyer-assurance",
	"text": "Buyer Protection Guaranteed",
	"tooltip": {
		"title": "Buyer Protection",
		"text": "Purchases made on 1stdibs are covered by our buyer protection program. In the rare instance that a purchase doesn't meet your expectations, our team of specialists is here to help. <a href='/about/promise/' target='_blank'>View details.</a>"
	},
	"tradeTooltip": {
		"title": "Buyer Protection",
		"text": "Purchases made on 1stdibs are covered by our buyer protection program. In the rare instance that a purchase doesn't meet your expectations, our team of specialists is here to help. <a href='/trade/promise/' target='_blank'>View details.</a>"
	}
};

/***/ }),
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var createHelper = function createHelper(func, helperName) {
  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (false) {
    var _ret = function () {
      /* eslint-disable global-require */
      var wrapDisplayName = require('./wrapDisplayName').default;
      /* eslint-enable global-require */

      if (noArgs) {
        return {
          v: function v(BaseComponent) {
            var Component = func(BaseComponent);
            Component.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component;
          }
        };
      }

      return {
        v: function v() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return function (BaseComponent) {
            var Component = func.apply(undefined, args)(BaseComponent);
            Component.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component;
          };
        }
      };
    }();

    if (typeof _ret === "object") return _ret.v;
  }

  return func;
};

exports.default = createHelper;

/***/ }),
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buyerDisplayHelper;
function buyerDisplayHelper(_ref) {
    var _ref$buyerOwnsActiveH = _ref.buyerOwnsActiveHold,
        ownsActiveHold = _ref$buyerOwnsActiveH === undefined ? false : _ref$buyerOwnsActiveH,
        _ref$buyerHasTradePer = _ref.buyerHasTradePermission,
        hasTradePermission = _ref$buyerHasTradePer === undefined ? false : _ref$buyerHasTradePer,
        _ref$itemIsOnHold = _ref.itemIsOnHold,
        isOnHold = _ref$itemIsOnHold === undefined ? false : _ref$itemIsOnHold,
        _ref$itemIsSold = _ref.itemIsSold,
        isSold = _ref$itemIsSold === undefined ? false : _ref$itemIsSold,
        _ref$itemIsFurniture = _ref.itemIsFurniture,
        isFurniture = _ref$itemIsFurniture === undefined ? false : _ref$itemIsFurniture,
        _ref$pricingShowSale = _ref.pricingShowSale,
        showSale = _ref$pricingShowSale === undefined ? false : _ref$pricingShowSale,
        _ref$pricingHideRetai = _ref.pricingHideRetail,
        hideRetail = _ref$pricingHideRetai === undefined ? false : _ref$pricingHideRetai,
        _ref$pricingValidNet = _ref.pricingValidNet,
        validNet = _ref$pricingValidNet === undefined ? false : _ref$pricingValidNet,
        _ref$pricingNegotiabl = _ref.pricingNegotiableSale,
        negotiableSale = _ref$pricingNegotiabl === undefined ? false : _ref$pricingNegotiabl,
        _ref$pricingNegotiabl2 = _ref.pricingNegotiableRetail,
        negotiableRetail = _ref$pricingNegotiabl2 === undefined ? false : _ref$pricingNegotiabl2,
        _ref$transactionIsBuy = _ref.transactionIsBuyerOfferWithReserve,
        isBuyerOfferWithReserve = _ref$transactionIsBuy === undefined ? false : _ref$transactionIsBuy,
        _ref$transactionIsFul = _ref.transactionIsFullPriceOrder,
        isFullPriceOrder = _ref$transactionIsFul === undefined ? false : _ref$transactionIsFul,
        _ref$transactionHasDe = _ref.transactionHasDealerSubmittedOfferAction,
        hasDealerSubmittedOfferAction = _ref$transactionHasDe === undefined ? false : _ref$transactionHasDe,
        _ref$transactionHasAc = _ref.transactionHasAcceptedBuyerOfferAction,
        hasAcceptedBuyerOfferAction = _ref$transactionHasAc === undefined ? false : _ref$transactionHasAc,
        _ref$transactionIsPre = _ref.transactionIsPreAuth,
        isPreAuth = _ref$transactionIsPre === undefined ? false : _ref$transactionIsPre,
        _ref$transactionIsInM = _ref.transactionIsInManualReview,
        isManualReview = _ref$transactionIsInM === undefined ? false : _ref$transactionIsInM,
        _ref$mostRecentOfferI = _ref.mostRecentOfferIsSubmitted,
        offerIsSubmitted = _ref$mostRecentOfferI === undefined ? false : _ref$mostRecentOfferI,
        _ref$mostRecentOfferI2 = _ref.mostRecentOfferIsAccepted,
        offerIsAccepted = _ref$mostRecentOfferI2 === undefined ? false : _ref$mostRecentOfferI2;

    var netTradeable = hasTradePermission && isFurniture;
    return {
        getShowCTAs: function getShowCTAs() {
            var unownedActiveHoldOrItemSold = isOnHold && !ownsActiveHold || isSold;
            var activeNonTradePrice = showSale || !hideRetail;
            var noCompleteTransactionOrOffer = !isBuyerOfferWithReserve && !isFullPriceOrder && !offerIsAccepted && (!offerIsSubmitted || offerIsSubmitted && isPreAuth);
            return {
                showPurchaseCTA: (activeNonTradePrice || netTradeable && (activeNonTradePrice || validNet)) && !unownedActiveHoldOrItemSold && noCompleteTransactionOrOffer,

                showMakeOfferCTA: (showSale && negotiableSale || !hideRetail && negotiableRetail) && !unownedActiveHoldOrItemSold && noCompleteTransactionOrOffer,

                showRequestCTA: !netTradeable && !showSale && hideRetail && !unownedActiveHoldOrItemSold,

                showRequestNetCTA: netTradeable && !showSale && !validNet && !unownedActiveHoldOrItemSold,

                showCheckoutOfferCTA: (hasDealerSubmittedOfferAction || hasAcceptedBuyerOfferAction || offerIsAccepted && isPreAuth && !isManualReview) && !unownedActiveHoldOrItemSold
            };
        },

        getShowPrices: function getShowPrices() {
            var showOnHold = isOnHold && !ownsActiveHold;
            var showRetailPrice = !hideRetail && !showSale && !showOnHold;
            var showNetPrice = netTradeable && validNet && !showSale && !showOnHold;
            var showSalePrice = showSale && !showOnHold;
            return {
                showSalePrice: showSalePrice,
                showNetPrice: showNetPrice,
                showRetailPrice: showRetailPrice,
                showOnHold: showOnHold,

                showPriceUponRequest: !showNetPrice && !showRetailPrice && !showSalePrice,
                showListPriceLabel: netTradeable && showRetailPrice,
                showOnHoldCustom: isOnHold && ownsActiveHold,
                showSold: isSold
            };
        }
    };
}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getPricingData;

var _price = __webpack_require__(947);

var priceSelectors = _interopRequireWildcard(_price);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getPricingData(_ref) {
    var salePrice = _ref.salePrice,
        retailPrice = _ref.retailPrice,
        netPrice = _ref.netPrice;

    var retailPriceAmountUSD = priceSelectors.getPriceAmountByCurrency(retailPrice)('USD');
    var pricingHideRetail = priceSelectors.isPriceHidden(retailPrice);

    var pricingShowSale = void 0;
    if (salePrice) {
        var salePriceAmountUSD = priceSelectors.getPriceAmountByCurrency(salePrice)('USD');
        pricingShowSale = salePriceAmountUSD > 0 && salePriceAmountUSD < retailPriceAmountUSD;
    } else {
        pricingShowSale = false;
    }

    var pricingValidNet = void 0;
    if (netPrice) {
        var netPriceAmountUSD = priceSelectors.getPriceAmountByCurrency(netPrice)('USD');
        pricingValidNet = netPriceAmountUSD > 0;
        if (retailPriceAmountUSD) {
            pricingValidNet = pricingValidNet && netPriceAmountUSD < retailPriceAmountUSD;
        } else if (!pricingHideRetail) {
            throw new Error('Retail price must have convertedAmounts if it is not hidden');
        }
    } else {
        pricingValidNet = false;
    }

    return {
        pricingShowSale: pricingShowSale,
        pricingValidNet: pricingValidNet,
        pricingHideRetail: pricingHideRetail,
        pricingNegotiableSale: priceSelectors.isNegotiable(salePrice),
        pricingNegotiableRetail: priceSelectors.isNegotiable(retailPrice)
    };
}

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAmountByCurrency = exports.getConvertedAmountList = exports.getConvertedAmounts = exports.getBaseAmount = undefined;

var _createSelector = __webpack_require__(627);

var _createSelector2 = _interopRequireDefault(_createSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getBaseAmount = exports.getBaseAmount = function getBaseAmount(amount) {
    return amount ? amount.amount : undefined;
};
var getConvertedAmounts = exports.getConvertedAmounts = function getConvertedAmounts(amount) {
    return amount ? amount.convertedAmounts : undefined;
};
var getConvertedAmountList = exports.getConvertedAmountList = function getConvertedAmountList(amount) {
    return amount ? amount.convertedAmountList : undefined;
};

// Selectors
// ------------------------------------------

/**
 * @param {object} Item
 * @returns {function} A function that can take a currency and return the value amount as long as
 *                      amount is inflated (so amount and convertedAmounts are present)
 */
var getAmountByCurrency = exports.getAmountByCurrency = (0, _createSelector2.default)(getBaseAmount, getConvertedAmounts, getConvertedAmountList, function (baseAmount, convertedAmounts, convertedAmountList) {
    return function (currency) {
        if (baseAmount === 0) {
            return 0;
        } else if (convertedAmounts) {
            return convertedAmounts[currency];
        } else if (convertedAmountList) {
            return getBaseAmount(convertedAmountList.find(function (amount) {
                return amount.currency === currency;
            }));
        } else {
            return undefined;
        }
    };
});

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActiveHoldByBuyerId = exports.getActiveHold = exports.isRetailPriceHidden = exports.getNetPrice = exports.getSalePrice = exports.getRetailPrice = exports.getPrices = exports.isArt = exports.isJewelry = exports.isFashion = exports.isFurniture = exports.isSold = exports.isOnHold = exports.isUnavailable = exports.getDealerReference = exports.getUrl = exports.getUnavailableReasonCode = exports.getStatus = exports.getSellerId = exports.getProductName = exports.getPricing = exports.getItemId = exports.getHolds = exports.getGender = exports.getCreator = exports.getCondition = exports.getCategory = undefined;

var _lodash = __webpack_require__(803);

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsVerticalHelpers = __webpack_require__(373);

var _dibsVerticalHelpers2 = _interopRequireDefault(_dibsVerticalHelpers);

var _createSelector = __webpack_require__(627);

var _createSelector2 = _interopRequireDefault(_createSelector);

var _makeSelectorHelpers = __webpack_require__(802);

var _price = __webpack_require__(947);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getCategory = exports.getCategory = function getCategory(item) {
  return (0, _lodash2.default)(item, 'vertical');
};
var getCondition = exports.getCondition = function getCondition(item) {
  return (0, _lodash2.default)(item, 'condition.state');
};
var getCreator = exports.getCreator = function getCreator(item) {
  var creator = (0, _lodash2.default)(item, 'creators[0].creator', {});
  return creator.displayName || creator.name;
};
var getGender = exports.getGender = function getGender(item) {
  return (0, _lodash2.default)(item, 'classification.gender');
};
var getHolds = exports.getHolds = function getHolds(item) {
  return (0, _lodash2.default)(item, 'holds', []);
};
var getItemId = exports.getItemId = function getItemId(item) {
  return (0, _lodash2.default)(item, 'id') || (0, _lodash2.default)(item, 'serviceId');
};
var getPricing = exports.getPricing = function getPricing(item) {
  return (0, _lodash2.default)(item, 'pricing', {});
};
var getProductName = exports.getProductName = function getProductName(item) {
  return (0, _lodash2.default)(item, 'title');
};
var getSellerId = exports.getSellerId = function getSellerId(item) {
  return (0, _lodash2.default)(item, 'seller.id');
};
var getStatus = exports.getStatus = function getStatus(item) {
  return (0, _lodash2.default)(item, 'status');
};
var getUnavailableReasonCode = exports.getUnavailableReasonCode = function getUnavailableReasonCode(item) {
  return (0, _lodash2.default)(item, 'unavailableReasonCode');
};
var getUrl = exports.getUrl = function getUrl(item) {
  return (0, _lodash2.default)(item, 'pdpUrls[0]') || (0, _lodash2.default)(item, 'pdpURL') || '';
};
var getDealerReference = exports.getDealerReference = function getDealerReference(item) {
  return (0, _lodash2.default)(item, 'dealerReference') || '';
};

// Selectors
// ------------------------------------------

/**
 * @param {string} status to compare to on the passed-in item
 * @returns {function} selector that checks the status with whats on the
 *                      passed-in item
 */
var itemStatusCheckSelector = (0, _makeSelectorHelpers.makeEqualityCheckSelector)(getStatus);
var isUnavailable = exports.isUnavailable = itemStatusCheckSelector('UNAVAILABLE');

/**
 * @param {...string} all reason codes to compare against the unavailable reason
 *                      code actually on the item
 * @returns {function} selector that checks the reason code on the item against the
 *                      given reason codes
 */
var itemUnavailabilityCheckSelector = function itemUnavailabilityCheckSelector() {
  for (var _len = arguments.length, reasonCodes = Array(_len), _key = 0; _key < _len; _key++) {
    reasonCodes[_key] = arguments[_key];
  }

  return (0, _createSelector2.default)(isUnavailable, getUnavailableReasonCode, function (itemIsUnavailable, unavailableReasonCode) {
    return itemIsUnavailable && reasonCodes.indexOf(unavailableReasonCode) > -1;
  });
};
var isOnHold = exports.isOnHold = itemUnavailabilityCheckSelector('ON_HOLD', 'ON_HOLD_CUSTOM');
var isSold = exports.isSold = itemUnavailabilityCheckSelector('SOLD', 'SOLD_ON_PLATFORM');

/**
 * @param {string} category to compare to on the passed-in item
 * @returns {function} selector that checks the vertical of the item
 */
var itemCategoryCheckSelector = (0, _makeSelectorHelpers.makeEqualityCheckSelector)(getCategory);
var isFurniture = exports.isFurniture = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_FURNITURE);
var isFashion = exports.isFashion = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_FASHION);
var isJewelry = exports.isJewelry = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_JEWELRY);
var isArt = exports.isArt = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_ART);

/**
 * @param {object} item
 * @returns {array} prices (i.e. retail, sale, etc) for the item
 */
var getPrices = exports.getPrices = (0, _createSelector2.default)(getPricing, function (pricing) {
  return pricing.prices || [];
});

/**
 * @param {string} price type to get from pricing
 * @returns {function} selector that gets the passed in price type from
 *                      pricing data
 */
var pricingPriceTypeSelector = function pricingPriceTypeSelector(typeToCheck) {
  return (0, _createSelector2.default)(getPrices, function (prices) {
    return prices.find(function (_ref) {
      var type = _ref.type,
          status = _ref.status;
      return type === typeToCheck && status === 'ACTIVE';
    });
  });
};
var getRetailPrice = exports.getRetailPrice = pricingPriceTypeSelector('RETAIL');
var getSalePrice = exports.getSalePrice = pricingPriceTypeSelector('WEEKLY_SALE');
var getNetPrice = exports.getNetPrice = pricingPriceTypeSelector('NET');

/**
 * @param {object} item
 * @returns {boolean} true if retail price is hidden
 */
var isRetailPriceHidden = exports.isRetailPriceHidden = (0, _createSelector2.default)(getRetailPrice, _price.isPriceHidden);

/**
 * @param {object} item
 * @returns {?object} the active hold if there is one, undefined otherwise
 */
var getActiveHold = exports.getActiveHold = (0, _createSelector2.default)(getHolds, function (holds) {
  return holds.find(function (hold) {
    return hold.status === 'ACTIVE';
  });
});

/**
 * @param {object} item
 * @returns {function} function that if given a buyer id will return true/false if the buyer
 *                      owns the active hold
 */
var isActiveHoldByBuyerId = exports.isActiveHoldByBuyerId = (0, _createSelector2.default)(getActiveHold, function (hold) {
  return function (buyerId) {
    if (!buyerId) {
      return false;
    }
    return (0, _lodash2.default)(hold, 'buyer.id') === buyerId || (0, _lodash2.default)(hold, 'buyer.serviceId') === buyerId;
  };
});

/***/ }),
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-email'].join(' '), viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M0,224V26h250v198H0z M239,213V37h-8.4L126.3,160.9L19.6,37H11v176H239z M126.1,144.3L216.4,37H34L126.1,144.3z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1239 */,
/* 1240 */,
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
				_inherits(Component, _React$Component);

				function Component() {
								_classCallCheck(this, Component);

								return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
				}

				_createClass(Component, [{
								key: 'render',
								value: function render() {
												return React.createElement(
																'svg',
																{ className: [this.props.className, 'dibsvg-svg dibsvg-phone'].join(' '), viewBox: '0 0 250 250' },
																React.createElement('path', { d: 'M199.1,248.7l-0.2,0c-24.3-0.7-51.7-13.1-81.5-36.6c-20.9-16.5-35.2-32.6-37.1-34.7 C35.6,137,9.4,87.5,8.3,85.4l-0.1-0.3C-5.9,53.3,11.2,32.7,12,31.9l0.2-0.2l19.6-19.8c4.2-3.6,9.6-8,11.8-8.9C46.7,1.6,49.9,1,53,1 c9.8,0,16.5,6.2,16.7,6.4l0.1,0.1l29.9,29.9c6.9,6.4,10.3,13.2,10.2,20.3c-0.2,10-7.6,16.4-8,16.7l-13.7,12 c-7.9,5.6-2.6,16.9-1.8,18.5c23.3,35.2,60.1,58.1,60.5,58.4c4,2.5,7.8,3.8,11.5,3.8c3.8,0,6.2-1.4,6.7-1.8l16.6-15.6 c4.5-3.4,9.2-5.1,14.2-5.1c10.1,0,17.4,7.3,18.6,8.6l26.9,25.2c10.6,7.9,12.9,20.4,6.2,34.3c-1.1,2.4-4.3,6.3-5.3,7.5l-0.1,0.1 l-13.6,15.3C216.3,248.3,200.8,248.7,199.1,248.7z M16.3,81.4c1.5,2.8,27.6,51.1,70.2,89.4l0.4,0.4c0.1,0.2,14.9,17.1,36.2,33.9 c19.4,15.3,48.3,33.8,76,34.6l0,0c0.5,0,13.2-0.1,23.1-10.3l13.3-15c1.6-2,3.6-4.7,4.1-5.6c3.3-7,5.4-16.7-3.6-23.3l-0.4-0.4 l-27.5-25.8c0,0-5.3-5.8-12-5.8c-2.9,0-5.8,1.1-8.6,3.2l-16.7,15.6c-0.5,0.4-5,3.7-12.3,3.7c-5.4,0-10.8-1.7-16.2-5.2 c-1.5-0.9-39-24.3-63.3-61.2l-0.2-0.4c-3.6-6.8-7.3-21.7,4.3-30.1l13.3-11.6c0.1-0.1,4.7-4.2,4.8-10.1c0.1-4.4-2.4-8.9-7.3-13.5 l-0.1-0.1L63.6,13.9C63.2,13.6,59,10,53,10c-2,0-4,0.4-5.9,1.2c-1.2,0.6-5.7,4.3-9.3,7.3L18.7,37.8C17.5,39.4,5.1,55.8,16.3,81.4z' })
												);
								}
				}]);

				return Component;
}(React.Component);

module.exports = Component;

/***/ }),
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"promoContainer":"VerifiedTradePromo__promoContainer__1VryM","textContainer":"VerifiedTradePromo__textContainer__1NKgf","highlightedText":"VerifiedTradePromo__highlightedText__X9b42","infoContainer":"VerifiedTradePromo__infoContainer__3gRRS","infoIcon":"VerifiedTradePromo__infoIcon__QyiGT","tooltip":"VerifiedTradePromo__tooltip__l2AG1","top":"VerifiedTradePromo__top__2mGbV","left":"VerifiedTradePromo__left__20ptO","tooltipInner":"VerifiedTradePromo__tooltipInner__1OKiE","inShippingModal":"VerifiedTradePromo__inShippingModal__2AFj3"};

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"shippingTitle":"shipping-styles__shippingTitle__3wffv"};

/***/ }),
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var UserStore = __webpack_require__(109);
var makeOfferLauncher = __webpack_require__(1301);
var ArrowRightIcon = __webpack_require__(351);
var PurchaseTracking = __webpack_require__(458);
var classNames = __webpack_require__(16);
var css = __webpack_require__(766);
var get = __webpack_require__(14);
var copy = __webpack_require__(728);

var MakeOfferButton = function (_React$Component) {
    _inherits(MakeOfferButton, _React$Component);

    function MakeOfferButton(props) {
        _classCallCheck(this, MakeOfferButton);

        var _this = _possibleConstructorReturn(this, (MakeOfferButton.__proto__ || Object.getPrototypeOf(MakeOfferButton)).call(this, props));

        _this.onMakeOffer = _this.onMakeOffer.bind(_this);
        if (props.tracking) {
            _this.purchaseTracking = new PurchaseTracking({
                item: props.item,
                pageContext: props.tracking.pageContext
            });
            _this.purchaseTracking.url = props.tracking.url || document.URL;
        }
        return _this;
    }

    _createClass(MakeOfferButton, [{
        key: 'onMakeOffer',
        value: function onMakeOffer() {
            var currency = this.props.context.getStore(UserStore).getCurrency();

            makeOfferLauncher(Object.assign({
                currency: currency,
                purchaseTracking: this.purchaseTracking,
                linkLocation: get(this.props.tracking, 'pageContext')
            }, this.props));

            if (this.purchaseTracking) {
                this.purchaseTracking.ecommerceAddToCartTracking({
                    url: this.purchaseTracking.url,
                    isTrade: this.props.enableRequestNetPrice
                });
                this.purchaseTracking.trackOfferEvent({
                    actionPrefix: 'offer selected',
                    actionSuffix: 'make offer button',
                    objectName: 'button'
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                buttonClass = _props.buttonClass,
                _props$makeOfferPurch = _props.makeOfferPurchaseSwapTestRunning,
                makeOfferPurchaseSwapTestRunning = _props$makeOfferPurch === undefined ? false : _props$makeOfferPurch;

            var showArrow = (!buttonClass || buttonClass === 'button-large') && !makeOfferPurchaseSwapTestRunning;
            var cls = classNames('button', 'button-' + (makeOfferPurchaseSwapTestRunning ? 'primary' : 'secondary'), buttonClass, { 'button-large': !buttonClass });
            var arrow = void 0;
            if (showArrow) {
                arrow = React.createElement(ArrowRightIcon, { className: css.itemActionRightArrow });
            }
            return React.createElement(
                'button',
                { className: cls, 'data-tn': 'item-actions-make-offer', onClick: this.onMakeOffer },
                copy.makeOffer,
                arrow
            );
        }
    }]);

    return MakeOfferButton;
}(React.Component);

MakeOfferButton.propTypes = {
    buttonClass: PropTypes.string,
    tracking: PropTypes.object,
    item: PropTypes.object.isRequired,
    transaction: PropTypes.object,
    enableRequestNetPrice: PropTypes.bool,
    context: PropTypes.object,
    makeOfferPurchaseSwapTestRunning: PropTypes.bool
};

module.exports = MakeOfferButton;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ContextComponent = __webpack_require__(61);
var cartActions = __webpack_require__(1136);
var CartStore = __webpack_require__(106);

var PurchaseTracking = __webpack_require__(458);

var _require = __webpack_require__(339),
    getCheckoutUrl = _require.getCheckoutUrl,
    redirect = _require.redirect;

var classNames = __webpack_require__(16);
var copy = __webpack_require__(728);

var PurchaseCartButton = function (_ContextComponent) {
    _inherits(PurchaseCartButton, _ContextComponent);

    function PurchaseCartButton(props) {
        _classCallCheck(this, PurchaseCartButton);

        var _this = _possibleConstructorReturn(this, (PurchaseCartButton.__proto__ || Object.getPrototypeOf(PurchaseCartButton)).call(this, props));

        _this._onClick = _this._onClick.bind(_this);
        return _this;
    }

    /**
     * if a tracking object is provided in props then this will fire the 'purchase click'
     * event and the addToCart E-commerce event
     *
     * @param {object} tracking
     * @param {string} tracking.url
     * @param {string} tracking.pageContext
     * @returns {PurchaseCartButton}
     * @private
     */


    _createClass(PurchaseCartButton, [{
        key: '_onClickTracking',
        value: function _onClickTracking() {
            var _props = this.props,
                item = _props.item,
                tracking = _props.tracking,
                enableRequestNetPrice = _props.enableRequestNetPrice;

            var _ref = tracking || {},
                url = _ref.url,
                pageContext = _ref.pageContext;

            var purchaseTracking = void 0;
            var action = void 0;

            if (tracking) {
                // initialize purchaseTracking object
                purchaseTracking = new PurchaseTracking({ item: item });

                // get action for firing 'purchase click' event
                if (pageContext && pageContext.indexOf('message center') > -1) {
                    action = 'purchase button - ' + pageContext + ' - link in conversation';
                } else {
                    action = pageContext + ' purchase button';
                }

                // fire tracking events
                purchaseTracking.trackPurchaseEvent({ action: action });
                purchaseTracking.ecommerceAddToCartTracking({ url: url, isTrade: enableRequestNetPrice });
            }

            return this;
        }
    }, {
        key: '_onClick',
        value: function _onClick(e) {
            var href = e.target.href;
            var _props2 = this.props,
                item = _props2.item,
                addToCart = _props2.addToCart;

            var cartStore = this.context.getStore(CartStore);

            // fires tracking (if this.props.tracking is set)
            this._onClickTracking();

            // only add the item to the cart if addToCart is set to true and
            // the item is not already in the cart
            if (addToCart && !cartStore.isItemInCart(item)) {
                cartStore.getItemsCollection().once('cart:itemAdded', function () {
                    return redirect(href);
                });
                this.context.executeAction(cartActions.addToCart, { item: item });

                // want to wait for redirect to be called manually
                // after item has been added to the cart
                e.preventDefault();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                item = _props3.item,
                _props3$makeOfferPurc = _props3.makeOfferPurchaseSwapTestRunning,
                makeOfferPurchaseSwapTestRunning = _props3$makeOfferPurc === undefined ? false : _props3$makeOfferPurc;

            var buttonClass = this.props.buttonClass || 'button-large';
            var cls = classNames('button', 'button-' + (makeOfferPurchaseSwapTestRunning ? 'secondary' : 'primary'), buttonClass);

            return React.createElement(
                'a',
                { className: cls, href: getCheckoutUrl(item), 'data-tn': 'item-actions-purchase-item', onClick: this._onClick },
                copy.purchase
            );
        }
    }]);

    return PurchaseCartButton;
}(ContextComponent);

// TODO: models such as item and transaction should not be passed directly
// only the props that are needed should be passed. Requires other changes.


PurchaseCartButton.propTypes = {
    item: PropTypes.object.isRequired,
    addToCart: PropTypes.bool,
    buttonClass: PropTypes.string,
    tracking: PropTypes.shape({
        pageContext: PropTypes.string,
        url: PropTypes.string
    }),
    makeOfferPurchaseSwapTestRunning: PropTypes.bool
};

module.exports = PurchaseCartButton;

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ContextComponent = __webpack_require__(61);
var PurchaseTracking = __webpack_require__(458);
var get = __webpack_require__(14);
var netPriceLauncher = __webpack_require__(957);
var Tour = __webpack_require__(487);
var copy = __webpack_require__(728);

var RequestNetPriceButton = function (_ContextComponent) {
    _inherits(RequestNetPriceButton, _ContextComponent);

    function RequestNetPriceButton(props) {
        _classCallCheck(this, RequestNetPriceButton);

        var _this = _possibleConstructorReturn(this, (RequestNetPriceButton.__proto__ || Object.getPrototypeOf(RequestNetPriceButton)).call(this, props));

        _this.onNetPriceClick = _this.onNetPriceClick.bind(_this);
        if (props.tracking) {
            _this.purchaseTracking = new PurchaseTracking({ item: props.item, pageContext: _this.props.tracking.pageContext });
        }
        return _this;
    }

    _createClass(RequestNetPriceButton, [{
        key: '_trackNetPriceClick',
        value: function _trackNetPriceClick() {
            if (this.purchaseTracking) {
                this.purchaseTracking.trackNetPriceEvent({
                    actionSuffix: 'clicked'
                });
            }
        }
    }, {
        key: 'onNetPriceClick',
        value: function onNetPriceClick(e) {
            e.preventDefault();
            this._trackNetPriceClick();
            netPriceLauncher(Object.assign({
                itemPk: this.props.item.get('id'),
                purchaseTracking: this.purchaseTracking,
                linkLocation: get(this.props.tracking, 'pageContext'),
                context: this.context
            }, this.props));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$tradeTour = this.props.tradeTour,
                tradeTour = _props$tradeTour === undefined ? {} : _props$tradeTour;

            var cls = 'button button-secondary ' + this.props.buttonClass;
            var requestCta = React.createElement(
                'a',
                { className: cls, href: '#request-net-price', 'data-tn': 'item-actions-request-net-price', onClick: function onClick(e) {
                        return _this2.onNetPriceClick(e);
                    } },
                copy.requestNetPrice
            );

            if (tradeTour && tradeTour.type) {
                return React.createElement(
                    Tour,
                    _extends({ className: 'button-wrapper', dataTn: 'request-net-price', step: 1 }, tradeTour),
                    requestCta
                );
            }

            return requestCta;
        }
    }]);

    return RequestNetPriceButton;
}(ContextComponent);

RequestNetPriceButton.propTypes = {
    item: PropTypes.object.isRequired,
    buttonClass: PropTypes.string,
    tracking: PropTypes.object,
    tradeTour: PropTypes.object
};

RequestNetPriceButton.defaultProps = {
    buttonClass: 'button-large'
};

module.exports = RequestNetPriceButton;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 6/22/16.
 */



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

// Stores
var UserStore = __webpack_require__(109);
var PriceStore = __webpack_require__(367);
var ItemStore = __webpack_require__(336);

// Components

var _require = __webpack_require__(880),
    PriceComponent = _require.PriceComponent,
    PercentageOffComponent = _require.PercentageOffComponent,
    RawPriceComponent = _require.RawPriceComponent,
    RawPercentageOffComponent = _require.RawPercentageOffComponent;

var _require2 = __webpack_require__(1281),
    RawNetPriceTour = _require2.Raw,
    NetPriceTourConnected = _require2.Connected;

// Helpers


var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var classnames = __webpack_require__(16);
var pageTypes = __webpack_require__(383);

// Styles
var priceStyles = __webpack_require__(633);
var styles = __webpack_require__(805);

var NetPrice = function (_React$Component) {
    _inherits(NetPrice, _React$Component);

    function NetPrice(props) {
        _classCallCheck(this, NetPrice);

        var _this = _possibleConstructorReturn(this, (NetPrice.__proto__ || Object.getPrototypeOf(NetPrice)).call(this, props));

        _this.state = {
            isOnNewLine: false
        };

        _this._getWidthComparison = _this._getWidthComparison.bind(_this);
        return _this;
    }

    _createClass(NetPrice, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this._getWidthComparison);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
            if (this._rightElement && !this._rightWidth) {
                this._rightWidth = this._rightElement.childNodes[0].getBoundingClientRect().width;
                this._getWidthComparison();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this._getWidthComparison);
        }
    }, {
        key: '_getWidthComparison',
        value: function _getWidthComparison() {
            var wrapperWidth = this._wrapperElement.getBoundingClientRect().width;
            var leftWidth = this._leftElement.getBoundingClientRect().width;
            var auxiliarySpacing = 25;

            if (wrapperWidth <= 0 && !this._rightWidth) {
                return false;
            }

            var isOnNewLine = this._rightWidth + leftWidth + auxiliarySpacing > wrapperWidth;

            this.setState({ isOnNewLine: isOnNewLine });
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this2 = this;

            var _props = this.props,
                context = _props.context,
                pageType = _props.pageType,
                _props$currencyLoaded = _props.currencyLoaded,
                currencyLoaded = _props$currencyLoaded === undefined ? false : _props$currencyLoaded,
                retailPrice = _props.retailPrice,
                netPrice = _props.netPrice,
                showPercentage = _props.showPercentage,
                priceDisplays = _props.priceDisplays,
                showTour = _props.showTour;

            var isPdp = pageType === pageTypes.PAGE_TYPE.PDP;
            var canShowPercentage = showPercentage;

            // If we don't show the list/retail price, then we don't show the percentage off
            if (!priceDisplays.showRetailPrice) {
                canShowPercentage = false;
            }

            // avoids flash of currency changing
            if (!currencyLoaded) {
                return false;
            }

            var wrapperClasses = classnames('is-net-price ', 'notranslate', 'cf', styles.isNetPrice, (_classnames = {
                'pdp-price': isPdp
            }, _defineProperty(_classnames, styles.price, isPdp), _defineProperty(_classnames, 'is-price-breaking', this.state.isOnNewLine), _defineProperty(_classnames, priceStyles.portfolio, pageType === pageTypes.PAGE_TYPE.FAVORITES), _classnames));

            var priceWrapClass = classnames({
                'float-l': isPdp
            });

            var NetPriceComponent = false;
            if (showTour) {
                // Only PDP pages use NetPriceTour component connected to stores as itemStore can't be populated with multiple items required for favorites/cart.
                NetPriceComponent = isPdp ? React.createElement(NetPriceTourConnected, { type: 'net', context: context }) : React.createElement(RawNetPriceTour, _extends({}, this.props, { type: 'net' }));
            } else if (netPrice || priceDisplays.showRequestNetPrice) {
                // Only PDP pages use Price component connected to stores as itemStore can't be populated with multiple items required for favorites/cart.
                NetPriceComponent = isPdp ? React.createElement(PriceComponent, { context: context, type: 'net' }) : React.createElement(RawPriceComponent, _extends({}, this.props, { type: 'net' }));
            }

            var RetailPriceComponent = false;
            if (retailPrice && priceDisplays.showRetailPrice) {
                // do not show retail price if it is a PUR item
                RetailPriceComponent =
                // Only PDP pages use Price component connected to stores as itemStore can't be populated with multiple items required for favorites/cart.
                isPdp ? React.createElement(PriceComponent, { context: context, type: 'retail' }) : React.createElement(RawPriceComponent, _extends({}, this.props, { type: 'retail' }));
            }

            var PercentOff = false;
            // Only PDP pages show percentage off
            if (canShowPercentage && pageType !== pageTypes.PAGE_TYPE.FAVORITES) {
                PercentOff = React.createElement(
                    'span',
                    { ref: function ref(rightElement) {
                            _this2._rightElement = rightElement;
                        } },
                    isPdp ? React.createElement(PercentageOffComponent, { context: context, type: 'percentageOff' }) : React.createElement(RawPercentageOffComponent, this.props)
                );
            }

            return React.createElement(
                'div',
                { className: wrapperClasses, 'data-tn': 'pdp-net-price-wrapper', ref: function ref(wrapperElement) {
                        _this2._wrapperElement = wrapperElement;
                    } },
                React.createElement(
                    'div',
                    { className: priceWrapClass, ref: function ref(leftElement) {
                            _this2._leftElement = leftElement;
                        } },
                    NetPriceComponent,
                    RetailPriceComponent
                ),
                PercentOff
            );
        }
    }]);

    return NetPrice;
}(React.Component);

NetPrice.defaultProps = {
    showPercentage: true,
    showTour: false
};

NetPrice.propTypes = {
    context: PropTypes.object,
    priceDisplays: PropTypes.object.isRequired,
    currencyLoaded: PropTypes.bool,
    retailPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    netPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    showPercentage: PropTypes.bool,
    pageType: PropTypes.string,
    float: PropTypes.bool,
    showTour: PropTypes.bool
};

var Connected = provideContext(connectToStores(NetPrice, [ItemStore, PriceStore, UserStore], function (context) {
    var userStore = context.getStore(UserStore);
    var itemStore = context.getStore(ItemStore);
    var priceStore = context.getStore(PriceStore);
    var item = itemStore.getItem();
    var processedPriceData = priceStore.processPrice(item);
    var _processedPriceData$s = processedPriceData.salePriceData,
        salePriceData = _processedPriceData$s === undefined ? {} : _processedPriceData$s,
        _processedPriceData$o = processedPriceData.originalPriceData,
        originalPriceData = _processedPriceData$o === undefined ? {} : _processedPriceData$o,
        _processedPriceData$n = processedPriceData.netPriceData,
        netPriceData = _processedPriceData$n === undefined ? {} : _processedPriceData$n,
        _processedPriceData$r = processedPriceData.retailPriceData,
        retailPriceData = _processedPriceData$r === undefined ? {} : _processedPriceData$r;

    return {
        currencyLoaded: userStore.isCurrencyLoaded(),
        netPrice: netPriceData.price,
        originalPrice: originalPriceData.price,
        priceDisplays: processedPriceData.priceDisplays,
        retailPrice: retailPriceData.price,
        salePrice: salePriceData.price
    };
}));

module.exports = {
    Connected: Connected,
    Raw: NetPrice
};

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 6/17/16.
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

// Stores
var UserStore = __webpack_require__(109);
var PriceStore = __webpack_require__(367);
var ItemStore = __webpack_require__(336);
var TourStore = __webpack_require__(547);

// Components
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var Tour = __webpack_require__(487);

var _require = __webpack_require__(880),
    PriceComponent = _require.RawPriceComponent;

var ContextComponent = __webpack_require__(61);

// Helpers
var SV = __webpack_require__(17);

var _require2 = __webpack_require__(734),
    setSession = _require2.setSession;

var _TourStore$type = TourStore.type,
    TRADE_TOUR = _TourStore$type.TRADE_TOUR,
    NET_PRICE_TOUR = _TourStore$type.NET_PRICE_TOUR;

var tourTracking = __webpack_require__(506);
var pageTypes = __webpack_require__(383);

var NetPriceTour = function (_ContextComponent) {
    _inherits(NetPriceTour, _ContextComponent);

    function NetPriceTour(props) {
        _classCallCheck(this, NetPriceTour);

        var _this = _possibleConstructorReturn(this, (NetPriceTour.__proto__ || Object.getPrototypeOf(NetPriceTour)).call(this, props));

        _this.onTourOpen = _this.onTourOpen.bind(_this);
        return _this;
    }

    _createClass(NetPriceTour, [{
        key: 'onTourOpen',
        value: function onTourOpen(payload) {
            var onOpen = this.props.tradeTour.onOpen;

            this.context.executeAction(setSession, { type: NET_PRICE_TOUR });
            onOpen(payload);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                pageType = _props.pageType,
                netPriceTour = _props.netPriceTour,
                tradeTour = _props.tradeTour,
                _props$copy = _props.copy,
                copy = _props$copy === undefined ? {} : _props$copy,
                isSoldIndividually = _props.isSoldIndividually,
                netPrice = _props.netPrice,
                priceDisplays = _props.priceDisplays,
                currency = _props.currency;


            return React.createElement(
                Tour,
                {
                    className: 'button-wrapper',
                    copy: tradeTour.copy,
                    dataTn: 'net-price-trade',
                    type: tradeTour.type,
                    subType: tradeTour.subType,
                    isTourOpen: tradeTour.isTourOpen,
                    currentStep: tradeTour.currentStep,
                    totalSteps: tradeTour.totalSteps,
                    onOpen: this.onTourOpen,
                    step: 1
                },
                React.createElement(
                    Tour,
                    {
                        copy: netPriceTour.copy,
                        dataTn: 'net-price',
                        type: netPriceTour.type,
                        subType: netPriceTour.subType,
                        isTourOpen: netPriceTour.isTourOpen,
                        currentStep: netPriceTour.currentStep,
                        totalSteps: netPriceTour.totalSteps,
                        onCtaClick: netPriceTour.onCtaClick,
                        onOpen: netPriceTour.onOpen,
                        step: 1
                    },
                    React.createElement(PriceComponent, {
                        float: true,
                        type: 'net',
                        copy: copy,
                        priceDisplays: priceDisplays,
                        isSoldIndividually: isSoldIndividually,
                        netPrice: netPrice,
                        currency: currency,
                        pageType: pageType
                    })
                )
            );
        }
    }]);

    return NetPriceTour;
}(ContextComponent);

NetPriceTour.propTypes = {
    priceDisplays: PropTypes.object.isRequired,
    isSoldIndividually: PropTypes.bool,
    currency: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    netPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    copy: PropTypes.object,
    netPriceTour: PropTypes.object,
    tradeTour: PropTypes.object,
    pageType: PropTypes.string
};

var Connected = provideContext(connectToStores(NetPriceTour, [ItemStore, UserStore, TourStore, PriceStore], function (context) {
    var userStore = context.getStore(UserStore);
    var itemStore = context.getStore(ItemStore);
    var tourStore = context.getStore(TourStore);
    var priceStore = context.getStore(PriceStore);
    var item = itemStore.getItem();
    var processedPriceData = priceStore.processPrice(item);
    var _processedPriceData$n = processedPriceData.netPriceData,
        netPriceData = _processedPriceData$n === undefined ? {} : _processedPriceData$n,
        _processedPriceData$r = processedPriceData.retailPriceData,
        retailPriceData = _processedPriceData$r === undefined ? {} : _processedPriceData$r,
        priceDisplays = processedPriceData.priceDisplays;

    return {
        copy: itemStore.getCopy(),
        currency: userStore.getCurrency(),
        isSoldIndividually: itemStore.getSoldIndividually(netPriceData.model || retailPriceData.model),
        netPrice: netPriceData.price,
        netPriceTour: {
            type: NET_PRICE_TOUR,
            copy: SV.get('tourCopy.' + NET_PRICE_TOUR),
            isTourOpen: tourStore.isTourOpen(NET_PRICE_TOUR),
            currentStep: tourStore.getCurrentStep(NET_PRICE_TOUR),
            totalSteps: tourStore.getTotalSteps(NET_PRICE_TOUR),
            onCtaClick: tourTracking.trackCta,
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        },
        pageType: pageTypes.PAGE_TYPE.PDP,
        priceDisplays: priceDisplays,
        tradeTour: {
            type: TRADE_TOUR,
            subType: priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
            copy: SV.get('tourCopy.' + TRADE_TOUR),
            isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
            currentStep: tourStore.getCurrentStep(TRADE_TOUR),
            totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        }
    };
}));

module.exports = {
    Connected: Connected,
    Raw: NetPriceTour
};

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 6/22/16.
 */



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

// Stores
var UserStore = __webpack_require__(109);
var PriceStore = __webpack_require__(367);
var ItemStore = __webpack_require__(336);

// Components
var FormattedPrice = __webpack_require__(636);

// Styles
var styles = __webpack_require__(633);

// Helpers
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var classnames = __webpack_require__(16);
var pageTypes = __webpack_require__(383);
var get = __webpack_require__(14);

var ReducedPrice = function ReducedPrice(props) {
    var _classnames;

    var currency = props.currency,
        originalPrice = props.originalPrice,
        salePrice = props.salePrice,
        _props$copy = props.copy,
        copy = _props$copy === undefined ? {} : _props$copy,
        _props$pageType = props.pageType,
        pageType = _props$pageType === undefined ? 'pdp' : _props$pageType,
        showReducedFrom = props.showReducedFrom,
        isSoldIndividually = props.isSoldIndividually,
        priceDisplays = props.priceDisplays;

    var reducedFromText = get(copy, 'priceStates.reducedFrom');
    var isPdp = pageType === pageTypes.PAGE_TYPE.PDP;
    var priceClasses = classnames('notranslate', (_classnames = {
        'pdp-price': isPdp
    }, _defineProperty(_classnames, styles.price, isPdp), _defineProperty(_classnames, styles.portfolio, pageType === pageTypes.PAGE_TYPE.FAVORITES), _classnames));

    return React.createElement(
        'div',
        null,
        React.createElement(
            'div',
            { className: priceClasses, 'data-tn': 'item-details-price' },
            React.createElement(FormattedPrice, {
                isSoldIndividually: isSoldIndividually,
                copy: copy,
                priceDisplays: priceDisplays,
                price: salePrice,
                currency: currency,
                type: 'reduced' })
        ),
        showReducedFrom ? React.createElement(
            'div',
            { className: styles.reduced + ' pdp-price-reduced notranslate', 'data-tn': 'price-reduced' },
            reducedFromText + ' ',
            React.createElement(FormattedPrice, {
                isSoldIndividually: isSoldIndividually,
                copy: copy,
                priceDisplays: priceDisplays,
                price: originalPrice,
                currency: currency,
                type: 'initial' })
        ) : null
    );
};

ReducedPrice.defaultProps = {
    showReducedFrom: true
};

ReducedPrice.propTypes = {
    copy: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    salePrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    originalPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    pageType: PropTypes.string,
    isSoldIndividually: PropTypes.bool,
    priceDisplays: PropTypes.object,
    showReducedFrom: PropTypes.bool
};

var Connected = provideContext(connectToStores(ReducedPrice, [ItemStore, PriceStore, UserStore], function (context) {
    var userStore = context.getStore(UserStore);
    var itemStore = context.getStore(ItemStore);
    var priceStore = context.getStore(PriceStore);
    var item = itemStore.getItem();
    var processedPriceData = priceStore.processPrice(item);
    var _processedPriceData$s = processedPriceData.salePriceData,
        salePriceData = _processedPriceData$s === undefined ? {} : _processedPriceData$s,
        _processedPriceData$n = processedPriceData.netPriceData,
        netPriceData = _processedPriceData$n === undefined ? {} : _processedPriceData$n,
        _processedPriceData$o = processedPriceData.originalPriceData,
        originalPriceData = _processedPriceData$o === undefined ? {} : _processedPriceData$o,
        _processedPriceData$r = processedPriceData.retailPriceData,
        retailPriceData = _processedPriceData$r === undefined ? {} : _processedPriceData$r;

    return {
        copy: itemStore.getCopy(),
        currency: userStore.getCurrency(),
        isSoldIndividually: itemStore.getSoldIndividually(netPriceData.model || retailPriceData.model),
        originalPrice: originalPriceData.price,
        pageType: pageTypes.PAGE_TYPE.PDP,
        priceDisplays: processedPriceData.priceDisplays,
        salePrice: salePriceData.price
    };
}));

module.exports = {
    Connected: Connected,
    Raw: ReducedPrice
};

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classNames = __webpack_require__(16);
var CloseIcon = __webpack_require__(276);

function QuickView(props) {
    var classes = props.classes,
        isActive = props.isActive,
        onClose = props.onClose,
        data = _objectWithoutProperties(props, ['classes', 'isActive', 'onClose']);

    var attributes = data.attributes;

    if (attributes !== null && (typeof attributes === 'undefined' ? 'undefined' : _typeof(attributes)) === 'object' && !!attributes.materials_techniques_list) {
        attributes = attributes.materials_techniques_list;
    }

    var className = classNames(classes.view, _defineProperty({}, classes.isActive, isActive));

    return React.createElement(
        'div',
        { className: className },
        React.createElement(
            'div',
            { onClick: onClose, className: classes.view + '-close' },
            React.createElement(CloseIcon, null)
        ),
        React.createElement(
            'div',
            { className: classes.view + '-title' },
            React.createElement(
                'a',
                { href: data.uri },
                data.title
            )
        ),
        data.location ? React.createElement(
            'div',
            { className: classes.view + '-location' },
            data.location
        ) : data.creators ? React.createElement(
            'div',
            { className: classes.view + '-creators' },
            data.creators
        ) : null,
        data.seller ? React.createElement(
            'div',
            { className: classes.view + '-seller' },
            data.seller
        ) : null,
        attributes && typeof attributes === 'string' ? React.createElement(
            'div',
            { className: classes.view + '-attributes' },
            attributes
        ) : null,
        data.materials ? React.createElement(
            'div',
            { className: classes.view + '-materials' },
            data.materials
        ) : null,
        React.createElement(
            'div',
            { className: classes.view + '-description' },
            data.description
        )
    );
}

QuickView.defaultProps = {
    classes: {
        view: 'product-quick-view',
        isActive: 'is-active'
    },
    isActive: false,
    onClose: function onClose() {}
};

QuickView.propTypes = {
    classes: PropTypes.shape({
        view: PropTypes.string.isRequired,
        isActive: PropTypes.string.isRequired
    }).isRequired,
    isActive: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,

    uri: PropTypes.string,
    title: PropTypes.string,
    location: PropTypes.string,
    creators: PropTypes.string,
    seller: PropTypes.string,
    attributes: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    materials: PropTypes.string,
    description: PropTypes.string
};

module.exports = QuickView;

/***/ }),
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GalleryWrapperView = __webpack_require__(985);

var _require = __webpack_require__(709),
    connectGalleryModalStoreToView = _require.connectGalleryModalStoreToView;

/**
 * GalleryModalView extends GalleryWrapperView
 * Top Level Connected Wrapper for Views in Gallery Modal
 */


var GalleryModalView = connectGalleryModalStoreToView(GalleryWrapperView).extend({
    isModal: true,

    constructor: function constructor() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            pageType = _ref.pageType;

        this.pageType = pageType;

        GalleryWrapperView.prototype.constructor.apply(this, arguments);
    },


    /**
     * Processes galleryStore and sets props before render
     *
     * @param {GalleryStore} galleryStore
     * @param {GalleryModalStore} galleryModalStore
     * @see /gallery/stores/GalleryStore
     * @see /gallery/modal/GalleryModalStore
     */
    getPropsFromStores: function getPropsFromStores(galleryStore, galleryModalStore) {
        var props = GalleryWrapperView.prototype.getPropsFromStores.apply(this, arguments);

        if (galleryModalStore.isHidden()) {
            return Object.assign(props, {
                titleTag: galleryModalStore.getOriginalPageTitleTag()
            });
        }

        return props;
    }
});

module.exports = GalleryModalView;

/***/ }),
/* 1331 */,
/* 1332 */,
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ContextComponent = __webpack_require__(61);

var SocialIcon = __webpack_require__(891);
var PinterestIcon = __webpack_require__(494);

var pinterestUtils = __webpack_require__(714);
var pinterestActions = __webpack_require__(710);

var Pinterest = function (_ContextComponent) {
    _inherits(Pinterest, _ContextComponent);

    function Pinterest(props) {
        _classCallCheck(this, Pinterest);

        var _this = _possibleConstructorReturn(this, (Pinterest.__proto__ || Object.getPrototypeOf(Pinterest)).call(this, props));

        _this.pin = _this.pin.bind(_this);
        return _this;
    }

    _createClass(Pinterest, [{
        key: '_onPin',
        value: function _onPin() {
            var onPin = this.props.onPin;


            if (typeof onPin === 'function') {
                onPin();
            }
        }
    }, {
        key: 'openWindow',
        value: function openWindow() {
            return pinterestUtils.openWindow();
        }
    }, {
        key: 'pin',
        value: function pin() {
            var _props = this.props,
                url = _props.url,
                media = _props.media,
                description = _props.description,
                copy = _props.copy,
                connectAccounts = _props.connectAccounts;

            var pinterestWindow = this.openWindow();

            if (connectAccounts) {
                var tracking = copy.tracking.connectModalPinClicked;
                this.context.executeAction(pinterestActions.showConnectModalAfterPinAdded, {
                    pinterestWindow: pinterestWindow, url: url, media: media, description: description, tracking: tracking
                });
            } else {
                this.context.executeAction(pinterestActions.pin, { pinterestWindow: pinterestWindow, url: url, media: media, description: description });
            }

            this._onPin();
        }
    }, {
        key: 'render',
        value: function render() {
            var iconType = this.props.iconType;


            return React.createElement(SocialIcon, { onClick: this.pin, Icon: PinterestIcon, iconName: 'pinterest', iconType: iconType, 'data-tn': 'pinterest' });
        }
    }]);

    return Pinterest;
}(ContextComponent);

Pinterest.displayName = 'Pinterest';

Pinterest.propTypes = {
    url: PropTypes.string.isRequired,
    media: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired,
    connectAccounts: PropTypes.bool,
    iconType: PropTypes.string,
    onPin: PropTypes.func
};

Pinterest.defaultProps = {
    url: '',
    media: '',
    description: ''
};

module.exports = Pinterest;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 9/7/16.
 */



var convertedAmountsString = '\n    USD\n    GBP\n    EUR\n    CAD\n    AUD\n    CHF\n    MXN\n';

var actionsQuery = '\n    actions {\n        apiType\n        code\n    }\n';

var returnPolicyQuery = '\n    returnPolicy {\n        id\n        name\n        accept\n        note\n        notifyDays\n        sellerKey {\n            id\n            vertical\n        }\n    }\n';

var lowestShipmentQuoteQuery = '\n    lowestShipmentQuote {\n        id\n        complimentaryShipping\n        totalAmount {\n            amount\n            convertedAmounts {\n                ' + convertedAmountsString + '\n            }\n        }\n    }\n';

var pricesQuery = '\n    prices {\n        type\n        hidePrice\n        negotiable\n        pricePerPiece\n        status\n        amount {\n            apiType\n            currency\n            amount\n            convertedAmounts {\n                ' + convertedAmountsString + '\n            }\n        }\n    }\n';

var priceLocksQuery = '\n    priceLocks {\n        id\n        lockType {\n            name\n        }\n        price {\n            amount {\n                convertedAmounts {\n                    ' + convertedAmountsString + '\n                }\n            }\n        }\n    }\n';

var pricingQuery = '\n    pricing {\n        negotiable\n        hidePrice\n        pricePerPiece\n        totalAmount {\n            amount\n        }\n        ' + pricesQuery + '\n        ' + priceLocksQuery + '\n    }\n';

var holdsQuery = '\n    activeHold {\n        id\n        buyer {\n            serviceId\n        }\n        status\n        expirationDate\n    }\n';

var shipmentQuotesFragment = '\n    edges {\n        node {\n            handlingTimeDisplay\n            totalAmount {\n                currency\n                amount\n                convertedAmountList {\n                    currency\n                    amount\n                }\n            },\n            is1stdibsWhiteGloveQuote\n            serviceMethod {\n                serviceMethodType\n                displayName\n                region {\n                    apiType\n                    code\n                    regionName\n                    regionType\n                }\n            }\n        }\n   }\n';

var query = function query(pk, userId, hasUserId) {
    if (!pk) {
        console.warn('a valid pk must be passed in. ' + pk + ' was given');
        return false;
    }

    return '{\n        viewer {\n            item(itemId:"' + pk + '") {\n                vertical\n                title\n                pieces\n                status\n                isSold\n                isOnHold\n                unavailableReasonCode\n                canMakePurchase\n                pieces\n                ' + holdsQuery + '\n                ' + actionsQuery + '\n                ' + returnPolicyQuery + '\n                ' + lowestShipmentQuoteQuery + '\n                ' + pricingQuery + '\n            }\n            shipmentQuotes(itemId: "' + pk + '", searchView: PDP) {\n                ' + shipmentQuotesFragment + '\n            }\n            localDeliveryOptions: availableDeliveryOptions(itemId: "' + pk + '", regionView: LOCAL, addressResolutionType: IP) {\n                ' + shipmentQuotesFragment + '\n            }\n            domesticDeliveryOptions: availableDeliveryOptions(itemId: "' + pk + '", regionView: DOMESTIC, addressResolutionType: IP) {\n                ' + shipmentQuotesFragment + '\n            }\n            user(userId: "' + userId + '") @include(if: ' + hasUserId + ') {\n                canRequestShippingQuote: hasPermission(name: "B_REQUEST_SHIPPING_QUOTE")\n            }\n        }\n    }';
};

module.exports = {
    query: query
};

/***/ }),
/* 1335 */,
/* 1336 */,
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var _require = __webpack_require__(541),
    getValidQuote = _require.getValidQuote;

var _require2 = __webpack_require__(1010),
    DOMESTIC = _require2.DOMESTIC,
    LOCAL = _require2.LOCAL;

function QuotePrimary(_ref) {
    var quotes = _ref.quotes,
        currency = _ref.currency;

    var _getValidQuote = getValidQuote({
        quotes: quotes.domestic,
        regionType: DOMESTIC,
        currency: currency
    }),
        outputDomestic = _getValidQuote.output;

    var _getValidQuote2 = getValidQuote({
        quotes: quotes.local,
        regionType: LOCAL,
        isLocalPrimary: true,
        currency: currency
    }),
        outputLocal = _getValidQuote2.output;

    if (outputDomestic || outputLocal) {
        return React.createElement(
            'div',
            { 'data-tn': 'shipping-primary' },
            outputDomestic || outputLocal
        );
    }

    return React.createElement(
        'div',
        { 'data-tn': 'shipping-primary' },
        'Global Shipping Available'
    );
}

QuotePrimary.propTypes = {
    quotes: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired
};

module.exports = QuotePrimary;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Component = React.Component;

var Relay = __webpack_require__(18);
var get = __webpack_require__(14);

// Stores
var ItemStore = __webpack_require__(336);
var UserStore = __webpack_require__(109);

// Components
var ModalContainer = __webpack_require__(760).default;
var ShippingDetailsModal = __webpack_require__(1863);
__webpack_require__(1161);

var _require = __webpack_require__(785),
    OPEN_DETAILS_FROM_SIDEBAR = _require.OPEN_DETAILS_FROM_SIDEBAR,
    OPEN_DETAILS_FROM_DESCRIPTION = _require.OPEN_DETAILS_FROM_DESCRIPTION;

// Helpers


var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);

var _require2 = __webpack_require__(541),
    getValidQuote = _require2.getValidQuote;

var _require3 = __webpack_require__(542),
    trackGaEvent = _require3.trackGaEvent;

var chatUtils = __webpack_require__(268);

var _require4 = __webpack_require__(482),
    getEnvironment = _require4.getEnvironment;

// Request Shipping Quote Modal


var _require5 = __webpack_require__(271),
    connect = _require5.connect;

var _require6 = __webpack_require__(1116),
    RequestShippingModal = _require6.default;

var showAuthModal = __webpack_require__(611);
__webpack_require__(1745);

function onOpen(_ref) {
    var output = _ref.output,
        source = _ref.source,
        customQuoteAvailable = _ref.customQuoteAvailable;

    return function () {
        var labels = ['pdp ' + source];
        labels.push(output ? 'shipping quote provided' : 'no shipping quote provided');
        if (customQuoteAvailable) {
            labels.push('custom quote request available');
        }
        trackGaEvent('product', 'view shipping details', labels.join('|'));
        chatUtils.track.shippingDetailsClick();
    };
}

function onShowQuoteRequest(source) {
    return function () {
        trackGaEvent('product', 'request shipping quote clicked', 'pdp ' + source);
    };
}

function hasNoQuotes() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        domestic = _ref2.domestic,
        local = _ref2.local,
        shipmentQuotes = _ref2.shipmentQuotes;

    return !domestic.length && !local.length && !shipmentQuotes.length;
}

var ShippingDetailsLink = function (_Component) {
    _inherits(ShippingDetailsLink, _Component);

    function ShippingDetailsLink(props) {
        _classCallCheck(this, ShippingDetailsLink);

        var _this = _possibleConstructorReturn(this, (ShippingDetailsLink.__proto__ || Object.getPrototypeOf(ShippingDetailsLink)).call(this, props));

        _this.openModal = _this.openModal.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        // isSubmitAfterAuth and openModalKey are from RequestShippingModal's redux store
        _this.state = { isOpened: props.isSubmitAfterAuth && props.openModalKey && props.openModalKey === props.pagePosition };
        return _this;
    }

    _createClass(ShippingDetailsLink, [{
        key: 'openModal',
        value: function openModal() {
            this.setState({ isOpened: true });
            this.props.relay.forceFetch();
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.setState({ isOpened: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                currency = _props.currency,
                quotes = _props.quotes,
                _props$user = _props.user,
                user = _props$user === undefined ? {} : _props$user,
                link = _props.link,
                source = _props.source,
                itemId = _props.itemId,
                userId = _props.userId,
                dealerPk = _props.dealerPk,
                viewer = _props.viewer,
                customQuoteAvailable = _props.customQuoteAvailable,
                dealerData = _props.dealerData,
                trackingLocation = _props.trackingLocation,
                pagePosition = _props.pagePosition,
                item = _props.item;

            var _getValidQuote = getValidQuote({
                quotes: quotes.domestic,
                regionType: 'DOMESTIC',
                currency: currency
            }),
                output = _getValidQuote.output;

            var detailsModal = React.createElement(ShippingDetailsModal, {
                quotes: quotes,
                currency: currency,
                user: user,
                source: source,
                itemId: itemId,
                userId: userId,
                closeShippingModal: this.closeModal,
                viewer: viewer,
                item: item
            });
            if (get(user, 'canRequestShippingQuote')) {
                if (hasNoQuotes(quotes)) {
                    detailsModal = null;
                }
                return React.createElement(
                    'div',
                    { className: 'pdp-shipping-details-link' },
                    React.cloneElement(link, { onClick: this.openModal }),
                    React.createElement(
                        RequestShippingModal,
                        {
                            environment: getEnvironment(),
                            closeOnEsc: true,
                            closeOnOutsideClick: true,
                            closeShippingModal: this.closeModal,
                            isOpened: this.state.isOpened,
                            onOpen: onOpen({ output: output, source: source, customQuoteAvailable: customQuoteAvailable }),
                            onShowQuoteRequest: onShowQuoteRequest(source),
                            itemId: itemId,
                            userId: userId,
                            user: user,
                            dealerPk: dealerPk,
                            viewer: viewer,
                            dealerData: dealerData,
                            showAuthModal: showAuthModal,
                            trackingLocation: trackingLocation,
                            modalKey: pagePosition,
                            conversation: null,
                            item: null
                        },
                        detailsModal
                    )
                );
            }
            return React.createElement(
                'div',
                { className: 'pdp-shipping-details-link' },
                React.cloneElement(link, { onClick: this.openModal }),
                React.createElement(
                    ModalContainer,
                    {
                        modalSize: 'medium',
                        onClose: this.closeModal,
                        isOpen: this.state.isOpened,
                        onOpen: onOpen({ output: output, source: source, customQuoteAvailable: customQuoteAvailable })
                    },
                    detailsModal
                )
            );
        }
    }]);

    return ShippingDetailsLink;
}(Component);

ShippingDetailsLink.propTypes = {
    context: PropTypes.object,
    customQuoteAvailable: PropTypes.bool,
    currency: PropTypes.string.isRequired,
    quotes: PropTypes.object.isRequired,
    user: PropTypes.object,
    itemId: PropTypes.string,
    userId: PropTypes.string,
    dealerPk: PropTypes.string,
    viewer: PropTypes.object,
    link: PropTypes.element.isRequired,
    source: PropTypes.oneOf([OPEN_DETAILS_FROM_SIDEBAR, OPEN_DETAILS_FROM_DESCRIPTION]).isRequired,
    regionType: PropTypes.string.isRequired,
    favoriteDealer: PropTypes.object,
    favoriteDealerCta: PropTypes.object,
    dealerData: PropTypes.object,
    relay: PropTypes.object,
    trackingLocation: PropTypes.string,
    isSubmitAfterAuth: PropTypes.bool,
    openModalKey: PropTypes.string,
    pagePosition: PropTypes.string,
    item: PropTypes.object
};

// we need these props from the shipping quote request modal redux store (which is a parent of the
// NewPdpRoot Relay instance) in order to know if we were in the middle of the shipping request flow
// when the user was prompted to login, triggering a re-render of this component.
var connectToRedux = connect(function (_ref3) {
    var isSubmitAfterAuth = _ref3.isSubmitAfterAuth,
        openModalKey = _ref3.openModalKey;
    return { isSubmitAfterAuth: isSubmitAfterAuth, openModalKey: openModalKey };
});

module.exports = Relay.createContainer(connectToRedux(provideContext(connectToStores(ShippingDetailsLink, [ItemStore, UserStore], function (context) {
    var userStore = context.getStore(UserStore);
    var itemStore = context.getStore(ItemStore);
    return {
        currency: userStore.getCurrency(),
        copy: itemStore.getCopy()
    };
}))), {
    initialVariables: {
        userId: null,
        itemId: null
    },
    fragments: {
        user: function user(_ref4) {
            var itemId = _ref4.itemId,
                userId = _ref4.userId;
            return function (RQL_0, RQL_1) {
                return {
                    children: [].concat.apply([], [{
                        alias: 'canRequestShippingQuote',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_REQUEST_SHIPPING_QUOTE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ShippingDetailsLink_UserRelayQL',
                    type: 'User'
                };
            }(ShippingDetailsModal.getFragment('user', { itemId: itemId, userId: userId }), RequestShippingModal.getFragment('user', { itemId: itemId, userId: userId }));
        },
        item: function item() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ShippingDetailsLink_ItemRelayQL',
                    type: 'Item'
                };
            }(ShippingDetailsModal.getFragment('item'));
        },
        viewer: function viewer(_ref5) {
            var itemId = _ref5.itemId,
                userId = _ref5.userId;
            return function (RQL_0, RQL_1) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ShippingDetailsLink_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(ShippingDetailsModal.getFragment('viewer', { itemId: itemId, userId: userId }), RequestShippingModal.getFragment('viewer', { itemId: itemId, userId: userId }));
        }
    }
});

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ViewerFragment = undefined;

var _reactRelay = __webpack_require__(18);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewerFragment = exports.ViewerFragment = function () {
    return {
        children: [{
            calls: [{
                kind: 'Call',
                metadata: {},
                name: 'userId',
                value: {
                    kind: 'CallVariable',
                    callVariableName: 'userId'
                }
            }],
            children: [{
                fieldName: 'isVerifiedTrade',
                kind: 'Field',
                metadata: {},
                type: 'Boolean'
            }, {
                fieldName: 'verifiedTradeSubStatus',
                kind: 'Field',
                metadata: {},
                type: 'String'
            }, {
                fieldName: 'id',
                kind: 'Field',
                metadata: {
                    isGenerated: true,
                    isRequisite: true
                },
                type: 'ID'
            }],
            fieldName: 'user',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true,
                inferredRootCallName: 'node',
                inferredPrimaryKey: 'id'
            },
            type: 'User'
        }, {
            calls: [{
                kind: 'Call',
                metadata: {},
                name: 'itemId',
                value: {
                    kind: 'CallVariable',
                    callVariableName: 'itemId'
                }
            }],
            children: [{
                children: [{
                    children: [{
                        fieldName: 'type',
                        kind: 'Field',
                        metadata: {},
                        type: 'PriceType'
                    }, {
                        fieldName: 'status',
                        kind: 'Field',
                        metadata: {},
                        type: 'String'
                    }, {
                        children: [{
                            children: [{
                                fieldName: 'USD',
                                kind: 'Field',
                                metadata: {},
                                type: 'Float'
                            }],
                            fieldName: 'convertedAmounts',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ConvertedAmounts'
                        }],
                        fieldName: 'amount',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true
                        },
                        type: 'FinancialAmount'
                    }],
                    fieldName: 'prices',
                    kind: 'Field',
                    metadata: {
                        canHaveSubselections: true,
                        isPlural: true
                    },
                    type: 'Price'
                }],
                fieldName: 'pricing',
                kind: 'Field',
                metadata: {
                    canHaveSubselections: true
                },
                type: 'ItemPricing'
            }, {
                fieldName: 'id',
                kind: 'Field',
                metadata: {
                    isGenerated: true,
                    isRequisite: true
                },
                type: 'ID'
            }],
            fieldName: 'item',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true,
                inferredRootCallName: 'node',
                inferredPrimaryKey: 'id'
            },
            type: 'Item'
        }, {
            alias: 'confirmedTransactions',
            calls: [{
                kind: 'Call',
                metadata: {},
                name: 'buyerId',
                value: {
                    kind: 'CallVariable',
                    callVariableName: 'userId'
                }
            }, {
                kind: 'Call',
                metadata: {},
                name: 'viewName',
                value: {
                    kind: 'CallValue',
                    callValue: 'buyerTracking.confirmed'
                }
            }, {
                kind: 'Call',
                metadata: {},
                name: 'first',
                value: {
                    kind: 'CallValue',
                    callValue: 0
                }
            }],
            children: [{
                fieldName: 'totalResults',
                kind: 'Field',
                metadata: {},
                type: 'Int'
            }],
            fieldName: 'transactions',
            kind: 'Field',
            metadata: {
                canHaveSubselections: true,
                isConnection: true
            },
            type: 'TransactionConnection'
        }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
                isGenerated: true,
                isRequisite: true
            },
            type: 'ID'
        }],
        id: _reactRelay2.default.QL.__id(),
        kind: 'Fragment',
        metadata: {},
        name: 'VerifiedTradePromoFragmentsRelayQL',
        type: 'Viewer'
    };
}();

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applyPromo = exports.promoCoversShipping = undefined;

var _lodash = __webpack_require__(14);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(813);

var _lodash4 = _interopRequireDefault(_lodash3);

var _item = __webpack_require__(818);

var _amount = __webpack_require__(748);

var _verifiedTradePromoConstants = __webpack_require__(1085);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var promoCoversShipping = exports.promoCoversShipping = function promoCoversShipping(shippingAmount) {
    return (0, _amount.getAmountByCurrency)(shippingAmount)('USD') <= _verifiedTradePromoConstants.shipping.amounts.PROMO_AMOUNT_USD;
};

var applyPromo = exports.applyPromo = function applyPromo() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$user = _ref.user,
        user = _ref$user === undefined ? {} : _ref$user,
        _ref$item = _ref.item,
        item = _ref$item === undefined ? {} : _ref$item,
        _ref$confirmedTransac = _ref.confirmedTransactions,
        confirmedTransactions = _ref$confirmedTransac === undefined ? {} : _ref$confirmedTransac;

    var isVerifiedTrade = user.isVerifiedTrade,
        verifiedTradeSubStatus = user.verifiedTradeSubStatus;
    var _confirmedTransaction = confirmedTransactions.totalResults,
        totalResults = _confirmedTransaction === undefined ? 0 : _confirmedTransaction;

    var itemPriceUSD = (0, _lodash2.default)((0, _item.getRetailPrice)(item), 'amount.convertedAmounts.USD');

    return isVerifiedTrade && (0, _lodash4.default)(verifiedTradeSubStatus, 'VERIFIED_IN_LAST_30_DAYS') && totalResults === 0 && itemPriceUSD >= _verifiedTradePromoConstants.shipping.amounts.MIN_ITEM_PRICE_USD;
};

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Lior Elrom
 * Date: 03/21/16
 * Time: 3:49 PM
 */



var PRODUCT_CATEGORY = 'product';
var CHECKOUT_CATEGORY = 'checkout';

module.exports = {
    getCarouselCategory: function getCarouselCategory(owner) {
        switch (owner) {
            case 'checkout':
                return CHECKOUT_CATEGORY;
            default:
                return PRODUCT_CATEGORY;
        }
    }
};

/***/ }),
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */
/***/ (function(module, exports) {

module.exports = {
	"verticalOverrides": {
		"art": {
			"dealerSingular": "gallery",
			"dealerPossessive": "gallery's"
		}
	},
	"dealerSingular": "dealer",
	"dealerPossessive": "dealer's",
	"dealersReturnPolicy": "Item's Return Policy",
	"cannotBeReturned": "This item cannot be returned or exchanged.",
	"viewDetails": "View Details",
	"inCaseOfDamages": "In the case of damages in transit, loss in transit, or misrepresentation, 1stdibs is here to assist you. For more information on 1stdibs Return Policies, please visit our <a target='_blank' href='%s'>Support Center</a>",
	"returnsAcceptedMarketplaceHelp": "Questions or concerns about returning your online purchase? Our <a target='_blank' href='%s'>Marketplace Support Team</a> is here to help.",
	"returnsNotAcceptedMarketplaceHelp": "Questions or concerns about your online purchase? Our <a target='_blank' href='%s'>Marketplace Support Team</a> is here to help.",
	"modalTitle": "Item Return policy",
	"returnsAcceptedSingular": "Returns can be initiated within %s day of delivery by contacting 1stdibs.",
	"returnsAcceptedPlural": "Returns can be initiated within %s days of delivery by contacting 1stdibs.",
	"bothWays": "This %dealerSingular% covers the cost of return shipping for this item.",
	"userResponsible": "You are responsible for the cost of return shipping for this item.",
	"additionalNotesHeader": "Additional notes from %dealerSingular%",
	"returnsAcceptedMarketplaceSupportIsHere": "Questions or concerns about returning your online purchase? Our <a target='_blank' href='%s'>Marketplace Support Team</a> is here to help.",
	"returnsAcceptedMarketplaceSupportNoLink": "Questions or concerns about returning your online purchase? Our Marketplace Support Team is here to help.",
	"returnsNotAcceptedMarketplaceSupportIsHere": "Questions or concerns about your online purchase? Our <a target='_blank' href='%s'>Marketplace Support Team</a> is here to help.",
	"returnsNotAcceptedMarketplaceSupportNoLink": "Questions or concerns about your online purchase? Our Marketplace Support Team is here to help.",
	"tradeReturns": {
		"pdp": {
			"returnsAccepted": "Exclusive: As a member of our trade program, you have an additional 7 days to return this item.",
			"cannotBeReturned": "Exclusive: As a member of our trade program, you may initiate a return of this item within 7 days of delivery."
		},
		"shippingModal": {
			"returnsAccepted": "<p>Returns can be initiated within 7 days of delivery by contacting 1stdibs.  You are responsible for the unsubsidized cost of return shipping for this item, which may be significantly higher than the cost to have the item shipped to you.</p><p>Exclusive: As a member of our trade program, you have an additional 7 days to return this item. Your extended return period is valid only on shipments within the U.S. and a 10% restocking fee applies during this period. <a href='https://www.1stdibs.com/trade/returns/' target='_blank'>Learn more</a></p>",
			"cannotBeReturned": "<p>Exclusive: While this dealer does not typically accept returns, as a member of our trade program, you may initiate a return of this item within 7 days of delivery by contacting 1stdibs.</p><p>You are responsible for the unsubsidized cost of return shipping for this item, which may be significantly higher than the cost to have the item shipped to you. Your exclusive return period is valid only on shipments within the U.S. and a 10% restocking fee applies. <a href='https://www.1stdibs.com/trade/returns/' target='_blank'>Learn more</a></p>"
		},
		"buyerAssuranceTooltip": ""
	}
};

/***/ }),
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(3),
    history = _require.history;

var GalleryRouter = __webpack_require__(1155);

var GalleryStore = __webpack_require__(357);
var GalleryModalStore = __webpack_require__(548);

var galleryActions = __webpack_require__(363);
var galleryModalActions = __webpack_require__(512);

var GalleryModalRouter = GalleryRouter.extend({
    stores: [GalleryStore, GalleryModalStore],

    initialize: function initialize() {
        var _this = this;

        this.route(history.getFragment(), function () {
            return _this._hideModal();
        });
        GalleryRouter.prototype.initialize.apply(this, arguments);
    },
    getPropsFromStores: function getPropsFromStores(galleryStore, galleryModalStore) {
        var props = {};

        // sets route to original url
        if (galleryModalStore.hasOpened() && galleryModalStore.isHidden()) {
            props.route = galleryModalStore.getOriginalUrl();

            // sets route to photo url
        } else if (!galleryModalStore.isHidden()) {
            props.route = galleryStore.getCurrentPhotoUrl();
        }
        return props;
    },


    /**
     * Route Handler - executes action to set photo
     *  (invoked mostly when the user hits the back button)
     */
    _setPhoto: function _setPhoto(urlLabel, rootId) {
        var galleryStore = this.context.getStore(GalleryStore);
        var url = galleryStore.buildPhotoUrl({ urlLabel: urlLabel, rootId: rootId });

        if (url && typeof galleryStore.getPhotoByUrl(url) !== 'undefined') {

            // If Photo url exists, set url
            this.context.executeAction(galleryActions.setPhoto, { url: url });
            this.context.executeAction(galleryModalActions.showModal);
        } else {

            // Else refresh b/c navigating to photo URL outside of current gallery
            this.refresh();
        }
    },


    /**
     * Route Handler - executes action to hide the modal
     *  (invoked mostly when the user hits the back button from the modal)
     */
    _hideModal: function _hideModal() {
        if (!this.context.getStore(GalleryModalStore).isHidden()) {
            this.context.executeAction(galleryModalActions.hideModal);
        }
    }
});

module.exports = GalleryModalRouter;

/***/ }),
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1621);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(7);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1600);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1607);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1599);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(18);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(11);

var _component2 = _interopRequireDefault(_component);

var _enhancers = __webpack_require__(12);

var _enhancers2 = _interopRequireDefault(_enhancers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _enhancers2.default)(_component2.default);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CallDealerForm = function (_PureComponent) {
    _inherits(CallDealerForm, _PureComponent);

    function CallDealerForm(props) {
        _classCallCheck(this, CallDealerForm);

        var _this = _possibleConstructorReturn(this, (CallDealerForm.__proto__ || Object.getPrototypeOf(CallDealerForm)).call(this, props));

        _this.onNameChange = _this.onNameChange.bind(_this);
        _this.onPhoneNumberChange = _this.onPhoneNumberChange.bind(_this);
        _this.onCountryCodeChange = _this.onCountryCodeChange.bind(_this);
        _this.onFormSubmit = _this.onFormSubmit.bind(_this);
        return _this;
    }

    _createClass(CallDealerForm, [{
        key: 'onNameChange',
        value: function onNameChange(e) {
            this.props.setName(e.target.value);
        }
    }, {
        key: 'onPhoneNumberChange',
        value: function onPhoneNumberChange(e) {
            this.props.setPhoneNumber(e.target.value);
        }
    }, {
        key: 'onCountryCodeChange',
        value: function onCountryCodeChange(e) {
            this.props.setCountryCode(e.target.value);
        }
    }, {
        key: 'onFormSubmit',
        value: function onFormSubmit(e) {
            e.preventDefault();
            this.props.onSubmit();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                showNameField = _props.showNameField,
                name = _props.name,
                phoneNumber = _props.phoneNumber,
                countryCode = _props.countryCode,
                submitting = _props.submitting,
                error = _props.error,
                copy = _props.copy,
                theme = _props.theme;


            var submitDisabled = submitting || !name && showNameField || !phoneNumber || !countryCode;

            return _react2.default.createElement(
                'form',
                { className: theme.form, onSubmit: this.onFormSubmit },
                error ? _react2.default.createElement(
                    'div',
                    { className: theme.error },
                    error
                ) : null,
                _react2.default.createElement(
                    'p',
                    null,
                    copy('callDealerFormHeading')
                ),
                _react2.default.createElement(
                    'div',
                    { className: theme.inputsRow },
                    _react2.default.createElement(
                        'label',
                        { className: theme.countryCode },
                        _react2.default.createElement(
                            'div',
                            null,
                            copy('inputLabelCountryCode')
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: theme.plusSign },
                                '+'
                            ),
                            _react2.default.createElement('input', {
                                type: 'text',
                                className: theme.input,
                                value: countryCode,
                                disabled: submitting,
                                onChange: this.onCountryCodeChange
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'label',
                        { className: theme.phoneNumber },
                        _react2.default.createElement(
                            'div',
                            null,
                            copy('inputLabelPhoneNumber')
                        ),
                        _react2.default.createElement('input', {
                            type: 'tel',
                            className: theme.input,
                            value: phoneNumber,
                            disabled: submitting,
                            onChange: this.onPhoneNumberChange
                        })
                    )
                ),
                showNameField ? _react2.default.createElement(
                    'div',
                    { className: theme.inputsRow },
                    _react2.default.createElement(
                        'label',
                        { className: theme.name },
                        _react2.default.createElement(
                            'div',
                            null,
                            copy('inputLabelName')
                        ),
                        _react2.default.createElement('input', {
                            type: 'text',
                            className: theme.input,
                            value: name,
                            disabled: submitting,
                            onChange: this.onNameChange
                        })
                    )
                ) : null,
                _react2.default.createElement(
                    'button',
                    {
                        type: 'submit',
                        className: theme.submit,
                        disabled: submitDisabled
                    },
                    copy('submitInitiateCall')
                ),
                _react2.default.createElement(
                    'p',
                    { className: theme.footer },
                    copy('callDealerFormFooter')
                )
            );
        }
    }]);

    return CallDealerForm;
}(_react.PureComponent);

var requiredString = _propTypes2.default.string.isRequired;
CallDealerForm.propTypes = {
    showNameField: _propTypes2.default.bool,
    name: _propTypes2.default.string,
    phoneNumber: _propTypes2.default.string,
    countryCode: _propTypes2.default.string,
    error: _propTypes2.default.string,
    submitting: _propTypes2.default.bool,
    setName: _propTypes2.default.func.isRequired,
    setPhoneNumber: _propTypes2.default.func.isRequired,
    setCountryCode: _propTypes2.default.func.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,
    copy: _propTypes2.default.func.isRequired,
    theme: _propTypes2.default.shape({
        form: requiredString,
        countryCode: requiredString,
        phoneNumber: requiredString,
        name: requiredString,
        input: requiredString,
        inputsRow: requiredString,
        submit: requiredString,
        footer: requiredString,
        error: requiredString
    })
};

exports.default = CallDealerForm;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeHOC = exports.copyHOC = undefined;

var _compose = __webpack_require__(3);

var _compose2 = _interopRequireDefault(_compose);

var _withProps = __webpack_require__(4);

var _withProps2 = _interopRequireDefault(_withProps);

var _copier = __webpack_require__(0);

var _copier2 = _interopRequireDefault(_copier);

var _copy = __webpack_require__(21);

var _copy2 = _interopRequireDefault(_copy);

var _styles = __webpack_require__(18);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyHOC = exports.copyHOC = (0, _copier2.default)({ copy: _copy2.default });
var themeHOC = exports.themeHOC = (0, _withProps2.default)({ theme: _styles2.default });
exports.default = (0, _compose2.default)(themeHOC, copyHOC);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.themeHOC = exports.copyHOC = undefined;

var _enhancers = __webpack_require__(9);

Object.defineProperty(exports, 'copyHOC', {
  enumerable: true,
  get: function get() {
    return _enhancers.copyHOC;
  }
});
Object.defineProperty(exports, 'themeHOC', {
  enumerable: true,
  get: function get() {
    return _enhancers.themeHOC;
  }
});

var _component = __webpack_require__(8);

var _component2 = _interopRequireDefault(_component);

var _enhancers2 = _interopRequireDefault(_enhancers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = exports.Component = _component2.default;
exports.default = (0, _enhancers2.default)(_component2.default);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CallDealerForm = __webpack_require__(10);

var _CallDealerForm2 = _interopRequireDefault(_CallDealerForm);

var _CallInitiatedSuccess = __webpack_require__(15);

var _CallInitiatedSuccess2 = _interopRequireDefault(_CallInitiatedSuccess);

var _dibsComModal = __webpack_require__(24);

var _tracking = __webpack_require__(17);

var tracking = _interopRequireWildcard(_tracking);

var _lodash = __webpack_require__(5);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(25);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultCountryCode = '1';
var numbersOnlyRegex = /^\d+$/;
var containsLettersRegex = /[a-z]/i;

var initialState = function initialState(props) {
    var name = (0, _lodash2.default)(props.viewer, 'user.profile.displayName') || '';
    var saveName = !name;
    var existingPhone = !!(0, _lodash2.default)(props.viewer, 'primaryPhone.isActive');
    var savePhoneNumber = !existingPhone;
    var countryCode = defaultCountryCode;
    var phoneNumber = '';

    if (existingPhone) {
        countryCode = (0, _lodash2.default)(props.viewer, 'primaryPhone.countryCodeNumber');
        phoneNumber = (0, _lodash2.default)(props.viewer, 'primaryPhone.formattedPhoneNumber');
    }

    return {
        name: name,
        countryCode: countryCode,
        phoneNumber: phoneNumber,
        saveName: saveName,
        savePhoneNumber: savePhoneNumber,
        submitting: false,
        success: false,
        error: undefined
    };
};

var resetForm = function resetForm() {
    return { submitting: false };
};
var resetSuccess = function resetSuccess() {
    return { success: false };
};
var submitForm = function submitForm() {
    return { submitting: true, error: undefined };
};
var submitSuccess = function submitSuccess() {
    return {
        success: true,
        submitting: false,
        saveName: false,
        savePhoneNumber: false
    };
};

var updateName = function updateName(name) {
    return function () {
        return { name: name, saveName: true, error: undefined };
    };
};
var updateCountryCode = function updateCountryCode(countryCode) {
    return function () {
        return { countryCode: countryCode, savePhoneNumber: true, error: undefined };
    };
};
var updatePhoneNumber = function updatePhoneNumber(phoneNumber) {
    return function () {
        return { phoneNumber: phoneNumber, savePhoneNumber: true, error: undefined };
    };
};
var setErrorMessage = function setErrorMessage(error) {
    return function () {
        return { error: error, submitting: false };
    };
};

var CallDealerModal = function (_PureComponent) {
    _inherits(CallDealerModal, _PureComponent);

    function CallDealerModal(props) {
        _classCallCheck(this, CallDealerModal);

        var _this = _possibleConstructorReturn(this, (CallDealerModal.__proto__ || Object.getPrototypeOf(CallDealerModal)).call(this, props));

        _this.state = initialState(props);

        if (!props.userId && !props.onAuthRequired) {
            throw new Error('No userId prop given. Must have a handler for when auth is then required.');
        }
        if (props.isOpened && props.location) {
            tracking.onCallModalOpen(props.location);
        }

        _this.initiateCall = _this.initiateCall.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onFailure = _this.onFailure.bind(_this);
        return _this;
    }

    _createClass(CallDealerModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.props.isOpened && nextProps.isOpened && nextProps.location) {
                tracking.onCallModalOpen(nextProps.location);
            }
        }
    }, {
        key: 'initiateCall',
        value: function initiateCall(buyerId) {
            var item = this.props.item;
            var _state = this.state,
                name = _state.name,
                phoneNumber = _state.phoneNumber,
                countryCode = _state.countryCode,
                saveName = _state.saveName,
                savePhoneNumber = _state.savePhoneNumber;

            this.props.onSubmit({ buyerId: buyerId, name: name, phoneNumber: phoneNumber, countryCode: countryCode, item: item, saveName: saveName, savePhoneNumber: savePhoneNumber }, { onSuccess: this.onSuccess, onFailure: this.onFailure });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            var _this2 = this;

            var _props = this.props,
                userId = _props.userId,
                copy = _props.copy,
                location = _props.location,
                onAuthRequired = _props.onAuthRequired;
            var _state2 = this.state,
                phoneNumber = _state2.phoneNumber,
                countryCode = _state2.countryCode;


            var invalidCountryCode = !numbersOnlyRegex.test(countryCode);
            var invalidPhoneNumber = containsLettersRegex.test(phoneNumber);

            if (invalidCountryCode || invalidPhoneNumber) {
                this.setState(setErrorMessage(copy('invalidInput')));
                return;
            }

            this.setState(submitForm);

            if (location) {
                tracking.onCallModalSubmitted(location);
            }
            if (!userId) {
                onAuthRequired(this.initiateCall, function () {
                    return _this2.setState(resetForm);
                } // if auth fails
                );
                return;
            }

            this.initiateCall(userId);
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess(_ref) {
            var initiateCall = _ref.initiateCall;
            var success = initiateCall.success,
                errors = initiateCall.errors;
            var copy = this.props.copy;


            if (success) {
                this.setState(submitSuccess);
                if (location) {
                    tracking.onCallModalSuccess(location);
                }
            } else if (errors && errors.length) {
                this.setState(setErrorMessage(errors[0].message));
            } else {
                this.setState(setErrorMessage(copy('unknownServiceError')));
            }
        }
    }, {
        key: 'onFailure',
        value: function onFailure() {
            var copy = this.props.copy;

            this.setState(setErrorMessage(copy('unknownServiceError')));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                isOpened = _props2.isOpened,
                item = _props2.item,
                copy = _props2.copy,
                theme = _props2.theme,
                onFollowDealer = _props2.onFollowDealer;

            var dealerName = (0, _lodash2.default)(item, 'seller.sellerProfile.company') || 'Dealer';
            var dealerLocation = (0, _lodash2.default)(item, 'seller.shippingAddress.displayCityStateCountry');

            var header = void 0;
            var prompt = void 0;
            if (this.state.success) {
                header = copy('modalSuccessHeader');
                prompt = _react2.default.createElement(_CallInitiatedSuccess2.default, { onFollowDealer: onFollowDealer });
            } else {
                var headerCopy = copy('modalFormHeader', { dealerName: dealerName });
                header = dealerLocation ? _react2.default.createElement(
                    'span',
                    null,
                    headerCopy,
                    _react2.default.createElement(
                        'span',
                        { className: theme.subheader },
                        copy('modalFormSubheader', { dealerLocation: dealerLocation })
                    )
                ) : headerCopy;

                prompt = _react2.default.createElement(_CallDealerForm2.default, {
                    showNameField: this.state.saveName,
                    name: this.state.name,
                    phoneNumber: this.state.phoneNumber,
                    countryCode: this.state.countryCode,
                    submitting: this.state.submitting,
                    error: this.state.error,
                    setName: function setName(name) {
                        return _this3.setState(updateName(name));
                    },
                    setPhoneNumber: function setPhoneNumber(phoneNumber) {
                        return _this3.setState(updatePhoneNumber(phoneNumber));
                    },
                    setCountryCode: function setCountryCode(countryCode) {
                        return _this3.setState(updateCountryCode(countryCode));
                    },
                    onSubmit: this.onSubmit
                });
            }

            return _react2.default.createElement(
                _dibsComModal.Modal,
                {
                    wrapperClass: theme.wrapper,
                    isOpened: isOpened,
                    closeModal: function closeModal() {
                        _this3.setState(resetSuccess);
                        _this3.props.onClose();
                    }
                },
                _react2.default.createElement(
                    _dibsComModal.Header,
                    { headerClass: theme.header },
                    header
                ),
                prompt
            );
        }
    }]);

    return CallDealerModal;
}(_react.PureComponent);

var requiredString = _propTypes2.default.string.isRequired;
CallDealerModal.propTypes = {
    userId: _propTypes2.default.string,
    isOpened: _propTypes2.default.bool,
    onFollowDealer: _propTypes2.default.func.isRequired,
    onClose: _propTypes2.default.func.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,
    onAuthRequired: _propTypes2.default.func,
    viewer: _propTypes2.default.object,
    item: _propTypes2.default.object,
    location: _propTypes2.default.oneOf(['pdp', 'storefront', 'mc', 'mcEmail']),
    copy: _propTypes2.default.func.isRequired,
    theme: _propTypes2.default.shape({
        wrapper: requiredString,
        header: requiredString,
        subheader: requiredString
    })
};

exports.default = CallDealerModal;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handlersHOC = exports.relayHOC = exports.themeHOC = exports.copyHOC = undefined;

var _reactRelay = __webpack_require__(6);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _compose = __webpack_require__(3);

var _compose2 = _interopRequireDefault(_compose);

var _withProps = __webpack_require__(4);

var _withProps2 = _interopRequireDefault(_withProps);

var _hoistStatics = __webpack_require__(28);

var _hoistStatics2 = _interopRequireDefault(_hoistStatics);

var _copier = __webpack_require__(0);

var _copier2 = _interopRequireDefault(_copier);

var _copy = __webpack_require__(22);

var _copy2 = _interopRequireDefault(_copy);

var _styles = __webpack_require__(19);

var _styles2 = _interopRequireDefault(_styles);

var _InitiateCall = __webpack_require__(16);

var _InitiateCall2 = _interopRequireDefault(_InitiateCall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyHOC = exports.copyHOC = (0, _copier2.default)({ copy: _copy2.default });
var themeHOC = exports.themeHOC = (0, _withProps2.default)({ theme: _styles2.default });

var relayHOC = exports.relayHOC = function relayHOC(BaseComponent) {
    return _reactRelay2.default.createContainer(BaseComponent, {
        initialVariables: {
            userId: null,
            hasUserId: false
        },
        fragments: {
            item: function item() {
                return function (RQL_0) {
                    return {
                        children: [].concat.apply([], [{
                            children: [{
                                children: [{
                                    fieldName: 'company',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'sellerProfile',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'SellerProfile'
                            }, {
                                children: [{
                                    fieldName: 'displayCityStateCountry',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'shippingAddress',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id'
                                },
                                type: 'Address'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'seller',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'Seller'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, _reactRelay2.default.QL.__frag(RQL_0)]),
                        id: _reactRelay2.default.QL.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Enhancers_ItemRelayQL',
                        type: 'Item'
                    };
                }(_InitiateCall2.default.getFragment('item'));
            },
            viewer: function viewer() {
                return function () {
                    return {
                        children: [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [{
                                children: [{
                                    fieldName: 'displayName',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'profile',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'Profile'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'user',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'User'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [{
                                fieldName: 'countryCodeNumber',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'formattedPhoneNumber',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                alias: 'isActive',
                                calls: [{
                                    kind: 'Call',
                                    metadata: {},
                                    name: 'status',
                                    value: {
                                        kind: 'CallValue',
                                        callValue: 'ACTIVE'
                                    }
                                }],
                                fieldName: 'hasStatus',
                                kind: 'Field',
                                metadata: {},
                                type: 'Boolean'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'primaryPhone',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'Phone'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: _reactRelay2.default.QL.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Enhancers_ViewerRelayQL',
                        type: 'Viewer'
                    };
                }();
            }
        }
    });
};

var handlersHOC = exports.handlersHOC = (0, _withProps2.default)(function (ownProps) {
    return {
        onSubmit: function onSubmit(props, handlers) {
            return ownProps.relay.commitUpdate(new _InitiateCall2.default(props), handlers);
        }
    };
});

exports.default = (0, _hoistStatics2.default)((0, _compose2.default)(relayHOC, handlersHOC, themeHOC, copyHOC));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arrowRight = __webpack_require__(27);

var _arrowRight2 = _interopRequireDefault(_arrowRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CallInitiatedSuccess = function CallInitiatedSuccess(props) {
    var copy = props.copy,
        theme = props.theme,
        onFollowDealer = props.onFollowDealer,
        conversationLinkHref = props.conversationLinkHref;

    return _react2.default.createElement(
        'div',
        { className: theme.prompt },
        _react2.default.createElement(
            'p',
            null,
            copy('callSuccessHeading')
        ),
        _react2.default.createElement(
            'p',
            null,
            copy('callSuccessSubheading'),
            _react2.default.createElement(
                'a',
                {
                    href: conversationLinkHref,
                    className: theme.conversationsLink
                },
                copy('conversationsLink'),
                _react2.default.createElement(_arrowRight2.default, { className: theme.arrowRight })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: theme.followDealer },
            _react2.default.createElement(
                'p',
                { className: theme.followDealerNotice },
                copy('followDealerHeading')
            ),
            _react2.default.createElement(
                'p',
                null,
                copy('followDealerBody')
            )
        ),
        _react2.default.createElement(
            'button',
            {
                className: theme.submitFollowDealer,
                onClick: onFollowDealer
            },
            copy('followDealer')
        )
    );
};

var requiredString = _propTypes2.default.string.isRequired;
CallInitiatedSuccess.propTypes = {
    conversationLinkHref: _propTypes2.default.string,
    onFollowDealer: _propTypes2.default.func,
    copy: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
        arrowRight: requiredString,
        conversationsLink: requiredString,
        followDealer: requiredString,
        followDealerNotice: requiredString,
        prompt: requiredString,
        submitFollowDealer: requiredString
    })
};
CallInitiatedSuccess.defaultProps = {
    conversationLinkHref: '/my/conversations/',
    onFollowDealer: function onFollowDealer() {}
};

exports.default = CallInitiatedSuccess;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeHOC = exports.copyHOC = undefined;

var _compose = __webpack_require__(3);

var _compose2 = _interopRequireDefault(_compose);

var _withProps = __webpack_require__(4);

var _withProps2 = _interopRequireDefault(_withProps);

var _copier = __webpack_require__(0);

var _copier2 = _interopRequireDefault(_copier);

var _copy = __webpack_require__(23);

var _copy2 = _interopRequireDefault(_copy);

var _styles = __webpack_require__(20);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyHOC = exports.copyHOC = (0, _copier2.default)({ copy: _copy2.default });
var themeHOC = exports.themeHOC = (0, _withProps2.default)({ theme: _styles2.default });
exports.default = (0, _compose2.default)(themeHOC, copyHOC);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.component = exports.themeHOC = exports.copyHOC = undefined;

var _enhancers = __webpack_require__(14);

Object.defineProperty(exports, 'copyHOC', {
  enumerable: true,
  get: function get() {
    return _enhancers.copyHOC;
  }
});
Object.defineProperty(exports, 'themeHOC', {
  enumerable: true,
  get: function get() {
    return _enhancers.themeHOC;
  }
});

var _component = __webpack_require__(13);

var _component2 = _interopRequireDefault(_component);

var _enhancers2 = _interopRequireDefault(_enhancers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var component = exports.component = _component2.default;
exports.default = (0, _enhancers2.default)(_component2.default);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRelay = __webpack_require__(6);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _lodash = __webpack_require__(5);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InitiateCall = function (_Relay$Mutation) {
    _inherits(InitiateCall, _Relay$Mutation);

    function InitiateCall() {
        _classCallCheck(this, InitiateCall);

        return _possibleConstructorReturn(this, (InitiateCall.__proto__ || Object.getPrototypeOf(InitiateCall)).apply(this, arguments));
    }

    _createClass(InitiateCall, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'initiateCall',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'InitiateCallInput!'
                    },
                    name: 'InitiateCall',
                    responseType: 'InitiateCallPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            var _props = this.props,
                buyerId = _props.buyerId,
                name = _props.name,
                phoneNumber = _props.phoneNumber,
                countryCode = _props.countryCode,
                item = _props.item,
                saveName = _props.saveName,
                savePhoneNumber = _props.savePhoneNumber;


            return {
                buyerId: buyerId,
                saveName: saveName,
                savePhoneNumber: savePhoneNumber,
                buyerName: name,
                // strip out non-numeric characters
                buyerNumber: phoneNumber.replace(/\D/g, ''),
                buyerCountryCode: countryCode,
                itemId: (0, _lodash2.default)(item, 'serviceId'),
                itemName: (0, _lodash2.default)(item, 'title'),
                dealerId: (0, _lodash2.default)(item, 'seller.serviceId')
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        fieldName: 'success',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        children: [{
                            fieldName: 'message',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }],
                        fieldName: 'errors',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isPlural: true
                        },
                        type: 'GraphQLError'
                    }],
                    id: _reactRelay2.default.QL.__id(),
                    kind: 'Fragment',
                    metadata: {
                        pattern: true
                    },
                    name: 'InitiateCall_ValueRelayQL',
                    type: 'InitiateCallPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'REQUIRED_CHILDREN',
                children: [function () {
                    return {
                        children: [{
                            fieldName: 'success',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                fieldName: 'message',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'errors',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'GraphQLError'
                        }],
                        id: _reactRelay2.default.QL.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'InitiateCall_ChildrenRelayQL',
                        type: 'InitiateCallPayload'
                    };
                }()]
            }];
        }
    }]);

    return InitiateCall;
}(_reactRelay2.default.Mutation);

exports.default = InitiateCall;


InitiateCall.fragments = {
    item: function item() {
        return function () {
            return {
                children: [{
                    fieldName: 'serviceId',
                    kind: 'Field',
                    metadata: {},
                    type: 'ID'
                }, {
                    fieldName: 'title',
                    kind: 'Field',
                    metadata: {},
                    type: 'String'
                }, {
                    children: [{
                        fieldName: 'serviceId',
                        kind: 'Field',
                        metadata: {},
                        type: 'ID'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    fieldName: 'seller',
                    kind: 'Field',
                    metadata: {
                        canHaveSubselections: true,
                        inferredRootCallName: 'node',
                        inferredPrimaryKey: 'id'
                    },
                    type: 'Seller'
                }, {
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                        isGenerated: true,
                        isRequisite: true
                    },
                    type: 'ID'
                }],
                id: _reactRelay2.default.QL.__id(),
                kind: 'Fragment',
                metadata: {},
                name: 'InitiateCall_ItemRelayQL',
                type: 'Item'
            };
        }();
    }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onCallModalSuccess = exports.onCallModalSubmitted = exports.onCallModalOpen = undefined;

var _dibsTracking = __webpack_require__(26);

var _dibsTracking2 = _interopRequireDefault(_dibsTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackingCategory = 'call dealer';
var locationLabels = {
    pdp: 'more from dealer',
    storefront: 'dealer storefront',
    mc: 'my conversations',
    mcEmail: 'my conversations - via email'
};

var onCallModalOpen = exports.onCallModalOpen = function onCallModalOpen(location) {
    _dibsTracking2.default.trackEvent({
        category: trackingCategory,
        action: 'call dealer clicked',
        label: locationLabels[location]
    });
};

var onCallModalSubmitted = exports.onCallModalSubmitted = function onCallModalSubmitted(location) {
    _dibsTracking2.default.trackEvent({
        category: trackingCategory,
        action: 'call dealer initiate clicked',
        label: locationLabels[location]
    });
};

var onCallModalSuccess = exports.onCallModalSuccess = function onCallModalSuccess(location) {
    _dibsTracking2.default.trackEvent({
        category: trackingCategory,
        action: 'call dealer initiated',
        label: locationLabels[location]
    });
};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form":"styles__form__10tVq","inputsRow":"styles__inputsRow__1YOqQ","input":"styles__input__2WqAG","countryCode":"styles__countryCode__1RnK2","phoneNumber":"styles__phoneNumber__3Nufi","name":"styles__name__cTD9K","plusSign":"styles__plusSign__1CIQ-","submit":"styles__submit__1r3ey","footer":"styles__footer__1mQQh","error":"styles__error__1N_-4"};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"styles__wrapper__to8CF","header":"styles__header__22Xjq","subheader":"styles__subheader__9_v4Z"};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"prompt":"styles__prompt__1g8h1","followDealer":"styles__followDealer__3Iksg","arrowRight":"styles__arrowRight__2FaS7","conversationsLink":"styles__conversationsLink__3KEoK","followDealerNotice":"styles__followDealerNotice__1_ren","submitFollowDealer":"styles__submitFollowDealer__EsdVy"};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = {
	"callDealerFormHeading": "Enter your preferred number. Your phone will ring momentarily, connecting you to the dealer.",
	"callDealerFormFooter": "Your direct number will not be shared with the dealer.",
	"inputLabelCountryCode": "Country Code",
	"inputLabelPhoneNumber": "Your Number",
	"inputLabelName": "Your Name",
	"submitInitiateCall": "Initiate Call"
};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = {
	"modalFormHeader": "Call <%= dealerName %>",
	"modalFormSubheader": "Located in <%= dealerLocation %>",
	"modalSuccessHeader": "Call Initiated",
	"unknownServiceError": "Unknown error occurred. Please try again later",
	"invalidInput": "Phone number format is invalid. Include a country code and the correct number of digits."
};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = {
	"callSuccessHeading": "Your phone will ring momentarily, connecting you with the dealer.",
	"callSuccessSubheading": "You can also message the dealer in ",
	"conversationsLink": "My Conversations",
	"followDealerHeading": "Stay Up-to-Date",
	"followDealerBody": "Follow to get weekly email alerts with new arrivals from this dealer",
	"followDealer": "Follow Dealer"
};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(591);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(730);

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(351);

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1602);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CallDealerModal = __webpack_require__(7);

Object.defineProperty(exports, 'CallDealerModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CallDealerModal).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })
/******/ ]);

/***/ }),
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * User: daletan
 * Date: 1/15/16
 * Time: 5:56 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */



var _require = __webpack_require__(379),
    trackEmailFriend = _require.trackEmailFriend;

var ModalEmail = __webpack_require__(1186);
var contactDealerLauncher = __webpack_require__(638);
var netPriceLauncher = __webpack_require__(957);
var bunsenAssert = __webpack_require__(31);
var dibsVerticals = __webpack_require__(373);
var PurchaseTracking = __webpack_require__(458);

var launchModalEmail = function launchModalEmail() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // TODO: Currently, if we cache the modal instead of re-creating it each time, the modal will not work after
    // the first open. This modal should ultimately be refactored to fix this issue and then we can re-use it here.
    var emailModal = new ModalEmail({
        type: 'friend',
        pageType: 'item'
    });
    bunsenAssert(payload.id && payload.vertical, 'both payload.id and payload.vertical are required');
    emailModal.show(payload);
};

var launchContactDealer = function launchContactDealer(actionContext, payload) {
    var itemPk = payload.itemPk,
        dealerPk = payload.dealerPk,
        currentStep = payload.currentStep,
        handleCtaClick = payload.handleCtaClick,
        linkLocation = payload.tracking,
        modalContentData = payload.modalContentData;

    contactDealerLauncher({
        context: actionContext,
        itemPk: itemPk,
        linkLocation: linkLocation,
        dealerPk: dealerPk,
        currentStep: currentStep,
        handleCtaClick: handleCtaClick,
        modalContentData: modalContentData
    });
};

var trackNetPriceClick = function trackNetPriceClick(purchaseTracking) {
    if (purchaseTracking) {
        purchaseTracking.trackNetPriceEvent({
            actionSuffix: 'clicked-amppage'
        });
    }
};

var launchRequestNetPrice = function launchRequestNetPrice(actionContext, payload) {
    var item = payload.item,
        itemPk = payload.itemPk,
        currency = payload.currency,
        linkLocation = payload.tracking;

    var purchaseTracking = new PurchaseTracking({ item: item, pageContext: linkLocation.pageContext });
    trackNetPriceClick(purchaseTracking);
    netPriceLauncher({
        context: actionContext,
        itemPk: itemPk,
        purchaseTracking: purchaseTracking,
        linkLocation: linkLocation,
        item: item,
        currency: currency
    });
};

// need to keep this variable reference
// otherwise Fluxible context will see `this` this as undefined
var modals = module.exports = {
    stf: function stf(actionContext, payload, done) {
        // calling "private" property so can be spied on in tests
        var id = payload.id,
            vertical = payload.vertical,
            itemPk = payload.itemPk;

        var realFuckingId = id;
        if (dibsVerticals.testForPk(id)) {
            // fucking pk/id strikes again!
            realFuckingId = id.substring(2);
        }
        modals._stf({ id: realFuckingId, vertical: vertical });
        actionContext.executeAction(trackEmailFriend, { itemPk: itemPk });
        done();
    },
    contactDealer: function contactDealer(actionContext, payload, done) {
        // FINDING-7331 This method is for an optimizely variant to make the contact dealer modal
        //              appear from clicking on a cta in the sidebar. Remove this code if the
        //              variant is removed. Alternatively, remove this comment if the variant
        //              becomes permanent.
        // calling "private" property so can be spied on in tests
        modals._dealer(actionContext, payload);
        done();
    },
    netPrice: function netPrice(actionContext, payload, done) {
        modals._netPrice(actionContext, payload);
        done();
    },

    _dealer: launchContactDealer,
    _stf: launchModalEmail,
    _netPrice: launchRequestNetPrice
};

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var GridBase = function (_React$Component) {
    _inherits(GridBase, _React$Component);

    function GridBase() {
        _classCallCheck(this, GridBase);

        return _possibleConstructorReturn(this, (GridBase.__proto__ || Object.getPrototypeOf(GridBase)).apply(this, arguments));
    }

    _createClass(GridBase, [{
        key: '_getHeader',
        value: function _getHeader() {
            return null;
        }
    }, {
        key: '_getItems',
        value: function _getItems() {
            return null;
        }
    }, {
        key: '_getViewAll',
        value: function _getViewAll() {
            return null;
        }
    }, {
        key: '_setQuickViewId',
        value: function _setQuickViewId(id) {
            this.setState({
                quickViewItemId: id
            });
        }
    }, {
        key: '_renderGrid',
        value: function _renderGrid() {
            return React.createElement(
                'div',
                null,
                this._getHeader(),
                React.createElement(
                    'div',
                    { className: 'rowFlex' },
                    this._getItems()
                ),
                this._getViewAll()
            );
        }
    }, {
        key: '_renderDarkGrid',
        value: function _renderDarkGrid() {
            return React.createElement(
                'div',
                { className: 'pdp-grid-dark' },
                React.createElement(
                    'div',
                    { className: 'pdp-grid-dark-inner' },
                    this._renderGrid()
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var items = this._getItems();
            var grid = this.props.darkGrid ? this._renderDarkGrid() : this._renderGrid();
            // Only render if there are items to display.
            if (!items.length) {
                return null;
            }

            return grid;
        }
    }]);

    return GridBase;
}(React.Component);

GridBase.propTypes = {
    darkGrid: PropTypes.bool
};

GridBase.defaultProps = {
    darkGrid: false
};

GridBase.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func
};

module.exports = GridBase;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var tokenReplace = __webpack_require__(75);

function GridHeader(_ref) {
    var type = _ref.type,
        title = _ref.title;

    var headerCopy = type ? tokenReplace(title, { type: type }) : title;

    return React.createElement(
        'h2',
        { className: 'pdp-grid-header' },
        headerCopy
    );
}

GridHeader.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string
};

module.exports = GridHeader;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classNames = __webpack_require__(16);
var LazyLoad = __webpack_require__(738).default;

var _require = __webpack_require__(379),
    trackGridProductClick = _require.trackGridProductClick,
    trackGridProductImpressions = _require.trackGridProductImpressions;

var screenSize = __webpack_require__(365);

var QuickViewButton = __webpack_require__(1799);
var QuickView = __webpack_require__(1283);

var CarouselItem = __webpack_require__(896);

var GridItem = function (_React$Component) {
    _inherits(GridItem, _React$Component);

    function GridItem(props) {
        _classCallCheck(this, GridItem);

        var _this = _possibleConstructorReturn(this, (GridItem.__proto__ || Object.getPrototypeOf(GridItem)).call(this, props));

        _this.state = {
            itemLoaded: false,
            imageHeightChanged: false
        };

        _this._handleClick = _this._handleClick.bind(_this);
        _this._showInfo = _this._showInfo.bind(_this);
        _this._hideInfo = _this._hideInfo.bind(_this);
        _this._imageVisible = _this._imageVisible.bind(_this);
        return _this;
    }

    _createClass(GridItem, [{
        key: '_handleClick',
        value: function _handleClick() {
            if (this.context.executeAction) {
                this.context.executeAction(trackGridProductClick, {
                    product: this.props,
                    gridType: this.props.gridType
                });
            }
            if (this.props.onProductClick) {
                this.props.onProductClick(this.props); //using this.props as the full product since fields were destructured
            }
        }
    }, {
        key: '_handleImpression',
        value: function _handleImpression() {
            if (this.context.executeAction) {
                this.context.executeAction(trackGridProductImpressions, {
                    product: this.props,
                    gridType: this.props.gridType
                });
            }
        }
    }, {
        key: '_showInfo',
        value: function _showInfo() {
            this.props.setQuickViewId(this.props.id);
        }
    }, {
        key: '_hideInfo',
        value: function _hideInfo() {
            this.props.setQuickViewId(null);
        }
    }, {
        key: '_renderQuickView',
        value: function _renderQuickView(isQuickViewOpen) {
            var _props = this.props,
                attributes = _props.attributes,
                creators = _props.creators,
                description = _props.description,
                location = _props.location,
                materials = _props.materials,
                seller = _props.seller,
                title = _props.title,
                uri = _props.uri;

            var sellerName = void 0;
            if (typeof seller === 'string') {
                sellerName = seller;
            } else if (seller && seller.company) {
                sellerName = seller.company;
            }
            var quickView = React.createElement(QuickView, _extends({}, this.props, {
                onClose: this._hideInfo,
                isActive: isQuickViewOpen,
                attributes: attributes,
                creators: creators,
                description: description,
                location: location,
                materials: materials,
                seller: sellerName,
                title: title,
                uri: uri
            }));
            var quickViewButton = React.createElement(
                'div',
                { className: 'pdp-grid-quick-view-button' },
                React.createElement(QuickViewButton, { onClick: this._showInfo })
            );

            if (!this.props.quickView) {
                quickView = null;
                quickViewButton = null;
            } else if (isQuickViewOpen) {
                quickViewButton = null;
            }

            return React.createElement(
                'div',
                null,
                quickViewButton,
                quickView
            );
        }
    }, {
        key: '_setHeight',
        value: function _setHeight() {
            // LazyLoad height when it has no content
            var size = 240;

            if (screenSize.isMobile()) {
                size = 133;
            } else if (screenSize.isTablet()) {
                size = 189;
            }

            return size;
        }
    }, {
        key: '_setHeightState',
        value: function _setHeightState() {
            this.setState({ imageHeightChanged: true });
        }
    }, {
        key: '_imageVisible',
        value: function _imageVisible() {
            this._handleImpression();
            this.setState({ itemLoaded: true });
            setTimeout(this._setHeightState.bind(this), 300);
        }
    }, {
        key: '_squareImage',
        value: function _squareImage(image) {
            var size = this._setHeight();
            return image + '?width=' + size + '&height=' + size + '&canvas=' + size + ',' + size;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                uri = _props2.uri,
                title = _props2.title,
                index = _props2.index,
                image = _props2.image,
                quickView = _props2.quickView;
            var _state = this.state,
                itemLoaded = _state.itemLoaded,
                imageHeightChanged = _state.imageHeightChanged;

            var isQuickViewOpen = this.props.id === this.props.quickViewItemId;
            var imageHeight = imageHeightChanged ? 'auto' : this._setHeight();

            var itemLinkClassName = classNames('pdp-grid-item-link', {
                'is-blur': isQuickViewOpen
            });
            var imageWrapperClass = classNames('pdp-grid-item-image-wrapper', {
                'is-loading': !itemLoaded
            });

            return React.createElement(
                'div',
                { className: 'pdp-grid-item-content' },
                React.createElement(
                    'a',
                    { href: uri, className: itemLinkClassName, onClick: this._handleClick },
                    React.createElement(
                        'div',
                        { className: imageWrapperClass },
                        React.createElement(
                            LazyLoad,
                            { className: 'pdp-grid-lazy', height: imageHeight, onContentVisible: this._imageVisible },
                            React.createElement(CarouselItem, { className: 'pdp-grid-item-image',
                                title: title,
                                src: this._squareImage(image),
                                index: index
                            })
                        )
                    ),
                    React.createElement(
                        'span',
                        { className: 'pdp-grid-item-text' },
                        title
                    )
                ),
                quickView ? this._renderQuickView(isQuickViewOpen) : null
            );
        }
    }]);

    return GridItem;
}(React.Component);

GridItem.propTypes = {
    id: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    quickView: PropTypes.bool,
    onProductClick: PropTypes.func,
    setQuickViewId: PropTypes.func,
    quickViewItemId: PropTypes.string,
    gridType: PropTypes.string,
    location: PropTypes.string,
    creators: PropTypes.string,
    attributes: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    seller: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    materials: PropTypes.string,
    description: PropTypes.string
};

GridItem.defaultProps = {
    gridType: 'pdp more from dealer'
};

GridItem.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func
};

module.exports = GridItem;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var get = __webpack_require__(14);

function ViewInvoiceLink(_ref) {
    var user = _ref.user,
        viewer = _ref.viewer,
        itemId = _ref.itemId,
        onClick = _ref.onClick,
        children = _ref.children,
        className = _ref.className;

    if (!get(user, 'canSeeInvoice') || get(viewer, 'transactions.totalResults')) {
        return null;
    }
    return React.createElement(
        'a',
        {
            href: '/my/orders/invoice/id-' + itemId + '/',
            target: '_blank',
            className: className,
            onClick: onClick
        },
        children
    );
}

ViewInvoiceLink.defaultProps = {
    onClick: function onClick() {}
};

ViewInvoiceLink.propTypes = {
    itemId: PropTypes.string.isRequired,
    viewer: PropTypes.object,
    user: PropTypes.object,
    onClick: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string
};

module.exports = Relay.createContainer(ViewInvoiceLink, {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null
    },
    fragments: {
        viewer: function viewer() {
            return function () {
                return {
                    children: [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'viewName',
                            value: {
                                kind: 'CallValue',
                                callValue: 'buyer.buyerPreInvoiceFilter'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'totalResults',
                            kind: 'Field',
                            metadata: {},
                            type: 'Int'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'hasUserId'
                                }
                            }]
                        }],
                        fieldName: 'transactions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'TransactionConnection'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ViewInvoiceLink_ViewerRelayQL',
                    type: 'Viewer'
                };
            }();
        },
        user: function user() {
            return function () {
                return {
                    children: [{
                        alias: 'canSeeInvoice',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_INVOICE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ViewInvoiceLink_UserRelayQL',
                    type: 'User'
                };
            }();
        }
    }
});

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ContextComponent = __webpack_require__(61);
var Pinterest = __webpack_require__(1333);
var PdpFacebookIcon = __webpack_require__(1871);
var PdpEmailIcon = __webpack_require__(1870);
var PdpPrintIcon = __webpack_require__(1872);
var MediaQuery = __webpack_require__(378);

var _require = __webpack_require__(365),
    queries = _require.queries;

var PdpSocialIcons = function (_ContextComponent) {
    _inherits(PdpSocialIcons, _ContextComponent);

    function PdpSocialIcons() {
        _classCallCheck(this, PdpSocialIcons);

        return _possibleConstructorReturn(this, (PdpSocialIcons.__proto__ || Object.getPrototypeOf(PdpSocialIcons)).apply(this, arguments));
    }

    _createClass(PdpSocialIcons, [{
        key: '_getPrintIcon',
        value: function _getPrintIcon() {
            var _props = this.props,
                printIcon = _props.printIcon,
                context = _props.context;


            if (printIcon) {
                return React.createElement(
                    MediaQuery,
                    { query: queries.xl },
                    React.createElement(PdpPrintIcon, { context: context })
                );
            }

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var socialData = props.socialData,
                pinterest = props.pinterest,
                iconType = props.iconType,
                onPinterestPin = props.onPinterestPin,
                pinterestConnectAccounts = props.pinterestConnectAccounts;


            return React.createElement(
                'div',
                { className: 'pdp-social-icons' },
                React.createElement(Pinterest, { url: socialData.uri,
                    media: socialData.image,
                    description: socialData.pinterest,
                    onPin: onPinterestPin,
                    copy: pinterest.copy,
                    iconType: iconType,
                    connectAccounts: pinterestConnectAccounts }),
                React.createElement(PdpFacebookIcon, { iconType: props.iconType }),
                React.createElement(PdpEmailIcon, { id: props.id,
                    vertical: props.vertical,
                    itemPk: props.itemPk,
                    stfOnClick: props.stfOnClick,
                    iconType: props.iconType }),
                this._getPrintIcon()
            );
        }
    }]);

    return PdpSocialIcons;
}(ContextComponent);

PdpSocialIcons.propTypes = {
    vertical: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    socialData: PropTypes.object.isRequired,
    itemPk: PropTypes.string.isRequired,
    stfOnClick: PropTypes.func.isRequired,
    pinterest: PropTypes.object.isRequired,
    onPinterestPin: PropTypes.func,
    pinterestConnectAccounts: PropTypes.bool,
    printIcon: PropTypes.bool,
    iconType: PropTypes.string
};

PdpSocialIcons.defaultProps = {
    printIcon: true
};

module.exports = PdpSocialIcons;

/***/ }),
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */
/***/ (function(module, exports) {

// Chosen, a Select Box Enhancer for jQuery and Protoype
// Chosen, a Select Box Enhancer for jQuery and Protoype
// by Patrick Filler for Harvest, http://getharvest.com
// 
// Version 0.9.11
// Full source at https://github.com/harvesthq/chosen
// Copyright (c) 2011 Harvest http://getharvest.com

// MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
// This file is generated by `cake build`, do not edit it by hand.
(function() {
  var SelectParser;

  SelectParser = (function() {

    function SelectParser() {
      this.options_index = 0;
      this.parsed = [];
    }

    SelectParser.prototype.add_node = function(child) {
      if (child.nodeName.toUpperCase() === "OPTGROUP") {
        return this.add_group(child);
      } else {
        return this.add_option(child);
      }
    };

    SelectParser.prototype.add_group = function(group) {
      var group_position, option, _i, _len, _ref, _results;
      group_position = this.parsed.length;
      this.parsed.push({
        array_index: group_position,
        group: true,
        label: group.label,
        children: 0,
        disabled: group.disabled
      });
      _ref = group.childNodes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        _results.push(this.add_option(option, group_position, group.disabled));
      }
      return _results;
    };

    SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
      if (option.nodeName.toUpperCase() === "OPTION") {
        if (option.text !== "") {
          if (group_position != null) {
            this.parsed[group_position].children += 1;
          }
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            value: option.value,
            text: option.text,
            html: option.innerHTML,
            selected: option.selected,
            disabled: group_disabled === true ? group_disabled : option.disabled,
            group_array_index: group_position,
            classes: option.className,
            style: option.style.cssText
          });
        } else {
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            empty: true
          });
        }
        return this.options_index += 1;
      }
    };

    return SelectParser;

  })();

  SelectParser.select_to_array = function(select) {
    var child, parser, _i, _len, _ref;
    parser = new SelectParser();
    _ref = select.childNodes;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      child = _ref[_i];
      parser.add_node(child);
    }
    return parser.parsed;
  };

  this.SelectParser = SelectParser;

}).call(this);

/*
Chosen source: generate output using 'cake build'
Copyright (c) 2011 by Harvest
*/


(function() {
  var AbstractChosen, root;

  root = this;

  AbstractChosen = (function() {

    function AbstractChosen(form_field, options) {
      this.form_field = form_field;
      this.options = options != null ? options : {};
      this.is_multiple = this.form_field.multiple;
      this.set_default_text();
      this.set_default_values();
      this.setup();
      this.set_up_html();
      this.register_observers();
      this.finish_setup();
    }

    AbstractChosen.prototype.set_default_values = function() {
      var _this = this;
      this.click_test_action = function(evt) {
        return _this.test_active_click(evt);
      };
      this.activate_action = function(evt) {
        return _this.activate_field(evt);
      };
      this.active_field = false;
      this.mouse_on_container = false;
      this.results_showing = false;
      this.result_highlighted = null;
      this.result_single_selected = null;
      this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
      this.disable_search_threshold = this.options.disable_search_threshold || 0;
      this.disable_search = this.options.disable_search || false;
      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
      this.search_contains = this.options.search_contains || false;
      this.choices = 0;
      this.single_backstroke_delete = this.options.single_backstroke_delete || false;
      this.max_selected_options = this.options.max_selected_options || Infinity;
      this.drop_direction = this.options.drop_direction === 'up' ? 'up' : 'down';
      this.vertical_anchor = this.drop_direction === 'up' ? 'bottom' : 'top';
      this.clear_onfocusshift = this.options.clear_onfocusshift !== false;
      this.show_results_callback = this.options.show_results_callback || function () {return true;};
      return this.inherit_select_classes = this.options.inherit_select_classes || false;
    };

    AbstractChosen.prototype.set_default_text = function() {
      if (this.form_field.getAttribute("data-placeholder")) {
        this.default_text = this.form_field.getAttribute("data-placeholder");
      } else if (this.is_multiple) {
        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || "Select Some Options";
      } else {
        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || "Select an Option";
      }
      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || "No results match";
    };

    AbstractChosen.prototype.mouse_enter = function() {
      return this.mouse_on_container = true;
    };

    AbstractChosen.prototype.mouse_leave = function() {
      return this.mouse_on_container = false;
    };

    AbstractChosen.prototype.input_focus = function(evt) {
      var _this = this;
      if (this.is_multiple) {
        if (!this.active_field) {
          return setTimeout((function() {
            return _this.container_mousedown();
          }), 50);
        }
      } else {
        if (!this.active_field) {
          return this.activate_field();
        }
      }
    };

    AbstractChosen.prototype.input_blur = function(evt) {
      var _this = this;
      if (!this.mouse_on_container) {
        this.active_field = false;
        return setTimeout((function() {
          return _this.blur_test();
        }), 100);
      }
    };

    AbstractChosen.prototype.result_add_option = function(option) {
      var classes, style;
      if (!option.disabled) {
        option.dom_id = this.container_id + "_o_" + option.array_index;
        classes = option.selected && this.is_multiple ? [] : ["active-result"];
        if (option.selected) {
          classes.push("result-selected");
        }
        if (option.group_array_index != null) {
          classes.push("group-option");
        }
        if (option.classes !== "") {
          classes.push(option.classes);
        }
        style = option.style.cssText !== "" ? " style=\"" + option.style + "\"" : "";
        return '<li id="' + option.dom_id + '" class="' + classes.join(' ') + '"' + style + '>' + option.html + '</li>';
      } else {
        return "";
      }
    };

    AbstractChosen.prototype.results_update_field = function() {
      if (!this.is_multiple) {
        this.results_reset_cleanup();
      }
      this.result_clear_highlight();
      this.result_single_selected = null;
      return this.results_build();
    };

    AbstractChosen.prototype.results_toggle = function() {
      if (this.results_showing) {
        return this.results_hide();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.results_search = function(evt) {
      if (this.results_showing) {
        if (!this.show_results_callback(this.search_field, this)) {
          return this.results_hide();
        }
        return this.winnow_results();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.keyup_checker = function(evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      switch (stroke) {
        case 8:
          if (this.is_multiple && this.backstroke_length < 1 && this.choices > 0) {
            return this.keydown_backstroke();
          } else if (!this.pending_backstroke) {
            this.result_clear_highlight();
            return this.results_search();
          }
          break;
        case 13:
          evt.preventDefault();
          if (this.results_showing) {
            return this.result_select(evt);
          }
          break;
        case 27:
          if (this.results_showing) {
            this.results_hide();
          }
          return true;
        case 9:
        case 38:
        case 40:
        case 16:
        case 91:
        case 17:
          break;
        default:
          return this.results_search();
      }
    };

    AbstractChosen.prototype.generate_field_id = function() {
      var new_id;
      new_id = this.generate_random_id();
      this.form_field.id = new_id;
      return new_id;
    };

    AbstractChosen.prototype.generate_random_char = function() {
      var chars, newchar, rand;
      chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      rand = Math.floor(Math.random() * chars.length);
      return newchar = chars.substring(rand, rand + 1);
    };

    return AbstractChosen;

  })();

  root.AbstractChosen = AbstractChosen;

}).call(this);

/*
Chosen source: generate output using 'cake build'
Copyright (c) 2011 by Harvest
*/


(function() {
  var $, Chosen, get_side_border_padding, root,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  root = this;

  $ = jQuery;

  $.fn.extend({
    chosen: function(options) {
      return this.each(function(input_field) {
        var $this;
        $this = $(this);
        if (!$this.hasClass("chzn-done")) {
          return $this.data('chosen', new Chosen(this, options));
        }
      });
    }
  });

  Chosen = (function(_super) {

    __extends(Chosen, _super);

    function Chosen() {
      return Chosen.__super__.constructor.apply(this, arguments);
    }

    Chosen.prototype.setup = function() {
      this.form_field_jq = $(this.form_field);
      this.current_value = this.form_field_jq.val();
      return this.is_rtl = this.form_field_jq.hasClass("chzn-rtl");
    };

    Chosen.prototype.finish_setup = function() {
      return this.form_field_jq.addClass("chzn-done");
    };

    Chosen.prototype.set_up_html = function() {
      var container_classes, container_div, container_props, dd_top, dd_width, sf_width;
      this.container_id = this.form_field.id.length ? this.form_field.id.replace(/[^\w]/g, '_') : this.generate_field_id();
      this.container_id += "_chzn";
      container_classes = ["chzn-container"];
      container_classes.push("chzn-container-" + (this.is_multiple ? "multi" : "single"));
      if (this.inherit_select_classes && this.form_field.className) {
        container_classes.push(this.form_field.className);
      }
      if (this.is_rtl) {
        container_classes.push("chzn-rtl");
      }
      this.f_width = this.form_field_jq.outerWidth();
      container_props = {
        id: this.container_id,
        "class": container_classes.join(' '),
        style: 'width: ' + this.f_width + 'px;',
        title: this.form_field.title
      };
      container_div = $("<div />", container_props);
      if (this.is_multiple) {
        container_div.html('<ul class="chzn-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chzn-drop" style="left:-9000px;"><ul class="chzn-results"></ul></div>');
      } else {
        container_div.html('<a href="javascript:void(0)" class="chzn-single chzn-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chzn-drop" style="left:-9000px;"><div class="chzn-search"><input type="text" autocomplete="off" /></div><ul class="chzn-results"></ul></div>');
      }
      this.form_field_jq.hide().after(container_div);
      this.container = $('#' + this.container_id);
      this.dropdown = this.container.find('div.chzn-drop').first();
      dd_top = this.container.height();
      dd_width = this.f_width - get_side_border_padding(this.dropdown);
      this.dropdown.css({
        "width": dd_width + "px"
      }).addClass('drop-' + this.drop_direction).css(this.vertical_anchor, dd_top + "px");
      this.search_field = this.container.find('input').first();
      this.search_results = this.container.find('ul.chzn-results').first();
      this.search_field_scale();
      this.search_no_results = this.container.find('li.no-results').first();
      if (this.is_multiple) {
        this.search_choices = this.container.find('ul.chzn-choices').first();
        this.search_container = this.container.find('li.search-field').first();
      } else {
        this.search_container = this.container.find('div.chzn-search').first();
        this.selected_item = this.container.find('.chzn-single').first();
        sf_width = dd_width - get_side_border_padding(this.search_container) - get_side_border_padding(this.search_field);
        this.search_field.css({
          "width": sf_width + "px"
        });
      }
      this.results_build();
      this.set_tab_index();
      return this.form_field_jq.trigger("liszt:ready", {
        chosen: this
      });
    };

    Chosen.prototype.register_observers = function() {
      var _this = this;
      this.container.mousedown(function(evt) {
        return _this.container_mousedown(evt);
      });
      this.container.mouseup(function(evt) {
        return _this.container_mouseup(evt);
      });
      this.container.mouseenter(function(evt) {
        return _this.mouse_enter(evt);
      });
      this.container.mouseleave(function(evt) {
        return _this.mouse_leave(evt);
      });
      this.search_results.mouseup(function(evt) {
        return _this.search_results_mouseup(evt);
      });
      this.search_results.mouseover(function(evt) {
        return _this.search_results_mouseover(evt);
      });
      this.search_results.mouseout(function(evt) {
        return _this.search_results_mouseout(evt);
      });
      this.form_field_jq.bind("liszt:updated", function(evt) {
        return _this.results_update_field(evt);
      });
      this.form_field_jq.bind("liszt:activate", function(evt) {
        return _this.activate_field(evt);
      });
      this.form_field_jq.bind("liszt:open", function(evt) {
        return _this.container_mousedown(evt);
      });
      this.search_field.blur(function(evt) {
        return _this.input_blur(evt);
      });
      this.search_field.keyup(function(evt) {
        return _this.keyup_checker(evt);
      });
      this.search_field.keydown(function(evt) {
        return _this.keydown_checker(evt);
      });
      this.search_field.focus(function(evt) {
        return _this.input_focus(evt);
      });
      if (this.is_multiple) {
        return this.search_choices.click(function(evt) {
          return _this.choices_click(evt);
        });
      } else {
        return this.container.click(function(evt) {
          return evt.preventDefault();
        });
      }
    };

    Chosen.prototype.search_field_disabled = function() {
      this.is_disabled = this.form_field_jq[0].disabled;
      if (this.is_disabled) {
        this.container.addClass('chzn-disabled');
        this.search_field[0].disabled = true;
        if (!this.is_multiple) {
          this.selected_item.unbind("focus", this.activate_action);
        }
        return this.close_field();
      } else {
        this.container.removeClass('chzn-disabled');
        this.search_field[0].disabled = false;
        if (!this.is_multiple) {
          return this.selected_item.bind("focus", this.activate_action);
        }
      }
    };

    Chosen.prototype.container_mousedown = function(evt) {
      var target_closelink;
      if (!this.is_disabled) {
        target_closelink = evt != null ? ($(evt.target)).hasClass("search-choice-close") : false;
        if (evt && evt.type === "mousedown" && !this.results_showing) {
          evt.preventDefault();
        }
        if (!this.pending_destroy_click && !target_closelink) {
          if (!this.active_field) {
            if (this.is_multiple && (this.clear_onfocusshift || this.search_field.val() === this.default_text)) {
              this.search_field.val("");
            }
            $(document).click(this.click_test_action);
            this.results_show();
          } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chzn-single").length)) {
            evt.preventDefault();
            this.results_toggle();
          }
          return this.activate_field();
        } else {
          return this.pending_destroy_click = false;
        }
      }
    };

    Chosen.prototype.container_mouseup = function(evt) {
      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
        return this.results_reset(evt);
      }
    };

    Chosen.prototype.blur_test = function(evt) {
      if (!this.active_field && this.container.hasClass("chzn-container-active")) {
        return this.close_field();
      }
    };

    Chosen.prototype.close_field = function() {
      $(document).unbind("click", this.click_test_action);
      this.active_field = false;
      this.results_hide();
      this.container.removeClass("chzn-container-active");
      this.clear_backstroke();
      if (this.clear_onfocusshift || this.search_field.val() === '') {
        this.winnow_results_clear();
        this.show_search_field_default();
      }
      return this.search_field_scale();
    };

    Chosen.prototype.activate_field = function() {
      this.container.addClass("chzn-container-active");
      this.active_field = true;
      this.search_field.val(this.search_field.val());
      return this.search_field.focus();
    };

    Chosen.prototype.test_active_click = function(evt) {
      if ($(evt.target).parents('#' + this.container_id).length) {
        return this.active_field = true;
      } else {
        return this.close_field();
      }
    };

    Chosen.prototype.results_build = function() {
      var content, data, _i, _len, _ref;
      this.parsing = true;
      this.results_data = root.SelectParser.select_to_array(this.form_field);
      if (this.is_multiple && this.choices > 0) {
        this.search_choices.find("li.search-choice").remove();
        this.choices = 0;
      } else if (!this.is_multiple) {
        this.selected_item.addClass("chzn-default").find("span").text(this.default_text);
        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
          this.container.addClass("chzn-container-single-nosearch");
        } else {
          this.container.removeClass("chzn-container-single-nosearch");
        }
      }
      content = '';
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        data = _ref[_i];
        if (data.group) {
          content += this.result_add_group(data);
        } else if (!data.empty) {
          content += this.result_add_option(data);
          if (data.selected && this.is_multiple) {
            this.choice_build(data);
          } else if (data.selected && !this.is_multiple) {
            this.selected_item.removeClass("chzn-default").find("span").text(data.text);
            if (this.allow_single_deselect) {
              this.single_deselect_control_build();
            }
          }
        }
      }
      this.search_field_disabled();
      this.show_search_field_default();
      this.search_field_scale();
      this.search_results.html(content);
      return this.parsing = false;
    };

    Chosen.prototype.result_add_group = function(group) {
      if (!group.disabled) {
        group.dom_id = this.container_id + "_g_" + group.array_index;
        return '<li id="' + group.dom_id + '" class="group-result">' + $("<div />").text(group.label).html() + '</li>';
      } else {
        return "";
      }
    };

    Chosen.prototype.result_do_highlight = function(el) {
      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
      if (el.length) {
        this.result_clear_highlight();
        this.result_highlight = el;
        this.result_highlight.addClass("highlighted");
        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
        visible_top = this.search_results.scrollTop();
        visible_bottom = maxHeight + visible_top;
        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
        high_bottom = high_top + this.result_highlight.outerHeight();
        if (high_bottom >= visible_bottom) {
          return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
        } else if (high_top < visible_top) {
          return this.search_results.scrollTop(high_top);
        }
      }
    };

    Chosen.prototype.result_clear_highlight = function() {
      if (this.result_highlight) {
        this.result_highlight.removeClass("highlighted");
      }
      return this.result_highlight = null;
    };

    Chosen.prototype.results_show = function() {
      var dd_top;
      if (!this.show_results_callback(this.search_field, this)) {
          return false;
      }
      if (!this.is_multiple) {
        this.selected_item.addClass("chzn-single-with-drop");
        if (this.result_single_selected) {
          this.result_do_highlight(this.result_single_selected);
        }
      } else if (this.max_selected_options <= this.choices) {
        this.form_field_jq.trigger("liszt:maxselected", {
          chosen: this
        });
        return false;
      }
      dd_top = this.is_multiple ? this.container.height() : this.container.height() - 1;
      this.form_field_jq.trigger("liszt:showing_dropdown", {
        chosen: this
      });
      this.dropdown.css({
        "left": 0
      }).css(this.vertical_anchor, dd_top + "px");
      this.results_showing = true;
      this.search_field.focus();
      this.search_field.val(this.search_field.val());
      return this.winnow_results();
    };

    Chosen.prototype.results_hide = function() {
      if (!this.is_multiple) {
        this.selected_item.removeClass("chzn-single-with-drop");
      }
      this.result_clear_highlight();
      this.form_field_jq.trigger("liszt:hiding_dropdown", {
        chosen: this
      });
      this.dropdown.css({
        "left": "-9000px"
      });
      return this.results_showing = false;
    };

    Chosen.prototype.set_tab_index = function(el) {
      var ti;
      if (this.form_field_jq.attr("tabindex")) {
        ti = this.form_field_jq.attr("tabindex");
        this.form_field_jq.attr("tabindex", -1);
        return this.search_field.attr("tabindex", ti);
      }
    };

    Chosen.prototype.show_search_field_default = function() {
      if (this.is_multiple && this.choices < 1 && !this.active_field) {
        this.search_field.val(this.default_text);
        return this.search_field.addClass("default");
      } else {
        this.search_field.val("");
        return this.search_field.removeClass("default");
      }
    };

    Chosen.prototype.search_results_mouseup = function(evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
      if (target.length) {
        this.result_highlight = target;
        this.result_select(evt);
        return this.search_field.focus();
      }
    };

    Chosen.prototype.search_results_mouseover = function(evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
      if (target) {
        return this.result_do_highlight(target);
      }
    };

    Chosen.prototype.search_results_mouseout = function(evt) {
      if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
        return this.result_clear_highlight();
      }
    };

    Chosen.prototype.choices_click = function(evt) {
      evt.preventDefault();
      if (this.active_field && !($(evt.target).hasClass("search-choice" || $(evt.target).parents('.search-choice').first)) && !this.results_showing) {
        return this.results_show();
      }
    };

    Chosen.prototype.choice_build = function(item) {
      var choice_id, html, link,
        _this = this;
      if (this.is_multiple && this.max_selected_options <= this.choices) {
        this.form_field_jq.trigger("liszt:maxselected", {
          chosen: this
        });
        return false;
      }
      choice_id = this.container_id + "_c_" + item.array_index;
      this.choices += 1;
      if (item.disabled) {
        html = '<li class="search-choice search-choice-disabled" id="' + choice_id + '"><span>' + item.html + '</span></li>';
      } else {
        html = '<li class="search-choice" id="' + choice_id + '"><span>' + item.html + '</span><a href="javascript:void(0)" class="search-choice-close" rel="' + item.array_index + '"></a></li>';
      }
      this.search_container.before(html);
      link = $('#' + choice_id).find("a").first();
      return link.click(function(evt) {
        return _this.choice_destroy_link_click(evt);
      });
    };

    Chosen.prototype.choice_destroy_link_click = function(evt) {
      evt.preventDefault();
      if (!this.is_disabled) {
        this.pending_destroy_click = true;
        return this.choice_destroy($(evt.target));
      } else {
        return evt.stopPropagation;
      }
    };

    Chosen.prototype.choice_destroy = function(link) {
      if (this.result_deselect(link.attr("rel"))) {
        this.choices -= 1;
        this.show_search_field_default();
        if (this.is_multiple && this.choices > 0 && this.search_field.val().length < 1) {
          this.results_hide();
        }
        link.parents('li').first().remove();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.results_reset = function() {
      this.form_field.options[0].selected = true;
      this.selected_item.find("span").text(this.default_text);
      if (!this.is_multiple) {
        this.selected_item.addClass("chzn-default");
      }
      this.show_search_field_default();
      this.results_reset_cleanup();
      this.form_field_jq.trigger("change");
      if (this.active_field) {
        return this.results_hide();
      }
    };

    Chosen.prototype.results_reset_cleanup = function() {
      this.current_value = this.form_field_jq.val();
      return this.selected_item.find("abbr").remove();
    };

    Chosen.prototype.result_select = function(evt) {
      var high, high_id, item, position;
      if (this.result_highlight) {
        high = this.result_highlight;
        high_id = high.attr("id");
        this.result_clear_highlight();
        if (this.is_multiple) {
          this.result_deactivate(high);
        } else {
          this.search_results.find(".result-selected").removeClass("result-selected");
          this.result_single_selected = high;
          this.selected_item.removeClass("chzn-default");
        }
        high.addClass("result-selected");
        position = high_id.substr(high_id.lastIndexOf("_") + 1);
        item = this.results_data[position];
        item.selected = true;
        this.form_field.options[item.options_index].selected = true;
        if (this.is_multiple) {
          this.choice_build(item);
        } else {
          this.selected_item.find("span").first().text(item.text);
          if (this.allow_single_deselect) {
            this.single_deselect_control_build();
          }
        }
        if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
          this.results_hide();
        }
        this.search_field.val("");
        if (this.is_multiple || this.form_field_jq.val() !== this.current_value) {
          this.form_field_jq.trigger("change", {
            'selected': this.form_field.options[item.options_index].value
          });
        }
        this.current_value = this.form_field_jq.val();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.result_activate = function(el) {
      return el.addClass("active-result");
    };

    Chosen.prototype.result_deactivate = function(el) {
      return el.removeClass("active-result");
    };

    Chosen.prototype.result_deselect = function(pos) {
      var result, result_data;
      result_data = this.results_data[pos];
      if (!this.form_field.options[result_data.options_index].disabled) {
        result_data.selected = false;
        this.form_field.options[result_data.options_index].selected = false;
        result = $("#" + this.container_id + "_o_" + pos);
        result.removeClass("result-selected").addClass("active-result").show();
        this.result_clear_highlight();
        this.winnow_results();
        this.form_field_jq.trigger("change", {
          deselected: this.form_field.options[result_data.options_index].value
        });
        this.search_field_scale();
        return true;
      } else {
        return false;
      }
    };

    Chosen.prototype.single_deselect_control_build = function() {
      if (this.allow_single_deselect && this.selected_item.find("abbr").length < 1) {
        return this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
      }
    };

    Chosen.prototype.winnow_results = function() {
      var found, option, part, parts, regex, regexAnchor, result, result_id, results, searchText, startpos, text, zregex, _i, _j, _len, _len1, _ref;
      this.no_results_clear();
      results = 0;
      searchText = this.search_field.val() === this.default_text ? "" : $('<div/>').text($.trim(this.search_field.val())).html();
      regexAnchor = this.search_contains ? "" : "^";
      regex = new RegExp(regexAnchor + searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
      zregex = new RegExp(searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        if (!option.disabled && !option.empty) {
          if (option.group) {
            $('#' + option.dom_id).css('display', 'none');
          } else if (!(this.is_multiple && option.selected)) {
            found = false;
            result_id = option.dom_id;
            result = $("#" + result_id);
            if (regex.test(option.html)) {
              found = true;
              results += 1;
            } else if (this.enable_split_word_search && (option.html.indexOf(" ") >= 0 || option.html.indexOf("[") === 0)) {
              parts = option.html.replace(/\[|\]/g, "").split(" ");
              if (parts.length) {
                for (_j = 0, _len1 = parts.length; _j < _len1; _j++) {
                  part = parts[_j];
                  if (regex.test(part)) {
                    found = true;
                    results += 1;
                  }
                }
              }
            }
            if (found) {
              if (searchText.length) {
                startpos = option.html.search(zregex);
                text = option.html.substr(0, startpos + searchText.length) + '</em>' + option.html.substr(startpos + searchText.length);
                text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
              } else {
                text = option.html;
              }
              result.html(text);
              this.result_activate(result);
              if (option.group_array_index != null) {
                $("#" + this.results_data[option.group_array_index].dom_id).css('display', 'list-item');
              }
            } else {
              if (this.result_highlight && result_id === this.result_highlight.attr('id')) {
                this.result_clear_highlight();
              }
              this.result_deactivate(result);
            }
          }
        }
      }
      if (results < 1 && searchText.length) {
        return this.no_results(searchText);
      } else {
        return this.winnow_results_set_highlight();
      }
    };

    Chosen.prototype.winnow_results_clear = function() {
      var li, lis, _i, _len, _results;
      this.search_field.val("");
      lis = this.search_results.find("li");
      _results = [];
      for (_i = 0, _len = lis.length; _i < _len; _i++) {
        li = lis[_i];
        li = $(li);
        if (li.hasClass("group-result")) {
          _results.push(li.css('display', 'auto'));
        } else if (!this.is_multiple || !li.hasClass("result-selected")) {
          _results.push(this.result_activate(li));
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Chosen.prototype.winnow_results_set_highlight = function() {
      var do_high, selected_results;
      if (!this.result_highlight) {
        selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
        do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
        if (do_high != null) {
          return this.result_do_highlight(do_high);
        }
      }
    };

    Chosen.prototype.no_results = function(terms) {
      var no_results_html;
      no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
      no_results_html.find("span").first().html(terms);
      return this.search_results.append(no_results_html);
    };

    Chosen.prototype.no_results_clear = function() {
      return this.search_results.find(".no-results").remove();
    };

    Chosen.prototype.keydown_arrow = function() {
      var first_active, next_sib;
      if (!this.result_highlight) {
        first_active = this.search_results.find("li.active-result").first();
        if (first_active) {
          this.result_do_highlight($(first_active));
        }
      } else if (this.results_showing) {
        next_sib = this.result_highlight.nextAll("li.active-result").first();
        if (next_sib) {
          this.result_do_highlight(next_sib);
        }
      }
      if (!this.results_showing) {
        return this.results_show();
      }
    };

    Chosen.prototype.keyup_arrow = function() {
      var prev_sibs;
      if (!this.results_showing && !this.is_multiple) {
        return this.results_show();
      } else if (this.result_highlight) {
        prev_sibs = this.result_highlight.prevAll("li.active-result");
        if (prev_sibs.length) {
          return this.result_do_highlight(prev_sibs.first());
        } else {
          if (this.choices > 0) {
            this.results_hide();
          }
          return this.result_clear_highlight();
        }
      }
    };

    Chosen.prototype.keydown_backstroke = function() {
      var next_available_destroy;
      if (this.pending_backstroke) {
        this.choice_destroy(this.pending_backstroke.find("a").first());
        return this.clear_backstroke();
      } else {
        next_available_destroy = this.search_container.siblings("li.search-choice").last();
        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
          this.pending_backstroke = next_available_destroy;
          if (this.single_backstroke_delete) {
            return this.keydown_backstroke();
          } else {
            return this.pending_backstroke.addClass("search-choice-focus");
          }
        }
      }
    };

    Chosen.prototype.clear_backstroke = function() {
      if (this.pending_backstroke) {
        this.pending_backstroke.removeClass("search-choice-focus");
      }
      return this.pending_backstroke = null;
    };

    Chosen.prototype.keydown_checker = function(evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      if (stroke !== 8 && this.pending_backstroke) {
        this.clear_backstroke();
      }
      switch (stroke) {
        case 8:
          this.backstroke_length = this.search_field.val().length;
          break;
        case 9:
          if (this.results_showing && !this.is_multiple) {
            this.result_select(evt);
          }
          this.mouse_on_container = false;
          break;
        case 13:
          evt.preventDefault();
          break;
        case 38:
          evt.preventDefault();
          this.keyup_arrow();
          break;
        case 40:
          this.keydown_arrow();
          break;
      }
    };

    Chosen.prototype.search_field_scale = function() {
      var dd_top, div, h, style, style_block, styles, w, _i, _len;
      if (this.is_multiple) {
        h = 0;
        w = 0;
        style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
        styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
        for (_i = 0, _len = styles.length; _i < _len; _i++) {
          style = styles[_i];
          style_block += style + ":" + this.search_field.css(style) + ";";
        }
        div = $('<div />', {
          'style': style_block
        });
        div.text(this.search_field.val());
        $('body').append(div);
        w = div.width() + 25;
        div.remove();
        if (w > this.f_width - 10) {
          w = this.f_width - 10;
        }
        this.search_field.css({
          'width': w + 'px'
        });
        dd_top = this.container.height();
        return this.dropdown.css(this.vertical_anchor, dd_top + "px");
      }
    };

    Chosen.prototype.generate_random_id = function() {
      var string;
      string = "sel" + this.generate_random_char() + this.generate_random_char() + this.generate_random_char();
      while ($("#" + string).length > 0) {
        string += this.generate_random_char();
      }
      return string;
    };

    return Chosen;

  })(root.AbstractChosen);

  root.Chosen = Chosen;

  get_side_border_padding = function(elmt) {
    var side_border_padding;
    return side_border_padding = elmt.outerWidth() - elmt.width();
  };

  root.get_side_border_padding = get_side_border_padding;

}).call(this);


/***/ }),
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */
/***/ (function(module, exports) {

module.exports = {
	"accountSettings": {
		"title": "Pinterest",
		"connectedMessage": "Favorites automatically posted to <span class=\"italic\">{boardName}</span>.",
		"noBoardConnectedMessage": "You do not have a board connected for your 1stdibs favorites.",
		"ctaBoard": "Change board",
		"notConnectedMessage": "Instantly pin your Favorites on Pinterest.",
		"connectAccountCta": "Connect to Pinterest",
		"disconnectCta": "Disconnect Account",
		"confirmHeader": "Disconnect Account?",
		"confirmMessage": "Your Favorites will no longer<br /> automatically post to Pinterest.",
		"confirmCta": "Ok",
		"cancelCta": "Cancel"
	},
	"connectAccounts": {
		"header": "Connect Your Pinterest Account",
		"description": "Save your favorites on 1stdibs and automatically<br /> share to the Pinterest board of your choice.",
		"cta": "Connect to Pinterest",
		"cancel": "No thanks, not now"
	},
	"connectBoards": {
		"defaultBoardName": "My 1stdibs Favorites",
		"header": "Choose a Default Pinterest Board",
		"message": "Please select a default Pinterest board where we should pin your favorites.",
		"hint": "Favorites you save will be automatically pinned to this board.<br /> You can select a different default board under your account.",
		"boardConflict": "There was an issue with the board you selected. Please select another board.",
		"cta": "Done"
	},
	"tracking": {
		"tooltipShown": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "tooltip share now displayed"
		},
		"connectModalConnectAccountClicked": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "modal displayed|connect account clicked"
		},
		"connectModalTooltipShareNowClicked": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "modal displayed|tooltip share now clicked"
		},
		"connectModalPinClicked": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "modal displayed|pinterest click"
		},
		"connectClicked": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "connect account clicked"
		},
		"connectSuccessful": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "connect account successful"
		},
		"disconnectSuccessful": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "disconnect account successful"
		},
		"changeBoardClicked": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "change board clicked"
		},
		"boardUnchanged": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "done clicked|default folder unchanged"
		},
		"boardUpdated": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "done clicked|default folder updated"
		}
	}
};

/***/ }),
/* 1572 */,
/* 1573 */,
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var Backbone = __webpack_require__(3);
var isEmpty = __webpack_require__(264);
var SV = __webpack_require__(17);
var template = __webpack_require__(1897).modalCarouselTemplate;
var SimpleModal = __webpack_require__(983);
var CarouselBin = __webpack_require__(1793);
var ModalCarouselTracking = __webpack_require__(1196);
var PinchZoom = __webpack_require__(1585);
var cssVars = __webpack_require__(362);
var get = __webpack_require__(14);
var transitionHelpers = __webpack_require__(1336);
var pinit = __webpack_require__(937);
var ModalCarouselUIState = __webpack_require__(1575);

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(40);
var provideContext = __webpack_require__(284);
var PinterestButton = __webpack_require__(1878);
var pinterestActions = __webpack_require__(710);
var pinterestUtils = __webpack_require__(714);
var ArrowLeftIcon = __webpack_require__(1670);
var ArrowRightIcon = __webpack_require__(1671);

var ModalCarousel;
// React component reference needed for zoom modal on old PDP layout
// Todo: Remove once New PDP layout rolls out 100%


// Media query to determine if the user is on a tablet based on the screen dimensions.
function isTablet() {
    return window.matchMedia(
        '(min-width: ' + cssVars.breakpoints.pixel['mobile-large-landscape'] + ') and ' +
        '(max-width: ' + cssVars.breakpoints.pixel['tablet-landscape'] + ')'
    ).matches;
}

/**
 * @private
 * @deprecated - Remove once New PDP layout rolls out 100%
 * @param props
 */
function handlePinterestTracking(props) {
    pinit.track('share - zoom modal', props.url, props.description);
}

/**
 * Represents a full-page modal containing an image carousel. The carousel allows users to hover over the currently
 * selected image to zoom in and pan around.
 *
 * TODO: The non-modal functionality should be extracted out of this so it can also be used in the main PDP carousel.
 * A wrapper class containing the modal functionality should be used instead of this.
 */
ModalCarousel = Backbone.BaseView.extend({

    subViewConfig: {
        carouselBin: {
            construct: CarouselBin,
            location: '.modal-carousel-bin',
            singleton: true
        }
    },

    events: {
        'click .modal-carousel-previous': '_previous',
        'click .modal-carousel-next': '_next',
        'mouseenter .modal-carousel-small-image': '_zoomIn',
        'click .modal-carousel-purchase': '_purchase'
    },

    initialize: function (options) {
        options = options || {};

        if (!options.model) {
            throw new Error('ModalCarousel must have a model to be initialized.');
        }

        this.UIState = new ModalCarouselUIState();
        this._images = options.images || [];
        this._updateImageCallback = options.updateImageCallback;
        this._isTablet = isTablet();
        this._tracking = new ModalCarouselTracking({ imagesLength: this._images.length, item: this.model });

        // Used to render social buttons in React.
        this.context = options.context;
        this.socialData = !isEmpty(options.socialData) && options.socialData;
        this.siteProtocol = options.siteProtocol;

        // Add the modal as a property so we can interact with it directly.
        this.modal = new SimpleModal({
            content: this,
            manualHideCallback: function () {
                $(document).off('keydown', this._keyHandler);
            }.bind(this),
            classNames: {
                modal: 'is-full-page'
            }
        });

        this.subs.add({
            // Subview that handles the additional images that can be viewed in the footer.
            carouselBin: {

                // Just need the small version of the images here.
                images: this._images.map(function (image) {
                    return image.small;
                }),

                // We want to track whenever a user clicks directly on an image in the bin.
                jumpToImageCallback: this._tracking.thumbnailClick.bind(this._tracking),

                // We need to update the currently displayed image when a new image is selected, either from clicking
                // next/previous or directly on an image.
                updateImageCallback: function (index) {
                    this._jumpToImage();
                    this._transitionImage();
                    this._resetImageState();

                    if (typeof this._updateImageCallback === 'function') {
                        this._updateImageCallback(index);
                    }
                    this.UIState.setSelectedImage(this._getZoomImageSrc(this._getSelected()));
                }.bind(this)
            }
        });

        // Allow user to flip between images with the arrow keys. Need to bind this here so it can be removed and
        // re-added when the modal is closed/opened.
        this._keyHandler = function (e) {
            // Left arrow key
            if (e.which === 37) {
                this._previous();
            }

            // Right arrow key
            if (e.which === 39) {
                this._next();
            }
        }.bind(this);
    },

    render: function () {
        this.setElement(template({
            arrowLeftIcon: ArrowLeftIcon,
            arrowRightIcon: ArrowRightIcon,
            checkoutRoute: '/checkout/id-' + SV.get('data.pk') + '/',
            purchasable: 'boolean' === typeof this.model.canMakePurchase
                // head.js call comes back as a boolean
                ? this.model.canMakePurchase
                : this.model.canMakePurchase()
        }));

        this.$image = this.$('.modal-carousel-image');
        this.$smallImage = this.$('.modal-carousel-small-image');
        this.$body = this.$('.modal-carousel-body');

        if (this._isTablet) {
            // Using pinch-to-zoom library directly instead of using the wrapper. The wrapper added extra styling that
            // broke this case. Also need to turn off 2d transforms here because the library is causing a duplicate
            // image to flash on the screen when resizing if 2d is turned on.
            this._pinchZoom = new PinchZoom(this.$smallImage, {
                use2d: false
            });
            // Add a class to override some styling imposed by the library.
            this.$smallImage.parent().addClass('modal-carousel-pinch-zoom');
            this.$image.addClass('is-tablet');
        }

        if (this._images.length === 1) {
            this.$('.modal-carousel-previous').addClass('is-invisible');
            this.$('.modal-carousel-next').addClass('is-invisible');
        }

        this.UIState.setSelectedImage(this._getZoomImageSrc(this._getSelected()));
        if (this.socialData) {
            this._insertSocialIcons();
        }
        this._jumpToImage();
        this.subs.renderAppend();
        this.modal.render();

        return this;
    },

    /**
     * Show the view. Delegates to the underlying modal functionality. The consumer can pass in the start position
     * of the bin and the currently selected image. Otherwise it will retain its state from the previous opening.
     * @param  {number} imageIndex Index of the image that should be selected on open.
     * @param  {number} leftIndex  Index of the leftmost image in the bin that should be visible on open.
     */
    show: function (imageIndex, leftIndex) {
        this.subs.get('carouselBin').setPosition(imageIndex, leftIndex);
        $(document).on('keydown', this._keyHandler);
        this._tracking.showModal(imageIndex);
        this.modal.show();
    },

    /**
     * Get the currently selected image from the bin.
     * @return {number} The index of the currently selected image.
     */
    _getSelected: function () {
        return this.subs.get('carouselBin').getSelected();
    },

    /**
     * Helper method to grab the source of the zoom image.
     * @param  {number} index Index of the image to get.
     * @return {string}       The image source.
     */
    _getZoomImageSrc: function (index) {
        return get(this._images[index], 'zoom.src', '');
    },

    /**
     * Handle zooming into the image.
     */
    _zoomIn: function () {
        var mouseMoveHandler;

        // On tablet, zoom is handled by pinching via a library.
        if (this._isTablet) {
            return;
        }

        mouseMoveHandler = this._mouseMoveHandler.bind(this);

        // Update the background image of the zoom image.
        this.$image.css({
            backgroundImage: 'url(' + this._getZoomImageSrc(this._getSelected()) + ')'
        });

        this.$image.addClass('enlarged');

        // Setup handlers for panning around the image.
        this.$body.on('mousemove', mouseMoveHandler);
        this.$body.one('mouseleave', function () {
            this._zoomOut();
            this.$body.off('mousemove', mouseMoveHandler);
        }.bind(this));

        this._transitionImage();
    },

    /**
     * Handle zooming out of the image.
     */
    _zoomOut: function () {
        this._resetImageState();
        this._transitionImage();
    },

    /**
     * Updates the main image based on the image currently selected in the bin.
     */
    _jumpToImage: function () {
        var selected = this._getSelected();

        // Update the small image source.
        this.$smallImage.attr('src', this._getZoomImageSrc(selected));
    },

    /**
     * Handle image switch animation. This adds an initial class to prime the animation and then on the next tick
     * kicks off the animation. When the transition is complete, remove the classes.
     */
    _transitionImage: function () {
        transitionHelpers.transitionElement(this.$image);
    },

    /**
     * Move to the next image.
     */
    _next: function () {
        this.subs.get('carouselBin').next(this._tracking.nextClick.bind(this._tracking));
    },

    /**
     * Move the the next previous image.
     */
    _previous: function () {
        this.subs.get('carouselBin').previous(this._tracking.previousClick.bind(this._tracking));
    },

    /**
     * Reset the image to the "small" state.
     */
    _resetImageState: function () {
        if (this._isTablet) {
            this._pinchZoom.zoomOutAnimation();
        }

        this.$image.removeClass('enlarged');
        this.$image.css({
            backgroundImage: ''
        });
    },

    /**
     * Update the image position given the new coordinates.
     * @param  {number} translateX New X position for the image.
     * @param  {number} translateY New Y position for the image.
     */
    _translateImagePosition: function (translateX, translateY) {
        this.$image.css('backgroundPosition', 'calc(50% + ' + translateX + '%)' + translateY + '%');
    },

    /**
     * Handler for panning over the zoomed in image. Translate the mouse position into coordinates for the image.
     * @param  {object} e The mousemove event.
     */
    _mouseMoveHandler: function (e) {
        var mouseX = e.clientX;
        var mouseY = e.clientY;
        var bodyWidth = this.$body.width();
        var bodyHeight = this.$body.height();

        // Calculate offset from the center for the X axis.
        var translateX = ((mouseX / bodyWidth) - 0.5) * -50;
        var translateY = (mouseY / bodyHeight) * 100;

        this._translateImagePosition(translateX, translateY);
    },

    _purchase: function (e) {
        e.preventDefault();
        this._tracking.purchase();
        window.location = $(e.currentTarget).attr('href');
    },

    /**
     * HACK: Social icons are rendered server side and then an init script attaches event listeners to them. This
     * method grabs the existing icons from the page, clones them and re-attaches the required event handlers. A
     * better approach might be to create a component for the social icons and have the server generate the template
     * so the main PDP icons can be rendered server side but then more icons can be added later with the same HTML.
     */
    _insertSocialIcons: function () {
        var UIState = this.UIState;
        var $socialIcons = $('.social-share-nav .social-share-nav-item');
        var socialSelector = '.modal-carousel-social';
        var $socialIconsClone;
        var $pinterest;
        var props;
        var domContainer;

        // Detect if we are on the old PDP or the new one.
        if ($socialIcons.length) {
            $socialIconsClone = $socialIcons.clone();
            $pinterest = $socialIconsClone.filter('.pinterest').find('.social-share-nav-item-link');

            props = {
                url: $pinterest.data('url'),
                media: UIState.getSelectedImage(),
                description: $pinterest.data('title'),
                model: UIState,
                context: this.context
            };

            PinterestButton.prototype.pin = function () {
                var pinterestWindow = pinterestUtils.openWindow();
                this.context.executeAction(pinterestActions.pin, {
                    pinterestWindow: pinterestWindow,
                    url: this.props.url,
                    media: this.state.media,
                    description: this.props.description
                });
                handlePinterestTracking(this.props);
            };

            PinterestButton = React.createFactory(provideContext(PinterestButton));
            ReactDOM.render(PinterestButton(props), this.el.querySelector(socialSelector)); //eslint-disable-line
        } else if (!isEmpty(this.socialData)) {
            domContainer = this.$(socialSelector).html('<div class="pdp-social-icons is-modal" />').children()[0];

            PinterestButton = React.createFactory(provideContext(PinterestButton));
            ReactDOM.render(PinterestButton({ //eslint-disable-line
                url: this.socialData.url,
                media: UIState.getSelectedImage(),
                description: this.socialData.pinterest,
                model: UIState,
                context: this.context
            }), domContainer);
        }
    }

});

module.exports = ModalCarousel;


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(23);
var Backbone = __webpack_require__(3);

/**
 * @class ModalCarouselUIState
 */
var ModalCarouselUIState = module.exports = Backbone.Model.extend({});

_.extend(ModalCarouselUIState.prototype, {
    defaults: function () {
        return {
            selectedImage : ''
        };
    },
    /**
     * @param {string} image
     */
    setSelectedImage: function (image) {
        this.set({'selectedImage': image});
    },
    /**
     * @returns {string}
     */
    getSelectedImage: function () {
        return this.get('selectedImage');
    }
});


/***/ }),
/* 1576 */,
/* 1577 */
/***/ (function(module, exports) {

module.exports = {
	"hasQuote": {
		"href": "#all-shipping",
		"canRequest": "View and request shipping quotes",
		"cannotRequest": "View all shipping quotes"
	},
	"noQuote": {
		"href": "#all-shipping-global",
		"canRequest": "Request a shipping quote",
		"cannotRequest": "View details"
	}
};

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

module.exports = {
	"title": "Item Invoice",
	"copy": "Generate an invoice that you can customize and print.",
	"cta": "View Invoice",
	"calloutCopy": {
		"header": "Exclusive Trade Feature",
		"text": "Instantly display a formal quote for any item you are considering."
	}
};

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

module.exports = {
	"title": "Shipping"
};

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

module.exports = {
	"disclaimer": "To obtain a shipping quote, proceed to checkout and complete your purchase.  You will not be charged at this time.  Within 48 hours, you will receive a shipping quote via email for your approval.  If you do not approve the quote, you will not be charged and your order will be cancelled.",
	"legal": "Customs duties and taxes may apply to international purchases. ",
	"linkCTA": "Learn More ",
	"link": "https://support.1stdibs.com/s/article/Customs-Duties-Taxes-for-International-Shipments",
	"preDisclaimer": {
		"canRequestQuote": {
			"copy": "Need different shipping arrangements?  ",
			"linkCTA": "Request a shipping quote >"
		},
		"standard": "Shipping somewhere else? ",
		"trade": "Shipping somewhere else or need expedited delivery? ",
		"none": ""
	}
};

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

module.exports = {
	"restOfWorld": "Rest of the World",
	"alone": "Anywhere in the World",
	"withOthers": "Everywhere Else"
};

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

module.exports = {
	"FREIGHT": {
		"FRONT_DOOR": "Delivered to front door of your house or building and does not include unpacking, inspection, assembly, or installation. Facilitated by {facilitatedBy}."
	},
	"PARCEL": {
		"STANDARD": "Carefully packaged and delivered via a parcel delivery service such as UPS or FedEx. Facilitated by {facilitatedBy}.",
		"EXPRESS": "Carefully packaged and delivered via a parcel delivery service such as UPS or FedEx. Facilitated by {facilitatedBy}.",
		"MESSENGER": "Hand-delivered via a local messenger service at a time that is convenient for you to sign for a delivery. Facilitated by {facilitatedBy}."
	},
	"WHITE_GLOVE": {
		"STANDARD": "Delivered to room of choice and includes unpacking, inspection, and minor assembly at your convenience. Facilitated by {facilitatedBy}.",
		"EXPRESS": "Delivered to room of choice and includes unpacking, inspection, and minor assembly at your convenience. Facilitated by {facilitatedBy}."
	}
};

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

module.exports = {
	"cards": [
		{
			"title": "Visa",
			"icon": "visa"
		},
		{
			"title": "Discover",
			"icon": "discover"
		},
		{
			"title": "American Express",
			"icon": "americanExpress"
		},
		{
			"title": "MasterCard",
			"icon": "masterCard"
		}
	],
	"title": "Online payment methods",
	"description": "1stdibs accepts the following payment methods:",
	"paypalPriceThreshold": 55000
};

/***/ }),
/* 1584 */,
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Plugin originally modified by liliana on 6/17/15
 */

/*

 Copyright (c) Manuel Stofer 2013 - rtp.ch - RTP.PinchZoom.js

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.

 */


/*global jQuery, console, define, setTimeout, window*/
(function () {
    'use strict';
    var definePinchZoom = function ($) {

        /**
         * Pinch zoom using jQuery
         * @version 0.0.2
         * @author Manuel Stofer <mst@rtp.ch>
         * @param el
         * @param options
         * @constructor
         */
        var PinchZoom = function (el, options) {
                this.el = $(el);
                this.zoomFactor = 1;
                this.lastScale = 1;
                this.offset = {
                    x: 0,
                    y: 0
                };
                this.options = $.extend({}, this.defaults, options);
                this.setupMarkup();
                this.bindEvents();
                this.update();
                // default enable.
                this.enable();

            },
            sum = function (a, b) {
                return a + b;
            },
            isCloseTo = function (value, expected) {
                return value > expected - 0.01 && value < expected + 0.01;
            };

        PinchZoom.prototype = {

            defaults: {
                tapZoomFactor: 2,
                zoomOutFactor: 1.3,
                animationDuration: 300,
                animationInterval: 5,
                maxZoom: 4,
                minZoom: 0.5,
                lockDragAxis: false,
                use2d: true,
                zoomStartEventName: 'pz_zoomstart',
                zoomEndEventName: 'pz_zoomend',
                dragStartEventName: 'pz_dragstart',
                dragEndEventName: 'pz_dragend',
                doubleTapEventName: 'pz_doubletap'
            },

            /**
             * Event handler for 'dragstart'
             * @param event
             */
            handleDragStart: function (event) {
                this.el.trigger(this.options.dragStartEventName);
                this.stopAnimation();
                this.lastDragPosition = false;
                this.hasInteraction = true;
                this.handleDrag(event);
            },

            /**
             * Event handler for 'drag'
             * @param event
             */
            handleDrag: function (event) {

                if (this.zoomFactor > 1.0) {
                    var touch = this.getTouches(event)[0];
                    this.drag(touch, this.lastDragPosition);
                    this.offset = this.sanitizeOffset(this.offset);
                    this.lastDragPosition = touch;
                }
            },

            handleDragEnd: function () {
                this.el.trigger(this.options.dragEndEventName);
                this.end();
            },

            /**
             * Event handler for 'zoomstart'
             * @param event
             */
            handleZoomStart: function (event) {
                this.el.trigger(this.options.zoomStartEventName);
                this.stopAnimation();
                this.lastScale = 1;
                this.nthZoom = 0;
                this.lastZoomCenter = false;
                this.hasInteraction = true;
            },

            /**
             * Event handler for 'zoom'
             * @param event
             */
            handleZoom: function (event, newScale) {

                // a relative scale factor is used
                var touchCenter = this.getTouchCenter(this.getTouches(event)),
                    scale = newScale / this.lastScale;
                this.lastScale = newScale;

                // the first touch events are thrown away since they are not precise
                this.nthZoom += 1;
                if (this.nthZoom > 3) {

                    this.scale(scale, touchCenter);
                    this.drag(touchCenter, this.lastZoomCenter);
                }
                this.lastZoomCenter = touchCenter;
            },

            handleZoomEnd: function () {
                this.el.trigger(this.options.zoomEndEventName);
                this.end();
            },

            /**
             * Event handler for 'doubletap'
             * @param event
             */
            handleDoubleTap: function (event) {
                var center = this.getTouches(event)[0],
                    zoomFactor = this.zoomFactor > 1 ? 1 : this.options.tapZoomFactor,
                    startZoomFactor = this.zoomFactor,
                    updateProgress = (function (progress) {
                        this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
                    }).bind(this);

                if (this.hasInteraction) {
                    return;
                }
                if (startZoomFactor > zoomFactor) {
                    center = this.getCurrentZoomCenter();
                }

                this.animate(this.options.animationDuration, this.options.animationInterval, updateProgress, this.swing);
                this.el.trigger(this.options.doubleTapEventName);
            },

            /**
             * Max / min values for the offset
             * @param offset
             * @return {Object} the sanitized offset
             */
            sanitizeOffset: function (offset) {
                var maxX = (this.zoomFactor - 1) * this.getContainerX(),
                    maxY = (this.zoomFactor - 1) * this.getContainerY(),
                    maxOffsetX = Math.max(maxX, 0),
                    maxOffsetY = Math.max(maxY, 0),
                    minOffsetX = Math.min(maxX, 0),
                    minOffsetY = Math.min(maxY, 0);

                return {
                    x: Math.min(Math.max(offset.x, minOffsetX), maxOffsetX),
                    y: Math.min(Math.max(offset.y, minOffsetY), maxOffsetY)
                };
            },

            /**
             * Scale to a specific zoom factor (not relative)
             * @param zoomFactor
             * @param center
             */
            scaleTo: function (zoomFactor, center) {
                this.scale(zoomFactor / this.zoomFactor, center);
            },

            /**
             * Scales the element from specified center
             * @param scale
             * @param center
             */
            scale: function (scale, center) {
                scale = this.scaleZoomFactor(scale);
                this.addOffset({
                    x: (scale - 1) * (center.x + this.offset.x),
                    y: (scale - 1) * (center.y + this.offset.y)
                });
            },

            /**
             * Scales the zoom factor relative to current state
             * @param scale
             * @return the actual scale (can differ because of max min zoom factor)
             */
            scaleZoomFactor: function (scale) {
                var originalZoomFactor = this.zoomFactor;
                this.zoomFactor *= scale;
                this.zoomFactor = Math.min(this.options.maxZoom, Math.max(this.zoomFactor, this.options.minZoom));
                return this.zoomFactor / originalZoomFactor;
            },

            /**
             * Drags the element
             * @param center
             * @param lastCenter
             */
            drag: function (center, lastCenter) {
                if (lastCenter) {
                    if(this.options.lockDragAxis) {
                        // lock scroll to position that was changed the most
                        if(Math.abs(center.x - lastCenter.x) > Math.abs(center.y - lastCenter.y)) {
                            this.addOffset({
                                x: -(center.x - lastCenter.x),
                                y: 0
                            });
                        }
                        else {
                            this.addOffset({
                                y: -(center.y - lastCenter.y),
                                x: 0
                            });
                        }
                    }
                    else {
                        this.addOffset({
                            y: -(center.y - lastCenter.y),
                            x: -(center.x - lastCenter.x)
                        });
                    }
                }
            },

            /**
             * Calculates the touch center of multiple touches
             * @param touches
             * @return {Object}
             */
            getTouchCenter: function (touches) {
                return this.getVectorAvg(touches);
            },

            /**
             * Calculates the average of multiple vectors (x, y values)
             */
            getVectorAvg: function (vectors) {
                return {
                    x: vectors.map(function (v) { return v.x; }).reduce(sum) / vectors.length,
                    y: vectors.map(function (v) { return v.y; }).reduce(sum) / vectors.length
                };
            },

            /**
             * Adds an offset
             * @param offset the offset to add
             * @return return true when the offset change was accepted
             */
            addOffset: function (offset) {
                this.offset = {
                    x: this.offset.x + offset.x,
                    y: this.offset.y + offset.y
                };
            },

            sanitize: function () {
                if (this.zoomFactor < this.options.zoomOutFactor) {
                    this.zoomOutAnimation();
                } else if (this.isInsaneOffset(this.offset)) {
                    this.sanitizeOffsetAnimation();
                }
            },

            /**
             * Checks if the offset is ok with the current zoom factor
             * @param offset
             * @return {Boolean}
             */
            isInsaneOffset: function (offset) {
                var sanitizedOffset = this.sanitizeOffset(offset);
                return sanitizedOffset.x !== offset.x ||
                    sanitizedOffset.y !== offset.y;
            },

            /**
             * Creates an animation moving to a sane offset
             */
            sanitizeOffsetAnimation: function () {
                var targetOffset = this.sanitizeOffset(this.offset),
                    startOffset = {
                        x: this.offset.x,
                        y: this.offset.y
                    },
                    updateProgress = (function (progress) {
                        this.offset.x = startOffset.x + progress * (targetOffset.x - startOffset.x);
                        this.offset.y = startOffset.y + progress * (targetOffset.y - startOffset.y);
                        this.update();
                    }).bind(this);

                this.animate(
                    this.options.animationDuration,
                    this.options.animationInterval,
                    updateProgress,
                    this.swing
                );
            },

            /**
             * Zooms back to the original position,
             * (no offset and zoom factor 1)
             */
            zoomOutAnimation: function () {
                var startZoomFactor = this.zoomFactor,
                    zoomFactor = 1,
                    center = this.getCurrentZoomCenter(),
                    updateProgress = (function (progress) {
                        this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
                    }).bind(this);

                this.animate(
                    this.options.animationDuration,
                    this.options.animationInterval,
                    updateProgress,
                    this.swing
                );
            },

            /**
             * Updates the aspect ratio
             */
            updateAspectRatio: function () {
                this.setContainerY(this.getContainerX() / this.getAspectRatio());
            },

            /**
             * Calculates the initial zoom factor (for the element to fit into the container)
             * @return the initial zoom factor
             */
            getInitialZoomFactor: function () {
                // use .offsetWidth instead of width()
                // because jQuery-width() return the original width but Zepto-width() will calculate width with transform.
                // the same as .height()
                return this.container[0].offsetWidth / this.el[0].offsetWidth;
            },

            /**
             * Calculates the aspect ratio of the element
             * @return the aspect ratio
             */
            getAspectRatio: function () {
                return this.el[0].offsetWidth / this.el[0].offsetHeight;
            },

            /**
             * Calculates the virtual zoom center for the current offset and zoom factor
             * (used for reverse zoom)
             * @return {Object} the current zoom center
             */
            getCurrentZoomCenter: function () {

                // uses following formula to calculate the zoom center x value
                // offset_left / offset_right = zoomcenter_x / (container_x - zoomcenter_x)
                var length = this.container[0].offsetWidth * this.zoomFactor,
                    offsetLeft  = this.offset.x,
                    offsetRight = length - offsetLeft -this.container[0].offsetWidth,
                    widthOffsetRatio = offsetLeft / offsetRight,
                    centerX = widthOffsetRatio * this.container[0].offsetWidth / (widthOffsetRatio + 1),

                // the same for the zoomcenter y
                    height = this.container[0].offsetHeight * this.zoomFactor,
                    offsetTop  = this.offset.y,
                    offsetBottom = height - offsetTop - this.container[0].offsetHeight,
                    heightOffsetRatio = offsetTop / offsetBottom,
                    centerY = heightOffsetRatio * this.container[0].offsetHeight / (heightOffsetRatio + 1);

                // prevents division by zero
                if (offsetRight === 0) { centerX = this.container[0].offsetWidth; }
                if (offsetBottom === 0) { centerY = this.container[0].offsetHeight; }

                return {
                    x: centerX,
                    y: centerY
                };
            },

            canDrag: function () {
                return !isCloseTo(this.zoomFactor, 1);
            },

            /**
             * Returns the touches of an event relative to the container offset
             * @param event
             * @return array touches
             */
            getTouches: function (event) {
                var position = this.container.offset();
                return Array.prototype.slice.call(event.touches).map(function (touch) {
                    return {
                        x: touch.pageX - position.left,
                        y: touch.pageY - position.top
                    };
                });
            },

            /**
             * Animation loop
             * does not support simultaneous animations
             * @param duration
             * @param interval
             * @param framefn
             * @param timefn
             * @param callback
             */
            animate: function (duration, interval, framefn, timefn, callback) {
                var startTime = new Date().getTime(),
                    renderFrame = (function () {
                        if (!this.inAnimation) { return; }
                        var frameTime = new Date().getTime() - startTime,
                            progress = frameTime / duration;
                        if (frameTime >= duration) {
                            framefn(1);
                            if (callback) {
                                callback();
                            }
                            this.update();
                            this.stopAnimation();
                            this.update();
                        } else {
                            if (timefn) {
                                progress = timefn(progress);
                            }
                            framefn(progress);
                            this.update();
                            setTimeout(renderFrame, interval);
                        }
                    }).bind(this);
                this.inAnimation = true;
                renderFrame();
            },

            /**
             * Stops the animation
             */
            stopAnimation: function () {
                this.inAnimation = false;
            },

            /**
             * Swing timing function for animations
             * @param p
             * @return {Number}
             */
            swing: function (p) {
                return -Math.cos(p * Math.PI) / 2  + 0.5;
            },

            getContainerX: function () {
                return this.container[0].offsetWidth;
            },

            getContainerY: function () {
                return this.container[0].offsetHeight;
            },

            setContainerY: function (y) {
                return this.container.height(y);
            },

            /**
             * Creates the expected html structure
             */
            setupMarkup: function () {
                this.container = $('<div class="pinch-zoom-container"></div>');
                this.el.before(this.container);
                this.container.append(this.el);

                this.container.css({
                    'overflow': 'hidden',
                    'position': 'relative'
                });

                // Zepto doesn't recognize `webkitTransform..` style
                this.el.css({
                    '-webkit-transform-origin': '0% 0%',
                    '-moz-transform-origin': '0% 0%',
                    '-ms-transform-origin': '0% 0%',
                    '-o-transform-origin': '0% 0%',
                    'transform-origin': '0% 0%',
                    'position': 'absolute'
                });
            },

            end: function () {
                this.hasInteraction = false;
                this.sanitize();
                this.update();
            },

            /**
             * Binds all required event listeners
             */
            bindEvents: function () {
                detectGestures(this.container.get(0), this);
                // Zepto and jQuery both know about `on`
                $(window).on('resize', this.update.bind(this));
                $(this.el).find('img').on('load', this.update.bind(this));
            },

            /**
             * Updates the css values according to the current zoom factor and offset
             */
            update: function () {

                if (this.updatePlaned) {
                    return;
                }
                this.updatePlaned = true;

                setTimeout((function () {
                    this.updatePlaned = false;
                    this.updateAspectRatio();

                    var zoomFactor = this.getInitialZoomFactor() * this.zoomFactor,
                        offsetX = -this.offset.x / zoomFactor,
                        offsetY = -this.offset.y / zoomFactor,
                        transform3d =   'scale3d('     + zoomFactor + ', '  + zoomFactor + ',1) ' +
                            'translate3d(' + offsetX    + 'px,' + offsetY    + 'px,0px)',
                        transform2d =   'scale('       + zoomFactor + ', '  + zoomFactor + ') ' +
                            'translate('   + offsetX    + 'px,' + offsetY    + 'px)',
                        removeClone = (function () {
                            if (this.clone) {
                                this.clone.remove();
                                delete this.clone;
                            }
                        }).bind(this);

                    // Scale 3d and translate3d are faster (at least on ios)
                    // but they also reduce the quality.
                    // PinchZoom uses the 3d transformations during interactions
                    // after interactions it falls back to 2d transformations
                    if (!this.options.use2d || this.hasInteraction || this.inAnimation) {
                        this.is3d = true;
                        removeClone();
                        this.el.css({
                            '-webkit-transform':  transform3d,
                            '-o-transform':       transform2d,
                            '-ms-transform':      transform2d,
                            '-moz-transform':     transform2d,
                            'transform':        transform3d
                        });
                    } else {

                        // When changing from 3d to 2d transform webkit has some glitches.
                        // To avoid this, a copy of the 3d transformed element is displayed in the
                        // foreground while the element is converted from 3d to 2d transform
                        if (this.is3d) {
                            this.clone = this.el.clone();
                            this.clone.css('pointer-events', 'none');
                            this.clone.appendTo(this.container);
                            setTimeout(removeClone, 200);
                        }
                        this.el.css({
                            '-webkit-transform':  transform2d,
                            '-o-transform':       transform2d,
                            '-ms-transform':      transform2d,
                            '-moz-transform':     transform2d,
                            'transform':        transform2d
                        });
                        this.is3d = false;
                    }
                }).bind(this), 0);
            },

            /**
             * Enables event handling for gestures
             */
            enable: function() {
                this.enabled = true;
            },

            /**
             * Disables event handling for gestures
             */
            disable: function() {
                this.enabled = false;
            }
        };

        var detectGestures = function (el, target) {
            var interaction = null,
                fingers = 0,
                lastTouchStart = null,
                startTouches = null,

                setInteraction = function (newInteraction, event) {
                    if (interaction !== newInteraction) {

                        if (interaction && !newInteraction) {
                            switch (interaction) {
                                case "zoom":
                                    target.handleZoomEnd(event);
                                    break;
                                case 'drag':
                                    target.handleDragEnd(event);
                                    break;
                            }
                        }

                        switch (newInteraction) {
                            case 'zoom':
                                target.handleZoomStart(event);
                                break;
                            case 'drag':
                                target.handleDragStart(event);
                                break;
                        }
                    }
                    interaction = newInteraction;
                },

                updateInteraction = function (event) {
                    if (fingers === 2) {
                        setInteraction('zoom');
                    } else if (fingers === 1 && target.canDrag()) {
                        setInteraction('drag', event);
                    } else {
                        setInteraction(null, event);
                    }
                },

                targetTouches = function (touches) {
                    return Array.prototype.slice.call(touches).map(function (touch) {
                        return {
                            x: touch.pageX,
                            y: touch.pageY
                        };
                    });
                },

                getDistance = function (a, b) {
                    var x, y;
                    x = a.x - b.x;
                    y = a.y - b.y;
                    return Math.sqrt(x * x + y * y);
                },

                calculateScale = function (startTouches, endTouches) {
                    var startDistance = getDistance(startTouches[0], startTouches[1]),
                        endDistance = getDistance(endTouches[0], endTouches[1]);
                    return endDistance / startDistance;
                },

                cancelEvent = function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                },

                detectDoubleTap = function (event) {
                    var time = (new Date()).getTime();

                    if (fingers > 1) {
                        lastTouchStart = null;
                    }

                    if (time - lastTouchStart < 300) {
                        cancelEvent(event);

                        target.handleDoubleTap(event);
                        switch (interaction) {
                            case "zoom":
                                target.handleZoomEnd(event);
                                break;
                            case 'drag':
                                target.handleDragEnd(event);
                                break;
                        }
                    }

                    if (fingers === 1) {
                        lastTouchStart = time;
                    }
                },
                firstMove = true;

            el.addEventListener('touchstart', function (event) {
                if(target.enabled) {
                    firstMove = true;
                    fingers = event.touches.length;
                    detectDoubleTap(event);
                }
            });

            el.addEventListener('touchmove', function (event) {
                if(target.enabled) {
                    if (firstMove) {
                        updateInteraction(event);
                        if (interaction) {
                            cancelEvent(event);
                        }
                        startTouches = targetTouches(event.touches);
                    } else {
                        switch (interaction) {
                            case 'zoom':
                                target.handleZoom(event, calculateScale(startTouches, targetTouches(event.touches)));
                                break;
                            case 'drag':
                                target.handleDrag(event);
                                break;
                        }
                        if (interaction) {
                            cancelEvent(event);
                            target.update();
                        }
                    }

                    firstMove = false;
                }
            });

            el.addEventListener('touchend', function (event) {
                if(target.enabled) {
                    fingers = event.touches.length;
                    updateInteraction(event);
                }
            });
        };

        return PinchZoom;
    };

    if (true) {
        module.exports = definePinchZoom(__webpack_require__(5));
    } else if (typeof define !== 'undefined' && define.amd && define.jquery) {
        define(['dibs-jquery-shim'], function ($) {
            return definePinchZoom($);
        });
    } else {
        window.RTP = window.RTP || {};
        window.RTP.PinchZoom = definePinchZoom(window.$);
    }

}).call(this);


/***/ }),
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 24);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form":"main__form__3Zpch","block":"main__block__3Zk-j","inline":"main__inline__2Wsth","group":"main__group__37z2Z","right":"main__right__1CK6j","left":"main__left__GaIku","leftGroup":"main__leftGroup___CCrR main__group__37z2Z main__left__GaIku","field":"main__field___fM1r","text":"main__text__FPjFi","label":"main__label__3ed_U main__text__FPjFi","placeHolder":"main__placeHolder__3Wqds","input":"main__input__19Fr2 main__text__FPjFi","select":"main__select__1m8Cq","disable":"main__disable__QWEvv","valid":"main__valid__1_l7A","error":"main__error__2my5S","errorMessage":"main__errorMessage__38TEF","button":"main__button__3Mk67","buttonDisabled":"main__buttonDisabled__X90Yr","spinnerWrapper":"main__spinnerWrapper__35XxJ","spinner":"main__spinner__TppDV main__inline__2Wsth"};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(7);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Text(_ref) {
    var _classNames;

    var wrapperClass = _ref.wrapperClass,
        type = _ref.type,
        name = _ref.name,
        value = _ref.value,
        pattern = _ref.pattern,
        placeholder = _ref.placeholder,
        autoComplete = _ref.autoComplete,
        autoFocus = _ref.autoFocus,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        _onChange = _ref.onChange,
        onBlur = _ref.onBlur;

    var showError = !isDisabled && isBlurred && !!error;
    var wrapperClasses = (0, _classnames2.default)(wrapperClass, _main2.default.field);
    var inputClasses = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _main2.default.input, true), _defineProperty(_classNames, _main2.default.disable, isDisabled), _defineProperty(_classNames, _main2.default.valid, isBlurred && !!value && !showError), _defineProperty(_classNames, _main2.default.error, showError), _classNames));
    return _react2.default.createElement(
        'div',
        { className: wrapperClasses, 'data-field': name },
        _react2.default.createElement('input', {
            className: inputClasses,
            type: type,
            value: value,
            name: name,
            pattern: pattern,
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            disabled: isDisabled,
            onChange: function onChange(e) {
                return _onChange({ name: name, value: e.target.value });
            },
            onBlur: onBlur
        }),
        _react2.default.createElement(
            'span',
            { className: _main2.default.placeHolder },
            placeholder
        ),
        showError && _react2.default.createElement(
            'label',
            { className: _main2.default.errorMessage },
            error
        )
    );
}

Text.propTypes = {
    wrapperClass: _propTypes2.default.string,
    type: _propTypes2.default.string,
    name: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired,
    pattern: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    autoComplete: _propTypes2.default.string,
    autoFocus: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    error: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

Text.defaultProps = {
    wrapperClass: '',
    type: 'text',
    placeholder: '',
    autoComplete: 'on',
    autoFocus: false,
    isBlurred: false,
    isDisabled: false,
    onBlur: function onBlur() {}
};

exports.default = Text;
module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(16);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _reactSelect = __webpack_require__(30);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// components


var Select = function Select(_ref) {
    var _classNames;

    var wrapperClass = _ref.wrapperClass,
        options = _ref.options,
        name = _ref.name,
        value = _ref.value,
        placeHolder = _ref.placeHolder,
        autoComplete = _ref.autoComplete,
        isClearable = _ref.isClearable,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        _onChange = _ref.onChange,
        onBlur = _ref.onBlur;

    var showError = !isDisabled && isBlurred && !!error;
    var placeHolderText = (placeHolder || name).charAt(0).toUpperCase() + (placeHolder || name).slice(1);
    var selectWrapperClasses = (0, _classnames2.default)(wrapperClass, _main2.default.field);
    var selectClasses = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _main2.default.select, true), _defineProperty(_classNames, _main2.default.disable, isDisabled), _defineProperty(_classNames, _main2.default.valid, isBlurred && !!value && !showError), _defineProperty(_classNames, _main2.default.error, showError), _classNames));
    return _react2.default.createElement(
        'div',
        { className: selectWrapperClasses, 'data-field': name },
        _react2.default.createElement(
            'div',
            { className: selectClasses },
            _react2.default.createElement(_reactSelect2.default, {
                name: name,
                value: value,
                autoComplete: 'on',
                inputProps: {
                    name: name,
                    autoComplete: autoComplete
                },
                options: options,
                disabled: isDisabled,
                clearable: isClearable,
                scrollMenuIntoView: false,
                onChange: function onChange(o) {
                    return _onChange({ name: name, value: o && o.value || '' });
                },
                onBlur: onBlur
            }),
            _react2.default.createElement(
                'span',
                { className: _main2.default.placeHolder },
                placeHolderText
            )
        ),
        showError && _react2.default.createElement(
            'label',
            { className: _main2.default.errorMessage },
            error
        )
    );
};

Select.propTypes = {
    wrapperClass: _propTypes2.default.string,
    name: _propTypes2.default.any.isRequired,
    value: _propTypes2.default.any.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.any.isRequired,
        value: _propTypes2.default.any.isRequired
    })).isRequired,
    placeHolder: _propTypes2.default.string,
    autoComplete: _propTypes2.default.string,
    isClearable: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    error: _propTypes2.default.any,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

Select.defaultProps = {
    wrapperClass: '',
    placeHolder: '',
    autoComplete: 'on',
    isClearable: false,
    isDisabled: false,
    onBlur: function onBlur() {}
};

exports.default = Select;
module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(368);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(508);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(18);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(8);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

__webpack_require__(7);

var _AddressForm = __webpack_require__(10);

var _AddressForm2 = _interopRequireDefault(_AddressForm);

var _dibsOverlaySpinner = __webpack_require__(6);

var _dibsOverlaySpinner2 = _interopRequireDefault(_dibsOverlaySpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// components


var queryConfig = {
    name: 'AddressFormRoute',
    params: {},
    queries: {
        viewer: function viewer(Component, params) {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, _reactRelay2.default.QL.__frag(RQL_0)]),
                    fieldName: 'viewer',
                    kind: 'Query',
                    metadata: {},
                    name: 'AddressFormWrapper',
                    type: 'Viewer'
                };
            }(Component.getFragment('viewer', params));
        }
    }
};

var AddressFormWrapper = function AddressFormWrapper(_ref) {
    var environment = _ref.environment,
        formProps = _objectWithoutProperties(_ref, ['environment']);

    return _react2.default.createElement(_reactRelay2.default.Renderer, {
        environment: environment,
        queryConfig: queryConfig,
        Container: _AddressForm2.default,
        render: function render(_ref2) {
            var done = _ref2.done,
                error = _ref2.error,
                props = _ref2.props;
            // eslint-disable-line
            if (error) {
                return _react2.default.createElement(
                    'div',
                    null,
                    error
                );
            } else if (done) {
                return _react2.default.createElement(_AddressForm2.default, _extends({}, props, formProps));
            } else {
                return _react2.default.createElement(_dibsOverlaySpinner2.default, {
                    size: 'medium',
                    position: 'isRelative',
                    additionalWrapperClasses: _main2.default.block,
                    additionalOverlayClasses: _main2.default.inline,
                    additionalSpinnerClasses: _main2.default.spinner
                });
            }
        }
    });
};

AddressFormWrapper.propTypes = {
    // required
    environment: _propTypes2.default.object.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,

    // optional
    wrapperClass: _propTypes2.default.string,
    formClass: _propTypes2.default.string,
    address: _propTypes2.default.object,
    fields: _propTypes2.default.arrayOf(_propTypes2.default.string),
    disabled: _propTypes2.default.array,
    validations: _propTypes2.default.object,
    autoFocus: _propTypes2.default.bool,
    showCityAndState: _propTypes2.default.bool,
    hideCompany: _propTypes2.default.bool,
    hidePhoneNumber: _propTypes2.default.bool,
    submitLabel: _propTypes2.default.string,
    children: _propTypes2.default.any,
    onMount: _propTypes2.default.func,
    onUpdate: _propTypes2.default.func
};

exports.default = AddressFormWrapper;
module.exports = exports['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(29);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(8);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _dibsAddressValidator = __webpack_require__(26);

var _dibsAddressValidator2 = _interopRequireDefault(_dibsAddressValidator);

var _constants = __webpack_require__(25);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

__webpack_require__(31);

var _FirstName = __webpack_require__(15);

var _FirstName2 = _interopRequireDefault(_FirstName);

var _LastName = __webpack_require__(16);

var _LastName2 = _interopRequireDefault(_LastName);

var _Company = __webpack_require__(13);

var _Company2 = _interopRequireDefault(_Company);

var _Country = __webpack_require__(14);

var _Country2 = _interopRequireDefault(_Country);

var _Line = __webpack_require__(17);

var _Line2 = _interopRequireDefault(_Line);

var _Line3 = __webpack_require__(18);

var _Line4 = _interopRequireDefault(_Line3);

var _City = __webpack_require__(11);

var _City2 = _interopRequireDefault(_City);

var _State = __webpack_require__(20);

var _State2 = _interopRequireDefault(_State);

var _StateUS = __webpack_require__(21);

var _StateUS2 = _interopRequireDefault(_StateUS);

var _ZipCode = __webpack_require__(22);

var _ZipCode2 = _interopRequireDefault(_ZipCode);

var _CityState = __webpack_require__(12);

var _CityState2 = _interopRequireDefault(_CityState);

var _PhoneNumber = __webpack_require__(19);

var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);

var _Submit = __webpack_require__(23);

var _Submit2 = _interopRequireDefault(_Submit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


var AddressForm = function (_Component) {
    _inherits(AddressForm, _Component);

    function AddressForm(props) {
        _classCallCheck(this, AddressForm);

        var _this = _possibleConstructorReturn(this, (AddressForm.__proto__ || Object.getPrototypeOf(AddressForm)).call(this, props));

        var _address = props.address,
            _fields = props.fields,
            disabled = props.disabled,
            showCityAndState = props.showCityAndState,
            hideCompany = props.hideCompany,
            hidePhoneNumber = props.hidePhoneNumber;

        var address = _extends({}, _address, { country: _address.country || 'US' });
        var country = address.country,
            city = address.city,
            state = address.state,
            _address$zipCode = address.zipCode,
            zipCode = _address$zipCode === undefined ? '' : _address$zipCode;

        var fields = _fields.filter(function (f) {
            return !(f === 'company' && hideCompany || f === 'phoneNumber' && hidePhoneNumber);
        });

        _this.onZipCodeDropDown = _this.onZipCodeDropDown.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);

        _this.state = {
            address: fields.reduce(function (o, f) {
                return _extends({}, o, _defineProperty({}, f, address[f] || ''));
            }, {}),
            blurred: fields.reduce(function (o, f) {
                return _extends({}, o, _defineProperty({}, f, false));
            }, {}),
            disabled: fields.reduce(function (o, f) {
                return _extends({}, o, _defineProperty({}, f, disabled.includes(f)));
            }, {}),
            showCityAndState: showCityAndState || !!disabled.zipCode || country !== 'US' || zipCode.length >= 5 && !(city && state),
            isSaving: false
        };
        return _this;
    }

    _createClass(AddressForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.onMount) {
                this.props.onMount();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var address = this.state.address;
            var prevZipCodeLookUp = this.props.viewer.zipCodeLookUp;
            var nextZipCodeLookUp = nextProps.viewer.zipCodeLookUp,
                onUpdate = nextProps.onUpdate;


            var prevCity = (0, _lodash2.default)(prevZipCodeLookUp, '[0].city');
            var prevState = (0, _lodash2.default)(prevZipCodeLookUp, '[0].state');
            var city = (0, _lodash2.default)(nextZipCodeLookUp, '[0].city') || '';
            var state = (0, _lodash2.default)(nextZipCodeLookUp, '[0].state') || '';

            var showCityAndState = address.country !== 'US' || this.state.showCityAndState;
            var shouldUpdate = !!(city && state) && (city !== prevCity || state !== prevState);
            var newAddress = _extends({}, address, { city: city, state: state });

            if (onUpdate) {
                onUpdate({ address: shouldUpdate ? newAddress : address });
            }
            this.setState({
                showCityAndState: showCityAndState || this.state.showCityAndState,
                address: shouldUpdate ? newAddress : address
            });
        }
    }, {
        key: 'onZipCodeDropDown',
        value: function onZipCodeDropDown(_ref) {
            var value = _ref.value;

            this.setState({
                blurred: _extends({}, this.state.blurred, { city: true, state: true }),
                showCityAndState: value === 'otherCityState'
            });
        }
    }, {
        key: 'onValidate',
        value: function onValidate() {
            var address = this.state.address;
            var _props = this.props,
                fields = _props.fields,
                validations = _props.validations,
                hidePhoneNumber = _props.hidePhoneNumber;

            return (0, _dibsAddressValidator2.default)(address, _extends({
                fields: fields,
                isPhoneRequired: !hidePhoneNumber
            }, validations));
        }
    }, {
        key: 'onChange',
        value: function onChange(_ref2) {
            var name = _ref2.name,
                value = _ref2.value;
            var _props2 = this.props,
                relay = _props2.relay,
                onUpdate = _props2.onUpdate;

            var address = _extends({}, this.state.address, _defineProperty({}, name, value));
            var country = address.country,
                zipCode = address.zipCode;


            if (country && zipCode && zipCode.length >= 5) {
                relay.setVariables({ country: country, zipCode: zipCode, canCheckZipCode: true });
            }
            if (onUpdate) {
                onUpdate({ address: address, field: name, value: value });
            }
            this.setState({ address: address });
        }
    }, {
        key: 'onBlur',
        value: function onBlur() {
            var address = this.state.address;

            var blurred = Object.keys(address).reduce(function (obj, field) {
                obj[field] = !!address[field];
                return obj;
            }, {});
            this.setState({ blurred: blurred });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            var address = this.state.address;
            var onSubmit = this.props.onSubmit;

            var _onValidate = this.onValidate(),
                isValid = _onValidate.isValid;

            onSubmit({ address: address, isValid: isValid });

            if (isValid) {
                this.setState({ isSaving: true });
            } else {
                this.setState({
                    blurred: Object.keys(address).reduce(function (obj, field) {
                        return _extends({}, obj, _defineProperty({}, field, true));
                    }, {})
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                address = _state.address,
                blurred = _state.blurred,
                disabled = _state.disabled,
                showCityAndState = _state.showCityAndState,
                isSaving = _state.isSaving;
            var _props3 = this.props,
                geography = _props3.viewer.geography,
                children = _props3.children,
                wrapperClass = _props3.wrapperClass,
                formClass = _props3.formClass,
                autoFocus = _props3.autoFocus,
                submitLabel = _props3.submitLabel;

            var _onValidate2 = this.onValidate(),
                errors = _onValidate2.errors,
                isValid = _onValidate2.isValid;

            var formClasses = (0, _classnames2.default)(_main2.default.form, formClass);
            var labelClasses = (0, _classnames2.default)(_main2.default.right, _main2.default.text);
            var isCountryUS = address.country === 'US';
            var isCityStateKnown = !!(address.city && address.state);
            var countries = geography.countries.map(function (country) {
                return { label: country.name, value: country.abbreviation };
            });
            var usStates = geography.usStates.map(function (state) {
                return { label: state.name, value: state.abbreviation };
            });
            var cityStateOptions = [{ value: 'cityState', label: address.city + ', ' + address.state }, { value: 'otherCityState', label: 'Other city and state' }];

            var props = Object.keys(address).reduce(function (obj, field) {
                return _extends({}, obj, _defineProperty({}, field, {
                    value: address[field],
                    error: errors[field],
                    isBlurred: blurred[field],
                    isDisabled: isSaving || disabled[field],
                    onChange: _this2.onChange,
                    onBlur: _this2.onBlur
                }));
            }, {});

            var showName = !!(props.firstName && props.lastName);
            var showCompany = !!props.company;
            var showCountry = !!props.country;
            var showLine1 = !!props.line1;
            var showLine2 = !!props.line2;
            var showZipCode = !!props.zipCode;
            var showCity = !isCountryUS || showCityAndState || !!disabled.city;
            var showState = !isCountryUS;
            var showStateUS = isCountryUS && (showCityAndState || !!disabled.state);
            var showCityStateDropDown = isCountryUS && !showCityAndState && isCityStateKnown && !disabled.zipCode;
            var showCityStateLabel = isCountryUS && !showCityStateDropDown && !isCityStateKnown;
            var showPhoneNumber = !!props.phoneNumber;

            return _react2.default.createElement(
                'div',
                { className: wrapperClass },
                _react2.default.createElement(
                    'form',
                    { className: formClasses },
                    showName && _react2.default.createElement(
                        'div',
                        { className: _main2.default.group, 'data-field': 'displayName' },
                        _react2.default.createElement(_FirstName2.default, _extends({}, props.firstName, { autoFocus: autoFocus })),
                        _react2.default.createElement(_LastName2.default, props.lastName)
                    ),
                    showCompany && _react2.default.createElement(_Company2.default, props.company),
                    showCountry && _react2.default.createElement(_Country2.default, _extends({}, props.country, { options: countries })),
                    showLine1 && _react2.default.createElement(_Line2.default, props.line1),
                    showLine2 && _react2.default.createElement(_Line4.default, props.line2),
                    showCity && _react2.default.createElement(_City2.default, props.city),
                    showState && _react2.default.createElement(_State2.default, props.state),
                    showStateUS && _react2.default.createElement(_StateUS2.default, _extends({}, props.state, { options: usStates })),
                    showZipCode && _react2.default.createElement(
                        'div',
                        { className: _main2.default.group, 'data-field': 'zipCode' },
                        _react2.default.createElement(_ZipCode2.default, _extends({}, props.zipCode, { isCountryUS: isCountryUS })),
                        showCityStateDropDown && _react2.default.createElement(_CityState2.default, {
                            value: 'cityState',
                            city: address.city,
                            state: address.state,
                            options: cityStateOptions,
                            isBlurred: blurred.zipCode,
                            isDisabled: isSaving,
                            onChange: this.onZipCodeDropDown
                        }),
                        showCityStateLabel && _react2.default.createElement(
                            'label',
                            { className: labelClasses },
                            'Enter ZIP code for City and State'
                        )
                    ),
                    showPhoneNumber && _react2.default.createElement(
                        'div',
                        { className: _main2.default.group, 'data-field': 'phoneNumber' },
                        _react2.default.createElement(_PhoneNumber2.default, props.phoneNumber),
                        _react2.default.createElement(
                            'label',
                            { className: labelClasses },
                            'For shipping questions only'
                        )
                    ),
                    children
                ),
                _react2.default.createElement(_Submit2.default, {
                    label: submitLabel || 'Save',
                    isDisabled: isSaving || !isValid,
                    isSaving: isSaving,
                    onClick: this.onSubmit
                })
            );
        }
    }]);

    return AddressForm;
}(_react.Component);

AddressForm.propTypes = {
    relay: _propTypes2.default.object.isRequired,
    viewer: _propTypes2.default.object.isRequired,
    wrapperClass: _propTypes2.default.string,
    formClass: _propTypes2.default.string,
    address: _propTypes2.default.object,
    fields: _propTypes2.default.arrayOf(_propTypes2.default.string),
    disabled: _propTypes2.default.array,
    validations: _propTypes2.default.object,
    autoFocus: _propTypes2.default.bool,
    showCityAndState: _propTypes2.default.bool,
    hideCompany: _propTypes2.default.bool,
    hidePhoneNumber: _propTypes2.default.bool,
    submitLabel: _propTypes2.default.string,
    children: _propTypes2.default.any,
    onMount: _propTypes2.default.func,
    onUpdate: _propTypes2.default.func,
    onSubmit: _propTypes2.default.func.isRequired
};

AddressForm.defaultProps = {
    wrapperClass: '',
    formClass: '',
    address: {},
    fields: _constants.Fields,
    disabled: [],
    validations: {},
    autoFocus: false,
    showCityAndState: false,
    hideCompany: false,
    hidePhoneNumber: false
};

exports.default = _reactRelay2.default.createContainer(AddressForm, {
    initialVariables: {
        zipCode: null,
        country: null,
        canCheckZipCode: false
    },
    prepareVariables: function prepareVariables(prevVariables) {
        var country = prevVariables.country,
            _prevVariables$zipCod = prevVariables.zipCode,
            zipCode = _prevVariables$zipCod === undefined ? '' : _prevVariables$zipCod;

        return _extends({}, prevVariables, {
            canCheckZipCode: country === 'US' && zipCode.length >= 5
        });
    },
    fragments: {
        viewer: function viewer(variables) {
            return function () {
                return {
                    children: [{
                        children: [{
                            children: [{
                                fieldName: 'name',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'abbreviation',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'countries',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'GeographyObject'
                        }, {
                            children: [{
                                fieldName: 'name',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'abbreviation',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'usStates',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'GeographyObject'
                        }],
                        fieldName: 'geography',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true
                        },
                        type: 'Geography'
                    }, {
                        alias: 'zipCodeLookUp',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'zipCode',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'zipCode'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'country',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'country'
                            }
                        }],
                        children: [{
                            fieldName: 'city',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'state',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'canCheckZipCode'
                                }
                            }]
                        }],
                        fieldName: 'zipCode',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id',
                            isPlural: true
                        },
                        type: 'Address'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: _reactRelay2.default.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'AddressForm_ViewerRelayQL',
                    type: 'Viewer'
                };
            }();
        }
    }
});
module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Text = __webpack_require__(3);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CityInput = function CityInput(_ref) {
    var value = _ref.value,
        autoFocus = _ref.autoFocus,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Text2.default, {
        name: 'city',
        value: value,
        wrapperClass: _main2.default.leftGroup,
        placeholder: 'City',
        autoComplete: 'address-level2',
        autoFocus: autoFocus,
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


CityInput.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    autoFocus: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

CityInput.defaultProps = {
    autoFocus: false,
    onBlur: function onBlur() {}
};

exports.default = CityInput;
module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Select = __webpack_require__(5);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CityState = function CityState(_ref) {
    var value = _ref.value,
        options = _ref.options,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Select2.default, {
        name: 'cityStateOptions',
        value: value,
        wrapperClass: _main2.default.right,
        options: options,
        placeHolder: 'City & state',
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


CityState.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    options: _propTypes2.default.array.isRequired,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

CityState.defaultProps = {
    onBlur: function onBlur() {}
};

exports.default = CityState;
module.exports = exports['default'];

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Text = __webpack_require__(3);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyInput = function CompanyInput(_ref) {
    var value = _ref.value,
        autoFocus = _ref.autoFocus,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Text2.default, {
        name: 'company',
        value: value,
        wrapperClass: _main2.default.group,
        placeholder: 'Company',
        autoComplete: 'organization',
        autoFocus: autoFocus,
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


CompanyInput.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    autoFocus: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

CompanyInput.defaultProps = {
    autoFocus: false,
    onBlur: function onBlur() {}
};

exports.default = CompanyInput;
module.exports = exports['default'];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Select = __webpack_require__(5);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Country = function Country(_ref) {
    var value = _ref.value,
        options = _ref.options,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Select2.default, {
        name: 'country',
        value: value,
        wrapperClass: _main2.default.group,
        options: options,
        isClearable: true,
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


Country.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    options: _propTypes2.default.array.isRequired,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

Country.defaultProps = {
    onBlur: function onBlur() {}
};

exports.default = Country;
module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Text = __webpack_require__(3);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FirstName = function FirstName(_ref) {
    var value = _ref.value,
        autoFocus = _ref.autoFocus,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Text2.default, {
        name: 'firstName',
        value: value,
        wrapperClass: _main2.default.left,
        placeholder: 'First Name',
        autoComplete: 'given-name',
        autoFocus: autoFocus,
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


FirstName.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    autoFocus: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

FirstName.defaultProps = {
    autoFocus: false,
    onBlur: function onBlur() {}
};

exports.default = FirstName;
module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Text = __webpack_require__(3);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LastName = function LastName(_ref) {
    var value = _ref.value,
        autoFocus = _ref.autoFocus,
        error = _ref.error,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Text2.default, {
        name: 'lastName',
        value: value,
        wrapperClass: _main2.default.right,
        placeholder: 'Last Name',
        autoComplete: 'family-name',
        autoFocus: autoFocus,
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


LastName.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    autoFocus: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

LastName.defaultProps = {
    autoFocus: false,
    onBlur: function onBlur() {}
};

exports.default = LastName;
module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Text = __webpack_require__(3);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Line1 = function Line1(_ref) {
    var value = _ref.value,
        autoFocus = _ref.autoFocus,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Text2.default, {
        name: 'line1',
        value: value,
        wrapperClass: _main2.default.group,
        placeholder: 'Address',
        autoComplete: 'address-line1',
        autoFocus: autoFocus,
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


Line1.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    autoFocus: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

Line1.defaultProps = {
    autoFocus: false,
    onBlur: function onBlur() {}
};

exports.default = Line1;
module.exports = exports['default'];

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Text = __webpack_require__(3);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Line2 = function Line2(_ref) {
    var value = _ref.value,
        autoFocus = _ref.autoFocus,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Text2.default, {
        name: 'line2',
        value: value,
        wrapperClass: _main2.default.group,
        placeholder: 'Apt, suite, etc. (optional)',
        autoComplete: 'address-line2',
        autoFocus: autoFocus,
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


Line2.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    autoFocus: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

Line2.defaultProps = {
    autoFocus: false,
    onBlur: function onBlur() {}
};

exports.default = Line2;
module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Text = __webpack_require__(3);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhoneNumber = function PhoneNumber(_ref) {
    var value = _ref.value,
        autoFocus = _ref.autoFocus,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Text2.default, {
        name: 'phoneNumber',
        value: value,
        wrapperClass: _main2.default.left,
        type: 'tel',
        pattern: '\\\\d*',
        autoComplete: 'tel',
        placeholder: 'Phone Number',
        autoFocus: autoFocus,
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


PhoneNumber.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    autoFocus: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

PhoneNumber.defaultProps = {
    autoFocus: false,
    onBlur: function onBlur() {}
};

exports.default = PhoneNumber;
module.exports = exports['default'];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Text = __webpack_require__(3);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var State = function State(_ref) {
    var value = _ref.value,
        autoFocus = _ref.autoFocus,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Text2.default, {
        name: 'state',
        value: value,
        wrapperClass: _main2.default.leftGroup,
        placeholder: 'State or Region (optional)',
        autoFocus: autoFocus,
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


State.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    autoFocus: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

State.defaultProps = {
    autoFocus: false,
    onBlur: function onBlur() {}
};

exports.default = State;
module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Select = __webpack_require__(5);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StateUS = function StateUS(_ref) {
    var value = _ref.value,
        options = _ref.options,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Select2.default, {
        name: 'state',
        value: value,
        autoComplete: 'state',
        wrapperClass: _main2.default.leftGroup,
        options: options,
        isClearable: true,
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


StateUS.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    options: _propTypes2.default.array.isRequired,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

StateUS.defaultProps = {
    onBlur: function onBlur() {}
};

exports.default = StateUS;
module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

var _Text = __webpack_require__(3);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZipCode = function ZipCode(_ref) {
    var value = _ref.value,
        autoFocus = _ref.autoFocus,
        isCountryUS = _ref.isCountryUS,
        isBlurred = _ref.isBlurred,
        isDisabled = _ref.isDisabled,
        error = _ref.error,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur;
    return _react2.default.createElement(_Text2.default, {
        name: 'zipCode',
        value: value,
        wrapperClass: _main2.default.left,
        placeholder: 'Zip Code',
        autoComplete: 'postal-code',
        autoFocus: autoFocus,
        pattern: isCountryUS ? '\\d*' : '.*',
        isBlurred: isBlurred,
        isDisabled: isDisabled,
        error: error,
        onChange: onChange,
        onBlur: onBlur
    });
};

// components


ZipCode.propTypes = {
    value: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    autoFocus: _propTypes2.default.bool,
    isCountryUS: _propTypes2.default.bool,
    isBlurred: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func
};

ZipCode.defaultProps = {
    autoFocus: false,
    isCountryUS: false,
    onBlur: function onBlur() {}
};

exports.default = ZipCode;
module.exports = exports['default'];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

__webpack_require__(28);

__webpack_require__(7);

var _Primary = __webpack_require__(27);

var _Primary2 = _interopRequireDefault(_Primary);

var _dibsOverlaySpinner = __webpack_require__(6);

var _dibsOverlaySpinner2 = _interopRequireDefault(_dibsOverlaySpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// components


var Submit = function Submit(_ref) {
    var _classNames;

    var label = _ref.label,
        isSaving = _ref.isSaving,
        isDisabled = _ref.isDisabled,
        onClick = _ref.onClick;

    var buttonClasses = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _main2.default.button, true), _defineProperty(_classNames, _main2.default.buttonDisabled, isDisabled), _classNames));
    return _react2.default.createElement(
        _Primary2.default,
        { className: buttonClasses, disabled: isSaving, onClick: onClick },
        isSaving && _react2.default.createElement(_dibsOverlaySpinner2.default, {
            size: 'small',
            position: 'isStatic',
            additionalWrapperClasses: _main2.default.spinnerWrapper,
            additionalSpinnerClasses: _main2.default.inline
        }),
        isSaving ? 'Saving...' : label
    );
};

Submit.propTypes = {
    label: _propTypes2.default.string.isRequired,
    isDisabled: _propTypes2.default.bool,
    isSaving: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired
};

Submit.defaultProps = {
    isDisabled: false,
    isSaving: false
};

exports.default = Submit;
module.exports = exports['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddressFormWrapper = __webpack_require__(9);

var _AddressFormWrapper2 = _interopRequireDefault(_AddressFormWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AddressFormWrapper2.default;
module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Fields = ['firstName', 'lastName', 'company', 'line1', 'line2', 'country', 'city', 'state', 'zipCode', 'phoneNumber'];

exports.Fields = Fields;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(842);

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(696);

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1742);

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1598);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(333);

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1746);

/***/ })
/******/ ]);

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__(1606);

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__(1604);

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _hoistNonReactStatics = __webpack_require__(749);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    (0, _hoistNonReactStatics2.default)(NewComponent, BaseComponent);
    return NewComponent;
  };
};

exports.default = hoistStatics;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
};

exports.default = isClassComponent;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isClassComponent = __webpack_require__(1603);

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && ('production' === 'production' || !Component.propTypes));
};

exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHelper = __webpack_require__(1212);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(1601);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (props) {
      return factory(propsMapper(props));
    };
  };
};

exports.default = (0, _createHelper2.default)(mapProps, 'mapProps');

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component = type;

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

exports.default = createEagerElementUtil;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createHelper = __webpack_require__(1212);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _mapProps = __webpack_require__(1605);

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withProps = function withProps(input) {
  return (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
};

exports.default = (0, _createHelper2.default)(withProps, 'withProps');

/***/ }),
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.composeCopy = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*global __DEV__*/


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(386);

var _invariant2 = _interopRequireDefault(_invariant);

var _lodash = __webpack_require__(1623);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(1624);

var _lodash4 = _interopRequireDefault(_lodash3);

var _getDisplayName = __webpack_require__(1622);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  Does some checks before setting on the composed copy object
 */
var setComposedCopyKey = function setComposedCopyKey(composedCopy, key, value) {
    if (false) {
        (0, _invariant2.default)(typeof composedCopy[key] === 'undefined', 'Key "%s" is already defined with copy: "%s"', key, composedCopy[key]);

        (0, _invariant2.default)(typeof value !== 'undefined', 'Copy value for key "%s" is "undefined". Most likely missing from ' + 'the context (global) copy', key);
    }
    composedCopy[key] = value;
};

/**
 *  Creates the composed copy using the copy from context and the passed-in
 *  array of configs
 */
var composeCopy = exports.composeCopy = function composeCopy() {
    var contextCopy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var configsArr = arguments[1];
    return configsArr.reduce(function (composedCopy, options) {
        var keys = options.keys;
        var copy = options.copy,
            path = options.path;


        if (false) {
            (0, _invariant2.default)(keys && !copy || !keys && copy, // XOR
            'Found "keys" and "copy" in copy object. Only one should exist ' + 'in a single copy object');
        }

        // Passed-in keys checks the context for copy
        if (keys) {
            keys = Array.isArray(keys) ? keys : [keys];
            keys.forEach(function (key) {
                if ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object') {
                    // Renaming key using format { 'originalKey': 'newKey' }
                    Object.keys(key).forEach(function (originalKey) {
                        var newKey = key[originalKey];
                        setComposedCopyKey(composedCopy, newKey, (0, _lodash2.default)(contextCopy, path ? path + '.' + originalKey : originalKey));
                    });
                } else {
                    setComposedCopyKey(composedCopy, key, (0, _lodash2.default)(contextCopy, path ? path + '.' + key : key));
                }
            });
        }

        // Passed-in copy is it's own set of copy, transfer to composed copy
        if (copy) {
            Object.keys(copy).forEach(function (key) {
                if (false) {
                    var copyKeyType = _typeof(copy[key]);
                    (0, _invariant2.default)(copyKeyType === 'string', 'Passed option "copy" should be object of strings only, ' + 'instead found type "%s" for key "%s"', copyKeyType, key);
                }
                setComposedCopyKey(composedCopy, key, copy[key]);
            });
        }

        return composedCopy;
    }, {});
};

exports.default = function () {
    for (var _len = arguments.length, configsArr = Array(_len), _key = 0; _key < _len; _key++) {
        configsArr[_key] = arguments[_key];
    }

    // Cache so all uses of this instance of the HOC don't have to repeat
    // the processing
    var copyCache = void 0;

    return function (BaseComponent) {
        var baseComponentName = (0, _getDisplayName2.default)(BaseComponent);
        var wrappedDisplayName = 'copier(' + baseComponentName + ')';

        if (false) {

            // If BaseComponent has propTypes.copy defined, check that it's set as
            // PropTypes.func (and PropTypes.func.isRequired)
            (0, _invariant2.default)(!BaseComponent.propTypes || BaseComponent.propTypes.copy === _propTypes2.default.func || BaseComponent.propTypes.copy === _propTypes2.default.func.isRequired || BaseComponent.propTypes.copy === _react2.default.PropTypes.func || BaseComponent.propTypes.copy === _react2.default.PropTypes.func.isRequired, '%s.propType.copy is not set as React.PropTypes.func[.isRequired]', baseComponentName);
        }

        var Copied = function (_Component) {
            _inherits(Copied, _Component);

            function Copied(props) {
                _classCallCheck(this, Copied);

                var _this = _possibleConstructorReturn(this, (Copied.__proto__ || Object.getPrototypeOf(Copied)).call(this, props));

                _this.getCopy = _this.getCopy.bind(_this);
                return _this;
            }

            _createClass(Copied, [{
                key: 'componentWillMount',
                value: function componentWillMount() {
                    if (!copyCache) {
                        copyCache = composeCopy((0, _lodash2.default)(this.context, 'copier.copy'), configsArr);
                    }
                    this._copy = copyCache;
                }
            }, {
                key: '_getCopyByKey',
                value: function _getCopyByKey(key, params) {
                    if (false) {
                        (0, _invariant2.default)(Object.keys(this._copy).indexOf(key) >= 0, 'No copy defined for key "%s" in component "%s"', key, wrappedDisplayName);
                    }
                    if (params) {
                        return (0, _lodash4.default)((0, _lodash2.default)(this._copy, key))(params);
                    }
                    return (0, _lodash2.default)(this._copy, key);
                }
            }, {
                key: 'getCopy',
                value: function getCopy(key, params) {
                    var _this2 = this;

                    if (Array.isArray(key)) {
                        return key.reduce(function (copyObj, currKey) {
                            copyObj[currKey] = _this2._getCopyByKey(currKey, params);
                            return copyObj;
                        }, {});
                    } else {
                        return this._getCopyByKey(key, params);
                    }
                }
            }, {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(BaseComponent, _extends({}, this.props, { copy: this.getCopy }));
                }
            }]);

            return Copied;
        }(_react.Component);

        Copied.displayName = wrappedDisplayName;
        Copied.contextTypes = {
            copier: _propTypes2.default.shape({
                copy: _propTypes2.default.object
            })
        };

        return Copied;
    };
};

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getDisplayName = function getDisplayName(BaseComponent) {
    if (typeof BaseComponent === 'string') {
        return BaseComponent;
    }
    if (!BaseComponent) {
        return undefined;
    }
    return BaseComponent.displayName || BaseComponent.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var reInterpolate = __webpack_require__(1145),
    templateSettings = __webpack_require__(1625);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Used by `_.defaults` to customize its `_.assignIn` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function assignInDefaults(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  return (objectToString.call(value) == errorTag) ||
    (typeof value.message == 'string' && typeof value.name == 'string');
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, assignInDefaults);

  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp(
    (options.escape || reNoMatch).source + '|' +
    interpolate.source + '|' +
    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
    (options.evaluate || reNoMatch).source + '|$'
  , 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
    .replace(reEmptyStringMiddle, '$1')
    .replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' +
    (variable
      ? ''
      : 'obj || (obj = {});\n'
    ) +
    "var __t, __p = ''" +
    (isEscaping
       ? ', __e = _.escape'
       : ''
    ) +
    (isEvaluating
      ? ', __j = Array.prototype.join;\n' +
        "function print() { __p += __j.call(arguments, '') }\n"
      : ';\n'
    ) +
    source +
    'return __p\n}';

  var result = attempt(function() {
    return Function(importsKeys, sourceURL + 'return ' + source)
      .apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function(func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

module.exports = template;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var reInterpolate = __webpack_require__(1145);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g,
    reEvaluate = /<%([\s\S]+?)%>/g;

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB). Change the following template settings to use
 * alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape }
  }
};

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

module.exports = templateSettings;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1626 */,
/* 1627 */,
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = pdpDisplayHelper;

var _item = __webpack_require__(1219);

var itemSelectors = _interopRequireWildcard(_item);

var _buyerDisplayHelper = __webpack_require__(1216);

var _buyerDisplayHelper2 = _interopRequireDefault(_buyerDisplayHelper);

var _getPricingData2 = __webpack_require__(1217);

var _getPricingData3 = _interopRequireDefault(_getPricingData2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function pdpDisplayHelper(_ref) {
    var buyerId = _ref.buyerId,
        _ref$buyerHasTradePer = _ref.buyerHasTradePermission,
        buyerHasTradePermission = _ref$buyerHasTradePer === undefined ? false : _ref$buyerHasTradePer,
        item = _ref.item,
        _ref$tradeMakeOfferCT = _ref.tradeMakeOfferCTATestRunning,
        tradeMakeOfferCTATestRunning = _ref$tradeMakeOfferCT === undefined ? false : _ref$tradeMakeOfferCT;

    if (!item) {
        throw new Error('Item is required');
    }

    var itemIsFurniture = itemSelectors.isFurniture(item);
    var salePrice = itemSelectors.getSalePrice(item);
    var retailPrice = itemSelectors.getRetailPrice(item);
    var netPrice = itemSelectors.getNetPrice(item);

    var _getPricingData = (0, _getPricingData3.default)({
        salePrice: salePrice,
        netPrice: netPrice,
        retailPrice: retailPrice
    }),
        pricingShowSale = _getPricingData.pricingShowSale,
        pricingNegotiableRetail = _getPricingData.pricingNegotiableRetail,
        pricingNegotiableSale = _getPricingData.pricingNegotiableSale,
        pricingData = _objectWithoutProperties(_getPricingData, ['pricingShowSale', 'pricingNegotiableRetail', 'pricingNegotiableSale']);

    // NOTE: For not showing Make Offer when there is a sale or net tradeable


    var customNegotiableRetailCheck = !pricingShowSale && (!buyerHasTradePermission || !itemIsFurniture);

    var displays = (0, _buyerDisplayHelper2.default)(_extends({
        buyerHasTradePermission: buyerHasTradePermission,
        buyerOwnsActiveHold: itemSelectors.isActiveHoldByBuyerId(item)(buyerId),

        itemIsFurniture: itemIsFurniture,
        itemIsOnHold: itemSelectors.isOnHold(item),
        itemIsSold: itemSelectors.isSold(item),

        pricingShowSale: pricingShowSale,
        pricingNegotiableSale: pricingNegotiableSale,
        pricingNegotiableRetail: pricingNegotiableRetail && customNegotiableRetailCheck
    }, pricingData));

    return {
        getShowCTAs: function getShowCTAs() {
            var ctaDisplays = displays.getShowCTAs();
            var priceDisplays = displays.getShowPrices();
            var showMakeOfferCTA = ctaDisplays.showMakeOfferCTA;


            if (!showMakeOfferCTA) {
                showMakeOfferCTA = tradeMakeOfferCTATestRunning && buyerHasTradePermission && !priceDisplays.showSold && !priceDisplays.showOnHold && (pricingNegotiableRetail || pricingNegotiableSale);
            }

            return _extends({}, ctaDisplays, { showMakeOfferCTA: showMakeOfferCTA });
        },
        getShowPrices: function getShowPrices() {
            return displays.getShowPrices();
        }
    };
}

/***/ }),
/* 1629 */,
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = baseRest(function(object, props) {
  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
});

module.exports = pick;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(1153);
var invariant = __webpack_require__(489);
var ReactPropTypesSecret = __webpack_require__(1634);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1632)();
}


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = "<svg version=\"1.1\" class=\"dibsvg-svg dibsvg-arrow-left\" viewBox=\"-8.5 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <path d=\"M14,32c-0.3,0-0.6-0.1-0.8-0.3l-13-15c-0.3-0.4-0.3-0.9,0-1.3l13-15c0.4-0.4,1-0.5,1.4-0.1 c0.4,0.4,0.5,1,0.1,1.4L2.3,16l12.4,14.3c0.4,0.4,0.3,1-0.1,1.4C14.4,31.9,14.2,32,14,32z\" />\n</svg>";

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = "<svg version=\"1.1\" class=\"dibsvg-svg dibsvg-arrow-right\" viewBox=\"-8.5 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <path d=\"M1,0c0.3,0,0.6,0.1,0.8,0.3l13,15c0.3,0.4,0.3,0.9,0,1.3l-13,15c-0.4,0.4-1,0.5-1.4,0.1 c-0.4-0.4-0.5-1-0.1-1.4L12.6,16L0.2,1.7c-0.4-0.4-0.3-1,0.1-1.4C0.5,0.1,0.8,0,1,0z\" />\n</svg>";

/***/ }),
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"BuyerAssuranceTooltip-style__title__1Nb29","body":"BuyerAssuranceTooltip-style__body__2z7Qm","hr":"BuyerAssuranceTooltip-style__hr__3hAPi","wrapper":"BuyerAssuranceTooltip-style__wrapper__2tcNm","content":"BuyerAssuranceTooltip-style__content__22_Tf","triangle":"BuyerAssuranceTooltip-style__triangle__3VIAL"};

/***/ }),
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dibs":"ConnectAccountsModal-style__dibs__19cNj","pinterest":"ConnectAccountsModal-style__pinterest__2My_G","dibsIcon":"ConnectAccountsModal-style__dibsIcon__2AWtj","pinterestIcon":"ConnectAccountsModal-style__pinterestIcon__OUd5U","dibsImage":"ConnectAccountsModal-style__dibsImage__v-3Vy","pinterestImage":"ConnectAccountsModal-style__pinterestImage__2N7uL","overlay":"ConnectAccountsModal-style__overlay__2mRwC","modal":"ConnectAccountsModal-style__modal__1XiIi","infoRow":"ConnectAccountsModal-style__infoRow__2zB9Y","title":"ConnectAccountsModal-style__title__2vYlM","price":"ConnectAccountsModal-style__price__2bKAe","seller":"ConnectAccountsModal-style__seller__1BYFn","content":"ConnectAccountsModal-style__content__16UU7","close":"ConnectAccountsModal-style__close__1IZDB","header":"ConnectAccountsModal-style__header__3z3D5","description":"ConnectAccountsModal-style__description__3O3kW","contentHolder":"ConnectAccountsModal-style__contentHolder__1C31k","star":"ConnectAccountsModal-style__star__1gXvQ","arrow":"ConnectAccountsModal-style__arrow__WSN6s","pinterestFooter":"ConnectAccountsModal-style__pinterestFooter__2Mytv","button":"ConnectAccountsModal-style__button__yy2Wn","footerLink":"ConnectAccountsModal-style__footerLink__1X7yu"};

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"ConnectBoardModal-style__overlay__22-dU","modal":"ConnectBoardModal-style__modal__2Dyxu","isCentered":"ConnectBoardModal-style__isCentered__1qOKn","title":"ConnectBoardModal-style__title___A1H3","imageWrapper":"ConnectBoardModal-style__imageWrapper__2XbTT","image":"ConnectBoardModal-style__image__1loZj","fieldLabel":"ConnectBoardModal-style__fieldLabel__3ZL7B","fieldInput":"ConnectBoardModal-style__fieldInput__3-Kad","error":"ConnectBoardModal-style__error__1DuEi","fieldSubHeader":"ConnectBoardModal-style__fieldSubHeader__a-Qwn","buttonWrapper":"ConnectBoardModal-style__buttonWrapper__3E0JQ","button":"ConnectBoardModal-style__button__1UGh9"};

/***/ }),
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"unitLabel":"Measurement-style__unitLabel__256tr","divider":"Measurement-style__divider__3wY6t"};

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DetailsInvoice__wrapper__2PS3z","returnModalLink":"DetailsInvoice__returnModalLink__86H7i","title":"DetailsInvoice__title__2CAIb","tooltipContainer":"DetailsInvoice__tooltipContainer__XQjQu"};

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DetailsReturnModal__wrapper__K70JV","body":"DetailsReturnModal__body__pRCbG","titleWrapper":"DetailsReturnModal__titleWrapper__3lpJ2","titleText":"DetailsReturnModal__titleText__3V20c","titlePlaceholder":"DetailsReturnModal__titlePlaceholder__18uiN","titleClose":"DetailsReturnModal__titleClose__1yZoz","returnPolicy":"DetailsReturnModal__returnPolicy__1brVH","returnPolicyLine":"DetailsReturnModal__returnPolicyLine__3UrgH","guarantee":"DetailsReturnModal__guarantee__2TKps","guaranteeLine":"DetailsReturnModal__guaranteeLine__R-Pka","guaranteeText":"DetailsReturnModal__guaranteeText__19gAZ","guaranteeHeader":"DetailsReturnModal__guaranteeHeader__uu_2t _headers__bodyHeaderPrimaryLarge__PYw4x"};

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"ProductionLeadTime__title__25Duh"};

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ShippingDetailsModal__wrapper__2S81r"};

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DetailsFooter__wrapper__Jedcz","quoteWrapper":"DetailsFooter__quoteWrapper__2iLG6 DetailsFooter__wrapper__Jedcz","quoteWrapperNoQuotes":"DetailsFooter__quoteWrapperNoQuotes__22p2z DetailsFooter__quoteWrapper__2iLG6 DetailsFooter__wrapper__Jedcz","noQuotes":"DetailsFooter__noQuotes__11LFK DetailsFooter__quoteWrapper__2iLG6 DetailsFooter__wrapper__Jedcz","somewhereElse":"DetailsFooter__somewhereElse__1kTE3","customsWrapper":"DetailsFooter__customsWrapper__1RFMt DetailsFooter__wrapper__Jedcz"};

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dataPoint":"DetailsQuotes__dataPoint__3yELI","value":"DetailsQuotes__value__2QQzd","quote":"DetailsQuotes__quote__3mVGf","wrapper":"DetailsQuotes__wrapper__1YMjf","boundaryHeader":"DetailsQuotes__boundaryHeader__2oGzw","column":"DetailsQuotes__column__20Eof","method":"DetailsQuotes__method__3Dt0c","price":"DetailsQuotes__price__3YwFH","applyFreeShipping":"DetailsQuotes__applyFreeShipping__3O2XJ"};

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DetailsTitle__wrapper__1zEY5 _headers__headerPrimaryLarge__ZHchg","closeWrapper":"DetailsTitle__closeWrapper__2cCYS","close":"DetailsTitle__close__3QvRs","headerBottomBorder":"DetailsTitle__headerBottomBorder__lwNOs"};

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Header__container__2UCrH"};

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"creditCardIcon":"payment-methods__creditCardIcon__3qOY4"};

/***/ }),
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1743 */,
/* 1744 */,
/* 1745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var styles = __webpack_require__(1692);

var BuyerAssuranceTooltip = React.createClass({
    displayName: 'BuyerAssuranceTooltip',

    propTypes: {
        trackLinkClick: PropTypes.func,
        showInfo: PropTypes.bool.isRequired,
        copy: PropTypes.shape({
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired
        })
    },

    onClick: function onClick(e) {
        // clicks on the window outside the tooltip should close the tooltip so added e.stopPropagation() here to
        // prevent this event from propagating to the window.addEventListener('click' ...) on the pdp and checkout
        e.stopPropagation();

        if (this.props.trackLinkClick && e.target.tagName === "A") {
            this.props.trackLinkClick();
        }
    },
    render: function render() {
        var _props$copy = this.props.copy,
            title = _props$copy.title,
            text = _props$copy.text;

        // Only render if showInfo is true

        if (!this.props.showInfo) {
            return null;
        }

        return React.createElement(
            'div',
            { className: styles.wrapper, onClick: this.onClick },
            React.createElement(
                'div',
                { className: styles.content },
                React.createElement(
                    'div',
                    { key: 'buyer-assurance-tooltip-title',
                        className: styles.title },
                    title
                ),
                React.createElement('hr', { className: styles.hr }),
                React.createElement('div', { key: 'buyer-assurance-tooltip-text',
                    className: styles.body,
                    dangerouslySetInnerHTML: { __html: text } })
            ),
            React.createElement('div', { className: styles.triangle + ' triangle down' })
        );
    }
});

module.exports = BuyerAssuranceTooltip;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1453);
var Backbone = __webpack_require__(3);

var _require = __webpack_require__(1892),
    template = _require.carouselBinTemplate;

/**
 * Represents the area of an image carousel that displays additional images that can be viewed. This can be hooked into
 * a full carousel component by passing in callbacks that will be called whenever an image changes. There are some quirks
 * regarding the number of images shown at a given time. By default, 5 are shown and the CSS is setup to make this work.
 * If a custom number is passed, the CSS must also be overridden to ensure the correct number are shown. Ideally this
 * would be driven entirely by either JS or CSS instead.
 *
 * @param  {array} options.images An array of images to display in the view. Images should have a `src` attribute containing the location of the image.
 * @param  {boolean} [options.numberVisible=5] The number of images to show at any one time.
 * @param  {boolean} [options.jumpToImageCallback] Callback that fires when an image in the bin is clicked on directly.
 * @param  {boolean} [options.updateImageCallback] Callback that fires whenever the image is updated.
 * @return {object}
 */


var CarouselBin = Backbone.BaseView.extend({

    events: {
        'click .carousel-bin-image-wrapper': '_jumpToImage'
    },

    initialize: function initialize() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this._images = options.images || [];
        this._numberVisible = options.numberVisible || 5;
        this._jumpToImageCallback = options.jumpToImageCallback;
        this._updateImageCallback = options.updateImageCallback;

        this._selected = 0;
        // Keeps track of the index of the leftmost visible image.
        this._leftIndex = 0;
        this._offset = 0;
    },
    render: function render() {
        this.setElement(template({
            images: this._images.map(function (image) {
                return image.src;
            })
        }));

        this.$images = this.$('.carousel-bin-image-wrapper');

        if (this.$images.length === 1) {
            this.$images.addClass('is-invisible');
        }

        return this;
    },


    /**
     * Move to the next image.
     * @param  {function} callback Callback that will be passed the index of the new image.
     */
    next: function next(callback) {
        var imagesLength = this._images.length;
        var newSelected = this._selected + 1;

        // Keep us within range.
        if (newSelected >= imagesLength) {
            newSelected = 0;
            this._leftIndex = 0;

            // Detrmines whether or not the bin should scroll to the left, revealing a new image on the right and hiding one
            // on the left.
        } else if (this._leftIndex + this._numberVisible - 1 < imagesLength - 1) {
            this._leftIndex += 1;
        }

        this._setSelected(newSelected, callback);
        this._toggleSelectedClass();
        this._translatePosition();
    },


    /**
     * Move to the previous image.
     * @param  {function} callback Callback that will be passed the index of the new image.
     */
    previous: function previous(callback) {
        var lastIndex = this._images.length - 1;
        var newSelected = this._selected - 1;

        // Keep us within range.
        if (newSelected < 0) {
            newSelected = lastIndex;
            this._leftIndex = Math.max(0, lastIndex - (this._numberVisible - 1));

            // Detrmines whether or not the bin should scroll to the right, revealing a new image on the left and hiding one
            // on the right.
        } else if (this._leftIndex > 0) {
            this._leftIndex -= 1;
        }

        this._setSelected(newSelected, callback);
        this._toggleSelectedClass();
        this._translatePosition();
    },


    /**
     * Directly set the selected image and the leftmost visible image. Useful for if the view state needs to be
     * updated based on something happening elsewhere on the page.
     * @param {number} selected  New image to select.
     * @param {number} leftIndex  Leftmost visible image.
     */
    setPosition: function setPosition(selected, leftIndex) {
        // If nothing is passed in, jsut keep the existing state.
        selected = typeof selected !== 'undefined' ? selected : this._selected;
        leftIndex = typeof leftIndex !== 'undefined' ? leftIndex : this._leftIndex;

        this._leftIndex = leftIndex;

        this._setSelected(selected);
        this._translatePosition();
        this._toggleSelectedClass();
    },


    /**
     * Returns the index of the selected image.
     * @return {number}
     */
    getSelected: function getSelected() {
        return this._selected;
    },


    /**
     * Updates the selected image from clicking directly on the bin.
     * @param  {object} e
     */
    _jumpToImage: function _jumpToImage(e) {
        var target = e.currentTarget;
        // Fix for IE10 not supporting `dataset`.
        var index = target.dataset ? target.dataset.index : target.getAttribute('data-index');

        // The index is added as a data attribute during rendering so we can just grab it here.
        this._setSelected(Number(index), this._jumpToImageCallback);
        this._toggleSelectedClass();
    },


    /**
     * Helper method to get the width of an image. It is caches after the first call. This assumed the images don't
     * change size after the initial open. Ideally images should be resizable and this should get the new size.
     * @return {number} Image width.
     */
    _getImageWidth: function _getImageWidth() {
        if (!this._imageWidth) {
            this._imageWidth = this.$images.get(0).clientWidth;
        }

        return this._imageWidth;
    },


    /**
     * Adds transformation to the images in the bin to give them a sliding effect.
     */
    _translatePosition: function _translatePosition() {
        this._offset = this._getImageWidth() * -this._leftIndex;

        // JQuery adds the proper vendor prefixes automatically.
        this.$images.css({ transform: 'translate(' + this._offset + 'px)' });
    },


    /**
     * Sets the `selected` class on the newly selected image.
     */
    _toggleSelectedClass: function _toggleSelectedClass() {
        if (this.$selected) {
            this.$selected.removeClass('selected');
        }

        this.$selected = this.$('[data-index="' + this._selected + '"]');
        this.$selected.addClass('selected');
    },


    /**
     * Actually sets the newly selected image and calls the callbacks.
     * @param {number}   newSelected
     * @param {function} callback Callback only called if the new image is different from the currently selected image.
     */
    _setSelected: function _setSelected(newSelected, callback) {
        if (this._selected === newSelected) {
            return;
        }

        this._selected = newSelected;

        if (typeof this._updateImageCallback === 'function') {
            this._updateImageCallback(this._selected);
        }

        if (typeof callback === 'function') {
            callback(this._selected);
        }
    }
});

module.exports = CarouselBin;

/***/ }),
/* 1794 */,
/* 1795 */,
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);

var get = __webpack_require__(14);

var _require = __webpack_require__(334),
    getUserId = _require.getUserId,
    cookieJarConstants = _require.cookieJarConstants;

var MASQUERADE_BUYER = cookieJarConstants.MASQUERADE_BUYER;

var pdpDisplayHelper = __webpack_require__(1628).default;

var classNames = __webpack_require__(16);
var css = __webpack_require__(766);

// Button components
var PurchaseCartButton = __webpack_require__(1278);
var MakeOfferButton = __webpack_require__(1277);
var RequestPriceButton = __webpack_require__(1797);
var RequestNetPriceButton = __webpack_require__(1279);

/**
 * ItemCTAButtons: A stateless component that returns a set of action buttons, similar to
 * ItemActionButtons, based on CTAs passed in from dibs-display-helpers.
 *
 * @param {Object} root
 * @param {Object} [root.ctas] - (Test only) preconfigured CTA flags
 * @param {Object} root.item - The item to prepare buttons for.
 * @param {string} root.itemId - The current itemId.
 * @param {Object} root.props - Props that should be passed down into the buttons.
 * @param {string} [root.containerClass] - The class name to pass down.
 * @param {string} [root.user] - User lookup result from GraphQL.
 * @returns component or null
 */
function ItemCTAButtons(inputProps) {
    var item = inputProps.item,
        itemId = inputProps.itemId,
        _inputProps$user = inputProps.user,
        user = _inputProps$user === undefined ? null : _inputProps$user,
        _inputProps$props = inputProps.props,
        props = _inputProps$props === undefined ? {} : _inputProps$props,
        _inputProps$tradeMake = inputProps.tradeMakeOfferCTATestRunning,
        tradeMakeOfferCTATestRunning = _inputProps$tradeMake === undefined ? false : _inputProps$tradeMake,
        _inputProps$makeOffer = inputProps.makeOfferPurchaseSwapTestRunning,
        makeOfferPurchaseSwapTestRunning = _inputProps$makeOffer === undefined ? false : _inputProps$makeOffer;
    var _inputProps$ctas = inputProps.ctas,
        ctas = _inputProps$ctas === undefined ? null : _inputProps$ctas,
        containerClass = inputProps.containerClass;


    var buyerId = getUserId(document.cookie, MASQUERADE_BUYER);

    var buyerHasTradePermission = get(user, 'canUseNetPrice');
    if (user && typeof user.canRequestNetPrice === 'function') {
        buyerHasTradePermission = user.canRequestNetPrice();
    }

    var returnValue = [];
    containerClass = containerClass || classNames(css.itemActionWidget, 'boxSizingWrapper');

    ctas = ctas || pdpDisplayHelper({
        item: item.toJSON ? item.toJSON() : item,
        buyerId: buyerId,
        buyerHasTradePermission: buyerHasTradePermission,
        tradeMakeOfferCTATestRunning: tradeMakeOfferCTATestRunning
    }).getShowCTAs();

    /*
     * Handle logged-in users that are loading.
     *
     * Logged-in users that have not loaded will have a truthy buyerId and falsy user object.
     * Logged-in users that have loaded will have truthy buyerId and user object.
     * Logged-out users will have a falsy buyerId and user object.
     *
     * If a logged-in user is waiting for the GraphQL call to complete, reserve space based on the
     * item's requirements.  The item will always determine the number of buttons to be displayed,
     * while the user object (and the buyerHasTradePermission derived from the user object) dictates
     * which buttons will be displayed.
     */
    if (!user && buyerId) {
        var placeholder = css.placeholderOneButton;
        // do not need to check ctas.showRequestNetCTA here, since buyerHasTradePermission will always
        // be false without the user object
        if (!ctas.showRequestCTA && ctas.showPurchaseCTA && ctas.showMakeOfferCTA) {
            placeholder = css.placeholderTwoButtons;
        }
        containerClass = classNames(css.itemActionWidget, placeholder, 'boxSizingWrapper');
    } else {
        if (ctas.showRequestCTA) {
            // Since this is referenced differently in its contexts (PDP sidebar, favorites),
            // it will provide its own padding.
            return React.createElement(RequestPriceButton, props);
        }

        //If 'Swap Make Offer - Purchase CTAs' test is running 'Purchase' must go after 'Make Offer' and only when 'Make Offer' is being shown
        if (ctas.showPurchaseCTA && (!makeOfferPurchaseSwapTestRunning || ctas.showRequestNetCTA)) {
            returnValue.push(React.createElement(PurchaseCartButton, _extends({ key: 'purchaseCart-' + itemId }, props)));
        }

        if (ctas.showRequestNetCTA) {
            returnValue.push(React.createElement(RequestNetPriceButton, _extends({ key: 'requestNetPrice-' + itemId }, props)));
        } else if (ctas.showMakeOfferCTA) {
            returnValue.push(React.createElement(MakeOfferButton, _extends({ key: 'makeOffer-' + itemId }, props, { makeOfferPurchaseSwapTestRunning: makeOfferPurchaseSwapTestRunning })));
        }

        //If 'Swap Make Offer - Purchase CTAs' test is running 'Purchase' must become secondary when 'Make Offer' is being shown, othewise it remains primary
        if (ctas.showPurchaseCTA && makeOfferPurchaseSwapTestRunning && !ctas.showRequestNetCTA) {
            returnValue.push(React.createElement(PurchaseCartButton, _extends({ key: 'purchaseCart-' + itemId }, props, { makeOfferPurchaseSwapTestRunning: makeOfferPurchaseSwapTestRunning && ctas.showMakeOfferCTA })));
        }
    }

    return React.createElement(
        'div',
        { className: containerClass },
        returnValue
    );
}

ItemCTAButtons.propTypes = {
    ctas: PropTypes.object,
    itemId: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    containerClass: PropTypes.string,
    props: PropTypes.object,
    user: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    wrapResult: PropTypes.bool
};

ItemCTAButtons.contextTypes = {
    executeAction: PropTypes.func.isRequired
};

var Connected = Relay.createContainer(ItemCTAButtons, {
    fragments: {
        user: function user() {
            return function () {
                return {
                    children: [{
                        fieldName: 'canUseNetPrice',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ItemCTAButtons_UserRelayQL',
                    type: 'User'
                };
            }();
        }
    }
});

module.exports = {
    Connected: Connected,
    Raw: ItemCTAButtons
};

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var css = __webpack_require__(766);

function RequestPriceButton(props) {
    return React.createElement(
        'div',
        { className: css.itemActionWidget },
        React.createElement(
            'button',
            { className: props.requestButtonClass || 'button button-primary button-large', onClick: props.onClick, 'data-tn': 'item-actions-request-information' },
            props.requestButtonCopy || 'request price'
        )
    );
}

RequestPriceButton.propTypes = {
    requestButtonCopy: PropTypes.string,
    requestButtonClass: PropTypes.string,
    onClick: PropTypes.func.isRequired
};

module.exports = RequestPriceButton;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

// Stores
var UserStore = __webpack_require__(109);
var PriceStore = __webpack_require__(367);
var ItemStore = __webpack_require__(336);

// Components
var FormattedPrice = __webpack_require__(636);

var _require = __webpack_require__(1282),
    ReducedPrice = _require.Connected;

var _require2 = __webpack_require__(1280),
    NetPrice = _require2.Connected;

// Styles


var priceStyles = __webpack_require__(633);
var styles = __webpack_require__(805);

// Helpers
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var pageTypes = __webpack_require__(383);
var classnames = __webpack_require__(16);

var Price = function Price(props) {
    var _classnames;

    var _props$copy = props.copy,
        copy = _props$copy === undefined ? {} : _props$copy,
        context = props.context,
        priceDisplays = props.priceDisplays,
        isSold = props.isSold,
        isSoldIndividually = props.isSoldIndividually,
        isUnlisted = props.isUnlisted,
        currencyLoaded = props.currencyLoaded,
        currency = props.currency,
        retailPrice = props.retailPrice,
        showReducedFrom = props.showReducedFrom,
        pageType = props.pageType,
        showTour = props.showTour;
    var showSalePrice = priceDisplays.showSalePrice,
        showNetPrice = priceDisplays.showNetPrice,
        showRetailPrice = priceDisplays.showRetailPrice,
        showPriceUponRequest = priceDisplays.showPriceUponRequest;

    var priceStates = copy.priceStates || {};
    var sold = priceStates.sold,
        unavailable = priceStates.unavailable,
        uponRequest = priceStates.uponRequest;

    var isPdp = pageType === pageTypes.PAGE_TYPE.PDP;
    var doNotShowFormattedPrice = isSold || isUnlisted || showPriceUponRequest ? true : false;

    var wrapperClasses = classnames('cf', (_classnames = {
        'pdp-price': isPdp
    }, _defineProperty(_classnames, styles.price, isPdp), _defineProperty(_classnames, priceStyles.portfolio, pageType === pageTypes.PAGE_TYPE.FAVORITES), _classnames));

    var priceEl = void 0;

    if (isSold || isUnlisted) {
        var price = isSold ? sold : unavailable;

        priceEl = React.createElement(FormattedPrice, {
            isSoldIndividually: isSoldIndividually,
            copy: copy,
            priceDisplays: priceDisplays,
            doNotShowFormattedPrice: doNotShowFormattedPrice,
            price: price,
            currency: currency
        });
    } else if (showSalePrice) {
        return React.createElement(ReducedPrice, { context: context, showReducedFrom: showReducedFrom });
    } else if (showNetPrice) {
        return React.createElement(NetPrice, { context: context, showTour: showTour, pageType: pageType });
    } else if ((showPriceUponRequest || showRetailPrice) && currencyLoaded) {
        priceEl = React.createElement(FormattedPrice, {
            isSoldIndividually: isSoldIndividually,
            copy: copy,
            priceDisplays: priceDisplays,
            doNotShowFormattedPrice: doNotShowFormattedPrice,
            price: showRetailPrice ? retailPrice : uponRequest,
            currency: currency
        });
    }

    return React.createElement(
        'div',
        { className: wrapperClasses, 'data-tn': 'pdp-price-wrapper' },
        React.createElement(
            'div',
            { className: 'notranslate', 'data-tn': 'item-details-price' },
            priceEl
        )
    );
};

Price.defaultProps = {
    showReducedFrom: true,
    showTour: false
};

Price.propTypes = {
    context: PropTypes.object,
    copy: PropTypes.object.isRequired,
    currency: PropTypes.string,
    currencyLoaded: PropTypes.bool,
    isSold: PropTypes.bool.isRequired,
    isUnlisted: PropTypes.bool.isRequired,
    isSoldIndividually: PropTypes.bool.isRequired,
    pageType: PropTypes.string.isRequired,
    price: PropTypes.number,
    priceDisplays: PropTypes.object.isRequired,
    retailPrice: PropTypes.number,
    showReducedFrom: PropTypes.bool,
    showTour: PropTypes.bool
};

var ConnectedPrice = provideContext(connectToStores(Price, [ItemStore, PriceStore, UserStore], function (context) {
    var userStore = context.getStore(UserStore);
    var itemStore = context.getStore(ItemStore);
    var priceStore = context.getStore(PriceStore);
    var item = itemStore.getItem();
    var processedPriceData = priceStore.processPrice(item);
    var _processedPriceData$n = processedPriceData.netPriceData,
        netPriceData = _processedPriceData$n === undefined ? {} : _processedPriceData$n,
        _processedPriceData$r = processedPriceData.retailPriceData,
        retailPriceData = _processedPriceData$r === undefined ? {} : _processedPriceData$r,
        priceDisplays = processedPriceData.priceDisplays;

    return {
        copy: itemStore.getCopy(),
        currency: userStore.getCurrency(),
        currencyLoaded: userStore.isCurrencyLoaded(),
        isSold: itemStore.getIsSold(),
        isSoldIndividually: itemStore.getSoldIndividually(netPriceData.model || retailPriceData.model),
        isUnlisted: itemStore.getIsUnlisted(),
        price: retailPriceData.price || null,
        priceDisplays: priceDisplays,
        retailPrice: retailPriceData.price
    };
}));

module.exports = {
    Price: ConnectedPrice,
    Raw: Price
};

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var InfoCircleIcon = __webpack_require__(437);

var QuickViewButton = React.createClass({
    displayName: 'QuickViewButton',


    propTypes: {
        onClick: PropTypes.func.isRequired
    },

    render: function render() {
        return React.createElement(
            'a',
            { onClick: this.props.onClick, className: 'quick-view-button' },
            React.createElement(InfoCircleIcon, null)
        );
    }
});

module.exports = QuickViewButton;

/***/ }),
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var intelligentFormat = __webpack_require__(93);

var pinterestUtils = __webpack_require__(714);
var style = __webpack_require__(1711);

// Actions
var pinterestActions = __webpack_require__(710);

// Components
var ContextComponent = __webpack_require__(61);
var LogoNoRegIcon = __webpack_require__(763);
var HeartFilledIcon = __webpack_require__(389);
var ArrowRightIcon = __webpack_require__(351);
var PinterestIcon = __webpack_require__(494);
var CloseIcon = __webpack_require__(276);
var Modal = __webpack_require__(596);
var SanitizeHtml = __webpack_require__(296);

var ALLOWED_TAGS = ['br', 'a', 'span'];
var ALLOWED_ATTRIBUTES = {
    a: ['href', 'target', 'rel', 'title'],
    span: ['class']
};

var ConnectAccountsModal = function (_ContextComponent) {
    _inherits(ConnectAccountsModal, _ContextComponent);

    function ConnectAccountsModal(props) {
        _classCallCheck(this, ConnectAccountsModal);

        var _this = _possibleConstructorReturn(this, (ConnectAccountsModal.__proto__ || Object.getPrototypeOf(ConnectAccountsModal)).call(this, props));

        _this.close = _this.close.bind(_this);
        _this.openOath = _this.openOath.bind(_this);
        return _this;
    }

    _createClass(ConnectAccountsModal, [{
        key: 'openOath',
        value: function openOath() {
            var tracking = this.props.tracking;

            var pinterestWindow = pinterestUtils.openWindow();
            this.context.executeAction(pinterestActions.track, tracking.connectClicked);
            this.context.executeAction(pinterestActions.connectAccounts, {
                pinterestWindow: pinterestWindow,
                tracking: tracking.connectSuccessful
            });
        }
    }, {
        key: 'close',
        value: function close(event) {
            event.preventDefault();
            this.context.executeAction(pinterestActions.hideConnectAccountsModal);
        }
    }, {
        key: '_getContent',
        value: function _getContent() {
            var item = this.props.item;


            if (item) {
                var _ref = item || {},
                    title = _ref.title,
                    image = _ref.image,
                    seller = _ref.seller;

                return React.createElement(
                    'div',
                    { className: style.contentHolder },
                    React.createElement(
                        'div',
                        { className: style.dibs },
                        React.createElement(LogoNoRegIcon, { className: style.dibsIcon }),
                        React.createElement('img', { className: style.dibsImage, src: image }),
                        React.createElement(
                            'div',
                            { className: style.title },
                            title
                        ),
                        this._getPrice(),
                        React.createElement(
                            'div',
                            { className: style.seller },
                            seller
                        ),
                        React.createElement(HeartFilledIcon, { className: style.star }),
                        React.createElement(ArrowRightIcon, { className: style.arrow })
                    ),
                    React.createElement(
                        'div',
                        { className: style.pinterest },
                        React.createElement(PinterestIcon, { className: style.pinterestIcon }),
                        React.createElement('img', { className: style.pinterestImage, src: image }),
                        React.createElement(
                            'div',
                            { className: style.pinterestFooter },
                            'from 1stdibs.com'
                        )
                    )
                );
            }
        }
    }, {
        key: '_getPrice',
        value: function _getPrice() {
            var _props = this.props,
                currency = _props.currency,
                price = _props.item.price;


            if (price) {
                return React.createElement(
                    'div',
                    { className: style.price },
                    intelligentFormat(price, currency)
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var copy = this.props.copy;


            return React.createElement(
                Modal,
                { isOpen: this.props.isOpen,
                    className: style.modal,
                    overlayClassName: style.overlay,
                    canClose: false },
                React.createElement(
                    'div',
                    { className: style.content },
                    React.createElement(
                        'a',
                        { onClick: this.close, href: '' },
                        React.createElement(CloseIcon, { className: style.close })
                    ),
                    React.createElement(
                        'h2',
                        { className: style.header },
                        copy.header
                    ),
                    React.createElement(
                        'p',
                        { className: style.description },
                        React.createElement(SanitizeHtml, { allowedTags: ALLOWED_TAGS,
                            allowedAttributes: ALLOWED_ATTRIBUTES,
                            content: copy.description })
                    ),
                    this._getContent(),
                    React.createElement(
                        'button',
                        { onClick: this.openOath,
                            className: style.button + ' button-large button-primary' },
                        copy.cta
                    ),
                    React.createElement(
                        'a',
                        { onClick: this.close,
                            className: style.footerLink + ' italic',
                            href: '' },
                        copy.cancel
                    )
                )
            );
        }
    }]);

    return ConnectAccountsModal;
}(ContextComponent);

ConnectAccountsModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    item: PropTypes.object,
    currency: PropTypes.string,
    copy: PropTypes.object.isRequired,
    tracking: PropTypes.object,
    style: PropTypes.shape({
        content: PropTypes.object,
        overlay: PropTypes.object
    })
};

module.exports = ConnectAccountsModal;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var find = __webpack_require__(916);
var ContextComponent = __webpack_require__(61);
var style = __webpack_require__(1712);

// Components
var Select = __webpack_require__(333);
var CloseIcon = __webpack_require__(276);
var Modal = __webpack_require__(596);
var SanitizeHtml = __webpack_require__(296);

// Actions
var pinterestActions = __webpack_require__(710);

var ConnectBoardModal = function (_ContextComponent) {
    _inherits(ConnectBoardModal, _ContextComponent);

    function ConnectBoardModal(props) {
        _classCallCheck(this, ConnectBoardModal);

        var _this = _possibleConstructorReturn(this, (ConnectBoardModal.__proto__ || Object.getPrototypeOf(ConnectBoardModal)).call(this, props));

        _this._onBoardChange = _this._onBoardChange.bind(_this);
        _this._doneClick = _this._doneClick.bind(_this);
        _this._close = _this._close.bind(_this);

        _this.state = {
            boardChanged: false,
            boardId: 'default',
            boardName: _this._getDefaultBoardName()
        };
        return _this;
    }

    _createClass(ConnectBoardModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var isOpen = this.props.isOpen;
            var boardChanged = this.state.boardChanged;
            var boardId = this.state.boardId;


            if (!isOpen && nextProps.isOpen) {
                boardId = 'default';
                this.setState({ boardId: boardId, boardChanged: false });
            }

            var connectedBoard = this.props.connectedBoard;

            var defaultBoard = this._findDefaultBoard(nextProps);
            var connectedId = 'default';
            var boardName = this._getDefaultBoardName();

            if (connectedBoard) {
                connectedId = connectedBoard.id;
                boardName = connectedBoard.name;
            } else if (defaultBoard) {
                connectedId = defaultBoard.id;
            }

            if (!boardChanged) {
                this.setState({
                    boardId: connectedId,
                    boardName: boardName
                });
            }
        }
    }, {
        key: '_getDefaultBoardName',
        value: function _getDefaultBoardName() {
            var defaultBoardName = this.props.copy.defaultBoardName;

            return defaultBoardName;
        }
    }, {
        key: '_findDefaultBoard',
        value: function _findDefaultBoard(props) {
            var _this2 = this;

            var _ref = props || this.props,
                boards = _ref.boards;

            var defaultBoard = find(boards, function (board) {
                return board.name === _this2._getDefaultBoardName();
            });

            return defaultBoard;
        }
    }, {
        key: '_close',
        value: function _close(event) {
            var connectedBoard = this.props.connectedBoard;

            event.preventDefault();

            if (connectedBoard) {
                this.context.executeAction(pinterestActions.hideConnectBoardModal);
            } else {
                this._saveBoard();
            }
        }
    }, {
        key: '_doneClick',
        value: function _doneClick() {
            var boardName = this.state.boardName;
            var _props = this.props,
                connectedBoard = _props.connectedBoard,
                tracking = _props.tracking;


            this._saveBoard();

            if (connectedBoard && boardName === connectedBoard.name || !connectedBoard && boardName === this._getDefaultBoardName()) {
                this.context.executeAction(pinterestActions.track, tracking.boardUnchanged);
            } else {
                this.context.executeAction(pinterestActions.track, tracking.boardUpdated);
            }
        }
    }, {
        key: '_onBoardChange',
        value: function _onBoardChange(selectedItems) {
            var name = selectedItems.name,
                id = selectedItems.id;

            var boardChanged = true;
            this.setState({ boardId: id, boardName: name, boardChanged: boardChanged });
        }
    }, {
        key: '_saveBoard',
        value: function _saveBoard() {
            var id = this.state.boardId;


            if (id === 'default') {
                this._saveDefaultBoard();
            } else {
                this.context.executeAction(pinterestActions.connectBoard, { id: id });
            }
        }
    }, {
        key: '_saveDefaultBoard',
        value: function _saveDefaultBoard() {
            this.context.executeAction(pinterestActions.createAndConnectBoard, {
                name: this._getDefaultBoardName()
            });
        }

        /**
         * Gets pinterest boards and checks if default board name is among saved boards,
         * if not then ushifts (puts default board name to first array position) boards array
         * with default board data
         * @return {Array} pinterest boards
         */

    }, {
        key: '_getBoards',
        value: function _getBoards() {
            var boards = this.props.boards;

            var boardsCopy = boards.slice(0);
            var defaultBoardName = this._getDefaultBoardName();

            if (boardsCopy.length) {
                var defaultBoard = this._findDefaultBoard();

                if (!defaultBoard) {
                    boardsCopy.unshift({
                        id: 'default',
                        name: defaultBoardName
                    });
                }
            }

            return boardsCopy;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isOpen = _props2.isOpen,
                copy = _props2.copy,
                error = _props2.error;
            var boardId = this.state.boardId;

            var errorMessage = null;

            if (error) {
                errorMessage = React.createElement(
                    'div',
                    { className: style.error },
                    React.createElement(SanitizeHtml, { content: copy.boardConflict })
                );
            }

            return React.createElement(
                Modal,
                { isOpen: isOpen,
                    className: style.modal,
                    overlayClassName: style.overlay,
                    canClose: false },
                React.createElement(
                    'div',
                    { className: 'modal-inner-content' },
                    React.createElement(
                        'div',
                        { className: 'modal-header' },
                        copy.header
                    ),
                    React.createElement(
                        'div',
                        { className: 'modal-body' },
                        React.createElement(
                            'div',
                            { className: 'modal-simple-message' },
                            React.createElement(SanitizeHtml, { content: copy.message })
                        ),
                        errorMessage,
                        React.createElement(
                            'label',
                            { className: style.fieldLabel },
                            'Board Name'
                        ),
                        React.createElement(
                            'div',
                            { className: style.fieldInput },
                            React.createElement(Select, { name: 'board',
                                onChange: this._onBoardChange,
                                searchable: false,
                                clearable: false,
                                value: boardId,
                                labelKey: 'name',
                                valueKey: 'id',
                                options: this._getBoards() })
                        ),
                        React.createElement(
                            'div',
                            { className: style.fieldSubHeader },
                            React.createElement(SanitizeHtml, { content: copy.hint })
                        ),
                        React.createElement(
                            'button',
                            { onClick: this._doneClick, className: style.button + ' button button-medium button-primary' },
                            copy.cta
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'modal-close' },
                    React.createElement(
                        'a',
                        { onClick: this._close, className: 'modal-close-btn', href: '' },
                        React.createElement(CloseIcon, { className: style.close })
                    )
                )
            );
        }
    }]);

    return ConnectBoardModal;
}(ContextComponent);

ConnectBoardModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    connectedBoard: PropTypes.object,
    boards: PropTypes.array.isRequired,
    copy: PropTypes.object.isRequired,
    tracking: PropTypes.object,
    style: PropTypes.shape({
        content: PropTypes.object,
        overlay: PropTypes.object
    })
};

module.exports = ConnectBoardModal;

/***/ }),
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(302),
    createEnum = _require.createEnum;

// Simple enum for device types.


module.exports = createEnum('mobile', 'tablet', 'desktop');

/***/ }),
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(30);

module.exports = {
    inlineDatesAdverb: {
        calendar: {
            sameDay: '[at] h:mmA',
            lastDay: '[on] MMMM D',
            nextDay: '[on] MMMM D',
            lastWeek: '[on] MMMM D',
            nextWeek: '[on] MMMM D',
            sameElse: function sameElse(now) {
                return '[on] MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
            }
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        }
    }
};

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Component = React.Component;

var classnames = __webpack_require__(16);
var LazyLoad = __webpack_require__(738).default;

var MediaQuery = __webpack_require__(378);

var _require = __webpack_require__(365),
    queries = _require.queries;

var deviceTypeEnum = __webpack_require__(1838);

var ModalCarouselTracking = __webpack_require__(1196);
var PdpActions = __webpack_require__(796);
var ModalCarousel = __webpack_require__(1574);
var CarouselItem = __webpack_require__(896);

var _require2 = __webpack_require__(639),
    ArrowCarousel = _require2.ArrowCarousel,
    SwipeCarousel = _require2.SwipeCarousel;

var MobileZoomModal = __webpack_require__(1846);
var ZoomModal = __webpack_require__(1847);
var pdpTrackingActions = __webpack_require__(379);

/**
 * Carousel for the PDP hero.
 * @class
 */

var Carousel = function (_Component) {
    _inherits(Carousel, _Component);

    function Carousel(props) {
        _classCallCheck(this, Carousel);

        var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this._handleImageClick = _this._handleImageClick.bind(_this);
        _this._handleImageChange = _this._handleImageChange.bind(_this);
        _this._onThumbnailClick = _this._onThumbnailClick.bind(_this);
        _this._updatePage = _this._updatePage.bind(_this);
        _this._closeModal = _this._closeModal.bind(_this);
        _this._onZoomModalLeftArrowClick = _this._onZoomModalLeftArrowClick.bind(_this);
        _this._onZoomModalRightArrowClick = _this._onZoomModalRightArrowClick.bind(_this);

        _this._tracking = new ModalCarouselTracking({
            owner: props.owner,
            imagesLength: props.images.length
        });

        _this.state = {
            index: 0,
            modalOpen: props.isStaticModal
        };
        return _this;
    }

    _createClass(Carousel, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.isStaticModal) {
                this._tracking.showModal(this.state.index);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            // fire event only when opening the modal
            if (this.state.modalOpen && !prevState.modalOpen) {
                this._tracking.showModal(this.state.index);
            }
        }
    }, {
        key: '_handleImageClick',
        value: function _handleImageClick(startingIndex) {
            // Re-use the modal if it's already been opened before.
            if (!this.modalCarousel) {
                var _props = this.props,
                    item = _props.item,
                    images = _props.images,
                    siteProtocol = _props.siteProtocol,
                    socialData = _props.socialData;

                this.modalCarousel = new ModalCarousel({
                    model: item,
                    // Update this carousel's page if the modal carousel changes pages.
                    updateImageCallback: this.refs.inner.setPage,
                    // The modal is a backbone view so we need to pass the flux context to it in order to render react
                    // subviews within.
                    context: this.context,
                    siteProtocol: siteProtocol,
                    socialData: socialData,
                    images: images
                }).render();
            }

            // Make sure the modal carousel displays the same image as this one by passing in the current page number.
            this.modalCarousel.show(startingIndex);
        }
    }, {
        key: '_handleImageChange',
        value: function _handleImageChange(index) {
            // Fire an event on page change in case other parts of the page need to respond.
            this.context.executeAction(PdpActions.setIndex, { index: index });
            // Re-render when the page changes.
            this.setState({ index: index });
        }
    }, {
        key: '_getChildren',
        value: function _getChildren(deviceType) {
            var _this2 = this;

            var _props2 = this.props,
                images = _props2.images,
                title = _props2.title;

            var className = classnames('pdp-hero-carousel-image', {
                'is-zoom': !deviceType.isMobile()
            });

            return images.map(function (image, index) {
                var imageProps = {
                    alt: title + ' ' + (index + 1),
                    className: className,
                    src: image.large.src,
                    index: index,
                    onClick: function onClick() {
                        return _this2.setState({ modalOpen: true });
                    }
                };

                if (index === 0) {
                    return React.createElement(CarouselItem, _extends({}, imageProps, { key: index }));
                }

                return React.createElement(
                    LazyLoad,
                    { className: 'pdp-hero-carousel-lazy', offsetHorizontal: 300, key: index },
                    React.createElement(CarouselItem, imageProps)
                );
            });
        }
    }, {
        key: '_getCarousel',
        value: function _getCarousel(deviceType) {
            var _props3 = this.props,
                style = _props3.style,
                index = _props3.index;

            var ref = 'inner';
            var itemsPerPage = 1;
            var onPageChange = this._handleImageChange;
            var classNames = { list: 'pdp-hero-carousel-list' };
            var props = {};
            var carouselType = void 0;

            if (window && 'ontouchstart' in window && (deviceType.isMobile() || deviceType.isTablet())) {
                carouselType = SwipeCarousel;
            } else {
                carouselType = ArrowCarousel;
                props = {
                    onRightArrowClick: this._onRightArrowClick.bind(this),
                    onLeftArrowClick: this._onLeftArrowClick.bind(this)
                };
            }

            return React.createElement(carouselType, Object.assign({}, props, {
                children: this._getChildren(deviceType),
                style: style,
                ref: ref,
                itemsPerPage: itemsPerPage,
                classNames: classNames,
                onPageChange: onPageChange,
                startingPage: index
            }));
        }
    }, {
        key: '_onRightArrowClick',
        value: function _onRightArrowClick(page) {
            this.context.executeAction(pdpTrackingActions.trackNextImageClick, {
                image: page + 1, // `page` is zero-indexed
                totalImages: this.props.images.length
            });
        }
    }, {
        key: '_onLeftArrowClick',
        value: function _onLeftArrowClick(page) {
            this.context.executeAction(pdpTrackingActions.trackPreviousImageClick, {
                image: page + 1, // `page` is zero-indexed
                totalImages: this.props.images.length
            });
        }
    }, {
        key: '_onZoomModalRightArrowClick',
        value: function _onZoomModalRightArrowClick(page) {
            this._tracking.nextClick(page);
        }
    }, {
        key: '_onZoomModalLeftArrowClick',
        value: function _onZoomModalLeftArrowClick(page) {
            this._tracking.previousClick(page);
        }
    }, {
        key: '_onThumbnailClick',
        value: function _onThumbnailClick(page) {
            this._tracking.thumbnailClick(page);
        }
    }, {
        key: '_updatePage',
        value: function _updatePage(page) {
            this.refs.inner.setPage(page);
        }
    }, {
        key: '_closeModal',
        value: function _closeModal() {
            var onCloseModal = this.props.onCloseModal;

            if (onCloseModal) {
                onCloseModal();
            } else {
                this.setState({ modalOpen: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                index = _state.index,
                modalOpen = _state.modalOpen;
            var _props4 = this.props,
                context = _props4.context,
                owner = _props4.owner,
                wrapperClasses = _props4.wrapperClasses,
                images = _props4.images,
                vertical = _props4.vertical,
                itemId = _props4.itemId,
                itemPk = _props4.itemPk,
                title = _props4.title,
                heartComponent = _props4.heartComponent,
                siteProtocol = _props4.siteProtocol,
                socialData = _props4.socialData,
                pinterest = _props4.pinterest,
                style = _props4.style,
                mobileStyle = _props4.mobileStyle,
                stfOnClick = _props4.stfOnClick,
                isPrintPage = _props4.isPrintPage;


            return React.createElement(
                'div',
                { className: 'pdp-hero-carousel', 'data-tn': 'pdp-image-carousel' },
                React.createElement(
                    MediaQuery,
                    { query: [queries.lg, queries.xl], exclude: true },
                    this._getCarousel(deviceTypeEnum.mobile())
                ),
                React.createElement(
                    MediaQuery,
                    { query: queries.lg },
                    this._getCarousel(deviceTypeEnum.tablet())
                ),
                React.createElement(
                    MediaQuery,
                    { query: queries.xl },
                    this._getCarousel(deviceTypeEnum.desktop())
                ),
                React.createElement(
                    'span',
                    { className: 'pdp-hero-carousel-indicator' },
                    index + 1 + ' of ' + images.length + ' images'
                ),
                !isPrintPage && React.createElement(
                    MediaQuery,
                    { query: [queries.lg, queries.xl], exclude: true },
                    React.createElement(MobileZoomModal, {
                        owner: owner,
                        isOpen: modalOpen,
                        style: mobileStyle || style,
                        images: images,
                        startingIndex: index,
                        onIndexChange: this._updatePage,
                        onRequestClose: this._closeModal
                    })
                ),
                !isPrintPage && React.createElement(
                    MediaQuery,
                    { query: [queries.lg, queries.xl] },
                    React.createElement(ZoomModal, {
                        context: context,
                        owner: owner,
                        heartComponent: heartComponent,
                        wrapperClasses: wrapperClasses,
                        overlayClassName: 'modal-carousel-overlay',
                        isOpen: modalOpen,
                        pinterest: pinterest,
                        style: style,
                        vertical: vertical,
                        itemId: itemId,
                        siteProtocol: siteProtocol,
                        socialData: socialData,
                        itemPk: itemPk,
                        title: title,
                        images: images,
                        startingIndex: index,
                        stfOnClick: stfOnClick,
                        onThumbnailClick: this._onThumbnailClick,
                        onIndexChange: this._updatePage,
                        onRequestClose: this._closeModal,
                        onLeftArrowClick: this._onZoomModalLeftArrowClick,
                        onRightArrowClick: this._onZoomModalRightArrowClick
                    })
                )
            );
        }
    }]);

    return Carousel;
}(Component);

Carousel.propTypes = {
    context: PropTypes.object,
    owner: PropTypes.string,
    heartComponent: PropTypes.object,
    wrapperClasses: PropTypes.string,
    isStaticModal: PropTypes.bool,
    style: PropTypes.object,
    mobileStyle: PropTypes.object,
    socialData: PropTypes.object,
    pinterest: PropTypes.object,
    images: PropTypes.array.isRequired,
    item: PropTypes.object.isRequired,
    itemId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    siteProtocol: PropTypes.string.isRequired,
    vertical: PropTypes.string.isRequired,
    itemPk: PropTypes.string.isRequired,
    stfOnClick: PropTypes.func.isRequired,
    onCloseModal: PropTypes.func,
    isPrintPage: PropTypes.bool,
    index: PropTypes.number.isRequired
};

Carousel.defaultTypes = {
    isStaticModal: false
};

Carousel.contextTypes = {
    executeAction: PropTypes.func.isRequired,
    getStore: PropTypes.func.isRequired
};

module.exports = Carousel;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var tracking = __webpack_require__(27);
var ContextComponent = __webpack_require__(61);
var Modal = __webpack_require__(596);

var _require = __webpack_require__(67),
    noop = _require.noop;

var _require2 = __webpack_require__(639),
    SwipeCarousel = _require2.SwipeCarousel;

var PinchZoomComponent = __webpack_require__(737);
var CloseIcon = __webpack_require__(276);
var carouselHelpers = __webpack_require__(1341);

/**
 * Modal containing mobile pinch/zoom carousel on the PDP.
 *
 * TODO: There is too much functionality here. The combination of swipe carousel and pinch/zoom children can probably be
 * extracted into a re-usable component so that the rules about disabling/enabling swiping based on the zoom state can
 * be encapsulated.
 */

var MobileZoomModal = function (_ContextComponent) {
    _inherits(MobileZoomModal, _ContextComponent);

    function MobileZoomModal(props) {
        _classCallCheck(this, MobileZoomModal);

        var _this = _possibleConstructorReturn(this, (MobileZoomModal.__proto__ || Object.getPrototypeOf(MobileZoomModal)).call(this, props));

        _this.state = {
            index: props.startingIndex
        };

        _this._eventFired = false;

        _this._closeModal = _this._closeModal.bind(_this);
        _this._enableSwipe = _this._enableSwipe.bind(_this);
        _this._disableSwipe = _this._disableSwipe.bind(_this);
        _this._updateCurrent = _this._updateCurrent.bind(_this);
        _this._handleZoomIn = _this._handleZoomIn.bind(_this);
        return _this;
    }

    _createClass(MobileZoomModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ index: nextProps.startingIndex });
            if (this.refs && this.refs.carousel) {
                this.refs.carousel.setPage(nextProps.startingIndex);
            }
        }
    }, {
        key: '_enableSwipe',
        value: function _enableSwipe() {
            this.refs.carousel.enableSwipe();
        }
    }, {
        key: '_disableSwipe',
        value: function _disableSwipe() {
            this.refs.carousel.disableSwipe();
        }
    }, {
        key: '_handleZoomIn',
        value: function _handleZoomIn() {
            // Prevent swiping if a child element is zoomed in.
            this._disableSwipe();

            if (!this._eventFired) {
                this._trackZoom();
                // Disable event tracking until we see a new image.
                this._eventFired = true;
            }
        }
    }, {
        key: '_trackZoom',
        value: function _trackZoom() {
            var owner = this.props.owner;

            var category = carouselHelpers.getCarouselCategory(owner);
            tracking.trackEvent({
                category: category,
                action: 'mobile image zoom',
                label: this.state.index + 1 + '/' + this.props.images.length
            });
        }
    }, {
        key: '_closeModal',
        value: function _closeModal() {
            // Unzoom the current child when the modal closes.
            this.refs['image-' + this.state.index].reset();
            this._enableSwipe();
            this.props.onRequestClose();
            this._eventFired = false;
        }
    }, {
        key: '_updateCurrent',
        value: function _updateCurrent(index) {
            // Allow firing tracking event again since we are on a new image.
            if (index !== this.state.index) {
                this._eventFired = false;
            }

            this.props.onIndexChange(index);
            this.setState({ index: index });
        }
    }, {
        key: '_getStyle',
        value: function _getStyle() {
            var style = this.props.style;

            return Object.assign({}, {
                content: {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    padding: 0
                }
            }, style);
        }
    }, {
        key: '_getChildren',
        value: function _getChildren() {
            var _this2 = this;

            var currentIndex = this.state.index;

            return this.props.images.map(function (image, i) {
                return React.createElement(
                    PinchZoomComponent,
                    { ref: 'image-' + i, enabled: currentIndex === i, onZoomIn: _this2._handleZoomIn, onZoomOut: _this2._enableSwipe, key: i, className: 'mobile-zoom-carousel-image-wrapper' },
                    React.createElement('div', { className: 'mobile-zoom-carousel-image', style: { backgroundImage: 'url(' + image.large.src + ')' } })
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                Modal,
                _extends({}, this.props, { onRequestClose: this._closeModal, style: this._getStyle() }),
                React.createElement(
                    'div',
                    { className: 'mobile-zoom-modal-close-wrapper' },
                    React.createElement(
                        'span',
                        { onClick: this._closeModal, className: 'mobile-zoom-modal-close', title: 'Close' },
                        React.createElement(CloseIcon, { className: 'mobile-zoom-modal-close-icon' })
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'mobile-zoom-modal-content-wrapper' },
                    React.createElement(
                        'div',
                        { className: 'mobile-zoom-modal-content-body' },
                        React.createElement(
                            SwipeCarousel,
                            { ref: 'carousel', classNames: {
                                    wrapper: 'mobile-zoom-carousel-wrapper',
                                    list: 'mobile-zoom-carousel-list',
                                    item: 'mobile-zoom-carousel-item'
                                }, onPageChange: this._updateCurrent, startingPage: this.state.index },
                            this._getChildren()
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'mobile-zoom-modal-content-footer' },
                        React.createElement(
                            'div',
                            { className: 'mobile-zoom-modal-indicator-wrapper' },
                            React.createElement(
                                'span',
                                { className: 'mobile-zoom-modal-indicator' },
                                this.state.index + 1 + ' of ' + this.props.images.length + ' images'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return MobileZoomModal;
}(ContextComponent);

MobileZoomModal.propTypes = {
    owner: PropTypes.string,
    onRequestClose: PropTypes.func,
    style: PropTypes.object,
    images: PropTypes.array,
    startingIndex: PropTypes.number,
    onIndexChange: PropTypes.func
};

MobileZoomModal.defaultProps = {
    onRequestClose: noop,
    style: {},
    images: [],
    startingIndex: 0,
    onIndexChange: noop
};

module.exports = MobileZoomModal;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var $ = __webpack_require__(5);
var isEmpty = __webpack_require__(264);
var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);
var OverlaySpinner = __webpack_require__(368);

var transitionHelpers = __webpack_require__(1336);
var ContextComponent = __webpack_require__(61);
var MediaQuery = __webpack_require__(378);
var Modal = __webpack_require__(596);
var ArrowRightIcon = __webpack_require__(351);
var ArrowLeftIcon = __webpack_require__(352);
var CloseIcon = __webpack_require__(276);
var PinchZoomComponent = __webpack_require__(737);

var _require = __webpack_require__(365),
    queries = _require.queries;

var _require2 = __webpack_require__(67),
    noop = _require2.noop;

var _require3 = __webpack_require__(379),
    trackPinterestClick = _require3.trackPinterestClick;

var PdpSocialIcons = __webpack_require__(1490);

var ZoomModal = function (_ContextComponent) {
    _inherits(ZoomModal, _ContextComponent);

    function ZoomModal(props) {
        _classCallCheck(this, ZoomModal);

        var _this = _possibleConstructorReturn(this, (ZoomModal.__proto__ || Object.getPrototypeOf(ZoomModal)).call(this, props));

        _this.state = {
            index: props.startingIndex,
            numberVisible: props.numberVisible || 5,
            leftIndex: 0,
            binImageTransfrom: 'translate(0px)',
            previewImagePosition: 'calc(50%) 50%',
            inZoom: false
        };

        _this._closeModal = _this._closeModal.bind(_this);
        _this._onMouseEnter = _this._onMouseEnter.bind(_this);
        _this._onMouseLeave = _this._onMouseLeave.bind(_this);
        _this._onMouseMove = _this._onMouseMove.bind(_this);
        _this._onLeftArrowClick = _this._onLeftArrowClick.bind(_this);
        _this._onRightArrowClick = _this._onRightArrowClick.bind(_this);
        _this._onThumbnailClick = _this._onThumbnailClick.bind(_this);
        _this._onPinterestPin = _this._onPinterestPin.bind(_this);
        return _this;
    }

    _createClass(ZoomModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ index: nextProps.startingIndex });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _state = this.state,
                index = _state.index,
                leftIndex = _state.leftIndex,
                inZoom = _state.inZoom;
            var images = this.props.images;

            var lastIndex = images.length - 1;
            var indexChanged = index !== prevState.index;
            var zoomChanged = inZoom !== prevState.inZoom;

            if (indexChanged) {
                if (prevState.index === lastIndex && index === 0) {
                    // last to first
                    this._calculateLeftIndexNext();
                } else if (index === lastIndex && prevState.index === 0) {
                    // first to last
                    this._calculateLeftIndexPrevious();
                } else if (prevState.index < index) {
                    // next
                    this._calculateLeftIndexNext();
                } else {
                    // prev
                    this._calculateLeftIndexPrevious();
                }
            }

            if (leftIndex !== prevState.leftIndex) {
                this._translatePosition();
            }

            if (zoomChanged || indexChanged) {
                transitionHelpers.transitionElement($(this.refs.previewImage));
            }
        }
    }, {
        key: '_calculateLeftIndexPrevious',
        value: function _calculateLeftIndexPrevious() {
            var images = this.props.images;

            var lastIndex = images.length - 1;
            var _state2 = this.state,
                index = _state2.index,
                numberVisible = _state2.numberVisible;
            var leftIndex = this.state.leftIndex;


            if (index === lastIndex) {
                leftIndex = Math.max(0, lastIndex - (numberVisible - 1));
            } else if (leftIndex > 0) {
                leftIndex -= 1;
            }

            this.setState({ leftIndex: leftIndex });
        }
    }, {
        key: '_onLeftArrowClick',
        value: function _onLeftArrowClick() {
            var _props = this.props,
                images = _props.images,
                onLeftArrowClick = _props.onLeftArrowClick;

            var lastIndex = images.length - 1;
            var index = this.state.index;

            index -= 1;

            if (index < 0) {
                index = lastIndex;
            }

            if (onLeftArrowClick) {
                onLeftArrowClick(index);
            }

            this._updateCurrent(index);
        }
    }, {
        key: '_calculateLeftIndexNext',
        value: function _calculateLeftIndexNext() {
            var images = this.props.images;

            var imagesLength = images.length;
            var _state3 = this.state,
                index = _state3.index,
                numberVisible = _state3.numberVisible;
            var leftIndex = this.state.leftIndex;


            if (index === 0) {
                leftIndex = 0;
            } else if (leftIndex + numberVisible - 1 < imagesLength - 1) {
                leftIndex += 1;
            }

            this.setState({ leftIndex: leftIndex });
        }
    }, {
        key: '_onRightArrowClick',
        value: function _onRightArrowClick() {
            var _props2 = this.props,
                images = _props2.images,
                onRightArrowClick = _props2.onRightArrowClick;
            var index = this.state.index;


            var imagesLength = images.length;
            index += 1;

            if (index >= imagesLength) {
                index = 0;
            }

            if (onRightArrowClick) {
                onRightArrowClick(index);
            }

            this._updateCurrent(index);
        }
    }, {
        key: '_onThumbnailClick',
        value: function _onThumbnailClick(index) {
            this.props.onThumbnailClick(index);
            this._updateCurrent(index);
        }
    }, {
        key: '_updateCurrent',
        value: function _updateCurrent(index) {
            this.props.onIndexChange(index);
            this.setState({ index: index });
        }
    }, {
        key: '_translatePosition',
        value: function _translatePosition() {
            var leftIndex = this.state.leftIndex;

            var offset = 100 * -leftIndex;

            this.setState({
                binImageTransfrom: 'translate(' + offset + '%)'
            });
        }
    }, {
        key: '_closeModal',
        value: function _closeModal() {
            this.props.onRequestClose();
        }
    }, {
        key: '_onMouseEnter',
        value: function _onMouseEnter() {
            this.setState({ inZoom: true });
        }
    }, {
        key: '_onMouseLeave',
        value: function _onMouseLeave() {
            this.setState({ inZoom: false });
        }
    }, {
        key: '_onMouseMove',
        value: function _onMouseMove(e) {
            var owner = this.props.owner;
            var inZoom = this.state.inZoom;
            var previewImage = this.refs.previewImage;


            if (inZoom) {
                var mouseX = e.clientX;
                var mouseY = e.clientY;
                var bodyWidth = previewImage.clientWidth;
                var bodyHeight = previewImage.clientHeight;

                var translateX = void 0;
                var translateY = void 0;
                var previewImagePosition = void 0;

                // Calculate offset from the center for the X axis.
                switch (owner) {
                    case 'checkout':
                        translateX = mouseX / bodyWidth * 100 - 20;
                        translateY = mouseY / bodyHeight * 100 - 20;
                        previewImagePosition = 'calc(10% + ' + translateX + '%)' + translateY + '%';
                        break;
                    default:
                        translateX = (mouseX / bodyWidth - 0.5) * -50;
                        translateY = mouseY / bodyHeight * 100;
                        previewImagePosition = 'calc(50% + ' + translateX + '%)' + translateY + '%';
                }

                this.setState({ previewImagePosition: previewImagePosition });
            }
        }
    }, {
        key: '_getZoomImage',
        value: function _getZoomImage() {
            var index = this.state.index;
            var images = this.props.images;


            return images[index].zoom.src;
        }
    }, {
        key: '_getPreviewImage',
        value: function _getPreviewImage() {
            var _state4 = this.state,
                inZoom = _state4.inZoom,
                previewImagePosition = _state4.previewImagePosition;

            var className = classnames('modal-carousel-image', {
                enlarged: inZoom
            });
            var style = void 0;

            if (inZoom) {
                style = {
                    backgroundPosition: previewImagePosition,
                    backgroundImage: 'url(' + this._getZoomImage() + ')'
                };
            }

            return React.createElement(
                'div',
                { ref: 'previewImage', className: className, style: style },
                React.createElement('img', { className: 'modal-carousel-small-image',
                    onMouseEnter: this._onMouseEnter,
                    src: this._getZoomImage()
                }),
                React.createElement(OverlaySpinner, { additionalWrapperClasses: 'modal-carousel-lazy-spinner', position: 'isAbsolute' })
            );
        }
    }, {
        key: '_getThumbnails',
        value: function _getThumbnails() {
            var _this2 = this;

            var _state5 = this.state,
                index = _state5.index,
                binImageTransfrom = _state5.binImageTransfrom;


            return this.props.images.map(function (image, i) {
                var className = classnames('carousel-bin-image-wrapper', {
                    selected: index === i
                });

                return React.createElement(
                    'div',
                    { key: i,
                        onClick: function onClick() {
                            return _this2._onThumbnailClick(i);
                        },
                        className: className,
                        style: { transform: binImageTransfrom }
                    },
                    React.createElement('div', { className: 'carousel-bin-image',
                        style: { backgroundImage: 'url(' + image.small.src + ')' }
                    })
                );
            });
        }
    }, {
        key: '_getArrows',
        value: function _getArrows() {
            var images = this.props.images;


            if (images.length > 1) {
                return {
                    leftArrow: React.createElement(
                        'span',
                        { className: 'modal-carousel-previous', onClick: this._onLeftArrowClick },
                        React.createElement(ArrowLeftIcon, { className: 'modal-carousel-previous-icon' })
                    ),
                    rightArrow: React.createElement(
                        'span',
                        { className: 'modal-carousel-next', onClick: this._onRightArrowClick },
                        React.createElement(ArrowRightIcon, { className: 'modal-carousel-next-icon' })
                    )
                };
            } else {
                return {
                    leftArrow: null,
                    rightArrow: null
                };
            }
        }
    }, {
        key: '_getSocialData',
        value: function _getSocialData() {
            var socialData = this.props.socialData;

            var image = this._getZoomImage();

            return Object.assign({}, socialData, { image: image });
        }
    }, {
        key: '_onPinterestPin',
        value: function _onPinterestPin() {
            var suffix = 'zoom modal';
            this.context.executeAction(trackPinterestClick, { suffix: suffix });
        }
    }, {
        key: 'renderSocialData',
        value: function renderSocialData() {
            var _props3 = this.props,
                itemId = _props3.itemId,
                vertical = _props3.vertical,
                siteProtocol = _props3.siteProtocol,
                itemPk = _props3.itemPk,
                pinterest = _props3.pinterest,
                stfOnClick = _props3.stfOnClick;

            return React.createElement(
                'div',
                { className: 'modal-carousel-actions' },
                React.createElement(PdpSocialIcons, {
                    vertical: vertical,
                    id: itemId,
                    siteProtocol: siteProtocol,
                    socialData: this._getSocialData(),
                    itemPk: itemPk,
                    pinterest: pinterest,
                    onPinterestPin: this._onPinterestPin,
                    pinterestTracking: { suffix: 'modal' },
                    printIcon: false,
                    stfOnClick: stfOnClick,
                    iconType: 'colored'
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                wrapperClasses = _props4.wrapperClasses,
                title = _props4.title,
                socialData = _props4.socialData,
                heartComponent = _props4.heartComponent;

            var _getArrows2 = this._getArrows(),
                leftArrow = _getArrows2.leftArrow,
                rightArrow = _getArrows2.rightArrow;

            var hasSocialData = !isEmpty(socialData);

            return React.createElement(
                Modal,
                _extends({ className: wrapperClasses, onRequestClose: this._closeModal }, this.props),
                React.createElement(
                    'span',
                    { onClick: this._closeModal, className: 'modal-close', title: 'Close' },
                    React.createElement(CloseIcon, { className: 'modal-close-btn' })
                ),
                React.createElement(
                    'div',
                    { className: 'modal-carousel2' },
                    React.createElement(
                        'div',
                        { ref: 'modalBody',
                            onMouseLeave: this._onMouseLeave,
                            onMouseMove: this._onMouseMove,
                            className: 'modal-carousel-body'
                        },
                        leftArrow,
                        React.createElement(
                            MediaQuery,
                            { query: queries.lg },
                            React.createElement(
                                PinchZoomComponent,
                                { className: 'mobile-zoom-carousel-image-wrapper' },
                                React.createElement('div', { className: 'mobile-zoom-carousel-image', style: { backgroundImage: 'url(' + this._getZoomImage() + ')' } })
                            )
                        ),
                        React.createElement(
                            MediaQuery,
                            { query: queries.xl },
                            this._getPreviewImage()
                        ),
                        rightArrow
                    ),
                    React.createElement(
                        'div',
                        { className: 'modal-carousel-footer' },
                        React.createElement(
                            'div',
                            { className: 'modal-carousel-social social-share-nav' },
                            heartComponent ? heartComponent : null,
                            React.createElement(
                                'span',
                                { className: 'modal-carousel-title' },
                                title
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'modal-carousel-bin' },
                            React.createElement(
                                'div',
                                { ref: 'thumbnails', className: 'carousel-bin' },
                                this._getThumbnails()
                            )
                        ),
                        hasSocialData ? this.renderSocialData() : null
                    )
                )
            );
        }
    }]);

    return ZoomModal;
}(ContextComponent);

ZoomModal.propTypes = {
    owner: PropTypes.string,
    isOpen: PropTypes.bool,
    heartComponent: PropTypes.object,
    onRequestClose: PropTypes.func,
    images: PropTypes.array,
    startingIndex: PropTypes.number,
    onIndexChange: PropTypes.func,
    wrapperClasses: PropTypes.string,
    socialData: PropTypes.object,
    pinterest: PropTypes.object,
    onLeftArrowClick: PropTypes.func,
    onRightArrowClick: PropTypes.func,

    vertical: PropTypes.string.isRequired,
    itemId: PropTypes.string.isRequired,
    siteProtocol: PropTypes.string.isRequired,
    itemPk: PropTypes.string.isRequired,
    stfOnClick: PropTypes.func.isRequired,
    onThumbnailClick: PropTypes.func.isRequired
};

ZoomModal.defaultProps = {
    onRequestClose: noop,
    wrapperClasses: 'modal-carousel-wrapper',
    images: [],
    startingIndex: 0,
    onIndexChange: noop,
    onLeftArrowClick: noop,
    onRightArrowClick: noop
};

module.exports = ZoomModal;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ContextComponent = __webpack_require__(61);
var DetailsItems = __webpack_require__(1875);
var findNameSpace = __webpack_require__(285);
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var ItemStore = __webpack_require__(336);

var Details = function (_ContextComponent) {
    _inherits(Details, _ContextComponent);

    function Details(props) {
        _classCallCheck(this, Details);

        var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this, props));

        _this.mainTitle = findNameSpace('details.mainTitle', props.copy);
        return _this;
    }

    _createClass(Details, [{
        key: 'render',
        value: function render() {
            var props = this.props;

            return React.createElement(
                'div',
                { className: 'pdp-details-subcontainer rowFlexTransition' },
                React.createElement(
                    'div',
                    { className: 'pdp-details-title-container colXs12' },
                    React.createElement(
                        'h2',
                        { className: 'pdp-details-title header-primary-large pdp-secondary-header' },
                        this.mainTitle
                    )
                ),
                React.createElement(DetailsItems, { detailsConfig: props.detailsConfig, details: props.details, detailsTitles: props.detailsTitles, isPrintPage: props.isPrintPage })
            );
        }
    }]);

    return Details;
}(ContextComponent);

Details.defaultProps = {
    isPrintPage: false
};

Details.propTypes = {
    detailsConfig: PropTypes.array.isRequired,
    details: PropTypes.object.isRequired,
    detailsTitles: PropTypes.object.isRequired,
    vertical: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired,
    isPrintPage: PropTypes.bool
};

var Connected = provideContext(connectToStores(Details, [ItemStore], function (context) {
    var itemStore = context.getStore(ItemStore);
    return {
        copy: itemStore.getCopy(),
        detailsTitles: itemStore.getDetailsTitles(),
        details: itemStore.getDetails(),
        detailsConfig: itemStore.getDetailsConfig(),
        vertical: itemStore.getFromItemModel('vertical')
    };
}));

module.exports = {
    Connected: Connected,
    Raw: Details
};

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);
var ContextComponent = __webpack_require__(61);
var SanitizeHtml = __webpack_require__(296);
var inViewport = __webpack_require__(600);
var scrollIntoView = __webpack_require__(584);

var _require = __webpack_require__(379),
    trackDescriptionExpand = _require.trackDescriptionExpand,
    trackDescriptionCollapse = _require.trackDescriptionCollapse;

var PdpActions = __webpack_require__(796);

// Need some extra padding below the description when it is expanded or else the "READ LESS" text cuts off the description.
var EXPANDED_PADDING = 6;

var ExpandableContent = function (_ContextComponent) {
    _inherits(ExpandableContent, _ContextComponent);

    function ExpandableContent(props) {
        _classCallCheck(this, ExpandableContent);

        var _this = _possibleConstructorReturn(this, (ExpandableContent.__proto__ || Object.getPrototypeOf(ExpandableContent)).call(this, props));

        _this.state = {
            isExpanded: props.expanded,
            hasReadMore: false
        };

        _this._toggleReadMore = _this._toggleReadMore.bind(_this);
        _this._setExpanded = _this._setExpanded.bind(_this);
        return _this;
    }

    _createClass(ExpandableContent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._setReadMore();
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            if (nextState.isExpanded) {
                this._getDescriptionHeight();
            }
        }
    }, {
        key: '_getDescriptionHeight',
        value: function _getDescriptionHeight() {
            this.height = this._description.offsetHeight;
        }
    }, {
        key: '_setReadMore',
        value: function _setReadMore() {
            this._getDescriptionHeight();

            // Check if the actual height of the description is greater than the collapseHeight.
            // If it is we want to show the "CONTINUE READING" text link.
            if (this.height > this.props.collapseHeight) {
                this.setState({ hasReadMore: true });
            }
        }
    }, {
        key: '_toggleReadMore',
        value: function _toggleReadMore() {
            var scrollDuration = this.props.scrollDuration;
            var isExpanded = this.state.isExpanded;

            var self = this;

            // Check if the header is in view and scroll to it if needed.
            // The content will be collapsed after the scroll is completed
            if (!inViewport(this._header)) {
                scrollIntoView(this._header, { time: scrollDuration }, function () {
                    self._setExpanded(isExpanded);
                });
            } else {
                this._setExpanded(isExpanded);
            }

            if (this.props.tracking) {
                this._tracking();
            }
        }
    }, {
        key: '_tracking',
        value: function _tracking() {
            var action = this.state.isExpanded ? trackDescriptionCollapse : trackDescriptionExpand;

            this.context.executeAction(action);
        }
    }, {
        key: '_setExpanded',
        value: function _setExpanded(isExpanded) {
            this.setState({ isExpanded: !isExpanded });
            this.context.executeAction(PdpActions.setHeroExpanded, { heroExpanded: isExpanded });
            this._changeSizeListener();
        }

        // Keep track of the state of the expand/collapse transition so other components on the page cam react to the change
        // in size.

    }, {
        key: '_changeSizeListener',
        value: function _changeSizeListener() {
            var _this2 = this;

            var handleTransitionend = function handleTransitionend() {
                _this2.context.executeAction(PdpActions.setHeroChangingSize, { heroChangingSize: false });
                _this2._descriptionWrapper.removeEventListener('transitionend', handleTransitionend);
            };

            this._descriptionWrapper.addEventListener('transitionend', handleTransitionend);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                description = _props.description,
                title = _props.title,
                name = _props.name,
                imagePath = _props.image,
                collapseHeight = _props.collapseHeight,
                tnType = _props.tnType,
                isPrintHero = _props.isPrintHero;
            var _state = this.state,
                isExpanded = _state.isExpanded,
                hasReadMore = _state.hasReadMore;

            var hasImage = !!imagePath;
            var classes = classnames('pdp-hero-about-wrapper', { expanded: isExpanded }, { 'pdp-hero-about-has-image': hasImage });
            var readMoreText = isExpanded ? 'read less -' : 'continue reading +';
            var descriptionHeight = { height: isExpanded ? this.height + EXPANDED_PADDING : collapseHeight };
            var wrapperDataTags = isPrintHero ? 'print-pdp-' + tnType + '-description-wrapper' : 'pdp-' + tnType + '-description-wrapper';
            var descriptionDataTags = isPrintHero ? 'print-pdp-' + tnType + '-description' : 'pdp-' + tnType + '-description';
            var image = React.createElement(
                'div',
                { className: 'pdp-hero-image-overlay' },
                React.createElement('img', { src: imagePath, className: 'pdp-hero-image-overlay-content' })
            );

            return React.createElement(
                'div',
                { className: classes },
                hasImage ? image : null,
                React.createElement(
                    'div',
                    { className: 'pdp-hero-body-about-wrapper' },
                    React.createElement(
                        'h2',
                        { className: 'pdp-hero-about header-primary-large pdp-secondary-header',
                            ref: function ref(header) {
                                _this3._header = header;
                            }
                        },
                        title,
                        ' ',
                        name
                    ),
                    React.createElement(
                        'div',
                        { ref: function ref(descriptionWrapper) {
                                _this3._descriptionWrapper = descriptionWrapper;
                            }, className: 'pdp-hero-description-wrapper', 'data-tn': wrapperDataTags, style: descriptionHeight },
                        React.createElement(
                            'div',
                            { className: 'pdp-hero-description', ref: function ref(descriptionContent) {
                                    _this3._description = descriptionContent;
                                }, 'data-tn': descriptionDataTags },
                            React.createElement(SanitizeHtml, { content: description })
                        )
                    ),
                    hasReadMore ? React.createElement(
                        'a',
                        { href: '#0', className: 'pdp-hero-read-more', 'data-tn': 'pdp-' + tnType + '-read-more', onClick: this._toggleReadMore },
                        readMoreText
                    ) : null
                )
            );
        }
    }]);

    return ExpandableContent;
}(ContextComponent);

ExpandableContent.propTypes = {
    description: PropTypes.string.isRequired,
    title: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.string,

    tracking: PropTypes.bool,
    expanded: PropTypes.bool,

    collapseHeight: PropTypes.number,
    tnType: PropTypes.string,
    scrollDuration: PropTypes.number
};

ExpandableContent.defaultProps = {
    tracking: true,
    expanded: false,

    collapseHeight: 144,
    tnType: 'item',
    scrollDuration: 1000
};

module.exports = ExpandableContent;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var _require = __webpack_require__(379),
    trackDealerLinkClick = _require.trackDealerLinkClick;

var GridBase = __webpack_require__(1486);
var GridHeader = __webpack_require__(1487);
var GridItem = __webpack_require__(1488);

var GridDealer = function (_GridBase) {
    _inherits(GridDealer, _GridBase);

    function GridDealer(props) {
        _classCallCheck(this, GridDealer);

        var _this = _possibleConstructorReturn(this, (GridDealer.__proto__ || Object.getPrototypeOf(GridDealer)).call(this, props));

        _this.state = {
            quickViewItemId: null
        };

        _this._setQuickViewId = _this._setQuickViewId.bind(_this);

        _this._handleClick = _this._handleClick.bind(_this);
        return _this;
    }

    _createClass(GridDealer, [{
        key: '_handleClick',
        value: function _handleClick() {
            if (this.context.executeAction) {
                this.context.executeAction(trackDealerLinkClick, { location: 'more from dealer module' });
            }
            if (this.props.trackViewAllClick) {
                this.props.trackViewAllClick();
            }
        }
    }, {
        key: '_getHeader',
        value: function _getHeader() {
            var _props = this.props,
                dealerData = _props.dealerData,
                copy = _props.copy;

            return React.createElement(GridHeader, { type: dealerData.type, title: copy.dealer.carouselHeader });
        }
    }, {
        key: '_getItems',
        value: function _getItems() {
            var _this2 = this;

            return this.props.data.map(function (data, index) {
                // index needs to be 1-based, not 0-based
                data.index = index + 1;

                return React.createElement(
                    'div',
                    { className: 'pdp-grid-item colLg3 colMd4 colXs6', key: data.id },
                    React.createElement(GridItem, _extends({
                        setQuickViewId: _this2._setQuickViewId,
                        quickViewItemId: _this2.state.quickViewItemId,
                        quickView: _this2.props.quickView,
                        onProductClick: _this2.props.trackProductClick
                    }, data))
                );
            });
        }
    }, {
        key: '_getViewAll',
        value: function _getViewAll() {
            return React.createElement(
                'div',
                { className: 'pdp-grid-view-all-button' },
                React.createElement(
                    'a',
                    { href: this.props.dealerData.uri,
                        className: 'button-medium button-secondary',
                        onClick: this._handleClick
                    },
                    'View All'
                )
            );
        }
    }]);

    return GridDealer;
}(GridBase);

GridDealer.propTypes = {
    data: PropTypes.array,
    dealerData: PropTypes.object.isRequired,
    copy: PropTypes.object.isRequired,
    trackViewAllClick: PropTypes.func,
    trackProductClick: PropTypes.func,
    quickView: PropTypes.bool
};

GridDealer.defaultProps = {
    data: [],
    domId: 'dealer-grid',
    quickView: false
};

module.exports = GridDealer;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 9/28/15
 * Time: 9:51 AM
 * Copyright 1stdibs.com, Inc. 2015. All Rights Reserved.
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var styles = __webpack_require__(1716);
var ContextComponent = __webpack_require__(61);

var Measurement = function (_ContextComponent) {
    _inherits(Measurement, _ContextComponent);

    function Measurement() {
        _classCallCheck(this, Measurement);

        return _possibleConstructorReturn(this, (Measurement.__proto__ || Object.getPrototypeOf(Measurement)).apply(this, arguments));
    }

    _createClass(Measurement, [{
        key: 'render',
        value: function render() {
            var values = this.props.values;
            var numValues = values.length;

            if (!numValues || !Array.isArray(values)) {
                return null;
            }

            return React.createElement(
                'span',
                null,
                values.map(function (measurement, index) {
                    var value = measurement.displayValue;
                    var unitEl = void 0;

                    if (!value) {
                        value = measurement.value;
                        unitEl = React.createElement(
                            'span',
                            { className: styles.unit },
                            ' ',
                            measurement.unit
                        );
                    }
                    return React.createElement(
                        'span',
                        { className: styles.measurement, key: index },
                        React.createElement(
                            'span',
                            { className: styles.value },
                            value
                        ),
                        unitEl,
                        React.createElement(
                            'span',
                            { className: styles.unitLabel },
                            measurement.unitLabel
                        ),
                        index < numValues - 1 ? React.createElement(
                            'span',
                            { className: styles.divider },
                            'x'
                        ) : ''
                    );
                })
            );
        }
    }]);

    return Measurement;
}(ContextComponent);

Measurement.propTypes = {
    values: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        unit: PropTypes.string.isRequired,
        unitLabel: PropTypes.string.isRequired,
        schemaType: PropTypes.string.isRequired
    })).isRequired
};

module.exports = Measurement;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 8/25/16.
 */



var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);

var get = __webpack_require__(14);

// Stores
var ItemStore = __webpack_require__(336);
var UserStore = __webpack_require__(109);

var _require = __webpack_require__(785),
    OPEN_DETAILS_FROM_SIDEBAR = _require.OPEN_DETAILS_FROM_SIDEBAR;

// Components


var VerifiedTradePromo = __webpack_require__(1084).default;
var QuotePrimary = __webpack_require__(1337);
var ShippingDetailsLink = __webpack_require__(1338);

// Helpers
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);

var _require2 = __webpack_require__(541),
    filterQuotes = _require2.filterQuotes;

var copy = __webpack_require__(1577);

var ShippingBlurb = function ShippingBlurb(props) {
    var canShowBlurb = !(props.isSold || props.isUnlisted || props.hidePrice || !props.currency || !props.relayItem);
    var _props$user = props.user,
        user = _props$user === undefined ? null : _props$user,
        quotes = props.quotes,
        currency = props.currency,
        context = props.context,
        userId = props.userId,
        itemId = props.itemId,
        dealerPk = props.dealerPk,
        viewer = props.viewer,
        favoriteDealer = props.favoriteDealer,
        favoriteDealerCta = props.favoriteDealerCta,
        dealerData = props.dealerData,
        pagePosition = props.pagePosition;


    if (canShowBlurb) {
        var hasQuote = filterQuotes(quotes.domestic).length || filterQuotes(quotes.local).length;
        var canRequestShippingQuote = get(user, 'canRequestShippingQuote');

        var labelText = hasQuote ? copy.hasQuote : copy.noQuote;
        var link = React.createElement(
            'a',
            { href: labelText.href },
            canRequestShippingQuote ? labelText.canRequest : labelText.cannotRequest
        );

        return React.createElement(
            'div',
            { className: 'pdp-shipping-blurb' },
            React.createElement(QuotePrimary, { currency: currency, quotes: quotes }),
            React.createElement(VerifiedTradePromo, { userId: userId, itemId: itemId, viewer: viewer }),
            !props.isOnHold && React.createElement(ShippingDetailsLink, {
                pagePosition: pagePosition + '-blurb',
                userId: userId,
                itemId: itemId,
                dealerPk: dealerPk,
                viewer: viewer,
                link: link,
                context: context,
                user: user,
                quotes: quotes,
                customQuoteAvailable: canRequestShippingQuote,
                regionType: 'DOMESTIC',
                source: OPEN_DETAILS_FROM_SIDEBAR,
                favoriteDealer: favoriteDealer,
                favoriteDealerCta: favoriteDealerCta,
                dealerData: dealerData,
                trackingLocation: 'pdp sidebar',
                item: props.relayItem
            })
        );
    }
    return React.createElement('div', { className: 'pdp-shipping-blurb no-data' });
};

ShippingBlurb.propTypes = {
    context: PropTypes.object,
    quotes: PropTypes.object.isRequired,
    user: PropTypes.object,
    userId: PropTypes.string,
    itemId: PropTypes.string,
    dealerPk: PropTypes.string,
    viewer: PropTypes.object,
    relayItem: PropTypes.object,
    currency: PropTypes.string.isRequired,
    isOnHold: PropTypes.bool,
    isSold: PropTypes.bool,
    isUnlisted: PropTypes.bool,
    hidePrice: PropTypes.bool,
    favoriteDealer: PropTypes.object,
    favoriteDealerCta: PropTypes.object,
    dealerData: PropTypes.object,
    pagePosition: PropTypes.string
};

module.exports = Relay.createContainer(provideContext(connectToStores(ShippingBlurb, [ItemStore, UserStore], function (context) {
    var userStore = context.getStore(UserStore);
    var itemStore = context.getStore(ItemStore);
    return {
        currency: userStore.getCurrency(),
        isOnHold: itemStore.getIsOnHold(),
        isSold: itemStore.getIsSold(),
        isUnlisted: itemStore.getIsUnlisted(),
        hidePrice: itemStore.getHidePrice()

    };
})), {
    initialVariables: {
        userId: null,
        itemId: null
    },
    fragments: {
        user: function user(_ref) {
            var itemId = _ref.itemId,
                userId = _ref.userId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        alias: 'canRequestShippingQuote',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_REQUEST_SHIPPING_QUOTE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Blurb_UserRelayQL',
                    type: 'User'
                };
            }(ShippingDetailsLink.getFragment('user', { itemId: itemId, userId: userId }));
        },
        relayItem: function relayItem() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Blurb_RelayItemRelayQL',
                    type: 'Item'
                };
            }(ShippingDetailsLink.getFragment('item'));
        },
        viewer: function viewer(_ref2) {
            var itemId = _ref2.itemId,
                userId = _ref2.userId;
            return function (RQL_0, RQL_1) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Blurb_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(ShippingDetailsLink.getFragment('viewer', { itemId: itemId, userId: userId }), VerifiedTradePromo.getFragment('viewer', { itemId: itemId, userId: userId }));
        }
    }
});

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var get = __webpack_require__(14);

var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);

var Callout = __webpack_require__(589);
var CalloutStore = __webpack_require__(301);
var calloutHelper = __webpack_require__(485);

var _require = __webpack_require__(1578),
    title = _require.title,
    copy = _require.copy,
    cta = _require.cta,
    calloutCopy = _require.calloutCopy;

var styles = __webpack_require__(1717);

var _require2 = __webpack_require__(542),
    trackGaEvent = _require2.trackGaEvent;

var ViewInvoiceLink = __webpack_require__(1489);

var trackClick = function trackClick() {
    trackGaEvent('product', 'view invoice', 'pdp description', 0);
};

var DetailsInvoice = function DetailsInvoice(_ref) {
    var hasUserId = _ref.hasUserId,
        userId = _ref.userId,
        user = _ref.user,
        itemId = _ref.itemId,
        viewer = _ref.viewer,
        callout = _ref.callout,
        isPrintPage = _ref.isPrintPage;

    var shouldShowLink = false;

    if (!isPrintPage && !get(viewer, 'item.isSold') && get(viewer, 'item.isAvailable') && get(user, 'canSeeInvoice') && !get(viewer, 'transactions.totalResults')) {
        shouldShowLink = true;
    }

    return shouldShowLink ? React.createElement(
        'div',
        { className: 'pdp-shipping-entry-content-container ' + styles.wrapper },
        React.createElement(
            'div',
            { className: 'pdp-details-entry-title-container' },
            React.createElement(
                'span',
                { className: 'pdp-shipping-entry-title' },
                title
            )
        ),
        React.createElement(
            'div',
            { className: 'pdp-shipping-entry' },
            copy
        ),
        React.createElement(
            'div',
            { className: 'return-modal-link js-invoice-link ' + styles.returnModalLink, 'data-tn': 'return-modal-link' },
            React.createElement(
                ViewInvoiceLink,
                {
                    hasUserId: hasUserId,
                    userId: userId,
                    itemId: itemId,
                    viewer: viewer,
                    user: user,
                    onClick: trackClick
                },
                cta
            ),
            React.createElement(Callout, { type: calloutHelper.CALLOUT_TYPE_VIEW_INVOICE,
                copy: calloutCopy,
                direction: 'bottom',
                lockDirection: true,
                localCss: styles,
                callout: callout
            })
        )
    ) : null;
};

DetailsInvoice.defaultProps = {
    isPrintPage: false
};

DetailsInvoice.propTypes = {
    hasUserId: PropTypes.bool.isRequired,
    isPrintPage: PropTypes.bool,
    itemId: PropTypes.string.isRequired,
    userId: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
    callout: PropTypes.object
};

module.exports = Relay.createContainer(provideContext(connectToStores(DetailsInvoice, [CalloutStore], function (context) {
    var calloutStore = context.getStore(CalloutStore);
    return { callout: calloutStore.getCalloutData() };
})), {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null
    },
    fragments: {
        user: function user(_ref2) {
            var hasUserId = _ref2.hasUserId,
                userId = _ref2.userId,
                itemId = _ref2.itemId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        alias: 'canSeeInvoice',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_INVOICE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsInvoice_UserRelayQL',
                    type: 'User'
                };
            }(ViewInvoiceLink.getFragment('user', { hasUserId: hasUserId, userId: userId, itemId: itemId }));
        },
        viewer: function viewer(_ref3) {
            var hasUserId = _ref3.hasUserId,
                userId = _ref3.userId,
                itemId = _ref3.itemId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'viewName',
                            value: {
                                kind: 'CallValue',
                                callValue: 'buyer.buyerPreInvoiceFilter'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'totalResults',
                            kind: 'Field',
                            metadata: {},
                            type: 'Int'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'hasUserId'
                                }
                            }]
                        }],
                        fieldName: 'transactions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'TransactionConnection'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [{
                            fieldName: 'isSold',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isAvailable',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsInvoice_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(ViewInvoiceLink.getFragment('viewer', { hasUserId: hasUserId, userId: userId, itemId: itemId }));
        }
    }
});

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Arnaldas Augutis
 * Date: 04/08/16
 * Time: 14:21
 */



var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var get = __webpack_require__(14);
var css = __webpack_require__(1725);
var paymentMethodsConstants = __webpack_require__(1583);

var creditCardIcons = {
    visa: __webpack_require__(1026),
    discover: __webpack_require__(1023),
    americanExpress: __webpack_require__(1021),
    masterCard: __webpack_require__(1024),
    wireTransfer: __webpack_require__(1027),
    paypal: __webpack_require__(1025),
    check: __webpack_require__(1022)
};

var _getBestPrice = function _getBestPrice(prices, canSeeNetPrice) {
    var bestPrice = void 0;
    prices.forEach(function (priceNode) {
        var price = get(priceNode, 'amount.convertedAmounts.USD');

        // NET price is set even if user can't see it
        if (priceNode.type === 'NET' && !canSeeNetPrice) {
            return false;
        }
        if (!bestPrice || bestPrice > price) {
            bestPrice = price;
        }
        return false;
    });
    return bestPrice;
};

var _getCard = function _getCard(name) {
    var CardComponent = creditCardIcons[name];
    if (CardComponent) {
        return React.createElement(CardComponent, { className: css.creditCardIcon, key: name });
    } else {
        return null;
    }
};

var _getCreditCardsEl = function _getCreditCardsEl() {
    return paymentMethodsConstants.cards.map(function (card) {
        return _getCard(card.icon);
    });
};

var _getWireTransfer = function _getWireTransfer(user) {
    user = user || {};
    if (user.isVerifiedTrade || user.isVip) {
        return _getCard('wireTransfer');
    }
    return null;
};

var _getCheck = function _getCheck(user) {
    return get(user, 'canCheckoutWithCheck') ? _getCard('check') : null;
};

var _getPaypalEl = function _getPaypalEl(price) {
    // PayPals is available for <55000 price
    if (price && price < paymentMethodsConstants.paypalPriceThreshold) {
        return _getCard('paypal');
    }
    return null;
};

var DetailsPaymentMethods = function DetailsPaymentMethods(props) {
    var item = props.item,
        user = props.user;

    var canSeeNetPrice = user ? user.canSeeNetPrice : false;
    var prices = get(item, 'pricing.prices', []);
    var bestPrice = _getBestPrice(prices, canSeeNetPrice);

    return React.createElement(
        'div',
        { className: 'pdp-details-entry-content-container pdp-payment-methods-wrapper' },
        React.createElement(
            'div',
            { className: 'pdp-details-entry-title-container' },
            React.createElement(
                'span',
                { className: 'pdp-details-entry-title' },
                paymentMethodsConstants.title
            )
        ),
        React.createElement(
            'div',
            { className: 'pdp-details-entry-content' },
            React.createElement(
                'p',
                null,
                paymentMethodsConstants.description
            )
        ),
        React.createElement(
            'div',
            { className: 'pdp-details-payment-methods-icons-wrapper' },
            _getCreditCardsEl(),
            _getPaypalEl(bestPrice),
            _getWireTransfer(user),
            _getCheck(user)
        )
    );
};

DetailsPaymentMethods.propTypes = {
    item: PropTypes.object,
    user: PropTypes.object
};

module.exports = Relay.createContainer(DetailsPaymentMethods, {
    fragments: {
        item: function item() {
            return function () {
                return {
                    children: [{
                        children: [{
                            children: [{
                                fieldName: 'type',
                                kind: 'Field',
                                metadata: {},
                                type: 'PriceType'
                            }, {
                                children: [{
                                    children: [{
                                        fieldName: 'USD',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Float'
                                    }],
                                    fieldName: 'convertedAmounts',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'ConvertedAmounts'
                                }],
                                fieldName: 'amount',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'FinancialAmount'
                            }],
                            fieldName: 'prices',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'Price'
                        }],
                        fieldName: 'pricing',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true
                        },
                        type: 'ItemPricing'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsPaymentMethods_ItemRelayQL',
                    type: 'Item'
                };
            }();
        },
        user: function user() {
            return function () {
                return {
                    children: [{
                        alias: 'canSeeNetPrice',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_NET_PRICE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        alias: 'canCheckoutWithCheck',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_CHECKOUT_CHECK'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'isVerifiedTrade',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'isVip',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsPaymentMethods_UserRelayQL',
                    type: 'User'
                };
            }();
        }
    }
});

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);

// Stores
var ItemStore = __webpack_require__(336);

// Components
var ModalWrapper = __webpack_require__(1428);
var DetailsReturnModal = __webpack_require__(1856);
__webpack_require__(1161);

// Helpers
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);

var _require = __webpack_require__(542),
    trackGaEvent = _require.trackGaEvent;

var get = __webpack_require__(14);

function _link(_ref) {
    var href = _ref.href,
        text = _ref.text;

    return React.createElement(
        'a',
        { href: href },
        text
    );
}

_link.propTypes = {
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};

function onOpen(_ref2) {
    var item = _ref2.item;

    return function () {
        var description = get(item, 'returnPolicy.accept', false) ? 'returns accepted' : 'returns not accepted';
        trackGaEvent('product', 'view return details', 'pdp description|' + description);
    };
}

function DetailsReturnLink(_ref3) {
    var itemId = _ref3.itemId,
        href = _ref3.href,
        text = _ref3.text,
        item = _ref3.item,
        user = _ref3.user;

    var link = _link({ href: href, text: text });

    return React.createElement(
        ModalWrapper,
        { openByClickOn: link, closeOnEsc: true, closeOnOutsideClick: true, onOpen: onOpen({ user: user, item: item }) },
        React.createElement(DetailsReturnModal, { item: item, user: user, itemId: itemId })
    );
}

DetailsReturnLink.propTypes = {
    context: PropTypes.object,
    user: PropTypes.object,
    item: PropTypes.object,
    itemId: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};

module.exports = Relay.createContainer(provideContext(connectToStores(DetailsReturnLink, [ItemStore], function (context) {
    var itemStore = context.getStore(ItemStore);
    return { itemId: itemStore.getFromSV('data.pk') };
})), {
    fragments: {
        item: function item() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        children: [{
                            fieldName: 'accept',
                            kind: 'Field',
                            metadata: {},
                            type: 'YesNo'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'returnPolicy',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'ReturnPolicy'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsReturnLink_ItemRelayQL',
                    type: 'Item'
                };
            }(DetailsReturnModal.getFragment('item'));
        },
        user: function user() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        alias: 'canSeeTradeReturns',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_TRADE_RETURN_POLICY'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsReturnLink_UserRelayQL',
                    type: 'User'
                };
            }(DetailsReturnModal.getFragment('user'));
        }
    }
});

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var styles = __webpack_require__(1718);
var copy = __webpack_require__(1201);
var get = __webpack_require__(14);
var Title = __webpack_require__(1866);

function Note(_ref) {
    var note = _ref.note,
        additionalNotesHeader = _ref.additionalNotesHeader;

    if (!note) {
        return null;
    }
    return React.createElement(
        'span',
        { 'data-tn': 'return-modal-additional-notes', className: 'colSm12 ' + styles.returnPolicyLine },
        additionalNotesHeader,
        ': ',
        note
    );
}

Note.propTypes = {
    additionalNotesHeader: PropTypes.string,
    note: PropTypes.string
};

function ReturnPolicy(_ref2) {
    var returnPolicy = _ref2.returnPolicy,
        note = _ref2.note,
        additionalNotesHeader = _ref2.additionalNotesHeader;

    var text = Object.keys(returnPolicy).map(function (key) {
        return React.createElement(ReturnPolicyLine, _extends({ key: 'returnsLine-' + key }, returnPolicy[key]));
    });

    return React.createElement(
        'div',
        { 'data-tn': 'return-modal-return-policy', className: 'rowFlex colSm12 ' + styles.returnPolicy },
        text,
        React.createElement(Note, { note: note, additionalNotesHeader: additionalNotesHeader })
    );
}

ReturnPolicy.propTypes = {
    additionalNotesHeader: PropTypes.string,
    note: PropTypes.string,
    returnPolicy: PropTypes.object
};

function ReturnPolicyLine(props) {
    return React.createElement(
        'span',
        { className: 'colSm12 ' + styles.returnPolicyLine },
        props.body,
        props.link ? React.createElement(
            'a',
            { href: props.link },
            props.linkCTA
        ) : null
    );
}

ReturnPolicyLine.propTypes = {
    body: PropTypes.string.isRequired,
    link: PropTypes.string,
    linkCTA: PropTypes.string
};

function Guarantee() {
    return React.createElement(
        'div',
        { className: 'rowFlex colSm12 ' + styles.guarantee },
        React.createElement('div', { className: 'colSm12 ' + styles.guaranteeLine }),
        React.createElement(
            'span',
            { className: 'colSm12 ' + styles.guaranteeHeader },
            copy.buyerProtection.header
        ),
        React.createElement(
            'span',
            { className: 'colSm12 ' + styles.guaranteeText },
            copy.buyerProtection.beforeLink,
            React.createElement(
                'a',
                { href: copy.buyerProtection.linkHref },
                copy.buyerProtection.linkCTA
            ),
            copy.buyerProtection.afterLink
        )
    );
}

function DetailsReturnModal(_ref3) {
    var _ref3$user = _ref3.user,
        user = _ref3$user === undefined ? {} : _ref3$user,
        _ref3$item = _ref3.item,
        item = _ref3$item === undefined ? {} : _ref3$item,
        _ref3$closeModal = _ref3.closeModal,
        closeModal = _ref3$closeModal === undefined ? function () {} : _ref3$closeModal;

    // in cases where the user is not logged in, the explicit `null` passed in for GraphQL overrides the default
    // empty object assignment
    user = user || {};
    var itemReturnPolicy = get(item, 'returnPolicy.buyerCopy', {});
    var _user = user,
        canSeeTradeReturns = _user.canSeeTradeReturns;

    var returnsAccepted = get(item, 'returnPolicy.accept');
    var note = get(item, 'returnPolicy.note');
    var additionalNotesHeader = get(item, 'returnPolicy.buyerCopy.additionalNotesHeader');

    var returnPolicy = Object.keys(itemReturnPolicy)
    // __dataID__ is internal to relay; additionalNotesHeader will be passed separately
    .filter(function (key) {
        return key !== '__dataID__' && key !== 'additionalNotesHeader' && !!itemReturnPolicy[key];
    }).reduce(function (obj, key) {
        return Object.assign(obj, _defineProperty({}, key, { body: itemReturnPolicy[key] }));
    }, {});

    if (canSeeTradeReturns && item.isTradeReturnAvailable) {
        if (returnsAccepted) {
            // Include the dealer's return policy and the trade return policy
            returnPolicy = Object.assign({}, returnPolicy, {
                tradeCopy: { body: copy.returnPolicyModal.returnsAccepted },
                responsibility: copy.tradeResponsibility
            });
        } else {
            // Do not include the dealer's return policy; include the trade return policy and the dealer responsibility
            // disclaimer block.
            returnPolicy = {
                tradeCopy: { body: copy.returnPolicyModal.returnsNotAccepted },
                responsibility: copy.tradeResponsibility
            };
        }
    }

    return React.createElement(
        'div',
        { 'data-tn': 'return-details-modal', className: 'containerFluid ' + styles.wrapper },
        React.createElement(Title, { close: closeModal, title: copy.title }),
        React.createElement(
            'div',
            { className: styles.body },
            React.createElement(ReturnPolicy, { returnPolicy: returnPolicy, note: note, additionalNotesHeader: additionalNotesHeader }),
            React.createElement(Guarantee, null)
        )
    );
}

DetailsReturnModal.propTypes = {
    item: PropTypes.object,
    user: PropTypes.object,
    closeModal: PropTypes.func
};

module.exports = Relay.createContainer(DetailsReturnModal, {
    fragments: {
        item: function item() {
            return function () {
                return {
                    children: [{
                        fieldName: 'isTradeReturnAvailable',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        children: [{
                            children: [{
                                fieldName: 'returnsAccepted',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'returnsNotAccepted',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'additionalNotesHeader',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'shippingResponsibility',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'buyerCopy',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ReturnPolicyCopy'
                        }, {
                            fieldName: 'accept',
                            kind: 'Field',
                            metadata: {},
                            type: 'YesNo'
                        }, {
                            fieldName: 'note',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'returnPolicy',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'ReturnPolicy'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsReturnModal_ItemRelayQL',
                    type: 'Item'
                };
            }();
        },
        user: function user() {
            return function () {
                return {
                    children: [{
                        alias: 'canSeeTradeReturns',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_TRADE_RETURN_POLICY'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsReturnModal_UserRelayQL',
                    type: 'User'
                };
            }();
        }
    }
});

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 8/25/16.
 */



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);

// Stores
var ItemStore = __webpack_require__(336);
var PriceStore = __webpack_require__(367);
var TourStore = __webpack_require__(547);

// Components
var Tour = __webpack_require__(487);
var DetailsReturnLink = __webpack_require__(1855);

// Helpers
var get = __webpack_require__(14);

var _require = __webpack_require__(1012),
    buyerAssurance = _require.buyerAssurance;

var _require2 = __webpack_require__(1201),
    tradeReturnPolicy = _require2.returnPolicy;

var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var tourTracking = __webpack_require__(506);
var TRADE_TOUR = TourStore.type.TRADE_TOUR;

var SV = __webpack_require__(17);

// Styles
var styles = __webpack_require__(1257);

var DetailsReturn = function DetailsReturn(props) {
    var tradeTour = props.tradeTour,
        copy = props.copy,
        item = props.item,
        user = props.user,
        context = props.context;
    var returnTitle = copy.returnTitle;

    var _get = get(item, 'returnPolicy.buyerCopy', {}),
        returnsAccepted = _get.returnsAccepted,
        returnsNotAccepted = _get.returnsNotAccepted;

    var accept = get(item, 'returnPolicy.accept', false);
    var canSeeTradeReturns = get(user, 'canSeeTradeReturns');

    var returnCopy = returnsNotAccepted;
    if (accept) {
        returnCopy = returnsAccepted;
    } else if (canSeeTradeReturns && item.isTradeReturnAvailable) {
        returnCopy = tradeReturnPolicy.returnsNotAccepted;
    }
    var tradeReturnCopy = null;
    if (canSeeTradeReturns && accept && item.isTradeReturnAvailable) {
        tradeReturnCopy = React.createElement(
            'p',
            { className: 'pdp-shipping-entry-content' },
            tradeReturnPolicy.returnsAccepted
        );
    }

    return React.createElement(
        'div',
        { className: 'pdp-shipping-entry-content-container' },
        React.createElement(
            'div',
            { className: 'pdp-details-entry-title-container' },
            React.createElement(
                Tour,
                _extends({ dataTn: 'details-returns-trade', step: 5 }, tradeTour, { className: styles.shippingTitle }),
                React.createElement(
                    'span',
                    { className: 'pdp-shipping-entry-title' },
                    returnTitle
                )
            )
        ),
        React.createElement(
            'div',
            { className: 'pdp-shipping-entry' },
            React.createElement(
                'p',
                { className: 'pdp-shipping-entry-content', 'data-tn': 'return-copy' },
                returnCopy
            ),
            tradeReturnCopy,
            React.createElement(
                'p',
                { className: 'pdp-shipping-entry-content' },
                buyerAssurance
            )
        ),
        React.createElement(
            'div',
            { className: 'return-modal-link', 'data-tn': 'return-modal-link' },
            React.createElement(DetailsReturnLink, {
                context: context,
                href: '#',
                text: 'View details',
                item: item,
                user: user
            })
        )
    );
};

DetailsReturn.propTypes = {
    context: PropTypes.object,
    item: PropTypes.object,
    user: PropTypes.object,
    tradeTour: PropTypes.object.isRequired,
    copy: PropTypes.object.isRequired
};

module.exports = Relay.createContainer(provideContext(connectToStores(DetailsReturn, [ItemStore, PriceStore, TourStore], function (context) {
    var itemStore = context.getStore(ItemStore);
    var item = itemStore.getItem();
    var priceStore = context.getStore(PriceStore);

    var _priceStore$processPr = priceStore.processPrice(item),
        priceDisplays = _priceStore$processPr.priceDisplays;

    var tourStore = context.getStore(TourStore);
    return {
        copy: itemStore.getCopy().shipping,
        tradeTour: {
            type: TRADE_TOUR,
            subType: priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
            copy: SV.get('tourCopy.' + TRADE_TOUR),
            isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
            currentStep: tourStore.getCurrentStep(TRADE_TOUR),
            totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        }
    };
})), {
    fragments: {
        item: function item() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'isTradeReturnAvailable',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        children: [{
                            fieldName: 'accept',
                            kind: 'Field',
                            metadata: {},
                            type: 'YesNo'
                        }, {
                            children: [{
                                fieldName: 'returnsAccepted',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'returnsNotAccepted',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'buyerCopy',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ReturnPolicyCopy'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'returnPolicy',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'ReturnPolicy'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsReturns_ItemRelayQL',
                    type: 'Item'
                };
            }(DetailsReturnLink.getFragment('item'));
        },
        user: function user() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        alias: 'canSeeTradeReturns',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_TRADE_RETURN_POLICY'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsReturns_UserRelayQL',
                    type: 'User'
                };
            }(DetailsReturnLink.getFragment('user'));
        }
    }
});

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 8/25/16.
 */



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);

// Stores
var ItemStore = __webpack_require__(336);
var UserStore = __webpack_require__(109);
var PriceStore = __webpack_require__(367);
var TourStore = __webpack_require__(547);

var _require = __webpack_require__(785),
    OPEN_DETAILS_FROM_DESCRIPTION = _require.OPEN_DETAILS_FROM_DESCRIPTION;

// Components


var VerifiedTradePromo = __webpack_require__(1084).default;
var Tour = __webpack_require__(487);
var QuotePrimary = __webpack_require__(1337);
var QuoteHandling = __webpack_require__(1860);
var QuoteSecondary = __webpack_require__(1861);
var ShippingDetailsLink = __webpack_require__(1338);

// Helpers

var _require2 = __webpack_require__(541),
    filterQuotes = _require2.filterQuotes;

var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var tourTracking = __webpack_require__(506);
var TRADE_TOUR = TourStore.type.TRADE_TOUR;

var SV = __webpack_require__(17);
var get = __webpack_require__(14);

// Styles
var styles = __webpack_require__(1257);

var DetailsShipping = function DetailsShipping(props) {
    var quotes = props.quotes,
        tradeTour = props.tradeTour,
        currency = props.currency,
        context = props.context,
        copy = props.copy,
        user = props.user,
        userId = props.userId,
        itemIsSold = props.itemIsSold,
        itemIsUnlisted = props.itemIsUnlisted,
        itemId = props.itemId,
        dealerPk = props.dealerPk,
        viewer = props.viewer,
        favoriteDealerCta = props.favoriteDealerCta,
        favoriteDealer = props.favoriteDealer,
        dealerData = props.dealerData,
        item = props.item;
    var shippingTitle = copy.estimateTitle;

    var canRequestShippingQuote = get(user, 'canRequestShippingQuote');

    var hasQuote = filterQuotes(quotes.domestic).length || filterQuotes(quotes.local).length;
    var linkQuoteCopy = hasQuote ? copy.hasQuote : copy.noQuote;

    var link = React.createElement(
        'a',
        { className: 'pdp-shipping-link', href: '#', 'data-tn': 'pdp-shipping-modal-link' },
        canRequestShippingQuote ? linkQuoteCopy.canRequest : linkQuoteCopy.cannotRequest
    );

    return React.createElement(
        'div',
        { className: 'pdp-details-entry-content-container' },
        React.createElement(
            'div',
            { className: 'pdp-details-entry-title-container' },
            React.createElement(
                Tour,
                _extends({ step: 4 }, tradeTour, { dataTn: 'details-shipping-trade', className: styles.shippingTitle }),
                React.createElement(
                    'div',
                    { className: 'pdp-shipping-title' },
                    shippingTitle
                )
            )
        ),
        React.createElement(
            'div',
            { className: 'pdp-shipping-entry' },
            React.createElement(QuotePrimary, { quotes: quotes, currency: currency }),
            React.createElement(QuoteHandling, { quotes: quotes, currency: currency }),
            React.createElement(QuoteSecondary, { quotes: quotes, currency: currency }),
            React.createElement(VerifiedTradePromo, { userId: userId, itemId: itemId, viewer: viewer })
        ),
        !itemIsSold && !itemIsUnlisted && React.createElement(
            'div',
            { className: 'pdp-shipping-link-container' },
            React.createElement(ShippingDetailsLink, {
                pagePosition: 'details-shipping',
                context: context,
                user: user,
                userId: userId,
                itemId: itemId,
                dealerPk: dealerPk,
                viewer: viewer,
                quotes: quotes,
                link: link,
                regionType: 'DOMESTIC',
                source: OPEN_DETAILS_FROM_DESCRIPTION,
                favoriteDealer: favoriteDealer,
                favoriteDealerCta: favoriteDealerCta,
                dealerData: dealerData,
                trackingLocation: 'pdp description',
                item: item
            })
        )
    );
};

DetailsShipping.propTypes = {
    context: PropTypes.object,
    hidePrice: PropTypes.bool.isRequired,
    quotes: PropTypes.object.isRequired,
    user: PropTypes.object,
    userId: PropTypes.string,
    itemIsSold: PropTypes.bool,
    itemIsUnlisted: PropTypes.bool,
    itemId: PropTypes.string,
    dealerPk: PropTypes.string,
    viewer: PropTypes.object,
    currency: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired,
    tradeTour: PropTypes.object.isRequired,
    favoriteDealer: PropTypes.object,
    favoriteDealerCta: PropTypes.object,
    dealerData: PropTypes.object,
    item: PropTypes.object
};

module.exports = Relay.createContainer(provideContext(connectToStores(DetailsShipping, [ItemStore, PriceStore, TourStore, UserStore], function (context) {
    var userStore = context.getStore(UserStore);
    var itemStore = context.getStore(ItemStore);
    var item = itemStore.getItem();
    var priceStore = context.getStore(PriceStore);

    var _priceStore$processPr = priceStore.processPrice(item),
        priceDisplays = _priceStore$processPr.priceDisplays;

    var tourStore = context.getStore(TourStore);
    return {
        hidePrice: itemStore.getHidePrice(),
        currency: userStore.getCurrency(),
        copy: itemStore.getCopy().shipping,
        tradeTour: {
            type: TRADE_TOUR,
            subType: priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
            copy: SV.get('tourCopy.' + TRADE_TOUR),
            isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
            currentStep: tourStore.getCurrentStep(TRADE_TOUR),
            totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        }
    };
})), {
    initialVariables: {
        itemId: null,
        userId: null
    },
    fragments: {
        user: function user(_ref) {
            var itemId = _ref.itemId,
                userId = _ref.userId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        alias: 'canRequestShippingQuote',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_REQUEST_SHIPPING_QUOTE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsShipping_UserRelayQL',
                    type: 'User'
                };
            }(ShippingDetailsLink.getFragment('user', { itemId: itemId, userId: userId }));
        },
        item: function item() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsShipping_ItemRelayQL',
                    type: 'Item'
                };
            }(ShippingDetailsLink.getFragment('item'));
        },
        viewer: function viewer(_ref2) {
            var itemId = _ref2.itemId,
                userId = _ref2.userId;
            return function (RQL_0, RQL_1) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsShipping_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(ShippingDetailsLink.getFragment('viewer', { itemId: itemId, userId: userId }), VerifiedTradePromo.getFragment('viewer', { itemId: itemId, userId: userId }));
        }
    }
});

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var get = __webpack_require__(14);
var constants = __webpack_require__(507);
var copy = __webpack_require__(1112);
var styles = __webpack_require__(1719);

function ProductionLeadTime(_ref) {
    var item = _ref.relayItem;

    var leadTimeValue = get(item, 'attributes.leadTime[0].value');

    if (!leadTimeValue || leadTimeValue === constants.availableNow) {
        return null;
    }

    return React.createElement(
        'div',
        { className: 'pdp-product-lead-time' },
        React.createElement(
            'span',
            { className: styles.title },
            copy.productionTime.title
        ),
        leadTimeValue
    );
}

ProductionLeadTime.propTypes = {
    relayItem: PropTypes.object
};

var Connected = Relay.createContainer(ProductionLeadTime, {
    fragments: {
        relayItem: function relayItem() {
            return function () {
                return {
                    children: [{
                        children: [{
                            children: [{
                                fieldName: 'value',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'leadTime',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'AttributeValue'
                        }],
                        fieldName: 'attributes',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true
                        },
                        type: 'ItemAttributes'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ProductionLeadTime_RelayItemRelayQL',
                    type: 'Item'
                };
            }();
        }
    }
});

module.exports = {
    Raw: ProductionLeadTime,
    Connected: Connected
};

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(1010),
    DOMESTIC = _require.DOMESTIC,
    LOCAL = _require.LOCAL;

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var _require2 = __webpack_require__(541),
    getValidQuote = _require2.getValidQuote;

var get = __webpack_require__(14);

function QuotePrimary(_ref) {
    var quotes = _ref.quotes,
        currency = _ref.currency;

    var handlingTimeCopy = '';

    if (quotes.domestic.length) {
        handlingTimeCopy = get(getValidQuote({
            quotes: quotes.domestic,
            regionType: DOMESTIC,
            currency: currency
        }), 'handlingTimeCopy', '');
    } else if (quotes.local.length) {
        handlingTimeCopy = get(getValidQuote({
            quotes: quotes.local,
            regionType: LOCAL,
            currency: currency
        }), 'handlingTimeCopy', '');
    }

    if (handlingTimeCopy) {
        return React.createElement(
            'div',
            { 'data-tn': 'shipping-handling' },
            handlingTimeCopy
        );
    }
    return null;
}

QuotePrimary.propTypes = {
    quotes: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired
};

module.exports = QuotePrimary;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var _require = __webpack_require__(541),
    getValidQuote = _require.getValidQuote;

var _require2 = __webpack_require__(1010),
    LOCAL = _require2.LOCAL;

function QuoteSecondary(_ref) {
    var quotes = _ref.quotes,
        currency = _ref.currency;

    if (quotes.local.length && quotes.domestic.length) {
        var _getValidQuote = getValidQuote({
            quotes: quotes.local,
            regionType: LOCAL,
            currency: currency
        }),
            output = _getValidQuote.output;

        if (output) {
            return React.createElement(
                'div',
                { 'data-tn': 'shipping-secondary' },
                '(',
                output,
                ')'
            );
        }
    }
    return null;
}

QuoteSecondary.propTypes = {
    quotes: PropTypes.shape({
        local: PropTypes.arrayOf(PropTypes.object).isRequired,
        domestic: PropTypes.arrayOf(PropTypes.object).isRequired
    }).isRequired,
    currency: PropTypes.string.isRequired
};

module.exports = QuoteSecondary;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 8/28/16.
 */



var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);

// Components
var DetailsShipping = __webpack_require__(1858);
var DetailsReturns = __webpack_require__(1857);
var DetailsPaymentMethods = __webpack_require__(1854);
var DetailsInvoice = __webpack_require__(1853);

var ShippingAndReturnsColumn = function ShippingAndReturnsColumn(props) {
    var hasUserId = props.hasUserId,
        item = props.item,
        user = props.user,
        quotes = props.quotes,
        context = props.context,
        userId = props.userId,
        itemId = props.itemId,
        itemIsSold = props.itemIsSold,
        itemIsUnlisted = props.itemIsUnlisted,
        dealerPk = props.dealerPk,
        viewer = props.viewer,
        favoriteDealer = props.favoriteDealer,
        favoriteDealerCta = props.favoriteDealerCta,
        dealerData = props.dealerData,
        isPrintPage = props.isPrintPage;

    return React.createElement(
        'div',
        { className: 'pdp-shipping-subcontainer' },
        React.createElement(
            'div',
            { className: 'pdp-shipping-title-container' },
            React.createElement(
                'h2',
                { className: 'pdp-shipping-title header-primary-large pdp-secondary-header' },
                'Shipping & Returns'
            )
        ),
        React.createElement(
            'div',
            { className: 'pdp-shipping-content-container' },
            React.createElement(DetailsShipping, {
                context: context,
                user: user,
                quotes: quotes,
                userId: userId,
                itemIsSold: itemIsSold,
                itemIsUnlisted: itemIsUnlisted,
                itemId: itemId,
                viewer: viewer,
                dealerPk: dealerPk,
                favoriteDealer: favoriteDealer,
                favoriteDealerCta: favoriteDealerCta,
                dealerData: dealerData,
                item: item
            }),
            React.createElement(DetailsReturns, {
                context: context,
                item: item,
                user: user
            }),
            React.createElement(DetailsPaymentMethods, {
                item: item,
                user: user
            }),
            React.createElement(DetailsInvoice, {
                context: context,
                hasUserId: hasUserId,
                itemId: itemId,
                userId: userId,
                viewer: viewer,
                user: user,
                isPrintPage: isPrintPage
            })
        )
    );
};

ShippingAndReturnsColumn.defaultProps = {
    isPrintPage: false
};

ShippingAndReturnsColumn.propTypes = {
    isPrintPage: PropTypes.bool,
    context: PropTypes.object,
    itemId: PropTypes.string,
    itemIsSold: PropTypes.bool,
    itemIsUnlisted: PropTypes.bool,
    hasUserId: PropTypes.bool,
    userId: PropTypes.string,
    dealerPk: PropTypes.string,
    viewer: PropTypes.object,
    item: PropTypes.object,
    user: PropTypes.object,
    quotes: PropTypes.object.isRequired,
    favoriteDealer: PropTypes.object,
    favoriteDealerCta: PropTypes.object,
    dealerData: PropTypes.object
};

module.exports = Relay.createContainer(ShippingAndReturnsColumn, {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null
    },
    fragments: {
        user: function user(_ref) {
            var hasUserId = _ref.hasUserId,
                itemId = _ref.itemId,
                userId = _ref.userId;
            return function (RQL_0, RQL_1, RQL_2, RQL_3) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1), Relay.QL.__frag(RQL_2), Relay.QL.__frag(RQL_3)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ShippingAndReturnsColumn_UserRelayQL',
                    type: 'User'
                };
            }(DetailsReturns.getFragment('user'), DetailsShipping.getFragment('user', { itemId: itemId, userId: userId }), DetailsPaymentMethods.getFragment('user'), DetailsInvoice.getFragment('user', { hasUserId: hasUserId, itemId: itemId, userId: userId }));
        },
        item: function item() {
            return function (RQL_0, RQL_1, RQL_2) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1), Relay.QL.__frag(RQL_2)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ShippingAndReturnsColumn_ItemRelayQL',
                    type: 'Item'
                };
            }(DetailsShipping.getFragment('item'), DetailsReturns.getFragment('item'), DetailsPaymentMethods.getFragment('item'));
        },
        viewer: function viewer(_ref2) {
            var hasUserId = _ref2.hasUserId,
                itemId = _ref2.itemId,
                userId = _ref2.userId;
            return function (RQL_0, RQL_1) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ShippingAndReturnsColumn_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(DetailsShipping.getFragment('viewer', { itemId: itemId, userId: userId }), DetailsInvoice.getFragment('viewer', { hasUserId: hasUserId, itemId: itemId, userId: userId }));
        }
    }
});

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var classNames = __webpack_require__(16);
var get = __webpack_require__(14);
var styles = __webpack_require__(1720);
var DetailsQuotes = __webpack_require__(1865);
var ModalCloseButton = __webpack_require__(759).default;
var BarHeader = __webpack_require__(758).default;

var _require = __webpack_require__(1864),
    FooterQuoteBlurb = _require.FooterQuoteBlurb,
    FooterLegalBlurb = _require.FooterLegalBlurb;

var copy = __webpack_require__(1579);

var _require2 = __webpack_require__(785),
    OPEN_DETAILS_FROM_SIDEBAR = _require2.OPEN_DETAILS_FROM_SIDEBAR,
    OPEN_DETAILS_FROM_DESCRIPTION = _require2.OPEN_DETAILS_FROM_DESCRIPTION;

function ShippingDetailsModal(props) {
    var _props$quotes = props.quotes,
        quotes = _props$quotes === undefined ? [] : _props$quotes,
        currency = props.currency,
        closeShippingModal = props.closeShippingModal,
        _props$user = props.user,
        user = _props$user === undefined ? {} : _props$user,
        source = props.source,
        openQuoteRequestModal = props.openQuoteRequestModal,
        userId = props.userId,
        itemId = props.itemId,
        viewer = props.viewer,
        item = props.item;

    return React.createElement(
        'div',
        { 'data-tn': 'shipping-details-modal', className: classNames('containerFluid', styles.wrapper) },
        React.createElement(BarHeader, { title: copy.title }),
        React.createElement(ModalCloseButton, { onClick: closeShippingModal }),
        React.createElement(
            'div',
            null,
            React.createElement(DetailsQuotes, {
                quotes: quotes.shipmentQuotes,
                currency: currency,
                userId: userId,
                itemId: itemId,
                viewer: viewer,
                item: item
            }),
            React.createElement(FooterQuoteBlurb, {
                openQuoteRequestModal: openQuoteRequestModal,
                canRequestShippingQuote: get(user, 'canRequestShippingQuote', false),
                isVerifiedTrade: get(user, 'canSeeTradeReturns', false),
                quotes: quotes,
                source: source
            }),
            React.createElement(FooterLegalBlurb, null)
        )
    );
}

ShippingDetailsModal.propTypes = {
    source: PropTypes.oneOf([OPEN_DETAILS_FROM_SIDEBAR, OPEN_DETAILS_FROM_DESCRIPTION]).isRequired,
    closeShippingModal: PropTypes.func,
    currency: PropTypes.string.isRequired,
    user: PropTypes.object,
    quotes: PropTypes.object.isRequired,
    openQuoteRequestModal: PropTypes.func,
    userId: PropTypes.string,
    itemId: PropTypes.string,
    viewer: PropTypes.object,
    item: PropTypes.object
};

module.exports = Relay.createContainer(ShippingDetailsModal, {
    initialVariables: {
        userId: null,
        itemId: null
    },
    fragments: {
        user: function user() {
            return function () {
                return {
                    children: [{
                        alias: 'canSeeTradeReturns',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_TRADE_RETURN_POLICY'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        alias: 'canRequestShippingQuote',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_REQUEST_SHIPPING_QUOTE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ShippingDetailsModal_UserRelayQL',
                    type: 'User'
                };
            }();
        },
        item: function item() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ShippingDetailsModal_ItemRelayQL',
                    type: 'Item'
                };
            }(DetailsQuotes.getFragment('item'));
        },
        viewer: function viewer(_ref) {
            var itemId = _ref.itemId,
                userId = _ref.userId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ShippingDetailsModal_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(DetailsQuotes.getFragment('viewer', { itemId: itemId, userId: userId }));
        }
    }
});

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var get = __webpack_require__(14);

var copy = __webpack_require__(1580);

var _require = __webpack_require__(785),
    OPEN_DETAILS_FROM_SIDEBAR = _require.OPEN_DETAILS_FROM_SIDEBAR,
    OPEN_DETAILS_FROM_DESCRIPTION = _require.OPEN_DETAILS_FROM_DESCRIPTION;

var styles = __webpack_require__(1721);

function FooterQuoteBlurb(props) {
    var canRequestShippingQuote = props.canRequestShippingQuote,
        quotes = props.quotes;

    var hasQuotes = !!get(quotes, 'shipmentQuotes', []).length;
    if (canRequestShippingQuote) {
        var openQuoteRequestModal = props.openQuoteRequestModal;

        return React.createElement(
            'div',
            null,
            React.createElement(
                'div',
                { className: hasQuotes ? styles.quoteWrapper : styles.quoteWrapperNoQuotes },
                React.createElement(
                    'span',
                    { className: styles.somewhereElse },
                    hasQuotes ? copy.preDisclaimer.canRequestQuote.copy : null,
                    React.createElement(
                        'a',
                        { 'data-tn': 'shipping-request-open-quote-modal', href: '#', onClick: openQuoteRequestModal },
                        copy.preDisclaimer.canRequestQuote.linkCTA
                    )
                )
            )
        );
    }
    var isVerifiedTrade = props.isVerifiedTrade;

    var preDisclaimer = copy.preDisclaimer.standard;
    if (!hasQuotes) {
        preDisclaimer = copy.preDisclaimer.none;
    } else if (isVerifiedTrade) {
        preDisclaimer = copy.preDisclaimer.trade;
    }

    return React.createElement(
        'div',
        null,
        React.createElement(
            'div',
            { className: hasQuotes ? styles.quoteWrapper : styles.quoteWrapperNoQuotes },
            React.createElement(
                'span',
                { className: styles.somewhereElse },
                preDisclaimer
            ),
            React.createElement(
                'span',
                null,
                copy.disclaimer
            )
        ),
        hasQuotes ? null : React.createElement('div', { className: styles.noQuotes })
    );
}

FooterQuoteBlurb.propTypes = {
    canRequestShippingQuote: PropTypes.bool,
    isVerifiedTrade: PropTypes.bool,
    quotes: PropTypes.shape({
        shipmentQuotes: PropTypes.array.isRequired
    }).isRequired,
    source: PropTypes.oneOf([OPEN_DETAILS_FROM_SIDEBAR, OPEN_DETAILS_FROM_DESCRIPTION]).isRequired,
    openQuoteRequestModal: PropTypes.func
};

function FooterLegalBlurb() {
    return React.createElement(
        'div',
        null,
        React.createElement(
            'div',
            { className: styles.customsWrapper },
            copy.legal,
            React.createElement(
                'a',
                { href: copy.link },
                copy.linkCTA
            )
        )
    );
}

module.exports = { FooterLegalBlurb: FooterLegalBlurb, FooterQuoteBlurb: FooterQuoteBlurb };

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var classNames = __webpack_require__(16);
var get = __webpack_require__(14);
var tokenReplace = __webpack_require__(75);

var _require = __webpack_require__(541),
    getFormattedPrice = _require.getFormattedPrice,
    filterQuote = _require.filterQuote,
    sortQuote = _require.sortQuote;

var Header = __webpack_require__(1867).default;
var VerifiedTradePromo = __webpack_require__(1084).default;

var _require2 = __webpack_require__(1340),
    applyPromo = _require2.applyPromo,
    promoCoversShipping = _require2.promoCoversShipping;

var _require3 = __webpack_require__(1339),
    ViewerFragment = _require3.ViewerFragment;

var copy = __webpack_require__(1581);
var shipmentMethodDefinitions = __webpack_require__(1582);
var displayTransformations = __webpack_require__(1011);
var styles = __webpack_require__(1722);

var REGION_BOUNDARIES = ['DOMESTIC', 'REGIONAL', 'DISTRICT', 'METROPOLITAN', 'GLOBAL', 'REST_OF_WORLD'];

function getQuoteData(_ref) {
    var currency = _ref.currency,
        userId = _ref.userId,
        itemId = _ref.itemId,
        viewer = _ref.viewer;

    return function (_ref2) {
        var node = _ref2.node;

        var method = get(node, 'serviceMethod.displayName');
        method = displayTransformations[method] || method;
        if (node.is1stdibsWhiteGloveQuote) {
            method = '1stdibs ' + method + ' (Full Service)';
        } else if (node.is1stdibsBilledQuote) {
            method = '1stdibs ' + method;
        }

        var _getFormattedPrice = getFormattedPrice(get(node, 'totalAmount.convertedAmountList'), currency),
            string = _getFormattedPrice.string,
            abbreviation = _getFormattedPrice.abbreviation;

        var price = string + ' ' + abbreviation;
        if (get(node, 'totalAmount.amount') === 0) {
            price = 'Complimentary';
        }
        var totalAmount = node.totalAmount;


        var serviceMethodType = get(node, 'serviceMethod.serviceMethodType');
        var serviceType = get(node, 'serviceMethod.serviceType');
        var methodDefinition = tokenReplace(shipmentMethodDefinitions[serviceType][serviceMethodType] || "", {
            facilitatedBy: node.is1stdibsBilledQuote ? '1stdibs' : 'seller'
        });

        return {
            minTime: get(node, 'serviceMethod.windowMin.numberOfUnits'),
            regionBoundary: get(node, 'serviceMethod.region.regionBoundary.type.name'),
            shipTo: get(node, 'serviceMethod.region.regionName'),
            method: method,
            methodDefinition: methodDefinition,
            shipTime: get(node, 'handlingTimeDisplay'),
            price: price,
            id: get(node, 'serviceId'),
            shippingPromo: {
                element: React.createElement(VerifiedTradePromo, {
                    userId: userId,
                    itemId: itemId,
                    viewer: viewer,
                    shippingAmount: totalAmount,
                    inShippingModal: true
                }),
                coversShipping: applyPromo(viewer) && promoCoversShipping(totalAmount)
            }
        };
    };
}

function DataPoint(_ref3) {
    var value = _ref3.value,
        valueClass = _ref3.valueClass,
        dataTn = _ref3.dataTn,
        _ref3$className = _ref3.className,
        className = _ref3$className === undefined ? 'colLg12' : _ref3$className,
        _ref3$infoElement = _ref3.infoElement,
        infoElement = _ref3$infoElement === undefined ? null : _ref3$infoElement;

    return React.createElement(
        'div',
        { className: classNames(className, 'colSm12', styles.dataPoint) },
        React.createElement(
            'div',
            { className: styles.value },
            React.createElement(
                'span',
                { className: valueClass, 'data-tn': dataTn + '-value' },
                ' ',
                value,
                ' '
            ),
            infoElement
        )
    );
}

DataPoint.propTypes = {
    className: PropTypes.string,
    value: PropTypes.string,
    valueClass: PropTypes.string,
    dataTn: PropTypes.string,
    infoElement: PropTypes.node
};

function Quote(quote) {
    var _quote$shippingPromo = quote.shippingPromo,
        shippingPromo = _quote$shippingPromo === undefined ? {} : _quote$shippingPromo;

    var priceClass = classNames(styles.price, _defineProperty({}, styles.applyFreeShipping, shippingPromo.coversShipping));

    return React.createElement(
        'div',
        {
            'data-tn': 'shipping-row',
            key: 'quote-' + quote.id,
            className: classNames('rowFlex', 'colSm12', styles.quote)
        },
        React.createElement(
            'div',
            { className: classNames('colLg9', styles.column) },
            React.createElement(DataPoint, {
                dataTn: 'ship-method',
                className: styles.method,
                value: quote.method
            }),
            React.createElement(DataPoint, {
                dataTn: 'ship-method-definition',
                value: quote.methodDefinition
            })
        ),
        React.createElement(
            'div',
            { className: classNames('colLg2', styles.column) },
            React.createElement(DataPoint, {
                dataTn: 'ship-time',
                value: quote.shipTime
            }),
            React.createElement(DataPoint, {
                dataTn: 'ship-price',
                value: quote.price,
                valueClass: priceClass,
                infoElement: shippingPromo.element
            })
        )
    );
}

Quote.propTypes = {
    quote: PropTypes.shape({
        shipTo: PropTypes.string,
        method: PropTypes.string,
        methodDefinition: PropTypes.string,
        shipTime: PropTypes.string,
        price: PropTypes.string,
        shippingPromo: PropTypes.object
    }).isRequired,
    index: PropTypes.number.isRequired
};

function Quotes(_ref4) {
    var _ref4$quotes = _ref4.quotes,
        quotes = _ref4$quotes === undefined ? [] : _ref4$quotes,
        currency = _ref4.currency,
        userId = _ref4.userId,
        itemId = _ref4.itemId,
        viewer = _ref4.viewer,
        item = _ref4.item;

    var filteredQuotes = quotes.filter(filterQuote).sort(sortQuote).map(getQuoteData({
        currency: currency,
        userId: userId,
        itemId: itemId,
        viewer: viewer
    }));
    if (!filteredQuotes.length) {
        return null;
    }
    if (filteredQuotes[0].shipTo === copy.restOfWorld) {
        if (filteredQuotes.length === 1) {
            filteredQuotes[0].shipTo = copy.alone;
        } else {
            filteredQuotes[0].shipTo = copy.withOthers;
        }
    }

    // group quotes by regionName
    var groupedQuoteObj = filteredQuotes.reduce(function (groups, quote) {
        var regionName = quote.shipTo;
        if (!regionName) {
            return groups;
        }

        groups[regionName] = groups[regionName] || [];
        groups[regionName].push(quote);
        return groups;
    }, {});

    // convert groupedQuoteObj into array
    var groupedQuotes = Object.keys(groupedQuoteObj).map(function (key) {
        return groupedQuoteObj[key];
    });

    // sort array by regionBoundary then by regionName
    groupedQuotes.sort(function (a, b) {
        var aBoundary = get(a[0], 'regionBoundary');
        var bBoundary = get(b[0], 'regionBoundary');
        var aName = get(a[0], 'shipTo');
        var bName = get(b[0], 'shipTo');
        var boundarySort = REGION_BOUNDARIES.indexOf(aBoundary) - REGION_BOUNDARIES.indexOf(bBoundary);

        if (boundarySort) {
            return boundarySort;
        }
        if (aName < bName) {
            return -1;
        }
        if (aName > bName) {
            return 1;
        }
        return 0;
    });

    return React.createElement(
        'div',
        null,
        React.createElement(Header, { item: item }),
        groupedQuotes.map(function (q) {
            var shipTo = q[0].shipTo;
            return React.createElement(
                'div',
                {
                    key: 'quote-region-' + shipTo,
                    'data-tn': 'quote-region-' + shipTo,
                    className: styles.wrapper
                },
                React.createElement(
                    'div',
                    { className: styles.boundaryHeader },
                    shipTo
                ),
                q.map(Quote)
            );
        })
    );
}

Quotes.propTypes = {
    quotes: PropTypes.array.isRequired,
    currency: PropTypes.string.isRequired,
    userId: PropTypes.string,
    itemId: PropTypes.string,
    viewer: PropTypes.object,
    item: PropTypes.object
};

module.exports = Relay.createContainer(Quotes, {
    initialVariables: {
        userId: null,
        itemId: null
    },
    fragments: {
        item: function item() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsQuotes_ItemRelayQL',
                    type: 'Item'
                };
            }(Header.getFragment('item'));
        },
        viewer: function viewer(_ref5) {
            var itemId = _ref5.itemId,
                userId = _ref5.userId;
            return function (RQL_0, RQL_1) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'DetailsQuotes_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(VerifiedTradePromo.getFragment('viewer', { itemId: itemId, userId: userId }), ViewerFragment);
        }
    }
});

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classNames = __webpack_require__(16);
var styles = __webpack_require__(1723);
var CloseIcon = __webpack_require__(276);

function Title(_ref) {
    var close = _ref.close,
        title = _ref.title;

    return React.createElement(
        'div',
        null,
        React.createElement(
            'div',
            { className: classNames('rowFlex', 'colSm12', styles.wrapper) },
            React.createElement(
                'span',
                { className: styles.text },
                title
            ),
            React.createElement(
                'a',
                { 'data-tn': 'close-modal', className: styles.closeWrapper, href: '#0', onClick: close },
                React.createElement(CloseIcon, { className: styles.close })
            )
        ),
        React.createElement('div', { className: styles.headerBottomBorder })
    );
}

Title.propTypes = {
    title: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired
};

module.exports = Title;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__(18);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _lodash = __webpack_require__(14);

var _lodash2 = _interopRequireDefault(_lodash);

var _Header = __webpack_require__(1724);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Header(_ref) {
    var item = _ref.item;

    var dealerLocation = (0, _lodash2.default)(item, 'seller.shippingAddress.displayCityStateCountry');
    return _react2.default.createElement(
        'div',
        { className: 'rowFlex colSm12 ' + _Header2.default.container },
        'ships from ' + dealerLocation
    );
}

Header.propTypes = {
    item: _propTypes2.default.object
};

exports.default = _reactRelay2.default.createContainer(Header, {
    fragments: {
        item: function item() {
            return function () {
                return {
                    children: [{
                        children: [{
                            children: [{
                                fieldName: 'displayCityStateCountry',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'shippingAddress',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'Address'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: _reactRelay2.default.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Header_ItemRelayQL',
                    type: 'Item'
                };
            }();
        }
    }
});

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _dibsReactTooltip = __webpack_require__(270);

var _dibsReactTooltip2 = _interopRequireDefault(_dibsReactTooltip);

var _infoCircle = __webpack_require__(437);

var _infoCircle2 = _interopRequireDefault(_infoCircle);

var _infoCircleFilled = __webpack_require__(1119);

var _infoCircleFilled2 = _interopRequireDefault(_infoCircleFilled);

var _verifiedTradePromoConstants = __webpack_require__(1085);

var _VerifiedTradePromo = __webpack_require__(1256);

var _VerifiedTradePromo2 = _interopRequireDefault(_VerifiedTradePromo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VerifiedTradePromoInfo = function (_Component) {
    _inherits(VerifiedTradePromoInfo, _Component);

    function VerifiedTradePromoInfo() {
        _classCallCheck(this, VerifiedTradePromoInfo);

        var _this = _possibleConstructorReturn(this, (VerifiedTradePromoInfo.__proto__ || Object.getPrototypeOf(VerifiedTradePromoInfo)).call(this));

        _this.state = {
            isVisible: false
        };

        _this._setVisibility = _this._setVisibility.bind(_this);
        return _this;
    }

    _createClass(VerifiedTradePromoInfo, [{
        key: '_setVisibility',
        value: function _setVisibility(isVisible) {
            this.setState({ isVisible: isVisible });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var tooltipDirection = this.props.tooltipDirection;
            var isVisible = this.state.isVisible;
            var _shipping$tooltip = _verifiedTradePromoConstants.shipping.tooltip,
                texts = _shipping$tooltip.texts,
                link = _shipping$tooltip.link;

            var IconView = isVisible ? _infoCircleFilled2.default : _infoCircle2.default;

            return _react2.default.createElement(
                'div',
                { className: _VerifiedTradePromo2.default.infoContainer, onMouseEnter: function onMouseEnter() {
                        return _this2._setVisibility(true);
                    }, onMouseLeave: function onMouseLeave() {
                        return _this2._setVisibility(false);
                    } },
                _react2.default.createElement(IconView, { className: _VerifiedTradePromo2.default.infoIcon }),
                _react2.default.createElement(
                    _dibsReactTooltip2.default,
                    {
                        isVisible: isVisible,
                        className: (0, _classnames2.default)(_VerifiedTradePromo2.default.tooltip, _VerifiedTradePromo2.default[tooltipDirection]),
                        containerClass: _VerifiedTradePromo2.default.tooltipInner,
                        tooltipDirection: tooltipDirection
                    },
                    texts.MAIN,
                    ' ',
                    _react2.default.createElement(
                        'a',
                        { href: link.URL, target: '_blank' },
                        link.TEXT
                    ),
                    ' ',
                    texts.END
                )
            );
        }
    }]);

    return VerifiedTradePromoInfo;
}(_react.Component);

VerifiedTradePromoInfo.propTypes = {
    tooltipDirection: _propTypes2.default.string
};

exports.default = VerifiedTradePromoInfo;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

// Stores
var ItemStore = __webpack_require__(336);

// Helpers
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var classnames = __webpack_require__(16);

var Title = function Title(_ref) {
    var isArt = _ref.isArt,
        creationDate = _ref.creationDate,
        creatorData = _ref.creatorData,
        title = _ref.title;

    var titleClass = classnames({
        'pdp-sidebar-title-text': true,
        italic: isArt
    });
    var titleWrapperClass = classnames({
        'pdp-sidebar-title-inner': true,
        'pdp-sidebar-art-title-text': isArt
    });
    var creatorEl = void 0;
    var dateEl = void 0;

    if (isArt) {
        if (creationDate) {
            dateEl = React.createElement(
                'div',
                { className: 'pdp-sidebar-title-year-text' },
                React.createElement(
                    'span',
                    { className: 'pdp-sidebar-title-year' },
                    creationDate
                )
            );
        }

        if (creatorData && creatorData.name) {
            creatorEl = React.createElement(
                'div',
                { className: 'pdp-sidebar-title-creator' },
                creatorData.name
            );
        }
    }

    return React.createElement(
        'h1',
        { className: 'pdp-sidebar-title' },
        creatorEl,
        React.createElement(
            'div',
            { className: titleWrapperClass, 'data-tn': 'pdp-main-title' },
            React.createElement(
                'div',
                { className: titleClass },
                title
            ),
            dateEl
        )
    );
};

Title.propTypes = {
    isArt: PropTypes.bool.isRequired,
    creationDate: PropTypes.string,
    creatorData: PropTypes.shape({
        name: PropTypes.string
    }),
    title: PropTypes.string.isRequired
};

var Connected = provideContext(connectToStores(Title, [ItemStore], function (context) {
    var itemStore = context.getStore(ItemStore);

    return {
        creationDate: itemStore.getFromItemModel('classification.creationDate'),
        creatorData: itemStore.getCreatorData(),
        isArt: itemStore.getIsArt(),
        title: itemStore.getFromItemModel('title')
    };
}));

module.exports = {
    Connected: Connected,
    Raw: Title
};

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var SocialIcon = __webpack_require__(891);
var EmailIcon = __webpack_require__(1238);
var hasContextTypes = __webpack_require__(782);

var PdpEmailIcon = React.createClass(hasContextTypes({
    propTypes: {
        vertical: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        itemPk: PropTypes.string.isRequired,
        stfOnClick: PropTypes.func.isRequired,
        iconType: PropTypes.string
    },

    _handleClick: function _handleClick(e) {
        e.preventDefault();
        this.props.stfOnClick(this.props);
    },
    render: function render() {
        var iconType = this.props.iconType;


        return React.createElement(SocialIcon, { onClick: this._handleClick, Icon: EmailIcon, iconName: 'email', iconType: iconType, 'data-tn': 'email' });
    }
}));

module.exports = PdpEmailIcon;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var SocialIcon = __webpack_require__(891);
var FacebookIcon = __webpack_require__(537);

var _require = __webpack_require__(379),
    trackFacebookSuccess = _require.trackFacebookSuccess,
    trackFacebookClick = _require.trackFacebookClick;

var hasContextTypes = __webpack_require__(782);

var PdpFacebookIcon = React.createClass(hasContextTypes({
    propTypes: {
        trackingSuffix: PropTypes.string,
        iconType: PropTypes.string
    },

    _handleClick: function _handleClick() {
        var _this = this;

        // TODO: Maybe check for initialization.
        // TODO: Don't reference window here. Create a wrapper module instead.
        window.FB.ui({
            method: 'stream.share',
            u: window.document.location.href
        }, function (response) {
            return _this.context.executeAction(trackFacebookSuccess, { response: response });
        });

        this.context.executeAction(trackFacebookClick, { suffix: this.props.trackingSuffix });
    },
    render: function render() {
        var iconType = this.props.iconType;


        return React.createElement(SocialIcon, { onClick: this._handleClick, Icon: FacebookIcon, iconType: iconType, iconName: 'facebook', 'data-tn': 'facebook' });
    }
}));

module.exports = PdpFacebookIcon;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Tooltip = __webpack_require__(270);
__webpack_require__(272);

// Stores
var PdpUiStore = __webpack_require__(744);

// Components
var SocialIcon = __webpack_require__(891);
var PrintIcon = __webpack_require__(1028);

// Helpers
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var URL = __webpack_require__(640).URL;
var hasContextTypes = __webpack_require__(782);

var _require = __webpack_require__(379),
    trackPrint = _require.trackPrint;

var PdpPrintIcon = React.createClass(hasContextTypes({
    getInitialState: function getInitialState() {
        return {
            open: false
        };
    },
    _handleClick: function _handleClick() {
        this.setState({ open: true });

        document.body.addEventListener('click', this._closeOnBodyClick);
    },
    _closeOnBodyClick: function _closeOnBodyClick(event) {
        if (!this._icon.contains(event.target)) {
            this.setState({ open: false });
            document.body.removeEventListener('click', this._closeOnBodyClick);
        }
    },
    _printWithPrice: function _printWithPrice() {
        this.context.executeAction(trackPrint, { withPrice: true });
    },
    _printWithoutPrice: function _printWithoutPrice() {
        this.context.executeAction(trackPrint, { withPrice: false });
    },
    render: function render() {
        var _this = this;

        var selectedImage = this.props.selectedImage;

        var printNoPriceParam = 'print-view=no-price';
        var selectedImageParam = '?selected-image=' + selectedImage;
        var printParam = selectedImage ? selectedImageParam : '';
        var printParamNoPrice = selectedImage ? selectedImageParam + '&' + printNoPriceParam : '?' + printNoPriceParam;

        return React.createElement(
            'div',
            { ref: function ref(icon) {
                    _this._icon = icon;
                }, className: 'pdp-print', 'data-tn': 'print' },
            React.createElement(SocialIcon, { onClick: this._handleClick, Icon: PrintIcon, iconName: 'print' }),
            React.createElement(
                Tooltip,
                { isVisible: this.state.open,
                    containerClass: 'pdp-print-tooltip',
                    tooltipDirection: 'bottom' },
                React.createElement(
                    'div',
                    { className: 'pdp-print-menu-item' },
                    React.createElement(
                        'a',
                        { href: '/print' + URL.path + printParam, rel: 'nofollow', target: '_blank', onClick: this._printWithPrice },
                        'Print'
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'pdp-print-menu-item' },
                    React.createElement(
                        'a',
                        { href: '/print' + URL.path + printParamNoPrice, rel: 'nofollow', target: '_blank', onClick: this._printWithoutPrice },
                        'Print without Price'
                    )
                )
            )
        );
    }
}));

PdpPrintIcon.propTypes = {
    selectedImage: PropTypes.number
};

module.exports = provideContext(connectToStores(PdpPrintIcon, [PdpUiStore], function (context) {
    var uiStore = context.getStore(PdpUiStore);

    return { selectedImage: uiStore.getHeroCarouselIndex() };
}));

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 9/15/15.
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ContextComponent = __webpack_require__(61);
var Measurement = __webpack_require__(1851);

var DetailsDimensions = function (_ContextComponent) {
    _inherits(DetailsDimensions, _ContextComponent);

    function DetailsDimensions(props) {
        _classCallCheck(this, DetailsDimensions);

        return _possibleConstructorReturn(this, (DetailsDimensions.__proto__ || Object.getPrototypeOf(DetailsDimensions)).call(this, props));
    }

    _createClass(DetailsDimensions, [{
        key: 'render',
        value: function render() {
            var detailItems = this.props.contents.map(function (content, i) {
                return React.createElement(
                    'div',
                    { key: i },
                    React.createElement(Measurement, { values: content })
                );
            });

            return React.createElement(
                'li',
                { className: 'pdp-details-entry' },
                React.createElement(
                    'div',
                    { className: 'pdp-details-entry-title-container' },
                    React.createElement(
                        'span',
                        { className: 'pdp-details-entry-title' },
                        this.props.title
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'pdp-details-entry-content-container', 'data-tn': this.props.testName },
                    detailItems
                )
            );
        }
    }]);

    return DetailsDimensions;
}(ContextComponent);

DetailsDimensions.propTypes = {
    contents: PropTypes.arrayOf(PropTypes.array.isRequired).isRequired,
    testName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
};

module.exports = DetailsDimensions;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ContextComponent = __webpack_require__(61);
var SanitizeHtml = __webpack_require__(296);

var _require = __webpack_require__(379),
    trackAttributeClick = _require.trackAttributeClick;

var DetailsItem = function (_ContextComponent) {
    _inherits(DetailsItem, _ContextComponent);

    function DetailsItem(props) {
        _classCallCheck(this, DetailsItem);

        var _this = _possibleConstructorReturn(this, (DetailsItem.__proto__ || Object.getPrototypeOf(DetailsItem)).call(this, props));

        _this.fireTracking = _this.fireTracking.bind(_this);
        return _this;
    }

    _createClass(DetailsItem, [{
        key: 'fireTracking',
        value: function fireTracking() {
            var label = this.props.gaLabel;
            this.context.executeAction(trackAttributeClick, { label: label });
        }

        /**
         * Renders markup for each object in the prop contents,
         * an array structured like so
         * {{
         *     value: string,
         *     isLink: boolean,
         *     link: string,
         *     extraCopy: string
         * }[]}
         */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var contentsLength = this.props.contents.length - 1;

            var detailItems = this.props.contents.map(function (content, index) {
                var extraCopy = content.extraCopy ? ' ' + content.extraCopy : '';
                var delimiter = index < contentsLength ? ', ' : '';

                if (content.isLink && content.link && !_this2.props.isPrintPage) {
                    return React.createElement(
                        'div',
                        { className: 'pdp-details-entry-content', key: index },
                        React.createElement(
                            'a',
                            { className: 'pdp-details-entry-content-link', href: content.link, onClick: _this2.fireTracking },
                            React.createElement(SanitizeHtml, { content: content.value })
                        ),
                        extraCopy,
                        delimiter
                    );
                } else {
                    return React.createElement(
                        'div',
                        { className: 'pdp-details-entry-content', key: index },
                        React.createElement(SanitizeHtml, { content: content.value }),
                        extraCopy,
                        delimiter
                    );
                }
            });

            return React.createElement(
                'li',
                { className: 'pdp-details-entry' },
                React.createElement(
                    'div',
                    { className: 'pdp-details-entry-title-container' },
                    React.createElement(
                        'span',
                        { className: 'pdp-details-entry-title' },
                        this.props.title
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'pdp-details-entry-content-container', 'data-tn': this.props.testName },
                    detailItems
                )
            );
        }
    }]);

    return DetailsItem;
}(ContextComponent);

DetailsItem.defaultProps = {
    isPrintPage: false
};

DetailsItem.propTypes = {
    contents: PropTypes.array.isRequired,
    gaLabel: PropTypes.string,
    testName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isPrintPage: PropTypes.bool
};

module.exports = DetailsItem;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ContextComponent = __webpack_require__(61);
var DetailsItem = __webpack_require__(1874);
var DetailsMaterialAndTechniques = __webpack_require__(1876);
var DetailsDimensions = __webpack_require__(1873);
var DetailsMultiline = __webpack_require__(1877);
var findNameSpace = __webpack_require__(285);
var detailsConstants = __webpack_require__(507);

var DetailsItems = function (_ContextComponent) {
    _inherits(DetailsItems, _ContextComponent);

    function DetailsItems(props) {
        _classCallCheck(this, DetailsItems);

        return _possibleConstructorReturn(this, (DetailsItems.__proto__ || Object.getPrototypeOf(DetailsItems)).call(this, props));
    }

    /**
     * This component takes three props
     *   detailsConfig - see definition in detailsConfig {@link newPdp/details/detailsConfig}
     *   detailsTitles - see definition for detailsTitles in ItemStore {@link newPdp/stores/ItemStore}
     *   details       - see defintion for getDetails in ItemStore {@link newPdp/stores/ItemStore}
     *
     * And in render calls the array map method on detailsConfig, at each step using an object
     * in the array to determine what component to use to render a detail as well as what information
     * to pass to that component from detailsTitles and details.
     */


    _createClass(DetailsItems, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var details = this.props.detailsConfig.map(function (config) {
                return {
                    title: findNameSpace(config.title, _this2.props.detailsTitles),
                    contents: findNameSpace(config.contents, _this2.props.details),
                    component: config.component,
                    gaLabel: config.gaLabel,
                    testName: config.testName
                };
            }).filter(function (results) {
                return results.title && results.contents;
            }).map(function (results, i) {
                if (results.component && results.component === findNameSpace('components.materialsAndTechniques', detailsConstants)) {
                    return React.createElement(DetailsMaterialAndTechniques, _extends({}, results, { key: i, isPrintPage: _this2.props.isPrintPage }));
                } else if (results.component && results.component === findNameSpace('components.dimensions', detailsConstants)) {
                    return React.createElement(DetailsDimensions, _extends({}, results, { key: i }));
                } else if (results.component && results.component === findNameSpace('components.multiline', detailsConstants)) {
                    return React.createElement(DetailsMultiline, _extends({}, results, { key: i, isPrintPage: _this2.props.isPrintPage }));
                } else {
                    return React.createElement(DetailsItem, _extends({}, results, { key: i, isPrintPage: _this2.props.isPrintPage }));
                }
            });

            var detailsSize = Object.keys(this.props.details).length;
            var detailsSizeHalf = Math.ceil(detailsSize / 2);

            var detailsFirstHalf = void 0;
            var detailsSecondHalf = void 0;

            if (detailsSize <= 5) {
                // If there are five details, all the details should appear in the left column.
                detailsFirstHalf = details;
            } else if (detailsSize <= 10) {
                // If there are five to ten details, the first five should appear in the left
                // column and the remaining should appear on the right column.
                detailsFirstHalf = details.slice(0, 5);
                detailsSecondHalf = details.slice(5);
            } else {
                // If there are more than ten details, an even amount should appear on
                // the left and right columns.
                detailsFirstHalf = details.slice(0, detailsSizeHalf);
                detailsSecondHalf = details.slice(detailsSizeHalf);
            }

            return React.createElement(
                'div',
                { className: 'pdp-details-entries colXs12' },
                React.createElement(
                    'div',
                    { className: 'rowFlexTransition' },
                    React.createElement(
                        'ul',
                        { className: 'pdp-details-entries-column colXs12 colLg6' },
                        detailsFirstHalf
                    ),
                    React.createElement(
                        'ul',
                        { className: 'pdp-details-entries-column colXs12 colLg6' },
                        detailsSecondHalf
                    )
                )
            );
        }
    }]);

    return DetailsItems;
}(ContextComponent);

DetailsItems.defaultProps = {
    isPrintPage: false
};

DetailsItems.propTypes = {
    details: PropTypes.object.isRequired,
    detailsTitles: PropTypes.object.isRequired,
    detailsConfig: PropTypes.array.isRequired,
    isPrintPage: PropTypes.bool
};

module.exports = DetailsItems;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ContextComponent = __webpack_require__(61);
var SanitizeHtml = __webpack_require__(296);

var _require = __webpack_require__(379),
    trackAttributeClick = _require.trackAttributeClick;

var DetailsMaterialsAndTechniques = function (_ContextComponent) {
    _inherits(DetailsMaterialsAndTechniques, _ContextComponent);

    function DetailsMaterialsAndTechniques(props) {
        _classCallCheck(this, DetailsMaterialsAndTechniques);

        var _this = _possibleConstructorReturn(this, (DetailsMaterialsAndTechniques.__proto__ || Object.getPrototypeOf(DetailsMaterialsAndTechniques)).call(this, props));

        _this.fireTracking = _this.fireTracking.bind(_this);
        return _this;
    }

    _createClass(DetailsMaterialsAndTechniques, [{
        key: 'fireTracking',
        value: function fireTracking() {
            var label = this.props.gaLabel;
            this.context.executeAction(trackAttributeClick, { label: label });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var contentsLength = this.props.contents.length - 1;
            var self = this;

            var detailItems = this.props.contents.map(function (content, index) {
                var contentLength = content.length - 1;

                var materialsAndTechniquesItem = content.map(function (subContent, subIndex) {
                    var classes = subIndex < contentLength ? 'pdp-details-material-and-techniques-value' : '';

                    if (subContent.isLink && subContent.link && !_this2.props.isPrintPage) {
                        return React.createElement(
                            'a',
                            { className: classes, href: subContent.link, onClick: self.fireTracking, key: subIndex },
                            React.createElement(SanitizeHtml, { content: subContent.value })
                        );
                    } else {
                        return React.createElement(SanitizeHtml, { className: classes, key: subIndex, content: subContent.value });
                    }
                });

                var delimiter = index < contentsLength ? ', ' : '';

                return React.createElement(
                    'div',
                    { className: 'pdp-details-entry-content', key: index },
                    materialsAndTechniquesItem,
                    delimiter
                );
            });

            return React.createElement(
                'li',
                { className: 'pdp-details-entry' },
                React.createElement(
                    'div',
                    { className: 'pdp-details-entry-title-container' },
                    React.createElement(
                        'span',
                        { className: 'pdp-details-entry-title' },
                        this.props.title
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'pdp-details-entry-content-container', 'data-tn': this.props.testName },
                    detailItems
                )
            );
        }
    }]);

    return DetailsMaterialsAndTechniques;
}(ContextComponent);

DetailsMaterialsAndTechniques.defaultProps = {
    isPrintPage: false
};

DetailsMaterialsAndTechniques.propTypes = {
    contents: PropTypes.array.isRequired,
    gaLabel: PropTypes.string,
    testName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isPrintPage: PropTypes.bool
};

module.exports = DetailsMaterialsAndTechniques;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var SanitizeHtml = __webpack_require__(296);

var _require = __webpack_require__(379),
    trackAttributeClick = _require.trackAttributeClick;

var DetailsMultiline = function (_React$Component) {
    _inherits(DetailsMultiline, _React$Component);

    function DetailsMultiline(props) {
        _classCallCheck(this, DetailsMultiline);

        var _this = _possibleConstructorReturn(this, (DetailsMultiline.__proto__ || Object.getPrototypeOf(DetailsMultiline)).call(this, props));

        _this.fireTracking = _this.fireTracking.bind(_this);
        return _this;
    }

    _createClass(DetailsMultiline, [{
        key: 'fireTracking',
        value: function fireTracking() {
            this.context.executeAction(trackAttributeClick, { label: this.props.gaLabel });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var detailItems = this.props.contents.map(function (content) {
                if (content.isLink && content.link && !_this2.props.isPrintPage) {
                    return React.createElement(
                        'div',
                        { key: content.value },
                        React.createElement(
                            'a',
                            { className: 'pdp-details-entry-content-link', href: content.link, onClick: _this2.fireTracking },
                            React.createElement(SanitizeHtml, { content: content.value })
                        )
                    );
                } else {
                    return React.createElement(
                        'div',
                        { key: content.value },
                        React.createElement(SanitizeHtml, { content: content.value })
                    );
                }
            });

            return React.createElement(
                'li',
                { className: 'pdp-details-entry' },
                React.createElement(
                    'div',
                    { className: 'pdp-details-entry-title-container' },
                    React.createElement(
                        'span',
                        { className: 'pdp-details-entry-title' },
                        this.props.title
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'pdp-details-entry-content-container', 'data-tn': this.props.testName },
                    detailItems
                )
            );
        }
    }]);

    return DetailsMultiline;
}(React.Component);

DetailsMultiline.contextTypes = {
    executeAction: PropTypes.func.isRequired
};

DetailsMultiline.defaultProps = {
    isPrintPage: false
};

DetailsMultiline.propTypes = {
    contents: PropTypes.array.isRequired,
    gaLabel: PropTypes.string,
    testName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isPrintPage: PropTypes.bool
};

module.exports = DetailsMultiline;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var _require = __webpack_require__(379),
    trackPinterestClick = _require.trackPinterestClick;

var TRACKING_SUFFIX = 'zoom modal';

var Pinterest = __webpack_require__(1333);
var pinterestActions = __webpack_require__(710);

var PinterestButton = function (_Pinterest) {
    _inherits(PinterestButton, _Pinterest);

    function PinterestButton(props) {
        _classCallCheck(this, PinterestButton);

        var _this = _possibleConstructorReturn(this, (PinterestButton.__proto__ || Object.getPrototypeOf(PinterestButton)).call(this, props));

        _this._handlePinterestChange = _this._handlePinterestChange.bind(_this);

        _this.state = {
            media: _this.props.media
        };
        return _this;
    }

    _createClass(PinterestButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var model = this.props.model;

            if (model) {
                model.on('change', this._handlePinterestChange);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.model.off('change');
        }
    }, {
        key: '_handlePinterestChange',
        value: function _handlePinterestChange(model) {
            var media = model.getSelectedImage();
            this.setState({ media: media });
        }
    }, {
        key: 'pin',
        value: function pin() {
            var _props = this.props,
                url = _props.url,
                description = _props.description;
            var media = this.state.media;

            var pinterestWindow = this.openWindow();
            this.context.executeAction(pinterestActions.pin, { pinterestWindow: pinterestWindow, url: url, media: media, description: description });
            this.context.executeAction(trackPinterestClick, { suffix: TRACKING_SUFFIX });
        }
    }, {
        key: 'render',
        value: function render() {
            var divStyle = {
                cursor: 'pointer'
            };

            return React.createElement(
                'div',
                { style: divStyle,
                    'data-tn': 'pinterest',
                    'data-pin-do': this.props.pinDo,
                    'data-pin-config': this.props.pinConfig,
                    'data-pin-color': this.props.pinColor,
                    'data-pin-height': this.props.pinHeight,
                    onClick: this.pin },
                React.createElement('img', { src: this.props.buttonSrc })
            );
        }
    }]);

    return PinterestButton;
}(Pinterest);

PinterestButton.propTypes = Object.assign({}, Pinterest.propTypes, {
    buttonSrc: PropTypes.string,
    pinDo: PropTypes.string,
    pinConfig: PropTypes.string,
    pinColor: PropTypes.string,
    pinHeight: PropTypes.string
});

PinterestButton.defaultProps = Object.assign({}, Pinterest.defaultProps, {
    buttonSrc: '//assets.pinterest.com/images/pidgets/pinit_fg_en_rect_white_28.png',
    pinDo: 'buttonPin',
    pinConfig: 'above',
    pinColor: 'white',
    pinHeight: '28'
});

module.exports = PinterestButton;

/***/ }),
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

_ = __webpack_require__(23);
module.exports = {
    "carouselBinTemplate": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="carousel-bin">\n        ';
 _.each(obj.images, function(src, index) { ;
__p += '\n            <div class="carousel-bin-image-wrapper" data-index="' +
((__t = ( index )) == null ? '' : __t) +
'">\n                <div class="carousel-bin-image" style="background-image: url(' +
((__t = ( src )) == null ? '' : __t) +
');" ></div>\n            </div>\n        ';
 }); ;
__p += '\n    </div>\n';
return __p
}
};

/***/ }),
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

_ = __webpack_require__(23);
module.exports = {
    "modalCarouselTemplate": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="modal-carousel2">\n        <div class="modal-carousel-body">\n            <div class="modal-carousel-previous">\n                ' +
((__t = ( obj.arrowLeftIcon )) == null ? '' : __t) +
'\n            </div>\n            <div class="modal-carousel-image">\n                <img class="modal-carousel-small-image" />\n            </div>\n            <div class="modal-carousel-next">\n                ' +
((__t = ( obj.arrowRightIcon )) == null ? '' : __t) +
'\n            </div>\n        </div>\n        <div class="modal-carousel-footer">\n            <div class="modal-carousel-social social-share-nav use-icons is-round is-reverse item-hero-actions-social"></div>\n            <div class="modal-carousel-bin"></div>\n            <div class="modal-carousel-actions">\n                ';
 if (obj.purchasable) { ;
__p += '\n                    <a href="' +
((__t = ( obj.checkoutRoute )) == null ? '' : __t) +
'" class="button-primary button-medium modal-carousel-purchase">purchase</a>\n                ';
 } ;
__p += '\n            </div>\n        </div>\n    </div>\n';
return __p
}
};

/***/ }),
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */
/***/ (function(module, exports) {

module.exports = {
	"header": "Request Condition Report",
	"descriptionLabel": "The dealer will provide a written condition report for this item. If you have any specific questions regarding condition that you would like the report to address, please include them below.",
	"error": "This field is required.",
	"buttonSend": "Send",
	"buttonSending": "Sending...",
	"makeOfferLinkPrompt": "Ready to negotiate? ",
	"makeOfferLinkCta": "Make an offer >",
	"successHeader": "Request Sent",
	"successMessage": "You will receive a written condition report via email within two business days. If you require any assistance in the meantime, please contact Trade Concierge Services at <a href=\"mailto:trade@1stdibs.com\">trade@1stdibs.com</a> or 646-454-2651."
};

/***/ }),
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"ConditionReportModal__content__1_Fwd","label":"ConditionReportModal__label__3BwjU","textarea":"ConditionReportModal__textarea__2xc-H","error":"ConditionReportModal__error__2si6B","submit":"ConditionReportModal__submit__1fWsH","makeOfferModalLink":"ConditionReportModal__makeOfferModalLink__14GOM","makeOfferModalLinkCta":"ConditionReportModal__makeOfferModalLinkCta__2_yCh"};

/***/ }),
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(92),
    createReducerStore = _require.createReducerStore;

var Message = __webpack_require__(72);
var ContactDealerStore = createReducerStore(__webpack_require__(136));
var authModalLoader = __webpack_require__(263).default;

var ENTER_MESSAGE = 'ENTER_MESSAGE';
var ENTER_NAME = 'ENTER_NAME';
var MESSAGE_SEND_BEGIN = 'MESSAGE_SEND_BEGIN';
var MESSAGE_SEND_END = 'MESSAGE_SEND_END';
var SET_USER_VALUES = 'SET_USER_VALUES';
var SET_OPTIMIZELY_VARIANT = 'SET_OPTIMIZELY_VARIANT';

function setOptimizelyVariant(actionContext, payload) {
    actionContext.dispatch(SET_OPTIMIZELY_VARIANT, payload);
}

function initializeOffer(actionContext, payload) {
    actionContext.dispatch('pdp:contact:loading:done', payload);
}

function submitOffer(actionContext, payload) {
    var item = payload.item,
        offer = payload.offer;

    var message = actionContext.getStore(ContactDealerStore).getMessage();
    offer.redirectToCheckout({ message: message, item: item });
}

function sendMessage(actionContext, payload) {
    var messageBody = payload.messageBody;

    var message = new Message(messageBody);
    if (messageBody.textBody) {
        actionContext.dispatch(MESSAGE_SEND_BEGIN);
        return message.save().then(function () {
            return actionContext.dispatch(MESSAGE_SEND_END);
        });
    }
    return null;
}

function enterName(actionContext, payload) {
    actionContext.dispatch(ENTER_NAME, payload);
}

function enterMessage(actionContext, payload) {
    actionContext.dispatch(ENTER_MESSAGE, payload);
}

function submitMessageLoggedIn(actionContext, payload) {
    actionContext.dispatch(SET_USER_VALUES, {
        displayName: actionContext.getStore(ContactDealerStore).getName(),
        user: payload
    });
    var messageBody = actionContext.getStore(ContactDealerStore).state;
    return sendMessage(actionContext, messageBody);
}

function submitMessageNotLoggedIn(actionContext) {
    var action = authModalLoader.constants.REGISTER;

    authModalLoader.show({
        action: action,
        flow: authModalLoader.constants.CONTACT_DEALER_FORM_FLOW,
        ga: { label: 'contact link in pdp – more from dealer module' }
    }).then(function (_ref) {
        var err = _ref.err,
            user = _ref.user;

        if (!err && user && !actionContext.getStore(ContactDealerStore).getMessageSent()) {
            submitMessageLoggedIn(actionContext, user);
        }
    });
}

module.exports = {
    initializeOffer: initializeOffer,
    setOptimizelyVariant: setOptimizelyVariant,
    enterName: enterName,
    enterMessage: enterMessage,
    submitMessageLoggedIn: submitMessageLoggedIn,
    submitMessageNotLoggedIn: submitMessageNotLoggedIn,
    submitOffer: submitOffer
};

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var get = __webpack_require__(14);
var classNames = __webpack_require__(16);
var tokenReplace = __webpack_require__(75);
var User = __webpack_require__(15);
var ContextComponent = __webpack_require__(61);
var enabler = __webpack_require__(63);
var ContactDealerMessage = __webpack_require__(3673);
var ContactDealerMessageSent = __webpack_require__(3674);
var ContactDealerFavorite = __webpack_require__(2175);
var CallDealerButton = __webpack_require__(3672);
var RequestMoreInfoLinks = __webpack_require__(3402);

var _require = __webpack_require__(379),
    trackContactDealer = _require.trackContactDealer,
    trackDealerLinkClick = _require.trackDealerLinkClick,
    trackExpandDealerInfo = _require.trackExpandDealerInfo,
    trackDealerInfoClick = _require.trackDealerInfoClick,
    trackMakeOfferClick = _require.trackMakeOfferClick,
    trackAddToCart = _require.trackAddToCart,
    trackCheckoutRedirect = _require.trackCheckoutRedirect;

__webpack_require__(1735);

var contactDealerActions = __webpack_require__(2173);
var transactionActions = __webpack_require__(480);
var pdpTracking = __webpack_require__(542);
var copyText = __webpack_require__(39)().extend(__webpack_require__(754));

var _require2 = __webpack_require__(968),
    variants = _require2.variants;

var _require3 = __webpack_require__(3698),
    shouldShowHoldRequest = _require3.shouldShowHoldRequest;

var HoldRequestMutation = __webpack_require__(3677).default;

// Helper functions
function makeLocation(_ref) {
    var city = _ref.city,
        state = _ref.state,
        country = _ref.country;

    return city + ', ' + (state || country);
}

function locationCopy(_ref2) {
    var copy = _ref2.copy,
        city = _ref2.city,
        state = _ref2.state,
        country = _ref2.country;

    return tokenReplace(get(copy, 'dealer.location'), { location: makeLocation({ city: city, state: state, country: country }) });
}

function formatCityStateZip(_ref3) {
    var city = _ref3.city,
        state = _ref3.state,
        zip = _ref3.zip;

    return [[city, 'addressLocality'], [state, 'addressRegion'], [zip, 'postalCode']].reduce(function (acc, item) {
        var _item = _slicedToArray(item, 2),
            _item$ = _item[0],
            value = _item$ === undefined ? '' : _item$,
            _item$2 = _item[1],
            key = _item$2 === undefined ? '' : _item$2;

        if (typeof value === 'string') {
            acc.push('<span data-tn="dealer-more-info-' + key + '">' + value.trim() + '</span>');
        }

        return acc;
    }, []).join('<span>,&nbsp;</span>');
}

/**
 * @param {string} dealerReferenceTitle - Title-text for dealer reference number.
 * @param {string} dealerReferenceNumber - Item dealer reference number.
 */
function dealerReferenceCopy(_ref4) {
    var dealerReferenceTitle = _ref4.dealerReferenceTitle,
        dealerReferenceNumber = _ref4.dealerReferenceNumber;

    if (dealerReferenceNumber && dealerReferenceTitle) {
        return React.createElement(
            'span',
            null,
            dealerReferenceTitle,
            ': ',
            dealerReferenceNumber
        );
    }
    return null;
}

dealerReferenceCopy.propTypes = {
    dealerReferenceTitle: PropTypes.string,
    dealerReferenceNumber: PropTypes.string
};

var DEALER_TYPE_GALLERY = 'gallery';
var DEALER_TYPE_DEALER = 'dealer';
var DEALER_TYPE_SELLER = 'seller';

var MORE_INFO_OFFSET_TOP = 5;

var ContactDealerBody = function (_ContextComponent) {
    _inherits(ContactDealerBody, _ContextComponent);

    function ContactDealerBody(props) {
        _classCallCheck(this, ContactDealerBody);

        var _this = _possibleConstructorReturn(this, (ContactDealerBody.__proto__ || Object.getPrototypeOf(ContactDealerBody)).call(this, props));

        var _props$dealerData = props.dealerData,
            city = _props$dealerData.city,
            state = _props$dealerData.state,
            country = _props$dealerData.country,
            zip = _props$dealerData.zip,
            type = _props$dealerData.type,
            sinceYear = _props$dealerData.sinceYear,
            dealerReferenceNumber = _props$dealerData.dealerReferenceNumber,
            dealerReferenceTitle = _props$dealerData.dealerReferenceTitle;

        var copy = props.copy;
        _this.state = {
            nameError: false,
            messageError: false,
            moreInfoExpanded: false,
            offerExpanded: false,
            callDealerIsOpened: false,
            isHoldRequestChecked: false
        };
        _this._moreInfoHeight = null;
        _this._cityStateZip = formatCityStateZip({ copy: copy, city: city, state: state, zip: zip });
        _this._locationCopy = locationCopy({ copy: copy, city: city, state: state, country: country });
        _this._sinceYearCopy = tokenReplace(get(copy, 'dealer.sinceYear'), { type: type, sinceYear: sinceYear });
        _this._dealerReferenceCopy = dealerReferenceCopy({ dealerReferenceTitle: dealerReferenceTitle, dealerReferenceNumber: dealerReferenceNumber });
        _this.onContactDealer = _this.onContactDealer.bind(_this);
        _this.onMoreInfoClick = _this.onMoreInfoClick.bind(_this);
        _this.onDealerClick = _this.onDealerClick.bind(_this);
        _this.onMessageFocused = _this.onMessageFocused.bind(_this);
        _this.onMessageEntered = _this.onMessageEntered.bind(_this);
        _this.onNameEntered = _this.onNameEntered.bind(_this);
        _this.onOfferClick = _this.onOfferClick.bind(_this);
        _this.onOfferEntered = _this.onOfferEntered.bind(_this);
        _this.onOfferBlurred = _this.onOfferBlurred.bind(_this);
        _this.onHoldRequestClick = _this.onHoldRequestClick.bind(_this);

        _this.sentFrom = null;
        return _this;
    }

    _createClass(ContactDealerBody, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                isDealerMessageSent = _props.isDealerMessageSent,
                sidebar = _props.sidebar,
                isPrintDealer = _props.isPrintDealer;

            var sentFromSameBody = sidebar && this.sentFrom === 'sidebar' || !sidebar && this.sentFrom === 'body';

            if (isDealerMessageSent && !prevProps.isDealerMessageSent && !isPrintDealer && sentFromSameBody) {
                var trackingObj = {
                    action: 'submitted'
                };
                if (sidebar) {
                    trackingObj = _extends({}, trackingObj, { suffix: 'sidebar' });
                }
                this.context.executeAction(trackContactDealer, trackingObj);
            }
        }
    }, {
        key: 'setWhereWasSentFrom',
        value: function setWhereWasSentFrom(sidebar) {
            this.sentFrom = sidebar ? 'sidebar' : 'body';
        }
    }, {
        key: 'onContactDealer',
        value: function onContactDealer() {
            var _this2 = this;

            var _props2 = this.props,
                company = _props2.dealerData.company,
                errors = _props2.errors,
                item = _props2.backboneItem,
                offer = _props2.offer,
                offerAmount = _props2.offerAmount,
                price = _props2.price,
                userDisplayName = _props2.userDisplayName,
                userMessage = _props2.userMessage,
                sidebar = _props2.sidebar,
                userId = _props2.userId,
                itemId = _props2.itemId,
                vertical = _props2.vertical,
                relay = _props2.relay;

            var hasDisplay = User.loggedIn() || userDisplayName;
            var trackingObj = {
                action: 'send clicked'
            };
            if (sidebar) {
                trackingObj = _extends({}, trackingObj, { suffix: 'sidebar' });
            }
            if (!hasDisplay || !userMessage) {
                this.setState({
                    messageError: !userMessage,
                    nameError: !userDisplayName
                });
            } else if (offerAmount && !errors.length) {
                this.context.executeAction(trackCheckoutRedirect, { offerAmount: offerAmount, price: price });
                this.context.executeAction(contactDealerActions.submitOffer, { item: item, offer: offer });
            } else if (User.loggedIn()) {
                this.setWhereWasSentFrom(sidebar);
                if (this.state.isHoldRequestChecked) {
                    relay.commitUpdate(new HoldRequestMutation({
                        userId: userId,
                        itemId: itemId,
                        sellerId: this.props.item.seller.serviceId,
                        vertical: vertical
                    }), {
                        onSuccess: function onSuccess() {
                            _this2.context.executeAction(contactDealerActions.submitMessageLoggedIn, User.getCurrentUser().toJSON());
                        }
                    });
                } else {
                    this.context.executeAction(contactDealerActions.submitMessageLoggedIn, User.getCurrentUser().toJSON());
                }
                this.context.executeAction(trackContactDealer, trackingObj);
            } else {
                this.setWhereWasSentFrom(sidebar);
                this.context.executeAction(contactDealerActions.submitMessageNotLoggedIn, { company: company });
                this.context.executeAction(trackContactDealer, trackingObj);
            }
        }
    }, {
        key: 'onDealerClick',
        value: function onDealerClick() {
            this.context.executeAction(trackDealerLinkClick, { location: 'dealer logo' });
        }
    }, {
        key: 'onMessageEntered',
        value: function onMessageEntered(e) {
            var value = e.target.value;

            this.setState({ messageError: !value });
            this.context.executeAction(contactDealerActions.enterMessage, { value: value });
        }
    }, {
        key: 'onMessageFocused',
        value: function onMessageFocused() {
            var _props3 = this.props,
                hasTrackingFired = _props3.hasTrackingFired,
                sidebar = _props3.sidebar;

            if (!hasTrackingFired) {
                var trackingObj = {
                    action: 'clicked'
                };
                if (sidebar) {
                    trackingObj = _extends({}, trackingObj, { suffix: 'sidebar' });
                }
                this.context.executeAction(trackContactDealer, trackingObj);
            }
        }
    }, {
        key: 'onMoreInfoClick',
        value: function onMoreInfoClick() {
            var itemPk = this.props.itemPk;

            var height = get(this, 'refs.moreInfo.offsetHeight');
            var moreInfoExpanded = !this.state.moreInfoExpanded;

            if (!this._moreInfoHeight && height) {
                this._moreInfoHeight = height;
            }

            if (moreInfoExpanded) {
                this.context.executeAction(trackDealerInfoClick, { url: this.props.canonicalUrl });
                this.context.executeAction(trackExpandDealerInfo, { itemPk: itemPk });
            }
            this.setState({ moreInfoExpanded: moreInfoExpanded });
        }
    }, {
        key: 'onNameEntered',
        value: function onNameEntered(e) {
            var value = e.target.value;

            this.setState({ nameError: !value });
            this.context.executeAction(contactDealerActions.enterName, { value: value });
        }
    }, {
        key: 'onOfferClick',
        value: function onOfferClick() {
            var _props4 = this.props,
                isNegotiable = _props4.isNegotiable,
                isPreQuote = _props4.isPreQuote,
                isReturnable = _props4.isReturnable,
                item = _props4.backboneItem,
                user = _props4.backboneUser.user;
            var offerExpanded = this.state.offerExpanded;

            if (!offerExpanded) {
                this.context.executeAction(trackMakeOfferClick, { isNegotiable: isNegotiable, isPreQuote: isPreQuote, isReturnable: isReturnable });
                this.context.executeAction(trackAddToCart, { trackingVpvParams: pdpTracking.getInitialDataLayerInfo() });
            }
            this.setState({ offerExpanded: !offerExpanded });
            this.context.executeAction(contactDealerActions.initializeOffer, { item: item, user: user });
        }
    }, {
        key: 'onOfferEntered',
        value: function onOfferEntered(e) {
            var rawValue = e.target.value;

            var field = 'amountPerItem.amount';
            var value = rawValue.replace(/[^\d]+/g, '');
            this.context.executeAction(transactionActions.editOfferField, { field: field, value: value });
        }
    }, {
        key: 'onOfferBlurred',
        value: function onOfferBlurred() {
            var user = this.props.backboneUser;

            this.context.executeAction(transactionActions.validateOffer, {
                copyText: copyText,
                bypassLowball: true,
                showLowballOptions: false,
                user: user
            });
        }
    }, {
        key: '_getMoreInfoWrapperStyle',
        value: function _getMoreInfoWrapperStyle() {
            var moreInfoExpanded = this.state.moreInfoExpanded;

            var moreInfoHeight = this._moreInfoHeight || 0;
            return {
                maxHeight: moreInfoExpanded ? moreInfoHeight + MORE_INFO_OFFSET_TOP + 'px' : '0px',
                paddingTop: moreInfoExpanded ? MORE_INFO_OFFSET_TOP + 'px' : '0px'
            };
        }
    }, {
        key: '_makeAssociationList',
        value: function _makeAssociationList() {
            var associations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            if (Array.isArray(associations)) {

                var elements = associations.reduce(function (memo, association, index) {
                    association = get(association, 'displayName');
                    memo.push(React.createElement(
                        'li',
                        { key: index },
                        association
                    ));
                    return memo;
                }, []);
                var maytest = this.props.maytest;


                var associationsContainer = React.createElement(
                    'div',
                    { className: 'pdp-dealer-body-associations' },
                    React.createElement(
                        'span',
                        { className: 'pdp-dealer-body-title' },
                        'Associations',
                        maytest === variants.OPOP ? ':' : ''
                    ),
                    React.createElement(
                        'ul',
                        null,
                        elements
                    )
                );

                return associations.length > 0 ? maytest === variants.OPOP ? React.createElement(
                    'div',
                    { className: 'pdp-dealer-company-info' },
                    associationsContainer
                ) : React.createElement(
                    'div',
                    null,
                    React.createElement('div', { className: 'pdp-dealer-body-divider' }),
                    associationsContainer
                ) : null;
            } else {
                return null;
            }
        }
    }, {
        key: 'onHoldRequestClick',
        value: function onHoldRequestClick(checked) {
            this.setState({ isHoldRequestChecked: checked });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props5 = this.props,
                contactDealerCTATestRunning = _props5.contactDealerCTATestRunning,
                copy = _props5.copy,
                currency = _props5.currency,
                errors = _props5.errors,
                favoriteDealer = _props5.favoriteDealer,
                favoriteDealerCta = _props5.favoriteDealerCta,
                handleContactDealerCtaClick = _props5.handleContactDealerCtaClick,
                isDealerMessageSending = _props5.isDealerMessageSending,
                isDealerMessageSent = _props5.isDealerMessageSent,
                isNegotiable = _props5.isNegotiable,
                isPrintDealer = _props5.isPrintDealer,
                item = _props5.item,
                itemId = _props5.itemId,
                offerAmount = _props5.offerAmount,
                optimizelyVariant = _props5.optimizelyVariant,
                price = _props5.price,
                relay = _props5.relay,
                user = _props5.user,
                userId = _props5.userId,
                viewer = _props5.viewer,
                _props5$dealerData = _props5.dealerData,
                address = _props5$dealerData.address,
                address2 = _props5$dealerData.address2,
                company = _props5$dealerData.company,
                country = _props5$dealerData.country,
                logo = _props5$dealerData.logo,
                pk = _props5$dealerData.pk,
                telephone = _props5$dealerData.telephone,
                type = _props5$dealerData.type,
                uri = _props5$dealerData.uri,
                dealerPreferences = _props5$dealerData.preferences,
                association = _props5$dealerData.association,
                city = _props5$dealerData.city,
                state = _props5$dealerData.state,
                sinceYear = _props5$dealerData.sinceYear,
                maytest = _props5.maytest,
                sellerResponseTime = _props5.sellerResponseTime,
                sidebar = _props5.sidebar,
                onContactDealerModal = _props5.onContactDealerModal;
            var hasUserId = relay.variables.hasUserId;
            var _state = this.state,
                expanded = _state.moreInfoExpanded,
                offerExpanded = _state.offerExpanded,
                nameError = _state.nameError,
                messageError = _state.messageError,
                isHoldRequestChecked = _state.isHoldRequestChecked;

            var favoriteProps = { company: company, favoriteDealer: favoriteDealer, favoriteDealerCta: favoriteDealerCta, pk: pk, uri: uri, type: type, maytest: maytest };

            var detailDataTags = isPrintDealer ? 'print-item-details-dealer' : 'item-details-dealer';
            var moreInfoCopy = get(copy, 'dealer.' + (expanded ? 'infoExpanded' : 'infoCollapsed'));

            var _errors$map = errors.map(function (e) {
                return e.message;
            }),
                _errors$map2 = _slicedToArray(_errors$map, 1),
                error = _errors$map2[0];

            var isVariant = optimizelyVariant === 'submitOffer';

            var _ref5 = dealerPreferences || {},
                displayStoreAddress = _ref5.displayStoreAddress,
                storeAddressByAppointmentOnly = _ref5.storeAddressByAppointmentOnly;

            var isCallButtonEnabled = enabler.isEnabled('call_dealer_button');
            var canMakeCall = get(item, 'seller.canMakeCall', false);
            var showCallDealerButton = isCallButtonEnabled && telephone || canMakeCall;
            var showPhone = !isCallButtonEnabled && canMakeCall === false;

            var showAddress = displayStoreAddress === 'Y';
            var showByAppointmentOnly = storeAddressByAppointmentOnly === 'Y';
            var bodyClasses = classNames('pdp-dealer-body', {
                'in-sidebar': sidebar,
                'center-dealer-info': maytest === variants.CONTACT2,
                'center-in-column': maytest === variants.CONTACT3 && sidebar,
                'has-maytest-opop': maytest === variants.OPOP
            });
            var dealerInfoClassses = classNames('pdp-dealer-info', 'pdp-dealer-section', {
                'pdp-dealer-maytest-opop': maytest === variants.OPOP,
                'center-dealer-info': maytest === variants.CONTACT2
            });
            var messageArea = isDealerMessageSent ? React.createElement(ContactDealerMessageSent, favoriteProps) : React.createElement(ContactDealerMessage, {
                currency: currency,
                error: error,
                isDealerMessageSending: isDealerMessageSending,
                isLoggedIn: User.loggedIn(),
                displayOffer: isVariant && isNegotiable && !!price,
                messageError: messageError,
                nameError: nameError,
                offerAmount: offerAmount,
                offerExpanded: offerExpanded,
                onContactDealer: this.onContactDealer,
                onMessageEntered: this.onMessageEntered,
                onMessageFocused: this.onMessageFocused,
                onNameEntered: this.onNameEntered,
                onOfferClick: this.onOfferClick,
                onOfferEntered: this.onOfferEntered,
                onOfferBlurred: this.onOfferBlurred,
                price: price,
                type: type,
                maytest: maytest,
                sidebar: sidebar,
                showRequestHold: shouldShowHoldRequest(item, user),
                isHoldRequestChecked: isHoldRequestChecked,
                onHoldRequestClick: this.onHoldRequestClick
            });
            return !sidebar || maytest !== variants.CONTACT3 ? React.createElement(
                'div',
                { className: bodyClasses, 'data-tn': detailDataTags },
                !sidebar && maytest === variants.OPOP && React.createElement(
                    'div',
                    { className: dealerInfoClassses, 'data-tn': 'pdp-dealer-info' },
                    React.createElement(
                        'div',
                        { className: 'pdp-contact-dealer-title header-primary-large pdp-secondary-header' },
                        'Contact The Seller'
                    ),
                    sellerResponseTime && React.createElement(
                        'p',
                        { className: 'pdp-dealer-company-info' },
                        React.createElement(
                            'span',
                            { className: 'pdp-dealer-body-title' },
                            'Response Time:'
                        ),
                        ' Usually within ',
                        sellerResponseTime
                    ),
                    React.createElement(
                        'p',
                        { className: 'pdp-dealer-company-info' },
                        React.createElement(
                            'span',
                            { className: 'pdp-dealer-body-title' },
                            '1stdibs seller since'
                        ),
                        ' ',
                        sinceYear
                    ),
                    React.createElement(
                        'p',
                        { className: 'pdp-dealer-company-info' },
                        React.createElement(
                            'span',
                            { className: 'pdp-dealer-body-title' },
                            'Located in'
                        ),
                        ' ',
                        makeLocation({ city: city, state: state, country: country })
                    ),
                    this._makeAssociationList(association ? association.slice(0, 3) : null),
                    showCallDealerButton && React.createElement(CallDealerButton, { userId: userId, hasUserId: hasUserId, item: item, viewer: viewer, copy: copy, dealerPk: pk, page: uri })
                ),
                !sidebar && maytest !== variants.OPOP && React.createElement(
                    'div',
                    { className: dealerInfoClassses, 'data-tn': 'pdp-dealer-info' },
                    maytest === variants.CONTACT2 && React.createElement(
                        'div',
                        { className: 'pdp-contact-dealer-title header-primary-large pdp-secondary-header' },
                        'About The Seller'
                    ),
                    React.createElement(
                        'div',
                        null,
                        React.createElement(
                            'a',
                            { href: uri, onClick: this.onDealerClick },
                            React.createElement('img', { className: 'pdp-dealer-logo', src: logo, alt: company })
                        )
                    ),
                    showCallDealerButton && React.createElement(CallDealerButton, { userId: userId, hasUserId: hasUserId, item: item, viewer: viewer, copy: copy, dealerPk: pk, page: uri }),
                    React.createElement(
                        'div',
                        { className: 'pdp-dealer-info-wrapper', onClick: this.onMoreInfoClick },
                        React.createElement('div', { className: 'pdp-dealer-link', dangerouslySetInnerHTML: { __html: moreInfoCopy } }),
                        React.createElement(
                            'div',
                            { className: 'pdp-dealer-more-info-wrapper', style: this._getMoreInfoWrapperStyle() },
                            React.createElement(
                                'div',
                                { className: 'pdp-dealer-more-info', ref: 'moreInfo' },
                                showAddress && React.createElement(
                                    'span',
                                    null,
                                    copyText.get('address')
                                ),
                                React.createElement(
                                    'div',
                                    { 'data-tn': 'dealer-more-info-company' },
                                    company
                                ),
                                showAddress && React.createElement(
                                    'div',
                                    null,
                                    React.createElement(
                                        'div',
                                        { 'data-tn': 'dealer-more-info-address' },
                                        address
                                    ),
                                    React.createElement(
                                        'div',
                                        { 'data-tn': 'dealer-more-info-address2' },
                                        address2
                                    ),
                                    React.createElement('div', { dangerouslySetInnerHTML: { __html: this._cityStateZip } }),
                                    React.createElement(
                                        'div',
                                        { 'data-tn': 'dealer-more-info-country' },
                                        country
                                    )
                                ),
                                showByAppointmentOnly && React.createElement(
                                    'div',
                                    { className: 'pdp-dealer-more-info-by-appointment' },
                                    copyText.get('storeAddressByAppointmentOnly')
                                ),
                                showPhone && React.createElement(
                                    'div',
                                    { 'data-tn': 'dealer-more-info-telephone' },
                                    telephone
                                ),
                                React.createElement(
                                    'div',
                                    { 'data-tn': 'dealer-more-info-reference' },
                                    this._dealerReferenceCopy
                                ),
                                this._makeAssociationList(association)
                            )
                        )
                    ),
                    React.createElement(
                        'p',
                        { className: 'pdp-dealer-company-info' },
                        this._sinceYearCopy
                    ),
                    React.createElement(
                        'p',
                        { className: 'pdp-dealer-company-info' },
                        this._locationCopy
                    ),
                    !isDealerMessageSent && React.createElement(ContactDealerFavorite, favoriteProps)
                ),
                (sidebar || maytest !== variants.CONTACT2) && messageArea,
                !sidebar && contactDealerCTATestRunning && user && user.isVerifiedTrade && React.createElement(
                    'div',
                    { className: 'pdp-dealer-request-more-info' },
                    React.createElement(RequestMoreInfoLinks, {
                        hasUserId: hasUserId,
                        userId: userId,
                        itemId: itemId,
                        viewer: viewer,
                        user: user,
                        item: item,
                        handleCtaClick: handleContactDealerCtaClick
                    })
                )
            ) : React.createElement(
                'div',
                { className: bodyClasses, 'data-tn': detailDataTags },
                React.createElement(
                    'div',
                    { className: 'pdp-contact-dealer-title' },
                    'Questions about this piece?'
                ),
                React.createElement(
                    'button',
                    {
                        className: 'button-large button-secondary',
                        onClick: onContactDealerModal
                    },
                    'Ask the ' + type
                )
            );
        }
    }]);

    return ContactDealerBody;
}(ContextComponent);

ContactDealerBody.propTypes = {
    contactDealerCTATestRunning: PropTypes.bool.isRequired,
    canonicalUrl: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    errors: PropTypes.array,
    favoriteDealer: PropTypes.object.isRequired,
    favoriteDealerCta: PropTypes.object,
    itemId: PropTypes.string.isRequired,
    itemPk: PropTypes.string.isRequired,
    optimizelyVariant: PropTypes.string,
    offerAmount: PropTypes.string,
    price: PropTypes.number.isRequired,
    vertical: PropTypes.string.isRequired,
    handleContactDealerCtaClick: PropTypes.func.isRequired,
    dealerData: PropTypes.shape({
        uri: PropTypes.string.isRequired,
        logo: PropTypes.string.isRequired,
        company: PropTypes.string.isRequired,
        sinceYear: PropTypes.string.isRequired,
        address: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string.isRequired,
        state: PropTypes.string,
        country: PropTypes.string,
        zip: PropTypes.string,
        telephone: PropTypes.string,
        pk: PropTypes.string.isRequired,
        urlLabel: PropTypes.string.isRequired,
        type: PropTypes.oneOf([DEALER_TYPE_GALLERY, DEALER_TYPE_DEALER, DEALER_TYPE_SELLER]).isRequired,
        association: PropTypes.array,
        preferences: PropTypes.object.isRequired
    }).isRequired,
    maytest: PropTypes.string,
    sellerResponseTime: PropTypes.string,
    sidebar: PropTypes.bool,
    onContactDealerModal: PropTypes.func
};

module.exports = Relay.createContainer(ContactDealerBody, {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null
    },
    fragments: {
        viewer: function viewer(_ref6) {
            var hasUserId = _ref6.hasUserId,
                userId = _ref6.userId,
                itemId = _ref6.itemId;
            return function (RQL_0, RQL_1) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ContactDealerBody_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(CallDealerButton.getFragment('viewer', { hasUserId: hasUserId, userId: userId }), RequestMoreInfoLinks.getFragment('viewer', { hasUserId: hasUserId, userId: userId, itemId: itemId }));
        },
        user: function user(_ref7) {
            var hasUserId = _ref7.hasUserId,
                userId = _ref7.userId,
                itemId = _ref7.itemId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'isVerifiedTrade',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        alias: 'canUseNetPrice',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_NET_PRICE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ContactDealerBody_UserRelayQL',
                    type: 'User'
                };
            }(RequestMoreInfoLinks.getFragment('user', { hasUserId: hasUserId, userId: userId, itemId: itemId }));
        },
        item: function item(_ref8) {
            var hasUserId = _ref8.hasUserId,
                userId = _ref8.userId,
                itemId = _ref8.itemId;
            return function (RQL_0, RQL_1) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'isFurniture',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'hasUserId'
                                }
                            }]
                        }],
                        fieldName: 'hasRequestedHoldForBuyer',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'isPriceUponRequest',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'isOnHold',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'isSold',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        children: [{
                            children: [{
                                fieldName: 'value',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'customizable',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'AttributeValue'
                        }],
                        fieldName: 'attributes',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true
                        },
                        type: 'ItemAttributes'
                    }, {
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            alias: 'canMakeCall',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'listName',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'ALLOW_TRACKED_CALLS'
                                }
                            }],
                            fieldName: 'isWhitelisted',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                fieldName: 'company',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'sellerProfile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SellerProfile'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ContactDealerBody_ItemRelayQL',
                    type: 'Item'
                };
            }(CallDealerButton.getFragment('item', { hasUserId: hasUserId, userId: userId }), RequestMoreInfoLinks.getFragment('item', { hasUserId: hasUserId, userId: userId, itemId: itemId }));
        }
    }
});

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classNames = __webpack_require__(16);

var _require = __webpack_require__(376),
    sprintf = _require.sprintf;

var FavoriteModel = __webpack_require__(355);
var FavoriteCta = __webpack_require__(772);
var FAVORITE_TRACKING = __webpack_require__(672);

var _require2 = __webpack_require__(968),
    variants = _require2.variants;

function ContactDealerFavorite(_ref) {
    var company = _ref.company,
        favoriteDealer = _ref.favoriteDealer,
        favoriteDealerCta = _ref.favoriteDealerCta,
        pk = _ref.pk,
        uri = _ref.uri,
        maytest = _ref.maytest;

    var favoriteCtaCopy = Object.assign({}, favoriteDealerCta, {
        confirmationTooltip: sprintf(favoriteDealerCta.confirmationTooltip, company)
    });
    var buttonClasses = classNames('button-' + (maytest === variants.CONTACT2 ? 'small' : 'large'), 'button-secondary', {
        'pdp-favorite-cta': maytest !== variants.CONTACT2,
        'maytest-contact-button': maytest === variants.CONTACT2
    });
    return React.createElement(
        'div',
        { className: 'pdp-dealer-body-favorite-cta-container' },
        React.createElement(FavoriteCta, _extends({
            className: buttonClasses,
            copy: favoriteCtaCopy,
            favoriteData: {
                type: FavoriteModel.TYPE_DEALER,
                page: uri,
                primaryKey: pk,
                authModalOptions: FAVORITE_TRACKING.DEALER.PDP_AUTH_MODAL
            },
            tracking: FAVORITE_TRACKING.DEALER.PDP
        }, favoriteDealer))
    );
}

ContactDealerFavorite.propTypes = {
    company: PropTypes.string.isRequired,
    favoriteDealer: PropTypes.object.isRequired,
    favoriteDealerCta: PropTypes.object.isRequired,
    pk: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired,
    maytest: PropTypes.string
};

module.exports = ContactDealerFavorite;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(40);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRelay = __webpack_require__(18);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _dibsTracking = __webpack_require__(27);

var _mobileCheck = __webpack_require__(279);

var _mobileCheck2 = _interopRequireDefault(_mobileCheck);

var _forceFavorite2 = __webpack_require__(741);

var _forceFavorite3 = _interopRequireDefault(_forceFavorite2);

var _constants = __webpack_require__(626);

var _userHelper = __webpack_require__(374);

var _userHelper2 = _interopRequireDefault(_userHelper);

var _calloutHelper = __webpack_require__(485);

var _dibsPortfolioHeart = __webpack_require__(628);

var _dibsPortfolioHeart2 = _interopRequireDefault(_dibsPortfolioHeart);

var _Callout = __webpack_require__(589);

var _Callout2 = _interopRequireDefault(_Callout);

var _PdpFavoriteItemStyle = __webpack_require__(3055);

var _PdpFavoriteItemStyle2 = _interopRequireDefault(_PdpFavoriteItemStyle);

var _PdpFavoriteItemCallout = __webpack_require__(2578);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getRelayVariables(_ref) {
    var userId = _ref.userId,
        itemId = _ref.itemId;

    return {
        userId: userId,
        itemId: itemId,
        userIds: [userId],
        hasUserId: !!userId,
        selectedItemIds: [itemId]
    };
}

var PdpFavoriteItem = function (_React$Component) {
    _inherits(PdpFavoriteItem, _React$Component);

    function PdpFavoriteItem(props) {
        _classCallCheck(this, PdpFavoriteItem);

        var _this = _possibleConstructorReturn(this, (PdpFavoriteItem.__proto__ || Object.getPrototypeOf(PdpFavoriteItem)).call(this, props));

        _this.alreadyForced = false;
        _this.authModalShow = _this.authModalShow.bind(_this);
        _this.onFavorited = _this.onFavorited.bind(_this);
        _this.onUnFavorited = _this.onUnFavorited.bind(_this);
        return _this;
    }

    _createClass(PdpFavoriteItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.viewer) {
                this.forceFavorite();
                this.alreadyForced = true;
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.alreadyForced && this.props.viewer) {
                this.forceFavorite();
                this.alreadyForced = true;
            }
        }
    }, {
        key: 'authModalShow',
        value: function authModalShow(favoriteItem) {
            _userHelper2.default.checkLogin({
                label: 'save item - product page'
            }, _constants.SAVE_ITEM_FLOW).then(favoriteItem);
        }
    }, {
        key: 'onFavorited',
        value: function onFavorited() {
            this.trackFavoriting("item added");
        }
    }, {
        key: 'onUnFavorited',
        value: function onUnFavorited() {
            this.trackFavoriting("item removed");
        }
    }, {
        key: 'trackFavoriting',
        value: function trackFavoriting(action) {
            (0, _dibsTracking.trackEvent)({
                action: action,
                label: "PDP",
                category: "item favoriting"
            });
        }
    }, {
        key: 'forceFavorite',
        value: function forceFavorite() {
            var el = _reactDom2.default.findDOMNode(this);
            var portfolioItemMatches = this.props.viewer.portfolioItemMatches;


            _forceFavorite3.default.init({
                type: _forceFavorite3.default.TYPE_ITEM,
                isFavorited: !!portfolioItemMatches && !!portfolioItemMatches.length,
                heartEl: el.getElementsByClassName('js-heart-component')[0]
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                showCircle = _props.showCircle,
                viewer = _props.viewer,
                callout = _props.callout,
                params = _objectWithoutProperties(_props, ['showCircle', 'viewer', 'callout']);

            var className = (0, _classnames2.default)(_PdpFavoriteItemStyle2.default.pdpHeartItem, _defineProperty({}, _PdpFavoriteItemStyle2.default.withCircle, showCircle));

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: _PdpFavoriteItemStyle2.default.heartComponentWrapper, 'data-tn': 'item-save-to-portfolio' },
                    _react2.default.createElement(_dibsPortfolioHeart2.default, _extends({
                        className: 'js-heart-component',

                        viewer: viewer
                    }, getRelayVariables(params), {

                        // handlers
                        authModalShow: this.authModalShow,
                        onFavorited: this.onFavorited,
                        onUnFavorited: this.onUnFavorited
                    }))
                ),
                !_mobileCheck2.default.any() && !showCircle ? _react2.default.createElement(_Callout2.default, {
                    callout: callout,
                    copy: _PdpFavoriteItemCallout.copy,
                    type: _calloutHelper.CALLOUT_TYPE_SAVE_ITEM
                }) : null
            );
        }
    }]);

    return PdpFavoriteItem;
}(_react2.default.Component);

PdpFavoriteItem.propTypes = {
    showCircle: _propTypes2.default.bool,
    userId: _propTypes2.default.string,
    itemId: _propTypes2.default.string,
    viewer: _propTypes2.default.object,
    callout: _propTypes2.default.object
};

exports.default = _reactRelay2.default.createContainer(PdpFavoriteItem, {
    initialVariables: {
        itemId: null,
        userId: null,
        userIds: [],
        hasUserId: false,
        selectedItemIds: []
    },
    prepareVariables: function prepareVariables(params) {
        return getRelayVariables(params);
    },
    fragments: {
        viewer: function viewer(_ref2) {
            var userId = _ref2.userId,
                selectedItemIds = _ref2.selectedItemIds;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'userIds',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userIds'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'itemIds',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'selectedItemIds'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {
                                type: '[PortfolioTypes]'
                            },
                            name: 'portfolioTypes',
                            value: [{
                                kind: 'CallValue',
                                callValue: 'HEART'
                            }]
                        }],
                        children: [{
                            fieldName: 'portfolioId',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'hasUserId'
                                }
                            }]
                        }],
                        fieldName: 'portfolioItemMatches',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id',
                            isPlural: true
                        },
                        type: 'PortfolioItemV2'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, _reactRelay2.default.QL.__frag(RQL_0)]),
                    id: _reactRelay2.default.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'PdpFavoriteItem_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(_dibsPortfolioHeart2.default.getFragment('viewer', { userId: userId, selectedItemIds: selectedItemIds }));
        }
    }
});

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(18);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobileCheck = __webpack_require__(279);

var _mobileCheck2 = _interopRequireDefault(_mobileCheck);

var _constants = __webpack_require__(626);

var _userHelper = __webpack_require__(374);

var _userHelper2 = _interopRequireDefault(_userHelper);

var _folderTracking = __webpack_require__(708);

var _folderTracking2 = _interopRequireDefault(_folderTracking);

var _calloutHelper = __webpack_require__(485);

var _dibsPortfolioFolder = __webpack_require__(662);

var _dibsPortfolioFolder2 = _interopRequireDefault(_dibsPortfolioFolder);

var _Callout = __webpack_require__(589);

var _Callout2 = _interopRequireDefault(_Callout);

var _PdpFolderItemStyle = __webpack_require__(3056);

var _PdpFolderItemStyle2 = _interopRequireDefault(_PdpFolderItemStyle);

var _PdpFolderItemCallout = __webpack_require__(2579);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getRelayVariables(_ref) {
    var userId = _ref.userId,
        itemId = _ref.itemId;

    return {
        userId: userId,
        loadItemData: true,
        primaryItemPk: itemId,
        selectedItemIds: [itemId]
    };
}

var PdpFolderItem = function (_React$Component) {
    _inherits(PdpFolderItem, _React$Component);

    function PdpFolderItem(props) {
        _classCallCheck(this, PdpFolderItem);

        var _this = _possibleConstructorReturn(this, (PdpFolderItem.__proto__ || Object.getPrototypeOf(PdpFolderItem)).call(this, props));

        _this.authModalShow = _this.authModalShow.bind(_this);
        return _this;
    }

    _createClass(PdpFolderItem, [{
        key: 'authModalShow',
        value: function authModalShow(showFolderModal) {
            _userHelper2.default.checkLogin({
                label: 'save item - product page'
            }, _constants.SAVE_ITEM_FLOW).then(showFolderModal);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                viewer = _props.viewer,
                callout = _props.callout,
                params = _objectWithoutProperties(_props, ['viewer', 'callout']);

            return _react2.default.createElement(
                'div',
                { className: _PdpFolderItemStyle2.default.pdpFolderItem, 'data-tn': 'item-save-to-folder' },
                _react2.default.createElement(_dibsPortfolioFolder2.default, _extends({
                    viewer: viewer
                }, getRelayVariables(params), {
                    trackingHooks: _folderTracking2.default

                    // handlers
                    , authModalShow: this.authModalShow
                })),
                !_mobileCheck2.default.any() ? _react2.default.createElement(_Callout2.default, {
                    callout: callout,
                    copy: _PdpFolderItemCallout.copy,
                    type: _calloutHelper.CALLOUT_TYPE_SAVE_TO_FOLDER
                }) : null
            );
        }
    }]);

    return PdpFolderItem;
}(_react2.default.Component);

PdpFolderItem.propTypes = {
    userId: _propTypes2.default.string,
    itemId: _propTypes2.default.string,
    viewer: _propTypes2.default.object,
    callout: _propTypes2.default.object
};

exports.default = _reactRelay2.default.createContainer(PdpFolderItem, {
    initialVariables: {
        userId: null,
        itemId: null,
        loadItemData: true,
        primaryItemPk: null,
        selectedItemIds: []
    },
    prepareVariables: function prepareVariables(params) {
        return getRelayVariables(params);
    },
    fragments: {
        viewer: function viewer(params) {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, _reactRelay2.default.QL.__frag(RQL_0)]),
                    id: _reactRelay2.default.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'PdpFolderItem_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(_dibsPortfolioFolder2.default.getFragment('viewer', params));
        }
    }
});

/***/ }),
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by daletan on 8/24/16.
 */



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var Page = __webpack_require__(3699);

var getEnvironment = __webpack_require__(482).default.getEnvironment;

var _require = __webpack_require__(334),
    getUserId = _require.getUserId,
    cookieJarConstants = _require.cookieJarConstants;

var MASQUERADE_BUYER = cookieJarConstants.MASQUERADE_BUYER;

var _require2 = __webpack_require__(370),
    createStore = _require2.createStore,
    combineReducers = _require2.combineReducers;

var _require3 = __webpack_require__(271),
    Provider = _require3.Provider;

var _require4 = __webpack_require__(1116),
    shippingQuoteModal = _require4.reducers;

var NewPdpRoot = function NewPdpRoot(props) {
    var userId = getUserId(document.cookie, MASQUERADE_BUYER);
    var queryConfig = {
        name: 'NewPdpContainer',
        queries: {
            viewer: function viewer(Component, params) {
                return function (RQL_0) {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_0)]),
                        fieldName: 'viewer',
                        kind: 'Query',
                        metadata: {},
                        name: 'NewPdpRoot',
                        type: 'Viewer'
                    };
                }(Component.getFragment('viewer', params));
            }
        },
        params: {
            userId: userId
        }
    };
    return (
        // Redux store is for shipping quote request modal, which needs to maintain its state through forceUpdateFromUserLogin
        // Todo: Is store still needed now that forceUpdateFromUserLogin isn't necessary?
        React.createElement(
            Provider,
            { store: createStore(combineReducers({ shippingQuoteModal: shippingQuoteModal })) },
            React.createElement(Relay.Renderer, {
                Container: Page,
                environment: getEnvironment(),
                queryConfig: queryConfig,
                render: function render(_ref) {
                    var queryProps = _ref.props;
                    //eslint-disable-line react/display-name, react/prop-types
                    if (queryProps) {
                        return React.createElement(Page, _extends({}, queryProps, props, { context: props.context }));
                    }
                    // return with null viewer so the entire page does not flash
                    return React.createElement(Page, _extends({ viewer: null }, props, { context: props.context }));
                }
            })
        )
    );
};

NewPdpRoot.propTypes = {
    context: PropTypes.object.isRequired
};

module.exports = NewPdpRoot;

/***/ }),
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */
/***/ (function(module, exports) {

module.exports = {
	"header": "Request more information",
	"requestShippingQuote": "Request a Shipping Quote",
	"requestConditionReport": "Request Condition Report",
	"requestToHoldItem": "Request to Hold Item",
	"makeOffer": "Make offer",
	"viewInvoice": "View invoice"
};

/***/ }),
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */
/***/ (function(module, exports) {

module.exports = {
	"copy": {
		"header": "Save Beautiful Things",
		"text": "Save this item to create a collection of your Favorites.",
		"mobileText": "Tap to save in your favorites."
	}
};

/***/ }),
/* 2579 */
/***/ (function(module, exports) {

module.exports = {
	"copy": {
		"header": " Save This Item in a Folder",
		"text": "Click the folder icon to save items into organized folders."
	}
};

/***/ }),
/* 2580 */
/***/ (function(module, exports) {

module.exports = {
	"name": "Name",
	"yourMessage": "Your Message",
	"errors": {
		"isRequired": "This field is required."
	}
};

/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by daniel.gonzalez on 5/5/15.
 */



var SV = __webpack_require__(17);
var FinancialAmount = __webpack_require__(10);
var templates = __webpack_require__(3881);

var templateMap = {
    heroPrice: {
        soldSuspended: 'aboveFoldSoldSuspendedTmpl',
        recentlySoldHold: 'aboveFoldSoldHoldTmpl',
        priceUponRequest: 'aboveFoldPriceUponRequestTextTmpl',
        showPrice: 'aboveFoldPriceTmpl'
    },
    // only on old pdp
    detailsPrice: {
        soldSuspended: 'detailsSoldHoldTmpl',
        recentlySoldHold: 'detailsSoldHoldTmpl',
        priceUponRequest: 'detailsPriceUponRequestTmpl',
        showPrice: 'detailsPriceTmpl'
    },
    pdpPrint: {
        soldSuspended: 'pdpPrintIconTmpl',
        recentlySoldHold: 'pdpPrintIconTmpl',
        priceUponRequest: 'pdpPrintTmpl',
        showPrice: 'pdpPrintTmpl',
        netPrice: 'pdpPrintNetTmpl'
    }
};

var templateCopy = {
    soldSuspended: 'Sold',
    recentlySoldHold: 'On Hold',
    priceUponRequest: 'Price Upon Request'
};

var icons = {
    soldSuspended: 'is-sold',
    recentlySoldHold: 'is-on-hold'
};

var helpers = {
    SOLD: 'soldSuspended',
    HOLD: 'recentlySoldHold',
    UPON_REQUEST: 'priceUponRequest',
    SHOW_PRICE: 'showPrice'
};

/**
 * Gets the item's status: sold/suspended, recently sold/on hold, price upon request, or available with price
 * @param item
 * @returns {string} - constant corresponding to item's status
 */
helpers.getStatus = function (item) {
    var shouldShowSuspended = SV.get('data.isSuspended') || SV.get('data.isDeleted') || SV.get('data.isDealerSuspended');
    var status;

    if ((item.isSold() && SV.get('data.isSold')) || (!item.isAvailable() && shouldShowSuspended)) {
        // both of these conditions must stay combined together:
        // 1. (itemModel.isSold && SV.data.isSold)
        // 2. (itemModel.get('status.isAvailable') === 'N' && shouldShowSuspended)
        // If #2 uses an OR operator, then shit breaks and doesn't show the price
        // b/c for whatever reason, it seems like a lot of itemModel status.isAvailable === 'N'
        // even if they are on a category search page
        // Sold (using sold template) or suspended flow
        status = this.SOLD;
    } else if (item.isSold() || item.isOnHold()) {
        // On Hold, Recently Sold (i.e. not using sold template) flow
        status = this.HOLD;
    } else if (item.isPriceHidden() || item.getAmountIn(FinancialAmount.CURRENCY_USD) === 0) {
        // Price Upon Request flow
        status = this.UPON_REQUEST;
    } else {
        // Normal Price PDP
        status = this.SHOW_PRICE;
    }

    return status;
};

helpers.isShowPrice = function (status) {
    return status === this.SHOW_PRICE;
};

/**
 * Gets the template needed to show price on a view
 * @param view - view for which you need a template
 * @param status - status of item
 * @returns {Template}
 */
helpers.getTemplate = function (view, status) {
    var key = templateMap[view][status];
    return templates[key];
};

/**
 * @param id - template id
 * @returns {Template}
 */
helpers.getTemplateById = function (id) {
    return templates[id];
};

/**
 * Gets the copy to be shown in place of item's price
 * @param status - status of item
 * @returns {String}
 */
helpers.getTemplateCopy = function (status) {
    return templateCopy[status];
};

/**
 * Gets the icon to be shown next to copy
 * @param status - status of item
 * @returns {String}
 */
helpers.getIcon = function (status) {
    return icons[status];
};

module.exports = helpers;


/***/ }),
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */,
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */,
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */,
/* 2662 */,
/* 2663 */,
/* 2664 */,
/* 2665 */,
/* 2666 */,
/* 2667 */,
/* 2668 */,
/* 2669 */,
/* 2670 */,
/* 2671 */,
/* 2672 */,
/* 2673 */,
/* 2674 */,
/* 2675 */,
/* 2676 */,
/* 2677 */,
/* 2678 */,
/* 2679 */,
/* 2680 */,
/* 2681 */,
/* 2682 */,
/* 2683 */,
/* 2684 */,
/* 2685 */,
/* 2686 */,
/* 2687 */,
/* 2688 */,
/* 2689 */,
/* 2690 */,
/* 2691 */,
/* 2692 */,
/* 2693 */,
/* 2694 */,
/* 2695 */,
/* 2696 */,
/* 2697 */,
/* 2698 */,
/* 2699 */,
/* 2700 */,
/* 2701 */,
/* 2702 */,
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */,
/* 2710 */,
/* 2711 */,
/* 2712 */,
/* 2713 */,
/* 2714 */,
/* 2715 */,
/* 2716 */,
/* 2717 */,
/* 2718 */,
/* 2719 */,
/* 2720 */,
/* 2721 */,
/* 2722 */,
/* 2723 */,
/* 2724 */,
/* 2725 */,
/* 2726 */,
/* 2727 */,
/* 2728 */,
/* 2729 */,
/* 2730 */,
/* 2731 */,
/* 2732 */,
/* 2733 */,
/* 2734 */,
/* 2735 */,
/* 2736 */,
/* 2737 */,
/* 2738 */,
/* 2739 */,
/* 2740 */,
/* 2741 */,
/* 2742 */,
/* 2743 */,
/* 2744 */,
/* 2745 */,
/* 2746 */,
/* 2747 */,
/* 2748 */,
/* 2749 */,
/* 2750 */,
/* 2751 */,
/* 2752 */,
/* 2753 */,
/* 2754 */,
/* 2755 */,
/* 2756 */,
/* 2757 */,
/* 2758 */,
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */,
/* 2763 */,
/* 2764 */,
/* 2765 */,
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */,
/* 2772 */,
/* 2773 */,
/* 2774 */,
/* 2775 */,
/* 2776 */,
/* 2777 */,
/* 2778 */,
/* 2779 */,
/* 2780 */,
/* 2781 */,
/* 2782 */,
/* 2783 */,
/* 2784 */,
/* 2785 */,
/* 2786 */,
/* 2787 */,
/* 2788 */,
/* 2789 */,
/* 2790 */,
/* 2791 */,
/* 2792 */,
/* 2793 */,
/* 2794 */,
/* 2795 */,
/* 2796 */,
/* 2797 */,
/* 2798 */,
/* 2799 */,
/* 2800 */,
/* 2801 */,
/* 2802 */,
/* 2803 */,
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */,
/* 2808 */,
/* 2809 */,
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */,
/* 2820 */,
/* 2821 */,
/* 2822 */,
/* 2823 */,
/* 2824 */,
/* 2825 */,
/* 2826 */,
/* 2827 */,
/* 2828 */,
/* 2829 */,
/* 2830 */,
/* 2831 */,
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */,
/* 2850 */,
/* 2851 */,
/* 2852 */,
/* 2853 */,
/* 2854 */,
/* 2855 */,
/* 2856 */,
/* 2857 */,
/* 2858 */,
/* 2859 */,
/* 2860 */,
/* 2861 */,
/* 2862 */,
/* 2863 */,
/* 2864 */,
/* 2865 */,
/* 2866 */,
/* 2867 */,
/* 2868 */,
/* 2869 */,
/* 2870 */,
/* 2871 */,
/* 2872 */,
/* 2873 */,
/* 2874 */,
/* 2875 */,
/* 2876 */,
/* 2877 */,
/* 2878 */,
/* 2879 */,
/* 2880 */,
/* 2881 */,
/* 2882 */,
/* 2883 */,
/* 2884 */,
/* 2885 */,
/* 2886 */,
/* 2887 */,
/* 2888 */,
/* 2889 */,
/* 2890 */,
/* 2891 */,
/* 2892 */,
/* 2893 */,
/* 2894 */,
/* 2895 */,
/* 2896 */,
/* 2897 */,
/* 2898 */,
/* 2899 */,
/* 2900 */,
/* 2901 */,
/* 2902 */,
/* 2903 */,
/* 2904 */,
/* 2905 */,
/* 2906 */,
/* 2907 */,
/* 2908 */,
/* 2909 */,
/* 2910 */,
/* 2911 */,
/* 2912 */,
/* 2913 */,
/* 2914 */,
/* 2915 */,
/* 2916 */,
/* 2917 */,
/* 2918 */,
/* 2919 */,
/* 2920 */,
/* 2921 */,
/* 2922 */,
/* 2923 */,
/* 2924 */,
/* 2925 */,
/* 2926 */,
/* 2927 */,
/* 2928 */,
/* 2929 */,
/* 2930 */,
/* 2931 */,
/* 2932 */,
/* 2933 */,
/* 2934 */,
/* 2935 */,
/* 2936 */,
/* 2937 */,
/* 2938 */,
/* 2939 */,
/* 2940 */,
/* 2941 */,
/* 2942 */,
/* 2943 */,
/* 2944 */,
/* 2945 */,
/* 2946 */,
/* 2947 */,
/* 2948 */,
/* 2949 */,
/* 2950 */,
/* 2951 */,
/* 2952 */,
/* 2953 */,
/* 2954 */,
/* 2955 */,
/* 2956 */,
/* 2957 */,
/* 2958 */,
/* 2959 */,
/* 2960 */,
/* 2961 */,
/* 2962 */,
/* 2963 */,
/* 2964 */,
/* 2965 */,
/* 2966 */,
/* 2967 */,
/* 2968 */,
/* 2969 */,
/* 2970 */,
/* 2971 */,
/* 2972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"RequestMoreInfoLinks__link__UFUB6"};

/***/ }),
/* 2973 */,
/* 2974 */,
/* 2975 */,
/* 2976 */,
/* 2977 */,
/* 2978 */,
/* 2979 */,
/* 2980 */,
/* 2981 */,
/* 2982 */,
/* 2983 */,
/* 2984 */,
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */,
/* 3004 */,
/* 3005 */,
/* 3006 */,
/* 3007 */,
/* 3008 */,
/* 3009 */,
/* 3010 */,
/* 3011 */,
/* 3012 */,
/* 3013 */,
/* 3014 */,
/* 3015 */,
/* 3016 */,
/* 3017 */,
/* 3018 */,
/* 3019 */,
/* 3020 */,
/* 3021 */,
/* 3022 */,
/* 3023 */,
/* 3024 */,
/* 3025 */,
/* 3026 */,
/* 3027 */,
/* 3028 */,
/* 3029 */,
/* 3030 */,
/* 3031 */,
/* 3032 */,
/* 3033 */,
/* 3034 */,
/* 3035 */,
/* 3036 */,
/* 3037 */,
/* 3038 */,
/* 3039 */,
/* 3040 */,
/* 3041 */,
/* 3042 */,
/* 3043 */,
/* 3044 */,
/* 3045 */,
/* 3046 */,
/* 3047 */,
/* 3048 */,
/* 3049 */,
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"BuyerAssurance-style__wrapper__34tR4","icon":"BuyerAssurance-style__icon__1BWOt","text":"BuyerAssurance-style__text__mM6wC","link":"BuyerAssurance-style__link__215wY"};

/***/ }),
/* 3054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"HoldRequestInput-style__container__3VQYn","checkbox":"HoldRequestInput-style__checkbox__2CtKt","checked":"HoldRequestInput-style__checked__baGuq","icon":"HoldRequestInput-style__icon__1ssEi","label":"HoldRequestInput-style__label__ZpV_h"};

/***/ }),
/* 3055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pdpHeartItem":"PdpFavoriteItem-style__pdpHeartItem__2iH82","withCircle":"PdpFavoriteItem-style__withCircle__1NAUq","heartComponentWrapper":"PdpFavoriteItem-style__heartComponentWrapper__2HnXv"};

/***/ }),
/* 3056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pdpFolderItem":"PdpFolderItem-style__pdpFolderItem__15p_u"};

/***/ }),
/* 3057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"message":"RedirectedMessage-style__message__jg-QG"};

/***/ }),
/* 3058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"SaveSearch__contentWrapper__3DGGn","button":"SaveSearch__button__2wNKZ"};

/***/ }),
/* 3059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"benefits":"Benefits__benefits__2Fy_4","hasAnimation":"Benefits__hasAnimation__16uFn","benefits-fade-in":"Benefits__benefits-fade-in__3XF4n","title":"Benefits__title__2-Lmd","benefit":"Benefits__benefit__zZ0qY","icon":"Benefits__icon__2Q_4K","text":"Benefits__text__bSi_3"};

/***/ }),
/* 3060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"TradeGuarantee__wrapper__1ZDuN","moveUp":"TradeGuarantee__moveUp__1I7_Q","title":"TradeGuarantee__title__3FO8F","iconWrapper":"TradeGuarantee__iconWrapper__ZmWOc","tooltip":"TradeGuarantee__tooltip__3Wdcz","tooltipInner":"TradeGuarantee__tooltipInner__Fn9Rx","icon":"TradeGuarantee__icon__2GLUw","tooltipTitle":"TradeGuarantee__tooltipTitle__31FZZ","tooltipDescription":"TradeGuarantee__tooltipDescription__eWvTM"};

/***/ }),
/* 3061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Urgency__container__m1q19","icon":"Urgency__icon__1iBpi","content":"Urgency__content__1qN5Q","title":"Urgency__title__3yLLY","text":"Urgency__text__3F3FM"};

/***/ }),
/* 3062 */,
/* 3063 */,
/* 3064 */,
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */,
/* 3092 */,
/* 3093 */,
/* 3094 */,
/* 3095 */,
/* 3096 */,
/* 3097 */,
/* 3098 */,
/* 3099 */,
/* 3100 */,
/* 3101 */,
/* 3102 */,
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */,
/* 3122 */,
/* 3123 */,
/* 3124 */,
/* 3125 */,
/* 3126 */,
/* 3127 */,
/* 3128 */,
/* 3129 */,
/* 3130 */,
/* 3131 */,
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */,
/* 3188 */,
/* 3189 */,
/* 3190 */,
/* 3191 */,
/* 3192 */,
/* 3193 */,
/* 3194 */,
/* 3195 */,
/* 3196 */,
/* 3197 */,
/* 3198 */,
/* 3199 */,
/* 3200 */,
/* 3201 */,
/* 3202 */,
/* 3203 */,
/* 3204 */,
/* 3205 */,
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */,
/* 3212 */,
/* 3213 */,
/* 3214 */,
/* 3215 */,
/* 3216 */,
/* 3217 */,
/* 3218 */,
/* 3219 */,
/* 3220 */,
/* 3221 */,
/* 3222 */,
/* 3223 */,
/* 3224 */,
/* 3225 */,
/* 3226 */,
/* 3227 */,
/* 3228 */,
/* 3229 */,
/* 3230 */,
/* 3231 */,
/* 3232 */,
/* 3233 */,
/* 3234 */,
/* 3235 */,
/* 3236 */,
/* 3237 */,
/* 3238 */,
/* 3239 */,
/* 3240 */,
/* 3241 */,
/* 3242 */,
/* 3243 */,
/* 3244 */,
/* 3245 */,
/* 3246 */,
/* 3247 */,
/* 3248 */,
/* 3249 */,
/* 3250 */,
/* 3251 */,
/* 3252 */,
/* 3253 */,
/* 3254 */,
/* 3255 */,
/* 3256 */,
/* 3257 */,
/* 3258 */,
/* 3259 */,
/* 3260 */,
/* 3261 */,
/* 3262 */,
/* 3263 */,
/* 3264 */,
/* 3265 */,
/* 3266 */,
/* 3267 */,
/* 3268 */,
/* 3269 */,
/* 3270 */,
/* 3271 */,
/* 3272 */,
/* 3273 */,
/* 3274 */,
/* 3275 */,
/* 3276 */,
/* 3277 */,
/* 3278 */,
/* 3279 */,
/* 3280 */,
/* 3281 */,
/* 3282 */,
/* 3283 */,
/* 3284 */,
/* 3285 */,
/* 3286 */,
/* 3287 */,
/* 3288 */,
/* 3289 */,
/* 3290 */,
/* 3291 */,
/* 3292 */,
/* 3293 */,
/* 3294 */,
/* 3295 */,
/* 3296 */,
/* 3297 */,
/* 3298 */,
/* 3299 */,
/* 3300 */,
/* 3301 */,
/* 3302 */,
/* 3303 */,
/* 3304 */,
/* 3305 */,
/* 3306 */,
/* 3307 */,
/* 3308 */,
/* 3309 */,
/* 3310 */,
/* 3311 */,
/* 3312 */,
/* 3313 */,
/* 3314 */,
/* 3315 */,
/* 3316 */,
/* 3317 */,
/* 3318 */,
/* 3319 */,
/* 3320 */,
/* 3321 */,
/* 3322 */,
/* 3323 */,
/* 3324 */,
/* 3325 */,
/* 3326 */,
/* 3327 */,
/* 3328 */,
/* 3329 */,
/* 3330 */,
/* 3331 */,
/* 3332 */,
/* 3333 */,
/* 3334 */,
/* 3335 */,
/* 3336 */,
/* 3337 */,
/* 3338 */,
/* 3339 */,
/* 3340 */,
/* 3341 */,
/* 3342 */,
/* 3343 */,
/* 3344 */,
/* 3345 */,
/* 3346 */,
/* 3347 */,
/* 3348 */,
/* 3349 */,
/* 3350 */,
/* 3351 */,
/* 3352 */,
/* 3353 */,
/* 3354 */,
/* 3355 */,
/* 3356 */,
/* 3357 */,
/* 3358 */,
/* 3359 */,
/* 3360 */,
/* 3361 */,
/* 3362 */,
/* 3363 */,
/* 3364 */,
/* 3365 */,
/* 3366 */,
/* 3367 */,
/* 3368 */,
/* 3369 */,
/* 3370 */,
/* 3371 */,
/* 3372 */,
/* 3373 */,
/* 3374 */,
/* 3375 */,
/* 3376 */,
/* 3377 */,
/* 3378 */,
/* 3379 */,
/* 3380 */,
/* 3381 */,
/* 3382 */,
/* 3383 */,
/* 3384 */,
/* 3385 */,
/* 3386 */,
/* 3387 */,
/* 3388 */,
/* 3389 */,
/* 3390 */,
/* 3391 */,
/* 3392 */,
/* 3393 */,
/* 3394 */,
/* 3395 */,
/* 3396 */,
/* 3397 */,
/* 3398 */,
/* 3399 */,
/* 3400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var get = __webpack_require__(14);

var ContextComponent = __webpack_require__(61);

var style = __webpack_require__(2086);
var copy = __webpack_require__(2013);

var ConditionReportForm = function (_ContextComponent) {
    _inherits(ConditionReportForm, _ContextComponent);

    function ConditionReportForm() {
        _classCallCheck(this, ConditionReportForm);

        var _this = _possibleConstructorReturn(this, (ConditionReportForm.__proto__ || Object.getPrototypeOf(ConditionReportForm)).call(this));

        _this.onChange = _this.onChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.handleSuccess = _this.handleSuccess.bind(_this);

        _this.state = {
            description: '',
            isLoading: false,
            isError: false
        };
        return _this;
    }

    _createClass(ConditionReportForm, [{
        key: 'onChange',
        value: function onChange(event) {
            this.setState({ description: event.target.value });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(event) {
            var _state = this.state,
                isLoading = _state.isLoading,
                description = _state.description;

            var newState = {};

            if (description && !isLoading) {
                newState = {
                    isLoading: true,
                    isError: false
                };
            } else if (!isLoading) {
                event.preventDefault();
                newState = {
                    isError: true
                };
            }
            this.setState(newState);
        }
    }, {
        key: 'handleSuccess',
        value: function handleSuccess() {
            this.props.onSuccess();
        }
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                description = _state2.description,
                isError = _state2.isError,
                isLoading = _state2.isLoading;
            var _props = this.props,
                user = _props.user,
                item = _props.item;

            return React.createElement(
                'div',
                null,
                React.createElement(
                    'form',
                    {
                        className: style.content,
                        method: 'post',
                        action: 'https://www.tfaforms.com/responses/processor',
                        target: 'conditionReportIframe',
                        onSubmit: this.onSubmit
                    },
                    React.createElement(
                        'label',
                        { className: style.label },
                        copy.descriptionLabel
                    ),
                    React.createElement('textarea', {
                        className: style.textarea,
                        name: 'tfa_4',
                        value: description,
                        onChange: this.onChange,
                        title: 'Description'
                    }),
                    isError && React.createElement(
                        'div',
                        { className: style.error },
                        copy.error
                    ),
                    React.createElement(
                        'button',
                        {
                            className: 'button-primary button-large ' + style.submit,
                            disabled: isLoading
                        },
                        isLoading ? copy.buttonSending : copy.buttonSend
                    ),
                    React.createElement('input', { type: 'hidden', name: 'tfa_7', value: get(user, 'serviceId', '') }),
                    React.createElement('input', { type: 'hidden', name: 'tfa_8', value: get(item, 'seller.serviceId', '') }),
                    React.createElement('input', { type: 'hidden', name: 'tfa_1', value: '' }),
                    React.createElement('input', { type: 'hidden', name: 'tfa_2', value: '' }),
                    React.createElement('input', { type: 'hidden', name: 'tfa_3', value: 'Condition Report Request for - ' + get(item, 'dibsReference', '') }),
                    React.createElement('input', { type: 'hidden', name: 'tfa_5', value: get(item, 'dibsReference', '') }),
                    React.createElement('input', { type: 'hidden', name: 'tfa_6', value: get(item, 'title', '') }),
                    React.createElement('input', { type: 'hidden', name: 'tfa_9', value: get(item, 'pricing.totalAmount.amount', '') }),
                    React.createElement('input', { type: 'hidden', value: '4605473', name: 'tfa_dbFormId' }),
                    React.createElement('input', { type: 'hidden', value: '', name: 'tfa_dbResponseId' }),
                    React.createElement('input', { type: 'hidden', value: '24b4b37b947816e393a8c548e4f1fed7', name: 'tfa_dbControl' }),
                    React.createElement('input', { type: 'hidden', value: '2', name: 'tfa_dbVersionId' }),
                    React.createElement('input', { type: 'hidden', value: '', name: 'tfa_switchedoff' })
                ),
                React.createElement('iframe', { className: 'is-hidden', name: 'conditionReportIframe', onLoad: this.handleSuccess })
            );
        }
    }]);

    return ConditionReportForm;
}(ContextComponent);

ConditionReportForm.propTypes = {
    user: PropTypes.object,
    item: PropTypes.object,
    onSuccess: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired
};

module.exports = Relay.createContainer(ConditionReportForm, {
    fragments: {
        user: function user() {
            return function () {
                return {
                    children: [{
                        fieldName: 'serviceId',
                        kind: 'Field',
                        metadata: {},
                        type: 'ID'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ConditionReportForm_UserRelayQL',
                    type: 'User'
                };
            }();
        },
        item: function item() {
            return function () {
                return {
                    children: [{
                        fieldName: 'dibsReference',
                        kind: 'Field',
                        metadata: {},
                        type: 'String'
                    }, {
                        fieldName: 'title',
                        kind: 'Field',
                        metadata: {},
                        type: 'String'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {
                                type: 'ImageVersionTypeName!'
                            },
                            name: 'size',
                            value: {
                                kind: 'CallValue',
                                callValue: 'original'
                            }
                        }],
                        fieldName: 'firstPhotoWebPath',
                        kind: 'Field',
                        metadata: {},
                        type: 'String'
                    }, {
                        children: [{
                            children: [{
                                fieldName: 'amount',
                                kind: 'Field',
                                metadata: {},
                                type: 'Float'
                            }],
                            fieldName: 'totalAmount',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'FinancialAmount'
                        }],
                        fieldName: 'pricing',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true
                        },
                        type: 'ItemPricing'
                    }, {
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ConditionReportForm_ItemRelayQL',
                    type: 'Item'
                };
            }();
        }
    }
});

/***/ }),
/* 3401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);

var ContextComponent = __webpack_require__(61);

var _require = __webpack_require__(524),
    Modal = _require.Modal,
    Header = _require.Header,
    Body = _require.Body;

var style = __webpack_require__(2086);
var copy = __webpack_require__(2013);
var ConditionReportForm = __webpack_require__(3400);

var ConditionReportModal = function (_ContextComponent) {
    _inherits(ConditionReportModal, _ContextComponent);

    function ConditionReportModal() {
        _classCallCheck(this, ConditionReportModal);

        var _this = _possibleConstructorReturn(this, (ConditionReportModal.__proto__ || Object.getPrototypeOf(ConditionReportModal)).call(this));

        _this.onSuccess = _this.onSuccess.bind(_this);

        _this.state = {
            isSent: false
        };
        return _this;
    }

    _createClass(ConditionReportModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var isOpened = this.props.isOpened;

            if (isOpened && !nextProps.isOpened) {
                this.setState({ isSent: false });
            }
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess() {
            this.setState({ isSent: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var isSent = this.state.isSent;


            return React.createElement(
                Modal,
                this.props,
                React.createElement(
                    Header,
                    null,
                    isSent ? copy.successHeader : copy.header
                ),
                React.createElement(
                    Body,
                    null,
                    isSent ? React.createElement('div', { className: style.content, dangerouslySetInnerHTML: { __html: copy.successMessage } }) : React.createElement(ConditionReportForm, _extends({}, this.props, { onSuccess: this.onSuccess }))
                )
            );
        }
    }]);

    return ConditionReportModal;
}(ContextComponent);

ConditionReportModal.propTypes = {
    isOpened: PropTypes.bool.isRequired
};

module.exports = Relay.createContainer(ConditionReportModal, {
    initialVariables: {
        userId: ''
    },
    fragments: {
        user: function user(_ref) {
            var userId = _ref.userId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ConditionReportModal_UserRelayQL',
                    type: 'User'
                };
            }(ConditionReportForm.getFragment('user', { userId: userId }));
        },
        item: function item(_ref2) {
            var userId = _ref2.userId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ConditionReportModal_ItemRelayQL',
                    type: 'Item'
                };
            }(ConditionReportForm.getFragment('item', { userId: userId }));
        }
    }
});

/***/ }),
/* 3402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var get = __webpack_require__(14);
var tracking = __webpack_require__(27);

var ContextComponent = __webpack_require__(61);
var contactDealerLauncher = __webpack_require__(638);
var ViewInvoiceLink = __webpack_require__(1489);

var style = __webpack_require__(2972);
var copy = __webpack_require__(2543);

var shouldShowHoldRequest = function shouldShowHoldRequest(item, user) {
    return !!item && !get(item, 'hasRequestedHoldForBuyer') && !get(item, 'isPriceUponRequest') && !get(item, 'isOnHold') && !get(item, 'isSold') && !get(item, 'attributes.customizable[0].value') && get(user, 'canUseNetPrice') && get(item, 'isFurniture');
};

var trackCTA = function trackCTA(selection) {
    tracking.trackEvent({
        label: 'contact link in pdp - more from dealer module|pre-populated submitted:' + selection,
        category: 'contact dealer',
        action: 'contact dealer guided selection submitted'
    });

    tracking.trackEvent({
        label: 'contact link in pdp  - more from dealer module',
        category: 'contact dealer',
        action: 'contact dealer clicked'
    });
};

var RequestMoreInfoLinks = function (_ContextComponent) {
    _inherits(RequestMoreInfoLinks, _ContextComponent);

    function RequestMoreInfoLinks() {
        _classCallCheck(this, RequestMoreInfoLinks);

        var _this = _possibleConstructorReturn(this, (RequestMoreInfoLinks.__proto__ || Object.getPrototypeOf(RequestMoreInfoLinks)).call(this));

        _this.requestHold = _this.requestHold.bind(_this);
        _this.makeOffer = _this.makeOffer.bind(_this);

        _this.openShippingQuoteModal = _this.handleCtaClick.bind(_this, {
            action: 'openShippingQuoteModal',
            selection: 'ask about shipping'
        });

        _this.openConditionReportModal = _this.handleCtaClick.bind(_this, {
            action: 'openConditionReportModal',
            selection: 'request condition report'
        });
        return _this;
    }

    _createClass(RequestMoreInfoLinks, [{
        key: 'getLauncherProps',
        value: function getLauncherProps() {
            var item = this.props.item;

            return {
                context: this.context,
                itemPk: get(item, 'serviceId'),
                dealerPk: get(item, 'seller.serviceId')
            };
        }
    }, {
        key: 'handleCtaClick',
        value: function handleCtaClick(payload, event) {
            event.preventDefault();
            var handleCtaClick = this.props.handleCtaClick;

            handleCtaClick(payload);
            trackCTA(payload.selection);
        }
    }, {
        key: 'requestHold',
        value: function requestHold(event) {
            event.preventDefault();
            var payload = Object.assign(this.getLauncherProps(), {
                currentStep: 'contactDealer',
                modalContentData: {
                    isShowHoldRequest: false,
                    isHoldRequestChecked: true,
                    copySuffix: 'placeOnHold'
                }
            });

            contactDealerLauncher(payload);
            trackCTA('place item on hold');
        }
    }, {
        key: 'makeOffer',
        value: function makeOffer(event) {
            event.preventDefault();
            var payload = Object.assign(this.getLauncherProps(), {
                currentStep: 'makeOffer'
            });

            contactDealerLauncher(payload);
            trackCTA('make offer');
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                hasUserId = _props.hasUserId,
                userId = _props.userId,
                itemId = _props.itemId,
                viewer = _props.viewer,
                user = _props.user,
                item = _props.item;

            var showRequestHold = shouldShowHoldRequest(item, user);
            var showMakeOffer = get(item, 'canBuyerMakeOffer', false);
            var showRequestShippingQuote = get(user, 'canRequestShippingQuote', false);

            return React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: 'pdp-contact-instructions' },
                    copy.header
                ),
                showRequestShippingQuote && React.createElement(
                    'a',
                    { className: style.link, onClick: this.openShippingQuoteModal, href: '#0' },
                    copy.requestShippingQuote
                ),
                React.createElement(
                    'a',
                    { className: style.link, onClick: this.openConditionReportModal, href: '#0' },
                    copy.requestConditionReport
                ),
                showRequestHold && React.createElement(
                    'a',
                    { className: style.link, onClick: this.requestHold, href: '#0' },
                    copy.requestToHoldItem
                ),
                showMakeOffer && React.createElement(
                    'a',
                    { className: style.link, onClick: this.makeOffer, href: '#0' },
                    copy.makeOffer
                ),
                React.createElement(ViewInvoiceLink, {
                    className: style.link,
                    hasUserId: hasUserId,
                    userId: userId,
                    itemId: itemId,
                    viewer: viewer,
                    user: user,
                    onClick: function onClick() {
                        return trackCTA('view invoice');
                    },
                    children: copy.viewInvoice
                })
            );
        }
    }]);

    return RequestMoreInfoLinks;
}(ContextComponent);

RequestMoreInfoLinks.propTypes = {
    hasUserId: PropTypes.bool.isRequired,
    viewer: PropTypes.object,
    user: PropTypes.object,
    item: PropTypes.object,
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    handleCtaClick: PropTypes.func
};

module.exports = Relay.createContainer(RequestMoreInfoLinks, {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null
    },
    fragments: {
        viewer: function viewer(_ref) {
            var hasUserId = _ref.hasUserId,
                userId = _ref.userId,
                itemId = _ref.itemId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'RequestMoreInfoLinks_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(ViewInvoiceLink.getFragment('viewer', { hasUserId: hasUserId, userId: userId, itemId: itemId }));
        },
        user: function user(_ref2) {
            var hasUserId = _ref2.hasUserId,
                userId = _ref2.userId,
                itemId = _ref2.itemId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        alias: 'canUseNetPrice',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_NET_PRICE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        alias: 'canRequestShippingQuote',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_REQUEST_SHIPPING_QUOTE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'RequestMoreInfoLinks_UserRelayQL',
                    type: 'User'
                };
            }(ViewInvoiceLink.getFragment('user', { hasUserId: hasUserId, userId: userId, itemId: itemId }));
        },
        item: function item() {
            return function () {
                return {
                    children: [{
                        fieldName: 'serviceId',
                        kind: 'Field',
                        metadata: {},
                        type: 'ID'
                    }, {
                        fieldName: 'isFurniture',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        fieldName: 'canBuyerMakeOffer',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'buyerId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'hasUserId'
                                }
                            }]
                        }],
                        fieldName: 'hasRequestedHoldForBuyer',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'isPriceUponRequest',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'isOnHold',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'isSold',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        children: [{
                            children: [{
                                fieldName: 'value',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'customizable',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'AttributeValue'
                        }],
                        fieldName: 'attributes',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true
                        },
                        type: 'ItemAttributes'
                    }, {
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'company',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'sellerProfile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SellerProfile'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'seller',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Seller'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }],
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'RequestMoreInfoLinks_ItemRelayQL',
                    type: 'Item'
                };
            }();
        }
    }
});

/***/ }),
/* 3403 */,
/* 3404 */,
/* 3405 */,
/* 3406 */,
/* 3407 */,
/* 3408 */,
/* 3409 */,
/* 3410 */,
/* 3411 */,
/* 3412 */,
/* 3413 */,
/* 3414 */,
/* 3415 */,
/* 3416 */,
/* 3417 */,
/* 3418 */,
/* 3419 */,
/* 3420 */,
/* 3421 */,
/* 3422 */,
/* 3423 */,
/* 3424 */,
/* 3425 */,
/* 3426 */,
/* 3427 */,
/* 3428 */,
/* 3429 */,
/* 3430 */,
/* 3431 */,
/* 3432 */,
/* 3433 */,
/* 3434 */,
/* 3435 */,
/* 3436 */,
/* 3437 */,
/* 3438 */,
/* 3439 */,
/* 3440 */,
/* 3441 */,
/* 3442 */,
/* 3443 */,
/* 3444 */,
/* 3445 */,
/* 3446 */,
/* 3447 */,
/* 3448 */,
/* 3449 */,
/* 3450 */,
/* 3451 */,
/* 3452 */,
/* 3453 */,
/* 3454 */,
/* 3455 */,
/* 3456 */,
/* 3457 */,
/* 3458 */,
/* 3459 */,
/* 3460 */,
/* 3461 */,
/* 3462 */,
/* 3463 */,
/* 3464 */,
/* 3465 */,
/* 3466 */,
/* 3467 */,
/* 3468 */,
/* 3469 */,
/* 3470 */,
/* 3471 */,
/* 3472 */,
/* 3473 */,
/* 3474 */,
/* 3475 */,
/* 3476 */,
/* 3477 */,
/* 3478 */,
/* 3479 */,
/* 3480 */,
/* 3481 */,
/* 3482 */,
/* 3483 */,
/* 3484 */,
/* 3485 */,
/* 3486 */,
/* 3487 */,
/* 3488 */,
/* 3489 */,
/* 3490 */,
/* 3491 */,
/* 3492 */,
/* 3493 */,
/* 3494 */,
/* 3495 */,
/* 3496 */,
/* 3497 */,
/* 3498 */,
/* 3499 */,
/* 3500 */,
/* 3501 */,
/* 3502 */,
/* 3503 */,
/* 3504 */,
/* 3505 */,
/* 3506 */,
/* 3507 */,
/* 3508 */,
/* 3509 */,
/* 3510 */,
/* 3511 */,
/* 3512 */,
/* 3513 */,
/* 3514 */,
/* 3515 */,
/* 3516 */,
/* 3517 */,
/* 3518 */,
/* 3519 */,
/* 3520 */,
/* 3521 */,
/* 3522 */,
/* 3523 */,
/* 3524 */,
/* 3525 */,
/* 3526 */,
/* 3527 */,
/* 3528 */,
/* 3529 */,
/* 3530 */,
/* 3531 */,
/* 3532 */,
/* 3533 */,
/* 3534 */,
/* 3535 */,
/* 3536 */,
/* 3537 */,
/* 3538 */,
/* 3539 */,
/* 3540 */,
/* 3541 */,
/* 3542 */,
/* 3543 */,
/* 3544 */,
/* 3545 */,
/* 3546 */,
/* 3547 */,
/* 3548 */,
/* 3549 */,
/* 3550 */,
/* 3551 */,
/* 3552 */,
/* 3553 */,
/* 3554 */,
/* 3555 */,
/* 3556 */,
/* 3557 */,
/* 3558 */,
/* 3559 */,
/* 3560 */,
/* 3561 */,
/* 3562 */,
/* 3563 */,
/* 3564 */,
/* 3565 */,
/* 3566 */,
/* 3567 */,
/* 3568 */,
/* 3569 */,
/* 3570 */,
/* 3571 */,
/* 3572 */,
/* 3573 */,
/* 3574 */,
/* 3575 */,
/* 3576 */,
/* 3577 */,
/* 3578 */,
/* 3579 */,
/* 3580 */,
/* 3581 */,
/* 3582 */,
/* 3583 */,
/* 3584 */,
/* 3585 */,
/* 3586 */,
/* 3587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var animationFrame = __webpack_require__(893);
var classnames = __webpack_require__(16);
var browserCheck = __webpack_require__(478);

var DEFAULT_WIDTH = '100%';
var DEFAULT_LEFT = '0px';

var Sticky = function (_React$Component) {
    _inherits(Sticky, _React$Component);

    function Sticky(props) {
        _classCallCheck(this, Sticky);

        var _this = _possibleConstructorReturn(this, (Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call(this, props));

        _this.state = {
            top: 0,
            fixed: false,
            width: DEFAULT_WIDTH,
            left: DEFAULT_LEFT
        };

        _this._setWidth = _this._setWidth.bind(_this);
        _this._setPosition = _this._setPosition.bind(_this);
        _this._trackPosition = _this._trackPosition.bind(_this);
        return _this;
    }

    _createClass(Sticky, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var sticky = this._sticky;

            if (window.getComputedStyle(sticky).position === 'relative') {
                // position: sticky is not widely supported yet so the side bar is
                // using position: relative until it is - using "this.legacy" to denote this.
                // change position: relative to position: sticky and refactor when support is up.
                this.legacy = true;

                animationFrame(function () {
                    _this2._setPosition();
                    _this2._setWidth();
                });

                window.addEventListener('scroll', this._setPosition);
                window.addEventListener('resize', this._setWidth);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.legacy) {
                // Use `resetPosition` like a trigger to set off position tracking.
                if (nextProps.resetPosition && !this.props.resetPosition) {
                    this._trackPosition();
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.legacy) {
                window.removeEventListener('scroll', this._setPosition);
                window.removeEventListener('resize', this._setWidth);
            }
        }

        // If the `trackPosition` props gets set to true, keep adjusting the position until it is set to false. This allows
        // the sticky component to adjust itself in response to other components being animated.

    }, {
        key: '_trackPosition',
        value: function _trackPosition() {
            var _this3 = this;

            animationFrame(function () {
                _this3._setPosition();

                if (_this3.props.resetPosition) {
                    _this3._trackPosition();
                }
            });
        }
    }, {
        key: '_setWidth',
        value: function _setWidth() {
            var _props = this.props,
                calculateWidth = _props.calculateWidth,
                calculateLeft = _props.calculateLeft;


            this.setState({
                width: calculateWidth ? calculateWidth() : DEFAULT_WIDTH,
                left: calculateLeft ? calculateLeft() : DEFAULT_LEFT
            });
        }
    }, {
        key: '_setPosition',
        value: function _setPosition() {
            var _this4 = this;

            if (this.isAnimating) {
                return;
            }

            this.isAnimating = true;

            animationFrame(function () {
                var offsetTop = _this4.props.offsetTop;
                var sticky = _this4._sticky;
                var child = sticky.firstChild;
                var parent = sticky.parentElement;
                var parentBoundingRect = parent.getBoundingClientRect();
                var stickyHeight = child.clientHeight;
                var parentTop = parentBoundingRect.top - offsetTop;
                var parentBottom = parentBoundingRect.bottom - offsetTop;

                var top = 0;
                var fixed = false;

                // Prevents the sticky component from moving past the bottom of its parent.
                if (stickyHeight >= parentBottom) {
                    top -= stickyHeight + parentTop - parentBottom;

                    // This can be below 0 because the bounding box top is measured from the top of the viewport, not the top
                    // of the document.
                } else if (parentTop < 0) {
                    fixed = true;
                    top = offsetTop;

                    // If the sticky component is both above the bottom of its parent and the parent is below the top of the
                    // viewport (page scrolled to its top), then reset the position flag and top to its parents' top.
                } else if (parentTop >= 0) {
                    top = 0;
                }

                // Always reset the position
                _this4.setState({ fixed: fixed, top: top });
                _this4.isAnimating = false;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _props2 = this.props,
                className = _props2.className,
                offsetTop = _props2.offsetTop,
                children = _props2.children;
            var _state = this.state,
                top = _state.top,
                width = _state.width,
                left = _state.left,
                fixed = _state.fixed;


            var classConfig = classnames('sticky-wrapper', _defineProperty({}, className, className));

            var style = void 0;

            if (this.legacy) {
                style = { top: top, width: width };

                // IE 11 calculates this width differently than other browsers.
                // Need to subtract 2 to correct the value.
                if (browserCheck.isIE11() && style.width) {
                    style.width -= 2;
                }

                if (fixed) {
                    style.position = 'fixed';
                    style.left = left;
                }
            } else {
                style = {
                    top: offsetTop
                };
            }

            return React.createElement(
                'div',
                { ref: function ref(sticky) {
                        _this5._sticky = sticky;
                    }, style: style, className: classConfig },
                children
            );
        }
    }]);

    return Sticky;
}(React.Component);

Sticky.defaultProps = {
    offsetTop: 0,
    className: ''
};

Sticky.propTypes = {
    children: PropTypes.element,
    offsetTop: PropTypes.number,
    resetPosition: PropTypes.bool,
    className: PropTypes.string,
    calculateWidth: PropTypes.func,
    calculateLeft: PropTypes.func
};

module.exports = Sticky;

/***/ }),
/* 3588 */,
/* 3589 */,
/* 3590 */,
/* 3591 */,
/* 3592 */,
/* 3593 */,
/* 3594 */,
/* 3595 */,
/* 3596 */,
/* 3597 */,
/* 3598 */,
/* 3599 */,
/* 3600 */,
/* 3601 */,
/* 3602 */,
/* 3603 */,
/* 3604 */,
/* 3605 */,
/* 3606 */,
/* 3607 */,
/* 3608 */,
/* 3609 */,
/* 3610 */,
/* 3611 */,
/* 3612 */,
/* 3613 */,
/* 3614 */,
/* 3615 */,
/* 3616 */,
/* 3617 */,
/* 3618 */,
/* 3619 */,
/* 3620 */,
/* 3621 */,
/* 3622 */,
/* 3623 */,
/* 3624 */,
/* 3625 */,
/* 3626 */,
/* 3627 */,
/* 3628 */,
/* 3629 */,
/* 3630 */,
/* 3631 */,
/* 3632 */,
/* 3633 */,
/* 3634 */,
/* 3635 */,
/* 3636 */,
/* 3637 */,
/* 3638 */,
/* 3639 */,
/* 3640 */,
/* 3641 */,
/* 3642 */,
/* 3643 */,
/* 3644 */,
/* 3645 */,
/* 3646 */,
/* 3647 */,
/* 3648 */,
/* 3649 */,
/* 3650 */,
/* 3651 */,
/* 3652 */,
/* 3653 */,
/* 3654 */,
/* 3655 */,
/* 3656 */,
/* 3657 */,
/* 3658 */,
/* 3659 */,
/* 3660 */,
/* 3661 */,
/* 3662 */,
/* 3663 */,
/* 3664 */,
/* 3665 */,
/* 3666 */,
/* 3667 */,
/* 3668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var IABActions = __webpack_require__(1056);
var PurchaseTracking = __webpack_require__(458);

module.exports = {
    makeOffer: function makeOffer(actionContext, payload) {
        var item = payload.item,
            pageData = payload.pageData,
            referredFromAmp = payload.referredFromAmp,
            queryEmailTemplate = payload.queryEmailTemplate;

        var props = {
            item: item,
            referredFromAmp: referredFromAmp,
            tracking: {
                emailTmplName: queryEmailTemplate || '',
                pageContext: 'pdp'
            }
        };

        var purchaseTracking = new PurchaseTracking({
            item: item,
            pageContext: props.tracking.pageContext
        });

        purchaseTracking.url = pageData && pageData.canonicalUrl || document.URL;

        actionContext.executeAction(IABActions.MakeOfferActions.renderModal, {
            props: props,
            modalId: props.item.id + '-offer',
            linkLocation: props.tracking.emailTmplName,
            purchaseTracking: purchaseTracking
        });

        if (props.tracking.emailTmplName) {
            actionContext.executeAction(IABActions.MakeOfferActions.trackPageLoadModal, {
                props: props,
                purchaseTracking: purchaseTracking
            });
        } else if (props.referredFromAmp) {
            actionContext.executeAction(IABActions.MakeOfferActions.trackPageLoadModal, {
                props: props,
                purchaseTracking: purchaseTracking
            });
            purchaseTracking.ecommerceAddToCartTracking({ url: purchaseTracking.url });
        }
    }
};

/***/ }),
/* 3669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var PageBreadcrumbs = __webpack_require__(1078);
var ContextComponent = __webpack_require__(61);

var _require = __webpack_require__(379),
    trackBreadcrumbClick = _require.trackBreadcrumbClick;

var Breadcrumbs = function (_ContextComponent) {
    _inherits(Breadcrumbs, _ContextComponent);

    function Breadcrumbs(props) {
        _classCallCheck(this, Breadcrumbs);

        var _this = _possibleConstructorReturn(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).call(this, props));

        _this._handleBreadcrumbClick = _this._handleBreadcrumbClick.bind(_this);
        return _this;
    }

    _createClass(Breadcrumbs, [{
        key: '_getConfig',
        value: function _getConfig() {
            var config = [];

            this.props.categories.getCategory().ascendTree(function (category) {

                // `categories` begin with most specific category e.g. L4 -> L3 -> L2 -> L1 -- add in reverse order
                config.unshift({
                    label: category.getName(),
                    trackingLabel: 'l' + category.getLevel(),
                    path: category.getBrowseUrl()
                });
            });
            return config;
        }
    }, {
        key: '_handleBreadcrumbClick',
        value: function _handleBreadcrumbClick(_ref) {
            var trackingLabel = _ref.trackingLabel;

            this.context.executeAction(trackBreadcrumbClick, { category: trackingLabel });
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(PageBreadcrumbs, { config: this._getConfig(), addInitialConfig: true, itemClickCallback: this._handleBreadcrumbClick });
        }
    }]);

    return Breadcrumbs;
}(ContextComponent);

Breadcrumbs.propTypes = {
    categories: PropTypes.object.isRequired
};

module.exports = Breadcrumbs;

/***/ }),
/* 3670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var chatUtils = __webpack_require__(268);

// Components
var BuyerAssuranceIcon = __webpack_require__(577);
var BuyerAssuranceTooltip = __webpack_require__(3671);
var Tour = __webpack_require__(487);

var styles = __webpack_require__(3053);

function Tooltip(props) {
    var hideTooltip = props.hideTooltip,
        trackLinkClick = props.trackLinkClick;
    var tooltip = props.copy.tooltip;


    return React.createElement(BuyerAssuranceTooltip, { key: 'pdp-buyer-assurance-tooltip', copy: tooltip, hideTooltip: hideTooltip, trackLinkClick: trackLinkClick });
}

Tooltip.propTypes = {
    hideTooltip: PropTypes.func,
    trackLinkClick: PropTypes.func,
    copy: PropTypes.shape({
        tooltip: PropTypes.shape({
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired
        })
    })
};

function BuyerAssurance(props) {
    var showTooltip = props.showTooltip,
        tradeTour = props.tradeTour;
    var text = props.copy.text;
    var showInfo = props.state.showInfo;


    var onClick = function onClick(event) {
        event.preventDefault();

        if (!showInfo) {
            chatUtils.track.buyerAssuranceClick();
            showTooltip();
        }
    };

    return React.createElement(
        Tour,
        _extends({ className: styles.wrapper, dataTn: 'buyer-assurance-trade', step: 3 }, tradeTour),
        showInfo ? React.createElement(Tooltip, props) : null,
        React.createElement(
            'div',
            { className: styles.icon, onClick: onClick },
            React.createElement(BuyerAssuranceIcon, null)
        ),
        React.createElement(
            'a',
            { href: '#0', key: 'pdp-buyer-assurance-link', className: styles.text, onClick: onClick },
            text
        )
    );
}

BuyerAssurance.propTypes = {
    showTooltip: PropTypes.func.isRequired,
    hideTooltip: PropTypes.func,
    trackLinkClick: PropTypes.func,
    copy: PropTypes.shape({
        text: PropTypes.string.isRequired,
        tooltip: PropTypes.shape({
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired
        })
    }),
    state: PropTypes.shape({
        showInfo: PropTypes.bool.isRequired
    }),
    tradeTour: PropTypes.object
};

module.exports = BuyerAssurance;

/***/ }),
/* 3671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var root = __webpack_require__(97);

var _require = __webpack_require__(1),
    PropTypes = _require.PropTypes;

var BuyerAssuranceTooltipView = __webpack_require__(1792);

/**
 * Extending the global BuyerAssuranceTooltip in order to add pdp specific listeners when the tooltip is mounted and unmounted
 */

var BuyerAssuranceTooltip = function (_BuyerAssuranceToolti) {
    _inherits(BuyerAssuranceTooltip, _BuyerAssuranceToolti);

    function BuyerAssuranceTooltip() {
        _classCallCheck(this, BuyerAssuranceTooltip);

        return _possibleConstructorReturn(this, (BuyerAssuranceTooltip.__proto__ || Object.getPrototypeOf(BuyerAssuranceTooltip)).apply(this, arguments));
    }

    _createClass(BuyerAssuranceTooltip, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            root.addEventListener('scroll', this.props.hideTooltip);
            root.addEventListener('click', this.props.hideTooltip);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            root.removeEventListener('scroll', this.props.hideTooltip);
            root.removeEventListener('click', this.props.hideTooltip);
        }
    }]);

    return BuyerAssuranceTooltip;
}(BuyerAssuranceTooltipView);

// parent component (PdpBuyerAssurance) only calls to render this component if it should be shown


BuyerAssuranceTooltip.defaultProps = {
    showInfo: true
};

BuyerAssuranceTooltip.propTypes = {
    trackLinkClick: PropTypes.func,
    hideTooltip: PropTypes.func.isRequired,
    copy: PropTypes.shape({
        title: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    })
};

module.exports = BuyerAssuranceTooltip;

/***/ }),
/* 3672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Created by untitled on 13/03/2017.
 */

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);
var get = __webpack_require__(14);
var ContextComponent = __webpack_require__(61);

var _require = __webpack_require__(1441),
    CallDealerModal = _require.CallDealerModal;

var authModalLoader = __webpack_require__(263).default;
var favoriteActions = __webpack_require__(1331);
var FavoriteModel = __webpack_require__(355);
var PhoneIcon = __webpack_require__(1241);

var CallDealerButton = function (_ContextComponent) {
    _inherits(CallDealerButton, _ContextComponent);

    function CallDealerButton(props) {
        _classCallCheck(this, CallDealerButton);

        var _this = _possibleConstructorReturn(this, (CallDealerButton.__proto__ || Object.getPrototypeOf(CallDealerButton)).call(this, props));

        _this.state = { callDealerIsOpened: false };
        _this.onCallDealerClick = _this.onCallDealerClick.bind(_this);
        _this.onCallDealerModalClose = _this.onCallDealerModalClose.bind(_this);
        _this.onCallDealerAuthRequired = _this.onCallDealerAuthRequired.bind(_this);
        _this.onCallDealerModalFollow = _this.onCallDealerModalFollow.bind(_this);
        return _this;
    }

    _createClass(CallDealerButton, [{
        key: 'onCallDealerClick',
        value: function onCallDealerClick() {
            var callDealerIsOpened = this.state.callDealerIsOpened;

            this.setState({ callDealerIsOpened: !callDealerIsOpened });
        }
    }, {
        key: 'onCallDealerModalClose',
        value: function onCallDealerModalClose() {
            this.setState({ callDealerIsOpened: false });
        }
    }, {
        key: 'onCallDealerAuthRequired',
        value: function onCallDealerAuthRequired(onAuthSuccess, onAuthFailure) {
            var _this2 = this;

            this.setState({ callDealerIsOpened: false });
            authModalLoader.show({
                action: authModalLoader.constants.REGISTER,
                flow: authModalLoader.constants.CONTACT_DEALER_CALL_FLOW
            }).then(function (_ref) {
                var user = _ref.user,
                    err = _ref.err;

                if (err) {
                    onAuthFailure();
                    return;
                }
                onAuthSuccess(user.userId);
                _this2.setState({ callDealerIsOpened: true });
            });
        }
    }, {
        key: 'onCallDealerModalFollow',
        value: function onCallDealerModalFollow() {
            var _props = this.props,
                dealerPk = _props.dealerPk,
                page = _props.page;

            var payload = {
                type: FavoriteModel.TYPE_DEALER,
                primaryKey: dealerPk,
                page: page
            };
            this.context.executeAction(favoriteActions.saveToFavorites, payload);
            this.setState({ callDealerIsOpened: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var callDealerIsOpened = this.state.callDealerIsOpened;
            var _props2 = this.props,
                userId = _props2.userId,
                hasUserId = _props2.hasUserId,
                viewer = _props2.viewer,
                item = _props2.item,
                copy = _props2.copy;

            var callDealerCtaCopy = get(copy, 'dealer.callDealerCta');

            return React.createElement(
                'div',
                null,
                React.createElement(
                    'a',
                    { href: '#', className: 'pdp-call-dealer-wrapper', onClick: this.onCallDealerClick },
                    React.createElement(PhoneIcon, { className: 'pdp-call-dealer-icon' }),
                    React.createElement(
                        'span',
                        { className: 'pdp-call-dealer-copy' },
                        callDealerCtaCopy
                    )
                ),
                React.createElement(CallDealerModal, {
                    userId: userId,
                    hasUserId: hasUserId,
                    viewer: viewer,
                    item: item,
                    isOpened: callDealerIsOpened,
                    location: 'pdp',
                    onAuthRequired: this.onCallDealerAuthRequired,
                    onClose: this.onCallDealerModalClose,
                    onFollowDealer: this.onCallDealerModalFollow
                })
            );
        }
    }]);

    return CallDealerButton;
}(ContextComponent);

CallDealerButton.propTypes = {
    userId: PropTypes.string,
    hasUserId: PropTypes.bool.isRequired,
    dealerPk: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    item: PropTypes.object
};

module.exports = Relay.createContainer(CallDealerButton, {
    initialVariables: {
        userId: null,
        hasUserId: false
    },
    fragments: {
        item: function item(_ref2) {
            var userId = _ref2.userId,
                hasUserId = _ref2.hasUserId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'CallDealerButton_ItemRelayQL',
                    type: 'Item'
                };
            }(CallDealerModal.getFragment('item', { userId: userId, hasUserId: hasUserId }));
        },
        viewer: function viewer(_ref3) {
            var userId = _ref3.userId,
                hasUserId = _ref3.hasUserId;
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'CallDealerButton_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(CallDealerModal.getFragment('viewer', { userId: userId, hasUserId: hasUserId }));
        }
    }
});

/***/ }),
/* 3673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by !daletan on 2/30/93.
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classNames = __webpack_require__(16);
var intelligentFormatObj = __webpack_require__(536);
var getCurrencySymbol = __webpack_require__(2072);
var copy = __webpack_require__(2580);
var HoldRequestInput = __webpack_require__(3676).default;

var _require = __webpack_require__(968),
    variants = _require.variants;

var ContactDealerMessage = function (_React$Component) {
    _inherits(ContactDealerMessage, _React$Component);

    function ContactDealerMessage() {
        _classCallCheck(this, ContactDealerMessage);

        var _this = _possibleConstructorReturn(this, (ContactDealerMessage.__proto__ || Object.getPrototypeOf(ContactDealerMessage)).call(this));

        _this.state = { name: '' };
        _this.onNameInput = _this.onNameInput.bind(_this);
        return _this;
    }

    _createClass(ContactDealerMessage, [{
        key: 'onNameInput',
        value: function onNameInput(e) {
            this.setState({ name: e.target.value });
        }
    }, {
        key: 'render',
        value: function render() {
            var name = this.state.name;
            var _props = this.props,
                offerExpanded = _props.offerExpanded,
                price = _props.price,
                currency = _props.currency,
                isLoggedIn = _props.isLoggedIn,
                onNameEntered = _props.onNameEntered,
                onMessageFocused = _props.onMessageFocused,
                nameError = _props.nameError,
                onMessageEntered = _props.onMessageEntered,
                messageError = _props.messageError,
                displayOffer = _props.displayOffer,
                onOfferClick = _props.onOfferClick,
                onOfferBlurred = _props.onOfferBlurred,
                onOfferEntered = _props.onOfferEntered,
                offerAmount = _props.offerAmount,
                error = _props.error,
                isDealerMessageSending = _props.isDealerMessageSending,
                onContactDealer = _props.onContactDealer,
                type = _props.type,
                maytest = _props.maytest,
                sidebar = _props.sidebar,
                showRequestHold = _props.showRequestHold,
                isHoldRequestChecked = _props.isHoldRequestChecked,
                onHoldRequestClick = _props.onHoldRequestClick;

            var offerClasses = classNames('pdp-make-offer-wrapper', { expanded: offerExpanded });
            var offerLinkClasses = classNames('pdp-dealer-link', { 'offer-link': !offerExpanded });
            var symbol = offerExpanded ? '–' : '+';

            var _intelligentFormatObj = intelligentFormatObj(price, currency),
                currencySymbol = _intelligentFormatObj.currencySymbol,
                number = _intelligentFormatObj.number;

            var buttonClasses = classNames('button-' + (maytest === variants.CONTACT2 ? 'small' : 'large'), 'button-' + (sidebar ? 'secondary' : 'primary'), 'pdp-contact-button', {
                'maytest-contact-button': maytest === variants.CONTACT2,
                'in-sidebar': sidebar
            });

            return React.createElement(
                'div',
                { className: 'pdp-dealer-section pdp-contact-dealer' },
                maytest === variants.OPOP || maytest === variants.CONTACT2 ? React.createElement(
                    'div',
                    { className: 'pdp-dealer-maytest-opop' },
                    maytest === variants.CONTACT2 && React.createElement(
                        'p',
                        { className: 'pdp-contact-dealer-title' },
                        'Questions about this piece?'
                    ),
                    !isLoggedIn && React.createElement(
                        'div',
                        { className: 'pdp-contact-name-wrapper' },
                        React.createElement('input', {
                            className: 'pdp-contact-name maytest-opop-input',
                            onBlur: onNameEntered,
                            onFocus: onMessageFocused,
                            onChange: this.onNameInput,
                            value: name
                        }),
                        React.createElement(
                            'span',
                            { className: 'maytest-opop-input-placeholder' },
                            maytest === variants.CONTACT2 && 'Your ',
                            'Name'
                        ),
                        nameError && React.createElement(
                            'p',
                            { className: 'pdp-contact-errors' },
                            copy.errors.isRequired
                        )
                    )
                ) : React.createElement(
                    'div',
                    null,
                    React.createElement(
                        'h1',
                        { className: 'pdp-contact-dealer-title pdp-dealer-message-title' },
                        'Contact ',
                        type
                    ),
                    !isLoggedIn && React.createElement(
                        'div',
                        { className: 'pdp-contact-name-wrapper' },
                        React.createElement(
                            'p',
                            { className: 'pdp-contact-instructions' },
                            copy.name
                        ),
                        React.createElement('input', {
                            className: 'pdp-contact-name com-form-input',
                            onBlur: onNameEntered,
                            onFocus: onMessageFocused
                        }),
                        nameError && React.createElement(
                            'p',
                            { className: 'pdp-contact-errors' },
                            copy.errors.isRequired
                        )
                    ),
                    React.createElement(
                        'p',
                        { className: 'pdp-contact-instructions' },
                        copy.yourMessage
                    )
                ),
                React.createElement('textarea', {
                    className: 'pdp-contact-text',
                    onBlur: onMessageEntered,
                    onFocus: onMessageFocused,
                    placeholder: maytest === variants.CONTACT2 ? 'Ask the ' + type + ' a question about this piece.' : 'Contact the ' + type + ' to learn more about the history of the piece, request more details or even to discuss the price.',
                    rows: '5'
                }),
                messageError && React.createElement(
                    'p',
                    { className: 'pdp-contact-errors' },
                    copy.errors.isRequired
                ),
                displayOffer && React.createElement(
                    'p',
                    { className: offerLinkClasses, onClick: onOfferClick },
                    'Make an Offer ' + symbol
                ),
                displayOffer && React.createElement(
                    'div',
                    { className: offerClasses },
                    React.createElement(
                        'p',
                        { className: 'pdp-contact-item-price' },
                        'List Price ' + currencySymbol + number
                    ),
                    React.createElement(
                        'div',
                        { className: 'pdp-contact-offer-wrapper' },
                        React.createElement(
                            'span',
                            { className: 'pdp-contact-offer-currency' },
                            getCurrencySymbol(currency)
                        ),
                        React.createElement('input', {
                            className: 'pdp-contact-offer com-form-input',
                            onBlur: onOfferBlurred,
                            onChange: onOfferEntered,
                            value: offerAmount
                        })
                    ),
                    React.createElement(
                        'p',
                        { className: 'pdp-contact-errors' },
                        error
                    )
                ),
                sidebar && maytest === variants.CONTACT2 && showRequestHold && React.createElement(HoldRequestInput, {
                    isHoldRequestChecked: isHoldRequestChecked,
                    onClick: onHoldRequestClick
                }),
                React.createElement(
                    'button',
                    {
                        className: buttonClasses,
                        disabled: isDealerMessageSending,
                        onClick: onContactDealer
                    },
                    maytest === variants.OPOP ? 'Send' : 'Send to ' + type
                )
            );
        }
    }]);

    return ContactDealerMessage;
}(React.Component);

ContactDealerMessage.defaultProps = {
    displayOffer: false,
    offerAmount: ''
};

ContactDealerMessage.propTypes = {
    currency: PropTypes.string.isRequired,
    error: PropTypes.string,
    isDealerMessageSending: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    displayOffer: PropTypes.bool,
    hasErrors: PropTypes.bool,
    messageError: PropTypes.bool,
    nameError: PropTypes.bool,
    offerAmount: PropTypes.string,
    offerExpanded: PropTypes.bool.isRequired,
    onContactDealer: PropTypes.func.isRequired,
    onMessageEntered: PropTypes.func.isRequired,
    onMessageFocused: PropTypes.func.isRequired,
    onNameEntered: PropTypes.func.isRequired,
    onOfferBlurred: PropTypes.func.isRequired,
    onOfferClick: PropTypes.func.isRequired,
    onOfferEntered: PropTypes.func.isRequired,
    price: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    maytest: PropTypes.string,
    sidebar: PropTypes.bool,
    showRequestHold: PropTypes.bool,
    isHoldRequestChecked: PropTypes.bool,
    onHoldRequestClick: PropTypes.func
};

module.exports = ContactDealerMessage;

/***/ }),
/* 3674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ContactDealerFavorite = __webpack_require__(2175);

var _require = __webpack_require__(968),
    variants = _require.variants;

function ContactDealerMessageSent(_ref) {
    var company = _ref.company,
        favoriteDealer = _ref.favoriteDealer,
        favoriteDealerCta = _ref.favoriteDealerCta,
        pk = _ref.pk,
        uri = _ref.uri,
        type = _ref.type,
        maytest = _ref.maytest;

    return React.createElement(
        'div',
        { className: 'pdp-dealer-section pdp-contact-dealer' },
        React.createElement(
            'h1',
            { className: 'pdp-contact-dealer-title' },
            'Your message was sent!'
        ),
        React.createElement(
            'p',
            { className: 'pdp-contact-description' },
            maytest === variants.CONTACT2 ? 'The ' + type + ' will respond to your message shortly' : 'Follow ' + company + ' to receive weekly email alerts when they add new listings on 1stdibs'
        ),
        maytest !== variants.CONTACT2 && React.createElement(ContactDealerFavorite, {
            company: company,
            favoriteDealer: favoriteDealer,
            favoriteDealerCta: favoriteDealerCta,
            pk: pk,
            uri: uri
        })
    );
}

ContactDealerMessageSent.propTypes = {
    company: PropTypes.string.isRequired,
    favoriteDealer: PropTypes.object.isRequired,
    favoriteDealerCta: PropTypes.object.isRequired,
    pk: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired,
    type: PropTypes.string,
    maytest: PropTypes.string
};

module.exports = ContactDealerMessageSent;

/***/ }),
/* 3675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

// Stores
var ItemStore = __webpack_require__(336);
var PriceStore = __webpack_require__(367);
var TourStore = __webpack_require__(547);

// Components
var Tour = __webpack_require__(487);

// Helpers
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var SV = __webpack_require__(17);
var _TourStore$type = TourStore.type,
    TRADE_TOUR = _TourStore$type.TRADE_TOUR,
    REQUEST_ITEM_HOLD_TOUR = _TourStore$type.REQUEST_ITEM_HOLD_TOUR;

var tourTracking = __webpack_require__(506);
var ArrowRightIcon = __webpack_require__(351);

var ContactDealerSidebar = function ContactDealerSidebar(_ref) {
    var copy = _ref.copy,
        onContactDealer = _ref.onContactDealer,
        tradeTour = _ref.tradeTour,
        requestItemHoldTour = _ref.requestItemHoldTour;

    return React.createElement(
        'div',
        { className: 'pdp-sidebar-contact-dealer' },
        React.createElement(
            Tour,
            _extends({ step: 1, dataTn: 'contact-dealer-request-hold' }, requestItemHoldTour),
            React.createElement(
                Tour,
                _extends({ step: 2, dataTn: 'contact-dealer-trade' }, tradeTour),
                React.createElement(
                    'a',
                    { href: '#0', className: 'pdp-sidebar-contact-dealer-copy', onClick: onContactDealer },
                    copy,
                    ' ',
                    React.createElement(ArrowRightIcon, { className: 'pdp-sidebar-contact-dealer-icon' })
                )
            )
        )
    );
};

ContactDealerSidebar.propTypes = {
    onContactDealer: PropTypes.func.isRequired,
    copy: PropTypes.string.isRequired,
    tradeTour: PropTypes.object,
    requestItemHoldTour: PropTypes.object,
    callout: PropTypes.object
};

module.exports = provideContext(connectToStores(ContactDealerSidebar, [ItemStore, PriceStore, TourStore], function (context) {
    var itemStore = context.getStore(ItemStore);
    var priceStore = context.getStore(PriceStore);
    var tourStore = context.getStore(TourStore);
    var item = itemStore.getItem();
    var processedPriceData = priceStore.processPrice(item);

    return {
        requestItemHoldTour: {
            type: REQUEST_ITEM_HOLD_TOUR,
            copy: SV.get('tourCopy.' + REQUEST_ITEM_HOLD_TOUR),
            isTourOpen: tourStore.isTourOpen(REQUEST_ITEM_HOLD_TOUR),
            currentStep: tourStore.getCurrentStep(REQUEST_ITEM_HOLD_TOUR),
            totalSteps: tourStore.getTotalSteps(REQUEST_ITEM_HOLD_TOUR),
            onCtaClick: tourTracking.trackCta,
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        },
        tradeTour: {
            type: TRADE_TOUR,
            subType: processedPriceData.priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
            copy: SV.get('tourCopy.' + TRADE_TOUR),
            isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
            currentStep: tourStore.getCurrentStep(TRADE_TOUR),
            totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        }
    };
}));

/***/ }),
/* 3676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _checkmark = __webpack_require__(448);

var _checkmark2 = _interopRequireDefault(_checkmark);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _HoldRequestInputStyle = __webpack_require__(3054);

var _HoldRequestInputStyle2 = _interopRequireDefault(_HoldRequestInputStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HoldRequestInput = function (_Component) {
    _inherits(HoldRequestInput, _Component);

    function HoldRequestInput() {
        _classCallCheck(this, HoldRequestInput);

        var _this = _possibleConstructorReturn(this, (HoldRequestInput.__proto__ || Object.getPrototypeOf(HoldRequestInput)).call(this));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(HoldRequestInput, [{
        key: 'onClick',
        value: function onClick() {
            var isHoldRequestChecked = this.props.isHoldRequestChecked;

            this.props.onClick(!isHoldRequestChecked);
        }
    }, {
        key: 'render',
        value: function render() {
            var isHoldRequestChecked = this.props.isHoldRequestChecked;

            var checkboxClasses = (0, _classnames2.default)(_HoldRequestInputStyle2.default.checkbox, _defineProperty({}, _HoldRequestInputStyle2.default.checked, isHoldRequestChecked));

            return _react2.default.createElement(
                'div',
                { className: _HoldRequestInputStyle2.default.container },
                _react2.default.createElement(
                    'div',
                    { className: checkboxClasses, onClick: this.onClick },
                    isHoldRequestChecked && _react2.default.createElement(_checkmark2.default, { className: _HoldRequestInputStyle2.default.icon })
                ),
                _react2.default.createElement(
                    'label',
                    { className: _HoldRequestInputStyle2.default.label, onClick: this.onClick },
                    'Place item on hold (include for how long)'
                )
            );
        }
    }]);

    return HoldRequestInput;
}(_react.Component);

HoldRequestInput.propTypes = {
    isHoldRequestChecked: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

exports.default = HoldRequestInput;

/***/ }),
/* 3677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRelay = __webpack_require__(18);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HoldRequestMutation = function (_Relay$Mutation) {
    _inherits(HoldRequestMutation, _Relay$Mutation);

    function HoldRequestMutation() {
        _classCallCheck(this, HoldRequestMutation);

        return _possibleConstructorReturn(this, (HoldRequestMutation.__proto__ || Object.getPrototypeOf(HoldRequestMutation)).apply(this, arguments));
    }

    _createClass(HoldRequestMutation, [{
        key: 'getMutation',
        value: function getMutation() {
            return function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'createHoldRequest',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'CreateHoldRequestInput!'
                    },
                    name: 'HoldRequestMutation',
                    responseType: 'CreateHoldRequestPayload'
                };
            }();
        }
    }, {
        key: 'getVariables',
        value: function getVariables() {
            var _props = this.props,
                itemId = _props.itemId,
                userId = _props.userId,
                sellerId = _props.sellerId,
                vertical = _props.vertical;


            return {
                itemId: itemId,
                userId: userId,
                sellerId: sellerId,
                vertical: vertical
            };
        }
    }, {
        key: 'getFatQuery',
        value: function getFatQuery() {
            return function () {
                return {
                    children: [{
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }],
                    id: _reactRelay2.default.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'HoldRequestMutation_ValueRelayQL',
                    type: 'CreateHoldRequestPayload'
                };
            }();
        }
    }, {
        key: 'getConfigs',
        value: function getConfigs() {
            return [{
                type: 'FIELDS_CHANGE',
                fieldIDs: { item: this.props.itemId }
            }];
        }
    }]);

    return HoldRequestMutation;
}(_reactRelay2.default.Mutation);

exports.default = HoldRequestMutation;

/***/ }),
/* 3678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var GridPhotoElement = __webpack_require__(3679);

var _require = __webpack_require__(379),
    trackGridPhotoDisplay = _require.trackGridPhotoDisplay;

var GridPhoto = function (_React$Component) {
    _inherits(GridPhoto, _React$Component);

    function GridPhoto() {
        _classCallCheck(this, GridPhoto);

        return _possibleConstructorReturn(this, (GridPhoto.__proto__ || Object.getPrototypeOf(GridPhoto)).apply(this, arguments));
    }

    _createClass(GridPhoto, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.context.executeAction(trackGridPhotoDisplay);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return React.createElement(
                'div',
                { className: 'pdp-grid-photo-container' },
                React.createElement(
                    'div',
                    { className: 'pdp-grid-photo-inner' },
                    React.createElement(
                        'h2',
                        { className: 'pdp-grid-photo-header' },
                        'View Similar Pieces in Featured Rooms'
                    ),
                    React.createElement(
                        'div',
                        { className: 'pdp-grid-photo-list' },
                        this.props.photos.map(function (photo) {
                            return React.createElement(GridPhotoElement, _extends({ key: photo.id, context: _this2.context }, photo));
                        })
                    )
                )
            );
        }
    }]);

    return GridPhoto;
}(React.Component);

GridPhoto.defaultProps = {
    photos: []
};

GridPhoto.propTypes = {
    context: PropTypes.object,
    photos: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired
    }))
};

GridPhoto.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func
};

module.exports = GridPhoto;

/***/ }),
/* 3679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var galleryActions = __webpack_require__(363);
var galleryModalActions = __webpack_require__(512);

var _require = __webpack_require__(379),
    trackGridPhotoClick = _require.trackGridPhotoClick,
    trackGridPhotoGalleryOpen = _require.trackGridPhotoGalleryOpen;

var GridPhotoElement = function (_React$Component) {
    _inherits(GridPhotoElement, _React$Component);

    function GridPhotoElement(props) {
        _classCallCheck(this, GridPhotoElement);

        var _this = _possibleConstructorReturn(this, (GridPhotoElement.__proto__ || Object.getPrototypeOf(GridPhotoElement)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(GridPhotoElement, [{
        key: 'handleClick',
        value: function handleClick(e) {
            e.preventDefault();
            var id = this.props.id;


            this.context.executeAction(trackGridPhotoClick);
            this.context.executeAction(galleryActions.setPhoto, { id: id });
            this.context.executeAction(galleryModalActions.showModal);
            this.context.executeAction(trackGridPhotoGalleryOpen);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                url = _props.url,
                thumb = _props.thumb,
                project = _props.project,
                firm = _props.firm;

            return React.createElement(
                'div',
                { className: 'pdp-grid-photo', onClick: this.handleClick },
                React.createElement(
                    'div',
                    { className: 'pdp-grid-photo-content' },
                    React.createElement(
                        'a',
                        { href: url, className: 'pdp-grid-photo-link' },
                        React.createElement(
                            'div',
                            { className: 'pdp-grid-photo-image-wrapper' },
                            React.createElement('img', { src: thumb, className: 'pdp-grid-photo-image' })
                        ),
                        React.createElement(
                            'div',
                            { className: 'pdp-grid-photo-text' },
                            React.createElement(
                                'div',
                                { className: 'pdp-grid-photo-title' },
                                project.name
                            ),
                            React.createElement(
                                'div',
                                { className: 'pdp-grid-photo-subtitle' },
                                firm.name
                            )
                        )
                    )
                )
            );
        }
    }]);

    return GridPhotoElement;
}(React.Component);

GridPhotoElement.propTypes = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string,
    url: PropTypes.string,
    thumb: PropTypes.string,
    project: PropTypes.shape({
        name: PropTypes.string
    }),
    firm: PropTypes.shape({
        name: PropTypes.string
    })
};

GridPhotoElement.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func
};

module.exports = GridPhotoElement;

/***/ }),
/* 3680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var GridBase = __webpack_require__(1486);
var GridHeader = __webpack_require__(1487);
var GridItem = __webpack_require__(1488);

var GridSuggestion = function (_GridBase) {
    _inherits(GridSuggestion, _GridBase);

    function GridSuggestion(props) {
        _classCallCheck(this, GridSuggestion);

        var _this = _possibleConstructorReturn(this, (GridSuggestion.__proto__ || Object.getPrototypeOf(GridSuggestion)).call(this, props));

        _this.state = {
            quickViewItemId: null
        };

        _this._setQuickViewId = _this._setQuickViewId.bind(_this);
        return _this;
    }

    _createClass(GridSuggestion, [{
        key: '_getHeader',
        value: function _getHeader() {
            return React.createElement(
                'div',
                { className: 'pdp-suggestion-grid-header' },
                React.createElement(GridHeader, { title: this.props.copy.suggestion.carouselHeader })
            );
        }
    }, {
        key: '_getItems',
        value: function _getItems() {
            var _this2 = this;

            return this.props.data.map(function (data, index) {
                // index needs to be 1-based, not 0-based
                data.index = index + 1;
                return React.createElement(
                    'div',
                    { className: 'pdp-grid-item colLg3 colMd4 colXs6', key: data.id },
                    React.createElement(GridItem, _extends({
                        setQuickViewId: _this2._setQuickViewId,
                        quickViewItemId: _this2.state.quickViewItemId,
                        quickView: _this2.props.quickView,
                        gridType: 'pdp you may also like'
                    }, data))
                );
            });
        }
    }]);

    return GridSuggestion;
}(GridBase);

GridSuggestion.propTypes = {
    data: PropTypes.array,
    copy: PropTypes.object.isRequired,
    quickView: PropTypes.bool,
    darkGrid: PropTypes.bool
};

GridSuggestion.defaultProps = {
    data: [],
    quickView: true,
    darkGrid: true,
    domId: 'suggestion-grid'
};

module.exports = GridSuggestion;

/***/ }),
/* 3681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);

// Components
var classnames = __webpack_require__(16);
var RequestShippingModal = __webpack_require__(1116).default;

var _require = __webpack_require__(482),
    getEnvironment = _require.getEnvironment;

var ContextComponent = __webpack_require__(61);
var MediaQuery = __webpack_require__(378);
var Sticky = __webpack_require__(3587);
var ShippingAndReturnsColumn = __webpack_require__(1862);
var ConnectAccountsModal = __webpack_require__(1831);
var ConnectBoardModal = __webpack_require__(1832);
var TradeWelcomeMessage = __webpack_require__(780);
var Similar = __webpack_require__(3695);
var Breadcrumbs = __webpack_require__(3669);
var Carousel = __webpack_require__(1845);
var Sidebar = __webpack_require__(3691);
var PdpSocialIcons = __webpack_require__(1490);
var ExpandableContent = __webpack_require__(1849);
var ProfileLink = __webpack_require__(3682);

var _require2 = __webpack_require__(1848),
    Details = _require2.Connected;

var ContactDealerBody = __webpack_require__(2174);
var GridDealer = __webpack_require__(1850);
var GridSuggestion = __webpack_require__(3680);
var GridPhoto = __webpack_require__(3678);
var SeoLinks = __webpack_require__(3686);
var PdpFolderItem = __webpack_require__(2177).default;
var PdpFavoriteItem = __webpack_require__(2176).default;
var RedirectedMessage = __webpack_require__(3683);
var ConditionReportModal = __webpack_require__(3401);

// Helpers
var SV = __webpack_require__(17);

var _require3 = __webpack_require__(334),
    getUserId = _require3.getUserId,
    cookieJarConstants = _require3.cookieJarConstants;

var MASQUERADE_BUYER = cookieJarConstants.MASQUERADE_BUYER;

var _require4 = __webpack_require__(541),
    getShipmentPrequotes = _require4.getShipmentPrequotes;

var _require5 = __webpack_require__(365),
    queries = _require5.queries;

var facebookInit = __webpack_require__(3697);
var pdpTracking = __webpack_require__(542);
var enabler = __webpack_require__(63);
var get = __webpack_require__(14);

var _require6 = __webpack_require__(968),
    variants = _require6.variants;
// Actions


var makeOfferActions = __webpack_require__(3668);
var modalActions = __webpack_require__(1485);
var pinterestActions = __webpack_require__(710);

var _require7 = __webpack_require__(379),
    trackPinterestClick = _require7.trackPinterestClick;

var contactDealerActions = __webpack_require__(2173);

var abExperiments = __webpack_require__(497);

// Constants
// The distance from the top of the page where the sidebar should start "sticking".
var STICKY_OFFSET_TOP = 80;

var PdpLayout = function (_ContextComponent) {
    _inherits(PdpLayout, _ContextComponent);

    function PdpLayout(props) {
        _classCallCheck(this, PdpLayout);

        var _this = _possibleConstructorReturn(this, (PdpLayout.__proto__ || Object.getPrototypeOf(PdpLayout)).call(this, props));

        _this._calculateStickyWidth = _this._calculateStickyWidth.bind(_this);
        _this._calculateStickyLeft = _this._calculateStickyLeft.bind(_this);
        _this._stf = _this._stf.bind(_this);
        _this._contactDealer = _this._contactDealer.bind(_this);
        _this._onPinterestPin = _this._onPinterestPin.bind(_this);
        _this.handleCtaClick = _this.handleCtaClick.bind(_this);

        _this.state = {
            contactDealerCTATestRunning: false,
            isRequestShippingQuoteModalOpen: false,
            isConditionReportModalOpen: false
        };
        return _this;
    }

    _createClass(PdpLayout, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var props = this.props;
            var item = props.item,
                urlData = props.urlData,
                priceDisplays = props.priceDisplays;

            var modalValue = get(urlData, 'queryKey.modal');
            var referredFromAmp = get(urlData, 'queryKey.userComesFromAmp');
            var ctaSelected = get(urlData, 'queryKey.ctaSelected');
            var actions = {
                'offer': makeOfferActions.makeOffer,
                // needs to keep the space b/c of the way the queryKey parses query params with hyphens
                'contact dealer': modalActions.contactDealer,
                'request net price': modalActions.netPrice,
                'stf': modalActions.stf
            };
            var action = actions[modalValue];
            var ampTrackingLabel = ctaSelected === 'requestPrice' ? ' - request price button' : '';

            var tracking = {
                'stf': 'send to a friend in pdp – deeplink',
                'contact dealer': 'contact link in pdp – deeplink',
                'ampContact': 'contact link in pdp' + ampTrackingLabel + '\u2013amppage'
            };
            var trackingValue = tracking[referredFromAmp ? 'ampContact' : modalValue];
            var modalOptions = {
                id: props.itemId,
                itemPk: props.itemPk,
                dealerPk: props.dealerPk,
                vertical: props.itemVertical,
                tracking: trackingValue
            };
            // Setup the Facebook API for sharing items.
            facebookInit();

            // This call kicks off the logic that results in the initial tracking pageview for the pdp.
            // No tracking will happen until after this finishes.
            pdpTracking.updateGaReturns(item.get('returnPolicy.accept') === 'Y');

            if (priceDisplays) {
                pdpTracking.updateGaPageSubtype(priceDisplays);
            }

            pdpTracking.setupShippingStatusTracking();
            pdpTracking.unblockCustomVar();

            // Track initial page load.
            // TODO: Migrate this to new pdp tracking file.
            var trackingOverrides = {};
            if (item.isSold() || item.isUnavailableStatus()) {
                trackingOverrides = pdpTracking.checkListingStatus(item.getListings().get('metadata.groupedListingStatuses'));
            }
            pdpTracking.trackProductDetail(trackingOverrides);

            this.context.executeAction(pinterestActions.initApp);
            this.context.executeAction(pinterestActions.setSessionOnLoginChange);

            // Open the make offer modal on page load if there is query param modal=offer,
            // item is negotiable, and item has not been sold
            if (action) {
                if (modalValue === 'offer' && item.isNegotiablePrice() && !item.isSold()) {
                    this.context.executeAction(action, {
                        item: props.item,
                        pageData: props.pageData,
                        queryEmailTemplate: get(urlData, 'queryKey.e_tmpl'),
                        referredFromAmp: referredFromAmp
                    });
                } else if (modalValue === 'request net price') {
                    var netPriceTracking = {
                        pageContext: 'pdp',
                        url: props.canonicalUrl || props.url,
                        emailTmplName: urlData.queryKey.e_tmpl || ''
                    };
                    var netPriceModalOptions = Object.assign({}, modalOptions, {
                        item: props.item,
                        currency: props.currency,
                        context: this.context,
                        tracking: netPriceTracking.pageContext
                    });

                    this.context.executeAction(action, netPriceModalOptions);
                } else {
                    this.context.executeAction(action, modalOptions);
                }
            }
            // AB test for GROWTH-1908: IMbedded offer on contact dealer
            if (abExperiments.contactDealerSubmitOffer) {
                abExperiments.contactDealerSubmitOffer.then(function (res) {
                    _this2.context.executeAction(contactDealerActions.setOptimizelyVariant, { optimizely: res });
                });
            }

            if (abExperiments.contactDealerCTA) {
                abExperiments.contactDealerCTA.then(function () {
                    _this2.setState({ contactDealerCTATestRunning: true });
                });
            }
        }
    }, {
        key: '_onPinterestPin',
        value: function _onPinterestPin() {
            this.context.executeAction(trackPinterestClick);
        }

        // Get the sidebar width. This is necessary here because the sidebar uses `position: fixed` and so doesn't inherit
        // the correct width from its parent.

    }, {
        key: '_calculateStickyWidth',
        value: function _calculateStickyWidth() {
            var mainContentRef = this.refs.mainContent;

            return mainContentRef.clientWidth - this._carousel.clientWidth;
        }

        // Get the sidebar position. This is necessary here because the sidebar uses `position: fixed` and so isn't positioned
        // correctly within its parent.

    }, {
        key: '_calculateStickyLeft',
        value: function _calculateStickyLeft() {
            return this._carousel.getBoundingClientRect().right;
        }

        /**
         * Passed along to social/PdpEmailIcon component
         * @param props
         * @private
         */

    }, {
        key: '_stf',
        value: function _stf(props) {
            this.context.executeAction(modalActions.stf, {
                id: props.id,
                itemPk: props.itemPk,
                vertical: props.vertical
            });
        }

        /**
         * Passed along to Sidebar
         * @param props
         * @private
         */

    }, {
        key: '_contactDealer',
        value: function _contactDealer() {
            var contactDealerCTATestRunning = this.state.contactDealerCTATestRunning;
            var _props = this.props,
                viewer = _props.viewer,
                itemPk = _props.itemPk,
                dealerPk = _props.dealerPk,
                maytest = _props.maytest;
            var isCustomizable = viewer.item.isCustomizable;


            var tracking = isCustomizable ? 'contact link in pdp - sidebar - customize this item link' : 'contact link in pdp - sidebar';

            var showPreContactDealer = contactDealerCTATestRunning && viewer.user && viewer.user.isVerifiedTrade;

            this.context.executeAction(modalActions.contactDealer, {
                tracking: tracking,
                itemPk: itemPk,
                dealerPk: dealerPk,
                currentStep: showPreContactDealer ? 'preContactDealer' : 'contactDealer',
                handleCtaClick: this.handleCtaClick,
                modalContentData: {
                    /*GROWTH-2689/GROWTH-2637 if test needs to be removed - remove copies with test prefix from dibs-contact-modal*/
                    copySuffix: maytest === variants.OPOP || maytest === variants.CONTACT3 ? maytest : null
                }
            });
        }
    }, {
        key: '_getTradeMessage',
        value: function _getTradeMessage() {
            var tradeSalesRep = this.props.tradeMessage.tradeSalesRep;

            if (enabler.isEnabled('trade_welcome_message') && tradeSalesRep) {
                return React.createElement(TradeWelcomeMessage, _extends({}, this.props.tradeMessage, { tradeTour: this.props.tradeTour }));
            }
            return null;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.userId !== this.props.userId) {
                this.props.relay.setVariables({
                    userId: getUserId(document.cookie, MASQUERADE_BUYER),
                    hasUserId: !!getUserId(document.cookie, MASQUERADE_BUYER)
                });
            }
        }
    }, {
        key: 'handleCtaClick',
        value: function handleCtaClick(_ref) {
            var action = _ref.action;

            switch (action) {
                case 'openShippingQuoteModal':
                    this.setState({ isRequestShippingQuoteModalOpen: true });
                    break;

                case 'openConditionReportModal':
                    this.setState({ isConditionReportModalOpen: true });
                    break;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var hasUserId = this.props.relay.variables.hasUserId;
            var _state = this.state,
                contactDealerCTATestRunning = _state.contactDealerCTATestRunning,
                isRequestShippingQuoteModalOpen = _state.isRequestShippingQuoteModalOpen,
                isConditionReportModalOpen = _state.isConditionReportModalOpen;

            var props = this.props;
            var canonicalUrl = props.canonicalUrl,
                contactDealerErrors = props.contactDealerErrors,
                context = props.context,
                copy = props.copy,
                currency = props.currency,
                creatorContent = props.creatorContent,
                dealerData = props.dealerData,
                dealerPk = props.dealerPk,
                dealerRelatedItems = props.dealerRelatedItems,
                favoriteDealer = props.favoriteDealer,
                favoriteDealerCta = props.favoriteDealerCta,
                goodRelationsMeta = props.goodRelationsMeta,
                hasTrackingFired = props.hasTrackingFired,
                heroCarouselIndex = props.heroCarouselIndex,
                heroChangingSize = props.heroChangingSize,
                heroExpanded = props.heroExpanded,
                isAnyTourOpen = props.isAnyTourOpen,
                isDealerMessageSending = props.isDealerMessageSending,
                isDealerMessageSent = props.isDealerMessageSent,
                isNegotiablePrice = props.isNegotiablePrice,
                isPrintNP = props.isPrintNP,
                isPrintPage = props.isPrintPage,
                isReturnable = props.isReturnable,
                backboneItem = props.item,
                itemCategories = props.itemCategories,
                itemDescription = props.itemDescription,
                itemIsSold = props.itemIsSold,
                itemIsUnlisted = props.itemIsUnlisted,
                customizationNote = props.customizationNote,
                itemId = props.itemId,
                itemImages = props.itemImages,
                itemPk = props.itemPk,
                itemTitle = props.itemTitle,
                itemVertical = props.itemVertical,
                offer = props.offer,
                offerAmount = props.offerAmount,
                optimizelyVariant = props.optimizelyVariant,
                pageData = props.pageData,
                pinterest = props.pinterest,
                price = props.price,
                recommendedCarousel = props.recommendedCarousel,
                internalLinks = props.internalLinks,
                retailPrice = props.retailPrice,
                siteProtocol = props.siteProtocol,
                socialData = props.socialData,
                stickyAlertTopHeight = props.stickyAlertTopHeight,
                title = props.title,
                topRecommendations = props.topRecommendations,
                trackingVpvParams = props.trackingVpvParams,
                backboneUser = props.user,
                _props$viewer = props.viewer,
                viewer = _props$viewer === undefined ? null : _props$viewer,
                userDisplayName = props.userDisplayName,
                userMessage = props.userMessage,
                recommendedPhotos = props.recommendedPhotos,
                relay = props.relay,
                maytest = props.maytest,
                sellerResponseTime = props.sellerResponseTime;

            var _ref2 = viewer || {},
                availableDeliveryOptions = _ref2.availableDeliveryOptions,
                _ref2$user = _ref2.user,
                user = _ref2$user === undefined ? null : _ref2$user,
                _ref2$item = _ref2.item,
                item = _ref2$item === undefined ? null : _ref2$item;

            var quotes = getShipmentPrequotes(viewer || {});
            var offsetTop = STICKY_OFFSET_TOP + stickyAlertTopHeight;
            var creatorNoPrint = creatorContent && !isPrintPage;
            var itemData = {
                title: title,
                image: (itemImages[0] || {}).small,
                seller: dealerData.company || '',
                price: retailPrice
            };
            var userId = props.userId || get(relay, 'variables.userId');

            var rowFlexPrintClass = null;
            var rowFlexTransition = null;
            var shippingEl = void 0;
            // Sidebar needs to have higher z-index then `none` (new-pdp/pdp-layout.scss) that tour tooltips
            // would be above the content so adding the class `is-high` when any tour is open
            var pdpSidebarContainerClass = classnames('pdp-sidebar-container', {
                'is-high': isAnyTourOpen
            });

            if (isPrintPage) {
                rowFlexTransition = "pdp-print-row";
                rowFlexPrintClass = "pdp-print-line";
            } else {
                rowFlexTransition = "rowFlexTransition pdp-print-row";
                rowFlexPrintClass = "pdp-line";
            }

            if (isPrintNP) {
                shippingEl = null;
            } else if (viewer) {
                shippingEl = React.createElement(
                    'div',
                    { className: 'pdp-shipping-container flex-column colXs12 colXl4' },
                    React.createElement(ShippingAndReturnsColumn, {
                        hasUserId: hasUserId,
                        availableDeliveryOptions: availableDeliveryOptions || null,
                        context: context,
                        item: item,
                        quotes: quotes,
                        viewer: viewer,
                        relay: relay,
                        itemIsSold: itemIsSold,
                        itemIsUnlisted: itemIsUnlisted,
                        itemId: itemId,
                        userId: userId,
                        dealerPk: dealerPk,
                        user: user,
                        favoriteDealer: favoriteDealer,
                        favoriteDealerCta: favoriteDealerCta,
                        dealerData: dealerData
                    })
                );
            }

            var sidebarProps = {
                context: context,
                dealerData: dealerData,
                dealerPk: dealerPk,
                favoriteDealer: favoriteDealer,
                favoriteDealerCta: favoriteDealerCta,
                itemId: itemId,
                itemPk: itemPk,
                relay: relay,
                relayItem: item,
                viewer: viewer || null,
                user: user,
                userId: userId,
                hasUserId: hasUserId,
                quotes: quotes,
                availableDeliveryOptions: availableDeliveryOptions || null,
                showReducedFrom: pageData.isSaturdaySale,
                contactDealerClick: this._contactDealer,
                stfOnClick: this._stf
            };

            if (maytest === variants.OPOP || maytest === variants.CONTACT2 || maytest === variants.CONTACT3) {
                dealerData.type = 'seller';
            }

            var contactDealerBodyProps = {
                backboneItem: backboneItem,
                backboneUser: backboneUser,
                canonicalUrl: canonicalUrl,
                contactDealerCTATestRunning: contactDealerCTATestRunning,
                copy: copy,
                currency: currency,
                dealerData: dealerData,
                errors: contactDealerErrors,
                favoriteDealer: favoriteDealer,
                favoriteDealerCta: favoriteDealerCta,
                handleContactDealerCtaClick: this.handleCtaClick,
                hasTrackingFired: hasTrackingFired,
                hasUserId: hasUserId,
                isDealerMessageSending: isDealerMessageSending,
                isDealerMessageSent: isDealerMessageSent,
                isNegotiable: isNegotiablePrice,
                isPreQuote: !!quotes.shipmentQuotes.length,
                isReturnable: isReturnable,
                item: item,
                itemId: itemId,
                itemPk: itemPk,
                offer: offer,
                offerAmount: offerAmount,
                optimizelyVariant: optimizelyVariant,
                price: price,
                title: title,
                trackingVpvParams: trackingVpvParams,
                user: user,
                userDisplayName: userDisplayName,
                userId: userId,
                userMessage: userMessage,
                vertical: itemVertical,
                viewer: viewer,
                maytest: maytest,
                sellerResponseTime: sellerResponseTime
            };

            var modalHeart = React.createElement(PdpFavoriteItem, { showCircle: true, userId: userId, itemId: itemId, viewer: viewer });

            return React.createElement(
                'div',
                { className: 'pdp-layout boxSizingWrapper' },
                React.createElement('div', { className: 'js-notification-container-middle' }),
                React.createElement(RedirectedMessage, null),
                topRecommendations && React.createElement(Similar, {
                    items: topRecommendations,
                    itemIsUnavailable: itemIsSold || itemIsUnlisted,
                    copy: copy,
                    title: itemTitle
                }),
                React.createElement(
                    MediaQuery,
                    { query: queries.xl },
                    React.createElement(
                        'div',
                        { className: 'pdp-breadcrumbs-container' },
                        React.createElement(Breadcrumbs, { categories: itemCategories })
                    )
                ),
                React.createElement(
                    'div',
                    { className: rowFlexTransition, ref: 'mainContent' },
                    React.createElement('meta', { content: goodRelationsMeta }),
                    React.createElement(
                        'div',
                        {
                            className: 'pdp-carousel-container colXs12 colLg7 colXl8',
                            ref: function ref(carousel) {
                                _this3._carousel = carousel;
                            }
                        },
                        React.createElement(
                            'div',
                            { className: 'pdp-carousel-favorite-item-container' },
                            React.createElement(
                                'div',
                                { className: 'pdp-carousel-favorite-item' },
                                React.createElement(PdpFavoriteItem, {
                                    userId: userId,
                                    itemId: itemId,
                                    viewer: viewer
                                }),
                                React.createElement(PdpFolderItem, {
                                    userId: userId,
                                    itemId: itemId,
                                    viewer: viewer
                                })
                            )
                        ),
                        React.createElement(Carousel, {
                            context: context,
                            title: itemTitle,
                            images: itemImages,
                            index: heroCarouselIndex,
                            itemId: itemId,
                            item: backboneItem,
                            siteProtocol: siteProtocol,
                            socialData: socialData,
                            vertical: itemVertical,
                            itemPk: itemPk,
                            heartComponent: modalHeart,
                            pinterest: pinterest,
                            stfOnClick: this._stf,
                            isPrintPage: isPrintPage
                        }),
                        React.createElement(PdpSocialIcons, {
                            context: context,
                            id: itemId,
                            vertical: itemVertical,
                            socialData: socialData,
                            itemPk: itemPk,
                            pinterest: pinterest,
                            pinterestConnectAccounts: true,
                            onPinterestPin: this._onPinterestPin,
                            stfOnClick: this._stf,
                            index: heroCarouselIndex
                        })
                    ),
                    React.createElement(
                        MediaQuery,
                        { query: [queries.lg, queries.xl], exclude: true },
                        React.createElement(
                            'div',
                            { className: pdpSidebarContainerClass + ' colXs12' },
                            React.createElement(Sidebar, _extends({}, sidebarProps, {
                                pagePosition: 'exclude-desktop'
                            }))
                        )
                    ),
                    React.createElement(
                        MediaQuery,
                        { query: [queries.lg, queries.xl] },
                        maytest && maytest !== variants.OPOP && maytest !== variants.CONTROL ? React.createElement(
                            'div',
                            { className: pdpSidebarContainerClass + ' colXs5 colXl4' },
                            React.createElement(Sidebar, _extends({}, sidebarProps, {
                                contactDealerBodyProps: contactDealerBodyProps
                            }))
                        ) : React.createElement(
                            Sticky,
                            {
                                className: pdpSidebarContainerClass + ' colXs5 colXl4',
                                offsetTop: offsetTop
                                // This prop lets the sticky sidebar know that it needs to adjust position in response
                                // to some change on the page elsewhere. Specifically it`s for adjusting the sidebar
                                // when the item description is collapsed and the page suddenly shrinks.
                                , resetPosition: !heroExpanded && heroChangingSize,
                                calculateWidth: this._calculateStickyWidth,
                                calculateLeft: this._calculateStickyLeft
                            },
                            React.createElement(Sidebar, _extends({}, sidebarProps, {
                                pagePosition: 'sticky'
                            }))
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'pdp-print-sidebar-wrapper' },
                        React.createElement(
                            MediaQuery,
                            { query: [queries.lg, queries.xl] },
                            React.createElement(Sidebar, _extends({}, sidebarProps, {
                                pagePosition: 'print'
                            }))
                        ),
                        React.createElement(
                            'div',
                            { className: 'pdp-sidebar-print pdp-dealer-print-container flex-column' },
                            React.createElement(ContactDealerBody, _extends({}, contactDealerBodyProps, {
                                isPrintDealer: true,
                                isPrintPage: isPrintPage
                            }))
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'pdp-hero-container colXs12 colLg7 colXl8' },
                        isPrintPage ? null : React.createElement(ExpandableContent, {
                            title: copy.heroTitles.about,
                            description: itemDescription,
                            expanded: heroExpanded,
                            isPrintHero: false
                        }),
                        customizationNote ? React.createElement(ExpandableContent, {
                            title: copy.heroTitles.customizationOptions,
                            description: customizationNote,
                            tracking: false
                        }) : null
                    ),
                    React.createElement(
                        'div',
                        { className: 'pdp-details-shipping-container colXs12 colLg7 colXl8' },
                        React.createElement(
                            'div',
                            { className: 'rowFlexTransition ' + rowFlexPrintClass },
                            React.createElement(
                                'div',
                                { className: 'pdp-hero-container colXs12 colLg12 colXl12 print' },
                                React.createElement(ExpandableContent, {
                                    title: copy.heroTitles.about,
                                    description: itemDescription,
                                    expanded: heroExpanded,
                                    isPrintHero: true
                                }),
                                customizationNote ? React.createElement(ExpandableContent, {
                                    title: copy.heroTitles.customizationOptions,
                                    description: customizationNote,
                                    tracking: false,
                                    isPrintHero: true
                                }) : null
                            ),
                            React.createElement(
                                'div',
                                { className: 'pdp-details-container flex-columm colXs12 colXl8' },
                                React.createElement(Details, { context: context })
                            ),
                            shippingEl,
                            dealerData.maker && dealerData.maker.description ? React.createElement(
                                'div',
                                { className: 'pdp-creator-container colXs12 colLg12 colXl12 print' },
                                React.createElement(ExpandableContent, {
                                    title: copy.heroTitles.aboutTheMaker,
                                    description: dealerData.maker.description
                                })
                            ) : null
                        )
                    ),
                    maytest !== variants.OPOP && dealerData.maker && dealerData.maker.description ? React.createElement(
                        'div',
                        { className: 'pdp-creator-container colXs12 colLg7 colXl8' },
                        React.createElement(
                            'h2',
                            { className: 'pdp-hero-about header-primary-large pdp-secondary-header' },
                            copy.heroTitles.aboutTheMaker
                        ),
                        React.createElement(ProfileLink, {
                            caption: dealerData.company,
                            url: dealerData.uri,
                            label: copy.linkText.viewProfileLinktext,
                            image: dealerData.maker.headshot
                        }),
                        React.createElement(ExpandableContent, {
                            description: dealerData.maker.description,
                            tracking: false
                        })
                    ) : null,
                    maytest !== variants.OPOP && creatorNoPrint ? React.createElement(
                        'div',
                        { className: 'pdp-creator-container colXs12 colLg7 colXl8' },
                        React.createElement(ExpandableContent, {
                            description: creatorContent.description,
                            title: copy.heroTitles.about,
                            name: creatorContent.name,
                            image: creatorContent.image,
                            collapseHeight: 73,
                            tnType: 'creator',
                            tracking: false
                        })
                    ) : null,
                    maytest === variants.CONTACT2 && React.createElement(
                        'div',
                        { className: 'pdp-dealer-container colXs12 colLg7 colXl8 has-maytest-contact2' },
                        React.createElement(ContactDealerBody, contactDealerBodyProps)
                    )
                ),
                maytest !== variants.CONTACT2 && React.createElement(
                    'div',
                    { className: 'pdp-dealer-container' },
                    React.createElement(ContactDealerBody, contactDealerBodyProps)
                ),
                React.createElement(
                    'div',
                    { className: 'pdp-grid-container' },
                    dealerRelatedItems && dealerRelatedItems.items.length ? React.createElement(GridDealer, {
                        data: dealerRelatedItems.items,
                        dealerData: dealerData,
                        quickView: dealerRelatedItems.quickView,
                        copy: copy
                    }) : null
                ),
                React.createElement(
                    'div',
                    { className: 'pdp-grid-container' },
                    recommendedCarousel && recommendedCarousel.items.length ? React.createElement(GridSuggestion, {
                        data: recommendedCarousel.items,
                        quickView: recommendedCarousel.quickView,
                        copy: copy
                    }) : null
                ),
                React.createElement(
                    'div',
                    { className: 'pdp-grid-container' },
                    recommendedPhotos.length ? React.createElement(GridPhoto, {
                        photos: recommendedPhotos,
                        context: this.context
                    }) : null
                ),
                internalLinks && React.createElement(
                    'div',
                    { className: 'pdp-seo-links-container' },
                    React.createElement(SeoLinks, { links: internalLinks })
                ),
                React.createElement(ConnectAccountsModal, _extends({
                    item: itemData,
                    currency: currency,
                    copy: pinterest.copy.connectAccounts,
                    tracking: pinterest.copy.tracking
                }, pinterest.connectAccountsModal)),
                React.createElement(ConnectBoardModal, _extends({
                    connectedBoard: pinterest.connectedBoard,
                    boards: pinterest.boards,
                    copy: pinterest.copy.connectBoards,
                    tracking: pinterest.copy.tracking
                }, pinterest.connectBoardModal)),
                this._getTradeMessage(),
                contactDealerCTATestRunning && React.createElement(RequestShippingModal, {
                    environment: getEnvironment(),
                    closeOnEsc: true,
                    closeOnOutsideClick: true,
                    closeShippingModal: function closeShippingModal() {
                        return _this3.setState({ isRequestShippingQuoteModalOpen: false });
                    },
                    isOpened: isRequestShippingQuoteModalOpen,
                    itemId: itemId,
                    userId: userId,
                    user: user,
                    dealerPk: get(item, 'seller.serviceId', ''),
                    viewer: viewer,
                    dealerData: get(item, 'seller.sellerProfile'),
                    modalKey: 'details-shipping',
                    conversation: null,
                    item: null
                }),
                contactDealerCTATestRunning && React.createElement(ConditionReportModal, {
                    user: user,
                    item: item,
                    isOpened: isConditionReportModalOpen,
                    closeModal: function closeModal() {
                        return _this3.setState({ isConditionReportModalOpen: false });
                    }
                })
            );
        }
    }]);

    return PdpLayout;
}(ContextComponent);

PdpLayout.propTypes = {
    ctas: PropTypes.object.isRequired,
    priceDisplays: PropTypes.object.isRequired,
    detailsTitles: PropTypes.object.isRequired,
    details: PropTypes.object.isRequired,
    detailsConfig: PropTypes.array.isRequired,
    shippingMessage: PropTypes.string,
    currency: PropTypes.string,
    currencyLoaded: PropTypes.bool,
    heroCarouselIndex: PropTypes.number.isRequired,
    heroExpanded: PropTypes.bool.isRequired,
    heroChangingSize: PropTypes.bool,
    hold: PropTypes.array,
    isAnyTourOpen: PropTypes.bool,
    item: PropTypes.object.isRequired,
    itemId: PropTypes.string.isRequired,
    itemCategories: PropTypes.object.isRequired,
    itemCreationDate: PropTypes.string,
    itemDescription: PropTypes.string.isRequired,
    itemHidePrice: PropTypes.bool.isRequired,
    itemImages: PropTypes.array.isRequired,
    itemPrice: PropTypes.number,
    itemInitialPrice: PropTypes.number,
    itemIsArt: PropTypes.bool.isRequired,
    itemIsSold: PropTypes.bool.isRequired,
    itemIsUnlisted: PropTypes.bool.isRequired,
    itemTitle: PropTypes.string.isRequired,
    itemVertical: PropTypes.string.isRequired,
    itemPk: PropTypes.string.isRequired,
    isSoldIndividually: PropTypes.bool.isRequired,
    itemCanMakePurchase: PropTypes.bool.isRequired,
    creatorData: PropTypes.object.isRequired,
    creatorContent: PropTypes.object,
    dealerData: PropTypes.object.isRequired,
    dealerRelatedItems: PropTypes.object.isRequired,
    canonicalUrl: PropTypes.string.isRequired,
    dealerPk: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    askingPrice: PropTypes.number,
    itemIsOnHold: PropTypes.bool.isRequired,
    internalLinks: PropTypes.array,
    siteProtocol: PropTypes.string.isRequired,
    socialData: PropTypes.object.isRequired,
    returnPolicy: PropTypes.object.isRequired,
    returnMessage: PropTypes.string.isRequired,
    goodRelationsMeta: PropTypes.string,
    copy: PropTypes.object.isRequired,
    stickyAlertTopHeight: PropTypes.number.isRequired,
    favoriteDealer: PropTypes.object.isRequired,
    pinterest: PropTypes.object.isRequired,
    isPrintPage: PropTypes.bool,
    pageData: PropTypes.shape({
        isSaturdaySale: PropTypes.bool
    }).isRequired,
    userId: PropTypes.string,
    recommendedPhotos: PropTypes.array,
    maytest: PropTypes.string,
    sellerResponseTime: PropTypes.string
};

module.exports = Relay.createContainer(PdpLayout, {
    initialVariables: {
        itemId: SV.get('data.pk'),
        userId: null,
        useIPAddress: true,
        hasUserId: false,
        first: 10,
        regionType: null
    },
    prepareVariables: function prepareVariables(vars) {
        return Object.assign({}, vars, {
            userId: getUserId(document.cookie, MASQUERADE_BUYER),
            hasUserId: !!getUserId(document.cookie, MASQUERADE_BUYER)
        });
    },
    fragments: {
        viewer: function viewer(_ref3) {
            var userId = _ref3.userId,
                hasUserId = _ref3.hasUserId,
                itemId = _ref3.itemId;
            return function (RQL_0, RQL_1, RQL_2, RQL_3, RQL_4, RQL_5, RQL_6, RQL_7, RQL_8, RQL_9, RQL_10, RQL_11, RQL_12, RQL_13, RQL_14) {
                return {
                    children: [].concat.apply([], [{
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'userId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'userId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'isVerifiedTrade',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_6), Relay.QL.__frag(RQL_7), Relay.QL.__frag(RQL_8), Relay.QL.__frag(RQL_9), Relay.QL.__frag(RQL_10)]),
                        directives: [{
                            kind: 'Directive',
                            name: 'include',
                            args: [{
                                name: 'if',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'hasUserId'
                                }
                            }]
                        }],
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }],
                        children: [].concat.apply([], [{
                            fieldName: 'isCustomizable',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, Relay.QL.__frag(RQL_11), Relay.QL.__frag(RQL_12), Relay.QL.__frag(RQL_13), Relay.QL.__frag(RQL_14)]),
                        fieldName: 'item',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Item'
                    }, {
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {
                                type: 'SearchView'
                            },
                            name: 'searchView',
                            value: {
                                kind: 'CallValue',
                                callValue: 'PDP'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'first',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'first'
                            }
                        }],
                        children: [{
                            children: [{
                                children: [{
                                    children: [{
                                        fieldName: 'numberOfUnits',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Int'
                                    }],
                                    fieldName: 'handlingTime',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'Period'
                                }, {
                                    fieldName: 'handlingTimeDisplay',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    children: [{
                                        fieldName: 'currency',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Currency'
                                    }, {
                                        fieldName: 'amount',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Float'
                                    }, {
                                        children: [{
                                            fieldName: 'currency',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Currency'
                                        }, {
                                            fieldName: 'amount',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Float'
                                        }],
                                        fieldName: 'convertedAmountList',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            isPlural: true
                                        },
                                        type: 'ConvertedAmountList'
                                    }],
                                    fieldName: 'totalAmount',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'FinancialAmount'
                                }, {
                                    fieldName: 'is1stdibsBilledQuote',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'is1stdibsWhiteGloveQuote',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'serviceId',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'ID'
                                }, {
                                    children: [{
                                        fieldName: 'serviceMethodType',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'serviceType',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'displayName',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        children: [{
                                            fieldName: 'apiType',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'code',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'regionName',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'regionType',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'RegionType'
                                        }, {
                                            children: [{
                                                children: [{
                                                    fieldName: 'name',
                                                    kind: 'Field',
                                                    metadata: {},
                                                    type: 'String'
                                                }],
                                                fieldName: 'type',
                                                kind: 'Field',
                                                metadata: {
                                                    canHaveSubselections: true
                                                },
                                                type: 'RegionBoundaryType'
                                            }],
                                            fieldName: 'regionBoundary',
                                            kind: 'Field',
                                            metadata: {
                                                canHaveSubselections: true
                                            },
                                            type: 'RegionBoundary'
                                        }, {
                                            fieldName: 'id',
                                            kind: 'Field',
                                            metadata: {
                                                isGenerated: true,
                                                isRequisite: true
                                            },
                                            type: 'ID'
                                        }],
                                        fieldName: 'region',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            inferredRootCallName: 'node',
                                            inferredPrimaryKey: 'id'
                                        },
                                        type: 'Region'
                                    }, {
                                        children: [{
                                            fieldName: 'numberOfUnits',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Int'
                                        }],
                                        fieldName: 'windowMin',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true
                                        },
                                        type: 'Period'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'serviceMethod',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'ShipmentServiceMethod'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'node',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isRequisite: true
                                },
                                type: 'ShipmentQuote'
                            }, {
                                fieldName: 'cursor',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'String'
                            }],
                            fieldName: 'edges',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'ShipmentQuotesEdge'
                        }, {
                            children: [{
                                fieldName: 'hasNextPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }, {
                                fieldName: 'hasPreviousPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }],
                            fieldName: 'pageInfo',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'PageInfo'
                        }],
                        fieldName: 'shipmentQuotes',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'ShipmentQuotesConnection'
                    }, {
                        alias: 'localDeliveryOptions',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {
                                type: 'RegionView'
                            },
                            name: 'regionView',
                            value: {
                                kind: 'CallValue',
                                callValue: 'LOCAL'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'first',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'first'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {
                                type: 'AddressResolutionType!'
                            },
                            name: 'addressResolutionType',
                            value: {
                                kind: 'CallValue',
                                callValue: 'IP'
                            }
                        }],
                        children: [{
                            children: [{
                                children: [{
                                    fieldName: 'handlingTimeDisplay',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    children: [{
                                        fieldName: 'currency',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Currency'
                                    }, {
                                        fieldName: 'amount',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Float'
                                    }, {
                                        children: [{
                                            fieldName: 'currency',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Currency'
                                        }, {
                                            fieldName: 'amount',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Float'
                                        }],
                                        fieldName: 'convertedAmountList',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            isPlural: true
                                        },
                                        type: 'ConvertedAmountList'
                                    }],
                                    fieldName: 'totalAmount',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'FinancialAmount'
                                }, {
                                    fieldName: 'is1stdibsWhiteGloveQuote',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    children: [{
                                        fieldName: 'serviceMethodType',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'displayName',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        children: [{
                                            fieldName: 'apiType',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'code',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'regionName',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'regionType',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'RegionType'
                                        }, {
                                            fieldName: 'id',
                                            kind: 'Field',
                                            metadata: {
                                                isGenerated: true,
                                                isRequisite: true
                                            },
                                            type: 'ID'
                                        }],
                                        fieldName: 'region',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            inferredRootCallName: 'node',
                                            inferredPrimaryKey: 'id'
                                        },
                                        type: 'Region'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'serviceMethod',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'ShipmentServiceMethod'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'node',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isRequisite: true
                                },
                                type: 'ShipmentQuote'
                            }, {
                                fieldName: 'cursor',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'String'
                            }],
                            fieldName: 'edges',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'ShipmentQuoteEdge'
                        }, {
                            children: [{
                                fieldName: 'hasNextPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }, {
                                fieldName: 'hasPreviousPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }],
                            fieldName: 'pageInfo',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'PageInfo'
                        }],
                        fieldName: 'availableDeliveryOptions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'ShipmentQuoteConnection'
                    }, {
                        alias: 'domesticDeliveryOptions',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'itemId',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'itemId'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {
                                type: 'RegionView'
                            },
                            name: 'regionView',
                            value: {
                                kind: 'CallValue',
                                callValue: 'DOMESTIC'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {},
                            name: 'first',
                            value: {
                                kind: 'CallVariable',
                                callVariableName: 'first'
                            }
                        }, {
                            kind: 'Call',
                            metadata: {
                                type: 'AddressResolutionType!'
                            },
                            name: 'addressResolutionType',
                            value: {
                                kind: 'CallValue',
                                callValue: 'IP'
                            }
                        }],
                        children: [{
                            children: [{
                                children: [{
                                    fieldName: 'handlingTimeDisplay',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    children: [{
                                        fieldName: 'currency',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Currency'
                                    }, {
                                        fieldName: 'amount',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Float'
                                    }, {
                                        children: [{
                                            fieldName: 'currency',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Currency'
                                        }, {
                                            fieldName: 'amount',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Float'
                                        }],
                                        fieldName: 'convertedAmountList',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            isPlural: true
                                        },
                                        type: 'ConvertedAmountList'
                                    }],
                                    fieldName: 'totalAmount',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'FinancialAmount'
                                }, {
                                    fieldName: 'is1stdibsWhiteGloveQuote',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    children: [{
                                        fieldName: 'serviceMethodType',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'displayName',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        children: [{
                                            fieldName: 'apiType',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'code',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'regionName',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'regionType',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'RegionType'
                                        }, {
                                            fieldName: 'id',
                                            kind: 'Field',
                                            metadata: {
                                                isGenerated: true,
                                                isRequisite: true
                                            },
                                            type: 'ID'
                                        }],
                                        fieldName: 'region',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            inferredRootCallName: 'node',
                                            inferredPrimaryKey: 'id'
                                        },
                                        type: 'Region'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'serviceMethod',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'ShipmentServiceMethod'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'node',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isRequisite: true
                                },
                                type: 'ShipmentQuote'
                            }, {
                                fieldName: 'cursor',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'String'
                            }],
                            fieldName: 'edges',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'ShipmentQuoteEdge'
                        }, {
                            children: [{
                                fieldName: 'hasNextPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }, {
                                fieldName: 'hasPreviousPage',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'Boolean'
                            }],
                            fieldName: 'pageInfo',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'PageInfo'
                        }],
                        fieldName: 'availableDeliveryOptions',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            isConnection: true
                        },
                        type: 'ShipmentQuoteConnection'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1), Relay.QL.__frag(RQL_2), Relay.QL.__frag(RQL_3), Relay.QL.__frag(RQL_4), Relay.QL.__frag(RQL_5)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'PdpLayout_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(PdpFavoriteItem.getFragment('viewer', { itemId: itemId, userId: userId }), PdpFolderItem.getFragment('viewer', { itemId: itemId, userId: userId }), RequestShippingModal.getFragment('viewer', { itemId: itemId, userId: userId }), ShippingAndReturnsColumn.getFragment('viewer', { hasUserId: hasUserId, itemId: itemId, userId: userId }).if(hasUserId), Sidebar.getFragment('viewer', { itemId: itemId, userId: userId, hasUserId: hasUserId }), ContactDealerBody.getFragment('viewer', { userId: userId, itemId: itemId, hasUserId: hasUserId }), RequestShippingModal.getFragment('user', { itemId: itemId, userId: userId }), ShippingAndReturnsColumn.getFragment('user', { hasUserId: hasUserId, itemId: itemId, userId: userId }), Sidebar.getFragment('user', { itemId: itemId, userId: userId, hasUserId: hasUserId }), ContactDealerBody.getFragment('user', { userId: userId, itemId: itemId, hasUserId: hasUserId }), ConditionReportModal.getFragment('user', { userId: userId }), ShippingAndReturnsColumn.getFragment('item', { hasUserId: hasUserId, itemId: itemId, userId: userId }), Sidebar.getFragment('relayItem', { itemId: itemId, userId: userId, hasUserId: hasUserId }), ContactDealerBody.getFragment('item', { userId: userId, itemId: itemId, hasUserId: hasUserId }), ConditionReportModal.getFragment('item', { userId: userId }));
        }
    }
});

/***/ }),
/* 3682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ArrowIcon = __webpack_require__(351);

var ProfileLink = function ProfileLink(_ref) {
    var image = _ref.image,
        caption = _ref.caption,
        url = _ref.url,
        label = _ref.label;
    return React.createElement(
        'div',
        { className: 'pdp-hero-link' },
        image ? React.createElement('img', { className: 'pdp-hero-link-image', src: image, alt: caption }) : null,
        React.createElement(
            'div',
            { className: 'pdp-hero-link-content' },
            caption ? React.createElement(
                'div',
                { className: 'pdp-hero-link-caption' },
                caption
            ) : null,
            React.createElement(
                'a',
                { href: url },
                label,
                ' ',
                React.createElement(ArrowIcon, { className: 'pdp-hero-link-arrow' })
            )
        )
    );
};

ProfileLink.propTypes = {
    image: PropTypes.string,
    caption: PropTypes.string,
    url: PropTypes.string.isRequired,
    label: PropTypes.string
};

ProfileLink.defaultProps = {
    label: 'View Profile'
};

module.exports = ProfileLink;

/***/ }),
/* 3683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * Created by nerijussavickas on 12/30/16.
 */



var $ = __webpack_require__(5);
var React = __webpack_require__(1);
var css = __webpack_require__(3057);

var SOLD_ITEM_COOKIE = 'soldItemTitle';
var soldItemTitle = void 0;

function RedirectedMessage() {
    if (!soldItemTitle && $.cookie(SOLD_ITEM_COOKIE)) {
        soldItemTitle = $.cookie(SOLD_ITEM_COOKIE);
        $.removeCookie('soldItemTitle', { path: '/' });
    }

    if (soldItemTitle) {
        return React.createElement(
            'div',
            { className: css.message },
            soldItemTitle,
            ' ',
            React.createElement('br', null),
            'is no longer available, we think you might like this item'
        );
    }

    return null;
}

module.exports = RedirectedMessage;

/***/ }),
/* 3684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var omit = __webpack_require__(95);
var connectToStores = __webpack_require__(286);
var FavoriteModel = __webpack_require__(355);
var TYPE_SEARCH = FavoriteModel.TYPE_SEARCH;

var ContextComponent = __webpack_require__(61);
var SanitizeHtml = __webpack_require__(296);
var FavoritePageStore = __webpack_require__(475);
var FavoriteButton = __webpack_require__(560);
var StickyAlertMiddle = __webpack_require__(881);

var style = __webpack_require__(3058);

var SaveSearch = function (_ContextComponent) {
    _inherits(SaveSearch, _ContextComponent);

    function SaveSearch(props) {
        _classCallCheck(this, SaveSearch);

        var _this = _possibleConstructorReturn(this, (SaveSearch.__proto__ || Object.getPrototypeOf(SaveSearch)).call(this, props));

        _this._onClick = _this._onClick.bind(_this);
        _this._closeSuccessMessage = _this._closeSuccessMessage.bind(_this);

        _this.state = {
            successMessageIsOpen: false,
            buttonClicked: false
        };
        return _this;
    }

    _createClass(SaveSearch, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Should show success message components button was clicked, favorites were
            // fetched already and favorite was saved
            if (this.state.buttonClicked && this.props.isFetched && !this.props.isSaved && nextProps.isSaved) {
                this.setState({
                    successMessageIsOpen: true,
                    buttonClicked: false
                });

                // Close success message after 5 seconds
                setTimeout(this._closeSuccessMessage, 5000);
            }
        }
    }, {
        key: '_onClick',
        value: function _onClick() {
            this.setState({ buttonClicked: true });
        }
    }, {
        key: '_closeSuccessMessage',
        value: function _closeSuccessMessage() {
            this.setState({ successMessageIsOpen: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var successMessageIsOpen = this.state.successMessageIsOpen;

            var allowedTags = ['div', 'a', 'span', 'br', 'p'];
            var allowedAttributes = { span: ['class'] };
            var buttonClass = style.button + ' button-primary button-large';
            var buttonData = omit(this.props, 'description', 'successMessage');

            return React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: style.contentWrapper },
                    React.createElement(SanitizeHtml, {
                        allowedTags: allowedTags,
                        allowedAttributes: allowedAttributes,
                        content: this.props.description
                    })
                ),
                React.createElement(FavoriteButton, _extends({ className: buttonClass, onClick: this._onClick }, buttonData)),
                React.createElement(
                    StickyAlertMiddle,
                    { isOpen: successMessageIsOpen, onClose: this._closeSuccessMessage },
                    React.createElement(SanitizeHtml, { allowedTags: allowedTags, content: this.props.successMessage })
                )
            );
        }
    }]);

    return SaveSearch;
}(ContextComponent);

SaveSearch.propTypes = {
    id: PropTypes.number,
    favoriteData: PropTypes.object.isRequired,
    cta: PropTypes.object.isRequired,
    tracking: PropTypes.object,
    successMessage: PropTypes.node,

    isSaved: PropTypes.bool,
    isFetched: PropTypes.bool,
    description: PropTypes.string
};

module.exports = connectToStores(SaveSearch, [FavoritePageStore], function (context) {
    var store = context.getStore(FavoritePageStore);
    return {
        id: store.getFavoriteId(TYPE_SEARCH),
        isSaved: store.isSaved(TYPE_SEARCH),
        isFetched: store.isFetched(TYPE_SEARCH)
    };
});

/***/ }),
/* 3685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var _require = __webpack_require__(379),
    trackSeoLinkClick = _require.trackSeoLinkClick;

var hasContextTypes = __webpack_require__(782);

var SeoLink = React.createClass(hasContextTypes({
    propTypes: {
        link: PropTypes.object.isRequired
    },

    _handleClick: function _handleClick() {
        this.context.executeAction(trackSeoLinkClick, { label: '' });
    },
    render: function render() {
        var link = this.props.link;

        return React.createElement(
            'li',
            { className: 'seo-link-wrapper colXs12 colMd4' },
            React.createElement(
                'a',
                { className: 'seo-link', href: link.url, onClick: this._handleClick },
                link.anchorText
            )
        );
    }
}));

module.exports = SeoLink;

/***/ }),
/* 3686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var SeoLink = __webpack_require__(3685);

function getSeoLinks(links) {
    return links.map(function (link, i) {
        return React.createElement(SeoLink, { key: i, link: link });
    });
}

var SeoLinks = React.createClass({
    displayName: 'SeoLinks',

    propTypes: {
        links: PropTypes.array.isRequired
    },

    render: function render() {
        return React.createElement(
            'div',
            { className: 'seo-links' },
            React.createElement(
                'div',
                { className: 'header-primary-large seo-links-title' },
                'more ways to browse'
            ),
            React.createElement(
                'ul',
                { className: 'seo-links-inner rowFlex' },
                getSeoLinks(this.props.links)
            )
        );
    }
});

module.exports = SeoLinks;

/***/ }),
/* 3687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _buyerAssurance = __webpack_require__(577);

var _buyerAssurance2 = _interopRequireDefault(_buyerAssurance);

var _Benefits = __webpack_require__(3059);

var _Benefits2 = _interopRequireDefault(_Benefits);

var _pdp = __webpack_require__(1112);

var _pdp2 = _interopRequireDefault(_pdp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Benefit(_ref) {
    var item = _ref.item;

    return _react2.default.createElement(
        'div',
        { className: _Benefits2.default.benefit },
        _react2.default.createElement(
            'div',
            { className: _Benefits2.default.icon },
            _react2.default.createElement(_buyerAssurance2.default, null)
        ),
        _react2.default.createElement(
            'div',
            { className: _Benefits2.default.text },
            item.title
        )
    );
}

Benefit.propTypes = {
    item: _propTypes2.default.object
};

var Benefits = function (_Component) {
    _inherits(Benefits, _Component);

    function Benefits(props) {
        _classCallCheck(this, Benefits);

        var _this = _possibleConstructorReturn(this, (Benefits.__proto__ || Object.getPrototypeOf(Benefits)).call(this, props));

        _this.state = {
            hasAnimation: true
        };
        return _this;
    }

    _createClass(Benefits, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            setTimeout(function () {
                _this2.timeoutAnimation();
            }, 1000);
        }
    }, {
        key: 'timeoutAnimation',
        value: function timeoutAnimation() {
            this.setState({ hasAnimation: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _copy$benefits = _pdp2.default.benefits,
                title = _copy$benefits.title,
                linkText = _copy$benefits.linkText,
                linkUrl = _copy$benefits.linkUrl,
                fields = _copy$benefits.fields;

            var benefitsClass = (0, _classnames2.default)(_Benefits2.default.benefits, _defineProperty({}, _Benefits2.default.hasAnimation, this.state.hasAnimation));

            return _react2.default.createElement(
                'div',
                { className: benefitsClass },
                _react2.default.createElement(
                    'div',
                    { className: _Benefits2.default.title },
                    title
                ),
                fields.map(function (item, index) {
                    return _react2.default.createElement(Benefit, { item: item, key: index });
                }),
                _react2.default.createElement(
                    'a',
                    { href: linkUrl, target: '_blank', title: linkText },
                    linkText
                )
            );
        }
    }]);

    return Benefits;
}(_react.Component);

module.exports = Benefits;

/***/ }),
/* 3688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);

// Stores
var PriceStore = __webpack_require__(367);
var ItemStore = __webpack_require__(336);
var TourStore = __webpack_require__(547);

// Components
var ItemCTAButtonsWrapper = __webpack_require__(3690).default;

// Helpers
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var SV = __webpack_require__(17);
var TRADE_TOUR = TourStore.type.TRADE_TOUR;

var tourTracking = __webpack_require__(506);
var pageUrl = __webpack_require__(134).parseUri(global.location, { stripDelimiters: true });
var hasContextTypes = __webpack_require__(782);
var modalActions = __webpack_require__(1485);
var hasDataClass = __webpack_require__(3696);

var Buttons = React.createClass(hasContextTypes({
    propTypes: {
        askingPrice: PropTypes.number,
        canonicalUrl: PropTypes.string.isRequired,
        context: PropTypes.object,
        dealerPk: PropTypes.string.isRequired,
        item: PropTypes.object.isRequired,
        itemId: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        vertical: PropTypes.string.isRequired
    },

    _contactDealer: function _contactDealer() {
        this.context.executeAction(modalActions.contactDealer, {
            itemPk: this.props.itemId,
            tracking: 'contact link in pdp – request price button',
            dealerPk: this.props.dealerPk
        });
    },
    render: function render() {
        var _props = this.props,
            canonicalUrl = _props.canonicalUrl,
            user = _props.user,
            item = _props.item,
            itemId = _props.itemId,
            tradeTour = _props.tradeTour,
            context = _props.context,
            url = _props.url;


        var tracking = {
            pageContext: 'pdp',
            url: canonicalUrl || url,
            emailTmplName: pageUrl.queryKey.e_tmpl || ''
        };

        var requiredProps = ['item', 'itemId', 'vertical', 'canonicalUrl', 'dealerPk', 'url', 'askingPrice'];

        var outputProps = {
            className: 'pdp-actions-container ' + hasDataClass(this.props, requiredProps) // TODO classNames
        };

        var buttonProps = {
            addToCart: true,
            context: context,
            tracking: tracking,
            item: item,
            tradeTour: tradeTour,
            onClick: this._contactDealer
        };

        var buttons = React.createElement(ItemCTAButtonsWrapper, { itemId: itemId, props: buttonProps, item: item, user: user || null });
        if (buttons) {
            outputProps = Object.assign({}, outputProps, { ref: 'actions', 'data-tn': 'item-actions' });
        }

        return React.createElement(
            'div',
            outputProps,
            buttons
        );
    }
}));

var Connected = Relay.createContainer(provideContext(connectToStores(Buttons, [ItemStore, PriceStore, TourStore], function (context) {
    var itemStore = context.getStore(ItemStore);
    var priceStore = context.getStore(PriceStore);
    var tourStore = context.getStore(TourStore);
    var item = itemStore.getItem();
    var processedPriceData = priceStore.processPrice(item);

    return {
        askingPrice: itemStore.getFromSV('tracking.initialDataLayerInfo.askingPrice'),
        canonicalUrl: itemStore.getFromSV('data.canonicalUrl'),
        dealerPk: itemStore.getFromSV('data.dealerPk'),
        item: item,
        itemId: itemStore.getFromSV('data.pk'),
        tradeTour: {
            type: TRADE_TOUR,
            subType: processedPriceData.priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
            copy: SV.get('tourCopy.' + TRADE_TOUR),
            isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
            currentStep: tourStore.getCurrentStep(TRADE_TOUR),
            totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        },
        url: itemStore.getUrl(),
        vertical: itemStore.getFromItemModel('vertical')
    };
})), {
    fragments: {
        user: function user() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Buttons_UserRelayQL',
                    type: 'User'
                };
            }(ItemCTAButtonsWrapper.getFragment('user'));
        }
    }
});

module.exports = {
    Connected: Connected,
    Raw: Buttons
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 3689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var moment = __webpack_require__(30);

var _require = __webpack_require__(1844),
    inlineDatesAdverb = _require.inlineDatesAdverb;

function HoldExpiration(_ref) {
    var expirationDate = _ref.expirationDate;

    var expirationDateCountdown = ' Expires ' + moment(expirationDate).locale('inlineDatesAdverb', inlineDatesAdverb).fromNow();
    return React.createElement(
        'span',
        { className: 'pdp-sidebar-hold-countdown' },
        expirationDateCountdown
    );
}

HoldExpiration.propTypes = {
    expirationDate: PropTypes.string.isRequired
};

function CustomHold(_ref2) {
    var customHoldCopy = _ref2.customHoldCopy,
        expirationDate = _ref2.expirationDate;

    return React.createElement(
        'div',
        { className: 'pdp-sidebar-hold-for-you' },
        customHoldCopy,
        expirationDate ? React.createElement(HoldExpiration, { expirationDate: expirationDate }) : null
    );
}

CustomHold.propTypes = {
    customHoldCopy: PropTypes.string.isRequired,
    expirationDate: PropTypes.string
};

module.exports = CustomHold;

/***/ }),
/* 3690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(18);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _abExperiments = __webpack_require__(497);

var _abExperiments2 = _interopRequireDefault(_abExperiments);

var _ItemCTAButtons = __webpack_require__(1796);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemCTAButtonsWrapper = function (_Component) {
    _inherits(ItemCTAButtonsWrapper, _Component);

    function ItemCTAButtonsWrapper() {
        _classCallCheck(this, ItemCTAButtonsWrapper);

        var _this = _possibleConstructorReturn(this, (ItemCTAButtonsWrapper.__proto__ || Object.getPrototypeOf(ItemCTAButtonsWrapper)).call(this));

        _this.state = {
            tradeMakeOfferCTATestRunning: false,
            makeOfferPurchaseSwapTestRunning: false
        };
        return _this;
    }

    _createClass(ItemCTAButtonsWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var tradeMakeOfferCTA = _abExperiments2.default.tradeMakeOfferCTA,
                makeOfferPurchaseSwap = _abExperiments2.default.makeOfferPurchaseSwap;

            if (tradeMakeOfferCTA) {
                tradeMakeOfferCTA.then(function () {
                    _this2.setState({ tradeMakeOfferCTATestRunning: true });
                });
            }
            if (makeOfferPurchaseSwap) {
                makeOfferPurchaseSwap.then(function () {
                    _this2.setState({ makeOfferPurchaseSwapTestRunning: true });
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                tradeMakeOfferCTATestRunning = _state.tradeMakeOfferCTATestRunning,
                makeOfferPurchaseSwapTestRunning = _state.makeOfferPurchaseSwapTestRunning;

            var itemCTAButtonsProps = _extends({}, this.props, {
                tradeMakeOfferCTATestRunning: tradeMakeOfferCTATestRunning,
                makeOfferPurchaseSwapTestRunning: makeOfferPurchaseSwapTestRunning
            });
            return _react2.default.createElement(_ItemCTAButtons.Connected, itemCTAButtonsProps);
        }
    }]);

    return ItemCTAButtonsWrapper;
}(_react.Component);

;

exports.default = _reactRelay2.default.createContainer(ItemCTAButtonsWrapper, {
    fragments: {
        user: function user() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, _reactRelay2.default.QL.__frag(RQL_0)]),
                    id: _reactRelay2.default.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'ItemCTAButtonsWrapper_UserRelayQL',
                    type: 'User'
                };
            }(_ItemCTAButtons.Connected.getFragment('user'));
        }
    }
});

/***/ }),
/* 3691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _priceStatusToClassMa;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Relay = __webpack_require__(18);

// Stores
var PriceStore = __webpack_require__(367);
var ItemStore = __webpack_require__(336);
var PdpUiStore = __webpack_require__(744);
var CalloutStore = __webpack_require__(301);
var TourStore = __webpack_require__(547);

// Components
var ContextComponent = __webpack_require__(61);

var _require = __webpack_require__(1798),
    PdpPrice = _require.Price;

var PdpFolderItem = __webpack_require__(2177).default;
var PdpFavoriteItem = __webpack_require__(2176).default;

var _require2 = __webpack_require__(3688),
    Buttons = _require2.Connected;

var Support = __webpack_require__(3692);
var CustomHold = __webpack_require__(3689);
var ContactDealerSidebar = __webpack_require__(3675);

var _require3 = __webpack_require__(1859),
    ProductionLeadTime = _require3.Connected;

var Blurb = __webpack_require__(1852);

var _require4 = __webpack_require__(1869),
    Title = _require4.Connected;

var SaveSearch = __webpack_require__(3684);
var Benefits = __webpack_require__(3687);
var TradeGuarantee = __webpack_require__(3693);
var Urgency = __webpack_require__(3694).default;
var ContactDealerBody = __webpack_require__(2174);

// Helpers
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var SV = __webpack_require__(17);
var tokenReplace = __webpack_require__(75);
var get = __webpack_require__(14);
var classnames = __webpack_require__(16);
var priceHelpers = __webpack_require__(2581);
var pageTypes = __webpack_require__(383);
var tourTracking = __webpack_require__(506);
var TRADE_TOUR = TourStore.type.TRADE_TOUR;


var abExperiments = __webpack_require__(497);

var FavoriteModel = __webpack_require__(355);
var TYPE_SEARCH = FavoriteModel.TYPE_SEARCH;
var FAVORITE_TRACKING = __webpack_require__(672);

var _require5 = __webpack_require__(968),
    variants = _require5.variants;

// Todo: Price status classes can go away when markup is in Twig as well as React see (see FINDING-7829)
// Add classes to apply min-heights to avoid Sidebar from contracting before all React components mount


var priceStatusToClassMap = (_priceStatusToClassMa = {}, _defineProperty(_priceStatusToClassMa, priceHelpers.SOLD, 'is-sold'), _defineProperty(_priceStatusToClassMa, priceHelpers.HOLD, 'is-hold'), _defineProperty(_priceStatusToClassMa, priceHelpers.UPON_REQUEST, 'is-upon-request'), _defineProperty(_priceStatusToClassMa, priceHelpers.SHOW_PRICE, 'is-show-price'), _priceStatusToClassMa);

/**
 * quick and dirty to stop using pdpPrice module logic (still using constants)
 * @param isSold
 * @param isOnHold
 * @param isHidingPrice
 */
var getStatus = function getStatus(_ref) {
    var isSold = _ref.isSold,
        isOnHold = _ref.isOnHold,
        showPriceUponRequest = _ref.showPriceUponRequest;

    if (isSold) {
        return priceHelpers.SOLD;
    }
    if (isSold || isOnHold) {
        // On Hold, Recently Sold (i.e. not using sold template) flow
        return priceHelpers.HOLD;
    }
    if (showPriceUponRequest) {
        return priceHelpers.UPON_REQUEST;
    }
    return priceHelpers.SHOW_PRICE;
};

var Sidebar = function (_ContextComponent) {
    _inherits(Sidebar, _ContextComponent);

    function Sidebar(props) {
        _classCallCheck(this, Sidebar);

        var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

        _this.state = { isUrgencyVisible: false };

        _this._contactDealer = _this._contactDealer.bind(_this);
        return _this;
    }

    _createClass(Sidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (abExperiments.pdpUrgency) {
                abExperiments.pdpUrgency.then(function () {
                    _this2.setState({ isUrgencyVisible: true });
                });
            }
        }
    }, {
        key: '_contactDealer',
        value: function _contactDealer(e) {
            e.preventDefault();
            this.props.contactDealerClick(this.props);
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var buyerAssuranceProps = props.buyerAssuranceProps,
                canMakePurchase = props.canMakePurchase,
                _props$copy = props.copy,
                copy = _props$copy === undefined ? {} : _props$copy,
                customHold = props.customHold,
                dealerPk = props.dealerPk,
                hidePrice = props.hidePrice,
                isAsyncItemLoaded = props.isAsyncItemLoaded,
                isOnHold = props.isOnHold,
                isPreview = props.isPreview,
                isSold = props.isSold,
                isUnlisted = props.isUnlisted,
                itemId = props.itemId,
                priceDisplays = props.priceDisplays,
                tradeTour = props.tradeTour,
                context = props.context,
                quotes = props.quotes,
                _props$user = props.user,
                user = _props$user === undefined ? null : _props$user,
                userId = props.userId,
                viewer = props.viewer,
                relayItem = props.relayItem,
                favoriteDealer = props.favoriteDealer,
                favoriteDealerCta = props.favoriteDealerCta,
                dealerData = props.dealerData,
                showReducedFrom = props.showReducedFrom,
                pagePosition = props.pagePosition,
                callout = props.callout,
                contactDealerBodyProps = props.contactDealerBodyProps;

            var priceStates = copy.priceStates;
            var priceStatus = getStatus({ isSold: isSold, isOnHold: isOnHold, showPriceUponRequest: priceDisplays.showPriceUponRequest });
            var expirationDate = priceDisplays.showOnHoldCustom && customHold && customHold.expirationDate ? customHold.expirationDate : null;
            var hasTradeBenefits = SV.get('data.hasPdpBenefits') && get(user, 'isVerifiedTrade');
            var buttonsEl = void 0;
            var requestInfoEl = void 0;
            var priceEl = void 0;
            var dealerEl = void 0;
            // Save Search
            var saveName = { name: SV.get('saveSearchData.name') };
            var favoriteData = {
                solrQuery: SV.get('saveSearchData.sq'),
                page: SV.get('saveSearchData.uri'),
                type: TYPE_SEARCH,
                authModalOptions: FAVORITE_TRACKING.SEARCH.SOLD_PDP_AUTH_MODAL
            };

            var _ref2 = contactDealerBodyProps || {},
                maytest = _ref2.maytest;

            // FINDING-8230 Wait on displaying price to ensure converted currencies reflect latest conversion rates


            if (isAsyncItemLoaded || isPreview) {
                priceEl = React.createElement(PdpPrice, { context: context, pageType: pageTypes.PAGE_TYPE.PDP, showReducedFrom: showReducedFrom, showTour: true });
            }

            // Show Save Search if sold item
            if (isSold || isUnlisted) {
                buttonsEl = React.createElement(SaveSearch, {
                    context: context,
                    description: tokenReplace(SV.get('favoriteCta.soldPdp.description'), saveName),
                    cta: SV.get('favoriteCta.soldPdp.cta'),
                    successMessage: tokenReplace(SV.get('favoriteCta.soldPdp.confirmationTooltip'), saveName),
                    favoriteData: favoriteData,
                    tracking: FAVORITE_TRACKING.SEARCH.SOLD_PDP
                });
                dealerEl = React.createElement(
                    'div',
                    { className: 'pdp-sidebar-dealer-name' },
                    copy.dealer.offeredBy,
                    ' ',
                    React.createElement(
                        'a',
                        { href: dealerData.uri, title: dealerData.company },
                        dealerData.company
                    )
                );
                // Show shipping blurb if non-sold item is on hold (but could be on hold for a user) and is not sold
            } else if (!priceDisplays.showOnHold) {
                buttonsEl = React.createElement(Buttons, { context: context, user: user });
            }

            if (relayItem && (canMakePurchase || priceDisplays.showNetPrice) && !priceDisplays.showOnHold) {
                var isCustomizable = relayItem.isCustomizable;
                var copyText = isCustomizable ? copy.sidebar.customizeItem : copy.sidebar.requestInfo;

                requestInfoEl = React.createElement(ContactDealerSidebar, {
                    copy: copyText,
                    context: context,
                    onContactDealer: this._contactDealer
                });
            }

            var listingScore = get(relayItem, 'listingScore') || 0;
            var showUrgencyBox = this.state.isUrgencyVisible && listingScore > 1;

            var sidebarClasses = classnames('pdp-sidebar', {
                'has-maytest-contact-dealer': maytest === variants.CONTACT2 || maytest === variants.CONTACT3,
                'has-trade-benefits': hasTradeBenefits
            });

            var priceClasses = classnames('pdp-price-container', {
                'has-net-price': priceDisplays.showNetPrice,
                'has-sale-price': priceDisplays.showSalePrice,
                'has-unavailable-price': priceDisplays.showSold || isUnlisted
            });

            return React.createElement(
                'div',
                { className: sidebarClasses + ' ' + priceStatusToClassMap[priceStatus] },
                React.createElement(
                    'div',
                    { className: 'pdp-sidebar-box' },
                    React.createElement(
                        'div',
                        { className: 'pdp-sidebar-top-section' },
                        React.createElement(
                            'div',
                            { className: 'pdp-sidebar-top-favorite-item' },
                            React.createElement(PdpFavoriteItem, {
                                userId: userId,
                                itemId: itemId,
                                viewer: viewer,
                                callout: callout
                            }),
                            React.createElement(PdpFolderItem, {
                                userId: userId,
                                itemId: itemId,
                                viewer: viewer,
                                callout: callout
                            })
                        ),
                        React.createElement(Title, { context: context }),
                        dealerEl,
                        React.createElement(
                            'div',
                            { className: priceClasses },
                            priceDisplays.showOnHold && React.createElement(
                                'div',
                                { className: 'is-on-hold' },
                                priceStates.onHold
                            ),
                            hasTradeBenefits && !priceDisplays.showPriceUponRequest ? React.createElement(TradeGuarantee, null) : null,
                            priceEl
                        ),
                        React.createElement(ProductionLeadTime, { relayItem: relayItem }),
                        React.createElement(Blurb, {
                            pagePosition: pagePosition + '-pdp-sidebar',
                            userId: userId,
                            itemId: itemId,
                            dealerPk: dealerPk,
                            viewer: viewer,
                            context: context,
                            relayItem: relayItem,
                            quotes: quotes,
                            user: user,
                            favoriteDealer: favoriteDealer,
                            favoriteDealerCta: favoriteDealerCta,
                            dealerData: dealerData
                        }),
                        priceDisplays.showOnHoldCustom ? React.createElement(CustomHold, { customHoldCopy: priceStates.onHoldForUser, expirationDate: expirationDate }) : null
                    ),
                    React.createElement(
                        'div',
                        { className: 'pdp-sidebar-middle-section' },
                        buttonsEl,
                        hasTradeBenefits && priceDisplays.showPriceUponRequest ? React.createElement(TradeGuarantee, { moveUp: true }) : null,
                        maytest !== variants.CONTACT2 && maytest !== variants.CONTACT3 && requestInfoEl
                    ),
                    !hasTradeBenefits && !isSold && !isUnlisted ? React.createElement(
                        'div',
                        { className: 'pdp-sidebar-bottom-section' },
                        React.createElement(Support, {
                            hidePrice: hidePrice,
                            tradeTour: tradeTour,
                            buyerAssuranceProps: buyerAssuranceProps
                        })
                    ) : null
                ),
                (maytest === variants.CONTACT2 || maytest === variants.CONTACT3) && React.createElement(ContactDealerBody, _extends({}, contactDealerBodyProps, {
                    sidebar: true,
                    onContactDealerModal: this._contactDealer
                })),
                showUrgencyBox && React.createElement(Urgency, { views: listingScore }),
                hasTradeBenefits && React.createElement(Benefits, null)
            );
        }
    }]);

    return Sidebar;
}(ContextComponent);

Sidebar.defaultProps = {
    showReducedFrom: true
};

Sidebar.propTypes = {
    buyerAssuranceProps: PropTypes.shape({
        copy: PropTypes.object.isRequired,
        state: PropTypes.shape({
            showInfo: PropTypes.bool.isRequired
        })
    }),
    canMakePurchase: PropTypes.bool,
    contactDealerClick: PropTypes.func.isRequired,
    context: PropTypes.object,
    copy: PropTypes.object.isRequired,
    customHold: PropTypes.object,
    dealerPk: PropTypes.string.isRequired,
    hidePrice: PropTypes.bool.isRequired,
    isAsyncItemLoaded: PropTypes.bool,
    isOnHold: PropTypes.bool.isRequired,
    isPreview: PropTypes.bool,
    isSold: PropTypes.bool.isRequired,
    isUnlisted: PropTypes.bool.isRequired,
    relayItem: PropTypes.object,
    itemId: PropTypes.string.isRequired,
    priceDisplays: PropTypes.object.isRequired,
    showReducedFrom: PropTypes.bool,
    tradeTour: PropTypes.object,
    userId: PropTypes.string,
    viewer: PropTypes.object,
    favoriteDealer: PropTypes.object,
    favoriteDealerCta: PropTypes.object,
    dealerData: PropTypes.object,
    pagePosition: PropTypes.string,
    callout: PropTypes.object,
    contactDealerBodyProps: PropTypes.object
};

module.exports = Relay.createContainer(provideContext(connectToStores(Sidebar, [ItemStore, PriceStore, PdpUiStore, TourStore, CalloutStore], function (context) {
    var calloutStore = context.getStore(CalloutStore);
    var itemStore = context.getStore(ItemStore);
    var priceStore = context.getStore(PriceStore);
    var uiStore = context.getStore(PdpUiStore);
    var tourStore = context.getStore(TourStore);
    var item = itemStore.getItem();
    var processedPriceData = priceStore.processPrice(item);

    return {
        buyerAssuranceProps: uiStore.getBuyerAssuranceProps(),
        canMakePurchase: itemStore.getCanMakePurchase() || false,
        copy: itemStore.getCopy(),
        customHold: itemStore.getFromItemModel('activeHold'),
        dealerPk: itemStore.getFromSV('data.dealerPk'),
        hidePrice: itemStore.getHidePrice(),
        isAsyncItemLoaded: itemStore.getIsAsyncItemLoaded(),
        isOnHold: itemStore.getIsOnHold(),
        isPreview: itemStore.getIsPreview(),
        isSold: itemStore.getIsSold(),
        isUnlisted: itemStore.getIsUnlisted(),
        itemId: itemStore.getFromSV('data.pk'),
        priceDisplays: processedPriceData.priceDisplays,
        tradeTour: {
            type: TRADE_TOUR,
            subType: processedPriceData.priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
            copy: SV.get('tourCopy.' + TRADE_TOUR),
            isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
            currentStep: tourStore.getCurrentStep(TRADE_TOUR),
            totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        },
        callout: calloutStore.getCalloutData()
    };
})), {
    initialVariables: {
        userId: null,
        itemId: null,
        hasUserId: false
    },
    fragments: {
        user: function user(_ref3) {
            var itemId = _ref3.itemId,
                userId = _ref3.userId,
                hasUserId = _ref3.hasUserId;
            return function (RQL_0, RQL_1, RQL_2) {
                return {
                    children: [].concat.apply([], [{
                        alias: 'isVerifiedTrade',
                        calls: [{
                            kind: 'Call',
                            metadata: {},
                            name: 'name',
                            value: {
                                kind: 'CallValue',
                                callValue: 'B_NET_PRICE'
                            }
                        }],
                        fieldName: 'hasPermission',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1), Relay.QL.__frag(RQL_2)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Sidebar_UserRelayQL',
                    type: 'User'
                };
            }(Blurb.getFragment('user', { itemId: itemId, userId: userId }), Buttons.getFragment('user'), ContactDealerBody.getFragment('user', { userId: userId, itemId: itemId, hasUserId: hasUserId }));
        },
        viewer: function viewer(_ref4) {
            var itemId = _ref4.itemId,
                userId = _ref4.userId,
                hasUserId = _ref4.hasUserId;
            return function (RQL_0, RQL_1, RQL_2, RQL_3) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1), Relay.QL.__frag(RQL_2), Relay.QL.__frag(RQL_3)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Sidebar_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(PdpFavoriteItem.getFragment('viewer', { itemId: itemId, userId: userId }), PdpFolderItem.getFragment('viewer', { itemId: itemId, userId: userId }), Blurb.getFragment('viewer', { itemId: itemId, userId: userId }).if(hasUserId), ContactDealerBody.getFragment('viewer', { userId: userId, itemId: itemId, hasUserId: hasUserId }));
        },
        relayItem: function relayItem(_ref5) {
            var itemId = _ref5.itemId,
                userId = _ref5.userId,
                hasUserId = _ref5.hasUserId;
            return function (RQL_0, RQL_1, RQL_2) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'isCustomizable',
                        kind: 'Field',
                        metadata: {},
                        type: 'Boolean'
                    }, {
                        fieldName: 'listingScore',
                        kind: 'Field',
                        metadata: {},
                        type: 'Int'
                    }, {
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0), Relay.QL.__frag(RQL_1), Relay.QL.__frag(RQL_2)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Sidebar_RelayItemRelayQL',
                    type: 'Item'
                };
            }(Blurb.getFragment('relayItem'), ProductionLeadTime.getFragment('relayItem'), ContactDealerBody.getFragment('item', { userId: userId, itemId: itemId, hasUserId: hasUserId }));
        }
    }
});

/***/ }),
/* 3692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

var _require = __webpack_require__(379),
    trackSupportClick = _require.trackSupportClick,
    trackBuyerAssuranceClick = _require.trackBuyerAssuranceClick,
    trackBuyerAssuranceLinkClick = _require.trackBuyerAssuranceLinkClick;

var PdpActions = __webpack_require__(796);
var ContextComponent = __webpack_require__(61);
var BuyerAssurance = __webpack_require__(3670);

var Support = function (_ContextComponent) {
    _inherits(Support, _ContextComponent);

    function Support(props) {
        _classCallCheck(this, Support);

        var _this = _possibleConstructorReturn(this, (Support.__proto__ || Object.getPrototypeOf(Support)).call(this, props));

        _this._handleSupportClick = _this._handleSupportClick.bind(_this);
        _this._showBuyerAssuranceTooltip = _this._showBuyerAssuranceTooltip.bind(_this);
        _this._hideBuyerAssuranceTooltip = _this._hideBuyerAssuranceTooltip.bind(_this);
        _this._trackBuyerAssuranceLinkClick = _this._trackBuyerAssuranceLinkClick.bind(_this);
        return _this;
    }

    _createClass(Support, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // FINDING-7210 - delete buyer assurance "surfaced" cookie
            this.context.executeAction(PdpActions.deleteBuyerAssurance);
        }
    }, {
        key: '_handleSupportClick',
        value: function _handleSupportClick() {
            this.context.executeAction(trackSupportClick);
        }

        /*
         * calls PdpAction to show the tooltip
         */

    }, {
        key: '_showBuyerAssuranceTooltip',
        value: function _showBuyerAssuranceTooltip() {
            this.context.executeAction(trackBuyerAssuranceClick);
            this.context.executeAction(PdpActions.toggleBuyerAssuranceShowInfo, { showInfo: true });
        }

        /**
         * calls PdpAction to hide the tooltip
         * @private
         */

    }, {
        key: '_hideBuyerAssuranceTooltip',
        value: function _hideBuyerAssuranceTooltip() {
            this.context.executeAction(PdpActions.toggleBuyerAssuranceShowInfo, { showInfo: false });
        }

        /**
         * calls PdpTrackingAction to track link clicks
         * @private
         */

    }, {
        key: '_trackBuyerAssuranceLinkClick',
        value: function _trackBuyerAssuranceLinkClick() {
            this.context.executeAction(trackBuyerAssuranceLinkClick);
        }
    }, {
        key: '_renderBuyerAssuranceLink',
        value: function _renderBuyerAssuranceLink() {
            var props = this.props.buyerAssuranceProps;

            return React.createElement(BuyerAssurance, _extends({}, props, {
                tradeTour: this.props.tradeTour,
                hideTooltip: this._hideBuyerAssuranceTooltip,
                showTooltip: this._showBuyerAssuranceTooltip,
                trackLinkClick: this._trackBuyerAssuranceLinkClick,
                key: 'pdp-buyer-assurance-link' }));
        }
    }, {
        key: 'render',
        value: function render() {
            // FINDING-7164 : hide buyer assurance when price is hidden
            if (this.props.hidePrice) {
                return null;
            }

            return React.createElement(
                'div',
                { className: 'pdp-support' },
                this._renderBuyerAssuranceLink()
            );
        }
    }]);

    return Support;
}(ContextComponent);

Support.defaultProps = {
    isVariant: false
};

Support.propTypes = {
    isVariant: PropTypes.bool,
    hidePrice: PropTypes.bool,
    buyerAssuranceProps: PropTypes.shape({
        copy: PropTypes.object.isRequired,
        state: PropTypes.shape({
            showInfo: PropTypes.bool.isRequired
        })
    }).isRequired
};

module.exports = Support;

/***/ }),
/* 3693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _dibsReactTooltip = __webpack_require__(270);

var _dibsReactTooltip2 = _interopRequireDefault(_dibsReactTooltip);

var _infoCircle = __webpack_require__(437);

var _infoCircle2 = _interopRequireDefault(_infoCircle);

var _infoCircleFilled = __webpack_require__(1119);

var _infoCircleFilled2 = _interopRequireDefault(_infoCircleFilled);

var _TradeGuarantee = __webpack_require__(3060);

var _TradeGuarantee2 = _interopRequireDefault(_TradeGuarantee);

var _pdp = __webpack_require__(1112);

var _pdp2 = _interopRequireDefault(_pdp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TradeGuarantee = function (_Component) {
    _inherits(TradeGuarantee, _Component);

    function TradeGuarantee(props) {
        _classCallCheck(this, TradeGuarantee);

        var _this = _possibleConstructorReturn(this, (TradeGuarantee.__proto__ || Object.getPrototypeOf(TradeGuarantee)).call(this, props));

        _this.state = {
            isVisible: false
        };

        _this.toggleIcon = _this.toggleIcon.bind(_this);
        return _this;
    }

    _createClass(TradeGuarantee, [{
        key: 'toggleIcon',
        value: function toggleIcon() {
            var isVisible = this.state.isVisible;


            this.setState({
                isVisible: !isVisible
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var isVisible = this.state.isVisible;
            var _copy$guarantee = _pdp2.default.guarantee,
                title = _copy$guarantee.title,
                tooltip = _copy$guarantee.tooltip;

            var mainClass = (0, _classnames2.default)(_TradeGuarantee2.default.wrapper, _defineProperty({}, _TradeGuarantee2.default.moveUp, this.props.moveUp));
            var IconView = isVisible ? _infoCircleFilled2.default : _infoCircle2.default;

            return _react2.default.createElement(
                'div',
                { className: mainClass },
                _react2.default.createElement(
                    'span',
                    { className: _TradeGuarantee2.default.title },
                    title
                ),
                _react2.default.createElement(
                    'span',
                    {
                        className: _TradeGuarantee2.default.iconWrapper,
                        onMouseEnter: this.toggleIcon,
                        onMouseLeave: this.toggleIcon
                    },
                    _react2.default.createElement(IconView, { className: _TradeGuarantee2.default.icon }),
                    _react2.default.createElement(
                        _dibsReactTooltip2.default,
                        {
                            isVisible: isVisible,
                            className: _TradeGuarantee2.default.tooltip,
                            containerClass: _TradeGuarantee2.default.tooltipInner
                        },
                        _react2.default.createElement(
                            'div',
                            { className: _TradeGuarantee2.default.tooltipTitle },
                            tooltip.title
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _TradeGuarantee2.default.tooltipDescription },
                            tooltip.description
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: tooltip.linkUrl,
                                title: tooltip.linkText,
                                target: '_blank'
                            },
                            tooltip.linkText
                        )
                    )
                )
            );
        }
    }]);

    return TradeGuarantee;
}(_react.Component);

TradeGuarantee.propTypes = {
    moveUp: _propTypes2.default.bool
};

TradeGuarantee.defaultProps = {
    moveUp: false
};

module.exports = TradeGuarantee;

/***/ }),
/* 3694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _cartOpen = __webpack_require__(993);

var _cartOpen2 = _interopRequireDefault(_cartOpen);

var _pdp = __webpack_require__(1112);

var _pdp2 = _interopRequireDefault(_pdp);

var _Urgency = __webpack_require__(3061);

var _Urgency2 = _interopRequireDefault(_Urgency);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Urgency = function Urgency(props) {
    return _react2.default.createElement(
        'div',
        { className: _Urgency2.default.container },
        _react2.default.createElement(_cartOpen2.default, { className: _Urgency2.default.icon }),
        _react2.default.createElement(
            'div',
            { className: _Urgency2.default.content },
            _react2.default.createElement(
                'div',
                { className: _Urgency2.default.title },
                _pdp2.default.urgency.title
            ),
            _react2.default.createElement(
                'div',
                { className: _Urgency2.default.text },
                props.views,
                ' ',
                _pdp2.default.urgency.text
            )
        )
    );
};

Urgency.propTypes = {
    views: _propTypes.number.isRequired
};

exports.default = Urgency;

/***/ }),
/* 3695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var scrollIntoView = __webpack_require__(584);
var windowCheck = __webpack_require__(97);
var tokenReplace = __webpack_require__(75);
var ContextComponent = __webpack_require__(61);
var SanitizeHtml = __webpack_require__(296);

var _require = __webpack_require__(379),
    trackSimilarItemsDisplayed = _require.trackSimilarItemsDisplayed,
    trackSimilarItemClick = _require.trackSimilarItemClick,
    trackSimilarViewAllClick = _require.trackSimilarViewAllClick;

var CarouselItem = __webpack_require__(896);
var SPACE = ' ';

function SimilarHeader(_ref) {
    var copy = _ref.copy,
        title = _ref.title,
        itemIsUnavailable = _ref.itemIsUnavailable;

    if (itemIsUnavailable) {
        return React.createElement(
            'h3',
            { className: 'pdp-similar-header-title' },
            copy.soldSubheader
        );
    }

    return React.createElement(
        'h2',
        { className: 'pdp-similar-header-title' },
        copy.header,
        SPACE,
        React.createElement(
            'span',
            { className: 'pdp-similar-header-info' },
            title
        )
    );
}

SimilarHeader.propTypes = {
    copy: PropTypes.object,
    title: PropTypes.string,
    itemIsUnavailable: PropTypes.bool
};

function SoldHeader(_ref2) {
    var copy = _ref2.copy,
        title = _ref2.title;

    var soldCopy = copy.soldHeader;
    var allowedTags = ['i'];
    var soldHeader = tokenReplace(soldCopy, {
        itemTitle: title
    });

    return React.createElement(
        'h2',
        { className: 'pdp-similar-header-module' },
        React.createElement(SanitizeHtml, { allowedTags: allowedTags, content: soldHeader })
    );
}

SoldHeader.propTypes = {
    copy: PropTypes.object,
    title: PropTypes.string
};

function SimilarItem(_ref3) {
    var item = _ref3.item,
        onClick = _ref3.onClick,
        index = _ref3.index;

    return React.createElement(
        'div',
        { className: 'colLg2 colMd4 colXs6 pdp-similar-item-wrapper' },
        React.createElement(
            'div',
            { className: 'pdp-similar-item' },
            React.createElement(
                'a',
                { href: item.uri, className: 'pdp-similar-item-link', onClick: onClick },
                React.createElement(CarouselItem, { className: 'pdp-similar-item-image',
                    title: item.title,
                    src: item.image,
                    index: index + 1
                }),
                React.createElement(
                    'span',
                    { className: 'pdp-similar-item-text' },
                    item.title
                )
            )
        )
    );
}

SimilarItem.propTypes = {
    index: PropTypes.number,
    item: PropTypes.object,
    onClick: PropTypes.func
};

function SimilarItems(_ref4) {
    var items = _ref4.items,
        onClick = _ref4.onClick;

    if (!items.length) {
        return null;
    }

    return React.createElement(
        'div',
        null,
        items.map(function (recommendations, recIndex) {
            return React.createElement(
                'div',
                { className: 'rowFlex pdp-similar-items', key: 'similar-' + recIndex },
                recommendations.map(function (item, index) {
                    return React.createElement(SimilarItem, { item: item, onClick: onClick, key: item.id, index: index });
                })
            );
        })
    );
}

SimilarItems.propTypes = {
    items: PropTypes.array,
    onClick: PropTypes.func
};

var Similar = function (_ContextComponent) {
    _inherits(Similar, _ContextComponent);

    function Similar(props) {
        _classCallCheck(this, Similar);

        var _this = _possibleConstructorReturn(this, (Similar.__proto__ || Object.getPrototypeOf(Similar)).call(this, props));

        _this._handleClick = _this._handleClick.bind(_this);
        _this._onSimilarCtaClick = _this._onSimilarCtaClick.bind(_this);
        return _this;
    }

    _createClass(Similar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.context.executeAction(trackSimilarItemsDisplayed);
        }
    }, {
        key: '_handleClick',
        value: function _handleClick() {
            this.context.executeAction(trackSimilarItemClick);
        }
    }, {
        key: '_onSimilarCtaClick',
        value: function _onSimilarCtaClick(event) {
            var gridHeader = windowCheck.document.querySelector('.pdp-suggestion-grid-header');

            event.preventDefault();
            this.context.executeAction(trackSimilarViewAllClick);
            scrollIntoView(gridHeader, { time: 1000, align: { top: 0.1 } });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                copy = _props.copy,
                title = _props.title,
                items = _props.items,
                itemIsUnavailable = _props.itemIsUnavailable;


            return React.createElement(
                'div',
                { className: 'pdp-similar' },
                React.createElement(
                    'div',
                    { className: 'pdp-similar-inner' },
                    itemIsUnavailable && React.createElement(SoldHeader, { copy: copy.similar, title: title }),
                    React.createElement(
                        'div',
                        { className: 'pdp-similar-header' },
                        React.createElement(SimilarHeader, { copy: copy.similar, title: title, itemIsUnavailable: itemIsUnavailable }),
                        React.createElement(
                            'a',
                            { href: '#0', className: 'pdp-similar-cta', onClick: this._onSimilarCtaClick },
                            copy.similar.cta
                        )
                    ),
                    React.createElement(SimilarItems, { items: items, onClick: this._handleClick })
                )
            );
        }
    }]);

    return Similar;
}(ContextComponent);

Similar.propTypes = {
    items: PropTypes.array,
    itemIsUnavailable: PropTypes.bool,
    copy: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired
};

Similar.defaultProps = {
    items: []
};

module.exports = Similar;

/***/ }),
/* 3696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Eric Willenson
 * Date: 04/27/16
 * Time: 11:32 PM
 */



function hasDataClass() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requiredProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var hasData = true;
    requiredProps.forEach(function (currentProperty) {
        currentProperty = props[currentProperty];
        if (typeof currentProperty !== 'undefined') {
            hasData = currentProperty || currentProperty === false ? hasData : false;
        } else {
            hasData = false;
        }
    });
    return hasData ? '' : 'no-data';
};

module.exports = hasDataClass;

/***/ }),
/* 3697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SV = __webpack_require__(17);

var scriptId = 'facebook-jssdk';
var scriptSrc = '//connect.facebook.net/en_US/all.js';

module.exports = function init() {
    if (document.querySelector('script#' + scriptId)) {
        return;
    }

    var facebookScript = document.createElement('script');
    facebookScript.id = scriptId;
    facebookScript.src = scriptSrc;

    // TODO: Check for a race condition in the actial facebook icon action. What happens if the initialization here fails and
    // someone tries to share?
    facebookScript.onload = function () {
        window.FB.init({ appId: SV.settings.socialKeys.facebook_appid, status: true, cookie: true, xfbml: true });
    };

    document.body.appendChild(facebookScript);
};

/***/ }),
/* 3698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shouldShowHoldRequest = undefined;

var _lodash = __webpack_require__(14);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldShowHoldRequest = exports.shouldShowHoldRequest = function shouldShowHoldRequest(item, user) {
    return !!item && !(0, _lodash2.default)(item, 'hasRequestedHoldForBuyer') && !(0, _lodash2.default)(item, 'isPriceUponRequest') && !(0, _lodash2.default)(item, 'isOnHold') && !(0, _lodash2.default)(item, 'isSold') && !(0, _lodash2.default)(item, 'attributes.customizable[0].value') && (0, _lodash2.default)(user, 'canUseNetPrice') && (0, _lodash2.default)(item, 'isFurniture');
};

/***/ }),
/* 3699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Bootstrap file that does any initialization needed and returns the top level view component.

// GROWTH-444 need this file just loaded on the page to fix chosen plugin

__webpack_require__(1531);
__webpack_require__(834);

var _require = __webpack_require__(92),
    createReducerStore = _require.createReducerStore;

var Relay = __webpack_require__(18);

var _require2 = __webpack_require__(1143),
    NAME_PINTEREST = _require2.NAME_PINTEREST;

var User = __webpack_require__(15);

// Stores
var ContactDealerStore = createReducerStore(__webpack_require__(136));
var ContactTransactionStore = __webpack_require__(104);
var ItemStore = __webpack_require__(336);
var UserStore = __webpack_require__(109);
var PdpUiStore = __webpack_require__(744);
var TourStore = __webpack_require__(547);
var StickyAlertTopStore = __webpack_require__(318);
var FavoritesStore = __webpack_require__(648);
var FavoritePageStore = __webpack_require__(475);
var PinterestStore = __webpack_require__(1107);
var TradeMessageStore = __webpack_require__(549);
var UserSocialNetworkStore = __webpack_require__(987);
var CalloutStore = __webpack_require__(301);

var _require3 = __webpack_require__(355),
    TYPE_DEALER = _require3.TYPE_DEALER;

var PriceStore = __webpack_require__(367);
var GalleryStore = __webpack_require__(357);

// Components
var PdpLayout = __webpack_require__(3681);

// Helpers
var SV = __webpack_require__(17);
var provideContext = __webpack_require__(284);
var connectToStores = __webpack_require__(286);
var newsy = __webpack_require__(41);

var tourTracking = __webpack_require__(506);

var pinterestCopy = __webpack_require__(1571);

var _require4 = __webpack_require__(334),
    getUserId = _require4.getUserId,
    cookieJarConstants = _require4.cookieJarConstants;

var MASQUERADE_BUYER = cookieJarConstants.MASQUERADE_BUYER;
var _TourStore$type = TourStore.type,
    TRADE_TOUR = _TourStore$type.TRADE_TOUR,
    NET_PRICE_TOUR = _TourStore$type.NET_PRICE_TOUR,
    REQUEST_ITEM_HOLD_TOUR = _TourStore$type.REQUEST_ITEM_HOLD_TOUR;


var PdpLayoutConnected = Relay.createContainer(provideContext(connectToStores(PdpLayout, [UserStore, ContactDealerStore, ContactTransactionStore, ItemStore, PdpUiStore, StickyAlertTopStore, FavoritesStore, FavoritePageStore, PinterestStore, UserSocialNetworkStore, CalloutStore, TourStore, TradeMessageStore, PriceStore, GalleryStore], function (context) {
    var userStore = context.getStore(UserStore);
    var itemStore = context.getStore(ItemStore);
    var contactDealerStore = context.getStore(ContactDealerStore);
    var optimizelyVariant = contactDealerStore.getVariant();
    var isMessageSent = contactDealerStore.getMessageSent();
    var isMessageSending = contactDealerStore.getMessageSending();
    var hasTrackingFired = contactDealerStore.getTrackingFired();
    var contactDealerErrors = contactDealerStore.getErrors();
    var uiStore = context.getStore(PdpUiStore);
    var stickyAlertTopStore = context.getStore(StickyAlertTopStore);
    var pinterestStore = context.getStore(PinterestStore);
    var userSocialNetworkStore = context.getStore(UserSocialNetworkStore);
    var calloutStore = context.getStore(CalloutStore);
    var favoritePageStore = context.getStore(FavoritePageStore);
    var tourStore = context.getStore(TourStore);
    var tradeMessageStore = context.getStore(TradeMessageStore);
    var itemModel = itemStore.getItem();
    var priceStore = context.getStore(PriceStore);
    var currency = userStore.getCurrency();
    var processedPriceData = priceStore.processPrice(itemModel);

    var _processedPriceData$s = processedPriceData.salePriceData,
        salePriceData = _processedPriceData$s === undefined ? {} : _processedPriceData$s,
        _processedPriceData$n = processedPriceData.netPriceData,
        netPriceData = _processedPriceData$n === undefined ? {} : _processedPriceData$n,
        _processedPriceData$r = processedPriceData.retailPriceData,
        retailPriceData = _processedPriceData$r === undefined ? {} : _processedPriceData$r,
        originalPriceData = processedPriceData.originalPriceData,
        canRequestNetPrice = processedPriceData.canRequestNetPrice,
        ctas = processedPriceData.ctas,
        priceDisplays = processedPriceData.priceDisplays;
    // Set the item ID as the PK directly

    var itemId = itemStore.getFromSV('data.pk');
    // GROWTH-1908: test for making offer in contact dealer form
    var offer = context.getStore(ContactTransactionStore).offer;
    var offerAmount = offer && offer.get('amountPerItem.amount');
    // end test

    return {
        userId: getUserId(document.cookie, MASQUERADE_BUYER),
        title: itemStore.getFromItemModel('title'),
        currency: currency,
        currencyLoaded: userStore.isCurrencyLoaded(),
        item: itemModel,
        itemId: itemId,
        itemHidePrice: itemStore.getHidePrice(),
        itemCategories: itemStore.getItemCategoryGroup(),
        itemImages: itemStore.getFromSV('item.images'),
        itemPrice: itemStore.getPrice(),
        itemInitialPrice: itemStore.getInitialPrice(),
        itemCanMakePurchase: itemStore.getCanMakePurchase() || false,
        itemDescription: itemStore.getFromItemModel('description'),
        customizationNote: itemStore.getCustomizationNote(),
        itemCreationDate: itemStore.getFromItemModel('classification.creationDate'),
        itemIsArt: itemStore.getIsArt(),
        itemIsFurniture: itemModel.isFurniture(),
        itemTitle: itemStore.getFromItemModel('title'),
        itemVertical: itemStore.getFromItemModel('vertical'),
        itemPk: itemId,
        isSoldIndividually: itemStore.getSoldIndividually(netPriceData.model || retailPriceData.model),
        itemIsOnHold: itemStore.getIsOnHold(),
        itemIsSold: itemStore.getIsSold(),
        itemIsUnlisted: itemStore.getIsUnlisted(),
        shouldShowSuspended: itemStore.getShouldShowSuspended(),
        creatorData: itemStore.getCreatorData(),
        creatorContent: itemStore.getFromSV('creatorContent'),
        dealerData: itemStore.getDealerData(),
        dealerRelatedItems: itemStore.getFromSV('carousel'),
        recommendedCarousel: itemStore.getFromSV('recommendedCarousel'),
        topRecommendations: itemStore.getFromSV('topRecommendations'),
        recommendedPhotos: itemStore.getFromSV('recommendedPhotos') || [],
        dealerPk: itemStore.getFromSV('data.dealerPk'),
        canonicalUrl: itemStore.getFromSV('data.canonicalUrl'),
        url: itemStore.getUrl(),
        urlData: itemStore.getUrlData(),
        askingPrice: itemStore.getFromSV('tracking.initialDataLayerInfo.askingPrice'),
        isPreview: itemStore.getIsPreview(),
        isAsyncItemLoaded: itemStore.getIsAsyncItemLoaded(),
        heroCarouselIndex: uiStore.getHeroCarouselIndex(),
        heroExpanded: uiStore.getHeroExpanded(),
        heroChangingSize: uiStore.getHeroChangingSize(),
        detailsTitles: itemStore.getDetailsTitles(),
        details: itemStore.getDetails(),
        detailsConfig: itemStore.getDetailsConfig(),
        internalLinks: itemStore.getFromSV('internalLinks'),
        siteProtocol: itemStore.getFromSV('settings.siteProtocol'),
        socialData: itemStore.getSocialData(),
        returnPolicy: itemStore.getFromItemModel('returnPolicy'),
        customHold: itemStore.getFromItemModel('activeHold'),
        returnMessage: itemStore.getReturnMessage(),
        breadcrumbs: itemStore.getBreadcrumbs(),
        goodRelationsMeta: itemStore.getGoodRelationsMeta(),
        copy: itemStore.getCopy(),
        supportCopy: itemStore.getSupportCopy(),
        buyerAssuranceProps: uiStore.getBuyerAssuranceProps(),
        // enableRequestNetPrice is for the net price button
        enableRequestNetPrice: uiStore.getEnableNetPrice(),
        // contact dealer items
        contactDealerErrors: contactDealerErrors,
        hasTrackingFired: hasTrackingFired,
        isDealerMessageSending: isMessageSending,
        isDealerMessageSent: isMessageSent,
        isReturnable: itemStore.getFromItemModel('returnPolicy.accept'),
        offer: offer,
        offerAmount: offerAmount, // GROWTH-1908: test
        optimizelyVariant: optimizelyVariant,
        price: itemModel.getPriceIn('RETAIL', currency), // GROWTH-1908: test
        trackingVpvParams: itemStore.getVpvParams(canRequestNetPrice),
        user: User.getCurrentUser(),
        userDisplayName: contactDealerStore.getName(),
        userMessage: contactDealerStore.getMessage(),
        // end contact dealer items
        isTradeUser: canRequestNetPrice,
        originalPrice: originalPriceData.price,
        salePrice: salePriceData.price,
        netPrice: netPriceData.price,
        retailPrice: retailPriceData.price,
        ctas: ctas,
        priceDisplays: priceDisplays,
        isNegotiablePrice: itemStore.isNegotiablePrice(),
        pageData: itemStore.getPageData(),
        stickyAlertTopHeight: stickyAlertTopStore.getHeight(),
        tradeReturnsEnabled: itemStore.isTradeReturnsEnabled(),
        tradeReturnAvailable: itemStore.isTradeReturnAvailable(),
        favoriteDealerCta: SV.get('favoriteCta.dealer'),
        favoriteDealer: {
            id: favoritePageStore.getFavoriteId(TYPE_DEALER),
            isSaved: favoritePageStore.isSaved(TYPE_DEALER),
            isFetched: favoritePageStore.isFetched(TYPE_DEALER),
            isCanceled: favoritePageStore.isCanceled()
        },
        pinterest: {
            isLoaded: userSocialNetworkStore.isLoaded(),
            connected: userSocialNetworkStore.getConnectedSocialNetwork(NAME_PINTEREST),
            connectedBoard: pinterestStore.getConnectedBoard(),
            connectAccountsModal: pinterestStore.getConnectAccountsModal(),
            connectBoardModal: pinterestStore.getConnectBoardModal(),
            boards: pinterestStore.getBoards(),
            copy: pinterestCopy
        },
        callout: calloutStore.getCalloutData(),
        netPriceTour: {
            type: NET_PRICE_TOUR,
            copy: SV.get('tourCopy.' + NET_PRICE_TOUR),
            isTourOpen: tourStore.isTourOpen(NET_PRICE_TOUR),
            currentStep: tourStore.getCurrentStep(NET_PRICE_TOUR),
            totalSteps: tourStore.getTotalSteps(NET_PRICE_TOUR),
            onCtaClick: tourTracking.trackCta,
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        },
        tradeTour: {
            type: TRADE_TOUR,
            subType: priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
            copy: SV.get('tourCopy.' + TRADE_TOUR),
            isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
            currentStep: tourStore.getCurrentStep(TRADE_TOUR),
            totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        },
        requestItemHoldTour: {
            type: REQUEST_ITEM_HOLD_TOUR,
            copy: SV.get('tourCopy.' + REQUEST_ITEM_HOLD_TOUR),
            isTourOpen: tourStore.isTourOpen(REQUEST_ITEM_HOLD_TOUR),
            currentStep: tourStore.getCurrentStep(REQUEST_ITEM_HOLD_TOUR),
            totalSteps: tourStore.getTotalSteps(REQUEST_ITEM_HOLD_TOUR),
            onCtaClick: tourTracking.trackCta,
            onOpen: tourTracking.trackOpen,
            onClose: tourTracking.trackClose
        },
        isAnyTourOpen: tourStore.isAnyTourOpen(),
        tradeMessage: {
            tradeSalesRep: userStore.getTradeSalesRep(),
            isVisible: tradeMessageStore.canShowMessage(),
            userFirstName: User.getCurrentUser().get('profile.firstName')
        },
        isPrintNP: uiStore.getIsPrintNP(),
        isPrintPage: uiStore.getIsPrintPage(),
        maytest: itemStore.getFromSV('settings.maytest'),
        sellerResponseTime: itemStore.getFromSV('data.sellerResponseTime')
    };
})), {
    fragments: {
        viewer: function viewer() {
            return function (RQL_0) {
                return {
                    children: [].concat.apply([], [{
                        fieldName: 'id',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'ID'
                    }, Relay.QL.__frag(RQL_0)]),
                    id: Relay.QL.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'Index_ViewerRelayQL',
                    type: 'Viewer'
                };
            }(PdpLayout.getFragment('viewer'));
        }
    }
});

newsy.register([__webpack_require__(71), __webpack_require__(68)]);

module.exports = PdpLayoutConnected;

/***/ }),
/* 3700 */,
/* 3701 */,
/* 3702 */,
/* 3703 */,
/* 3704 */,
/* 3705 */,
/* 3706 */,
/* 3707 */,
/* 3708 */,
/* 3709 */,
/* 3710 */,
/* 3711 */,
/* 3712 */,
/* 3713 */,
/* 3714 */,
/* 3715 */,
/* 3716 */,
/* 3717 */,
/* 3718 */,
/* 3719 */,
/* 3720 */,
/* 3721 */,
/* 3722 */,
/* 3723 */,
/* 3724 */,
/* 3725 */,
/* 3726 */,
/* 3727 */,
/* 3728 */,
/* 3729 */,
/* 3730 */,
/* 3731 */,
/* 3732 */,
/* 3733 */,
/* 3734 */,
/* 3735 */,
/* 3736 */,
/* 3737 */,
/* 3738 */,
/* 3739 */,
/* 3740 */,
/* 3741 */,
/* 3742 */,
/* 3743 */,
/* 3744 */,
/* 3745 */,
/* 3746 */,
/* 3747 */,
/* 3748 */,
/* 3749 */,
/* 3750 */,
/* 3751 */,
/* 3752 */,
/* 3753 */,
/* 3754 */,
/* 3755 */,
/* 3756 */,
/* 3757 */,
/* 3758 */,
/* 3759 */,
/* 3760 */,
/* 3761 */,
/* 3762 */,
/* 3763 */,
/* 3764 */,
/* 3765 */,
/* 3766 */,
/* 3767 */,
/* 3768 */,
/* 3769 */,
/* 3770 */,
/* 3771 */,
/* 3772 */,
/* 3773 */,
/* 3774 */,
/* 3775 */,
/* 3776 */,
/* 3777 */,
/* 3778 */,
/* 3779 */,
/* 3780 */,
/* 3781 */,
/* 3782 */,
/* 3783 */,
/* 3784 */,
/* 3785 */,
/* 3786 */,
/* 3787 */,
/* 3788 */,
/* 3789 */,
/* 3790 */,
/* 3791 */,
/* 3792 */,
/* 3793 */,
/* 3794 */,
/* 3795 */,
/* 3796 */,
/* 3797 */,
/* 3798 */,
/* 3799 */,
/* 3800 */,
/* 3801 */,
/* 3802 */,
/* 3803 */,
/* 3804 */,
/* 3805 */,
/* 3806 */,
/* 3807 */,
/* 3808 */,
/* 3809 */,
/* 3810 */,
/* 3811 */,
/* 3812 */,
/* 3813 */,
/* 3814 */,
/* 3815 */,
/* 3816 */,
/* 3817 */,
/* 3818 */,
/* 3819 */,
/* 3820 */,
/* 3821 */,
/* 3822 */,
/* 3823 */,
/* 3824 */,
/* 3825 */,
/* 3826 */,
/* 3827 */,
/* 3828 */,
/* 3829 */,
/* 3830 */,
/* 3831 */,
/* 3832 */,
/* 3833 */,
/* 3834 */,
/* 3835 */,
/* 3836 */,
/* 3837 */,
/* 3838 */,
/* 3839 */,
/* 3840 */,
/* 3841 */,
/* 3842 */,
/* 3843 */,
/* 3844 */,
/* 3845 */,
/* 3846 */,
/* 3847 */,
/* 3848 */,
/* 3849 */,
/* 3850 */,
/* 3851 */,
/* 3852 */,
/* 3853 */,
/* 3854 */,
/* 3855 */,
/* 3856 */,
/* 3857 */,
/* 3858 */,
/* 3859 */,
/* 3860 */,
/* 3861 */,
/* 3862 */,
/* 3863 */,
/* 3864 */,
/* 3865 */,
/* 3866 */,
/* 3867 */,
/* 3868 */,
/* 3869 */,
/* 3870 */,
/* 3871 */,
/* 3872 */,
/* 3873 */,
/* 3874 */,
/* 3875 */,
/* 3876 */,
/* 3877 */,
/* 3878 */,
/* 3879 */,
/* 3880 */,
/* 3881 */
/***/ (function(module, exports, __webpack_require__) {

_ = __webpack_require__(23);
module.exports = {
    "aboveFoldPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="product-price-current icon-inline-right product-price-item"\n          data-tracking-position="view price link - product page - under product title"\n          data-tracking-action="view price">\n    </span>\n';
return __p
},
    "aboveFoldPriceUponRequestTextTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="item-price-upon-request">Price Upon Request</span>\n';
return __p
},
    "aboveFoldInitialPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="product-price-initial-wrapper">\n        Reduced From <span class="product-price-initial product-price-item"></span>\n    </span>\n';
return __p
},
    "aboveFoldSoldHoldTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="icon ' +
((__t = ( obj.classes )) == null ? '' : __t) +
'" data-gastorecount="' +
((__t = ( obj.gastorecount )) == null ? '' : __t) +
'">\n        ' +
((__t = ( obj.copy )) == null ? '' : __t) +
'\n    </span>\n';
return __p
},
    "soldPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="icon is-' +
((__t = ( obj.status )) == null ? '' : __t) +
'" data-gastorecount="' +
((__t = ( obj.gastorecount )) == null ? '' : __t) +
'">\n        ' +
((__t = ( obj.title )) == null ? '' : __t) +
'\n    </span>\n';
return __p
},
    "aboveFoldSoldSuspendedTmpl": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n        <span class="icon is-' +
((__t = ( obj.status )) == null ? '' : __t) +
'" data-gastorecount="' +
((__t = ( obj.gastorecount )) == null ? '' : __t) +
'">\n            ' +
((__t = ( obj.title )) == null ? '' : __t) +
'\n        </span>\n\n    ';
 if (obj.status === 'suspended') { ;
__p += '\n        <a href="' +
((__t = ( obj.link.href )) == null ? '' : __t) +
'" class="icon-inline-title icon-inline-right"\n            data-gastorecount="' +
((__t = ( obj.gastorecount )) == null ? '' : __t) +
'"\n            data-gaaction="' +
((__t = ( obj.gaaction )) == null ? '' : __t) +
'"\n            data-gamorecount="' +
((__t = ( obj.gamorecount )) == null ? '' : __t) +
'">\n\n            ' +
((__t = ( obj.link.title )) == null ? '' : __t) +
'\n\n            ';
 if (obj.useSvgIcon && obj.svgWrapClass) { ;
__p += '\n                <span class="' +
((__t = ( obj.svgWrapClass )) == null ? '' : __t) +
'"></span>\n            ';
 } ;
__p += '\n        </a>\n    ';
 } ;
__p += '\n';
return __p
},
    "detailsPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="item-data-border text-next-to-icon">\n        <span class="product-price-current item-details-price product-price-item notranslate"></span>\n    </div>\n    <div>\n        <a href="/checkout/id-' +
((__t = ( obj.pk )) == null ? '' : __t) +
'" class="ecom-action purchase-link" rel="nofollow"\n           data-tracking-action="PDP Purchase Clicked"\n           data-tracking-position="pdp purchase link">\n                <span class="icon-inline-title">Purchase</span>\n        </a>\n    </div>\n';
return __p
},
    "detailsInitialPriceTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="product-price-initial item-details-price strike-through product-price-item"></span>\n';
return __p
},
    "detailsPriceUponRequestTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div>\n        <a href="#contact-dealer" class="item-details-price-contact contact-dealer" data-galocation="contact link in pdp - in product description">\n            Price Upon Request\n        </a>\n    </div>\n';
return __p
},
    "detailsSoldHoldTmpl": function(obj) {
var __t, __p = '';
__p += '\n    ' +
((__t = ( obj.copy )) == null ? '' : __t) +
'\n';
return __p
},
    "purchaseButtonTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <a href="/checkout/id-' +
((__t = ( obj.pk )) == null ? '' : __t) +
'" class="ecom-action purchase-link button-large mobile-full-width button-primary" rel="nofollow"\n        data-tracking-action="PDP Purchase Clicked"\n        data-tracking-position="pdp purchase button">\n        Purchase\n    </a>\n';
return __p
},
    "pdpPrintTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="product-price-item">' +
((__t = ( obj.copy )) == null ? '' : __t) +
'</span>\n';
return __p
},
    "pdpPrintIconTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <span class="icon ' +
((__t = ( obj.icon )) == null ? '' : __t) +
'" data-gastorecount="">' +
((__t = ( obj.copy )) == null ? '' : __t) +
'</span>\n';
return __p
},
    "pdpPrintNetTmpl": function(obj) {
var __t, __p = '';
__p += '\n    <div class="bb-pdp-price"></div>\n';
return __p
}
};

/***/ }),
/* 3882 */,
/* 3883 */,
/* 3884 */,
/* 3885 */,
/* 3886 */,
/* 3887 */,
/* 3888 */,
/* 3889 */,
/* 3890 */,
/* 3891 */,
/* 3892 */,
/* 3893 */,
/* 3894 */,
/* 3895 */,
/* 3896 */,
/* 3897 */,
/* 3898 */,
/* 3899 */,
/* 3900 */,
/* 3901 */,
/* 3902 */,
/* 3903 */,
/* 3904 */,
/* 3905 */,
/* 3906 */,
/* 3907 */,
/* 3908 */,
/* 3909 */,
/* 3910 */,
/* 3911 */,
/* 3912 */,
/* 3913 */,
/* 3914 */,
/* 3915 */,
/* 3916 */,
/* 3917 */,
/* 3918 */,
/* 3919 */,
/* 3920 */,
/* 3921 */,
/* 3922 */,
/* 3923 */,
/* 3924 */,
/* 3925 */,
/* 3926 */,
/* 3927 */,
/* 3928 */,
/* 3929 */,
/* 3930 */,
/* 3931 */,
/* 3932 */,
/* 3933 */,
/* 3934 */,
/* 3935 */,
/* 3936 */,
/* 3937 */,
/* 3938 */,
/* 3939 */,
/* 3940 */,
/* 3941 */,
/* 3942 */,
/* 3943 */,
/* 3944 */,
/* 3945 */,
/* 3946 */,
/* 3947 */,
/* 3948 */,
/* 3949 */,
/* 3950 */,
/* 3951 */,
/* 3952 */,
/* 3953 */,
/* 3954 */,
/* 3955 */,
/* 3956 */,
/* 3957 */,
/* 3958 */,
/* 3959 */,
/* 3960 */,
/* 3961 */,
/* 3962 */,
/* 3963 */,
/* 3964 */,
/* 3965 */,
/* 3966 */,
/* 3967 */,
/* 3968 */,
/* 3969 */,
/* 3970 */,
/* 3971 */,
/* 3972 */,
/* 3973 */,
/* 3974 */,
/* 3975 */,
/* 3976 */,
/* 3977 */,
/* 3978 */,
/* 3979 */,
/* 3980 */,
/* 3981 */,
/* 3982 */,
/* 3983 */,
/* 3984 */,
/* 3985 */,
/* 3986 */,
/* 3987 */,
/* 3988 */,
/* 3989 */,
/* 3990 */,
/* 3991 */,
/* 3992 */,
/* 3993 */,
/* 3994 */,
/* 3995 */,
/* 3996 */,
/* 3997 */,
/* 3998 */,
/* 3999 */,
/* 4000 */,
/* 4001 */,
/* 4002 */,
/* 4003 */,
/* 4004 */,
/* 4005 */,
/* 4006 */,
/* 4007 */,
/* 4008 */,
/* 4009 */,
/* 4010 */,
/* 4011 */,
/* 4012 */,
/* 4013 */,
/* 4014 */,
/* 4015 */,
/* 4016 */,
/* 4017 */,
/* 4018 */,
/* 4019 */,
/* 4020 */,
/* 4021 */,
/* 4022 */,
/* 4023 */,
/* 4024 */,
/* 4025 */,
/* 4026 */,
/* 4027 */,
/* 4028 */,
/* 4029 */,
/* 4030 */,
/* 4031 */,
/* 4032 */,
/* 4033 */,
/* 4034 */,
/* 4035 */,
/* 4036 */,
/* 4037 */,
/* 4038 */,
/* 4039 */,
/* 4040 */,
/* 4041 */,
/* 4042 */,
/* 4043 */,
/* 4044 */,
/* 4045 */,
/* 4046 */,
/* 4047 */,
/* 4048 */,
/* 4049 */,
/* 4050 */,
/* 4051 */,
/* 4052 */,
/* 4053 */,
/* 4054 */,
/* 4055 */,
/* 4056 */,
/* 4057 */,
/* 4058 */,
/* 4059 */,
/* 4060 */,
/* 4061 */,
/* 4062 */,
/* 4063 */,
/* 4064 */,
/* 4065 */,
/* 4066 */,
/* 4067 */,
/* 4068 */,
/* 4069 */,
/* 4070 */,
/* 4071 */,
/* 4072 */,
/* 4073 */,
/* 4074 */,
/* 4075 */,
/* 4076 */,
/* 4077 */,
/* 4078 */,
/* 4079 */,
/* 4080 */,
/* 4081 */,
/* 4082 */,
/* 4083 */,
/* 4084 */,
/* 4085 */,
/* 4086 */,
/* 4087 */,
/* 4088 */,
/* 4089 */,
/* 4090 */,
/* 4091 */,
/* 4092 */,
/* 4093 */,
/* 4094 */,
/* 4095 */,
/* 4096 */,
/* 4097 */,
/* 4098 */,
/* 4099 */,
/* 4100 */,
/* 4101 */,
/* 4102 */,
/* 4103 */,
/* 4104 */,
/* 4105 */,
/* 4106 */,
/* 4107 */,
/* 4108 */,
/* 4109 */,
/* 4110 */,
/* 4111 */,
/* 4112 */,
/* 4113 */,
/* 4114 */,
/* 4115 */,
/* 4116 */,
/* 4117 */,
/* 4118 */,
/* 4119 */,
/* 4120 */,
/* 4121 */,
/* 4122 */,
/* 4123 */,
/* 4124 */,
/* 4125 */,
/* 4126 */,
/* 4127 */,
/* 4128 */,
/* 4129 */,
/* 4130 */,
/* 4131 */,
/* 4132 */,
/* 4133 */,
/* 4134 */,
/* 4135 */,
/* 4136 */,
/* 4137 */,
/* 4138 */,
/* 4139 */,
/* 4140 */,
/* 4141 */,
/* 4142 */,
/* 4143 */,
/* 4144 */,
/* 4145 */,
/* 4146 */,
/* 4147 */,
/* 4148 */,
/* 4149 */,
/* 4150 */,
/* 4151 */,
/* 4152 */,
/* 4153 */,
/* 4154 */,
/* 4155 */,
/* 4156 */,
/* 4157 */,
/* 4158 */,
/* 4159 */,
/* 4160 */,
/* 4161 */,
/* 4162 */,
/* 4163 */,
/* 4164 */,
/* 4165 */,
/* 4166 */,
/* 4167 */,
/* 4168 */,
/* 4169 */,
/* 4170 */,
/* 4171 */,
/* 4172 */,
/* 4173 */,
/* 4174 */,
/* 4175 */,
/* 4176 */,
/* 4177 */,
/* 4178 */,
/* 4179 */,
/* 4180 */,
/* 4181 */,
/* 4182 */,
/* 4183 */,
/* 4184 */,
/* 4185 */,
/* 4186 */,
/* 4187 */,
/* 4188 */,
/* 4189 */,
/* 4190 */,
/* 4191 */,
/* 4192 */,
/* 4193 */,
/* 4194 */,
/* 4195 */,
/* 4196 */,
/* 4197 */,
/* 4198 */,
/* 4199 */,
/* 4200 */,
/* 4201 */,
/* 4202 */,
/* 4203 */,
/* 4204 */,
/* 4205 */,
/* 4206 */,
/* 4207 */,
/* 4208 */,
/* 4209 */,
/* 4210 */,
/* 4211 */,
/* 4212 */,
/* 4213 */,
/* 4214 */,
/* 4215 */,
/* 4216 */,
/* 4217 */,
/* 4218 */,
/* 4219 */,
/* 4220 */,
/* 4221 */,
/* 4222 */,
/* 4223 */,
/* 4224 */,
/* 4225 */,
/* 4226 */,
/* 4227 */,
/* 4228 */,
/* 4229 */,
/* 4230 */,
/* 4231 */,
/* 4232 */,
/* 4233 */,
/* 4234 */,
/* 4235 */,
/* 4236 */,
/* 4237 */,
/* 4238 */,
/* 4239 */,
/* 4240 */,
/* 4241 */,
/* 4242 */,
/* 4243 */,
/* 4244 */,
/* 4245 */,
/* 4246 */,
/* 4247 */,
/* 4248 */,
/* 4249 */,
/* 4250 */,
/* 4251 */,
/* 4252 */,
/* 4253 */,
/* 4254 */,
/* 4255 */,
/* 4256 */,
/* 4257 */,
/* 4258 */,
/* 4259 */,
/* 4260 */,
/* 4261 */,
/* 4262 */,
/* 4263 */,
/* 4264 */,
/* 4265 */,
/* 4266 */,
/* 4267 */,
/* 4268 */,
/* 4269 */,
/* 4270 */,
/* 4271 */,
/* 4272 */,
/* 4273 */,
/* 4274 */,
/* 4275 */,
/* 4276 */,
/* 4277 */,
/* 4278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _require = __webpack_require__(3),
    history = _require.history;

var $ = __webpack_require__(5);
var SV = __webpack_require__(17);
var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(40);
var PageRoot = __webpack_require__(2440);
var createEntryPointContext = __webpack_require__(91);
var urlData = __webpack_require__(134).parseUri(global.location, { stripDelimiters: true });
var returnsCopy = __webpack_require__(1416);
var isEmpty = __webpack_require__(264);
var findNamespaceValue = __webpack_require__(285);
var root = __webpack_require__(97);

var _require2 = __webpack_require__(275),
    currencies = _require2.currencies;

var remarketingTag = __webpack_require__(936);
var ItemStore = __webpack_require__(336);
var PdpUiStore = __webpack_require__(744);
var PriceStore = __webpack_require__(367);
var User = __webpack_require__(15);
var loginActions = __webpack_require__(603);
var currencyActionConstants = __webpack_require__(287);

var _require3 = __webpack_require__(92),
    createReducerStore = _require3.createReducerStore;

var pdpActionsConstants = __webpack_require__(743);
var sourceAttributionHelper = __webpack_require__(817);
var GalleryModalRouter = __webpack_require__(1421);
var GalleryModalWrapperView = __webpack_require__(1106);
var galleryModalActions = __webpack_require__(512);
var galleryActions = __webpack_require__(363);
var categoriesActions = __webpack_require__(797);
var GAC = __webpack_require__(342);
var pdpActions = __webpack_require__(796);

var stores = [ItemStore, PdpUiStore, createReducerStore(__webpack_require__(548)), createReducerStore(__webpack_require__(357)), createReducerStore(__webpack_require__(649)), createReducerStore(__webpack_require__(575)), createReducerStore(__webpack_require__(650)), createReducerStore(PriceStore), __webpack_require__(547), __webpack_require__(1107), __webpack_require__(986), __webpack_require__(987), __webpack_require__(648), __webpack_require__(475), __webpack_require__(549)];

__webpack_require__(647);
__webpack_require__(2391);
__webpack_require__(617);
__webpack_require__(1538);

__webpack_require__(380).addGlobalSVPath('copy.contactDealer').addGlobalSVPath('copy');

/**
 * Convenience method that executes an action, which dispatches event with given payload
 * @param {object} context
 * @param {string} eventName
 * @param {object} [payload={}]
 * @returns {Promise}
 */
var executeAction = function executeAction(context, eventName) {
    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return context.executeAction(function (actionContext, p) {
        actionContext.dispatch(eventName, p);
    }, payload);
};

sourceAttributionHelper.trackPreRegistrationPageVisit();

// Need to wrap this in a jquery ready function to keep tracking working. In the component
// did mount method of pdpLayout, pdpTracking.updateGaReturns is called which in turn
// publishes the event 'ga:unblockCustomVar'. A subscriber in gas.dibs.pageview catches this
// and kicks off the tracking for the pdp. However, if the code below isn't wrapped in a
// jquery ready, the publish event will fire before the subscriber is set up. Tracking will
// never start as a result.
// Todo Long term solution is to refactor gas.dibs.pageview to follow Flux pattern. Would also
// be ideal to rewrite jquery's document.ready method in vanilla javascript and remove all the
// jquery on this page in the mean time.
$(function () {
    var state = SV.get('jsTemplatesState') || {};
    var promises = [];
    var promise = void 0;

    // Set this up like NYDC page routing through the node app
    // If state is empty, page is routed through PHP
    if (isEmpty(state)) {
        var context = createEntryPointContext(stores, { connectToContact: true });
        var currency = findNamespaceValue('currency', root.essentialPropsForPdpSidebar);

        // Async data takes precedence and overwrites POST data from Item Preview
        if (!SV.get('data.isPreview')) {

            promises.push(context.executeAction(pdpActions.asyncLoadItem, { pk: SV.get('data.pk') }));
        }

        if (User.loggedIn()) {
            promises.push(context.executeAction(loginActions.loadFullUser));
            promises.push(context.executeAction(loginActions.checkUserTypeStatus));
        } else {
            promises.push(context.executeAction(loginActions.loadLoggedOutUser));
        }

        // Dispatch generic page received event
        promises.push(executeAction(context, pdpActionsConstants.ACTION_RECEIVE_PAGE));

        promises.push(executeAction(context, pdpActionsConstants.ACTION_PRINT_PAGE, {
            isPrintPage: SV.get('settings.isPrintPDP'),
            isPrintNP: SV.get('settings.isPrintNP')
        }));

        if (SV.get('settings.isPrintPDP')) {
            promises.push(executeAction(context, pdpActionsConstants.ACTION_CAROUSEL_INDEX, {
                index: Number(SV.get('settings.selectedImage')) || 0
            }));
        }

        // Dispatch events to populate stores
        promises.push(executeAction(context, 'BOOTSTRAP_ITEM_STORE', {
            breadcrumbs: SV.get('breadcrumbs'),
            creatorRoleReferences: SV.get('creatorRoleReferences'),
            conditionReferences: SV.get('conditionReferences'),
            copy: SV.get('pdpCopy'),
            rawResult: SV.get('rawResult'),
            detailLinks: SV.get('detailLinks'),
            detailTechniques: SV.get('detailTechniques'),
            detailsTitles: SV.get('detailsTitles'),
            goodRelationsMeta: SV.get('goodRelationsMeta'),
            periodReferences: SV.get('periodReferences'),
            pageData: SV.get('data') || {},
            returnsCopy: returnsCopy,
            shippingCopy: SV.get('data.shippingCopy') || {},
            shouldShowSuspended: SV.get('data.isSuspended') || SV.get('data.isDeleted') || SV.get('data.isDealerSuspended'),
            tradeReturnsEnabled: SV.get('settings.enabler.trade_returns_enabled'),
            urlData: urlData
        }));
        promises.push(executeAction(context, 'BOOTSTRAP_SHIPPING_STORE', {
            rawResult: SV.get('rawResult'),
            returnsCopy: returnsCopy,
            shipmentQuotes: findNamespaceValue('shipmentQuotes', root.essentialPropsForPdpSidebar),
            shipping: SV.get('data.shippingCopy') || {}
        }));

        var photos = SV.get('recommendedPhotos') || [];

        // Fetch the categories for the CategoriesStore
        promises.push(context.executeAction(categoriesActions.fetchGalleryCategories));

        promises.push(context.executeAction(galleryActions.setupStoreWithMultipleProjectPhotos, Object.assign({}, {
            galleryPhotos: photos,
            initialPhoto: photos.length ? photos[0] : null,
            totalPhotos: photos.length
        })));

        // Set Up the gallery modal store and project views
        promises.push(context.executeAction(galleryModalActions.setupStoreWithServerVars, {
            originalUrl: location.pathname + location.search,
            originalPageTitleTag: document.querySelector('title').innerHTML,
            originalPageType: GAC.pageTypes.PDP,
            originalDataLayerInfo: SV.get('tracking.initialDataLayerInfo'),
            originalVPVString: window.virtualPageName ? '/' + window.virtualPageName.join('/') + '/' : void 0
        }));

        if (currency) {
            promises.push(executeAction(context, currencyActionConstants.CURRENCY_CHANGED, { currency: currency }));
            promises.push(executeAction(context, currencyActionConstants.CURRENCY_LOADED));
        }
        promise = Promise.all(promises).then(function () {
            // Return context here to mimic resolve from createEntryPointContext
            return context;
        });
    } else {
        // If state is not empty, page is routed through Node App and Flux App must be rehydrated
        promise = createEntryPointContext(stores, { state: state });
    }

    promise.then(function (cxt) {
        var itemStore = cxt.getStore(ItemStore);
        var item = itemStore.getItem();

        history.start({ root: '/', pushState: true, silent: true });

        new GalleryModalWrapperView({ context: cxt });
        new GalleryModalRouter({ context: cxt });

        ReactDOM.render(React.createElement(PageRoot, {
            context: cxt.getComponentContext()
        }), document.body.querySelector('.pdp-wrapper'));

        // Re-marketing tag should fire just for available PDP
        item.once('change', function () {
            if (!itemStore.getIsSold() && !itemStore.getIsOnHold() && !itemStore.getHidePrice()) {
                var id = item.get('id');
                var price = item.getAmountIn(currencies.CURRENCY_USD) || 0;
                remarketingTag.product(id, price);
            }
        });
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ })
],[4278]);


// WEBPACK FOOTER //
// newPdp.es.c78a0f98fc0b6b69ac65.js